//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AboutServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<AboutDto> {
        let url_ = this.baseUrl + "/api/services/app/About/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AboutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AboutDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AboutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AboutDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AboutDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<AboutDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/About/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AboutDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AboutDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AboutDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AboutDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AboutDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: AboutDto | undefined): Observable<AboutDto> {
        let url_ = this.baseUrl + "/api/services/app/About/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AboutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AboutDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AboutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AboutDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AboutDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: AboutDto | undefined): Observable<AboutDto> {
        let url_ = this.baseUrl + "/api/services/app/About/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AboutDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AboutDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AboutDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AboutDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AboutDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/About/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = IsTenantAvailableOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsTenantAvailableOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RegisterOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterOutput>(null as any);
    }
}

@Injectable()
export class AccountsChartServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAccountsChart(body: AccountsChartDto | undefined): Observable<AccountsChartDto> {
        let url_ = this.baseUrl + "/api/services/app/AccountsChart/CreateAccountsChart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateAccountsChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAccountsChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountsChartDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountsChartDto>;
        }));
    }

    protected processCreateAccountsChart(response: HttpResponseBase): Observable<AccountsChartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AccountsChartDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountsChartDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getAccountsChart(tenantId: number | undefined): Observable<AccountsChartDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AccountsChart/GetAccountsChart?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAccountsChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountsChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountsChartDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountsChartDto[]>;
        }));
    }

    protected processGetAccountsChart(response: HttpResponseBase): Observable<AccountsChartDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(AccountsChartDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountsChartDto[]>(null as any);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getAccountsChartByCode(code: string | undefined): Observable<AccountsChartDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AccountsChart/GetAccountsChartByCode?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAccountsChartByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountsChartByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountsChartDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountsChartDto[]>;
        }));
    }

    protected processGetAccountsChartByCode(response: HttpResponseBase): Observable<AccountsChartDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(AccountsChartDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountsChartDto[]>(null as any);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getOneAccountChartByCode(code: string | undefined): Observable<AccountsChart> {
        let url_ = this.baseUrl + "/api/services/app/AccountsChart/GetOneAccountChartByCode?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOneAccountChartByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOneAccountChartByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountsChart>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountsChart>;
        }));
    }

    protected processGetOneAccountChartByCode(response: HttpResponseBase): Observable<AccountsChart> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AccountsChart.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountsChart>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getAccountsChartWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<AccountsChartPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AccountsChart/GetAccountsChartWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAccountsChartWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountsChartWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountsChartPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountsChartPagedResultDto>;
        }));
    }

    protected processGetAccountsChartWithInput(response: HttpResponseBase): Observable<AccountsChartPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AccountsChartPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountsChartPagedResultDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getAccountsChartByTenantId(tenantId: number | undefined): Observable<AccountsChart[]> {
        let url_ = this.baseUrl + "/api/services/app/AccountsChart/GetAccountsChartByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAccountsChartByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountsChartByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountsChart[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountsChart[]>;
        }));
    }

    protected processGetAccountsChartByTenantId(response: HttpResponseBase): Observable<AccountsChart[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(AccountsChart.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountsChart[]>(null as any);
    }

    /**
     * @param categoryCode (optional) 
     * @return Success
     */
    getAccountsChartByCategoryCode(categoryCode: string | undefined): Observable<AccountsChart[]> {
        let url_ = this.baseUrl + "/api/services/app/AccountsChart/GetAccountsChartByCategoryCode?";
        if (categoryCode === null)
            throw new Error("The parameter 'categoryCode' cannot be null.");
        else if (categoryCode !== undefined)
            url_ += "categoryCode=" + encodeURIComponent("" + categoryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAccountsChartByCategoryCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountsChartByCategoryCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountsChart[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountsChart[]>;
        }));
    }

    protected processGetAccountsChartByCategoryCode(response: HttpResponseBase): Observable<AccountsChart[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(AccountsChart.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountsChart[]>(null as any);
    }

    /**
     * @param categoryCode (optional) 
     * @return Success
     */
    getAccountsChartForProcurement(categoryCode: string | undefined): Observable<AccountsChart[]> {
        let url_ = this.baseUrl + "/api/services/app/AccountsChart/GetAccountsChartForProcurement?";
        if (categoryCode === null)
            throw new Error("The parameter 'categoryCode' cannot be null.");
        else if (categoryCode !== undefined)
            url_ += "categoryCode=" + encodeURIComponent("" + categoryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAccountsChartForProcurement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountsChartForProcurement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountsChart[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountsChart[]>;
        }));
    }

    protected processGetAccountsChartForProcurement(response: HttpResponseBase): Observable<AccountsChart[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(AccountsChart.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountsChart[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateAccountsChart(id: number | undefined, body: AccountsChartDto | undefined): Observable<AccountsChartDto> {
        let url_ = this.baseUrl + "/api/services/app/AccountsChart/UpdateAccountsChart?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateAccountsChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAccountsChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountsChartDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountsChartDto>;
        }));
    }

    protected processUpdateAccountsChart(response: HttpResponseBase): Observable<AccountsChartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AccountsChartDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountsChartDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteAccountsChart(id: number | undefined): Observable<AccountsChartDto> {
        let url_ = this.baseUrl + "/api/services/app/AccountsChart/DeleteAccountsChart?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteAccountsChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAccountsChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountsChartDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountsChartDto>;
        }));
    }

    protected processDeleteAccountsChart(response: HttpResponseBase): Observable<AccountsChartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AccountsChartDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountsChartDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetAccountsChartFromList(body: AccountsChartDto[] | undefined): Observable<AccountsChartDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AccountsChart/ResetAccountsChartFromList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResetAccountsChartFromList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetAccountsChartFromList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountsChartDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountsChartDto[]>;
        }));
    }

    protected processResetAccountsChartFromList(response: HttpResponseBase): Observable<AccountsChartDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(AccountsChartDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountsChartDto[]>(null as any);
    }

    /**
     * @return Success
     */
    resetAccountsChartFromDefaultTenant(): Observable<AccountsChartDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AccountsChart/ResetAccountsChartFromDefaultTenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResetAccountsChartFromDefaultTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetAccountsChartFromDefaultTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountsChartDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountsChartDto[]>;
        }));
    }

    protected processResetAccountsChartFromDefaultTenant(response: HttpResponseBase): Observable<AccountsChartDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(AccountsChartDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountsChartDto[]>(null as any);
    }

    /**
     * @return Success
     */
    checkChartOfAccounts(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AccountsChart/checkChartOfAccounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckChartOfAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckChartOfAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckChartOfAccounts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class BankAccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getBankAccountsByTenantId(tenantId: number | undefined): Observable<BankAccountDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BankAccount/GetBankAccountsByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBankAccountsByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBankAccountsByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankAccountDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankAccountDto[]>;
        }));
    }

    protected processGetBankAccountsByTenantId(response: HttpResponseBase): Observable<BankAccountDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(BankAccountDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankAccountDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<BankAccountDto> {
        let url_ = this.baseUrl + "/api/services/app/BankAccount/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankAccountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankAccountDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BankAccountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BankAccountDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankAccountDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<BankAccountDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/BankAccount/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankAccountDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankAccountDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BankAccountDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BankAccountDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankAccountDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: BankAccountDto | undefined): Observable<BankAccountDto> {
        let url_ = this.baseUrl + "/api/services/app/BankAccount/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankAccountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankAccountDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<BankAccountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BankAccountDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankAccountDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: BankAccountDto | undefined): Observable<BankAccountDto> {
        let url_ = this.baseUrl + "/api/services/app/BankAccount/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankAccountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankAccountDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<BankAccountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BankAccountDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BankAccountDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BankAccount/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class BillServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBillById(id: string | undefined): Observable<BillDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetBillById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBillById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDto>;
        }));
    }

    protected processGetBillById(response: HttpResponseBase): Observable<BillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDto>(null as any);
    }

    /**
     * @return Success
     */
    getBillsWithCreditNoteForCashbook(): Observable<BillDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetBillsWithCreditNoteForCashbook";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBillsWithCreditNoteForCashbook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillsWithCreditNoteForCashbook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDto[]>;
        }));
    }

    protected processGetBillsWithCreditNoteForCashbook(response: HttpResponseBase): Observable<BillDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(BillDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDto[]>(null as any);
    }

    /**
     * @param billId (optional) 
     * @return Success
     */
    getCreditNoteCashbookAmountByBillId(billId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetCreditNoteCashbookAmountByBillId?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCreditNoteCashbookAmountByBillId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreditNoteCashbookAmountByBillId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetCreditNoteCashbookAmountByBillId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getBillSummary(): Observable<BillSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetBillSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBillSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillSummaryDto>;
        }));
    }

    protected processGetBillSummary(response: HttpResponseBase): Observable<BillSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillSummaryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillSummaryDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getBillAsPdf(id: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetBillAsPdf?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBillAsPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillAsPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetBillAsPdf(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendInvoiceWithPdf(body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bill/SendInvoiceWithPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendInvoiceWithPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendInvoiceWithPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendInvoiceWithPdf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param reminderType (optional) 
     * @param body (optional) 
     * @return Success
     */
    sendReminderToEmail(reminderType: number | undefined, body: BillDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Bill/SendReminderToEmail?";
        if (reminderType === null)
            throw new Error("The parameter 'reminderType' cannot be null.");
        else if (reminderType !== undefined)
            url_ += "reminderType=" + encodeURIComponent("" + reminderType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendReminderToEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendReminderToEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendReminderToEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param filterString (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getInvoicesForChart(tenantId: number | undefined, filterString: string | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<ChartDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetInvoicesForChart?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (filterString === null)
            throw new Error("The parameter 'filterString' cannot be null.");
        else if (filterString !== undefined)
            url_ += "filterString=" + encodeURIComponent("" + filterString) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetInvoicesForChart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoicesForChart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChartDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChartDto>;
        }));
    }

    protected processGetInvoicesForChart(response: HttpResponseBase): Observable<ChartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ChartDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChartDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @param selectedStatus (optional) 
     * @return Success
     */
    getBillsWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined, selectedStatus: string | undefined): Observable<BillDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetBillsWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (selectedStatus === null)
            throw new Error("The parameter 'selectedStatus' cannot be null.");
        else if (selectedStatus !== undefined)
            url_ += "selectedStatus=" + encodeURIComponent("" + selectedStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBillsWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillsWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDtoPagedResultDto>;
        }));
    }

    protected processGetBillsWithInput(response: HttpResponseBase): Observable<BillDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDtoPagedResultDto>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getBillsForLedger(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<LedgerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetBillsForLedger?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBillsForLedger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillsForLedger(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LedgerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LedgerDto[]>;
        }));
    }

    protected processGetBillsForLedger(response: HttpResponseBase): Observable<LedgerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(LedgerDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LedgerDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    generateNewIvoiceNumber(tenantId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GenerateNewIvoiceNumber?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGenerateNewIvoiceNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateNewIvoiceNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateNewIvoiceNumber(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendDeliveryOrder(body: BillDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bill/SendDeliveryOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendDeliveryOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDeliveryOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendDeliveryOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    confirmDO(id: string | undefined): Observable<BillDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/ConfirmDO?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processConfirmDO(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmDO(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDto>;
        }));
    }

    protected processConfirmDO(response: HttpResponseBase): Observable<BillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDto>(null as any);
    }

    /**
     * @return Success
     */
    checkDueInvoices(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bill/CheckDueInvoices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckDueInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDueInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckDueInvoices(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAllBillsWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<BillDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetAllBillsWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllBillsWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBillsWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDtoPagedResultDto>;
        }));
    }

    protected processGetAllBillsWithInput(response: HttpResponseBase): Observable<BillDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    adminDeleteInvoice(id: string | undefined): Observable<BillDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/AdminDeleteInvoice?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAdminDeleteInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdminDeleteInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDto>;
        }));
    }

    protected processAdminDeleteInvoice(response: HttpResponseBase): Observable<BillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCreditNote(body: CreditNoteDto | undefined): Observable<CreditNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/CreateCreditNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateCreditNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCreditNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreditNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreditNoteDto>;
        }));
    }

    protected processCreateCreditNote(response: HttpResponseBase): Observable<CreditNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreditNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreditNoteDto>(null as any);
    }

    /**
     * @param billId (optional) 
     * @return Success
     */
    getCreditNote(billId: string | undefined): Observable<CreditNote[]> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetCreditNote?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCreditNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreditNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreditNote[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreditNote[]>;
        }));
    }

    protected processGetCreditNote(response: HttpResponseBase): Observable<CreditNote[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(CreditNote.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreditNote[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateCreditNote(id: number | undefined, body: CreditNoteDto | undefined): Observable<CreditNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/UpdateCreditNote?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateCreditNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCreditNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreditNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreditNoteDto>;
        }));
    }

    protected processUpdateCreditNote(response: HttpResponseBase): Observable<CreditNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreditNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreditNoteDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteCreditNote(id: number | undefined): Observable<CreditNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/DeleteCreditNote?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteCreditNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCreditNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreditNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreditNoteDto>;
        }));
    }

    protected processDeleteCreditNote(response: HttpResponseBase): Observable<CreditNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreditNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreditNoteDto>(null as any);
    }

    /**
     * @param billId (optional) 
     * @return Success
     */
    getTotalCreditNote(billId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetTotalCreditNote?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTotalCreditNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalCreditNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTotalCreditNote(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param billId (optional) 
     * @param addValue (optional) 
     * @return Success
     */
    addTotalCreditNote(billId: string | undefined, addValue: number | undefined): Observable<Bill> {
        let url_ = this.baseUrl + "/api/services/app/Bill/AddTotalCreditNote?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&";
        if (addValue === null)
            throw new Error("The parameter 'addValue' cannot be null.");
        else if (addValue !== undefined)
            url_ += "addValue=" + encodeURIComponent("" + addValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAddTotalCreditNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTotalCreditNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Bill>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Bill>;
        }));
    }

    protected processAddTotalCreditNote(response: HttpResponseBase): Observable<Bill> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Bill.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Bill>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendCreditnoteWithPdf(body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bill/SendCreditnoteWithPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendCreditnoteWithPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendCreditnoteWithPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendCreditnoteWithPdf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getInvoiceWithApproval(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<BillDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetInvoiceWithApproval?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetInvoiceWithApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceWithApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDtoPagedResultDto>;
        }));
    }

    protected processGetInvoiceWithApproval(response: HttpResponseBase): Observable<BillDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendEmailToApprover(body: BillDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bill/SendEmailToApprover";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendEmailToApprover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailToApprover(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendEmailToApprover(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param periodInt (optional) 
     * @param year (optional) 
     * @return Success
     */
    getTaxReport(tenantId: number | undefined, periodInt: number | undefined, year: number | undefined): Observable<Bill[]> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetTaxReport?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (periodInt === null)
            throw new Error("The parameter 'periodInt' cannot be null.");
        else if (periodInt !== undefined)
            url_ += "periodInt=" + encodeURIComponent("" + periodInt) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTaxReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaxReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Bill[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Bill[]>;
        }));
    }

    protected processGetTaxReport(response: HttpResponseBase): Observable<Bill[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(Bill.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Bill[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param customerId (optional) 
     * @return Success
     */
    getStatements(tenantId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, customerId: string | undefined): Observable<StatementDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetStatements?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetStatements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StatementDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StatementDto[]>;
        }));
    }

    protected processGetStatements(response: HttpResponseBase): Observable<StatementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(StatementDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StatementDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendStatementithPdf(body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bill/SendStatementithPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendStatementithPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendStatementithPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendStatementithPdf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param startdate (optional) 
     * @param enddate (optional) 
     * @return Success
     */
    getBillSummaryWithRange(startdate: moment.Moment | undefined, enddate: moment.Moment | undefined): Observable<BillSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetBillSummaryWithRange?";
        if (startdate === null)
            throw new Error("The parameter 'startdate' cannot be null.");
        else if (startdate !== undefined)
            url_ += "startdate=" + encodeURIComponent(startdate ? "" + startdate.toISOString() : "") + "&";
        if (enddate === null)
            throw new Error("The parameter 'enddate' cannot be null.");
        else if (enddate !== undefined)
            url_ += "enddate=" + encodeURIComponent(enddate ? "" + enddate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBillSummaryWithRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillSummaryWithRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillSummaryDto>;
        }));
    }

    protected processGetBillSummaryWithRange(response: HttpResponseBase): Observable<BillSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillSummaryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillSummaryDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    marketplaceCreateNewInvoice(body: BillDto | undefined): Observable<BillDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/MarketplaceCreateNewInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processMarketplaceCreateNewInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarketplaceCreateNewInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDto>;
        }));
    }

    protected processMarketplaceCreateNewInvoice(response: HttpResponseBase): Observable<BillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDto>(null as any);
    }

    /**
     * @param phone (optional) 
     * @return Success
     */
    sendMerchantLinkToSms(phone: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bill/SendMerchantLinkToSms?";
        if (phone === null)
            throw new Error("The parameter 'phone' cannot be null.");
        else if (phone !== undefined)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendMerchantLinkToSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMerchantLinkToSms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendMerchantLinkToSms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param email (optional) 
     * @return Success
     */
    sendMerchantLinkToEmail(email: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bill/SendMerchantLinkToEmail?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendMerchantLinkToEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMerchantLinkToEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendMerchantLinkToEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tenancyName (optional) 
     * @param dateString (optional) 
     * @return Success
     */
    getFirebaseCollectionList(tenancyName: string | undefined, dateString: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetFirebaseCollectionList?";
        if (tenancyName === null)
            throw new Error("The parameter 'tenancyName' cannot be null.");
        else if (tenancyName !== undefined)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        if (dateString === null)
            throw new Error("The parameter 'dateString' cannot be null.");
        else if (dateString !== undefined)
            url_ += "dateString=" + encodeURIComponent("" + dateString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFirebaseCollectionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirebaseCollectionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetFirebaseCollectionList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param tenancyName (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getFirebaseTransaction(tenancyName: string | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<TransactionSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetFirebaseTransaction?";
        if (tenancyName === null)
            throw new Error("The parameter 'tenancyName' cannot be null.");
        else if (tenancyName !== undefined)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFirebaseTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirebaseTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionSummaryDto[]>;
        }));
    }

    protected processGetFirebaseTransaction(response: HttpResponseBase): Observable<TransactionSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(TransactionSummaryDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionSummaryDto[]>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getPosForLedger(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<LedgerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetPosForLedger?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPosForLedger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPosForLedger(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LedgerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LedgerDto[]>;
        }));
    }

    protected processGetPosForLedger(response: HttpResponseBase): Observable<LedgerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(LedgerDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LedgerDto[]>(null as any);
    }

    /**
     * @param tenancyName (optional) 
     * @return Success
     */
    getCurrentReport(tenancyName: string | undefined): Observable<TransactionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetCurrentReport?";
        if (tenancyName === null)
            throw new Error("The parameter 'tenancyName' cannot be null.");
        else if (tenancyName !== undefined)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCurrentReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDto[]>;
        }));
    }

    protected processGetCurrentReport(response: HttpResponseBase): Observable<TransactionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(TransactionDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionDto[]>(null as any);
    }

    /**
     * @param tenancyName (optional) 
     * @param transactionName (optional) 
     * @param time (optional) 
     * @return Success
     */
    getCurrentReportItem(tenancyName: string | undefined, transactionName: string | undefined, time: string | undefined): Observable<TransactionItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetCurrentReportItem?";
        if (tenancyName === null)
            throw new Error("The parameter 'tenancyName' cannot be null.");
        else if (tenancyName !== undefined)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        if (transactionName === null)
            throw new Error("The parameter 'transactionName' cannot be null.");
        else if (transactionName !== undefined)
            url_ += "transactionName=" + encodeURIComponent("" + transactionName) + "&";
        if (time === null)
            throw new Error("The parameter 'time' cannot be null.");
        else if (time !== undefined)
            url_ += "time=" + encodeURIComponent("" + time) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCurrentReportItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentReportItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionItemDto[]>;
        }));
    }

    protected processGetCurrentReportItem(response: HttpResponseBase): Observable<TransactionItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(TransactionItemDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionItemDto[]>(null as any);
    }

    /**
     * @param tenancyName (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getCurrentReportRange(tenancyName: string | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<TransactionItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetCurrentReportRange?";
        if (tenancyName === null)
            throw new Error("The parameter 'tenancyName' cannot be null.");
        else if (tenancyName !== undefined)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCurrentReportRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentReportRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionItemDto[]>;
        }));
    }

    protected processGetCurrentReportRange(response: HttpResponseBase): Observable<TransactionItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(TransactionItemDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionItemDto[]>(null as any);
    }

    /**
     * @param tenancyName (optional) 
     * @param date (optional) 
     * @return Success
     */
    getReportByDate(tenancyName: string | undefined, date: string | undefined): Observable<TransactionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetReportByDate?";
        if (tenancyName === null)
            throw new Error("The parameter 'tenancyName' cannot be null.");
        else if (tenancyName !== undefined)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetReportByDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportByDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDto[]>;
        }));
    }

    protected processGetReportByDate(response: HttpResponseBase): Observable<TransactionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(TransactionDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionDto[]>(null as any);
    }

    /**
     * @param tenancyName (optional) 
     * @param date (optional) 
     * @param docId (optional) 
     * @return Success
     */
    getAttachments(tenancyName: string | undefined, date: string | undefined, docId: string | undefined): Observable<TransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetAttachments?";
        if (tenancyName === null)
            throw new Error("The parameter 'tenancyName' cannot be null.");
        else if (tenancyName !== undefined)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (docId === null)
            throw new Error("The parameter 'docId' cannot be null.");
        else if (docId !== undefined)
            url_ += "docId=" + encodeURIComponent("" + docId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDto>;
        }));
    }

    protected processGetAttachments(response: HttpResponseBase): Observable<TransactionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TransactionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionDto>(null as any);
    }

    /**
     * @param tenancyName (optional) 
     * @param date (optional) 
     * @return Success
     */
    getTransactionsInfo(tenancyName: string | undefined, date: moment.Moment | undefined): Observable<TransactionSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetTransactionsInfo?";
        if (tenancyName === null)
            throw new Error("The parameter 'tenancyName' cannot be null.");
        else if (tenancyName !== undefined)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTransactionsInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionsInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionSummaryDto[]>;
        }));
    }

    protected processGetTransactionsInfo(response: HttpResponseBase): Observable<TransactionSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(TransactionSummaryDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionSummaryDto[]>(null as any);
    }

    /**
     * @param tenancyName (optional) 
     * @param date (optional) 
     * @return Success
     */
    getTransactionsInfoWithItems(tenancyName: string | undefined, date: moment.Moment | undefined): Observable<TransactionSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetTransactionsInfoWithItems?";
        if (tenancyName === null)
            throw new Error("The parameter 'tenancyName' cannot be null.");
        else if (tenancyName !== undefined)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTransactionsInfoWithItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionsInfoWithItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionSummaryDto[]>;
        }));
    }

    protected processGetTransactionsInfoWithItems(response: HttpResponseBase): Observable<TransactionSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(TransactionSummaryDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionSummaryDto[]>(null as any);
    }

    /**
     * @param tenancyName (optional) 
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getTransactionsInfoByMonth(tenancyName: string | undefined, month: string | undefined, year: string | undefined): Observable<TransactionSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetTransactionsInfoByMonth?";
        if (tenancyName === null)
            throw new Error("The parameter 'tenancyName' cannot be null.");
        else if (tenancyName !== undefined)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTransactionsInfoByMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionsInfoByMonth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionSummaryDto[]>;
        }));
    }

    protected processGetTransactionsInfoByMonth(response: HttpResponseBase): Observable<TransactionSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(TransactionSummaryDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionSummaryDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getAllUnpaidInvoices(tenantId: number | undefined): Observable<BillDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetAllUnpaidInvoices?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllUnpaidInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUnpaidInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDto[]>;
        }));
    }

    protected processGetAllUnpaidInvoices(response: HttpResponseBase): Observable<BillDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(BillDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getAllPaidInvoicesForAnalytics(tenantId: number | undefined): Observable<SmeAnalyticsDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetAllPaidInvoicesForAnalytics?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllPaidInvoicesForAnalytics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaidInvoicesForAnalytics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SmeAnalyticsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SmeAnalyticsDto>;
        }));
    }

    protected processGetAllPaidInvoicesForAnalytics(response: HttpResponseBase): Observable<SmeAnalyticsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SmeAnalyticsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SmeAnalyticsDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getBillForTemplatePreview(tenantId: number | undefined): Observable<BillDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetBillForTemplatePreview?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBillForTemplatePreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillForTemplatePreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDto>;
        }));
    }

    protected processGetBillForTemplatePreview(response: HttpResponseBase): Observable<BillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDto>(null as any);
    }

    /**
     * @param tenancyName (optional) 
     * @return Success
     */
    getTableList(tenancyName: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetTableList?";
        if (tenancyName === null)
            throw new Error("The parameter 'tenancyName' cannot be null.");
        else if (tenancyName !== undefined)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTableList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTableList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetTableList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param tenancyName (optional) 
     * @param tableNumber (optional) 
     * @param info (optional) 
     * @param body (optional) 
     * @return Success
     */
    addTableOrder(tenancyName: string | undefined, tableNumber: string | undefined, info: string | undefined, body: CartDto[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Bill/AddTableOrder?";
        if (tenancyName === null)
            throw new Error("The parameter 'tenancyName' cannot be null.");
        else if (tenancyName !== undefined)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        if (tableNumber === null)
            throw new Error("The parameter 'tableNumber' cannot be null.");
        else if (tableNumber !== undefined)
            url_ += "tableNumber=" + encodeURIComponent("" + tableNumber) + "&";
        if (info === null)
            throw new Error("The parameter 'info' cannot be null.");
        else if (info !== undefined)
            url_ += "info=" + encodeURIComponent("" + info) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAddTableOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTableOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddTableOrder(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenancyName (optional) 
     * @param tableNumber (optional) 
     * @param info (optional) 
     * @param body (optional) 
     * @return Success
     */
    addKitchenList(tenancyName: string | undefined, tableNumber: string | undefined, info: string | undefined, body: CartDto[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Bill/addKitchenList?";
        if (tenancyName === null)
            throw new Error("The parameter 'tenancyName' cannot be null.");
        else if (tenancyName !== undefined)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        if (tableNumber === null)
            throw new Error("The parameter 'tableNumber' cannot be null.");
        else if (tableNumber !== undefined)
            url_ += "tableNumber=" + encodeURIComponent("" + tableNumber) + "&";
        if (info === null)
            throw new Error("The parameter 'info' cannot be null.");
        else if (info !== undefined)
            url_ += "info=" + encodeURIComponent("" + info) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAddKitchenList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddKitchenList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddKitchenList(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenancyName (optional) 
     * @param productIdGuid (optional) 
     * @return Success
     */
    getFirebaseDocId(tenancyName: string | undefined, productIdGuid: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetFirebaseDocId?";
        if (tenancyName === null)
            throw new Error("The parameter 'tenancyName' cannot be null.");
        else if (tenancyName !== undefined)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        if (productIdGuid === null)
            throw new Error("The parameter 'productIdGuid' cannot be null.");
        else if (productIdGuid !== undefined)
            url_ += "productIdGuid=" + encodeURIComponent("" + productIdGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFirebaseDocId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirebaseDocId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFirebaseDocId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkMigrationData(body: BillMigrationDto[] | undefined): Observable<BillMigrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bill/CheckMigrationData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckMigrationData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckMigrationData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillMigrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillMigrationDto[]>;
        }));
    }

    protected processCheckMigrationData(response: HttpResponseBase): Observable<BillMigrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(BillMigrationDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillMigrationDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createInvoicesFromMigration(body: BillMigrationDto[] | undefined): Observable<BillMigrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bill/CreateInvoicesFromMigration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateInvoicesFromMigration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoicesFromMigration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillMigrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillMigrationDto[]>;
        }));
    }

    protected processCreateInvoicesFromMigration(response: HttpResponseBase): Observable<BillMigrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(BillMigrationDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillMigrationDto[]>(null as any);
    }

    /**
     * @return Success
     */
    fixTotalAmount(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Bill/FixTotalAmount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processFixTotalAmount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFixTotalAmount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processFixTotalAmount(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getSellBadge(tenantId: number | undefined): Observable<SellBadgeDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetSellBadge?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSellBadge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSellBadge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SellBadgeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SellBadgeDto>;
        }));
    }

    protected processGetSellBadge(response: HttpResponseBase): Observable<SellBadgeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SellBadgeDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SellBadgeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTfxBill(body: TfxBillDto | undefined): Observable<TfxBillDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/CreateTfxBill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateTfxBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTfxBill(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TfxBillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TfxBillDto>;
        }));
    }

    protected processCreateTfxBill(response: HttpResponseBase): Observable<TfxBillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TfxBillDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TfxBillDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getTfxBillWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<TfxBillDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetTfxBillWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTfxBillWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTfxBillWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TfxBillDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TfxBillDtoPagedResultDto>;
        }));
    }

    protected processGetTfxBillWithInput(response: HttpResponseBase): Observable<TfxBillDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TfxBillDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TfxBillDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTfxBillItem(body: TfxBillItemDto | undefined): Observable<TfxBillItemDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/CreateTfxBillItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateTfxBillItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTfxBillItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TfxBillItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TfxBillItemDto>;
        }));
    }

    protected processCreateTfxBillItem(response: HttpResponseBase): Observable<TfxBillItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TfxBillItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TfxBillItemDto>(null as any);
    }

    /**
     * @param billId (optional) 
     * @return Success
     */
    getTfxBillItem(billId: number | undefined): Observable<TfxBillItem[]> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetTfxBillItem?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTfxBillItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTfxBillItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TfxBillItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TfxBillItem[]>;
        }));
    }

    protected processGetTfxBillItem(response: HttpResponseBase): Observable<TfxBillItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(TfxBillItem.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TfxBillItem[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTfxbillWithPdf(body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bill/SendTfxbillWithPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendTfxbillWithPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTfxbillWithPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTfxbillWithPdf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrderFromBill(body: BillDto | undefined): Observable<OrdersDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/CreateOrderFromBill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrderFromBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrderFromBill(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrdersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrdersDto>;
        }));
    }

    protected processCreateOrderFromBill(response: HttpResponseBase): Observable<OrdersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrdersDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrdersDto>(null as any);
    }

    /**
     * @param billId (optional) 
     * @return Success
     */
    updateOrdersItemProductOnShelf(billId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bill/UpdateOrdersItemProductOnShelf?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateOrdersItemProductOnShelf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrdersItemProductOnShelf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrdersItemProductOnShelf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tenancyName (optional) 
     * @return Success
     */
    getFirebaseProducts(tenancyName: string | undefined): Observable<FirebaseProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetFirebaseProducts?";
        if (tenancyName === null)
            throw new Error("The parameter 'tenancyName' cannot be null.");
        else if (tenancyName !== undefined)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFirebaseProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirebaseProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FirebaseProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FirebaseProductDto[]>;
        }));
    }

    protected processGetFirebaseProducts(response: HttpResponseBase): Observable<FirebaseProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(FirebaseProductDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FirebaseProductDto[]>(null as any);
    }

    /**
     * @param tenancyName (optional) 
     * @return Success
     */
    getFirebaseCategory(tenancyName: string | undefined): Observable<FirebaseProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetFirebaseCategory?";
        if (tenancyName === null)
            throw new Error("The parameter 'tenancyName' cannot be null.");
        else if (tenancyName !== undefined)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFirebaseCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirebaseCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FirebaseProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FirebaseProductDto[]>;
        }));
    }

    protected processGetFirebaseCategory(response: HttpResponseBase): Observable<FirebaseProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(FirebaseProductDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FirebaseProductDto[]>(null as any);
    }

    /**
     * @param tenancyName (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatefirebaseProductId(tenancyName: string | undefined, body: ProductDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bill/UpdatefirebaseProductId?";
        if (tenancyName === null)
            throw new Error("The parameter 'tenancyName' cannot be null.");
        else if (tenancyName !== undefined)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatefirebaseProductId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatefirebaseProductId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatefirebaseProductId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param billUrl (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateBillUrl(billUrl: string | undefined, body: BillDto | undefined): Observable<BillDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/UpdateBillUrl?";
        if (billUrl === null)
            throw new Error("The parameter 'billUrl' cannot be null.");
        else if (billUrl !== undefined)
            url_ += "billUrl=" + encodeURIComponent("" + billUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateBillUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBillUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDto>;
        }));
    }

    protected processUpdateBillUrl(response: HttpResponseBase): Observable<BillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    sendScfOnboardingNotification(tenantId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Bill/sendScfOnboardingNotification?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendScfOnboardingNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendScfOnboardingNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendScfOnboardingNotification(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<BillDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDto>(null as any);
    }

    /**
     * @param status (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(status: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<BillDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/GetAll?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BillDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateBillDto | undefined): Observable<BillDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<BillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateBillDto | undefined): Observable<BillDto> {
        let url_ = this.baseUrl + "/api/services/app/Bill/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<BillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Bill/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class BillItemServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getByBillId(id: string | undefined): Observable<BillItemDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/BillItem/GetByBillId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetByBillId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByBillId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillItemDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillItemDtoListResultDto>;
        }));
    }

    protected processGetByBillId(response: HttpResponseBase): Observable<BillItemDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillItemDtoListResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillItemDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBillService(body: BillServiceDto | undefined): Observable<BillServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/BillItem/CreateBillService";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateBillService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBillService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillServiceDto>;
        }));
    }

    protected processCreateBillService(response: HttpResponseBase): Observable<BillServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillServiceDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillServiceDto>(null as any);
    }

    /**
     * @param billId (optional) 
     * @return Success
     */
    getBillService(billId: string | undefined): Observable<BillServiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BillItem/GetBillService?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBillService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillServiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillServiceDto[]>;
        }));
    }

    protected processGetBillService(response: HttpResponseBase): Observable<BillServiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(BillServiceDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillServiceDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateBillService(id: number | undefined, body: BillServiceDto | undefined): Observable<BillServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/BillItem/UpdateBillService?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateBillService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBillService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillServiceDto>;
        }));
    }

    protected processUpdateBillService(response: HttpResponseBase): Observable<BillServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillServiceDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillServiceDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteBillService(id: number | undefined): Observable<BillServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/BillItem/DeleteBillService?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteBillService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBillService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillServiceDto>;
        }));
    }

    protected processDeleteBillService(response: HttpResponseBase): Observable<BillServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillServiceDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillServiceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    marketplaceCreateBillItem(body: BillItemDto | undefined): Observable<BillItemDto> {
        let url_ = this.baseUrl + "/api/services/app/BillItem/MarketplaceCreateBillItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processMarketplaceCreateBillItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarketplaceCreateBillItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillItemDto>;
        }));
    }

    protected processMarketplaceCreateBillItem(response: HttpResponseBase): Observable<BillItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBillItem(body: BillItemDto | undefined): Observable<BillItemDto> {
        let url_ = this.baseUrl + "/api/services/app/BillItem/CreateBillItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateBillItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBillItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillItemDto>;
        }));
    }

    protected processCreateBillItem(response: HttpResponseBase): Observable<BillItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBillItemAndInventoryCount(body: BillItemDto | undefined): Observable<BillItemDto> {
        let url_ = this.baseUrl + "/api/services/app/BillItem/UpdateBillItemAndInventoryCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateBillItemAndInventoryCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBillItemAndInventoryCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillItemDto>;
        }));
    }

    protected processUpdateBillItemAndInventoryCount(response: HttpResponseBase): Observable<BillItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillItemDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<BillItemDto> {
        let url_ = this.baseUrl + "/api/services/app/BillItem/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillItemDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BillItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillItemDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<BillItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/BillItem/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BillItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillItemDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillItemDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateBillItemDto | undefined): Observable<BillItemDto> {
        let url_ = this.baseUrl + "/api/services/app/BillItem/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillItemDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<BillItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateBillItemDto | undefined): Observable<BillItemDto> {
        let url_ = this.baseUrl + "/api/services/app/BillItem/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillItemDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<BillItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillItemDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillItem/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CartServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getByProductId(id: string | undefined): Observable<CartDto> {
        let url_ = this.baseUrl + "/api/services/app/Cart/GetByProductId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetByProductId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProductId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CartDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CartDto>;
        }));
    }

    protected processGetByProductId(response: HttpResponseBase): Observable<CartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CartDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CartDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserCartsByUserId(userId: number | undefined): Observable<CartDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Cart/GetUserCartsByUserId?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserCartsByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserCartsByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CartDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CartDto[]>;
        }));
    }

    protected processGetUserCartsByUserId(response: HttpResponseBase): Observable<CartDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(CartDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CartDto[]>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    clearUserCart(userId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Cart/ClearUserCart?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processClearUserCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearUserCart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processClearUserCart(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param cartId (optional) 
     * @return Success
     */
    removeCartItem(cartId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Cart/RemoveCartItem?";
        if (cartId === null)
            throw new Error("The parameter 'cartId' cannot be null.");
        else if (cartId !== undefined)
            url_ += "cartId=" + encodeURIComponent("" + cartId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRemoveCartItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveCartItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRemoveCartItem(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<CartDto> {
        let url_ = this.baseUrl + "/api/services/app/Cart/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CartDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CartDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CartDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CartDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<CartDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Cart/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CartDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CartDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CartDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CartDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CartDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCartDto | undefined): Observable<CartDto> {
        let url_ = this.baseUrl + "/api/services/app/Cart/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CartDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CartDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CartDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CartDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCartDto | undefined): Observable<CartDto> {
        let url_ = this.baseUrl + "/api/services/app/Cart/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CartDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CartDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CartDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CartDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Cart/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CashbookServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCashBook(body: CashbooksDto | undefined): Observable<CashbooksDto> {
        let url_ = this.baseUrl + "/api/services/app/Cashbook/CreateCashBook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateCashBook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCashBook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashbooksDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashbooksDto>;
        }));
    }

    protected processCreateCashBook(response: HttpResponseBase): Observable<CashbooksDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CashbooksDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashbooksDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param inputStartDate (optional) 
     * @param inputEndDate (optional) 
     * @param bankAccountNo (optional) 
     * @return Success
     */
    getCashbookData(tenantId: number | undefined, inputStartDate: moment.Moment | undefined, inputEndDate: moment.Moment | undefined, bankAccountNo: string | undefined): Observable<CashbookData> {
        let url_ = this.baseUrl + "/api/services/app/Cashbook/GetCashbookData?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (inputStartDate === null)
            throw new Error("The parameter 'inputStartDate' cannot be null.");
        else if (inputStartDate !== undefined)
            url_ += "inputStartDate=" + encodeURIComponent(inputStartDate ? "" + inputStartDate.toISOString() : "") + "&";
        if (inputEndDate === null)
            throw new Error("The parameter 'inputEndDate' cannot be null.");
        else if (inputEndDate !== undefined)
            url_ += "inputEndDate=" + encodeURIComponent(inputEndDate ? "" + inputEndDate.toISOString() : "") + "&";
        if (bankAccountNo === null)
            throw new Error("The parameter 'bankAccountNo' cannot be null.");
        else if (bankAccountNo !== undefined)
            url_ += "bankAccountNo=" + encodeURIComponent("" + bankAccountNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCashbookData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCashbookData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashbookData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashbookData>;
        }));
    }

    protected processGetCashbookData(response: HttpResponseBase): Observable<CashbookData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CashbookData.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashbookData>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param inputStartDate (optional) 
     * @param inputEndDate (optional) 
     * @return Success
     */
    getAllCashbookData(tenantId: number | undefined, inputStartDate: moment.Moment | undefined, inputEndDate: moment.Moment | undefined): Observable<CashbookData> {
        let url_ = this.baseUrl + "/api/services/app/Cashbook/GetAllCashbookData?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (inputStartDate === null)
            throw new Error("The parameter 'inputStartDate' cannot be null.");
        else if (inputStartDate !== undefined)
            url_ += "inputStartDate=" + encodeURIComponent(inputStartDate ? "" + inputStartDate.toISOString() : "") + "&";
        if (inputEndDate === null)
            throw new Error("The parameter 'inputEndDate' cannot be null.");
        else if (inputEndDate !== undefined)
            url_ += "inputEndDate=" + encodeURIComponent(inputEndDate ? "" + inputEndDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllCashbookData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCashbookData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashbookData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashbookData>;
        }));
    }

    protected processGetAllCashbookData(response: HttpResponseBase): Observable<CashbookData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CashbookData.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashbookData>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getCashbookDataForPettyCash(tenantId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<CashbookData> {
        let url_ = this.baseUrl + "/api/services/app/Cashbook/GetCashbookDataForPettyCash?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCashbookDataForPettyCash(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCashbookDataForPettyCash(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashbookData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashbookData>;
        }));
    }

    protected processGetCashbookDataForPettyCash(response: HttpResponseBase): Observable<CashbookData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CashbookData.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashbookData>(null as any);
    }

    /**
     * @param gantan (optional) 
     * @param inputDate (optional) 
     * @return Success
     */
    getCashbookDataForLedger(gantan: moment.Moment | undefined, inputDate: moment.Moment | undefined): Observable<LedgerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Cashbook/GetCashbookDataForLedger?";
        if (gantan === null)
            throw new Error("The parameter 'gantan' cannot be null.");
        else if (gantan !== undefined)
            url_ += "gantan=" + encodeURIComponent(gantan ? "" + gantan.toISOString() : "") + "&";
        if (inputDate === null)
            throw new Error("The parameter 'inputDate' cannot be null.");
        else if (inputDate !== undefined)
            url_ += "inputDate=" + encodeURIComponent(inputDate ? "" + inputDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCashbookDataForLedger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCashbookDataForLedger(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LedgerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LedgerDto[]>;
        }));
    }

    protected processGetCashbookDataForLedger(response: HttpResponseBase): Observable<LedgerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(LedgerDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LedgerDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getAllCashbooks(tenantId: number | undefined): Observable<Cashbooks[]> {
        let url_ = this.baseUrl + "/api/services/app/Cashbook/GetAllCashbooks?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllCashbooks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCashbooks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Cashbooks[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Cashbooks[]>;
        }));
    }

    protected processGetAllCashbooks(response: HttpResponseBase): Observable<Cashbooks[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(Cashbooks.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Cashbooks[]>(null as any);
    }

    /**
     * @param referenceNo (optional) 
     * @return Success
     */
    getAllCashbooksByReferenceNo(referenceNo: string | undefined): Observable<Cashbooks[]> {
        let url_ = this.baseUrl + "/api/services/app/Cashbook/GetAllCashbooksByReferenceNo?";
        if (referenceNo === null)
            throw new Error("The parameter 'referenceNo' cannot be null.");
        else if (referenceNo !== undefined)
            url_ += "referenceNo=" + encodeURIComponent("" + referenceNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllCashbooksByReferenceNo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCashbooksByReferenceNo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Cashbooks[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Cashbooks[]>;
        }));
    }

    protected processGetAllCashbooksByReferenceNo(response: HttpResponseBase): Observable<Cashbooks[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(Cashbooks.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Cashbooks[]>(null as any);
    }

    /**
     * @param creditNoteInvoiceId (optional) 
     * @return Success
     */
    checkCreditNotePaidWithCashbook(creditNoteInvoiceId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Cashbook/CheckCreditNotePaidWithCashbook?";
        if (creditNoteInvoiceId === null)
            throw new Error("The parameter 'creditNoteInvoiceId' cannot be null.");
        else if (creditNoteInvoiceId !== undefined)
            url_ += "creditNoteInvoiceId=" + encodeURIComponent("" + creditNoteInvoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckCreditNotePaidWithCashbook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCreditNotePaidWithCashbook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCheckCreditNotePaidWithCashbook(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getCashbooksWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<CashbooksPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Cashbook/GetCashbooksWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCashbooksWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCashbooksWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashbooksPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashbooksPagedResultDto>;
        }));
    }

    protected processGetCashbooksWithInput(response: HttpResponseBase): Observable<CashbooksPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CashbooksPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashbooksPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateCashbook(id: number | undefined, body: CashbooksDto | undefined): Observable<Cashbooks> {
        let url_ = this.baseUrl + "/api/services/app/Cashbook/UpdateCashbook?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateCashbook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCashbook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Cashbooks>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Cashbooks>;
        }));
    }

    protected processUpdateCashbook(response: HttpResponseBase): Observable<Cashbooks> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Cashbooks.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Cashbooks>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteCashbook(id: number | undefined): Observable<CashbooksDto> {
        let url_ = this.baseUrl + "/api/services/app/Cashbook/DeleteCashbook?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteCashbook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCashbook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashbooksDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashbooksDto>;
        }));
    }

    protected processDeleteCashbook(response: HttpResponseBase): Observable<CashbooksDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CashbooksDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashbooksDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getCashbookDataForApproval(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<CashbooksDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Cashbook/GetCashbookDataForApproval?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCashbookDataForApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCashbookDataForApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashbooksDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashbooksDtoPagedResultDto>;
        }));
    }

    protected processGetCashbookDataForApproval(response: HttpResponseBase): Observable<CashbooksDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CashbooksDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashbooksDtoPagedResultDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getCashbookDataForReversal(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<CashbooksDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Cashbook/GetCashbookDataForReversal?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCashbookDataForReversal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCashbookDataForReversal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashbooksDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashbooksDtoPagedResultDto>;
        }));
    }

    protected processGetCashbookDataForReversal(response: HttpResponseBase): Observable<CashbooksDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CashbooksDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashbooksDtoPagedResultDto>(null as any);
    }

    /**
     * @param referenceNo (optional) 
     * @param remarks (optional) 
     * @param approvalStatusInt (optional) 
     * @return Success
     */
    approvePayment(referenceNo: string | undefined, remarks: string | undefined, approvalStatusInt: number | undefined): Observable<CashbooksDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Cashbook/ApprovePayment?";
        if (referenceNo === null)
            throw new Error("The parameter 'referenceNo' cannot be null.");
        else if (referenceNo !== undefined)
            url_ += "referenceNo=" + encodeURIComponent("" + referenceNo) + "&";
        if (remarks === null)
            throw new Error("The parameter 'remarks' cannot be null.");
        else if (remarks !== undefined)
            url_ += "remarks=" + encodeURIComponent("" + remarks) + "&";
        if (approvalStatusInt === null)
            throw new Error("The parameter 'approvalStatusInt' cannot be null.");
        else if (approvalStatusInt !== undefined)
            url_ += "approvalStatusInt=" + encodeURIComponent("" + approvalStatusInt) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processApprovePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprovePayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashbooksDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashbooksDto[]>;
        }));
    }

    protected processApprovePayment(response: HttpResponseBase): Observable<CashbooksDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(CashbooksDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashbooksDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requestReversal(body: CashbooksDto | undefined): Observable<CashbooksDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Cashbook/RequestReversal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRequestReversal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestReversal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashbooksDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashbooksDto[]>;
        }));
    }

    protected processRequestReversal(response: HttpResponseBase): Observable<CashbooksDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(CashbooksDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashbooksDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approveReversal(body: CashbooksDto | undefined): Observable<CashbooksDto> {
        let url_ = this.baseUrl + "/api/services/app/Cashbook/ApproveReversal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processApproveReversal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveReversal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashbooksDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashbooksDto>;
        }));
    }

    protected processApproveReversal(response: HttpResponseBase): Observable<CashbooksDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CashbooksDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashbooksDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getMakePaymentMiscCashbooks(tenantId: number | undefined): Observable<CashbooksDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Cashbook/GetMakePaymentMiscCashbooks?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMakePaymentMiscCashbooks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMakePaymentMiscCashbooks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashbooksDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashbooksDto[]>;
        }));
    }

    protected processGetMakePaymentMiscCashbooks(response: HttpResponseBase): Observable<CashbooksDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(CashbooksDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashbooksDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkMigrationData(body: CashbooksDto[] | undefined): Observable<CashbooksDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Cashbook/checkMigrationData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckMigrationData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckMigrationData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashbooksDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashbooksDto[]>;
        }));
    }

    protected processCheckMigrationData(response: HttpResponseBase): Observable<CashbooksDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(CashbooksDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashbooksDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCashBookFromList(body: CashbooksDto[] | undefined): Observable<CashbooksDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Cashbook/CreateCashBookFromList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateCashBookFromList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCashBookFromList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashbooksDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashbooksDto[]>;
        }));
    }

    protected processCreateCashBookFromList(response: HttpResponseBase): Observable<CashbooksDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(CashbooksDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashbooksDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getPayBadge(tenantId: number | undefined): Observable<PayBadgeDto> {
        let url_ = this.baseUrl + "/api/services/app/Cashbook/GetPayBadge?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPayBadge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayBadge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayBadgeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayBadgeDto>;
        }));
    }

    protected processGetPayBadge(response: HttpResponseBase): Observable<PayBadgeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PayBadgeDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PayBadgeDto>(null as any);
    }
}

@Injectable()
export class CompanyProfileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getCompanyProfileByTenantId(tenantId: number | undefined): Observable<CompanyProfile> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetCompanyProfileByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCompanyProfileByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyProfileByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyProfile>;
        }));
    }

    protected processGetCompanyProfileByTenantId(response: HttpResponseBase): Observable<CompanyProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyProfile.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyProfile>(null as any);
    }

    /**
     * @return Success
     */
    getMyCompanyProfile(): Observable<CompanyProfile> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetMyCompanyProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMyCompanyProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyCompanyProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyProfile>;
        }));
    }

    protected processGetMyCompanyProfile(response: HttpResponseBase): Observable<CompanyProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyProfile.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyProfile>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getMerchantsWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<CompanyProfilePagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetMerchantsWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMerchantsWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMerchantsWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyProfilePagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyProfilePagedResultDto>;
        }));
    }

    protected processGetMerchantsWithInput(response: HttpResponseBase): Observable<CompanyProfilePagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyProfilePagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyProfilePagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    updateTutorialCompleted(): Observable<CompanyProfile> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/UpdateTutorialCompleted";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateTutorialCompleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTutorialCompleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyProfile>;
        }));
    }

    protected processUpdateTutorialCompleted(response: HttpResponseBase): Observable<CompanyProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyProfile.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyProfile>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCompanyRegNo(body: UpdateCompanyProfileDto | undefined): Observable<CompanyProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/UpdateCompanyRegNo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateCompanyRegNo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCompanyRegNo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyProfileDto>;
        }));
    }

    protected processUpdateCompanyRegNo(response: HttpResponseBase): Observable<CompanyProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyProfileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyProfileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBillplzInfo(body: UpdateBillplzDto | undefined): Observable<CompanyProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/UpdateBillplzInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateBillplzInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBillplzInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyProfileDto>;
        }));
    }

    protected processUpdateBillplzInfo(response: HttpResponseBase): Observable<CompanyProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyProfileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyProfileDto>(null as any);
    }

    /**
     * @param companyRegNo (optional) 
     * @return Success
     */
    getCompanyprofileByRegNo(companyRegNo: string | undefined): Observable<CompanyProfile> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetCompanyprofileByRegNo?";
        if (companyRegNo === null)
            throw new Error("The parameter 'companyRegNo' cannot be null.");
        else if (companyRegNo !== undefined)
            url_ += "companyRegNo=" + encodeURIComponent("" + companyRegNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCompanyprofileByRegNo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyprofileByRegNo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyProfile>;
        }));
    }

    protected processGetCompanyprofileByRegNo(response: HttpResponseBase): Observable<CompanyProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyProfile.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyProfile>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateScfApplicationStatus(body: UpdateScfDto | undefined): Observable<UpdateScfDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/UpdateScfApplicationStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateScfApplicationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateScfApplicationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateScfDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateScfDto>;
        }));
    }

    protected processUpdateScfApplicationStatus(response: HttpResponseBase): Observable<UpdateScfDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateScfDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateScfDto>(null as any);
    }

    /**
     * @param key (optional) 
     * @param cipherText (optional) 
     * @return Success
     */
    decryptString(key: string | undefined, cipherText: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/DecryptString?";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        if (cipherText === null)
            throw new Error("The parameter 'cipherText' cannot be null.");
        else if (cipherText !== undefined)
            url_ += "cipherText=" + encodeURIComponent("" + cipherText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDecryptString(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDecryptString(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDecryptString(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAiInformation(body: CompanyProfile | undefined): Observable<CompanyProfile> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/UpdateAiInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateAiInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAiInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyProfile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyProfile>;
        }));
    }

    protected processUpdateAiInformation(response: HttpResponseBase): Observable<CompanyProfile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyProfile.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyProfile>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateFinancialStatementUrl(body: UpdateFSDto | undefined): Observable<UpdateFSDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/UpdateFinancialStatementUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateFinancialStatementUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFinancialStatementUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateFSDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateFSDto>;
        }));
    }

    protected processUpdateFinancialStatementUrl(response: HttpResponseBase): Observable<UpdateFSDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateFSDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateFSDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<CompanyProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyProfileDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CompanyProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyProfileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyProfileDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<CompanyProfileDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyProfileDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyProfileDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CompanyProfileDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyProfileDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyProfileDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCompanyProfileDto | undefined): Observable<CompanyProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyProfileDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CompanyProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyProfileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyProfileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCompanyProfileDto | undefined): Observable<CompanyProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyProfileDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CompanyProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyProfileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyProfileDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyProfile/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processChangeUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUiTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CurrencyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    saveExchangeRates(): Observable<CurrencyResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Currency/SaveExchangeRates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveExchangeRates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveExchangeRates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrencyResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrencyResponseDto>;
        }));
    }

    protected processSaveExchangeRates(response: HttpResponseBase): Observable<CurrencyResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CurrencyResponseDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrencyResponseDto>(null as any);
    }

    /**
     * @return Success
     */
    getDefaultCurrency(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Currency/GetDefaultCurrency";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDefaultCurrency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultCurrency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDefaultCurrency(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateTfxCurrency(body: CurrencyResponseDto | undefined): Observable<CurrencyResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Currency/CreateOrUpdateTfxCurrency";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrUpdateTfxCurrency(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateTfxCurrency(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrencyResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrencyResponseDto>;
        }));
    }

    protected processCreateOrUpdateTfxCurrency(response: HttpResponseBase): Observable<CurrencyResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CurrencyResponseDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrencyResponseDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllExchangeRate(): Observable<TfxCurrency> {
        let url_ = this.baseUrl + "/api/services/app/Currency/GetAllExchangeRate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllExchangeRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExchangeRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TfxCurrency>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TfxCurrency>;
        }));
    }

    protected processGetAllExchangeRate(response: HttpResponseBase): Observable<TfxCurrency> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TfxCurrency.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TfxCurrency>(null as any);
    }
}

@Injectable()
export class CustomerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getCustomersWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<CustomerDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/GetCustomersWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCustomersWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomersWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDtoPagedResultDto>;
        }));
    }

    protected processGetCustomersWithInput(response: HttpResponseBase): Observable<CustomerDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteCustomer(id: string | undefined): Observable<CustomerDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/DeleteCustomer?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDto>;
        }));
    }

    protected processDeleteCustomer(response: HttpResponseBase): Observable<CustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCustomerShippingAddress(body: CustomerShippingAddressDto | undefined): Observable<CustomerShippingAddressDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/CreateCustomerShippingAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateCustomerShippingAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustomerShippingAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerShippingAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerShippingAddressDto>;
        }));
    }

    protected processCreateCustomerShippingAddress(response: HttpResponseBase): Observable<CustomerShippingAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerShippingAddressDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerShippingAddressDto>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    getCustomerShippingAddress(customerId: string | undefined): Observable<CustomerShippingAddress[]> {
        let url_ = this.baseUrl + "/api/services/app/Customer/GetCustomerShippingAddress?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCustomerShippingAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerShippingAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerShippingAddress[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerShippingAddress[]>;
        }));
    }

    protected processGetCustomerShippingAddress(response: HttpResponseBase): Observable<CustomerShippingAddress[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(CustomerShippingAddress.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerShippingAddress[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteShippingAddress(id: number | undefined): Observable<CustomerShippingAddressDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/DeleteShippingAddress?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteShippingAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteShippingAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerShippingAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerShippingAddressDto>;
        }));
    }

    protected processDeleteShippingAddress(response: HttpResponseBase): Observable<CustomerShippingAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerShippingAddressDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerShippingAddressDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @param startdate (optional) 
     * @param enddate (optional) 
     * @param showAll (optional) 
     * @param customerType (optional) 
     * @return Success
     */
    getCustomersWithInputFilterDate(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined, startdate: moment.Moment | undefined, enddate: moment.Moment | undefined, showAll: boolean | undefined, customerType: number | undefined): Observable<CustomerDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/GetCustomersWithInputFilterDate?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (startdate === null)
            throw new Error("The parameter 'startdate' cannot be null.");
        else if (startdate !== undefined)
            url_ += "startdate=" + encodeURIComponent(startdate ? "" + startdate.toISOString() : "") + "&";
        if (enddate === null)
            throw new Error("The parameter 'enddate' cannot be null.");
        else if (enddate !== undefined)
            url_ += "enddate=" + encodeURIComponent(enddate ? "" + enddate.toISOString() : "") + "&";
        if (showAll === null)
            throw new Error("The parameter 'showAll' cannot be null.");
        else if (showAll !== undefined)
            url_ += "showAll=" + encodeURIComponent("" + showAll) + "&";
        if (customerType === null)
            throw new Error("The parameter 'customerType' cannot be null.");
        else if (customerType !== undefined)
            url_ += "customerType=" + encodeURIComponent("" + customerType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCustomersWithInputFilterDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomersWithInputFilterDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDtoPagedResultDto>;
        }));
    }

    protected processGetCustomersWithInputFilterDate(response: HttpResponseBase): Observable<CustomerDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDtoPagedResultDto>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    getCustomerById(customerId: string | undefined): Observable<Customer> {
        let url_ = this.baseUrl + "/api/services/app/Customer/GetCustomerById?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCustomerById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Customer>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Customer>;
        }));
    }

    protected processGetCustomerById(response: HttpResponseBase): Observable<Customer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Customer.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Customer>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCustomerOutstanding(body: CustomerOutstandingDto | undefined): Observable<CustomerOutstandingDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/CreateCustomerOutstanding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateCustomerOutstanding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustomerOutstanding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerOutstandingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerOutstandingDto>;
        }));
    }

    protected processCreateCustomerOutstanding(response: HttpResponseBase): Observable<CustomerOutstandingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerOutstandingDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerOutstandingDto>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    getCustomerOutstanding(customerId: string | undefined): Observable<CustomerOutstanding[]> {
        let url_ = this.baseUrl + "/api/services/app/Customer/GetCustomerOutstanding?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCustomerOutstanding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerOutstanding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerOutstanding[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerOutstanding[]>;
        }));
    }

    protected processGetCustomerOutstanding(response: HttpResponseBase): Observable<CustomerOutstanding[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(CustomerOutstanding.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerOutstanding[]>(null as any);
    }

    /**
     * @return Success
     */
    getCustomersByTenantId(): Observable<CustomerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Customer/GetCustomersByTenantId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCustomersByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomersByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDto[]>;
        }));
    }

    protected processGetCustomersByTenantId(response: HttpResponseBase): Observable<CustomerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(CustomerDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateCustomerOutstanding(id: number | undefined, body: CustomerOutstandingDto | undefined): Observable<CustomerOutstandingDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/UpdateCustomerOutstanding?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateCustomerOutstanding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomerOutstanding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerOutstandingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerOutstandingDto>;
        }));
    }

    protected processUpdateCustomerOutstanding(response: HttpResponseBase): Observable<CustomerOutstandingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerOutstandingDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerOutstandingDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteCustomerOutstanding(id: number | undefined): Observable<CustomerOutstandingDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/DeleteCustomerOutstanding?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteCustomerOutstanding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomerOutstanding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerOutstandingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerOutstandingDto>;
        }));
    }

    protected processDeleteCustomerOutstanding(response: HttpResponseBase): Observable<CustomerOutstandingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerOutstandingDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerOutstandingDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param email (optional) 
     * @param name (optional) 
     * @return Success
     */
    getCustomerByEmail(tenantId: number | undefined, email: string | undefined, name: string | undefined): Observable<CustomerDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/GetCustomerByEmail?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCustomerByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerByEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDto>;
        }));
    }

    protected processGetCustomerByEmail(response: HttpResponseBase): Observable<CustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    marketplaceCreateCustomer(body: CustomerDto | undefined): Observable<CustomerDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/MarketplaceCreateCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processMarketplaceCreateCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarketplaceCreateCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDto>;
        }));
    }

    protected processMarketplaceCreateCustomer(response: HttpResponseBase): Observable<CustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkCustomer(body: CustomerDto | undefined): Observable<CustomerDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/CheckCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDto>;
        }));
    }

    protected processCheckCustomer(response: HttpResponseBase): Observable<CustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto>(null as any);
    }

    /**
     * @param subject (optional) 
     * @param message (optional) 
     * @param body (optional) 
     * @return Success
     */
    emailAllCustomers(subject: string | undefined, message: string | undefined, body: CompanyProfile | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Customer/EmailAllCustomers?";
        if (subject === null)
            throw new Error("The parameter 'subject' cannot be null.");
        else if (subject !== undefined)
            url_ += "subject=" + encodeURIComponent("" + subject) + "&";
        if (message === null)
            throw new Error("The parameter 'message' cannot be null.");
        else if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processEmailAllCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailAllCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmailAllCustomers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    generateNewCustomerCode(tenantId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Customer/GenerateNewCustomerCode?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGenerateNewCustomerCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateNewCustomerCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateNewCustomerCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkMigrationData(body: CustomerMigrationDto[] | undefined): Observable<CustomerMigrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Customer/CheckMigrationData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckMigrationData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckMigrationData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerMigrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerMigrationDto[]>;
        }));
    }

    protected processCheckMigrationData(response: HttpResponseBase): Observable<CustomerMigrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(CustomerMigrationDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerMigrationDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCustomersFromMigration(body: CustomerMigrationDto[] | undefined): Observable<CustomerMigrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Customer/CreateCustomersFromMigration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateCustomersFromMigration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustomersFromMigration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerMigrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerMigrationDto[]>;
        }));
    }

    protected processCreateCustomersFromMigration(response: HttpResponseBase): Observable<CustomerMigrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(CustomerMigrationDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerMigrationDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<CustomerDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomerDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomerDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCustomerDto | undefined): Observable<CustomerDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCustomerDto | undefined): Observable<CustomerDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Customer/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class DealershipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getAllDealers(): Observable<DealerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dealership/GetAllDealers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllDealers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDealers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DealerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DealerDto[]>;
        }));
    }

    protected processGetAllDealers(response: HttpResponseBase): Observable<DealerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(DealerDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DealerDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getDealersWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<CompanyProfilePagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Dealership/GetDealersWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDealersWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDealersWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyProfilePagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyProfilePagedResultDto>;
        }));
    }

    protected processGetDealersWithInput(response: HttpResponseBase): Observable<CompanyProfilePagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyProfilePagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyProfilePagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateDealer(id: string | undefined, body: CompanyProfileDto | undefined): Observable<CompanyProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/Dealership/UpdateDealer?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateDealer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDealer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyProfileDto>;
        }));
    }

    protected processUpdateDealer(response: HttpResponseBase): Observable<CompanyProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyProfileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyProfileDto>(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @return Success
     */
    inviteDealerOnboard(emailAddress: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Dealership/InviteDealerOnboard?";
        if (emailAddress === null)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processInviteDealerOnboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInviteDealerOnboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInviteDealerOnboard(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getDistributors(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<VendorPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Dealership/GetDistributors?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDistributors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDistributors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorPagedResultDto>;
        }));
    }

    protected processGetDistributors(response: HttpResponseBase): Observable<VendorPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorPagedResultDto>(null as any);
    }

    /**
     * @param producerTenantId (optional) 
     * @return Success
     */
    getAllDistributors(producerTenantId: number | undefined): Observable<Vendor[]> {
        let url_ = this.baseUrl + "/api/services/app/Dealership/GetAllDistributors?";
        if (producerTenantId === null)
            throw new Error("The parameter 'producerTenantId' cannot be null.");
        else if (producerTenantId !== undefined)
            url_ += "producerTenantId=" + encodeURIComponent("" + producerTenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllDistributors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDistributors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Vendor[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Vendor[]>;
        }));
    }

    protected processGetAllDistributors(response: HttpResponseBase): Observable<Vendor[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(Vendor.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Vendor[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDistributor(body: VendorDto | undefined): Observable<VendorDto> {
        let url_ = this.baseUrl + "/api/services/app/Dealership/createDistributor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateDistributor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDistributor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorDto>;
        }));
    }

    protected processCreateDistributor(response: HttpResponseBase): Observable<VendorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorDto>(null as any);
    }
}

@Injectable()
export class DebitNoteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDebitNote(body: DebitNoteDto | undefined): Observable<DebitNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/DebitNote/CreateDebitNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateDebitNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDebitNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DebitNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DebitNoteDto>;
        }));
    }

    protected processCreateDebitNote(response: HttpResponseBase): Observable<DebitNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DebitNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DebitNoteDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDebitNote(body: DebitNoteDto | undefined): Observable<DebitNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/DebitNote/UpdateDebitNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateDebitNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDebitNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DebitNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DebitNoteDto>;
        }));
    }

    protected processUpdateDebitNote(response: HttpResponseBase): Observable<DebitNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DebitNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DebitNoteDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getDebitNotesWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<DebitNoteDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DebitNote/GetDebitNotesWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDebitNotesWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDebitNotesWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DebitNoteDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DebitNoteDtoPagedResultDto>;
        }));
    }

    protected processGetDebitNotesWithInput(response: HttpResponseBase): Observable<DebitNoteDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DebitNoteDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DebitNoteDtoPagedResultDto>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getDebitNotesForLedger(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<LedgerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DebitNote/GetDebitNotesForLedger?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDebitNotesForLedger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDebitNotesForLedger(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LedgerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LedgerDto[]>;
        }));
    }

    protected processGetDebitNotesForLedger(response: HttpResponseBase): Observable<LedgerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(LedgerDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LedgerDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<DebitNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/DebitNote/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DebitNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DebitNoteDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DebitNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DebitNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DebitNoteDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<DebitNoteDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DebitNote/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DebitNoteDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DebitNoteDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DebitNoteDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DebitNoteDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DebitNoteDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: DebitNoteDto | undefined): Observable<DebitNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/DebitNote/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DebitNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DebitNoteDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DebitNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DebitNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DebitNoteDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: DebitNoteDto | undefined): Observable<DebitNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/DebitNote/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DebitNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DebitNoteDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DebitNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DebitNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DebitNoteDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DebitNote/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class DebitNoteItemServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<DebitNoteItemDto> {
        let url_ = this.baseUrl + "/api/services/app/DebitNoteItem/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DebitNoteItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DebitNoteItemDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DebitNoteItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DebitNoteItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DebitNoteItemDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<DebitNoteItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DebitNoteItem/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DebitNoteItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DebitNoteItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DebitNoteItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DebitNoteItemDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DebitNoteItemDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: DebitNoteItemDto | undefined): Observable<DebitNoteItemDto> {
        let url_ = this.baseUrl + "/api/services/app/DebitNoteItem/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DebitNoteItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DebitNoteItemDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DebitNoteItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DebitNoteItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DebitNoteItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: DebitNoteItemDto | undefined): Observable<DebitNoteItemDto> {
        let url_ = this.baseUrl + "/api/services/app/DebitNoteItem/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DebitNoteItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DebitNoteItemDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DebitNoteItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DebitNoteItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DebitNoteItemDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DebitNoteItem/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class DepartmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDepartment(body: DepartmentDto | undefined): Observable<DepartmentDto> {
        let url_ = this.baseUrl + "/api/services/app/Department/CreateDepartment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DepartmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DepartmentDto>;
        }));
    }

    protected processCreateDepartment(response: HttpResponseBase): Observable<DepartmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DepartmentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DepartmentDto>(null as any);
    }

    /**
     * @param departmentId (optional) 
     * @return Success
     */
    getDepartment(departmentId: number | undefined): Observable<Department[]> {
        let url_ = this.baseUrl + "/api/services/app/Department/GetDepartment?";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Department[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Department[]>;
        }));
    }

    protected processGetDepartment(response: HttpResponseBase): Observable<Department[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(Department.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Department[]>(null as any);
    }

    /**
     * @param departmentName (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getDepartmentByNameAndTenant(departmentName: string | undefined, tenantId: number | undefined): Observable<Department> {
        let url_ = this.baseUrl + "/api/services/app/Department/GetDepartmentByNameAndTenant?";
        if (departmentName === null)
            throw new Error("The parameter 'departmentName' cannot be null.");
        else if (departmentName !== undefined)
            url_ += "departmentName=" + encodeURIComponent("" + departmentName) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDepartmentByNameAndTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartmentByNameAndTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Department>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Department>;
        }));
    }

    protected processGetDepartmentByNameAndTenant(response: HttpResponseBase): Observable<Department> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Department.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Department>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getDepartments(tenantId: number | undefined): Observable<Department[]> {
        let url_ = this.baseUrl + "/api/services/app/Department/GetDepartments?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDepartments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Department[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Department[]>;
        }));
    }

    protected processGetDepartments(response: HttpResponseBase): Observable<Department[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(Department.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Department[]>(null as any);
    }

    /**
     * @param departmentId (optional) 
     * @return Success
     */
    getDepartmentById(departmentId: number | undefined): Observable<Department> {
        let url_ = this.baseUrl + "/api/services/app/Department/GetDepartmentById?";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDepartmentById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartmentById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Department>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Department>;
        }));
    }

    protected processGetDepartmentById(response: HttpResponseBase): Observable<Department> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Department.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Department>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserDepartmentByUserId(userId: number | undefined): Observable<Department> {
        let url_ = this.baseUrl + "/api/services/app/Department/GetUserDepartmentByUserId?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserDepartmentByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDepartmentByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Department>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Department>;
        }));
    }

    protected processGetUserDepartmentByUserId(response: HttpResponseBase): Observable<Department> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Department.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Department>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param departmentName (optional) 
     * @return Success
     */
    getPrDepartmentDtoByDepartmentName(tenantId: number | undefined, departmentName: string | undefined): Observable<DepartmentDto> {
        let url_ = this.baseUrl + "/api/services/app/Department/GetPrDepartmentDtoByDepartmentName?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (departmentName === null)
            throw new Error("The parameter 'departmentName' cannot be null.");
        else if (departmentName !== undefined)
            url_ += "departmentName=" + encodeURIComponent("" + departmentName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPrDepartmentDtoByDepartmentName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrDepartmentDtoByDepartmentName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DepartmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DepartmentDto>;
        }));
    }

    protected processGetPrDepartmentDtoByDepartmentName(response: HttpResponseBase): Observable<DepartmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DepartmentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DepartmentDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getDepartmentWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<DepartmentPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Department/GetDepartmentWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDepartmentWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartmentWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DepartmentPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DepartmentPagedResultDto>;
        }));
    }

    protected processGetDepartmentWithInput(response: HttpResponseBase): Observable<DepartmentPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DepartmentPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DepartmentPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateDepartment(id: number | undefined, body: DepartmentDto | undefined): Observable<DepartmentDto> {
        let url_ = this.baseUrl + "/api/services/app/Department/UpdateDepartment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DepartmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DepartmentDto>;
        }));
    }

    protected processUpdateDepartment(response: HttpResponseBase): Observable<DepartmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DepartmentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DepartmentDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteDepartment(id: number | undefined): Observable<DepartmentDto> {
        let url_ = this.baseUrl + "/api/services/app/Department/DeleteDepartment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DepartmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DepartmentDto>;
        }));
    }

    protected processDeleteDepartment(response: HttpResponseBase): Observable<DepartmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DepartmentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DepartmentDto>(null as any);
    }
}

@Injectable()
export class EasyParcelServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param pickCode (optional) 
     * @param sendCode (optional) 
     * @param weight (optional) 
     * @return Success
     */
    checkRate(pickCode: number | undefined, sendCode: number | undefined, weight: number | undefined): Observable<CheckrateReponseDto> {
        let url_ = this.baseUrl + "/api/services/app/EasyParcel/CheckRate?";
        if (pickCode === null)
            throw new Error("The parameter 'pickCode' cannot be null.");
        else if (pickCode !== undefined)
            url_ += "pickCode=" + encodeURIComponent("" + pickCode) + "&";
        if (sendCode === null)
            throw new Error("The parameter 'sendCode' cannot be null.");
        else if (sendCode !== undefined)
            url_ += "sendCode=" + encodeURIComponent("" + sendCode) + "&";
        if (weight === null)
            throw new Error("The parameter 'weight' cannot be null.");
        else if (weight !== undefined)
            url_ += "weight=" + encodeURIComponent("" + weight) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckRate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckRate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckrateReponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckrateReponseDto>;
        }));
    }

    protected processCheckRate(response: HttpResponseBase): Observable<CheckrateReponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CheckrateReponseDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckrateReponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    placeOrderBulk(body: BulkOrderDetailsDto[] | undefined): Observable<PlaceOrderResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/EasyParcel/PlaceOrderBulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPlaceOrderBulk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlaceOrderBulk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlaceOrderResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlaceOrderResponseDto>;
        }));
    }

    protected processPlaceOrderBulk(response: HttpResponseBase): Observable<PlaceOrderResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PlaceOrderResponseDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlaceOrderResponseDto>(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    makeOrderPayment(orderId: string | undefined): Observable<PaymentResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/EasyParcel/MakeOrderPayment?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processMakeOrderPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMakeOrderPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentResponseDto>;
        }));
    }

    protected processMakeOrderPayment(response: HttpResponseBase): Observable<PaymentResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaymentResponseDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEasyParcelOrder(body: Result2 | undefined): Observable<Result2> {
        let url_ = this.baseUrl + "/api/services/app/EasyParcel/CreateEasyParcelOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateEasyParcelOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEasyParcelOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result2>;
        }));
    }

    protected processCreateEasyParcelOrder(response: HttpResponseBase): Observable<Result2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Result2.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result2>(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getEasyParcelOrder(orderId: string | undefined): Observable<EasyParcelOrder> {
        let url_ = this.baseUrl + "/api/services/app/EasyParcel/GetEasyParcelOrder?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEasyParcelOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEasyParcelOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EasyParcelOrder>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EasyParcelOrder>;
        }));
    }

    protected processGetEasyParcelOrder(response: HttpResponseBase): Observable<EasyParcelOrder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EasyParcelOrder.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EasyParcelOrder>(null as any);
    }
}

@Injectable()
export class EsgServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEsgElectric(body: EsgElectricDto | undefined): Observable<EsgElectricDto> {
        let url_ = this.baseUrl + "/api/services/app/Esg/CreateEsgElectric";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateEsgElectric(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEsgElectric(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgElectricDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgElectricDto>;
        }));
    }

    protected processCreateEsgElectric(response: HttpResponseBase): Observable<EsgElectricDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EsgElectricDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgElectricDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param year (optional) 
     * @return Success
     */
    getEsgElectric(tenantId: number | undefined, year: number | undefined): Observable<EsgElectricDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Esg/GetEsgElectric?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEsgElectric(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEsgElectric(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgElectricDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgElectricDto[]>;
        }));
    }

    protected processGetEsgElectric(response: HttpResponseBase): Observable<EsgElectricDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(EsgElectricDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgElectricDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getEsgElectricWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<EsgElectricPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Esg/GetEsgElectricWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEsgElectricWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEsgElectricWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgElectricPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgElectricPagedResultDto>;
        }));
    }

    protected processGetEsgElectricWithInput(response: HttpResponseBase): Observable<EsgElectricPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EsgElectricPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgElectricPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateEsgElectric(id: number | undefined, body: EsgElectricDto | undefined): Observable<EsgElectricDto> {
        let url_ = this.baseUrl + "/api/services/app/Esg/UpdateEsgElectric?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateEsgElectric(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEsgElectric(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgElectricDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgElectricDto>;
        }));
    }

    protected processUpdateEsgElectric(response: HttpResponseBase): Observable<EsgElectricDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EsgElectricDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgElectricDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteEsgElectric(id: number | undefined): Observable<EsgElectricDto> {
        let url_ = this.baseUrl + "/api/services/app/Esg/DeleteEsgElectric?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteEsgElectric(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEsgElectric(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgElectricDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgElectricDto>;
        }));
    }

    protected processDeleteEsgElectric(response: HttpResponseBase): Observable<EsgElectricDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EsgElectricDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgElectricDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEsgConsumer(body: EsgConsumerDto | undefined): Observable<EsgConsumer> {
        let url_ = this.baseUrl + "/api/services/app/Esg/CreateEsgConsumer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateEsgConsumer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEsgConsumer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgConsumer>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgConsumer>;
        }));
    }

    protected processCreateEsgConsumer(response: HttpResponseBase): Observable<EsgConsumer> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EsgConsumer.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgConsumer>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getEsgConsumer(tenantId: number | undefined): Observable<EsgConsumer[]> {
        let url_ = this.baseUrl + "/api/services/app/Esg/GetEsgConsumer?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEsgConsumer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEsgConsumer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgConsumer[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgConsumer[]>;
        }));
    }

    protected processGetEsgConsumer(response: HttpResponseBase): Observable<EsgConsumer[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(EsgConsumer.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgConsumer[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEsgConsumption(body: EsgConsumptionDto | undefined): Observable<EsgConsumptionDto> {
        let url_ = this.baseUrl + "/api/services/app/Esg/CreateEsgConsumption";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateEsgConsumption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEsgConsumption(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgConsumptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgConsumptionDto>;
        }));
    }

    protected processCreateEsgConsumption(response: HttpResponseBase): Observable<EsgConsumptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EsgConsumptionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgConsumptionDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param year (optional) 
     * @return Success
     */
    getEsgConsumption(tenantId: number | undefined, year: number | undefined): Observable<EsgConsumptionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Esg/GetEsgConsumption?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEsgConsumption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEsgConsumption(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgConsumptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgConsumptionDto[]>;
        }));
    }

    protected processGetEsgConsumption(response: HttpResponseBase): Observable<EsgConsumptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(EsgConsumptionDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgConsumptionDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getEsgConsumptionWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<EsgConsumptionPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Esg/GetEsgConsumptionWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEsgConsumptionWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEsgConsumptionWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgConsumptionPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgConsumptionPagedResultDto>;
        }));
    }

    protected processGetEsgConsumptionWithInput(response: HttpResponseBase): Observable<EsgConsumptionPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EsgConsumptionPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgConsumptionPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateEsgConsumption(id: number | undefined, body: EsgConsumptionDto | undefined): Observable<EsgConsumptionDto> {
        let url_ = this.baseUrl + "/api/services/app/Esg/UpdateEsgConsumption?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateEsgConsumption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEsgConsumption(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgConsumptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgConsumptionDto>;
        }));
    }

    protected processUpdateEsgConsumption(response: HttpResponseBase): Observable<EsgConsumptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EsgConsumptionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgConsumptionDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteEsgConsumption(id: number | undefined): Observable<EsgConsumptionDto> {
        let url_ = this.baseUrl + "/api/services/app/Esg/DeleteEsgConsumption?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteEsgConsumption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEsgConsumption(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgConsumptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgConsumptionDto>;
        }));
    }

    protected processDeleteEsgConsumption(response: HttpResponseBase): Observable<EsgConsumptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EsgConsumptionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgConsumptionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEsgWaste(body: EsgWasteDto | undefined): Observable<EsgWasteDto> {
        let url_ = this.baseUrl + "/api/services/app/Esg/CreateEsgWaste";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateEsgWaste(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEsgWaste(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgWasteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgWasteDto>;
        }));
    }

    protected processCreateEsgWaste(response: HttpResponseBase): Observable<EsgWasteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EsgWasteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgWasteDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param year (optional) 
     * @return Success
     */
    getEsgWaste(tenantId: number | undefined, year: number | undefined): Observable<EsgWasteDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Esg/GetEsgWaste?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEsgWaste(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEsgWaste(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgWasteDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgWasteDto[]>;
        }));
    }

    protected processGetEsgWaste(response: HttpResponseBase): Observable<EsgWasteDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(EsgWasteDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgWasteDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateEsgWaste(id: number | undefined, body: EsgWasteDto | undefined): Observable<EsgWasteDto> {
        let url_ = this.baseUrl + "/api/services/app/Esg/UpdateEsgWaste?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateEsgWaste(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEsgWaste(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgWasteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgWasteDto>;
        }));
    }

    protected processUpdateEsgWaste(response: HttpResponseBase): Observable<EsgWasteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EsgWasteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgWasteDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteEsgWaste(id: number | undefined): Observable<EsgWasteDto> {
        let url_ = this.baseUrl + "/api/services/app/Esg/DeleteEsgWaste?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteEsgWaste(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEsgWaste(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgWasteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgWasteDto>;
        }));
    }

    protected processDeleteEsgWaste(response: HttpResponseBase): Observable<EsgWasteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EsgWasteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgWasteDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEsgWasteType(body: EsgWasteTypeDto | undefined): Observable<EsgWasteTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/Esg/CreateEsgWasteType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateEsgWasteType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEsgWasteType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgWasteTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgWasteTypeDto>;
        }));
    }

    protected processCreateEsgWasteType(response: HttpResponseBase): Observable<EsgWasteTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EsgWasteTypeDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgWasteTypeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetEsgWasteType(body: EsgWasteTypeDto[] | undefined): Observable<EsgWasteTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Esg/ResetEsgWasteType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResetEsgWasteType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetEsgWasteType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgWasteTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgWasteTypeDto[]>;
        }));
    }

    protected processResetEsgWasteType(response: HttpResponseBase): Observable<EsgWasteTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(EsgWasteTypeDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgWasteTypeDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getEsgWasteType(tenantId: number | undefined): Observable<EsgWasteType[]> {
        let url_ = this.baseUrl + "/api/services/app/Esg/GetEsgWasteType?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEsgWasteType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEsgWasteType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgWasteType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgWasteType[]>;
        }));
    }

    protected processGetEsgWasteType(response: HttpResponseBase): Observable<EsgWasteType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(EsgWasteType.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgWasteType[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateEsgWasteType(id: number | undefined, body: EsgWasteTypeDto | undefined): Observable<EsgWasteTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/Esg/UpdateEsgWasteType?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateEsgWasteType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEsgWasteType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgWasteTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgWasteTypeDto>;
        }));
    }

    protected processUpdateEsgWasteType(response: HttpResponseBase): Observable<EsgWasteTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EsgWasteTypeDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgWasteTypeDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteEsgWasteType(id: number | undefined): Observable<EsgWasteTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/Esg/DeleteEsgWasteType?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteEsgWasteType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEsgWasteType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgWasteTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgWasteTypeDto>;
        }));
    }

    protected processDeleteEsgWasteType(response: HttpResponseBase): Observable<EsgWasteTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EsgWasteTypeDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgWasteTypeDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param year (optional) 
     * @return Success
     */
    getEsgData(tenantId: number | undefined, year: number | undefined): Observable<EsgDataDto> {
        let url_ = this.baseUrl + "/api/services/app/Esg/GetEsgData?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEsgData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEsgData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgDataDto>;
        }));
    }

    protected processGetEsgData(response: HttpResponseBase): Observable<EsgDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EsgDataDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgDataDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEsgEmission(body: EsgEmissionDto | undefined): Observable<EsgEmissionDto> {
        let url_ = this.baseUrl + "/api/services/app/Esg/CreateEsgEmission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateEsgEmission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEsgEmission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgEmissionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgEmissionDto>;
        }));
    }

    protected processCreateEsgEmission(response: HttpResponseBase): Observable<EsgEmissionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EsgEmissionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgEmissionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkEmissionMigrationData(body: EsgEmissionMigrationDto[] | undefined): Observable<EsgEmissionMigrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Esg/CheckEmissionMigrationData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckEmissionMigrationData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckEmissionMigrationData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgEmissionMigrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgEmissionMigrationDto[]>;
        }));
    }

    protected processCheckEmissionMigrationData(response: HttpResponseBase): Observable<EsgEmissionMigrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(EsgEmissionMigrationDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgEmissionMigrationDto[]>(null as any);
    }

    /**
     * @param emissionId (optional) 
     * @param quantity (optional) 
     * @return Success
     */
    calculateTotalEmission(emissionId: number | undefined, quantity: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Esg/CalculateTotalEmission?";
        if (emissionId === null)
            throw new Error("The parameter 'emissionId' cannot be null.");
        else if (emissionId !== undefined)
            url_ += "emissionId=" + encodeURIComponent("" + emissionId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCalculateTotalEmission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateTotalEmission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCalculateTotalEmission(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param emissionId (optional) 
     * @return Success
     */
    calculateEmissionFactor(emissionId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Esg/CalculateEmissionFactor?";
        if (emissionId === null)
            throw new Error("The parameter 'emissionId' cannot be null.");
        else if (emissionId !== undefined)
            url_ += "emissionId=" + encodeURIComponent("" + emissionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCalculateEmissionFactor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateEmissionFactor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCalculateEmissionFactor(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param emissionId (optional) 
     * @return Success
     */
    getEmissionType(emissionId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Esg/GetEmissionType?";
        if (emissionId === null)
            throw new Error("The parameter 'emissionId' cannot be null.");
        else if (emissionId !== undefined)
            url_ += "emissionId=" + encodeURIComponent("" + emissionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEmissionType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmissionType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetEmissionType(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEmissionFromMigration(body: EsgEmissionMigrationDto[] | undefined): Observable<EsgEmissionMigrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Esg/CreateEmissionFromMigration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateEmissionFromMigration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEmissionFromMigration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgEmissionMigrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgEmissionMigrationDto[]>;
        }));
    }

    protected processCreateEmissionFromMigration(response: HttpResponseBase): Observable<EsgEmissionMigrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(EsgEmissionMigrationDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgEmissionMigrationDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param year (optional) 
     * @return Success
     */
    getEsgEmission(tenantId: number | undefined, year: number | undefined): Observable<EsgEmissionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Esg/GetEsgEmission?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEsgEmission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEsgEmission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgEmissionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgEmissionDto[]>;
        }));
    }

    protected processGetEsgEmission(response: HttpResponseBase): Observable<EsgEmissionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(EsgEmissionDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgEmissionDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateEsgEmission(id: number | undefined, body: EsgEmissionDto | undefined): Observable<EsgEmissionDto> {
        let url_ = this.baseUrl + "/api/services/app/Esg/UpdateEsgEmission?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateEsgEmission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEsgEmission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgEmissionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgEmissionDto>;
        }));
    }

    protected processUpdateEsgEmission(response: HttpResponseBase): Observable<EsgEmissionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EsgEmissionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgEmissionDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteEsgEmission(id: number | undefined): Observable<EsgEmissionDto> {
        let url_ = this.baseUrl + "/api/services/app/Esg/DeleteEsgEmission?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteEsgEmission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEsgEmission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgEmissionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgEmissionDto>;
        }));
    }

    protected processDeleteEsgEmission(response: HttpResponseBase): Observable<EsgEmissionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EsgEmissionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgEmissionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkElectricMigrationData(body: EsgElectricMigrationDto[] | undefined): Observable<EsgElectricMigrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Esg/CheckElectricMigrationData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckElectricMigrationData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckElectricMigrationData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgElectricMigrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgElectricMigrationDto[]>;
        }));
    }

    protected processCheckElectricMigrationData(response: HttpResponseBase): Observable<EsgElectricMigrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(EsgElectricMigrationDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgElectricMigrationDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createElectricFromMigration(body: EsgElectricMigrationDto[] | undefined): Observable<EsgElectricMigrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Esg/CreateElectricFromMigration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateElectricFromMigration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateElectricFromMigration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgElectricMigrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgElectricMigrationDto[]>;
        }));
    }

    protected processCreateElectricFromMigration(response: HttpResponseBase): Observable<EsgElectricMigrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(EsgElectricMigrationDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgElectricMigrationDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkWaterMigrationData(body: EsgConsumptionMigrationDto[] | undefined): Observable<EsgConsumptionMigrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Esg/CheckWaterMigrationData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckWaterMigrationData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckWaterMigrationData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgConsumptionMigrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgConsumptionMigrationDto[]>;
        }));
    }

    protected processCheckWaterMigrationData(response: HttpResponseBase): Observable<EsgConsumptionMigrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(EsgConsumptionMigrationDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgConsumptionMigrationDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createWaterFromMigration(body: EsgConsumptionMigrationDto[] | undefined): Observable<EsgConsumptionMigrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Esg/CreateWaterFromMigration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateWaterFromMigration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWaterFromMigration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgConsumptionMigrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgConsumptionMigrationDto[]>;
        }));
    }

    protected processCreateWaterFromMigration(response: HttpResponseBase): Observable<EsgConsumptionMigrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(EsgConsumptionMigrationDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgConsumptionMigrationDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkWasteMigrationData(body: EsgWasteMigrationDto[] | undefined): Observable<EsgWasteMigrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Esg/CheckWasteMigrationData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckWasteMigrationData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckWasteMigrationData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgWasteMigrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgWasteMigrationDto[]>;
        }));
    }

    protected processCheckWasteMigrationData(response: HttpResponseBase): Observable<EsgWasteMigrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(EsgWasteMigrationDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgWasteMigrationDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createWasteFromMigration(body: EsgWasteMigrationDto[] | undefined): Observable<EsgWasteMigrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Esg/CreateWasteFromMigration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateWasteFromMigration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWasteFromMigration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EsgWasteMigrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EsgWasteMigrationDto[]>;
        }));
    }

    protected processCreateWasteFromMigration(response: HttpResponseBase): Observable<EsgWasteMigrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(EsgWasteMigrationDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EsgWasteMigrationDto[]>(null as any);
    }
}

@Injectable()
export class FinancialStatementServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFinancialStatementFile(body: FinancialStatementFileDto | undefined): Observable<FinancialStatementFileDto> {
        let url_ = this.baseUrl + "/api/services/app/FinancialStatement/CreateFinancialStatementFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateFinancialStatementFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFinancialStatementFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialStatementFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialStatementFileDto>;
        }));
    }

    protected processCreateFinancialStatementFile(response: HttpResponseBase): Observable<FinancialStatementFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FinancialStatementFileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FinancialStatementFileDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param reportType (optional) 
     * @return Success
     */
    getFinancialStatementFile(tenantId: number | undefined, reportType: boolean | undefined): Observable<FinancialStatementFile[]> {
        let url_ = this.baseUrl + "/api/services/app/FinancialStatement/GetFinancialStatementFile?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (reportType === null)
            throw new Error("The parameter 'reportType' cannot be null.");
        else if (reportType !== undefined)
            url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFinancialStatementFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialStatementFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialStatementFile[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialStatementFile[]>;
        }));
    }

    protected processGetFinancialStatementFile(response: HttpResponseBase): Observable<FinancialStatementFile[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(FinancialStatementFile.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FinancialStatementFile[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param reportType (optional) 
     * @param type (optional) 
     * @param companyType (optional) 
     * @param language (optional) 
     * @return Success
     */
    getFinancialStatementFileWithInput(tenantId: number | undefined, reportType: boolean | undefined, type: string | undefined, companyType: string | undefined, language: string | undefined): Observable<FinancialStatementFile[]> {
        let url_ = this.baseUrl + "/api/services/app/FinancialStatement/GetFinancialStatementFileWithInput?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (reportType === null)
            throw new Error("The parameter 'reportType' cannot be null.");
        else if (reportType !== undefined)
            url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (companyType === null)
            throw new Error("The parameter 'companyType' cannot be null.");
        else if (companyType !== undefined)
            url_ += "companyType=" + encodeURIComponent("" + companyType) + "&";
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFinancialStatementFileWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialStatementFileWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialStatementFile[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialStatementFile[]>;
        }));
    }

    protected processGetFinancialStatementFileWithInput(response: HttpResponseBase): Observable<FinancialStatementFile[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(FinancialStatementFile.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FinancialStatementFile[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateFinancialStatementFile(body: FinancialStatementFile | undefined): Observable<FinancialStatementFile> {
        let url_ = this.baseUrl + "/api/services/app/FinancialStatement/UpdateFinancialStatementFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateFinancialStatementFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFinancialStatementFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialStatementFile>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialStatementFile>;
        }));
    }

    protected processUpdateFinancialStatementFile(response: HttpResponseBase): Observable<FinancialStatementFile> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FinancialStatementFile.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FinancialStatementFile>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteFinancialStatementFile(id: number | undefined): Observable<FinancialStatementFileDto> {
        let url_ = this.baseUrl + "/api/services/app/FinancialStatement/DeleteFinancialStatementFile?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteFinancialStatementFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFinancialStatementFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FinancialStatementFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FinancialStatementFileDto>;
        }));
    }

    protected processDeleteFinancialStatementFile(response: HttpResponseBase): Observable<FinancialStatementFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FinancialStatementFileDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FinancialStatementFileDto>(null as any);
    }

    /**
     * @param isManagementReport (optional) 
     * @return Success
     */
    resetToDefault(isManagementReport: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FinancialStatement/ResetToDefault?";
        if (isManagementReport === null)
            throw new Error("The parameter 'isManagementReport' cannot be null.");
        else if (isManagementReport !== undefined)
            url_ += "isManagementReport=" + encodeURIComponent("" + isManagementReport) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResetToDefault(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetToDefault(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetToDefault(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param isManagementReport (optional) 
     * @return Success
     */
    getDefaultTemplate(isManagementReport: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FinancialStatement/GetDefaultTemplate?";
        if (isManagementReport === null)
            throw new Error("The parameter 'isManagementReport' cannot be null.");
        else if (isManagementReport !== undefined)
            url_ += "isManagementReport=" + encodeURIComponent("" + isManagementReport) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDefaultTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetDefaultTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class GeneralLedgerDataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param tenantId (optional) 
     * @param year (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getGeneralLedgerData(tenantId: number | undefined, year: number | undefined, userId: number | undefined): Observable<GeneralLedgerData> {
        let url_ = this.baseUrl + "/api/services/app/GeneralLedgerData/GetGeneralLedgerData?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGeneralLedgerData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralLedgerData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralLedgerData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralLedgerData>;
        }));
    }

    protected processGetGeneralLedgerData(response: HttpResponseBase): Observable<GeneralLedgerData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GeneralLedgerData.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralLedgerData>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateGeneralLedgerData(body: GeneralLedgerDataDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GeneralLedgerData/CreateOrUpdateGeneralLedgerData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrUpdateGeneralLedgerData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateGeneralLedgerData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateGeneralLedgerData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getGeneralLedgerDataWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<GeneralLedgerDataDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneralLedgerData/GetGeneralLedgerDataWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGeneralLedgerDataWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralLedgerDataWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralLedgerDataDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralLedgerDataDtoPagedResultDto>;
        }));
    }

    protected processGetGeneralLedgerDataWithInput(response: HttpResponseBase): Observable<GeneralLedgerDataDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GeneralLedgerDataDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralLedgerDataDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createGeneralData(body: GeneralDataDto | undefined): Observable<GeneralDataDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneralLedgerData/CreateGeneralData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateGeneralData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateGeneralData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralDataDto>;
        }));
    }

    protected processCreateGeneralData(response: HttpResponseBase): Observable<GeneralDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GeneralDataDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralDataDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getGeneralDataWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GeneralDataDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneralLedgerData/GetGeneralDataWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGeneralDataWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralDataWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralDataDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralDataDtoPagedResultDto>;
        }));
    }

    protected processGetGeneralDataWithInput(response: HttpResponseBase): Observable<GeneralDataDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GeneralDataDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralDataDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getFormulaList(): Observable<GeneralDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneralLedgerData/GetFormulaList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFormulaList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormulaList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralDataDto[]>;
        }));
    }

    protected processGetFormulaList(response: HttpResponseBase): Observable<GeneralDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(GeneralDataDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralDataDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetFormula(body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GeneralLedgerData/ResetFormula";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResetFormula(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetFormula(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetFormula(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param key (optional) 
     * @param description (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    updateGeneraldataDescription(key: string | undefined, description: string | undefined, tenantId: number | undefined): Observable<GeneralDataDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneralLedgerData/UpdateGeneraldataDescription?";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        if (description === null)
            throw new Error("The parameter 'description' cannot be null.");
        else if (description !== undefined)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateGeneraldataDescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGeneraldataDescription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralDataDto>;
        }));
    }

    protected processUpdateGeneraldataDescription(response: HttpResponseBase): Observable<GeneralDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GeneralDataDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralDataDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateBudgetFromListGeneralData(body: GeneralDataBudgetDto[] | undefined): Observable<GeneralDataBudgetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneralLedgerData/CreateOrUpdateBudgetFromListGeneralData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrUpdateBudgetFromListGeneralData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateBudgetFromListGeneralData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralDataBudgetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralDataBudgetDto[]>;
        }));
    }

    protected processCreateOrUpdateBudgetFromListGeneralData(response: HttpResponseBase): Observable<GeneralDataBudgetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(GeneralDataBudgetDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralDataBudgetDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteGeneralData(id: number | undefined): Observable<GeneralDataDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneralLedgerData/DeleteGeneralData?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteGeneralData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteGeneralData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralDataDto>;
        }));
    }

    protected processDeleteGeneralData(response: HttpResponseBase): Observable<GeneralDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GeneralDataDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralDataDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createGeneralDataValue(body: GeneralDataValueDto | undefined): Observable<GeneralDataValueDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneralLedgerData/CreateGeneralDataValue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateGeneralDataValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateGeneralDataValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralDataValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralDataValueDto>;
        }));
    }

    protected processCreateGeneralDataValue(response: HttpResponseBase): Observable<GeneralDataValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GeneralDataValueDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralDataValueDto>(null as any);
    }

    /**
     * @param key (optional) 
     * @return Success
     */
    getGeneralDataValues(key: string | undefined): Observable<GeneralDataValue[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneralLedgerData/GetGeneralDataValues?";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGeneralDataValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralDataValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralDataValue[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralDataValue[]>;
        }));
    }

    protected processGetGeneralDataValues(response: HttpResponseBase): Observable<GeneralDataValue[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(GeneralDataValue.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralDataValue[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteGeneralDataValue(id: number | undefined): Observable<GeneralDataValueDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneralLedgerData/DeleteGeneralDataValue?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteGeneralDataValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteGeneralDataValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralDataValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralDataValueDto>;
        }));
    }

    protected processDeleteGeneralDataValue(response: HttpResponseBase): Observable<GeneralDataValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GeneralDataValueDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralDataValueDto>(null as any);
    }

    /**
     * @param key (optional) 
     * @return Success
     */
    getCodeFromKey(key: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneralLedgerData/GetCodeFromKey?";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCodeFromKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCodeFromKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetCodeFromKey(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @return Success
     */
    getDefaultTenantId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/GeneralLedgerData/GetDefaultTenantId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDefaultTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetDefaultTenantId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param financialYear (optional) 
     * @return Success
     */
    getGeneralDataBudgets(tenantId: number | undefined, financialYear: number | undefined): Observable<GeneralDataBudget[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneralLedgerData/GetGeneralDataBudgets?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (financialYear === null)
            throw new Error("The parameter 'financialYear' cannot be null.");
        else if (financialYear !== undefined)
            url_ += "financialYear=" + encodeURIComponent("" + financialYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGeneralDataBudgets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralDataBudgets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralDataBudget[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralDataBudget[]>;
        }));
    }

    protected processGetGeneralDataBudgets(response: HttpResponseBase): Observable<GeneralDataBudget[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(GeneralDataBudget.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralDataBudget[]>(null as any);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getBudgetFromAccountCode(code: string | undefined): Observable<GeneralDataBudget> {
        let url_ = this.baseUrl + "/api/services/app/GeneralLedgerData/getBudgetFromAccountCode?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBudgetFromAccountCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBudgetFromAccountCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralDataBudget>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralDataBudget>;
        }));
    }

    protected processGetBudgetFromAccountCode(response: HttpResponseBase): Observable<GeneralDataBudget> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GeneralDataBudget.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralDataBudget>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GeneralLedgerDataDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneralLedgerData/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralLedgerDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralLedgerDataDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GeneralLedgerDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GeneralLedgerDataDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralLedgerDataDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<GeneralLedgerDataDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneralLedgerData/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralLedgerDataDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralLedgerDataDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GeneralLedgerDataDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GeneralLedgerDataDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralLedgerDataDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: GeneralLedgerDataDto | undefined): Observable<GeneralLedgerDataDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneralLedgerData/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralLedgerDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralLedgerDataDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<GeneralLedgerDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GeneralLedgerDataDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralLedgerDataDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: GeneralLedgerDataDto | undefined): Observable<GeneralLedgerDataDto> {
        let url_ = this.baseUrl + "/api/services/app/GeneralLedgerData/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GeneralLedgerDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GeneralLedgerDataDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<GeneralLedgerDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GeneralLedgerDataDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GeneralLedgerDataDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GeneralLedgerData/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class GoodsReceivedNotesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createGoodsReceivedNote(body: GoodsReceivedNoteDto | undefined): Observable<GoodsReceivedNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/GoodsReceivedNotes/CreateGoodsReceivedNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateGoodsReceivedNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateGoodsReceivedNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GoodsReceivedNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GoodsReceivedNoteDto>;
        }));
    }

    protected processCreateGoodsReceivedNote(response: HttpResponseBase): Observable<GoodsReceivedNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GoodsReceivedNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodsReceivedNoteDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getGoodsReceivedNote(tenantId: number | undefined): Observable<GoodsReceivedNotes[]> {
        let url_ = this.baseUrl + "/api/services/app/GoodsReceivedNotes/GetGoodsReceivedNote?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGoodsReceivedNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGoodsReceivedNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GoodsReceivedNotes[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GoodsReceivedNotes[]>;
        }));
    }

    protected processGetGoodsReceivedNote(response: HttpResponseBase): Observable<GoodsReceivedNotes[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(GoodsReceivedNotes.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodsReceivedNotes[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGoodsReceivedNoteById(id: number | undefined): Observable<GoodsReceivedNotes> {
        let url_ = this.baseUrl + "/api/services/app/GoodsReceivedNotes/GetGoodsReceivedNoteById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGoodsReceivedNoteById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGoodsReceivedNoteById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GoodsReceivedNotes>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GoodsReceivedNotes>;
        }));
    }

    protected processGetGoodsReceivedNoteById(response: HttpResponseBase): Observable<GoodsReceivedNotes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GoodsReceivedNotes.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodsReceivedNotes>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGoodsReceivedNoteByIdIncludeItem(id: number | undefined): Observable<GoodsReceivedNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/GoodsReceivedNotes/GetGoodsReceivedNoteByIdIncludeItem?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGoodsReceivedNoteByIdIncludeItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGoodsReceivedNoteByIdIncludeItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GoodsReceivedNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GoodsReceivedNoteDto>;
        }));
    }

    protected processGetGoodsReceivedNoteByIdIncludeItem(response: HttpResponseBase): Observable<GoodsReceivedNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GoodsReceivedNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodsReceivedNoteDto>(null as any);
    }

    /**
     * @param vendorInvoiceId (optional) 
     * @return Success
     */
    getGoodsReceivedNoteByVendorInvoiceId(vendorInvoiceId: number | undefined): Observable<GoodsReceivedNotes> {
        let url_ = this.baseUrl + "/api/services/app/GoodsReceivedNotes/GetGoodsReceivedNoteByVendorInvoiceId?";
        if (vendorInvoiceId === null)
            throw new Error("The parameter 'vendorInvoiceId' cannot be null.");
        else if (vendorInvoiceId !== undefined)
            url_ += "vendorInvoiceId=" + encodeURIComponent("" + vendorInvoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGoodsReceivedNoteByVendorInvoiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGoodsReceivedNoteByVendorInvoiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GoodsReceivedNotes>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GoodsReceivedNotes>;
        }));
    }

    protected processGetGoodsReceivedNoteByVendorInvoiceId(response: HttpResponseBase): Observable<GoodsReceivedNotes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GoodsReceivedNotes.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodsReceivedNotes>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getGoodsReceivedNoteWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<GoodsReceivedNoteDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/GoodsReceivedNotes/GetGoodsReceivedNoteWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGoodsReceivedNoteWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGoodsReceivedNoteWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GoodsReceivedNoteDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GoodsReceivedNoteDtoPagedResultDto>;
        }));
    }

    protected processGetGoodsReceivedNoteWithInput(response: HttpResponseBase): Observable<GoodsReceivedNoteDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GoodsReceivedNoteDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodsReceivedNoteDtoPagedResultDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getGoodsReceivedNoteFromVendorInvoice(input: number[] | undefined): Observable<GoodsReceivedNoteDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GoodsReceivedNotes/GetGoodsReceivedNoteFromVendorInvoice?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            input && input.forEach(item => { url_ += "input=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGoodsReceivedNoteFromVendorInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGoodsReceivedNoteFromVendorInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GoodsReceivedNoteDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GoodsReceivedNoteDto[]>;
        }));
    }

    protected processGetGoodsReceivedNoteFromVendorInvoice(response: HttpResponseBase): Observable<GoodsReceivedNoteDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(GoodsReceivedNoteDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodsReceivedNoteDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    editGoodsReceivedNote(id: number | undefined, body: GoodsReceivedNoteDto | undefined): Observable<GoodsReceivedNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/GoodsReceivedNotes/EditGoodsReceivedNote?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processEditGoodsReceivedNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditGoodsReceivedNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GoodsReceivedNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GoodsReceivedNoteDto>;
        }));
    }

    protected processEditGoodsReceivedNote(response: HttpResponseBase): Observable<GoodsReceivedNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GoodsReceivedNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodsReceivedNoteDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateGoodsReceivedNote(id: number | undefined, body: GoodsReceivedNoteDto | undefined): Observable<GoodsReceivedNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/GoodsReceivedNotes/UpdateGoodsReceivedNote?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateGoodsReceivedNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGoodsReceivedNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GoodsReceivedNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GoodsReceivedNoteDto>;
        }));
    }

    protected processUpdateGoodsReceivedNote(response: HttpResponseBase): Observable<GoodsReceivedNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GoodsReceivedNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodsReceivedNoteDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateSupplementaryGoodsReceivedNote(id: number | undefined, body: GoodsReceivedNoteDto | undefined): Observable<GoodsReceivedNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/GoodsReceivedNotes/UpdateSupplementaryGoodsReceivedNote?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateSupplementaryGoodsReceivedNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSupplementaryGoodsReceivedNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GoodsReceivedNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GoodsReceivedNoteDto>;
        }));
    }

    protected processUpdateSupplementaryGoodsReceivedNote(response: HttpResponseBase): Observable<GoodsReceivedNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GoodsReceivedNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodsReceivedNoteDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    updateGrnInventoryStatus(id: number | undefined): Observable<GoodsReceivedNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/GoodsReceivedNotes/UpdateGrnInventoryStatus?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateGrnInventoryStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGrnInventoryStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GoodsReceivedNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GoodsReceivedNoteDto>;
        }));
    }

    protected processUpdateGrnInventoryStatus(response: HttpResponseBase): Observable<GoodsReceivedNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GoodsReceivedNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodsReceivedNoteDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param status (optional) 
     * @return Success
     */
    updateGrnApprovalStatus(id: number | undefined, status: number | undefined): Observable<GoodsReceivedNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/GoodsReceivedNotes/UpdateGrnApprovalStatus?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateGrnApprovalStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGrnApprovalStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GoodsReceivedNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GoodsReceivedNoteDto>;
        }));
    }

    protected processUpdateGrnApprovalStatus(response: HttpResponseBase): Observable<GoodsReceivedNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GoodsReceivedNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodsReceivedNoteDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteGoodsReceivedNote(id: number | undefined): Observable<GoodsReceivedNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/GoodsReceivedNotes/DeleteGoodsReceivedNote?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteGoodsReceivedNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteGoodsReceivedNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GoodsReceivedNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GoodsReceivedNoteDto>;
        }));
    }

    protected processDeleteGoodsReceivedNote(response: HttpResponseBase): Observable<GoodsReceivedNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GoodsReceivedNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodsReceivedNoteDto>(null as any);
    }

    /**
     * @param headerMessage (optional) 
     * @param footerMessage (optional) 
     * @param body (optional) 
     * @return Success
     */
    requestCreditNote(headerMessage: string | undefined, footerMessage: string | undefined, body: GoodsReceivedNoteDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GoodsReceivedNotes/RequestCreditNote?";
        if (headerMessage === null)
            throw new Error("The parameter 'headerMessage' cannot be null.");
        else if (headerMessage !== undefined)
            url_ += "headerMessage=" + encodeURIComponent("" + headerMessage) + "&";
        if (footerMessage === null)
            throw new Error("The parameter 'footerMessage' cannot be null.");
        else if (footerMessage !== undefined)
            url_ += "footerMessage=" + encodeURIComponent("" + footerMessage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRequestCreditNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestCreditNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestCreditNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requestDeliveryOrder(body: GoodsReceivedNoteDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GoodsReceivedNotes/RequestDeliveryOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRequestDeliveryOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestDeliveryOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRequestDeliveryOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param vendorInvoiceId (optional) 
     * @return Success
     */
    getVendorInvoiceItem(vendorInvoiceId: number | undefined): Observable<VendorInvoiceItem[]> {
        let url_ = this.baseUrl + "/api/services/app/GoodsReceivedNotes/GetVendorInvoiceItem?";
        if (vendorInvoiceId === null)
            throw new Error("The parameter 'vendorInvoiceId' cannot be null.");
        else if (vendorInvoiceId !== undefined)
            url_ += "vendorInvoiceId=" + encodeURIComponent("" + vendorInvoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVendorInvoiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorInvoiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItem[]>;
        }));
    }

    protected processGetVendorInvoiceItem(response: HttpResponseBase): Observable<VendorInvoiceItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(VendorInvoiceItem.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItem[]>(null as any);
    }
}

@Injectable()
export class GoodsReceivedNotesPublicServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGoodsReceivedNoteById(id: number | undefined): Observable<GoodsReceivedNotes> {
        let url_ = this.baseUrl + "/api/services/app/GoodsReceivedNotesPublic/GetGoodsReceivedNoteById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGoodsReceivedNoteById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGoodsReceivedNoteById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GoodsReceivedNotes>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GoodsReceivedNotes>;
        }));
    }

    protected processGetGoodsReceivedNoteById(response: HttpResponseBase): Observable<GoodsReceivedNotes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GoodsReceivedNotes.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodsReceivedNotes>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getGoodsReceivedNoteByIdIncludeItem(id: number | undefined): Observable<GoodsReceivedNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/GoodsReceivedNotesPublic/GetGoodsReceivedNoteByIdIncludeItem?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGoodsReceivedNoteByIdIncludeItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGoodsReceivedNoteByIdIncludeItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GoodsReceivedNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GoodsReceivedNoteDto>;
        }));
    }

    protected processGetGoodsReceivedNoteByIdIncludeItem(response: HttpResponseBase): Observable<GoodsReceivedNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GoodsReceivedNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodsReceivedNoteDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateGoodsReceivedNote(id: number | undefined, body: GoodsReceivedNoteDto | undefined): Observable<GoodsReceivedNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/GoodsReceivedNotesPublic/UpdateGoodsReceivedNote?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateGoodsReceivedNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGoodsReceivedNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GoodsReceivedNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GoodsReceivedNoteDto>;
        }));
    }

    protected processUpdateGoodsReceivedNote(response: HttpResponseBase): Observable<GoodsReceivedNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GoodsReceivedNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodsReceivedNoteDto>(null as any);
    }

    /**
     * @param vendorInvoiceId (optional) 
     * @return Success
     */
    getVendorInvoiceItemsForCreditNoteByVendorInvoiceId(vendorInvoiceId: number | undefined): Observable<VendorInvoiceItem[]> {
        let url_ = this.baseUrl + "/api/services/app/GoodsReceivedNotesPublic/GetVendorInvoiceItemsForCreditNoteByVendorInvoiceId?";
        if (vendorInvoiceId === null)
            throw new Error("The parameter 'vendorInvoiceId' cannot be null.");
        else if (vendorInvoiceId !== undefined)
            url_ += "vendorInvoiceId=" + encodeURIComponent("" + vendorInvoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVendorInvoiceItemsForCreditNoteByVendorInvoiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorInvoiceItemsForCreditNoteByVendorInvoiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItem[]>;
        }));
    }

    protected processGetVendorInvoiceItemsForCreditNoteByVendorInvoiceId(response: HttpResponseBase): Observable<VendorInvoiceItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(VendorInvoiceItem.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItem[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateVendorInvoiceItem(id: number | undefined, body: VendorInvoiceItemDto | undefined): Observable<VendorInvoiceItemDto> {
        let url_ = this.baseUrl + "/api/services/app/GoodsReceivedNotesPublic/UpdateVendorInvoiceItem?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateVendorInvoiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVendorInvoiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItemDto>;
        }));
    }

    protected processUpdateVendorInvoiceItem(response: HttpResponseBase): Observable<VendorInvoiceItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorInvoiceItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateListVendorInvoiceItem(body: VendorInvoiceItemDto[] | undefined): Observable<VendorInvoiceItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GoodsReceivedNotesPublic/UpdateListVendorInvoiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateListVendorInvoiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateListVendorInvoiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItemDto[]>;
        }));
    }

    protected processUpdateListVendorInvoiceItem(response: HttpResponseBase): Observable<VendorInvoiceItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(VendorInvoiceItemDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItemDto[]>(null as any);
    }
}

@Injectable()
export class HrmServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getAllLeaveType(tenantId: number | undefined): Observable<LeaveTypeModelDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetAllLeaveType?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllLeaveType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLeaveType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveTypeModelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveTypeModelDto[]>;
        }));
    }

    protected processGetAllLeaveType(response: HttpResponseBase): Observable<LeaveTypeModelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(LeaveTypeModelDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveTypeModelDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getLeaveTypeModelWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<LeaveTypeModelPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetLeaveTypeModelWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLeaveTypeModelWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveTypeModelWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveTypeModelPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveTypeModelPagedResultDto>;
        }));
    }

    protected processGetLeaveTypeModelWithInput(response: HttpResponseBase): Observable<LeaveTypeModelPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveTypeModelPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveTypeModelPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateLeaveTypeModel(id: number | undefined, body: LeaveTypeModelDto | undefined): Observable<LeaveTypeModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/UpdateLeaveTypeModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateLeaveTypeModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLeaveTypeModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveTypeModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveTypeModelDto>;
        }));
    }

    protected processUpdateLeaveTypeModel(response: HttpResponseBase): Observable<LeaveTypeModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveTypeModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveTypeModelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteLeaveTypeModelDto(id: number | undefined): Observable<LeaveTypeModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/DeleteLeaveTypeModelDto?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteLeaveTypeModelDto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLeaveTypeModelDto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveTypeModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveTypeModelDto>;
        }));
    }

    protected processDeleteLeaveTypeModelDto(response: HttpResponseBase): Observable<LeaveTypeModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveTypeModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveTypeModelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    disableOrEnableLeaveTypeModelDto(id: number | undefined): Observable<LeaveTypeModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/DisableOrEnableLeaveTypeModelDto?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDisableOrEnableLeaveTypeModelDto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableOrEnableLeaveTypeModelDto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveTypeModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveTypeModelDto>;
        }));
    }

    protected processDisableOrEnableLeaveTypeModelDto(response: HttpResponseBase): Observable<LeaveTypeModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveTypeModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveTypeModelDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createLeavePolicy(body: LeavePolicyDto | undefined): Observable<LeavePolicyDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/CreateLeavePolicy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateLeavePolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLeavePolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeavePolicyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeavePolicyDto>;
        }));
    }

    protected processCreateLeavePolicy(response: HttpResponseBase): Observable<LeavePolicyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeavePolicyDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeavePolicyDto>(null as any);
    }

    /**
     * @param policyId (optional) 
     * @return Success
     */
    getLeavePolicyById(policyId: number | undefined): Observable<LeavePolicyDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetLeavePolicyById?";
        if (policyId === null)
            throw new Error("The parameter 'policyId' cannot be null.");
        else if (policyId !== undefined)
            url_ += "policyId=" + encodeURIComponent("" + policyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLeavePolicyById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeavePolicyById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeavePolicyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeavePolicyDto>;
        }));
    }

    protected processGetLeavePolicyById(response: HttpResponseBase): Observable<LeavePolicyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeavePolicyDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeavePolicyDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getAllLeavePolicyByTenantId(tenantId: number | undefined): Observable<LeavePolicyDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetAllLeavePolicyByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllLeavePolicyByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLeavePolicyByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeavePolicyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeavePolicyDto[]>;
        }));
    }

    protected processGetAllLeavePolicyByTenantId(response: HttpResponseBase): Observable<LeavePolicyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(LeavePolicyDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeavePolicyDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getLeavePolicyWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<LeavePolicyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetLeavePolicyWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLeavePolicyWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeavePolicyWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeavePolicyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeavePolicyDtoPagedResultDto>;
        }));
    }

    protected processGetLeavePolicyWithInput(response: HttpResponseBase): Observable<LeavePolicyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeavePolicyDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeavePolicyDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateLeavePolicy(id: number | undefined, body: LeavePolicyDto | undefined): Observable<LeavePolicyDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/UpdateLeavePolicy?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateLeavePolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLeavePolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeavePolicyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeavePolicyDto>;
        }));
    }

    protected processUpdateLeavePolicy(response: HttpResponseBase): Observable<LeavePolicyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeavePolicyDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeavePolicyDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteLeavePolicy(id: number | undefined): Observable<LeavePolicyDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/DeleteLeavePolicy?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteLeavePolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLeavePolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeavePolicyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeavePolicyDto>;
        }));
    }

    protected processDeleteLeavePolicy(response: HttpResponseBase): Observable<LeavePolicyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeavePolicyDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeavePolicyDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUserLeavePolicyRelation(body: UserLeavePolicyRelationDto | undefined): Observable<UserLeavePolicyRelationDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/CreateUserLeavePolicyRelation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateUserLeavePolicyRelation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserLeavePolicyRelation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLeavePolicyRelationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLeavePolicyRelationDto>;
        }));
    }

    protected processCreateUserLeavePolicyRelation(response: HttpResponseBase): Observable<UserLeavePolicyRelationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserLeavePolicyRelationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserLeavePolicyRelationDto>(null as any);
    }

    /**
     * @param relationId (optional) 
     * @return Success
     */
    getUserLeavePolicyRelationById(relationId: number | undefined): Observable<UserLeavePolicyRelationDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetUserLeavePolicyRelationById?";
        if (relationId === null)
            throw new Error("The parameter 'relationId' cannot be null.");
        else if (relationId !== undefined)
            url_ += "relationId=" + encodeURIComponent("" + relationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserLeavePolicyRelationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserLeavePolicyRelationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLeavePolicyRelationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLeavePolicyRelationDto>;
        }));
    }

    protected processGetUserLeavePolicyRelationById(response: HttpResponseBase): Observable<UserLeavePolicyRelationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserLeavePolicyRelationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserLeavePolicyRelationDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param leavePolicyId (optional) 
     * @return Success
     */
    getUserLeavePolicyRelationByUserIdAndLeavePolicyId(userId: number | undefined, leavePolicyId: number | undefined): Observable<UserLeavePolicyRelationDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetUserLeavePolicyRelationByUserIdAndLeavePolicyId?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (leavePolicyId === null)
            throw new Error("The parameter 'leavePolicyId' cannot be null.");
        else if (leavePolicyId !== undefined)
            url_ += "leavePolicyId=" + encodeURIComponent("" + leavePolicyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserLeavePolicyRelationByUserIdAndLeavePolicyId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserLeavePolicyRelationByUserIdAndLeavePolicyId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLeavePolicyRelationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLeavePolicyRelationDto>;
        }));
    }

    protected processGetUserLeavePolicyRelationByUserIdAndLeavePolicyId(response: HttpResponseBase): Observable<UserLeavePolicyRelationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserLeavePolicyRelationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserLeavePolicyRelationDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param leaveTypeModelId (optional) 
     * @return Success
     */
    checkUserLeavePolicyRelationByUserIdAndLeaveTypeModelId(userId: number | undefined, leaveTypeModelId: number | undefined): Observable<UserLeavePolicyRelationDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/CheckUserLeavePolicyRelationByUserIdAndLeaveTypeModelId?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (leaveTypeModelId === null)
            throw new Error("The parameter 'leaveTypeModelId' cannot be null.");
        else if (leaveTypeModelId !== undefined)
            url_ += "leaveTypeModelId=" + encodeURIComponent("" + leaveTypeModelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckUserLeavePolicyRelationByUserIdAndLeaveTypeModelId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckUserLeavePolicyRelationByUserIdAndLeaveTypeModelId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLeavePolicyRelationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLeavePolicyRelationDto>;
        }));
    }

    protected processCheckUserLeavePolicyRelationByUserIdAndLeaveTypeModelId(response: HttpResponseBase): Observable<UserLeavePolicyRelationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserLeavePolicyRelationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserLeavePolicyRelationDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getAllUserLeavePolicyRelationByUserId(userId: number | undefined): Observable<UserLeavePolicyRelationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetAllUserLeavePolicyRelationByUserId?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllUserLeavePolicyRelationByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserLeavePolicyRelationByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLeavePolicyRelationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLeavePolicyRelationDto[]>;
        }));
    }

    protected processGetAllUserLeavePolicyRelationByUserId(response: HttpResponseBase): Observable<UserLeavePolicyRelationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(UserLeavePolicyRelationDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserLeavePolicyRelationDto[]>(null as any);
    }

    /**
     * @param leavePolicyId (optional) 
     * @return Success
     */
    getAllUserLeavePolicyRelationByLeavePolicyId(leavePolicyId: number | undefined): Observable<UserLeavePolicyRelationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetAllUserLeavePolicyRelationByLeavePolicyId?";
        if (leavePolicyId === null)
            throw new Error("The parameter 'leavePolicyId' cannot be null.");
        else if (leavePolicyId !== undefined)
            url_ += "leavePolicyId=" + encodeURIComponent("" + leavePolicyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllUserLeavePolicyRelationByLeavePolicyId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserLeavePolicyRelationByLeavePolicyId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLeavePolicyRelationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLeavePolicyRelationDto[]>;
        }));
    }

    protected processGetAllUserLeavePolicyRelationByLeavePolicyId(response: HttpResponseBase): Observable<UserLeavePolicyRelationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(UserLeavePolicyRelationDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserLeavePolicyRelationDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getAllUserLeavePolicyRelationByTenantId(tenantId: number | undefined): Observable<UserLeavePolicyRelationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetAllUserLeavePolicyRelationByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllUserLeavePolicyRelationByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserLeavePolicyRelationByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLeavePolicyRelationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLeavePolicyRelationDto[]>;
        }));
    }

    protected processGetAllUserLeavePolicyRelationByTenantId(response: HttpResponseBase): Observable<UserLeavePolicyRelationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(UserLeavePolicyRelationDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserLeavePolicyRelationDto[]>(null as any);
    }

    /**
     * @param leavePolicyId (optional) 
     * @return Success
     */
    getAvailableEmployeesForLeavePolicy(leavePolicyId: number | undefined): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetAvailableEmployeesForLeavePolicy?";
        if (leavePolicyId === null)
            throw new Error("The parameter 'leavePolicyId' cannot be null.");
        else if (leavePolicyId !== undefined)
            url_ += "leavePolicyId=" + encodeURIComponent("" + leavePolicyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAvailableEmployeesForLeavePolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableEmployeesForLeavePolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processGetAvailableEmployeesForLeavePolicy(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(UserDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getUserLeavePolicyRelationWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<UserLeavePolicyRelationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetUserLeavePolicyRelationWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserLeavePolicyRelationWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserLeavePolicyRelationWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLeavePolicyRelationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLeavePolicyRelationDtoPagedResultDto>;
        }));
    }

    protected processGetUserLeavePolicyRelationWithInput(response: HttpResponseBase): Observable<UserLeavePolicyRelationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserLeavePolicyRelationDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserLeavePolicyRelationDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateUserLeavePolicyRelation(id: number | undefined, body: UserLeavePolicyRelationDto | undefined): Observable<UserLeavePolicyRelationDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/UpdateUserLeavePolicyRelation?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateUserLeavePolicyRelation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserLeavePolicyRelation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLeavePolicyRelationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLeavePolicyRelationDto>;
        }));
    }

    protected processUpdateUserLeavePolicyRelation(response: HttpResponseBase): Observable<UserLeavePolicyRelationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserLeavePolicyRelationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserLeavePolicyRelationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUserLeavePolicyRelation(body: UserLeavePolicyRelationDto | undefined): Observable<UserLeavePolicyRelationDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/ChangeUserLeavePolicyRelation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processChangeUserLeavePolicyRelation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUserLeavePolicyRelation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLeavePolicyRelationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLeavePolicyRelationDto>;
        }));
    }

    protected processChangeUserLeavePolicyRelation(response: HttpResponseBase): Observable<UserLeavePolicyRelationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserLeavePolicyRelationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserLeavePolicyRelationDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    calculateAccrualForUserLeavePolicy(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/CalculateAccrualForUserLeavePolicy?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCalculateAccrualForUserLeavePolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateAccrualForUserLeavePolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCalculateAccrualForUserLeavePolicy(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteUserLeavePolicyRelation(id: number | undefined): Observable<UserLeavePolicyRelationDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/DeleteUserLeavePolicyRelation?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteUserLeavePolicyRelation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUserLeavePolicyRelation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLeavePolicyRelationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLeavePolicyRelationDto>;
        }));
    }

    protected processDeleteUserLeavePolicyRelation(response: HttpResponseBase): Observable<UserLeavePolicyRelationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserLeavePolicyRelationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserLeavePolicyRelationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createNoticeModel(body: NoticeModelDto | undefined): Observable<NoticeModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/CreateNoticeModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateNoticeModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNoticeModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NoticeModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NoticeModelDto>;
        }));
    }

    protected processCreateNoticeModel(response: HttpResponseBase): Observable<NoticeModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NoticeModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NoticeModelDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getNoticeModel(tenantId: number | undefined): Observable<NoticeModelDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetNoticeModel?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNoticeModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNoticeModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NoticeModelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NoticeModelDto[]>;
        }));
    }

    protected processGetNoticeModel(response: HttpResponseBase): Observable<NoticeModelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(NoticeModelDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NoticeModelDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getNoticeModelWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, userId: number | undefined): Observable<NoticeModelDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetNoticeModelWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNoticeModelWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNoticeModelWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NoticeModelDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NoticeModelDtoPagedResultDto>;
        }));
    }

    protected processGetNoticeModelWithInput(response: HttpResponseBase): Observable<NoticeModelDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NoticeModelDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NoticeModelDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateNoticeModel(id: number | undefined, body: NoticeModelDto | undefined): Observable<NoticeModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/UpdateNoticeModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateNoticeModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNoticeModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NoticeModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NoticeModelDto>;
        }));
    }

    protected processUpdateNoticeModel(response: HttpResponseBase): Observable<NoticeModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NoticeModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NoticeModelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteNoticeModelDto(id: number | undefined): Observable<NoticeModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/DeleteNoticeModelDto?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteNoticeModelDto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNoticeModelDto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NoticeModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NoticeModelDto>;
        }));
    }

    protected processDeleteNoticeModelDto(response: HttpResponseBase): Observable<NoticeModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NoticeModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NoticeModelDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    emailNoticeToEmployees(body: NoticeModelDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/EmailNoticeToEmployees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processEmailNoticeToEmployees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailNoticeToEmployees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmailNoticeToEmployees(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPaySlipAllowanceModel(body: PaySlipAllowanceModelDto | undefined): Observable<PaySlipAllowanceModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/CreatePaySlipAllowanceModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePaySlipAllowanceModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePaySlipAllowanceModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaySlipAllowanceModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaySlipAllowanceModelDto>;
        }));
    }

    protected processCreatePaySlipAllowanceModel(response: HttpResponseBase): Observable<PaySlipAllowanceModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaySlipAllowanceModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaySlipAllowanceModelDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getPaySlipAllowanceModel(tenantId: number | undefined): Observable<PaySlipAllowanceModel[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetPaySlipAllowanceModel?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPaySlipAllowanceModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaySlipAllowanceModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaySlipAllowanceModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaySlipAllowanceModel[]>;
        }));
    }

    protected processGetPaySlipAllowanceModel(response: HttpResponseBase): Observable<PaySlipAllowanceModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PaySlipAllowanceModel.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaySlipAllowanceModel[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getPaySlipAllowanceModelWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<PaySlipAllowanceModelPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetPaySlipAllowanceModelWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPaySlipAllowanceModelWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaySlipAllowanceModelWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaySlipAllowanceModelPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaySlipAllowanceModelPagedResultDto>;
        }));
    }

    protected processGetPaySlipAllowanceModelWithInput(response: HttpResponseBase): Observable<PaySlipAllowanceModelPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaySlipAllowanceModelPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaySlipAllowanceModelPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatePaySlipAllowanceModel(id: number | undefined, body: PaySlipAllowanceModelDto | undefined): Observable<PaySlipAllowanceModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/UpdatePaySlipAllowanceModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePaySlipAllowanceModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePaySlipAllowanceModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaySlipAllowanceModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaySlipAllowanceModelDto>;
        }));
    }

    protected processUpdatePaySlipAllowanceModel(response: HttpResponseBase): Observable<PaySlipAllowanceModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaySlipAllowanceModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaySlipAllowanceModelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deletePaySlipAllowanceModel(id: number | undefined): Observable<PaySlipAllowanceModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/DeletePaySlipAllowanceModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeletePaySlipAllowanceModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePaySlipAllowanceModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaySlipAllowanceModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaySlipAllowanceModelDto>;
        }));
    }

    protected processDeletePaySlipAllowanceModel(response: HttpResponseBase): Observable<PaySlipAllowanceModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaySlipAllowanceModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaySlipAllowanceModelDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getPaySlipModel(tenantId: number | undefined): Observable<PaySlipModelDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetPaySlipModel?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPaySlipModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaySlipModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaySlipModelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaySlipModelDto[]>;
        }));
    }

    protected processGetPaySlipModel(response: HttpResponseBase): Observable<PaySlipModelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PaySlipModelDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaySlipModelDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getPaySlipModelWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<PaySlipModelPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetPaySlipModelWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPaySlipModelWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaySlipModelWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaySlipModelPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaySlipModelPagedResultDto>;
        }));
    }

    protected processGetPaySlipModelWithInput(response: HttpResponseBase): Observable<PaySlipModelPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaySlipModelPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaySlipModelPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatePaySlipModel(id: number | undefined, body: PaySlipModelDto | undefined): Observable<PaySlipModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/UpdatePaySlipModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePaySlipModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePaySlipModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaySlipModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaySlipModelDto>;
        }));
    }

    protected processUpdatePaySlipModel(response: HttpResponseBase): Observable<PaySlipModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaySlipModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaySlipModelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deletePaySlipModel(id: number | undefined): Observable<PaySlipModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/DeletePaySlipModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeletePaySlipModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePaySlipModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaySlipModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaySlipModelDto>;
        }));
    }

    protected processDeletePaySlipModel(response: HttpResponseBase): Observable<PaySlipModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaySlipModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaySlipModelDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUserModel(body: UserModelDto | undefined): Observable<UserModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/CreateUserModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateUserModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModelDto>;
        }));
    }

    protected processCreateUserModel(response: HttpResponseBase): Observable<UserModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModelDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getUserModel(tenantId: number | undefined): Observable<UserModel[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetUserModel?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModel[]>;
        }));
    }

    protected processGetUserModel(response: HttpResponseBase): Observable<UserModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(UserModel.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModel[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getUserModelWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<UserModelPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetUserModelWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserModelWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserModelWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModelPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModelPagedResultDto>;
        }));
    }

    protected processGetUserModelWithInput(response: HttpResponseBase): Observable<UserModelPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserModelPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModelPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateUserModel(id: number | undefined, body: UserModelDto | undefined): Observable<UserModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/UpdateUserModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateUserModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModelDto>;
        }));
    }

    protected processUpdateUserModel(response: HttpResponseBase): Observable<UserModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteUserModel(id: number | undefined): Observable<UserModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/DeleteUserModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteUserModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUserModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserModelDto>;
        }));
    }

    protected processDeleteUserModel(response: HttpResponseBase): Observable<UserModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserModelDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getDashboardInformation(tenantId: number | undefined): Observable<DashboardInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetDashboardInformation?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDashboardInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardInfoDto>;
        }));
    }

    protected processGetDashboardInformation(response: HttpResponseBase): Observable<DashboardInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DashboardInfoDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardInfoDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getCalendarInformation(tenantId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<FullCalendarEventDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetCalendarInformation?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCalendarInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalendarInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FullCalendarEventDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FullCalendarEventDto[]>;
        }));
    }

    protected processGetCalendarInformation(response: HttpResponseBase): Observable<FullCalendarEventDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(FullCalendarEventDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FullCalendarEventDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getUserLeaveAndHolidayInformation(tenantId: number | undefined, userId: number | undefined): Observable<moment.Moment[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetUserLeaveAndHolidayInformation?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserLeaveAndHolidayInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserLeaveAndHolidayInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<moment.Moment[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<moment.Moment[]>;
        }));
    }

    protected processGetUserLeaveAndHolidayInformation(response: HttpResponseBase): Observable<moment.Moment[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(moment(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<moment.Moment[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUserDependantModel(body: UserDependantModelDto | undefined): Observable<UserDependantModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/CreateUserDependantModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateUserDependantModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserDependantModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDependantModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDependantModelDto>;
        }));
    }

    protected processCreateUserDependantModel(response: HttpResponseBase): Observable<UserDependantModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserDependantModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDependantModelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUserDependantModelById(id: number | undefined): Observable<UserDependantModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetUserDependantModelById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserDependantModelById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDependantModelById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDependantModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDependantModelDto>;
        }));
    }

    protected processGetUserDependantModelById(response: HttpResponseBase): Observable<UserDependantModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserDependantModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDependantModelDto>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    getAllUserDependantModelDtoByEmployeeId(employeeId: number | undefined): Observable<UserDependantModelDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetAllUserDependantModelDtoByEmployeeId?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllUserDependantModelDtoByEmployeeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserDependantModelDtoByEmployeeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDependantModelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDependantModelDto[]>;
        }));
    }

    protected processGetAllUserDependantModelDtoByEmployeeId(response: HttpResponseBase): Observable<UserDependantModelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(UserDependantModelDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDependantModelDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getAllUserDependantModelDtoByTenantId(tenantId: number | undefined): Observable<UserDependantModelDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetAllUserDependantModelDtoByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllUserDependantModelDtoByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserDependantModelDtoByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDependantModelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDependantModelDto[]>;
        }));
    }

    protected processGetAllUserDependantModelDtoByTenantId(response: HttpResponseBase): Observable<UserDependantModelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(UserDependantModelDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDependantModelDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateUserDependantModel(id: number | undefined, body: UserDependantModelDto | undefined): Observable<UserDependantModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/UpdateUserDependantModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateUserDependantModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserDependantModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDependantModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDependantModelDto>;
        }));
    }

    protected processUpdateUserDependantModel(response: HttpResponseBase): Observable<UserDependantModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserDependantModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDependantModelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteUserDependantModel(id: number | undefined): Observable<UserDependantModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/DeleteUserDependantModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteUserDependantModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUserDependantModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDependantModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDependantModelDto>;
        }));
    }

    protected processDeleteUserDependantModel(response: HttpResponseBase): Observable<UserDependantModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserDependantModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDependantModelDto>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getSalariesForLedger(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<LedgerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetSalariesForLedger?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSalariesForLedger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalariesForLedger(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LedgerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LedgerDto[]>;
        }));
    }

    protected processGetSalariesForLedger(response: HttpResponseBase): Observable<LedgerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(LedgerDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LedgerDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    emailPayslipToEmployee(body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/EmailPayslipToEmployee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processEmailPayslipToEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailPayslipToEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmailPayslipToEmployee(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAllowanceEmployeeModel(body: AllowanceEmployeeModelDto | undefined): Observable<AllowanceEmployeeModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/CreateAllowanceEmployeeModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateAllowanceEmployeeModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAllowanceEmployeeModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllowanceEmployeeModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllowanceEmployeeModelDto>;
        }));
    }

    protected processCreateAllowanceEmployeeModel(response: HttpResponseBase): Observable<AllowanceEmployeeModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AllowanceEmployeeModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AllowanceEmployeeModelDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param employeeId (optional) 
     * @param allowanceId (optional) 
     * @return Success
     */
    getAllowanceEmployeeByEmployeeIdAndAllowanceId(tenantId: number | undefined, employeeId: number | undefined, allowanceId: number | undefined): Observable<AllowanceEmployeeModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetAllowanceEmployeeByEmployeeIdAndAllowanceId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (allowanceId === null)
            throw new Error("The parameter 'allowanceId' cannot be null.");
        else if (allowanceId !== undefined)
            url_ += "allowanceId=" + encodeURIComponent("" + allowanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllowanceEmployeeByEmployeeIdAndAllowanceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowanceEmployeeByEmployeeIdAndAllowanceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllowanceEmployeeModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllowanceEmployeeModelDto>;
        }));
    }

    protected processGetAllowanceEmployeeByEmployeeIdAndAllowanceId(response: HttpResponseBase): Observable<AllowanceEmployeeModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AllowanceEmployeeModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AllowanceEmployeeModelDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param employeeId (optional) 
     * @return Success
     */
    getAllowanceEmployeeByEmployeeId(tenantId: number | undefined, employeeId: number | undefined): Observable<AllowanceEmployeeModelDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetAllowanceEmployeeByEmployeeId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllowanceEmployeeByEmployeeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowanceEmployeeByEmployeeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllowanceEmployeeModelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllowanceEmployeeModelDto[]>;
        }));
    }

    protected processGetAllowanceEmployeeByEmployeeId(response: HttpResponseBase): Observable<AllowanceEmployeeModelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(AllowanceEmployeeModelDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AllowanceEmployeeModelDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param allowanceId (optional) 
     * @return Success
     */
    getAllowanceEmployeeByAllowanceId(tenantId: number | undefined, allowanceId: number | undefined): Observable<AllowanceEmployeeModelDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetAllowanceEmployeeByAllowanceId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (allowanceId === null)
            throw new Error("The parameter 'allowanceId' cannot be null.");
        else if (allowanceId !== undefined)
            url_ += "allowanceId=" + encodeURIComponent("" + allowanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllowanceEmployeeByAllowanceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowanceEmployeeByAllowanceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllowanceEmployeeModelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllowanceEmployeeModelDto[]>;
        }));
    }

    protected processGetAllowanceEmployeeByAllowanceId(response: HttpResponseBase): Observable<AllowanceEmployeeModelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(AllowanceEmployeeModelDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AllowanceEmployeeModelDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @param employeeId (optional) 
     * @return Success
     */
    getAllowanceEmployeeModelWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined, employeeId: number | undefined): Observable<AllowanceEmployeeModelPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetAllowanceEmployeeModelWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllowanceEmployeeModelWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowanceEmployeeModelWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllowanceEmployeeModelPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllowanceEmployeeModelPagedResultDto>;
        }));
    }

    protected processGetAllowanceEmployeeModelWithInput(response: HttpResponseBase): Observable<AllowanceEmployeeModelPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AllowanceEmployeeModelPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AllowanceEmployeeModelPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateAllowanceEmployeeModel(id: number | undefined, body: AllowanceEmployeeModelDto | undefined): Observable<AllowanceEmployeeModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/UpdateAllowanceEmployeeModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateAllowanceEmployeeModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllowanceEmployeeModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllowanceEmployeeModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllowanceEmployeeModelDto>;
        }));
    }

    protected processUpdateAllowanceEmployeeModel(response: HttpResponseBase): Observable<AllowanceEmployeeModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AllowanceEmployeeModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AllowanceEmployeeModelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteAllowanceEmployeeModel(id: number | undefined): Observable<AllowanceEmployeeModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/DeleteAllowanceEmployeeModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteAllowanceEmployeeModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllowanceEmployeeModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllowanceEmployeeModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllowanceEmployeeModelDto>;
        }));
    }

    protected processDeleteAllowanceEmployeeModel(response: HttpResponseBase): Observable<AllowanceEmployeeModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AllowanceEmployeeModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AllowanceEmployeeModelDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAllowanceModel(body: AllowanceModelDto | undefined): Observable<AllowanceModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/CreateAllowanceModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateAllowanceModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAllowanceModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllowanceModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllowanceModelDto>;
        }));
    }

    protected processCreateAllowanceModel(response: HttpResponseBase): Observable<AllowanceModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AllowanceModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AllowanceModelDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getAllowanceModel(tenantId: number | undefined): Observable<AllowanceModelDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetAllowanceModel?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllowanceModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowanceModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllowanceModelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllowanceModelDto[]>;
        }));
    }

    protected processGetAllowanceModel(response: HttpResponseBase): Observable<AllowanceModelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(AllowanceModelDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AllowanceModelDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getAllowanceModelWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<AllowanceModelPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetAllowanceModelWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllowanceModelWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowanceModelWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllowanceModelPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllowanceModelPagedResultDto>;
        }));
    }

    protected processGetAllowanceModelWithInput(response: HttpResponseBase): Observable<AllowanceModelPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AllowanceModelPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AllowanceModelPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateAllowanceModel(id: number | undefined, body: AllowanceModelDto | undefined): Observable<AllowanceModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/UpdateAllowanceModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateAllowanceModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllowanceModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllowanceModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllowanceModelDto>;
        }));
    }

    protected processUpdateAllowanceModel(response: HttpResponseBase): Observable<AllowanceModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AllowanceModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AllowanceModelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteAllowanceModel(id: number | undefined): Observable<AllowanceModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/DeleteAllowanceModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteAllowanceModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllowanceModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllowanceModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllowanceModelDto>;
        }));
    }

    protected processDeleteAllowanceModel(response: HttpResponseBase): Observable<AllowanceModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AllowanceModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AllowanceModelDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAllowanceTypeModel(body: AllowanceTypeModelDto | undefined): Observable<AllowanceTypeModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/CreateAllowanceTypeModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateAllowanceTypeModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAllowanceTypeModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllowanceTypeModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllowanceTypeModelDto>;
        }));
    }

    protected processCreateAllowanceTypeModel(response: HttpResponseBase): Observable<AllowanceTypeModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AllowanceTypeModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AllowanceTypeModelDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getAllowanceTypeModel(tenantId: number | undefined): Observable<AllowanceTypeModel[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetAllowanceTypeModel?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllowanceTypeModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowanceTypeModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllowanceTypeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllowanceTypeModel[]>;
        }));
    }

    protected processGetAllowanceTypeModel(response: HttpResponseBase): Observable<AllowanceTypeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(AllowanceTypeModel.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AllowanceTypeModel[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getAllowanceTypeModelWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<AllowanceTypeModelPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetAllowanceTypeModelWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllowanceTypeModelWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowanceTypeModelWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllowanceTypeModelPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllowanceTypeModelPagedResultDto>;
        }));
    }

    protected processGetAllowanceTypeModelWithInput(response: HttpResponseBase): Observable<AllowanceTypeModelPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AllowanceTypeModelPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AllowanceTypeModelPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateAllowanceTypeModel(id: number | undefined, body: AllowanceTypeModelDto | undefined): Observable<AllowanceTypeModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/UpdateAllowanceTypeModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateAllowanceTypeModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllowanceTypeModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllowanceTypeModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllowanceTypeModelDto>;
        }));
    }

    protected processUpdateAllowanceTypeModel(response: HttpResponseBase): Observable<AllowanceTypeModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AllowanceTypeModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AllowanceTypeModelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteAllowanceTypeModel(id: number | undefined): Observable<AllowanceTypeModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/DeleteAllowanceTypeModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteAllowanceTypeModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllowanceTypeModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllowanceTypeModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllowanceTypeModelDto>;
        }));
    }

    protected processDeleteAllowanceTypeModel(response: HttpResponseBase): Observable<AllowanceTypeModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AllowanceTypeModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AllowanceTypeModelDto>(null as any);
    }

    /**
     * @param isFromClock (optional) 
     * @param body (optional) 
     * @return Success
     */
    createAttendenceModel(isFromClock: boolean | undefined, body: AttendenceModelDto | undefined): Observable<AttendenceModelDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/CreateAttendenceModel?";
        if (isFromClock === null)
            throw new Error("The parameter 'isFromClock' cannot be null.");
        else if (isFromClock !== undefined)
            url_ += "isFromClock=" + encodeURIComponent("" + isFromClock) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateAttendenceModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAttendenceModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendenceModelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendenceModelDto[]>;
        }));
    }

    protected processCreateAttendenceModel(response: HttpResponseBase): Observable<AttendenceModelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(AttendenceModelDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttendenceModelDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param isFromClock (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateAttendenceModel(id: number | undefined, isFromClock: boolean | undefined, body: AttendenceModelDto | undefined): Observable<AttendenceModelDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/UpdateAttendenceModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isFromClock === null)
            throw new Error("The parameter 'isFromClock' cannot be null.");
        else if (isFromClock !== undefined)
            url_ += "isFromClock=" + encodeURIComponent("" + isFromClock) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateAttendenceModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAttendenceModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendenceModelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendenceModelDto[]>;
        }));
    }

    protected processUpdateAttendenceModel(response: HttpResponseBase): Observable<AttendenceModelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(AttendenceModelDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttendenceModelDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getAttendenceModel(tenantId: number | undefined): Observable<AttendenceModel[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetAttendenceModel?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAttendenceModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendenceModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendenceModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendenceModel[]>;
        }));
    }

    protected processGetAttendenceModel(response: HttpResponseBase): Observable<AttendenceModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(AttendenceModel.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttendenceModel[]>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getCurrentClockIn(userId: number | undefined): Observable<AttendenceModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetCurrentClockIn?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCurrentClockIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentClockIn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendenceModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendenceModelDto>;
        }));
    }

    protected processGetCurrentClockIn(response: HttpResponseBase): Observable<AttendenceModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AttendenceModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttendenceModelDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getAttendenceModelWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<AttendenceModelPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetAttendenceModelWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAttendenceModelWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendenceModelWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendenceModelPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendenceModelPagedResultDto>;
        }));
    }

    protected processGetAttendenceModelWithInput(response: HttpResponseBase): Observable<AttendenceModelPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AttendenceModelPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttendenceModelPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkUserAttendanceInRange(body: AttendenceModelDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/CheckUserAttendanceInRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckUserAttendanceInRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckUserAttendanceInRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckUserAttendanceInRange(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getUserAttendanceWithRange(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userId: number | undefined): Observable<AttendenceModelDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetUserAttendanceWithRange?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserAttendanceWithRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAttendanceWithRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendenceModelDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendenceModelDtoPagedResultDto>;
        }));
    }

    protected processGetUserAttendanceWithRange(response: HttpResponseBase): Observable<AttendenceModelDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AttendenceModelDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttendenceModelDtoPagedResultDto>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getAttendanceReportWithRange(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetAttendanceReportWithRange?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAttendanceReportWithRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendanceReportWithRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processGetAttendanceReportWithRange(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(UserDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteAttendenceModel(id: number | undefined): Observable<AttendenceModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/DeleteAttendenceModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteAttendenceModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAttendenceModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendenceModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendenceModelDto>;
        }));
    }

    protected processDeleteAttendenceModel(response: HttpResponseBase): Observable<AttendenceModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AttendenceModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttendenceModelDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAwardModel(body: AwardModelDto | undefined): Observable<AwardModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/CreateAwardModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateAwardModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAwardModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AwardModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AwardModelDto>;
        }));
    }

    protected processCreateAwardModel(response: HttpResponseBase): Observable<AwardModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AwardModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AwardModelDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getAwardModel(tenantId: number | undefined): Observable<AwardModel[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetAwardModel?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAwardModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAwardModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AwardModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AwardModel[]>;
        }));
    }

    protected processGetAwardModel(response: HttpResponseBase): Observable<AwardModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(AwardModel.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AwardModel[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getAwardModelWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<AwardModelPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetAwardModelWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAwardModelWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAwardModelWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AwardModelPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AwardModelPagedResultDto>;
        }));
    }

    protected processGetAwardModelWithInput(response: HttpResponseBase): Observable<AwardModelPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AwardModelPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AwardModelPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateAwardModel(id: number | undefined, body: AwardModelDto | undefined): Observable<AwardModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/UpdateAwardModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateAwardModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAwardModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AwardModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AwardModelDto>;
        }));
    }

    protected processUpdateAwardModel(response: HttpResponseBase): Observable<AwardModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AwardModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AwardModelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteAwardModel(id: number | undefined): Observable<AwardModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/DeleteAwardModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteAwardModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAwardModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AwardModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AwardModelDto>;
        }));
    }

    protected processDeleteAwardModel(response: HttpResponseBase): Observable<AwardModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AwardModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AwardModelDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCompanyModel(body: CompanyModelDto | undefined): Observable<CompanyModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/CreateCompanyModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateCompanyModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCompanyModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyModelDto>;
        }));
    }

    protected processCreateCompanyModel(response: HttpResponseBase): Observable<CompanyModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyModelDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getCompanyModeld(tenantId: number | undefined): Observable<CompanyModel[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetCompanyModeld?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCompanyModeld(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyModeld(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyModel[]>;
        }));
    }

    protected processGetCompanyModeld(response: HttpResponseBase): Observable<CompanyModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(CompanyModel.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyModel[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getCompanyModeldWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<CompanyModelPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetCompanyModeldWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCompanyModeldWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyModeldWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyModelPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyModelPagedResultDto>;
        }));
    }

    protected processGetCompanyModeldWithInput(response: HttpResponseBase): Observable<CompanyModelPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyModelPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyModelPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateCompanyModel(id: number | undefined, body: CompanyModelDto | undefined): Observable<CompanyModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/UpdateCompanyModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateCompanyModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCompanyModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyModelDto>;
        }));
    }

    protected processUpdateCompanyModel(response: HttpResponseBase): Observable<CompanyModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyModelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteCompanyModel(id: number | undefined): Observable<CompanyModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/DeleteCompanyModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteCompanyModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCompanyModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompanyModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompanyModelDto>;
        }));
    }

    protected processDeleteCompanyModel(response: HttpResponseBase): Observable<CompanyModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CompanyModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyModelDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDepartment(body: DepartmentDto | undefined): Observable<DepartmentDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/CreateDepartment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DepartmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DepartmentDto>;
        }));
    }

    protected processCreateDepartment(response: HttpResponseBase): Observable<DepartmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DepartmentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DepartmentDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getDepartment(tenantId: number | undefined): Observable<Department[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetDepartment?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Department[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Department[]>;
        }));
    }

    protected processGetDepartment(response: HttpResponseBase): Observable<Department[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(Department.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Department[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getDepartmentById(id: number | undefined): Observable<Department> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetDepartmentById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDepartmentById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartmentById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Department>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Department>;
        }));
    }

    protected processGetDepartmentById(response: HttpResponseBase): Observable<Department> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Department.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Department>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getDepartmentWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<DepartmentPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetDepartmentWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDepartmentWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartmentWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DepartmentPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DepartmentPagedResultDto>;
        }));
    }

    protected processGetDepartmentWithInput(response: HttpResponseBase): Observable<DepartmentPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DepartmentPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DepartmentPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateDepartment(id: number | undefined, body: DepartmentDto | undefined): Observable<DepartmentDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/UpdateDepartment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DepartmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DepartmentDto>;
        }));
    }

    protected processUpdateDepartment(response: HttpResponseBase): Observable<DepartmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DepartmentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DepartmentDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteDepartment(id: number | undefined): Observable<DepartmentDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/DeleteDepartment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteDepartment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDepartment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DepartmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DepartmentDto>;
        }));
    }

    protected processDeleteDepartment(response: HttpResponseBase): Observable<DepartmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DepartmentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DepartmentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDesignationModel(body: DesignationModelDto | undefined): Observable<DesignationModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/CreateDesignationModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateDesignationModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDesignationModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DesignationModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DesignationModelDto>;
        }));
    }

    protected processCreateDesignationModel(response: HttpResponseBase): Observable<DesignationModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DesignationModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DesignationModelDto>(null as any);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    getDesignationModelByName(name: string | undefined): Observable<DesignationModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetDesignationModelByName?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDesignationModelByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDesignationModelByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DesignationModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DesignationModelDto>;
        }));
    }

    protected processGetDesignationModelByName(response: HttpResponseBase): Observable<DesignationModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DesignationModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DesignationModelDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getDesignationModelByTenantId(tenantId: number | undefined): Observable<DesignationModelDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetDesignationModelByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDesignationModelByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDesignationModelByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DesignationModelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DesignationModelDto[]>;
        }));
    }

    protected processGetDesignationModelByTenantId(response: HttpResponseBase): Observable<DesignationModelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(DesignationModelDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DesignationModelDto[]>(null as any);
    }

    /**
     * @param departmentId (optional) 
     * @return Success
     */
    getDesignationModelByDepartmentId(departmentId: number | undefined): Observable<DesignationModelDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetDesignationModelByDepartmentId?";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "departmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDesignationModelByDepartmentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDesignationModelByDepartmentId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DesignationModelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DesignationModelDto[]>;
        }));
    }

    protected processGetDesignationModelByDepartmentId(response: HttpResponseBase): Observable<DesignationModelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(DesignationModelDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DesignationModelDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getDesignationModelWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<DesignationModelDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetDesignationModelWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDesignationModelWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDesignationModelWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DesignationModelDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DesignationModelDtoPagedResultDto>;
        }));
    }

    protected processGetDesignationModelWithInput(response: HttpResponseBase): Observable<DesignationModelDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DesignationModelDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DesignationModelDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateDesignationModel(id: number | undefined, body: DesignationModelDto | undefined): Observable<DesignationModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/UpdateDesignationModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateDesignationModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDesignationModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DesignationModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DesignationModelDto>;
        }));
    }

    protected processUpdateDesignationModel(response: HttpResponseBase): Observable<DesignationModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DesignationModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DesignationModelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteDesignationModel(id: number | undefined): Observable<DesignationModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/DeleteDesignationModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteDesignationModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDesignationModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DesignationModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DesignationModelDto>;
        }));
    }

    protected processDeleteDesignationModel(response: HttpResponseBase): Observable<DesignationModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DesignationModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DesignationModelDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEmployeePaySlipModel(body: EmployeePaySlipModelDto | undefined): Observable<EmployeePaySlipModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/CreateEmployeePaySlipModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateEmployeePaySlipModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEmployeePaySlipModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeePaySlipModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeePaySlipModelDto>;
        }));
    }

    protected processCreateEmployeePaySlipModel(response: HttpResponseBase): Observable<EmployeePaySlipModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EmployeePaySlipModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeePaySlipModelDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDefaultPayslipAllowance(body: EmployeePaySlipModelDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/CreateDefaultPayslipAllowance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateDefaultPayslipAllowance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDefaultPayslipAllowance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateDefaultPayslipAllowance(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param employeeId (optional) 
     * @return Success
     */
    getEmployeePaySlipModel(tenantId: number | undefined, employeeId: number | undefined): Observable<EmployeePaySlipModelDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetEmployeePaySlipModel?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEmployeePaySlipModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeePaySlipModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeePaySlipModelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeePaySlipModelDto[]>;
        }));
    }

    protected processGetEmployeePaySlipModel(response: HttpResponseBase): Observable<EmployeePaySlipModelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(EmployeePaySlipModelDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeePaySlipModelDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEmployeePaySlipModelById(id: number | undefined): Observable<EmployeePaySlipModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetEmployeePaySlipModelById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEmployeePaySlipModelById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeePaySlipModelById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeePaySlipModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeePaySlipModelDto>;
        }));
    }

    protected processGetEmployeePaySlipModelById(response: HttpResponseBase): Observable<EmployeePaySlipModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EmployeePaySlipModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeePaySlipModelDto>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param year (optional) 
     * @param month (optional) 
     * @return Success
     */
    getEmployeePaySlipModelByYearAndMonth(employeeId: number | undefined, year: number | undefined, month: number | undefined): Observable<EmployeePaySlipModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetEmployeePaySlipModelByYearAndMonth?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEmployeePaySlipModelByYearAndMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeePaySlipModelByYearAndMonth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeePaySlipModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeePaySlipModelDto>;
        }));
    }

    protected processGetEmployeePaySlipModelByYearAndMonth(response: HttpResponseBase): Observable<EmployeePaySlipModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EmployeePaySlipModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeePaySlipModelDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param year (optional) 
     * @param month (optional) 
     * @return Success
     */
    getPayrollReportByYearAndMonth(tenantId: number | undefined, year: number | undefined, month: number | undefined): Observable<PayrollReportDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetPayrollReportByYearAndMonth?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPayrollReportByYearAndMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayrollReportByYearAndMonth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayrollReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayrollReportDto>;
        }));
    }

    protected processGetPayrollReportByYearAndMonth(response: HttpResponseBase): Observable<PayrollReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PayrollReportDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PayrollReportDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param month (optional) 
     * @param monthString (optional) 
     * @param year (optional) 
     * @param userId (optional) 
     * @param user_IsActive (optional) 
     * @param user_FullName (optional) 
     * @param user_LastLoginTime (optional) 
     * @param user_CreationTime (optional) 
     * @param user_RoleNames (optional) 
     * @param user_mainRoleId (optional) 
     * @param user_mainRoleName (optional) 
     * @param user_mainRolePermissionList (optional) 
     * @param user_lastVisitedMerchantStore (optional) 
     * @param user_IsEmailConfirmed (optional) 
     * @param user_Mobile (optional) 
     * @param user_ImagePath (optional) 
     * @param user_DateOfBirth (optional) 
     * @param user_Gender (optional) 
     * @param user_PresentAddress1 (optional) 
     * @param user_PresentAddress2 (optional) 
     * @param user_PresentAddress3 (optional) 
     * @param user_PresentAddress4 (optional) 
     * @param user_PermanentAddress1 (optional) 
     * @param user_PermanentAddress2 (optional) 
     * @param user_PermanentAddress3 (optional) 
     * @param user_PermanentAddress4 (optional) 
     * @param user_BasicSalary (optional) 
     * @param user_Status (optional) 
     * @param user_ResignDate (optional) 
     * @param user_departmentId (optional) 
     * @param user_Department_tenantId (optional) 
     * @param user_Department_departmentName (optional) 
     * @param user_Department_parentId (optional) 
     * @param user_Department_headOfDepartmentId (optional) 
     * @param user_Department_headOfDepartmentName (optional) 
     * @param user_Department_headOfDepartmentEmail (optional) 
     * @param user_Department_isCapex (optional) 
     * @param user_Department_isOpex (optional) 
     * @param user_Department_isResale (optional) 
     * @param user_Department_isManufacturing (optional) 
     * @param user_Department_isProject (optional) 
     * @param user_Department_limitCapex (optional) 
     * @param user_Department_limitOpex (optional) 
     * @param user_Department_limitResale (optional) 
     * @param user_Department_limitManufacturing (optional) 
     * @param user_Department_limitProject (optional) 
     * @param user_Department_IsDeleted (optional) 
     * @param user_Department_DeleterUserId (optional) 
     * @param user_Department_DeletionTime (optional) 
     * @param user_Department_LastModificationTime (optional) 
     * @param user_Department_LastModifierUserId (optional) 
     * @param user_Department_CreationTime (optional) 
     * @param user_Department_CreatorUserId (optional) 
     * @param user_Department_Id (optional) 
     * @param user_DesignationId (optional) 
     * @param user_Designation_departmentId (optional) 
     * @param user_Designation_department_tenantId (optional) 
     * @param user_Designation_department_departmentName (optional) 
     * @param user_Designation_department_parentId (optional) 
     * @param user_Designation_department_headOfDepartmentId (optional) 
     * @param user_Designation_department_headOfDepartmentName (optional) 
     * @param user_Designation_department_headOfDepartmentEmail (optional) 
     * @param user_Designation_department_isCapex (optional) 
     * @param user_Designation_department_isOpex (optional) 
     * @param user_Designation_department_isResale (optional) 
     * @param user_Designation_department_isManufacturing (optional) 
     * @param user_Designation_department_isProject (optional) 
     * @param user_Designation_department_limitCapex (optional) 
     * @param user_Designation_department_limitOpex (optional) 
     * @param user_Designation_department_limitResale (optional) 
     * @param user_Designation_department_limitManufacturing (optional) 
     * @param user_Designation_department_limitProject (optional) 
     * @param user_Designation_department_IsDeleted (optional) 
     * @param user_Designation_department_DeleterUserId (optional) 
     * @param user_Designation_department_DeletionTime (optional) 
     * @param user_Designation_department_LastModificationTime (optional) 
     * @param user_Designation_department_LastModifierUserId (optional) 
     * @param user_Designation_department_CreationTime (optional) 
     * @param user_Designation_department_CreatorUserId (optional) 
     * @param user_Designation_department_Id (optional) 
     * @param user_Designation_tenantId (optional) 
     * @param user_Designation_designationLevel (optional) 
     * @param user_Designation_IsDeleted (optional) 
     * @param user_Designation_DeleterUserId (optional) 
     * @param user_Designation_DeletionTime (optional) 
     * @param user_Designation_LastModificationTime (optional) 
     * @param user_Designation_LastModifierUserId (optional) 
     * @param user_Designation_CreationTime (optional) 
     * @param user_Designation_CreatorUserId (optional) 
     * @param user_Designation_Id (optional) 
     * @param user_BankName (optional) 
     * @param user_AccountName (optional) 
     * @param user_AccountNumber (optional) 
     * @param user_SWIFTCode (optional) 
     * @param user_Branch (optional) 
     * @param user_CV (optional) 
     * @param user_NationalId (optional) 
     * @param user_Other (optional) 
     * @param user_tenantId (optional) 
     * @param user_icUrl (optional) 
     * @param user_otherUrl (optional) 
     * @param user_RegularList (optional) 
     * @param user_AbsentList (optional) 
     * @param user_OvertimeList (optional) 
     * @param user_HolidayList (optional) 
     * @param user_PaidTimeOffList (optional) 
     * @param user_regularHours (optional) 
     * @param user_absentHours (optional) 
     * @param user_overtimeHours (optional) 
     * @param user_holidayHours (optional) 
     * @param user_paidTimeOffHours (optional) 
     * @param user_totalHours (optional) 
     * @param user_UserLeavePolicies (optional) 
     * @param user_staffId (optional) 
     * @param user_isResident (optional) 
     * @param user_identificationType (optional) 
     * @param user_identificationNo (optional) 
     * @param user_religion (optional) 
     * @param user_ethnicity (optional) 
     * @param user_maritalStatus (optional) 
     * @param user_disability (optional) 
     * @param user_country (optional) 
     * @param user_postcode (optional) 
     * @param user_city (optional) 
     * @param user_state (optional) 
     * @param user_highestEducation (optional) 
     * @param user_educationSpecialisation (optional) 
     * @param user_isSpecialWorker (optional) 
     * @param user_SalaryType (optional) 
     * @param user_salaryPaymentMethod (optional) 
     * @param user_epfNumber (optional) 
     * @param user_incomeTaxNumber (optional) 
     * @param user_socsoAccountNumber (optional) 
     * @param user_socsoContributionSchedule (optional) 
     * @param user_eisAccountNumber (optional) 
     * @param user_zakatAccountNumber (optional) 
     * @param user_zakatState (optional) 
     * @param user_zakatAmount (optional) 
     * @param user_asnbAccountNumber (optional) 
     * @param user_asnbAmount (optional) 
     * @param user_ptptnAccountNumber (optional) 
     * @param user_ptptnAmount (optional) 
     * @param user_tabungHajiAccountNumber (optional) 
     * @param user_tabungHajiAmount (optional) 
     * @param user_Id (optional) 
     * @param basicSalary (optional) 
     * @param salaryType (optional) 
     * @param cycleNo (optional) 
     * @param salaryForThisCycle (optional) 
     * @param worked (optional) 
     * @param proRatedSalary (optional) 
     * @param allowanceTotal (optional) 
     * @param deductionTotal (optional) 
     * @param epfEmployeeContribution (optional) 
     * @param socsoEmployeeContribution (optional) 
     * @param eisEmployeeContribution (optional) 
     * @param pcbEmployeeContribution (optional) 
     * @param hrdfEmployeeContribution (optional) 
     * @param employeeContribution (optional) 
     * @param netSalary (optional) 
     * @param epfEmployerContribution (optional) 
     * @param socsoEmployerContribution (optional) 
     * @param eisEmployerContribution (optional) 
     * @param pcbEmployerContribution (optional) 
     * @param hrdfEmployerContribution (optional) 
     * @param employerContribution (optional) 
     * @param status (optional) 
     * @param isOptedOut (optional) 
     * @param paymentDate (optional) 
     * @param payslipAllowanceList (optional) 
     * @param payslipDeductionList (optional) 
     * @param eligibleAllowanceList (optional) 
     * @param eligibleDeductionList (optional) 
     * @param isDeleted (optional) 
     * @param deleterUserId (optional) 
     * @param deletionTime (optional) 
     * @param lastModificationTime (optional) 
     * @param lastModifierUserId (optional) 
     * @param creationTime (optional) 
     * @param creatorUserId (optional) 
     * @param id (optional) 
     * @return Success
     */
    getPayslipAllowances(tenantId: number | undefined, month: number | undefined, monthString: string | undefined, year: number | undefined, userId: number | undefined, user_UserName: string, user_Name: string, user_Surname: string, user_EmailAddress: string, user_IsActive: boolean | undefined, user_FullName: string | undefined, user_LastLoginTime: moment.Moment | undefined, user_CreationTime: moment.Moment | undefined, user_RoleNames: string[] | undefined, user_mainRoleId: number | undefined, user_mainRoleName: string | undefined, user_mainRolePermissionList: RolePermissionSetting[] | undefined, user_lastVisitedMerchantStore: string | undefined, user_IsEmailConfirmed: boolean | undefined, user_Mobile: string | undefined, user_ImagePath: string | undefined, user_DateOfBirth: moment.Moment | undefined, user_Gender: string | undefined, user_PresentAddress1: string | undefined, user_PresentAddress2: string | undefined, user_PresentAddress3: string | undefined, user_PresentAddress4: string | undefined, user_PermanentAddress1: string | undefined, user_PermanentAddress2: string | undefined, user_PermanentAddress3: string | undefined, user_PermanentAddress4: string | undefined, user_BasicSalary: number | undefined, user_Status: number | undefined, user_JoiningDate: moment.Moment, user_ResignDate: moment.Moment | undefined, user_departmentId: number | undefined, user_Department_tenantId: number | undefined, user_Department_departmentName: string | undefined, user_Department_parentId: number | undefined, user_Department_headOfDepartmentId: number | undefined, user_Department_headOfDepartmentName: string | undefined, user_Department_headOfDepartmentEmail: string | undefined, user_Department_isCapex: boolean | undefined, user_Department_isOpex: boolean | undefined, user_Department_isResale: boolean | undefined, user_Department_isManufacturing: boolean | undefined, user_Department_isProject: boolean | undefined, user_Department_limitCapex: number | undefined, user_Department_limitOpex: number | undefined, user_Department_limitResale: number | undefined, user_Department_limitManufacturing: number | undefined, user_Department_limitProject: number | undefined, user_Department_IsDeleted: boolean | undefined, user_Department_DeleterUserId: number | undefined, user_Department_DeletionTime: moment.Moment | undefined, user_Department_LastModificationTime: moment.Moment | undefined, user_Department_LastModifierUserId: number | undefined, user_Department_CreationTime: moment.Moment | undefined, user_Department_CreatorUserId: number | undefined, user_Department_Id: number | undefined, user_DesignationId: number | undefined, user_Designation_Name: string, user_Designation_departmentId: number | undefined, user_Designation_department_tenantId: number | undefined, user_Designation_department_departmentName: string | undefined, user_Designation_department_parentId: number | undefined, user_Designation_department_headOfDepartmentId: number | undefined, user_Designation_department_headOfDepartmentName: string | undefined, user_Designation_department_headOfDepartmentEmail: string | undefined, user_Designation_department_isCapex: boolean | undefined, user_Designation_department_isOpex: boolean | undefined, user_Designation_department_isResale: boolean | undefined, user_Designation_department_isManufacturing: boolean | undefined, user_Designation_department_isProject: boolean | undefined, user_Designation_department_limitCapex: number | undefined, user_Designation_department_limitOpex: number | undefined, user_Designation_department_limitResale: number | undefined, user_Designation_department_limitManufacturing: number | undefined, user_Designation_department_limitProject: number | undefined, user_Designation_department_IsDeleted: boolean | undefined, user_Designation_department_DeleterUserId: number | undefined, user_Designation_department_DeletionTime: moment.Moment | undefined, user_Designation_department_LastModificationTime: moment.Moment | undefined, user_Designation_department_LastModifierUserId: number | undefined, user_Designation_department_CreationTime: moment.Moment | undefined, user_Designation_department_CreatorUserId: number | undefined, user_Designation_department_Id: number | undefined, user_Designation_tenantId: number | undefined, user_Designation_designationLevel: number | undefined, user_Designation_IsDeleted: boolean | undefined, user_Designation_DeleterUserId: number | undefined, user_Designation_DeletionTime: moment.Moment | undefined, user_Designation_LastModificationTime: moment.Moment | undefined, user_Designation_LastModifierUserId: number | undefined, user_Designation_CreationTime: moment.Moment | undefined, user_Designation_CreatorUserId: number | undefined, user_Designation_Id: number | undefined, user_BankName: string | undefined, user_AccountName: string | undefined, user_AccountNumber: string | undefined, user_SWIFTCode: string | undefined, user_Branch: string | undefined, user_CV: string | undefined, user_NationalId: string | undefined, user_Other: string | undefined, user_tenantId: number | undefined, user_icUrl: string | undefined, user_otherUrl: string | undefined, user_RegularList: AttendenceModel[] | undefined, user_AbsentList: AttendenceModel[] | undefined, user_OvertimeList: AttendenceModel[] | undefined, user_HolidayList: AttendenceModel[] | undefined, user_PaidTimeOffList: AttendenceModel[] | undefined, user_regularHours: number | undefined, user_absentHours: number | undefined, user_overtimeHours: number | undefined, user_holidayHours: number | undefined, user_paidTimeOffHours: number | undefined, user_totalHours: number | undefined, user_UserLeavePolicies: UserLeavePolicyRelationDto[] | undefined, user_staffId: string | undefined, user_isResident: boolean | undefined, user_identificationType: string | undefined, user_identificationNo: string | undefined, user_religion: string | undefined, user_ethnicity: string | undefined, user_maritalStatus: string | undefined, user_disability: boolean | undefined, user_country: string | undefined, user_postcode: string | undefined, user_city: string | undefined, user_state: string | undefined, user_highestEducation: string | undefined, user_educationSpecialisation: string | undefined, user_isSpecialWorker: boolean | undefined, user_SalaryType: SalaryType | undefined, user_salaryPaymentMethod: boolean | undefined, user_epfNumber: string | undefined, user_incomeTaxNumber: string | undefined, user_socsoAccountNumber: string | undefined, user_socsoContributionSchedule: number | undefined, user_eisAccountNumber: string | undefined, user_zakatAccountNumber: string | undefined, user_zakatState: string | undefined, user_zakatAmount: number | undefined, user_asnbAccountNumber: string | undefined, user_asnbAmount: number | undefined, user_ptptnAccountNumber: string | undefined, user_ptptnAmount: number | undefined, user_tabungHajiAccountNumber: string | undefined, user_tabungHajiAmount: number | undefined, user_Id: number | undefined, basicSalary: number | undefined, salaryType: SalaryType | undefined, cycleNo: number | undefined, salaryForThisCycle: number | undefined, worked: number | undefined, proRatedSalary: number | undefined, allowanceTotal: number | undefined, deductionTotal: number | undefined, epfEmployeeContribution: number | undefined, socsoEmployeeContribution: number | undefined, eisEmployeeContribution: number | undefined, pcbEmployeeContribution: number | undefined, hrdfEmployeeContribution: number | undefined, employeeContribution: number | undefined, netSalary: number | undefined, epfEmployerContribution: number | undefined, socsoEmployerContribution: number | undefined, eisEmployerContribution: number | undefined, pcbEmployerContribution: number | undefined, hrdfEmployerContribution: number | undefined, employerContribution: number | undefined, status: string | undefined, isOptedOut: boolean | undefined, paymentDate: moment.Moment | undefined, payslipAllowanceList: PaySlipAllowanceModel[] | undefined, payslipDeductionList: PaySlipAllowanceModel[] | undefined, eligibleAllowanceList: PaySlipAllowanceModelDto[] | undefined, eligibleDeductionList: PaySlipAllowanceModelDto[] | undefined, isDeleted: boolean | undefined, deleterUserId: number | undefined, deletionTime: moment.Moment | undefined, lastModificationTime: moment.Moment | undefined, lastModifierUserId: number | undefined, creationTime: moment.Moment | undefined, creatorUserId: number | undefined, id: number | undefined): Observable<EmployeePaySlipModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetPayslipAllowances?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "Month=" + encodeURIComponent("" + month) + "&";
        if (monthString === null)
            throw new Error("The parameter 'monthString' cannot be null.");
        else if (monthString !== undefined)
            url_ += "MonthString=" + encodeURIComponent("" + monthString) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (user_UserName === undefined || user_UserName === null)
            throw new Error("The parameter 'user_UserName' must be defined and cannot be null.");
        else
            url_ += "User.UserName=" + encodeURIComponent("" + user_UserName) + "&";
        if (user_Name === undefined || user_Name === null)
            throw new Error("The parameter 'user_Name' must be defined and cannot be null.");
        else
            url_ += "User.Name=" + encodeURIComponent("" + user_Name) + "&";
        if (user_Surname === undefined || user_Surname === null)
            throw new Error("The parameter 'user_Surname' must be defined and cannot be null.");
        else
            url_ += "User.Surname=" + encodeURIComponent("" + user_Surname) + "&";
        if (user_EmailAddress === undefined || user_EmailAddress === null)
            throw new Error("The parameter 'user_EmailAddress' must be defined and cannot be null.");
        else
            url_ += "User.EmailAddress=" + encodeURIComponent("" + user_EmailAddress) + "&";
        if (user_IsActive === null)
            throw new Error("The parameter 'user_IsActive' cannot be null.");
        else if (user_IsActive !== undefined)
            url_ += "User.IsActive=" + encodeURIComponent("" + user_IsActive) + "&";
        if (user_FullName === null)
            throw new Error("The parameter 'user_FullName' cannot be null.");
        else if (user_FullName !== undefined)
            url_ += "User.FullName=" + encodeURIComponent("" + user_FullName) + "&";
        if (user_LastLoginTime === null)
            throw new Error("The parameter 'user_LastLoginTime' cannot be null.");
        else if (user_LastLoginTime !== undefined)
            url_ += "User.LastLoginTime=" + encodeURIComponent(user_LastLoginTime ? "" + user_LastLoginTime.toISOString() : "") + "&";
        if (user_CreationTime === null)
            throw new Error("The parameter 'user_CreationTime' cannot be null.");
        else if (user_CreationTime !== undefined)
            url_ += "User.CreationTime=" + encodeURIComponent(user_CreationTime ? "" + user_CreationTime.toISOString() : "") + "&";
        if (user_RoleNames === null)
            throw new Error("The parameter 'user_RoleNames' cannot be null.");
        else if (user_RoleNames !== undefined)
            user_RoleNames && user_RoleNames.forEach(item => { url_ += "User.RoleNames=" + encodeURIComponent("" + item) + "&"; });
        if (user_mainRoleId === null)
            throw new Error("The parameter 'user_mainRoleId' cannot be null.");
        else if (user_mainRoleId !== undefined)
            url_ += "User.mainRoleId=" + encodeURIComponent("" + user_mainRoleId) + "&";
        if (user_mainRoleName === null)
            throw new Error("The parameter 'user_mainRoleName' cannot be null.");
        else if (user_mainRoleName !== undefined)
            url_ += "User.mainRoleName=" + encodeURIComponent("" + user_mainRoleName) + "&";
        if (user_mainRolePermissionList === null)
            throw new Error("The parameter 'user_mainRolePermissionList' cannot be null.");
        else if (user_mainRolePermissionList !== undefined)
            user_mainRolePermissionList && user_mainRolePermissionList.forEach((item, index) => {
                for (let attr in item)
                    if (item.hasOwnProperty(attr)) {
                        url_ += "User.mainRolePermissionList[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
                    }
            });
        if (user_lastVisitedMerchantStore === null)
            throw new Error("The parameter 'user_lastVisitedMerchantStore' cannot be null.");
        else if (user_lastVisitedMerchantStore !== undefined)
            url_ += "User.lastVisitedMerchantStore=" + encodeURIComponent("" + user_lastVisitedMerchantStore) + "&";
        if (user_IsEmailConfirmed === null)
            throw new Error("The parameter 'user_IsEmailConfirmed' cannot be null.");
        else if (user_IsEmailConfirmed !== undefined)
            url_ += "User.IsEmailConfirmed=" + encodeURIComponent("" + user_IsEmailConfirmed) + "&";
        if (user_Mobile === null)
            throw new Error("The parameter 'user_Mobile' cannot be null.");
        else if (user_Mobile !== undefined)
            url_ += "User.Mobile=" + encodeURIComponent("" + user_Mobile) + "&";
        if (user_ImagePath === null)
            throw new Error("The parameter 'user_ImagePath' cannot be null.");
        else if (user_ImagePath !== undefined)
            url_ += "User.ImagePath=" + encodeURIComponent("" + user_ImagePath) + "&";
        if (user_DateOfBirth === null)
            throw new Error("The parameter 'user_DateOfBirth' cannot be null.");
        else if (user_DateOfBirth !== undefined)
            url_ += "User.DateOfBirth=" + encodeURIComponent(user_DateOfBirth ? "" + user_DateOfBirth.toISOString() : "") + "&";
        if (user_Gender === null)
            throw new Error("The parameter 'user_Gender' cannot be null.");
        else if (user_Gender !== undefined)
            url_ += "User.Gender=" + encodeURIComponent("" + user_Gender) + "&";
        if (user_PresentAddress1 === null)
            throw new Error("The parameter 'user_PresentAddress1' cannot be null.");
        else if (user_PresentAddress1 !== undefined)
            url_ += "User.PresentAddress1=" + encodeURIComponent("" + user_PresentAddress1) + "&";
        if (user_PresentAddress2 === null)
            throw new Error("The parameter 'user_PresentAddress2' cannot be null.");
        else if (user_PresentAddress2 !== undefined)
            url_ += "User.PresentAddress2=" + encodeURIComponent("" + user_PresentAddress2) + "&";
        if (user_PresentAddress3 === null)
            throw new Error("The parameter 'user_PresentAddress3' cannot be null.");
        else if (user_PresentAddress3 !== undefined)
            url_ += "User.PresentAddress3=" + encodeURIComponent("" + user_PresentAddress3) + "&";
        if (user_PresentAddress4 === null)
            throw new Error("The parameter 'user_PresentAddress4' cannot be null.");
        else if (user_PresentAddress4 !== undefined)
            url_ += "User.PresentAddress4=" + encodeURIComponent("" + user_PresentAddress4) + "&";
        if (user_PermanentAddress1 === null)
            throw new Error("The parameter 'user_PermanentAddress1' cannot be null.");
        else if (user_PermanentAddress1 !== undefined)
            url_ += "User.PermanentAddress1=" + encodeURIComponent("" + user_PermanentAddress1) + "&";
        if (user_PermanentAddress2 === null)
            throw new Error("The parameter 'user_PermanentAddress2' cannot be null.");
        else if (user_PermanentAddress2 !== undefined)
            url_ += "User.PermanentAddress2=" + encodeURIComponent("" + user_PermanentAddress2) + "&";
        if (user_PermanentAddress3 === null)
            throw new Error("The parameter 'user_PermanentAddress3' cannot be null.");
        else if (user_PermanentAddress3 !== undefined)
            url_ += "User.PermanentAddress3=" + encodeURIComponent("" + user_PermanentAddress3) + "&";
        if (user_PermanentAddress4 === null)
            throw new Error("The parameter 'user_PermanentAddress4' cannot be null.");
        else if (user_PermanentAddress4 !== undefined)
            url_ += "User.PermanentAddress4=" + encodeURIComponent("" + user_PermanentAddress4) + "&";
        if (user_BasicSalary === null)
            throw new Error("The parameter 'user_BasicSalary' cannot be null.");
        else if (user_BasicSalary !== undefined)
            url_ += "User.BasicSalary=" + encodeURIComponent("" + user_BasicSalary) + "&";
        if (user_Status === null)
            throw new Error("The parameter 'user_Status' cannot be null.");
        else if (user_Status !== undefined)
            url_ += "User.Status=" + encodeURIComponent("" + user_Status) + "&";
        if (user_JoiningDate === undefined || user_JoiningDate === null)
            throw new Error("The parameter 'user_JoiningDate' must be defined and cannot be null.");
        else
            url_ += "User.JoiningDate=" + encodeURIComponent(user_JoiningDate ? "" + user_JoiningDate.toISOString() : "") + "&";
        if (user_ResignDate === null)
            throw new Error("The parameter 'user_ResignDate' cannot be null.");
        else if (user_ResignDate !== undefined)
            url_ += "User.ResignDate=" + encodeURIComponent(user_ResignDate ? "" + user_ResignDate.toISOString() : "") + "&";
        if (user_departmentId === null)
            throw new Error("The parameter 'user_departmentId' cannot be null.");
        else if (user_departmentId !== undefined)
            url_ += "User.departmentId=" + encodeURIComponent("" + user_departmentId) + "&";
        if (user_Department_tenantId === null)
            throw new Error("The parameter 'user_Department_tenantId' cannot be null.");
        else if (user_Department_tenantId !== undefined)
            url_ += "User.Department.tenantId=" + encodeURIComponent("" + user_Department_tenantId) + "&";
        if (user_Department_departmentName === null)
            throw new Error("The parameter 'user_Department_departmentName' cannot be null.");
        else if (user_Department_departmentName !== undefined)
            url_ += "User.Department.departmentName=" + encodeURIComponent("" + user_Department_departmentName) + "&";
        if (user_Department_parentId === null)
            throw new Error("The parameter 'user_Department_parentId' cannot be null.");
        else if (user_Department_parentId !== undefined)
            url_ += "User.Department.parentId=" + encodeURIComponent("" + user_Department_parentId) + "&";
        if (user_Department_headOfDepartmentId === null)
            throw new Error("The parameter 'user_Department_headOfDepartmentId' cannot be null.");
        else if (user_Department_headOfDepartmentId !== undefined)
            url_ += "User.Department.headOfDepartmentId=" + encodeURIComponent("" + user_Department_headOfDepartmentId) + "&";
        if (user_Department_headOfDepartmentName === null)
            throw new Error("The parameter 'user_Department_headOfDepartmentName' cannot be null.");
        else if (user_Department_headOfDepartmentName !== undefined)
            url_ += "User.Department.headOfDepartmentName=" + encodeURIComponent("" + user_Department_headOfDepartmentName) + "&";
        if (user_Department_headOfDepartmentEmail === null)
            throw new Error("The parameter 'user_Department_headOfDepartmentEmail' cannot be null.");
        else if (user_Department_headOfDepartmentEmail !== undefined)
            url_ += "User.Department.headOfDepartmentEmail=" + encodeURIComponent("" + user_Department_headOfDepartmentEmail) + "&";
        if (user_Department_isCapex === null)
            throw new Error("The parameter 'user_Department_isCapex' cannot be null.");
        else if (user_Department_isCapex !== undefined)
            url_ += "User.Department.isCapex=" + encodeURIComponent("" + user_Department_isCapex) + "&";
        if (user_Department_isOpex === null)
            throw new Error("The parameter 'user_Department_isOpex' cannot be null.");
        else if (user_Department_isOpex !== undefined)
            url_ += "User.Department.isOpex=" + encodeURIComponent("" + user_Department_isOpex) + "&";
        if (user_Department_isResale === null)
            throw new Error("The parameter 'user_Department_isResale' cannot be null.");
        else if (user_Department_isResale !== undefined)
            url_ += "User.Department.isResale=" + encodeURIComponent("" + user_Department_isResale) + "&";
        if (user_Department_isManufacturing === null)
            throw new Error("The parameter 'user_Department_isManufacturing' cannot be null.");
        else if (user_Department_isManufacturing !== undefined)
            url_ += "User.Department.isManufacturing=" + encodeURIComponent("" + user_Department_isManufacturing) + "&";
        if (user_Department_isProject === null)
            throw new Error("The parameter 'user_Department_isProject' cannot be null.");
        else if (user_Department_isProject !== undefined)
            url_ += "User.Department.isProject=" + encodeURIComponent("" + user_Department_isProject) + "&";
        if (user_Department_limitCapex === null)
            throw new Error("The parameter 'user_Department_limitCapex' cannot be null.");
        else if (user_Department_limitCapex !== undefined)
            url_ += "User.Department.limitCapex=" + encodeURIComponent("" + user_Department_limitCapex) + "&";
        if (user_Department_limitOpex === null)
            throw new Error("The parameter 'user_Department_limitOpex' cannot be null.");
        else if (user_Department_limitOpex !== undefined)
            url_ += "User.Department.limitOpex=" + encodeURIComponent("" + user_Department_limitOpex) + "&";
        if (user_Department_limitResale === null)
            throw new Error("The parameter 'user_Department_limitResale' cannot be null.");
        else if (user_Department_limitResale !== undefined)
            url_ += "User.Department.limitResale=" + encodeURIComponent("" + user_Department_limitResale) + "&";
        if (user_Department_limitManufacturing === null)
            throw new Error("The parameter 'user_Department_limitManufacturing' cannot be null.");
        else if (user_Department_limitManufacturing !== undefined)
            url_ += "User.Department.limitManufacturing=" + encodeURIComponent("" + user_Department_limitManufacturing) + "&";
        if (user_Department_limitProject === null)
            throw new Error("The parameter 'user_Department_limitProject' cannot be null.");
        else if (user_Department_limitProject !== undefined)
            url_ += "User.Department.limitProject=" + encodeURIComponent("" + user_Department_limitProject) + "&";
        if (user_Department_IsDeleted === null)
            throw new Error("The parameter 'user_Department_IsDeleted' cannot be null.");
        else if (user_Department_IsDeleted !== undefined)
            url_ += "User.Department.IsDeleted=" + encodeURIComponent("" + user_Department_IsDeleted) + "&";
        if (user_Department_DeleterUserId === null)
            throw new Error("The parameter 'user_Department_DeleterUserId' cannot be null.");
        else if (user_Department_DeleterUserId !== undefined)
            url_ += "User.Department.DeleterUserId=" + encodeURIComponent("" + user_Department_DeleterUserId) + "&";
        if (user_Department_DeletionTime === null)
            throw new Error("The parameter 'user_Department_DeletionTime' cannot be null.");
        else if (user_Department_DeletionTime !== undefined)
            url_ += "User.Department.DeletionTime=" + encodeURIComponent(user_Department_DeletionTime ? "" + user_Department_DeletionTime.toISOString() : "") + "&";
        if (user_Department_LastModificationTime === null)
            throw new Error("The parameter 'user_Department_LastModificationTime' cannot be null.");
        else if (user_Department_LastModificationTime !== undefined)
            url_ += "User.Department.LastModificationTime=" + encodeURIComponent(user_Department_LastModificationTime ? "" + user_Department_LastModificationTime.toISOString() : "") + "&";
        if (user_Department_LastModifierUserId === null)
            throw new Error("The parameter 'user_Department_LastModifierUserId' cannot be null.");
        else if (user_Department_LastModifierUserId !== undefined)
            url_ += "User.Department.LastModifierUserId=" + encodeURIComponent("" + user_Department_LastModifierUserId) + "&";
        if (user_Department_CreationTime === null)
            throw new Error("The parameter 'user_Department_CreationTime' cannot be null.");
        else if (user_Department_CreationTime !== undefined)
            url_ += "User.Department.CreationTime=" + encodeURIComponent(user_Department_CreationTime ? "" + user_Department_CreationTime.toISOString() : "") + "&";
        if (user_Department_CreatorUserId === null)
            throw new Error("The parameter 'user_Department_CreatorUserId' cannot be null.");
        else if (user_Department_CreatorUserId !== undefined)
            url_ += "User.Department.CreatorUserId=" + encodeURIComponent("" + user_Department_CreatorUserId) + "&";
        if (user_Department_Id === null)
            throw new Error("The parameter 'user_Department_Id' cannot be null.");
        else if (user_Department_Id !== undefined)
            url_ += "User.Department.Id=" + encodeURIComponent("" + user_Department_Id) + "&";
        if (user_DesignationId === null)
            throw new Error("The parameter 'user_DesignationId' cannot be null.");
        else if (user_DesignationId !== undefined)
            url_ += "User.DesignationId=" + encodeURIComponent("" + user_DesignationId) + "&";
        if (user_Designation_Name === undefined || user_Designation_Name === null)
            throw new Error("The parameter 'user_Designation_Name' must be defined and cannot be null.");
        else
            url_ += "User.Designation.Name=" + encodeURIComponent("" + user_Designation_Name) + "&";
        if (user_Designation_departmentId === null)
            throw new Error("The parameter 'user_Designation_departmentId' cannot be null.");
        else if (user_Designation_departmentId !== undefined)
            url_ += "User.Designation.departmentId=" + encodeURIComponent("" + user_Designation_departmentId) + "&";
        if (user_Designation_department_tenantId === null)
            throw new Error("The parameter 'user_Designation_department_tenantId' cannot be null.");
        else if (user_Designation_department_tenantId !== undefined)
            url_ += "User.Designation.department.tenantId=" + encodeURIComponent("" + user_Designation_department_tenantId) + "&";
        if (user_Designation_department_departmentName === null)
            throw new Error("The parameter 'user_Designation_department_departmentName' cannot be null.");
        else if (user_Designation_department_departmentName !== undefined)
            url_ += "User.Designation.department.departmentName=" + encodeURIComponent("" + user_Designation_department_departmentName) + "&";
        if (user_Designation_department_parentId === null)
            throw new Error("The parameter 'user_Designation_department_parentId' cannot be null.");
        else if (user_Designation_department_parentId !== undefined)
            url_ += "User.Designation.department.parentId=" + encodeURIComponent("" + user_Designation_department_parentId) + "&";
        if (user_Designation_department_headOfDepartmentId === null)
            throw new Error("The parameter 'user_Designation_department_headOfDepartmentId' cannot be null.");
        else if (user_Designation_department_headOfDepartmentId !== undefined)
            url_ += "User.Designation.department.headOfDepartmentId=" + encodeURIComponent("" + user_Designation_department_headOfDepartmentId) + "&";
        if (user_Designation_department_headOfDepartmentName === null)
            throw new Error("The parameter 'user_Designation_department_headOfDepartmentName' cannot be null.");
        else if (user_Designation_department_headOfDepartmentName !== undefined)
            url_ += "User.Designation.department.headOfDepartmentName=" + encodeURIComponent("" + user_Designation_department_headOfDepartmentName) + "&";
        if (user_Designation_department_headOfDepartmentEmail === null)
            throw new Error("The parameter 'user_Designation_department_headOfDepartmentEmail' cannot be null.");
        else if (user_Designation_department_headOfDepartmentEmail !== undefined)
            url_ += "User.Designation.department.headOfDepartmentEmail=" + encodeURIComponent("" + user_Designation_department_headOfDepartmentEmail) + "&";
        if (user_Designation_department_isCapex === null)
            throw new Error("The parameter 'user_Designation_department_isCapex' cannot be null.");
        else if (user_Designation_department_isCapex !== undefined)
            url_ += "User.Designation.department.isCapex=" + encodeURIComponent("" + user_Designation_department_isCapex) + "&";
        if (user_Designation_department_isOpex === null)
            throw new Error("The parameter 'user_Designation_department_isOpex' cannot be null.");
        else if (user_Designation_department_isOpex !== undefined)
            url_ += "User.Designation.department.isOpex=" + encodeURIComponent("" + user_Designation_department_isOpex) + "&";
        if (user_Designation_department_isResale === null)
            throw new Error("The parameter 'user_Designation_department_isResale' cannot be null.");
        else if (user_Designation_department_isResale !== undefined)
            url_ += "User.Designation.department.isResale=" + encodeURIComponent("" + user_Designation_department_isResale) + "&";
        if (user_Designation_department_isManufacturing === null)
            throw new Error("The parameter 'user_Designation_department_isManufacturing' cannot be null.");
        else if (user_Designation_department_isManufacturing !== undefined)
            url_ += "User.Designation.department.isManufacturing=" + encodeURIComponent("" + user_Designation_department_isManufacturing) + "&";
        if (user_Designation_department_isProject === null)
            throw new Error("The parameter 'user_Designation_department_isProject' cannot be null.");
        else if (user_Designation_department_isProject !== undefined)
            url_ += "User.Designation.department.isProject=" + encodeURIComponent("" + user_Designation_department_isProject) + "&";
        if (user_Designation_department_limitCapex === null)
            throw new Error("The parameter 'user_Designation_department_limitCapex' cannot be null.");
        else if (user_Designation_department_limitCapex !== undefined)
            url_ += "User.Designation.department.limitCapex=" + encodeURIComponent("" + user_Designation_department_limitCapex) + "&";
        if (user_Designation_department_limitOpex === null)
            throw new Error("The parameter 'user_Designation_department_limitOpex' cannot be null.");
        else if (user_Designation_department_limitOpex !== undefined)
            url_ += "User.Designation.department.limitOpex=" + encodeURIComponent("" + user_Designation_department_limitOpex) + "&";
        if (user_Designation_department_limitResale === null)
            throw new Error("The parameter 'user_Designation_department_limitResale' cannot be null.");
        else if (user_Designation_department_limitResale !== undefined)
            url_ += "User.Designation.department.limitResale=" + encodeURIComponent("" + user_Designation_department_limitResale) + "&";
        if (user_Designation_department_limitManufacturing === null)
            throw new Error("The parameter 'user_Designation_department_limitManufacturing' cannot be null.");
        else if (user_Designation_department_limitManufacturing !== undefined)
            url_ += "User.Designation.department.limitManufacturing=" + encodeURIComponent("" + user_Designation_department_limitManufacturing) + "&";
        if (user_Designation_department_limitProject === null)
            throw new Error("The parameter 'user_Designation_department_limitProject' cannot be null.");
        else if (user_Designation_department_limitProject !== undefined)
            url_ += "User.Designation.department.limitProject=" + encodeURIComponent("" + user_Designation_department_limitProject) + "&";
        if (user_Designation_department_IsDeleted === null)
            throw new Error("The parameter 'user_Designation_department_IsDeleted' cannot be null.");
        else if (user_Designation_department_IsDeleted !== undefined)
            url_ += "User.Designation.department.IsDeleted=" + encodeURIComponent("" + user_Designation_department_IsDeleted) + "&";
        if (user_Designation_department_DeleterUserId === null)
            throw new Error("The parameter 'user_Designation_department_DeleterUserId' cannot be null.");
        else if (user_Designation_department_DeleterUserId !== undefined)
            url_ += "User.Designation.department.DeleterUserId=" + encodeURIComponent("" + user_Designation_department_DeleterUserId) + "&";
        if (user_Designation_department_DeletionTime === null)
            throw new Error("The parameter 'user_Designation_department_DeletionTime' cannot be null.");
        else if (user_Designation_department_DeletionTime !== undefined)
            url_ += "User.Designation.department.DeletionTime=" + encodeURIComponent(user_Designation_department_DeletionTime ? "" + user_Designation_department_DeletionTime.toISOString() : "") + "&";
        if (user_Designation_department_LastModificationTime === null)
            throw new Error("The parameter 'user_Designation_department_LastModificationTime' cannot be null.");
        else if (user_Designation_department_LastModificationTime !== undefined)
            url_ += "User.Designation.department.LastModificationTime=" + encodeURIComponent(user_Designation_department_LastModificationTime ? "" + user_Designation_department_LastModificationTime.toISOString() : "") + "&";
        if (user_Designation_department_LastModifierUserId === null)
            throw new Error("The parameter 'user_Designation_department_LastModifierUserId' cannot be null.");
        else if (user_Designation_department_LastModifierUserId !== undefined)
            url_ += "User.Designation.department.LastModifierUserId=" + encodeURIComponent("" + user_Designation_department_LastModifierUserId) + "&";
        if (user_Designation_department_CreationTime === null)
            throw new Error("The parameter 'user_Designation_department_CreationTime' cannot be null.");
        else if (user_Designation_department_CreationTime !== undefined)
            url_ += "User.Designation.department.CreationTime=" + encodeURIComponent(user_Designation_department_CreationTime ? "" + user_Designation_department_CreationTime.toISOString() : "") + "&";
        if (user_Designation_department_CreatorUserId === null)
            throw new Error("The parameter 'user_Designation_department_CreatorUserId' cannot be null.");
        else if (user_Designation_department_CreatorUserId !== undefined)
            url_ += "User.Designation.department.CreatorUserId=" + encodeURIComponent("" + user_Designation_department_CreatorUserId) + "&";
        if (user_Designation_department_Id === null)
            throw new Error("The parameter 'user_Designation_department_Id' cannot be null.");
        else if (user_Designation_department_Id !== undefined)
            url_ += "User.Designation.department.Id=" + encodeURIComponent("" + user_Designation_department_Id) + "&";
        if (user_Designation_tenantId === null)
            throw new Error("The parameter 'user_Designation_tenantId' cannot be null.");
        else if (user_Designation_tenantId !== undefined)
            url_ += "User.Designation.tenantId=" + encodeURIComponent("" + user_Designation_tenantId) + "&";
        if (user_Designation_designationLevel === null)
            throw new Error("The parameter 'user_Designation_designationLevel' cannot be null.");
        else if (user_Designation_designationLevel !== undefined)
            url_ += "User.Designation.designationLevel=" + encodeURIComponent("" + user_Designation_designationLevel) + "&";
        if (user_Designation_IsDeleted === null)
            throw new Error("The parameter 'user_Designation_IsDeleted' cannot be null.");
        else if (user_Designation_IsDeleted !== undefined)
            url_ += "User.Designation.IsDeleted=" + encodeURIComponent("" + user_Designation_IsDeleted) + "&";
        if (user_Designation_DeleterUserId === null)
            throw new Error("The parameter 'user_Designation_DeleterUserId' cannot be null.");
        else if (user_Designation_DeleterUserId !== undefined)
            url_ += "User.Designation.DeleterUserId=" + encodeURIComponent("" + user_Designation_DeleterUserId) + "&";
        if (user_Designation_DeletionTime === null)
            throw new Error("The parameter 'user_Designation_DeletionTime' cannot be null.");
        else if (user_Designation_DeletionTime !== undefined)
            url_ += "User.Designation.DeletionTime=" + encodeURIComponent(user_Designation_DeletionTime ? "" + user_Designation_DeletionTime.toISOString() : "") + "&";
        if (user_Designation_LastModificationTime === null)
            throw new Error("The parameter 'user_Designation_LastModificationTime' cannot be null.");
        else if (user_Designation_LastModificationTime !== undefined)
            url_ += "User.Designation.LastModificationTime=" + encodeURIComponent(user_Designation_LastModificationTime ? "" + user_Designation_LastModificationTime.toISOString() : "") + "&";
        if (user_Designation_LastModifierUserId === null)
            throw new Error("The parameter 'user_Designation_LastModifierUserId' cannot be null.");
        else if (user_Designation_LastModifierUserId !== undefined)
            url_ += "User.Designation.LastModifierUserId=" + encodeURIComponent("" + user_Designation_LastModifierUserId) + "&";
        if (user_Designation_CreationTime === null)
            throw new Error("The parameter 'user_Designation_CreationTime' cannot be null.");
        else if (user_Designation_CreationTime !== undefined)
            url_ += "User.Designation.CreationTime=" + encodeURIComponent(user_Designation_CreationTime ? "" + user_Designation_CreationTime.toISOString() : "") + "&";
        if (user_Designation_CreatorUserId === null)
            throw new Error("The parameter 'user_Designation_CreatorUserId' cannot be null.");
        else if (user_Designation_CreatorUserId !== undefined)
            url_ += "User.Designation.CreatorUserId=" + encodeURIComponent("" + user_Designation_CreatorUserId) + "&";
        if (user_Designation_Id === null)
            throw new Error("The parameter 'user_Designation_Id' cannot be null.");
        else if (user_Designation_Id !== undefined)
            url_ += "User.Designation.Id=" + encodeURIComponent("" + user_Designation_Id) + "&";
        if (user_BankName === null)
            throw new Error("The parameter 'user_BankName' cannot be null.");
        else if (user_BankName !== undefined)
            url_ += "User.BankName=" + encodeURIComponent("" + user_BankName) + "&";
        if (user_AccountName === null)
            throw new Error("The parameter 'user_AccountName' cannot be null.");
        else if (user_AccountName !== undefined)
            url_ += "User.AccountName=" + encodeURIComponent("" + user_AccountName) + "&";
        if (user_AccountNumber === null)
            throw new Error("The parameter 'user_AccountNumber' cannot be null.");
        else if (user_AccountNumber !== undefined)
            url_ += "User.AccountNumber=" + encodeURIComponent("" + user_AccountNumber) + "&";
        if (user_SWIFTCode === null)
            throw new Error("The parameter 'user_SWIFTCode' cannot be null.");
        else if (user_SWIFTCode !== undefined)
            url_ += "User.SWIFTCode=" + encodeURIComponent("" + user_SWIFTCode) + "&";
        if (user_Branch === null)
            throw new Error("The parameter 'user_Branch' cannot be null.");
        else if (user_Branch !== undefined)
            url_ += "User.Branch=" + encodeURIComponent("" + user_Branch) + "&";
        if (user_CV === null)
            throw new Error("The parameter 'user_CV' cannot be null.");
        else if (user_CV !== undefined)
            url_ += "User.CV=" + encodeURIComponent("" + user_CV) + "&";
        if (user_NationalId === null)
            throw new Error("The parameter 'user_NationalId' cannot be null.");
        else if (user_NationalId !== undefined)
            url_ += "User.NationalId=" + encodeURIComponent("" + user_NationalId) + "&";
        if (user_Other === null)
            throw new Error("The parameter 'user_Other' cannot be null.");
        else if (user_Other !== undefined)
            url_ += "User.Other=" + encodeURIComponent("" + user_Other) + "&";
        if (user_tenantId === null)
            throw new Error("The parameter 'user_tenantId' cannot be null.");
        else if (user_tenantId !== undefined)
            url_ += "User.tenantId=" + encodeURIComponent("" + user_tenantId) + "&";
        if (user_icUrl === null)
            throw new Error("The parameter 'user_icUrl' cannot be null.");
        else if (user_icUrl !== undefined)
            url_ += "User.icUrl=" + encodeURIComponent("" + user_icUrl) + "&";
        if (user_otherUrl === null)
            throw new Error("The parameter 'user_otherUrl' cannot be null.");
        else if (user_otherUrl !== undefined)
            url_ += "User.otherUrl=" + encodeURIComponent("" + user_otherUrl) + "&";
        if (user_RegularList === null)
            throw new Error("The parameter 'user_RegularList' cannot be null.");
        else if (user_RegularList !== undefined)
            user_RegularList && user_RegularList.forEach((item, index) => {
                for (let attr in item)
                    if (item.hasOwnProperty(attr)) {
                        url_ += "User.RegularList[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
                    }
            });
        if (user_AbsentList === null)
            throw new Error("The parameter 'user_AbsentList' cannot be null.");
        else if (user_AbsentList !== undefined)
            user_AbsentList && user_AbsentList.forEach((item, index) => {
                for (let attr in item)
                    if (item.hasOwnProperty(attr)) {
                        url_ += "User.AbsentList[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
                    }
            });
        if (user_OvertimeList === null)
            throw new Error("The parameter 'user_OvertimeList' cannot be null.");
        else if (user_OvertimeList !== undefined)
            user_OvertimeList && user_OvertimeList.forEach((item, index) => {
                for (let attr in item)
                    if (item.hasOwnProperty(attr)) {
                        url_ += "User.OvertimeList[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
                    }
            });
        if (user_HolidayList === null)
            throw new Error("The parameter 'user_HolidayList' cannot be null.");
        else if (user_HolidayList !== undefined)
            user_HolidayList && user_HolidayList.forEach((item, index) => {
                for (let attr in item)
                    if (item.hasOwnProperty(attr)) {
                        url_ += "User.HolidayList[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
                    }
            });
        if (user_PaidTimeOffList === null)
            throw new Error("The parameter 'user_PaidTimeOffList' cannot be null.");
        else if (user_PaidTimeOffList !== undefined)
            user_PaidTimeOffList && user_PaidTimeOffList.forEach((item, index) => {
                for (let attr in item)
                    if (item.hasOwnProperty(attr)) {
                        url_ += "User.PaidTimeOffList[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
                    }
            });
        if (user_regularHours === null)
            throw new Error("The parameter 'user_regularHours' cannot be null.");
        else if (user_regularHours !== undefined)
            url_ += "User.regularHours=" + encodeURIComponent("" + user_regularHours) + "&";
        if (user_absentHours === null)
            throw new Error("The parameter 'user_absentHours' cannot be null.");
        else if (user_absentHours !== undefined)
            url_ += "User.absentHours=" + encodeURIComponent("" + user_absentHours) + "&";
        if (user_overtimeHours === null)
            throw new Error("The parameter 'user_overtimeHours' cannot be null.");
        else if (user_overtimeHours !== undefined)
            url_ += "User.overtimeHours=" + encodeURIComponent("" + user_overtimeHours) + "&";
        if (user_holidayHours === null)
            throw new Error("The parameter 'user_holidayHours' cannot be null.");
        else if (user_holidayHours !== undefined)
            url_ += "User.holidayHours=" + encodeURIComponent("" + user_holidayHours) + "&";
        if (user_paidTimeOffHours === null)
            throw new Error("The parameter 'user_paidTimeOffHours' cannot be null.");
        else if (user_paidTimeOffHours !== undefined)
            url_ += "User.paidTimeOffHours=" + encodeURIComponent("" + user_paidTimeOffHours) + "&";
        if (user_totalHours === null)
            throw new Error("The parameter 'user_totalHours' cannot be null.");
        else if (user_totalHours !== undefined)
            url_ += "User.totalHours=" + encodeURIComponent("" + user_totalHours) + "&";
        if (user_UserLeavePolicies === null)
            throw new Error("The parameter 'user_UserLeavePolicies' cannot be null.");
        else if (user_UserLeavePolicies !== undefined)
            user_UserLeavePolicies && user_UserLeavePolicies.forEach((item, index) => {
                for (let attr in item)
                    if (item.hasOwnProperty(attr)) {
                        url_ += "User.UserLeavePolicies[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
                    }
            });
        if (user_staffId === null)
            throw new Error("The parameter 'user_staffId' cannot be null.");
        else if (user_staffId !== undefined)
            url_ += "User.staffId=" + encodeURIComponent("" + user_staffId) + "&";
        if (user_isResident === null)
            throw new Error("The parameter 'user_isResident' cannot be null.");
        else if (user_isResident !== undefined)
            url_ += "User.isResident=" + encodeURIComponent("" + user_isResident) + "&";
        if (user_identificationType === null)
            throw new Error("The parameter 'user_identificationType' cannot be null.");
        else if (user_identificationType !== undefined)
            url_ += "User.identificationType=" + encodeURIComponent("" + user_identificationType) + "&";
        if (user_identificationNo === null)
            throw new Error("The parameter 'user_identificationNo' cannot be null.");
        else if (user_identificationNo !== undefined)
            url_ += "User.identificationNo=" + encodeURIComponent("" + user_identificationNo) + "&";
        if (user_religion === null)
            throw new Error("The parameter 'user_religion' cannot be null.");
        else if (user_religion !== undefined)
            url_ += "User.religion=" + encodeURIComponent("" + user_religion) + "&";
        if (user_ethnicity === null)
            throw new Error("The parameter 'user_ethnicity' cannot be null.");
        else if (user_ethnicity !== undefined)
            url_ += "User.ethnicity=" + encodeURIComponent("" + user_ethnicity) + "&";
        if (user_maritalStatus === null)
            throw new Error("The parameter 'user_maritalStatus' cannot be null.");
        else if (user_maritalStatus !== undefined)
            url_ += "User.maritalStatus=" + encodeURIComponent("" + user_maritalStatus) + "&";
        if (user_disability === null)
            throw new Error("The parameter 'user_disability' cannot be null.");
        else if (user_disability !== undefined)
            url_ += "User.disability=" + encodeURIComponent("" + user_disability) + "&";
        if (user_country === null)
            throw new Error("The parameter 'user_country' cannot be null.");
        else if (user_country !== undefined)
            url_ += "User.country=" + encodeURIComponent("" + user_country) + "&";
        if (user_postcode === null)
            throw new Error("The parameter 'user_postcode' cannot be null.");
        else if (user_postcode !== undefined)
            url_ += "User.postcode=" + encodeURIComponent("" + user_postcode) + "&";
        if (user_city === null)
            throw new Error("The parameter 'user_city' cannot be null.");
        else if (user_city !== undefined)
            url_ += "User.city=" + encodeURIComponent("" + user_city) + "&";
        if (user_state === null)
            throw new Error("The parameter 'user_state' cannot be null.");
        else if (user_state !== undefined)
            url_ += "User.state=" + encodeURIComponent("" + user_state) + "&";
        if (user_highestEducation === null)
            throw new Error("The parameter 'user_highestEducation' cannot be null.");
        else if (user_highestEducation !== undefined)
            url_ += "User.highestEducation=" + encodeURIComponent("" + user_highestEducation) + "&";
        if (user_educationSpecialisation === null)
            throw new Error("The parameter 'user_educationSpecialisation' cannot be null.");
        else if (user_educationSpecialisation !== undefined)
            url_ += "User.educationSpecialisation=" + encodeURIComponent("" + user_educationSpecialisation) + "&";
        if (user_isSpecialWorker === null)
            throw new Error("The parameter 'user_isSpecialWorker' cannot be null.");
        else if (user_isSpecialWorker !== undefined)
            url_ += "User.isSpecialWorker=" + encodeURIComponent("" + user_isSpecialWorker) + "&";
        if (user_SalaryType === null)
            throw new Error("The parameter 'user_SalaryType' cannot be null.");
        else if (user_SalaryType !== undefined)
            url_ += "User.SalaryType=" + encodeURIComponent("" + user_SalaryType) + "&";
        if (user_salaryPaymentMethod === null)
            throw new Error("The parameter 'user_salaryPaymentMethod' cannot be null.");
        else if (user_salaryPaymentMethod !== undefined)
            url_ += "User.salaryPaymentMethod=" + encodeURIComponent("" + user_salaryPaymentMethod) + "&";
        if (user_epfNumber === null)
            throw new Error("The parameter 'user_epfNumber' cannot be null.");
        else if (user_epfNumber !== undefined)
            url_ += "User.epfNumber=" + encodeURIComponent("" + user_epfNumber) + "&";
        if (user_incomeTaxNumber === null)
            throw new Error("The parameter 'user_incomeTaxNumber' cannot be null.");
        else if (user_incomeTaxNumber !== undefined)
            url_ += "User.incomeTaxNumber=" + encodeURIComponent("" + user_incomeTaxNumber) + "&";
        if (user_socsoAccountNumber === null)
            throw new Error("The parameter 'user_socsoAccountNumber' cannot be null.");
        else if (user_socsoAccountNumber !== undefined)
            url_ += "User.socsoAccountNumber=" + encodeURIComponent("" + user_socsoAccountNumber) + "&";
        if (user_socsoContributionSchedule === null)
            throw new Error("The parameter 'user_socsoContributionSchedule' cannot be null.");
        else if (user_socsoContributionSchedule !== undefined)
            url_ += "User.socsoContributionSchedule=" + encodeURIComponent("" + user_socsoContributionSchedule) + "&";
        if (user_eisAccountNumber === null)
            throw new Error("The parameter 'user_eisAccountNumber' cannot be null.");
        else if (user_eisAccountNumber !== undefined)
            url_ += "User.eisAccountNumber=" + encodeURIComponent("" + user_eisAccountNumber) + "&";
        if (user_zakatAccountNumber === null)
            throw new Error("The parameter 'user_zakatAccountNumber' cannot be null.");
        else if (user_zakatAccountNumber !== undefined)
            url_ += "User.zakatAccountNumber=" + encodeURIComponent("" + user_zakatAccountNumber) + "&";
        if (user_zakatState === null)
            throw new Error("The parameter 'user_zakatState' cannot be null.");
        else if (user_zakatState !== undefined)
            url_ += "User.zakatState=" + encodeURIComponent("" + user_zakatState) + "&";
        if (user_zakatAmount === null)
            throw new Error("The parameter 'user_zakatAmount' cannot be null.");
        else if (user_zakatAmount !== undefined)
            url_ += "User.zakatAmount=" + encodeURIComponent("" + user_zakatAmount) + "&";
        if (user_asnbAccountNumber === null)
            throw new Error("The parameter 'user_asnbAccountNumber' cannot be null.");
        else if (user_asnbAccountNumber !== undefined)
            url_ += "User.asnbAccountNumber=" + encodeURIComponent("" + user_asnbAccountNumber) + "&";
        if (user_asnbAmount === null)
            throw new Error("The parameter 'user_asnbAmount' cannot be null.");
        else if (user_asnbAmount !== undefined)
            url_ += "User.asnbAmount=" + encodeURIComponent("" + user_asnbAmount) + "&";
        if (user_ptptnAccountNumber === null)
            throw new Error("The parameter 'user_ptptnAccountNumber' cannot be null.");
        else if (user_ptptnAccountNumber !== undefined)
            url_ += "User.ptptnAccountNumber=" + encodeURIComponent("" + user_ptptnAccountNumber) + "&";
        if (user_ptptnAmount === null)
            throw new Error("The parameter 'user_ptptnAmount' cannot be null.");
        else if (user_ptptnAmount !== undefined)
            url_ += "User.ptptnAmount=" + encodeURIComponent("" + user_ptptnAmount) + "&";
        if (user_tabungHajiAccountNumber === null)
            throw new Error("The parameter 'user_tabungHajiAccountNumber' cannot be null.");
        else if (user_tabungHajiAccountNumber !== undefined)
            url_ += "User.tabungHajiAccountNumber=" + encodeURIComponent("" + user_tabungHajiAccountNumber) + "&";
        if (user_tabungHajiAmount === null)
            throw new Error("The parameter 'user_tabungHajiAmount' cannot be null.");
        else if (user_tabungHajiAmount !== undefined)
            url_ += "User.tabungHajiAmount=" + encodeURIComponent("" + user_tabungHajiAmount) + "&";
        if (user_Id === null)
            throw new Error("The parameter 'user_Id' cannot be null.");
        else if (user_Id !== undefined)
            url_ += "User.Id=" + encodeURIComponent("" + user_Id) + "&";
        if (basicSalary === null)
            throw new Error("The parameter 'basicSalary' cannot be null.");
        else if (basicSalary !== undefined)
            url_ += "BasicSalary=" + encodeURIComponent("" + basicSalary) + "&";
        if (salaryType === null)
            throw new Error("The parameter 'salaryType' cannot be null.");
        else if (salaryType !== undefined)
            url_ += "SalaryType=" + encodeURIComponent("" + salaryType) + "&";
        if (cycleNo === null)
            throw new Error("The parameter 'cycleNo' cannot be null.");
        else if (cycleNo !== undefined)
            url_ += "CycleNo=" + encodeURIComponent("" + cycleNo) + "&";
        if (salaryForThisCycle === null)
            throw new Error("The parameter 'salaryForThisCycle' cannot be null.");
        else if (salaryForThisCycle !== undefined)
            url_ += "SalaryForThisCycle=" + encodeURIComponent("" + salaryForThisCycle) + "&";
        if (worked === null)
            throw new Error("The parameter 'worked' cannot be null.");
        else if (worked !== undefined)
            url_ += "Worked=" + encodeURIComponent("" + worked) + "&";
        if (proRatedSalary === null)
            throw new Error("The parameter 'proRatedSalary' cannot be null.");
        else if (proRatedSalary !== undefined)
            url_ += "ProRatedSalary=" + encodeURIComponent("" + proRatedSalary) + "&";
        if (allowanceTotal === null)
            throw new Error("The parameter 'allowanceTotal' cannot be null.");
        else if (allowanceTotal !== undefined)
            url_ += "AllowanceTotal=" + encodeURIComponent("" + allowanceTotal) + "&";
        if (deductionTotal === null)
            throw new Error("The parameter 'deductionTotal' cannot be null.");
        else if (deductionTotal !== undefined)
            url_ += "DeductionTotal=" + encodeURIComponent("" + deductionTotal) + "&";
        if (epfEmployeeContribution === null)
            throw new Error("The parameter 'epfEmployeeContribution' cannot be null.");
        else if (epfEmployeeContribution !== undefined)
            url_ += "EpfEmployeeContribution=" + encodeURIComponent("" + epfEmployeeContribution) + "&";
        if (socsoEmployeeContribution === null)
            throw new Error("The parameter 'socsoEmployeeContribution' cannot be null.");
        else if (socsoEmployeeContribution !== undefined)
            url_ += "SocsoEmployeeContribution=" + encodeURIComponent("" + socsoEmployeeContribution) + "&";
        if (eisEmployeeContribution === null)
            throw new Error("The parameter 'eisEmployeeContribution' cannot be null.");
        else if (eisEmployeeContribution !== undefined)
            url_ += "EisEmployeeContribution=" + encodeURIComponent("" + eisEmployeeContribution) + "&";
        if (pcbEmployeeContribution === null)
            throw new Error("The parameter 'pcbEmployeeContribution' cannot be null.");
        else if (pcbEmployeeContribution !== undefined)
            url_ += "PcbEmployeeContribution=" + encodeURIComponent("" + pcbEmployeeContribution) + "&";
        if (hrdfEmployeeContribution === null)
            throw new Error("The parameter 'hrdfEmployeeContribution' cannot be null.");
        else if (hrdfEmployeeContribution !== undefined)
            url_ += "HrdfEmployeeContribution=" + encodeURIComponent("" + hrdfEmployeeContribution) + "&";
        if (employeeContribution === null)
            throw new Error("The parameter 'employeeContribution' cannot be null.");
        else if (employeeContribution !== undefined)
            url_ += "EmployeeContribution=" + encodeURIComponent("" + employeeContribution) + "&";
        if (netSalary === null)
            throw new Error("The parameter 'netSalary' cannot be null.");
        else if (netSalary !== undefined)
            url_ += "NetSalary=" + encodeURIComponent("" + netSalary) + "&";
        if (epfEmployerContribution === null)
            throw new Error("The parameter 'epfEmployerContribution' cannot be null.");
        else if (epfEmployerContribution !== undefined)
            url_ += "EpfEmployerContribution=" + encodeURIComponent("" + epfEmployerContribution) + "&";
        if (socsoEmployerContribution === null)
            throw new Error("The parameter 'socsoEmployerContribution' cannot be null.");
        else if (socsoEmployerContribution !== undefined)
            url_ += "SocsoEmployerContribution=" + encodeURIComponent("" + socsoEmployerContribution) + "&";
        if (eisEmployerContribution === null)
            throw new Error("The parameter 'eisEmployerContribution' cannot be null.");
        else if (eisEmployerContribution !== undefined)
            url_ += "EisEmployerContribution=" + encodeURIComponent("" + eisEmployerContribution) + "&";
        if (pcbEmployerContribution === null)
            throw new Error("The parameter 'pcbEmployerContribution' cannot be null.");
        else if (pcbEmployerContribution !== undefined)
            url_ += "PcbEmployerContribution=" + encodeURIComponent("" + pcbEmployerContribution) + "&";
        if (hrdfEmployerContribution === null)
            throw new Error("The parameter 'hrdfEmployerContribution' cannot be null.");
        else if (hrdfEmployerContribution !== undefined)
            url_ += "HrdfEmployerContribution=" + encodeURIComponent("" + hrdfEmployerContribution) + "&";
        if (employerContribution === null)
            throw new Error("The parameter 'employerContribution' cannot be null.");
        else if (employerContribution !== undefined)
            url_ += "EmployerContribution=" + encodeURIComponent("" + employerContribution) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (isOptedOut === null)
            throw new Error("The parameter 'isOptedOut' cannot be null.");
        else if (isOptedOut !== undefined)
            url_ += "IsOptedOut=" + encodeURIComponent("" + isOptedOut) + "&";
        if (paymentDate === null)
            throw new Error("The parameter 'paymentDate' cannot be null.");
        else if (paymentDate !== undefined)
            url_ += "PaymentDate=" + encodeURIComponent(paymentDate ? "" + paymentDate.toISOString() : "") + "&";
        if (payslipAllowanceList === null)
            throw new Error("The parameter 'payslipAllowanceList' cannot be null.");
        else if (payslipAllowanceList !== undefined)
            payslipAllowanceList && payslipAllowanceList.forEach((item, index) => {
                for (let attr in item)
                    if (item.hasOwnProperty(attr)) {
                        url_ += "PayslipAllowanceList[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
                    }
            });
        if (payslipDeductionList === null)
            throw new Error("The parameter 'payslipDeductionList' cannot be null.");
        else if (payslipDeductionList !== undefined)
            payslipDeductionList && payslipDeductionList.forEach((item, index) => {
                for (let attr in item)
                    if (item.hasOwnProperty(attr)) {
                        url_ += "PayslipDeductionList[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
                    }
            });
        if (eligibleAllowanceList === null)
            throw new Error("The parameter 'eligibleAllowanceList' cannot be null.");
        else if (eligibleAllowanceList !== undefined)
            eligibleAllowanceList && eligibleAllowanceList.forEach((item, index) => {
                for (let attr in item)
                    if (item.hasOwnProperty(attr)) {
                        url_ += "EligibleAllowanceList[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
                    }
            });
        if (eligibleDeductionList === null)
            throw new Error("The parameter 'eligibleDeductionList' cannot be null.");
        else if (eligibleDeductionList !== undefined)
            eligibleDeductionList && eligibleDeductionList.forEach((item, index) => {
                for (let attr in item)
                    if (item.hasOwnProperty(attr)) {
                        url_ += "EligibleDeductionList[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
                    }
            });
        if (isDeleted === null)
            throw new Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined)
            url_ += "IsDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (deleterUserId === null)
            throw new Error("The parameter 'deleterUserId' cannot be null.");
        else if (deleterUserId !== undefined)
            url_ += "DeleterUserId=" + encodeURIComponent("" + deleterUserId) + "&";
        if (deletionTime === null)
            throw new Error("The parameter 'deletionTime' cannot be null.");
        else if (deletionTime !== undefined)
            url_ += "DeletionTime=" + encodeURIComponent(deletionTime ? "" + deletionTime.toISOString() : "") + "&";
        if (lastModificationTime === null)
            throw new Error("The parameter 'lastModificationTime' cannot be null.");
        else if (lastModificationTime !== undefined)
            url_ += "LastModificationTime=" + encodeURIComponent(lastModificationTime ? "" + lastModificationTime.toISOString() : "") + "&";
        if (lastModifierUserId === null)
            throw new Error("The parameter 'lastModifierUserId' cannot be null.");
        else if (lastModifierUserId !== undefined)
            url_ += "LastModifierUserId=" + encodeURIComponent("" + lastModifierUserId) + "&";
        if (creationTime === null)
            throw new Error("The parameter 'creationTime' cannot be null.");
        else if (creationTime !== undefined)
            url_ += "CreationTime=" + encodeURIComponent(creationTime ? "" + creationTime.toISOString() : "") + "&";
        if (creatorUserId === null)
            throw new Error("The parameter 'creatorUserId' cannot be null.");
        else if (creatorUserId !== undefined)
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPayslipAllowances(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayslipAllowances(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeePaySlipModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeePaySlipModelDto>;
        }));
    }

    protected processGetPayslipAllowances(response: HttpResponseBase): Observable<EmployeePaySlipModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EmployeePaySlipModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeePaySlipModelDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @param employeeId (optional) 
     * @return Success
     */
    getEmployeePaySlipModelWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined, employeeId: number | undefined): Observable<EmployeePaySlipModelPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetEmployeePaySlipModelWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEmployeePaySlipModelWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeePaySlipModelWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeePaySlipModelPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeePaySlipModelPagedResultDto>;
        }));
    }

    protected processGetEmployeePaySlipModelWithInput(response: HttpResponseBase): Observable<EmployeePaySlipModelPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EmployeePaySlipModelPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeePaySlipModelPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateEmployeePaySlipModel(id: number | undefined, body: EmployeePaySlipModelDto | undefined): Observable<EmployeePaySlipModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/UpdateEmployeePaySlipModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateEmployeePaySlipModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEmployeePaySlipModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeePaySlipModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeePaySlipModelDto>;
        }));
    }

    protected processUpdateEmployeePaySlipModel(response: HttpResponseBase): Observable<EmployeePaySlipModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EmployeePaySlipModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeePaySlipModelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteEmployeePaySlipModel(id: number | undefined): Observable<EmployeePaySlipModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/DeleteEmployeePaySlipModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteEmployeePaySlipModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEmployeePaySlipModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeePaySlipModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeePaySlipModelDto>;
        }));
    }

    protected processDeleteEmployeePaySlipModel(response: HttpResponseBase): Observable<EmployeePaySlipModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EmployeePaySlipModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeePaySlipModelDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createHolidayModel(body: HolidayModelDto | undefined): Observable<HolidayModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/CreateHolidayModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateHolidayModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateHolidayModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HolidayModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HolidayModelDto>;
        }));
    }

    protected processCreateHolidayModel(response: HttpResponseBase): Observable<HolidayModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = HolidayModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HolidayModelDto>(null as any);
    }

    /**
     * @param year (optional) 
     * @return Success
     */
    addMalaysiaHoliday(year: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/AddMalaysiaHoliday?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAddMalaysiaHoliday(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMalaysiaHoliday(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddMalaysiaHoliday(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getHolidayModel(tenantId: number | undefined): Observable<HolidayModel[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetHolidayModel?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetHolidayModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHolidayModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HolidayModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HolidayModel[]>;
        }));
    }

    protected processGetHolidayModel(response: HttpResponseBase): Observable<HolidayModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(HolidayModel.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HolidayModel[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param year (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getHolidayModelWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, year: number | undefined, tenantId: number | undefined): Observable<HolidayModelDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetHolidayModelWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetHolidayModelWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHolidayModelWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HolidayModelDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HolidayModelDtoPagedResultDto>;
        }));
    }

    protected processGetHolidayModelWithInput(response: HttpResponseBase): Observable<HolidayModelDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = HolidayModelDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HolidayModelDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateHolidayModel(id: number | undefined, body: HolidayModelDto | undefined): Observable<HolidayModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/UpdateHolidayModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateHolidayModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateHolidayModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HolidayModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HolidayModelDto>;
        }));
    }

    protected processUpdateHolidayModel(response: HttpResponseBase): Observable<HolidayModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = HolidayModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HolidayModelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteHolidayModel(id: number | undefined): Observable<HolidayModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/DeleteHolidayModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteHolidayModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteHolidayModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HolidayModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HolidayModelDto>;
        }));
    }

    protected processDeleteHolidayModel(response: HttpResponseBase): Observable<HolidayModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = HolidayModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HolidayModelDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createLeaveApplicationModel(body: LeaveApplicationModelDto | undefined): Observable<LeaveApplicationModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/CreateLeaveApplicationModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateLeaveApplicationModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLeaveApplicationModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveApplicationModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveApplicationModelDto>;
        }));
    }

    protected processCreateLeaveApplicationModel(response: HttpResponseBase): Observable<LeaveApplicationModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveApplicationModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveApplicationModelDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getLeaveApplicationModel(tenantId: number | undefined): Observable<LeaveApplicationModel[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetLeaveApplicationModel?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLeaveApplicationModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveApplicationModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveApplicationModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveApplicationModel[]>;
        }));
    }

    protected processGetLeaveApplicationModel(response: HttpResponseBase): Observable<LeaveApplicationModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(LeaveApplicationModel.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveApplicationModel[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getLeaveApplicationModelWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<LeaveApplicationModelDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetLeaveApplicationModelWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLeaveApplicationModelWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveApplicationModelWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveApplicationModelDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveApplicationModelDtoPagedResultDto>;
        }));
    }

    protected processGetLeaveApplicationModelWithInput(response: HttpResponseBase): Observable<LeaveApplicationModelDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveApplicationModelDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveApplicationModelDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateLeaveApplicationModel(id: number | undefined, body: LeaveApplicationModelDto | undefined): Observable<LeaveApplicationModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/UpdateLeaveApplicationModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateLeaveApplicationModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLeaveApplicationModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveApplicationModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveApplicationModelDto>;
        }));
    }

    protected processUpdateLeaveApplicationModel(response: HttpResponseBase): Observable<LeaveApplicationModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveApplicationModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveApplicationModelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteLeaveApplicationModel(id: number | undefined): Observable<LeaveApplicationModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/DeleteLeaveApplicationModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteLeaveApplicationModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLeaveApplicationModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveApplicationModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveApplicationModelDto>;
        }));
    }

    protected processDeleteLeaveApplicationModel(response: HttpResponseBase): Observable<LeaveApplicationModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveApplicationModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveApplicationModelDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createLeaveEmployeeModel(body: LeaveEmployeeModelDto | undefined): Observable<LeaveEmployeeModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/CreateLeaveEmployeeModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateLeaveEmployeeModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLeaveEmployeeModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveEmployeeModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveEmployeeModelDto>;
        }));
    }

    protected processCreateLeaveEmployeeModel(response: HttpResponseBase): Observable<LeaveEmployeeModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveEmployeeModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveEmployeeModelDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getLeaveEmployeeModel(tenantId: number | undefined): Observable<LeaveEmployeeModel[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetLeaveEmployeeModel?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLeaveEmployeeModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveEmployeeModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveEmployeeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveEmployeeModel[]>;
        }));
    }

    protected processGetLeaveEmployeeModel(response: HttpResponseBase): Observable<LeaveEmployeeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(LeaveEmployeeModel.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveEmployeeModel[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getLeaveEmployeeModelWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<LeaveEmployeeModelPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetLeaveEmployeeModelWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLeaveEmployeeModelWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveEmployeeModelWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveEmployeeModelPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveEmployeeModelPagedResultDto>;
        }));
    }

    protected processGetLeaveEmployeeModelWithInput(response: HttpResponseBase): Observable<LeaveEmployeeModelPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveEmployeeModelPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveEmployeeModelPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateLeaveEmployeeModel(id: number | undefined, body: LeaveEmployeeModelDto | undefined): Observable<LeaveEmployeeModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/UpdateLeaveEmployeeModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateLeaveEmployeeModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLeaveEmployeeModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveEmployeeModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveEmployeeModelDto>;
        }));
    }

    protected processUpdateLeaveEmployeeModel(response: HttpResponseBase): Observable<LeaveEmployeeModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveEmployeeModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveEmployeeModelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteLeaveEmployeeModel(id: number | undefined): Observable<LeaveEmployeeModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/DeleteLeaveEmployeeModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteLeaveEmployeeModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLeaveEmployeeModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveEmployeeModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveEmployeeModelDto>;
        }));
    }

    protected processDeleteLeaveEmployeeModel(response: HttpResponseBase): Observable<LeaveEmployeeModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveEmployeeModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveEmployeeModelDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createLeaveGroupModel(body: LeaveGroupModelDto | undefined): Observable<LeaveGroupModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/CreateLeaveGroupModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateLeaveGroupModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLeaveGroupModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveGroupModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveGroupModelDto>;
        }));
    }

    protected processCreateLeaveGroupModel(response: HttpResponseBase): Observable<LeaveGroupModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveGroupModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveGroupModelDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getLeaveGroupModel(tenantId: number | undefined): Observable<LeaveGroupModel[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetLeaveGroupModel?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLeaveGroupModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveGroupModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveGroupModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveGroupModel[]>;
        }));
    }

    protected processGetLeaveGroupModel(response: HttpResponseBase): Observable<LeaveGroupModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(LeaveGroupModel.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveGroupModel[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getLeaveGroupModelWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<LeaveGroupModelPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetLeaveGroupModelWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLeaveGroupModelWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveGroupModelWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveGroupModelPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveGroupModelPagedResultDto>;
        }));
    }

    protected processGetLeaveGroupModelWithInput(response: HttpResponseBase): Observable<LeaveGroupModelPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveGroupModelPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveGroupModelPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    udateLeaveGroupModel(id: number | undefined, body: LeaveGroupModelDto | undefined): Observable<LeaveGroupModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/UdateLeaveGroupModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUdateLeaveGroupModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUdateLeaveGroupModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveGroupModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveGroupModelDto>;
        }));
    }

    protected processUdateLeaveGroupModel(response: HttpResponseBase): Observable<LeaveGroupModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveGroupModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveGroupModelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteLeaveGroupModel(id: number | undefined): Observable<LeaveGroupModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/DeleteLeaveGroupModel?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteLeaveGroupModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLeaveGroupModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveGroupModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveGroupModelDto>;
        }));
    }

    protected processDeleteLeaveGroupModel(response: HttpResponseBase): Observable<LeaveGroupModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveGroupModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveGroupModelDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createLeaveTypeModel(body: LeaveTypeModelDto | undefined): Observable<LeaveTypeModelDto> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/CreateLeaveTypeModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateLeaveTypeModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLeaveTypeModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveTypeModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveTypeModelDto>;
        }));
    }

    protected processCreateLeaveTypeModel(response: HttpResponseBase): Observable<LeaveTypeModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LeaveTypeModelDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveTypeModelDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getLeaveTypeModel(tenantId: number | undefined): Observable<LeaveTypeModel[]> {
        let url_ = this.baseUrl + "/api/services/app/Hrm/GetLeaveTypeModel?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLeaveTypeModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLeaveTypeModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LeaveTypeModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LeaveTypeModel[]>;
        }));
    }

    protected processGetLeaveTypeModel(response: HttpResponseBase): Observable<LeaveTypeModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(LeaveTypeModel.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaveTypeModel[]>(null as any);
    }
}

@Injectable()
export class InventoryCategoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getProductInventoryCategoryWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<InventoryCategoryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/getProductInventoryCategoryWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductInventoryCategoryWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductInventoryCategoryWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryCategoryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryCategoryDtoPagedResultDto>;
        }));
    }

    protected processGetProductInventoryCategoryWithInput(response: HttpResponseBase): Observable<InventoryCategoryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryCategoryDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryCategoryDtoPagedResultDto>(null as any);
    }

    /**
     * @param materialId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getMaterialForInventory(materialId: string | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<MaterialInventoryDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/GetMaterialForInventory?";
        if (materialId === null)
            throw new Error("The parameter 'materialId' cannot be null.");
        else if (materialId !== undefined)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMaterialForInventory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterialForInventory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialInventoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialInventoryDto>;
        }));
    }

    protected processGetMaterialForInventory(response: HttpResponseBase): Observable<MaterialInventoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MaterialInventoryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialInventoryDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getProductForInventory(productId: string | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<ProductIventoryDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/GetProductForInventory?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductForInventory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductForInventory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductIventoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductIventoryDto>;
        }));
    }

    protected processGetProductForInventory(response: HttpResponseBase): Observable<ProductIventoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductIventoryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductIventoryDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getProductForDashboard(productId: string | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<ProductIventoryDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/GetProductForDashboard?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductForDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductForDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductIventoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductIventoryDto>;
        }));
    }

    protected processGetProductForDashboard(response: HttpResponseBase): Observable<ProductIventoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductIventoryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductIventoryDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param categoryId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getProductInventoryCategoryByIdWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, categoryId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<InventoryCategoryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/getProductInventoryCategoryByIdWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductInventoryCategoryByIdWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductInventoryCategoryByIdWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryCategoryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryCategoryDtoPagedResultDto>;
        }));
    }

    protected processGetProductInventoryCategoryByIdWithInput(response: HttpResponseBase): Observable<InventoryCategoryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryCategoryDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryCategoryDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    fixInventory(): Observable<InventoryCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/FixInventory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processFixInventory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFixInventory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryCategoryDto>;
        }));
    }

    protected processFixInventory(response: HttpResponseBase): Observable<InventoryCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryCategoryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryCategoryDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getProductInventoryCategoryByTenantId(tenantId: number | undefined): Observable<InventoryCategory[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/getProductInventoryCategoryByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductInventoryCategoryByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductInventoryCategoryByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryCategory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryCategory[]>;
        }));
    }

    protected processGetProductInventoryCategoryByTenantId(response: HttpResponseBase): Observable<InventoryCategory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(InventoryCategory.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryCategory[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getMaterialInventoryCategoryWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<InventoryCategoryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/getMaterialInventoryCategoryWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMaterialInventoryCategoryWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterialInventoryCategoryWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryCategoryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryCategoryDtoPagedResultDto>;
        }));
    }

    protected processGetMaterialInventoryCategoryWithInput(response: HttpResponseBase): Observable<InventoryCategoryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryCategoryDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryCategoryDtoPagedResultDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param categoryId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getMaterialInventoryCategoryByIdWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, categoryId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<InventoryCategoryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/getMaterialInventoryCategoryByIdWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMaterialInventoryCategoryByIdWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterialInventoryCategoryByIdWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryCategoryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryCategoryDtoPagedResultDto>;
        }));
    }

    protected processGetMaterialInventoryCategoryByIdWithInput(response: HttpResponseBase): Observable<InventoryCategoryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryCategoryDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryCategoryDtoPagedResultDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getMaterialInventoryCategoryByTenantId(tenantId: number | undefined): Observable<InventoryCategory[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/getMaterialInventoryCategoryByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMaterialInventoryCategoryByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterialInventoryCategoryByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryCategory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryCategory[]>;
        }));
    }

    protected processGetMaterialInventoryCategoryByTenantId(response: HttpResponseBase): Observable<InventoryCategory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(InventoryCategory.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryCategory[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getInventoryCategoryByTenantId(tenantId: number | undefined): Observable<InventoryCategoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/GetInventoryCategoryByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetInventoryCategoryByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInventoryCategoryByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryCategoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryCategoryDto[]>;
        }));
    }

    protected processGetInventoryCategoryByTenantId(response: HttpResponseBase): Observable<InventoryCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(InventoryCategoryDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryCategoryDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getInventoryCategoryById(id: number | undefined): Observable<InventoryCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/GetInventoryCategoryById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetInventoryCategoryById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInventoryCategoryById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryCategoryDto>;
        }));
    }

    protected processGetInventoryCategoryById(response: HttpResponseBase): Observable<InventoryCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryCategoryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryCategoryDto>(null as any);
    }

    /**
     * @param name (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getInventoryCategoryByName(name: string | undefined, tenantId: number | undefined): Observable<InventoryCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/GetInventoryCategoryByName?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetInventoryCategoryByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInventoryCategoryByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryCategoryDto>;
        }));
    }

    protected processGetInventoryCategoryByName(response: HttpResponseBase): Observable<InventoryCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryCategoryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryCategoryDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getInventoryCategories(tenantId: number | undefined): Observable<InventoryCategoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/GetInventoryCategories?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetInventoryCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInventoryCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryCategoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryCategoryDto[]>;
        }));
    }

    protected processGetInventoryCategories(response: HttpResponseBase): Observable<InventoryCategoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(InventoryCategoryDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryCategoryDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getInventoryDataTenantId(tenantId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<InventoryItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/GetInventoryDataTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetInventoryDataTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInventoryDataTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryItemDto[]>;
        }));
    }

    protected processGetInventoryDataTenantId(response: HttpResponseBase): Observable<InventoryItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(InventoryItemDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    checkMinLevel(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/CheckMinLevel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckMinLevel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckMinLevel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckMinLevel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendReminderToEmail(body: CompanyProfile | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/SendReminderToEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendReminderToEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendReminderToEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendReminderToEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    checkInventoryUsage(id: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/CheckInventoryUsage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckInventoryUsage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckInventoryUsage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckInventoryUsage(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getAdjustmentItemForInventoryDashboard(tenantId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<WriteOffNoteItem[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/GetAdjustmentItemForInventoryDashboard?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAdjustmentItemForInventoryDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdjustmentItemForInventoryDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteItem[]>;
        }));
    }

    protected processGetAdjustmentItemForInventoryDashboard(response: HttpResponseBase): Observable<WriteOffNoteItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(WriteOffNoteItem.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteItem[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getSalesForInventoryDashboard(tenantId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<BillItem[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/GetSalesForInventoryDashboard?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSalesForInventoryDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesForInventoryDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillItem[]>;
        }));
    }

    protected processGetSalesForInventoryDashboard(response: HttpResponseBase): Observable<BillItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(BillItem.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillItem[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getReturnsForInventoryDashboard(tenantId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<CreditNote[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/GetReturnsForInventoryDashboard?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetReturnsForInventoryDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReturnsForInventoryDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreditNote[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreditNote[]>;
        }));
    }

    protected processGetReturnsForInventoryDashboard(response: HttpResponseBase): Observable<CreditNote[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(CreditNote.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreditNote[]>(null as any);
    }

    /**
     * @param itemId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getVendorInvoiceItemByItemId(itemId: string | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<VendorInvoiceItem[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/GetVendorInvoiceItemByItemId?";
        if (itemId === null)
            throw new Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVendorInvoiceItemByItemId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorInvoiceItemByItemId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItem[]>;
        }));
    }

    protected processGetVendorInvoiceItemByItemId(response: HttpResponseBase): Observable<VendorInvoiceItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(VendorInvoiceItem.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItem[]>(null as any);
    }

    /**
     * @param itemId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getBillItemByItemId(itemId: string | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<BillItem[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/GetBillItemByItemId?";
        if (itemId === null)
            throw new Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBillItemByItemId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillItemByItemId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillItem[]>;
        }));
    }

    protected processGetBillItemByItemId(response: HttpResponseBase): Observable<BillItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(BillItem.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillItem[]>(null as any);
    }

    /**
     * @param itemId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getCreditBillItemByItemId(itemId: string | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<BillItem[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/GetCreditBillItemByItemId?";
        if (itemId === null)
            throw new Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCreditBillItemByItemId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreditBillItemByItemId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillItem[]>;
        }));
    }

    protected processGetCreditBillItemByItemId(response: HttpResponseBase): Observable<BillItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(BillItem.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillItem[]>(null as any);
    }

    /**
     * @param itemId (optional) 
     * @param type (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param status (optional) 
     * @return Success
     */
    getWriteOffNoteItemByItemId(itemId: string | undefined, type: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, status: number | undefined): Observable<WriteOffNoteItem[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/GetWriteOffNoteItemByItemId?";
        if (itemId === null)
            throw new Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetWriteOffNoteItemByItemId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWriteOffNoteItemByItemId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteItem[]>;
        }));
    }

    protected processGetWriteOffNoteItemByItemId(response: HttpResponseBase): Observable<WriteOffNoteItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(WriteOffNoteItem.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteItem[]>(null as any);
    }

    /**
     * @param itemId (optional) 
     * @param type (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param status (optional) 
     * @return Success
     */
    getWriteOffNoteItemByProductId(itemId: string | undefined, type: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, status: number | undefined): Observable<WriteOffNoteItem[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/GetWriteOffNoteItemByProductId?";
        if (itemId === null)
            throw new Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetWriteOffNoteItemByProductId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWriteOffNoteItemByProductId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteItem[]>;
        }));
    }

    protected processGetWriteOffNoteItemByProductId(response: HttpResponseBase): Observable<WriteOffNoteItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(WriteOffNoteItem.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteItem[]>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param migrationDate (optional) 
     * @param code (optional) 
     * @param name (optional) 
     * @param date (optional) 
     * @return Success
     */
    checkIsMigrationAccount(startDate: moment.Moment | undefined, migrationDate: moment.Moment | undefined, code: string | undefined, name: string | undefined, date: moment.Moment | undefined): Observable<AccountsChartDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/CheckIsMigrationAccount?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (migrationDate === null)
            throw new Error("The parameter 'migrationDate' cannot be null.");
        else if (migrationDate !== undefined)
            url_ += "migrationDate=" + encodeURIComponent(migrationDate ? "" + migrationDate.toISOString() : "") + "&";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckIsMigrationAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIsMigrationAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountsChartDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountsChartDto>;
        }));
    }

    protected processCheckIsMigrationAccount(response: HttpResponseBase): Observable<AccountsChartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AccountsChartDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountsChartDto>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getInventoryForLedger(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<LedgerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/GetInventoryForLedger?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetInventoryForLedger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInventoryForLedger(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LedgerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LedgerDto[]>;
        }));
    }

    protected processGetInventoryForLedger(response: HttpResponseBase): Observable<LedgerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(LedgerDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LedgerDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<InventoryCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryCategoryDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InventoryCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryCategoryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryCategoryDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<InventoryCategoryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryCategoryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryCategoryDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<InventoryCategoryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryCategoryDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryCategoryDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: InventoryCategoryDto | undefined): Observable<InventoryCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryCategoryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<InventoryCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryCategoryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryCategoryDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: InventoryCategoryDto | undefined): Observable<InventoryCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryCategoryDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<InventoryCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryCategoryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryCategoryDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InventoryCategory/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class InventoryLocationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getInventoryLocationsByItemId(id: string | undefined): Observable<InventoryLocation[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryLocation/getInventoryLocationsByItemId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetInventoryLocationsByItemId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInventoryLocationsByItemId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryLocation[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryLocation[]>;
        }));
    }

    protected processGetInventoryLocationsByItemId(response: HttpResponseBase): Observable<InventoryLocation[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(InventoryLocation.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryLocation[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<InventoryLocationDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryLocation/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryLocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryLocationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InventoryLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryLocationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryLocationDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<InventoryLocationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryLocation/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryLocationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryLocationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<InventoryLocationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryLocationDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryLocationDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: InventoryLocationDto | undefined): Observable<InventoryLocationDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryLocation/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryLocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryLocationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<InventoryLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryLocationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryLocationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: InventoryLocationDto | undefined): Observable<InventoryLocationDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryLocation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryLocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryLocationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<InventoryLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryLocationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryLocationDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InventoryLocation/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class InventoryManualEntryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEntryFromFrontend(body: InventoryManualEntryDto | undefined): Observable<InventoryManualEntryDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryManualEntry/CreateEntryFromFrontend";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateEntryFromFrontend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEntryFromFrontend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryManualEntryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryManualEntryDto>;
        }));
    }

    protected processCreateEntryFromFrontend(response: HttpResponseBase): Observable<InventoryManualEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryManualEntryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryManualEntryDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<InventoryManualEntryDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryManualEntry/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryManualEntryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryManualEntryDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InventoryManualEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryManualEntryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryManualEntryDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<InventoryManualEntryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryManualEntry/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryManualEntryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryManualEntryDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<InventoryManualEntryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryManualEntryDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryManualEntryDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: InventoryManualEntryDto | undefined): Observable<InventoryManualEntryDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryManualEntry/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryManualEntryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryManualEntryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<InventoryManualEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryManualEntryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryManualEntryDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: InventoryManualEntryDto | undefined): Observable<InventoryManualEntryDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryManualEntry/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryManualEntryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryManualEntryDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<InventoryManualEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryManualEntryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryManualEntryDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InventoryManualEntry/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class InventoryMaterialOnShelfServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param shelfId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getMaterialOnShelfWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, shelfId: number | undefined, tenantId: number | undefined): Observable<InventoryMaterialOnShelfDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryMaterialOnShelf/GetMaterialOnShelfWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMaterialOnShelfWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterialOnShelfWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryMaterialOnShelfDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryMaterialOnShelfDtoPagedResultDto>;
        }));
    }

    protected processGetMaterialOnShelfWithInput(response: HttpResponseBase): Observable<InventoryMaterialOnShelfDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryMaterialOnShelfDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryMaterialOnShelfDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMaterialLocationsByItemId(id: string | undefined): Observable<InventoryMaterialOnShelf[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryMaterialOnShelf/getMaterialLocationsByItemId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMaterialLocationsByItemId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterialLocationsByItemId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryMaterialOnShelf[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryMaterialOnShelf[]>;
        }));
    }

    protected processGetMaterialLocationsByItemId(response: HttpResponseBase): Observable<InventoryMaterialOnShelf[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(InventoryMaterialOnShelf.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryMaterialOnShelf[]>(null as any);
    }

    /**
     * @param isEmptyIncluded (optional) 
     * @return Success
     */
    getMaterialShelfByTenantId(isEmptyIncluded: boolean | undefined): Observable<InventoryMaterialOnShelfDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryMaterialOnShelf/GetMaterialShelfByTenantId?";
        if (isEmptyIncluded === null)
            throw new Error("The parameter 'isEmptyIncluded' cannot be null.");
        else if (isEmptyIncluded !== undefined)
            url_ += "IsEmptyIncluded=" + encodeURIComponent("" + isEmptyIncluded) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMaterialShelfByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterialShelfByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryMaterialOnShelfDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryMaterialOnShelfDto[]>;
        }));
    }

    protected processGetMaterialShelfByTenantId(response: HttpResponseBase): Observable<InventoryMaterialOnShelfDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(InventoryMaterialOnShelfDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryMaterialOnShelfDto[]>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @return Success
     */
    getMaterialByWarehouseId(warehouseId: number | undefined): Observable<InventoryMaterialOnShelf[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryMaterialOnShelf/getMaterialByWarehouseId?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMaterialByWarehouseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterialByWarehouseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryMaterialOnShelf[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryMaterialOnShelf[]>;
        }));
    }

    protected processGetMaterialByWarehouseId(response: HttpResponseBase): Observable<InventoryMaterialOnShelf[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(InventoryMaterialOnShelf.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryMaterialOnShelf[]>(null as any);
    }

    /**
     * @param materialId (optional) 
     * @param isEmptyIncluded (optional) 
     * @return Success
     */
    getMaterialShelfByMaterialId(materialId: string | undefined, isEmptyIncluded: boolean | undefined): Observable<InventoryMaterialOnShelfDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryMaterialOnShelf/GetMaterialShelfByMaterialId?";
        if (materialId === null)
            throw new Error("The parameter 'materialId' cannot be null.");
        else if (materialId !== undefined)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&";
        if (isEmptyIncluded === null)
            throw new Error("The parameter 'isEmptyIncluded' cannot be null.");
        else if (isEmptyIncluded !== undefined)
            url_ += "IsEmptyIncluded=" + encodeURIComponent("" + isEmptyIncluded) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMaterialShelfByMaterialId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterialShelfByMaterialId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryMaterialOnShelfDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryMaterialOnShelfDto[]>;
        }));
    }

    protected processGetMaterialShelfByMaterialId(response: HttpResponseBase): Observable<InventoryMaterialOnShelfDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(InventoryMaterialOnShelfDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryMaterialOnShelfDto[]>(null as any);
    }

    /**
     * @param materialId (optional) 
     * @param shelfId (optional) 
     * @return Success
     */
    getQuantityFromMaterialIdAndShelfId(materialId: string | undefined, shelfId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/InventoryMaterialOnShelf/GetQuantityFromMaterialIdAndShelfId?";
        if (materialId === null)
            throw new Error("The parameter 'materialId' cannot be null.");
        else if (materialId !== undefined)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetQuantityFromMaterialIdAndShelfId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuantityFromMaterialIdAndShelfId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetQuantityFromMaterialIdAndShelfId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<InventoryMaterialOnShelfDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryMaterialOnShelf/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryMaterialOnShelfDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryMaterialOnShelfDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InventoryMaterialOnShelfDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryMaterialOnShelfDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryMaterialOnShelfDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<InventoryMaterialOnShelfDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryMaterialOnShelf/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryMaterialOnShelfDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryMaterialOnShelfDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<InventoryMaterialOnShelfDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryMaterialOnShelfDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryMaterialOnShelfDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: InventoryMaterialOnShelfDto | undefined): Observable<InventoryMaterialOnShelfDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryMaterialOnShelf/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryMaterialOnShelfDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryMaterialOnShelfDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<InventoryMaterialOnShelfDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryMaterialOnShelfDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryMaterialOnShelfDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: InventoryMaterialOnShelfDto | undefined): Observable<InventoryMaterialOnShelfDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryMaterialOnShelf/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryMaterialOnShelfDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryMaterialOnShelfDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<InventoryMaterialOnShelfDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryMaterialOnShelfDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryMaterialOnShelfDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InventoryMaterialOnShelf/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class InventoryProductOnShelfServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param shelfId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getProductOnShelfWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, shelfId: number | undefined, tenantId: number | undefined): Observable<InventoryProductOnShelfDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryProductOnShelf/GetProductOnShelfWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductOnShelfWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductOnShelfWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryProductOnShelfDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryProductOnShelfDtoPagedResultDto>;
        }));
    }

    protected processGetProductOnShelfWithInput(response: HttpResponseBase): Observable<InventoryProductOnShelfDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryProductOnShelfDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryProductOnShelfDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProductLocationsByItemId(id: string | undefined): Observable<InventoryProductOnShelf[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryProductOnShelf/getProductLocationsByItemId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductLocationsByItemId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductLocationsByItemId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryProductOnShelf[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryProductOnShelf[]>;
        }));
    }

    protected processGetProductLocationsByItemId(response: HttpResponseBase): Observable<InventoryProductOnShelf[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(InventoryProductOnShelf.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryProductOnShelf[]>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @return Success
     */
    getProductByWarehouseId(warehouseId: number | undefined): Observable<InventoryProductOnShelf[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryProductOnShelf/getProductByWarehouseId?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductByWarehouseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductByWarehouseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryProductOnShelf[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryProductOnShelf[]>;
        }));
    }

    protected processGetProductByWarehouseId(response: HttpResponseBase): Observable<InventoryProductOnShelf[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(InventoryProductOnShelf.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryProductOnShelf[]>(null as any);
    }

    /**
     * @param isEmptyIncluded (optional) 
     * @return Success
     */
    getProductShelfByTenantId(isEmptyIncluded: boolean | undefined): Observable<InventoryProductOnShelfDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryProductOnShelf/GetProductShelfByTenantId?";
        if (isEmptyIncluded === null)
            throw new Error("The parameter 'isEmptyIncluded' cannot be null.");
        else if (isEmptyIncluded !== undefined)
            url_ += "IsEmptyIncluded=" + encodeURIComponent("" + isEmptyIncluded) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductShelfByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductShelfByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryProductOnShelfDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryProductOnShelfDto[]>;
        }));
    }

    protected processGetProductShelfByTenantId(response: HttpResponseBase): Observable<InventoryProductOnShelfDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(InventoryProductOnShelfDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryProductOnShelfDto[]>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param isEmptyIncluded (optional) 
     * @return Success
     */
    getProductShelfByProductId(productId: string | undefined, isEmptyIncluded: boolean | undefined): Observable<InventoryProductOnShelfDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryProductOnShelf/GetProductShelfByProductId?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (isEmptyIncluded === null)
            throw new Error("The parameter 'isEmptyIncluded' cannot be null.");
        else if (isEmptyIncluded !== undefined)
            url_ += "IsEmptyIncluded=" + encodeURIComponent("" + isEmptyIncluded) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductShelfByProductId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductShelfByProductId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryProductOnShelfDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryProductOnShelfDto[]>;
        }));
    }

    protected processGetProductShelfByProductId(response: HttpResponseBase): Observable<InventoryProductOnShelfDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(InventoryProductOnShelfDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryProductOnShelfDto[]>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param shelfId (optional) 
     * @return Success
     */
    getQuantityFromProductIdAndShelfId(productId: string | undefined, shelfId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/InventoryProductOnShelf/GetQuantityFromProductIdAndShelfId?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (shelfId === null)
            throw new Error("The parameter 'shelfId' cannot be null.");
        else if (shelfId !== undefined)
            url_ += "shelfId=" + encodeURIComponent("" + shelfId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetQuantityFromProductIdAndShelfId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuantityFromProductIdAndShelfId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetQuantityFromProductIdAndShelfId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<InventoryProductOnShelfDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryProductOnShelf/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryProductOnShelfDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryProductOnShelfDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InventoryProductOnShelfDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryProductOnShelfDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryProductOnShelfDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<InventoryProductOnShelfDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryProductOnShelf/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryProductOnShelfDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryProductOnShelfDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<InventoryProductOnShelfDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryProductOnShelfDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryProductOnShelfDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: InventoryProductOnShelfDto | undefined): Observable<InventoryProductOnShelfDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryProductOnShelf/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryProductOnShelfDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryProductOnShelfDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<InventoryProductOnShelfDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryProductOnShelfDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryProductOnShelfDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: InventoryProductOnShelfDto | undefined): Observable<InventoryProductOnShelfDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryProductOnShelf/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryProductOnShelfDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryProductOnShelfDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<InventoryProductOnShelfDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryProductOnShelfDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryProductOnShelfDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InventoryProductOnShelf/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class InventoryShelfServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param warehouseId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getShelfByWarehouseIdWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, warehouseId: number | undefined, tenantId: number | undefined): Observable<InventoryShelfDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryShelf/GetShelfByWarehouseIdWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetShelfByWarehouseIdWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShelfByWarehouseIdWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryShelfDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryShelfDtoPagedResultDto>;
        }));
    }

    protected processGetShelfByWarehouseIdWithInput(response: HttpResponseBase): Observable<InventoryShelfDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryShelfDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryShelfDtoPagedResultDto>(null as any);
    }

    /**
     * @param warehouseId (optional) 
     * @return Success
     */
    getShelfByWarehouseId(warehouseId: number | undefined): Observable<InventoryShelfDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryShelf/GetShelfByWarehouseId?";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetShelfByWarehouseId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShelfByWarehouseId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryShelfDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryShelfDto[]>;
        }));
    }

    protected processGetShelfByWarehouseId(response: HttpResponseBase): Observable<InventoryShelfDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(InventoryShelfDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryShelfDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<InventoryShelfDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryShelf/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryShelfDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryShelfDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InventoryShelfDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryShelfDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryShelfDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<InventoryShelfDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryShelf/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryShelfDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryShelfDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<InventoryShelfDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryShelfDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryShelfDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: InventoryShelfDto | undefined): Observable<InventoryShelfDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryShelf/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryShelfDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryShelfDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<InventoryShelfDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryShelfDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryShelfDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: InventoryShelfDto | undefined): Observable<InventoryShelfDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryShelf/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryShelfDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryShelfDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<InventoryShelfDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryShelfDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryShelfDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InventoryShelf/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class InventoryWarehouseServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getWarehouseIncludingShelfByTenantId(tenantId: number | undefined): Observable<InventoryWarehouseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryWarehouse/GetWarehouseIncludingShelfByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetWarehouseIncludingShelfByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWarehouseIncludingShelfByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryWarehouseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryWarehouseDto[]>;
        }));
    }

    protected processGetWarehouseIncludingShelfByTenantId(response: HttpResponseBase): Observable<InventoryWarehouseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(InventoryWarehouseDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryWarehouseDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getWarehouseByTenantId(tenantId: number | undefined): Observable<InventoryWarehouseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InventoryWarehouse/GetWarehouseByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetWarehouseByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWarehouseByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryWarehouseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryWarehouseDto[]>;
        }));
    }

    protected processGetWarehouseByTenantId(response: HttpResponseBase): Observable<InventoryWarehouseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(InventoryWarehouseDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryWarehouseDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getWarehouseWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<InventoryWarehouseDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryWarehouse/GetWarehouseWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetWarehouseWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWarehouseWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryWarehouseDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryWarehouseDtoPagedResultDto>;
        }));
    }

    protected processGetWarehouseWithInput(response: HttpResponseBase): Observable<InventoryWarehouseDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryWarehouseDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryWarehouseDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    checkWarehouse(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InventoryWarehouse/CheckWarehouse";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckWarehouse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckWarehouse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckWarehouse(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<InventoryWarehouseDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryWarehouse/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryWarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryWarehouseDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InventoryWarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryWarehouseDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryWarehouseDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<InventoryWarehouseDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryWarehouse/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryWarehouseDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryWarehouseDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<InventoryWarehouseDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryWarehouseDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryWarehouseDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: InventoryWarehouseDto | undefined): Observable<InventoryWarehouseDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryWarehouse/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryWarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryWarehouseDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<InventoryWarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryWarehouseDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryWarehouseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: InventoryWarehouseDto | undefined): Observable<InventoryWarehouseDto> {
        let url_ = this.baseUrl + "/api/services/app/InventoryWarehouse/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InventoryWarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InventoryWarehouseDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<InventoryWarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InventoryWarehouseDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InventoryWarehouseDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InventoryWarehouse/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class JournalServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createJournal(body: JournalsDto | undefined): Observable<JournalsDto> {
        let url_ = this.baseUrl + "/api/services/app/Journal/CreateJournal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateJournal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateJournal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JournalsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JournalsDto>;
        }));
    }

    protected processCreateJournal(response: HttpResponseBase): Observable<JournalsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = JournalsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JournalsDto>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @param status (optional) 
     * @return Success
     */
    getJournalsForApproval(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined, status: string | undefined): Observable<JournalsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Journal/GetJournalsForApproval?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetJournalsForApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJournalsForApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JournalsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JournalsDto[]>;
        }));
    }

    protected processGetJournalsForApproval(response: HttpResponseBase): Observable<JournalsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(JournalsDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JournalsDto[]>(null as any);
    }

    /**
     * @param jvNo (optional) 
     * @return Success
     */
    getJournalItemsByJvNo(jvNo: string | undefined): Observable<JournalsDto> {
        let url_ = this.baseUrl + "/api/services/app/Journal/GetJournalItemsByJvNo?";
        if (jvNo === null)
            throw new Error("The parameter 'jvNo' cannot be null.");
        else if (jvNo !== undefined)
            url_ += "jvNo=" + encodeURIComponent("" + jvNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetJournalItemsByJvNo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJournalItemsByJvNo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JournalsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JournalsDto>;
        }));
    }

    protected processGetJournalItemsByJvNo(response: HttpResponseBase): Observable<JournalsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = JournalsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JournalsDto>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @param status (optional) 
     * @return Success
     */
    getJournals(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined, status: string | undefined): Observable<Journals[]> {
        let url_ = this.baseUrl + "/api/services/app/Journal/GetJournals?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetJournals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJournals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Journals[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Journals[]>;
        }));
    }

    protected processGetJournals(response: HttpResponseBase): Observable<Journals[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(Journals.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Journals[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getJournalsWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<JournalsPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Journal/GetJournalsWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetJournalsWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJournalsWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JournalsPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JournalsPagedResultDto>;
        }));
    }

    protected processGetJournalsWithInput(response: HttpResponseBase): Observable<JournalsPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = JournalsPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JournalsPagedResultDto>(null as any);
    }

    /**
     * @param jvNo (optional) 
     * @return Success
     */
    getJournalsByJvNo(jvNo: string | undefined): Observable<Journals[]> {
        let url_ = this.baseUrl + "/api/services/app/Journal/GetJournalsByJvNo?";
        if (jvNo === null)
            throw new Error("The parameter 'jvNo' cannot be null.");
        else if (jvNo !== undefined)
            url_ += "jvNo=" + encodeURIComponent("" + jvNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetJournalsByJvNo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJournalsByJvNo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Journals[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Journals[]>;
        }));
    }

    protected processGetJournalsByJvNo(response: HttpResponseBase): Observable<Journals[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(Journals.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Journals[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateJournal(body: JournalsDto | undefined): Observable<JournalsDto> {
        let url_ = this.baseUrl + "/api/services/app/Journal/UpdateJournal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateJournal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJournal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JournalsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JournalsDto>;
        }));
    }

    protected processUpdateJournal(response: HttpResponseBase): Observable<JournalsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = JournalsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JournalsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAllJournal(body: JournalsDto | undefined): Observable<JournalsDto> {
        let url_ = this.baseUrl + "/api/services/app/Journal/UpdateAllJournal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateAllJournal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllJournal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JournalsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JournalsDto>;
        }));
    }

    protected processUpdateAllJournal(response: HttpResponseBase): Observable<JournalsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = JournalsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JournalsDto>(null as any);
    }

    /**
     * @param jvNo (optional) 
     * @return Success
     */
    deleteJournal(jvNo: string | undefined): Observable<JournalsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Journal/DeleteJournal?";
        if (jvNo === null)
            throw new Error("The parameter 'jvNo' cannot be null.");
        else if (jvNo !== undefined)
            url_ += "jvNo=" + encodeURIComponent("" + jvNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteJournal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteJournal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JournalsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JournalsDto[]>;
        }));
    }

    protected processDeleteJournal(response: HttpResponseBase): Observable<JournalsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(JournalsDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JournalsDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteJournalById(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Journal/DeleteJournalById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteJournalById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteJournalById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteJournalById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param gantan (optional) 
     * @param inputDate (optional) 
     * @return Success
     */
    getJournalDataForLedger(gantan: moment.Moment | undefined, inputDate: moment.Moment | undefined): Observable<LedgerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Journal/GetJournalDataForLedger?";
        if (gantan === null)
            throw new Error("The parameter 'gantan' cannot be null.");
        else if (gantan !== undefined)
            url_ += "gantan=" + encodeURIComponent(gantan ? "" + gantan.toISOString() : "") + "&";
        if (inputDate === null)
            throw new Error("The parameter 'inputDate' cannot be null.");
        else if (inputDate !== undefined)
            url_ += "inputDate=" + encodeURIComponent(inputDate ? "" + inputDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetJournalDataForLedger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJournalDataForLedger(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LedgerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LedgerDto[]>;
        }));
    }

    protected processGetJournalDataForLedger(response: HttpResponseBase): Observable<LedgerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(LedgerDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LedgerDto[]>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getAccountingData(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<AccountingData> {
        let url_ = this.baseUrl + "/api/services/app/Journal/GetAccountingData?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAccountingData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountingData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountingData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountingData>;
        }));
    }

    protected processGetAccountingData(response: HttpResponseBase): Observable<AccountingData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AccountingData.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountingData>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getAllLedgerData(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<LedgerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Journal/GetAllLedgerData?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllLedgerData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLedgerData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LedgerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LedgerDto[]>;
        }));
    }

    protected processGetAllLedgerData(response: HttpResponseBase): Observable<LedgerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(LedgerDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LedgerDto[]>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param migrationDate (optional) 
     * @param code (optional) 
     * @param name (optional) 
     * @param date (optional) 
     * @return Success
     */
    checkIsMigrationAccount(startDate: moment.Moment | undefined, migrationDate: moment.Moment | undefined, code: string | undefined, name: string | undefined, date: moment.Moment | undefined): Observable<AccountsChartDto> {
        let url_ = this.baseUrl + "/api/services/app/Journal/CheckIsMigrationAccount?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (migrationDate === null)
            throw new Error("The parameter 'migrationDate' cannot be null.");
        else if (migrationDate !== undefined)
            url_ += "migrationDate=" + encodeURIComponent(migrationDate ? "" + migrationDate.toISOString() : "") + "&";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckIsMigrationAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIsMigrationAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountsChartDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountsChartDto>;
        }));
    }

    protected processCheckIsMigrationAccount(response: HttpResponseBase): Observable<AccountsChartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AccountsChartDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountsChartDto>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @param categoryCode (optional) 
     * @return Success
     */
    getJournalEntriesForCashbook(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined, categoryCode: string | undefined): Observable<CashbookJournalData> {
        let url_ = this.baseUrl + "/api/services/app/Journal/GetJournalEntriesForCashbook?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (categoryCode === null)
            throw new Error("The parameter 'categoryCode' cannot be null.");
        else if (categoryCode !== undefined)
            url_ += "categoryCode=" + encodeURIComponent("" + categoryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetJournalEntriesForCashbook(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJournalEntriesForCashbook(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CashbookJournalData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CashbookJournalData>;
        }));
    }

    protected processGetJournalEntriesForCashbook(response: HttpResponseBase): Observable<CashbookJournalData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CashbookJournalData.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CashbookJournalData>(null as any);
    }

    /**
     * @return Success
     */
    monthlyAccountingReport(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Journal/MonthlyAccountingReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processMonthlyAccountingReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMonthlyAccountingReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMonthlyAccountingReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendAccountingReportToEmail(body: CompanyProfile | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Journal/SendAccountingReportToEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendAccountingReportToEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAccountingReportToEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendAccountingReportToEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class KeyProductServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createKeyProduct(body: AppKeyProductDto | undefined): Observable<AppKeyProductDto> {
        let url_ = this.baseUrl + "/api/services/app/KeyProduct/CreateKeyProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateKeyProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateKeyProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppKeyProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppKeyProductDto>;
        }));
    }

    protected processCreateKeyProduct(response: HttpResponseBase): Observable<AppKeyProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AppKeyProductDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppKeyProductDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getKeyProduct(tenantId: number | undefined): Observable<AppKeyProduct[]> {
        let url_ = this.baseUrl + "/api/services/app/KeyProduct/GetKeyProduct?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetKeyProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKeyProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppKeyProduct[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppKeyProduct[]>;
        }));
    }

    protected processGetKeyProduct(response: HttpResponseBase): Observable<AppKeyProduct[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(AppKeyProduct.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppKeyProduct[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getKeyProductWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<AppKeyProductPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/KeyProduct/GetKeyProductWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetKeyProductWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKeyProductWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppKeyProductPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppKeyProductPagedResultDto>;
        }));
    }

    protected processGetKeyProductWithInput(response: HttpResponseBase): Observable<AppKeyProductPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AppKeyProductPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppKeyProductPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateKeyProduct(id: number | undefined, body: AppKeyProductDto | undefined): Observable<AppKeyProductDto> {
        let url_ = this.baseUrl + "/api/services/app/KeyProduct/UpdateKeyProduct?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateKeyProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateKeyProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppKeyProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppKeyProductDto>;
        }));
    }

    protected processUpdateKeyProduct(response: HttpResponseBase): Observable<AppKeyProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AppKeyProductDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppKeyProductDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteKeyProduct(id: number | undefined): Observable<AppKeyProductDto> {
        let url_ = this.baseUrl + "/api/services/app/KeyProduct/DeleteKeyProduct?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteKeyProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteKeyProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppKeyProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppKeyProductDto>;
        }));
    }

    protected processDeleteKeyProduct(response: HttpResponseBase): Observable<AppKeyProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AppKeyProductDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppKeyProductDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createKeyProductPrices(body: AppKeyProductPricesDto | undefined): Observable<AppKeyProductPricesDto> {
        let url_ = this.baseUrl + "/api/services/app/KeyProduct/CreateKeyProductPrices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateKeyProductPrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateKeyProductPrices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppKeyProductPricesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppKeyProductPricesDto>;
        }));
    }

    protected processCreateKeyProductPrices(response: HttpResponseBase): Observable<AppKeyProductPricesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AppKeyProductPricesDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppKeyProductPricesDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getKeyProductPrices(tenantId: number | undefined): Observable<AppKeyProductPrices[]> {
        let url_ = this.baseUrl + "/api/services/app/KeyProduct/GetKeyProductPrices?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetKeyProductPrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKeyProductPrices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppKeyProductPrices[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppKeyProductPrices[]>;
        }));
    }

    protected processGetKeyProductPrices(response: HttpResponseBase): Observable<AppKeyProductPrices[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(AppKeyProductPrices.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppKeyProductPrices[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getKeyProductPricesWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<AppKeyProductPricesPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/KeyProduct/GetKeyProductPricesWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetKeyProductPricesWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKeyProductPricesWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppKeyProductPricesPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppKeyProductPricesPagedResultDto>;
        }));
    }

    protected processGetKeyProductPricesWithInput(response: HttpResponseBase): Observable<AppKeyProductPricesPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AppKeyProductPricesPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppKeyProductPricesPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateKeyProductPrices(id: number | undefined, body: AppKeyProductPricesDto | undefined): Observable<AppKeyProductPricesDto> {
        let url_ = this.baseUrl + "/api/services/app/KeyProduct/UpdateKeyProductPrices?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateKeyProductPrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateKeyProductPrices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppKeyProductPricesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppKeyProductPricesDto>;
        }));
    }

    protected processUpdateKeyProductPrices(response: HttpResponseBase): Observable<AppKeyProductPricesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AppKeyProductPricesDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppKeyProductPricesDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteKeyProductPrices(id: number | undefined): Observable<AppKeyProductPricesDto> {
        let url_ = this.baseUrl + "/api/services/app/KeyProduct/DeleteKeyProductPrices?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteKeyProductPrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteKeyProductPrices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppKeyProductPricesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppKeyProductPricesDto>;
        }));
    }

    protected processDeleteKeyProductPrices(response: HttpResponseBase): Observable<AppKeyProductPricesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AppKeyProductPricesDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppKeyProductPricesDto>(null as any);
    }
}

@Injectable()
export class LHDNServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    loginAsTaxpayerSystem(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LHDN/LoginAsTaxpayerSystem";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLoginAsTaxpayerSystem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginAsTaxpayerSystem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processLoginAsTaxpayerSystem(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param myTinNumber (optional) 
     * @return Success
     */
    loginAsIntermediarySystem(myTinNumber: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LHDN/LoginAsIntermediarySystem?";
        if (myTinNumber === null)
            throw new Error("The parameter 'myTinNumber' cannot be null.");
        else if (myTinNumber !== undefined)
            url_ += "myTinNumber=" + encodeURIComponent("" + myTinNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processLoginAsIntermediarySystem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginAsIntermediarySystem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processLoginAsIntermediarySystem(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param accessToken (optional) 
     * @return Success
     */
    getAllDocumentTypes(accessToken: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LHDN/GetAllDocumentTypes?";
        if (accessToken === null)
            throw new Error("The parameter 'accessToken' cannot be null.");
        else if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllDocumentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDocumentTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAllDocumentTypes(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param accessToken (optional) 
     * @param documentTypeId (optional) 
     * @return Success
     */
    getDocumentType(accessToken: string | undefined, documentTypeId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LHDN/GetDocumentType?";
        if (accessToken === null)
            throw new Error("The parameter 'accessToken' cannot be null.");
        else if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' cannot be null.");
        else if (documentTypeId !== undefined)
            url_ += "documentTypeId=" + encodeURIComponent("" + documentTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDocumentType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDocumentType(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param accessToken (optional) 
     * @param documentTypeId (optional) 
     * @param versionId (optional) 
     * @return Success
     */
    getDocumentTypeVersion(accessToken: string | undefined, documentTypeId: string | undefined, versionId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LHDN/GetDocumentTypeVersion?";
        if (accessToken === null)
            throw new Error("The parameter 'accessToken' cannot be null.");
        else if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (documentTypeId === null)
            throw new Error("The parameter 'documentTypeId' cannot be null.");
        else if (documentTypeId !== undefined)
            url_ += "documentTypeId=" + encodeURIComponent("" + documentTypeId) + "&";
        if (versionId === null)
            throw new Error("The parameter 'versionId' cannot be null.");
        else if (versionId !== undefined)
            url_ += "versionId=" + encodeURIComponent("" + versionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDocumentTypeVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentTypeVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDocumentTypeVersion(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param accessToken (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param type (optional) 
     * @param language (optional) 
     * @param status (optional) 
     * @param channel (optional) 
     * @param pageNo (optional) 
     * @param pageSize (optional) 
     * @return Success
     */
    getNotifications(accessToken: string | undefined, dateFrom: string | undefined, dateTo: string | undefined, type: string | undefined, language: string | undefined, status: string | undefined, channel: string | undefined, pageNo: number | undefined, pageSize: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LHDN/GetNotifications?";
        if (accessToken === null)
            throw new Error("The parameter 'accessToken' cannot be null.");
        else if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (channel === null)
            throw new Error("The parameter 'channel' cannot be null.");
        else if (channel !== undefined)
            url_ += "channel=" + encodeURIComponent("" + channel) + "&";
        if (pageNo === null)
            throw new Error("The parameter 'pageNo' cannot be null.");
        else if (pageNo !== undefined)
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetNotifications(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param accessToken (optional) 
     * @param tin (optional) 
     * @param idType (optional) 
     * @param idValue (optional) 
     * @return Success
     */
    validateTaxpayerTIN(accessToken: string | undefined, tin: string | undefined, idType: string | undefined, idValue: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LHDN/ValidateTaxpayerTIN?";
        if (accessToken === null)
            throw new Error("The parameter 'accessToken' cannot be null.");
        else if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (tin === null)
            throw new Error("The parameter 'tin' cannot be null.");
        else if (tin !== undefined)
            url_ += "tin=" + encodeURIComponent("" + tin) + "&";
        if (idType === null)
            throw new Error("The parameter 'idType' cannot be null.");
        else if (idType !== undefined)
            url_ += "idType=" + encodeURIComponent("" + idType) + "&";
        if (idValue === null)
            throw new Error("The parameter 'idValue' cannot be null.");
        else if (idValue !== undefined)
            url_ += "idValue=" + encodeURIComponent("" + idValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processValidateTaxpayerTIN(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateTaxpayerTIN(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processValidateTaxpayerTIN(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param token (optional) 
     * @return Success
     */
    setAccessToken(token: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LHDN/SetAccessToken?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSetAccessToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAccessToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAccessToken(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitDocument(body: BillLhdnDto | undefined): Observable<SubmitDocumentsResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/LHDN/SubmitDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSubmitDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubmitDocumentsResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubmitDocumentsResponseDto>;
        }));
    }

    protected processSubmitDocument(response: HttpResponseBase): Observable<SubmitDocumentsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SubmitDocumentsResponseDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubmitDocumentsResponseDto>(null as any);
    }

    /**
     * @param accessToken (optional) 
     * @param uuid (optional) 
     * @param reason (optional) 
     * @return Success
     */
    cancelDocument(accessToken: string | undefined, uuid: string | undefined, reason: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LHDN/CancelDocument?";
        if (accessToken === null)
            throw new Error("The parameter 'accessToken' cannot be null.");
        else if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (uuid === null)
            throw new Error("The parameter 'uuid' cannot be null.");
        else if (uuid !== undefined)
            url_ += "uuid=" + encodeURIComponent("" + uuid) + "&";
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCancelDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCancelDocument(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    convertToBillLhdn(body: BillDto | undefined): Observable<BillLhdnDto> {
        let url_ = this.baseUrl + "/api/services/app/LHDN/ConvertToBillLhdn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processConvertToBillLhdn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConvertToBillLhdn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillLhdnDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillLhdnDto>;
        }));
    }

    protected processConvertToBillLhdn(response: HttpResponseBase): Observable<BillLhdnDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillLhdnDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillLhdnDto>(null as any);
    }

    /**
     * @param accessToken (optional) 
     * @param uuid (optional) 
     * @param reason (optional) 
     * @return Success
     */
    rejectDocument(accessToken: string | undefined, uuid: string | undefined, reason: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LHDN/RejectDocument?";
        if (accessToken === null)
            throw new Error("The parameter 'accessToken' cannot be null.");
        else if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (uuid === null)
            throw new Error("The parameter 'uuid' cannot be null.");
        else if (uuid !== undefined)
            url_ += "uuid=" + encodeURIComponent("" + uuid) + "&";
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRejectDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processRejectDocument(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param accessToken (optional) 
     * @param pageNo (optional) 
     * @param pageSize (optional) 
     * @param submissionDateFrom (optional) 
     * @param submissionDateTo (optional) 
     * @param issueDateFrom (optional) 
     * @param issueDateTo (optional) 
     * @param direction (optional) 
     * @param status (optional) 
     * @param documentType (optional) 
     * @param receiverIdType (optional) 
     * @param receiverId (optional) 
     * @param receiverTin (optional) 
     * @param issuerTin (optional) 
     * @param issuerIdType (optional) 
     * @param issuerId (optional) 
     * @return Success
     */
    getRecentDocuments(accessToken: string | undefined, pageNo: number | undefined, pageSize: number | undefined, submissionDateFrom: string | undefined, submissionDateTo: string | undefined, issueDateFrom: string | undefined, issueDateTo: string | undefined, direction: string | undefined, status: string | undefined, documentType: string | undefined, receiverIdType: string | undefined, receiverId: string | undefined, receiverTin: string | undefined, issuerTin: string | undefined, issuerIdType: string | undefined, issuerId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LHDN/GetRecentDocuments?";
        if (accessToken === null)
            throw new Error("The parameter 'accessToken' cannot be null.");
        else if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (pageNo === null)
            throw new Error("The parameter 'pageNo' cannot be null.");
        else if (pageNo !== undefined)
            url_ += "pageNo=" + encodeURIComponent("" + pageNo) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (submissionDateFrom === null)
            throw new Error("The parameter 'submissionDateFrom' cannot be null.");
        else if (submissionDateFrom !== undefined)
            url_ += "submissionDateFrom=" + encodeURIComponent("" + submissionDateFrom) + "&";
        if (submissionDateTo === null)
            throw new Error("The parameter 'submissionDateTo' cannot be null.");
        else if (submissionDateTo !== undefined)
            url_ += "submissionDateTo=" + encodeURIComponent("" + submissionDateTo) + "&";
        if (issueDateFrom === null)
            throw new Error("The parameter 'issueDateFrom' cannot be null.");
        else if (issueDateFrom !== undefined)
            url_ += "issueDateFrom=" + encodeURIComponent("" + issueDateFrom) + "&";
        if (issueDateTo === null)
            throw new Error("The parameter 'issueDateTo' cannot be null.");
        else if (issueDateTo !== undefined)
            url_ += "issueDateTo=" + encodeURIComponent("" + issueDateTo) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "direction=" + encodeURIComponent("" + direction) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (documentType === null)
            throw new Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        if (receiverIdType === null)
            throw new Error("The parameter 'receiverIdType' cannot be null.");
        else if (receiverIdType !== undefined)
            url_ += "receiverIdType=" + encodeURIComponent("" + receiverIdType) + "&";
        if (receiverId === null)
            throw new Error("The parameter 'receiverId' cannot be null.");
        else if (receiverId !== undefined)
            url_ += "receiverId=" + encodeURIComponent("" + receiverId) + "&";
        if (receiverTin === null)
            throw new Error("The parameter 'receiverTin' cannot be null.");
        else if (receiverTin !== undefined)
            url_ += "receiverTin=" + encodeURIComponent("" + receiverTin) + "&";
        if (issuerTin === null)
            throw new Error("The parameter 'issuerTin' cannot be null.");
        else if (issuerTin !== undefined)
            url_ += "issuerTin=" + encodeURIComponent("" + issuerTin) + "&";
        if (issuerIdType === null)
            throw new Error("The parameter 'issuerIdType' cannot be null.");
        else if (issuerIdType !== undefined)
            url_ += "issuerIdType=" + encodeURIComponent("" + issuerIdType) + "&";
        if (issuerId === null)
            throw new Error("The parameter 'issuerId' cannot be null.");
        else if (issuerId !== undefined)
            url_ += "issuerId=" + encodeURIComponent("" + issuerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRecentDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetRecentDocuments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param submissionUid (optional) 
     * @return Success
     */
    getSubmission(submissionUid: string | undefined): Observable<DocumentSubmissionDto> {
        let url_ = this.baseUrl + "/api/services/app/LHDN/GetSubmission?";
        if (submissionUid === null)
            throw new Error("The parameter 'submissionUid' cannot be null.");
        else if (submissionUid !== undefined)
            url_ += "submissionUid=" + encodeURIComponent("" + submissionUid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSubmission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubmission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentSubmissionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentSubmissionDto>;
        }));
    }

    protected processGetSubmission(response: HttpResponseBase): Observable<DocumentSubmissionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DocumentSubmissionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentSubmissionDto>(null as any);
    }

    /**
     * @param documentUUID (optional) 
     * @return Success
     */
    getDocument(documentUUID: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LHDN/GetDocument?";
        if (documentUUID === null)
            throw new Error("The parameter 'documentUUID' cannot be null.");
        else if (documentUUID !== undefined)
            url_ += "documentUUID=" + encodeURIComponent("" + documentUUID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetDocument(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param uuid (optional) 
     * @return Success
     */
    getDocumentDetails(uuid: string | undefined): Observable<DocumentDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/LHDN/GetDocumentDetails?";
        if (uuid === null)
            throw new Error("The parameter 'uuid' cannot be null.");
        else if (uuid !== undefined)
            url_ += "uuid=" + encodeURIComponent("" + uuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDocumentDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDetailsDto>;
        }));
    }

    protected processGetDocumentDetails(response: HttpResponseBase): Observable<DocumentDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DocumentDetailsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDetailsDto>(null as any);
    }

    /**
     * @param accessToken (optional) 
     * @param uuid (optional) 
     * @param submissionDateFrom (optional) 
     * @param submissionDateTo (optional) 
     * @param continuationToken (optional) 
     * @param pageSize (optional) 
     * @param issueDateFrom (optional) 
     * @param issueDateTo (optional) 
     * @param direction (optional) 
     * @param status (optional) 
     * @param documentType (optional) 
     * @param receiverId (optional) 
     * @param receiverIdType (optional) 
     * @param issuerTin (optional) 
     * @param receiverTin (optional) 
     * @return Success
     */
    searchDocuments(accessToken: string | undefined, uuid: string | undefined, submissionDateFrom: string | undefined, submissionDateTo: string | undefined, continuationToken: string | undefined, pageSize: number | undefined, issueDateFrom: string | undefined, issueDateTo: string | undefined, direction: string | undefined, status: string | undefined, documentType: string | undefined, receiverId: string | undefined, receiverIdType: string | undefined, issuerTin: string | undefined, receiverTin: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/LHDN/SearchDocuments?";
        if (accessToken === null)
            throw new Error("The parameter 'accessToken' cannot be null.");
        else if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (uuid === null)
            throw new Error("The parameter 'uuid' cannot be null.");
        else if (uuid !== undefined)
            url_ += "uuid=" + encodeURIComponent("" + uuid) + "&";
        if (submissionDateFrom === null)
            throw new Error("The parameter 'submissionDateFrom' cannot be null.");
        else if (submissionDateFrom !== undefined)
            url_ += "submissionDateFrom=" + encodeURIComponent("" + submissionDateFrom) + "&";
        if (submissionDateTo === null)
            throw new Error("The parameter 'submissionDateTo' cannot be null.");
        else if (submissionDateTo !== undefined)
            url_ += "submissionDateTo=" + encodeURIComponent("" + submissionDateTo) + "&";
        if (continuationToken === null)
            throw new Error("The parameter 'continuationToken' cannot be null.");
        else if (continuationToken !== undefined)
            url_ += "continuationToken=" + encodeURIComponent("" + continuationToken) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (issueDateFrom === null)
            throw new Error("The parameter 'issueDateFrom' cannot be null.");
        else if (issueDateFrom !== undefined)
            url_ += "issueDateFrom=" + encodeURIComponent("" + issueDateFrom) + "&";
        if (issueDateTo === null)
            throw new Error("The parameter 'issueDateTo' cannot be null.");
        else if (issueDateTo !== undefined)
            url_ += "issueDateTo=" + encodeURIComponent("" + issueDateTo) + "&";
        if (direction === null)
            throw new Error("The parameter 'direction' cannot be null.");
        else if (direction !== undefined)
            url_ += "direction=" + encodeURIComponent("" + direction) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (documentType === null)
            throw new Error("The parameter 'documentType' cannot be null.");
        else if (documentType !== undefined)
            url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
        if (receiverId === null)
            throw new Error("The parameter 'receiverId' cannot be null.");
        else if (receiverId !== undefined)
            url_ += "receiverId=" + encodeURIComponent("" + receiverId) + "&";
        if (receiverIdType === null)
            throw new Error("The parameter 'receiverIdType' cannot be null.");
        else if (receiverIdType !== undefined)
            url_ += "receiverIdType=" + encodeURIComponent("" + receiverIdType) + "&";
        if (issuerTin === null)
            throw new Error("The parameter 'issuerTin' cannot be null.");
        else if (issuerTin !== undefined)
            url_ += "issuerTin=" + encodeURIComponent("" + issuerTin) + "&";
        if (receiverTin === null)
            throw new Error("The parameter 'receiverTin' cannot be null.");
        else if (receiverTin !== undefined)
            url_ += "receiverTin=" + encodeURIComponent("" + receiverTin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSearchDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSearchDocuments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBillLhdn(body: BillLhdnDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/LHDN/CreateBillLhdn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateBillLhdn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBillLhdn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateBillLhdn(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param billId (optional) 
     * @return Success
     */
    getBillLhdnFromBillId(billId: string | undefined): Observable<BillLhdn> {
        let url_ = this.baseUrl + "/api/services/app/LHDN/GetBillLhdnFromBillId?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBillLhdnFromBillId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillLhdnFromBillId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillLhdn>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillLhdn>;
        }));
    }

    protected processGetBillLhdnFromBillId(response: HttpResponseBase): Observable<BillLhdn> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BillLhdn.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillLhdn>(null as any);
    }
}

@Injectable()
export class MaterialServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param materialId (optional) 
     * @return Success
     */
    getMaterial(materialId: string | undefined): Observable<MaterialDto> {
        let url_ = this.baseUrl + "/api/services/app/Material/GetMaterial?";
        if (materialId === null)
            throw new Error("The parameter 'materialId' cannot be null.");
        else if (materialId !== undefined)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMaterial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialDto>;
        }));
    }

    protected processGetMaterial(response: HttpResponseBase): Observable<MaterialDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MaterialDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialDto>(null as any);
    }

    /**
     * @param materialName (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getMaterialByName(materialName: string | undefined, tenantId: number | undefined): Observable<Material> {
        let url_ = this.baseUrl + "/api/services/app/Material/GetMaterialByName?";
        if (materialName === null)
            throw new Error("The parameter 'materialName' cannot be null.");
        else if (materialName !== undefined)
            url_ += "materialName=" + encodeURIComponent("" + materialName) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMaterialByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterialByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Material>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Material>;
        }));
    }

    protected processGetMaterialByName(response: HttpResponseBase): Observable<Material> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Material.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Material>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param category (optional) 
     * @param isSubsidized (optional) 
     * @param isCertified (optional) 
     * @param isIslamic (optional) 
     * @param isLoanAvailable (optional) 
     * @param minValue (optional) 
     * @param maxValue (optional) 
     * @return Success
     */
    getMaterialsByCategoryWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, category: string | undefined, isSubsidized: boolean | undefined, isCertified: boolean | undefined, isIslamic: boolean | undefined, isLoanAvailable: boolean | undefined, minValue: number | undefined, maxValue: number | undefined): Observable<MaterialDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Material/GetMaterialsByCategoryWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        if (isSubsidized === null)
            throw new Error("The parameter 'isSubsidized' cannot be null.");
        else if (isSubsidized !== undefined)
            url_ += "isSubsidized=" + encodeURIComponent("" + isSubsidized) + "&";
        if (isCertified === null)
            throw new Error("The parameter 'isCertified' cannot be null.");
        else if (isCertified !== undefined)
            url_ += "isCertified=" + encodeURIComponent("" + isCertified) + "&";
        if (isIslamic === null)
            throw new Error("The parameter 'isIslamic' cannot be null.");
        else if (isIslamic !== undefined)
            url_ += "isIslamic=" + encodeURIComponent("" + isIslamic) + "&";
        if (isLoanAvailable === null)
            throw new Error("The parameter 'isLoanAvailable' cannot be null.");
        else if (isLoanAvailable !== undefined)
            url_ += "isLoanAvailable=" + encodeURIComponent("" + isLoanAvailable) + "&";
        if (minValue === null)
            throw new Error("The parameter 'minValue' cannot be null.");
        else if (minValue !== undefined)
            url_ += "minValue=" + encodeURIComponent("" + minValue) + "&";
        if (maxValue === null)
            throw new Error("The parameter 'maxValue' cannot be null.");
        else if (maxValue !== undefined)
            url_ += "maxValue=" + encodeURIComponent("" + maxValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMaterialsByCategoryWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterialsByCategoryWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialDtoPagedResultDto>;
        }));
    }

    protected processGetMaterialsByCategoryWithInput(response: HttpResponseBase): Observable<MaterialDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MaterialDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialDtoPagedResultDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getMaterialWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<MaterialDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Material/GetMaterialWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMaterialWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterialWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialDtoPagedResultDto>;
        }));
    }

    protected processGetMaterialWithInput(response: HttpResponseBase): Observable<MaterialDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MaterialDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getMaterialByTenant(): Observable<Material[]> {
        let url_ = this.baseUrl + "/api/services/app/Material/GetMaterialByTenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMaterialByTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterialByTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Material[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Material[]>;
        }));
    }

    protected processGetMaterialByTenant(response: HttpResponseBase): Observable<Material[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(Material.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Material[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param isNotEqual (optional) 
     * @return Success
     */
    getMaterialByInventoryCategoryId(id: number | undefined, isNotEqual: boolean | undefined): Observable<MaterialDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Material/GetMaterialByInventoryCategoryId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isNotEqual === null)
            throw new Error("The parameter 'isNotEqual' cannot be null.");
        else if (isNotEqual !== undefined)
            url_ += "isNotEqual=" + encodeURIComponent("" + isNotEqual) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMaterialByInventoryCategoryId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterialByInventoryCategoryId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialDto[]>;
        }));
    }

    protected processGetMaterialByInventoryCategoryId(response: HttpResponseBase): Observable<MaterialDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(MaterialDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getFeaturedMaterials(): Observable<MaterialDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Material/GetFeaturedMaterials";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFeaturedMaterials(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeaturedMaterials(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialDto[]>;
        }));
    }

    protected processGetFeaturedMaterials(response: HttpResponseBase): Observable<MaterialDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(MaterialDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param companyRegNo (optional) 
     * @param minValue (optional) 
     * @param maxValue (optional) 
     * @return Success
     */
    getMaterialsByCompanyRegNo(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, companyRegNo: string | undefined, minValue: number | undefined, maxValue: number | undefined): Observable<MaterialDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Material/GetMaterialsByCompanyRegNo?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (companyRegNo === null)
            throw new Error("The parameter 'companyRegNo' cannot be null.");
        else if (companyRegNo !== undefined)
            url_ += "companyRegNo=" + encodeURIComponent("" + companyRegNo) + "&";
        if (minValue === null)
            throw new Error("The parameter 'minValue' cannot be null.");
        else if (minValue !== undefined)
            url_ += "minValue=" + encodeURIComponent("" + minValue) + "&";
        if (maxValue === null)
            throw new Error("The parameter 'maxValue' cannot be null.");
        else if (maxValue !== undefined)
            url_ += "maxValue=" + encodeURIComponent("" + maxValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMaterialsByCompanyRegNo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterialsByCompanyRegNo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialDtoPagedResultDto>;
        }));
    }

    protected processGetMaterialsByCompanyRegNo(response: HttpResponseBase): Observable<MaterialDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MaterialDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialDtoPagedResultDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param companyRegNo (optional) 
     * @param minValue (optional) 
     * @param maxValue (optional) 
     * @return Success
     */
    getFeaturedMaterialsByCompanyRegNo(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, companyRegNo: string | undefined, minValue: number | undefined, maxValue: number | undefined): Observable<MaterialDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Material/GetFeaturedMaterialsByCompanyRegNo?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (companyRegNo === null)
            throw new Error("The parameter 'companyRegNo' cannot be null.");
        else if (companyRegNo !== undefined)
            url_ += "companyRegNo=" + encodeURIComponent("" + companyRegNo) + "&";
        if (minValue === null)
            throw new Error("The parameter 'minValue' cannot be null.");
        else if (minValue !== undefined)
            url_ += "minValue=" + encodeURIComponent("" + minValue) + "&";
        if (maxValue === null)
            throw new Error("The parameter 'maxValue' cannot be null.");
        else if (maxValue !== undefined)
            url_ += "maxValue=" + encodeURIComponent("" + maxValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFeaturedMaterialsByCompanyRegNo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeaturedMaterialsByCompanyRegNo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialDtoPagedResultDto>;
        }));
    }

    protected processGetFeaturedMaterialsByCompanyRegNo(response: HttpResponseBase): Observable<MaterialDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MaterialDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllMaterial(): Observable<MaterialDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Material/GetAllMaterial";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllMaterial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMaterial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialDto[]>;
        }));
    }

    protected processGetAllMaterial(response: HttpResponseBase): Observable<MaterialDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(MaterialDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialDto[]>(null as any);
    }

    /**
     * @param vendorInvoiceItemId (optional) 
     * @param quantity (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    updateMaterialInventoryCount(vendorInvoiceItemId: number | undefined, quantity: number | undefined, warehouseId: number | undefined): Observable<MaterialDto> {
        let url_ = this.baseUrl + "/api/services/app/Material/UpdateMaterialInventoryCount?";
        if (vendorInvoiceItemId === null)
            throw new Error("The parameter 'vendorInvoiceItemId' cannot be null.");
        else if (vendorInvoiceItemId !== undefined)
            url_ += "vendorInvoiceItemId=" + encodeURIComponent("" + vendorInvoiceItemId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateMaterialInventoryCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMaterialInventoryCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialDto>;
        }));
    }

    protected processUpdateMaterialInventoryCount(response: HttpResponseBase): Observable<MaterialDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MaterialDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialDto>(null as any);
    }

    /**
     * @param type (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateMaterialWriteOffQuantity(type: number | undefined, body: WriteOffNoteItemDto | undefined): Observable<MaterialDto> {
        let url_ = this.baseUrl + "/api/services/app/Material/UpdateMaterialWriteOffQuantity?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateMaterialWriteOffQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMaterialWriteOffQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialDto>;
        }));
    }

    protected processUpdateMaterialWriteOffQuantity(response: HttpResponseBase): Observable<MaterialDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MaterialDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialDto>(null as any);
    }

    /**
     * @param type (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateMaterialProjectQuantity(type: number | undefined, body: WriteOffNoteItemDto | undefined): Observable<MaterialDto> {
        let url_ = this.baseUrl + "/api/services/app/Material/UpdateMaterialProjectQuantity?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateMaterialProjectQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMaterialProjectQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialDto>;
        }));
    }

    protected processUpdateMaterialProjectQuantity(response: HttpResponseBase): Observable<MaterialDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MaterialDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMaterialProductionQuantity(body: WriteOffNoteItemDto | undefined): Observable<MaterialDto> {
        let url_ = this.baseUrl + "/api/services/app/Material/UpdateMaterialProductionQuantity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateMaterialProductionQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMaterialProductionQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialDto>;
        }));
    }

    protected processUpdateMaterialProductionQuantity(response: HttpResponseBase): Observable<MaterialDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MaterialDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialDto>(null as any);
    }

    /**
     * @param type (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateMaterialTransferQuantity(type: number | undefined, body: WriteOffNoteItemDto | undefined): Observable<MaterialDto> {
        let url_ = this.baseUrl + "/api/services/app/Material/UpdateMaterialTransferQuantity?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateMaterialTransferQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMaterialTransferQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialDto>;
        }));
    }

    protected processUpdateMaterialTransferQuantity(response: HttpResponseBase): Observable<MaterialDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MaterialDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialDto>(null as any);
    }

    /**
     * @param materialId (optional) 
     * @return Success
     */
    calculateAverageMaterialPriceFromPo(materialId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Material/CalculateAverageMaterialPriceFromPo?";
        if (materialId === null)
            throw new Error("The parameter 'materialId' cannot be null.");
        else if (materialId !== undefined)
            url_ += "materialId=" + encodeURIComponent("" + materialId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCalculateAverageMaterialPriceFromPo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateAverageMaterialPriceFromPo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCalculateAverageMaterialPriceFromPo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    checkMaterialInventoryCategory(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Material/CheckMaterialInventoryCategory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckMaterialInventoryCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckMaterialInventoryCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckMaterialInventoryCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMaterial(body: CreateMaterialDto | undefined): Observable<MaterialDto> {
        let url_ = this.baseUrl + "/api/services/app/Material/CreateMaterial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateMaterial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMaterial(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialDto>;
        }));
    }

    protected processCreateMaterial(response: HttpResponseBase): Observable<MaterialDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MaterialDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkMigrationData(body: MaterialMigrationDto[] | undefined): Observable<MaterialMigrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Material/CheckMigrationData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckMigrationData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckMigrationData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialMigrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialMigrationDto[]>;
        }));
    }

    protected processCheckMigrationData(response: HttpResponseBase): Observable<MaterialMigrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(MaterialMigrationDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialMigrationDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMaterialsFromMigration(body: MaterialMigrationDto[] | undefined): Observable<MaterialMigrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Material/CreateMaterialsFromMigration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateMaterialsFromMigration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMaterialsFromMigration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialMigrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialMigrationDto[]>;
        }));
    }

    protected processCreateMaterialsFromMigration(response: HttpResponseBase): Observable<MaterialMigrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(MaterialMigrationDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialMigrationDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<MaterialDto> {
        let url_ = this.baseUrl + "/api/services/app/Material/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MaterialDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MaterialDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MaterialDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Material/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MaterialDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MaterialDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMaterialDto | undefined): Observable<MaterialDto> {
        let url_ = this.baseUrl + "/api/services/app/Material/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MaterialDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MaterialDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateMaterialDto | undefined): Observable<MaterialDto> {
        let url_ = this.baseUrl + "/api/services/app/Material/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaterialDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaterialDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MaterialDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MaterialDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaterialDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Material/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class NonCurrentAssetServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param nonCurrentAssetId (optional) 
     * @return Success
     */
    getNonCurrentAsset(nonCurrentAssetId: string | undefined): Observable<NonCurrentAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAsset/GetNonCurrentAsset?";
        if (nonCurrentAssetId === null)
            throw new Error("The parameter 'nonCurrentAssetId' cannot be null.");
        else if (nonCurrentAssetId !== undefined)
            url_ += "NonCurrentAssetId=" + encodeURIComponent("" + nonCurrentAssetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNonCurrentAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNonCurrentAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetDto>;
        }));
    }

    protected processGetNonCurrentAsset(response: HttpResponseBase): Observable<NonCurrentAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetDto>(null as any);
    }

    /**
     * @param nonCurrentAssetId (optional) 
     * @param invoiceId (optional) 
     * @return Success
     */
    getNonCurrentAssetWithItems(nonCurrentAssetId: string | undefined, invoiceId: number | undefined): Observable<NonCurrentAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAsset/GetNonCurrentAssetWithItems?";
        if (nonCurrentAssetId === null)
            throw new Error("The parameter 'nonCurrentAssetId' cannot be null.");
        else if (nonCurrentAssetId !== undefined)
            url_ += "NonCurrentAssetId=" + encodeURIComponent("" + nonCurrentAssetId) + "&";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNonCurrentAssetWithItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNonCurrentAssetWithItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetDto>;
        }));
    }

    protected processGetNonCurrentAssetWithItems(response: HttpResponseBase): Observable<NonCurrentAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetDto>(null as any);
    }

    /**
     * @param nonCurrentAssetName (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getNonCurrentAssetByName(nonCurrentAssetName: string | undefined, tenantId: number | undefined): Observable<NonCurrentAsset> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAsset/GetNonCurrentAssetByName?";
        if (nonCurrentAssetName === null)
            throw new Error("The parameter 'nonCurrentAssetName' cannot be null.");
        else if (nonCurrentAssetName !== undefined)
            url_ += "NonCurrentAssetName=" + encodeURIComponent("" + nonCurrentAssetName) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNonCurrentAssetByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNonCurrentAssetByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAsset>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAsset>;
        }));
    }

    protected processGetNonCurrentAssetByName(response: HttpResponseBase): Observable<NonCurrentAsset> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAsset.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAsset>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param category (optional) 
     * @param isSubsidized (optional) 
     * @param isCertified (optional) 
     * @param isIslamic (optional) 
     * @param isLoanAvailable (optional) 
     * @param minValue (optional) 
     * @param maxValue (optional) 
     * @return Success
     */
    getNonCurrentAssetByCategoryWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, category: string | undefined, isSubsidized: boolean | undefined, isCertified: boolean | undefined, isIslamic: boolean | undefined, isLoanAvailable: boolean | undefined, minValue: number | undefined, maxValue: number | undefined): Observable<NonCurrentAssetDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAsset/GetNonCurrentAssetByCategoryWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        if (isSubsidized === null)
            throw new Error("The parameter 'isSubsidized' cannot be null.");
        else if (isSubsidized !== undefined)
            url_ += "isSubsidized=" + encodeURIComponent("" + isSubsidized) + "&";
        if (isCertified === null)
            throw new Error("The parameter 'isCertified' cannot be null.");
        else if (isCertified !== undefined)
            url_ += "isCertified=" + encodeURIComponent("" + isCertified) + "&";
        if (isIslamic === null)
            throw new Error("The parameter 'isIslamic' cannot be null.");
        else if (isIslamic !== undefined)
            url_ += "isIslamic=" + encodeURIComponent("" + isIslamic) + "&";
        if (isLoanAvailable === null)
            throw new Error("The parameter 'isLoanAvailable' cannot be null.");
        else if (isLoanAvailable !== undefined)
            url_ += "isLoanAvailable=" + encodeURIComponent("" + isLoanAvailable) + "&";
        if (minValue === null)
            throw new Error("The parameter 'minValue' cannot be null.");
        else if (minValue !== undefined)
            url_ += "minValue=" + encodeURIComponent("" + minValue) + "&";
        if (maxValue === null)
            throw new Error("The parameter 'maxValue' cannot be null.");
        else if (maxValue !== undefined)
            url_ += "maxValue=" + encodeURIComponent("" + maxValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNonCurrentAssetByCategoryWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNonCurrentAssetByCategoryWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetDtoPagedResultDto>;
        }));
    }

    protected processGetNonCurrentAssetByCategoryWithInput(response: HttpResponseBase): Observable<NonCurrentAssetDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetDtoPagedResultDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getNonCurrentAssetWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<NonCurrentAssetDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAsset/GetNonCurrentAssetWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNonCurrentAssetWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNonCurrentAssetWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetDtoPagedResultDto>;
        }));
    }

    protected processGetNonCurrentAssetWithInput(response: HttpResponseBase): Observable<NonCurrentAssetDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getFeaturedNonCurrentAssets(): Observable<NonCurrentAssetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAsset/GetFeaturedNonCurrentAssets";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFeaturedNonCurrentAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeaturedNonCurrentAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetDto[]>;
        }));
    }

    protected processGetFeaturedNonCurrentAssets(response: HttpResponseBase): Observable<NonCurrentAssetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(NonCurrentAssetDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param companyRegNo (optional) 
     * @param minValue (optional) 
     * @param maxValue (optional) 
     * @return Success
     */
    getNonCurrentAssetsByCompanyRegNo(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, companyRegNo: string | undefined, minValue: number | undefined, maxValue: number | undefined): Observable<NonCurrentAssetDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAsset/GetNonCurrentAssetsByCompanyRegNo?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (companyRegNo === null)
            throw new Error("The parameter 'companyRegNo' cannot be null.");
        else if (companyRegNo !== undefined)
            url_ += "companyRegNo=" + encodeURIComponent("" + companyRegNo) + "&";
        if (minValue === null)
            throw new Error("The parameter 'minValue' cannot be null.");
        else if (minValue !== undefined)
            url_ += "minValue=" + encodeURIComponent("" + minValue) + "&";
        if (maxValue === null)
            throw new Error("The parameter 'maxValue' cannot be null.");
        else if (maxValue !== undefined)
            url_ += "maxValue=" + encodeURIComponent("" + maxValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNonCurrentAssetsByCompanyRegNo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNonCurrentAssetsByCompanyRegNo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetDtoPagedResultDto>;
        }));
    }

    protected processGetNonCurrentAssetsByCompanyRegNo(response: HttpResponseBase): Observable<NonCurrentAssetDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetDtoPagedResultDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param companyRegNo (optional) 
     * @param minValue (optional) 
     * @param maxValue (optional) 
     * @return Success
     */
    getFeaturedNonCurrentAssetsByCompanyRegNo(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, companyRegNo: string | undefined, minValue: number | undefined, maxValue: number | undefined): Observable<NonCurrentAssetDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAsset/GetFeaturedNonCurrentAssetsByCompanyRegNo?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (companyRegNo === null)
            throw new Error("The parameter 'companyRegNo' cannot be null.");
        else if (companyRegNo !== undefined)
            url_ += "companyRegNo=" + encodeURIComponent("" + companyRegNo) + "&";
        if (minValue === null)
            throw new Error("The parameter 'minValue' cannot be null.");
        else if (minValue !== undefined)
            url_ += "minValue=" + encodeURIComponent("" + minValue) + "&";
        if (maxValue === null)
            throw new Error("The parameter 'maxValue' cannot be null.");
        else if (maxValue !== undefined)
            url_ += "maxValue=" + encodeURIComponent("" + maxValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFeaturedNonCurrentAssetsByCompanyRegNo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeaturedNonCurrentAssetsByCompanyRegNo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetDtoPagedResultDto>;
        }));
    }

    protected processGetFeaturedNonCurrentAssetsByCompanyRegNo(response: HttpResponseBase): Observable<NonCurrentAssetDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllNonCurrentAsset(): Observable<NonCurrentAssetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAsset/GetAllNonCurrentAsset";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllNonCurrentAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNonCurrentAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetDto[]>;
        }));
    }

    protected processGetAllNonCurrentAsset(response: HttpResponseBase): Observable<NonCurrentAssetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(NonCurrentAssetDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetDto[]>(null as any);
    }

    /**
     * @param name (optional) 
     * @param code (optional) 
     * @return Success
     */
    getAllNonCurrentAssetByAccountNameOrCode(name: string | undefined, code: string | undefined): Observable<NonCurrentAssetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAsset/GetAllNonCurrentAssetByAccountNameOrCode?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllNonCurrentAssetByAccountNameOrCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNonCurrentAssetByAccountNameOrCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetDto[]>;
        }));
    }

    protected processGetAllNonCurrentAssetByAccountNameOrCode(response: HttpResponseBase): Observable<NonCurrentAssetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(NonCurrentAssetDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getNonCurrentAssetClassWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<NonCurrentAssetClassDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAsset/GetNonCurrentAssetClassWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNonCurrentAssetClassWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNonCurrentAssetClassWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetClassDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetClassDtoPagedResultDto>;
        }));
    }

    protected processGetNonCurrentAssetClassWithInput(response: HttpResponseBase): Observable<NonCurrentAssetClassDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetClassDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetClassDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getNonCurrentAssetByTenant(): Observable<NonCurrentAsset[]> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAsset/GetNonCurrentAssetByTenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNonCurrentAssetByTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNonCurrentAssetByTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAsset[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAsset[]>;
        }));
    }

    protected processGetNonCurrentAssetByTenant(response: HttpResponseBase): Observable<NonCurrentAsset[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(NonCurrentAsset.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAsset[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<NonCurrentAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAsset/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NonCurrentAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<NonCurrentAssetDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAsset/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<NonCurrentAssetDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateNonCurrentAssetDto | undefined): Observable<NonCurrentAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAsset/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<NonCurrentAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateNonCurrentAssetDto | undefined): Observable<NonCurrentAssetDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAsset/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<NonCurrentAssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAsset/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class NonCurrentAssetClassServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getNonCurrentAssetClassWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<NonCurrentAssetClassDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetClass/GetNonCurrentAssetClassWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetNonCurrentAssetClassWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNonCurrentAssetClassWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetClassDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetClassDtoPagedResultDto>;
        }));
    }

    protected processGetNonCurrentAssetClassWithInput(response: HttpResponseBase): Observable<NonCurrentAssetClassDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetClassDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetClassDtoPagedResultDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getAssetClassByTenantId(tenantId: number | undefined): Observable<NonCurrentAssetClassDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetClass/GetAssetClassByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAssetClassByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetClassByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetClassDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetClassDto[]>;
        }));
    }

    protected processGetAssetClassByTenantId(response: HttpResponseBase): Observable<NonCurrentAssetClassDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(NonCurrentAssetClassDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetClassDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAssetClassById(id: string | undefined): Observable<NonCurrentAssetClassDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetClass/GetAssetClassById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAssetClassById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetClassById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetClassDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetClassDto>;
        }));
    }

    protected processGetAssetClassById(response: HttpResponseBase): Observable<NonCurrentAssetClassDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetClassDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetClassDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<NonCurrentAssetClassDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetClass/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetClassDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetClassDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NonCurrentAssetClassDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetClassDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetClassDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<NonCurrentAssetClassDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetClass/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetClassDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetClassDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<NonCurrentAssetClassDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetClassDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetClassDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateNonCurrentAssetClassDto | undefined): Observable<NonCurrentAssetClassDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetClass/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetClassDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetClassDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<NonCurrentAssetClassDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetClassDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetClassDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateNonCurrentAssetClassDto | undefined): Observable<NonCurrentAssetClassDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetClass/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetClassDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetClassDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<NonCurrentAssetClassDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetClassDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetClassDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetClass/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class NonCurrentAssetItemServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getByNonCurrentAssetId(id: string | undefined): Observable<NonCurrentAssetItem[]> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetItem/GetByNonCurrentAssetId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetByNonCurrentAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByNonCurrentAssetId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetItem[]>;
        }));
    }

    protected processGetByNonCurrentAssetId(response: HttpResponseBase): Observable<NonCurrentAssetItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(NonCurrentAssetItem.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetItem[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param classId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getByClassIdWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, classId: string | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<NonCurrentAssetItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetItem/GetByClassIdWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (classId === null)
            throw new Error("The parameter 'classId' cannot be null.");
        else if (classId !== undefined)
            url_ += "classId=" + encodeURIComponent("" + classId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetByClassIdWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByClassIdWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetItemDtoPagedResultDto>;
        }));
    }

    protected processGetByClassIdWithInput(response: HttpResponseBase): Observable<NonCurrentAssetItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetItemDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetItemDtoPagedResultDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getAllDisposalByTenantId(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<NonCurrentAssetItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetItem/GetAllDisposalByTenantId?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllDisposalByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDisposalByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetItemDtoPagedResultDto>;
        }));
    }

    protected processGetAllDisposalByTenantId(response: HttpResponseBase): Observable<NonCurrentAssetItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetItemDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetItemDtoPagedResultDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getAllAssetItemByTenantId(tenantId: number | undefined): Observable<NonCurrentAssetItemDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetItem/GetAllAssetItemByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllAssetItemByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAssetItemByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetItemDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetItemDtoListResultDto>;
        }));
    }

    protected processGetAllAssetItemByTenantId(response: HttpResponseBase): Observable<NonCurrentAssetItemDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetItemDtoListResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetItemDtoListResultDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getAllUndisposedAssetItemByTenantId(tenantId: number | undefined): Observable<NonCurrentAssetItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetItem/GetAllUndisposedAssetItemByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllUndisposedAssetItemByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUndisposedAssetItemByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetItemDto[]>;
        }));
    }

    protected processGetAllUndisposedAssetItemByTenantId(response: HttpResponseBase): Observable<NonCurrentAssetItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(NonCurrentAssetItemDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetItemDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param impairmentValue (optional) 
     * @return Success
     */
    updateAccumulatedImpairment(id: string | undefined, impairmentValue: number | undefined): Observable<NonCurrentAssetItemDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetItem/UpdateAccumulatedImpairment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (impairmentValue === null)
            throw new Error("The parameter 'impairmentValue' cannot be null.");
        else if (impairmentValue !== undefined)
            url_ += "impairmentValue=" + encodeURIComponent("" + impairmentValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateAccumulatedImpairment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAccumulatedImpairment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetItemDto>;
        }));
    }

    protected processUpdateAccumulatedImpairment(response: HttpResponseBase): Observable<NonCurrentAssetItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    marketplaceCreateNonCurrentAssetItem(body: NonCurrentAssetItemDto | undefined): Observable<NonCurrentAssetItemDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetItem/MarketplaceCreateNonCurrentAssetItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processMarketplaceCreateNonCurrentAssetItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarketplaceCreateNonCurrentAssetItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetItemDto>;
        }));
    }

    protected processMarketplaceCreateNonCurrentAssetItem(response: HttpResponseBase): Observable<NonCurrentAssetItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createNonCurrentAssetItem(body: NonCurrentAssetItemDto | undefined): Observable<NonCurrentAssetItemDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetItem/CreateNonCurrentAssetItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateNonCurrentAssetItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNonCurrentAssetItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetItemDto>;
        }));
    }

    protected processCreateNonCurrentAssetItem(response: HttpResponseBase): Observable<NonCurrentAssetItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetItemDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param code (optional) 
     * @param name (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getByClassNameOrCodeWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, code: string | undefined, name: string | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<NonCurrentAssetItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetItem/GetByClassNameOrCodeWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetByClassNameOrCodeWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByClassNameOrCodeWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetItemDtoPagedResultDto>;
        }));
    }

    protected processGetByClassNameOrCodeWithInput(response: HttpResponseBase): Observable<NonCurrentAssetItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetItemDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetItemDtoPagedResultDto>(null as any);
    }

    /**
     * @param todayDate (optional) 
     * @param body (optional) 
     * @return Success
     */
    accumulatedDepreciation(todayDate: moment.Moment | undefined, body: NonCurrentAssetItem | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetItem/AccumulatedDepreciation?";
        if (todayDate === null)
            throw new Error("The parameter 'todayDate' cannot be null.");
        else if (todayDate !== undefined)
            url_ += "todayDate=" + encodeURIComponent(todayDate ? "" + todayDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAccumulatedDepreciation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccumulatedDepreciation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAccumulatedDepreciation(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param assetType (optional) 
     * @param body (optional) 
     * @return Success
     */
    checkMigrationData(assetType: number | undefined, body: NonCurrentAssetMigrationDto[] | undefined): Observable<NonCurrentAssetMigrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetItem/CheckMigrationData?";
        if (assetType === null)
            throw new Error("The parameter 'assetType' cannot be null.");
        else if (assetType !== undefined)
            url_ += "assetType=" + encodeURIComponent("" + assetType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckMigrationData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckMigrationData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetMigrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetMigrationDto[]>;
        }));
    }

    protected processCheckMigrationData(response: HttpResponseBase): Observable<NonCurrentAssetMigrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(NonCurrentAssetMigrationDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetMigrationDto[]>(null as any);
    }

    /**
     * @param assetType (optional) 
     * @param body (optional) 
     * @return Success
     */
    createAssetItemsFromMigration(assetType: number | undefined, body: NonCurrentAssetMigrationDto[] | undefined): Observable<NonCurrentAssetMigrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetItem/CreateAssetItemsFromMigration?";
        if (assetType === null)
            throw new Error("The parameter 'assetType' cannot be null.");
        else if (assetType !== undefined)
            url_ += "assetType=" + encodeURIComponent("" + assetType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateAssetItemsFromMigration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAssetItemsFromMigration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetMigrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetMigrationDto[]>;
        }));
    }

    protected processCreateAssetItemsFromMigration(response: HttpResponseBase): Observable<NonCurrentAssetMigrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(NonCurrentAssetMigrationDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetMigrationDto[]>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getAssetItemForLedger(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<NonCurrentAssetItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetItem/GetAssetItemForLedger?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAssetItemForLedger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetItemForLedger(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetItemDto[]>;
        }));
    }

    protected processGetAssetItemForLedger(response: HttpResponseBase): Observable<NonCurrentAssetItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(NonCurrentAssetItemDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetItemDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param codeList (optional) 
     * @return Success
     */
    getAssetItemByCode(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, codeList: string[] | undefined): Observable<NonCurrentAssetItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetItem/GetAssetItemByCode?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (codeList === null)
            throw new Error("The parameter 'codeList' cannot be null.");
        else if (codeList !== undefined)
            codeList && codeList.forEach(item => { url_ += "codeList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAssetItemByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetItemByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetItemDto[]>;
        }));
    }

    protected processGetAssetItemByCode(response: HttpResponseBase): Observable<NonCurrentAssetItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(NonCurrentAssetItemDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetItemDto[]>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param code (optional) 
     * @param name (optional) 
     * @param date (optional) 
     * @return Success
     */
    checkIsMigrationAccount(startDate: moment.Moment | undefined, code: string | undefined, name: string | undefined, date: moment.Moment | undefined): Observable<AccountsChartDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetItem/CheckIsMigrationAccount?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckIsMigrationAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIsMigrationAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountsChartDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountsChartDto>;
        }));
    }

    protected processCheckIsMigrationAccount(response: HttpResponseBase): Observable<AccountsChartDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AccountsChartDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountsChartDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<NonCurrentAssetItemDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetItem/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetItemDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NonCurrentAssetItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetItemDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<NonCurrentAssetItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetItem/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<NonCurrentAssetItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetItemDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetItemDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateNonCurrentAssetItemDto | undefined): Observable<NonCurrentAssetItemDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetItem/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetItemDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<NonCurrentAssetItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateNonCurrentAssetItemDto | undefined): Observable<NonCurrentAssetItemDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetItem/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetItemDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<NonCurrentAssetItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetItemDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetItem/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class NonCurrentAssetItemImpairmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<NonCurrentAssetItemImpairmentDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetItemImpairment/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetItemImpairmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetItemImpairmentDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NonCurrentAssetItemImpairmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetItemImpairmentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetItemImpairmentDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<NonCurrentAssetItemImpairmentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetItemImpairment/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetItemImpairmentDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetItemImpairmentDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<NonCurrentAssetItemImpairmentDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetItemImpairmentDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetItemImpairmentDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateNonCurrentAssetItemImpairmentDto | undefined): Observable<NonCurrentAssetItemImpairmentDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetItemImpairment/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetItemImpairmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetItemImpairmentDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<NonCurrentAssetItemImpairmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetItemImpairmentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetItemImpairmentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateNonCurrentAssetItemImpairmentDto | undefined): Observable<NonCurrentAssetItemImpairmentDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetItemImpairment/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetItemImpairmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetItemImpairmentDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<NonCurrentAssetItemImpairmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetItemImpairmentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetItemImpairmentDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetItemImpairment/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class NonCurrentAssetMaintenanceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMaintenanceByItemId(id: string | undefined): Observable<NonCurrentAssetMaintenanceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetMaintenance/GetMaintenanceByItemId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMaintenanceByItemId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaintenanceByItemId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetMaintenanceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetMaintenanceDto[]>;
        }));
    }

    protected processGetMaintenanceByItemId(response: HttpResponseBase): Observable<NonCurrentAssetMaintenanceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(NonCurrentAssetMaintenanceDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetMaintenanceDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMaintenanceById(id: string | undefined): Observable<NonCurrentAssetMaintenance> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetMaintenance/GetMaintenanceById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMaintenanceById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaintenanceById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetMaintenance>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetMaintenance>;
        }));
    }

    protected processGetMaintenanceById(response: HttpResponseBase): Observable<NonCurrentAssetMaintenance> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetMaintenance.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetMaintenance>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<NonCurrentAssetMaintenanceDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetMaintenance/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetMaintenanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetMaintenanceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NonCurrentAssetMaintenanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetMaintenanceDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetMaintenanceDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<NonCurrentAssetMaintenanceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetMaintenance/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetMaintenanceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetMaintenanceDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<NonCurrentAssetMaintenanceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetMaintenanceDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetMaintenanceDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateNonCurrentAssetMaintenanceDto | undefined): Observable<NonCurrentAssetMaintenanceDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetMaintenance/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetMaintenanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetMaintenanceDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<NonCurrentAssetMaintenanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetMaintenanceDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetMaintenanceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateNonCurrentAssetMaintenanceDto | undefined): Observable<NonCurrentAssetMaintenanceDto> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetMaintenance/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonCurrentAssetMaintenanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonCurrentAssetMaintenanceDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<NonCurrentAssetMaintenanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NonCurrentAssetMaintenanceDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonCurrentAssetMaintenanceDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NonCurrentAssetMaintenance/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param tenantId (optional) 
     * @param billId (optional) 
     * @return Success
     */
    updateBillUrl(tenantId: number | undefined, billId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/UpdateBillUrl?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateBillUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBillUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBillUrl(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    automateM2e(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/AutomateM2e";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAutomateM2e(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAutomateM2e(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAutomateM2e(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class OrdersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrder(body: OrdersDto | undefined): Observable<OrdersDto> {
        let url_ = this.baseUrl + "/api/services/app/Orders/CreateOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrdersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrdersDto>;
        }));
    }

    protected processCreateOrder(response: HttpResponseBase): Observable<OrdersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrdersDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrdersDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getOrders(userId: number | undefined): Observable<Orders[]> {
        let url_ = this.baseUrl + "/api/services/app/Orders/GetOrders?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Orders[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Orders[]>;
        }));
    }

    protected processGetOrders(response: HttpResponseBase): Observable<Orders[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(Orders.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Orders[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @param status (optional) 
     * @return Success
     */
    getOrdersWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined, status: number | undefined): Observable<OrdersDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Orders/GetOrdersWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrdersWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrdersWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrdersDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrdersDtoPagedResultDto>;
        }));
    }

    protected processGetOrdersWithInput(response: HttpResponseBase): Observable<OrdersDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrdersDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrdersDtoPagedResultDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param userId (optional) 
     * @param status (optional) 
     * @return Success
     */
    getUserOrdersWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, userId: number | undefined, status: number | undefined): Observable<OrdersDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Orders/GetUserOrdersWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserOrdersWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserOrdersWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrdersDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrdersDtoPagedResultDto>;
        }));
    }

    protected processGetUserOrdersWithInput(response: HttpResponseBase): Observable<OrdersDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrdersDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrdersDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateOrders(id: string | undefined, body: OrdersDto | undefined): Observable<OrdersDto> {
        let url_ = this.baseUrl + "/api/services/app/Orders/UpdateOrders?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrdersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrdersDto>;
        }));
    }

    protected processUpdateOrders(response: HttpResponseBase): Observable<OrdersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrdersDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrdersDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteOrder(id: string | undefined): Observable<OrdersDto> {
        let url_ = this.baseUrl + "/api/services/app/Orders/DeleteOrder?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrdersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrdersDto>;
        }));
    }

    protected processDeleteOrder(response: HttpResponseBase): Observable<OrdersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrdersDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrdersDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrderItems(body: OrderItemsDto | undefined): Observable<OrderItemsDto> {
        let url_ = this.baseUrl + "/api/services/app/Orders/CreateOrderItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrderItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrderItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderItemsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderItemsDto>;
        }));
    }

    protected processCreateOrderItems(response: HttpResponseBase): Observable<OrderItemsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrderItemsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderItemsDto>(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getOrderItems(orderId: string | undefined): Observable<OrderItems[]> {
        let url_ = this.baseUrl + "/api/services/app/Orders/GetOrderItems?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrderItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderItems[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderItems[]>;
        }));
    }

    protected processGetOrderItems(response: HttpResponseBase): Observable<OrderItems[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(OrderItems.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderItems[]>(null as any);
    }

    /**
     * @param orderId (optional) 
     * @return Success
     */
    getOrderItemsDto(orderId: string | undefined): Observable<OrderItemsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Orders/GetOrderItemsDto?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrderItemsDto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderItemsDto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderItemsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderItemsDto[]>;
        }));
    }

    protected processGetOrderItemsDto(response: HttpResponseBase): Observable<OrderItemsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(OrderItemsDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderItemsDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param orderId (optional) 
     * @return Success
     */
    getOrderItemsWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, orderId: string | undefined): Observable<OrderItemsPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Orders/GetOrderItemsWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrderItemsWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderItemsWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderItemsPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderItemsPagedResultDto>;
        }));
    }

    protected processGetOrderItemsWithInput(response: HttpResponseBase): Observable<OrderItemsPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrderItemsPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderItemsPagedResultDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getTenantOrderItemsWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<OrderItemsDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Orders/GetTenantOrderItemsWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTenantOrderItemsWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantOrderItemsWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderItemsDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderItemsDtoPagedResultDto>;
        }));
    }

    protected processGetTenantOrderItemsWithInput(response: HttpResponseBase): Observable<OrderItemsDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrderItemsDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderItemsDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateOrderItems(id: number | undefined, body: OrderItemsDto | undefined): Observable<OrderItemsDto> {
        let url_ = this.baseUrl + "/api/services/app/Orders/UpdateOrderItems?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateOrderItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderItemsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderItemsDto>;
        }));
    }

    protected processUpdateOrderItems(response: HttpResponseBase): Observable<OrderItemsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrderItemsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderItemsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteOrderItems(id: number | undefined): Observable<OrderItemsDto> {
        let url_ = this.baseUrl + "/api/services/app/Orders/DeleteOrderItems?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteOrderItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrderItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderItemsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderItemsDto>;
        }));
    }

    protected processDeleteOrderItems(response: HttpResponseBase): Observable<OrderItemsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrderItemsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderItemsDto>(null as any);
    }

    /**
     * @return Success
     */
    getOrderSummary(): Observable<OrderSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Orders/GetOrderSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrderSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderSummaryDto>;
        }));
    }

    protected processGetOrderSummary(response: HttpResponseBase): Observable<OrderSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrderSummaryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderSummaryDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserOrderSummary(userId: number | undefined): Observable<OrderSummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Orders/GetUserOrderSummary?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserOrderSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserOrderSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderSummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderSummaryDto>;
        }));
    }

    protected processGetUserOrderSummary(response: HttpResponseBase): Observable<OrderSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrderSummaryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderSummaryDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendOrderNotification(body: OrdersDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Orders/SendOrderNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendOrderNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendOrderNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendOrderNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendOrderQuotationWithPdf(body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Orders/SendOrderQuotationWithPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendOrderQuotationWithPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendOrderQuotationWithPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendOrderQuotationWithPdf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ApiServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    updatePaymentBillCallback(): Observable<void> {
        let url_ = this.baseUrl + "/api/UpdatePaymentBillCallback";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePaymentBillCallback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePaymentBillCallback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePaymentBillCallback(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    updateSubscriptionEndDate(): Observable<void> {
        let url_ = this.baseUrl + "/api/UpdateSubscriptionEndDate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateSubscriptionEndDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSubscriptionEndDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSubscriptionEndDate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    puchaseTfxProduct(): Observable<void> {
        let url_ = this.baseUrl + "/api/PuchaseTfxProduct";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPuchaseTfxProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPuchaseTfxProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPuchaseTfxProduct(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class PaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBillPaymentURL(body: BillDto | undefined): Observable<PaymentBillDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CreateBillPaymentURL";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateBillPaymentURL(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBillPaymentURL(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentBillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentBillDto>;
        }));
    }

    protected processCreateBillPaymentURL(response: HttpResponseBase): Observable<PaymentBillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaymentBillDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentBillDto>(null as any);
    }

    /**
     * @param tenancyName (optional) 
     * @param payAmount (optional) 
     * @param subscriptionEndDate (optional) 
     * @param edition (optional) 
     * @return Success
     */
    subscriptionPayment(tenancyName: string | undefined, payAmount: number | undefined, subscriptionEndDate: moment.Moment | undefined, edition: string | undefined): Observable<PaymentBillDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/SubscriptionPayment?";
        if (tenancyName === null)
            throw new Error("The parameter 'tenancyName' cannot be null.");
        else if (tenancyName !== undefined)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        if (payAmount === null)
            throw new Error("The parameter 'payAmount' cannot be null.");
        else if (payAmount !== undefined)
            url_ += "payAmount=" + encodeURIComponent("" + payAmount) + "&";
        if (subscriptionEndDate === null)
            throw new Error("The parameter 'subscriptionEndDate' cannot be null.");
        else if (subscriptionEndDate !== undefined)
            url_ += "SubscriptionEndDate=" + encodeURIComponent(subscriptionEndDate ? "" + subscriptionEndDate.toISOString() : "") + "&";
        if (edition === null)
            throw new Error("The parameter 'edition' cannot be null.");
        else if (edition !== undefined)
            url_ += "edition=" + encodeURIComponent("" + edition) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSubscriptionPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscriptionPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentBillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentBillDto>;
        }));
    }

    protected processSubscriptionPayment(response: HttpResponseBase): Observable<PaymentBillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaymentBillDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentBillDto>(null as any);
    }

    /**
     * @param companyId (optional) 
     * @param invoiceNo (optional) 
     * @param body (optional) 
     * @return Success
     */
    purchaseTfxProduct(companyId: string | undefined, invoiceNo: string | undefined, body: TfxBillItemDto[] | undefined): Observable<PaymentBillDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/purchaseTfxProduct?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (invoiceNo === null)
            throw new Error("The parameter 'invoiceNo' cannot be null.");
        else if (invoiceNo !== undefined)
            url_ += "invoiceNo=" + encodeURIComponent("" + invoiceNo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPurchaseTfxProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPurchaseTfxProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentBillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentBillDto>;
        }));
    }

    protected processPurchaseTfxProduct(response: HttpResponseBase): Observable<PaymentBillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaymentBillDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentBillDto>(null as any);
    }

    /**
     * @return Success
     */
    getBillPlzUrl(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetBillPlzUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBillPlzUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillPlzUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetBillPlzUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    createCollection(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CreateCollection";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateCollection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCollection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateCollection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getBankAccount(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetBankAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBankAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBankAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetBankAccount(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    createBankAccount(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CreateBankAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateBankAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBankAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateBankAccount(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    createPayoutCollection(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CreatePayoutCollection";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePayoutCollection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePayoutCollection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreatePayoutCollection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    createPayout(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CreatePayout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePayout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePayout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreatePayout(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPaymentBill(body: PaymentBillDto | undefined): Observable<PaymentBillDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CreatePaymentBill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePaymentBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePaymentBill(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentBillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentBillDto>;
        }));
    }

    protected processCreatePaymentBill(response: HttpResponseBase): Observable<PaymentBillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaymentBillDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentBillDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getPaymentBill(tenantId: number | undefined): Observable<PaymentBill[]> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentBill?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPaymentBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentBill(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentBill[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentBill[]>;
        }));
    }

    protected processGetPaymentBill(response: HttpResponseBase): Observable<PaymentBill[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PaymentBill.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentBill[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getPaymentBillWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<PaymentBillDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentBillWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPaymentBillWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentBillWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentBillDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentBillDtoPagedResultDto>;
        }));
    }

    protected processGetPaymentBillWithInput(response: HttpResponseBase): Observable<PaymentBillDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaymentBillDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentBillDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatePaymentBill(id: number | undefined, body: PaymentBillDto | undefined): Observable<PaymentBillDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/UpdatePaymentBill?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePaymentBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePaymentBill(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentBillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentBillDto>;
        }));
    }

    protected processUpdatePaymentBill(response: HttpResponseBase): Observable<PaymentBillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaymentBillDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentBillDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deletePaymentBill(id: number | undefined): Observable<PaymentBillDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/DeletePaymentBill?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeletePaymentBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePaymentBill(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentBillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentBillDto>;
        }));
    }

    protected processDeletePaymentBill(response: HttpResponseBase): Observable<PaymentBillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaymentBillDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentBillDto>(null as any);
    }
}

@Injectable()
export class PettyCashsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPettyCashs(body: PettyCashsDto | undefined): Observable<PettyCashsDto> {
        let url_ = this.baseUrl + "/api/services/app/PettyCashs/CreatePettyCashs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePettyCashs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePettyCashs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PettyCashsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PettyCashsDto>;
        }));
    }

    protected processCreatePettyCashs(response: HttpResponseBase): Observable<PettyCashsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PettyCashsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PettyCashsDto>(null as any);
    }

    /**
     * @return Success
     */
    getPettyCashs(): Observable<PettyCashs[]> {
        let url_ = this.baseUrl + "/api/services/app/PettyCashs/GetPettyCashs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPettyCashs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPettyCashs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PettyCashs[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PettyCashs[]>;
        }));
    }

    protected processGetPettyCashs(response: HttpResponseBase): Observable<PettyCashs[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PettyCashs.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PettyCashs[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getPettyCashsWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<PettyCashsDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PettyCashs/GetPettyCashsWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPettyCashsWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPettyCashsWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PettyCashsDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PettyCashsDtoPagedResultDto>;
        }));
    }

    protected processGetPettyCashsWithInput(response: HttpResponseBase): Observable<PettyCashsDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PettyCashsDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PettyCashsDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatePettyCashsStatus(id: number | undefined, body: PettyCashsDto | undefined): Observable<PettyCashsDto> {
        let url_ = this.baseUrl + "/api/services/app/PettyCashs/UpdatePettyCashsStatus?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePettyCashsStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePettyCashsStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PettyCashsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PettyCashsDto>;
        }));
    }

    protected processUpdatePettyCashsStatus(response: HttpResponseBase): Observable<PettyCashsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PettyCashsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PettyCashsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deletePettyCashs(id: number | undefined): Observable<PettyCashsDto> {
        let url_ = this.baseUrl + "/api/services/app/PettyCashs/DeletePettyCashs?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeletePettyCashs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePettyCashs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PettyCashsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PettyCashsDto>;
        }));
    }

    protected processDeletePettyCashs(response: HttpResponseBase): Observable<PettyCashsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PettyCashsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PettyCashsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPettyCashItems(body: PettyCashItemsDto | undefined): Observable<PettyCashItemsDto> {
        let url_ = this.baseUrl + "/api/services/app/PettyCashs/CreatePettyCashItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePettyCashItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePettyCashItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PettyCashItemsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PettyCashItemsDto>;
        }));
    }

    protected processCreatePettyCashItems(response: HttpResponseBase): Observable<PettyCashItemsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PettyCashItemsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PettyCashItemsDto>(null as any);
    }

    /**
     * @param pettycashId (optional) 
     * @return Success
     */
    getPettyCashItems(pettycashId: number | undefined): Observable<PettyCashItemsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PettyCashs/GetPettyCashItems?";
        if (pettycashId === null)
            throw new Error("The parameter 'pettycashId' cannot be null.");
        else if (pettycashId !== undefined)
            url_ += "pettycashId=" + encodeURIComponent("" + pettycashId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPettyCashItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPettyCashItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PettyCashItemsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PettyCashItemsDto[]>;
        }));
    }

    protected processGetPettyCashItems(response: HttpResponseBase): Observable<PettyCashItemsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PettyCashItemsDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PettyCashItemsDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatePettyCashItems(id: number | undefined, body: PettyCashItemsDto | undefined): Observable<PettyCashItemsDto> {
        let url_ = this.baseUrl + "/api/services/app/PettyCashs/UpdatePettyCashItems?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePettyCashItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePettyCashItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PettyCashItemsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PettyCashItemsDto>;
        }));
    }

    protected processUpdatePettyCashItems(response: HttpResponseBase): Observable<PettyCashItemsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PettyCashItemsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PettyCashItemsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deletePettyCashItems(id: number | undefined): Observable<PettyCashItemsDto> {
        let url_ = this.baseUrl + "/api/services/app/PettyCashs/DeletePettyCashItems?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeletePettyCashItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePettyCashItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PettyCashItemsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PettyCashItemsDto>;
        }));
    }

    protected processDeletePettyCashItems(response: HttpResponseBase): Observable<PettyCashItemsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PettyCashItemsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PettyCashItemsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPettyCashCategories(body: PettyCashCategoriesDto | undefined): Observable<PettyCashCategoriesDto> {
        let url_ = this.baseUrl + "/api/services/app/PettyCashs/CreatePettyCashCategories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePettyCashCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePettyCashCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PettyCashCategoriesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PettyCashCategoriesDto>;
        }));
    }

    protected processCreatePettyCashCategories(response: HttpResponseBase): Observable<PettyCashCategoriesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PettyCashCategoriesDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PettyCashCategoriesDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getPettyCashCategories(tenantId: number | undefined): Observable<PettyCashCategories[]> {
        let url_ = this.baseUrl + "/api/services/app/PettyCashs/GetPettyCashCategories?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPettyCashCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPettyCashCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PettyCashCategories[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PettyCashCategories[]>;
        }));
    }

    protected processGetPettyCashCategories(response: HttpResponseBase): Observable<PettyCashCategories[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PettyCashCategories.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PettyCashCategories[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatePettyCashCategories(id: number | undefined, body: PettyCashCategoriesDto | undefined): Observable<PettyCashCategoriesDto> {
        let url_ = this.baseUrl + "/api/services/app/PettyCashs/UpdatePettyCashCategories?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePettyCashCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePettyCashCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PettyCashCategoriesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PettyCashCategoriesDto>;
        }));
    }

    protected processUpdatePettyCashCategories(response: HttpResponseBase): Observable<PettyCashCategoriesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PettyCashCategoriesDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PettyCashCategoriesDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deletePettyCashCategories(id: number | undefined): Observable<PettyCashCategoriesDto> {
        let url_ = this.baseUrl + "/api/services/app/PettyCashs/DeletePettyCashCategories?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeletePettyCashCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePettyCashCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PettyCashCategoriesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PettyCashCategoriesDto>;
        }));
    }

    protected processDeletePettyCashCategories(response: HttpResponseBase): Observable<PettyCashCategoriesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PettyCashCategoriesDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PettyCashCategoriesDto>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getPettyCashForLedger(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<LedgerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PettyCashs/GetPettyCashForLedger?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPettyCashForLedger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPettyCashForLedger(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LedgerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LedgerDto[]>;
        }));
    }

    protected processGetPettyCashForLedger(response: HttpResponseBase): Observable<LedgerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(LedgerDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LedgerDto[]>(null as any);
    }
}

@Injectable()
export class PosServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getTenancyName(tenantId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Pos/GetTenancyName?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTenancyName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenancyName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetTenancyName(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param dateString (optional) 
     * @return Success
     */
    getFirebaseCollectionList(tenantId: number | undefined, dateString: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Pos/GetFirebaseCollectionList?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (dateString === null)
            throw new Error("The parameter 'dateString' cannot be null.");
        else if (dateString !== undefined)
            url_ += "dateString=" + encodeURIComponent("" + dateString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFirebaseCollectionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirebaseCollectionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetFirebaseCollectionList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getFirebaseTransaction(tenantId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<TransactionSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Pos/GetFirebaseTransaction?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFirebaseTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirebaseTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionSummaryDto[]>;
        }));
    }

    protected processGetFirebaseTransaction(response: HttpResponseBase): Observable<TransactionSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(TransactionSummaryDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionSummaryDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getCurrentReport(tenantId: number | undefined): Observable<TransactionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Pos/GetCurrentReport?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCurrentReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDto[]>;
        }));
    }

    protected processGetCurrentReport(response: HttpResponseBase): Observable<TransactionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(TransactionDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param transactionName (optional) 
     * @param time (optional) 
     * @return Success
     */
    getCurrentReportItem(tenantId: number | undefined, transactionName: string | undefined, time: string | undefined): Observable<TransactionItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Pos/GetCurrentReportItem?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (transactionName === null)
            throw new Error("The parameter 'transactionName' cannot be null.");
        else if (transactionName !== undefined)
            url_ += "transactionName=" + encodeURIComponent("" + transactionName) + "&";
        if (time === null)
            throw new Error("The parameter 'time' cannot be null.");
        else if (time !== undefined)
            url_ += "time=" + encodeURIComponent("" + time) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCurrentReportItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentReportItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionItemDto[]>;
        }));
    }

    protected processGetCurrentReportItem(response: HttpResponseBase): Observable<TransactionItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(TransactionItemDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionItemDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getCurrentReportRange(tenantId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<TransactionItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Pos/GetCurrentReportRange?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCurrentReportRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentReportRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionItemDto[]>;
        }));
    }

    protected processGetCurrentReportRange(response: HttpResponseBase): Observable<TransactionItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(TransactionItemDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionItemDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param date (optional) 
     * @return Success
     */
    getReportByDate(tenantId: number | undefined, date: string | undefined): Observable<TransactionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Pos/GetReportByDate?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetReportByDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportByDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDto[]>;
        }));
    }

    protected processGetReportByDate(response: HttpResponseBase): Observable<TransactionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(TransactionDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param date (optional) 
     * @param docId (optional) 
     * @return Success
     */
    getAttachments(tenantId: number | undefined, date: string | undefined, docId: string | undefined): Observable<TransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/Pos/GetAttachments?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (docId === null)
            throw new Error("The parameter 'docId' cannot be null.");
        else if (docId !== undefined)
            url_ += "docId=" + encodeURIComponent("" + docId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDto>;
        }));
    }

    protected processGetAttachments(response: HttpResponseBase): Observable<TransactionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TransactionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param date (optional) 
     * @return Success
     */
    getTransactionsInfo(tenantId: number | undefined, date: moment.Moment | undefined): Observable<TransactionSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Pos/GetTransactionsInfo?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTransactionsInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionsInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionSummaryDto[]>;
        }));
    }

    protected processGetTransactionsInfo(response: HttpResponseBase): Observable<TransactionSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(TransactionSummaryDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionSummaryDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param date (optional) 
     * @return Success
     */
    getTransactionsInfoWithItems(tenantId: number | undefined, date: moment.Moment | undefined): Observable<TransactionSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Pos/GetTransactionsInfoWithItems?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTransactionsInfoWithItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionsInfoWithItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionSummaryDto[]>;
        }));
    }

    protected processGetTransactionsInfoWithItems(response: HttpResponseBase): Observable<TransactionSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(TransactionSummaryDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionSummaryDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param month (optional) 
     * @param year (optional) 
     * @return Success
     */
    getTransactionsInfoByMonth(tenantId: number | undefined, month: string | undefined, year: string | undefined): Observable<TransactionSummaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Pos/GetTransactionsInfoByMonth?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTransactionsInfoByMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionsInfoByMonth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionSummaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionSummaryDto[]>;
        }));
    }

    protected processGetTransactionsInfoByMonth(response: HttpResponseBase): Observable<TransactionSummaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(TransactionSummaryDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionSummaryDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getTableList(tenantId: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Pos/GetTableList?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTableList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTableList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetTableList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(item);
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param tableNumber (optional) 
     * @param info (optional) 
     * @param body (optional) 
     * @return Success
     */
    addTableOrder(tenantId: number | undefined, tableNumber: string | undefined, info: string | undefined, body: CartDto[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Pos/AddTableOrder?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (tableNumber === null)
            throw new Error("The parameter 'tableNumber' cannot be null.");
        else if (tableNumber !== undefined)
            url_ += "tableNumber=" + encodeURIComponent("" + tableNumber) + "&";
        if (info === null)
            throw new Error("The parameter 'info' cannot be null.");
        else if (info !== undefined)
            url_ += "info=" + encodeURIComponent("" + info) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAddTableOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTableOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddTableOrder(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param tableNumber (optional) 
     * @param info (optional) 
     * @param body (optional) 
     * @return Success
     */
    addKitchenList(tenantId: number | undefined, tableNumber: string | undefined, info: string | undefined, body: CartDto[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Pos/addKitchenList?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (tableNumber === null)
            throw new Error("The parameter 'tableNumber' cannot be null.");
        else if (tableNumber !== undefined)
            url_ += "tableNumber=" + encodeURIComponent("" + tableNumber) + "&";
        if (info === null)
            throw new Error("The parameter 'info' cannot be null.");
        else if (info !== undefined)
            url_ += "info=" + encodeURIComponent("" + info) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAddKitchenList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddKitchenList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAddKitchenList(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param productIdGuid (optional) 
     * @return Success
     */
    getFirebaseDocId(tenantId: number | undefined, productIdGuid: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Pos/GetFirebaseDocId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (productIdGuid === null)
            throw new Error("The parameter 'productIdGuid' cannot be null.");
        else if (productIdGuid !== undefined)
            url_ += "productIdGuid=" + encodeURIComponent("" + productIdGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFirebaseDocId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirebaseDocId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFirebaseDocId(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getFirebaseProducts(tenantId: number | undefined): Observable<FirebaseProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Pos/GetFirebaseProducts?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFirebaseProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirebaseProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FirebaseProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FirebaseProductDto[]>;
        }));
    }

    protected processGetFirebaseProducts(response: HttpResponseBase): Observable<FirebaseProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(FirebaseProductDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FirebaseProductDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getFirebaseCategory(tenantId: number | undefined): Observable<FirebaseProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Pos/GetFirebaseCategory?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFirebaseCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirebaseCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FirebaseProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FirebaseProductDto[]>;
        }));
    }

    protected processGetFirebaseCategory(response: HttpResponseBase): Observable<FirebaseProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(FirebaseProductDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FirebaseProductDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatefirebaseProductId(tenantId: number | undefined, body: ProductDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Pos/UpdatefirebaseProductId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatefirebaseProductId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatefirebaseProductId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatefirebaseProductId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param docID (optional) 
     * @return Success
     */
    deleteFirebaseProduct(tenantId: number | undefined, docID: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Pos/DeleteFirebaseProduct?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (docID === null)
            throw new Error("The parameter 'docID' cannot be null.");
        else if (docID !== undefined)
            url_ += "docID=" + encodeURIComponent("" + docID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteFirebaseProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFirebaseProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteFirebaseProduct(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param docID (optional) 
     * @param productId (optional) 
     * @return Success
     */
    updateFirebaseProductId(tenantId: number | undefined, docID: string | undefined, productId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Pos/updateFirebaseProductId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (docID === null)
            throw new Error("The parameter 'docID' cannot be null.");
        else if (docID !== undefined)
            url_ += "docID=" + encodeURIComponent("" + docID) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateFirebaseProductId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFirebaseProductId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateFirebaseProductId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param docID (optional) 
     * @param image (optional) 
     * @return Success
     */
    updateFirebaseProductImage(tenantId: number | undefined, docID: string | undefined, image: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Pos/updateFirebaseProductImage?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (docID === null)
            throw new Error("The parameter 'docID' cannot be null.");
        else if (docID !== undefined)
            url_ += "docID=" + encodeURIComponent("" + docID) + "&";
        if (image === null)
            throw new Error("The parameter 'image' cannot be null.");
        else if (image !== undefined)
            url_ += "image=" + encodeURIComponent("" + image) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateFirebaseProductImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFirebaseProductImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateFirebaseProductImage(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param categoryName (optional) 
     * @return Success
     */
    getFirebaseProductsByCategory(tenantId: number | undefined, categoryName: string | undefined): Observable<FirebaseProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Pos/GetFirebaseProductsByCategory?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (categoryName === null)
            throw new Error("The parameter 'categoryName' cannot be null.");
        else if (categoryName !== undefined)
            url_ += "categoryName=" + encodeURIComponent("" + categoryName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFirebaseProductsByCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirebaseProductsByCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FirebaseProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FirebaseProductDto[]>;
        }));
    }

    protected processGetFirebaseProductsByCategory(response: HttpResponseBase): Observable<FirebaseProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(FirebaseProductDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FirebaseProductDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param categoryName (optional) 
     * @param filterText (optional) 
     * @return Success
     */
    getProductsByCategory(tenantId: number | undefined, categoryName: string | undefined, filterText: string | undefined): Observable<ProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Pos/GetProductsByCategory?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (categoryName === null)
            throw new Error("The parameter 'categoryName' cannot be null.");
        else if (categoryName !== undefined)
            url_ += "categoryName=" + encodeURIComponent("" + categoryName) + "&";
        if (filterText === null)
            throw new Error("The parameter 'filterText' cannot be null.");
        else if (filterText !== undefined)
            url_ += "filterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductsByCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductsByCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto[]>;
        }));
    }

    protected processGetProductsByCategory(response: HttpResponseBase): Observable<ProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(ProductDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param docId (optional) 
     * @param oldCategory (optional) 
     * @param newCategory (optional) 
     * @return Success
     */
    moveFirebaseCategory(tenantId: number | undefined, docId: string | undefined, oldCategory: string | undefined, newCategory: string | undefined): Observable<FirebaseProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Pos/MoveFirebaseCategory?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (docId === null)
            throw new Error("The parameter 'docId' cannot be null.");
        else if (docId !== undefined)
            url_ += "docId=" + encodeURIComponent("" + docId) + "&";
        if (oldCategory === null)
            throw new Error("The parameter 'oldCategory' cannot be null.");
        else if (oldCategory !== undefined)
            url_ += "oldCategory=" + encodeURIComponent("" + oldCategory) + "&";
        if (newCategory === null)
            throw new Error("The parameter 'newCategory' cannot be null.");
        else if (newCategory !== undefined)
            url_ += "newCategory=" + encodeURIComponent("" + newCategory) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processMoveFirebaseCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveFirebaseCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FirebaseProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FirebaseProductDto>;
        }));
    }

    protected processMoveFirebaseCategory(response: HttpResponseBase): Observable<FirebaseProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FirebaseProductDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FirebaseProductDto>(null as any);
    }
}

@Injectable()
export class ProductServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param productId (optional) 
     * @return Success
     */
    getProduct(productId: string | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProduct?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto>;
        }));
    }

    protected processGetProduct(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(null as any);
    }

    /**
     * @param productName (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getProductByName(productName: string | undefined, tenantId: number | undefined): Observable<Product> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductByName?";
        if (productName === null)
            throw new Error("The parameter 'productName' cannot be null.");
        else if (productName !== undefined)
            url_ += "productName=" + encodeURIComponent("" + productName) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Product>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Product>;
        }));
    }

    protected processGetProductByName(response: HttpResponseBase): Observable<Product> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Product.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Product>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param category (optional) 
     * @param isSubsidized (optional) 
     * @param isCertified (optional) 
     * @param isIslamic (optional) 
     * @param isLoanAvailable (optional) 
     * @param minValue (optional) 
     * @param maxValue (optional) 
     * @return Success
     */
    getPoductsByCategoryWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, category: string | undefined, isSubsidized: boolean | undefined, isCertified: boolean | undefined, isIslamic: boolean | undefined, isLoanAvailable: boolean | undefined, minValue: number | undefined, maxValue: number | undefined): Observable<ProductDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetPoductsByCategoryWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        if (isSubsidized === null)
            throw new Error("The parameter 'isSubsidized' cannot be null.");
        else if (isSubsidized !== undefined)
            url_ += "isSubsidized=" + encodeURIComponent("" + isSubsidized) + "&";
        if (isCertified === null)
            throw new Error("The parameter 'isCertified' cannot be null.");
        else if (isCertified !== undefined)
            url_ += "isCertified=" + encodeURIComponent("" + isCertified) + "&";
        if (isIslamic === null)
            throw new Error("The parameter 'isIslamic' cannot be null.");
        else if (isIslamic !== undefined)
            url_ += "isIslamic=" + encodeURIComponent("" + isIslamic) + "&";
        if (isLoanAvailable === null)
            throw new Error("The parameter 'isLoanAvailable' cannot be null.");
        else if (isLoanAvailable !== undefined)
            url_ += "isLoanAvailable=" + encodeURIComponent("" + isLoanAvailable) + "&";
        if (minValue === null)
            throw new Error("The parameter 'minValue' cannot be null.");
        else if (minValue !== undefined)
            url_ += "minValue=" + encodeURIComponent("" + minValue) + "&";
        if (maxValue === null)
            throw new Error("The parameter 'maxValue' cannot be null.");
        else if (maxValue !== undefined)
            url_ += "maxValue=" + encodeURIComponent("" + maxValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPoductsByCategoryWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPoductsByCategoryWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDtoPagedResultDto>;
        }));
    }

    protected processGetPoductsByCategoryWithInput(response: HttpResponseBase): Observable<ProductDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDtoPagedResultDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getProductWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<ProductDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDtoPagedResultDto>;
        }));
    }

    protected processGetProductWithInput(response: HttpResponseBase): Observable<ProductDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDtoPagedResultDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getProductForPriceListWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<ProductDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductForPriceListWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductForPriceListWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductForPriceListWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDtoPagedResultDto>;
        }));
    }

    protected processGetProductForPriceListWithInput(response: HttpResponseBase): Observable<ProductDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDtoPagedResultDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getProductOnlyWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<ProductDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductOnlyWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductOnlyWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductOnlyWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDtoPagedResultDto>;
        }));
    }

    protected processGetProductOnlyWithInput(response: HttpResponseBase): Observable<ProductDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getServiceOnlyByTenant(): Observable<Product[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetServiceOnlyByTenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetServiceOnlyByTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceOnlyByTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Product[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Product[]>;
        }));
    }

    protected processGetServiceOnlyByTenant(response: HttpResponseBase): Observable<Product[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(Product.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Product[]>(null as any);
    }

    /**
     * @return Success
     */
    getProductOnlyByTenant(): Observable<Product[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductOnlyByTenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductOnlyByTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductOnlyByTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Product[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Product[]>;
        }));
    }

    protected processGetProductOnlyByTenant(response: HttpResponseBase): Observable<Product[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(Product.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Product[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param isNotEqual (optional) 
     * @return Success
     */
    getProductOnlyByInventoryCategoryId(id: number | undefined, isNotEqual: boolean | undefined): Observable<ProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductOnlyByInventoryCategoryId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isNotEqual === null)
            throw new Error("The parameter 'isNotEqual' cannot be null.");
        else if (isNotEqual !== undefined)
            url_ += "isNotEqual=" + encodeURIComponent("" + isNotEqual) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductOnlyByInventoryCategoryId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductOnlyByInventoryCategoryId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto[]>;
        }));
    }

    protected processGetProductOnlyByInventoryCategoryId(response: HttpResponseBase): Observable<ProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(ProductDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto[]>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param category (optional) 
     * @return Success
     */
    updateProductFirebaseCategory(productId: string | undefined, category: string | undefined): Observable<Product> {
        let url_ = this.baseUrl + "/api/services/app/Product/UpdateProductFirebaseCategory?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateProductFirebaseCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProductFirebaseCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Product>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Product>;
        }));
    }

    protected processUpdateProductFirebaseCategory(response: HttpResponseBase): Observable<Product> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Product.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Product>(null as any);
    }

    /**
     * @param category (optional) 
     * @return Success
     */
    deleteFirebaseCategory(category: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Product/DeleteFirebaseCategory?";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteFirebaseCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFirebaseCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteFirebaseCategory(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param vendorInvoiceItemId (optional) 
     * @param quantity (optional) 
     * @param warehouseId (optional) 
     * @return Success
     */
    updateProductInventoryCount(vendorInvoiceItemId: number | undefined, quantity: number | undefined, warehouseId: number | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/UpdateProductInventoryCount?";
        if (vendorInvoiceItemId === null)
            throw new Error("The parameter 'vendorInvoiceItemId' cannot be null.");
        else if (vendorInvoiceItemId !== undefined)
            url_ += "vendorInvoiceItemId=" + encodeURIComponent("" + vendorInvoiceItemId) + "&";
        if (quantity === null)
            throw new Error("The parameter 'quantity' cannot be null.");
        else if (quantity !== undefined)
            url_ += "quantity=" + encodeURIComponent("" + quantity) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "warehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateProductInventoryCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProductInventoryCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto>;
        }));
    }

    protected processUpdateProductInventoryCount(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(null as any);
    }

    /**
     * @param type (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateProductWriteOffQuantity(type: number | undefined, body: WriteOffNoteItemDto | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/UpdateProductWriteOffQuantity?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateProductWriteOffQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProductWriteOffQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto>;
        }));
    }

    protected processUpdateProductWriteOffQuantity(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(null as any);
    }

    /**
     * @param type (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateProductTransferQuantity(type: number | undefined, body: WriteOffNoteItemDto | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/UpdateProductTransferQuantity?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateProductTransferQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProductTransferQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto>;
        }));
    }

    protected processUpdateProductTransferQuantity(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProductSizes(body: ProductSizesDto | undefined): Observable<ProductSizesDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/CreateProductSizes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateProductSizes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProductSizes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductSizesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductSizesDto>;
        }));
    }

    protected processCreateProductSizes(response: HttpResponseBase): Observable<ProductSizesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductSizesDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSizesDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @return Success
     */
    getProductSizes(productId: string | undefined): Observable<ProductSizes[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductSizes?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductSizes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductSizes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductSizes[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductSizes[]>;
        }));
    }

    protected processGetProductSizes(response: HttpResponseBase): Observable<ProductSizes[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(ProductSizes.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSizes[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateProductSizes(id: number | undefined, body: ProductSizesDto | undefined): Observable<ProductSizesDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/UpdateProductSizes?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateProductSizes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProductSizes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductSizesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductSizesDto>;
        }));
    }

    protected processUpdateProductSizes(response: HttpResponseBase): Observable<ProductSizesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductSizesDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSizesDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteProductSizes(id: number | undefined): Observable<ProductSizesDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/DeleteProductSizes?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteProductSizes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProductSizes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductSizesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductSizesDto>;
        }));
    }

    protected processDeleteProductSizes(response: HttpResponseBase): Observable<ProductSizesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductSizesDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductSizesDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProductColors(body: ProductColorsDto | undefined): Observable<ProductColorsDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/CreateProductColors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateProductColors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProductColors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductColorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductColorsDto>;
        }));
    }

    protected processCreateProductColors(response: HttpResponseBase): Observable<ProductColorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductColorsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductColorsDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @return Success
     */
    getProductColors(productId: string | undefined): Observable<ProductColors[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductColors?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductColors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductColors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductColors[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductColors[]>;
        }));
    }

    protected processGetProductColors(response: HttpResponseBase): Observable<ProductColors[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(ProductColors.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductColors[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateProductColors(id: number | undefined, body: ProductColorsDto | undefined): Observable<ProductColorsDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/UpdateProductColors?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateProductColors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProductColors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductColorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductColorsDto>;
        }));
    }

    protected processUpdateProductColors(response: HttpResponseBase): Observable<ProductColorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductColorsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductColorsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteProductColors(id: number | undefined): Observable<ProductColorsDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/DeleteProductColors?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteProductColors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProductColors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductColorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductColorsDto>;
        }));
    }

    protected processDeleteProductColors(response: HttpResponseBase): Observable<ProductColorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductColorsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductColorsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProductImages(body: ProductImagesDto | undefined): Observable<ProductImagesDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/CreateProductImages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateProductImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProductImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductImagesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductImagesDto>;
        }));
    }

    protected processCreateProductImages(response: HttpResponseBase): Observable<ProductImagesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductImagesDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductImagesDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @return Success
     */
    getProductImages(productId: string | undefined): Observable<ProductImages[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductImages?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductImages[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductImages[]>;
        }));
    }

    protected processGetProductImages(response: HttpResponseBase): Observable<ProductImages[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(ProductImages.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductImages[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateProductImages(id: number | undefined, body: ProductImagesDto | undefined): Observable<ProductImagesDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/UpdateProductImages?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateProductImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProductImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductImagesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductImagesDto>;
        }));
    }

    protected processUpdateProductImages(response: HttpResponseBase): Observable<ProductImagesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductImagesDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductImagesDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteProductImages(id: number | undefined): Observable<ProductImagesDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/DeleteProductImages?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteProductImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProductImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductImagesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductImagesDto>;
        }));
    }

    protected processDeleteProductImages(response: HttpResponseBase): Observable<ProductImagesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductImagesDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductImagesDto>(null as any);
    }

    /**
     * @param link (optional) 
     * @param productId (optional) 
     * @return Success
     */
    deleteProductImageByLink(link: string | undefined, productId: string | undefined): Observable<ProductImagesDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/DeleteProductImageByLink?";
        if (link === null)
            throw new Error("The parameter 'link' cannot be null.");
        else if (link !== undefined)
            url_ += "link=" + encodeURIComponent("" + link) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteProductImageByLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProductImageByLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductImagesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductImagesDto>;
        }));
    }

    protected processDeleteProductImageByLink(response: HttpResponseBase): Observable<ProductImagesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductImagesDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductImagesDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProductPriceHistory(body: ProductPriceHistoryDto | undefined): Observable<ProductPriceHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/CreateProductPriceHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateProductPriceHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProductPriceHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductPriceHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductPriceHistoryDto>;
        }));
    }

    protected processCreateProductPriceHistory(response: HttpResponseBase): Observable<ProductPriceHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductPriceHistoryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductPriceHistoryDto>(null as any);
    }

    /**
     * @param productId (optional) 
     * @param isApproved (optional) 
     * @return Success
     */
    getProductPriceHistory(productId: string | undefined, isApproved: boolean | undefined): Observable<ProductPriceHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductPriceHistory?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (isApproved === null)
            throw new Error("The parameter 'isApproved' cannot be null.");
        else if (isApproved !== undefined)
            url_ += "isApproved=" + encodeURIComponent("" + isApproved) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductPriceHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductPriceHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductPriceHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductPriceHistoryDto[]>;
        }));
    }

    protected processGetProductPriceHistory(response: HttpResponseBase): Observable<ProductPriceHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(ProductPriceHistoryDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductPriceHistoryDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateProductPriceHistory(id: number | undefined, body: ProductPriceHistoryDto | undefined): Observable<ProductPriceHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/UpdateProductPriceHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateProductPriceHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProductPriceHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductPriceHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductPriceHistoryDto>;
        }));
    }

    protected processUpdateProductPriceHistory(response: HttpResponseBase): Observable<ProductPriceHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductPriceHistoryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductPriceHistoryDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteProductPriceHistory(id: number | undefined): Observable<ProductPriceHistoryDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/DeleteProductPriceHistory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteProductPriceHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProductPriceHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductPriceHistoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductPriceHistoryDto>;
        }));
    }

    protected processDeleteProductPriceHistory(response: HttpResponseBase): Observable<ProductPriceHistoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductPriceHistoryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductPriceHistoryDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCategory(body: CategoryDto | undefined): Observable<CategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/CreateCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDto>;
        }));
    }

    protected processCreateCategory(response: HttpResponseBase): Observable<CategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CategoryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategoryDto>(null as any);
    }

    /**
     * @return Success
     */
    getCategory(): Observable<Category[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetCategory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Category[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Category[]>;
        }));
    }

    protected processGetCategory(response: HttpResponseBase): Observable<Category[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(Category.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Category[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteCategory(id: number | undefined): Observable<CategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/DeleteCategory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDto>;
        }));
    }

    protected processDeleteCategory(response: HttpResponseBase): Observable<CategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CategoryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategoryDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param filterString (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getTiles(tenantId: number | undefined, filterString: string | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<TilesDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetTiles?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (filterString === null)
            throw new Error("The parameter 'filterString' cannot be null.");
        else if (filterString !== undefined)
            url_ += "filterString=" + encodeURIComponent("" + filterString) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TilesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TilesDto>;
        }));
    }

    protected processGetTiles(response: HttpResponseBase): Observable<TilesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TilesDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TilesDto>(null as any);
    }

    /**
     * @return Success
     */
    getFeaturedProducts(): Observable<ProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetFeaturedProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFeaturedProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeaturedProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto[]>;
        }));
    }

    protected processGetFeaturedProducts(response: HttpResponseBase): Observable<ProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(ProductDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param companyRegNo (optional) 
     * @param minValue (optional) 
     * @param maxValue (optional) 
     * @return Success
     */
    getProductsByCompanyRegNo(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, companyRegNo: string | undefined, minValue: number | undefined, maxValue: number | undefined): Observable<ProductDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductsByCompanyRegNo?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (companyRegNo === null)
            throw new Error("The parameter 'companyRegNo' cannot be null.");
        else if (companyRegNo !== undefined)
            url_ += "companyRegNo=" + encodeURIComponent("" + companyRegNo) + "&";
        if (minValue === null)
            throw new Error("The parameter 'minValue' cannot be null.");
        else if (minValue !== undefined)
            url_ += "minValue=" + encodeURIComponent("" + minValue) + "&";
        if (maxValue === null)
            throw new Error("The parameter 'maxValue' cannot be null.");
        else if (maxValue !== undefined)
            url_ += "maxValue=" + encodeURIComponent("" + maxValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductsByCompanyRegNo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductsByCompanyRegNo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDtoPagedResultDto>;
        }));
    }

    protected processGetProductsByCompanyRegNo(response: HttpResponseBase): Observable<ProductDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDtoPagedResultDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param companyRegNo (optional) 
     * @param minValue (optional) 
     * @param maxValue (optional) 
     * @return Success
     */
    getFeaturedProductsByCompanyRegNo(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, companyRegNo: string | undefined, minValue: number | undefined, maxValue: number | undefined): Observable<ProductDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetFeaturedProductsByCompanyRegNo?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (companyRegNo === null)
            throw new Error("The parameter 'companyRegNo' cannot be null.");
        else if (companyRegNo !== undefined)
            url_ += "companyRegNo=" + encodeURIComponent("" + companyRegNo) + "&";
        if (minValue === null)
            throw new Error("The parameter 'minValue' cannot be null.");
        else if (minValue !== undefined)
            url_ += "minValue=" + encodeURIComponent("" + minValue) + "&";
        if (maxValue === null)
            throw new Error("The parameter 'maxValue' cannot be null.");
        else if (maxValue !== undefined)
            url_ += "maxValue=" + encodeURIComponent("" + maxValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFeaturedProductsByCompanyRegNo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFeaturedProductsByCompanyRegNo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDtoPagedResultDto>;
        }));
    }

    protected processGetFeaturedProductsByCompanyRegNo(response: HttpResponseBase): Observable<ProductDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllProduct(): Observable<ProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetAllProduct";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto[]>;
        }));
    }

    protected processGetAllProduct(response: HttpResponseBase): Observable<ProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(ProductDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllProductForDropdown(): Observable<ProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetAllProductForDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllProductForDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProductForDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto[]>;
        }));
    }

    protected processGetAllProductForDropdown(response: HttpResponseBase): Observable<ProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(ProductDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getMarketplaceProducts(): Observable<ProductDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetMarketplaceProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMarketplaceProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMarketplaceProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto[]>;
        }));
    }

    protected processGetMarketplaceProducts(response: HttpResponseBase): Observable<ProductDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(ProductDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto[]>(null as any);
    }

    /**
     * @param productId (optional) 
     * @return Success
     */
    calculateAverageProductPriceFromPo(productId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/CalculateAverageProductPriceFromPo?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCalculateAverageProductPriceFromPo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateAverageProductPriceFromPo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCalculateAverageProductPriceFromPo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param productId (optional) 
     * @return Success
     */
    calculateAverageProductProductionCost(productId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/CalculateAverageProductProductionCost?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCalculateAverageProductProductionCost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateAverageProductProductionCost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCalculateAverageProductProductionCost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    checkProductInventoryCategory(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/CheckProductInventoryCategory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckProductInventoryCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckProductInventoryCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckProductInventoryCategory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param productId (optional) 
     * @return Success
     */
    getProductObject(productId: string | undefined): Observable<Product> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetProductObject?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductObject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductObject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Product>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Product>;
        }));
    }

    protected processGetProductObject(response: HttpResponseBase): Observable<Product> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Product.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Product>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProduct(body: CreateProductDto | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/CreateProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto>;
        }));
    }

    protected processCreateProduct(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkMigrationData(body: ProductMigrationDto[] | undefined): Observable<ProductMigrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/CheckMigrationData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckMigrationData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckMigrationData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductMigrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductMigrationDto[]>;
        }));
    }

    protected processCheckMigrationData(response: HttpResponseBase): Observable<ProductMigrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(ProductMigrationDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductMigrationDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProductsFromMigration(body: ProductMigrationDto[] | undefined): Observable<ProductMigrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Product/CreateProductsFromMigration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateProductsFromMigration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProductsFromMigration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductMigrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductMigrationDto[]>;
        }));
    }

    protected processCreateProductsFromMigration(response: HttpResponseBase): Observable<ProductMigrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(ProductMigrationDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductMigrationDto[]>(null as any);
    }

    /**
     * @param tenancyName (optional) 
     * @param docID (optional) 
     * @return Success
     */
    deleteFirebaseProduct(tenancyName: string | undefined, docID: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Product/DeleteFirebaseProduct?";
        if (tenancyName === null)
            throw new Error("The parameter 'tenancyName' cannot be null.");
        else if (tenancyName !== undefined)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        if (docID === null)
            throw new Error("The parameter 'docID' cannot be null.");
        else if (docID !== undefined)
            url_ += "docID=" + encodeURIComponent("" + docID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteFirebaseProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFirebaseProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteFirebaseProduct(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenancyName (optional) 
     * @param docID (optional) 
     * @param productId (optional) 
     * @return Success
     */
    updateFirebaseProductId(tenancyName: string | undefined, docID: string | undefined, productId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Product/updateFirebaseProductId?";
        if (tenancyName === null)
            throw new Error("The parameter 'tenancyName' cannot be null.");
        else if (tenancyName !== undefined)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        if (docID === null)
            throw new Error("The parameter 'docID' cannot be null.");
        else if (docID !== undefined)
            url_ += "docID=" + encodeURIComponent("" + docID) + "&";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateFirebaseProductId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFirebaseProductId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateFirebaseProductId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenancyName (optional) 
     * @param docID (optional) 
     * @param image (optional) 
     * @return Success
     */
    updateFirebaseProductImage(tenancyName: string | undefined, docID: string | undefined, image: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Product/updateFirebaseProductImage?";
        if (tenancyName === null)
            throw new Error("The parameter 'tenancyName' cannot be null.");
        else if (tenancyName !== undefined)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        if (docID === null)
            throw new Error("The parameter 'docID' cannot be null.");
        else if (docID !== undefined)
            url_ += "docID=" + encodeURIComponent("" + docID) + "&";
        if (image === null)
            throw new Error("The parameter 'image' cannot be null.");
        else if (image !== undefined)
            url_ += "image=" + encodeURIComponent("" + image) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateFirebaseProductImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFirebaseProductImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateFirebaseProductImage(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProductDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProductDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateProductDto | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateProductDto | undefined): Observable<ProductDto> {
        let url_ = this.baseUrl + "/api/services/app/Product/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProductDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProductDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProductDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProductDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Product/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ProjectServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProject(body: ProjectDto | undefined): Observable<ProjectDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/CreateProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDto>;
        }));
    }

    protected processCreateProject(response: HttpResponseBase): Observable<ProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getProjects(tenantId: number | undefined): Observable<Project[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetProjects?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Project[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Project[]>;
        }));
    }

    protected processGetProjects(response: HttpResponseBase): Observable<Project[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(Project.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Project[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getProjectsWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<ProjectDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetProjectsWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProjectsWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectsWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDtoPagedResultDto>;
        }));
    }

    protected processGetProjectsWithInput(response: HttpResponseBase): Observable<ProjectDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateProject(id: number | undefined, body: ProjectDto | undefined): Observable<ProjectDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/UpdateProject?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDto>;
        }));
    }

    protected processUpdateProject(response: HttpResponseBase): Observable<ProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteProject(id: number | undefined): Observable<ProjectDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/DeleteProject?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDto>;
        }));
    }

    protected processDeleteProject(response: HttpResponseBase): Observable<ProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProjectStaff(body: ProjectStaffDto | undefined): Observable<ProjectStaffDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/CreateProjectStaff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateProjectStaff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProjectStaff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStaffDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStaffDto>;
        }));
    }

    protected processCreateProjectStaff(response: HttpResponseBase): Observable<ProjectStaffDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectStaffDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectStaffDto>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    getProjectStaff(projectId: number | undefined): Observable<ProjectStaff[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetProjectStaff?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProjectStaff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectStaff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStaff[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStaff[]>;
        }));
    }

    protected processGetProjectStaff(response: HttpResponseBase): Observable<ProjectStaff[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(ProjectStaff.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectStaff[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param projectId (optional) 
     * @return Success
     */
    getProjectStaffWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, projectId: number | undefined): Observable<ProjectStaffDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetProjectStaffWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProjectStaffWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectStaffWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStaffDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStaffDtoPagedResultDto>;
        }));
    }

    protected processGetProjectStaffWithInput(response: HttpResponseBase): Observable<ProjectStaffDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectStaffDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectStaffDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateProjectStaff(id: number | undefined, body: ProjectStaffDto | undefined): Observable<ProjectStaffDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/UpdateProjectStaff?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateProjectStaff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProjectStaff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStaffDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStaffDto>;
        }));
    }

    protected processUpdateProjectStaff(response: HttpResponseBase): Observable<ProjectStaffDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectStaffDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectStaffDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteProjectStaff(id: number | undefined): Observable<ProjectStaffDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/DeleteProjectStaff?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteProjectStaff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProjectStaff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStaffDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStaffDto>;
        }));
    }

    protected processDeleteProjectStaff(response: HttpResponseBase): Observable<ProjectStaffDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectStaffDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectStaffDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProjectItem(body: ProjectItemDto | undefined): Observable<ProjectItemDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/CreateProjectItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateProjectItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProjectItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectItemDto>;
        }));
    }

    protected processCreateProjectItem(response: HttpResponseBase): Observable<ProjectItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectItemDto>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param filterString (optional) 
     * @return Success
     */
    getProjectItem(projectId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, filterString: string | undefined): Observable<ProjectItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetProjectItem?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (filterString === null)
            throw new Error("The parameter 'filterString' cannot be null.");
        else if (filterString !== undefined)
            url_ += "filterString=" + encodeURIComponent("" + filterString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProjectItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectItemDto[]>;
        }));
    }

    protected processGetProjectItem(response: HttpResponseBase): Observable<ProjectItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(ProjectItemDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectItemDto[]>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getProjectItemForLedger(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<LedgerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetProjectItemForLedger?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProjectItemForLedger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectItemForLedger(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LedgerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LedgerDto[]>;
        }));
    }

    protected processGetProjectItemForLedger(response: HttpResponseBase): Observable<LedgerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(LedgerDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LedgerDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getProjectItemWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<ProjectItemPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetProjectItemWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProjectItemWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectItemWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectItemPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectItemPagedResultDto>;
        }));
    }

    protected processGetProjectItemWithInput(response: HttpResponseBase): Observable<ProjectItemPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectItemPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectItemPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param cashbookId (optional) 
     * @return Success
     */
    updateCashbookIdProjectItem(id: number | undefined, cashbookId: number | undefined): Observable<ProjectItemDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/UpdateCashbookIdProjectItem?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (cashbookId === null)
            throw new Error("The parameter 'cashbookId' cannot be null.");
        else if (cashbookId !== undefined)
            url_ += "cashbookId=" + encodeURIComponent("" + cashbookId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateCashbookIdProjectItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCashbookIdProjectItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectItemDto>;
        }));
    }

    protected processUpdateCashbookIdProjectItem(response: HttpResponseBase): Observable<ProjectItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectItemDto>(null as any);
    }

    /**
     * @param invoiceId (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateProjectItemList(invoiceId: string | undefined, body: ProjectItemDto[] | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Project/UpdateProjectItemList?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateProjectItemList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProjectItemList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateProjectItemList(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateProjectItem(id: number | undefined, body: ProjectItemDto | undefined): Observable<ProjectItemDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/UpdateProjectItem?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateProjectItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProjectItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectItemDto>;
        }));
    }

    protected processUpdateProjectItem(response: HttpResponseBase): Observable<ProjectItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reverseToContractAsset(body: ProjectItemDto | undefined): Observable<ProjectItemDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/ReverseToContractAsset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processReverseToContractAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReverseToContractAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectItemDto>;
        }));
    }

    protected processReverseToContractAsset(response: HttpResponseBase): Observable<ProjectItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findAndDeleteProjectItem(body: ProjectItemDto | undefined): Observable<ProjectItemDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/FindAndDeleteProjectItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processFindAndDeleteProjectItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindAndDeleteProjectItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectItemDto>;
        }));
    }

    protected processFindAndDeleteProjectItem(response: HttpResponseBase): Observable<ProjectItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProjectStaffHours(body: ProjectStaffHoursDto | undefined): Observable<ProjectStaffHoursDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/CreateProjectStaffHours";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateProjectStaffHours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProjectStaffHours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStaffHoursDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStaffHoursDto>;
        }));
    }

    protected processCreateProjectStaffHours(response: HttpResponseBase): Observable<ProjectStaffHoursDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectStaffHoursDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectStaffHoursDto>(null as any);
    }

    /**
     * @param projectStaffId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getProjectStaffHours(projectStaffId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<ProjectStaffHours[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetProjectStaffHours?";
        if (projectStaffId === null)
            throw new Error("The parameter 'projectStaffId' cannot be null.");
        else if (projectStaffId !== undefined)
            url_ += "projectStaffId=" + encodeURIComponent("" + projectStaffId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProjectStaffHours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectStaffHours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStaffHours[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStaffHours[]>;
        }));
    }

    protected processGetProjectStaffHours(response: HttpResponseBase): Observable<ProjectStaffHours[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(ProjectStaffHours.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectStaffHours[]>(null as any);
    }

    /**
     * @param cashbookId (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateCashbookIdProjectStaffHours(cashbookId: number | undefined, body: ProjectStaffHours[] | undefined): Observable<ProjectStaffHours[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/UpdateCashbookIdProjectStaffHours?";
        if (cashbookId === null)
            throw new Error("The parameter 'cashbookId' cannot be null.");
        else if (cashbookId !== undefined)
            url_ += "cashbookId=" + encodeURIComponent("" + cashbookId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateCashbookIdProjectStaffHours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCashbookIdProjectStaffHours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStaffHours[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStaffHours[]>;
        }));
    }

    protected processUpdateCashbookIdProjectStaffHours(response: HttpResponseBase): Observable<ProjectStaffHours[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(ProjectStaffHours.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectStaffHours[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteProjectStaffHours(id: number | undefined): Observable<ProjectStaffHoursDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/DeleteProjectStaffHours?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteProjectStaffHours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProjectStaffHours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStaffHoursDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStaffHoursDto>;
        }));
    }

    protected processDeleteProjectStaffHours(response: HttpResponseBase): Observable<ProjectStaffHoursDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectStaffHoursDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectStaffHoursDto>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    deleteProjectAndStaffs(projectId: number | undefined): Observable<ProjectDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/DeleteProjectAndStaffs?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteProjectAndStaffs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProjectAndStaffs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDto>;
        }));
    }

    protected processDeleteProjectAndStaffs(response: HttpResponseBase): Observable<ProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectDto>(null as any);
    }

    /**
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getTotalProjectRevenue(endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetTotalProjectRevenue?";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTotalProjectRevenue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalProjectRevenue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTotalProjectRevenue(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param projectStaffId (optional) 
     * @return Success
     */
    getLatestCostPerHour(projectId: number | undefined, projectStaffId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetLatestCostPerHour?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (projectStaffId === null)
            throw new Error("The parameter 'projectStaffId' cannot be null.");
        else if (projectStaffId !== undefined)
            url_ += "projectStaffId=" + encodeURIComponent("" + projectStaffId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLatestCostPerHour(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestCostPerHour(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetLatestCostPerHour(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProjectBudget(body: ProjectBudgetDto | undefined): Observable<ProjectBudgetDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/CreateProjectBudget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateProjectBudget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProjectBudget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectBudgetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectBudgetDto>;
        }));
    }

    protected processCreateProjectBudget(response: HttpResponseBase): Observable<ProjectBudgetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectBudgetDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectBudgetDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getProjectBudgetById(id: number | undefined): Observable<ProjectBudgetDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetProjectBudgetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProjectBudgetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectBudgetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectBudgetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectBudgetDto>;
        }));
    }

    protected processGetProjectBudgetById(response: HttpResponseBase): Observable<ProjectBudgetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectBudgetDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectBudgetDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getProjectBudgetsByTenantId(tenantId: number | undefined): Observable<ProjectBudgetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetProjectBudgetsByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProjectBudgetsByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectBudgetsByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectBudgetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectBudgetDto[]>;
        }));
    }

    protected processGetProjectBudgetsByTenantId(response: HttpResponseBase): Observable<ProjectBudgetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(ProjectBudgetDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectBudgetDto[]>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    getProjectBudgetsByProjectId(projectId: number | undefined): Observable<ProjectBudgetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/GetProjectBudgetsByProjectId?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProjectBudgetsByProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectBudgetsByProjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectBudgetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectBudgetDto[]>;
        }));
    }

    protected processGetProjectBudgetsByProjectId(response: HttpResponseBase): Observable<ProjectBudgetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(ProjectBudgetDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectBudgetDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProjectBudget(body: ProjectBudgetDto | undefined): Observable<ProjectBudgetDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/UpdateProjectBudget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateProjectBudget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProjectBudget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectBudgetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectBudgetDto>;
        }));
    }

    protected processUpdateProjectBudget(response: HttpResponseBase): Observable<ProjectBudgetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectBudgetDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectBudgetDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteProjectBudgetById(id: number | undefined): Observable<ProjectBudgetDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/DeleteProjectBudgetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteProjectBudgetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProjectBudgetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectBudgetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectBudgetDto>;
        }));
    }

    protected processDeleteProjectBudgetById(response: HttpResponseBase): Observable<ProjectBudgetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectBudgetDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectBudgetDto>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    deleteProjectBudgetsByProjectId(projectId: number | undefined): Observable<ProjectBudgetDto> {
        let url_ = this.baseUrl + "/api/services/app/Project/DeleteProjectBudgetsByProjectId?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteProjectBudgetsByProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProjectBudgetsByProjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectBudgetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectBudgetDto>;
        }));
    }

    protected processDeleteProjectBudgetsByProjectId(response: HttpResponseBase): Observable<ProjectBudgetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectBudgetDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectBudgetDto>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param body (optional) 
     * @return Success
     */
    checkMigrationData(projectId: number | undefined, body: ProjectBudgetMigrationDto[] | undefined): Observable<ProjectBudgetMigrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/CheckMigrationData?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckMigrationData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckMigrationData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectBudgetMigrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectBudgetMigrationDto[]>;
        }));
    }

    protected processCheckMigrationData(response: HttpResponseBase): Observable<ProjectBudgetMigrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(ProjectBudgetMigrationDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectBudgetMigrationDto[]>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createProjectBudgetFromMigration(projectId: number | undefined, body: ProjectBudgetMigrationDto[] | undefined): Observable<ProjectBudgetMigrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/CreateProjectBudgetFromMigration?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateProjectBudgetFromMigration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateProjectBudgetFromMigration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectBudgetMigrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectBudgetMigrationDto[]>;
        }));
    }

    protected processCreateProjectBudgetFromMigration(response: HttpResponseBase): Observable<ProjectBudgetMigrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(ProjectBudgetMigrationDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectBudgetMigrationDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateProjectBudgetFromList(body: ProjectBudgetDto[] | undefined): Observable<ProjectBudgetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Project/CreateOrUpdateProjectBudgetFromList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrUpdateProjectBudgetFromList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateProjectBudgetFromList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectBudgetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectBudgetDto[]>;
        }));
    }

    protected processCreateOrUpdateProjectBudgetFromList(response: HttpResponseBase): Observable<ProjectBudgetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(ProjectBudgetDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectBudgetDto[]>(null as any);
    }
}

@Injectable()
export class PurchaseOrdersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPurchaseOrder(body: PurchaseOrdersDto | undefined): Observable<PurchaseOrdersDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrders/CreatePurchaseOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePurchaseOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePurchaseOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrdersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrdersDto>;
        }));
    }

    protected processCreatePurchaseOrder(response: HttpResponseBase): Observable<PurchaseOrdersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrdersDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrdersDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    syncCreatePurchaseOrder(body: PurchaseOrdersDto | undefined): Observable<PurchaseOrdersDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrders/SyncCreatePurchaseOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSyncCreatePurchaseOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncCreatePurchaseOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrdersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrdersDto>;
        }));
    }

    protected processSyncCreatePurchaseOrder(response: HttpResponseBase): Observable<PurchaseOrdersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrdersDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrdersDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getPurchaseOrders(tenantId: number | undefined): Observable<PurchaseOrders[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrders/GetPurchaseOrders?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrders[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrders[]>;
        }));
    }

    protected processGetPurchaseOrders(response: HttpResponseBase): Observable<PurchaseOrders[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseOrders.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrders[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getPurchaseOrdersWithApproval(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<PurchaseOrdersPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrders/GetPurchaseOrdersWithApproval?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseOrdersWithApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseOrdersWithApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrdersPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrdersPagedResultDto>;
        }));
    }

    protected processGetPurchaseOrdersWithApproval(response: HttpResponseBase): Observable<PurchaseOrdersPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrdersPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrdersPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPurchaseOrdersById(id: number | undefined): Observable<PurchaseOrders> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrders/GetPurchaseOrdersById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseOrdersById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseOrdersById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrders>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrders>;
        }));
    }

    protected processGetPurchaseOrdersById(response: HttpResponseBase): Observable<PurchaseOrders> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrders.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrders>(null as any);
    }

    /**
     * @param purchaseOrderReferenceNumber (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getPurchaseOrderByReferenceNumber(purchaseOrderReferenceNumber: string | undefined, tenantId: number | undefined): Observable<PurchaseOrders> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrders/GetPurchaseOrderByReferenceNumber?";
        if (purchaseOrderReferenceNumber === null)
            throw new Error("The parameter 'purchaseOrderReferenceNumber' cannot be null.");
        else if (purchaseOrderReferenceNumber !== undefined)
            url_ += "purchaseOrderReferenceNumber=" + encodeURIComponent("" + purchaseOrderReferenceNumber) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseOrderByReferenceNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseOrderByReferenceNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrders>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrders>;
        }));
    }

    protected processGetPurchaseOrderByReferenceNumber(response: HttpResponseBase): Observable<PurchaseOrders> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrders.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrders>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getPurchaseOrdersWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<PurchaseOrdersDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrders/GetPurchaseOrdersWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseOrdersWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseOrdersWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrdersDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrdersDtoPagedResultDto>;
        }));
    }

    protected processGetPurchaseOrdersWithInput(response: HttpResponseBase): Observable<PurchaseOrdersDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrdersDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrdersDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatePurchaseOrders(id: number | undefined, body: PurchaseOrdersDto | undefined): Observable<PurchaseOrdersDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrders/UpdatePurchaseOrders?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePurchaseOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePurchaseOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrdersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrdersDto>;
        }));
    }

    protected processUpdatePurchaseOrders(response: HttpResponseBase): Observable<PurchaseOrdersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrdersDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrdersDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatePurchaseOrdersInvoice(id: number | undefined, body: PurchaseOrdersDto | undefined): Observable<PurchaseOrdersDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrders/UpdatePurchaseOrdersInvoice?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePurchaseOrdersInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePurchaseOrdersInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrdersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrdersDto>;
        }));
    }

    protected processUpdatePurchaseOrdersInvoice(response: HttpResponseBase): Observable<PurchaseOrdersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrdersDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrdersDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param status (optional) 
     * @return Success
     */
    updatePurchaseOrdersStatus(id: number | undefined, status: string | undefined): Observable<PurchaseOrdersDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrders/UpdatePurchaseOrdersStatus?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePurchaseOrdersStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePurchaseOrdersStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrdersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrdersDto>;
        }));
    }

    protected processUpdatePurchaseOrdersStatus(response: HttpResponseBase): Observable<PurchaseOrdersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrdersDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrdersDto>(null as any);
    }

    /**
     * @param poId (optional) 
     * @param prId (optional) 
     * @return Success
     */
    deletePurchaseOrder(poId: number | undefined, prId: number | undefined): Observable<PurchaseOrdersDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrders/DeletePurchaseOrder?";
        if (poId === null)
            throw new Error("The parameter 'poId' cannot be null.");
        else if (poId !== undefined)
            url_ += "poId=" + encodeURIComponent("" + poId) + "&";
        if (prId === null)
            throw new Error("The parameter 'prId' cannot be null.");
        else if (prId !== undefined)
            url_ += "prId=" + encodeURIComponent("" + prId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeletePurchaseOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePurchaseOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrdersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrdersDto>;
        }));
    }

    protected processDeletePurchaseOrder(response: HttpResponseBase): Observable<PurchaseOrdersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrdersDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrdersDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendPurchaseOrderWithPdf(body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrders/SendPurchaseOrderWithPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendPurchaseOrderWithPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPurchaseOrderWithPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendPurchaseOrderWithPdf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendEmailToApproverWithPdf(body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrders/SendEmailToApproverWithPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendEmailToApproverWithPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailToApproverWithPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendEmailToApproverWithPdf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendEmailToFinalApproverWithPdf(body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrders/SendEmailToFinalApproverWithPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendEmailToFinalApproverWithPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailToFinalApproverWithPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendEmailToFinalApproverWithPdf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendApprovedPurchaseOrderWithPdf(body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrders/SendApprovedPurchaseOrderWithPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendApprovedPurchaseOrderWithPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendApprovedPurchaseOrderWithPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendApprovedPurchaseOrderWithPdf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getPurchseOrderWithRange(tenantId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<PurchaseOrders[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrders/GetPurchseOrderWithRange?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchseOrderWithRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchseOrderWithRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrders[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrders[]>;
        }));
    }

    protected processGetPurchseOrderWithRange(response: HttpResponseBase): Observable<PurchaseOrders[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseOrders.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrders[]>(null as any);
    }
}

@Injectable()
export class PurchaseOrdersItemsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPurchaseOrderItem(body: PurchaseOrderItemDto | undefined): Observable<PurchaseOrderItemDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrdersItems/CreatePurchaseOrderItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePurchaseOrderItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePurchaseOrderItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrderItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrderItemDto>;
        }));
    }

    protected processCreatePurchaseOrderItem(response: HttpResponseBase): Observable<PurchaseOrderItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrderItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrderItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    syncCreatePurchaseOrderItem(body: PurchaseOrderItemDto | undefined): Observable<PurchaseOrderItemDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrdersItems/SyncCreatePurchaseOrderItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSyncCreatePurchaseOrderItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncCreatePurchaseOrderItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrderItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrderItemDto>;
        }));
    }

    protected processSyncCreatePurchaseOrderItem(response: HttpResponseBase): Observable<PurchaseOrderItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrderItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrderItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createListPurchaseOrderItem(body: PurchaseOrderItemDto[] | undefined): Observable<PurchaseOrderItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrdersItems/CreateListPurchaseOrderItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateListPurchaseOrderItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateListPurchaseOrderItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrderItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrderItemDto[]>;
        }));
    }

    protected processCreateListPurchaseOrderItem(response: HttpResponseBase): Observable<PurchaseOrderItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseOrderItemDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrderItemDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getPurchaseOrderItems(tenantId: number | undefined): Observable<PurchaseOrderItem[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrdersItems/GetPurchaseOrderItems?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseOrderItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseOrderItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrderItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrderItem[]>;
        }));
    }

    protected processGetPurchaseOrderItems(response: HttpResponseBase): Observable<PurchaseOrderItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseOrderItem.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrderItem[]>(null as any);
    }

    /**
     * @param purchaseOrderId (optional) 
     * @return Success
     */
    getPurchaseOrderItemsByPurchaseOrderId(purchaseOrderId: number | undefined): Observable<PurchaseOrderItem[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrdersItems/GetPurchaseOrderItemsByPurchaseOrderId?";
        if (purchaseOrderId === null)
            throw new Error("The parameter 'purchaseOrderId' cannot be null.");
        else if (purchaseOrderId !== undefined)
            url_ += "purchaseOrderId=" + encodeURIComponent("" + purchaseOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseOrderItemsByPurchaseOrderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseOrderItemsByPurchaseOrderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrderItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrderItem[]>;
        }));
    }

    protected processGetPurchaseOrderItemsByPurchaseOrderId(response: HttpResponseBase): Observable<PurchaseOrderItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseOrderItem.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrderItem[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPurchaseOrderItemById(id: number | undefined): Observable<PurchaseOrderItem> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrdersItems/GetPurchaseOrderItemById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseOrderItemById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseOrderItemById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrderItem>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrderItem>;
        }));
    }

    protected processGetPurchaseOrderItemById(response: HttpResponseBase): Observable<PurchaseOrderItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrderItem.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrderItem>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPoItemByPrItemId(id: number | undefined): Observable<PurchaseOrderItemDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrdersItems/GetPoItemByPrItemId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPoItemByPrItemId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPoItemByPrItemId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrderItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrderItemDto>;
        }));
    }

    protected processGetPoItemByPrItemId(response: HttpResponseBase): Observable<PurchaseOrderItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrderItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrderItemDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getPurchaseOrderItemsWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<PurchaseOrderItemPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrdersItems/GetPurchaseOrderItemsWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseOrderItemsWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseOrderItemsWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrderItemPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrderItemPagedResultDto>;
        }));
    }

    protected processGetPurchaseOrderItemsWithInput(response: HttpResponseBase): Observable<PurchaseOrderItemPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrderItemPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrderItemPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatePurchaseOrderItem(id: number | undefined, body: PurchaseOrderItemDto | undefined): Observable<PurchaseOrderItemDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrdersItems/UpdatePurchaseOrderItem?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePurchaseOrderItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePurchaseOrderItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrderItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrderItemDto>;
        }));
    }

    protected processUpdatePurchaseOrderItem(response: HttpResponseBase): Observable<PurchaseOrderItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrderItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrderItemDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deletePurchaseOrderItem(id: number | undefined): Observable<PurchaseOrderItemDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrdersItems/DeletePurchaseOrderItem?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeletePurchaseOrderItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePurchaseOrderItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrderItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrderItemDto>;
        }));
    }

    protected processDeletePurchaseOrderItem(response: HttpResponseBase): Observable<PurchaseOrderItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrderItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrderItemDto>(null as any);
    }

    /**
     * @param purchaseRequisitionItemId (optional) 
     * @param tenantId (optional) 
     * @param purchaseOrderId (optional) 
     * @return Success
     */
    deletePoItemByPrItemId(purchaseRequisitionItemId: number | undefined, tenantId: number | undefined, purchaseOrderId: number | undefined): Observable<PurchaseOrderItemDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrdersItems/DeletePoItemByPrItemId?";
        if (purchaseRequisitionItemId === null)
            throw new Error("The parameter 'purchaseRequisitionItemId' cannot be null.");
        else if (purchaseRequisitionItemId !== undefined)
            url_ += "purchaseRequisitionItemId=" + encodeURIComponent("" + purchaseRequisitionItemId) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (purchaseOrderId === null)
            throw new Error("The parameter 'purchaseOrderId' cannot be null.");
        else if (purchaseOrderId !== undefined)
            url_ += "purchaseOrderId=" + encodeURIComponent("" + purchaseOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeletePoItemByPrItemId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePoItemByPrItemId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrderItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrderItemDto>;
        }));
    }

    protected processDeletePoItemByPrItemId(response: HttpResponseBase): Observable<PurchaseOrderItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrderItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrderItemDto>(null as any);
    }

    /**
     * @param purchaseRequisitionItemId (optional) 
     * @param tenantId (optional) 
     * @param purchaseOrderId (optional) 
     * @return Success
     */
    deleteListPoItemByPrItemId(purchaseRequisitionItemId: number[] | undefined, tenantId: number | undefined, purchaseOrderId: number | undefined): Observable<PurchaseOrderItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrdersItems/DeleteListPoItemByPrItemId?";
        if (purchaseRequisitionItemId === null)
            throw new Error("The parameter 'purchaseRequisitionItemId' cannot be null.");
        else if (purchaseRequisitionItemId !== undefined)
            purchaseRequisitionItemId && purchaseRequisitionItemId.forEach(item => { url_ += "purchaseRequisitionItemId=" + encodeURIComponent("" + item) + "&"; });
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (purchaseOrderId === null)
            throw new Error("The parameter 'purchaseOrderId' cannot be null.");
        else if (purchaseOrderId !== undefined)
            url_ += "purchaseOrderId=" + encodeURIComponent("" + purchaseOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteListPoItemByPrItemId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteListPoItemByPrItemId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrderItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrderItemDto[]>;
        }));
    }

    protected processDeleteListPoItemByPrItemId(response: HttpResponseBase): Observable<PurchaseOrderItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseOrderItemDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrderItemDto[]>(null as any);
    }
}

@Injectable()
export class PurchaseOrdersPublicServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPurchaseOrdersById(id: number | undefined): Observable<PurchaseOrders> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrdersPublic/GetPurchaseOrdersById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseOrdersById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseOrdersById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrders>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrders>;
        }));
    }

    protected processGetPurchaseOrdersById(response: HttpResponseBase): Observable<PurchaseOrders> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrders.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrders>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatePurchaseOrdersInvoice(id: number | undefined, body: PurchaseOrdersDto | undefined): Observable<PurchaseOrdersDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrdersPublic/UpdatePurchaseOrdersInvoice?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePurchaseOrdersInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePurchaseOrdersInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrdersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrdersDto>;
        }));
    }

    protected processUpdatePurchaseOrdersInvoice(response: HttpResponseBase): Observable<PurchaseOrdersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseOrdersDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrdersDto>(null as any);
    }

    /**
     * @param purchaseOrderId (optional) 
     * @return Success
     */
    getPurchaseOrderItemsByPurchaseOrderId(purchaseOrderId: number | undefined): Observable<PurchaseOrderItem[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrdersPublic/GetPurchaseOrderItemsByPurchaseOrderId?";
        if (purchaseOrderId === null)
            throw new Error("The parameter 'purchaseOrderId' cannot be null.");
        else if (purchaseOrderId !== undefined)
            url_ += "purchaseOrderId=" + encodeURIComponent("" + purchaseOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseOrderItemsByPurchaseOrderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseOrderItemsByPurchaseOrderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrderItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrderItem[]>;
        }));
    }

    protected processGetPurchaseOrderItemsByPurchaseOrderId(response: HttpResponseBase): Observable<PurchaseOrderItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseOrderItem.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrderItem[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createVendorInvoice(body: VendorInvoiceDto | undefined): Observable<VendorInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrdersPublic/CreateVendorInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateVendorInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateVendorInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceDto>;
        }));
    }

    protected processCreateVendorInvoice(response: HttpResponseBase): Observable<VendorInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorInvoiceDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createVendorInvoiceItem(body: VendorInvoiceItemDto | undefined): Observable<VendorInvoiceItemDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrdersPublic/CreateVendorInvoiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateVendorInvoiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateVendorInvoiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItemDto>;
        }));
    }

    protected processCreateVendorInvoiceItem(response: HttpResponseBase): Observable<VendorInvoiceItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorInvoiceItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createListVendorInvoiceItem(body: VendorInvoiceItemDto[] | undefined): Observable<VendorInvoiceItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrdersPublic/CreateListVendorInvoiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateListVendorInvoiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateListVendorInvoiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItemDto[]>;
        }));
    }

    protected processCreateListVendorInvoiceItem(response: HttpResponseBase): Observable<VendorInvoiceItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(VendorInvoiceItemDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItemDto[]>(null as any);
    }

    /**
     * @param purchaseOrderId (optional) 
     * @return Success
     */
    getVendorInvoicesByPurchaseOrderId(purchaseOrderId: number | undefined): Observable<VendorInvoice[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrdersPublic/GetVendorInvoicesByPurchaseOrderId?";
        if (purchaseOrderId === null)
            throw new Error("The parameter 'purchaseOrderId' cannot be null.");
        else if (purchaseOrderId !== undefined)
            url_ += "purchaseOrderId=" + encodeURIComponent("" + purchaseOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVendorInvoicesByPurchaseOrderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorInvoicesByPurchaseOrderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoice[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoice[]>;
        }));
    }

    protected processGetVendorInvoicesByPurchaseOrderId(response: HttpResponseBase): Observable<VendorInvoice[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(VendorInvoice.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoice[]>(null as any);
    }

    /**
     * @param vendorInvoiceId (optional) 
     * @return Success
     */
    getVendorInvoiceItemsByVendorInvoiceId(vendorInvoiceId: number | undefined): Observable<VendorInvoiceItem[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrdersPublic/GetVendorInvoiceItemsByVendorInvoiceId?";
        if (vendorInvoiceId === null)
            throw new Error("The parameter 'vendorInvoiceId' cannot be null.");
        else if (vendorInvoiceId !== undefined)
            url_ += "vendorInvoiceId=" + encodeURIComponent("" + vendorInvoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVendorInvoiceItemsByVendorInvoiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorInvoiceItemsByVendorInvoiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItem[]>;
        }));
    }

    protected processGetVendorInvoiceItemsByVendorInvoiceId(response: HttpResponseBase): Observable<VendorInvoiceItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(VendorInvoiceItem.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItem[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateVendorInvoice(id: number | undefined, body: VendorInvoiceDto | undefined): Observable<VendorInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrdersPublic/UpdateVendorInvoice?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateVendorInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVendorInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceDto>;
        }));
    }

    protected processUpdateVendorInvoice(response: HttpResponseBase): Observable<VendorInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorInvoiceDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateListVendorInvoiceItem(body: VendorInvoiceItemDto[] | undefined): Observable<VendorInvoiceItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrdersPublic/UpdateListVendorInvoiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateListVendorInvoiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateListVendorInvoiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItemDto[]>;
        }));
    }

    protected processUpdateListVendorInvoiceItem(response: HttpResponseBase): Observable<VendorInvoiceItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(VendorInvoiceItemDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItemDto[]>(null as any);
    }

    /**
     * @param vendorInvoiceId (optional) 
     * @return Success
     */
    getGoodsReceivedNoteByVendorInvoiceId(vendorInvoiceId: number | undefined): Observable<GoodsReceivedNotes> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrdersPublic/GetGoodsReceivedNoteByVendorInvoiceId?";
        if (vendorInvoiceId === null)
            throw new Error("The parameter 'vendorInvoiceId' cannot be null.");
        else if (vendorInvoiceId !== undefined)
            url_ += "vendorInvoiceId=" + encodeURIComponent("" + vendorInvoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetGoodsReceivedNoteByVendorInvoiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGoodsReceivedNoteByVendorInvoiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GoodsReceivedNotes>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GoodsReceivedNotes>;
        }));
    }

    protected processGetGoodsReceivedNoteByVendorInvoiceId(response: HttpResponseBase): Observable<GoodsReceivedNotes> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GoodsReceivedNotes.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodsReceivedNotes>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateGoodsReceivedNoteDo(id: number | undefined, body: GoodsReceivedNoteDto | undefined): Observable<GoodsReceivedNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseOrdersPublic/UpdateGoodsReceivedNoteDo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateGoodsReceivedNoteDo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGoodsReceivedNoteDo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GoodsReceivedNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GoodsReceivedNoteDto>;
        }));
    }

    protected processUpdateGoodsReceivedNoteDo(response: HttpResponseBase): Observable<GoodsReceivedNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GoodsReceivedNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GoodsReceivedNoteDto>(null as any);
    }
}

@Injectable()
export class PurchaseRequisitionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPurchaseRequisition(body: PurchaseRequisitionDto | undefined): Observable<PurchaseRequisitionDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/CreatePurchaseRequisition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePurchaseRequisition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePurchaseRequisition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionDto>;
        }));
    }

    protected processCreatePurchaseRequisition(response: HttpResponseBase): Observable<PurchaseRequisitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    syncCreatePurchaseRequisition(body: PurchaseRequisitionDto | undefined): Observable<PurchaseRequisitionDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/SyncCreatePurchaseRequisition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSyncCreatePurchaseRequisition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncCreatePurchaseRequisition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionDto>;
        }));
    }

    protected processSyncCreatePurchaseRequisition(response: HttpResponseBase): Observable<PurchaseRequisitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionDto>(null as any);
    }

    /**
     * @param purchaseRequisitionId (optional) 
     * @return Success
     */
    getPurchaseRequisition(purchaseRequisitionId: number | undefined): Observable<PurchaseRequisition[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/GetPurchaseRequisition?";
        if (purchaseRequisitionId === null)
            throw new Error("The parameter 'purchaseRequisitionId' cannot be null.");
        else if (purchaseRequisitionId !== undefined)
            url_ += "purchaseRequisitionId=" + encodeURIComponent("" + purchaseRequisitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseRequisition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseRequisition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisition[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisition[]>;
        }));
    }

    protected processGetPurchaseRequisition(response: HttpResponseBase): Observable<PurchaseRequisition[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseRequisition.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisition[]>(null as any);
    }

    /**
     * @param purchaseRequisitionId (optional) 
     * @return Success
     */
    getPrObjectAndDtoById(purchaseRequisitionId: number | undefined): Observable<PurchaseRequisitionDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/GetPrObjectAndDtoById?";
        if (purchaseRequisitionId === null)
            throw new Error("The parameter 'purchaseRequisitionId' cannot be null.");
        else if (purchaseRequisitionId !== undefined)
            url_ += "purchaseRequisitionId=" + encodeURIComponent("" + purchaseRequisitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPrObjectAndDtoById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrObjectAndDtoById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionDto>;
        }));
    }

    protected processGetPrObjectAndDtoById(response: HttpResponseBase): Observable<PurchaseRequisitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionDto>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getAllRequisitionForLedger(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<LedgerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/GetAllRequisitionForLedger?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllRequisitionForLedger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRequisitionForLedger(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LedgerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LedgerDto[]>;
        }));
    }

    protected processGetAllRequisitionForLedger(response: HttpResponseBase): Observable<LedgerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(LedgerDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LedgerDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getPurchaseRequisitionWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<PurchaseRequisitionPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/GetPurchaseRequisitionWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseRequisitionWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseRequisitionWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionPagedResultDto>;
        }));
    }

    protected processGetPurchaseRequisitionWithInput(response: HttpResponseBase): Observable<PurchaseRequisitionPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionPagedResultDto>(null as any);
    }

    /**
     * @param purchaseRequisitionId (optional) 
     * @return Success
     */
    getPurchaseRequisitionById(purchaseRequisitionId: number | undefined): Observable<PurchaseRequisition> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/GetPurchaseRequisitionById?";
        if (purchaseRequisitionId === null)
            throw new Error("The parameter 'purchaseRequisitionId' cannot be null.");
        else if (purchaseRequisitionId !== undefined)
            url_ += "purchaseRequisitionId=" + encodeURIComponent("" + purchaseRequisitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseRequisitionById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseRequisitionById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisition>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisition>;
        }));
    }

    protected processGetPurchaseRequisitionById(response: HttpResponseBase): Observable<PurchaseRequisition> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisition.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisition>(null as any);
    }

    /**
     * @param vendorInvoiceId (optional) 
     * @return Success
     */
    getPurchaseRequisitionByVendorInvoiceId(vendorInvoiceId: number | undefined): Observable<PurchaseRequisitionDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/GetPurchaseRequisitionByVendorInvoiceId?";
        if (vendorInvoiceId === null)
            throw new Error("The parameter 'vendorInvoiceId' cannot be null.");
        else if (vendorInvoiceId !== undefined)
            url_ += "vendorInvoiceId=" + encodeURIComponent("" + vendorInvoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseRequisitionByVendorInvoiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseRequisitionByVendorInvoiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionDto>;
        }));
    }

    protected processGetPurchaseRequisitionByVendorInvoiceId(response: HttpResponseBase): Observable<PurchaseRequisitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionDto>(null as any);
    }

    /**
     * @param purchaseRequisitionId (optional) 
     * @return Success
     */
    getPurchaseRequisitionDtoById(purchaseRequisitionId: number | undefined): Observable<PurchaseRequisitionDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/GetPurchaseRequisitionDtoById?";
        if (purchaseRequisitionId === null)
            throw new Error("The parameter 'purchaseRequisitionId' cannot be null.");
        else if (purchaseRequisitionId !== undefined)
            url_ += "purchaseRequisitionId=" + encodeURIComponent("" + purchaseRequisitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseRequisitionDtoById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseRequisitionDtoById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionDto>;
        }));
    }

    protected processGetPurchaseRequisitionDtoById(response: HttpResponseBase): Observable<PurchaseRequisitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionDto>(null as any);
    }

    /**
     * @param purchaseRequisitionReferenceNumber (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getPurchaseRequisitionByReferenceNumber(purchaseRequisitionReferenceNumber: string | undefined, tenantId: number | undefined): Observable<PurchaseRequisition> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/GetPurchaseRequisitionByReferenceNumber?";
        if (purchaseRequisitionReferenceNumber === null)
            throw new Error("The parameter 'purchaseRequisitionReferenceNumber' cannot be null.");
        else if (purchaseRequisitionReferenceNumber !== undefined)
            url_ += "purchaseRequisitionReferenceNumber=" + encodeURIComponent("" + purchaseRequisitionReferenceNumber) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseRequisitionByReferenceNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseRequisitionByReferenceNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisition>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisition>;
        }));
    }

    protected processGetPurchaseRequisitionByReferenceNumber(response: HttpResponseBase): Observable<PurchaseRequisition> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisition.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisition>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getPurchaseRequisitionWithApproval(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<PurchaseRequisitionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/GetPurchaseRequisitionWithApproval?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseRequisitionWithApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseRequisitionWithApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionDtoPagedResultDto>;
        }));
    }

    protected processGetPurchaseRequisitionWithApproval(response: HttpResponseBase): Observable<PurchaseRequisitionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionDtoPagedResultDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getPurchaseRequisitionCalledForQuotation(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<PurchaseRequisitionPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/GetPurchaseRequisitionCalledForQuotation?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseRequisitionCalledForQuotation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseRequisitionCalledForQuotation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionPagedResultDto>;
        }));
    }

    protected processGetPurchaseRequisitionCalledForQuotation(response: HttpResponseBase): Observable<PurchaseRequisitionPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatePurchaseRequisition(id: number | undefined, body: PurchaseRequisitionDto | undefined): Observable<PurchaseRequisitionDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/UpdatePurchaseRequisition?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePurchaseRequisition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePurchaseRequisition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionDto>;
        }));
    }

    protected processUpdatePurchaseRequisition(response: HttpResponseBase): Observable<PurchaseRequisitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    editPurchaseRequisition(id: number | undefined, body: PurchaseRequisitionDto | undefined): Observable<PurchaseRequisitionDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/EditPurchaseRequisition?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processEditPurchaseRequisition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditPurchaseRequisition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionDto>;
        }));
    }

    protected processEditPurchaseRequisition(response: HttpResponseBase): Observable<PurchaseRequisitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param isCalledForQuotation (optional) 
     * @return Success
     */
    updateCalledForQuotationStatusById(id: number | undefined, isCalledForQuotation: boolean | undefined): Observable<PurchaseRequisitionDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/UpdateCalledForQuotationStatusById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isCalledForQuotation === null)
            throw new Error("The parameter 'isCalledForQuotation' cannot be null.");
        else if (isCalledForQuotation !== undefined)
            url_ += "isCalledForQuotation=" + encodeURIComponent("" + isCalledForQuotation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateCalledForQuotationStatusById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCalledForQuotationStatusById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionDto>;
        }));
    }

    protected processUpdateCalledForQuotationStatusById(response: HttpResponseBase): Observable<PurchaseRequisitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deletePurchaseRequisition(id: number | undefined): Observable<PurchaseRequisitionDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/DeletePurchaseRequisition?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeletePurchaseRequisition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePurchaseRequisition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionDto>;
        }));
    }

    protected processDeletePurchaseRequisition(response: HttpResponseBase): Observable<PurchaseRequisitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param remarks (optional) 
     * @return Success
     */
    updateRemarksByPurchaseRequisitionId(id: number | undefined, remarks: string | undefined): Observable<PurchaseRequisitionDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/UpdateRemarksByPurchaseRequisitionId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (remarks === null)
            throw new Error("The parameter 'remarks' cannot be null.");
        else if (remarks !== undefined)
            url_ += "remarks=" + encodeURIComponent("" + remarks) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateRemarksByPurchaseRequisitionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRemarksByPurchaseRequisitionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionDto>;
        }));
    }

    protected processUpdateRemarksByPurchaseRequisitionId(response: HttpResponseBase): Observable<PurchaseRequisitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPurchaseRequisitionItems(body: PurchaseRequisitionItemsDto | undefined): Observable<PurchaseRequisitionItemsDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/CreatePurchaseRequisitionItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePurchaseRequisitionItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePurchaseRequisitionItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionItemsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionItemsDto>;
        }));
    }

    protected processCreatePurchaseRequisitionItems(response: HttpResponseBase): Observable<PurchaseRequisitionItemsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionItemsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionItemsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    syncCreatePurchaseRequisitionItems(body: PurchaseRequisitionItemsDto | undefined): Observable<PurchaseRequisitionItemsDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/SyncCreatePurchaseRequisitionItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSyncCreatePurchaseRequisitionItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncCreatePurchaseRequisitionItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionItemsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionItemsDto>;
        }));
    }

    protected processSyncCreatePurchaseRequisitionItems(response: HttpResponseBase): Observable<PurchaseRequisitionItemsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionItemsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionItemsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateListPurchaseRequisitionItems(body: PurchaseRequisitionItemsDto[] | undefined): Observable<PurchaseRequisitionItemsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/CreateOrUpdateListPurchaseRequisitionItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateOrUpdateListPurchaseRequisitionItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateListPurchaseRequisitionItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionItemsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionItemsDto[]>;
        }));
    }

    protected processCreateOrUpdateListPurchaseRequisitionItems(response: HttpResponseBase): Observable<PurchaseRequisitionItemsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseRequisitionItemsDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionItemsDto[]>(null as any);
    }

    /**
     * @param purchaseRequisitionId (optional) 
     * @return Success
     */
    getPurchaseRequisitionItems(purchaseRequisitionId: number | undefined): Observable<PurchaseRequisitionItems[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/GetPurchaseRequisitionItems?";
        if (purchaseRequisitionId === null)
            throw new Error("The parameter 'purchaseRequisitionId' cannot be null.");
        else if (purchaseRequisitionId !== undefined)
            url_ += "purchaseRequisitionId=" + encodeURIComponent("" + purchaseRequisitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseRequisitionItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseRequisitionItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionItems[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionItems[]>;
        }));
    }

    protected processGetPurchaseRequisitionItems(response: HttpResponseBase): Observable<PurchaseRequisitionItems[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseRequisitionItems.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionItems[]>(null as any);
    }

    /**
     * @param purchaseRequisitionId (optional) 
     * @return Success
     */
    getPurchaseRequisitionItemsDto(purchaseRequisitionId: number | undefined): Observable<PurchaseRequisitionItemsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/GetPurchaseRequisitionItemsDto?";
        if (purchaseRequisitionId === null)
            throw new Error("The parameter 'purchaseRequisitionId' cannot be null.");
        else if (purchaseRequisitionId !== undefined)
            url_ += "purchaseRequisitionId=" + encodeURIComponent("" + purchaseRequisitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseRequisitionItemsDto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseRequisitionItemsDto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionItemsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionItemsDto[]>;
        }));
    }

    protected processGetPurchaseRequisitionItemsDto(response: HttpResponseBase): Observable<PurchaseRequisitionItemsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseRequisitionItemsDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionItemsDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatePurchaseRequisitionItems(id: number | undefined, body: PurchaseRequisitionItemsDto | undefined): Observable<PurchaseRequisitionItemsDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/UpdatePurchaseRequisitionItems?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePurchaseRequisitionItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePurchaseRequisitionItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionItemsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionItemsDto>;
        }));
    }

    protected processUpdatePurchaseRequisitionItems(response: HttpResponseBase): Observable<PurchaseRequisitionItemsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionItemsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionItemsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatePurchaseRequisitionItemsGrnQuantity(id: number | undefined, body: PurchaseRequisitionItemsDto | undefined): Observable<PurchaseRequisitionItemsDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/UpdatePurchaseRequisitionItemsGrnQuantity?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePurchaseRequisitionItemsGrnQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePurchaseRequisitionItemsGrnQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionItemsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionItemsDto>;
        }));
    }

    protected processUpdatePurchaseRequisitionItemsGrnQuantity(response: HttpResponseBase): Observable<PurchaseRequisitionItemsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionItemsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionItemsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deletePurchaseRequisitionItems(id: number | undefined): Observable<PurchaseRequisitionItemsDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/DeletePurchaseRequisitionItems?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeletePurchaseRequisitionItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePurchaseRequisitionItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionItemsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionItemsDto>;
        }));
    }

    protected processDeletePurchaseRequisitionItems(response: HttpResponseBase): Observable<PurchaseRequisitionItemsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionItemsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionItemsDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    deleteListPurchaseRequisitionItems(input: number[] | undefined): Observable<PurchaseRequisitionItemsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/DeleteListPurchaseRequisitionItems?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            input && input.forEach(item => { url_ += "input=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteListPurchaseRequisitionItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteListPurchaseRequisitionItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionItemsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionItemsDto[]>;
        }));
    }

    protected processDeleteListPurchaseRequisitionItems(response: HttpResponseBase): Observable<PurchaseRequisitionItemsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseRequisitionItemsDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionItemsDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPurchaseRequisitionRecommendedVendors(body: PurchaseRequisitionRecommendedVendorsDto | undefined): Observable<PurchaseRequisitionRecommendedVendorsDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/CreatePurchaseRequisitionRecommendedVendors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePurchaseRequisitionRecommendedVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePurchaseRequisitionRecommendedVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionRecommendedVendorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionRecommendedVendorsDto>;
        }));
    }

    protected processCreatePurchaseRequisitionRecommendedVendors(response: HttpResponseBase): Observable<PurchaseRequisitionRecommendedVendorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionRecommendedVendorsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionRecommendedVendorsDto>(null as any);
    }

    /**
     * @param purchaseRequisitionId (optional) 
     * @return Success
     */
    getPurchaseRequisitionRecommendedVendors(purchaseRequisitionId: number | undefined): Observable<PurchaseRequisitionRecommendedVendors[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/GetPurchaseRequisitionRecommendedVendors?";
        if (purchaseRequisitionId === null)
            throw new Error("The parameter 'purchaseRequisitionId' cannot be null.");
        else if (purchaseRequisitionId !== undefined)
            url_ += "purchaseRequisitionId=" + encodeURIComponent("" + purchaseRequisitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseRequisitionRecommendedVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseRequisitionRecommendedVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionRecommendedVendors[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionRecommendedVendors[]>;
        }));
    }

    protected processGetPurchaseRequisitionRecommendedVendors(response: HttpResponseBase): Observable<PurchaseRequisitionRecommendedVendors[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseRequisitionRecommendedVendors.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionRecommendedVendors[]>(null as any);
    }

    /**
     * @param purchaseRequisitionId (optional) 
     * @param purchaseRequisitionRecommendedVendorsId (optional) 
     * @return Success
     */
    getPurchaseRequisitionRecommendedVendorsById(purchaseRequisitionId: number | undefined, purchaseRequisitionRecommendedVendorsId: number | undefined): Observable<PurchaseRequisitionRecommendedVendors> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/GetPurchaseRequisitionRecommendedVendorsById?";
        if (purchaseRequisitionId === null)
            throw new Error("The parameter 'purchaseRequisitionId' cannot be null.");
        else if (purchaseRequisitionId !== undefined)
            url_ += "purchaseRequisitionId=" + encodeURIComponent("" + purchaseRequisitionId) + "&";
        if (purchaseRequisitionRecommendedVendorsId === null)
            throw new Error("The parameter 'purchaseRequisitionRecommendedVendorsId' cannot be null.");
        else if (purchaseRequisitionRecommendedVendorsId !== undefined)
            url_ += "purchaseRequisitionRecommendedVendorsId=" + encodeURIComponent("" + purchaseRequisitionRecommendedVendorsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseRequisitionRecommendedVendorsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseRequisitionRecommendedVendorsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionRecommendedVendors>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionRecommendedVendors>;
        }));
    }

    protected processGetPurchaseRequisitionRecommendedVendorsById(response: HttpResponseBase): Observable<PurchaseRequisitionRecommendedVendors> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionRecommendedVendors.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionRecommendedVendors>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatePurchaseRequisitionRecommendedVendors(id: number | undefined, body: PurchaseRequisitionRecommendedVendorsDto | undefined): Observable<PurchaseRequisitionRecommendedVendorsDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/UpdatePurchaseRequisitionRecommendedVendors?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePurchaseRequisitionRecommendedVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePurchaseRequisitionRecommendedVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionRecommendedVendorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionRecommendedVendorsDto>;
        }));
    }

    protected processUpdatePurchaseRequisitionRecommendedVendors(response: HttpResponseBase): Observable<PurchaseRequisitionRecommendedVendorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionRecommendedVendorsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionRecommendedVendorsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateOrCreatePurchaseRequisitionRecommendedVendors(id: number | undefined, body: PurchaseRequisitionRecommendedVendorsDto | undefined): Observable<PurchaseRequisitionRecommendedVendorsDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/UpdateOrCreatePurchaseRequisitionRecommendedVendors?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateOrCreatePurchaseRequisitionRecommendedVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrCreatePurchaseRequisitionRecommendedVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionRecommendedVendorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionRecommendedVendorsDto>;
        }));
    }

    protected processUpdateOrCreatePurchaseRequisitionRecommendedVendors(response: HttpResponseBase): Observable<PurchaseRequisitionRecommendedVendorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionRecommendedVendorsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionRecommendedVendorsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    deletePurchaseRequisitionRecommendedVendors(id: number | undefined, tenantId: number | undefined): Observable<PurchaseRequisitionRecommendedVendorsDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/DeletePurchaseRequisitionRecommendedVendors?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeletePurchaseRequisitionRecommendedVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePurchaseRequisitionRecommendedVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionRecommendedVendorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionRecommendedVendorsDto>;
        }));
    }

    protected processDeletePurchaseRequisitionRecommendedVendors(response: HttpResponseBase): Observable<PurchaseRequisitionRecommendedVendorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionRecommendedVendorsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionRecommendedVendorsDto>(null as any);
    }

    /**
     * @param ids (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    deleteListPurchaseRequisitionRecommendedVendors(ids: number[] | undefined, tenantId: number | undefined): Observable<PurchaseRequisitionRecommendedVendorsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/DeleteListPurchaseRequisitionRecommendedVendors?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteListPurchaseRequisitionRecommendedVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteListPurchaseRequisitionRecommendedVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionRecommendedVendorsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionRecommendedVendorsDto[]>;
        }));
    }

    protected processDeleteListPurchaseRequisitionRecommendedVendors(response: HttpResponseBase): Observable<PurchaseRequisitionRecommendedVendorsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseRequisitionRecommendedVendorsDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionRecommendedVendorsDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendEmailToFinalApproverWithPdf(body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/SendEmailToFinalApproverWithPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendEmailToFinalApproverWithPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailToFinalApproverWithPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendEmailToFinalApproverWithPdf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendEmailToApproverWithPdf(body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/SendEmailToApproverWithPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendEmailToApproverWithPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailToApproverWithPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendEmailToApproverWithPdf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendPurchaseRequisitionWithPdf(body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/SendPurchaseRequisitionWithPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendPurchaseRequisitionWithPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPurchaseRequisitionWithPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendPurchaseRequisitionWithPdf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPurchaseRequisitionVendorItems(body: PurchaseRequisitionVendorItemsDto | undefined): Observable<PurchaseRequisitionVendorItemsDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/CreatePurchaseRequisitionVendorItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePurchaseRequisitionVendorItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePurchaseRequisitionVendorItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionVendorItemsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionVendorItemsDto>;
        }));
    }

    protected processCreatePurchaseRequisitionVendorItems(response: HttpResponseBase): Observable<PurchaseRequisitionVendorItemsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionVendorItemsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionVendorItemsDto>(null as any);
    }

    /**
     * @param purchaseRequisitionId (optional) 
     * @return Success
     */
    getPurchaseRequisitionVendorItems(purchaseRequisitionId: number | undefined): Observable<PurchaseRequisitionVendorItems[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/GetPurchaseRequisitionVendorItems?";
        if (purchaseRequisitionId === null)
            throw new Error("The parameter 'purchaseRequisitionId' cannot be null.");
        else if (purchaseRequisitionId !== undefined)
            url_ += "purchaseRequisitionId=" + encodeURIComponent("" + purchaseRequisitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseRequisitionVendorItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseRequisitionVendorItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionVendorItems[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionVendorItems[]>;
        }));
    }

    protected processGetPurchaseRequisitionVendorItems(response: HttpResponseBase): Observable<PurchaseRequisitionVendorItems[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseRequisitionVendorItems.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionVendorItems[]>(null as any);
    }

    /**
     * @param purchaseRequisitionId (optional) 
     * @param vendorId (optional) 
     * @return Success
     */
    getPurchaseRequisitionVendorItemsByVendorId(purchaseRequisitionId: number | undefined, vendorId: number | undefined): Observable<PurchaseRequisitionVendorItems[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/GetPurchaseRequisitionVendorItemsByVendorId?";
        if (purchaseRequisitionId === null)
            throw new Error("The parameter 'purchaseRequisitionId' cannot be null.");
        else if (purchaseRequisitionId !== undefined)
            url_ += "purchaseRequisitionId=" + encodeURIComponent("" + purchaseRequisitionId) + "&";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseRequisitionVendorItemsByVendorId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseRequisitionVendorItemsByVendorId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionVendorItems[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionVendorItems[]>;
        }));
    }

    protected processGetPurchaseRequisitionVendorItemsByVendorId(response: HttpResponseBase): Observable<PurchaseRequisitionVendorItems[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseRequisitionVendorItems.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionVendorItems[]>(null as any);
    }

    /**
     * @param purchaseRequisitionId (optional) 
     * @param purchaseRequisitionRecommendedVendorsId (optional) 
     * @return Success
     */
    getPurchaseRequisitionVendorItemsByQuotationVendorId(purchaseRequisitionId: number | undefined, purchaseRequisitionRecommendedVendorsId: number | undefined): Observable<PurchaseRequisitionVendorItems[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/GetPurchaseRequisitionVendorItemsByQuotationVendorId?";
        if (purchaseRequisitionId === null)
            throw new Error("The parameter 'purchaseRequisitionId' cannot be null.");
        else if (purchaseRequisitionId !== undefined)
            url_ += "purchaseRequisitionId=" + encodeURIComponent("" + purchaseRequisitionId) + "&";
        if (purchaseRequisitionRecommendedVendorsId === null)
            throw new Error("The parameter 'purchaseRequisitionRecommendedVendorsId' cannot be null.");
        else if (purchaseRequisitionRecommendedVendorsId !== undefined)
            url_ += "purchaseRequisitionRecommendedVendorsId=" + encodeURIComponent("" + purchaseRequisitionRecommendedVendorsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseRequisitionVendorItemsByQuotationVendorId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseRequisitionVendorItemsByQuotationVendorId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionVendorItems[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionVendorItems[]>;
        }));
    }

    protected processGetPurchaseRequisitionVendorItemsByQuotationVendorId(response: HttpResponseBase): Observable<PurchaseRequisitionVendorItems[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseRequisitionVendorItems.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionVendorItems[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatePurchaseRequisitionVendorItems(id: number | undefined, body: PurchaseRequisitionVendorItemsDto | undefined): Observable<PurchaseRequisitionVendorItemsDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/UpdatePurchaseRequisitionVendorItems?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePurchaseRequisitionVendorItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePurchaseRequisitionVendorItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionVendorItemsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionVendorItemsDto>;
        }));
    }

    protected processUpdatePurchaseRequisitionVendorItems(response: HttpResponseBase): Observable<PurchaseRequisitionVendorItemsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionVendorItemsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionVendorItemsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateListPurchaseRequisitionVendorItems(body: PurchaseRequisitionVendorItemsDto[] | undefined): Observable<PurchaseRequisitionVendorItemsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/UpdateListPurchaseRequisitionVendorItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateListPurchaseRequisitionVendorItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateListPurchaseRequisitionVendorItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionVendorItemsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionVendorItemsDto[]>;
        }));
    }

    protected processUpdateListPurchaseRequisitionVendorItems(response: HttpResponseBase): Observable<PurchaseRequisitionVendorItemsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseRequisitionVendorItemsDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionVendorItemsDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatePurchaseRequisitionVendorItemsGrnQuantity(id: number | undefined, body: PurchaseRequisitionVendorItemsDto | undefined): Observable<PurchaseRequisitionVendorItemsDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/UpdatePurchaseRequisitionVendorItemsGrnQuantity?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePurchaseRequisitionVendorItemsGrnQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePurchaseRequisitionVendorItemsGrnQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionVendorItemsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionVendorItemsDto>;
        }));
    }

    protected processUpdatePurchaseRequisitionVendorItemsGrnQuantity(response: HttpResponseBase): Observable<PurchaseRequisitionVendorItemsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionVendorItemsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionVendorItemsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deletePurchaseRequisitionVendorItems(id: number | undefined): Observable<PurchaseRequisitionVendorItemsDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/DeletePurchaseRequisitionVendorItems?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeletePurchaseRequisitionVendorItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePurchaseRequisitionVendorItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionVendorItemsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionVendorItemsDto>;
        }));
    }

    protected processDeletePurchaseRequisitionVendorItems(response: HttpResponseBase): Observable<PurchaseRequisitionVendorItemsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionVendorItemsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionVendorItemsDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getRequsitionWithRange(tenantId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<PurchaseRequisitionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/GetRequsitionWithRange?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRequsitionWithRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequsitionWithRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionDto[]>;
        }));
    }

    protected processGetRequsitionWithRange(response: HttpResponseBase): Observable<PurchaseRequisitionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseRequisitionDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionDto[]>(null as any);
    }

    /**
     * @param purchaseRequisitionId (optional) 
     * @return Success
     */
    getPurchaseRequisitionItemsSync(purchaseRequisitionId: number | undefined): Observable<PurchaseRequisitionItems[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/GetPurchaseRequisitionItemsSync?";
        if (purchaseRequisitionId === null)
            throw new Error("The parameter 'purchaseRequisitionId' cannot be null.");
        else if (purchaseRequisitionId !== undefined)
            url_ += "purchaseRequisitionId=" + encodeURIComponent("" + purchaseRequisitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseRequisitionItemsSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseRequisitionItemsSync(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionItems[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionItems[]>;
        }));
    }

    protected processGetPurchaseRequisitionItemsSync(response: HttpResponseBase): Observable<PurchaseRequisitionItems[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseRequisitionItems.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionItems[]>(null as any);
    }

    /**
     * @param purhcaseOrderId (optional) 
     * @return Success
     */
    getPurchaseOrderItemsSync(purhcaseOrderId: number | undefined): Observable<PurchaseOrderItem[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/GetPurchaseOrderItemsSync?";
        if (purhcaseOrderId === null)
            throw new Error("The parameter 'purhcaseOrderId' cannot be null.");
        else if (purhcaseOrderId !== undefined)
            url_ += "purhcaseOrderId=" + encodeURIComponent("" + purhcaseOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseOrderItemsSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseOrderItemsSync(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseOrderItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseOrderItem[]>;
        }));
    }

    protected processGetPurchaseOrderItemsSync(response: HttpResponseBase): Observable<PurchaseOrderItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseOrderItem.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseOrderItem[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    updatePurchaseOrderValue(tenantId: number | undefined): Observable<PurchaseRequisition[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/UpdatePurchaseOrderValue?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePurchaseOrderValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePurchaseOrderValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisition[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisition[]>;
        }));
    }

    protected processUpdatePurchaseOrderValue(response: HttpResponseBase): Observable<PurchaseRequisition[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseRequisition.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisition[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getAllUnpaidRequistion(tenantId: number | undefined): Observable<PurchaseRequisitionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/GetAllUnpaidRequistion?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllUnpaidRequistion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUnpaidRequistion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionDto[]>;
        }));
    }

    protected processGetAllUnpaidRequistion(response: HttpResponseBase): Observable<PurchaseRequisitionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseRequisitionDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getAllUnpaidPurchaseWithoutPo(tenantId: number | undefined): Observable<PurchaseRequisitionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/GetAllUnpaidPurchaseWithoutPo?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllUnpaidPurchaseWithoutPo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUnpaidPurchaseWithoutPo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionDto[]>;
        }));
    }

    protected processGetAllUnpaidPurchaseWithoutPo(response: HttpResponseBase): Observable<PurchaseRequisitionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseRequisitionDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPrPoVo(body: VendorInvoiceDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/CreatePrPoVo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePrPoVo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePrPoVo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreatePrPoVo(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePrPoVo(body: VendorInvoiceDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/UpdatePrPoVo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePrPoVo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePrPoVo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdatePrPoVo(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateAllId(id: number | undefined, body: PurchaseRequisitionDto | undefined): Observable<PurchaseRequisitionDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/UpdateAllId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateAllId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionDto>;
        }));
    }

    protected processUpdateAllId(response: HttpResponseBase): Observable<PurchaseRequisitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkMigrationData(body: VendorInvoiceMigrationDto[] | undefined): Observable<VendorInvoiceMigrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/CheckMigrationData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckMigrationData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckMigrationData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceMigrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceMigrationDto[]>;
        }));
    }

    protected processCheckMigrationData(response: HttpResponseBase): Observable<VendorInvoiceMigrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(VendorInvoiceMigrationDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceMigrationDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createInvoicesFromMigration(body: VendorInvoiceMigrationDto[] | undefined): Observable<VendorInvoiceMigrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/CreateInvoicesFromMigration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateInvoicesFromMigration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoicesFromMigration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceMigrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceMigrationDto[]>;
        }));
    }

    protected processCreateInvoicesFromMigration(response: HttpResponseBase): Observable<VendorInvoiceMigrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(VendorInvoiceMigrationDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceMigrationDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getBuyBadge(tenantId: number | undefined): Observable<BuyBadgeDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisition/GetBuyBadge?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBuyBadge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBuyBadge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuyBadgeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuyBadgeDto>;
        }));
    }

    protected processGetBuyBadge(response: HttpResponseBase): Observable<BuyBadgeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BuyBadgeDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BuyBadgeDto>(null as any);
    }
}

@Injectable()
export class PurchaseRequisitionPublicServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param purchaseRequisitionId (optional) 
     * @return Success
     */
    getPurchaseRequisitionById(purchaseRequisitionId: number | undefined): Observable<PurchaseRequisition> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisitionPublic/GetPurchaseRequisitionById?";
        if (purchaseRequisitionId === null)
            throw new Error("The parameter 'purchaseRequisitionId' cannot be null.");
        else if (purchaseRequisitionId !== undefined)
            url_ += "purchaseRequisitionId=" + encodeURIComponent("" + purchaseRequisitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseRequisitionById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseRequisitionById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisition>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisition>;
        }));
    }

    protected processGetPurchaseRequisitionById(response: HttpResponseBase): Observable<PurchaseRequisition> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisition.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisition>(null as any);
    }

    /**
     * @param purchaseRequisitionId (optional) 
     * @return Success
     */
    getPurchaseRequisitionItems(purchaseRequisitionId: number | undefined): Observable<PurchaseRequisitionItems[]> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisitionPublic/GetPurchaseRequisitionItems?";
        if (purchaseRequisitionId === null)
            throw new Error("The parameter 'purchaseRequisitionId' cannot be null.");
        else if (purchaseRequisitionId !== undefined)
            url_ += "purchaseRequisitionId=" + encodeURIComponent("" + purchaseRequisitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseRequisitionItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseRequisitionItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionItems[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionItems[]>;
        }));
    }

    protected processGetPurchaseRequisitionItems(response: HttpResponseBase): Observable<PurchaseRequisitionItems[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseRequisitionItems.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionItems[]>(null as any);
    }

    /**
     * @param purchaseRequisitionId (optional) 
     * @param vendorId (optional) 
     * @return Success
     */
    getPurchaseRequisitionRecommendedVendorsById(purchaseRequisitionId: number | undefined, vendorId: number | undefined): Observable<PurchaseRequisitionRecommendedVendors> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisitionPublic/GetPurchaseRequisitionRecommendedVendorsById?";
        if (purchaseRequisitionId === null)
            throw new Error("The parameter 'purchaseRequisitionId' cannot be null.");
        else if (purchaseRequisitionId !== undefined)
            url_ += "purchaseRequisitionId=" + encodeURIComponent("" + purchaseRequisitionId) + "&";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseRequisitionRecommendedVendorsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseRequisitionRecommendedVendorsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionRecommendedVendors>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionRecommendedVendors>;
        }));
    }

    protected processGetPurchaseRequisitionRecommendedVendorsById(response: HttpResponseBase): Observable<PurchaseRequisitionRecommendedVendors> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionRecommendedVendors.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionRecommendedVendors>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatePurchaseRequisitionRecommendedVendors(id: number | undefined, body: PurchaseRequisitionRecommendedVendorsDto | undefined): Observable<PurchaseRequisitionRecommendedVendorsDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisitionPublic/UpdatePurchaseRequisitionRecommendedVendors?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdatePurchaseRequisitionRecommendedVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePurchaseRequisitionRecommendedVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionRecommendedVendorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionRecommendedVendorsDto>;
        }));
    }

    protected processUpdatePurchaseRequisitionRecommendedVendors(response: HttpResponseBase): Observable<PurchaseRequisitionRecommendedVendorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionRecommendedVendorsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionRecommendedVendorsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param remarks (optional) 
     * @return Success
     */
    updateRemarksByPurchaseRequisitionId(id: number | undefined, remarks: string | undefined): Observable<PurchaseRequisitionDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisitionPublic/UpdateRemarksByPurchaseRequisitionId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (remarks === null)
            throw new Error("The parameter 'remarks' cannot be null.");
        else if (remarks !== undefined)
            url_ += "remarks=" + encodeURIComponent("" + remarks) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateRemarksByPurchaseRequisitionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRemarksByPurchaseRequisitionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionDto>;
        }));
    }

    protected processUpdateRemarksByPurchaseRequisitionId(response: HttpResponseBase): Observable<PurchaseRequisitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPurchaseRequisitionRecommendedVendors(body: PurchaseRequisitionRecommendedVendorsDto | undefined): Observable<PurchaseRequisitionRecommendedVendorsDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisitionPublic/CreatePurchaseRequisitionRecommendedVendors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePurchaseRequisitionRecommendedVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePurchaseRequisitionRecommendedVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionRecommendedVendorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionRecommendedVendorsDto>;
        }));
    }

    protected processCreatePurchaseRequisitionRecommendedVendors(response: HttpResponseBase): Observable<PurchaseRequisitionRecommendedVendorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionRecommendedVendorsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionRecommendedVendorsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPurchaseRequisitionVendorItems(body: PurchaseRequisitionVendorItemsDto | undefined): Observable<PurchaseRequisitionVendorItemsDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisitionPublic/CreatePurchaseRequisitionVendorItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePurchaseRequisitionVendorItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePurchaseRequisitionVendorItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionVendorItemsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionVendorItemsDto>;
        }));
    }

    protected processCreatePurchaseRequisitionVendorItems(response: HttpResponseBase): Observable<PurchaseRequisitionVendorItemsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionVendorItemsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionVendorItemsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateVendor(id: number | undefined, body: VendorDto | undefined): Observable<VendorDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisitionPublic/UpdateVendor?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorDto>;
        }));
    }

    protected processUpdateVendor(response: HttpResponseBase): Observable<VendorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createVendor(body: VendorDto | undefined): Observable<VendorDto> {
        let url_ = this.baseUrl + "/api/services/app/PurchaseRequisitionPublic/CreateVendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorDto>;
        }));
    }

    protected processCreateVendor(response: HttpResponseBase): Observable<VendorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorDto>(null as any);
    }
}

@Injectable()
export class QuotationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createQuotation(body: QuotationDto | undefined): Observable<QuotationDto> {
        let url_ = this.baseUrl + "/api/services/app/Quotation/CreateQuotation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateQuotation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateQuotation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuotationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuotationDto>;
        }));
    }

    protected processCreateQuotation(response: HttpResponseBase): Observable<QuotationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = QuotationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuotationDto>(null as any);
    }

    /**
     * @param quotationId (optional) 
     * @return Success
     */
    getQuotation(quotationId: number | undefined): Observable<Quotation[]> {
        let url_ = this.baseUrl + "/api/services/app/Quotation/GetQuotation?";
        if (quotationId === null)
            throw new Error("The parameter 'quotationId' cannot be null.");
        else if (quotationId !== undefined)
            url_ += "quotationId=" + encodeURIComponent("" + quotationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetQuotation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuotation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Quotation[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Quotation[]>;
        }));
    }

    protected processGetQuotation(response: HttpResponseBase): Observable<Quotation[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(Quotation.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Quotation[]>(null as any);
    }

    /**
     * @param quotationId (optional) 
     * @return Success
     */
    getQuotationById(quotationId: number | undefined): Observable<Quotation> {
        let url_ = this.baseUrl + "/api/services/app/Quotation/GetQuotationById?";
        if (quotationId === null)
            throw new Error("The parameter 'quotationId' cannot be null.");
        else if (quotationId !== undefined)
            url_ += "quotationId=" + encodeURIComponent("" + quotationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetQuotationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuotationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Quotation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Quotation>;
        }));
    }

    protected processGetQuotationById(response: HttpResponseBase): Observable<Quotation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Quotation.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Quotation>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getQuotationWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<QuotationPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Quotation/GetQuotationWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetQuotationWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuotationWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuotationPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuotationPagedResultDto>;
        }));
    }

    protected processGetQuotationWithInput(response: HttpResponseBase): Observable<QuotationPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = QuotationPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuotationPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateQuotation(id: number | undefined, body: QuotationDto | undefined): Observable<QuotationDto> {
        let url_ = this.baseUrl + "/api/services/app/Quotation/UpdateQuotation?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateQuotation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQuotation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuotationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuotationDto>;
        }));
    }

    protected processUpdateQuotation(response: HttpResponseBase): Observable<QuotationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = QuotationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuotationDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateQuotationPeriod(id: number | undefined, body: QuotationDto | undefined): Observable<Quotation> {
        let url_ = this.baseUrl + "/api/services/app/Quotation/UpdateQuotationPeriod?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateQuotationPeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQuotationPeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Quotation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Quotation>;
        }));
    }

    protected processUpdateQuotationPeriod(response: HttpResponseBase): Observable<Quotation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Quotation.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Quotation>(null as any);
    }

    /**
     * @param id (optional) 
     * @param status (optional) 
     * @return Success
     */
    updateQuotationStatus(id: number | undefined, status: number | undefined): Observable<QuotationDto> {
        let url_ = this.baseUrl + "/api/services/app/Quotation/UpdateQuotationStatus?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateQuotationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQuotationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuotationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuotationDto>;
        }));
    }

    protected processUpdateQuotationStatus(response: HttpResponseBase): Observable<QuotationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = QuotationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuotationDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateQuotationtoPurchaseOrder(id: number | undefined, body: QuotationDto | undefined): Observable<QuotationDto> {
        let url_ = this.baseUrl + "/api/services/app/Quotation/UpdateQuotationtoPurchaseOrder?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateQuotationtoPurchaseOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQuotationtoPurchaseOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuotationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuotationDto>;
        }));
    }

    protected processUpdateQuotationtoPurchaseOrder(response: HttpResponseBase): Observable<QuotationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = QuotationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuotationDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteQuotation(id: number | undefined): Observable<QuotationDto> {
        let url_ = this.baseUrl + "/api/services/app/Quotation/DeleteQuotation?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteQuotation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteQuotation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuotationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuotationDto>;
        }));
    }

    protected processDeleteQuotation(response: HttpResponseBase): Observable<QuotationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = QuotationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuotationDto>(null as any);
    }

    /**
     * @param quotationRecommendedVendorId (optional) 
     * @param body (optional) 
     * @return Success
     */
    sendSingleQuotationInvitation(quotationRecommendedVendorId: number | undefined, body: Quotation | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Quotation/SendSingleQuotationInvitation?";
        if (quotationRecommendedVendorId === null)
            throw new Error("The parameter 'quotationRecommendedVendorId' cannot be null.");
        else if (quotationRecommendedVendorId !== undefined)
            url_ += "quotationRecommendedVendorId=" + encodeURIComponent("" + quotationRecommendedVendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendSingleQuotationInvitation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSingleQuotationInvitation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendSingleQuotationInvitation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendQuotationInvitation(body: Quotation | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Quotation/SendQuotationInvitation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendQuotationInvitation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendQuotationInvitation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendQuotationInvitation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createQuotationRecommendedVendors(body: QuotationRecommendedVendorsDto | undefined): Observable<QuotationRecommendedVendorsDto> {
        let url_ = this.baseUrl + "/api/services/app/Quotation/CreateQuotationRecommendedVendors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateQuotationRecommendedVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateQuotationRecommendedVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuotationRecommendedVendorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuotationRecommendedVendorsDto>;
        }));
    }

    protected processCreateQuotationRecommendedVendors(response: HttpResponseBase): Observable<QuotationRecommendedVendorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = QuotationRecommendedVendorsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuotationRecommendedVendorsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createListQuotationRecommendedVendors(body: QuotationRecommendedVendorsDto[] | undefined): Observable<QuotationRecommendedVendorsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Quotation/CreateListQuotationRecommendedVendors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateListQuotationRecommendedVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateListQuotationRecommendedVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuotationRecommendedVendorsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuotationRecommendedVendorsDto[]>;
        }));
    }

    protected processCreateListQuotationRecommendedVendors(response: HttpResponseBase): Observable<QuotationRecommendedVendorsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(QuotationRecommendedVendorsDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuotationRecommendedVendorsDto[]>(null as any);
    }

    /**
     * @param quotationId (optional) 
     * @return Success
     */
    getQuotationRecommendedVendors(quotationId: number | undefined): Observable<QuotationRecommendedVendors[]> {
        let url_ = this.baseUrl + "/api/services/app/Quotation/GetQuotationRecommendedVendors?";
        if (quotationId === null)
            throw new Error("The parameter 'quotationId' cannot be null.");
        else if (quotationId !== undefined)
            url_ += "quotationId=" + encodeURIComponent("" + quotationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetQuotationRecommendedVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuotationRecommendedVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuotationRecommendedVendors[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuotationRecommendedVendors[]>;
        }));
    }

    protected processGetQuotationRecommendedVendors(response: HttpResponseBase): Observable<QuotationRecommendedVendors[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(QuotationRecommendedVendors.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuotationRecommendedVendors[]>(null as any);
    }

    /**
     * @param quotationId (optional) 
     * @param quotationRecommendedVendorId (optional) 
     * @return Success
     */
    getQuotationRecommendedVendorsById(quotationId: number | undefined, quotationRecommendedVendorId: number | undefined): Observable<QuotationRecommendedVendors> {
        let url_ = this.baseUrl + "/api/services/app/Quotation/GetQuotationRecommendedVendorsById?";
        if (quotationId === null)
            throw new Error("The parameter 'quotationId' cannot be null.");
        else if (quotationId !== undefined)
            url_ += "quotationId=" + encodeURIComponent("" + quotationId) + "&";
        if (quotationRecommendedVendorId === null)
            throw new Error("The parameter 'quotationRecommendedVendorId' cannot be null.");
        else if (quotationRecommendedVendorId !== undefined)
            url_ += "quotationRecommendedVendorId=" + encodeURIComponent("" + quotationRecommendedVendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetQuotationRecommendedVendorsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuotationRecommendedVendorsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuotationRecommendedVendors>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuotationRecommendedVendors>;
        }));
    }

    protected processGetQuotationRecommendedVendorsById(response: HttpResponseBase): Observable<QuotationRecommendedVendors> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = QuotationRecommendedVendors.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuotationRecommendedVendors>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateQuotationRecommendedVendors(id: number | undefined, body: QuotationRecommendedVendorsDto | undefined): Observable<QuotationRecommendedVendorsDto> {
        let url_ = this.baseUrl + "/api/services/app/Quotation/UpdateQuotationRecommendedVendors?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateQuotationRecommendedVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQuotationRecommendedVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuotationRecommendedVendorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuotationRecommendedVendorsDto>;
        }));
    }

    protected processUpdateQuotationRecommendedVendors(response: HttpResponseBase): Observable<QuotationRecommendedVendorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = QuotationRecommendedVendorsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuotationRecommendedVendorsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateQuotationRecommendedVendorsEvaluation(id: number | undefined, body: QuotationRecommendedVendorsDto | undefined): Observable<QuotationRecommendedVendorsDto> {
        let url_ = this.baseUrl + "/api/services/app/Quotation/UpdateQuotationRecommendedVendorsEvaluation?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateQuotationRecommendedVendorsEvaluation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQuotationRecommendedVendorsEvaluation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuotationRecommendedVendorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuotationRecommendedVendorsDto>;
        }));
    }

    protected processUpdateQuotationRecommendedVendorsEvaluation(response: HttpResponseBase): Observable<QuotationRecommendedVendorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = QuotationRecommendedVendorsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuotationRecommendedVendorsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteQuotationRecommendedVendors(id: number | undefined): Observable<QuotationRecommendedVendorsDto> {
        let url_ = this.baseUrl + "/api/services/app/Quotation/DeleteQuotationRecommendedVendors?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteQuotationRecommendedVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteQuotationRecommendedVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuotationRecommendedVendorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuotationRecommendedVendorsDto>;
        }));
    }

    protected processDeleteQuotationRecommendedVendors(response: HttpResponseBase): Observable<QuotationRecommendedVendorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = QuotationRecommendedVendorsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuotationRecommendedVendorsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    selectVendor(id: number | undefined, body: UpdateQuotationVendorDto | undefined): Observable<UpdateQuotationVendorDto> {
        let url_ = this.baseUrl + "/api/services/app/Quotation/SelectVendor?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSelectVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelectVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateQuotationVendorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateQuotationVendorDto>;
        }));
    }

    protected processSelectVendor(response: HttpResponseBase): Observable<UpdateQuotationVendorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateQuotationVendorDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateQuotationVendorDto>(null as any);
    }
}

@Injectable()
export class QuotationPublicServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param quotationId (optional) 
     * @return Success
     */
    getQuotationById(quotationId: number | undefined): Observable<Quotation> {
        let url_ = this.baseUrl + "/api/services/app/QuotationPublic/GetQuotationById?";
        if (quotationId === null)
            throw new Error("The parameter 'quotationId' cannot be null.");
        else if (quotationId !== undefined)
            url_ += "quotationId=" + encodeURIComponent("" + quotationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetQuotationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuotationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Quotation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Quotation>;
        }));
    }

    protected processGetQuotationById(response: HttpResponseBase): Observable<Quotation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Quotation.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Quotation>(null as any);
    }

    /**
     * @param purchaseRequisitionId (optional) 
     * @return Success
     */
    getPurchaseRequisitionItems(purchaseRequisitionId: number | undefined): Observable<PurchaseRequisitionItems[]> {
        let url_ = this.baseUrl + "/api/services/app/QuotationPublic/GetPurchaseRequisitionItems?";
        if (purchaseRequisitionId === null)
            throw new Error("The parameter 'purchaseRequisitionId' cannot be null.");
        else if (purchaseRequisitionId !== undefined)
            url_ += "purchaseRequisitionId=" + encodeURIComponent("" + purchaseRequisitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseRequisitionItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseRequisitionItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionItems[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionItems[]>;
        }));
    }

    protected processGetPurchaseRequisitionItems(response: HttpResponseBase): Observable<PurchaseRequisitionItems[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseRequisitionItems.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionItems[]>(null as any);
    }

    /**
     * @param quotationId (optional) 
     * @param quotationRecommendedVendorId (optional) 
     * @return Success
     */
    getQuotationRecommendedVendorsById(quotationId: number | undefined, quotationRecommendedVendorId: number | undefined): Observable<QuotationRecommendedVendors> {
        let url_ = this.baseUrl + "/api/services/app/QuotationPublic/GetQuotationRecommendedVendorsById?";
        if (quotationId === null)
            throw new Error("The parameter 'quotationId' cannot be null.");
        else if (quotationId !== undefined)
            url_ += "quotationId=" + encodeURIComponent("" + quotationId) + "&";
        if (quotationRecommendedVendorId === null)
            throw new Error("The parameter 'quotationRecommendedVendorId' cannot be null.");
        else if (quotationRecommendedVendorId !== undefined)
            url_ += "quotationRecommendedVendorId=" + encodeURIComponent("" + quotationRecommendedVendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetQuotationRecommendedVendorsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetQuotationRecommendedVendorsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuotationRecommendedVendors>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuotationRecommendedVendors>;
        }));
    }

    protected processGetQuotationRecommendedVendorsById(response: HttpResponseBase): Observable<QuotationRecommendedVendors> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = QuotationRecommendedVendors.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuotationRecommendedVendors>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateQuotationRecommendedVendors(id: number | undefined, body: QuotationRecommendedVendorsDto | undefined): Observable<QuotationRecommendedVendorsDto> {
        let url_ = this.baseUrl + "/api/services/app/QuotationPublic/UpdateQuotationRecommendedVendors?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateQuotationRecommendedVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQuotationRecommendedVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuotationRecommendedVendorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuotationRecommendedVendorsDto>;
        }));
    }

    protected processUpdateQuotationRecommendedVendors(response: HttpResponseBase): Observable<QuotationRecommendedVendorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = QuotationRecommendedVendorsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuotationRecommendedVendorsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createQuotationRecommendedVendors(body: QuotationRecommendedVendorsDto | undefined): Observable<QuotationRecommendedVendorsDto> {
        let url_ = this.baseUrl + "/api/services/app/QuotationPublic/CreateQuotationRecommendedVendors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateQuotationRecommendedVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateQuotationRecommendedVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QuotationRecommendedVendorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QuotationRecommendedVendorsDto>;
        }));
    }

    protected processCreateQuotationRecommendedVendors(response: HttpResponseBase): Observable<QuotationRecommendedVendorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = QuotationRecommendedVendorsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QuotationRecommendedVendorsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPurchaseRequisitionVendorItems(body: PurchaseRequisitionVendorItemsDto | undefined): Observable<PurchaseRequisitionVendorItemsDto> {
        let url_ = this.baseUrl + "/api/services/app/QuotationPublic/CreatePurchaseRequisitionVendorItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreatePurchaseRequisitionVendorItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePurchaseRequisitionVendorItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionVendorItemsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionVendorItemsDto>;
        }));
    }

    protected processCreatePurchaseRequisitionVendorItems(response: HttpResponseBase): Observable<PurchaseRequisitionVendorItemsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PurchaseRequisitionVendorItemsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionVendorItemsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createListPurchaseRequisitionVendorItems(body: PurchaseRequisitionVendorItemsDto[] | undefined): Observable<PurchaseRequisitionVendorItemsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/QuotationPublic/CreateListPurchaseRequisitionVendorItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateListPurchaseRequisitionVendorItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateListPurchaseRequisitionVendorItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionVendorItemsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionVendorItemsDto[]>;
        }));
    }

    protected processCreateListPurchaseRequisitionVendorItems(response: HttpResponseBase): Observable<PurchaseRequisitionVendorItemsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseRequisitionVendorItemsDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionVendorItemsDto[]>(null as any);
    }

    /**
     * @param vendorId (optional) 
     * @return Success
     */
    getVendorById(vendorId: number | undefined): Observable<Vendor> {
        let url_ = this.baseUrl + "/api/services/app/QuotationPublic/GetVendorById?";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVendorById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Vendor>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Vendor>;
        }));
    }

    protected processGetVendorById(response: HttpResponseBase): Observable<Vendor> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Vendor.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Vendor>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateVendor(id: number | undefined, body: VendorDto | undefined): Observable<VendorDto> {
        let url_ = this.baseUrl + "/api/services/app/QuotationPublic/UpdateVendor?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorDto>;
        }));
    }

    protected processUpdateVendor(response: HttpResponseBase): Observable<VendorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createVendor(body: VendorDto | undefined): Observable<VendorDto> {
        let url_ = this.baseUrl + "/api/services/app/QuotationPublic/CreateVendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorDto>;
        }));
    }

    protected processCreateVendor(response: HttpResponseBase): Observable<VendorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorDto>(null as any);
    }
}

@Injectable()
export class ResetAllServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    deleteInventoryItemDataByTenantId(tenantId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ResetAll/DeleteInventoryItemDataByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteInventoryItemDataByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInventoryItemDataByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteInventoryItemDataByTenantId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    deleteSellDataByTenantId(tenantId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ResetAll/DeleteSellDataByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteSellDataByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSellDataByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteSellDataByTenantId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    deleteProcurementDataByTenantId(tenantId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ResetAll/DeleteProcurementDataByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteProcurementDataByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProcurementDataByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteProcurementDataByTenantId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    deleteAssetDataByTenantId(tenantId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ResetAll/DeleteAssetDataByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteAssetDataByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAssetDataByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteAssetDataByTenantId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    deleteCashBookDataByTenantId(tenantId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ResetAll/DeleteCashBookDataByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteCashBookDataByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCashBookDataByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteCashBookDataByTenantId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    deletePettyCashDataByTenantId(tenantId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ResetAll/DeletePettyCashDataByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeletePettyCashDataByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePettyCashDataByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeletePettyCashDataByTenantId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    deleteJournalDataByTenantId(tenantId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ResetAll/DeleteJournalDataByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteJournalDataByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteJournalDataByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteJournalDataByTenantId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    deleteDebitNoteDataByTenantId(tenantId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ResetAll/DeleteDebitNoteDataByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteDebitNoteDataByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDebitNoteDataByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteDebitNoteDataByTenantId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    deleteCustomerDataByTenantId(tenantId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ResetAll/DeleteCustomerDataByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteCustomerDataByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomerDataByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteCustomerDataByTenantId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    deleteVendorDataByTenantId(tenantId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ResetAll/DeleteVendorDataByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteVendorDataByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteVendorDataByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteVendorDataByTenantId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    deleteItemsDataByTenantId(tenantId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ResetAll/DeleteItemsDataByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteItemsDataByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteItemsDataByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteItemsDataByTenantId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    deleteWarehouseDataByTenantId(tenantId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ResetAll/DeleteWarehouseDataByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteWarehouseDataByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWarehouseDataByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteWarehouseDataByTenantId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    deleteInventoryCategoryDataByTenantId(tenantId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ResetAll/DeleteInventoryCategoryDataByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteInventoryCategoryDataByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInventoryCategoryDataByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteInventoryCategoryDataByTenantId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    deleteInventoryLocationDataByTenantId(tenantId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ResetAll/DeleteInventoryLocationDataByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteInventoryLocationDataByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInventoryLocationDataByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteInventoryLocationDataByTenantId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    deleteProjectDataByTenantId(tenantId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ResetAll/DeleteProjectDataByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteProjectDataByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteProjectDataByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteProjectDataByTenantId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RoleDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission === null)
            throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleListDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleListDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RoleListDtoListResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleListDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RoleDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<PermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionDtoListResultDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<PermissionDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PermissionDtoListResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PermissionDtoListResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetRoleForEditOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleForEditOutput>(null as any);
    }

    /**
     * @return Success
     */
    grantAllPermissionsForAdmins(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/GrantAllPermissionsForAdmins";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGrantAllPermissionsForAdmins(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGrantAllPermissionsForAdmins(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGrantAllPermissionsForAdmins(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RoleDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RoleDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(null as any);
    }
}

@Injectable()
export class SubscriptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    disableRecurringPayments(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/DisableRecurringPayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDisableRecurringPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableRecurringPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableRecurringPayments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    enableRecurringPayments(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/EnableRecurringPayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processEnableRecurringPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableRecurringPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnableRecurringPayments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TenantDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @return Success
     */
    getTenantsFromEmail(emailAddress: string | undefined): Observable<TenantDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantsFromEmail?";
        if (emailAddress === null)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTenantsFromEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantsFromEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto[]>;
        }));
    }

    protected processGetTenantsFromEmail(response: HttpResponseBase): Observable<TenantDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(TenantDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createNewTenant(body: CreateNewTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/CreateNewTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateNewTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNewTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processCreateNewTenant(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TenantDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @param tenantId (optional) 
     * @param merchantStore (optional) 
     * @return Success
     */
    sendEmailToResetEmail(emailAddress: string | undefined, tenantId: number | undefined, merchantStore: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/sendEmailToResetEmail?";
        if (emailAddress === null)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (merchantStore === null)
            throw new Error("The parameter 'merchantStore' cannot be null.");
        else if (merchantStore !== undefined)
            url_ += "merchantStore=" + encodeURIComponent("" + merchantStore) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendEmailToResetEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailToResetEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendEmailToResetEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getAllTenants(): Observable<TenantDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAllTenants";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTenants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto[]>;
        }));
    }

    protected processGetAllTenants(response: HttpResponseBase): Observable<TenantDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(TenantDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAllTenantsWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAllTenantsWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllTenantsWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTenantsWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDtoPagedResultDto>;
        }));
    }

    protected processGetAllTenantsWithInput(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TenantDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetUserPassword(body: ResetPasswordInputDto | undefined): Observable<ResetPasswordResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/resetUserPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResetUserPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetUserPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResetPasswordResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResetPasswordResponseDto>;
        }));
    }

    protected processResetUserPassword(response: HttpResponseBase): Observable<ResetPasswordResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ResetPasswordResponseDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResetPasswordResponseDto>(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    checkCanResetPassword(emailAddress: string | undefined, tenantId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/checkCanResetPassword?";
        if (emailAddress === null)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckCanResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCanResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckCanResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEdition(body: EditionDto | undefined): Observable<EditionDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/CreateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditionDto>;
        }));
    }

    protected processCreateEdition(response: HttpResponseBase): Observable<EditionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EditionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditionDto>(null as any);
    }

    /**
     * @return Success
     */
    getEditions(): Observable<Edition[]> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetEditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Edition[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Edition[]>;
        }));
    }

    protected processGetEditions(response: HttpResponseBase): Observable<Edition[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(Edition.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Edition[]>(null as any);
    }

    /**
     * @param editionId (optional) 
     * @return Success
     */
    getSubscribableEdition(editionId: number | undefined): Observable<SubscribableEdition> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetSubscribableEdition?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSubscribableEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscribableEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscribableEdition>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscribableEdition>;
        }));
    }

    protected processGetSubscribableEdition(response: HttpResponseBase): Observable<SubscribableEdition> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SubscribableEdition.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscribableEdition>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getSubscribableEditionByTenantId(tenantId: number | undefined): Observable<SubscribableEdition> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetSubscribableEditionByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSubscribableEditionByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscribableEditionByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscribableEdition>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscribableEdition>;
        }));
    }

    protected processGetSubscribableEditionByTenantId(response: HttpResponseBase): Observable<SubscribableEdition> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SubscribableEdition.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscribableEdition>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getAccessLevelByTenantId(tenantId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAccessLevelByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAccessLevelByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccessLevelByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetAccessLevelByTenantId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateEdition(id: number | undefined, body: EditionDto | undefined): Observable<EditionDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateEdition?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditionDto>;
        }));
    }

    protected processUpdateEdition(response: HttpResponseBase): Observable<EditionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EditionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditionDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteEdition(id: number | undefined): Observable<EditionDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/DeleteEdition?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditionDto>;
        }));
    }

    protected processDeleteEdition(response: HttpResponseBase): Observable<EditionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EditionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EditionDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenantById(id: number | undefined): Observable<Tenant> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTenantById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Tenant>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Tenant>;
        }));
    }

    protected processGetTenantById(response: HttpResponseBase): Observable<Tenant> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Tenant.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Tenant>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenantByIdWithCompanyprofiles(id: number | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantByIdWithCompanyprofiles?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTenantByIdWithCompanyprofiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantByIdWithCompanyprofiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processGetTenantByIdWithCompanyprofiles(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TenantDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTenant(body: TenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processUpdateTenant(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TenantDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param emailAddress (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    sendEmailVerification(emailAddress: string | undefined, tenantId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/SendEmailVerification?";
        if (emailAddress === null)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendEmailVerification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailVerification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendEmailVerification(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param emailCode (optional) 
     * @param emailAddress (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    activateEmail(emailCode: string | undefined, emailAddress: string | undefined, tenantId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ActivateEmail?";
        if (emailCode === null)
            throw new Error("The parameter 'emailCode' cannot be null.");
        else if (emailCode !== undefined)
            url_ += "emailCode=" + encodeURIComponent("" + emailCode) + "&";
        if (emailAddress === null)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processActivateEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processActivateEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param tenancyName (optional) 
     * @return Success
     */
    getTenantByTenancyName(tenancyName: string | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantByTenancyName?";
        if (tenancyName === null)
            throw new Error("The parameter 'tenancyName' cannot be null.");
        else if (tenancyName !== undefined)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTenantByTenancyName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantByTenancyName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processGetTenantByTenancyName(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TenantDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TenantDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TenantDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TenantDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }
}

@Injectable()
export class TestServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTestTable(body: TestTableDto | undefined): Observable<TestTableDto> {
        let url_ = this.baseUrl + "/api/services/app/Test/CreateTestTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateTestTable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTestTable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TestTableDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TestTableDto>;
        }));
    }

    protected processCreateTestTable(response: HttpResponseBase): Observable<TestTableDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TestTableDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TestTableDto>(null as any);
    }
}

@Injectable()
export class TfxHolidayServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param countryId (optional) 
     * @param year (optional) 
     * @return Success
     */
    getHolidays(countryId: string | undefined, year: number | undefined): Observable<TfxHolidayDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TfxHoliday/GetHolidays?";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetHolidays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHolidays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TfxHolidayDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TfxHolidayDto[]>;
        }));
    }

    protected processGetHolidays(response: HttpResponseBase): Observable<TfxHolidayDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(TfxHolidayDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TfxHolidayDto[]>(null as any);
    }

    /**
     * @param countryId (optional) 
     * @param year (optional) 
     * @return Success
     */
    saveHolidays(countryId: string | undefined, year: number | undefined): Observable<TfxHolidayDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TfxHoliday/SaveHolidays?";
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveHolidays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveHolidays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TfxHolidayDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TfxHolidayDto[]>;
        }));
    }

    protected processSaveHolidays(response: HttpResponseBase): Observable<TfxHolidayDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(TfxHolidayDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TfxHolidayDto[]>(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AuthenticateResultModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(null as any);
    }

    /**
     * @param email (optional) 
     * @param password (optional) 
     * @param tenancyName (optional) 
     * @return Success
     */
    newAuthenticate(email: string | undefined, password: string | undefined, tenancyName: string | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/NewAuthenticate?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (password === null)
            throw new Error("The parameter 'password' cannot be null.");
        else if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (tenancyName === null)
            throw new Error("The parameter 'tenancyName' cannot be null.");
        else if (tenancyName !== undefined)
            url_ += "tenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processNewAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processNewAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AuthenticateResultModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(null as any);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(ExternalLoginProviderInfoModel.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalLoginProviderInfoModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalAuthenticateResultModel>(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deActivate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeActivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RoleDtoListResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createStandardUsers(body: CreateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateStandardUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateStandardUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateStandardUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processCreateStandardUsers(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getUsersWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUsersWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDtoPagedResultDto>;
        }));
    }

    protected processGetUsersWithInput(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDtoPagedResultDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getAllUsersByTenantId(tenantId: number | undefined): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAllUsersByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllUsersByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsersByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processGetAllUsersByTenantId(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(UserDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto[]>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param permissionName (optional) 
     * @return Success
     */
    checkUserPermission(userId: number | undefined, permissionName: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/checkUserPermission?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (permissionName === null)
            throw new Error("The parameter 'permissionName' cannot be null.");
        else if (permissionName !== undefined)
            url_ += "permissionName=" + encodeURIComponent("" + permissionName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckUserPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckUserPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckUserPermission(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserbyUserId(userId: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserbyUserId?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserbyUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserbyUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGetUserbyUserId(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param accessToken (optional) 
     * @return Success
     */
    updateAccesstoken(accessToken: string | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateAccesstoken?";
        if (accessToken === null)
            throw new Error("The parameter 'accessToken' cannot be null.");
        else if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateAccesstoken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAccesstoken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdateAccesstoken(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @return Success
     */
    getMyUser(): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetMyUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMyUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGetMyUser(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getAdminUserByTenantId(tenantId: number | undefined): Observable<User> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAdminUserByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAdminUserByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminUserByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<User>;
                }
            } else
                return _observableThrow(response_) as any as Observable<User>;
        }));
    }

    protected processGetAdminUserByTenantId(response: HttpResponseBase): Observable<User> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = User.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<User>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class UserAddressesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUserAddress(body: UserAddressDto | undefined): Observable<UserAddressDto> {
        let url_ = this.baseUrl + "/api/services/app/UserAddresses/CreateUserAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateUserAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAddressDto>;
        }));
    }

    protected processCreateUserAddress(response: HttpResponseBase): Observable<UserAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserAddressDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAddressDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserAddress(userId: number | undefined): Observable<UserAddress[]> {
        let url_ = this.baseUrl + "/api/services/app/UserAddresses/GetUserAddress?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAddress[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAddress[]>;
        }));
    }

    protected processGetUserAddress(response: HttpResponseBase): Observable<UserAddress[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(UserAddress.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAddress[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateUserAddress(id: number | undefined, body: UserAddressDto | undefined): Observable<UserAddressDto> {
        let url_ = this.baseUrl + "/api/services/app/UserAddresses/UpdateUserAddress?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateUserAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAddressDto>;
        }));
    }

    protected processUpdateUserAddress(response: HttpResponseBase): Observable<UserAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserAddressDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAddressDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteUserAddress(id: number | undefined): Observable<UserAddressDto> {
        let url_ = this.baseUrl + "/api/services/app/UserAddresses/DeleteUserAddress?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteUserAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUserAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAddressDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAddressDto>;
        }));
    }

    protected processDeleteUserAddress(response: HttpResponseBase): Observable<UserAddressDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserAddressDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserAddressDto>(null as any);
    }
}

@Injectable()
export class UserCurrentAccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getUserCurrentAccountsWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<UserCurrentAccountDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserCurrentAccount/GetUserCurrentAccountsWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserCurrentAccountsWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserCurrentAccountsWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCurrentAccountDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCurrentAccountDtoPagedResultDto>;
        }));
    }

    protected processGetUserCurrentAccountsWithInput(response: HttpResponseBase): Observable<UserCurrentAccountDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserCurrentAccountDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCurrentAccountDtoPagedResultDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getUserCurrentAccountsWithInputByUserId(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, userId: number | undefined): Observable<UserCurrentAccountDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserCurrentAccount/GetUserCurrentAccountsWithInputByUserId?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserCurrentAccountsWithInputByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserCurrentAccountsWithInputByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCurrentAccountDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCurrentAccountDtoPagedResultDto>;
        }));
    }

    protected processGetUserCurrentAccountsWithInputByUserId(response: HttpResponseBase): Observable<UserCurrentAccountDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserCurrentAccountDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCurrentAccountDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserCurrentAccountDto> {
        let url_ = this.baseUrl + "/api/services/app/UserCurrentAccount/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCurrentAccountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCurrentAccountDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserCurrentAccountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserCurrentAccountDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCurrentAccountDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<UserCurrentAccountDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserCurrentAccount/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCurrentAccountDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCurrentAccountDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserCurrentAccountDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserCurrentAccountDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCurrentAccountDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: UserCurrentAccountDto | undefined): Observable<UserCurrentAccountDto> {
        let url_ = this.baseUrl + "/api/services/app/UserCurrentAccount/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCurrentAccountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCurrentAccountDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserCurrentAccountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserCurrentAccountDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCurrentAccountDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UserCurrentAccountDto | undefined): Observable<UserCurrentAccountDto> {
        let url_ = this.baseUrl + "/api/services/app/UserCurrentAccount/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCurrentAccountDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCurrentAccountDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserCurrentAccountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserCurrentAccountDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCurrentAccountDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserCurrentAccount/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class VendorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createVendor(body: VendorDto | undefined): Observable<VendorDto> {
        let url_ = this.baseUrl + "/api/services/app/Vendor/CreateVendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorDto>;
        }));
    }

    protected processCreateVendor(response: HttpResponseBase): Observable<VendorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getAllVendors(tenantId: number | undefined): Observable<Vendor[]> {
        let url_ = this.baseUrl + "/api/services/app/Vendor/GetAllVendors?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Vendor[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Vendor[]>;
        }));
    }

    protected processGetAllVendors(response: HttpResponseBase): Observable<Vendor[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(Vendor.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Vendor[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getVendorWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<VendorDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Vendor/GetVendorWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVendorWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorDtoPagedResultDto>;
        }));
    }

    protected processGetVendorWithInput(response: HttpResponseBase): Observable<VendorDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorDtoPagedResultDto>(null as any);
    }

    /**
     * @param vendorId (optional) 
     * @return Success
     */
    getVendorById(vendorId: number | undefined): Observable<Vendor> {
        let url_ = this.baseUrl + "/api/services/app/Vendor/GetVendorById?";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVendorById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Vendor>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Vendor>;
        }));
    }

    protected processGetVendorById(response: HttpResponseBase): Observable<Vendor> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Vendor.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Vendor>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateVendor(id: number | undefined, body: VendorDto | undefined): Observable<VendorDto> {
        let url_ = this.baseUrl + "/api/services/app/Vendor/UpdateVendor?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorDto>;
        }));
    }

    protected processUpdateVendor(response: HttpResponseBase): Observable<VendorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteVendor(id: number | undefined): Observable<VendorDto> {
        let url_ = this.baseUrl + "/api/services/app/Vendor/DeleteVendor?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorDto>;
        }));
    }

    protected processDeleteVendor(response: HttpResponseBase): Observable<VendorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param remarks (optional) 
     * @return Success
     */
    updateRemarksByVendorId(id: number | undefined, remarks: string | undefined): Observable<VendorDto> {
        let url_ = this.baseUrl + "/api/services/app/Vendor/UpdateRemarksByVendorId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (remarks === null)
            throw new Error("The parameter 'remarks' cannot be null.");
        else if (remarks !== undefined)
            url_ += "remarks=" + encodeURIComponent("" + remarks) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateRemarksByVendorId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRemarksByVendorId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorDto>;
        }));
    }

    protected processUpdateRemarksByVendorId(response: HttpResponseBase): Observable<VendorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorDto>(null as any);
    }

    /**
     * @param vendorId (optional) 
     * @return Success
     */
    getPurchaseRequisitionByVendorId(vendorId: number | undefined): Observable<PurchaseRequisitionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Vendor/GetPurchaseRequisitionByVendorId?";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPurchaseRequisitionByVendorId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseRequisitionByVendorId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseRequisitionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseRequisitionDto[]>;
        }));
    }

    protected processGetPurchaseRequisitionByVendorId(response: HttpResponseBase): Observable<PurchaseRequisitionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(PurchaseRequisitionDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseRequisitionDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    generateNewVendorCode(tenantId: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Vendor/GenerateNewVendorCode?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGenerateNewVendorCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateNewVendorCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateNewVendorCode(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class VendorInvoiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createVendorInvoice(body: VendorInvoiceDto | undefined): Observable<VendorInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoice/CreateVendorInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateVendorInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateVendorInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceDto>;
        }));
    }

    protected processCreateVendorInvoice(response: HttpResponseBase): Observable<VendorInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorInvoiceDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    syncCreateVendorInvoice(body: VendorInvoiceDto | undefined): Observable<VendorInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoice/SyncCreateVendorInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSyncCreateVendorInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncCreateVendorInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceDto>;
        }));
    }

    protected processSyncCreateVendorInvoice(response: HttpResponseBase): Observable<VendorInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorInvoiceDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createListVendorInvoice(body: VendorInvoiceDto[] | undefined): Observable<VendorInvoiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoice/CreateListVendorInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateListVendorInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateListVendorInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceDto[]>;
        }));
    }

    protected processCreateListVendorInvoice(response: HttpResponseBase): Observable<VendorInvoiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(VendorInvoiceDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceDto[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getVendorInvoices(tenantId: number | undefined): Observable<VendorInvoice[]> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoice/GetVendorInvoices?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVendorInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoice[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoice[]>;
        }));
    }

    protected processGetVendorInvoices(response: HttpResponseBase): Observable<VendorInvoice[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(VendorInvoice.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoice[]>(null as any);
    }

    /**
     * @param purchaseRequisitionId (optional) 
     * @return Success
     */
    getVendorInvoicesByPrId(purchaseRequisitionId: number | undefined): Observable<VendorInvoice[]> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoice/GetVendorInvoicesByPrId?";
        if (purchaseRequisitionId === null)
            throw new Error("The parameter 'purchaseRequisitionId' cannot be null.");
        else if (purchaseRequisitionId !== undefined)
            url_ += "PurchaseRequisitionId=" + encodeURIComponent("" + purchaseRequisitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVendorInvoicesByPrId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorInvoicesByPrId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoice[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoice[]>;
        }));
    }

    protected processGetVendorInvoicesByPrId(response: HttpResponseBase): Observable<VendorInvoice[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(VendorInvoice.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoice[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getVendorInvoicesForGrn(tenantId: number | undefined): Observable<VendorInvoiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoice/GetVendorInvoicesForGrn?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVendorInvoicesForGrn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorInvoicesForGrn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceDto[]>;
        }));
    }

    protected processGetVendorInvoicesForGrn(response: HttpResponseBase): Observable<VendorInvoiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(VendorInvoiceDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getVendorInvoiceById(id: number | undefined): Observable<VendorInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoice/GetVendorInvoiceById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVendorInvoiceById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorInvoiceById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceDto>;
        }));
    }

    protected processGetVendorInvoiceById(response: HttpResponseBase): Observable<VendorInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorInvoiceDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getVendorInvoicesWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<VendorInvoiceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoice/GetVendorInvoicesWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVendorInvoicesWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorInvoicesWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceDtoPagedResultDto>;
        }));
    }

    protected processGetVendorInvoicesWithInput(response: HttpResponseBase): Observable<VendorInvoiceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorInvoiceDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateVendorInvoice(id: number | undefined, body: VendorInvoiceDto | undefined): Observable<VendorInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoice/UpdateVendorInvoice?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateVendorInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVendorInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceDto>;
        }));
    }

    protected processUpdateVendorInvoice(response: HttpResponseBase): Observable<VendorInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorInvoiceDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateVendorInvoicePoId(id: number | undefined, body: VendorInvoiceDto | undefined): Observable<VendorInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoice/UpdateVendorInvoicePoId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateVendorInvoicePoId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVendorInvoicePoId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceDto>;
        }));
    }

    protected processUpdateVendorInvoicePoId(response: HttpResponseBase): Observable<VendorInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorInvoiceDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateVendorInvoiceInstallationDetails(id: number | undefined, body: VendorInvoiceDto | undefined): Observable<VendorInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoice/UpdateVendorInvoiceInstallationDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateVendorInvoiceInstallationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVendorInvoiceInstallationDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceDto>;
        }));
    }

    protected processUpdateVendorInvoiceInstallationDetails(response: HttpResponseBase): Observable<VendorInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorInvoiceDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateVendorInvoiceDeliveryDetails(id: number | undefined, body: VendorInvoiceDto | undefined): Observable<VendorInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoice/UpdateVendorInvoiceDeliveryDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateVendorInvoiceDeliveryDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVendorInvoiceDeliveryDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceDto>;
        }));
    }

    protected processUpdateVendorInvoiceDeliveryDetails(response: HttpResponseBase): Observable<VendorInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorInvoiceDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateListVendorInvoice(body: VendorInvoiceDto[] | undefined): Observable<VendorInvoiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoice/UpdateListVendorInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateListVendorInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateListVendorInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceDto[]>;
        }));
    }

    protected processUpdateListVendorInvoice(response: HttpResponseBase): Observable<VendorInvoiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(VendorInvoiceDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateVendorInvoiceStatus(body: UpdateVendorInvoiceDto | undefined): Observable<UpdateVendorInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoice/UpdateVendorInvoiceStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateVendorInvoiceStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVendorInvoiceStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateVendorInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateVendorInvoiceDto>;
        }));
    }

    protected processUpdateVendorInvoiceStatus(response: HttpResponseBase): Observable<UpdateVendorInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateVendorInvoiceDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateVendorInvoiceDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteVendorInvoice(id: number | undefined): Observable<VendorInvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoice/DeleteVendorInvoice?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteVendorInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteVendorInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceDto>;
        }));
    }

    protected processDeleteVendorInvoice(response: HttpResponseBase): Observable<VendorInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorInvoiceDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceDto>(null as any);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteListVendorInvoice(ids: number[] | undefined): Observable<VendorInvoiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoice/DeleteListVendorInvoice?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteListVendorInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteListVendorInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceDto[]>;
        }));
    }

    protected processDeleteListVendorInvoice(response: HttpResponseBase): Observable<VendorInvoiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(VendorInvoiceDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceDto[]>(null as any);
    }

    /**
     * @return Success
     */
    checkDueDeliveries(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoice/CheckDueDeliveries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCheckDueDeliveries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDueDeliveries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCheckDueDeliveries(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param reminderType (optional) 
     * @param body (optional) 
     * @return Success
     */
    sendReminderToEmail(reminderType: number | undefined, body: VendorInvoiceDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoice/SendReminderToEmail?";
        if (reminderType === null)
            throw new Error("The parameter 'reminderType' cannot be null.");
        else if (reminderType !== undefined)
            url_ += "reminderType=" + encodeURIComponent("" + reminderType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendReminderToEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendReminderToEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendReminderToEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendReminderToHod(body: VendorInvoiceDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoice/SendReminderToHod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendReminderToHod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendReminderToHod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendReminderToHod(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class VendorInvoiceItemServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createVendorInvoiceItem(body: VendorInvoiceItemDto | undefined): Observable<VendorInvoiceItemDto> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoiceItem/CreateVendorInvoiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateVendorInvoiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateVendorInvoiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItemDto>;
        }));
    }

    protected processCreateVendorInvoiceItem(response: HttpResponseBase): Observable<VendorInvoiceItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorInvoiceItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    syncCreateVendorInvoiceItem(body: VendorInvoiceItemDto | undefined): Observable<VendorInvoiceItemDto> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoiceItem/SyncCreateVendorInvoiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSyncCreateVendorInvoiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncCreateVendorInvoiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItemDto>;
        }));
    }

    protected processSyncCreateVendorInvoiceItem(response: HttpResponseBase): Observable<VendorInvoiceItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorInvoiceItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItemDto>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getVendorInvoiceItems(tenantId: number | undefined): Observable<VendorInvoiceItem[]> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoiceItem/GetVendorInvoiceItems?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVendorInvoiceItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorInvoiceItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItem[]>;
        }));
    }

    protected processGetVendorInvoiceItems(response: HttpResponseBase): Observable<VendorInvoiceItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(VendorInvoiceItem.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItem[]>(null as any);
    }

    /**
     * @param vendorInvoiceId (optional) 
     * @return Success
     */
    getVendorInvoiceItemsByVendorInvoiceId(vendorInvoiceId: number | undefined): Observable<VendorInvoiceItem[]> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoiceItem/GetVendorInvoiceItemsByVendorInvoiceId?";
        if (vendorInvoiceId === null)
            throw new Error("The parameter 'vendorInvoiceId' cannot be null.");
        else if (vendorInvoiceId !== undefined)
            url_ += "vendorInvoiceId=" + encodeURIComponent("" + vendorInvoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVendorInvoiceItemsByVendorInvoiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorInvoiceItemsByVendorInvoiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItem[]>;
        }));
    }

    protected processGetVendorInvoiceItemsByVendorInvoiceId(response: HttpResponseBase): Observable<VendorInvoiceItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(VendorInvoiceItem.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItem[]>(null as any);
    }

    /**
     * @param vendorInvoiceId (optional) 
     * @return Success
     */
    getVendorInvoiceItemDtosByVendorInvoiceId(vendorInvoiceId: number | undefined): Observable<VendorInvoiceItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoiceItem/GetVendorInvoiceItemDtosByVendorInvoiceId?";
        if (vendorInvoiceId === null)
            throw new Error("The parameter 'vendorInvoiceId' cannot be null.");
        else if (vendorInvoiceId !== undefined)
            url_ += "vendorInvoiceId=" + encodeURIComponent("" + vendorInvoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVendorInvoiceItemDtosByVendorInvoiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorInvoiceItemDtosByVendorInvoiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItemDto[]>;
        }));
    }

    protected processGetVendorInvoiceItemDtosByVendorInvoiceId(response: HttpResponseBase): Observable<VendorInvoiceItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(VendorInvoiceItemDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItemDto[]>(null as any);
    }

    /**
     * @param vendorInvoiceId (optional) 
     * @return Success
     */
    getVendorInvoiceItemsForCreditNoteByVendorInvoiceId(vendorInvoiceId: number | undefined): Observable<VendorInvoiceItem[]> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoiceItem/GetVendorInvoiceItemsForCreditNoteByVendorInvoiceId?";
        if (vendorInvoiceId === null)
            throw new Error("The parameter 'vendorInvoiceId' cannot be null.");
        else if (vendorInvoiceId !== undefined)
            url_ += "vendorInvoiceId=" + encodeURIComponent("" + vendorInvoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVendorInvoiceItemsForCreditNoteByVendorInvoiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorInvoiceItemsForCreditNoteByVendorInvoiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItem[]>;
        }));
    }

    protected processGetVendorInvoiceItemsForCreditNoteByVendorInvoiceId(response: HttpResponseBase): Observable<VendorInvoiceItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(VendorInvoiceItem.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItem[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getVendorInvoiceItemById(id: number | undefined): Observable<VendorInvoiceItem> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoiceItem/GetVendorInvoiceItemById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVendorInvoiceItemById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorInvoiceItemById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItem>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItem>;
        }));
    }

    protected processGetVendorInvoiceItemById(response: HttpResponseBase): Observable<VendorInvoiceItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorInvoiceItem.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItem>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getVendorInvoiceItemsWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, tenantId: number | undefined): Observable<VendorInvoiceItemPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoiceItem/GetVendorInvoiceItemsWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVendorInvoiceItemsWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorInvoiceItemsWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItemPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItemPagedResultDto>;
        }));
    }

    protected processGetVendorInvoiceItemsWithInput(response: HttpResponseBase): Observable<VendorInvoiceItemPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorInvoiceItemPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItemPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateVendorInvoiceItem(id: number | undefined, body: VendorInvoiceItemDto | undefined): Observable<VendorInvoiceItemDto> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoiceItem/UpdateVendorInvoiceItem?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateVendorInvoiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVendorInvoiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItemDto>;
        }));
    }

    protected processUpdateVendorInvoiceItem(response: HttpResponseBase): Observable<VendorInvoiceItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorInvoiceItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateVendorInvoiceItemFromObject(body: VendorInvoiceItem | undefined): Observable<VendorInvoiceItem> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoiceItem/UpdateVendorInvoiceItemFromObject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateVendorInvoiceItemFromObject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVendorInvoiceItemFromObject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItem>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItem>;
        }));
    }

    protected processUpdateVendorInvoiceItemFromObject(response: HttpResponseBase): Observable<VendorInvoiceItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorInvoiceItem.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItem>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateVendorInvoiceItemOriginalIdAndCode(id: number | undefined, body: VendorInvoiceItemDto | undefined): Observable<VendorInvoiceItemDto> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoiceItem/UpdateVendorInvoiceItemOriginalIdAndCode?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateVendorInvoiceItemOriginalIdAndCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVendorInvoiceItemOriginalIdAndCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItemDto>;
        }));
    }

    protected processUpdateVendorInvoiceItemOriginalIdAndCode(response: HttpResponseBase): Observable<VendorInvoiceItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorInvoiceItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateListSupplementaryGrnQuantityVendorInvoiceItem(body: VendorInvoiceItemDto[] | undefined): Observable<VendorInvoiceItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoiceItem/updateListSupplementaryGrnQuantityVendorInvoiceItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateListSupplementaryGrnQuantityVendorInvoiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateListSupplementaryGrnQuantityVendorInvoiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItemDto[]>;
        }));
    }

    protected processUpdateListSupplementaryGrnQuantityVendorInvoiceItem(response: HttpResponseBase): Observable<VendorInvoiceItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(VendorInvoiceItemDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItemDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateVendorInvoiceItemGrnQuantity(id: number | undefined, body: VendorInvoiceItemDto | undefined): Observable<VendorInvoiceItemDto> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoiceItem/UpdateVendorInvoiceItemGrnQuantity?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateVendorInvoiceItemGrnQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVendorInvoiceItemGrnQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItemDto>;
        }));
    }

    protected processUpdateVendorInvoiceItemGrnQuantity(response: HttpResponseBase): Observable<VendorInvoiceItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorInvoiceItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateListVendorInvoiceItemGrnQuantity(body: VendorInvoiceItemDto[] | undefined): Observable<VendorInvoiceItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoiceItem/UpdateListVendorInvoiceItemGrnQuantity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateListVendorInvoiceItemGrnQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateListVendorInvoiceItemGrnQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItemDto[]>;
        }));
    }

    protected processUpdateListVendorInvoiceItemGrnQuantity(response: HttpResponseBase): Observable<VendorInvoiceItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(VendorInvoiceItemDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItemDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteVendorInvoiceItem(id: number | undefined): Observable<VendorInvoiceItemDto> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoiceItem/DeleteVendorInvoiceItem?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteVendorInvoiceItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteVendorInvoiceItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItemDto>;
        }));
    }

    protected processDeleteVendorInvoiceItem(response: HttpResponseBase): Observable<VendorInvoiceItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorInvoiceItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItemDto>(null as any);
    }

    /**
     * @param vendorInvoiceItemId (optional) 
     * @param value (optional) 
     * @return Success
     */
    updateItemIsTaxRecoverable(vendorInvoiceItemId: number | undefined, value: boolean | undefined): Observable<VendorInvoiceItemDto> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoiceItem/UpdateItemIsTaxRecoverable?";
        if (vendorInvoiceItemId === null)
            throw new Error("The parameter 'vendorInvoiceItemId' cannot be null.");
        else if (vendorInvoiceItemId !== undefined)
            url_ += "vendorInvoiceItemId=" + encodeURIComponent("" + vendorInvoiceItemId) + "&";
        if (value === null)
            throw new Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateItemIsTaxRecoverable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateItemIsTaxRecoverable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItemDto>;
        }));
    }

    protected processUpdateItemIsTaxRecoverable(response: HttpResponseBase): Observable<VendorInvoiceItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorInvoiceItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItemDto>(null as any);
    }

    /**
     * @param itemGuid (optional) 
     * @return Success
     */
    getLastPurchasedPrice(itemGuid: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoiceItem/GetLastPurchasedPrice?";
        if (itemGuid === null)
            throw new Error("The parameter 'itemGuid' cannot be null.");
        else if (itemGuid !== undefined)
            url_ += "itemGuid=" + encodeURIComponent("" + itemGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLastPurchasedPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastPurchasedPrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetLastPurchasedPrice(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    splitItem(body: VendorInvoiceItem[] | undefined): Observable<VendorInvoiceItem[]> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoiceItem/SplitItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSplitItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSplitItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoiceItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoiceItem[]>;
        }));
    }

    protected processSplitItem(response: HttpResponseBase): Observable<VendorInvoiceItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(VendorInvoiceItem.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoiceItem[]>(null as any);
    }

    /**
     * @param ncaId (optional) 
     * @return Success
     */
    getVendorInvoiceFromNonCurrentAssetId(ncaId: string | undefined): Observable<VendorInvoice> {
        let url_ = this.baseUrl + "/api/services/app/VendorInvoiceItem/GetVendorInvoiceFromNonCurrentAssetId?";
        if (ncaId === null)
            throw new Error("The parameter 'ncaId' cannot be null.");
        else if (ncaId !== undefined)
            url_ += "ncaId=" + encodeURIComponent("" + ncaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetVendorInvoiceFromNonCurrentAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendorInvoiceFromNonCurrentAssetId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VendorInvoice>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VendorInvoice>;
        }));
    }

    protected processGetVendorInvoiceFromNonCurrentAssetId(response: HttpResponseBase): Observable<VendorInvoice> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = VendorInvoice.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VendorInvoice>(null as any);
    }
}

@Injectable()
export class WishlistServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getByProductId(id: string | undefined): Observable<WishlistDto> {
        let url_ = this.baseUrl + "/api/services/app/Wishlist/GetByProductId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetByProductId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProductId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WishlistDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WishlistDto>;
        }));
    }

    protected processGetByProductId(response: HttpResponseBase): Observable<WishlistDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WishlistDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WishlistDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserWishlistsByUserId(userId: number | undefined): Observable<WishlistDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Wishlist/GetUserWishlistsByUserId?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUserWishlistsByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserWishlistsByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WishlistDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WishlistDto[]>;
        }));
    }

    protected processGetUserWishlistsByUserId(response: HttpResponseBase): Observable<WishlistDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(WishlistDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WishlistDto[]>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    clearUserWishlist(userId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Wishlist/ClearUserWishlist?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processClearUserWishlist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearUserWishlist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processClearUserWishlist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param wishlistId (optional) 
     * @return Success
     */
    removeWishlistItem(wishlistId: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Wishlist/RemoveWishlistItem?";
        if (wishlistId === null)
            throw new Error("The parameter 'wishlistId' cannot be null.");
        else if (wishlistId !== undefined)
            url_ += "WishlistId=" + encodeURIComponent("" + wishlistId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRemoveWishlistItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveWishlistItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRemoveWishlistItem(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<WishlistDto> {
        let url_ = this.baseUrl + "/api/services/app/Wishlist/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WishlistDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WishlistDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WishlistDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WishlistDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WishlistDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<WishlistDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Wishlist/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WishlistDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WishlistDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<WishlistDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WishlistDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WishlistDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateWishlistDto | undefined): Observable<WishlistDto> {
        let url_ = this.baseUrl + "/api/services/app/Wishlist/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WishlistDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WishlistDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<WishlistDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WishlistDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WishlistDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateWishlistDto | undefined): Observable<WishlistDto> {
        let url_ = this.baseUrl + "/api/services/app/Wishlist/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WishlistDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WishlistDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<WishlistDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WishlistDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WishlistDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Wishlist/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class WriteOffNoteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createWriteOffNote(body: WriteOffNoteDto | undefined): Observable<WriteOffNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNote/CreateWriteOffNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateWriteOffNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWriteOffNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteDto>;
        }));
    }

    protected processCreateWriteOffNote(response: HttpResponseBase): Observable<WriteOffNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWriteOffNote(body: WriteOffNoteDto | undefined): Observable<WriteOffNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNote/UpdateWriteOffNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateWriteOffNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWriteOffNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteDto>;
        }));
    }

    protected processUpdateWriteOffNote(response: HttpResponseBase): Observable<WriteOffNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getWriteOffNoteById(id: number | undefined): Observable<WriteOffNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNote/GetWriteOffNoteById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetWriteOffNoteById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWriteOffNoteById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteDto>;
        }));
    }

    protected processGetWriteOffNoteById(response: HttpResponseBase): Observable<WriteOffNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getAdjustmentForApprovalWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<WriteOffNoteDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNote/GetAdjustmentForApprovalWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAdjustmentForApprovalWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdjustmentForApprovalWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteDtoPagedResultDto>;
        }));
    }

    protected processGetAdjustmentForApprovalWithInput(response: HttpResponseBase): Observable<WriteOffNoteDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteDtoPagedResultDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getAdjustmentsWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<WriteOffNoteDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNote/GetAdjustmentsWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAdjustmentsWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdjustmentsWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteDtoPagedResultDto>;
        }));
    }

    protected processGetAdjustmentsWithInput(response: HttpResponseBase): Observable<WriteOffNoteDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteDtoPagedResultDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getTransferNoteWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<WriteOffNoteDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNote/GetTransferNoteWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTransferNoteWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferNoteWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteDtoPagedResultDto>;
        }));
    }

    protected processGetTransferNoteWithInput(response: HttpResponseBase): Observable<WriteOffNoteDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteDtoPagedResultDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getProductionIssuesWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<WriteOffNoteDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNote/GetProductionIssuesWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductionIssuesWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductionIssuesWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteDtoPagedResultDto>;
        }));
    }

    protected processGetProductionIssuesWithInput(response: HttpResponseBase): Observable<WriteOffNoteDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteDtoPagedResultDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getProjectIssuesWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, tenantId: number | undefined): Observable<WriteOffNoteDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNote/GetProjectIssuesWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProjectIssuesWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectIssuesWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteDtoPagedResultDto>;
        }));
    }

    protected processGetProjectIssuesWithInput(response: HttpResponseBase): Observable<WriteOffNoteDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteDtoPagedResultDto>(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getListWriteOffNoteAndItem(input: number[] | undefined): Observable<WriteOffNoteDto[]> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNote/GetListWriteOffNoteAndItem?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            input && input.forEach(item => { url_ += "input=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetListWriteOffNoteAndItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListWriteOffNoteAndItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteDto[]>;
        }));
    }

    protected processGetListWriteOffNoteAndItem(response: HttpResponseBase): Observable<WriteOffNoteDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(WriteOffNoteDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendEmailToStorekeeper(body: WriteOffNoteDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNote/SendEmailToStorekeeper";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendEmailToStorekeeper(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailToStorekeeper(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendEmailToStorekeeper(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param productId (optional) 
     * @return Success
     */
    getProductionIssuesByProductId(productId: string | undefined): Observable<WriteOffNoteDto[]> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNote/GetProductionIssuesByProductId?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductionIssuesByProductId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductionIssuesByProductId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteDto[]>;
        }));
    }

    protected processGetProductionIssuesByProductId(response: HttpResponseBase): Observable<WriteOffNoteDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(WriteOffNoteDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteDto[]>(null as any);
    }

    /**
     * @param projectId (optional) 
     * @return Success
     */
    getProjectIssueByProjectId(projectId: number | undefined): Observable<WriteOffNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNote/GetProjectIssueByProjectId?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProjectIssueByProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectIssueByProjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteDto>;
        }));
    }

    protected processGetProjectIssueByProjectId(response: HttpResponseBase): Observable<WriteOffNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getAllDetailsById(id: number | undefined): Observable<WriteOffNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNote/GetAllDetailsById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllDetailsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDetailsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteDto>;
        }));
    }

    protected processGetAllDetailsById(response: HttpResponseBase): Observable<WriteOffNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<WriteOffNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNote/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WriteOffNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<WriteOffNoteDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNote/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<WriteOffNoteDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: WriteOffNoteDto | undefined): Observable<WriteOffNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNote/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<WriteOffNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: WriteOffNoteDto | undefined): Observable<WriteOffNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNote/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<WriteOffNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNote/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class WriteOffNoteCategoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getAllWriteOffCategoryByTenantId(tenantId: number | undefined): Observable<WriteOffNoteCategory[]> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteCategory/GetAllWriteOffCategoryByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAllWriteOffCategoryByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWriteOffCategoryByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteCategory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteCategory[]>;
        }));
    }

    protected processGetAllWriteOffCategoryByTenantId(response: HttpResponseBase): Observable<WriteOffNoteCategory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(WriteOffNoteCategory.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteCategory[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getWriteOffNoteCategoryByTenantId(tenantId: number | undefined): Observable<WriteOffNoteCategory[]> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteCategory/GetWriteOffNoteCategoryByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetWriteOffNoteCategoryByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWriteOffNoteCategoryByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteCategory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteCategory[]>;
        }));
    }

    protected processGetWriteOffNoteCategoryByTenantId(response: HttpResponseBase): Observable<WriteOffNoteCategory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(WriteOffNoteCategory.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteCategory[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getTransferCategoryByTenantId(tenantId: number | undefined): Observable<WriteOffNoteCategory[]> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteCategory/GetTransferCategoryByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetTransferCategoryByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferCategoryByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteCategory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteCategory[]>;
        }));
    }

    protected processGetTransferCategoryByTenantId(response: HttpResponseBase): Observable<WriteOffNoteCategory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(WriteOffNoteCategory.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteCategory[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getProductionCategoryByTenantId(tenantId: number | undefined): Observable<WriteOffNoteCategory[]> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteCategory/GetProductionCategoryByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProductionCategoryByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductionCategoryByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteCategory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteCategory[]>;
        }));
    }

    protected processGetProductionCategoryByTenantId(response: HttpResponseBase): Observable<WriteOffNoteCategory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(WriteOffNoteCategory.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteCategory[]>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getProjectCategoryByTenantId(tenantId: number | undefined): Observable<WriteOffNoteCategory[]> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteCategory/GetProjectCategoryByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetProjectCategoryByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectCategoryByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteCategory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteCategory[]>;
        }));
    }

    protected processGetProjectCategoryByTenantId(response: HttpResponseBase): Observable<WriteOffNoteCategory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(WriteOffNoteCategory.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteCategory[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<WriteOffNoteCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteCategory/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteCategoryDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WriteOffNoteCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteCategoryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteCategoryDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<WriteOffNoteCategoryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteCategory/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteCategoryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteCategoryDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<WriteOffNoteCategoryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteCategoryDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteCategoryDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: WriteOffNoteCategoryDto | undefined): Observable<WriteOffNoteCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteCategory/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteCategoryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<WriteOffNoteCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteCategoryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteCategoryDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: WriteOffNoteCategoryDto | undefined): Observable<WriteOffNoteCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteCategory/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteCategoryDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<WriteOffNoteCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteCategoryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteCategoryDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteCategory/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class WriteOffNoteCategoryRelationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param writeOffNoteId (optional) 
     * @return Success
     */
    getCategoriesByWriteOffNoteId(writeOffNoteId: number | undefined): Observable<WriteOffNoteCategoryRelation[]> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteCategoryRelation/GetCategoriesByWriteOffNoteId?";
        if (writeOffNoteId === null)
            throw new Error("The parameter 'writeOffNoteId' cannot be null.");
        else if (writeOffNoteId !== undefined)
            url_ += "writeOffNoteId=" + encodeURIComponent("" + writeOffNoteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCategoriesByWriteOffNoteId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoriesByWriteOffNoteId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteCategoryRelation[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteCategoryRelation[]>;
        }));
    }

    protected processGetCategoriesByWriteOffNoteId(response: HttpResponseBase): Observable<WriteOffNoteCategoryRelation[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(WriteOffNoteCategoryRelation.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteCategoryRelation[]>(null as any);
    }

    /**
     * @param wonCategoryId (optional) 
     * @return Success
     */
    getWriteOffNotesByCategoryId(wonCategoryId: number | undefined): Observable<WriteOffNoteCategoryRelation[]> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteCategoryRelation/GetWriteOffNotesByCategoryId?";
        if (wonCategoryId === null)
            throw new Error("The parameter 'wonCategoryId' cannot be null.");
        else if (wonCategoryId !== undefined)
            url_ += "wonCategoryId=" + encodeURIComponent("" + wonCategoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetWriteOffNotesByCategoryId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWriteOffNotesByCategoryId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteCategoryRelation[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteCategoryRelation[]>;
        }));
    }

    protected processGetWriteOffNotesByCategoryId(response: HttpResponseBase): Observable<WriteOffNoteCategoryRelation[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(WriteOffNoteCategoryRelation.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteCategoryRelation[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateWriteOffNoteCategoryRelation(body: WriteOffNoteCategoryRelationDto | undefined): Observable<WriteOffNoteCategoryRelationDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteCategoryRelation/UpdateWriteOffNoteCategoryRelation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateWriteOffNoteCategoryRelation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWriteOffNoteCategoryRelation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteCategoryRelationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteCategoryRelationDto>;
        }));
    }

    protected processUpdateWriteOffNoteCategoryRelation(response: HttpResponseBase): Observable<WriteOffNoteCategoryRelationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteCategoryRelationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteCategoryRelationDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<WriteOffNoteCategoryRelationDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteCategoryRelation/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteCategoryRelationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteCategoryRelationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WriteOffNoteCategoryRelationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteCategoryRelationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteCategoryRelationDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<WriteOffNoteCategoryRelationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteCategoryRelation/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteCategoryRelationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteCategoryRelationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<WriteOffNoteCategoryRelationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteCategoryRelationDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteCategoryRelationDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: WriteOffNoteCategoryRelationDto | undefined): Observable<WriteOffNoteCategoryRelationDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteCategoryRelation/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteCategoryRelationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteCategoryRelationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<WriteOffNoteCategoryRelationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteCategoryRelationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteCategoryRelationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: WriteOffNoteCategoryRelationDto | undefined): Observable<WriteOffNoteCategoryRelationDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteCategoryRelation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteCategoryRelationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteCategoryRelationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<WriteOffNoteCategoryRelationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteCategoryRelationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteCategoryRelationDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteCategoryRelation/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class WriteOffNoteItemServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param writeOffNoteId (optional) 
     * @return Success
     */
    getItemByWriteOffNoteId(writeOffNoteId: number | undefined): Observable<WriteOffNoteItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteItem/GetItemByWriteOffNoteId?";
        if (writeOffNoteId === null)
            throw new Error("The parameter 'writeOffNoteId' cannot be null.");
        else if (writeOffNoteId !== undefined)
            url_ += "writeOffNoteId=" + encodeURIComponent("" + writeOffNoteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetItemByWriteOffNoteId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetItemByWriteOffNoteId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteItemDto[]>;
        }));
    }

    protected processGetItemByWriteOffNoteId(response: HttpResponseBase): Observable<WriteOffNoteItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(WriteOffNoteItemDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteItemDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<WriteOffNoteItemDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteItem/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteItemDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WriteOffNoteItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteItemDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<WriteOffNoteItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteItem/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<WriteOffNoteItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteItemDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteItemDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: WriteOffNoteItemDto | undefined): Observable<WriteOffNoteItemDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteItem/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteItemDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<WriteOffNoteItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: WriteOffNoteItemDto | undefined): Observable<WriteOffNoteItemDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteItem/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteItemDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<WriteOffNoteItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteItemDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteItem/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class WriteOffNoteLabourServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param writeOffNoteId (optional) 
     * @return Success
     */
    getLabourByWriteOffNoteId(writeOffNoteId: number | undefined): Observable<WriteOffNoteLabour[]> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteLabour/GetLabourByWriteOffNoteId?";
        if (writeOffNoteId === null)
            throw new Error("The parameter 'writeOffNoteId' cannot be null.");
        else if (writeOffNoteId !== undefined)
            url_ += "writeOffNoteId=" + encodeURIComponent("" + writeOffNoteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLabourByWriteOffNoteId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabourByWriteOffNoteId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteLabour[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteLabour[]>;
        }));
    }

    protected processGetLabourByWriteOffNoteId(response: HttpResponseBase): Observable<WriteOffNoteLabour[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(WriteOffNoteLabour.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteLabour[]>(null as any);
    }

    /**
     * @param writeOffNoteId (optional) 
     * @return Success
     */
    getLabourDtoByWriteOffNoteId(writeOffNoteId: number | undefined): Observable<WriteOffNoteLabourDto[]> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteLabour/GetLabourDtoByWriteOffNoteId?";
        if (writeOffNoteId === null)
            throw new Error("The parameter 'writeOffNoteId' cannot be null.");
        else if (writeOffNoteId !== undefined)
            url_ += "writeOffNoteId=" + encodeURIComponent("" + writeOffNoteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetLabourDtoByWriteOffNoteId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabourDtoByWriteOffNoteId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteLabourDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteLabourDto[]>;
        }));
    }

    protected processGetLabourDtoByWriteOffNoteId(response: HttpResponseBase): Observable<WriteOffNoteLabourDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(WriteOffNoteLabourDto.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteLabourDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<WriteOffNoteLabourDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteLabour/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteLabourDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteLabourDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WriteOffNoteLabourDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteLabourDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteLabourDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<WriteOffNoteLabourDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteLabour/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteLabourDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteLabourDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<WriteOffNoteLabourDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteLabourDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteLabourDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: WriteOffNoteLabourDto | undefined): Observable<WriteOffNoteLabourDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteLabour/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteLabourDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteLabourDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<WriteOffNoteLabourDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteLabourDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteLabourDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: WriteOffNoteLabourDto | undefined): Observable<WriteOffNoteLabourDto> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteLabour/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WriteOffNoteLabourDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WriteOffNoteLabourDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<WriteOffNoteLabourDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = WriteOffNoteLabourDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WriteOffNoteLabourDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WriteOffNoteLabour/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class YayasanHijauServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createYhmReceipt(body: YayasanHijauDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/YayasanHijau/CreateYhmReceipt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateYhmReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateYhmReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateYhmReceipt(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendEmailToYayasan(body: YayasanHijau | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/YayasanHijau/SendEmailToYayasan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendEmailToYayasan(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailToYayasan(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendEmailToYayasan(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendAcknowledgementEmailToCustomer(body: YayasanHijau | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/YayasanHijau/SendAcknowledgementEmailToCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendAcknowledgementEmailToCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAcknowledgementEmailToCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendAcknowledgementEmailToCustomer(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getYayasanHijauReceipt(id: string | undefined): Observable<YayasanHijau> {
        let url_ = this.baseUrl + "/api/services/app/YayasanHijau/GetYayasanHijauReceipt?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetYayasanHijauReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetYayasanHijauReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<YayasanHijau>;
                }
            } else
                return _observableThrow(response_) as any as Observable<YayasanHijau>;
        }));
    }

    protected processGetYayasanHijauReceipt(response: HttpResponseBase): Observable<YayasanHijau> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = YayasanHijau.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<YayasanHijau>(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @return Success
     */
    getYayasanHijauReceiptsByTenantId(tenantId: number | undefined): Observable<YayasanHijau[]> {
        let url_ = this.baseUrl + "/api/services/app/YayasanHijau/GetYayasanHijauReceiptsByTenantId?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetYayasanHijauReceiptsByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetYayasanHijauReceiptsByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<YayasanHijau[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<YayasanHijau[]>;
        }));
    }

    protected processGetYayasanHijauReceiptsByTenantId(response: HttpResponseBase): Observable<YayasanHijau[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200.push(YayasanHijau.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<YayasanHijau[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getYayasanHijauReceiptsWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<YayasanHijauPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/YayasanHijau/GetYayasanHijauReceiptsWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetYayasanHijauReceiptsWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetYayasanHijauReceiptsWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<YayasanHijauPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<YayasanHijauPagedResultDto>;
        }));
    }

    protected processGetYayasanHijauReceiptsWithInput(response: HttpResponseBase): Observable<YayasanHijauPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = YayasanHijauPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<YayasanHijauPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateReceipt(body: YayasanHijau | undefined): Observable<YayasanHijau> {
        let url_ = this.baseUrl + "/api/services/app/YayasanHijau/UpdateReceipt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<YayasanHijau>;
                }
            } else
                return _observableThrow(response_) as any as Observable<YayasanHijau>;
        }));
    }

    protected processUpdateReceipt(response: HttpResponseBase): Observable<YayasanHijau> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = YayasanHijau.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<YayasanHijau>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendReceiptToUser(body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/YayasanHijau/SendReceiptToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSendReceiptToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendReceiptToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendReceiptToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDonationProgram(body: DonationProgramDto | undefined): Observable<DonationProgramDto> {
        let url_ = this.baseUrl + "/api/services/app/YayasanHijau/CreateDonationProgram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateDonationProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDonationProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DonationProgramDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DonationProgramDto>;
        }));
    }

    protected processCreateDonationProgram(response: HttpResponseBase): Observable<DonationProgramDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DonationProgramDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DonationProgramDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDonationProgramFromList(body: DonationProgramDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/YayasanHijau/CreateDonationProgramFromList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateDonationProgramFromList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDonationProgramFromList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateDonationProgramFromList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getDonationProgramWithInput(filter: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<DonationProgramPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/YayasanHijau/GetDonationProgramWithInput?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetDonationProgramWithInput(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDonationProgramWithInput(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DonationProgramPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DonationProgramPagedResultDto>;
        }));
    }

    protected processGetDonationProgramWithInput(response: HttpResponseBase): Observable<DonationProgramPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DonationProgramPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DonationProgramPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateDonationProgram(id: number | undefined, body: DonationProgram | undefined): Observable<DonationProgram> {
        let url_ = this.baseUrl + "/api/services/app/YayasanHijau/UpdateDonationProgram?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateDonationProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDonationProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DonationProgram>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DonationProgram>;
        }));
    }

    protected processUpdateDonationProgram(response: HttpResponseBase): Observable<DonationProgram> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DonationProgram.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DonationProgram>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteDonationProgram(id: number | undefined): Observable<DonationProgramDto> {
        let url_ = this.baseUrl + "/api/services/app/YayasanHijau/DeleteDonationProgram?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processDeleteDonationProgram(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDonationProgram(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DonationProgramDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DonationProgramDto>;
        }));
    }

    protected processDeleteDonationProgram(response: HttpResponseBase): Observable<DonationProgramDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DonationProgramDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DonationProgramDto>(null as any);
    }
}

export class AboutDto implements IAboutDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    sellModuleUrl: string | undefined;
    buyModuleUrl: string | undefined;
    payModuleUrl: string | undefined;
    hrModuleUrl: string | undefined;
    accountingModuleUrl: string | undefined;
    inventoryModuleUrl: string | undefined;
    assetModuleUrl: string | undefined;
    projectModuleUrl: string | undefined;
    taxModuleUrl: string | undefined;
    migrationModuleUrl: string | undefined;
    esgModuleUrl: string | undefined;

    constructor(data?: IAboutDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.sellModuleUrl = _data["sellModuleUrl"];
            this.buyModuleUrl = _data["buyModuleUrl"];
            this.payModuleUrl = _data["payModuleUrl"];
            this.hrModuleUrl = _data["hrModuleUrl"];
            this.accountingModuleUrl = _data["accountingModuleUrl"];
            this.inventoryModuleUrl = _data["inventoryModuleUrl"];
            this.assetModuleUrl = _data["assetModuleUrl"];
            this.projectModuleUrl = _data["projectModuleUrl"];
            this.taxModuleUrl = _data["taxModuleUrl"];
            this.migrationModuleUrl = _data["migrationModuleUrl"];
            this.esgModuleUrl = _data["esgModuleUrl"];
        }
    }

    static fromJS(data: any): AboutDto {
        data = typeof data === 'object' ? data : {};
        let result = new AboutDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["sellModuleUrl"] = this.sellModuleUrl;
        data["buyModuleUrl"] = this.buyModuleUrl;
        data["payModuleUrl"] = this.payModuleUrl;
        data["hrModuleUrl"] = this.hrModuleUrl;
        data["accountingModuleUrl"] = this.accountingModuleUrl;
        data["inventoryModuleUrl"] = this.inventoryModuleUrl;
        data["assetModuleUrl"] = this.assetModuleUrl;
        data["projectModuleUrl"] = this.projectModuleUrl;
        data["taxModuleUrl"] = this.taxModuleUrl;
        data["migrationModuleUrl"] = this.migrationModuleUrl;
        data["esgModuleUrl"] = this.esgModuleUrl;
        return data;
    }

    clone(): AboutDto {
        const json = this.toJSON();
        let result = new AboutDto();
        result.init(json);
        return result;
    }
}

export interface IAboutDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    sellModuleUrl: string | undefined;
    buyModuleUrl: string | undefined;
    payModuleUrl: string | undefined;
    hrModuleUrl: string | undefined;
    accountingModuleUrl: string | undefined;
    inventoryModuleUrl: string | undefined;
    assetModuleUrl: string | undefined;
    projectModuleUrl: string | undefined;
    taxModuleUrl: string | undefined;
    migrationModuleUrl: string | undefined;
    esgModuleUrl: string | undefined;
}

export class AboutDtoPagedResultDto implements IAboutDtoPagedResultDto {
    items: AboutDto[] | undefined;
    totalCount: number;

    constructor(data?: IAboutDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AboutDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AboutDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AboutDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AboutDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AboutDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAboutDtoPagedResultDto {
    items: AboutDto[] | undefined;
    totalCount: number;
}

export class AcceptedDocumentDto implements IAcceptedDocumentDto {
    uuid: string | undefined;
    invoiceCodeNumber: string | undefined;

    constructor(data?: IAcceptedDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uuid = _data["uuid"];
            this.invoiceCodeNumber = _data["invoiceCodeNumber"];
        }
    }

    static fromJS(data: any): AcceptedDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptedDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uuid"] = this.uuid;
        data["invoiceCodeNumber"] = this.invoiceCodeNumber;
        return data;
    }

    clone(): AcceptedDocumentDto {
        const json = this.toJSON();
        let result = new AcceptedDocumentDto();
        result.init(json);
        return result;
    }
}

export interface IAcceptedDocumentDto {
    uuid: string | undefined;
    invoiceCodeNumber: string | undefined;
}

export class AccountingData implements IAccountingData {
    isLoading: boolean;
    itemList: LedgerDto[] | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    daysToDate: number;
    myCompany: CompanyProfile;
    tenantId: number;
    materialList: InventoryCategoryDto[] | undefined;
    productList: InventoryCategoryDto[] | undefined;
    ppe: number;
    disposalList: NonCurrentAssetItemDto[] | undefined;
    disposalPPEList: NonCurrentAssetItemDto[] | undefined;
    disposalPPE: number;
    disposalPPE2: number;
    disposalIntangibleList: NonCurrentAssetItemDto[] | undefined;
    disposalIntangible: number;
    disposalIntangible2: number;
    disposalOtherList: NonCurrentAssetItemDto[] | undefined;
    disposalOther: number;
    disposalOther2: number;
    ncaList: any | undefined;
    key: any | undefined;
    budgetList: GeneralDataBudget[] | undefined;
    allAccountList: AccountsChartDto[] | undefined;
    relist: AccountsChartDto[] | undefined;
    dclist: AccountsChartDto[] | undefined;
    selist: AccountsChartDto[] | undefined;
    gelist: AccountsChartDto[] | undefined;
    nclist: AccountsChartDto[] | undefined;
    cllist: AccountsChartDto[] | undefined;
    calist: AccountsChartDto[] | undefined;
    nllist: AccountsChartDto[] | undefined;
    eqlist: AccountsChartDto[] | undefined;
    reSum: number;
    dcSum: number;
    seSum: number;
    geSum: number;
    ncSum: number;
    clSum: number;
    caSum: number;
    nlSum: number;
    eqSum: number;
    projectRevenue: any | undefined;
    rosf: number;
    roce: number;
    operatingProfitMargin: number;
    netProfitMargin: number;
    cgfo: number;
    fcfMargins: number;
    liquidityRatio: number;
    workingCapitalIntensity: number;
    debtServiceCoverRatio: number;
    gearingDebtEquityRatio: number;
    gearingDebtToProfitRatio: number;
    gearingCostStructure: number;

    constructor(data?: IAccountingData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isLoading = _data["isLoading"];
            if (Array.isArray(_data["itemList"])) {
                this.itemList = [] as any;
                for (let item of _data["itemList"])
                    this.itemList.push(LedgerDto.fromJS(item));
            }
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.daysToDate = _data["daysToDate"];
            this.myCompany = _data["myCompany"] ? CompanyProfile.fromJS(_data["myCompany"]) : <any>undefined;
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["materialList"])) {
                this.materialList = [] as any;
                for (let item of _data["materialList"])
                    this.materialList.push(InventoryCategoryDto.fromJS(item));
            }
            if (Array.isArray(_data["productList"])) {
                this.productList = [] as any;
                for (let item of _data["productList"])
                    this.productList.push(InventoryCategoryDto.fromJS(item));
            }
            this.ppe = _data["ppe"];
            if (Array.isArray(_data["disposalList"])) {
                this.disposalList = [] as any;
                for (let item of _data["disposalList"])
                    this.disposalList.push(NonCurrentAssetItemDto.fromJS(item));
            }
            if (Array.isArray(_data["disposalPPEList"])) {
                this.disposalPPEList = [] as any;
                for (let item of _data["disposalPPEList"])
                    this.disposalPPEList.push(NonCurrentAssetItemDto.fromJS(item));
            }
            this.disposalPPE = _data["disposalPPE"];
            this.disposalPPE2 = _data["disposalPPE2"];
            if (Array.isArray(_data["disposalIntangibleList"])) {
                this.disposalIntangibleList = [] as any;
                for (let item of _data["disposalIntangibleList"])
                    this.disposalIntangibleList.push(NonCurrentAssetItemDto.fromJS(item));
            }
            this.disposalIntangible = _data["disposalIntangible"];
            this.disposalIntangible2 = _data["disposalIntangible2"];
            if (Array.isArray(_data["disposalOtherList"])) {
                this.disposalOtherList = [] as any;
                for (let item of _data["disposalOtherList"])
                    this.disposalOtherList.push(NonCurrentAssetItemDto.fromJS(item));
            }
            this.disposalOther = _data["disposalOther"];
            this.disposalOther2 = _data["disposalOther2"];
            this.ncaList = _data["ncaList"];
            this.key = _data["key"];
            if (Array.isArray(_data["budgetList"])) {
                this.budgetList = [] as any;
                for (let item of _data["budgetList"])
                    this.budgetList.push(GeneralDataBudget.fromJS(item));
            }
            if (Array.isArray(_data["allAccountList"])) {
                this.allAccountList = [] as any;
                for (let item of _data["allAccountList"])
                    this.allAccountList.push(AccountsChartDto.fromJS(item));
            }
            if (Array.isArray(_data["relist"])) {
                this.relist = [] as any;
                for (let item of _data["relist"])
                    this.relist.push(AccountsChartDto.fromJS(item));
            }
            if (Array.isArray(_data["dclist"])) {
                this.dclist = [] as any;
                for (let item of _data["dclist"])
                    this.dclist.push(AccountsChartDto.fromJS(item));
            }
            if (Array.isArray(_data["selist"])) {
                this.selist = [] as any;
                for (let item of _data["selist"])
                    this.selist.push(AccountsChartDto.fromJS(item));
            }
            if (Array.isArray(_data["gelist"])) {
                this.gelist = [] as any;
                for (let item of _data["gelist"])
                    this.gelist.push(AccountsChartDto.fromJS(item));
            }
            if (Array.isArray(_data["nclist"])) {
                this.nclist = [] as any;
                for (let item of _data["nclist"])
                    this.nclist.push(AccountsChartDto.fromJS(item));
            }
            if (Array.isArray(_data["cllist"])) {
                this.cllist = [] as any;
                for (let item of _data["cllist"])
                    this.cllist.push(AccountsChartDto.fromJS(item));
            }
            if (Array.isArray(_data["calist"])) {
                this.calist = [] as any;
                for (let item of _data["calist"])
                    this.calist.push(AccountsChartDto.fromJS(item));
            }
            if (Array.isArray(_data["nllist"])) {
                this.nllist = [] as any;
                for (let item of _data["nllist"])
                    this.nllist.push(AccountsChartDto.fromJS(item));
            }
            if (Array.isArray(_data["eqlist"])) {
                this.eqlist = [] as any;
                for (let item of _data["eqlist"])
                    this.eqlist.push(AccountsChartDto.fromJS(item));
            }
            this.reSum = _data["reSum"];
            this.dcSum = _data["dcSum"];
            this.seSum = _data["seSum"];
            this.geSum = _data["geSum"];
            this.ncSum = _data["ncSum"];
            this.clSum = _data["clSum"];
            this.caSum = _data["caSum"];
            this.nlSum = _data["nlSum"];
            this.eqSum = _data["eqSum"];
            this.projectRevenue = _data["projectRevenue"];
            this.rosf = _data["rosf"];
            this.roce = _data["roce"];
            this.operatingProfitMargin = _data["operatingProfitMargin"];
            this.netProfitMargin = _data["netProfitMargin"];
            this.cgfo = _data["cgfo"];
            this.fcfMargins = _data["fcfMargins"];
            this.liquidityRatio = _data["liquidityRatio"];
            this.workingCapitalIntensity = _data["workingCapitalIntensity"];
            this.debtServiceCoverRatio = _data["debtServiceCoverRatio"];
            this.gearingDebtEquityRatio = _data["gearingDebtEquityRatio"];
            this.gearingDebtToProfitRatio = _data["gearingDebtToProfitRatio"];
            this.gearingCostStructure = _data["gearingCostStructure"];
        }
    }

    static fromJS(data: any): AccountingData {
        data = typeof data === 'object' ? data : {};
        let result = new AccountingData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isLoading"] = this.isLoading;
        if (Array.isArray(this.itemList)) {
            data["itemList"] = [];
            for (let item of this.itemList)
                data["itemList"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["daysToDate"] = this.daysToDate;
        data["myCompany"] = this.myCompany ? this.myCompany.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.materialList)) {
            data["materialList"] = [];
            for (let item of this.materialList)
                data["materialList"].push(item.toJSON());
        }
        if (Array.isArray(this.productList)) {
            data["productList"] = [];
            for (let item of this.productList)
                data["productList"].push(item.toJSON());
        }
        data["ppe"] = this.ppe;
        if (Array.isArray(this.disposalList)) {
            data["disposalList"] = [];
            for (let item of this.disposalList)
                data["disposalList"].push(item.toJSON());
        }
        if (Array.isArray(this.disposalPPEList)) {
            data["disposalPPEList"] = [];
            for (let item of this.disposalPPEList)
                data["disposalPPEList"].push(item.toJSON());
        }
        data["disposalPPE"] = this.disposalPPE;
        data["disposalPPE2"] = this.disposalPPE2;
        if (Array.isArray(this.disposalIntangibleList)) {
            data["disposalIntangibleList"] = [];
            for (let item of this.disposalIntangibleList)
                data["disposalIntangibleList"].push(item.toJSON());
        }
        data["disposalIntangible"] = this.disposalIntangible;
        data["disposalIntangible2"] = this.disposalIntangible2;
        if (Array.isArray(this.disposalOtherList)) {
            data["disposalOtherList"] = [];
            for (let item of this.disposalOtherList)
                data["disposalOtherList"].push(item.toJSON());
        }
        data["disposalOther"] = this.disposalOther;
        data["disposalOther2"] = this.disposalOther2;
        data["ncaList"] = this.ncaList;
        data["key"] = this.key;
        if (Array.isArray(this.budgetList)) {
            data["budgetList"] = [];
            for (let item of this.budgetList)
                data["budgetList"].push(item.toJSON());
        }
        if (Array.isArray(this.allAccountList)) {
            data["allAccountList"] = [];
            for (let item of this.allAccountList)
                data["allAccountList"].push(item.toJSON());
        }
        if (Array.isArray(this.relist)) {
            data["relist"] = [];
            for (let item of this.relist)
                data["relist"].push(item.toJSON());
        }
        if (Array.isArray(this.dclist)) {
            data["dclist"] = [];
            for (let item of this.dclist)
                data["dclist"].push(item.toJSON());
        }
        if (Array.isArray(this.selist)) {
            data["selist"] = [];
            for (let item of this.selist)
                data["selist"].push(item.toJSON());
        }
        if (Array.isArray(this.gelist)) {
            data["gelist"] = [];
            for (let item of this.gelist)
                data["gelist"].push(item.toJSON());
        }
        if (Array.isArray(this.nclist)) {
            data["nclist"] = [];
            for (let item of this.nclist)
                data["nclist"].push(item.toJSON());
        }
        if (Array.isArray(this.cllist)) {
            data["cllist"] = [];
            for (let item of this.cllist)
                data["cllist"].push(item.toJSON());
        }
        if (Array.isArray(this.calist)) {
            data["calist"] = [];
            for (let item of this.calist)
                data["calist"].push(item.toJSON());
        }
        if (Array.isArray(this.nllist)) {
            data["nllist"] = [];
            for (let item of this.nllist)
                data["nllist"].push(item.toJSON());
        }
        if (Array.isArray(this.eqlist)) {
            data["eqlist"] = [];
            for (let item of this.eqlist)
                data["eqlist"].push(item.toJSON());
        }
        data["reSum"] = this.reSum;
        data["dcSum"] = this.dcSum;
        data["seSum"] = this.seSum;
        data["geSum"] = this.geSum;
        data["ncSum"] = this.ncSum;
        data["clSum"] = this.clSum;
        data["caSum"] = this.caSum;
        data["nlSum"] = this.nlSum;
        data["eqSum"] = this.eqSum;
        data["projectRevenue"] = this.projectRevenue;
        data["rosf"] = this.rosf;
        data["roce"] = this.roce;
        data["operatingProfitMargin"] = this.operatingProfitMargin;
        data["netProfitMargin"] = this.netProfitMargin;
        data["cgfo"] = this.cgfo;
        data["fcfMargins"] = this.fcfMargins;
        data["liquidityRatio"] = this.liquidityRatio;
        data["workingCapitalIntensity"] = this.workingCapitalIntensity;
        data["debtServiceCoverRatio"] = this.debtServiceCoverRatio;
        data["gearingDebtEquityRatio"] = this.gearingDebtEquityRatio;
        data["gearingDebtToProfitRatio"] = this.gearingDebtToProfitRatio;
        data["gearingCostStructure"] = this.gearingCostStructure;
        return data;
    }

    clone(): AccountingData {
        const json = this.toJSON();
        let result = new AccountingData();
        result.init(json);
        return result;
    }
}

export interface IAccountingData {
    isLoading: boolean;
    itemList: LedgerDto[] | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    daysToDate: number;
    myCompany: CompanyProfile;
    tenantId: number;
    materialList: InventoryCategoryDto[] | undefined;
    productList: InventoryCategoryDto[] | undefined;
    ppe: number;
    disposalList: NonCurrentAssetItemDto[] | undefined;
    disposalPPEList: NonCurrentAssetItemDto[] | undefined;
    disposalPPE: number;
    disposalPPE2: number;
    disposalIntangibleList: NonCurrentAssetItemDto[] | undefined;
    disposalIntangible: number;
    disposalIntangible2: number;
    disposalOtherList: NonCurrentAssetItemDto[] | undefined;
    disposalOther: number;
    disposalOther2: number;
    ncaList: any | undefined;
    key: any | undefined;
    budgetList: GeneralDataBudget[] | undefined;
    allAccountList: AccountsChartDto[] | undefined;
    relist: AccountsChartDto[] | undefined;
    dclist: AccountsChartDto[] | undefined;
    selist: AccountsChartDto[] | undefined;
    gelist: AccountsChartDto[] | undefined;
    nclist: AccountsChartDto[] | undefined;
    cllist: AccountsChartDto[] | undefined;
    calist: AccountsChartDto[] | undefined;
    nllist: AccountsChartDto[] | undefined;
    eqlist: AccountsChartDto[] | undefined;
    reSum: number;
    dcSum: number;
    seSum: number;
    geSum: number;
    ncSum: number;
    clSum: number;
    caSum: number;
    nlSum: number;
    eqSum: number;
    projectRevenue: any | undefined;
    rosf: number;
    roce: number;
    operatingProfitMargin: number;
    netProfitMargin: number;
    cgfo: number;
    fcfMargins: number;
    liquidityRatio: number;
    workingCapitalIntensity: number;
    debtServiceCoverRatio: number;
    gearingDebtEquityRatio: number;
    gearingDebtToProfitRatio: number;
    gearingCostStructure: number;
}

export class AccountsChart implements IAccountsChart {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    categoryCode: string | undefined;
    description: string | undefined;
    source: string | undefined;
    isProcurement: boolean;
    totalStock: number;
    totalBudget: number;
    totalCost: number;
    code: string | undefined;
    name: string | undefined;
    canEdit: boolean;
    category: string | undefined;
    showCashbook: boolean;
    typeOfCompany: string | undefined;
    depreciationFor: string | undefined;
    amortizationFor: string | undefined;
    notesUrl: string | undefined;
    notesText: string | undefined;
    parentCode: string | undefined;
    descriptionMalay: string | undefined;

    constructor(data?: IAccountsChart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.categoryCode = _data["categoryCode"];
            this.description = _data["description"];
            this.source = _data["source"];
            this.isProcurement = _data["isProcurement"];
            this.totalStock = _data["totalStock"];
            this.totalBudget = _data["totalBudget"];
            this.totalCost = _data["totalCost"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.canEdit = _data["canEdit"];
            this.category = _data["category"];
            this.showCashbook = _data["showCashbook"];
            this.typeOfCompany = _data["typeOfCompany"];
            this.depreciationFor = _data["depreciationFor"];
            this.amortizationFor = _data["amortizationFor"];
            this.notesUrl = _data["notesUrl"];
            this.notesText = _data["notesText"];
            this.parentCode = _data["parentCode"];
            this.descriptionMalay = _data["descriptionMalay"];
        }
    }

    static fromJS(data: any): AccountsChart {
        data = typeof data === 'object' ? data : {};
        let result = new AccountsChart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["categoryCode"] = this.categoryCode;
        data["description"] = this.description;
        data["source"] = this.source;
        data["isProcurement"] = this.isProcurement;
        data["totalStock"] = this.totalStock;
        data["totalBudget"] = this.totalBudget;
        data["totalCost"] = this.totalCost;
        data["code"] = this.code;
        data["name"] = this.name;
        data["canEdit"] = this.canEdit;
        data["category"] = this.category;
        data["showCashbook"] = this.showCashbook;
        data["typeOfCompany"] = this.typeOfCompany;
        data["depreciationFor"] = this.depreciationFor;
        data["amortizationFor"] = this.amortizationFor;
        data["notesUrl"] = this.notesUrl;
        data["notesText"] = this.notesText;
        data["parentCode"] = this.parentCode;
        data["descriptionMalay"] = this.descriptionMalay;
        return data;
    }

    clone(): AccountsChart {
        const json = this.toJSON();
        let result = new AccountsChart();
        result.init(json);
        return result;
    }
}

export interface IAccountsChart {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    categoryCode: string | undefined;
    description: string | undefined;
    source: string | undefined;
    isProcurement: boolean;
    totalStock: number;
    totalBudget: number;
    totalCost: number;
    code: string | undefined;
    name: string | undefined;
    canEdit: boolean;
    category: string | undefined;
    showCashbook: boolean;
    typeOfCompany: string | undefined;
    depreciationFor: string | undefined;
    amortizationFor: string | undefined;
    notesUrl: string | undefined;
    notesText: string | undefined;
    parentCode: string | undefined;
    descriptionMalay: string | undefined;
}

export class AccountsChartDto implements IAccountsChartDto {
    tenantId: number;
    accountsChartId: number;
    categoryCode: string | undefined;
    description: string | undefined;
    source: string | undefined;
    isProcurement: boolean;
    totalStock: number;
    totalBudget: number;
    totalCost: number;
    children: AccountsChart[] | undefined;
    code: string | undefined;
    name: string | undefined;
    canEdit: boolean;
    category: string | undefined;
    showCashbook: boolean;
    typeOfCompany: string | undefined;
    depreciationFor: string | undefined;
    amortizationFor: string | undefined;
    notesUrl: string | undefined;
    notesText: string | undefined;
    parentCode: string | undefined;
    date: moment.Moment | undefined;
    descriptionMalay: string | undefined;

    constructor(data?: IAccountsChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.accountsChartId = _data["accountsChartId"];
            this.categoryCode = _data["categoryCode"];
            this.description = _data["description"];
            this.source = _data["source"];
            this.isProcurement = _data["isProcurement"];
            this.totalStock = _data["totalStock"];
            this.totalBudget = _data["totalBudget"];
            this.totalCost = _data["totalCost"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children.push(AccountsChart.fromJS(item));
            }
            this.code = _data["code"];
            this.name = _data["name"];
            this.canEdit = _data["canEdit"];
            this.category = _data["category"];
            this.showCashbook = _data["showCashbook"];
            this.typeOfCompany = _data["typeOfCompany"];
            this.depreciationFor = _data["depreciationFor"];
            this.amortizationFor = _data["amortizationFor"];
            this.notesUrl = _data["notesUrl"];
            this.notesText = _data["notesText"];
            this.parentCode = _data["parentCode"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.descriptionMalay = _data["descriptionMalay"];
        }
    }

    static fromJS(data: any): AccountsChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountsChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["accountsChartId"] = this.accountsChartId;
        data["categoryCode"] = this.categoryCode;
        data["description"] = this.description;
        data["source"] = this.source;
        data["isProcurement"] = this.isProcurement;
        data["totalStock"] = this.totalStock;
        data["totalBudget"] = this.totalBudget;
        data["totalCost"] = this.totalCost;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["code"] = this.code;
        data["name"] = this.name;
        data["canEdit"] = this.canEdit;
        data["category"] = this.category;
        data["showCashbook"] = this.showCashbook;
        data["typeOfCompany"] = this.typeOfCompany;
        data["depreciationFor"] = this.depreciationFor;
        data["amortizationFor"] = this.amortizationFor;
        data["notesUrl"] = this.notesUrl;
        data["notesText"] = this.notesText;
        data["parentCode"] = this.parentCode;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["descriptionMalay"] = this.descriptionMalay;
        return data;
    }

    clone(): AccountsChartDto {
        const json = this.toJSON();
        let result = new AccountsChartDto();
        result.init(json);
        return result;
    }
}

export interface IAccountsChartDto {
    tenantId: number;
    accountsChartId: number;
    categoryCode: string | undefined;
    description: string | undefined;
    source: string | undefined;
    isProcurement: boolean;
    totalStock: number;
    totalBudget: number;
    totalCost: number;
    children: AccountsChart[] | undefined;
    code: string | undefined;
    name: string | undefined;
    canEdit: boolean;
    category: string | undefined;
    showCashbook: boolean;
    typeOfCompany: string | undefined;
    depreciationFor: string | undefined;
    amortizationFor: string | undefined;
    notesUrl: string | undefined;
    notesText: string | undefined;
    parentCode: string | undefined;
    date: moment.Moment | undefined;
    descriptionMalay: string | undefined;
}

export class AccountsChartPagedResultDto implements IAccountsChartPagedResultDto {
    items: AccountsChart[] | undefined;
    totalCount: number;

    constructor(data?: IAccountsChartPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AccountsChart.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AccountsChartPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountsChartPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AccountsChartPagedResultDto {
        const json = this.toJSON();
        let result = new AccountsChartPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAccountsChartPagedResultDto {
    items: AccountsChart[] | undefined;
    totalCount: number;
}

export enum AccrualFrequencyType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
}

export class Addon implements IAddon {
    sms_addon: string | undefined;
    email_addon: string | undefined;
    awbbranding_addon: string | undefined;

    constructor(data?: IAddon) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sms_addon = _data["sms_addon"];
            this.email_addon = _data["email_addon"];
            this.awbbranding_addon = _data["awbbranding_addon"];
        }
    }

    static fromJS(data: any): Addon {
        data = typeof data === 'object' ? data : {};
        let result = new Addon();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sms_addon"] = this.sms_addon;
        data["email_addon"] = this.email_addon;
        data["awbbranding_addon"] = this.awbbranding_addon;
        return data;
    }

    clone(): Addon {
        const json = this.toJSON();
        let result = new Addon();
        result.init(json);
        return result;
    }
}

export interface IAddon {
    sms_addon: string | undefined;
    email_addon: string | undefined;
    awbbranding_addon: string | undefined;
}

export class AllowanceEmployeeModel implements IAllowanceEmployeeModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    userId: number;
    user: User;
    allowanceId: number;
    allowance: AllowanceModel;
    tenantId: number;
    fixedAmount: number;

    constructor(data?: IAllowanceEmployeeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.allowanceId = _data["allowanceId"];
            this.allowance = _data["allowance"] ? AllowanceModel.fromJS(_data["allowance"]) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.fixedAmount = _data["fixedAmount"];
        }
    }

    static fromJS(data: any): AllowanceEmployeeModel {
        data = typeof data === 'object' ? data : {};
        let result = new AllowanceEmployeeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["allowanceId"] = this.allowanceId;
        data["allowance"] = this.allowance ? this.allowance.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["fixedAmount"] = this.fixedAmount;
        return data;
    }

    clone(): AllowanceEmployeeModel {
        const json = this.toJSON();
        let result = new AllowanceEmployeeModel();
        result.init(json);
        return result;
    }
}

export interface IAllowanceEmployeeModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    userId: number;
    user: User;
    allowanceId: number;
    allowance: AllowanceModel;
    tenantId: number;
    fixedAmount: number;
}

export class AllowanceEmployeeModelDto implements IAllowanceEmployeeModelDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    userId: number;
    user: UserDto;
    allowanceId: number;
    allowance: AllowanceModel;
    tenantId: number;
    fixedAmount: number;

    constructor(data?: IAllowanceEmployeeModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.allowanceId = _data["allowanceId"];
            this.allowance = _data["allowance"] ? AllowanceModel.fromJS(_data["allowance"]) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.fixedAmount = _data["fixedAmount"];
        }
    }

    static fromJS(data: any): AllowanceEmployeeModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllowanceEmployeeModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["allowanceId"] = this.allowanceId;
        data["allowance"] = this.allowance ? this.allowance.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["fixedAmount"] = this.fixedAmount;
        return data;
    }

    clone(): AllowanceEmployeeModelDto {
        const json = this.toJSON();
        let result = new AllowanceEmployeeModelDto();
        result.init(json);
        return result;
    }
}

export interface IAllowanceEmployeeModelDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    userId: number;
    user: UserDto;
    allowanceId: number;
    allowance: AllowanceModel;
    tenantId: number;
    fixedAmount: number;
}

export class AllowanceEmployeeModelPagedResultDto implements IAllowanceEmployeeModelPagedResultDto {
    items: AllowanceEmployeeModel[] | undefined;
    totalCount: number;

    constructor(data?: IAllowanceEmployeeModelPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AllowanceEmployeeModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AllowanceEmployeeModelPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllowanceEmployeeModelPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AllowanceEmployeeModelPagedResultDto {
        const json = this.toJSON();
        let result = new AllowanceEmployeeModelPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAllowanceEmployeeModelPagedResultDto {
    items: AllowanceEmployeeModel[] | undefined;
    totalCount: number;
}

export class AllowanceModel implements IAllowanceModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    allowanceType: string;
    type: string;
    isValue: boolean;
    value: number;
    tenantId: number;
    eaField: string | undefined;
    isOtIncluded: boolean;
    isEnabled: boolean;
    isEpf: boolean;
    isSocso: boolean;
    isEis: boolean;
    isPcb: boolean;
    isHrdf: boolean;

    constructor(data?: IAllowanceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.allowanceType = _data["allowanceType"];
            this.type = _data["type"];
            this.isValue = _data["isValue"];
            this.value = _data["value"];
            this.tenantId = _data["tenantId"];
            this.eaField = _data["eaField"];
            this.isOtIncluded = _data["isOtIncluded"];
            this.isEnabled = _data["isEnabled"];
            this.isEpf = _data["isEpf"];
            this.isSocso = _data["isSocso"];
            this.isEis = _data["isEis"];
            this.isPcb = _data["isPcb"];
            this.isHrdf = _data["isHrdf"];
        }
    }

    static fromJS(data: any): AllowanceModel {
        data = typeof data === 'object' ? data : {};
        let result = new AllowanceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["allowanceType"] = this.allowanceType;
        data["type"] = this.type;
        data["isValue"] = this.isValue;
        data["value"] = this.value;
        data["tenantId"] = this.tenantId;
        data["eaField"] = this.eaField;
        data["isOtIncluded"] = this.isOtIncluded;
        data["isEnabled"] = this.isEnabled;
        data["isEpf"] = this.isEpf;
        data["isSocso"] = this.isSocso;
        data["isEis"] = this.isEis;
        data["isPcb"] = this.isPcb;
        data["isHrdf"] = this.isHrdf;
        return data;
    }

    clone(): AllowanceModel {
        const json = this.toJSON();
        let result = new AllowanceModel();
        result.init(json);
        return result;
    }
}

export interface IAllowanceModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    allowanceType: string;
    type: string;
    isValue: boolean;
    value: number;
    tenantId: number;
    eaField: string | undefined;
    isOtIncluded: boolean;
    isEnabled: boolean;
    isEpf: boolean;
    isSocso: boolean;
    isEis: boolean;
    isPcb: boolean;
    isHrdf: boolean;
}

export class AllowanceModelDto implements IAllowanceModelDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    allowanceType: string | undefined;
    type: string | undefined;
    isValue: boolean;
    value: number;
    tenantId: number;
    eaField: string | undefined;
    isOtIncluded: boolean;
    isEnabled: boolean;
    isEpf: boolean;
    isSocso: boolean;
    isEis: boolean;
    isPcb: boolean;
    isHrdf: boolean;
    allowanceDeductionEmployeesList: AllowanceEmployeeModelDto[] | undefined;

    constructor(data?: IAllowanceModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.allowanceType = _data["allowanceType"];
            this.type = _data["type"];
            this.isValue = _data["isValue"];
            this.value = _data["value"];
            this.tenantId = _data["tenantId"];
            this.eaField = _data["eaField"];
            this.isOtIncluded = _data["isOtIncluded"];
            this.isEnabled = _data["isEnabled"];
            this.isEpf = _data["isEpf"];
            this.isSocso = _data["isSocso"];
            this.isEis = _data["isEis"];
            this.isPcb = _data["isPcb"];
            this.isHrdf = _data["isHrdf"];
            if (Array.isArray(_data["allowanceDeductionEmployeesList"])) {
                this.allowanceDeductionEmployeesList = [] as any;
                for (let item of _data["allowanceDeductionEmployeesList"])
                    this.allowanceDeductionEmployeesList.push(AllowanceEmployeeModelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AllowanceModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllowanceModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["allowanceType"] = this.allowanceType;
        data["type"] = this.type;
        data["isValue"] = this.isValue;
        data["value"] = this.value;
        data["tenantId"] = this.tenantId;
        data["eaField"] = this.eaField;
        data["isOtIncluded"] = this.isOtIncluded;
        data["isEnabled"] = this.isEnabled;
        data["isEpf"] = this.isEpf;
        data["isSocso"] = this.isSocso;
        data["isEis"] = this.isEis;
        data["isPcb"] = this.isPcb;
        data["isHrdf"] = this.isHrdf;
        if (Array.isArray(this.allowanceDeductionEmployeesList)) {
            data["allowanceDeductionEmployeesList"] = [];
            for (let item of this.allowanceDeductionEmployeesList)
                data["allowanceDeductionEmployeesList"].push(item.toJSON());
        }
        return data;
    }

    clone(): AllowanceModelDto {
        const json = this.toJSON();
        let result = new AllowanceModelDto();
        result.init(json);
        return result;
    }
}

export interface IAllowanceModelDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    allowanceType: string | undefined;
    type: string | undefined;
    isValue: boolean;
    value: number;
    tenantId: number;
    eaField: string | undefined;
    isOtIncluded: boolean;
    isEnabled: boolean;
    isEpf: boolean;
    isSocso: boolean;
    isEis: boolean;
    isPcb: boolean;
    isHrdf: boolean;
    allowanceDeductionEmployeesList: AllowanceEmployeeModelDto[] | undefined;
}

export class AllowanceModelPagedResultDto implements IAllowanceModelPagedResultDto {
    items: AllowanceModel[] | undefined;
    totalCount: number;

    constructor(data?: IAllowanceModelPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AllowanceModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AllowanceModelPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllowanceModelPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AllowanceModelPagedResultDto {
        const json = this.toJSON();
        let result = new AllowanceModelPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAllowanceModelPagedResultDto {
    items: AllowanceModel[] | undefined;
    totalCount: number;
}

export class AllowanceTypeModel implements IAllowanceTypeModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    allowanceTypeName: string;
    tenantId: number;

    constructor(data?: IAllowanceTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.allowanceTypeName = _data["allowanceTypeName"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AllowanceTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new AllowanceTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["allowanceTypeName"] = this.allowanceTypeName;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): AllowanceTypeModel {
        const json = this.toJSON();
        let result = new AllowanceTypeModel();
        result.init(json);
        return result;
    }
}

export interface IAllowanceTypeModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    allowanceTypeName: string;
    tenantId: number;
}

export class AllowanceTypeModelDto implements IAllowanceTypeModelDto {
    allowanceTypeName: string | undefined;
    tenantId: number;

    constructor(data?: IAllowanceTypeModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowanceTypeName = _data["allowanceTypeName"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AllowanceTypeModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllowanceTypeModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowanceTypeName"] = this.allowanceTypeName;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): AllowanceTypeModelDto {
        const json = this.toJSON();
        let result = new AllowanceTypeModelDto();
        result.init(json);
        return result;
    }
}

export interface IAllowanceTypeModelDto {
    allowanceTypeName: string | undefined;
    tenantId: number;
}

export class AllowanceTypeModelPagedResultDto implements IAllowanceTypeModelPagedResultDto {
    items: AllowanceTypeModel[] | undefined;
    totalCount: number;

    constructor(data?: IAllowanceTypeModelPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AllowanceTypeModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AllowanceTypeModelPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllowanceTypeModelPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AllowanceTypeModelPagedResultDto {
        const json = this.toJSON();
        let result = new AllowanceTypeModelPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAllowanceTypeModelPagedResultDto {
    items: AllowanceTypeModel[] | undefined;
    totalCount: number;
}

export class AppKeyProduct implements IAppKeyProduct {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    referenceNumber: string | undefined;
    description: string | undefined;

    constructor(data?: IAppKeyProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.referenceNumber = _data["referenceNumber"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AppKeyProduct {
        data = typeof data === 'object' ? data : {};
        let result = new AppKeyProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["referenceNumber"] = this.referenceNumber;
        data["description"] = this.description;
        return data;
    }

    clone(): AppKeyProduct {
        const json = this.toJSON();
        let result = new AppKeyProduct();
        result.init(json);
        return result;
    }
}

export interface IAppKeyProduct {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    referenceNumber: string | undefined;
    description: string | undefined;
}

export class AppKeyProductDto implements IAppKeyProductDto {
    tenantId: number;
    name: string | undefined;
    referenceNumber: string | undefined;
    description: string | undefined;

    constructor(data?: IAppKeyProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.referenceNumber = _data["referenceNumber"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AppKeyProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppKeyProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["referenceNumber"] = this.referenceNumber;
        data["description"] = this.description;
        return data;
    }

    clone(): AppKeyProductDto {
        const json = this.toJSON();
        let result = new AppKeyProductDto();
        result.init(json);
        return result;
    }
}

export interface IAppKeyProductDto {
    tenantId: number;
    name: string | undefined;
    referenceNumber: string | undefined;
    description: string | undefined;
}

export class AppKeyProductPagedResultDto implements IAppKeyProductPagedResultDto {
    items: AppKeyProduct[] | undefined;
    totalCount: number;

    constructor(data?: IAppKeyProductPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AppKeyProduct.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AppKeyProductPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppKeyProductPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AppKeyProductPagedResultDto {
        const json = this.toJSON();
        let result = new AppKeyProductPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAppKeyProductPagedResultDto {
    items: AppKeyProduct[] | undefined;
    totalCount: number;
}

export class AppKeyProductPrices implements IAppKeyProductPrices {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    keyProductId: number;
    unitPrice: number;
    unitOfMeasurement: string | undefined;
    description: string | undefined;

    constructor(data?: IAppKeyProductPrices) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.keyProductId = _data["keyProductId"];
            this.unitPrice = _data["unitPrice"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AppKeyProductPrices {
        data = typeof data === 'object' ? data : {};
        let result = new AppKeyProductPrices();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["keyProductId"] = this.keyProductId;
        data["unitPrice"] = this.unitPrice;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["description"] = this.description;
        return data;
    }

    clone(): AppKeyProductPrices {
        const json = this.toJSON();
        let result = new AppKeyProductPrices();
        result.init(json);
        return result;
    }
}

export interface IAppKeyProductPrices {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    keyProductId: number;
    unitPrice: number;
    unitOfMeasurement: string | undefined;
    description: string | undefined;
}

export class AppKeyProductPricesDto implements IAppKeyProductPricesDto {
    tenantId: number;
    keyProductId: number;
    unitPrice: number;
    unitOfMeasurement: string | undefined;
    description: string | undefined;

    constructor(data?: IAppKeyProductPricesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.keyProductId = _data["keyProductId"];
            this.unitPrice = _data["unitPrice"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AppKeyProductPricesDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppKeyProductPricesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["keyProductId"] = this.keyProductId;
        data["unitPrice"] = this.unitPrice;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["description"] = this.description;
        return data;
    }

    clone(): AppKeyProductPricesDto {
        const json = this.toJSON();
        let result = new AppKeyProductPricesDto();
        result.init(json);
        return result;
    }
}

export interface IAppKeyProductPricesDto {
    tenantId: number;
    keyProductId: number;
    unitPrice: number;
    unitOfMeasurement: string | undefined;
    description: string | undefined;
}

export class AppKeyProductPricesPagedResultDto implements IAppKeyProductPricesPagedResultDto {
    items: AppKeyProductPrices[] | undefined;
    totalCount: number;

    constructor(data?: IAppKeyProductPricesPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AppKeyProductPrices.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AppKeyProductPricesPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppKeyProductPricesPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AppKeyProductPricesPagedResultDto {
        const json = this.toJSON();
        let result = new AppKeyProductPricesPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAppKeyProductPricesPagedResultDto {
    items: AppKeyProductPrices[] | undefined;
    totalCount: number;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)[key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;
}

export class AttendenceModel implements IAttendenceModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    startDateTime: moment.Moment;
    endDateTime: moment.Moment | undefined;
    readonly durationInHours: number;
    status: string;
    reason: string | undefined;
    userId: number;
    user: User;
    tenantId: number;
    projectId: number | undefined;
    project: Project;
    projectTaskId: number | undefined;

    constructor(data?: IAttendenceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : <any>undefined;
            (<any>this).durationInHours = _data["durationInHours"];
            this.status = _data["status"];
            this.reason = _data["reason"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            this.projectTaskId = _data["projectTaskId"];
        }
    }

    static fromJS(data: any): AttendenceModel {
        data = typeof data === 'object' ? data : {};
        let result = new AttendenceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        data["durationInHours"] = this.durationInHours;
        data["status"] = this.status;
        data["reason"] = this.reason;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["projectTaskId"] = this.projectTaskId;
        return data;
    }

    clone(): AttendenceModel {
        const json = this.toJSON();
        let result = new AttendenceModel();
        result.init(json);
        return result;
    }
}

export interface IAttendenceModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    startDateTime: moment.Moment;
    endDateTime: moment.Moment | undefined;
    durationInHours: number;
    status: string;
    reason: string | undefined;
    userId: number;
    user: User;
    tenantId: number;
    projectId: number | undefined;
    project: Project;
    projectTaskId: number | undefined;
}

export class AttendenceModelDto implements IAttendenceModelDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    startDateTime: moment.Moment;
    endDateTime: moment.Moment | undefined;
    readonly durationInHours: number;
    status: string | undefined;
    reason: string | undefined;
    userId: number;
    user: User;
    tenantId: number;
    projectId: number | undefined;
    project: Project;
    projectTaskId: number | undefined;

    constructor(data?: IAttendenceModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : <any>undefined;
            this.endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : <any>undefined;
            (<any>this).durationInHours = _data["durationInHours"];
            this.status = _data["status"];
            this.reason = _data["reason"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            this.projectTaskId = _data["projectTaskId"];
        }
    }

    static fromJS(data: any): AttendenceModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendenceModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : <any>undefined;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : <any>undefined;
        data["durationInHours"] = this.durationInHours;
        data["status"] = this.status;
        data["reason"] = this.reason;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["projectTaskId"] = this.projectTaskId;
        return data;
    }

    clone(): AttendenceModelDto {
        const json = this.toJSON();
        let result = new AttendenceModelDto();
        result.init(json);
        return result;
    }
}

export interface IAttendenceModelDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    startDateTime: moment.Moment;
    endDateTime: moment.Moment | undefined;
    durationInHours: number;
    status: string | undefined;
    reason: string | undefined;
    userId: number;
    user: User;
    tenantId: number;
    projectId: number | undefined;
    project: Project;
    projectTaskId: number | undefined;
}

export class AttendenceModelDtoPagedResultDto implements IAttendenceModelDtoPagedResultDto {
    items: AttendenceModelDto[] | undefined;
    totalCount: number;

    constructor(data?: IAttendenceModelDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AttendenceModelDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AttendenceModelDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendenceModelDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AttendenceModelDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AttendenceModelDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAttendenceModelDtoPagedResultDto {
    items: AttendenceModelDto[] | undefined;
    totalCount: number;
}

export class AttendenceModelPagedResultDto implements IAttendenceModelPagedResultDto {
    items: AttendenceModel[] | undefined;
    totalCount: number;

    constructor(data?: IAttendenceModelPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AttendenceModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AttendenceModelPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendenceModelPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AttendenceModelPagedResultDto {
        const json = this.toJSON();
        let result = new AttendenceModelPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAttendenceModelPagedResultDto {
    items: AttendenceModel[] | undefined;
    totalCount: number;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data;
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        return data;
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
}

export class AwardModel implements IAwardModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    awardTitle: string;
    gift: string;
    price: number;
    date: moment.Moment;
    month: string | undefined;
    tenantId: number;

    constructor(data?: IAwardModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.awardTitle = _data["awardTitle"];
            this.gift = _data["gift"];
            this.price = _data["price"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.month = _data["month"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AwardModel {
        data = typeof data === 'object' ? data : {};
        let result = new AwardModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["awardTitle"] = this.awardTitle;
        data["gift"] = this.gift;
        data["price"] = this.price;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["month"] = this.month;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): AwardModel {
        const json = this.toJSON();
        let result = new AwardModel();
        result.init(json);
        return result;
    }
}

export interface IAwardModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    awardTitle: string;
    gift: string;
    price: number;
    date: moment.Moment;
    month: string | undefined;
    tenantId: number;
}

export class AwardModelDto implements IAwardModelDto {
    awardTitle: string | undefined;
    gift: string | undefined;
    price: number;
    date: moment.Moment;
    month: string | undefined;
    employeeId: number;
    tenantId: number;

    constructor(data?: IAwardModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.awardTitle = _data["awardTitle"];
            this.gift = _data["gift"];
            this.price = _data["price"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.month = _data["month"];
            this.employeeId = _data["employeeId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AwardModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new AwardModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["awardTitle"] = this.awardTitle;
        data["gift"] = this.gift;
        data["price"] = this.price;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["month"] = this.month;
        data["employeeId"] = this.employeeId;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): AwardModelDto {
        const json = this.toJSON();
        let result = new AwardModelDto();
        result.init(json);
        return result;
    }
}

export interface IAwardModelDto {
    awardTitle: string | undefined;
    gift: string | undefined;
    price: number;
    date: moment.Moment;
    month: string | undefined;
    employeeId: number;
    tenantId: number;
}

export class AwardModelPagedResultDto implements IAwardModelPagedResultDto {
    items: AwardModel[] | undefined;
    totalCount: number;

    constructor(data?: IAwardModelPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AwardModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AwardModelPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AwardModelPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AwardModelPagedResultDto {
        const json = this.toJSON();
        let result = new AwardModelPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAwardModelPagedResultDto {
    items: AwardModel[] | undefined;
    totalCount: number;
}

export class BankAccountDto implements IBankAccountDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    bankName: string;
    bankAccountHolder: string;
    bankAccountNo: string;
    accountCharge: string;

    constructor(data?: IBankAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.bankName = _data["bankName"];
            this.bankAccountHolder = _data["bankAccountHolder"];
            this.bankAccountNo = _data["bankAccountNo"];
            this.accountCharge = _data["accountCharge"];
        }
    }

    static fromJS(data: any): BankAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["bankName"] = this.bankName;
        data["bankAccountHolder"] = this.bankAccountHolder;
        data["bankAccountNo"] = this.bankAccountNo;
        data["accountCharge"] = this.accountCharge;
        return data;
    }

    clone(): BankAccountDto {
        const json = this.toJSON();
        let result = new BankAccountDto();
        result.init(json);
        return result;
    }
}

export interface IBankAccountDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    bankName: string;
    bankAccountHolder: string;
    bankAccountNo: string;
    accountCharge: string;
}

export class BankAccountDtoPagedResultDto implements IBankAccountDtoPagedResultDto {
    items: BankAccountDto[] | undefined;
    totalCount: number;

    constructor(data?: IBankAccountDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BankAccountDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): BankAccountDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): BankAccountDtoPagedResultDto {
        const json = this.toJSON();
        let result = new BankAccountDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IBankAccountDtoPagedResultDto {
    items: BankAccountDto[] | undefined;
    totalCount: number;
}

export class Bill implements IBill {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    billNo: string;
    billType: string;
    issueDate: moment.Moment;
    dueDate: moment.Moment;
    paymentTerm: number;
    remarks: string | undefined;
    totalDiscount: number;
    totalTax: number;
    totalAmount: number;
    status: string;
    customerId: string | undefined;
    customer: Customer;
    tenantId: number | undefined;
    tenant: Tenant;
    receivedDate: moment.Moment | undefined;
    paymentUrl: string | undefined;
    paymentDate: moment.Moment | undefined;
    paymentId: string | undefined;
    invoiceMessage: string | undefined;
    ccEmails: string | undefined;
    taxAmount: number;
    totalSubtotal: number;
    goodsReceived: boolean;
    goodsReceivedDate: moment.Moment | undefined;
    poReferenceNumber: string | undefined;
    shippingName: string | undefined;
    shippingAddress1: string | undefined;
    shippingAddress2: string | undefined;
    shippingCity: string | undefined;
    shippingState: string | undefined;
    shippingCountry: string | undefined;
    shippingPoscode: string | undefined;
    deliveryCharge: number;
    totalCreditNote: number;
    addtionalRemark: string | undefined;
    totalCreditnoteTax: number;
    isApproved: boolean;
    approvalRequestUserId: number;
    approvalRequestDate: moment.Moment;
    approvedDate: moment.Moment;
    approvalRequestName: string | undefined;
    paymentMethodId: number;
    paymentBankName: string | undefined;
    paymentBankAccountNo: string | undefined;
    paymentBankAccountHolder: string | undefined;
    reasonDateChange: string | undefined;
    warehouseId: number | undefined;
    warehouse: InventoryWarehouse;
    projectId: number;
    isUpdatedInventory: boolean;
    postMigration: boolean;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    billUrl: string | undefined;
    currency: string | undefined;
    exchangeRate: number;
    billLhdnId: number | undefined;
    billLhdn: BillLhdn;

    constructor(data?: IBill) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.billNo = _data["billNo"];
            this.billType = _data["billType"];
            this.issueDate = _data["issueDate"] ? moment(_data["issueDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.paymentTerm = _data["paymentTerm"];
            this.remarks = _data["remarks"];
            this.totalDiscount = _data["totalDiscount"];
            this.totalTax = _data["totalTax"];
            this.totalAmount = _data["totalAmount"];
            this.status = _data["status"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.receivedDate = _data["receivedDate"] ? moment(_data["receivedDate"].toString()) : <any>undefined;
            this.paymentUrl = _data["paymentUrl"];
            this.paymentDate = _data["paymentDate"] ? moment(_data["paymentDate"].toString()) : <any>undefined;
            this.paymentId = _data["paymentId"];
            this.invoiceMessage = _data["invoiceMessage"];
            this.ccEmails = _data["ccEmails"];
            this.taxAmount = _data["taxAmount"];
            this.totalSubtotal = _data["totalSubtotal"];
            this.goodsReceived = _data["goodsReceived"];
            this.goodsReceivedDate = _data["goodsReceivedDate"] ? moment(_data["goodsReceivedDate"].toString()) : <any>undefined;
            this.poReferenceNumber = _data["poReferenceNumber"];
            this.shippingName = _data["shippingName"];
            this.shippingAddress1 = _data["shippingAddress1"];
            this.shippingAddress2 = _data["shippingAddress2"];
            this.shippingCity = _data["shippingCity"];
            this.shippingState = _data["shippingState"];
            this.shippingCountry = _data["shippingCountry"];
            this.shippingPoscode = _data["shippingPoscode"];
            this.deliveryCharge = _data["deliveryCharge"];
            this.totalCreditNote = _data["totalCreditNote"];
            this.addtionalRemark = _data["addtionalRemark"];
            this.totalCreditnoteTax = _data["totalCreditnoteTax"];
            this.isApproved = _data["isApproved"];
            this.approvalRequestUserId = _data["approvalRequestUserId"];
            this.approvalRequestDate = _data["approvalRequestDate"] ? moment(_data["approvalRequestDate"].toString()) : <any>undefined;
            this.approvedDate = _data["approvedDate"] ? moment(_data["approvedDate"].toString()) : <any>undefined;
            this.approvalRequestName = _data["approvalRequestName"];
            this.paymentMethodId = _data["paymentMethodId"];
            this.paymentBankName = _data["paymentBankName"];
            this.paymentBankAccountNo = _data["paymentBankAccountNo"];
            this.paymentBankAccountHolder = _data["paymentBankAccountHolder"];
            this.reasonDateChange = _data["reasonDateChange"];
            this.warehouseId = _data["warehouseId"];
            this.warehouse = _data["warehouse"] ? InventoryWarehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.projectId = _data["projectId"];
            this.isUpdatedInventory = _data["isUpdatedInventory"];
            this.postMigration = _data["postMigration"];
            this.categoryCode = _data["categoryCode"];
            this.categoryName = _data["categoryName"];
            this.billUrl = _data["billUrl"];
            this.currency = _data["currency"];
            this.exchangeRate = _data["exchangeRate"];
            this.billLhdnId = _data["billLhdnId"];
            this.billLhdn = _data["billLhdn"] ? BillLhdn.fromJS(_data["billLhdn"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Bill {
        data = typeof data === 'object' ? data : {};
        let result = new Bill();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["billNo"] = this.billNo;
        data["billType"] = this.billType;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["paymentTerm"] = this.paymentTerm;
        data["remarks"] = this.remarks;
        data["totalDiscount"] = this.totalDiscount;
        data["totalTax"] = this.totalTax;
        data["totalAmount"] = this.totalAmount;
        data["status"] = this.status;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["paymentUrl"] = this.paymentUrl;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentId"] = this.paymentId;
        data["invoiceMessage"] = this.invoiceMessage;
        data["ccEmails"] = this.ccEmails;
        data["taxAmount"] = this.taxAmount;
        data["totalSubtotal"] = this.totalSubtotal;
        data["goodsReceived"] = this.goodsReceived;
        data["goodsReceivedDate"] = this.goodsReceivedDate ? this.goodsReceivedDate.toISOString() : <any>undefined;
        data["poReferenceNumber"] = this.poReferenceNumber;
        data["shippingName"] = this.shippingName;
        data["shippingAddress1"] = this.shippingAddress1;
        data["shippingAddress2"] = this.shippingAddress2;
        data["shippingCity"] = this.shippingCity;
        data["shippingState"] = this.shippingState;
        data["shippingCountry"] = this.shippingCountry;
        data["shippingPoscode"] = this.shippingPoscode;
        data["deliveryCharge"] = this.deliveryCharge;
        data["totalCreditNote"] = this.totalCreditNote;
        data["addtionalRemark"] = this.addtionalRemark;
        data["totalCreditnoteTax"] = this.totalCreditnoteTax;
        data["isApproved"] = this.isApproved;
        data["approvalRequestUserId"] = this.approvalRequestUserId;
        data["approvalRequestDate"] = this.approvalRequestDate ? this.approvalRequestDate.toISOString() : <any>undefined;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["approvalRequestName"] = this.approvalRequestName;
        data["paymentMethodId"] = this.paymentMethodId;
        data["paymentBankName"] = this.paymentBankName;
        data["paymentBankAccountNo"] = this.paymentBankAccountNo;
        data["paymentBankAccountHolder"] = this.paymentBankAccountHolder;
        data["reasonDateChange"] = this.reasonDateChange;
        data["warehouseId"] = this.warehouseId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["projectId"] = this.projectId;
        data["isUpdatedInventory"] = this.isUpdatedInventory;
        data["postMigration"] = this.postMigration;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["billUrl"] = this.billUrl;
        data["currency"] = this.currency;
        data["exchangeRate"] = this.exchangeRate;
        data["billLhdnId"] = this.billLhdnId;
        data["billLhdn"] = this.billLhdn ? this.billLhdn.toJSON() : <any>undefined;
        return data;
    }

    clone(): Bill {
        const json = this.toJSON();
        let result = new Bill();
        result.init(json);
        return result;
    }
}

export interface IBill {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    billNo: string;
    billType: string;
    issueDate: moment.Moment;
    dueDate: moment.Moment;
    paymentTerm: number;
    remarks: string | undefined;
    totalDiscount: number;
    totalTax: number;
    totalAmount: number;
    status: string;
    customerId: string | undefined;
    customer: Customer;
    tenantId: number | undefined;
    tenant: Tenant;
    receivedDate: moment.Moment | undefined;
    paymentUrl: string | undefined;
    paymentDate: moment.Moment | undefined;
    paymentId: string | undefined;
    invoiceMessage: string | undefined;
    ccEmails: string | undefined;
    taxAmount: number;
    totalSubtotal: number;
    goodsReceived: boolean;
    goodsReceivedDate: moment.Moment | undefined;
    poReferenceNumber: string | undefined;
    shippingName: string | undefined;
    shippingAddress1: string | undefined;
    shippingAddress2: string | undefined;
    shippingCity: string | undefined;
    shippingState: string | undefined;
    shippingCountry: string | undefined;
    shippingPoscode: string | undefined;
    deliveryCharge: number;
    totalCreditNote: number;
    addtionalRemark: string | undefined;
    totalCreditnoteTax: number;
    isApproved: boolean;
    approvalRequestUserId: number;
    approvalRequestDate: moment.Moment;
    approvedDate: moment.Moment;
    approvalRequestName: string | undefined;
    paymentMethodId: number;
    paymentBankName: string | undefined;
    paymentBankAccountNo: string | undefined;
    paymentBankAccountHolder: string | undefined;
    reasonDateChange: string | undefined;
    warehouseId: number | undefined;
    warehouse: InventoryWarehouse;
    projectId: number;
    isUpdatedInventory: boolean;
    postMigration: boolean;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    billUrl: string | undefined;
    currency: string | undefined;
    exchangeRate: number;
    billLhdnId: number | undefined;
    billLhdn: BillLhdn;
}

export class BillDto implements IBillDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    billNo: string | undefined;
    billType: string | undefined;
    issueDate: moment.Moment;
    dueDate: moment.Moment;
    paymentTerm: number;
    remarks: string | undefined;
    totalDiscount: number;
    totalTax: number;
    totalAmount: number;
    status: string | undefined;
    customerId: string | undefined;
    customer: Customer;
    tenantId: number;
    receivedDate: moment.Moment | undefined;
    paymentUrl: string | undefined;
    paymentDate: moment.Moment | undefined;
    paymentId: string | undefined;
    subtotal: number;
    taxAmount: number;
    invoiceMessage: string | undefined;
    ccEmails: string | undefined;
    totalSubtotal: number;
    goodsReceived: boolean;
    goodsReceivedDate: moment.Moment | undefined;
    poReferenceNumber: string | undefined;
    shippingName: string | undefined;
    shippingAddress1: string | undefined;
    shippingAddress2: string | undefined;
    shippingCity: string | undefined;
    shippingState: string | undefined;
    shippingCountry: string | undefined;
    shippingPoscode: string | undefined;
    deliveryCharge: number;
    totalDisbursement: number;
    totalReimbursement: number;
    companyObject: CompanyProfile;
    totalCreditNote: number;
    addtionalRemark: string | undefined;
    totalCreditnoteTax: number;
    isApproved: boolean;
    approvalRequestUserId: number;
    approvalRequestDate: moment.Moment;
    approvedDate: moment.Moment;
    approvalRequestName: string | undefined;
    statementDate: moment.Moment | undefined;
    creditnoteList: CreditNote[] | undefined;
    outstandingsList: CustomerOutstanding[] | undefined;
    billId: string;
    redirectUrl: string | undefined;
    paymentMethodId: number;
    paymentBankName: string | undefined;
    paymentBankAccountNo: string | undefined;
    paymentBankAccountHolder: string | undefined;
    reasonDateChange: string | undefined;
    description: string | undefined;
    cashbookList: Cashbooks[] | undefined;
    warehouseId: number | undefined;
    warehouse: InventoryWarehouse;
    statementAmount: number;
    projectId: number;
    isUpdatedInventory: boolean;
    billItemDtoList: BillItemDto[] | undefined;
    orderId: string | undefined;
    postMigration: boolean;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    billUrl: string | undefined;
    billLhdnId: number | undefined;
    billLhdn: BillLhdn;
    currency: string | undefined;
    exchangeRate: number;

    constructor(data?: IBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.billNo = _data["billNo"];
            this.billType = _data["billType"];
            this.issueDate = _data["issueDate"] ? moment(_data["issueDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.paymentTerm = _data["paymentTerm"];
            this.remarks = _data["remarks"];
            this.totalDiscount = _data["totalDiscount"];
            this.totalTax = _data["totalTax"];
            this.totalAmount = _data["totalAmount"];
            this.status = _data["status"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.receivedDate = _data["receivedDate"] ? moment(_data["receivedDate"].toString()) : <any>undefined;
            this.paymentUrl = _data["paymentUrl"];
            this.paymentDate = _data["paymentDate"] ? moment(_data["paymentDate"].toString()) : <any>undefined;
            this.paymentId = _data["paymentId"];
            this.subtotal = _data["subtotal"];
            this.taxAmount = _data["taxAmount"];
            this.invoiceMessage = _data["invoiceMessage"];
            this.ccEmails = _data["ccEmails"];
            this.totalSubtotal = _data["totalSubtotal"];
            this.goodsReceived = _data["goodsReceived"];
            this.goodsReceivedDate = _data["goodsReceivedDate"] ? moment(_data["goodsReceivedDate"].toString()) : <any>undefined;
            this.poReferenceNumber = _data["poReferenceNumber"];
            this.shippingName = _data["shippingName"];
            this.shippingAddress1 = _data["shippingAddress1"];
            this.shippingAddress2 = _data["shippingAddress2"];
            this.shippingCity = _data["shippingCity"];
            this.shippingState = _data["shippingState"];
            this.shippingCountry = _data["shippingCountry"];
            this.shippingPoscode = _data["shippingPoscode"];
            this.deliveryCharge = _data["deliveryCharge"];
            this.totalDisbursement = _data["totalDisbursement"];
            this.totalReimbursement = _data["totalReimbursement"];
            this.companyObject = _data["companyObject"] ? CompanyProfile.fromJS(_data["companyObject"]) : <any>undefined;
            this.totalCreditNote = _data["totalCreditNote"];
            this.addtionalRemark = _data["addtionalRemark"];
            this.totalCreditnoteTax = _data["totalCreditnoteTax"];
            this.isApproved = _data["isApproved"];
            this.approvalRequestUserId = _data["approvalRequestUserId"];
            this.approvalRequestDate = _data["approvalRequestDate"] ? moment(_data["approvalRequestDate"].toString()) : <any>undefined;
            this.approvedDate = _data["approvedDate"] ? moment(_data["approvedDate"].toString()) : <any>undefined;
            this.approvalRequestName = _data["approvalRequestName"];
            this.statementDate = _data["statementDate"] ? moment(_data["statementDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["creditnoteList"])) {
                this.creditnoteList = [] as any;
                for (let item of _data["creditnoteList"])
                    this.creditnoteList.push(CreditNote.fromJS(item));
            }
            if (Array.isArray(_data["outstandingsList"])) {
                this.outstandingsList = [] as any;
                for (let item of _data["outstandingsList"])
                    this.outstandingsList.push(CustomerOutstanding.fromJS(item));
            }
            this.billId = _data["billId"];
            this.redirectUrl = _data["redirectUrl"];
            this.paymentMethodId = _data["paymentMethodId"];
            this.paymentBankName = _data["paymentBankName"];
            this.paymentBankAccountNo = _data["paymentBankAccountNo"];
            this.paymentBankAccountHolder = _data["paymentBankAccountHolder"];
            this.reasonDateChange = _data["reasonDateChange"];
            this.description = _data["description"];
            if (Array.isArray(_data["cashbookList"])) {
                this.cashbookList = [] as any;
                for (let item of _data["cashbookList"])
                    this.cashbookList.push(Cashbooks.fromJS(item));
            }
            this.warehouseId = _data["warehouseId"];
            this.warehouse = _data["warehouse"] ? InventoryWarehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.statementAmount = _data["statementAmount"];
            this.projectId = _data["projectId"];
            this.isUpdatedInventory = _data["isUpdatedInventory"];
            if (Array.isArray(_data["billItemDtoList"])) {
                this.billItemDtoList = [] as any;
                for (let item of _data["billItemDtoList"])
                    this.billItemDtoList.push(BillItemDto.fromJS(item));
            }
            this.orderId = _data["orderId"];
            this.postMigration = _data["postMigration"];
            this.categoryCode = _data["categoryCode"];
            this.categoryName = _data["categoryName"];
            this.billUrl = _data["billUrl"];
            this.billLhdnId = _data["billLhdnId"];
            this.billLhdn = _data["billLhdn"] ? BillLhdn.fromJS(_data["billLhdn"]) : <any>undefined;
            this.currency = _data["currency"];
            this.exchangeRate = _data["exchangeRate"];
        }
    }

    static fromJS(data: any): BillDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["billNo"] = this.billNo;
        data["billType"] = this.billType;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["paymentTerm"] = this.paymentTerm;
        data["remarks"] = this.remarks;
        data["totalDiscount"] = this.totalDiscount;
        data["totalTax"] = this.totalTax;
        data["totalAmount"] = this.totalAmount;
        data["status"] = this.status;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["paymentUrl"] = this.paymentUrl;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentId"] = this.paymentId;
        data["subtotal"] = this.subtotal;
        data["taxAmount"] = this.taxAmount;
        data["invoiceMessage"] = this.invoiceMessage;
        data["ccEmails"] = this.ccEmails;
        data["totalSubtotal"] = this.totalSubtotal;
        data["goodsReceived"] = this.goodsReceived;
        data["goodsReceivedDate"] = this.goodsReceivedDate ? this.goodsReceivedDate.toISOString() : <any>undefined;
        data["poReferenceNumber"] = this.poReferenceNumber;
        data["shippingName"] = this.shippingName;
        data["shippingAddress1"] = this.shippingAddress1;
        data["shippingAddress2"] = this.shippingAddress2;
        data["shippingCity"] = this.shippingCity;
        data["shippingState"] = this.shippingState;
        data["shippingCountry"] = this.shippingCountry;
        data["shippingPoscode"] = this.shippingPoscode;
        data["deliveryCharge"] = this.deliveryCharge;
        data["totalDisbursement"] = this.totalDisbursement;
        data["totalReimbursement"] = this.totalReimbursement;
        data["companyObject"] = this.companyObject ? this.companyObject.toJSON() : <any>undefined;
        data["totalCreditNote"] = this.totalCreditNote;
        data["addtionalRemark"] = this.addtionalRemark;
        data["totalCreditnoteTax"] = this.totalCreditnoteTax;
        data["isApproved"] = this.isApproved;
        data["approvalRequestUserId"] = this.approvalRequestUserId;
        data["approvalRequestDate"] = this.approvalRequestDate ? this.approvalRequestDate.toISOString() : <any>undefined;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["approvalRequestName"] = this.approvalRequestName;
        data["statementDate"] = this.statementDate ? this.statementDate.toISOString() : <any>undefined;
        if (Array.isArray(this.creditnoteList)) {
            data["creditnoteList"] = [];
            for (let item of this.creditnoteList)
                data["creditnoteList"].push(item.toJSON());
        }
        if (Array.isArray(this.outstandingsList)) {
            data["outstandingsList"] = [];
            for (let item of this.outstandingsList)
                data["outstandingsList"].push(item.toJSON());
        }
        data["billId"] = this.billId;
        data["redirectUrl"] = this.redirectUrl;
        data["paymentMethodId"] = this.paymentMethodId;
        data["paymentBankName"] = this.paymentBankName;
        data["paymentBankAccountNo"] = this.paymentBankAccountNo;
        data["paymentBankAccountHolder"] = this.paymentBankAccountHolder;
        data["reasonDateChange"] = this.reasonDateChange;
        data["description"] = this.description;
        if (Array.isArray(this.cashbookList)) {
            data["cashbookList"] = [];
            for (let item of this.cashbookList)
                data["cashbookList"].push(item.toJSON());
        }
        data["warehouseId"] = this.warehouseId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["statementAmount"] = this.statementAmount;
        data["projectId"] = this.projectId;
        data["isUpdatedInventory"] = this.isUpdatedInventory;
        if (Array.isArray(this.billItemDtoList)) {
            data["billItemDtoList"] = [];
            for (let item of this.billItemDtoList)
                data["billItemDtoList"].push(item.toJSON());
        }
        data["orderId"] = this.orderId;
        data["postMigration"] = this.postMigration;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["billUrl"] = this.billUrl;
        data["billLhdnId"] = this.billLhdnId;
        data["billLhdn"] = this.billLhdn ? this.billLhdn.toJSON() : <any>undefined;
        data["currency"] = this.currency;
        data["exchangeRate"] = this.exchangeRate;
        return data;
    }

    clone(): BillDto {
        const json = this.toJSON();
        let result = new BillDto();
        result.init(json);
        return result;
    }
}

export interface IBillDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    billNo: string | undefined;
    billType: string | undefined;
    issueDate: moment.Moment;
    dueDate: moment.Moment;
    paymentTerm: number;
    remarks: string | undefined;
    totalDiscount: number;
    totalTax: number;
    totalAmount: number;
    status: string | undefined;
    customerId: string | undefined;
    customer: Customer;
    tenantId: number;
    receivedDate: moment.Moment | undefined;
    paymentUrl: string | undefined;
    paymentDate: moment.Moment | undefined;
    paymentId: string | undefined;
    subtotal: number;
    taxAmount: number;
    invoiceMessage: string | undefined;
    ccEmails: string | undefined;
    totalSubtotal: number;
    goodsReceived: boolean;
    goodsReceivedDate: moment.Moment | undefined;
    poReferenceNumber: string | undefined;
    shippingName: string | undefined;
    shippingAddress1: string | undefined;
    shippingAddress2: string | undefined;
    shippingCity: string | undefined;
    shippingState: string | undefined;
    shippingCountry: string | undefined;
    shippingPoscode: string | undefined;
    deliveryCharge: number;
    totalDisbursement: number;
    totalReimbursement: number;
    companyObject: CompanyProfile;
    totalCreditNote: number;
    addtionalRemark: string | undefined;
    totalCreditnoteTax: number;
    isApproved: boolean;
    approvalRequestUserId: number;
    approvalRequestDate: moment.Moment;
    approvedDate: moment.Moment;
    approvalRequestName: string | undefined;
    statementDate: moment.Moment | undefined;
    creditnoteList: CreditNote[] | undefined;
    outstandingsList: CustomerOutstanding[] | undefined;
    billId: string;
    redirectUrl: string | undefined;
    paymentMethodId: number;
    paymentBankName: string | undefined;
    paymentBankAccountNo: string | undefined;
    paymentBankAccountHolder: string | undefined;
    reasonDateChange: string | undefined;
    description: string | undefined;
    cashbookList: Cashbooks[] | undefined;
    warehouseId: number | undefined;
    warehouse: InventoryWarehouse;
    statementAmount: number;
    projectId: number;
    isUpdatedInventory: boolean;
    billItemDtoList: BillItemDto[] | undefined;
    orderId: string | undefined;
    postMigration: boolean;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    billUrl: string | undefined;
    billLhdnId: number | undefined;
    billLhdn: BillLhdn;
    currency: string | undefined;
    exchangeRate: number;
}

export class BillDtoPagedResultDto implements IBillDtoPagedResultDto {
    items: BillDto[] | undefined;
    totalCount: number;

    constructor(data?: IBillDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BillDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): BillDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): BillDtoPagedResultDto {
        const json = this.toJSON();
        let result = new BillDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IBillDtoPagedResultDto {
    items: BillDto[] | undefined;
    totalCount: number;
}

export class BillItem implements IBillItem {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    quantity: number;
    unitPrice: number;
    discount: number;
    tax: number;
    productId: string;
    product: Product;
    billId: string;
    bill: Bill;
    taxCode: string | undefined;
    orderId: string;
    creditNote: number;
    readonly price: number;
    readonly netSales: number;
    productShelfId: number | undefined;
    productShelf: InventoryProductOnShelf;
    isTaxRecoverable: boolean;

    constructor(data?: IBillItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.discount = _data["discount"];
            this.tax = _data["tax"];
            this.productId = _data["productId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.billId = _data["billId"];
            this.bill = _data["bill"] ? Bill.fromJS(_data["bill"]) : <any>undefined;
            this.taxCode = _data["taxCode"];
            this.orderId = _data["orderId"];
            this.creditNote = _data["creditNote"];
            (<any>this).price = _data["price"];
            (<any>this).netSales = _data["netSales"];
            this.productShelfId = _data["productShelfId"];
            this.productShelf = _data["productShelf"] ? InventoryProductOnShelf.fromJS(_data["productShelf"]) : <any>undefined;
            this.isTaxRecoverable = _data["isTaxRecoverable"];
        }
    }

    static fromJS(data: any): BillItem {
        data = typeof data === 'object' ? data : {};
        let result = new BillItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["discount"] = this.discount;
        data["tax"] = this.tax;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["billId"] = this.billId;
        data["bill"] = this.bill ? this.bill.toJSON() : <any>undefined;
        data["taxCode"] = this.taxCode;
        data["orderId"] = this.orderId;
        data["creditNote"] = this.creditNote;
        data["price"] = this.price;
        data["netSales"] = this.netSales;
        data["productShelfId"] = this.productShelfId;
        data["productShelf"] = this.productShelf ? this.productShelf.toJSON() : <any>undefined;
        data["isTaxRecoverable"] = this.isTaxRecoverable;
        return data;
    }

    clone(): BillItem {
        const json = this.toJSON();
        let result = new BillItem();
        result.init(json);
        return result;
    }
}

export interface IBillItem {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    quantity: number;
    unitPrice: number;
    discount: number;
    tax: number;
    productId: string;
    product: Product;
    billId: string;
    bill: Bill;
    taxCode: string | undefined;
    orderId: string;
    creditNote: number;
    price: number;
    netSales: number;
    productShelfId: number | undefined;
    productShelf: InventoryProductOnShelf;
    isTaxRecoverable: boolean;
}

export class BillItemDto implements IBillItemDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    quantity: number;
    unitPrice: number;
    discount: number;
    tax: number;
    productId: string;
    product: Product;
    billId: string;
    taxCode: string | undefined;
    subtotal: number;
    totalDiscount: number;
    totalExclTax: number;
    totaltax: number;
    totalInclTax: number;
    orderId: string;
    creditNote: number;
    creditnoteList: CreditNote[] | undefined;
    bill: Bill;
    productShelfId: number | undefined;
    productShelf: InventoryProductOnShelf;
    isTaxRecoverable: boolean;
    readonly price: number;
    readonly netSales: number;

    constructor(data?: IBillItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.discount = _data["discount"];
            this.tax = _data["tax"];
            this.productId = _data["productId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.billId = _data["billId"];
            this.taxCode = _data["taxCode"];
            this.subtotal = _data["subtotal"];
            this.totalDiscount = _data["totalDiscount"];
            this.totalExclTax = _data["totalExclTax"];
            this.totaltax = _data["totaltax"];
            this.totalInclTax = _data["totalInclTax"];
            this.orderId = _data["orderId"];
            this.creditNote = _data["creditNote"];
            if (Array.isArray(_data["creditnoteList"])) {
                this.creditnoteList = [] as any;
                for (let item of _data["creditnoteList"])
                    this.creditnoteList.push(CreditNote.fromJS(item));
            }
            this.bill = _data["bill"] ? Bill.fromJS(_data["bill"]) : <any>undefined;
            this.productShelfId = _data["productShelfId"];
            this.productShelf = _data["productShelf"] ? InventoryProductOnShelf.fromJS(_data["productShelf"]) : <any>undefined;
            this.isTaxRecoverable = _data["isTaxRecoverable"];
            (<any>this).price = _data["price"];
            (<any>this).netSales = _data["netSales"];
        }
    }

    static fromJS(data: any): BillItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["discount"] = this.discount;
        data["tax"] = this.tax;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["billId"] = this.billId;
        data["taxCode"] = this.taxCode;
        data["subtotal"] = this.subtotal;
        data["totalDiscount"] = this.totalDiscount;
        data["totalExclTax"] = this.totalExclTax;
        data["totaltax"] = this.totaltax;
        data["totalInclTax"] = this.totalInclTax;
        data["orderId"] = this.orderId;
        data["creditNote"] = this.creditNote;
        if (Array.isArray(this.creditnoteList)) {
            data["creditnoteList"] = [];
            for (let item of this.creditnoteList)
                data["creditnoteList"].push(item.toJSON());
        }
        data["bill"] = this.bill ? this.bill.toJSON() : <any>undefined;
        data["productShelfId"] = this.productShelfId;
        data["productShelf"] = this.productShelf ? this.productShelf.toJSON() : <any>undefined;
        data["isTaxRecoverable"] = this.isTaxRecoverable;
        data["price"] = this.price;
        data["netSales"] = this.netSales;
        return data;
    }

    clone(): BillItemDto {
        const json = this.toJSON();
        let result = new BillItemDto();
        result.init(json);
        return result;
    }
}

export interface IBillItemDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    quantity: number;
    unitPrice: number;
    discount: number;
    tax: number;
    productId: string;
    product: Product;
    billId: string;
    taxCode: string | undefined;
    subtotal: number;
    totalDiscount: number;
    totalExclTax: number;
    totaltax: number;
    totalInclTax: number;
    orderId: string;
    creditNote: number;
    creditnoteList: CreditNote[] | undefined;
    bill: Bill;
    productShelfId: number | undefined;
    productShelf: InventoryProductOnShelf;
    isTaxRecoverable: boolean;
    price: number;
    netSales: number;
}

export class BillItemDtoListResultDto implements IBillItemDtoListResultDto {
    items: BillItemDto[] | undefined;

    constructor(data?: IBillItemDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BillItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BillItemDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillItemDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): BillItemDtoListResultDto {
        const json = this.toJSON();
        let result = new BillItemDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IBillItemDtoListResultDto {
    items: BillItemDto[] | undefined;
}

export class BillItemDtoPagedResultDto implements IBillItemDtoPagedResultDto {
    items: BillItemDto[] | undefined;
    totalCount: number;

    constructor(data?: IBillItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BillItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): BillItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): BillItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new BillItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IBillItemDtoPagedResultDto {
    items: BillItemDto[] | undefined;
    totalCount: number;
}

export class BillLhdn implements IBillLhdn {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    submissionUid: string | undefined;
    invoiceCodeNumber: string | undefined;
    uuid: string | undefined;
    lhdnID: string | undefined;
    issueDate: string | undefined;
    issueTime: string | undefined;
    invoiceTypeCode: string | undefined;
    documentCurrencyCode: string | undefined;
    invoicePeriodStartDate: string | undefined;
    invoicePeriodEndDate: string | undefined;
    invoicePeriodDescription: string | undefined;
    additionalAccountID: string | undefined;
    industryClassificationName: string | undefined;
    industryClassificationCode: string | undefined;
    tin: string | undefined;
    brn: string | undefined;
    cityName: string | undefined;
    postalZone: string | undefined;
    countrySubentityCode: string | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    country: string | undefined;
    registrationName: string | undefined;
    telephone: string | undefined;
    electronicMail: string | undefined;
    customerTin: string | undefined;
    customerBRN: string | undefined;
    customerCityName: string | undefined;
    customerPostalZone: string | undefined;
    customerCountrySubentityCode: string | undefined;
    customerAddressLine1: string | undefined;
    customerAddressLine2: string | undefined;
    customerCountry: string | undefined;
    customerRegistrationName: string | undefined;
    customerTelephone: string | undefined;
    customerElectronicMail: string | undefined;
    deliveryTIN: string | undefined;
    deliveryBRN: string | undefined;
    deliveryCityName: string | undefined;
    deliveryPostalZone: string | undefined;
    deliveryCountrySubentityCode: string | undefined;
    deliveryAddressLine1: string | undefined;
    deliveryAddressLine2: string | undefined;
    deliveryCountry: string | undefined;
    deliveryRegistrationName: string | undefined;
    shipmentId: string | undefined;
    freightCharge: string | undefined;
    freightChargeReason: string | undefined;
    freightChargeAmount: string | undefined;
    paymentMeansCode: string | undefined;
    payeeFinancialAccount: string | undefined;
    paymentTerms: string | undefined;
    prepaidPaymentId: string | undefined;
    prepaidPaymentAmount: string | undefined;
    prepaidPaymentDate: string | undefined;
    prepaidPaymentTime: string | undefined;
    allowanceCharge: string | undefined;
    allowanceChargeReason: string | undefined;
    allowanceChargeAmount: string | undefined;
    taxAmount: string | undefined;
    taxableAmount: string | undefined;
    taxPercentage: string | undefined;
    taxBaseUnitMeasure: string | undefined;
    taxPerUnitAmount: string | undefined;
    taxCategoryID: string | undefined;
    taxSchemeID: string | undefined;
    taxschemeAgencyID: string | undefined;
    taxScheme: string | undefined;
    taxExemptionReason: string | undefined;
    lineExtensionAmount: string | undefined;
    taxExclusiveAmount: string | undefined;
    taxInclusiveAmount: string | undefined;
    allowanceTotalAmount: string | undefined;
    chargeTotalAmount: string | undefined;
    payableRoundingAmount: string | undefined;
    payableAmount: string | undefined;
    invoiceId: string | undefined;
    invoicedQuantityCode: string | undefined;
    invoicedQuantity: string | undefined;
    invoiceLineExtensionAmount: string | undefined;
    invoiceChargeIndicator: string | undefined;
    invoiceAllowanceChargeReason: string | undefined;
    invoiceMultiplierFactorNumeric: string | undefined;
    invoiceAmount: string | undefined;
    invoiceCurrency: string | undefined;
    status: string | undefined;
    error: string | undefined;
    billId: string | undefined;
    lhdnQr: string | undefined;

    constructor(data?: IBillLhdn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.submissionUid = _data["submissionUid"];
            this.invoiceCodeNumber = _data["invoiceCodeNumber"];
            this.uuid = _data["uuid"];
            this.lhdnID = _data["lhdnID"];
            this.issueDate = _data["issueDate"];
            this.issueTime = _data["issueTime"];
            this.invoiceTypeCode = _data["invoiceTypeCode"];
            this.documentCurrencyCode = _data["documentCurrencyCode"];
            this.invoicePeriodStartDate = _data["invoicePeriodStartDate"];
            this.invoicePeriodEndDate = _data["invoicePeriodEndDate"];
            this.invoicePeriodDescription = _data["invoicePeriodDescription"];
            this.additionalAccountID = _data["additionalAccountID"];
            this.industryClassificationName = _data["industryClassificationName"];
            this.industryClassificationCode = _data["industryClassificationCode"];
            this.tin = _data["tin"];
            this.brn = _data["brn"];
            this.cityName = _data["cityName"];
            this.postalZone = _data["postalZone"];
            this.countrySubentityCode = _data["countrySubentityCode"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.country = _data["country"];
            this.registrationName = _data["registrationName"];
            this.telephone = _data["telephone"];
            this.electronicMail = _data["electronicMail"];
            this.customerTin = _data["customerTin"];
            this.customerBRN = _data["customerBRN"];
            this.customerCityName = _data["customerCityName"];
            this.customerPostalZone = _data["customerPostalZone"];
            this.customerCountrySubentityCode = _data["customerCountrySubentityCode"];
            this.customerAddressLine1 = _data["customerAddressLine1"];
            this.customerAddressLine2 = _data["customerAddressLine2"];
            this.customerCountry = _data["customerCountry"];
            this.customerRegistrationName = _data["customerRegistrationName"];
            this.customerTelephone = _data["customerTelephone"];
            this.customerElectronicMail = _data["customerElectronicMail"];
            this.deliveryTIN = _data["deliveryTIN"];
            this.deliveryBRN = _data["deliveryBRN"];
            this.deliveryCityName = _data["deliveryCityName"];
            this.deliveryPostalZone = _data["deliveryPostalZone"];
            this.deliveryCountrySubentityCode = _data["deliveryCountrySubentityCode"];
            this.deliveryAddressLine1 = _data["deliveryAddressLine1"];
            this.deliveryAddressLine2 = _data["deliveryAddressLine2"];
            this.deliveryCountry = _data["deliveryCountry"];
            this.deliveryRegistrationName = _data["deliveryRegistrationName"];
            this.shipmentId = _data["shipmentId"];
            this.freightCharge = _data["freightCharge"];
            this.freightChargeReason = _data["freightChargeReason"];
            this.freightChargeAmount = _data["freightChargeAmount"];
            this.paymentMeansCode = _data["paymentMeansCode"];
            this.payeeFinancialAccount = _data["payeeFinancialAccount"];
            this.paymentTerms = _data["paymentTerms"];
            this.prepaidPaymentId = _data["prepaidPaymentId"];
            this.prepaidPaymentAmount = _data["prepaidPaymentAmount"];
            this.prepaidPaymentDate = _data["prepaidPaymentDate"];
            this.prepaidPaymentTime = _data["prepaidPaymentTime"];
            this.allowanceCharge = _data["allowanceCharge"];
            this.allowanceChargeReason = _data["allowanceChargeReason"];
            this.allowanceChargeAmount = _data["allowanceChargeAmount"];
            this.taxAmount = _data["taxAmount"];
            this.taxableAmount = _data["taxableAmount"];
            this.taxPercentage = _data["taxPercentage"];
            this.taxBaseUnitMeasure = _data["taxBaseUnitMeasure"];
            this.taxPerUnitAmount = _data["taxPerUnitAmount"];
            this.taxCategoryID = _data["taxCategoryID"];
            this.taxSchemeID = _data["taxSchemeID"];
            this.taxschemeAgencyID = _data["taxschemeAgencyID"];
            this.taxScheme = _data["taxScheme"];
            this.taxExemptionReason = _data["taxExemptionReason"];
            this.lineExtensionAmount = _data["lineExtensionAmount"];
            this.taxExclusiveAmount = _data["taxExclusiveAmount"];
            this.taxInclusiveAmount = _data["taxInclusiveAmount"];
            this.allowanceTotalAmount = _data["allowanceTotalAmount"];
            this.chargeTotalAmount = _data["chargeTotalAmount"];
            this.payableRoundingAmount = _data["payableRoundingAmount"];
            this.payableAmount = _data["payableAmount"];
            this.invoiceId = _data["invoiceId"];
            this.invoicedQuantityCode = _data["invoicedQuantityCode"];
            this.invoicedQuantity = _data["invoicedQuantity"];
            this.invoiceLineExtensionAmount = _data["invoiceLineExtensionAmount"];
            this.invoiceChargeIndicator = _data["invoiceChargeIndicator"];
            this.invoiceAllowanceChargeReason = _data["invoiceAllowanceChargeReason"];
            this.invoiceMultiplierFactorNumeric = _data["invoiceMultiplierFactorNumeric"];
            this.invoiceAmount = _data["invoiceAmount"];
            this.invoiceCurrency = _data["invoiceCurrency"];
            this.status = _data["status"];
            this.error = _data["error"];
            this.billId = _data["billId"];
            this.lhdnQr = _data["lhdnQr"];
        }
    }

    static fromJS(data: any): BillLhdn {
        data = typeof data === 'object' ? data : {};
        let result = new BillLhdn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["submissionUid"] = this.submissionUid;
        data["invoiceCodeNumber"] = this.invoiceCodeNumber;
        data["uuid"] = this.uuid;
        data["lhdnID"] = this.lhdnID;
        data["issueDate"] = this.issueDate;
        data["issueTime"] = this.issueTime;
        data["invoiceTypeCode"] = this.invoiceTypeCode;
        data["documentCurrencyCode"] = this.documentCurrencyCode;
        data["invoicePeriodStartDate"] = this.invoicePeriodStartDate;
        data["invoicePeriodEndDate"] = this.invoicePeriodEndDate;
        data["invoicePeriodDescription"] = this.invoicePeriodDescription;
        data["additionalAccountID"] = this.additionalAccountID;
        data["industryClassificationName"] = this.industryClassificationName;
        data["industryClassificationCode"] = this.industryClassificationCode;
        data["tin"] = this.tin;
        data["brn"] = this.brn;
        data["cityName"] = this.cityName;
        data["postalZone"] = this.postalZone;
        data["countrySubentityCode"] = this.countrySubentityCode;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["country"] = this.country;
        data["registrationName"] = this.registrationName;
        data["telephone"] = this.telephone;
        data["electronicMail"] = this.electronicMail;
        data["customerTin"] = this.customerTin;
        data["customerBRN"] = this.customerBRN;
        data["customerCityName"] = this.customerCityName;
        data["customerPostalZone"] = this.customerPostalZone;
        data["customerCountrySubentityCode"] = this.customerCountrySubentityCode;
        data["customerAddressLine1"] = this.customerAddressLine1;
        data["customerAddressLine2"] = this.customerAddressLine2;
        data["customerCountry"] = this.customerCountry;
        data["customerRegistrationName"] = this.customerRegistrationName;
        data["customerTelephone"] = this.customerTelephone;
        data["customerElectronicMail"] = this.customerElectronicMail;
        data["deliveryTIN"] = this.deliveryTIN;
        data["deliveryBRN"] = this.deliveryBRN;
        data["deliveryCityName"] = this.deliveryCityName;
        data["deliveryPostalZone"] = this.deliveryPostalZone;
        data["deliveryCountrySubentityCode"] = this.deliveryCountrySubentityCode;
        data["deliveryAddressLine1"] = this.deliveryAddressLine1;
        data["deliveryAddressLine2"] = this.deliveryAddressLine2;
        data["deliveryCountry"] = this.deliveryCountry;
        data["deliveryRegistrationName"] = this.deliveryRegistrationName;
        data["shipmentId"] = this.shipmentId;
        data["freightCharge"] = this.freightCharge;
        data["freightChargeReason"] = this.freightChargeReason;
        data["freightChargeAmount"] = this.freightChargeAmount;
        data["paymentMeansCode"] = this.paymentMeansCode;
        data["payeeFinancialAccount"] = this.payeeFinancialAccount;
        data["paymentTerms"] = this.paymentTerms;
        data["prepaidPaymentId"] = this.prepaidPaymentId;
        data["prepaidPaymentAmount"] = this.prepaidPaymentAmount;
        data["prepaidPaymentDate"] = this.prepaidPaymentDate;
        data["prepaidPaymentTime"] = this.prepaidPaymentTime;
        data["allowanceCharge"] = this.allowanceCharge;
        data["allowanceChargeReason"] = this.allowanceChargeReason;
        data["allowanceChargeAmount"] = this.allowanceChargeAmount;
        data["taxAmount"] = this.taxAmount;
        data["taxableAmount"] = this.taxableAmount;
        data["taxPercentage"] = this.taxPercentage;
        data["taxBaseUnitMeasure"] = this.taxBaseUnitMeasure;
        data["taxPerUnitAmount"] = this.taxPerUnitAmount;
        data["taxCategoryID"] = this.taxCategoryID;
        data["taxSchemeID"] = this.taxSchemeID;
        data["taxschemeAgencyID"] = this.taxschemeAgencyID;
        data["taxScheme"] = this.taxScheme;
        data["taxExemptionReason"] = this.taxExemptionReason;
        data["lineExtensionAmount"] = this.lineExtensionAmount;
        data["taxExclusiveAmount"] = this.taxExclusiveAmount;
        data["taxInclusiveAmount"] = this.taxInclusiveAmount;
        data["allowanceTotalAmount"] = this.allowanceTotalAmount;
        data["chargeTotalAmount"] = this.chargeTotalAmount;
        data["payableRoundingAmount"] = this.payableRoundingAmount;
        data["payableAmount"] = this.payableAmount;
        data["invoiceId"] = this.invoiceId;
        data["invoicedQuantityCode"] = this.invoicedQuantityCode;
        data["invoicedQuantity"] = this.invoicedQuantity;
        data["invoiceLineExtensionAmount"] = this.invoiceLineExtensionAmount;
        data["invoiceChargeIndicator"] = this.invoiceChargeIndicator;
        data["invoiceAllowanceChargeReason"] = this.invoiceAllowanceChargeReason;
        data["invoiceMultiplierFactorNumeric"] = this.invoiceMultiplierFactorNumeric;
        data["invoiceAmount"] = this.invoiceAmount;
        data["invoiceCurrency"] = this.invoiceCurrency;
        data["status"] = this.status;
        data["error"] = this.error;
        data["billId"] = this.billId;
        data["lhdnQr"] = this.lhdnQr;
        return data;
    }

    clone(): BillLhdn {
        const json = this.toJSON();
        let result = new BillLhdn();
        result.init(json);
        return result;
    }
}

export interface IBillLhdn {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    submissionUid: string | undefined;
    invoiceCodeNumber: string | undefined;
    uuid: string | undefined;
    lhdnID: string | undefined;
    issueDate: string | undefined;
    issueTime: string | undefined;
    invoiceTypeCode: string | undefined;
    documentCurrencyCode: string | undefined;
    invoicePeriodStartDate: string | undefined;
    invoicePeriodEndDate: string | undefined;
    invoicePeriodDescription: string | undefined;
    additionalAccountID: string | undefined;
    industryClassificationName: string | undefined;
    industryClassificationCode: string | undefined;
    tin: string | undefined;
    brn: string | undefined;
    cityName: string | undefined;
    postalZone: string | undefined;
    countrySubentityCode: string | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    country: string | undefined;
    registrationName: string | undefined;
    telephone: string | undefined;
    electronicMail: string | undefined;
    customerTin: string | undefined;
    customerBRN: string | undefined;
    customerCityName: string | undefined;
    customerPostalZone: string | undefined;
    customerCountrySubentityCode: string | undefined;
    customerAddressLine1: string | undefined;
    customerAddressLine2: string | undefined;
    customerCountry: string | undefined;
    customerRegistrationName: string | undefined;
    customerTelephone: string | undefined;
    customerElectronicMail: string | undefined;
    deliveryTIN: string | undefined;
    deliveryBRN: string | undefined;
    deliveryCityName: string | undefined;
    deliveryPostalZone: string | undefined;
    deliveryCountrySubentityCode: string | undefined;
    deliveryAddressLine1: string | undefined;
    deliveryAddressLine2: string | undefined;
    deliveryCountry: string | undefined;
    deliveryRegistrationName: string | undefined;
    shipmentId: string | undefined;
    freightCharge: string | undefined;
    freightChargeReason: string | undefined;
    freightChargeAmount: string | undefined;
    paymentMeansCode: string | undefined;
    payeeFinancialAccount: string | undefined;
    paymentTerms: string | undefined;
    prepaidPaymentId: string | undefined;
    prepaidPaymentAmount: string | undefined;
    prepaidPaymentDate: string | undefined;
    prepaidPaymentTime: string | undefined;
    allowanceCharge: string | undefined;
    allowanceChargeReason: string | undefined;
    allowanceChargeAmount: string | undefined;
    taxAmount: string | undefined;
    taxableAmount: string | undefined;
    taxPercentage: string | undefined;
    taxBaseUnitMeasure: string | undefined;
    taxPerUnitAmount: string | undefined;
    taxCategoryID: string | undefined;
    taxSchemeID: string | undefined;
    taxschemeAgencyID: string | undefined;
    taxScheme: string | undefined;
    taxExemptionReason: string | undefined;
    lineExtensionAmount: string | undefined;
    taxExclusiveAmount: string | undefined;
    taxInclusiveAmount: string | undefined;
    allowanceTotalAmount: string | undefined;
    chargeTotalAmount: string | undefined;
    payableRoundingAmount: string | undefined;
    payableAmount: string | undefined;
    invoiceId: string | undefined;
    invoicedQuantityCode: string | undefined;
    invoicedQuantity: string | undefined;
    invoiceLineExtensionAmount: string | undefined;
    invoiceChargeIndicator: string | undefined;
    invoiceAllowanceChargeReason: string | undefined;
    invoiceMultiplierFactorNumeric: string | undefined;
    invoiceAmount: string | undefined;
    invoiceCurrency: string | undefined;
    status: string | undefined;
    error: string | undefined;
    billId: string | undefined;
    lhdnQr: string | undefined;
}

export class BillLhdnDto implements IBillLhdnDto {
    billLhdnId: number;
    tenantId: number;
    submissionUid: string | undefined;
    invoiceCodeNumber: string | undefined;
    uuid: string | undefined;
    lhdnID: string | undefined;
    issueDate: string | undefined;
    issueTime: string | undefined;
    invoiceTypeCode: string | undefined;
    documentCurrencyCode: string | undefined;
    invoicePeriodStartDate: string | undefined;
    invoicePeriodEndDate: string | undefined;
    invoicePeriodDescription: string | undefined;
    additionalAccountID: string | undefined;
    industryClassificationName: string | undefined;
    industryClassificationCode: string | undefined;
    tin: string | undefined;
    brn: string | undefined;
    cityName: string | undefined;
    postalZone: string | undefined;
    countrySubentityCode: string | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    country: string | undefined;
    registrationName: string | undefined;
    telephone: string | undefined;
    electronicMail: string | undefined;
    customerTin: string | undefined;
    customerBRN: string | undefined;
    customerCityName: string | undefined;
    customerPostalZone: string | undefined;
    customerCountrySubentityCode: string | undefined;
    customerAddressLine1: string | undefined;
    customerAddressLine2: string | undefined;
    customerCountry: string | undefined;
    customerRegistrationName: string | undefined;
    customerTelephone: string | undefined;
    customerElectronicMail: string | undefined;
    deliveryTIN: string | undefined;
    deliveryBRN: string | undefined;
    deliveryCityName: string | undefined;
    deliveryPostalZone: string | undefined;
    deliveryCountrySubentityCode: string | undefined;
    deliveryAddressLine1: string | undefined;
    deliveryAddressLine2: string | undefined;
    deliveryCountry: string | undefined;
    deliveryRegistrationName: string | undefined;
    shipmentId: string | undefined;
    freightCharge: string | undefined;
    freightChargeReason: string | undefined;
    freightChargeAmount: string | undefined;
    paymentMeansCode: string | undefined;
    payeeFinancialAccount: string | undefined;
    paymentTerms: string | undefined;
    prepaidPaymentId: string | undefined;
    prepaidPaymentAmount: string | undefined;
    prepaidPaymentDate: string | undefined;
    prepaidPaymentTime: string | undefined;
    allowanceCharge: string | undefined;
    allowanceChargeReason: string | undefined;
    allowanceChargeAmount: string | undefined;
    taxAmount: string | undefined;
    taxableAmount: string | undefined;
    taxPercentage: string | undefined;
    taxBaseUnitMeasure: string | undefined;
    taxPerUnitAmount: string | undefined;
    taxCategoryID: string | undefined;
    taxSchemeID: string | undefined;
    taxschemeAgencyID: string | undefined;
    taxScheme: string | undefined;
    taxExemptionReason: string | undefined;
    lineExtensionAmount: string | undefined;
    taxExclusiveAmount: string | undefined;
    taxInclusiveAmount: string | undefined;
    allowanceTotalAmount: string | undefined;
    chargeTotalAmount: string | undefined;
    payableRoundingAmount: string | undefined;
    payableAmount: string | undefined;
    invoiceId: string | undefined;
    invoicedQuantityCode: string | undefined;
    invoicedQuantity: string | undefined;
    invoiceLineExtensionAmount: string | undefined;
    invoiceChargeIndicator: string | undefined;
    invoiceAllowanceChargeReason: string | undefined;
    invoiceMultiplierFactorNumeric: string | undefined;
    invoiceAmount: string | undefined;
    invoiceCurrency: string | undefined;
    billItems: BillLhdnItemDto[] | undefined;
    status: string | undefined;
    error: string | undefined;
    billId: string | undefined;
    lhdnQr: string | undefined;

    constructor(data?: IBillLhdnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billLhdnId = _data["billLhdnId"];
            this.tenantId = _data["tenantId"];
            this.submissionUid = _data["submissionUid"];
            this.invoiceCodeNumber = _data["invoiceCodeNumber"];
            this.uuid = _data["uuid"];
            this.lhdnID = _data["lhdnID"];
            this.issueDate = _data["issueDate"];
            this.issueTime = _data["issueTime"];
            this.invoiceTypeCode = _data["invoiceTypeCode"];
            this.documentCurrencyCode = _data["documentCurrencyCode"];
            this.invoicePeriodStartDate = _data["invoicePeriodStartDate"];
            this.invoicePeriodEndDate = _data["invoicePeriodEndDate"];
            this.invoicePeriodDescription = _data["invoicePeriodDescription"];
            this.additionalAccountID = _data["additionalAccountID"];
            this.industryClassificationName = _data["industryClassificationName"];
            this.industryClassificationCode = _data["industryClassificationCode"];
            this.tin = _data["tin"];
            this.brn = _data["brn"];
            this.cityName = _data["cityName"];
            this.postalZone = _data["postalZone"];
            this.countrySubentityCode = _data["countrySubentityCode"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.country = _data["country"];
            this.registrationName = _data["registrationName"];
            this.telephone = _data["telephone"];
            this.electronicMail = _data["electronicMail"];
            this.customerTin = _data["customerTin"];
            this.customerBRN = _data["customerBRN"];
            this.customerCityName = _data["customerCityName"];
            this.customerPostalZone = _data["customerPostalZone"];
            this.customerCountrySubentityCode = _data["customerCountrySubentityCode"];
            this.customerAddressLine1 = _data["customerAddressLine1"];
            this.customerAddressLine2 = _data["customerAddressLine2"];
            this.customerCountry = _data["customerCountry"];
            this.customerRegistrationName = _data["customerRegistrationName"];
            this.customerTelephone = _data["customerTelephone"];
            this.customerElectronicMail = _data["customerElectronicMail"];
            this.deliveryTIN = _data["deliveryTIN"];
            this.deliveryBRN = _data["deliveryBRN"];
            this.deliveryCityName = _data["deliveryCityName"];
            this.deliveryPostalZone = _data["deliveryPostalZone"];
            this.deliveryCountrySubentityCode = _data["deliveryCountrySubentityCode"];
            this.deliveryAddressLine1 = _data["deliveryAddressLine1"];
            this.deliveryAddressLine2 = _data["deliveryAddressLine2"];
            this.deliveryCountry = _data["deliveryCountry"];
            this.deliveryRegistrationName = _data["deliveryRegistrationName"];
            this.shipmentId = _data["shipmentId"];
            this.freightCharge = _data["freightCharge"];
            this.freightChargeReason = _data["freightChargeReason"];
            this.freightChargeAmount = _data["freightChargeAmount"];
            this.paymentMeansCode = _data["paymentMeansCode"];
            this.payeeFinancialAccount = _data["payeeFinancialAccount"];
            this.paymentTerms = _data["paymentTerms"];
            this.prepaidPaymentId = _data["prepaidPaymentId"];
            this.prepaidPaymentAmount = _data["prepaidPaymentAmount"];
            this.prepaidPaymentDate = _data["prepaidPaymentDate"];
            this.prepaidPaymentTime = _data["prepaidPaymentTime"];
            this.allowanceCharge = _data["allowanceCharge"];
            this.allowanceChargeReason = _data["allowanceChargeReason"];
            this.allowanceChargeAmount = _data["allowanceChargeAmount"];
            this.taxAmount = _data["taxAmount"];
            this.taxableAmount = _data["taxableAmount"];
            this.taxPercentage = _data["taxPercentage"];
            this.taxBaseUnitMeasure = _data["taxBaseUnitMeasure"];
            this.taxPerUnitAmount = _data["taxPerUnitAmount"];
            this.taxCategoryID = _data["taxCategoryID"];
            this.taxSchemeID = _data["taxSchemeID"];
            this.taxschemeAgencyID = _data["taxschemeAgencyID"];
            this.taxScheme = _data["taxScheme"];
            this.taxExemptionReason = _data["taxExemptionReason"];
            this.lineExtensionAmount = _data["lineExtensionAmount"];
            this.taxExclusiveAmount = _data["taxExclusiveAmount"];
            this.taxInclusiveAmount = _data["taxInclusiveAmount"];
            this.allowanceTotalAmount = _data["allowanceTotalAmount"];
            this.chargeTotalAmount = _data["chargeTotalAmount"];
            this.payableRoundingAmount = _data["payableRoundingAmount"];
            this.payableAmount = _data["payableAmount"];
            this.invoiceId = _data["invoiceId"];
            this.invoicedQuantityCode = _data["invoicedQuantityCode"];
            this.invoicedQuantity = _data["invoicedQuantity"];
            this.invoiceLineExtensionAmount = _data["invoiceLineExtensionAmount"];
            this.invoiceChargeIndicator = _data["invoiceChargeIndicator"];
            this.invoiceAllowanceChargeReason = _data["invoiceAllowanceChargeReason"];
            this.invoiceMultiplierFactorNumeric = _data["invoiceMultiplierFactorNumeric"];
            this.invoiceAmount = _data["invoiceAmount"];
            this.invoiceCurrency = _data["invoiceCurrency"];
            if (Array.isArray(_data["billItems"])) {
                this.billItems = [] as any;
                for (let item of _data["billItems"])
                    this.billItems.push(BillLhdnItemDto.fromJS(item));
            }
            this.status = _data["status"];
            this.error = _data["error"];
            this.billId = _data["billId"];
            this.lhdnQr = _data["lhdnQr"];
        }
    }

    static fromJS(data: any): BillLhdnDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillLhdnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billLhdnId"] = this.billLhdnId;
        data["tenantId"] = this.tenantId;
        data["submissionUid"] = this.submissionUid;
        data["invoiceCodeNumber"] = this.invoiceCodeNumber;
        data["uuid"] = this.uuid;
        data["lhdnID"] = this.lhdnID;
        data["issueDate"] = this.issueDate;
        data["issueTime"] = this.issueTime;
        data["invoiceTypeCode"] = this.invoiceTypeCode;
        data["documentCurrencyCode"] = this.documentCurrencyCode;
        data["invoicePeriodStartDate"] = this.invoicePeriodStartDate;
        data["invoicePeriodEndDate"] = this.invoicePeriodEndDate;
        data["invoicePeriodDescription"] = this.invoicePeriodDescription;
        data["additionalAccountID"] = this.additionalAccountID;
        data["industryClassificationName"] = this.industryClassificationName;
        data["industryClassificationCode"] = this.industryClassificationCode;
        data["tin"] = this.tin;
        data["brn"] = this.brn;
        data["cityName"] = this.cityName;
        data["postalZone"] = this.postalZone;
        data["countrySubentityCode"] = this.countrySubentityCode;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["country"] = this.country;
        data["registrationName"] = this.registrationName;
        data["telephone"] = this.telephone;
        data["electronicMail"] = this.electronicMail;
        data["customerTin"] = this.customerTin;
        data["customerBRN"] = this.customerBRN;
        data["customerCityName"] = this.customerCityName;
        data["customerPostalZone"] = this.customerPostalZone;
        data["customerCountrySubentityCode"] = this.customerCountrySubentityCode;
        data["customerAddressLine1"] = this.customerAddressLine1;
        data["customerAddressLine2"] = this.customerAddressLine2;
        data["customerCountry"] = this.customerCountry;
        data["customerRegistrationName"] = this.customerRegistrationName;
        data["customerTelephone"] = this.customerTelephone;
        data["customerElectronicMail"] = this.customerElectronicMail;
        data["deliveryTIN"] = this.deliveryTIN;
        data["deliveryBRN"] = this.deliveryBRN;
        data["deliveryCityName"] = this.deliveryCityName;
        data["deliveryPostalZone"] = this.deliveryPostalZone;
        data["deliveryCountrySubentityCode"] = this.deliveryCountrySubentityCode;
        data["deliveryAddressLine1"] = this.deliveryAddressLine1;
        data["deliveryAddressLine2"] = this.deliveryAddressLine2;
        data["deliveryCountry"] = this.deliveryCountry;
        data["deliveryRegistrationName"] = this.deliveryRegistrationName;
        data["shipmentId"] = this.shipmentId;
        data["freightCharge"] = this.freightCharge;
        data["freightChargeReason"] = this.freightChargeReason;
        data["freightChargeAmount"] = this.freightChargeAmount;
        data["paymentMeansCode"] = this.paymentMeansCode;
        data["payeeFinancialAccount"] = this.payeeFinancialAccount;
        data["paymentTerms"] = this.paymentTerms;
        data["prepaidPaymentId"] = this.prepaidPaymentId;
        data["prepaidPaymentAmount"] = this.prepaidPaymentAmount;
        data["prepaidPaymentDate"] = this.prepaidPaymentDate;
        data["prepaidPaymentTime"] = this.prepaidPaymentTime;
        data["allowanceCharge"] = this.allowanceCharge;
        data["allowanceChargeReason"] = this.allowanceChargeReason;
        data["allowanceChargeAmount"] = this.allowanceChargeAmount;
        data["taxAmount"] = this.taxAmount;
        data["taxableAmount"] = this.taxableAmount;
        data["taxPercentage"] = this.taxPercentage;
        data["taxBaseUnitMeasure"] = this.taxBaseUnitMeasure;
        data["taxPerUnitAmount"] = this.taxPerUnitAmount;
        data["taxCategoryID"] = this.taxCategoryID;
        data["taxSchemeID"] = this.taxSchemeID;
        data["taxschemeAgencyID"] = this.taxschemeAgencyID;
        data["taxScheme"] = this.taxScheme;
        data["taxExemptionReason"] = this.taxExemptionReason;
        data["lineExtensionAmount"] = this.lineExtensionAmount;
        data["taxExclusiveAmount"] = this.taxExclusiveAmount;
        data["taxInclusiveAmount"] = this.taxInclusiveAmount;
        data["allowanceTotalAmount"] = this.allowanceTotalAmount;
        data["chargeTotalAmount"] = this.chargeTotalAmount;
        data["payableRoundingAmount"] = this.payableRoundingAmount;
        data["payableAmount"] = this.payableAmount;
        data["invoiceId"] = this.invoiceId;
        data["invoicedQuantityCode"] = this.invoicedQuantityCode;
        data["invoicedQuantity"] = this.invoicedQuantity;
        data["invoiceLineExtensionAmount"] = this.invoiceLineExtensionAmount;
        data["invoiceChargeIndicator"] = this.invoiceChargeIndicator;
        data["invoiceAllowanceChargeReason"] = this.invoiceAllowanceChargeReason;
        data["invoiceMultiplierFactorNumeric"] = this.invoiceMultiplierFactorNumeric;
        data["invoiceAmount"] = this.invoiceAmount;
        data["invoiceCurrency"] = this.invoiceCurrency;
        if (Array.isArray(this.billItems)) {
            data["billItems"] = [];
            for (let item of this.billItems)
                data["billItems"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["error"] = this.error;
        data["billId"] = this.billId;
        data["lhdnQr"] = this.lhdnQr;
        return data;
    }

    clone(): BillLhdnDto {
        const json = this.toJSON();
        let result = new BillLhdnDto();
        result.init(json);
        return result;
    }
}

export interface IBillLhdnDto {
    billLhdnId: number;
    tenantId: number;
    submissionUid: string | undefined;
    invoiceCodeNumber: string | undefined;
    uuid: string | undefined;
    lhdnID: string | undefined;
    issueDate: string | undefined;
    issueTime: string | undefined;
    invoiceTypeCode: string | undefined;
    documentCurrencyCode: string | undefined;
    invoicePeriodStartDate: string | undefined;
    invoicePeriodEndDate: string | undefined;
    invoicePeriodDescription: string | undefined;
    additionalAccountID: string | undefined;
    industryClassificationName: string | undefined;
    industryClassificationCode: string | undefined;
    tin: string | undefined;
    brn: string | undefined;
    cityName: string | undefined;
    postalZone: string | undefined;
    countrySubentityCode: string | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    country: string | undefined;
    registrationName: string | undefined;
    telephone: string | undefined;
    electronicMail: string | undefined;
    customerTin: string | undefined;
    customerBRN: string | undefined;
    customerCityName: string | undefined;
    customerPostalZone: string | undefined;
    customerCountrySubentityCode: string | undefined;
    customerAddressLine1: string | undefined;
    customerAddressLine2: string | undefined;
    customerCountry: string | undefined;
    customerRegistrationName: string | undefined;
    customerTelephone: string | undefined;
    customerElectronicMail: string | undefined;
    deliveryTIN: string | undefined;
    deliveryBRN: string | undefined;
    deliveryCityName: string | undefined;
    deliveryPostalZone: string | undefined;
    deliveryCountrySubentityCode: string | undefined;
    deliveryAddressLine1: string | undefined;
    deliveryAddressLine2: string | undefined;
    deliveryCountry: string | undefined;
    deliveryRegistrationName: string | undefined;
    shipmentId: string | undefined;
    freightCharge: string | undefined;
    freightChargeReason: string | undefined;
    freightChargeAmount: string | undefined;
    paymentMeansCode: string | undefined;
    payeeFinancialAccount: string | undefined;
    paymentTerms: string | undefined;
    prepaidPaymentId: string | undefined;
    prepaidPaymentAmount: string | undefined;
    prepaidPaymentDate: string | undefined;
    prepaidPaymentTime: string | undefined;
    allowanceCharge: string | undefined;
    allowanceChargeReason: string | undefined;
    allowanceChargeAmount: string | undefined;
    taxAmount: string | undefined;
    taxableAmount: string | undefined;
    taxPercentage: string | undefined;
    taxBaseUnitMeasure: string | undefined;
    taxPerUnitAmount: string | undefined;
    taxCategoryID: string | undefined;
    taxSchemeID: string | undefined;
    taxschemeAgencyID: string | undefined;
    taxScheme: string | undefined;
    taxExemptionReason: string | undefined;
    lineExtensionAmount: string | undefined;
    taxExclusiveAmount: string | undefined;
    taxInclusiveAmount: string | undefined;
    allowanceTotalAmount: string | undefined;
    chargeTotalAmount: string | undefined;
    payableRoundingAmount: string | undefined;
    payableAmount: string | undefined;
    invoiceId: string | undefined;
    invoicedQuantityCode: string | undefined;
    invoicedQuantity: string | undefined;
    invoiceLineExtensionAmount: string | undefined;
    invoiceChargeIndicator: string | undefined;
    invoiceAllowanceChargeReason: string | undefined;
    invoiceMultiplierFactorNumeric: string | undefined;
    invoiceAmount: string | undefined;
    invoiceCurrency: string | undefined;
    billItems: BillLhdnItemDto[] | undefined;
    status: string | undefined;
    error: string | undefined;
    billId: string | undefined;
    lhdnQr: string | undefined;
}

export class BillLhdnItemDto implements IBillLhdnItemDto {
    billLhdnId: string | undefined;
    description: string | undefined;
    originCountry: string | undefined;
    itemClassificationCode: string | undefined;
    listID: string | undefined;
    priceAmount: string | undefined;
    itemPriceExtensionAmount: string | undefined;
    itemPriceExtensionCurrency: string | undefined;
    itemQuantity: string | undefined;
    taxPercentage: string | undefined;
    productName: string | undefined;
    taxCategoryID: string | undefined;

    constructor(data?: IBillLhdnItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billLhdnId = _data["billLhdnId"];
            this.description = _data["description"];
            this.originCountry = _data["originCountry"];
            this.itemClassificationCode = _data["itemClassificationCode"];
            this.listID = _data["listID"];
            this.priceAmount = _data["priceAmount"];
            this.itemPriceExtensionAmount = _data["itemPriceExtensionAmount"];
            this.itemPriceExtensionCurrency = _data["itemPriceExtensionCurrency"];
            this.itemQuantity = _data["itemQuantity"];
            this.taxPercentage = _data["taxPercentage"];
            this.productName = _data["productName"];
            this.taxCategoryID = _data["taxCategoryID"];
        }
    }

    static fromJS(data: any): BillLhdnItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillLhdnItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billLhdnId"] = this.billLhdnId;
        data["description"] = this.description;
        data["originCountry"] = this.originCountry;
        data["itemClassificationCode"] = this.itemClassificationCode;
        data["listID"] = this.listID;
        data["priceAmount"] = this.priceAmount;
        data["itemPriceExtensionAmount"] = this.itemPriceExtensionAmount;
        data["itemPriceExtensionCurrency"] = this.itemPriceExtensionCurrency;
        data["itemQuantity"] = this.itemQuantity;
        data["taxPercentage"] = this.taxPercentage;
        data["productName"] = this.productName;
        data["taxCategoryID"] = this.taxCategoryID;
        return data;
    }

    clone(): BillLhdnItemDto {
        const json = this.toJSON();
        let result = new BillLhdnItemDto();
        result.init(json);
        return result;
    }
}

export interface IBillLhdnItemDto {
    billLhdnId: string | undefined;
    description: string | undefined;
    originCountry: string | undefined;
    itemClassificationCode: string | undefined;
    listID: string | undefined;
    priceAmount: string | undefined;
    itemPriceExtensionAmount: string | undefined;
    itemPriceExtensionCurrency: string | undefined;
    itemQuantity: string | undefined;
    taxPercentage: string | undefined;
    productName: string | undefined;
    taxCategoryID: string | undefined;
}

export class BillMigrationDto implements IBillMigrationDto {
    invoiceDate: moment.Moment;
    invoiceNo: string | undefined;
    description: string | undefined;
    customerName: string | undefined;
    customerEmail: string | undefined;
    isValid: boolean;
    error: string | undefined;
    customerId: string | undefined;
    customer: Customer;
    contactNo: string | undefined;
    billingAddress: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    isPaid: boolean;
    invoiceAmount: number;
    taxAmount: number;
    deliveryCharge: number;
    postMigration: boolean;
    categoryCode: string | undefined;
    categoryName: string | undefined;

    constructor(data?: IBillMigrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceDate = _data["invoiceDate"] ? moment(_data["invoiceDate"].toString()) : <any>undefined;
            this.invoiceNo = _data["invoiceNo"];
            this.description = _data["description"];
            this.customerName = _data["customerName"];
            this.customerEmail = _data["customerEmail"];
            this.isValid = _data["isValid"];
            this.error = _data["error"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.contactNo = _data["contactNo"];
            this.billingAddress = _data["billingAddress"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.isPaid = _data["isPaid"];
            this.invoiceAmount = _data["invoiceAmount"];
            this.taxAmount = _data["taxAmount"];
            this.deliveryCharge = _data["deliveryCharge"];
            this.postMigration = _data["postMigration"];
            this.categoryCode = _data["categoryCode"];
            this.categoryName = _data["categoryName"];
        }
    }

    static fromJS(data: any): BillMigrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillMigrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["invoiceNo"] = this.invoiceNo;
        data["description"] = this.description;
        data["customerName"] = this.customerName;
        data["customerEmail"] = this.customerEmail;
        data["isValid"] = this.isValid;
        data["error"] = this.error;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["contactNo"] = this.contactNo;
        data["billingAddress"] = this.billingAddress;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["isPaid"] = this.isPaid;
        data["invoiceAmount"] = this.invoiceAmount;
        data["taxAmount"] = this.taxAmount;
        data["deliveryCharge"] = this.deliveryCharge;
        data["postMigration"] = this.postMigration;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        return data;
    }

    clone(): BillMigrationDto {
        const json = this.toJSON();
        let result = new BillMigrationDto();
        result.init(json);
        return result;
    }
}

export interface IBillMigrationDto {
    invoiceDate: moment.Moment;
    invoiceNo: string | undefined;
    description: string | undefined;
    customerName: string | undefined;
    customerEmail: string | undefined;
    isValid: boolean;
    error: string | undefined;
    customerId: string | undefined;
    customer: Customer;
    contactNo: string | undefined;
    billingAddress: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    isPaid: boolean;
    invoiceAmount: number;
    taxAmount: number;
    deliveryCharge: number;
    postMigration: boolean;
    categoryCode: string | undefined;
    categoryName: string | undefined;
}

export class BillService implements IBillService {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    billId: string;
    bill: Bill;
    serviceName: string | undefined;
    description: string | undefined;
    unitPrice: number;
    discount: number;
    tax: number;
    taxCode: string | undefined;
    quantity: number;
    type: string | undefined;

    constructor(data?: IBillService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.billId = _data["billId"];
            this.bill = _data["bill"] ? Bill.fromJS(_data["bill"]) : <any>undefined;
            this.serviceName = _data["serviceName"];
            this.description = _data["description"];
            this.unitPrice = _data["unitPrice"];
            this.discount = _data["discount"];
            this.tax = _data["tax"];
            this.taxCode = _data["taxCode"];
            this.quantity = _data["quantity"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): BillService {
        data = typeof data === 'object' ? data : {};
        let result = new BillService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["billId"] = this.billId;
        data["bill"] = this.bill ? this.bill.toJSON() : <any>undefined;
        data["serviceName"] = this.serviceName;
        data["description"] = this.description;
        data["unitPrice"] = this.unitPrice;
        data["discount"] = this.discount;
        data["tax"] = this.tax;
        data["taxCode"] = this.taxCode;
        data["quantity"] = this.quantity;
        data["type"] = this.type;
        return data;
    }

    clone(): BillService {
        const json = this.toJSON();
        let result = new BillService();
        result.init(json);
        return result;
    }
}

export interface IBillService {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    billId: string;
    bill: Bill;
    serviceName: string | undefined;
    description: string | undefined;
    unitPrice: number;
    discount: number;
    tax: number;
    taxCode: string | undefined;
    quantity: number;
    type: string | undefined;
}

export class BillServiceDto implements IBillServiceDto {
    billId: string;
    bill: Bill;
    serviceName: string | undefined;
    description: string | undefined;
    unitPrice: number;
    discount: number;
    tax: number;
    taxCode: string | undefined;
    quantity: number;
    type: string | undefined;
    billServiceId: number;

    constructor(data?: IBillServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billId = _data["billId"];
            this.bill = _data["bill"] ? Bill.fromJS(_data["bill"]) : <any>undefined;
            this.serviceName = _data["serviceName"];
            this.description = _data["description"];
            this.unitPrice = _data["unitPrice"];
            this.discount = _data["discount"];
            this.tax = _data["tax"];
            this.taxCode = _data["taxCode"];
            this.quantity = _data["quantity"];
            this.type = _data["type"];
            this.billServiceId = _data["billServiceId"];
        }
    }

    static fromJS(data: any): BillServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billId"] = this.billId;
        data["bill"] = this.bill ? this.bill.toJSON() : <any>undefined;
        data["serviceName"] = this.serviceName;
        data["description"] = this.description;
        data["unitPrice"] = this.unitPrice;
        data["discount"] = this.discount;
        data["tax"] = this.tax;
        data["taxCode"] = this.taxCode;
        data["quantity"] = this.quantity;
        data["type"] = this.type;
        data["billServiceId"] = this.billServiceId;
        return data;
    }

    clone(): BillServiceDto {
        const json = this.toJSON();
        let result = new BillServiceDto();
        result.init(json);
        return result;
    }
}

export interface IBillServiceDto {
    billId: string;
    bill: Bill;
    serviceName: string | undefined;
    description: string | undefined;
    unitPrice: number;
    discount: number;
    tax: number;
    taxCode: string | undefined;
    quantity: number;
    type: string | undefined;
    billServiceId: number;
}

export class BillSummaryDto implements IBillSummaryDto {
    totalOverdueAmount: number;
    totalDueIn30DaysAmount: number;
    totalInDraftAmount: number;
    totalUnpaid: number;
    totalUnpaidAmount: number;
    totalDraft: number;
    totalReceived: number;
    janTotal: number;
    febTotal: number;
    marTotal: number;
    aprTotal: number;
    mayTotal: number;
    junTotal: number;
    julTotal: number;
    augTotal: number;
    sepTotal: number;
    octTotal: number;
    novTotal: number;
    decTotal: number;
    totalReceivedYearAmount: number;
    totalReceivedMonthAmount: number;
    total60DaysOverdue: number;
    total30DaysOverdue: number;
    totalInvoices: number;
    totalCreditnotes: number;
    totalCreditnotesTax: number;
    totalTaxAmount: number;
    totalDeliveryCharge: number;
    totalDisburesement: number;
    totalReimbursement: number;

    constructor(data?: IBillSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalOverdueAmount = _data["totalOverdueAmount"];
            this.totalDueIn30DaysAmount = _data["totalDueIn30DaysAmount"];
            this.totalInDraftAmount = _data["totalInDraftAmount"];
            this.totalUnpaid = _data["totalUnpaid"];
            this.totalUnpaidAmount = _data["totalUnpaidAmount"];
            this.totalDraft = _data["totalDraft"];
            this.totalReceived = _data["totalReceived"];
            this.janTotal = _data["janTotal"];
            this.febTotal = _data["febTotal"];
            this.marTotal = _data["marTotal"];
            this.aprTotal = _data["aprTotal"];
            this.mayTotal = _data["mayTotal"];
            this.junTotal = _data["junTotal"];
            this.julTotal = _data["julTotal"];
            this.augTotal = _data["augTotal"];
            this.sepTotal = _data["sepTotal"];
            this.octTotal = _data["octTotal"];
            this.novTotal = _data["novTotal"];
            this.decTotal = _data["decTotal"];
            this.totalReceivedYearAmount = _data["totalReceivedYearAmount"];
            this.totalReceivedMonthAmount = _data["totalReceivedMonthAmount"];
            this.total60DaysOverdue = _data["total60DaysOverdue"];
            this.total30DaysOverdue = _data["total30DaysOverdue"];
            this.totalInvoices = _data["totalInvoices"];
            this.totalCreditnotes = _data["totalCreditnotes"];
            this.totalCreditnotesTax = _data["totalCreditnotesTax"];
            this.totalTaxAmount = _data["totalTaxAmount"];
            this.totalDeliveryCharge = _data["totalDeliveryCharge"];
            this.totalDisburesement = _data["totalDisburesement"];
            this.totalReimbursement = _data["totalReimbursement"];
        }
    }

    static fromJS(data: any): BillSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalOverdueAmount"] = this.totalOverdueAmount;
        data["totalDueIn30DaysAmount"] = this.totalDueIn30DaysAmount;
        data["totalInDraftAmount"] = this.totalInDraftAmount;
        data["totalUnpaid"] = this.totalUnpaid;
        data["totalUnpaidAmount"] = this.totalUnpaidAmount;
        data["totalDraft"] = this.totalDraft;
        data["totalReceived"] = this.totalReceived;
        data["janTotal"] = this.janTotal;
        data["febTotal"] = this.febTotal;
        data["marTotal"] = this.marTotal;
        data["aprTotal"] = this.aprTotal;
        data["mayTotal"] = this.mayTotal;
        data["junTotal"] = this.junTotal;
        data["julTotal"] = this.julTotal;
        data["augTotal"] = this.augTotal;
        data["sepTotal"] = this.sepTotal;
        data["octTotal"] = this.octTotal;
        data["novTotal"] = this.novTotal;
        data["decTotal"] = this.decTotal;
        data["totalReceivedYearAmount"] = this.totalReceivedYearAmount;
        data["totalReceivedMonthAmount"] = this.totalReceivedMonthAmount;
        data["total60DaysOverdue"] = this.total60DaysOverdue;
        data["total30DaysOverdue"] = this.total30DaysOverdue;
        data["totalInvoices"] = this.totalInvoices;
        data["totalCreditnotes"] = this.totalCreditnotes;
        data["totalCreditnotesTax"] = this.totalCreditnotesTax;
        data["totalTaxAmount"] = this.totalTaxAmount;
        data["totalDeliveryCharge"] = this.totalDeliveryCharge;
        data["totalDisburesement"] = this.totalDisburesement;
        data["totalReimbursement"] = this.totalReimbursement;
        return data;
    }

    clone(): BillSummaryDto {
        const json = this.toJSON();
        let result = new BillSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IBillSummaryDto {
    totalOverdueAmount: number;
    totalDueIn30DaysAmount: number;
    totalInDraftAmount: number;
    totalUnpaid: number;
    totalUnpaidAmount: number;
    totalDraft: number;
    totalReceived: number;
    janTotal: number;
    febTotal: number;
    marTotal: number;
    aprTotal: number;
    mayTotal: number;
    junTotal: number;
    julTotal: number;
    augTotal: number;
    sepTotal: number;
    octTotal: number;
    novTotal: number;
    decTotal: number;
    totalReceivedYearAmount: number;
    totalReceivedMonthAmount: number;
    total60DaysOverdue: number;
    total30DaysOverdue: number;
    totalInvoices: number;
    totalCreditnotes: number;
    totalCreditnotesTax: number;
    totalTaxAmount: number;
    totalDeliveryCharge: number;
    totalDisburesement: number;
    totalReimbursement: number;
}

export class BulkOrderDetailsDto implements IBulkOrderDetailsDto {
    weight: number;
    content: string | undefined;
    value: number;
    serviceId: string | undefined;
    pickName: string | undefined;
    pickContact: string | undefined;
    pickAddr1: string | undefined;
    pickCity: string | undefined;
    pickState: string | undefined;
    pickCode: string | undefined;
    pickCountry: string | undefined;
    sendName: string | undefined;
    sendContact: string | undefined;
    sendAddr1: string | undefined;
    sendCity: string | undefined;
    sendState: string | undefined;
    sendCode: string | undefined;
    sendCountry: string | undefined;
    collectDate: moment.Moment;
    sms: boolean;
    sendEmail: string | undefined;
    width: number | undefined;
    length: number | undefined;
    height: number | undefined;
    pickCompany: string | undefined;
    pickMobile: string | undefined;
    pickAddr2: string | undefined;
    pickAddr3: string | undefined;
    pickAddr4: string | undefined;
    pickPoint: string | undefined;
    sendPoint: string | undefined;
    sendCompany: string | undefined;
    sendMobile: string | undefined;
    sendAddr2: string | undefined;
    sendAddr3: string | undefined;
    sendAddr4: string | undefined;
    hsCode: string | undefined;
    reqId: string | undefined;
    reference: string | undefined;
    codEnabled: boolean | undefined;
    codAmount: number | undefined;
    taxDuty: string | undefined;
    parcelCategoryId: string | undefined;
    addonInsuranceEnabled: boolean | undefined;
    addonWhatsappTrackingEnabled: boolean | undefined;
    orderId: string;

    constructor(data?: IBulkOrderDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weight = _data["weight"];
            this.content = _data["content"];
            this.value = _data["value"];
            this.serviceId = _data["serviceId"];
            this.pickName = _data["pickName"];
            this.pickContact = _data["pickContact"];
            this.pickAddr1 = _data["pickAddr1"];
            this.pickCity = _data["pickCity"];
            this.pickState = _data["pickState"];
            this.pickCode = _data["pickCode"];
            this.pickCountry = _data["pickCountry"];
            this.sendName = _data["sendName"];
            this.sendContact = _data["sendContact"];
            this.sendAddr1 = _data["sendAddr1"];
            this.sendCity = _data["sendCity"];
            this.sendState = _data["sendState"];
            this.sendCode = _data["sendCode"];
            this.sendCountry = _data["sendCountry"];
            this.collectDate = _data["collectDate"] ? moment(_data["collectDate"].toString()) : <any>undefined;
            this.sms = _data["sms"];
            this.sendEmail = _data["sendEmail"];
            this.width = _data["width"];
            this.length = _data["length"];
            this.height = _data["height"];
            this.pickCompany = _data["pickCompany"];
            this.pickMobile = _data["pickMobile"];
            this.pickAddr2 = _data["pickAddr2"];
            this.pickAddr3 = _data["pickAddr3"];
            this.pickAddr4 = _data["pickAddr4"];
            this.pickPoint = _data["pickPoint"];
            this.sendPoint = _data["sendPoint"];
            this.sendCompany = _data["sendCompany"];
            this.sendMobile = _data["sendMobile"];
            this.sendAddr2 = _data["sendAddr2"];
            this.sendAddr3 = _data["sendAddr3"];
            this.sendAddr4 = _data["sendAddr4"];
            this.hsCode = _data["hsCode"];
            this.reqId = _data["reqId"];
            this.reference = _data["reference"];
            this.codEnabled = _data["codEnabled"];
            this.codAmount = _data["codAmount"];
            this.taxDuty = _data["taxDuty"];
            this.parcelCategoryId = _data["parcelCategoryId"];
            this.addonInsuranceEnabled = _data["addonInsuranceEnabled"];
            this.addonWhatsappTrackingEnabled = _data["addonWhatsappTrackingEnabled"];
            this.orderId = _data["orderId"];
        }
    }

    static fromJS(data: any): BulkOrderDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BulkOrderDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weight"] = this.weight;
        data["content"] = this.content;
        data["value"] = this.value;
        data["serviceId"] = this.serviceId;
        data["pickName"] = this.pickName;
        data["pickContact"] = this.pickContact;
        data["pickAddr1"] = this.pickAddr1;
        data["pickCity"] = this.pickCity;
        data["pickState"] = this.pickState;
        data["pickCode"] = this.pickCode;
        data["pickCountry"] = this.pickCountry;
        data["sendName"] = this.sendName;
        data["sendContact"] = this.sendContact;
        data["sendAddr1"] = this.sendAddr1;
        data["sendCity"] = this.sendCity;
        data["sendState"] = this.sendState;
        data["sendCode"] = this.sendCode;
        data["sendCountry"] = this.sendCountry;
        data["collectDate"] = this.collectDate ? this.collectDate.toISOString() : <any>undefined;
        data["sms"] = this.sms;
        data["sendEmail"] = this.sendEmail;
        data["width"] = this.width;
        data["length"] = this.length;
        data["height"] = this.height;
        data["pickCompany"] = this.pickCompany;
        data["pickMobile"] = this.pickMobile;
        data["pickAddr2"] = this.pickAddr2;
        data["pickAddr3"] = this.pickAddr3;
        data["pickAddr4"] = this.pickAddr4;
        data["pickPoint"] = this.pickPoint;
        data["sendPoint"] = this.sendPoint;
        data["sendCompany"] = this.sendCompany;
        data["sendMobile"] = this.sendMobile;
        data["sendAddr2"] = this.sendAddr2;
        data["sendAddr3"] = this.sendAddr3;
        data["sendAddr4"] = this.sendAddr4;
        data["hsCode"] = this.hsCode;
        data["reqId"] = this.reqId;
        data["reference"] = this.reference;
        data["codEnabled"] = this.codEnabled;
        data["codAmount"] = this.codAmount;
        data["taxDuty"] = this.taxDuty;
        data["parcelCategoryId"] = this.parcelCategoryId;
        data["addonInsuranceEnabled"] = this.addonInsuranceEnabled;
        data["addonWhatsappTrackingEnabled"] = this.addonWhatsappTrackingEnabled;
        data["orderId"] = this.orderId;
        return data;
    }

    clone(): BulkOrderDetailsDto {
        const json = this.toJSON();
        let result = new BulkOrderDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IBulkOrderDetailsDto {
    weight: number;
    content: string | undefined;
    value: number;
    serviceId: string | undefined;
    pickName: string | undefined;
    pickContact: string | undefined;
    pickAddr1: string | undefined;
    pickCity: string | undefined;
    pickState: string | undefined;
    pickCode: string | undefined;
    pickCountry: string | undefined;
    sendName: string | undefined;
    sendContact: string | undefined;
    sendAddr1: string | undefined;
    sendCity: string | undefined;
    sendState: string | undefined;
    sendCode: string | undefined;
    sendCountry: string | undefined;
    collectDate: moment.Moment;
    sms: boolean;
    sendEmail: string | undefined;
    width: number | undefined;
    length: number | undefined;
    height: number | undefined;
    pickCompany: string | undefined;
    pickMobile: string | undefined;
    pickAddr2: string | undefined;
    pickAddr3: string | undefined;
    pickAddr4: string | undefined;
    pickPoint: string | undefined;
    sendPoint: string | undefined;
    sendCompany: string | undefined;
    sendMobile: string | undefined;
    sendAddr2: string | undefined;
    sendAddr3: string | undefined;
    sendAddr4: string | undefined;
    hsCode: string | undefined;
    reqId: string | undefined;
    reference: string | undefined;
    codEnabled: boolean | undefined;
    codAmount: number | undefined;
    taxDuty: string | undefined;
    parcelCategoryId: string | undefined;
    addonInsuranceEnabled: boolean | undefined;
    addonWhatsappTrackingEnabled: boolean | undefined;
    orderId: string;
}

export class BuyBadgeDto implements IBuyBadgeDto {
    prPendingCount: number;
    poPendingCount: number;
    quotationPendingCount: number;
    vendorInvoicePendingCount: number;

    constructor(data?: IBuyBadgeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prPendingCount = _data["prPendingCount"];
            this.poPendingCount = _data["poPendingCount"];
            this.quotationPendingCount = _data["quotationPendingCount"];
            this.vendorInvoicePendingCount = _data["vendorInvoicePendingCount"];
        }
    }

    static fromJS(data: any): BuyBadgeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuyBadgeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prPendingCount"] = this.prPendingCount;
        data["poPendingCount"] = this.poPendingCount;
        data["quotationPendingCount"] = this.quotationPendingCount;
        data["vendorInvoicePendingCount"] = this.vendorInvoicePendingCount;
        return data;
    }

    clone(): BuyBadgeDto {
        const json = this.toJSON();
        let result = new BuyBadgeDto();
        result.init(json);
        return result;
    }
}

export interface IBuyBadgeDto {
    prPendingCount: number;
    poPendingCount: number;
    quotationPendingCount: number;
    vendorInvoicePendingCount: number;
}

export class CartDto implements ICartDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    userId: number;
    tenantId: number;
    productId: string;
    product: Product;
    productDto: ProductDto;
    name: string | undefined;
    quantity: number;
    unitPrice: number;
    discount: number;
    tax: number;
    taxCode: string | undefined;
    readonly purchaseAmount: number;
    readonly taxAmount: number;
    readonly totalAmount: number;
    readonly discountedPurchaseAmount: number;
    readonly discountedTaxAmount: number;
    readonly discountedTotalAmount: number;
    docId: string | undefined;
    additionalInfo: string | undefined;

    constructor(data?: ICartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.productId = _data["productId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.productDto = _data["productDto"] ? ProductDto.fromJS(_data["productDto"]) : <any>undefined;
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.discount = _data["discount"];
            this.tax = _data["tax"];
            this.taxCode = _data["taxCode"];
            (<any>this).purchaseAmount = _data["purchaseAmount"];
            (<any>this).taxAmount = _data["taxAmount"];
            (<any>this).totalAmount = _data["totalAmount"];
            (<any>this).discountedPurchaseAmount = _data["discountedPurchaseAmount"];
            (<any>this).discountedTaxAmount = _data["discountedTaxAmount"];
            (<any>this).discountedTotalAmount = _data["discountedTotalAmount"];
            this.docId = _data["docId"];
            this.additionalInfo = _data["additionalInfo"];
        }
    }

    static fromJS(data: any): CartDto {
        data = typeof data === 'object' ? data : {};
        let result = new CartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productDto"] = this.productDto ? this.productDto.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["discount"] = this.discount;
        data["tax"] = this.tax;
        data["taxCode"] = this.taxCode;
        data["purchaseAmount"] = this.purchaseAmount;
        data["taxAmount"] = this.taxAmount;
        data["totalAmount"] = this.totalAmount;
        data["discountedPurchaseAmount"] = this.discountedPurchaseAmount;
        data["discountedTaxAmount"] = this.discountedTaxAmount;
        data["discountedTotalAmount"] = this.discountedTotalAmount;
        data["docId"] = this.docId;
        data["additionalInfo"] = this.additionalInfo;
        return data;
    }

    clone(): CartDto {
        const json = this.toJSON();
        let result = new CartDto();
        result.init(json);
        return result;
    }
}

export interface ICartDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    userId: number;
    tenantId: number;
    productId: string;
    product: Product;
    productDto: ProductDto;
    name: string | undefined;
    quantity: number;
    unitPrice: number;
    discount: number;
    tax: number;
    taxCode: string | undefined;
    purchaseAmount: number;
    taxAmount: number;
    totalAmount: number;
    discountedPurchaseAmount: number;
    discountedTaxAmount: number;
    discountedTotalAmount: number;
    docId: string | undefined;
    additionalInfo: string | undefined;
}

export class CartDtoPagedResultDto implements ICartDtoPagedResultDto {
    items: CartDto[] | undefined;
    totalCount: number;

    constructor(data?: ICartDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CartDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CartDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CartDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CartDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CartDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICartDtoPagedResultDto {
    items: CartDto[] | undefined;
    totalCount: number;
}

export class CashbookData implements ICashbookData {
    data: CashbooksDto[] | undefined;
    previousData: CashbooksDto[] | undefined;

    constructor(data?: ICashbookData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data.push(CashbooksDto.fromJS(item));
            }
            if (Array.isArray(_data["previousData"])) {
                this.previousData = [] as any;
                for (let item of _data["previousData"])
                    this.previousData.push(CashbooksDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CashbookData {
        data = typeof data === 'object' ? data : {};
        let result = new CashbookData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        if (Array.isArray(this.previousData)) {
            data["previousData"] = [];
            for (let item of this.previousData)
                data["previousData"].push(item.toJSON());
        }
        return data;
    }

    clone(): CashbookData {
        const json = this.toJSON();
        let result = new CashbookData();
        result.init(json);
        return result;
    }
}

export interface ICashbookData {
    data: CashbooksDto[] | undefined;
    previousData: CashbooksDto[] | undefined;
}

export class CashbookJournalData implements ICashbookJournalData {
    openingBalance: number;
    totalReceived: number;
    totalPaid: number;

    constructor(data?: ICashbookJournalData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.openingBalance = _data["openingBalance"];
            this.totalReceived = _data["totalReceived"];
            this.totalPaid = _data["totalPaid"];
        }
    }

    static fromJS(data: any): CashbookJournalData {
        data = typeof data === 'object' ? data : {};
        let result = new CashbookJournalData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["openingBalance"] = this.openingBalance;
        data["totalReceived"] = this.totalReceived;
        data["totalPaid"] = this.totalPaid;
        return data;
    }

    clone(): CashbookJournalData {
        const json = this.toJSON();
        let result = new CashbookJournalData();
        result.init(json);
        return result;
    }
}

export interface ICashbookJournalData {
    openingBalance: number;
    totalReceived: number;
    totalPaid: number;
}

export class Cashbooks implements ICashbooks {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    cashbookTypeInt: number;
    paymentType: string | undefined;
    date: moment.Moment | undefined;
    scannedDocumentUrl: string | undefined;
    amount: number;
    details: string | undefined;
    referenceNo: string | undefined;
    billId: string | undefined;
    bill: Bill;
    purchaseRequisitionId: number | undefined;
    purchaseRequisition: PurchaseRequisition;
    disposedNonCurrentAssetItemId: string | undefined;
    disposedNonCurrentAssetItem: NonCurrentAssetItem;
    accountCharged: string | undefined;
    receivedBy: string | undefined;
    requestedBy: string | undefined;
    bankName: string | undefined;
    bankAccount: string | undefined;
    bankAccountHolder: string | undefined;
    isPaymentCompleted: boolean;
    approvalStatusInt: number;
    approvedUserId: number | undefined;
    approveRemarks: string | undefined;
    approvedDate: moment.Moment | undefined;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    reversalApprovalInt: number;
    reversalRequesterName: string | undefined;
    reversalRemark: string | undefined;
    reversalRequestDate: moment.Moment;
    reversalApprovedDate: moment.Moment;
    reversalApproverName: string | undefined;
    projectId: number;
    projectType: string | undefined;
    paidTo: string | undefined;
    owedTo: string | undefined;
    accountType: string | undefined;
    accountCurrency: string | undefined;
    transactionCode: string | undefined;
    transactionDescription: string | undefined;
    transactionDescription2: string | undefined;
    transactionDescription3: string | undefined;
    transactionDescription4: string | undefined;
    projectInvoiceId: string | undefined;
    projectInvoice: Bill;
    creditNoteInvoiceId: string | undefined;
    creditNoteInvoice: Bill;
    currency: string | undefined;
    exchangeRate: number;

    constructor(data?: ICashbooks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.cashbookTypeInt = _data["cashbookTypeInt"];
            this.paymentType = _data["paymentType"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.scannedDocumentUrl = _data["scannedDocumentUrl"];
            this.amount = _data["amount"];
            this.details = _data["details"];
            this.referenceNo = _data["referenceNo"];
            this.billId = _data["billId"];
            this.bill = _data["bill"] ? Bill.fromJS(_data["bill"]) : <any>undefined;
            this.purchaseRequisitionId = _data["purchaseRequisitionId"];
            this.purchaseRequisition = _data["purchaseRequisition"] ? PurchaseRequisition.fromJS(_data["purchaseRequisition"]) : <any>undefined;
            this.disposedNonCurrentAssetItemId = _data["disposedNonCurrentAssetItemId"];
            this.disposedNonCurrentAssetItem = _data["disposedNonCurrentAssetItem"] ? NonCurrentAssetItem.fromJS(_data["disposedNonCurrentAssetItem"]) : <any>undefined;
            this.accountCharged = _data["accountCharged"];
            this.receivedBy = _data["receivedBy"];
            this.requestedBy = _data["requestedBy"];
            this.bankName = _data["bankName"];
            this.bankAccount = _data["bankAccount"];
            this.bankAccountHolder = _data["bankAccountHolder"];
            this.isPaymentCompleted = _data["isPaymentCompleted"];
            this.approvalStatusInt = _data["approvalStatusInt"];
            this.approvedUserId = _data["approvedUserId"];
            this.approveRemarks = _data["approveRemarks"];
            this.approvedDate = _data["approvedDate"] ? moment(_data["approvedDate"].toString()) : <any>undefined;
            this.categoryCode = _data["categoryCode"];
            this.categoryName = _data["categoryName"];
            this.reversalApprovalInt = _data["reversalApprovalInt"];
            this.reversalRequesterName = _data["reversalRequesterName"];
            this.reversalRemark = _data["reversalRemark"];
            this.reversalRequestDate = _data["reversalRequestDate"] ? moment(_data["reversalRequestDate"].toString()) : <any>undefined;
            this.reversalApprovedDate = _data["reversalApprovedDate"] ? moment(_data["reversalApprovedDate"].toString()) : <any>undefined;
            this.reversalApproverName = _data["reversalApproverName"];
            this.projectId = _data["projectId"];
            this.projectType = _data["projectType"];
            this.paidTo = _data["paidTo"];
            this.owedTo = _data["owedTo"];
            this.accountType = _data["accountType"];
            this.accountCurrency = _data["accountCurrency"];
            this.transactionCode = _data["transactionCode"];
            this.transactionDescription = _data["transactionDescription"];
            this.transactionDescription2 = _data["transactionDescription2"];
            this.transactionDescription3 = _data["transactionDescription3"];
            this.transactionDescription4 = _data["transactionDescription4"];
            this.projectInvoiceId = _data["projectInvoiceId"];
            this.projectInvoice = _data["projectInvoice"] ? Bill.fromJS(_data["projectInvoice"]) : <any>undefined;
            this.creditNoteInvoiceId = _data["creditNoteInvoiceId"];
            this.creditNoteInvoice = _data["creditNoteInvoice"] ? Bill.fromJS(_data["creditNoteInvoice"]) : <any>undefined;
            this.currency = _data["currency"];
            this.exchangeRate = _data["exchangeRate"];
        }
    }

    static fromJS(data: any): Cashbooks {
        data = typeof data === 'object' ? data : {};
        let result = new Cashbooks();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["cashbookTypeInt"] = this.cashbookTypeInt;
        data["paymentType"] = this.paymentType;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["scannedDocumentUrl"] = this.scannedDocumentUrl;
        data["amount"] = this.amount;
        data["details"] = this.details;
        data["referenceNo"] = this.referenceNo;
        data["billId"] = this.billId;
        data["bill"] = this.bill ? this.bill.toJSON() : <any>undefined;
        data["purchaseRequisitionId"] = this.purchaseRequisitionId;
        data["purchaseRequisition"] = this.purchaseRequisition ? this.purchaseRequisition.toJSON() : <any>undefined;
        data["disposedNonCurrentAssetItemId"] = this.disposedNonCurrentAssetItemId;
        data["disposedNonCurrentAssetItem"] = this.disposedNonCurrentAssetItem ? this.disposedNonCurrentAssetItem.toJSON() : <any>undefined;
        data["accountCharged"] = this.accountCharged;
        data["receivedBy"] = this.receivedBy;
        data["requestedBy"] = this.requestedBy;
        data["bankName"] = this.bankName;
        data["bankAccount"] = this.bankAccount;
        data["bankAccountHolder"] = this.bankAccountHolder;
        data["isPaymentCompleted"] = this.isPaymentCompleted;
        data["approvalStatusInt"] = this.approvalStatusInt;
        data["approvedUserId"] = this.approvedUserId;
        data["approveRemarks"] = this.approveRemarks;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["reversalApprovalInt"] = this.reversalApprovalInt;
        data["reversalRequesterName"] = this.reversalRequesterName;
        data["reversalRemark"] = this.reversalRemark;
        data["reversalRequestDate"] = this.reversalRequestDate ? this.reversalRequestDate.toISOString() : <any>undefined;
        data["reversalApprovedDate"] = this.reversalApprovedDate ? this.reversalApprovedDate.toISOString() : <any>undefined;
        data["reversalApproverName"] = this.reversalApproverName;
        data["projectId"] = this.projectId;
        data["projectType"] = this.projectType;
        data["paidTo"] = this.paidTo;
        data["owedTo"] = this.owedTo;
        data["accountType"] = this.accountType;
        data["accountCurrency"] = this.accountCurrency;
        data["transactionCode"] = this.transactionCode;
        data["transactionDescription"] = this.transactionDescription;
        data["transactionDescription2"] = this.transactionDescription2;
        data["transactionDescription3"] = this.transactionDescription3;
        data["transactionDescription4"] = this.transactionDescription4;
        data["projectInvoiceId"] = this.projectInvoiceId;
        data["projectInvoice"] = this.projectInvoice ? this.projectInvoice.toJSON() : <any>undefined;
        data["creditNoteInvoiceId"] = this.creditNoteInvoiceId;
        data["creditNoteInvoice"] = this.creditNoteInvoice ? this.creditNoteInvoice.toJSON() : <any>undefined;
        data["currency"] = this.currency;
        data["exchangeRate"] = this.exchangeRate;
        return data;
    }

    clone(): Cashbooks {
        const json = this.toJSON();
        let result = new Cashbooks();
        result.init(json);
        return result;
    }
}

export interface ICashbooks {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    cashbookTypeInt: number;
    paymentType: string | undefined;
    date: moment.Moment | undefined;
    scannedDocumentUrl: string | undefined;
    amount: number;
    details: string | undefined;
    referenceNo: string | undefined;
    billId: string | undefined;
    bill: Bill;
    purchaseRequisitionId: number | undefined;
    purchaseRequisition: PurchaseRequisition;
    disposedNonCurrentAssetItemId: string | undefined;
    disposedNonCurrentAssetItem: NonCurrentAssetItem;
    accountCharged: string | undefined;
    receivedBy: string | undefined;
    requestedBy: string | undefined;
    bankName: string | undefined;
    bankAccount: string | undefined;
    bankAccountHolder: string | undefined;
    isPaymentCompleted: boolean;
    approvalStatusInt: number;
    approvedUserId: number | undefined;
    approveRemarks: string | undefined;
    approvedDate: moment.Moment | undefined;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    reversalApprovalInt: number;
    reversalRequesterName: string | undefined;
    reversalRemark: string | undefined;
    reversalRequestDate: moment.Moment;
    reversalApprovedDate: moment.Moment;
    reversalApproverName: string | undefined;
    projectId: number;
    projectType: string | undefined;
    paidTo: string | undefined;
    owedTo: string | undefined;
    accountType: string | undefined;
    accountCurrency: string | undefined;
    transactionCode: string | undefined;
    transactionDescription: string | undefined;
    transactionDescription2: string | undefined;
    transactionDescription3: string | undefined;
    transactionDescription4: string | undefined;
    projectInvoiceId: string | undefined;
    projectInvoice: Bill;
    creditNoteInvoiceId: string | undefined;
    creditNoteInvoice: Bill;
    currency: string | undefined;
    exchangeRate: number;
}

export class CashbooksDto implements ICashbooksDto {
    tenantId: number;
    cashbookTypeInt: number;
    paymentType: string | undefined;
    date: moment.Moment | undefined;
    scannedDocumentUrl: string | undefined;
    amount: number;
    details: string | undefined;
    referenceNo: string | undefined;
    billId: string | undefined;
    bill: Bill;
    purchaseRequisitionId: number | undefined;
    purchaseRequisition: PurchaseRequisition;
    disposedNonCurrentAssetItemId: string | undefined;
    disposedNonCurrentAssetItem: NonCurrentAssetItem;
    accountCharged: string | undefined;
    receivedBy: string | undefined;
    requestedBy: string | undefined;
    bankName: string | undefined;
    bankAccount: string | undefined;
    bankAccountHolder: string | undefined;
    isPaymentCompleted: boolean;
    billDto: BillDto;
    name: string | undefined;
    type: string | undefined;
    approvalStatusInt: number;
    approvedUserId: number | undefined;
    approveRemarks: string | undefined;
    approvedDate: moment.Moment | undefined;
    cashbookId: number;
    purchaseRequisitionDto: PurchaseRequisitionDto;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    reversalApprovalInt: number;
    reversalRequesterName: string | undefined;
    reversalRemark: string | undefined;
    reversalRequestDate: moment.Moment;
    reversalApprovedDate: moment.Moment;
    reversalApproverName: string | undefined;
    projectId: number;
    projectType: string | undefined;
    paidTo: string | undefined;
    owedTo: string | undefined;
    accountType: string | undefined;
    accountCurrency: string | undefined;
    transactionCode: string | undefined;
    transactionDescription: string | undefined;
    transactionDescription2: string | undefined;
    transactionDescription3: string | undefined;
    transactionDescription4: string | undefined;
    isNewMigration: boolean;
    dataCheck: boolean;
    endBalance: number;
    projectInvoiceId: string | undefined;
    projectInvoice: Bill;
    creditNoteInvoiceId: string | undefined;
    creditNoteInvoice: Bill;
    currency: string | undefined;
    exchangeRate: number;

    constructor(data?: ICashbooksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.cashbookTypeInt = _data["cashbookTypeInt"];
            this.paymentType = _data["paymentType"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.scannedDocumentUrl = _data["scannedDocumentUrl"];
            this.amount = _data["amount"];
            this.details = _data["details"];
            this.referenceNo = _data["referenceNo"];
            this.billId = _data["billId"];
            this.bill = _data["bill"] ? Bill.fromJS(_data["bill"]) : <any>undefined;
            this.purchaseRequisitionId = _data["purchaseRequisitionId"];
            this.purchaseRequisition = _data["purchaseRequisition"] ? PurchaseRequisition.fromJS(_data["purchaseRequisition"]) : <any>undefined;
            this.disposedNonCurrentAssetItemId = _data["disposedNonCurrentAssetItemId"];
            this.disposedNonCurrentAssetItem = _data["disposedNonCurrentAssetItem"] ? NonCurrentAssetItem.fromJS(_data["disposedNonCurrentAssetItem"]) : <any>undefined;
            this.accountCharged = _data["accountCharged"];
            this.receivedBy = _data["receivedBy"];
            this.requestedBy = _data["requestedBy"];
            this.bankName = _data["bankName"];
            this.bankAccount = _data["bankAccount"];
            this.bankAccountHolder = _data["bankAccountHolder"];
            this.isPaymentCompleted = _data["isPaymentCompleted"];
            this.billDto = _data["billDto"] ? BillDto.fromJS(_data["billDto"]) : <any>undefined;
            this.name = _data["name"];
            this.type = _data["type"];
            this.approvalStatusInt = _data["approvalStatusInt"];
            this.approvedUserId = _data["approvedUserId"];
            this.approveRemarks = _data["approveRemarks"];
            this.approvedDate = _data["approvedDate"] ? moment(_data["approvedDate"].toString()) : <any>undefined;
            this.cashbookId = _data["cashbookId"];
            this.purchaseRequisitionDto = _data["purchaseRequisitionDto"] ? PurchaseRequisitionDto.fromJS(_data["purchaseRequisitionDto"]) : <any>undefined;
            this.categoryCode = _data["categoryCode"];
            this.categoryName = _data["categoryName"];
            this.reversalApprovalInt = _data["reversalApprovalInt"];
            this.reversalRequesterName = _data["reversalRequesterName"];
            this.reversalRemark = _data["reversalRemark"];
            this.reversalRequestDate = _data["reversalRequestDate"] ? moment(_data["reversalRequestDate"].toString()) : <any>undefined;
            this.reversalApprovedDate = _data["reversalApprovedDate"] ? moment(_data["reversalApprovedDate"].toString()) : <any>undefined;
            this.reversalApproverName = _data["reversalApproverName"];
            this.projectId = _data["projectId"];
            this.projectType = _data["projectType"];
            this.paidTo = _data["paidTo"];
            this.owedTo = _data["owedTo"];
            this.accountType = _data["accountType"];
            this.accountCurrency = _data["accountCurrency"];
            this.transactionCode = _data["transactionCode"];
            this.transactionDescription = _data["transactionDescription"];
            this.transactionDescription2 = _data["transactionDescription2"];
            this.transactionDescription3 = _data["transactionDescription3"];
            this.transactionDescription4 = _data["transactionDescription4"];
            this.isNewMigration = _data["isNewMigration"];
            this.dataCheck = _data["dataCheck"];
            this.endBalance = _data["endBalance"];
            this.projectInvoiceId = _data["projectInvoiceId"];
            this.projectInvoice = _data["projectInvoice"] ? Bill.fromJS(_data["projectInvoice"]) : <any>undefined;
            this.creditNoteInvoiceId = _data["creditNoteInvoiceId"];
            this.creditNoteInvoice = _data["creditNoteInvoice"] ? Bill.fromJS(_data["creditNoteInvoice"]) : <any>undefined;
            this.currency = _data["currency"];
            this.exchangeRate = _data["exchangeRate"];
        }
    }

    static fromJS(data: any): CashbooksDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashbooksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["cashbookTypeInt"] = this.cashbookTypeInt;
        data["paymentType"] = this.paymentType;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["scannedDocumentUrl"] = this.scannedDocumentUrl;
        data["amount"] = this.amount;
        data["details"] = this.details;
        data["referenceNo"] = this.referenceNo;
        data["billId"] = this.billId;
        data["bill"] = this.bill ? this.bill.toJSON() : <any>undefined;
        data["purchaseRequisitionId"] = this.purchaseRequisitionId;
        data["purchaseRequisition"] = this.purchaseRequisition ? this.purchaseRequisition.toJSON() : <any>undefined;
        data["disposedNonCurrentAssetItemId"] = this.disposedNonCurrentAssetItemId;
        data["disposedNonCurrentAssetItem"] = this.disposedNonCurrentAssetItem ? this.disposedNonCurrentAssetItem.toJSON() : <any>undefined;
        data["accountCharged"] = this.accountCharged;
        data["receivedBy"] = this.receivedBy;
        data["requestedBy"] = this.requestedBy;
        data["bankName"] = this.bankName;
        data["bankAccount"] = this.bankAccount;
        data["bankAccountHolder"] = this.bankAccountHolder;
        data["isPaymentCompleted"] = this.isPaymentCompleted;
        data["billDto"] = this.billDto ? this.billDto.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["type"] = this.type;
        data["approvalStatusInt"] = this.approvalStatusInt;
        data["approvedUserId"] = this.approvedUserId;
        data["approveRemarks"] = this.approveRemarks;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["cashbookId"] = this.cashbookId;
        data["purchaseRequisitionDto"] = this.purchaseRequisitionDto ? this.purchaseRequisitionDto.toJSON() : <any>undefined;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["reversalApprovalInt"] = this.reversalApprovalInt;
        data["reversalRequesterName"] = this.reversalRequesterName;
        data["reversalRemark"] = this.reversalRemark;
        data["reversalRequestDate"] = this.reversalRequestDate ? this.reversalRequestDate.toISOString() : <any>undefined;
        data["reversalApprovedDate"] = this.reversalApprovedDate ? this.reversalApprovedDate.toISOString() : <any>undefined;
        data["reversalApproverName"] = this.reversalApproverName;
        data["projectId"] = this.projectId;
        data["projectType"] = this.projectType;
        data["paidTo"] = this.paidTo;
        data["owedTo"] = this.owedTo;
        data["accountType"] = this.accountType;
        data["accountCurrency"] = this.accountCurrency;
        data["transactionCode"] = this.transactionCode;
        data["transactionDescription"] = this.transactionDescription;
        data["transactionDescription2"] = this.transactionDescription2;
        data["transactionDescription3"] = this.transactionDescription3;
        data["transactionDescription4"] = this.transactionDescription4;
        data["isNewMigration"] = this.isNewMigration;
        data["dataCheck"] = this.dataCheck;
        data["endBalance"] = this.endBalance;
        data["projectInvoiceId"] = this.projectInvoiceId;
        data["projectInvoice"] = this.projectInvoice ? this.projectInvoice.toJSON() : <any>undefined;
        data["creditNoteInvoiceId"] = this.creditNoteInvoiceId;
        data["creditNoteInvoice"] = this.creditNoteInvoice ? this.creditNoteInvoice.toJSON() : <any>undefined;
        data["currency"] = this.currency;
        data["exchangeRate"] = this.exchangeRate;
        return data;
    }

    clone(): CashbooksDto {
        const json = this.toJSON();
        let result = new CashbooksDto();
        result.init(json);
        return result;
    }
}

export interface ICashbooksDto {
    tenantId: number;
    cashbookTypeInt: number;
    paymentType: string | undefined;
    date: moment.Moment | undefined;
    scannedDocumentUrl: string | undefined;
    amount: number;
    details: string | undefined;
    referenceNo: string | undefined;
    billId: string | undefined;
    bill: Bill;
    purchaseRequisitionId: number | undefined;
    purchaseRequisition: PurchaseRequisition;
    disposedNonCurrentAssetItemId: string | undefined;
    disposedNonCurrentAssetItem: NonCurrentAssetItem;
    accountCharged: string | undefined;
    receivedBy: string | undefined;
    requestedBy: string | undefined;
    bankName: string | undefined;
    bankAccount: string | undefined;
    bankAccountHolder: string | undefined;
    isPaymentCompleted: boolean;
    billDto: BillDto;
    name: string | undefined;
    type: string | undefined;
    approvalStatusInt: number;
    approvedUserId: number | undefined;
    approveRemarks: string | undefined;
    approvedDate: moment.Moment | undefined;
    cashbookId: number;
    purchaseRequisitionDto: PurchaseRequisitionDto;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    reversalApprovalInt: number;
    reversalRequesterName: string | undefined;
    reversalRemark: string | undefined;
    reversalRequestDate: moment.Moment;
    reversalApprovedDate: moment.Moment;
    reversalApproverName: string | undefined;
    projectId: number;
    projectType: string | undefined;
    paidTo: string | undefined;
    owedTo: string | undefined;
    accountType: string | undefined;
    accountCurrency: string | undefined;
    transactionCode: string | undefined;
    transactionDescription: string | undefined;
    transactionDescription2: string | undefined;
    transactionDescription3: string | undefined;
    transactionDescription4: string | undefined;
    isNewMigration: boolean;
    dataCheck: boolean;
    endBalance: number;
    projectInvoiceId: string | undefined;
    projectInvoice: Bill;
    creditNoteInvoiceId: string | undefined;
    creditNoteInvoice: Bill;
    currency: string | undefined;
    exchangeRate: number;
}

export class CashbooksDtoPagedResultDto implements ICashbooksDtoPagedResultDto {
    items: CashbooksDto[] | undefined;
    totalCount: number;

    constructor(data?: ICashbooksDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CashbooksDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CashbooksDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashbooksDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CashbooksDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CashbooksDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICashbooksDtoPagedResultDto {
    items: CashbooksDto[] | undefined;
    totalCount: number;
}

export class CashbooksPagedResultDto implements ICashbooksPagedResultDto {
    items: Cashbooks[] | undefined;
    totalCount: number;

    constructor(data?: ICashbooksPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(Cashbooks.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CashbooksPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashbooksPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CashbooksPagedResultDto {
        const json = this.toJSON();
        let result = new CashbooksPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICashbooksPagedResultDto {
    items: Cashbooks[] | undefined;
    totalCount: number;
}

export class Category implements ICategory {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    hasSubCategory: boolean;
    parentId: number;

    constructor(data?: ICategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.hasSubCategory = _data["hasSubCategory"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): Category {
        data = typeof data === 'object' ? data : {};
        let result = new Category();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["hasSubCategory"] = this.hasSubCategory;
        data["parentId"] = this.parentId;
        return data;
    }

    clone(): Category {
        const json = this.toJSON();
        let result = new Category();
        result.init(json);
        return result;
    }
}

export interface ICategory {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    hasSubCategory: boolean;
    parentId: number;
}

export class CategoryDto implements ICategoryDto {
    name: string | undefined;
    hasSubCategory: boolean;
    parentId: number;

    constructor(data?: ICategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.hasSubCategory = _data["hasSubCategory"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): CategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["hasSubCategory"] = this.hasSubCategory;
        data["parentId"] = this.parentId;
        return data;
    }

    clone(): CategoryDto {
        const json = this.toJSON();
        let result = new CategoryDto();
        result.init(json);
        return result;
    }
}

export interface ICategoryDto {
    name: string | undefined;
    hasSubCategory: boolean;
    parentId: number;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword: string;
    newPassword: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data;
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class ChartDto implements IChartDto {
    paidInvoices: Bill[] | undefined;
    unpaidInvoices: Bill[] | undefined;
    productsSold: BillItemDto[] | undefined;
    allInvoices: Bill[] | undefined;
    totalDeliveryCharge: number;
    totalDisburesement: number;
    totalReimbursement: number;

    constructor(data?: IChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["paidInvoices"])) {
                this.paidInvoices = [] as any;
                for (let item of _data["paidInvoices"])
                    this.paidInvoices.push(Bill.fromJS(item));
            }
            if (Array.isArray(_data["unpaidInvoices"])) {
                this.unpaidInvoices = [] as any;
                for (let item of _data["unpaidInvoices"])
                    this.unpaidInvoices.push(Bill.fromJS(item));
            }
            if (Array.isArray(_data["productsSold"])) {
                this.productsSold = [] as any;
                for (let item of _data["productsSold"])
                    this.productsSold.push(BillItemDto.fromJS(item));
            }
            if (Array.isArray(_data["allInvoices"])) {
                this.allInvoices = [] as any;
                for (let item of _data["allInvoices"])
                    this.allInvoices.push(Bill.fromJS(item));
            }
            this.totalDeliveryCharge = _data["totalDeliveryCharge"];
            this.totalDisburesement = _data["totalDisburesement"];
            this.totalReimbursement = _data["totalReimbursement"];
        }
    }

    static fromJS(data: any): ChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.paidInvoices)) {
            data["paidInvoices"] = [];
            for (let item of this.paidInvoices)
                data["paidInvoices"].push(item.toJSON());
        }
        if (Array.isArray(this.unpaidInvoices)) {
            data["unpaidInvoices"] = [];
            for (let item of this.unpaidInvoices)
                data["unpaidInvoices"].push(item.toJSON());
        }
        if (Array.isArray(this.productsSold)) {
            data["productsSold"] = [];
            for (let item of this.productsSold)
                data["productsSold"].push(item.toJSON());
        }
        if (Array.isArray(this.allInvoices)) {
            data["allInvoices"] = [];
            for (let item of this.allInvoices)
                data["allInvoices"].push(item.toJSON());
        }
        data["totalDeliveryCharge"] = this.totalDeliveryCharge;
        data["totalDisburesement"] = this.totalDisburesement;
        data["totalReimbursement"] = this.totalReimbursement;
        return data;
    }

    clone(): ChartDto {
        const json = this.toJSON();
        let result = new ChartDto();
        result.init(json);
        return result;
    }
}

export interface IChartDto {
    paidInvoices: Bill[] | undefined;
    unpaidInvoices: Bill[] | undefined;
    productsSold: BillItemDto[] | undefined;
    allInvoices: Bill[] | undefined;
    totalDeliveryCharge: number;
    totalDisburesement: number;
    totalReimbursement: number;
}

export class CheckrateReponseDto implements ICheckrateReponseDto {
    api_status: string | undefined;
    error_code: string | undefined;
    error_remark: string | undefined;
    result: Result[] | undefined;

    constructor(data?: ICheckrateReponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.api_status = _data["api_status"];
            this.error_code = _data["error_code"];
            this.error_remark = _data["error_remark"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(Result.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CheckrateReponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckrateReponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["api_status"] = this.api_status;
        data["error_code"] = this.error_code;
        data["error_remark"] = this.error_remark;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        return data;
    }

    clone(): CheckrateReponseDto {
        const json = this.toJSON();
        let result = new CheckrateReponseDto();
        result.init(json);
        return result;
    }
}

export interface ICheckrateReponseDto {
    api_status: string | undefined;
    error_code: string | undefined;
    error_remark: string | undefined;
    result: Result[] | undefined;
}

export class CompanyModel implements ICompanyModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    logo: string | undefined;
    companyName: string;
    email: string;
    web: string;
    phone: string;
    currency: string;
    address: string;
    tenantId: number;

    constructor(data?: ICompanyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.logo = _data["logo"];
            this.companyName = _data["companyName"];
            this.email = _data["email"];
            this.web = _data["web"];
            this.phone = _data["phone"];
            this.currency = _data["currency"];
            this.address = _data["address"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CompanyModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["logo"] = this.logo;
        data["companyName"] = this.companyName;
        data["email"] = this.email;
        data["web"] = this.web;
        data["phone"] = this.phone;
        data["currency"] = this.currency;
        data["address"] = this.address;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): CompanyModel {
        const json = this.toJSON();
        let result = new CompanyModel();
        result.init(json);
        return result;
    }
}

export interface ICompanyModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    logo: string | undefined;
    companyName: string;
    email: string;
    web: string;
    phone: string;
    currency: string;
    address: string;
    tenantId: number;
}

export class CompanyModelDto implements ICompanyModelDto {
    logo: string | undefined;
    companyName: string | undefined;
    email: string | undefined;
    web: string | undefined;
    phone: string | undefined;
    currency: string | undefined;
    address: string | undefined;
    tenantId: number;

    constructor(data?: ICompanyModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logo = _data["logo"];
            this.companyName = _data["companyName"];
            this.email = _data["email"];
            this.web = _data["web"];
            this.phone = _data["phone"];
            this.currency = _data["currency"];
            this.address = _data["address"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CompanyModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logo"] = this.logo;
        data["companyName"] = this.companyName;
        data["email"] = this.email;
        data["web"] = this.web;
        data["phone"] = this.phone;
        data["currency"] = this.currency;
        data["address"] = this.address;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): CompanyModelDto {
        const json = this.toJSON();
        let result = new CompanyModelDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyModelDto {
    logo: string | undefined;
    companyName: string | undefined;
    email: string | undefined;
    web: string | undefined;
    phone: string | undefined;
    currency: string | undefined;
    address: string | undefined;
    tenantId: number;
}

export class CompanyModelPagedResultDto implements ICompanyModelPagedResultDto {
    items: CompanyModel[] | undefined;
    totalCount: number;

    constructor(data?: ICompanyModelPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CompanyModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CompanyModelPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyModelPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CompanyModelPagedResultDto {
        const json = this.toJSON();
        let result = new CompanyModelPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyModelPagedResultDto {
    items: CompanyModel[] | undefined;
    totalCount: number;
}

export class CompanyProfile implements ICompanyProfile {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    companyRegNo: string;
    companyName: string;
    contactNo: string;
    email: string | undefined;
    address1: string | undefined;
    address2: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    pAddress1: string | undefined;
    pAddress2: string | undefined;
    pPostCode: string | undefined;
    pCity: string | undefined;
    pState: string | undefined;
    pCountry: string | undefined;
    tenantId: number;
    tenant: Tenant;
    accountFullName: string | undefined;
    accountEmailAddress: string | undefined;
    accountPassword: string | undefined;
    businessCompanyRegNo: string | undefined;
    businessAddress: string | undefined;
    bnmCode: string | undefined;
    picName: string | undefined;
    picPosition: string | undefined;
    picEmailAddress: string | undefined;
    picPhoneNumber: string | undefined;
    companyLogo: string | undefined;
    bankName: string | undefined;
    bankAccountHolder: string | undefined;
    bankAccountNo: string | undefined;
    invoiceTemplate: number;
    brandingColor: string | undefined;
    invoiceMessage: string | undefined;
    invoiceTnC: string | undefined;
    remarkMessage: string | undefined;
    revenue: string | undefined;
    numberOfEmployees: number;
    tutorialCompleted: boolean;
    dayDueReminder: number;
    billplzEmail: string | undefined;
    billplzPhone: string | undefined;
    billplzPassword: string | undefined;
    billplzStatusId: number;
    billplzCollectionId: string | undefined;
    billplzSecretKey: string | undefined;
    invoiceApproval: boolean;
    requisitionApproval: boolean;
    customerApproval: boolean;
    productApproval: boolean;
    mainBannerUrl: string | undefined;
    mainBannerTitle: string | undefined;
    mainBannerDescription: string | undefined;
    lastActive: moment.Moment;
    hideFromMarketplace: boolean;
    websiteLink: string | undefined;
    facebookLink: string | undefined;
    youtubeLink: string | undefined;
    whatsappLink: string | undefined;
    secondaryBankName: string | undefined;
    secondaryBankAccountHolder: string | undefined;
    secondaryBankAccountNo: string | undefined;
    secondaryBannerUrl: string | undefined;
    secondaryBannerTitle: string | undefined;
    secondaryBannerDescription: string | undefined;
    isScfOnboarded: boolean;
    scfTenancyName: string | undefined;
    scfTenantId: number;
    scfEmail: string | undefined;
    scfPassword: string | undefined;
    scfApplicationStatus: number;
    scfSupplierId: number;
    purchaseOrderMessage: string | undefined;
    quotationMessage: string | undefined;
    poDeliveryDueReminder: number;
    requisitionApproverDepartmentId: number | undefined;
    typeOfCompany: string | undefined;
    coreActivityDescription: string | undefined;
    isHideBankFromInvoice: boolean;
    totalSmsSent: number;
    aiOnboardingStatus: string | undefined;
    facebookURL: string | undefined;
    instagramURL: string | undefined;
    postFacebook: boolean;
    postInstagram: boolean;
    postTwitter: boolean;
    postLinkedin: boolean;
    postOthers: string | undefined;
    forBrandAwareness: boolean;
    forLeadGeneration: boolean;
    forEngagement: boolean;
    forCustomerSupport: boolean;
    forSales: boolean;
    professionalTone: boolean;
    casualTone: boolean;
    informativeTone: boolean;
    funTone: boolean;
    inspirationalTone: boolean;
    targetAudience: string | undefined;
    imageContent: boolean;
    videoContent: boolean;
    blogContent: boolean;
    infographicContent: boolean;
    podcastContent: boolean;
    webinarContent: boolean;
    topicsToCover: string | undefined;
    topicsToAvoid: string | undefined;
    productsToPromote: string | undefined;
    keyMessages: string | undefined;
    guideLines: string | undefined;
    postWeekday: boolean;
    postWeekend: boolean;
    postMorning: boolean;
    postAfternoon: boolean;
    postEvening: boolean;
    significantDates: string | undefined;
    postFrequency: string | undefined;
    numberOfWords: string | undefined;
    marketingRefence: string | undefined;
    exampleLink: string | undefined;
    extraInfo: string | undefined;
    fs1Url: string | undefined;
    fs2Url: string | undefined;
    fs3Url: string | undefined;
    fs4Url: string | undefined;
    currency: string | undefined;
    taxIdentificationNumber: string | undefined;
    requisitionApproverDepartment: Department;
    producerTenantId: number;
    overheadAllocation: number;
    financialYearOffset: number;
    financialYearStartDay: number;
    financialYearStartMonth: number;
    purchasedPos: boolean;
    sharesIssued: number;

    constructor(data?: ICompanyProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.companyRegNo = _data["companyRegNo"];
            this.companyName = _data["companyName"];
            this.contactNo = _data["contactNo"];
            this.email = _data["email"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.pAddress1 = _data["pAddress1"];
            this.pAddress2 = _data["pAddress2"];
            this.pPostCode = _data["pPostCode"];
            this.pCity = _data["pCity"];
            this.pState = _data["pState"];
            this.pCountry = _data["pCountry"];
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.accountFullName = _data["accountFullName"];
            this.accountEmailAddress = _data["accountEmailAddress"];
            this.accountPassword = _data["accountPassword"];
            this.businessCompanyRegNo = _data["businessCompanyRegNo"];
            this.businessAddress = _data["businessAddress"];
            this.bnmCode = _data["bnmCode"];
            this.picName = _data["picName"];
            this.picPosition = _data["picPosition"];
            this.picEmailAddress = _data["picEmailAddress"];
            this.picPhoneNumber = _data["picPhoneNumber"];
            this.companyLogo = _data["companyLogo"];
            this.bankName = _data["bankName"];
            this.bankAccountHolder = _data["bankAccountHolder"];
            this.bankAccountNo = _data["bankAccountNo"];
            this.invoiceTemplate = _data["invoiceTemplate"];
            this.brandingColor = _data["brandingColor"];
            this.invoiceMessage = _data["invoiceMessage"];
            this.invoiceTnC = _data["invoiceTnC"];
            this.remarkMessage = _data["remarkMessage"];
            this.revenue = _data["revenue"];
            this.numberOfEmployees = _data["numberOfEmployees"];
            this.tutorialCompleted = _data["tutorialCompleted"];
            this.dayDueReminder = _data["dayDueReminder"];
            this.billplzEmail = _data["billplzEmail"];
            this.billplzPhone = _data["billplzPhone"];
            this.billplzPassword = _data["billplzPassword"];
            this.billplzStatusId = _data["billplzStatusId"];
            this.billplzCollectionId = _data["billplzCollectionId"];
            this.billplzSecretKey = _data["billplzSecretKey"];
            this.invoiceApproval = _data["invoiceApproval"];
            this.requisitionApproval = _data["requisitionApproval"];
            this.customerApproval = _data["customerApproval"];
            this.productApproval = _data["productApproval"];
            this.mainBannerUrl = _data["mainBannerUrl"];
            this.mainBannerTitle = _data["mainBannerTitle"];
            this.mainBannerDescription = _data["mainBannerDescription"];
            this.lastActive = _data["lastActive"] ? moment(_data["lastActive"].toString()) : <any>undefined;
            this.hideFromMarketplace = _data["hideFromMarketplace"];
            this.websiteLink = _data["websiteLink"];
            this.facebookLink = _data["facebookLink"];
            this.youtubeLink = _data["youtubeLink"];
            this.whatsappLink = _data["whatsappLink"];
            this.secondaryBankName = _data["secondaryBankName"];
            this.secondaryBankAccountHolder = _data["secondaryBankAccountHolder"];
            this.secondaryBankAccountNo = _data["secondaryBankAccountNo"];
            this.secondaryBannerUrl = _data["secondaryBannerUrl"];
            this.secondaryBannerTitle = _data["secondaryBannerTitle"];
            this.secondaryBannerDescription = _data["secondaryBannerDescription"];
            this.isScfOnboarded = _data["isScfOnboarded"];
            this.scfTenancyName = _data["scfTenancyName"];
            this.scfTenantId = _data["scfTenantId"];
            this.scfEmail = _data["scfEmail"];
            this.scfPassword = _data["scfPassword"];
            this.scfApplicationStatus = _data["scfApplicationStatus"];
            this.scfSupplierId = _data["scfSupplierId"];
            this.purchaseOrderMessage = _data["purchaseOrderMessage"];
            this.quotationMessage = _data["quotationMessage"];
            this.poDeliveryDueReminder = _data["poDeliveryDueReminder"];
            this.requisitionApproverDepartmentId = _data["requisitionApproverDepartmentId"];
            this.typeOfCompany = _data["typeOfCompany"];
            this.coreActivityDescription = _data["coreActivityDescription"];
            this.isHideBankFromInvoice = _data["isHideBankFromInvoice"];
            this.totalSmsSent = _data["totalSmsSent"];
            this.aiOnboardingStatus = _data["aiOnboardingStatus"];
            this.facebookURL = _data["facebookURL"];
            this.instagramURL = _data["instagramURL"];
            this.postFacebook = _data["postFacebook"];
            this.postInstagram = _data["postInstagram"];
            this.postTwitter = _data["postTwitter"];
            this.postLinkedin = _data["postLinkedin"];
            this.postOthers = _data["postOthers"];
            this.forBrandAwareness = _data["forBrandAwareness"];
            this.forLeadGeneration = _data["forLeadGeneration"];
            this.forEngagement = _data["forEngagement"];
            this.forCustomerSupport = _data["forCustomerSupport"];
            this.forSales = _data["forSales"];
            this.professionalTone = _data["professionalTone"];
            this.casualTone = _data["casualTone"];
            this.informativeTone = _data["informativeTone"];
            this.funTone = _data["funTone"];
            this.inspirationalTone = _data["inspirationalTone"];
            this.targetAudience = _data["targetAudience"];
            this.imageContent = _data["imageContent"];
            this.videoContent = _data["videoContent"];
            this.blogContent = _data["blogContent"];
            this.infographicContent = _data["infographicContent"];
            this.podcastContent = _data["podcastContent"];
            this.webinarContent = _data["webinarContent"];
            this.topicsToCover = _data["topicsToCover"];
            this.topicsToAvoid = _data["topicsToAvoid"];
            this.productsToPromote = _data["productsToPromote"];
            this.keyMessages = _data["keyMessages"];
            this.guideLines = _data["guideLines"];
            this.postWeekday = _data["postWeekday"];
            this.postWeekend = _data["postWeekend"];
            this.postMorning = _data["postMorning"];
            this.postAfternoon = _data["postAfternoon"];
            this.postEvening = _data["postEvening"];
            this.significantDates = _data["significantDates"];
            this.postFrequency = _data["postFrequency"];
            this.numberOfWords = _data["numberOfWords"];
            this.marketingRefence = _data["marketingRefence"];
            this.exampleLink = _data["exampleLink"];
            this.extraInfo = _data["extraInfo"];
            this.fs1Url = _data["fs1Url"];
            this.fs2Url = _data["fs2Url"];
            this.fs3Url = _data["fs3Url"];
            this.fs4Url = _data["fs4Url"];
            this.currency = _data["currency"];
            this.taxIdentificationNumber = _data["taxIdentificationNumber"];
            this.requisitionApproverDepartment = _data["requisitionApproverDepartment"] ? Department.fromJS(_data["requisitionApproverDepartment"]) : <any>undefined;
            this.producerTenantId = _data["producerTenantId"];
            this.overheadAllocation = _data["overheadAllocation"];
            this.financialYearOffset = _data["financialYearOffset"];
            this.financialYearStartDay = _data["financialYearStartDay"];
            this.financialYearStartMonth = _data["financialYearStartMonth"];
            this.purchasedPos = _data["purchasedPos"];
            this.sharesIssued = _data["sharesIssued"];
        }
    }

    static fromJS(data: any): CompanyProfile {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["companyRegNo"] = this.companyRegNo;
        data["companyName"] = this.companyName;
        data["contactNo"] = this.contactNo;
        data["email"] = this.email;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["pAddress1"] = this.pAddress1;
        data["pAddress2"] = this.pAddress2;
        data["pPostCode"] = this.pPostCode;
        data["pCity"] = this.pCity;
        data["pState"] = this.pState;
        data["pCountry"] = this.pCountry;
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["accountFullName"] = this.accountFullName;
        data["accountEmailAddress"] = this.accountEmailAddress;
        data["accountPassword"] = this.accountPassword;
        data["businessCompanyRegNo"] = this.businessCompanyRegNo;
        data["businessAddress"] = this.businessAddress;
        data["bnmCode"] = this.bnmCode;
        data["picName"] = this.picName;
        data["picPosition"] = this.picPosition;
        data["picEmailAddress"] = this.picEmailAddress;
        data["picPhoneNumber"] = this.picPhoneNumber;
        data["companyLogo"] = this.companyLogo;
        data["bankName"] = this.bankName;
        data["bankAccountHolder"] = this.bankAccountHolder;
        data["bankAccountNo"] = this.bankAccountNo;
        data["invoiceTemplate"] = this.invoiceTemplate;
        data["brandingColor"] = this.brandingColor;
        data["invoiceMessage"] = this.invoiceMessage;
        data["invoiceTnC"] = this.invoiceTnC;
        data["remarkMessage"] = this.remarkMessage;
        data["revenue"] = this.revenue;
        data["numberOfEmployees"] = this.numberOfEmployees;
        data["tutorialCompleted"] = this.tutorialCompleted;
        data["dayDueReminder"] = this.dayDueReminder;
        data["billplzEmail"] = this.billplzEmail;
        data["billplzPhone"] = this.billplzPhone;
        data["billplzPassword"] = this.billplzPassword;
        data["billplzStatusId"] = this.billplzStatusId;
        data["billplzCollectionId"] = this.billplzCollectionId;
        data["billplzSecretKey"] = this.billplzSecretKey;
        data["invoiceApproval"] = this.invoiceApproval;
        data["requisitionApproval"] = this.requisitionApproval;
        data["customerApproval"] = this.customerApproval;
        data["productApproval"] = this.productApproval;
        data["mainBannerUrl"] = this.mainBannerUrl;
        data["mainBannerTitle"] = this.mainBannerTitle;
        data["mainBannerDescription"] = this.mainBannerDescription;
        data["lastActive"] = this.lastActive ? this.lastActive.toISOString() : <any>undefined;
        data["hideFromMarketplace"] = this.hideFromMarketplace;
        data["websiteLink"] = this.websiteLink;
        data["facebookLink"] = this.facebookLink;
        data["youtubeLink"] = this.youtubeLink;
        data["whatsappLink"] = this.whatsappLink;
        data["secondaryBankName"] = this.secondaryBankName;
        data["secondaryBankAccountHolder"] = this.secondaryBankAccountHolder;
        data["secondaryBankAccountNo"] = this.secondaryBankAccountNo;
        data["secondaryBannerUrl"] = this.secondaryBannerUrl;
        data["secondaryBannerTitle"] = this.secondaryBannerTitle;
        data["secondaryBannerDescription"] = this.secondaryBannerDescription;
        data["isScfOnboarded"] = this.isScfOnboarded;
        data["scfTenancyName"] = this.scfTenancyName;
        data["scfTenantId"] = this.scfTenantId;
        data["scfEmail"] = this.scfEmail;
        data["scfPassword"] = this.scfPassword;
        data["scfApplicationStatus"] = this.scfApplicationStatus;
        data["scfSupplierId"] = this.scfSupplierId;
        data["purchaseOrderMessage"] = this.purchaseOrderMessage;
        data["quotationMessage"] = this.quotationMessage;
        data["poDeliveryDueReminder"] = this.poDeliveryDueReminder;
        data["requisitionApproverDepartmentId"] = this.requisitionApproverDepartmentId;
        data["typeOfCompany"] = this.typeOfCompany;
        data["coreActivityDescription"] = this.coreActivityDescription;
        data["isHideBankFromInvoice"] = this.isHideBankFromInvoice;
        data["totalSmsSent"] = this.totalSmsSent;
        data["aiOnboardingStatus"] = this.aiOnboardingStatus;
        data["facebookURL"] = this.facebookURL;
        data["instagramURL"] = this.instagramURL;
        data["postFacebook"] = this.postFacebook;
        data["postInstagram"] = this.postInstagram;
        data["postTwitter"] = this.postTwitter;
        data["postLinkedin"] = this.postLinkedin;
        data["postOthers"] = this.postOthers;
        data["forBrandAwareness"] = this.forBrandAwareness;
        data["forLeadGeneration"] = this.forLeadGeneration;
        data["forEngagement"] = this.forEngagement;
        data["forCustomerSupport"] = this.forCustomerSupport;
        data["forSales"] = this.forSales;
        data["professionalTone"] = this.professionalTone;
        data["casualTone"] = this.casualTone;
        data["informativeTone"] = this.informativeTone;
        data["funTone"] = this.funTone;
        data["inspirationalTone"] = this.inspirationalTone;
        data["targetAudience"] = this.targetAudience;
        data["imageContent"] = this.imageContent;
        data["videoContent"] = this.videoContent;
        data["blogContent"] = this.blogContent;
        data["infographicContent"] = this.infographicContent;
        data["podcastContent"] = this.podcastContent;
        data["webinarContent"] = this.webinarContent;
        data["topicsToCover"] = this.topicsToCover;
        data["topicsToAvoid"] = this.topicsToAvoid;
        data["productsToPromote"] = this.productsToPromote;
        data["keyMessages"] = this.keyMessages;
        data["guideLines"] = this.guideLines;
        data["postWeekday"] = this.postWeekday;
        data["postWeekend"] = this.postWeekend;
        data["postMorning"] = this.postMorning;
        data["postAfternoon"] = this.postAfternoon;
        data["postEvening"] = this.postEvening;
        data["significantDates"] = this.significantDates;
        data["postFrequency"] = this.postFrequency;
        data["numberOfWords"] = this.numberOfWords;
        data["marketingRefence"] = this.marketingRefence;
        data["exampleLink"] = this.exampleLink;
        data["extraInfo"] = this.extraInfo;
        data["fs1Url"] = this.fs1Url;
        data["fs2Url"] = this.fs2Url;
        data["fs3Url"] = this.fs3Url;
        data["fs4Url"] = this.fs4Url;
        data["currency"] = this.currency;
        data["taxIdentificationNumber"] = this.taxIdentificationNumber;
        data["requisitionApproverDepartment"] = this.requisitionApproverDepartment ? this.requisitionApproverDepartment.toJSON() : <any>undefined;
        data["producerTenantId"] = this.producerTenantId;
        data["overheadAllocation"] = this.overheadAllocation;
        data["financialYearOffset"] = this.financialYearOffset;
        data["financialYearStartDay"] = this.financialYearStartDay;
        data["financialYearStartMonth"] = this.financialYearStartMonth;
        data["purchasedPos"] = this.purchasedPos;
        data["sharesIssued"] = this.sharesIssued;
        return data;
    }

    clone(): CompanyProfile {
        const json = this.toJSON();
        let result = new CompanyProfile();
        result.init(json);
        return result;
    }
}

export interface ICompanyProfile {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    companyRegNo: string;
    companyName: string;
    contactNo: string;
    email: string | undefined;
    address1: string | undefined;
    address2: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    pAddress1: string | undefined;
    pAddress2: string | undefined;
    pPostCode: string | undefined;
    pCity: string | undefined;
    pState: string | undefined;
    pCountry: string | undefined;
    tenantId: number;
    tenant: Tenant;
    accountFullName: string | undefined;
    accountEmailAddress: string | undefined;
    accountPassword: string | undefined;
    businessCompanyRegNo: string | undefined;
    businessAddress: string | undefined;
    bnmCode: string | undefined;
    picName: string | undefined;
    picPosition: string | undefined;
    picEmailAddress: string | undefined;
    picPhoneNumber: string | undefined;
    companyLogo: string | undefined;
    bankName: string | undefined;
    bankAccountHolder: string | undefined;
    bankAccountNo: string | undefined;
    invoiceTemplate: number;
    brandingColor: string | undefined;
    invoiceMessage: string | undefined;
    invoiceTnC: string | undefined;
    remarkMessage: string | undefined;
    revenue: string | undefined;
    numberOfEmployees: number;
    tutorialCompleted: boolean;
    dayDueReminder: number;
    billplzEmail: string | undefined;
    billplzPhone: string | undefined;
    billplzPassword: string | undefined;
    billplzStatusId: number;
    billplzCollectionId: string | undefined;
    billplzSecretKey: string | undefined;
    invoiceApproval: boolean;
    requisitionApproval: boolean;
    customerApproval: boolean;
    productApproval: boolean;
    mainBannerUrl: string | undefined;
    mainBannerTitle: string | undefined;
    mainBannerDescription: string | undefined;
    lastActive: moment.Moment;
    hideFromMarketplace: boolean;
    websiteLink: string | undefined;
    facebookLink: string | undefined;
    youtubeLink: string | undefined;
    whatsappLink: string | undefined;
    secondaryBankName: string | undefined;
    secondaryBankAccountHolder: string | undefined;
    secondaryBankAccountNo: string | undefined;
    secondaryBannerUrl: string | undefined;
    secondaryBannerTitle: string | undefined;
    secondaryBannerDescription: string | undefined;
    isScfOnboarded: boolean;
    scfTenancyName: string | undefined;
    scfTenantId: number;
    scfEmail: string | undefined;
    scfPassword: string | undefined;
    scfApplicationStatus: number;
    scfSupplierId: number;
    purchaseOrderMessage: string | undefined;
    quotationMessage: string | undefined;
    poDeliveryDueReminder: number;
    requisitionApproverDepartmentId: number | undefined;
    typeOfCompany: string | undefined;
    coreActivityDescription: string | undefined;
    isHideBankFromInvoice: boolean;
    totalSmsSent: number;
    aiOnboardingStatus: string | undefined;
    facebookURL: string | undefined;
    instagramURL: string | undefined;
    postFacebook: boolean;
    postInstagram: boolean;
    postTwitter: boolean;
    postLinkedin: boolean;
    postOthers: string | undefined;
    forBrandAwareness: boolean;
    forLeadGeneration: boolean;
    forEngagement: boolean;
    forCustomerSupport: boolean;
    forSales: boolean;
    professionalTone: boolean;
    casualTone: boolean;
    informativeTone: boolean;
    funTone: boolean;
    inspirationalTone: boolean;
    targetAudience: string | undefined;
    imageContent: boolean;
    videoContent: boolean;
    blogContent: boolean;
    infographicContent: boolean;
    podcastContent: boolean;
    webinarContent: boolean;
    topicsToCover: string | undefined;
    topicsToAvoid: string | undefined;
    productsToPromote: string | undefined;
    keyMessages: string | undefined;
    guideLines: string | undefined;
    postWeekday: boolean;
    postWeekend: boolean;
    postMorning: boolean;
    postAfternoon: boolean;
    postEvening: boolean;
    significantDates: string | undefined;
    postFrequency: string | undefined;
    numberOfWords: string | undefined;
    marketingRefence: string | undefined;
    exampleLink: string | undefined;
    extraInfo: string | undefined;
    fs1Url: string | undefined;
    fs2Url: string | undefined;
    fs3Url: string | undefined;
    fs4Url: string | undefined;
    currency: string | undefined;
    taxIdentificationNumber: string | undefined;
    requisitionApproverDepartment: Department;
    producerTenantId: number;
    overheadAllocation: number;
    financialYearOffset: number;
    financialYearStartDay: number;
    financialYearStartMonth: number;
    purchasedPos: boolean;
    sharesIssued: number;
}

export class CompanyProfileDto implements ICompanyProfileDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    companyRegNo: string | undefined;
    companyName: string | undefined;
    contactNo: string | undefined;
    email: string | undefined;
    address1: string | undefined;
    address2: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    pAddress1: string | undefined;
    pAddress2: string | undefined;
    pPostCode: string | undefined;
    pCity: string | undefined;
    pState: string | undefined;
    pCountry: string | undefined;
    accountFullName: string | undefined;
    accountEmailAddress: string | undefined;
    accountPassword: string | undefined;
    businessCompanyRegNo: string | undefined;
    businessAddress: string | undefined;
    bnmCode: string | undefined;
    picName: string | undefined;
    picPosition: string | undefined;
    picEmailAddress: string | undefined;
    picPhoneNumber: string | undefined;
    companyLogo: string | undefined;
    bankName: string | undefined;
    bankAccountHolder: string | undefined;
    bankAccountNo: string | undefined;
    invoiceTemplate: number | undefined;
    brandingColor: string | undefined;
    invoiceMessage: string | undefined;
    invoiceTnC: string | undefined;
    remarkMessage: string | undefined;
    revenue: string | undefined;
    numberOfEmployees: number;
    tutorialCompleted: boolean;
    dayDueReminder: number;
    billplzEmail: string | undefined;
    billplzPhone: string | undefined;
    billplzPassword: string | undefined;
    billplzStatusId: number;
    billplzCollectionId: string | undefined;
    billplzSecretKey: string | undefined;
    invoiceApproval: boolean;
    requisitionApproval: boolean;
    customerApproval: boolean;
    productApproval: boolean;
    mainBannerUrl: string | undefined;
    mainBannerTitle: string | undefined;
    mainBannerDescription: string | undefined;
    lastActive: moment.Moment;
    hideFromMarketplace: boolean;
    websiteLink: string | undefined;
    facebookLink: string | undefined;
    youtubeLink: string | undefined;
    whatsappLink: string | undefined;
    secondaryBankName: string | undefined;
    secondaryBankAccountHolder: string | undefined;
    secondaryBankAccountNo: string | undefined;
    secondaryBannerUrl: string | undefined;
    secondaryBannerTitle: string | undefined;
    secondaryBannerDescription: string | undefined;
    isScfOnboarded: boolean;
    scfTenancyName: string | undefined;
    scfTenantId: number;
    scfEmail: string | undefined;
    scfPassword: string | undefined;
    scfApplicationStatus: number;
    scfSupplierId: number;
    purchaseOrderMessage: string | undefined;
    quotationMessage: string | undefined;
    poDeliveryDueReminder: number;
    producerTenantId: number;
    typeOfCompany: string | undefined;
    overheadAllocation: number;
    financialYearOffset: number;
    financialYearStartDay: number;
    financialYearStartMonth: number;
    coreActivityDescription: string | undefined;
    isHideBankFromInvoice: boolean;
    aiOnboardingStatus: string | undefined;
    facebookURL: string | undefined;
    instagramURL: string | undefined;
    postFacebook: boolean;
    postInstagram: boolean;
    postTwitter: boolean;
    postLinkedin: boolean;
    postOthers: string | undefined;
    forBrandAwareness: boolean;
    forLeadGeneration: boolean;
    forEngagement: boolean;
    forCustomerSupport: boolean;
    forSales: boolean;
    professionalTone: boolean;
    casualTone: boolean;
    informativeTone: boolean;
    funTone: boolean;
    inspirationalTone: boolean;
    targetAudience: string | undefined;
    imageContent: boolean;
    videoContent: boolean;
    blogContent: boolean;
    infographicContent: boolean;
    podcastContent: boolean;
    webinarContent: boolean;
    topicsToCover: string | undefined;
    topicsToAvoid: string | undefined;
    productsToPromote: string | undefined;
    keyMessages: string | undefined;
    guideLines: string | undefined;
    postWeekday: boolean;
    postWeekend: boolean;
    postMorning: boolean;
    postAfternoon: boolean;
    postEvening: boolean;
    significantDates: string | undefined;
    postFrequency: string | undefined;
    numberOfWords: string | undefined;
    marketingRefence: string | undefined;
    exampleLink: string | undefined;
    extraInfo: string | undefined;
    totalSmsSent: number;
    purchasedPos: boolean;
    fs1Url: string | undefined;
    fs2Url: string | undefined;
    fs3Url: string | undefined;
    fs4Url: string | undefined;
    currency: string | undefined;
    sharesIssued: number;
    taxIdentificationNumber: string | undefined;

    constructor(data?: ICompanyProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.companyRegNo = _data["companyRegNo"];
            this.companyName = _data["companyName"];
            this.contactNo = _data["contactNo"];
            this.email = _data["email"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.pAddress1 = _data["pAddress1"];
            this.pAddress2 = _data["pAddress2"];
            this.pPostCode = _data["pPostCode"];
            this.pCity = _data["pCity"];
            this.pState = _data["pState"];
            this.pCountry = _data["pCountry"];
            this.accountFullName = _data["accountFullName"];
            this.accountEmailAddress = _data["accountEmailAddress"];
            this.accountPassword = _data["accountPassword"];
            this.businessCompanyRegNo = _data["businessCompanyRegNo"];
            this.businessAddress = _data["businessAddress"];
            this.bnmCode = _data["bnmCode"];
            this.picName = _data["picName"];
            this.picPosition = _data["picPosition"];
            this.picEmailAddress = _data["picEmailAddress"];
            this.picPhoneNumber = _data["picPhoneNumber"];
            this.companyLogo = _data["companyLogo"];
            this.bankName = _data["bankName"];
            this.bankAccountHolder = _data["bankAccountHolder"];
            this.bankAccountNo = _data["bankAccountNo"];
            this.invoiceTemplate = _data["invoiceTemplate"];
            this.brandingColor = _data["brandingColor"];
            this.invoiceMessage = _data["invoiceMessage"];
            this.invoiceTnC = _data["invoiceTnC"];
            this.remarkMessage = _data["remarkMessage"];
            this.revenue = _data["revenue"];
            this.numberOfEmployees = _data["numberOfEmployees"];
            this.tutorialCompleted = _data["tutorialCompleted"];
            this.dayDueReminder = _data["dayDueReminder"];
            this.billplzEmail = _data["billplzEmail"];
            this.billplzPhone = _data["billplzPhone"];
            this.billplzPassword = _data["billplzPassword"];
            this.billplzStatusId = _data["billplzStatusId"];
            this.billplzCollectionId = _data["billplzCollectionId"];
            this.billplzSecretKey = _data["billplzSecretKey"];
            this.invoiceApproval = _data["invoiceApproval"];
            this.requisitionApproval = _data["requisitionApproval"];
            this.customerApproval = _data["customerApproval"];
            this.productApproval = _data["productApproval"];
            this.mainBannerUrl = _data["mainBannerUrl"];
            this.mainBannerTitle = _data["mainBannerTitle"];
            this.mainBannerDescription = _data["mainBannerDescription"];
            this.lastActive = _data["lastActive"] ? moment(_data["lastActive"].toString()) : <any>undefined;
            this.hideFromMarketplace = _data["hideFromMarketplace"];
            this.websiteLink = _data["websiteLink"];
            this.facebookLink = _data["facebookLink"];
            this.youtubeLink = _data["youtubeLink"];
            this.whatsappLink = _data["whatsappLink"];
            this.secondaryBankName = _data["secondaryBankName"];
            this.secondaryBankAccountHolder = _data["secondaryBankAccountHolder"];
            this.secondaryBankAccountNo = _data["secondaryBankAccountNo"];
            this.secondaryBannerUrl = _data["secondaryBannerUrl"];
            this.secondaryBannerTitle = _data["secondaryBannerTitle"];
            this.secondaryBannerDescription = _data["secondaryBannerDescription"];
            this.isScfOnboarded = _data["isScfOnboarded"];
            this.scfTenancyName = _data["scfTenancyName"];
            this.scfTenantId = _data["scfTenantId"];
            this.scfEmail = _data["scfEmail"];
            this.scfPassword = _data["scfPassword"];
            this.scfApplicationStatus = _data["scfApplicationStatus"];
            this.scfSupplierId = _data["scfSupplierId"];
            this.purchaseOrderMessage = _data["purchaseOrderMessage"];
            this.quotationMessage = _data["quotationMessage"];
            this.poDeliveryDueReminder = _data["poDeliveryDueReminder"];
            this.producerTenantId = _data["producerTenantId"];
            this.typeOfCompany = _data["typeOfCompany"];
            this.overheadAllocation = _data["overheadAllocation"];
            this.financialYearOffset = _data["financialYearOffset"];
            this.financialYearStartDay = _data["financialYearStartDay"];
            this.financialYearStartMonth = _data["financialYearStartMonth"];
            this.coreActivityDescription = _data["coreActivityDescription"];
            this.isHideBankFromInvoice = _data["isHideBankFromInvoice"];
            this.aiOnboardingStatus = _data["aiOnboardingStatus"];
            this.facebookURL = _data["facebookURL"];
            this.instagramURL = _data["instagramURL"];
            this.postFacebook = _data["postFacebook"];
            this.postInstagram = _data["postInstagram"];
            this.postTwitter = _data["postTwitter"];
            this.postLinkedin = _data["postLinkedin"];
            this.postOthers = _data["postOthers"];
            this.forBrandAwareness = _data["forBrandAwareness"];
            this.forLeadGeneration = _data["forLeadGeneration"];
            this.forEngagement = _data["forEngagement"];
            this.forCustomerSupport = _data["forCustomerSupport"];
            this.forSales = _data["forSales"];
            this.professionalTone = _data["professionalTone"];
            this.casualTone = _data["casualTone"];
            this.informativeTone = _data["informativeTone"];
            this.funTone = _data["funTone"];
            this.inspirationalTone = _data["inspirationalTone"];
            this.targetAudience = _data["targetAudience"];
            this.imageContent = _data["imageContent"];
            this.videoContent = _data["videoContent"];
            this.blogContent = _data["blogContent"];
            this.infographicContent = _data["infographicContent"];
            this.podcastContent = _data["podcastContent"];
            this.webinarContent = _data["webinarContent"];
            this.topicsToCover = _data["topicsToCover"];
            this.topicsToAvoid = _data["topicsToAvoid"];
            this.productsToPromote = _data["productsToPromote"];
            this.keyMessages = _data["keyMessages"];
            this.guideLines = _data["guideLines"];
            this.postWeekday = _data["postWeekday"];
            this.postWeekend = _data["postWeekend"];
            this.postMorning = _data["postMorning"];
            this.postAfternoon = _data["postAfternoon"];
            this.postEvening = _data["postEvening"];
            this.significantDates = _data["significantDates"];
            this.postFrequency = _data["postFrequency"];
            this.numberOfWords = _data["numberOfWords"];
            this.marketingRefence = _data["marketingRefence"];
            this.exampleLink = _data["exampleLink"];
            this.extraInfo = _data["extraInfo"];
            this.totalSmsSent = _data["totalSmsSent"];
            this.purchasedPos = _data["purchasedPos"];
            this.fs1Url = _data["fs1Url"];
            this.fs2Url = _data["fs2Url"];
            this.fs3Url = _data["fs3Url"];
            this.fs4Url = _data["fs4Url"];
            this.currency = _data["currency"];
            this.sharesIssued = _data["sharesIssued"];
            this.taxIdentificationNumber = _data["taxIdentificationNumber"];
        }
    }

    static fromJS(data: any): CompanyProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["companyRegNo"] = this.companyRegNo;
        data["companyName"] = this.companyName;
        data["contactNo"] = this.contactNo;
        data["email"] = this.email;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["pAddress1"] = this.pAddress1;
        data["pAddress2"] = this.pAddress2;
        data["pPostCode"] = this.pPostCode;
        data["pCity"] = this.pCity;
        data["pState"] = this.pState;
        data["pCountry"] = this.pCountry;
        data["accountFullName"] = this.accountFullName;
        data["accountEmailAddress"] = this.accountEmailAddress;
        data["accountPassword"] = this.accountPassword;
        data["businessCompanyRegNo"] = this.businessCompanyRegNo;
        data["businessAddress"] = this.businessAddress;
        data["bnmCode"] = this.bnmCode;
        data["picName"] = this.picName;
        data["picPosition"] = this.picPosition;
        data["picEmailAddress"] = this.picEmailAddress;
        data["picPhoneNumber"] = this.picPhoneNumber;
        data["companyLogo"] = this.companyLogo;
        data["bankName"] = this.bankName;
        data["bankAccountHolder"] = this.bankAccountHolder;
        data["bankAccountNo"] = this.bankAccountNo;
        data["invoiceTemplate"] = this.invoiceTemplate;
        data["brandingColor"] = this.brandingColor;
        data["invoiceMessage"] = this.invoiceMessage;
        data["invoiceTnC"] = this.invoiceTnC;
        data["remarkMessage"] = this.remarkMessage;
        data["revenue"] = this.revenue;
        data["numberOfEmployees"] = this.numberOfEmployees;
        data["tutorialCompleted"] = this.tutorialCompleted;
        data["dayDueReminder"] = this.dayDueReminder;
        data["billplzEmail"] = this.billplzEmail;
        data["billplzPhone"] = this.billplzPhone;
        data["billplzPassword"] = this.billplzPassword;
        data["billplzStatusId"] = this.billplzStatusId;
        data["billplzCollectionId"] = this.billplzCollectionId;
        data["billplzSecretKey"] = this.billplzSecretKey;
        data["invoiceApproval"] = this.invoiceApproval;
        data["requisitionApproval"] = this.requisitionApproval;
        data["customerApproval"] = this.customerApproval;
        data["productApproval"] = this.productApproval;
        data["mainBannerUrl"] = this.mainBannerUrl;
        data["mainBannerTitle"] = this.mainBannerTitle;
        data["mainBannerDescription"] = this.mainBannerDescription;
        data["lastActive"] = this.lastActive ? this.lastActive.toISOString() : <any>undefined;
        data["hideFromMarketplace"] = this.hideFromMarketplace;
        data["websiteLink"] = this.websiteLink;
        data["facebookLink"] = this.facebookLink;
        data["youtubeLink"] = this.youtubeLink;
        data["whatsappLink"] = this.whatsappLink;
        data["secondaryBankName"] = this.secondaryBankName;
        data["secondaryBankAccountHolder"] = this.secondaryBankAccountHolder;
        data["secondaryBankAccountNo"] = this.secondaryBankAccountNo;
        data["secondaryBannerUrl"] = this.secondaryBannerUrl;
        data["secondaryBannerTitle"] = this.secondaryBannerTitle;
        data["secondaryBannerDescription"] = this.secondaryBannerDescription;
        data["isScfOnboarded"] = this.isScfOnboarded;
        data["scfTenancyName"] = this.scfTenancyName;
        data["scfTenantId"] = this.scfTenantId;
        data["scfEmail"] = this.scfEmail;
        data["scfPassword"] = this.scfPassword;
        data["scfApplicationStatus"] = this.scfApplicationStatus;
        data["scfSupplierId"] = this.scfSupplierId;
        data["purchaseOrderMessage"] = this.purchaseOrderMessage;
        data["quotationMessage"] = this.quotationMessage;
        data["poDeliveryDueReminder"] = this.poDeliveryDueReminder;
        data["producerTenantId"] = this.producerTenantId;
        data["typeOfCompany"] = this.typeOfCompany;
        data["overheadAllocation"] = this.overheadAllocation;
        data["financialYearOffset"] = this.financialYearOffset;
        data["financialYearStartDay"] = this.financialYearStartDay;
        data["financialYearStartMonth"] = this.financialYearStartMonth;
        data["coreActivityDescription"] = this.coreActivityDescription;
        data["isHideBankFromInvoice"] = this.isHideBankFromInvoice;
        data["aiOnboardingStatus"] = this.aiOnboardingStatus;
        data["facebookURL"] = this.facebookURL;
        data["instagramURL"] = this.instagramURL;
        data["postFacebook"] = this.postFacebook;
        data["postInstagram"] = this.postInstagram;
        data["postTwitter"] = this.postTwitter;
        data["postLinkedin"] = this.postLinkedin;
        data["postOthers"] = this.postOthers;
        data["forBrandAwareness"] = this.forBrandAwareness;
        data["forLeadGeneration"] = this.forLeadGeneration;
        data["forEngagement"] = this.forEngagement;
        data["forCustomerSupport"] = this.forCustomerSupport;
        data["forSales"] = this.forSales;
        data["professionalTone"] = this.professionalTone;
        data["casualTone"] = this.casualTone;
        data["informativeTone"] = this.informativeTone;
        data["funTone"] = this.funTone;
        data["inspirationalTone"] = this.inspirationalTone;
        data["targetAudience"] = this.targetAudience;
        data["imageContent"] = this.imageContent;
        data["videoContent"] = this.videoContent;
        data["blogContent"] = this.blogContent;
        data["infographicContent"] = this.infographicContent;
        data["podcastContent"] = this.podcastContent;
        data["webinarContent"] = this.webinarContent;
        data["topicsToCover"] = this.topicsToCover;
        data["topicsToAvoid"] = this.topicsToAvoid;
        data["productsToPromote"] = this.productsToPromote;
        data["keyMessages"] = this.keyMessages;
        data["guideLines"] = this.guideLines;
        data["postWeekday"] = this.postWeekday;
        data["postWeekend"] = this.postWeekend;
        data["postMorning"] = this.postMorning;
        data["postAfternoon"] = this.postAfternoon;
        data["postEvening"] = this.postEvening;
        data["significantDates"] = this.significantDates;
        data["postFrequency"] = this.postFrequency;
        data["numberOfWords"] = this.numberOfWords;
        data["marketingRefence"] = this.marketingRefence;
        data["exampleLink"] = this.exampleLink;
        data["extraInfo"] = this.extraInfo;
        data["totalSmsSent"] = this.totalSmsSent;
        data["purchasedPos"] = this.purchasedPos;
        data["fs1Url"] = this.fs1Url;
        data["fs2Url"] = this.fs2Url;
        data["fs3Url"] = this.fs3Url;
        data["fs4Url"] = this.fs4Url;
        data["currency"] = this.currency;
        data["sharesIssued"] = this.sharesIssued;
        data["taxIdentificationNumber"] = this.taxIdentificationNumber;
        return data;
    }

    clone(): CompanyProfileDto {
        const json = this.toJSON();
        let result = new CompanyProfileDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyProfileDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    companyRegNo: string | undefined;
    companyName: string | undefined;
    contactNo: string | undefined;
    email: string | undefined;
    address1: string | undefined;
    address2: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    pAddress1: string | undefined;
    pAddress2: string | undefined;
    pPostCode: string | undefined;
    pCity: string | undefined;
    pState: string | undefined;
    pCountry: string | undefined;
    accountFullName: string | undefined;
    accountEmailAddress: string | undefined;
    accountPassword: string | undefined;
    businessCompanyRegNo: string | undefined;
    businessAddress: string | undefined;
    bnmCode: string | undefined;
    picName: string | undefined;
    picPosition: string | undefined;
    picEmailAddress: string | undefined;
    picPhoneNumber: string | undefined;
    companyLogo: string | undefined;
    bankName: string | undefined;
    bankAccountHolder: string | undefined;
    bankAccountNo: string | undefined;
    invoiceTemplate: number | undefined;
    brandingColor: string | undefined;
    invoiceMessage: string | undefined;
    invoiceTnC: string | undefined;
    remarkMessage: string | undefined;
    revenue: string | undefined;
    numberOfEmployees: number;
    tutorialCompleted: boolean;
    dayDueReminder: number;
    billplzEmail: string | undefined;
    billplzPhone: string | undefined;
    billplzPassword: string | undefined;
    billplzStatusId: number;
    billplzCollectionId: string | undefined;
    billplzSecretKey: string | undefined;
    invoiceApproval: boolean;
    requisitionApproval: boolean;
    customerApproval: boolean;
    productApproval: boolean;
    mainBannerUrl: string | undefined;
    mainBannerTitle: string | undefined;
    mainBannerDescription: string | undefined;
    lastActive: moment.Moment;
    hideFromMarketplace: boolean;
    websiteLink: string | undefined;
    facebookLink: string | undefined;
    youtubeLink: string | undefined;
    whatsappLink: string | undefined;
    secondaryBankName: string | undefined;
    secondaryBankAccountHolder: string | undefined;
    secondaryBankAccountNo: string | undefined;
    secondaryBannerUrl: string | undefined;
    secondaryBannerTitle: string | undefined;
    secondaryBannerDescription: string | undefined;
    isScfOnboarded: boolean;
    scfTenancyName: string | undefined;
    scfTenantId: number;
    scfEmail: string | undefined;
    scfPassword: string | undefined;
    scfApplicationStatus: number;
    scfSupplierId: number;
    purchaseOrderMessage: string | undefined;
    quotationMessage: string | undefined;
    poDeliveryDueReminder: number;
    producerTenantId: number;
    typeOfCompany: string | undefined;
    overheadAllocation: number;
    financialYearOffset: number;
    financialYearStartDay: number;
    financialYearStartMonth: number;
    coreActivityDescription: string | undefined;
    isHideBankFromInvoice: boolean;
    aiOnboardingStatus: string | undefined;
    facebookURL: string | undefined;
    instagramURL: string | undefined;
    postFacebook: boolean;
    postInstagram: boolean;
    postTwitter: boolean;
    postLinkedin: boolean;
    postOthers: string | undefined;
    forBrandAwareness: boolean;
    forLeadGeneration: boolean;
    forEngagement: boolean;
    forCustomerSupport: boolean;
    forSales: boolean;
    professionalTone: boolean;
    casualTone: boolean;
    informativeTone: boolean;
    funTone: boolean;
    inspirationalTone: boolean;
    targetAudience: string | undefined;
    imageContent: boolean;
    videoContent: boolean;
    blogContent: boolean;
    infographicContent: boolean;
    podcastContent: boolean;
    webinarContent: boolean;
    topicsToCover: string | undefined;
    topicsToAvoid: string | undefined;
    productsToPromote: string | undefined;
    keyMessages: string | undefined;
    guideLines: string | undefined;
    postWeekday: boolean;
    postWeekend: boolean;
    postMorning: boolean;
    postAfternoon: boolean;
    postEvening: boolean;
    significantDates: string | undefined;
    postFrequency: string | undefined;
    numberOfWords: string | undefined;
    marketingRefence: string | undefined;
    exampleLink: string | undefined;
    extraInfo: string | undefined;
    totalSmsSent: number;
    purchasedPos: boolean;
    fs1Url: string | undefined;
    fs2Url: string | undefined;
    fs3Url: string | undefined;
    fs4Url: string | undefined;
    currency: string | undefined;
    sharesIssued: number;
    taxIdentificationNumber: string | undefined;
}

export class CompanyProfileDtoPagedResultDto implements ICompanyProfileDtoPagedResultDto {
    items: CompanyProfileDto[] | undefined;
    totalCount: number;

    constructor(data?: ICompanyProfileDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CompanyProfileDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CompanyProfileDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyProfileDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CompanyProfileDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CompanyProfileDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyProfileDtoPagedResultDto {
    items: CompanyProfileDto[] | undefined;
    totalCount: number;
}

export class CompanyProfilePagedResultDto implements ICompanyProfilePagedResultDto {
    items: CompanyProfile[] | undefined;
    totalCount: number;

    constructor(data?: ICompanyProfilePagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CompanyProfile.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CompanyProfilePagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyProfilePagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CompanyProfilePagedResultDto {
        const json = this.toJSON();
        let result = new CompanyProfilePagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyProfilePagedResultDto {
    items: CompanyProfile[] | undefined;
    totalCount: number;
}

export class CreateBillDto implements ICreateBillDto {
    billNo: string;
    billType: string;
    issueDate: moment.Moment;
    dueDate: moment.Moment;
    paymentTerm: number;
    remarks: string | undefined;
    totalDiscount: number;
    totalTax: number;
    totalAmount: number;
    status: string;
    customerId: string | undefined;
    tenantId: number | undefined;
    receivedDate: moment.Moment | undefined;
    paymentUrl: string | undefined;
    paymentDate: moment.Moment | undefined;
    paymentId: string | undefined;
    invoiceMessage: string | undefined;
    ccEmails: string | undefined;
    taxAmount: number;
    totalSubtotal: number;
    goodsReceived: boolean;
    goodsReceivedDate: moment.Moment | undefined;
    poReferenceNumber: string | undefined;
    shippingName: string | undefined;
    shippingAddress1: string | undefined;
    shippingAddress2: string | undefined;
    shippingCity: string | undefined;
    shippingState: string | undefined;
    shippingCountry: string | undefined;
    shippingPoscode: string | undefined;
    deliveryCharge: number;
    totalCreditNote: number;
    addtionalRemark: string | undefined;
    totalCreditnoteTax: number;
    isApproved: boolean;
    approvalRequestUserId: number;
    approvalRequestDate: moment.Moment;
    approvedDate: moment.Moment;
    approvalRequestName: string | undefined;
    paymentMethodId: number;
    paymentBankName: string | undefined;
    paymentBankAccountNo: string | undefined;
    paymentBankAccountHolder: string | undefined;
    reasonDateChange: string | undefined;
    warehouseId: number | undefined;
    warehouse: InventoryWarehouse;
    isUpdatedInventory: boolean;
    projectId: number;
    postMigration: boolean;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    currency: string | undefined;
    exchangeRate: number;

    constructor(data?: ICreateBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billNo = _data["billNo"];
            this.billType = _data["billType"];
            this.issueDate = _data["issueDate"] ? moment(_data["issueDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.paymentTerm = _data["paymentTerm"];
            this.remarks = _data["remarks"];
            this.totalDiscount = _data["totalDiscount"];
            this.totalTax = _data["totalTax"];
            this.totalAmount = _data["totalAmount"];
            this.status = _data["status"];
            this.customerId = _data["customerId"];
            this.tenantId = _data["tenantId"];
            this.receivedDate = _data["receivedDate"] ? moment(_data["receivedDate"].toString()) : <any>undefined;
            this.paymentUrl = _data["paymentUrl"];
            this.paymentDate = _data["paymentDate"] ? moment(_data["paymentDate"].toString()) : <any>undefined;
            this.paymentId = _data["paymentId"];
            this.invoiceMessage = _data["invoiceMessage"];
            this.ccEmails = _data["ccEmails"];
            this.taxAmount = _data["taxAmount"];
            this.totalSubtotal = _data["totalSubtotal"];
            this.goodsReceived = _data["goodsReceived"];
            this.goodsReceivedDate = _data["goodsReceivedDate"] ? moment(_data["goodsReceivedDate"].toString()) : <any>undefined;
            this.poReferenceNumber = _data["poReferenceNumber"];
            this.shippingName = _data["shippingName"];
            this.shippingAddress1 = _data["shippingAddress1"];
            this.shippingAddress2 = _data["shippingAddress2"];
            this.shippingCity = _data["shippingCity"];
            this.shippingState = _data["shippingState"];
            this.shippingCountry = _data["shippingCountry"];
            this.shippingPoscode = _data["shippingPoscode"];
            this.deliveryCharge = _data["deliveryCharge"];
            this.totalCreditNote = _data["totalCreditNote"];
            this.addtionalRemark = _data["addtionalRemark"];
            this.totalCreditnoteTax = _data["totalCreditnoteTax"];
            this.isApproved = _data["isApproved"];
            this.approvalRequestUserId = _data["approvalRequestUserId"];
            this.approvalRequestDate = _data["approvalRequestDate"] ? moment(_data["approvalRequestDate"].toString()) : <any>undefined;
            this.approvedDate = _data["approvedDate"] ? moment(_data["approvedDate"].toString()) : <any>undefined;
            this.approvalRequestName = _data["approvalRequestName"];
            this.paymentMethodId = _data["paymentMethodId"];
            this.paymentBankName = _data["paymentBankName"];
            this.paymentBankAccountNo = _data["paymentBankAccountNo"];
            this.paymentBankAccountHolder = _data["paymentBankAccountHolder"];
            this.reasonDateChange = _data["reasonDateChange"];
            this.warehouseId = _data["warehouseId"];
            this.warehouse = _data["warehouse"] ? InventoryWarehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.isUpdatedInventory = _data["isUpdatedInventory"];
            this.projectId = _data["projectId"];
            this.postMigration = _data["postMigration"];
            this.categoryCode = _data["categoryCode"];
            this.categoryName = _data["categoryName"];
            this.currency = _data["currency"];
            this.exchangeRate = _data["exchangeRate"];
        }
    }

    static fromJS(data: any): CreateBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billNo"] = this.billNo;
        data["billType"] = this.billType;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["paymentTerm"] = this.paymentTerm;
        data["remarks"] = this.remarks;
        data["totalDiscount"] = this.totalDiscount;
        data["totalTax"] = this.totalTax;
        data["totalAmount"] = this.totalAmount;
        data["status"] = this.status;
        data["customerId"] = this.customerId;
        data["tenantId"] = this.tenantId;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["paymentUrl"] = this.paymentUrl;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentId"] = this.paymentId;
        data["invoiceMessage"] = this.invoiceMessage;
        data["ccEmails"] = this.ccEmails;
        data["taxAmount"] = this.taxAmount;
        data["totalSubtotal"] = this.totalSubtotal;
        data["goodsReceived"] = this.goodsReceived;
        data["goodsReceivedDate"] = this.goodsReceivedDate ? this.goodsReceivedDate.toISOString() : <any>undefined;
        data["poReferenceNumber"] = this.poReferenceNumber;
        data["shippingName"] = this.shippingName;
        data["shippingAddress1"] = this.shippingAddress1;
        data["shippingAddress2"] = this.shippingAddress2;
        data["shippingCity"] = this.shippingCity;
        data["shippingState"] = this.shippingState;
        data["shippingCountry"] = this.shippingCountry;
        data["shippingPoscode"] = this.shippingPoscode;
        data["deliveryCharge"] = this.deliveryCharge;
        data["totalCreditNote"] = this.totalCreditNote;
        data["addtionalRemark"] = this.addtionalRemark;
        data["totalCreditnoteTax"] = this.totalCreditnoteTax;
        data["isApproved"] = this.isApproved;
        data["approvalRequestUserId"] = this.approvalRequestUserId;
        data["approvalRequestDate"] = this.approvalRequestDate ? this.approvalRequestDate.toISOString() : <any>undefined;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["approvalRequestName"] = this.approvalRequestName;
        data["paymentMethodId"] = this.paymentMethodId;
        data["paymentBankName"] = this.paymentBankName;
        data["paymentBankAccountNo"] = this.paymentBankAccountNo;
        data["paymentBankAccountHolder"] = this.paymentBankAccountHolder;
        data["reasonDateChange"] = this.reasonDateChange;
        data["warehouseId"] = this.warehouseId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["isUpdatedInventory"] = this.isUpdatedInventory;
        data["projectId"] = this.projectId;
        data["postMigration"] = this.postMigration;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["currency"] = this.currency;
        data["exchangeRate"] = this.exchangeRate;
        return data;
    }

    clone(): CreateBillDto {
        const json = this.toJSON();
        let result = new CreateBillDto();
        result.init(json);
        return result;
    }
}

export interface ICreateBillDto {
    billNo: string;
    billType: string;
    issueDate: moment.Moment;
    dueDate: moment.Moment;
    paymentTerm: number;
    remarks: string | undefined;
    totalDiscount: number;
    totalTax: number;
    totalAmount: number;
    status: string;
    customerId: string | undefined;
    tenantId: number | undefined;
    receivedDate: moment.Moment | undefined;
    paymentUrl: string | undefined;
    paymentDate: moment.Moment | undefined;
    paymentId: string | undefined;
    invoiceMessage: string | undefined;
    ccEmails: string | undefined;
    taxAmount: number;
    totalSubtotal: number;
    goodsReceived: boolean;
    goodsReceivedDate: moment.Moment | undefined;
    poReferenceNumber: string | undefined;
    shippingName: string | undefined;
    shippingAddress1: string | undefined;
    shippingAddress2: string | undefined;
    shippingCity: string | undefined;
    shippingState: string | undefined;
    shippingCountry: string | undefined;
    shippingPoscode: string | undefined;
    deliveryCharge: number;
    totalCreditNote: number;
    addtionalRemark: string | undefined;
    totalCreditnoteTax: number;
    isApproved: boolean;
    approvalRequestUserId: number;
    approvalRequestDate: moment.Moment;
    approvedDate: moment.Moment;
    approvalRequestName: string | undefined;
    paymentMethodId: number;
    paymentBankName: string | undefined;
    paymentBankAccountNo: string | undefined;
    paymentBankAccountHolder: string | undefined;
    reasonDateChange: string | undefined;
    warehouseId: number | undefined;
    warehouse: InventoryWarehouse;
    isUpdatedInventory: boolean;
    projectId: number;
    postMigration: boolean;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    currency: string | undefined;
    exchangeRate: number;
}

export class CreateBillItemDto implements ICreateBillItemDto {
    quantity: number;
    unitPrice: number;
    discount: number;
    tax: number;
    productId: string;
    billId: string;
    taxCode: string | undefined;
    orderId: string;
    creditNote: number;
    productShelfId: number | undefined;

    constructor(data?: ICreateBillItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.discount = _data["discount"];
            this.tax = _data["tax"];
            this.productId = _data["productId"];
            this.billId = _data["billId"];
            this.taxCode = _data["taxCode"];
            this.orderId = _data["orderId"];
            this.creditNote = _data["creditNote"];
            this.productShelfId = _data["productShelfId"];
        }
    }

    static fromJS(data: any): CreateBillItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBillItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["discount"] = this.discount;
        data["tax"] = this.tax;
        data["productId"] = this.productId;
        data["billId"] = this.billId;
        data["taxCode"] = this.taxCode;
        data["orderId"] = this.orderId;
        data["creditNote"] = this.creditNote;
        data["productShelfId"] = this.productShelfId;
        return data;
    }

    clone(): CreateBillItemDto {
        const json = this.toJSON();
        let result = new CreateBillItemDto();
        result.init(json);
        return result;
    }
}

export interface ICreateBillItemDto {
    quantity: number;
    unitPrice: number;
    discount: number;
    tax: number;
    productId: string;
    billId: string;
    taxCode: string | undefined;
    orderId: string;
    creditNote: number;
    productShelfId: number | undefined;
}

export class CreateCartDto implements ICreateCartDto {
    userId: number;
    tenantId: number;
    productId: string;
    name: string;
    quantity: number;
    unitPrice: number;
    discount: number;
    tax: number;
    taxCode: string | undefined;
    docId: string | undefined;
    additionalInfo: string | undefined;

    constructor(data?: ICreateCartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.productId = _data["productId"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.discount = _data["discount"];
            this.tax = _data["tax"];
            this.taxCode = _data["taxCode"];
            this.docId = _data["docId"];
            this.additionalInfo = _data["additionalInfo"];
        }
    }

    static fromJS(data: any): CreateCartDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["productId"] = this.productId;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["discount"] = this.discount;
        data["tax"] = this.tax;
        data["taxCode"] = this.taxCode;
        data["docId"] = this.docId;
        data["additionalInfo"] = this.additionalInfo;
        return data;
    }

    clone(): CreateCartDto {
        const json = this.toJSON();
        let result = new CreateCartDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCartDto {
    userId: number;
    tenantId: number;
    productId: string;
    name: string;
    quantity: number;
    unitPrice: number;
    discount: number;
    tax: number;
    taxCode: string | undefined;
    docId: string | undefined;
    additionalInfo: string | undefined;
}

export class CreateCompanyProfileDto implements ICreateCompanyProfileDto {
    tenantId: number;
    companyRegNo: string;
    companyName: string;
    contactNo: string;
    email: string | undefined;
    address1: string | undefined;
    address2: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    pAddress1: string | undefined;
    pAddress2: string | undefined;
    pPostCode: string | undefined;
    pCity: string | undefined;
    pState: string | undefined;
    pCountry: string | undefined;
    accountFullName: string | undefined;
    accountEmailAddress: string | undefined;
    accountPassword: string | undefined;
    businessCompanyRegNo: string | undefined;
    businessAddress: string | undefined;
    bnmCode: string | undefined;
    picName: string | undefined;
    picPosition: string | undefined;
    picEmailAddress: string | undefined;
    picPhoneNumber: string | undefined;
    companyLogo: string | undefined;
    bankName: string | undefined;
    bankAccountHolder: string | undefined;
    bankAccountNo: string | undefined;
    invoiceTemplate: number | undefined;
    brandingColor: string | undefined;
    invoiceMessage: string | undefined;
    remarkMessage: string | undefined;
    revenue: string | undefined;
    numberOfEmployees: number;
    tutorialCompleted: boolean;
    dayDueReminder: number;
    invoiceTnC: string | undefined;
    invoiceApproval: boolean;
    requisitionApproval: boolean;
    customerApproval: boolean;
    productApproval: boolean;
    mainBannerUrl: string | undefined;
    mainBannerTitle: string | undefined;
    mainBannerDescription: string | undefined;
    lastActive: moment.Moment;
    hideFromMarketplace: boolean;
    websiteLink: string | undefined;
    facebookLink: string | undefined;
    youtubeLink: string | undefined;
    whatsappLink: string | undefined;
    secondaryBankName: string | undefined;
    secondaryBankAccountHolder: string | undefined;
    secondaryBankAccountNo: string | undefined;
    secondaryBannerUrl: string | undefined;
    secondaryBannerTitle: string | undefined;
    secondaryBannerDescription: string | undefined;
    isScfOnboarded: boolean;
    scfTenancyName: string | undefined;
    scfTenantId: number;
    scfEmail: string | undefined;
    scfPassword: string | undefined;
    scfApplicationStatus: number;
    scfSupplierId: number;
    purchaseOrderMessage: string | undefined;
    quotationMessage: string | undefined;
    requisitionApproverDepartmentId: number | undefined;
    poDeliveryDueReminder: number;
    producerTenantId: number;
    typeOfCompany: string | undefined;
    overheadAllocation: number;
    financialYearOffset: number;
    financialYearStartDay: number;
    financialYearStartMonth: number;
    coreActivityDescription: string | undefined;
    isHideBankFromInvoice: boolean;
    aiOnboardingStatus: string | undefined;
    facebookURL: string | undefined;
    instagramURL: string | undefined;
    postFacebook: boolean;
    postInstagram: boolean;
    postTwitter: boolean;
    postLinkedin: boolean;
    postOthers: string | undefined;
    forBrandAwareness: boolean;
    forLeadGeneration: boolean;
    forEngagement: boolean;
    forCustomerSupport: boolean;
    forSales: boolean;
    professionalTone: boolean;
    casualTone: boolean;
    informativeTone: boolean;
    funTone: boolean;
    inspirationalTone: boolean;
    targetAudience: string | undefined;
    imageContent: boolean;
    videoContent: boolean;
    blogContent: boolean;
    infographicContent: boolean;
    podcastContent: boolean;
    webinarContent: boolean;
    topicsToCover: string | undefined;
    topicsToAvoid: string | undefined;
    productsToPromote: string | undefined;
    keyMessages: string | undefined;
    guideLines: string | undefined;
    postWeekday: boolean;
    postWeekend: boolean;
    postMorning: boolean;
    postAfternoon: boolean;
    postEvening: boolean;
    significantDates: string | undefined;
    postFrequency: string | undefined;
    numberOfWords: string | undefined;
    marketingRefence: string | undefined;
    exampleLink: string | undefined;
    extraInfo: string | undefined;
    totalSmsSent: number;
    purchasedPos: boolean;
    currency: string | undefined;
    sharesIssued: number;
    taxIdentificationNumber: string | undefined;

    constructor(data?: ICreateCompanyProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.companyRegNo = _data["companyRegNo"];
            this.companyName = _data["companyName"];
            this.contactNo = _data["contactNo"];
            this.email = _data["email"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.pAddress1 = _data["pAddress1"];
            this.pAddress2 = _data["pAddress2"];
            this.pPostCode = _data["pPostCode"];
            this.pCity = _data["pCity"];
            this.pState = _data["pState"];
            this.pCountry = _data["pCountry"];
            this.accountFullName = _data["accountFullName"];
            this.accountEmailAddress = _data["accountEmailAddress"];
            this.accountPassword = _data["accountPassword"];
            this.businessCompanyRegNo = _data["businessCompanyRegNo"];
            this.businessAddress = _data["businessAddress"];
            this.bnmCode = _data["bnmCode"];
            this.picName = _data["picName"];
            this.picPosition = _data["picPosition"];
            this.picEmailAddress = _data["picEmailAddress"];
            this.picPhoneNumber = _data["picPhoneNumber"];
            this.companyLogo = _data["companyLogo"];
            this.bankName = _data["bankName"];
            this.bankAccountHolder = _data["bankAccountHolder"];
            this.bankAccountNo = _data["bankAccountNo"];
            this.invoiceTemplate = _data["invoiceTemplate"];
            this.brandingColor = _data["brandingColor"];
            this.invoiceMessage = _data["invoiceMessage"];
            this.remarkMessage = _data["remarkMessage"];
            this.revenue = _data["revenue"];
            this.numberOfEmployees = _data["numberOfEmployees"];
            this.tutorialCompleted = _data["tutorialCompleted"];
            this.dayDueReminder = _data["dayDueReminder"];
            this.invoiceTnC = _data["invoiceTnC"];
            this.invoiceApproval = _data["invoiceApproval"];
            this.requisitionApproval = _data["requisitionApproval"];
            this.customerApproval = _data["customerApproval"];
            this.productApproval = _data["productApproval"];
            this.mainBannerUrl = _data["mainBannerUrl"];
            this.mainBannerTitle = _data["mainBannerTitle"];
            this.mainBannerDescription = _data["mainBannerDescription"];
            this.lastActive = _data["lastActive"] ? moment(_data["lastActive"].toString()) : <any>undefined;
            this.hideFromMarketplace = _data["hideFromMarketplace"];
            this.websiteLink = _data["websiteLink"];
            this.facebookLink = _data["facebookLink"];
            this.youtubeLink = _data["youtubeLink"];
            this.whatsappLink = _data["whatsappLink"];
            this.secondaryBankName = _data["secondaryBankName"];
            this.secondaryBankAccountHolder = _data["secondaryBankAccountHolder"];
            this.secondaryBankAccountNo = _data["secondaryBankAccountNo"];
            this.secondaryBannerUrl = _data["secondaryBannerUrl"];
            this.secondaryBannerTitle = _data["secondaryBannerTitle"];
            this.secondaryBannerDescription = _data["secondaryBannerDescription"];
            this.isScfOnboarded = _data["isScfOnboarded"];
            this.scfTenancyName = _data["scfTenancyName"];
            this.scfTenantId = _data["scfTenantId"];
            this.scfEmail = _data["scfEmail"];
            this.scfPassword = _data["scfPassword"];
            this.scfApplicationStatus = _data["scfApplicationStatus"];
            this.scfSupplierId = _data["scfSupplierId"];
            this.purchaseOrderMessage = _data["purchaseOrderMessage"];
            this.quotationMessage = _data["quotationMessage"];
            this.requisitionApproverDepartmentId = _data["requisitionApproverDepartmentId"];
            this.poDeliveryDueReminder = _data["poDeliveryDueReminder"];
            this.producerTenantId = _data["producerTenantId"];
            this.typeOfCompany = _data["typeOfCompany"];
            this.overheadAllocation = _data["overheadAllocation"];
            this.financialYearOffset = _data["financialYearOffset"];
            this.financialYearStartDay = _data["financialYearStartDay"];
            this.financialYearStartMonth = _data["financialYearStartMonth"];
            this.coreActivityDescription = _data["coreActivityDescription"];
            this.isHideBankFromInvoice = _data["isHideBankFromInvoice"];
            this.aiOnboardingStatus = _data["aiOnboardingStatus"];
            this.facebookURL = _data["facebookURL"];
            this.instagramURL = _data["instagramURL"];
            this.postFacebook = _data["postFacebook"];
            this.postInstagram = _data["postInstagram"];
            this.postTwitter = _data["postTwitter"];
            this.postLinkedin = _data["postLinkedin"];
            this.postOthers = _data["postOthers"];
            this.forBrandAwareness = _data["forBrandAwareness"];
            this.forLeadGeneration = _data["forLeadGeneration"];
            this.forEngagement = _data["forEngagement"];
            this.forCustomerSupport = _data["forCustomerSupport"];
            this.forSales = _data["forSales"];
            this.professionalTone = _data["professionalTone"];
            this.casualTone = _data["casualTone"];
            this.informativeTone = _data["informativeTone"];
            this.funTone = _data["funTone"];
            this.inspirationalTone = _data["inspirationalTone"];
            this.targetAudience = _data["targetAudience"];
            this.imageContent = _data["imageContent"];
            this.videoContent = _data["videoContent"];
            this.blogContent = _data["blogContent"];
            this.infographicContent = _data["infographicContent"];
            this.podcastContent = _data["podcastContent"];
            this.webinarContent = _data["webinarContent"];
            this.topicsToCover = _data["topicsToCover"];
            this.topicsToAvoid = _data["topicsToAvoid"];
            this.productsToPromote = _data["productsToPromote"];
            this.keyMessages = _data["keyMessages"];
            this.guideLines = _data["guideLines"];
            this.postWeekday = _data["postWeekday"];
            this.postWeekend = _data["postWeekend"];
            this.postMorning = _data["postMorning"];
            this.postAfternoon = _data["postAfternoon"];
            this.postEvening = _data["postEvening"];
            this.significantDates = _data["significantDates"];
            this.postFrequency = _data["postFrequency"];
            this.numberOfWords = _data["numberOfWords"];
            this.marketingRefence = _data["marketingRefence"];
            this.exampleLink = _data["exampleLink"];
            this.extraInfo = _data["extraInfo"];
            this.totalSmsSent = _data["totalSmsSent"];
            this.purchasedPos = _data["purchasedPos"];
            this.currency = _data["currency"];
            this.sharesIssued = _data["sharesIssued"];
            this.taxIdentificationNumber = _data["taxIdentificationNumber"];
        }
    }

    static fromJS(data: any): CreateCompanyProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["companyRegNo"] = this.companyRegNo;
        data["companyName"] = this.companyName;
        data["contactNo"] = this.contactNo;
        data["email"] = this.email;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["pAddress1"] = this.pAddress1;
        data["pAddress2"] = this.pAddress2;
        data["pPostCode"] = this.pPostCode;
        data["pCity"] = this.pCity;
        data["pState"] = this.pState;
        data["pCountry"] = this.pCountry;
        data["accountFullName"] = this.accountFullName;
        data["accountEmailAddress"] = this.accountEmailAddress;
        data["accountPassword"] = this.accountPassword;
        data["businessCompanyRegNo"] = this.businessCompanyRegNo;
        data["businessAddress"] = this.businessAddress;
        data["bnmCode"] = this.bnmCode;
        data["picName"] = this.picName;
        data["picPosition"] = this.picPosition;
        data["picEmailAddress"] = this.picEmailAddress;
        data["picPhoneNumber"] = this.picPhoneNumber;
        data["companyLogo"] = this.companyLogo;
        data["bankName"] = this.bankName;
        data["bankAccountHolder"] = this.bankAccountHolder;
        data["bankAccountNo"] = this.bankAccountNo;
        data["invoiceTemplate"] = this.invoiceTemplate;
        data["brandingColor"] = this.brandingColor;
        data["invoiceMessage"] = this.invoiceMessage;
        data["remarkMessage"] = this.remarkMessage;
        data["revenue"] = this.revenue;
        data["numberOfEmployees"] = this.numberOfEmployees;
        data["tutorialCompleted"] = this.tutorialCompleted;
        data["dayDueReminder"] = this.dayDueReminder;
        data["invoiceTnC"] = this.invoiceTnC;
        data["invoiceApproval"] = this.invoiceApproval;
        data["requisitionApproval"] = this.requisitionApproval;
        data["customerApproval"] = this.customerApproval;
        data["productApproval"] = this.productApproval;
        data["mainBannerUrl"] = this.mainBannerUrl;
        data["mainBannerTitle"] = this.mainBannerTitle;
        data["mainBannerDescription"] = this.mainBannerDescription;
        data["lastActive"] = this.lastActive ? this.lastActive.toISOString() : <any>undefined;
        data["hideFromMarketplace"] = this.hideFromMarketplace;
        data["websiteLink"] = this.websiteLink;
        data["facebookLink"] = this.facebookLink;
        data["youtubeLink"] = this.youtubeLink;
        data["whatsappLink"] = this.whatsappLink;
        data["secondaryBankName"] = this.secondaryBankName;
        data["secondaryBankAccountHolder"] = this.secondaryBankAccountHolder;
        data["secondaryBankAccountNo"] = this.secondaryBankAccountNo;
        data["secondaryBannerUrl"] = this.secondaryBannerUrl;
        data["secondaryBannerTitle"] = this.secondaryBannerTitle;
        data["secondaryBannerDescription"] = this.secondaryBannerDescription;
        data["isScfOnboarded"] = this.isScfOnboarded;
        data["scfTenancyName"] = this.scfTenancyName;
        data["scfTenantId"] = this.scfTenantId;
        data["scfEmail"] = this.scfEmail;
        data["scfPassword"] = this.scfPassword;
        data["scfApplicationStatus"] = this.scfApplicationStatus;
        data["scfSupplierId"] = this.scfSupplierId;
        data["purchaseOrderMessage"] = this.purchaseOrderMessage;
        data["quotationMessage"] = this.quotationMessage;
        data["requisitionApproverDepartmentId"] = this.requisitionApproverDepartmentId;
        data["poDeliveryDueReminder"] = this.poDeliveryDueReminder;
        data["producerTenantId"] = this.producerTenantId;
        data["typeOfCompany"] = this.typeOfCompany;
        data["overheadAllocation"] = this.overheadAllocation;
        data["financialYearOffset"] = this.financialYearOffset;
        data["financialYearStartDay"] = this.financialYearStartDay;
        data["financialYearStartMonth"] = this.financialYearStartMonth;
        data["coreActivityDescription"] = this.coreActivityDescription;
        data["isHideBankFromInvoice"] = this.isHideBankFromInvoice;
        data["aiOnboardingStatus"] = this.aiOnboardingStatus;
        data["facebookURL"] = this.facebookURL;
        data["instagramURL"] = this.instagramURL;
        data["postFacebook"] = this.postFacebook;
        data["postInstagram"] = this.postInstagram;
        data["postTwitter"] = this.postTwitter;
        data["postLinkedin"] = this.postLinkedin;
        data["postOthers"] = this.postOthers;
        data["forBrandAwareness"] = this.forBrandAwareness;
        data["forLeadGeneration"] = this.forLeadGeneration;
        data["forEngagement"] = this.forEngagement;
        data["forCustomerSupport"] = this.forCustomerSupport;
        data["forSales"] = this.forSales;
        data["professionalTone"] = this.professionalTone;
        data["casualTone"] = this.casualTone;
        data["informativeTone"] = this.informativeTone;
        data["funTone"] = this.funTone;
        data["inspirationalTone"] = this.inspirationalTone;
        data["targetAudience"] = this.targetAudience;
        data["imageContent"] = this.imageContent;
        data["videoContent"] = this.videoContent;
        data["blogContent"] = this.blogContent;
        data["infographicContent"] = this.infographicContent;
        data["podcastContent"] = this.podcastContent;
        data["webinarContent"] = this.webinarContent;
        data["topicsToCover"] = this.topicsToCover;
        data["topicsToAvoid"] = this.topicsToAvoid;
        data["productsToPromote"] = this.productsToPromote;
        data["keyMessages"] = this.keyMessages;
        data["guideLines"] = this.guideLines;
        data["postWeekday"] = this.postWeekday;
        data["postWeekend"] = this.postWeekend;
        data["postMorning"] = this.postMorning;
        data["postAfternoon"] = this.postAfternoon;
        data["postEvening"] = this.postEvening;
        data["significantDates"] = this.significantDates;
        data["postFrequency"] = this.postFrequency;
        data["numberOfWords"] = this.numberOfWords;
        data["marketingRefence"] = this.marketingRefence;
        data["exampleLink"] = this.exampleLink;
        data["extraInfo"] = this.extraInfo;
        data["totalSmsSent"] = this.totalSmsSent;
        data["purchasedPos"] = this.purchasedPos;
        data["currency"] = this.currency;
        data["sharesIssued"] = this.sharesIssued;
        data["taxIdentificationNumber"] = this.taxIdentificationNumber;
        return data;
    }

    clone(): CreateCompanyProfileDto {
        const json = this.toJSON();
        let result = new CreateCompanyProfileDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCompanyProfileDto {
    tenantId: number;
    companyRegNo: string;
    companyName: string;
    contactNo: string;
    email: string | undefined;
    address1: string | undefined;
    address2: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    pAddress1: string | undefined;
    pAddress2: string | undefined;
    pPostCode: string | undefined;
    pCity: string | undefined;
    pState: string | undefined;
    pCountry: string | undefined;
    accountFullName: string | undefined;
    accountEmailAddress: string | undefined;
    accountPassword: string | undefined;
    businessCompanyRegNo: string | undefined;
    businessAddress: string | undefined;
    bnmCode: string | undefined;
    picName: string | undefined;
    picPosition: string | undefined;
    picEmailAddress: string | undefined;
    picPhoneNumber: string | undefined;
    companyLogo: string | undefined;
    bankName: string | undefined;
    bankAccountHolder: string | undefined;
    bankAccountNo: string | undefined;
    invoiceTemplate: number | undefined;
    brandingColor: string | undefined;
    invoiceMessage: string | undefined;
    remarkMessage: string | undefined;
    revenue: string | undefined;
    numberOfEmployees: number;
    tutorialCompleted: boolean;
    dayDueReminder: number;
    invoiceTnC: string | undefined;
    invoiceApproval: boolean;
    requisitionApproval: boolean;
    customerApproval: boolean;
    productApproval: boolean;
    mainBannerUrl: string | undefined;
    mainBannerTitle: string | undefined;
    mainBannerDescription: string | undefined;
    lastActive: moment.Moment;
    hideFromMarketplace: boolean;
    websiteLink: string | undefined;
    facebookLink: string | undefined;
    youtubeLink: string | undefined;
    whatsappLink: string | undefined;
    secondaryBankName: string | undefined;
    secondaryBankAccountHolder: string | undefined;
    secondaryBankAccountNo: string | undefined;
    secondaryBannerUrl: string | undefined;
    secondaryBannerTitle: string | undefined;
    secondaryBannerDescription: string | undefined;
    isScfOnboarded: boolean;
    scfTenancyName: string | undefined;
    scfTenantId: number;
    scfEmail: string | undefined;
    scfPassword: string | undefined;
    scfApplicationStatus: number;
    scfSupplierId: number;
    purchaseOrderMessage: string | undefined;
    quotationMessage: string | undefined;
    requisitionApproverDepartmentId: number | undefined;
    poDeliveryDueReminder: number;
    producerTenantId: number;
    typeOfCompany: string | undefined;
    overheadAllocation: number;
    financialYearOffset: number;
    financialYearStartDay: number;
    financialYearStartMonth: number;
    coreActivityDescription: string | undefined;
    isHideBankFromInvoice: boolean;
    aiOnboardingStatus: string | undefined;
    facebookURL: string | undefined;
    instagramURL: string | undefined;
    postFacebook: boolean;
    postInstagram: boolean;
    postTwitter: boolean;
    postLinkedin: boolean;
    postOthers: string | undefined;
    forBrandAwareness: boolean;
    forLeadGeneration: boolean;
    forEngagement: boolean;
    forCustomerSupport: boolean;
    forSales: boolean;
    professionalTone: boolean;
    casualTone: boolean;
    informativeTone: boolean;
    funTone: boolean;
    inspirationalTone: boolean;
    targetAudience: string | undefined;
    imageContent: boolean;
    videoContent: boolean;
    blogContent: boolean;
    infographicContent: boolean;
    podcastContent: boolean;
    webinarContent: boolean;
    topicsToCover: string | undefined;
    topicsToAvoid: string | undefined;
    productsToPromote: string | undefined;
    keyMessages: string | undefined;
    guideLines: string | undefined;
    postWeekday: boolean;
    postWeekend: boolean;
    postMorning: boolean;
    postAfternoon: boolean;
    postEvening: boolean;
    significantDates: string | undefined;
    postFrequency: string | undefined;
    numberOfWords: string | undefined;
    marketingRefence: string | undefined;
    exampleLink: string | undefined;
    extraInfo: string | undefined;
    totalSmsSent: number;
    purchasedPos: boolean;
    currency: string | undefined;
    sharesIssued: number;
    taxIdentificationNumber: string | undefined;
}

export class CreateCustomerDto implements ICreateCustomerDto {
    name: string;
    companyRegNo: string | undefined;
    contactNo: string;
    email: string | undefined;
    billingAddress1: string;
    billingAddress2: string | undefined;
    postCode: string;
    city: string;
    state: string;
    country: string;
    tenantId: number | undefined;
    customertypeId: number;
    firstName: string | undefined;
    lastName: string | undefined;
    middleTitle: string | undefined;
    userId: number;
    creditRating: string | undefined;
    paymentTerm: number;
    creditDocumentUrl: string | undefined;
    code: string | undefined;
    sstRegistrationNo: string | undefined;
    taxIdentificationNumber: string | undefined;
    currency: string | undefined;

    constructor(data?: ICreateCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.companyRegNo = _data["companyRegNo"];
            this.contactNo = _data["contactNo"];
            this.email = _data["email"];
            this.billingAddress1 = _data["billingAddress1"];
            this.billingAddress2 = _data["billingAddress2"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.tenantId = _data["tenantId"];
            this.customertypeId = _data["customertypeId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleTitle = _data["middleTitle"];
            this.userId = _data["userId"];
            this.creditRating = _data["creditRating"];
            this.paymentTerm = _data["paymentTerm"];
            this.creditDocumentUrl = _data["creditDocumentUrl"];
            this.code = _data["code"];
            this.sstRegistrationNo = _data["sstRegistrationNo"];
            this.taxIdentificationNumber = _data["taxIdentificationNumber"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): CreateCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["companyRegNo"] = this.companyRegNo;
        data["contactNo"] = this.contactNo;
        data["email"] = this.email;
        data["billingAddress1"] = this.billingAddress1;
        data["billingAddress2"] = this.billingAddress2;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["tenantId"] = this.tenantId;
        data["customertypeId"] = this.customertypeId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleTitle"] = this.middleTitle;
        data["userId"] = this.userId;
        data["creditRating"] = this.creditRating;
        data["paymentTerm"] = this.paymentTerm;
        data["creditDocumentUrl"] = this.creditDocumentUrl;
        data["code"] = this.code;
        data["sstRegistrationNo"] = this.sstRegistrationNo;
        data["taxIdentificationNumber"] = this.taxIdentificationNumber;
        data["currency"] = this.currency;
        return data;
    }

    clone(): CreateCustomerDto {
        const json = this.toJSON();
        let result = new CreateCustomerDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCustomerDto {
    name: string;
    companyRegNo: string | undefined;
    contactNo: string;
    email: string | undefined;
    billingAddress1: string;
    billingAddress2: string | undefined;
    postCode: string;
    city: string;
    state: string;
    country: string;
    tenantId: number | undefined;
    customertypeId: number;
    firstName: string | undefined;
    lastName: string | undefined;
    middleTitle: string | undefined;
    userId: number;
    creditRating: string | undefined;
    paymentTerm: number;
    creditDocumentUrl: string | undefined;
    code: string | undefined;
    sstRegistrationNo: string | undefined;
    taxIdentificationNumber: string | undefined;
    currency: string | undefined;
}

export class CreateMaterialDto implements ICreateMaterialDto {
    code: string;
    name: string;
    description: string | undefined;
    price: number;
    tenantId: number | undefined;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    hideFromMarketplace: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    companyProfileId: string | undefined;
    isUserFeatured: boolean;
    showQuantity: boolean;
    minLevel: number;
    isNotifiedMinLevel: boolean;
    tagNumber: string | undefined;
    barCode: string | undefined;
    inventoryCategoryId: number | undefined;
    averagePriceFromPo: number;
    lastPriceFromPo: number;
    movingAverageValue: number;
    projectId: number;
    dateOfMigration: moment.Moment | undefined;

    constructor(data?: ICreateMaterialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.tenantId = _data["tenantId"];
            this.oldPrice = _data["oldPrice"];
            this.discount = _data["discount"];
            this.ratingsCount = _data["ratingsCount"];
            this.ratingsValue = _data["ratingsValue"];
            this.availibilityCount = _data["availibilityCount"];
            this.cartCount = _data["cartCount"];
            this.weight = _data["weight"];
            this.categoryId = _data["categoryId"];
            this.fullDescription = _data["fullDescription"];
            this.serviceTax = _data["serviceTax"];
            this.taxCode = _data["taxCode"];
            this.isSubsidized = _data["isSubsidized"];
            this.isCertified = _data["isCertified"];
            this.isIslamic = _data["isIslamic"];
            this.isLoanAvailable = _data["isLoanAvailable"];
            this.hideFromMarketplace = _data["hideFromMarketplace"];
            this.isFeatured = _data["isFeatured"];
            this.isTypeSerice = _data["isTypeSerice"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.companyProfileId = _data["companyProfileId"];
            this.isUserFeatured = _data["isUserFeatured"];
            this.showQuantity = _data["showQuantity"];
            this.minLevel = _data["minLevel"];
            this.isNotifiedMinLevel = _data["isNotifiedMinLevel"];
            this.tagNumber = _data["tagNumber"];
            this.barCode = _data["barCode"];
            this.inventoryCategoryId = _data["inventoryCategoryId"];
            this.averagePriceFromPo = _data["averagePriceFromPo"];
            this.lastPriceFromPo = _data["lastPriceFromPo"];
            this.movingAverageValue = _data["movingAverageValue"];
            this.projectId = _data["projectId"];
            this.dateOfMigration = _data["dateOfMigration"] ? moment(_data["dateOfMigration"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateMaterialDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMaterialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        data["tenantId"] = this.tenantId;
        data["oldPrice"] = this.oldPrice;
        data["discount"] = this.discount;
        data["ratingsCount"] = this.ratingsCount;
        data["ratingsValue"] = this.ratingsValue;
        data["availibilityCount"] = this.availibilityCount;
        data["cartCount"] = this.cartCount;
        data["weight"] = this.weight;
        data["categoryId"] = this.categoryId;
        data["fullDescription"] = this.fullDescription;
        data["serviceTax"] = this.serviceTax;
        data["taxCode"] = this.taxCode;
        data["isSubsidized"] = this.isSubsidized;
        data["isCertified"] = this.isCertified;
        data["isIslamic"] = this.isIslamic;
        data["isLoanAvailable"] = this.isLoanAvailable;
        data["hideFromMarketplace"] = this.hideFromMarketplace;
        data["isFeatured"] = this.isFeatured;
        data["isTypeSerice"] = this.isTypeSerice;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["companyProfileId"] = this.companyProfileId;
        data["isUserFeatured"] = this.isUserFeatured;
        data["showQuantity"] = this.showQuantity;
        data["minLevel"] = this.minLevel;
        data["isNotifiedMinLevel"] = this.isNotifiedMinLevel;
        data["tagNumber"] = this.tagNumber;
        data["barCode"] = this.barCode;
        data["inventoryCategoryId"] = this.inventoryCategoryId;
        data["averagePriceFromPo"] = this.averagePriceFromPo;
        data["lastPriceFromPo"] = this.lastPriceFromPo;
        data["movingAverageValue"] = this.movingAverageValue;
        data["projectId"] = this.projectId;
        data["dateOfMigration"] = this.dateOfMigration ? this.dateOfMigration.toISOString() : <any>undefined;
        return data;
    }

    clone(): CreateMaterialDto {
        const json = this.toJSON();
        let result = new CreateMaterialDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMaterialDto {
    code: string;
    name: string;
    description: string | undefined;
    price: number;
    tenantId: number | undefined;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    hideFromMarketplace: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    companyProfileId: string | undefined;
    isUserFeatured: boolean;
    showQuantity: boolean;
    minLevel: number;
    isNotifiedMinLevel: boolean;
    tagNumber: string | undefined;
    barCode: string | undefined;
    inventoryCategoryId: number | undefined;
    averagePriceFromPo: number;
    lastPriceFromPo: number;
    movingAverageValue: number;
    projectId: number;
    dateOfMigration: moment.Moment | undefined;
}

export class CreateNewTenantDto implements ICreateNewTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
    accountFullName: string | undefined;
    accountEmailAddress: string | undefined;
    accountPassword: string | undefined;
    businessCompanyRegNo: string | undefined;
    businessAddress: string | undefined;
    bnmCode: string | undefined;
    picName: string | undefined;
    picPosition: string | undefined;
    picEmailAddress: string | undefined;
    picPhoneNumber: string | undefined;
    revenue: string | undefined;
    numberOfEmployees: number;
    businessAddress2: string | undefined;
    city: string | undefined;
    poscode: string | undefined;
    state: string | undefined;
    country: string | undefined;
    producerTenantId: number;
    couponCode: string | undefined;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isAiAndPayment: boolean;
    isSkipAiForm: boolean;
    aiOnboardingStatus: string | undefined;
    facebookURL: string | undefined;
    instagramURL: string | undefined;
    postFacebook: boolean;
    postInstagram: boolean;
    postTwitter: boolean;
    postLinkedin: boolean;
    postOthers: string | undefined;
    forBrandAwareness: boolean;
    forLeadGeneration: boolean;
    forEngagement: boolean;
    forCustomerSupport: boolean;
    forSales: boolean;
    professionalTone: boolean;
    casualTone: boolean;
    informativeTone: boolean;
    funTone: boolean;
    inspirationalTone: boolean;
    targetAudience: string | undefined;
    imageContent: boolean;
    videoContent: boolean;
    blogContent: boolean;
    infographicContent: boolean;
    podcastContent: boolean;
    webinarContent: boolean;
    topicsToCover: string | undefined;
    topicsToAvoid: string | undefined;
    productsToPromote: string | undefined;
    keyMessages: string | undefined;
    guideLines: string | undefined;
    postWeekday: boolean;
    postWeekend: boolean;
    postMorning: boolean;
    postAfternoon: boolean;
    postEvening: boolean;
    significantDates: string | undefined;
    startDate: moment.Moment;
    postFrequency: string | undefined;
    numberOfWords: string | undefined;
    marketingRefence: string | undefined;
    exampleLink: string | undefined;
    extraInfo: string | undefined;

    constructor(data?: ICreateNewTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
            this.accountFullName = _data["accountFullName"];
            this.accountEmailAddress = _data["accountEmailAddress"];
            this.accountPassword = _data["accountPassword"];
            this.businessCompanyRegNo = _data["businessCompanyRegNo"];
            this.businessAddress = _data["businessAddress"];
            this.bnmCode = _data["bnmCode"];
            this.picName = _data["picName"];
            this.picPosition = _data["picPosition"];
            this.picEmailAddress = _data["picEmailAddress"];
            this.picPhoneNumber = _data["picPhoneNumber"];
            this.revenue = _data["revenue"];
            this.numberOfEmployees = _data["numberOfEmployees"];
            this.businessAddress2 = _data["businessAddress2"];
            this.city = _data["city"];
            this.poscode = _data["poscode"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.producerTenantId = _data["producerTenantId"];
            this.couponCode = _data["couponCode"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? moment(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isAiAndPayment = _data["isAiAndPayment"];
            this.isSkipAiForm = _data["isSkipAiForm"];
            this.aiOnboardingStatus = _data["aiOnboardingStatus"];
            this.facebookURL = _data["facebookURL"];
            this.instagramURL = _data["instagramURL"];
            this.postFacebook = _data["postFacebook"];
            this.postInstagram = _data["postInstagram"];
            this.postTwitter = _data["postTwitter"];
            this.postLinkedin = _data["postLinkedin"];
            this.postOthers = _data["postOthers"];
            this.forBrandAwareness = _data["forBrandAwareness"];
            this.forLeadGeneration = _data["forLeadGeneration"];
            this.forEngagement = _data["forEngagement"];
            this.forCustomerSupport = _data["forCustomerSupport"];
            this.forSales = _data["forSales"];
            this.professionalTone = _data["professionalTone"];
            this.casualTone = _data["casualTone"];
            this.informativeTone = _data["informativeTone"];
            this.funTone = _data["funTone"];
            this.inspirationalTone = _data["inspirationalTone"];
            this.targetAudience = _data["targetAudience"];
            this.imageContent = _data["imageContent"];
            this.videoContent = _data["videoContent"];
            this.blogContent = _data["blogContent"];
            this.infographicContent = _data["infographicContent"];
            this.podcastContent = _data["podcastContent"];
            this.webinarContent = _data["webinarContent"];
            this.topicsToCover = _data["topicsToCover"];
            this.topicsToAvoid = _data["topicsToAvoid"];
            this.productsToPromote = _data["productsToPromote"];
            this.keyMessages = _data["keyMessages"];
            this.guideLines = _data["guideLines"];
            this.postWeekday = _data["postWeekday"];
            this.postWeekend = _data["postWeekend"];
            this.postMorning = _data["postMorning"];
            this.postAfternoon = _data["postAfternoon"];
            this.postEvening = _data["postEvening"];
            this.significantDates = _data["significantDates"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.postFrequency = _data["postFrequency"];
            this.numberOfWords = _data["numberOfWords"];
            this.marketingRefence = _data["marketingRefence"];
            this.exampleLink = _data["exampleLink"];
            this.extraInfo = _data["extraInfo"];
        }
    }

    static fromJS(data: any): CreateNewTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNewTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["accountFullName"] = this.accountFullName;
        data["accountEmailAddress"] = this.accountEmailAddress;
        data["accountPassword"] = this.accountPassword;
        data["businessCompanyRegNo"] = this.businessCompanyRegNo;
        data["businessAddress"] = this.businessAddress;
        data["bnmCode"] = this.bnmCode;
        data["picName"] = this.picName;
        data["picPosition"] = this.picPosition;
        data["picEmailAddress"] = this.picEmailAddress;
        data["picPhoneNumber"] = this.picPhoneNumber;
        data["revenue"] = this.revenue;
        data["numberOfEmployees"] = this.numberOfEmployees;
        data["businessAddress2"] = this.businessAddress2;
        data["city"] = this.city;
        data["poscode"] = this.poscode;
        data["state"] = this.state;
        data["country"] = this.country;
        data["producerTenantId"] = this.producerTenantId;
        data["couponCode"] = this.couponCode;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isAiAndPayment"] = this.isAiAndPayment;
        data["isSkipAiForm"] = this.isSkipAiForm;
        data["aiOnboardingStatus"] = this.aiOnboardingStatus;
        data["facebookURL"] = this.facebookURL;
        data["instagramURL"] = this.instagramURL;
        data["postFacebook"] = this.postFacebook;
        data["postInstagram"] = this.postInstagram;
        data["postTwitter"] = this.postTwitter;
        data["postLinkedin"] = this.postLinkedin;
        data["postOthers"] = this.postOthers;
        data["forBrandAwareness"] = this.forBrandAwareness;
        data["forLeadGeneration"] = this.forLeadGeneration;
        data["forEngagement"] = this.forEngagement;
        data["forCustomerSupport"] = this.forCustomerSupport;
        data["forSales"] = this.forSales;
        data["professionalTone"] = this.professionalTone;
        data["casualTone"] = this.casualTone;
        data["informativeTone"] = this.informativeTone;
        data["funTone"] = this.funTone;
        data["inspirationalTone"] = this.inspirationalTone;
        data["targetAudience"] = this.targetAudience;
        data["imageContent"] = this.imageContent;
        data["videoContent"] = this.videoContent;
        data["blogContent"] = this.blogContent;
        data["infographicContent"] = this.infographicContent;
        data["podcastContent"] = this.podcastContent;
        data["webinarContent"] = this.webinarContent;
        data["topicsToCover"] = this.topicsToCover;
        data["topicsToAvoid"] = this.topicsToAvoid;
        data["productsToPromote"] = this.productsToPromote;
        data["keyMessages"] = this.keyMessages;
        data["guideLines"] = this.guideLines;
        data["postWeekday"] = this.postWeekday;
        data["postWeekend"] = this.postWeekend;
        data["postMorning"] = this.postMorning;
        data["postAfternoon"] = this.postAfternoon;
        data["postEvening"] = this.postEvening;
        data["significantDates"] = this.significantDates;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["postFrequency"] = this.postFrequency;
        data["numberOfWords"] = this.numberOfWords;
        data["marketingRefence"] = this.marketingRefence;
        data["exampleLink"] = this.exampleLink;
        data["extraInfo"] = this.extraInfo;
        return data;
    }

    clone(): CreateNewTenantDto {
        const json = this.toJSON();
        let result = new CreateNewTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateNewTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
    accountFullName: string | undefined;
    accountEmailAddress: string | undefined;
    accountPassword: string | undefined;
    businessCompanyRegNo: string | undefined;
    businessAddress: string | undefined;
    bnmCode: string | undefined;
    picName: string | undefined;
    picPosition: string | undefined;
    picEmailAddress: string | undefined;
    picPhoneNumber: string | undefined;
    revenue: string | undefined;
    numberOfEmployees: number;
    businessAddress2: string | undefined;
    city: string | undefined;
    poscode: string | undefined;
    state: string | undefined;
    country: string | undefined;
    producerTenantId: number;
    couponCode: string | undefined;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isAiAndPayment: boolean;
    isSkipAiForm: boolean;
    aiOnboardingStatus: string | undefined;
    facebookURL: string | undefined;
    instagramURL: string | undefined;
    postFacebook: boolean;
    postInstagram: boolean;
    postTwitter: boolean;
    postLinkedin: boolean;
    postOthers: string | undefined;
    forBrandAwareness: boolean;
    forLeadGeneration: boolean;
    forEngagement: boolean;
    forCustomerSupport: boolean;
    forSales: boolean;
    professionalTone: boolean;
    casualTone: boolean;
    informativeTone: boolean;
    funTone: boolean;
    inspirationalTone: boolean;
    targetAudience: string | undefined;
    imageContent: boolean;
    videoContent: boolean;
    blogContent: boolean;
    infographicContent: boolean;
    podcastContent: boolean;
    webinarContent: boolean;
    topicsToCover: string | undefined;
    topicsToAvoid: string | undefined;
    productsToPromote: string | undefined;
    keyMessages: string | undefined;
    guideLines: string | undefined;
    postWeekday: boolean;
    postWeekend: boolean;
    postMorning: boolean;
    postAfternoon: boolean;
    postEvening: boolean;
    significantDates: string | undefined;
    startDate: moment.Moment;
    postFrequency: string | undefined;
    numberOfWords: string | undefined;
    marketingRefence: string | undefined;
    exampleLink: string | undefined;
    extraInfo: string | undefined;
}

export class CreateNonCurrentAssetClassDto implements ICreateNonCurrentAssetClassDto {
    tenantId: number;
    name: string;
    accountsCategoryCode: string | undefined;
    accountsCategoryName: string | undefined;
    totalItems: number;
    totalCosts: number;
    totalAccumulatedDepreciation: number;
    totalAccumulatedImpairment: number;
    totalNetBookValue: number;

    constructor(data?: ICreateNonCurrentAssetClassDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.accountsCategoryCode = _data["accountsCategoryCode"];
            this.accountsCategoryName = _data["accountsCategoryName"];
            this.totalItems = _data["totalItems"];
            this.totalCosts = _data["totalCosts"];
            this.totalAccumulatedDepreciation = _data["totalAccumulatedDepreciation"];
            this.totalAccumulatedImpairment = _data["totalAccumulatedImpairment"];
            this.totalNetBookValue = _data["totalNetBookValue"];
        }
    }

    static fromJS(data: any): CreateNonCurrentAssetClassDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNonCurrentAssetClassDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["accountsCategoryCode"] = this.accountsCategoryCode;
        data["accountsCategoryName"] = this.accountsCategoryName;
        data["totalItems"] = this.totalItems;
        data["totalCosts"] = this.totalCosts;
        data["totalAccumulatedDepreciation"] = this.totalAccumulatedDepreciation;
        data["totalAccumulatedImpairment"] = this.totalAccumulatedImpairment;
        data["totalNetBookValue"] = this.totalNetBookValue;
        return data;
    }

    clone(): CreateNonCurrentAssetClassDto {
        const json = this.toJSON();
        let result = new CreateNonCurrentAssetClassDto();
        result.init(json);
        return result;
    }
}

export interface ICreateNonCurrentAssetClassDto {
    tenantId: number;
    name: string;
    accountsCategoryCode: string | undefined;
    accountsCategoryName: string | undefined;
    totalItems: number;
    totalCosts: number;
    totalAccumulatedDepreciation: number;
    totalAccumulatedImpairment: number;
    totalNetBookValue: number;
}

export class CreateNonCurrentAssetDto implements ICreateNonCurrentAssetDto {
    code: string;
    name: string;
    description: string | undefined;
    price: number;
    tenantId: number | undefined;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    hideFromMarketplace: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    companyProfileId: string | undefined;
    isUserFeatured: boolean;
    showQuantity: boolean;
    depreciationRate: number;
    accountsCategoryCode: string | undefined;
    accountsCategoryName: string | undefined;
    nonCurrentAssetClassId: string | undefined;

    constructor(data?: ICreateNonCurrentAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.tenantId = _data["tenantId"];
            this.oldPrice = _data["oldPrice"];
            this.discount = _data["discount"];
            this.ratingsCount = _data["ratingsCount"];
            this.ratingsValue = _data["ratingsValue"];
            this.availibilityCount = _data["availibilityCount"];
            this.cartCount = _data["cartCount"];
            this.weight = _data["weight"];
            this.categoryId = _data["categoryId"];
            this.fullDescription = _data["fullDescription"];
            this.serviceTax = _data["serviceTax"];
            this.taxCode = _data["taxCode"];
            this.isSubsidized = _data["isSubsidized"];
            this.isCertified = _data["isCertified"];
            this.isIslamic = _data["isIslamic"];
            this.isLoanAvailable = _data["isLoanAvailable"];
            this.hideFromMarketplace = _data["hideFromMarketplace"];
            this.isFeatured = _data["isFeatured"];
            this.isTypeSerice = _data["isTypeSerice"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.companyProfileId = _data["companyProfileId"];
            this.isUserFeatured = _data["isUserFeatured"];
            this.showQuantity = _data["showQuantity"];
            this.depreciationRate = _data["depreciationRate"];
            this.accountsCategoryCode = _data["accountsCategoryCode"];
            this.accountsCategoryName = _data["accountsCategoryName"];
            this.nonCurrentAssetClassId = _data["nonCurrentAssetClassId"];
        }
    }

    static fromJS(data: any): CreateNonCurrentAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNonCurrentAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        data["tenantId"] = this.tenantId;
        data["oldPrice"] = this.oldPrice;
        data["discount"] = this.discount;
        data["ratingsCount"] = this.ratingsCount;
        data["ratingsValue"] = this.ratingsValue;
        data["availibilityCount"] = this.availibilityCount;
        data["cartCount"] = this.cartCount;
        data["weight"] = this.weight;
        data["categoryId"] = this.categoryId;
        data["fullDescription"] = this.fullDescription;
        data["serviceTax"] = this.serviceTax;
        data["taxCode"] = this.taxCode;
        data["isSubsidized"] = this.isSubsidized;
        data["isCertified"] = this.isCertified;
        data["isIslamic"] = this.isIslamic;
        data["isLoanAvailable"] = this.isLoanAvailable;
        data["hideFromMarketplace"] = this.hideFromMarketplace;
        data["isFeatured"] = this.isFeatured;
        data["isTypeSerice"] = this.isTypeSerice;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["companyProfileId"] = this.companyProfileId;
        data["isUserFeatured"] = this.isUserFeatured;
        data["showQuantity"] = this.showQuantity;
        data["depreciationRate"] = this.depreciationRate;
        data["accountsCategoryCode"] = this.accountsCategoryCode;
        data["accountsCategoryName"] = this.accountsCategoryName;
        data["nonCurrentAssetClassId"] = this.nonCurrentAssetClassId;
        return data;
    }

    clone(): CreateNonCurrentAssetDto {
        const json = this.toJSON();
        let result = new CreateNonCurrentAssetDto();
        result.init(json);
        return result;
    }
}

export interface ICreateNonCurrentAssetDto {
    code: string;
    name: string;
    description: string | undefined;
    price: number;
    tenantId: number | undefined;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    hideFromMarketplace: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    companyProfileId: string | undefined;
    isUserFeatured: boolean;
    showQuantity: boolean;
    depreciationRate: number;
    accountsCategoryCode: string | undefined;
    accountsCategoryName: string | undefined;
    nonCurrentAssetClassId: string | undefined;
}

export class CreateNonCurrentAssetItemDto implements ICreateNonCurrentAssetItemDto {
    unitPrice: number;
    installationCost: number;
    thirdPartyInstallationCost: number;
    readonly totalInstallationCost: number;
    deliveryCost: number;
    totalOriginalCost: number;
    discount: number;
    tax: number;
    nonCurrentAssetId: string;
    taxCode: string | undefined;
    creditNote: number;
    serialNumber: string | undefined;
    barCode: string | undefined;
    depreciationRate: number;
    depreciationStartDate: moment.Moment;
    accumulatedImpairment: number;
    isWriteOff: boolean;
    isDisposal: boolean;
    writeOffAndDisposalDate: moment.Moment;
    sellValue: number;
    internalTag: string | undefined;
    residualValue: number;
    location: string | undefined;
    migratedAccumulatedDepreciation: number;
    migratedAccumulatedImpairment: number;
    migratedAccumulatedIncome: number;
    migratedDate: moment.Moment;
    migratedRequesterId: number;
    migratedRequesterName: string | undefined;
    migratedRequesterRemarks: string | undefined;
    migratedApproverId: number;
    migratedApproverName: string | undefined;
    migratedApproverRemarks: string | undefined;
    migratedApprovalStatus: number;
    migratedApprovalDate: moment.Moment;
    supplierInvoiceUrl: string | undefined;
    purchasedDate: moment.Moment;
    depreciationMode: number;
    vendorInvoiceId: number | undefined;
    writeOffNoteId: number | undefined;
    cashbookId: number | undefined;
    postMigration: boolean;
    dateAcquired: moment.Moment | undefined;
    description: string | undefined;
    typeOfInvestment: string | undefined;
    certificate: string | undefined;
    rateOfReturn: number | undefined;
    incomeReceived: number | undefined;
    accruedIncomeReceived: number | undefined;
    readonly totalIncomeReceived: number;
    dateOfIncomeReceived: moment.Moment | undefined;
    companyName: string | undefined;
    companyRegNo: string | undefined;
    companyType: string | undefined;
    numberOfSharePurchased: number | undefined;
    percentageOfHolding: number | undefined;
    shareCertificateNo: string | undefined;
    dividendsReceived: number | undefined;
    dateOfDividentReceived: moment.Moment | undefined;
    maturityDate: moment.Moment | undefined;
    readonly tenure: number | undefined;
    investee: string | undefined;

    constructor(data?: ICreateNonCurrentAssetItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitPrice = _data["unitPrice"];
            this.installationCost = _data["installationCost"];
            this.thirdPartyInstallationCost = _data["thirdPartyInstallationCost"];
            (<any>this).totalInstallationCost = _data["totalInstallationCost"];
            this.deliveryCost = _data["deliveryCost"];
            this.totalOriginalCost = _data["totalOriginalCost"];
            this.discount = _data["discount"];
            this.tax = _data["tax"];
            this.nonCurrentAssetId = _data["nonCurrentAssetId"];
            this.taxCode = _data["taxCode"];
            this.creditNote = _data["creditNote"];
            this.serialNumber = _data["serialNumber"];
            this.barCode = _data["barCode"];
            this.depreciationRate = _data["depreciationRate"];
            this.depreciationStartDate = _data["depreciationStartDate"] ? moment(_data["depreciationStartDate"].toString()) : <any>undefined;
            this.accumulatedImpairment = _data["accumulatedImpairment"];
            this.isWriteOff = _data["isWriteOff"];
            this.isDisposal = _data["isDisposal"];
            this.writeOffAndDisposalDate = _data["writeOffAndDisposalDate"] ? moment(_data["writeOffAndDisposalDate"].toString()) : <any>undefined;
            this.sellValue = _data["sellValue"];
            this.internalTag = _data["internalTag"];
            this.residualValue = _data["residualValue"];
            this.location = _data["location"];
            this.migratedAccumulatedDepreciation = _data["migratedAccumulatedDepreciation"];
            this.migratedAccumulatedImpairment = _data["migratedAccumulatedImpairment"];
            this.migratedAccumulatedIncome = _data["migratedAccumulatedIncome"];
            this.migratedDate = _data["migratedDate"] ? moment(_data["migratedDate"].toString()) : <any>undefined;
            this.migratedRequesterId = _data["migratedRequesterId"];
            this.migratedRequesterName = _data["migratedRequesterName"];
            this.migratedRequesterRemarks = _data["migratedRequesterRemarks"];
            this.migratedApproverId = _data["migratedApproverId"];
            this.migratedApproverName = _data["migratedApproverName"];
            this.migratedApproverRemarks = _data["migratedApproverRemarks"];
            this.migratedApprovalStatus = _data["migratedApprovalStatus"];
            this.migratedApprovalDate = _data["migratedApprovalDate"] ? moment(_data["migratedApprovalDate"].toString()) : <any>undefined;
            this.supplierInvoiceUrl = _data["supplierInvoiceUrl"];
            this.purchasedDate = _data["purchasedDate"] ? moment(_data["purchasedDate"].toString()) : <any>undefined;
            this.depreciationMode = _data["depreciationMode"];
            this.vendorInvoiceId = _data["vendorInvoiceId"];
            this.writeOffNoteId = _data["writeOffNoteId"];
            this.cashbookId = _data["cashbookId"];
            this.postMigration = _data["postMigration"];
            this.dateAcquired = _data["dateAcquired"] ? moment(_data["dateAcquired"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.typeOfInvestment = _data["typeOfInvestment"];
            this.certificate = _data["certificate"];
            this.rateOfReturn = _data["rateOfReturn"];
            this.incomeReceived = _data["incomeReceived"];
            this.accruedIncomeReceived = _data["accruedIncomeReceived"];
            (<any>this).totalIncomeReceived = _data["totalIncomeReceived"];
            this.dateOfIncomeReceived = _data["dateOfIncomeReceived"] ? moment(_data["dateOfIncomeReceived"].toString()) : <any>undefined;
            this.companyName = _data["companyName"];
            this.companyRegNo = _data["companyRegNo"];
            this.companyType = _data["companyType"];
            this.numberOfSharePurchased = _data["numberOfSharePurchased"];
            this.percentageOfHolding = _data["percentageOfHolding"];
            this.shareCertificateNo = _data["shareCertificateNo"];
            this.dividendsReceived = _data["dividendsReceived"];
            this.dateOfDividentReceived = _data["dateOfDividentReceived"] ? moment(_data["dateOfDividentReceived"].toString()) : <any>undefined;
            this.maturityDate = _data["maturityDate"] ? moment(_data["maturityDate"].toString()) : <any>undefined;
            (<any>this).tenure = _data["tenure"];
            this.investee = _data["investee"];
        }
    }

    static fromJS(data: any): CreateNonCurrentAssetItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNonCurrentAssetItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitPrice"] = this.unitPrice;
        data["installationCost"] = this.installationCost;
        data["thirdPartyInstallationCost"] = this.thirdPartyInstallationCost;
        data["totalInstallationCost"] = this.totalInstallationCost;
        data["deliveryCost"] = this.deliveryCost;
        data["totalOriginalCost"] = this.totalOriginalCost;
        data["discount"] = this.discount;
        data["tax"] = this.tax;
        data["nonCurrentAssetId"] = this.nonCurrentAssetId;
        data["taxCode"] = this.taxCode;
        data["creditNote"] = this.creditNote;
        data["serialNumber"] = this.serialNumber;
        data["barCode"] = this.barCode;
        data["depreciationRate"] = this.depreciationRate;
        data["depreciationStartDate"] = this.depreciationStartDate ? this.depreciationStartDate.toISOString() : <any>undefined;
        data["accumulatedImpairment"] = this.accumulatedImpairment;
        data["isWriteOff"] = this.isWriteOff;
        data["isDisposal"] = this.isDisposal;
        data["writeOffAndDisposalDate"] = this.writeOffAndDisposalDate ? this.writeOffAndDisposalDate.toISOString() : <any>undefined;
        data["sellValue"] = this.sellValue;
        data["internalTag"] = this.internalTag;
        data["residualValue"] = this.residualValue;
        data["location"] = this.location;
        data["migratedAccumulatedDepreciation"] = this.migratedAccumulatedDepreciation;
        data["migratedAccumulatedImpairment"] = this.migratedAccumulatedImpairment;
        data["migratedAccumulatedIncome"] = this.migratedAccumulatedIncome;
        data["migratedDate"] = this.migratedDate ? this.migratedDate.toISOString() : <any>undefined;
        data["migratedRequesterId"] = this.migratedRequesterId;
        data["migratedRequesterName"] = this.migratedRequesterName;
        data["migratedRequesterRemarks"] = this.migratedRequesterRemarks;
        data["migratedApproverId"] = this.migratedApproverId;
        data["migratedApproverName"] = this.migratedApproverName;
        data["migratedApproverRemarks"] = this.migratedApproverRemarks;
        data["migratedApprovalStatus"] = this.migratedApprovalStatus;
        data["migratedApprovalDate"] = this.migratedApprovalDate ? this.migratedApprovalDate.toISOString() : <any>undefined;
        data["supplierInvoiceUrl"] = this.supplierInvoiceUrl;
        data["purchasedDate"] = this.purchasedDate ? this.purchasedDate.toISOString() : <any>undefined;
        data["depreciationMode"] = this.depreciationMode;
        data["vendorInvoiceId"] = this.vendorInvoiceId;
        data["writeOffNoteId"] = this.writeOffNoteId;
        data["cashbookId"] = this.cashbookId;
        data["postMigration"] = this.postMigration;
        data["dateAcquired"] = this.dateAcquired ? this.dateAcquired.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["typeOfInvestment"] = this.typeOfInvestment;
        data["certificate"] = this.certificate;
        data["rateOfReturn"] = this.rateOfReturn;
        data["incomeReceived"] = this.incomeReceived;
        data["accruedIncomeReceived"] = this.accruedIncomeReceived;
        data["totalIncomeReceived"] = this.totalIncomeReceived;
        data["dateOfIncomeReceived"] = this.dateOfIncomeReceived ? this.dateOfIncomeReceived.toISOString() : <any>undefined;
        data["companyName"] = this.companyName;
        data["companyRegNo"] = this.companyRegNo;
        data["companyType"] = this.companyType;
        data["numberOfSharePurchased"] = this.numberOfSharePurchased;
        data["percentageOfHolding"] = this.percentageOfHolding;
        data["shareCertificateNo"] = this.shareCertificateNo;
        data["dividendsReceived"] = this.dividendsReceived;
        data["dateOfDividentReceived"] = this.dateOfDividentReceived ? this.dateOfDividentReceived.toISOString() : <any>undefined;
        data["maturityDate"] = this.maturityDate ? this.maturityDate.toISOString() : <any>undefined;
        data["tenure"] = this.tenure;
        data["investee"] = this.investee;
        return data;
    }

    clone(): CreateNonCurrentAssetItemDto {
        const json = this.toJSON();
        let result = new CreateNonCurrentAssetItemDto();
        result.init(json);
        return result;
    }
}

export interface ICreateNonCurrentAssetItemDto {
    unitPrice: number;
    installationCost: number;
    thirdPartyInstallationCost: number;
    totalInstallationCost: number;
    deliveryCost: number;
    totalOriginalCost: number;
    discount: number;
    tax: number;
    nonCurrentAssetId: string;
    taxCode: string | undefined;
    creditNote: number;
    serialNumber: string | undefined;
    barCode: string | undefined;
    depreciationRate: number;
    depreciationStartDate: moment.Moment;
    accumulatedImpairment: number;
    isWriteOff: boolean;
    isDisposal: boolean;
    writeOffAndDisposalDate: moment.Moment;
    sellValue: number;
    internalTag: string | undefined;
    residualValue: number;
    location: string | undefined;
    migratedAccumulatedDepreciation: number;
    migratedAccumulatedImpairment: number;
    migratedAccumulatedIncome: number;
    migratedDate: moment.Moment;
    migratedRequesterId: number;
    migratedRequesterName: string | undefined;
    migratedRequesterRemarks: string | undefined;
    migratedApproverId: number;
    migratedApproverName: string | undefined;
    migratedApproverRemarks: string | undefined;
    migratedApprovalStatus: number;
    migratedApprovalDate: moment.Moment;
    supplierInvoiceUrl: string | undefined;
    purchasedDate: moment.Moment;
    depreciationMode: number;
    vendorInvoiceId: number | undefined;
    writeOffNoteId: number | undefined;
    cashbookId: number | undefined;
    postMigration: boolean;
    dateAcquired: moment.Moment | undefined;
    description: string | undefined;
    typeOfInvestment: string | undefined;
    certificate: string | undefined;
    rateOfReturn: number | undefined;
    incomeReceived: number | undefined;
    accruedIncomeReceived: number | undefined;
    totalIncomeReceived: number;
    dateOfIncomeReceived: moment.Moment | undefined;
    companyName: string | undefined;
    companyRegNo: string | undefined;
    companyType: string | undefined;
    numberOfSharePurchased: number | undefined;
    percentageOfHolding: number | undefined;
    shareCertificateNo: string | undefined;
    dividendsReceived: number | undefined;
    dateOfDividentReceived: moment.Moment | undefined;
    maturityDate: moment.Moment | undefined;
    tenure: number | undefined;
    investee: string | undefined;
}

export class CreateNonCurrentAssetItemImpairmentDto implements ICreateNonCurrentAssetItemImpairmentDto {
    nonCurrentAssetItemId: string;
    impairmentValue: number;

    constructor(data?: ICreateNonCurrentAssetItemImpairmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nonCurrentAssetItemId = _data["nonCurrentAssetItemId"];
            this.impairmentValue = _data["impairmentValue"];
        }
    }

    static fromJS(data: any): CreateNonCurrentAssetItemImpairmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNonCurrentAssetItemImpairmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nonCurrentAssetItemId"] = this.nonCurrentAssetItemId;
        data["impairmentValue"] = this.impairmentValue;
        return data;
    }

    clone(): CreateNonCurrentAssetItemImpairmentDto {
        const json = this.toJSON();
        let result = new CreateNonCurrentAssetItemImpairmentDto();
        result.init(json);
        return result;
    }
}

export interface ICreateNonCurrentAssetItemImpairmentDto {
    nonCurrentAssetItemId: string;
    impairmentValue: number;
}

export class CreateNonCurrentAssetMaintenanceDto implements ICreateNonCurrentAssetMaintenanceDto {
    tenantId: number;
    nonCurrentAssetItemId: string;
    dateOfRepair: moment.Moment;
    natureOfRepair: string | undefined;
    amount: number;
    scheduledDate: moment.Moment;
    operationHours: number;

    constructor(data?: ICreateNonCurrentAssetMaintenanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.nonCurrentAssetItemId = _data["nonCurrentAssetItemId"];
            this.dateOfRepair = _data["dateOfRepair"] ? moment(_data["dateOfRepair"].toString()) : <any>undefined;
            this.natureOfRepair = _data["natureOfRepair"];
            this.amount = _data["amount"];
            this.scheduledDate = _data["scheduledDate"] ? moment(_data["scheduledDate"].toString()) : <any>undefined;
            this.operationHours = _data["operationHours"];
        }
    }

    static fromJS(data: any): CreateNonCurrentAssetMaintenanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNonCurrentAssetMaintenanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["nonCurrentAssetItemId"] = this.nonCurrentAssetItemId;
        data["dateOfRepair"] = this.dateOfRepair ? this.dateOfRepair.toISOString() : <any>undefined;
        data["natureOfRepair"] = this.natureOfRepair;
        data["amount"] = this.amount;
        data["scheduledDate"] = this.scheduledDate ? this.scheduledDate.toISOString() : <any>undefined;
        data["operationHours"] = this.operationHours;
        return data;
    }

    clone(): CreateNonCurrentAssetMaintenanceDto {
        const json = this.toJSON();
        let result = new CreateNonCurrentAssetMaintenanceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateNonCurrentAssetMaintenanceDto {
    tenantId: number;
    nonCurrentAssetItemId: string;
    dateOfRepair: moment.Moment;
    natureOfRepair: string | undefined;
    amount: number;
    scheduledDate: moment.Moment;
    operationHours: number;
}

export class CreateProductDto implements ICreateProductDto {
    code: string;
    name: string;
    description: string | undefined;
    price: number;
    tenantId: number | undefined;
    images: ProductImages[] | undefined;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    color: ProductColors[] | undefined;
    size: ProductSizes[] | undefined;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    hideFromMarketplace: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    companyProfileId: string | undefined;
    isUserFeatured: boolean;
    showQuantity: boolean;
    minLevel: number;
    isNotifiedMinLevel: boolean;
    tagNumber: string | undefined;
    barCode: string | undefined;
    inventoryCategoryId: number | undefined;
    producerTenantId: number;
    averagePriceFromPo: number;
    averageProductionCost: number;
    lastSellingPrice: number;
    lastPriceFromPo: number;
    lastProductionCost: number;
    movingAverageValue: number;
    isHidden: boolean;
    projectId: number | undefined;
    dateOfMigration: moment.Moment | undefined;
    firebaseDocID: string | undefined;
    firebaseCategory: string | undefined;

    constructor(data?: ICreateProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images.push(ProductImages.fromJS(item));
            }
            this.oldPrice = _data["oldPrice"];
            this.discount = _data["discount"];
            this.ratingsCount = _data["ratingsCount"];
            this.ratingsValue = _data["ratingsValue"];
            this.availibilityCount = _data["availibilityCount"];
            this.cartCount = _data["cartCount"];
            if (Array.isArray(_data["color"])) {
                this.color = [] as any;
                for (let item of _data["color"])
                    this.color.push(ProductColors.fromJS(item));
            }
            if (Array.isArray(_data["size"])) {
                this.size = [] as any;
                for (let item of _data["size"])
                    this.size.push(ProductSizes.fromJS(item));
            }
            this.weight = _data["weight"];
            this.categoryId = _data["categoryId"];
            this.fullDescription = _data["fullDescription"];
            this.serviceTax = _data["serviceTax"];
            this.taxCode = _data["taxCode"];
            this.isSubsidized = _data["isSubsidized"];
            this.isCertified = _data["isCertified"];
            this.isIslamic = _data["isIslamic"];
            this.isLoanAvailable = _data["isLoanAvailable"];
            this.hideFromMarketplace = _data["hideFromMarketplace"];
            this.isFeatured = _data["isFeatured"];
            this.isTypeSerice = _data["isTypeSerice"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.companyProfileId = _data["companyProfileId"];
            this.isUserFeatured = _data["isUserFeatured"];
            this.showQuantity = _data["showQuantity"];
            this.minLevel = _data["minLevel"];
            this.isNotifiedMinLevel = _data["isNotifiedMinLevel"];
            this.tagNumber = _data["tagNumber"];
            this.barCode = _data["barCode"];
            this.inventoryCategoryId = _data["inventoryCategoryId"];
            this.producerTenantId = _data["producerTenantId"];
            this.averagePriceFromPo = _data["averagePriceFromPo"];
            this.averageProductionCost = _data["averageProductionCost"];
            this.lastSellingPrice = _data["lastSellingPrice"];
            this.lastPriceFromPo = _data["lastPriceFromPo"];
            this.lastProductionCost = _data["lastProductionCost"];
            this.movingAverageValue = _data["movingAverageValue"];
            this.isHidden = _data["isHidden"];
            this.projectId = _data["projectId"];
            this.dateOfMigration = _data["dateOfMigration"] ? moment(_data["dateOfMigration"].toString()) : <any>undefined;
            this.firebaseDocID = _data["firebaseDocID"];
            this.firebaseCategory = _data["firebaseCategory"];
        }
    }

    static fromJS(data: any): CreateProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["oldPrice"] = this.oldPrice;
        data["discount"] = this.discount;
        data["ratingsCount"] = this.ratingsCount;
        data["ratingsValue"] = this.ratingsValue;
        data["availibilityCount"] = this.availibilityCount;
        data["cartCount"] = this.cartCount;
        if (Array.isArray(this.color)) {
            data["color"] = [];
            for (let item of this.color)
                data["color"].push(item.toJSON());
        }
        if (Array.isArray(this.size)) {
            data["size"] = [];
            for (let item of this.size)
                data["size"].push(item.toJSON());
        }
        data["weight"] = this.weight;
        data["categoryId"] = this.categoryId;
        data["fullDescription"] = this.fullDescription;
        data["serviceTax"] = this.serviceTax;
        data["taxCode"] = this.taxCode;
        data["isSubsidized"] = this.isSubsidized;
        data["isCertified"] = this.isCertified;
        data["isIslamic"] = this.isIslamic;
        data["isLoanAvailable"] = this.isLoanAvailable;
        data["hideFromMarketplace"] = this.hideFromMarketplace;
        data["isFeatured"] = this.isFeatured;
        data["isTypeSerice"] = this.isTypeSerice;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["companyProfileId"] = this.companyProfileId;
        data["isUserFeatured"] = this.isUserFeatured;
        data["showQuantity"] = this.showQuantity;
        data["minLevel"] = this.minLevel;
        data["isNotifiedMinLevel"] = this.isNotifiedMinLevel;
        data["tagNumber"] = this.tagNumber;
        data["barCode"] = this.barCode;
        data["inventoryCategoryId"] = this.inventoryCategoryId;
        data["producerTenantId"] = this.producerTenantId;
        data["averagePriceFromPo"] = this.averagePriceFromPo;
        data["averageProductionCost"] = this.averageProductionCost;
        data["lastSellingPrice"] = this.lastSellingPrice;
        data["lastPriceFromPo"] = this.lastPriceFromPo;
        data["lastProductionCost"] = this.lastProductionCost;
        data["movingAverageValue"] = this.movingAverageValue;
        data["isHidden"] = this.isHidden;
        data["projectId"] = this.projectId;
        data["dateOfMigration"] = this.dateOfMigration ? this.dateOfMigration.toISOString() : <any>undefined;
        data["firebaseDocID"] = this.firebaseDocID;
        data["firebaseCategory"] = this.firebaseCategory;
        return data;
    }

    clone(): CreateProductDto {
        const json = this.toJSON();
        let result = new CreateProductDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProductDto {
    code: string;
    name: string;
    description: string | undefined;
    price: number;
    tenantId: number | undefined;
    images: ProductImages[] | undefined;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    color: ProductColors[] | undefined;
    size: ProductSizes[] | undefined;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    hideFromMarketplace: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    companyProfileId: string | undefined;
    isUserFeatured: boolean;
    showQuantity: boolean;
    minLevel: number;
    isNotifiedMinLevel: boolean;
    tagNumber: string | undefined;
    barCode: string | undefined;
    inventoryCategoryId: number | undefined;
    producerTenantId: number;
    averagePriceFromPo: number;
    averageProductionCost: number;
    lastSellingPrice: number;
    lastPriceFromPo: number;
    lastProductionCost: number;
    movingAverageValue: number;
    isHidden: boolean;
    projectId: number | undefined;
    dateOfMigration: moment.Moment | undefined;
    firebaseDocID: string | undefined;
    firebaseCategory: string | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
}

export class CreateUserDto implements ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string;
    lastVisitedMerchantStore: string | undefined;
    mobile: string | undefined;
    imagePath: string | undefined;
    dateOfBirth: moment.Moment;
    gender: string | undefined;
    presentAddress1: string | undefined;
    presentAddress2: string | undefined;
    presentAddress3: string | undefined;
    presentAddress4: string | undefined;
    permanentAddress1: string | undefined;
    permanentAddress2: string | undefined;
    permanentAddress3: string | undefined;
    permanentAddress4: string | undefined;
    basicSalary: number;
    status: number;
    joiningDate: moment.Moment;
    resignDate: moment.Moment;
    departmentId: number;
    designationId: number;
    bankName: string | undefined;
    accountName: string | undefined;
    accountNumber: string | undefined;
    swiftCode: string | undefined;
    branch: string | undefined;
    cv: string | undefined;
    nationalId: string | undefined;
    other: string | undefined;
    icUrl: string | undefined;
    otherUrl: string | undefined;
    staffId: string | undefined;
    isResident: boolean;
    identificationType: string | undefined;
    identificationNo: string | undefined;
    religion: string | undefined;
    ethnicity: string | undefined;
    maritalStatus: string | undefined;
    disability: boolean;
    country: string | undefined;
    postcode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    highestEducation: string | undefined;
    educationSpecialisation: string | undefined;
    isSpecialWorker: boolean;
    salaryType: SalaryType;
    salaryPaymentMethod: boolean;
    epfNumber: string | undefined;
    incomeTaxNumber: string | undefined;
    socsoAccountNumber: string | undefined;
    socsoContributionSchedule: number;
    eisAccountNumber: string | undefined;
    zakatAccountNumber: string | undefined;
    zakatState: string | undefined;
    zakatAmount: number;
    asnbAccountNumber: string | undefined;
    asnbAmount: number;
    ptptnAccountNumber: string | undefined;
    ptptnAmount: number;
    tabungHajiAccountNumber: string | undefined;
    tabungHajiAmount: number;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.password = _data["password"];
            this.lastVisitedMerchantStore = _data["lastVisitedMerchantStore"];
            this.mobile = _data["mobile"];
            this.imagePath = _data["imagePath"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.presentAddress1 = _data["presentAddress1"];
            this.presentAddress2 = _data["presentAddress2"];
            this.presentAddress3 = _data["presentAddress3"];
            this.presentAddress4 = _data["presentAddress4"];
            this.permanentAddress1 = _data["permanentAddress1"];
            this.permanentAddress2 = _data["permanentAddress2"];
            this.permanentAddress3 = _data["permanentAddress3"];
            this.permanentAddress4 = _data["permanentAddress4"];
            this.basicSalary = _data["basicSalary"];
            this.status = _data["status"];
            this.joiningDate = _data["joiningDate"] ? moment(_data["joiningDate"].toString()) : <any>undefined;
            this.resignDate = _data["resignDate"] ? moment(_data["resignDate"].toString()) : <any>undefined;
            this.departmentId = _data["departmentId"];
            this.designationId = _data["designationId"];
            this.bankName = _data["bankName"];
            this.accountName = _data["accountName"];
            this.accountNumber = _data["accountNumber"];
            this.swiftCode = _data["swiftCode"];
            this.branch = _data["branch"];
            this.cv = _data["cv"];
            this.nationalId = _data["nationalId"];
            this.other = _data["other"];
            this.icUrl = _data["icUrl"];
            this.otherUrl = _data["otherUrl"];
            this.staffId = _data["staffId"];
            this.isResident = _data["isResident"];
            this.identificationType = _data["identificationType"];
            this.identificationNo = _data["identificationNo"];
            this.religion = _data["religion"];
            this.ethnicity = _data["ethnicity"];
            this.maritalStatus = _data["maritalStatus"];
            this.disability = _data["disability"];
            this.country = _data["country"];
            this.postcode = _data["postcode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.highestEducation = _data["highestEducation"];
            this.educationSpecialisation = _data["educationSpecialisation"];
            this.isSpecialWorker = _data["isSpecialWorker"];
            this.salaryType = _data["salaryType"];
            this.salaryPaymentMethod = _data["salaryPaymentMethod"];
            this.epfNumber = _data["epfNumber"];
            this.incomeTaxNumber = _data["incomeTaxNumber"];
            this.socsoAccountNumber = _data["socsoAccountNumber"];
            this.socsoContributionSchedule = _data["socsoContributionSchedule"];
            this.eisAccountNumber = _data["eisAccountNumber"];
            this.zakatAccountNumber = _data["zakatAccountNumber"];
            this.zakatState = _data["zakatState"];
            this.zakatAmount = _data["zakatAmount"];
            this.asnbAccountNumber = _data["asnbAccountNumber"];
            this.asnbAmount = _data["asnbAmount"];
            this.ptptnAccountNumber = _data["ptptnAccountNumber"];
            this.ptptnAmount = _data["ptptnAmount"];
            this.tabungHajiAccountNumber = _data["tabungHajiAccountNumber"];
            this.tabungHajiAmount = _data["tabungHajiAmount"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["password"] = this.password;
        data["lastVisitedMerchantStore"] = this.lastVisitedMerchantStore;
        data["mobile"] = this.mobile;
        data["imagePath"] = this.imagePath;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["presentAddress1"] = this.presentAddress1;
        data["presentAddress2"] = this.presentAddress2;
        data["presentAddress3"] = this.presentAddress3;
        data["presentAddress4"] = this.presentAddress4;
        data["permanentAddress1"] = this.permanentAddress1;
        data["permanentAddress2"] = this.permanentAddress2;
        data["permanentAddress3"] = this.permanentAddress3;
        data["permanentAddress4"] = this.permanentAddress4;
        data["basicSalary"] = this.basicSalary;
        data["status"] = this.status;
        data["joiningDate"] = this.joiningDate ? this.joiningDate.toISOString() : <any>undefined;
        data["resignDate"] = this.resignDate ? this.resignDate.toISOString() : <any>undefined;
        data["departmentId"] = this.departmentId;
        data["designationId"] = this.designationId;
        data["bankName"] = this.bankName;
        data["accountName"] = this.accountName;
        data["accountNumber"] = this.accountNumber;
        data["swiftCode"] = this.swiftCode;
        data["branch"] = this.branch;
        data["cv"] = this.cv;
        data["nationalId"] = this.nationalId;
        data["other"] = this.other;
        data["icUrl"] = this.icUrl;
        data["otherUrl"] = this.otherUrl;
        data["staffId"] = this.staffId;
        data["isResident"] = this.isResident;
        data["identificationType"] = this.identificationType;
        data["identificationNo"] = this.identificationNo;
        data["religion"] = this.religion;
        data["ethnicity"] = this.ethnicity;
        data["maritalStatus"] = this.maritalStatus;
        data["disability"] = this.disability;
        data["country"] = this.country;
        data["postcode"] = this.postcode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["highestEducation"] = this.highestEducation;
        data["educationSpecialisation"] = this.educationSpecialisation;
        data["isSpecialWorker"] = this.isSpecialWorker;
        data["salaryType"] = this.salaryType;
        data["salaryPaymentMethod"] = this.salaryPaymentMethod;
        data["epfNumber"] = this.epfNumber;
        data["incomeTaxNumber"] = this.incomeTaxNumber;
        data["socsoAccountNumber"] = this.socsoAccountNumber;
        data["socsoContributionSchedule"] = this.socsoContributionSchedule;
        data["eisAccountNumber"] = this.eisAccountNumber;
        data["zakatAccountNumber"] = this.zakatAccountNumber;
        data["zakatState"] = this.zakatState;
        data["zakatAmount"] = this.zakatAmount;
        data["asnbAccountNumber"] = this.asnbAccountNumber;
        data["asnbAmount"] = this.asnbAmount;
        data["ptptnAccountNumber"] = this.ptptnAccountNumber;
        data["ptptnAmount"] = this.ptptnAmount;
        data["tabungHajiAccountNumber"] = this.tabungHajiAccountNumber;
        data["tabungHajiAmount"] = this.tabungHajiAmount;
        return data;
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string;
    lastVisitedMerchantStore: string | undefined;
    mobile: string | undefined;
    imagePath: string | undefined;
    dateOfBirth: moment.Moment;
    gender: string | undefined;
    presentAddress1: string | undefined;
    presentAddress2: string | undefined;
    presentAddress3: string | undefined;
    presentAddress4: string | undefined;
    permanentAddress1: string | undefined;
    permanentAddress2: string | undefined;
    permanentAddress3: string | undefined;
    permanentAddress4: string | undefined;
    basicSalary: number;
    status: number;
    joiningDate: moment.Moment;
    resignDate: moment.Moment;
    departmentId: number;
    designationId: number;
    bankName: string | undefined;
    accountName: string | undefined;
    accountNumber: string | undefined;
    swiftCode: string | undefined;
    branch: string | undefined;
    cv: string | undefined;
    nationalId: string | undefined;
    other: string | undefined;
    icUrl: string | undefined;
    otherUrl: string | undefined;
    staffId: string | undefined;
    isResident: boolean;
    identificationType: string | undefined;
    identificationNo: string | undefined;
    religion: string | undefined;
    ethnicity: string | undefined;
    maritalStatus: string | undefined;
    disability: boolean;
    country: string | undefined;
    postcode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    highestEducation: string | undefined;
    educationSpecialisation: string | undefined;
    isSpecialWorker: boolean;
    salaryType: SalaryType;
    salaryPaymentMethod: boolean;
    epfNumber: string | undefined;
    incomeTaxNumber: string | undefined;
    socsoAccountNumber: string | undefined;
    socsoContributionSchedule: number;
    eisAccountNumber: string | undefined;
    zakatAccountNumber: string | undefined;
    zakatState: string | undefined;
    zakatAmount: number;
    asnbAccountNumber: string | undefined;
    asnbAmount: number;
    ptptnAccountNumber: string | undefined;
    ptptnAmount: number;
    tabungHajiAccountNumber: string | undefined;
    tabungHajiAmount: number;
}

export class CreateWishlistDto implements ICreateWishlistDto {
    userId: number;
    tenantId: number;
    productId: string;
    name: string;
    quantity: number;
    unitPrice: number;
    discount: number;
    tax: number;
    taxCode: string | undefined;
    docId: string | undefined;

    constructor(data?: ICreateWishlistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.productId = _data["productId"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.discount = _data["discount"];
            this.tax = _data["tax"];
            this.taxCode = _data["taxCode"];
            this.docId = _data["docId"];
        }
    }

    static fromJS(data: any): CreateWishlistDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWishlistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["productId"] = this.productId;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["discount"] = this.discount;
        data["tax"] = this.tax;
        data["taxCode"] = this.taxCode;
        data["docId"] = this.docId;
        return data;
    }

    clone(): CreateWishlistDto {
        const json = this.toJSON();
        let result = new CreateWishlistDto();
        result.init(json);
        return result;
    }
}

export interface ICreateWishlistDto {
    userId: number;
    tenantId: number;
    productId: string;
    name: string;
    quantity: number;
    unitPrice: number;
    discount: number;
    tax: number;
    taxCode: string | undefined;
    docId: string | undefined;
}

export class CreditNote implements ICreditNote {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    billId: string;
    creditNoteNo: string | undefined;
    description: string | undefined;
    quantity: number;
    price: number;
    productId: string | undefined;
    unitPrice: number;
    discount: number;
    tax: number;
    tenantId: number | undefined;
    creditNote: number;
    productShelfId: number | undefined;
    supportingDocumentUrl: string | undefined;
    productShelf: InventoryProductOnShelf;

    constructor(data?: ICreditNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.billId = _data["billId"];
            this.creditNoteNo = _data["creditNoteNo"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.price = _data["price"];
            this.productId = _data["productId"];
            this.unitPrice = _data["unitPrice"];
            this.discount = _data["discount"];
            this.tax = _data["tax"];
            this.tenantId = _data["tenantId"];
            this.creditNote = _data["creditNote"];
            this.productShelfId = _data["productShelfId"];
            this.supportingDocumentUrl = _data["supportingDocumentUrl"];
            this.productShelf = _data["productShelf"] ? InventoryProductOnShelf.fromJS(_data["productShelf"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreditNote {
        data = typeof data === 'object' ? data : {};
        let result = new CreditNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["billId"] = this.billId;
        data["creditNoteNo"] = this.creditNoteNo;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["productId"] = this.productId;
        data["unitPrice"] = this.unitPrice;
        data["discount"] = this.discount;
        data["tax"] = this.tax;
        data["tenantId"] = this.tenantId;
        data["creditNote"] = this.creditNote;
        data["productShelfId"] = this.productShelfId;
        data["supportingDocumentUrl"] = this.supportingDocumentUrl;
        data["productShelf"] = this.productShelf ? this.productShelf.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreditNote {
        const json = this.toJSON();
        let result = new CreditNote();
        result.init(json);
        return result;
    }
}

export interface ICreditNote {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    billId: string;
    creditNoteNo: string | undefined;
    description: string | undefined;
    quantity: number;
    price: number;
    productId: string | undefined;
    unitPrice: number;
    discount: number;
    tax: number;
    tenantId: number | undefined;
    creditNote: number;
    productShelfId: number | undefined;
    supportingDocumentUrl: string | undefined;
    productShelf: InventoryProductOnShelf;
}

export class CreditNoteDto implements ICreditNoteDto {
    billId: string;
    creditnoteId: number;
    creditNoteNo: string | undefined;
    description: string | undefined;
    quantity: number;
    price: number;
    productId: string | undefined;
    unitPrice: number;
    discount: number;
    tax: number;
    tenantId: number | undefined;
    productShelfId: number | undefined;
    productShelf: InventoryProductOnShelf;
    supportingDocumentUrl: string | undefined;

    constructor(data?: ICreditNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billId = _data["billId"];
            this.creditnoteId = _data["creditnoteId"];
            this.creditNoteNo = _data["creditNoteNo"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.price = _data["price"];
            this.productId = _data["productId"];
            this.unitPrice = _data["unitPrice"];
            this.discount = _data["discount"];
            this.tax = _data["tax"];
            this.tenantId = _data["tenantId"];
            this.productShelfId = _data["productShelfId"];
            this.productShelf = _data["productShelf"] ? InventoryProductOnShelf.fromJS(_data["productShelf"]) : <any>undefined;
            this.supportingDocumentUrl = _data["supportingDocumentUrl"];
        }
    }

    static fromJS(data: any): CreditNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billId"] = this.billId;
        data["creditnoteId"] = this.creditnoteId;
        data["creditNoteNo"] = this.creditNoteNo;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["productId"] = this.productId;
        data["unitPrice"] = this.unitPrice;
        data["discount"] = this.discount;
        data["tax"] = this.tax;
        data["tenantId"] = this.tenantId;
        data["productShelfId"] = this.productShelfId;
        data["productShelf"] = this.productShelf ? this.productShelf.toJSON() : <any>undefined;
        data["supportingDocumentUrl"] = this.supportingDocumentUrl;
        return data;
    }

    clone(): CreditNoteDto {
        const json = this.toJSON();
        let result = new CreditNoteDto();
        result.init(json);
        return result;
    }
}

export interface ICreditNoteDto {
    billId: string;
    creditnoteId: number;
    creditNoteNo: string | undefined;
    description: string | undefined;
    quantity: number;
    price: number;
    productId: string | undefined;
    unitPrice: number;
    discount: number;
    tax: number;
    tenantId: number | undefined;
    productShelfId: number | undefined;
    productShelf: InventoryProductOnShelf;
    supportingDocumentUrl: string | undefined;
}

export class CurrencyResponseDto implements ICurrencyResponseDto {
    base: string | undefined;
    date: string | undefined;
    usd: number;
    gbp: number;
    eur: number;
    sgd: number;
    idr: number;
    cny: number;
    jpy: number;

    constructor(data?: ICurrencyResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base = _data["base"];
            this.date = _data["date"];
            this.usd = _data["usd"];
            this.gbp = _data["gbp"];
            this.eur = _data["eur"];
            this.sgd = _data["sgd"];
            this.idr = _data["idr"];
            this.cny = _data["cny"];
            this.jpy = _data["jpy"];
        }
    }

    static fromJS(data: any): CurrencyResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base"] = this.base;
        data["date"] = this.date;
        data["usd"] = this.usd;
        data["gbp"] = this.gbp;
        data["eur"] = this.eur;
        data["sgd"] = this.sgd;
        data["idr"] = this.idr;
        data["cny"] = this.cny;
        data["jpy"] = this.jpy;
        return data;
    }

    clone(): CurrencyResponseDto {
        const json = this.toJSON();
        let result = new CurrencyResponseDto();
        result.init(json);
        return result;
    }
}

export interface ICurrencyResponseDto {
    base: string | undefined;
    date: string | undefined;
    usd: number;
    gbp: number;
    eur: number;
    sgd: number;
    idr: number;
    cny: number;
    jpy: number;
}

export class Customer implements ICustomer {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string;
    companyRegNo: string | undefined;
    contactNo: string;
    email: string | undefined;
    billingAddress1: string;
    billingAddress2: string | undefined;
    postCode: string;
    city: string;
    state: string;
    country: string;
    tenantId: number | undefined;
    tenant: Tenant;
    customertypeId: number;
    firstName: string | undefined;
    lastName: string | undefined;
    middleTitle: string | undefined;
    userId: number;
    creditRating: string | undefined;
    paymentTerm: number;
    creditDocumentUrl: string | undefined;
    code: string | undefined;
    sstRegistrationNo: string | undefined;
    taxIdentificationNumber: string | undefined;
    currency: string | undefined;

    constructor(data?: ICustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.companyRegNo = _data["companyRegNo"];
            this.contactNo = _data["contactNo"];
            this.email = _data["email"];
            this.billingAddress1 = _data["billingAddress1"];
            this.billingAddress2 = _data["billingAddress2"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.customertypeId = _data["customertypeId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleTitle = _data["middleTitle"];
            this.userId = _data["userId"];
            this.creditRating = _data["creditRating"];
            this.paymentTerm = _data["paymentTerm"];
            this.creditDocumentUrl = _data["creditDocumentUrl"];
            this.code = _data["code"];
            this.sstRegistrationNo = _data["sstRegistrationNo"];
            this.taxIdentificationNumber = _data["taxIdentificationNumber"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): Customer {
        data = typeof data === 'object' ? data : {};
        let result = new Customer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["companyRegNo"] = this.companyRegNo;
        data["contactNo"] = this.contactNo;
        data["email"] = this.email;
        data["billingAddress1"] = this.billingAddress1;
        data["billingAddress2"] = this.billingAddress2;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["customertypeId"] = this.customertypeId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleTitle"] = this.middleTitle;
        data["userId"] = this.userId;
        data["creditRating"] = this.creditRating;
        data["paymentTerm"] = this.paymentTerm;
        data["creditDocumentUrl"] = this.creditDocumentUrl;
        data["code"] = this.code;
        data["sstRegistrationNo"] = this.sstRegistrationNo;
        data["taxIdentificationNumber"] = this.taxIdentificationNumber;
        data["currency"] = this.currency;
        return data;
    }

    clone(): Customer {
        const json = this.toJSON();
        let result = new Customer();
        result.init(json);
        return result;
    }
}

export interface ICustomer {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string;
    companyRegNo: string | undefined;
    contactNo: string;
    email: string | undefined;
    billingAddress1: string;
    billingAddress2: string | undefined;
    postCode: string;
    city: string;
    state: string;
    country: string;
    tenantId: number | undefined;
    tenant: Tenant;
    customertypeId: number;
    firstName: string | undefined;
    lastName: string | undefined;
    middleTitle: string | undefined;
    userId: number;
    creditRating: string | undefined;
    paymentTerm: number;
    creditDocumentUrl: string | undefined;
    code: string | undefined;
    sstRegistrationNo: string | undefined;
    taxIdentificationNumber: string | undefined;
    currency: string | undefined;
}

export class CustomerDto implements ICustomerDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    companyRegNo: string | undefined;
    contactNo: string | undefined;
    email: string | undefined;
    billingAddress1: string | undefined;
    billingAddress2: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    tenantId: number;
    customertypeId: number;
    firstName: string | undefined;
    lastName: string | undefined;
    middleTitle: string | undefined;
    userId: number;
    creditRating: string | undefined;
    paymentTerm: number;
    creditDocumentUrl: string | undefined;
    billList: BillDto[] | undefined;
    overdueBillList: BillDto[] | undefined;
    openingBalance: number;
    billServices: BillService[] | undefined;
    creditNoteSum: number;
    allCreditNoteSum: number;
    creditNoteTaxSum: number;
    previousBillList: BillDto[] | undefined;
    code: string | undefined;
    sstRegistrationNo: string | undefined;
    taxIdentificationNumber: string | undefined;
    currency: string | undefined;

    constructor(data?: ICustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.companyRegNo = _data["companyRegNo"];
            this.contactNo = _data["contactNo"];
            this.email = _data["email"];
            this.billingAddress1 = _data["billingAddress1"];
            this.billingAddress2 = _data["billingAddress2"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.tenantId = _data["tenantId"];
            this.customertypeId = _data["customertypeId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleTitle = _data["middleTitle"];
            this.userId = _data["userId"];
            this.creditRating = _data["creditRating"];
            this.paymentTerm = _data["paymentTerm"];
            this.creditDocumentUrl = _data["creditDocumentUrl"];
            if (Array.isArray(_data["billList"])) {
                this.billList = [] as any;
                for (let item of _data["billList"])
                    this.billList.push(BillDto.fromJS(item));
            }
            if (Array.isArray(_data["overdueBillList"])) {
                this.overdueBillList = [] as any;
                for (let item of _data["overdueBillList"])
                    this.overdueBillList.push(BillDto.fromJS(item));
            }
            this.openingBalance = _data["openingBalance"];
            if (Array.isArray(_data["billServices"])) {
                this.billServices = [] as any;
                for (let item of _data["billServices"])
                    this.billServices.push(BillService.fromJS(item));
            }
            this.creditNoteSum = _data["creditNoteSum"];
            this.allCreditNoteSum = _data["allCreditNoteSum"];
            this.creditNoteTaxSum = _data["creditNoteTaxSum"];
            if (Array.isArray(_data["previousBillList"])) {
                this.previousBillList = [] as any;
                for (let item of _data["previousBillList"])
                    this.previousBillList.push(BillDto.fromJS(item));
            }
            this.code = _data["code"];
            this.sstRegistrationNo = _data["sstRegistrationNo"];
            this.taxIdentificationNumber = _data["taxIdentificationNumber"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): CustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["companyRegNo"] = this.companyRegNo;
        data["contactNo"] = this.contactNo;
        data["email"] = this.email;
        data["billingAddress1"] = this.billingAddress1;
        data["billingAddress2"] = this.billingAddress2;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["tenantId"] = this.tenantId;
        data["customertypeId"] = this.customertypeId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleTitle"] = this.middleTitle;
        data["userId"] = this.userId;
        data["creditRating"] = this.creditRating;
        data["paymentTerm"] = this.paymentTerm;
        data["creditDocumentUrl"] = this.creditDocumentUrl;
        if (Array.isArray(this.billList)) {
            data["billList"] = [];
            for (let item of this.billList)
                data["billList"].push(item.toJSON());
        }
        if (Array.isArray(this.overdueBillList)) {
            data["overdueBillList"] = [];
            for (let item of this.overdueBillList)
                data["overdueBillList"].push(item.toJSON());
        }
        data["openingBalance"] = this.openingBalance;
        if (Array.isArray(this.billServices)) {
            data["billServices"] = [];
            for (let item of this.billServices)
                data["billServices"].push(item.toJSON());
        }
        data["creditNoteSum"] = this.creditNoteSum;
        data["allCreditNoteSum"] = this.allCreditNoteSum;
        data["creditNoteTaxSum"] = this.creditNoteTaxSum;
        if (Array.isArray(this.previousBillList)) {
            data["previousBillList"] = [];
            for (let item of this.previousBillList)
                data["previousBillList"].push(item.toJSON());
        }
        data["code"] = this.code;
        data["sstRegistrationNo"] = this.sstRegistrationNo;
        data["taxIdentificationNumber"] = this.taxIdentificationNumber;
        data["currency"] = this.currency;
        return data;
    }

    clone(): CustomerDto {
        const json = this.toJSON();
        let result = new CustomerDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    companyRegNo: string | undefined;
    contactNo: string | undefined;
    email: string | undefined;
    billingAddress1: string | undefined;
    billingAddress2: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    tenantId: number;
    customertypeId: number;
    firstName: string | undefined;
    lastName: string | undefined;
    middleTitle: string | undefined;
    userId: number;
    creditRating: string | undefined;
    paymentTerm: number;
    creditDocumentUrl: string | undefined;
    billList: BillDto[] | undefined;
    overdueBillList: BillDto[] | undefined;
    openingBalance: number;
    billServices: BillService[] | undefined;
    creditNoteSum: number;
    allCreditNoteSum: number;
    creditNoteTaxSum: number;
    previousBillList: BillDto[] | undefined;
    code: string | undefined;
    sstRegistrationNo: string | undefined;
    taxIdentificationNumber: string | undefined;
    currency: string | undefined;
}

export class CustomerDtoPagedResultDto implements ICustomerDtoPagedResultDto {
    items: CustomerDto[] | undefined;
    totalCount: number;

    constructor(data?: ICustomerDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CustomerDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomerDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CustomerDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CustomerDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerDtoPagedResultDto {
    items: CustomerDto[] | undefined;
    totalCount: number;
}

export class CustomerMigrationDto implements ICustomerMigrationDto {
    name: string | undefined;
    companyRegNo: string | undefined;
    contactNo: string | undefined;
    email: string | undefined;
    billingAddress1: string | undefined;
    billingAddress2: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    customertypeId: number;
    isValid: boolean;
    error: string | undefined;

    constructor(data?: ICustomerMigrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.companyRegNo = _data["companyRegNo"];
            this.contactNo = _data["contactNo"];
            this.email = _data["email"];
            this.billingAddress1 = _data["billingAddress1"];
            this.billingAddress2 = _data["billingAddress2"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.customertypeId = _data["customertypeId"];
            this.isValid = _data["isValid"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): CustomerMigrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerMigrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["companyRegNo"] = this.companyRegNo;
        data["contactNo"] = this.contactNo;
        data["email"] = this.email;
        data["billingAddress1"] = this.billingAddress1;
        data["billingAddress2"] = this.billingAddress2;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["customertypeId"] = this.customertypeId;
        data["isValid"] = this.isValid;
        data["error"] = this.error;
        return data;
    }

    clone(): CustomerMigrationDto {
        const json = this.toJSON();
        let result = new CustomerMigrationDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerMigrationDto {
    name: string | undefined;
    companyRegNo: string | undefined;
    contactNo: string | undefined;
    email: string | undefined;
    billingAddress1: string | undefined;
    billingAddress2: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    customertypeId: number;
    isValid: boolean;
    error: string | undefined;
}

export class CustomerOutstanding implements ICustomerOutstanding {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    customerId: string;
    year: number;
    month: number;
    description: string | undefined;
    outstandingAmount: number;
    paidAmount: number;

    constructor(data?: ICustomerOutstanding) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.customerId = _data["customerId"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.description = _data["description"];
            this.outstandingAmount = _data["outstandingAmount"];
            this.paidAmount = _data["paidAmount"];
        }
    }

    static fromJS(data: any): CustomerOutstanding {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerOutstanding();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["customerId"] = this.customerId;
        data["year"] = this.year;
        data["month"] = this.month;
        data["description"] = this.description;
        data["outstandingAmount"] = this.outstandingAmount;
        data["paidAmount"] = this.paidAmount;
        return data;
    }

    clone(): CustomerOutstanding {
        const json = this.toJSON();
        let result = new CustomerOutstanding();
        result.init(json);
        return result;
    }
}

export interface ICustomerOutstanding {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    customerId: string;
    year: number;
    month: number;
    description: string | undefined;
    outstandingAmount: number;
    paidAmount: number;
}

export class CustomerOutstandingDto implements ICustomerOutstandingDto {
    customerId: string;
    year: number;
    month: number;
    description: string | undefined;
    outstandingAmount: number;
    paidAmount: number;
    customerOutstandingId: number;

    constructor(data?: ICustomerOutstandingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.description = _data["description"];
            this.outstandingAmount = _data["outstandingAmount"];
            this.paidAmount = _data["paidAmount"];
            this.customerOutstandingId = _data["customerOutstandingId"];
        }
    }

    static fromJS(data: any): CustomerOutstandingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerOutstandingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["year"] = this.year;
        data["month"] = this.month;
        data["description"] = this.description;
        data["outstandingAmount"] = this.outstandingAmount;
        data["paidAmount"] = this.paidAmount;
        data["customerOutstandingId"] = this.customerOutstandingId;
        return data;
    }

    clone(): CustomerOutstandingDto {
        const json = this.toJSON();
        let result = new CustomerOutstandingDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerOutstandingDto {
    customerId: string;
    year: number;
    month: number;
    description: string | undefined;
    outstandingAmount: number;
    paidAmount: number;
    customerOutstandingId: number;
}

export class CustomerShippingAddress implements ICustomerShippingAddress {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    customerId: string;
    name: string | undefined;
    address1: string | undefined;
    address2: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;

    constructor(data?: ICustomerShippingAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.customerId = _data["customerId"];
            this.name = _data["name"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): CustomerShippingAddress {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerShippingAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["customerId"] = this.customerId;
        data["name"] = this.name;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        return data;
    }

    clone(): CustomerShippingAddress {
        const json = this.toJSON();
        let result = new CustomerShippingAddress();
        result.init(json);
        return result;
    }
}

export interface ICustomerShippingAddress {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    customerId: string;
    name: string | undefined;
    address1: string | undefined;
    address2: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
}

export class CustomerShippingAddressDto implements ICustomerShippingAddressDto {
    customerId: string;
    name: string | undefined;
    address1: string | undefined;
    address2: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    shippingAddressId: number;

    constructor(data?: ICustomerShippingAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.name = _data["name"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.shippingAddressId = _data["shippingAddressId"];
        }
    }

    static fromJS(data: any): CustomerShippingAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerShippingAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["name"] = this.name;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["shippingAddressId"] = this.shippingAddressId;
        return data;
    }

    clone(): CustomerShippingAddressDto {
        const json = this.toJSON();
        let result = new CustomerShippingAddressDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerShippingAddressDto {
    customerId: string;
    name: string | undefined;
    address1: string | undefined;
    address2: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    shippingAddressId: number;
}

export class DashboardInfoDto implements IDashboardInfoDto {
    lastFiveNotifications: NoticeModel[] | undefined;
    lastFiveHolidays: HolidayModel[] | undefined;
    totalAbsent: number;
    totalDepartment: number;
    totalEmployee: number;
    totalPresent: number;

    constructor(data?: IDashboardInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["lastFiveNotifications"])) {
                this.lastFiveNotifications = [] as any;
                for (let item of _data["lastFiveNotifications"])
                    this.lastFiveNotifications.push(NoticeModel.fromJS(item));
            }
            if (Array.isArray(_data["lastFiveHolidays"])) {
                this.lastFiveHolidays = [] as any;
                for (let item of _data["lastFiveHolidays"])
                    this.lastFiveHolidays.push(HolidayModel.fromJS(item));
            }
            this.totalAbsent = _data["totalAbsent"];
            this.totalDepartment = _data["totalDepartment"];
            this.totalEmployee = _data["totalEmployee"];
            this.totalPresent = _data["totalPresent"];
        }
    }

    static fromJS(data: any): DashboardInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lastFiveNotifications)) {
            data["lastFiveNotifications"] = [];
            for (let item of this.lastFiveNotifications)
                data["lastFiveNotifications"].push(item.toJSON());
        }
        if (Array.isArray(this.lastFiveHolidays)) {
            data["lastFiveHolidays"] = [];
            for (let item of this.lastFiveHolidays)
                data["lastFiveHolidays"].push(item.toJSON());
        }
        data["totalAbsent"] = this.totalAbsent;
        data["totalDepartment"] = this.totalDepartment;
        data["totalEmployee"] = this.totalEmployee;
        data["totalPresent"] = this.totalPresent;
        return data;
    }

    clone(): DashboardInfoDto {
        const json = this.toJSON();
        let result = new DashboardInfoDto();
        result.init(json);
        return result;
    }
}

export interface IDashboardInfoDto {
    lastFiveNotifications: NoticeModel[] | undefined;
    lastFiveHolidays: HolidayModel[] | undefined;
    totalAbsent: number;
    totalDepartment: number;
    totalEmployee: number;
    totalPresent: number;
}

export class DealerDto implements IDealerDto {
    companyRegNo: string | undefined;
    companyName: string | undefined;
    contactNo: string | undefined;
    email: string | undefined;
    address1: string | undefined;
    address2: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    accountFullName: string | undefined;
    accountEmailAddress: string | undefined;
    accountPassword: string | undefined;
    businessCompanyRegNo: string | undefined;
    businessAddress: string | undefined;
    bnmCode: string | undefined;
    picName: string | undefined;
    picPosition: string | undefined;
    picEmailAddress: string | undefined;
    picPhoneNumber: string | undefined;
    companyLogo: string | undefined;
    bankName: string | undefined;
    bankAccountHolder: string | undefined;
    bankAccountNo: string | undefined;
    invoiceTemplate: number | undefined;
    brandingColor: string | undefined;
    invoiceMessage: string | undefined;
    invoiceTnC: string | undefined;
    remarkMessage: string | undefined;
    revenue: string | undefined;
    numberOfEmployees: number;
    tutorialCompleted: boolean;
    dayDueReminder: number;
    billplzEmail: string | undefined;
    billplzPhone: string | undefined;
    billplzPassword: string | undefined;
    billplzStatusId: number;
    billplzCollectionId: string | undefined;
    billplzSecretKey: string | undefined;
    invoiceApproval: boolean;
    requisitionApproval: boolean;
    customerApproval: boolean;
    productApproval: boolean;
    mainBannerUrl: string | undefined;
    mainBannerTitle: string | undefined;
    mainBannerDescription: string | undefined;
    lastActive: moment.Moment;
    hideFromMarketplace: boolean;
    websiteLink: string | undefined;
    facebookLink: string | undefined;
    youtubeLink: string | undefined;
    whatsappLink: string | undefined;
    secondaryBankName: string | undefined;
    secondaryBankAccountHolder: string | undefined;
    secondaryBankAccountNo: string | undefined;
    secondaryBannerUrl: string | undefined;
    secondaryBannerTitle: string | undefined;
    secondaryBannerDescription: string | undefined;
    isScfOnboarded: boolean;
    scfTenancyName: string | undefined;
    scfTenantId: number;
    scfEmail: string | undefined;
    scfPassword: string | undefined;
    scfApplicationStatus: number;
    scfSupplierId: number;
    purchaseOrderMessage: string | undefined;
    quotationMessage: string | undefined;
    poDeliveryDueReminder: number;
    producerTenantId: number;
    billList: Bill[] | undefined;
    prList: PurchaseRequisition[] | undefined;

    constructor(data?: IDealerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyRegNo = _data["companyRegNo"];
            this.companyName = _data["companyName"];
            this.contactNo = _data["contactNo"];
            this.email = _data["email"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.accountFullName = _data["accountFullName"];
            this.accountEmailAddress = _data["accountEmailAddress"];
            this.accountPassword = _data["accountPassword"];
            this.businessCompanyRegNo = _data["businessCompanyRegNo"];
            this.businessAddress = _data["businessAddress"];
            this.bnmCode = _data["bnmCode"];
            this.picName = _data["picName"];
            this.picPosition = _data["picPosition"];
            this.picEmailAddress = _data["picEmailAddress"];
            this.picPhoneNumber = _data["picPhoneNumber"];
            this.companyLogo = _data["companyLogo"];
            this.bankName = _data["bankName"];
            this.bankAccountHolder = _data["bankAccountHolder"];
            this.bankAccountNo = _data["bankAccountNo"];
            this.invoiceTemplate = _data["invoiceTemplate"];
            this.brandingColor = _data["brandingColor"];
            this.invoiceMessage = _data["invoiceMessage"];
            this.invoiceTnC = _data["invoiceTnC"];
            this.remarkMessage = _data["remarkMessage"];
            this.revenue = _data["revenue"];
            this.numberOfEmployees = _data["numberOfEmployees"];
            this.tutorialCompleted = _data["tutorialCompleted"];
            this.dayDueReminder = _data["dayDueReminder"];
            this.billplzEmail = _data["billplzEmail"];
            this.billplzPhone = _data["billplzPhone"];
            this.billplzPassword = _data["billplzPassword"];
            this.billplzStatusId = _data["billplzStatusId"];
            this.billplzCollectionId = _data["billplzCollectionId"];
            this.billplzSecretKey = _data["billplzSecretKey"];
            this.invoiceApproval = _data["invoiceApproval"];
            this.requisitionApproval = _data["requisitionApproval"];
            this.customerApproval = _data["customerApproval"];
            this.productApproval = _data["productApproval"];
            this.mainBannerUrl = _data["mainBannerUrl"];
            this.mainBannerTitle = _data["mainBannerTitle"];
            this.mainBannerDescription = _data["mainBannerDescription"];
            this.lastActive = _data["lastActive"] ? moment(_data["lastActive"].toString()) : <any>undefined;
            this.hideFromMarketplace = _data["hideFromMarketplace"];
            this.websiteLink = _data["websiteLink"];
            this.facebookLink = _data["facebookLink"];
            this.youtubeLink = _data["youtubeLink"];
            this.whatsappLink = _data["whatsappLink"];
            this.secondaryBankName = _data["secondaryBankName"];
            this.secondaryBankAccountHolder = _data["secondaryBankAccountHolder"];
            this.secondaryBankAccountNo = _data["secondaryBankAccountNo"];
            this.secondaryBannerUrl = _data["secondaryBannerUrl"];
            this.secondaryBannerTitle = _data["secondaryBannerTitle"];
            this.secondaryBannerDescription = _data["secondaryBannerDescription"];
            this.isScfOnboarded = _data["isScfOnboarded"];
            this.scfTenancyName = _data["scfTenancyName"];
            this.scfTenantId = _data["scfTenantId"];
            this.scfEmail = _data["scfEmail"];
            this.scfPassword = _data["scfPassword"];
            this.scfApplicationStatus = _data["scfApplicationStatus"];
            this.scfSupplierId = _data["scfSupplierId"];
            this.purchaseOrderMessage = _data["purchaseOrderMessage"];
            this.quotationMessage = _data["quotationMessage"];
            this.poDeliveryDueReminder = _data["poDeliveryDueReminder"];
            this.producerTenantId = _data["producerTenantId"];
            if (Array.isArray(_data["billList"])) {
                this.billList = [] as any;
                for (let item of _data["billList"])
                    this.billList.push(Bill.fromJS(item));
            }
            if (Array.isArray(_data["prList"])) {
                this.prList = [] as any;
                for (let item of _data["prList"])
                    this.prList.push(PurchaseRequisition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DealerDto {
        data = typeof data === 'object' ? data : {};
        let result = new DealerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyRegNo"] = this.companyRegNo;
        data["companyName"] = this.companyName;
        data["contactNo"] = this.contactNo;
        data["email"] = this.email;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["accountFullName"] = this.accountFullName;
        data["accountEmailAddress"] = this.accountEmailAddress;
        data["accountPassword"] = this.accountPassword;
        data["businessCompanyRegNo"] = this.businessCompanyRegNo;
        data["businessAddress"] = this.businessAddress;
        data["bnmCode"] = this.bnmCode;
        data["picName"] = this.picName;
        data["picPosition"] = this.picPosition;
        data["picEmailAddress"] = this.picEmailAddress;
        data["picPhoneNumber"] = this.picPhoneNumber;
        data["companyLogo"] = this.companyLogo;
        data["bankName"] = this.bankName;
        data["bankAccountHolder"] = this.bankAccountHolder;
        data["bankAccountNo"] = this.bankAccountNo;
        data["invoiceTemplate"] = this.invoiceTemplate;
        data["brandingColor"] = this.brandingColor;
        data["invoiceMessage"] = this.invoiceMessage;
        data["invoiceTnC"] = this.invoiceTnC;
        data["remarkMessage"] = this.remarkMessage;
        data["revenue"] = this.revenue;
        data["numberOfEmployees"] = this.numberOfEmployees;
        data["tutorialCompleted"] = this.tutorialCompleted;
        data["dayDueReminder"] = this.dayDueReminder;
        data["billplzEmail"] = this.billplzEmail;
        data["billplzPhone"] = this.billplzPhone;
        data["billplzPassword"] = this.billplzPassword;
        data["billplzStatusId"] = this.billplzStatusId;
        data["billplzCollectionId"] = this.billplzCollectionId;
        data["billplzSecretKey"] = this.billplzSecretKey;
        data["invoiceApproval"] = this.invoiceApproval;
        data["requisitionApproval"] = this.requisitionApproval;
        data["customerApproval"] = this.customerApproval;
        data["productApproval"] = this.productApproval;
        data["mainBannerUrl"] = this.mainBannerUrl;
        data["mainBannerTitle"] = this.mainBannerTitle;
        data["mainBannerDescription"] = this.mainBannerDescription;
        data["lastActive"] = this.lastActive ? this.lastActive.toISOString() : <any>undefined;
        data["hideFromMarketplace"] = this.hideFromMarketplace;
        data["websiteLink"] = this.websiteLink;
        data["facebookLink"] = this.facebookLink;
        data["youtubeLink"] = this.youtubeLink;
        data["whatsappLink"] = this.whatsappLink;
        data["secondaryBankName"] = this.secondaryBankName;
        data["secondaryBankAccountHolder"] = this.secondaryBankAccountHolder;
        data["secondaryBankAccountNo"] = this.secondaryBankAccountNo;
        data["secondaryBannerUrl"] = this.secondaryBannerUrl;
        data["secondaryBannerTitle"] = this.secondaryBannerTitle;
        data["secondaryBannerDescription"] = this.secondaryBannerDescription;
        data["isScfOnboarded"] = this.isScfOnboarded;
        data["scfTenancyName"] = this.scfTenancyName;
        data["scfTenantId"] = this.scfTenantId;
        data["scfEmail"] = this.scfEmail;
        data["scfPassword"] = this.scfPassword;
        data["scfApplicationStatus"] = this.scfApplicationStatus;
        data["scfSupplierId"] = this.scfSupplierId;
        data["purchaseOrderMessage"] = this.purchaseOrderMessage;
        data["quotationMessage"] = this.quotationMessage;
        data["poDeliveryDueReminder"] = this.poDeliveryDueReminder;
        data["producerTenantId"] = this.producerTenantId;
        if (Array.isArray(this.billList)) {
            data["billList"] = [];
            for (let item of this.billList)
                data["billList"].push(item.toJSON());
        }
        if (Array.isArray(this.prList)) {
            data["prList"] = [];
            for (let item of this.prList)
                data["prList"].push(item.toJSON());
        }
        return data;
    }

    clone(): DealerDto {
        const json = this.toJSON();
        let result = new DealerDto();
        result.init(json);
        return result;
    }
}

export interface IDealerDto {
    companyRegNo: string | undefined;
    companyName: string | undefined;
    contactNo: string | undefined;
    email: string | undefined;
    address1: string | undefined;
    address2: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    accountFullName: string | undefined;
    accountEmailAddress: string | undefined;
    accountPassword: string | undefined;
    businessCompanyRegNo: string | undefined;
    businessAddress: string | undefined;
    bnmCode: string | undefined;
    picName: string | undefined;
    picPosition: string | undefined;
    picEmailAddress: string | undefined;
    picPhoneNumber: string | undefined;
    companyLogo: string | undefined;
    bankName: string | undefined;
    bankAccountHolder: string | undefined;
    bankAccountNo: string | undefined;
    invoiceTemplate: number | undefined;
    brandingColor: string | undefined;
    invoiceMessage: string | undefined;
    invoiceTnC: string | undefined;
    remarkMessage: string | undefined;
    revenue: string | undefined;
    numberOfEmployees: number;
    tutorialCompleted: boolean;
    dayDueReminder: number;
    billplzEmail: string | undefined;
    billplzPhone: string | undefined;
    billplzPassword: string | undefined;
    billplzStatusId: number;
    billplzCollectionId: string | undefined;
    billplzSecretKey: string | undefined;
    invoiceApproval: boolean;
    requisitionApproval: boolean;
    customerApproval: boolean;
    productApproval: boolean;
    mainBannerUrl: string | undefined;
    mainBannerTitle: string | undefined;
    mainBannerDescription: string | undefined;
    lastActive: moment.Moment;
    hideFromMarketplace: boolean;
    websiteLink: string | undefined;
    facebookLink: string | undefined;
    youtubeLink: string | undefined;
    whatsappLink: string | undefined;
    secondaryBankName: string | undefined;
    secondaryBankAccountHolder: string | undefined;
    secondaryBankAccountNo: string | undefined;
    secondaryBannerUrl: string | undefined;
    secondaryBannerTitle: string | undefined;
    secondaryBannerDescription: string | undefined;
    isScfOnboarded: boolean;
    scfTenancyName: string | undefined;
    scfTenantId: number;
    scfEmail: string | undefined;
    scfPassword: string | undefined;
    scfApplicationStatus: number;
    scfSupplierId: number;
    purchaseOrderMessage: string | undefined;
    quotationMessage: string | undefined;
    poDeliveryDueReminder: number;
    producerTenantId: number;
    billList: Bill[] | undefined;
    prList: PurchaseRequisition[] | undefined;
}

export class DebitNote implements IDebitNote {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    date: moment.Moment | undefined;
    scannedDocumentUrl: string | undefined;
    scannedDocumentFileName: string | undefined;
    remarks: string | undefined;
    debitNoteReferenceNo: string | undefined;
    accountCharged: string | undefined;
    approvalStatusInt: number;
    approveRemarks: string | undefined;
    approvedDate: moment.Moment | undefined;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    preparerUserId: number;
    preparerUserName: string | undefined;
    preparerUserEmail: string | undefined;
    approverUserId: number | undefined;
    approverUserName: string | undefined;
    approverUserEmail: string | undefined;
    personToDebitName: string | undefined;
    personToDebitCompanyName: string | undefined;
    personToDebitAddress: string | undefined;
    personToDebitEmail: string | undefined;
    personToDebitContactNo: string | undefined;
    customerId: string | undefined;
    customer: Customer;
    vendorId: number | undefined;
    vendor: Vendor;

    constructor(data?: IDebitNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.scannedDocumentUrl = _data["scannedDocumentUrl"];
            this.scannedDocumentFileName = _data["scannedDocumentFileName"];
            this.remarks = _data["remarks"];
            this.debitNoteReferenceNo = _data["debitNoteReferenceNo"];
            this.accountCharged = _data["accountCharged"];
            this.approvalStatusInt = _data["approvalStatusInt"];
            this.approveRemarks = _data["approveRemarks"];
            this.approvedDate = _data["approvedDate"] ? moment(_data["approvedDate"].toString()) : <any>undefined;
            this.categoryCode = _data["categoryCode"];
            this.categoryName = _data["categoryName"];
            this.preparerUserId = _data["preparerUserId"];
            this.preparerUserName = _data["preparerUserName"];
            this.preparerUserEmail = _data["preparerUserEmail"];
            this.approverUserId = _data["approverUserId"];
            this.approverUserName = _data["approverUserName"];
            this.approverUserEmail = _data["approverUserEmail"];
            this.personToDebitName = _data["personToDebitName"];
            this.personToDebitCompanyName = _data["personToDebitCompanyName"];
            this.personToDebitAddress = _data["personToDebitAddress"];
            this.personToDebitEmail = _data["personToDebitEmail"];
            this.personToDebitContactNo = _data["personToDebitContactNo"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.vendorId = _data["vendorId"];
            this.vendor = _data["vendor"] ? Vendor.fromJS(_data["vendor"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DebitNote {
        data = typeof data === 'object' ? data : {};
        let result = new DebitNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["scannedDocumentUrl"] = this.scannedDocumentUrl;
        data["scannedDocumentFileName"] = this.scannedDocumentFileName;
        data["remarks"] = this.remarks;
        data["debitNoteReferenceNo"] = this.debitNoteReferenceNo;
        data["accountCharged"] = this.accountCharged;
        data["approvalStatusInt"] = this.approvalStatusInt;
        data["approveRemarks"] = this.approveRemarks;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["preparerUserId"] = this.preparerUserId;
        data["preparerUserName"] = this.preparerUserName;
        data["preparerUserEmail"] = this.preparerUserEmail;
        data["approverUserId"] = this.approverUserId;
        data["approverUserName"] = this.approverUserName;
        data["approverUserEmail"] = this.approverUserEmail;
        data["personToDebitName"] = this.personToDebitName;
        data["personToDebitCompanyName"] = this.personToDebitCompanyName;
        data["personToDebitAddress"] = this.personToDebitAddress;
        data["personToDebitEmail"] = this.personToDebitEmail;
        data["personToDebitContactNo"] = this.personToDebitContactNo;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["vendorId"] = this.vendorId;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        return data;
    }

    clone(): DebitNote {
        const json = this.toJSON();
        let result = new DebitNote();
        result.init(json);
        return result;
    }
}

export interface IDebitNote {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    date: moment.Moment | undefined;
    scannedDocumentUrl: string | undefined;
    scannedDocumentFileName: string | undefined;
    remarks: string | undefined;
    debitNoteReferenceNo: string | undefined;
    accountCharged: string | undefined;
    approvalStatusInt: number;
    approveRemarks: string | undefined;
    approvedDate: moment.Moment | undefined;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    preparerUserId: number;
    preparerUserName: string | undefined;
    preparerUserEmail: string | undefined;
    approverUserId: number | undefined;
    approverUserName: string | undefined;
    approverUserEmail: string | undefined;
    personToDebitName: string | undefined;
    personToDebitCompanyName: string | undefined;
    personToDebitAddress: string | undefined;
    personToDebitEmail: string | undefined;
    personToDebitContactNo: string | undefined;
    customerId: string | undefined;
    customer: Customer;
    vendorId: number | undefined;
    vendor: Vendor;
}

export class DebitNoteDto implements IDebitNoteDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    date: moment.Moment | undefined;
    scannedDocumentUrl: string | undefined;
    scannedDocumentFileName: string | undefined;
    remarks: string | undefined;
    debitNoteReferenceNo: string | undefined;
    accountCharged: string | undefined;
    approvalStatusInt: number;
    readonly approvalStatusText: string | undefined;
    approveRemarks: string | undefined;
    approvedDate: moment.Moment | undefined;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    preparerUserId: number;
    preparerUserName: string | undefined;
    preparerUserEmail: string | undefined;
    approverUserId: number | undefined;
    approverUserName: string | undefined;
    approverUserEmail: string | undefined;
    personToDebitName: string | undefined;
    personToDebitCompanyName: string | undefined;
    personToDebitAddress: string | undefined;
    personToDebitEmail: string | undefined;
    personToDebitContactNo: string | undefined;
    customerId: string | undefined;
    customer: Customer;
    vendorId: number | undefined;
    vendor: Vendor;
    debitNoteItemsDto: DebitNoteItemDto[] | undefined;
    totalPurchaseAmount: number;
    totalTaxAmount: number;
    totalAmount: number;

    constructor(data?: IDebitNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.scannedDocumentUrl = _data["scannedDocumentUrl"];
            this.scannedDocumentFileName = _data["scannedDocumentFileName"];
            this.remarks = _data["remarks"];
            this.debitNoteReferenceNo = _data["debitNoteReferenceNo"];
            this.accountCharged = _data["accountCharged"];
            this.approvalStatusInt = _data["approvalStatusInt"];
            (<any>this).approvalStatusText = _data["approvalStatusText"];
            this.approveRemarks = _data["approveRemarks"];
            this.approvedDate = _data["approvedDate"] ? moment(_data["approvedDate"].toString()) : <any>undefined;
            this.categoryCode = _data["categoryCode"];
            this.categoryName = _data["categoryName"];
            this.preparerUserId = _data["preparerUserId"];
            this.preparerUserName = _data["preparerUserName"];
            this.preparerUserEmail = _data["preparerUserEmail"];
            this.approverUserId = _data["approverUserId"];
            this.approverUserName = _data["approverUserName"];
            this.approverUserEmail = _data["approverUserEmail"];
            this.personToDebitName = _data["personToDebitName"];
            this.personToDebitCompanyName = _data["personToDebitCompanyName"];
            this.personToDebitAddress = _data["personToDebitAddress"];
            this.personToDebitEmail = _data["personToDebitEmail"];
            this.personToDebitContactNo = _data["personToDebitContactNo"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.vendorId = _data["vendorId"];
            this.vendor = _data["vendor"] ? Vendor.fromJS(_data["vendor"]) : <any>undefined;
            if (Array.isArray(_data["debitNoteItemsDto"])) {
                this.debitNoteItemsDto = [] as any;
                for (let item of _data["debitNoteItemsDto"])
                    this.debitNoteItemsDto.push(DebitNoteItemDto.fromJS(item));
            }
            this.totalPurchaseAmount = _data["totalPurchaseAmount"];
            this.totalTaxAmount = _data["totalTaxAmount"];
            this.totalAmount = _data["totalAmount"];
        }
    }

    static fromJS(data: any): DebitNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new DebitNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["scannedDocumentUrl"] = this.scannedDocumentUrl;
        data["scannedDocumentFileName"] = this.scannedDocumentFileName;
        data["remarks"] = this.remarks;
        data["debitNoteReferenceNo"] = this.debitNoteReferenceNo;
        data["accountCharged"] = this.accountCharged;
        data["approvalStatusInt"] = this.approvalStatusInt;
        data["approvalStatusText"] = this.approvalStatusText;
        data["approveRemarks"] = this.approveRemarks;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["preparerUserId"] = this.preparerUserId;
        data["preparerUserName"] = this.preparerUserName;
        data["preparerUserEmail"] = this.preparerUserEmail;
        data["approverUserId"] = this.approverUserId;
        data["approverUserName"] = this.approverUserName;
        data["approverUserEmail"] = this.approverUserEmail;
        data["personToDebitName"] = this.personToDebitName;
        data["personToDebitCompanyName"] = this.personToDebitCompanyName;
        data["personToDebitAddress"] = this.personToDebitAddress;
        data["personToDebitEmail"] = this.personToDebitEmail;
        data["personToDebitContactNo"] = this.personToDebitContactNo;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["vendorId"] = this.vendorId;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        if (Array.isArray(this.debitNoteItemsDto)) {
            data["debitNoteItemsDto"] = [];
            for (let item of this.debitNoteItemsDto)
                data["debitNoteItemsDto"].push(item.toJSON());
        }
        data["totalPurchaseAmount"] = this.totalPurchaseAmount;
        data["totalTaxAmount"] = this.totalTaxAmount;
        data["totalAmount"] = this.totalAmount;
        return data;
    }

    clone(): DebitNoteDto {
        const json = this.toJSON();
        let result = new DebitNoteDto();
        result.init(json);
        return result;
    }
}

export interface IDebitNoteDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    date: moment.Moment | undefined;
    scannedDocumentUrl: string | undefined;
    scannedDocumentFileName: string | undefined;
    remarks: string | undefined;
    debitNoteReferenceNo: string | undefined;
    accountCharged: string | undefined;
    approvalStatusInt: number;
    approvalStatusText: string | undefined;
    approveRemarks: string | undefined;
    approvedDate: moment.Moment | undefined;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    preparerUserId: number;
    preparerUserName: string | undefined;
    preparerUserEmail: string | undefined;
    approverUserId: number | undefined;
    approverUserName: string | undefined;
    approverUserEmail: string | undefined;
    personToDebitName: string | undefined;
    personToDebitCompanyName: string | undefined;
    personToDebitAddress: string | undefined;
    personToDebitEmail: string | undefined;
    personToDebitContactNo: string | undefined;
    customerId: string | undefined;
    customer: Customer;
    vendorId: number | undefined;
    vendor: Vendor;
    debitNoteItemsDto: DebitNoteItemDto[] | undefined;
    totalPurchaseAmount: number;
    totalTaxAmount: number;
    totalAmount: number;
}

export class DebitNoteDtoPagedResultDto implements IDebitNoteDtoPagedResultDto {
    items: DebitNoteDto[] | undefined;
    totalCount: number;

    constructor(data?: IDebitNoteDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DebitNoteDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DebitNoteDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DebitNoteDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DebitNoteDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DebitNoteDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDebitNoteDtoPagedResultDto {
    items: DebitNoteDto[] | undefined;
    totalCount: number;
}

export class DebitNoteItemDto implements IDebitNoteItemDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    debitNoteId: number;
    debitNote: DebitNote;
    itemDescription: string | undefined;
    itemQuantity: number;
    itemAmount: number;
    taxCode: string | undefined;
    taxRate: number;
    readonly purchaseAmount: number;
    readonly taxAmount: number;
    readonly totalAmount: number;

    constructor(data?: IDebitNoteItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.debitNoteId = _data["debitNoteId"];
            this.debitNote = _data["debitNote"] ? DebitNote.fromJS(_data["debitNote"]) : <any>undefined;
            this.itemDescription = _data["itemDescription"];
            this.itemQuantity = _data["itemQuantity"];
            this.itemAmount = _data["itemAmount"];
            this.taxCode = _data["taxCode"];
            this.taxRate = _data["taxRate"];
            (<any>this).purchaseAmount = _data["purchaseAmount"];
            (<any>this).taxAmount = _data["taxAmount"];
            (<any>this).totalAmount = _data["totalAmount"];
        }
    }

    static fromJS(data: any): DebitNoteItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new DebitNoteItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["debitNoteId"] = this.debitNoteId;
        data["debitNote"] = this.debitNote ? this.debitNote.toJSON() : <any>undefined;
        data["itemDescription"] = this.itemDescription;
        data["itemQuantity"] = this.itemQuantity;
        data["itemAmount"] = this.itemAmount;
        data["taxCode"] = this.taxCode;
        data["taxRate"] = this.taxRate;
        data["purchaseAmount"] = this.purchaseAmount;
        data["taxAmount"] = this.taxAmount;
        data["totalAmount"] = this.totalAmount;
        return data;
    }

    clone(): DebitNoteItemDto {
        const json = this.toJSON();
        let result = new DebitNoteItemDto();
        result.init(json);
        return result;
    }
}

export interface IDebitNoteItemDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    debitNoteId: number;
    debitNote: DebitNote;
    itemDescription: string | undefined;
    itemQuantity: number;
    itemAmount: number;
    taxCode: string | undefined;
    taxRate: number;
    purchaseAmount: number;
    taxAmount: number;
    totalAmount: number;
}

export class DebitNoteItemDtoPagedResultDto implements IDebitNoteItemDtoPagedResultDto {
    items: DebitNoteItemDto[] | undefined;
    totalCount: number;

    constructor(data?: IDebitNoteItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DebitNoteItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DebitNoteItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DebitNoteItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DebitNoteItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DebitNoteItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDebitNoteItemDtoPagedResultDto {
    items: DebitNoteItemDto[] | undefined;
    totalCount: number;
}

export class Department implements IDepartment {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    departmentName: string | undefined;
    parentId: number;
    headOfDepartmentId: number;
    headOfDepartmentName: string | undefined;
    headOfDepartmentEmail: string | undefined;
    isCapex: boolean;
    isOpex: boolean;
    isResale: boolean;
    isManufacturing: boolean;
    isProject: boolean;
    limitCapex: number;
    limitOpex: number;
    limitResale: number;
    limitManufacturing: number;
    limitProject: number;

    constructor(data?: IDepartment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.departmentName = _data["departmentName"];
            this.parentId = _data["parentId"];
            this.headOfDepartmentId = _data["headOfDepartmentId"];
            this.headOfDepartmentName = _data["headOfDepartmentName"];
            this.headOfDepartmentEmail = _data["headOfDepartmentEmail"];
            this.isCapex = _data["isCapex"];
            this.isOpex = _data["isOpex"];
            this.isResale = _data["isResale"];
            this.isManufacturing = _data["isManufacturing"];
            this.isProject = _data["isProject"];
            this.limitCapex = _data["limitCapex"];
            this.limitOpex = _data["limitOpex"];
            this.limitResale = _data["limitResale"];
            this.limitManufacturing = _data["limitManufacturing"];
            this.limitProject = _data["limitProject"];
        }
    }

    static fromJS(data: any): Department {
        data = typeof data === 'object' ? data : {};
        let result = new Department();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["departmentName"] = this.departmentName;
        data["parentId"] = this.parentId;
        data["headOfDepartmentId"] = this.headOfDepartmentId;
        data["headOfDepartmentName"] = this.headOfDepartmentName;
        data["headOfDepartmentEmail"] = this.headOfDepartmentEmail;
        data["isCapex"] = this.isCapex;
        data["isOpex"] = this.isOpex;
        data["isResale"] = this.isResale;
        data["isManufacturing"] = this.isManufacturing;
        data["isProject"] = this.isProject;
        data["limitCapex"] = this.limitCapex;
        data["limitOpex"] = this.limitOpex;
        data["limitResale"] = this.limitResale;
        data["limitManufacturing"] = this.limitManufacturing;
        data["limitProject"] = this.limitProject;
        return data;
    }

    clone(): Department {
        const json = this.toJSON();
        let result = new Department();
        result.init(json);
        return result;
    }
}

export interface IDepartment {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    departmentName: string | undefined;
    parentId: number;
    headOfDepartmentId: number;
    headOfDepartmentName: string | undefined;
    headOfDepartmentEmail: string | undefined;
    isCapex: boolean;
    isOpex: boolean;
    isResale: boolean;
    isManufacturing: boolean;
    isProject: boolean;
    limitCapex: number;
    limitOpex: number;
    limitResale: number;
    limitManufacturing: number;
    limitProject: number;
}

export class DepartmentDto implements IDepartmentDto {
    departmentId: number;
    tenantId: number;
    departmentName: string | undefined;
    parentId: number;
    headOfDepartmentId: number;
    headOfDepartment: UserDto;
    headOfDepartmentName: string | undefined;
    headOfDepartmentEmail: string | undefined;
    isCapex: boolean;
    isOpex: boolean;
    isResale: boolean;
    isManufacturing: boolean;
    isProject: boolean;
    limitCapex: number;
    limitOpex: number;
    limitResale: number;
    limitManufacturing: number;
    limitProject: number;

    constructor(data?: IDepartmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentId = _data["departmentId"];
            this.tenantId = _data["tenantId"];
            this.departmentName = _data["departmentName"];
            this.parentId = _data["parentId"];
            this.headOfDepartmentId = _data["headOfDepartmentId"];
            this.headOfDepartment = _data["headOfDepartment"] ? UserDto.fromJS(_data["headOfDepartment"]) : <any>undefined;
            this.headOfDepartmentName = _data["headOfDepartmentName"];
            this.headOfDepartmentEmail = _data["headOfDepartmentEmail"];
            this.isCapex = _data["isCapex"];
            this.isOpex = _data["isOpex"];
            this.isResale = _data["isResale"];
            this.isManufacturing = _data["isManufacturing"];
            this.isProject = _data["isProject"];
            this.limitCapex = _data["limitCapex"];
            this.limitOpex = _data["limitOpex"];
            this.limitResale = _data["limitResale"];
            this.limitManufacturing = _data["limitManufacturing"];
            this.limitProject = _data["limitProject"];
        }
    }

    static fromJS(data: any): DepartmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentId"] = this.departmentId;
        data["tenantId"] = this.tenantId;
        data["departmentName"] = this.departmentName;
        data["parentId"] = this.parentId;
        data["headOfDepartmentId"] = this.headOfDepartmentId;
        data["headOfDepartment"] = this.headOfDepartment ? this.headOfDepartment.toJSON() : <any>undefined;
        data["headOfDepartmentName"] = this.headOfDepartmentName;
        data["headOfDepartmentEmail"] = this.headOfDepartmentEmail;
        data["isCapex"] = this.isCapex;
        data["isOpex"] = this.isOpex;
        data["isResale"] = this.isResale;
        data["isManufacturing"] = this.isManufacturing;
        data["isProject"] = this.isProject;
        data["limitCapex"] = this.limitCapex;
        data["limitOpex"] = this.limitOpex;
        data["limitResale"] = this.limitResale;
        data["limitManufacturing"] = this.limitManufacturing;
        data["limitProject"] = this.limitProject;
        return data;
    }

    clone(): DepartmentDto {
        const json = this.toJSON();
        let result = new DepartmentDto();
        result.init(json);
        return result;
    }
}

export interface IDepartmentDto {
    departmentId: number;
    tenantId: number;
    departmentName: string | undefined;
    parentId: number;
    headOfDepartmentId: number;
    headOfDepartment: UserDto;
    headOfDepartmentName: string | undefined;
    headOfDepartmentEmail: string | undefined;
    isCapex: boolean;
    isOpex: boolean;
    isResale: boolean;
    isManufacturing: boolean;
    isProject: boolean;
    limitCapex: number;
    limitOpex: number;
    limitResale: number;
    limitManufacturing: number;
    limitProject: number;
}

export class DepartmentPagedResultDto implements IDepartmentPagedResultDto {
    items: Department[] | undefined;
    totalCount: number;

    constructor(data?: IDepartmentPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(Department.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DepartmentPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DepartmentPagedResultDto {
        const json = this.toJSON();
        let result = new DepartmentPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDepartmentPagedResultDto {
    items: Department[] | undefined;
    totalCount: number;
}

export class DesignationModel implements IDesignationModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string;
    departmentId: number;
    department: Department;
    tenantId: number;
    designationLevel: number;

    constructor(data?: IDesignationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.departmentId = _data["departmentId"];
            this.department = _data["department"] ? Department.fromJS(_data["department"]) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.designationLevel = _data["designationLevel"];
        }
    }

    static fromJS(data: any): DesignationModel {
        data = typeof data === 'object' ? data : {};
        let result = new DesignationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["departmentId"] = this.departmentId;
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["designationLevel"] = this.designationLevel;
        return data;
    }

    clone(): DesignationModel {
        const json = this.toJSON();
        let result = new DesignationModel();
        result.init(json);
        return result;
    }
}

export interface IDesignationModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string;
    departmentId: number;
    department: Department;
    tenantId: number;
    designationLevel: number;
}

export class DesignationModelDto implements IDesignationModelDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    departmentId: number;
    department: Department;
    tenantId: number;
    designationLevel: number;

    constructor(data?: IDesignationModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.departmentId = _data["departmentId"];
            this.department = _data["department"] ? Department.fromJS(_data["department"]) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.designationLevel = _data["designationLevel"];
        }
    }

    static fromJS(data: any): DesignationModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new DesignationModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["departmentId"] = this.departmentId;
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["designationLevel"] = this.designationLevel;
        return data;
    }

    clone(): DesignationModelDto {
        const json = this.toJSON();
        let result = new DesignationModelDto();
        result.init(json);
        return result;
    }
}

export interface IDesignationModelDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string | undefined;
    departmentId: number;
    department: Department;
    tenantId: number;
    designationLevel: number;
}

export class DesignationModelDtoPagedResultDto implements IDesignationModelDtoPagedResultDto {
    items: DesignationModelDto[] | undefined;
    totalCount: number;

    constructor(data?: IDesignationModelDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DesignationModelDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DesignationModelDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DesignationModelDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DesignationModelDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DesignationModelDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDesignationModelDtoPagedResultDto {
    items: DesignationModelDto[] | undefined;
    totalCount: number;
}

export class DocumentDetailsDto implements IDocumentDetailsDto {
    uuid: string | undefined;
    submissionUid: string | undefined;
    longId: string | undefined;
    typeName: string | undefined;
    typeVersionName: string | undefined;
    issuerTin: string | undefined;
    issuerName: string | undefined;
    receiverId: string | undefined;
    receiverName: string | undefined;
    dateTimeReceived: moment.Moment;
    dateTimeValidated: moment.Moment;
    totalExcludingTax: number;
    totalDiscount: number;
    totalNetAmount: number;
    totalPayableAmount: number;
    status: string | undefined;
    createdByUserId: string | undefined;
    documentStatusReason: string | undefined;
    cancelDateTime: moment.Moment | undefined;
    rejectRequestDateTime: moment.Moment | undefined;
    validationResults: ValidationResultsDto;
    internalId: string | undefined;
    dateTimeIssued: moment.Moment;

    constructor(data?: IDocumentDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uuid = _data["uuid"];
            this.submissionUid = _data["submissionUid"];
            this.longId = _data["longId"];
            this.typeName = _data["typeName"];
            this.typeVersionName = _data["typeVersionName"];
            this.issuerTin = _data["issuerTin"];
            this.issuerName = _data["issuerName"];
            this.receiverId = _data["receiverId"];
            this.receiverName = _data["receiverName"];
            this.dateTimeReceived = _data["dateTimeReceived"] ? moment(_data["dateTimeReceived"].toString()) : <any>undefined;
            this.dateTimeValidated = _data["dateTimeValidated"] ? moment(_data["dateTimeValidated"].toString()) : <any>undefined;
            this.totalExcludingTax = _data["totalExcludingTax"];
            this.totalDiscount = _data["totalDiscount"];
            this.totalNetAmount = _data["totalNetAmount"];
            this.totalPayableAmount = _data["totalPayableAmount"];
            this.status = _data["status"];
            this.createdByUserId = _data["createdByUserId"];
            this.documentStatusReason = _data["documentStatusReason"];
            this.cancelDateTime = _data["cancelDateTime"] ? moment(_data["cancelDateTime"].toString()) : <any>undefined;
            this.rejectRequestDateTime = _data["rejectRequestDateTime"] ? moment(_data["rejectRequestDateTime"].toString()) : <any>undefined;
            this.validationResults = _data["validationResults"] ? ValidationResultsDto.fromJS(_data["validationResults"]) : <any>undefined;
            this.internalId = _data["internalId"];
            this.dateTimeIssued = _data["dateTimeIssued"] ? moment(_data["dateTimeIssued"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uuid"] = this.uuid;
        data["submissionUid"] = this.submissionUid;
        data["longId"] = this.longId;
        data["typeName"] = this.typeName;
        data["typeVersionName"] = this.typeVersionName;
        data["issuerTin"] = this.issuerTin;
        data["issuerName"] = this.issuerName;
        data["receiverId"] = this.receiverId;
        data["receiverName"] = this.receiverName;
        data["dateTimeReceived"] = this.dateTimeReceived ? this.dateTimeReceived.toISOString() : <any>undefined;
        data["dateTimeValidated"] = this.dateTimeValidated ? this.dateTimeValidated.toISOString() : <any>undefined;
        data["totalExcludingTax"] = this.totalExcludingTax;
        data["totalDiscount"] = this.totalDiscount;
        data["totalNetAmount"] = this.totalNetAmount;
        data["totalPayableAmount"] = this.totalPayableAmount;
        data["status"] = this.status;
        data["createdByUserId"] = this.createdByUserId;
        data["documentStatusReason"] = this.documentStatusReason;
        data["cancelDateTime"] = this.cancelDateTime ? this.cancelDateTime.toISOString() : <any>undefined;
        data["rejectRequestDateTime"] = this.rejectRequestDateTime ? this.rejectRequestDateTime.toISOString() : <any>undefined;
        data["validationResults"] = this.validationResults ? this.validationResults.toJSON() : <any>undefined;
        data["internalId"] = this.internalId;
        data["dateTimeIssued"] = this.dateTimeIssued ? this.dateTimeIssued.toISOString() : <any>undefined;
        return data;
    }

    clone(): DocumentDetailsDto {
        const json = this.toJSON();
        let result = new DocumentDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentDetailsDto {
    uuid: string | undefined;
    submissionUid: string | undefined;
    longId: string | undefined;
    typeName: string | undefined;
    typeVersionName: string | undefined;
    issuerTin: string | undefined;
    issuerName: string | undefined;
    receiverId: string | undefined;
    receiverName: string | undefined;
    dateTimeReceived: moment.Moment;
    dateTimeValidated: moment.Moment;
    totalExcludingTax: number;
    totalDiscount: number;
    totalNetAmount: number;
    totalPayableAmount: number;
    status: string | undefined;
    createdByUserId: string | undefined;
    documentStatusReason: string | undefined;
    cancelDateTime: moment.Moment | undefined;
    rejectRequestDateTime: moment.Moment | undefined;
    validationResults: ValidationResultsDto;
    internalId: string | undefined;
    dateTimeIssued: moment.Moment;
}

export class DocumentSubmissionDto implements IDocumentSubmissionDto {
    submissionUid: string | undefined;
    documentCount: number;
    dateTimeReceived: moment.Moment;
    overallStatus: string | undefined;
    documentSummary: DocumentSummaryDto[] | undefined;

    constructor(data?: IDocumentSubmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionUid = _data["submissionUid"];
            this.documentCount = _data["documentCount"];
            this.dateTimeReceived = _data["dateTimeReceived"] ? moment(_data["dateTimeReceived"].toString()) : <any>undefined;
            this.overallStatus = _data["overallStatus"];
            if (Array.isArray(_data["documentSummary"])) {
                this.documentSummary = [] as any;
                for (let item of _data["documentSummary"])
                    this.documentSummary.push(DocumentSummaryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentSubmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentSubmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionUid"] = this.submissionUid;
        data["documentCount"] = this.documentCount;
        data["dateTimeReceived"] = this.dateTimeReceived ? this.dateTimeReceived.toISOString() : <any>undefined;
        data["overallStatus"] = this.overallStatus;
        if (Array.isArray(this.documentSummary)) {
            data["documentSummary"] = [];
            for (let item of this.documentSummary)
                data["documentSummary"].push(item.toJSON());
        }
        return data;
    }

    clone(): DocumentSubmissionDto {
        const json = this.toJSON();
        let result = new DocumentSubmissionDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentSubmissionDto {
    submissionUid: string | undefined;
    documentCount: number;
    dateTimeReceived: moment.Moment;
    overallStatus: string | undefined;
    documentSummary: DocumentSummaryDto[] | undefined;
}

export class DocumentSummaryDto implements IDocumentSummaryDto {
    uuid: string | undefined;
    submissionUid: string | undefined;
    longId: string | undefined;
    internalId: string | undefined;
    typeName: string | undefined;
    typeVersionName: string | undefined;
    issuerTin: string | undefined;
    issuerName: string | undefined;
    receiverId: string | undefined;
    receiverName: string | undefined;
    dateTimeIssued: moment.Moment;
    dateTimeReceived: moment.Moment;
    dateTimeValidated: moment.Moment;
    totalPayableAmount: number;
    totalExcludingTax: number;
    totalDiscount: number;
    totalNetAmount: number;
    status: string | undefined;
    cancelDateTime: moment.Moment | undefined;
    rejectRequestDateTime: moment.Moment | undefined;
    documentStatusReason: string | undefined;
    createdByUserId: string | undefined;

    constructor(data?: IDocumentSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uuid = _data["uuid"];
            this.submissionUid = _data["submissionUid"];
            this.longId = _data["longId"];
            this.internalId = _data["internalId"];
            this.typeName = _data["typeName"];
            this.typeVersionName = _data["typeVersionName"];
            this.issuerTin = _data["issuerTin"];
            this.issuerName = _data["issuerName"];
            this.receiverId = _data["receiverId"];
            this.receiverName = _data["receiverName"];
            this.dateTimeIssued = _data["dateTimeIssued"] ? moment(_data["dateTimeIssued"].toString()) : <any>undefined;
            this.dateTimeReceived = _data["dateTimeReceived"] ? moment(_data["dateTimeReceived"].toString()) : <any>undefined;
            this.dateTimeValidated = _data["dateTimeValidated"] ? moment(_data["dateTimeValidated"].toString()) : <any>undefined;
            this.totalPayableAmount = _data["totalPayableAmount"];
            this.totalExcludingTax = _data["totalExcludingTax"];
            this.totalDiscount = _data["totalDiscount"];
            this.totalNetAmount = _data["totalNetAmount"];
            this.status = _data["status"];
            this.cancelDateTime = _data["cancelDateTime"] ? moment(_data["cancelDateTime"].toString()) : <any>undefined;
            this.rejectRequestDateTime = _data["rejectRequestDateTime"] ? moment(_data["rejectRequestDateTime"].toString()) : <any>undefined;
            this.documentStatusReason = _data["documentStatusReason"];
            this.createdByUserId = _data["createdByUserId"];
        }
    }

    static fromJS(data: any): DocumentSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uuid"] = this.uuid;
        data["submissionUid"] = this.submissionUid;
        data["longId"] = this.longId;
        data["internalId"] = this.internalId;
        data["typeName"] = this.typeName;
        data["typeVersionName"] = this.typeVersionName;
        data["issuerTin"] = this.issuerTin;
        data["issuerName"] = this.issuerName;
        data["receiverId"] = this.receiverId;
        data["receiverName"] = this.receiverName;
        data["dateTimeIssued"] = this.dateTimeIssued ? this.dateTimeIssued.toISOString() : <any>undefined;
        data["dateTimeReceived"] = this.dateTimeReceived ? this.dateTimeReceived.toISOString() : <any>undefined;
        data["dateTimeValidated"] = this.dateTimeValidated ? this.dateTimeValidated.toISOString() : <any>undefined;
        data["totalPayableAmount"] = this.totalPayableAmount;
        data["totalExcludingTax"] = this.totalExcludingTax;
        data["totalDiscount"] = this.totalDiscount;
        data["totalNetAmount"] = this.totalNetAmount;
        data["status"] = this.status;
        data["cancelDateTime"] = this.cancelDateTime ? this.cancelDateTime.toISOString() : <any>undefined;
        data["rejectRequestDateTime"] = this.rejectRequestDateTime ? this.rejectRequestDateTime.toISOString() : <any>undefined;
        data["documentStatusReason"] = this.documentStatusReason;
        data["createdByUserId"] = this.createdByUserId;
        return data;
    }

    clone(): DocumentSummaryDto {
        const json = this.toJSON();
        let result = new DocumentSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentSummaryDto {
    uuid: string | undefined;
    submissionUid: string | undefined;
    longId: string | undefined;
    internalId: string | undefined;
    typeName: string | undefined;
    typeVersionName: string | undefined;
    issuerTin: string | undefined;
    issuerName: string | undefined;
    receiverId: string | undefined;
    receiverName: string | undefined;
    dateTimeIssued: moment.Moment;
    dateTimeReceived: moment.Moment;
    dateTimeValidated: moment.Moment;
    totalPayableAmount: number;
    totalExcludingTax: number;
    totalDiscount: number;
    totalNetAmount: number;
    status: string | undefined;
    cancelDateTime: moment.Moment | undefined;
    rejectRequestDateTime: moment.Moment | undefined;
    documentStatusReason: string | undefined;
    createdByUserId: string | undefined;
}

export class DonationProgram implements IDonationProgram {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    focusId: number;
    focusArea: string | undefined;
    programName: string | undefined;
    description: string | undefined;
    cost: string | undefined;
    target: string | undefined;
    thumbnailUrl: string | undefined;
    detailsUrl: string | undefined;

    constructor(data?: IDonationProgram) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.focusId = _data["focusId"];
            this.focusArea = _data["focusArea"];
            this.programName = _data["programName"];
            this.description = _data["description"];
            this.cost = _data["cost"];
            this.target = _data["target"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.detailsUrl = _data["detailsUrl"];
        }
    }

    static fromJS(data: any): DonationProgram {
        data = typeof data === 'object' ? data : {};
        let result = new DonationProgram();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["focusId"] = this.focusId;
        data["focusArea"] = this.focusArea;
        data["programName"] = this.programName;
        data["description"] = this.description;
        data["cost"] = this.cost;
        data["target"] = this.target;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["detailsUrl"] = this.detailsUrl;
        return data;
    }

    clone(): DonationProgram {
        const json = this.toJSON();
        let result = new DonationProgram();
        result.init(json);
        return result;
    }
}

export interface IDonationProgram {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    focusId: number;
    focusArea: string | undefined;
    programName: string | undefined;
    description: string | undefined;
    cost: string | undefined;
    target: string | undefined;
    thumbnailUrl: string | undefined;
    detailsUrl: string | undefined;
}

export class DonationProgramDto implements IDonationProgramDto {
    focusId: number;
    focusArea: string | undefined;
    programName: string | undefined;
    description: string | undefined;
    cost: string | undefined;
    target: string | undefined;
    thumbnailUrl: string | undefined;
    detailsUrl: string | undefined;

    constructor(data?: IDonationProgramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.focusId = _data["focusId"];
            this.focusArea = _data["focusArea"];
            this.programName = _data["programName"];
            this.description = _data["description"];
            this.cost = _data["cost"];
            this.target = _data["target"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.detailsUrl = _data["detailsUrl"];
        }
    }

    static fromJS(data: any): DonationProgramDto {
        data = typeof data === 'object' ? data : {};
        let result = new DonationProgramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["focusId"] = this.focusId;
        data["focusArea"] = this.focusArea;
        data["programName"] = this.programName;
        data["description"] = this.description;
        data["cost"] = this.cost;
        data["target"] = this.target;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["detailsUrl"] = this.detailsUrl;
        return data;
    }

    clone(): DonationProgramDto {
        const json = this.toJSON();
        let result = new DonationProgramDto();
        result.init(json);
        return result;
    }
}

export interface IDonationProgramDto {
    focusId: number;
    focusArea: string | undefined;
    programName: string | undefined;
    description: string | undefined;
    cost: string | undefined;
    target: string | undefined;
    thumbnailUrl: string | undefined;
    detailsUrl: string | undefined;
}

export class DonationProgramPagedResultDto implements IDonationProgramPagedResultDto {
    items: DonationProgram[] | undefined;
    totalCount: number;

    constructor(data?: IDonationProgramPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(DonationProgram.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DonationProgramPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DonationProgramPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DonationProgramPagedResultDto {
        const json = this.toJSON();
        let result = new DonationProgramPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDonationProgramPagedResultDto {
    items: DonationProgram[] | undefined;
    totalCount: number;
}

export class DropoffPoint implements IDropoffPoint {
    point_id: string | undefined;
    point_name: string | undefined;
    point_contact: string | undefined;
    point_addr1: string | undefined;
    point_addr2: string | undefined;
    point_addr3: string | undefined;
    point_addr4: string | undefined;
    point_postcode: string | undefined;
    point_city: string | undefined;
    point_state: string | undefined;
    start_time: string | undefined;
    end_time: string | undefined;
    price: number;

    constructor(data?: IDropoffPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.point_id = _data["point_id"];
            this.point_name = _data["point_name"];
            this.point_contact = _data["point_contact"];
            this.point_addr1 = _data["point_addr1"];
            this.point_addr2 = _data["point_addr2"];
            this.point_addr3 = _data["point_addr3"];
            this.point_addr4 = _data["point_addr4"];
            this.point_postcode = _data["point_postcode"];
            this.point_city = _data["point_city"];
            this.point_state = _data["point_state"];
            this.start_time = _data["start_time"];
            this.end_time = _data["end_time"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): DropoffPoint {
        data = typeof data === 'object' ? data : {};
        let result = new DropoffPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["point_id"] = this.point_id;
        data["point_name"] = this.point_name;
        data["point_contact"] = this.point_contact;
        data["point_addr1"] = this.point_addr1;
        data["point_addr2"] = this.point_addr2;
        data["point_addr3"] = this.point_addr3;
        data["point_addr4"] = this.point_addr4;
        data["point_postcode"] = this.point_postcode;
        data["point_city"] = this.point_city;
        data["point_state"] = this.point_state;
        data["start_time"] = this.start_time;
        data["end_time"] = this.end_time;
        data["price"] = this.price;
        return data;
    }

    clone(): DropoffPoint {
        const json = this.toJSON();
        let result = new DropoffPoint();
        result.init(json);
        return result;
    }
}

export interface IDropoffPoint {
    point_id: string | undefined;
    point_name: string | undefined;
    point_contact: string | undefined;
    point_addr1: string | undefined;
    point_addr2: string | undefined;
    point_addr3: string | undefined;
    point_addr4: string | undefined;
    point_postcode: string | undefined;
    point_city: string | undefined;
    point_state: string | undefined;
    start_time: string | undefined;
    end_time: string | undefined;
    price: number;
}

export class EasyParcelOrder implements IEasyParcelOrder {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    orderId: string;
    reQ_ID: string | undefined;
    parcel_number: string | undefined;
    order_number: string | undefined;
    price: string | undefined;
    addon_price: string | undefined;
    shipment_price: string | undefined;
    insurance_charges: string | undefined;
    max_insurance_coverage: string | undefined;
    cod_charges: string | undefined;
    status: string | undefined;
    remarks: string | undefined;
    courier: string | undefined;
    collect_date: string | undefined;

    constructor(data?: IEasyParcelOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.orderId = _data["orderId"];
            this.reQ_ID = _data["reQ_ID"];
            this.parcel_number = _data["parcel_number"];
            this.order_number = _data["order_number"];
            this.price = _data["price"];
            this.addon_price = _data["addon_price"];
            this.shipment_price = _data["shipment_price"];
            this.insurance_charges = _data["insurance_charges"];
            this.max_insurance_coverage = _data["max_insurance_coverage"];
            this.cod_charges = _data["cod_charges"];
            this.status = _data["status"];
            this.remarks = _data["remarks"];
            this.courier = _data["courier"];
            this.collect_date = _data["collect_date"];
        }
    }

    static fromJS(data: any): EasyParcelOrder {
        data = typeof data === 'object' ? data : {};
        let result = new EasyParcelOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["orderId"] = this.orderId;
        data["reQ_ID"] = this.reQ_ID;
        data["parcel_number"] = this.parcel_number;
        data["order_number"] = this.order_number;
        data["price"] = this.price;
        data["addon_price"] = this.addon_price;
        data["shipment_price"] = this.shipment_price;
        data["insurance_charges"] = this.insurance_charges;
        data["max_insurance_coverage"] = this.max_insurance_coverage;
        data["cod_charges"] = this.cod_charges;
        data["status"] = this.status;
        data["remarks"] = this.remarks;
        data["courier"] = this.courier;
        data["collect_date"] = this.collect_date;
        return data;
    }

    clone(): EasyParcelOrder {
        const json = this.toJSON();
        let result = new EasyParcelOrder();
        result.init(json);
        return result;
    }
}

export interface IEasyParcelOrder {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    orderId: string;
    reQ_ID: string | undefined;
    parcel_number: string | undefined;
    order_number: string | undefined;
    price: string | undefined;
    addon_price: string | undefined;
    shipment_price: string | undefined;
    insurance_charges: string | undefined;
    max_insurance_coverage: string | undefined;
    cod_charges: string | undefined;
    status: string | undefined;
    remarks: string | undefined;
    courier: string | undefined;
    collect_date: string | undefined;
}

export class Edition implements IEdition {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string;
    displayName: string;

    constructor(data?: IEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): Edition {
        data = typeof data === 'object' ? data : {};
        let result = new Edition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        return data;
    }

    clone(): Edition {
        const json = this.toJSON();
        let result = new Edition();
        result.init(json);
        return result;
    }
}

export interface IEdition {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string;
    displayName: string;
}

export class EditionDto implements IEditionDto {
    name: string;
    displayName: string;

    constructor(data?: IEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): EditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        return data;
    }

    clone(): EditionDto {
        const json = this.toJSON();
        let result = new EditionDto();
        result.init(json);
        return result;
    }
}

export interface IEditionDto {
    name: string;
    displayName: string;
}

export class EmployeePaySlipModel implements IEmployeePaySlipModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    month: number;
    readonly monthString: string | undefined;
    year: number;
    userId: number;
    user: User;
    basicSalary: number;
    salaryType: SalaryType;
    cycleNo: number;
    salaryForThisCycle: number;
    worked: number;
    readonly proRatedSalary: number;
    allowanceTotal: number;
    deductionTotal: number;
    epfEmployeeContribution: number;
    socsoEmployeeContribution: number;
    eisEmployeeContribution: number;
    pcbEmployeeContribution: number;
    hrdfEmployeeContribution: number;
    employeeContribution: number;
    netSalary: number;
    epfEmployerContribution: number;
    socsoEmployerContribution: number;
    eisEmployerContribution: number;
    pcbEmployerContribution: number;
    hrdfEmployerContribution: number;
    employerContribution: number;
    status: string | undefined;
    isOptedOut: boolean;
    paymentDate: moment.Moment | undefined;
    payslipAllowanceList: PaySlipAllowanceModel[] | undefined;
    payslipDeductionList: PaySlipAllowanceModel[] | undefined;

    constructor(data?: IEmployeePaySlipModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.month = _data["month"];
            (<any>this).monthString = _data["monthString"];
            this.year = _data["year"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.basicSalary = _data["basicSalary"];
            this.salaryType = _data["salaryType"];
            this.cycleNo = _data["cycleNo"];
            this.salaryForThisCycle = _data["salaryForThisCycle"];
            this.worked = _data["worked"];
            (<any>this).proRatedSalary = _data["proRatedSalary"];
            this.allowanceTotal = _data["allowanceTotal"];
            this.deductionTotal = _data["deductionTotal"];
            this.epfEmployeeContribution = _data["epfEmployeeContribution"];
            this.socsoEmployeeContribution = _data["socsoEmployeeContribution"];
            this.eisEmployeeContribution = _data["eisEmployeeContribution"];
            this.pcbEmployeeContribution = _data["pcbEmployeeContribution"];
            this.hrdfEmployeeContribution = _data["hrdfEmployeeContribution"];
            this.employeeContribution = _data["employeeContribution"];
            this.netSalary = _data["netSalary"];
            this.epfEmployerContribution = _data["epfEmployerContribution"];
            this.socsoEmployerContribution = _data["socsoEmployerContribution"];
            this.eisEmployerContribution = _data["eisEmployerContribution"];
            this.pcbEmployerContribution = _data["pcbEmployerContribution"];
            this.hrdfEmployerContribution = _data["hrdfEmployerContribution"];
            this.employerContribution = _data["employerContribution"];
            this.status = _data["status"];
            this.isOptedOut = _data["isOptedOut"];
            this.paymentDate = _data["paymentDate"] ? moment(_data["paymentDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["payslipAllowanceList"])) {
                this.payslipAllowanceList = [] as any;
                for (let item of _data["payslipAllowanceList"])
                    this.payslipAllowanceList.push(PaySlipAllowanceModel.fromJS(item));
            }
            if (Array.isArray(_data["payslipDeductionList"])) {
                this.payslipDeductionList = [] as any;
                for (let item of _data["payslipDeductionList"])
                    this.payslipDeductionList.push(PaySlipAllowanceModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeePaySlipModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePaySlipModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["month"] = this.month;
        data["monthString"] = this.monthString;
        data["year"] = this.year;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["basicSalary"] = this.basicSalary;
        data["salaryType"] = this.salaryType;
        data["cycleNo"] = this.cycleNo;
        data["salaryForThisCycle"] = this.salaryForThisCycle;
        data["worked"] = this.worked;
        data["proRatedSalary"] = this.proRatedSalary;
        data["allowanceTotal"] = this.allowanceTotal;
        data["deductionTotal"] = this.deductionTotal;
        data["epfEmployeeContribution"] = this.epfEmployeeContribution;
        data["socsoEmployeeContribution"] = this.socsoEmployeeContribution;
        data["eisEmployeeContribution"] = this.eisEmployeeContribution;
        data["pcbEmployeeContribution"] = this.pcbEmployeeContribution;
        data["hrdfEmployeeContribution"] = this.hrdfEmployeeContribution;
        data["employeeContribution"] = this.employeeContribution;
        data["netSalary"] = this.netSalary;
        data["epfEmployerContribution"] = this.epfEmployerContribution;
        data["socsoEmployerContribution"] = this.socsoEmployerContribution;
        data["eisEmployerContribution"] = this.eisEmployerContribution;
        data["pcbEmployerContribution"] = this.pcbEmployerContribution;
        data["hrdfEmployerContribution"] = this.hrdfEmployerContribution;
        data["employerContribution"] = this.employerContribution;
        data["status"] = this.status;
        data["isOptedOut"] = this.isOptedOut;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        if (Array.isArray(this.payslipAllowanceList)) {
            data["payslipAllowanceList"] = [];
            for (let item of this.payslipAllowanceList)
                data["payslipAllowanceList"].push(item.toJSON());
        }
        if (Array.isArray(this.payslipDeductionList)) {
            data["payslipDeductionList"] = [];
            for (let item of this.payslipDeductionList)
                data["payslipDeductionList"].push(item.toJSON());
        }
        return data;
    }

    clone(): EmployeePaySlipModel {
        const json = this.toJSON();
        let result = new EmployeePaySlipModel();
        result.init(json);
        return result;
    }
}

export interface IEmployeePaySlipModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    month: number;
    monthString: string | undefined;
    year: number;
    userId: number;
    user: User;
    basicSalary: number;
    salaryType: SalaryType;
    cycleNo: number;
    salaryForThisCycle: number;
    worked: number;
    proRatedSalary: number;
    allowanceTotal: number;
    deductionTotal: number;
    epfEmployeeContribution: number;
    socsoEmployeeContribution: number;
    eisEmployeeContribution: number;
    pcbEmployeeContribution: number;
    hrdfEmployeeContribution: number;
    employeeContribution: number;
    netSalary: number;
    epfEmployerContribution: number;
    socsoEmployerContribution: number;
    eisEmployerContribution: number;
    pcbEmployerContribution: number;
    hrdfEmployerContribution: number;
    employerContribution: number;
    status: string | undefined;
    isOptedOut: boolean;
    paymentDate: moment.Moment | undefined;
    payslipAllowanceList: PaySlipAllowanceModel[] | undefined;
    payslipDeductionList: PaySlipAllowanceModel[] | undefined;
}

export class EmployeePaySlipModelDto implements IEmployeePaySlipModelDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    month: number;
    readonly monthString: string | undefined;
    year: number;
    userId: number;
    user: UserDto;
    basicSalary: number;
    salaryType: SalaryType;
    cycleNo: number;
    salaryForThisCycle: number;
    worked: number;
    readonly proRatedSalary: number;
    allowanceTotal: number;
    deductionTotal: number;
    epfEmployeeContribution: number;
    socsoEmployeeContribution: number;
    eisEmployeeContribution: number;
    pcbEmployeeContribution: number;
    hrdfEmployeeContribution: number;
    employeeContribution: number;
    netSalary: number;
    epfEmployerContribution: number;
    socsoEmployerContribution: number;
    eisEmployerContribution: number;
    pcbEmployerContribution: number;
    hrdfEmployerContribution: number;
    employerContribution: number;
    status: string | undefined;
    isOptedOut: boolean;
    paymentDate: moment.Moment | undefined;
    payslipAllowanceList: PaySlipAllowanceModel[] | undefined;
    payslipDeductionList: PaySlipAllowanceModel[] | undefined;
    eligibleAllowanceList: PaySlipAllowanceModelDto[] | undefined;
    eligibleDeductionList: PaySlipAllowanceModelDto[] | undefined;

    constructor(data?: IEmployeePaySlipModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.month = _data["month"];
            (<any>this).monthString = _data["monthString"];
            this.year = _data["year"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.basicSalary = _data["basicSalary"];
            this.salaryType = _data["salaryType"];
            this.cycleNo = _data["cycleNo"];
            this.salaryForThisCycle = _data["salaryForThisCycle"];
            this.worked = _data["worked"];
            (<any>this).proRatedSalary = _data["proRatedSalary"];
            this.allowanceTotal = _data["allowanceTotal"];
            this.deductionTotal = _data["deductionTotal"];
            this.epfEmployeeContribution = _data["epfEmployeeContribution"];
            this.socsoEmployeeContribution = _data["socsoEmployeeContribution"];
            this.eisEmployeeContribution = _data["eisEmployeeContribution"];
            this.pcbEmployeeContribution = _data["pcbEmployeeContribution"];
            this.hrdfEmployeeContribution = _data["hrdfEmployeeContribution"];
            this.employeeContribution = _data["employeeContribution"];
            this.netSalary = _data["netSalary"];
            this.epfEmployerContribution = _data["epfEmployerContribution"];
            this.socsoEmployerContribution = _data["socsoEmployerContribution"];
            this.eisEmployerContribution = _data["eisEmployerContribution"];
            this.pcbEmployerContribution = _data["pcbEmployerContribution"];
            this.hrdfEmployerContribution = _data["hrdfEmployerContribution"];
            this.employerContribution = _data["employerContribution"];
            this.status = _data["status"];
            this.isOptedOut = _data["isOptedOut"];
            this.paymentDate = _data["paymentDate"] ? moment(_data["paymentDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["payslipAllowanceList"])) {
                this.payslipAllowanceList = [] as any;
                for (let item of _data["payslipAllowanceList"])
                    this.payslipAllowanceList.push(PaySlipAllowanceModel.fromJS(item));
            }
            if (Array.isArray(_data["payslipDeductionList"])) {
                this.payslipDeductionList = [] as any;
                for (let item of _data["payslipDeductionList"])
                    this.payslipDeductionList.push(PaySlipAllowanceModel.fromJS(item));
            }
            if (Array.isArray(_data["eligibleAllowanceList"])) {
                this.eligibleAllowanceList = [] as any;
                for (let item of _data["eligibleAllowanceList"])
                    this.eligibleAllowanceList.push(PaySlipAllowanceModelDto.fromJS(item));
            }
            if (Array.isArray(_data["eligibleDeductionList"])) {
                this.eligibleDeductionList = [] as any;
                for (let item of _data["eligibleDeductionList"])
                    this.eligibleDeductionList.push(PaySlipAllowanceModelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeePaySlipModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePaySlipModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["month"] = this.month;
        data["monthString"] = this.monthString;
        data["year"] = this.year;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["basicSalary"] = this.basicSalary;
        data["salaryType"] = this.salaryType;
        data["cycleNo"] = this.cycleNo;
        data["salaryForThisCycle"] = this.salaryForThisCycle;
        data["worked"] = this.worked;
        data["proRatedSalary"] = this.proRatedSalary;
        data["allowanceTotal"] = this.allowanceTotal;
        data["deductionTotal"] = this.deductionTotal;
        data["epfEmployeeContribution"] = this.epfEmployeeContribution;
        data["socsoEmployeeContribution"] = this.socsoEmployeeContribution;
        data["eisEmployeeContribution"] = this.eisEmployeeContribution;
        data["pcbEmployeeContribution"] = this.pcbEmployeeContribution;
        data["hrdfEmployeeContribution"] = this.hrdfEmployeeContribution;
        data["employeeContribution"] = this.employeeContribution;
        data["netSalary"] = this.netSalary;
        data["epfEmployerContribution"] = this.epfEmployerContribution;
        data["socsoEmployerContribution"] = this.socsoEmployerContribution;
        data["eisEmployerContribution"] = this.eisEmployerContribution;
        data["pcbEmployerContribution"] = this.pcbEmployerContribution;
        data["hrdfEmployerContribution"] = this.hrdfEmployerContribution;
        data["employerContribution"] = this.employerContribution;
        data["status"] = this.status;
        data["isOptedOut"] = this.isOptedOut;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        if (Array.isArray(this.payslipAllowanceList)) {
            data["payslipAllowanceList"] = [];
            for (let item of this.payslipAllowanceList)
                data["payslipAllowanceList"].push(item.toJSON());
        }
        if (Array.isArray(this.payslipDeductionList)) {
            data["payslipDeductionList"] = [];
            for (let item of this.payslipDeductionList)
                data["payslipDeductionList"].push(item.toJSON());
        }
        if (Array.isArray(this.eligibleAllowanceList)) {
            data["eligibleAllowanceList"] = [];
            for (let item of this.eligibleAllowanceList)
                data["eligibleAllowanceList"].push(item.toJSON());
        }
        if (Array.isArray(this.eligibleDeductionList)) {
            data["eligibleDeductionList"] = [];
            for (let item of this.eligibleDeductionList)
                data["eligibleDeductionList"].push(item.toJSON());
        }
        return data;
    }

    clone(): EmployeePaySlipModelDto {
        const json = this.toJSON();
        let result = new EmployeePaySlipModelDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeePaySlipModelDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    month: number;
    monthString: string | undefined;
    year: number;
    userId: number;
    user: UserDto;
    basicSalary: number;
    salaryType: SalaryType;
    cycleNo: number;
    salaryForThisCycle: number;
    worked: number;
    proRatedSalary: number;
    allowanceTotal: number;
    deductionTotal: number;
    epfEmployeeContribution: number;
    socsoEmployeeContribution: number;
    eisEmployeeContribution: number;
    pcbEmployeeContribution: number;
    hrdfEmployeeContribution: number;
    employeeContribution: number;
    netSalary: number;
    epfEmployerContribution: number;
    socsoEmployerContribution: number;
    eisEmployerContribution: number;
    pcbEmployerContribution: number;
    hrdfEmployerContribution: number;
    employerContribution: number;
    status: string | undefined;
    isOptedOut: boolean;
    paymentDate: moment.Moment | undefined;
    payslipAllowanceList: PaySlipAllowanceModel[] | undefined;
    payslipDeductionList: PaySlipAllowanceModel[] | undefined;
    eligibleAllowanceList: PaySlipAllowanceModelDto[] | undefined;
    eligibleDeductionList: PaySlipAllowanceModelDto[] | undefined;
}

export class EmployeePaySlipModelPagedResultDto implements IEmployeePaySlipModelPagedResultDto {
    items: EmployeePaySlipModel[] | undefined;
    totalCount: number;

    constructor(data?: IEmployeePaySlipModelPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EmployeePaySlipModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): EmployeePaySlipModelPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePaySlipModelPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): EmployeePaySlipModelPagedResultDto {
        const json = this.toJSON();
        let result = new EmployeePaySlipModelPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeePaySlipModelPagedResultDto {
    items: EmployeePaySlipModel[] | undefined;
    totalCount: number;
}

export class ErrorDetailDto implements IErrorDetailDto {
    code: string | undefined;
    message: string | undefined;
    target: string | undefined;
    propertyPath: string | undefined;
    details: any | undefined;

    constructor(data?: IErrorDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            this.target = _data["target"];
            this.propertyPath = _data["propertyPath"];
            this.details = _data["details"];
        }
    }

    static fromJS(data: any): ErrorDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["target"] = this.target;
        data["propertyPath"] = this.propertyPath;
        data["details"] = this.details;
        return data;
    }

    clone(): ErrorDetailDto {
        const json = this.toJSON();
        let result = new ErrorDetailDto();
        result.init(json);
        return result;
    }
}

export interface IErrorDetailDto {
    code: string | undefined;
    message: string | undefined;
    target: string | undefined;
    propertyPath: string | undefined;
    details: any | undefined;
}

export class ErrorDetailsDto implements IErrorDetailsDto {
    code: string | undefined;
    message: string | undefined;
    target: string | undefined;
    propertyPath: string | undefined;
    details: ErrorDetailDto[] | undefined;

    constructor(data?: IErrorDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            this.target = _data["target"];
            this.propertyPath = _data["propertyPath"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details.push(ErrorDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ErrorDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["target"] = this.target;
        data["propertyPath"] = this.propertyPath;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data;
    }

    clone(): ErrorDetailsDto {
        const json = this.toJSON();
        let result = new ErrorDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IErrorDetailsDto {
    code: string | undefined;
    message: string | undefined;
    target: string | undefined;
    propertyPath: string | undefined;
    details: ErrorDetailDto[] | undefined;
}

export class EsgConsumer implements IEsgConsumer {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    parentLocation: string | undefined;
    consumerName: string | undefined;

    constructor(data?: IEsgConsumer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.parentLocation = _data["parentLocation"];
            this.consumerName = _data["consumerName"];
        }
    }

    static fromJS(data: any): EsgConsumer {
        data = typeof data === 'object' ? data : {};
        let result = new EsgConsumer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["parentLocation"] = this.parentLocation;
        data["consumerName"] = this.consumerName;
        return data;
    }

    clone(): EsgConsumer {
        const json = this.toJSON();
        let result = new EsgConsumer();
        result.init(json);
        return result;
    }
}

export interface IEsgConsumer {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    parentLocation: string | undefined;
    consumerName: string | undefined;
}

export class EsgConsumerDto implements IEsgConsumerDto {
    tenantId: number;
    parentLocation: string | undefined;
    consumerName: string | undefined;

    constructor(data?: IEsgConsumerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.parentLocation = _data["parentLocation"];
            this.consumerName = _data["consumerName"];
        }
    }

    static fromJS(data: any): EsgConsumerDto {
        data = typeof data === 'object' ? data : {};
        let result = new EsgConsumerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["parentLocation"] = this.parentLocation;
        data["consumerName"] = this.consumerName;
        return data;
    }

    clone(): EsgConsumerDto {
        const json = this.toJSON();
        let result = new EsgConsumerDto();
        result.init(json);
        return result;
    }
}

export interface IEsgConsumerDto {
    tenantId: number;
    parentLocation: string | undefined;
    consumerName: string | undefined;
}

export class EsgConsumption implements IEsgConsumption {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    consumerId: number;
    consumer: EsgConsumer;
    startDate: moment.Moment;
    endDate: moment.Moment;
    provider: string | undefined;
    currency: string | undefined;
    cost: number;
    consumptionType: string | undefined;
    consumption: number;
    unitOfMeasurement: string | undefined;
    label: string | undefined;
    fileUrl: string | undefined;
    remark: string | undefined;
    isValidated: boolean;
    validatedDate: moment.Moment;

    constructor(data?: IEsgConsumption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.consumerId = _data["consumerId"];
            this.consumer = _data["consumer"] ? EsgConsumer.fromJS(_data["consumer"]) : <any>undefined;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.provider = _data["provider"];
            this.currency = _data["currency"];
            this.cost = _data["cost"];
            this.consumptionType = _data["consumptionType"];
            this.consumption = _data["consumption"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.label = _data["label"];
            this.fileUrl = _data["fileUrl"];
            this.remark = _data["remark"];
            this.isValidated = _data["isValidated"];
            this.validatedDate = _data["validatedDate"] ? moment(_data["validatedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EsgConsumption {
        data = typeof data === 'object' ? data : {};
        let result = new EsgConsumption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["consumerId"] = this.consumerId;
        data["consumer"] = this.consumer ? this.consumer.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["provider"] = this.provider;
        data["currency"] = this.currency;
        data["cost"] = this.cost;
        data["consumptionType"] = this.consumptionType;
        data["consumption"] = this.consumption;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["label"] = this.label;
        data["fileUrl"] = this.fileUrl;
        data["remark"] = this.remark;
        data["isValidated"] = this.isValidated;
        data["validatedDate"] = this.validatedDate ? this.validatedDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): EsgConsumption {
        const json = this.toJSON();
        let result = new EsgConsumption();
        result.init(json);
        return result;
    }
}

export interface IEsgConsumption {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    consumerId: number;
    consumer: EsgConsumer;
    startDate: moment.Moment;
    endDate: moment.Moment;
    provider: string | undefined;
    currency: string | undefined;
    cost: number;
    consumptionType: string | undefined;
    consumption: number;
    unitOfMeasurement: string | undefined;
    label: string | undefined;
    fileUrl: string | undefined;
    remark: string | undefined;
    isValidated: boolean;
    validatedDate: moment.Moment;
}

export class EsgConsumptionDto implements IEsgConsumptionDto {
    tenantId: number;
    consumerId: number;
    consumer: EsgConsumer;
    startDate: moment.Moment;
    endDate: moment.Moment;
    provider: string | undefined;
    currency: string | undefined;
    cost: number;
    consumptionType: string | undefined;
    consumption: number;
    unitOfMeasurement: string | undefined;
    label: string | undefined;
    fileUrl: string | undefined;
    remark: string | undefined;
    isValidated: boolean;
    validatedDate: moment.Moment;
    esgConsumptionId: number;

    constructor(data?: IEsgConsumptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.consumerId = _data["consumerId"];
            this.consumer = _data["consumer"] ? EsgConsumer.fromJS(_data["consumer"]) : <any>undefined;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.provider = _data["provider"];
            this.currency = _data["currency"];
            this.cost = _data["cost"];
            this.consumptionType = _data["consumptionType"];
            this.consumption = _data["consumption"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.label = _data["label"];
            this.fileUrl = _data["fileUrl"];
            this.remark = _data["remark"];
            this.isValidated = _data["isValidated"];
            this.validatedDate = _data["validatedDate"] ? moment(_data["validatedDate"].toString()) : <any>undefined;
            this.esgConsumptionId = _data["esgConsumptionId"];
        }
    }

    static fromJS(data: any): EsgConsumptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EsgConsumptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["consumerId"] = this.consumerId;
        data["consumer"] = this.consumer ? this.consumer.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["provider"] = this.provider;
        data["currency"] = this.currency;
        data["cost"] = this.cost;
        data["consumptionType"] = this.consumptionType;
        data["consumption"] = this.consumption;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["label"] = this.label;
        data["fileUrl"] = this.fileUrl;
        data["remark"] = this.remark;
        data["isValidated"] = this.isValidated;
        data["validatedDate"] = this.validatedDate ? this.validatedDate.toISOString() : <any>undefined;
        data["esgConsumptionId"] = this.esgConsumptionId;
        return data;
    }

    clone(): EsgConsumptionDto {
        const json = this.toJSON();
        let result = new EsgConsumptionDto();
        result.init(json);
        return result;
    }
}

export interface IEsgConsumptionDto {
    tenantId: number;
    consumerId: number;
    consumer: EsgConsumer;
    startDate: moment.Moment;
    endDate: moment.Moment;
    provider: string | undefined;
    currency: string | undefined;
    cost: number;
    consumptionType: string | undefined;
    consumption: number;
    unitOfMeasurement: string | undefined;
    label: string | undefined;
    fileUrl: string | undefined;
    remark: string | undefined;
    isValidated: boolean;
    validatedDate: moment.Moment;
    esgConsumptionId: number;
}

export class EsgConsumptionMigrationDto implements IEsgConsumptionMigrationDto {
    startDate: moment.Moment;
    endDate: moment.Moment;
    parentLocation: string | undefined;
    consumerName: string | undefined;
    provider: string | undefined;
    cost: number;
    unitOfMeasurement: string | undefined;
    consumption: number;
    label: string | undefined;
    remark: string | undefined;
    isValid: boolean;
    error: string | undefined;
    consumerId: number | undefined;

    constructor(data?: IEsgConsumptionMigrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.parentLocation = _data["parentLocation"];
            this.consumerName = _data["consumerName"];
            this.provider = _data["provider"];
            this.cost = _data["cost"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.consumption = _data["consumption"];
            this.label = _data["label"];
            this.remark = _data["remark"];
            this.isValid = _data["isValid"];
            this.error = _data["error"];
            this.consumerId = _data["consumerId"];
        }
    }

    static fromJS(data: any): EsgConsumptionMigrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EsgConsumptionMigrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["parentLocation"] = this.parentLocation;
        data["consumerName"] = this.consumerName;
        data["provider"] = this.provider;
        data["cost"] = this.cost;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["consumption"] = this.consumption;
        data["label"] = this.label;
        data["remark"] = this.remark;
        data["isValid"] = this.isValid;
        data["error"] = this.error;
        data["consumerId"] = this.consumerId;
        return data;
    }

    clone(): EsgConsumptionMigrationDto {
        const json = this.toJSON();
        let result = new EsgConsumptionMigrationDto();
        result.init(json);
        return result;
    }
}

export interface IEsgConsumptionMigrationDto {
    startDate: moment.Moment;
    endDate: moment.Moment;
    parentLocation: string | undefined;
    consumerName: string | undefined;
    provider: string | undefined;
    cost: number;
    unitOfMeasurement: string | undefined;
    consumption: number;
    label: string | undefined;
    remark: string | undefined;
    isValid: boolean;
    error: string | undefined;
    consumerId: number | undefined;
}

export class EsgConsumptionPagedResultDto implements IEsgConsumptionPagedResultDto {
    items: EsgConsumption[] | undefined;
    totalCount: number;

    constructor(data?: IEsgConsumptionPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EsgConsumption.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): EsgConsumptionPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EsgConsumptionPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): EsgConsumptionPagedResultDto {
        const json = this.toJSON();
        let result = new EsgConsumptionPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IEsgConsumptionPagedResultDto {
    items: EsgConsumption[] | undefined;
    totalCount: number;
}

export class EsgDataDto implements IEsgDataDto {
    year: number;
    electricalList: EsgElectricDto[] | undefined;
    consumptionList: EsgConsumptionDto[] | undefined;
    wasteList: EsgWasteDto[] | undefined;
    emissionList: EsgEmissionDto[] | undefined;
    scope1: number;
    scope2: number;
    scope3: number;
    p_Scope1: number;
    p_Scope2: number;
    p_Scope3: number;

    constructor(data?: IEsgDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            if (Array.isArray(_data["electricalList"])) {
                this.electricalList = [] as any;
                for (let item of _data["electricalList"])
                    this.electricalList.push(EsgElectricDto.fromJS(item));
            }
            if (Array.isArray(_data["consumptionList"])) {
                this.consumptionList = [] as any;
                for (let item of _data["consumptionList"])
                    this.consumptionList.push(EsgConsumptionDto.fromJS(item));
            }
            if (Array.isArray(_data["wasteList"])) {
                this.wasteList = [] as any;
                for (let item of _data["wasteList"])
                    this.wasteList.push(EsgWasteDto.fromJS(item));
            }
            if (Array.isArray(_data["emissionList"])) {
                this.emissionList = [] as any;
                for (let item of _data["emissionList"])
                    this.emissionList.push(EsgEmissionDto.fromJS(item));
            }
            this.scope1 = _data["scope1"];
            this.scope2 = _data["scope2"];
            this.scope3 = _data["scope3"];
            this.p_Scope1 = _data["p_Scope1"];
            this.p_Scope2 = _data["p_Scope2"];
            this.p_Scope3 = _data["p_Scope3"];
        }
    }

    static fromJS(data: any): EsgDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new EsgDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        if (Array.isArray(this.electricalList)) {
            data["electricalList"] = [];
            for (let item of this.electricalList)
                data["electricalList"].push(item.toJSON());
        }
        if (Array.isArray(this.consumptionList)) {
            data["consumptionList"] = [];
            for (let item of this.consumptionList)
                data["consumptionList"].push(item.toJSON());
        }
        if (Array.isArray(this.wasteList)) {
            data["wasteList"] = [];
            for (let item of this.wasteList)
                data["wasteList"].push(item.toJSON());
        }
        if (Array.isArray(this.emissionList)) {
            data["emissionList"] = [];
            for (let item of this.emissionList)
                data["emissionList"].push(item.toJSON());
        }
        data["scope1"] = this.scope1;
        data["scope2"] = this.scope2;
        data["scope3"] = this.scope3;
        data["p_Scope1"] = this.p_Scope1;
        data["p_Scope2"] = this.p_Scope2;
        data["p_Scope3"] = this.p_Scope3;
        return data;
    }

    clone(): EsgDataDto {
        const json = this.toJSON();
        let result = new EsgDataDto();
        result.init(json);
        return result;
    }
}

export interface IEsgDataDto {
    year: number;
    electricalList: EsgElectricDto[] | undefined;
    consumptionList: EsgConsumptionDto[] | undefined;
    wasteList: EsgWasteDto[] | undefined;
    emissionList: EsgEmissionDto[] | undefined;
    scope1: number;
    scope2: number;
    scope3: number;
    p_Scope1: number;
    p_Scope2: number;
    p_Scope3: number;
}

export class EsgElectric implements IEsgElectric {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    consumerId: number;
    consumer: EsgConsumer;
    ghgScope: number;
    startDate: moment.Moment;
    endDate: moment.Moment;
    provider: string | undefined;
    currency: string | undefined;
    cost: number;
    electricalUnit: string | undefined;
    consumption: number;
    label: string | undefined;
    fileUrl: string | undefined;
    remark: string | undefined;

    constructor(data?: IEsgElectric) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.consumerId = _data["consumerId"];
            this.consumer = _data["consumer"] ? EsgConsumer.fromJS(_data["consumer"]) : <any>undefined;
            this.ghgScope = _data["ghgScope"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.provider = _data["provider"];
            this.currency = _data["currency"];
            this.cost = _data["cost"];
            this.electricalUnit = _data["electricalUnit"];
            this.consumption = _data["consumption"];
            this.label = _data["label"];
            this.fileUrl = _data["fileUrl"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): EsgElectric {
        data = typeof data === 'object' ? data : {};
        let result = new EsgElectric();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["consumerId"] = this.consumerId;
        data["consumer"] = this.consumer ? this.consumer.toJSON() : <any>undefined;
        data["ghgScope"] = this.ghgScope;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["provider"] = this.provider;
        data["currency"] = this.currency;
        data["cost"] = this.cost;
        data["electricalUnit"] = this.electricalUnit;
        data["consumption"] = this.consumption;
        data["label"] = this.label;
        data["fileUrl"] = this.fileUrl;
        data["remark"] = this.remark;
        return data;
    }

    clone(): EsgElectric {
        const json = this.toJSON();
        let result = new EsgElectric();
        result.init(json);
        return result;
    }
}

export interface IEsgElectric {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    consumerId: number;
    consumer: EsgConsumer;
    ghgScope: number;
    startDate: moment.Moment;
    endDate: moment.Moment;
    provider: string | undefined;
    currency: string | undefined;
    cost: number;
    electricalUnit: string | undefined;
    consumption: number;
    label: string | undefined;
    fileUrl: string | undefined;
    remark: string | undefined;
}

export class EsgElectricDto implements IEsgElectricDto {
    tenantId: number;
    consumerId: number;
    consumer: EsgConsumer;
    ghgScope: number;
    startDate: moment.Moment;
    endDate: moment.Moment;
    provider: string | undefined;
    currency: string | undefined;
    cost: number;
    electricalUnit: string | undefined;
    consumption: number;
    label: string | undefined;
    fileUrl: string | undefined;
    remark: string | undefined;
    ghgEmissions: number;
    esgElectricId: number;

    constructor(data?: IEsgElectricDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.consumerId = _data["consumerId"];
            this.consumer = _data["consumer"] ? EsgConsumer.fromJS(_data["consumer"]) : <any>undefined;
            this.ghgScope = _data["ghgScope"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.provider = _data["provider"];
            this.currency = _data["currency"];
            this.cost = _data["cost"];
            this.electricalUnit = _data["electricalUnit"];
            this.consumption = _data["consumption"];
            this.label = _data["label"];
            this.fileUrl = _data["fileUrl"];
            this.remark = _data["remark"];
            this.ghgEmissions = _data["ghgEmissions"];
            this.esgElectricId = _data["esgElectricId"];
        }
    }

    static fromJS(data: any): EsgElectricDto {
        data = typeof data === 'object' ? data : {};
        let result = new EsgElectricDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["consumerId"] = this.consumerId;
        data["consumer"] = this.consumer ? this.consumer.toJSON() : <any>undefined;
        data["ghgScope"] = this.ghgScope;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["provider"] = this.provider;
        data["currency"] = this.currency;
        data["cost"] = this.cost;
        data["electricalUnit"] = this.electricalUnit;
        data["consumption"] = this.consumption;
        data["label"] = this.label;
        data["fileUrl"] = this.fileUrl;
        data["remark"] = this.remark;
        data["ghgEmissions"] = this.ghgEmissions;
        data["esgElectricId"] = this.esgElectricId;
        return data;
    }

    clone(): EsgElectricDto {
        const json = this.toJSON();
        let result = new EsgElectricDto();
        result.init(json);
        return result;
    }
}

export interface IEsgElectricDto {
    tenantId: number;
    consumerId: number;
    consumer: EsgConsumer;
    ghgScope: number;
    startDate: moment.Moment;
    endDate: moment.Moment;
    provider: string | undefined;
    currency: string | undefined;
    cost: number;
    electricalUnit: string | undefined;
    consumption: number;
    label: string | undefined;
    fileUrl: string | undefined;
    remark: string | undefined;
    ghgEmissions: number;
    esgElectricId: number;
}

export class EsgElectricMigrationDto implements IEsgElectricMigrationDto {
    startDate: moment.Moment;
    endDate: moment.Moment;
    parentLocation: string | undefined;
    consumerName: string | undefined;
    provider: string | undefined;
    cost: number;
    electricalUnit: string | undefined;
    consumption: number;
    label: string | undefined;
    remark: string | undefined;
    isValid: boolean;
    error: string | undefined;
    consumerId: number | undefined;

    constructor(data?: IEsgElectricMigrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.parentLocation = _data["parentLocation"];
            this.consumerName = _data["consumerName"];
            this.provider = _data["provider"];
            this.cost = _data["cost"];
            this.electricalUnit = _data["electricalUnit"];
            this.consumption = _data["consumption"];
            this.label = _data["label"];
            this.remark = _data["remark"];
            this.isValid = _data["isValid"];
            this.error = _data["error"];
            this.consumerId = _data["consumerId"];
        }
    }

    static fromJS(data: any): EsgElectricMigrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EsgElectricMigrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["parentLocation"] = this.parentLocation;
        data["consumerName"] = this.consumerName;
        data["provider"] = this.provider;
        data["cost"] = this.cost;
        data["electricalUnit"] = this.electricalUnit;
        data["consumption"] = this.consumption;
        data["label"] = this.label;
        data["remark"] = this.remark;
        data["isValid"] = this.isValid;
        data["error"] = this.error;
        data["consumerId"] = this.consumerId;
        return data;
    }

    clone(): EsgElectricMigrationDto {
        const json = this.toJSON();
        let result = new EsgElectricMigrationDto();
        result.init(json);
        return result;
    }
}

export interface IEsgElectricMigrationDto {
    startDate: moment.Moment;
    endDate: moment.Moment;
    parentLocation: string | undefined;
    consumerName: string | undefined;
    provider: string | undefined;
    cost: number;
    electricalUnit: string | undefined;
    consumption: number;
    label: string | undefined;
    remark: string | undefined;
    isValid: boolean;
    error: string | undefined;
    consumerId: number | undefined;
}

export class EsgElectricPagedResultDto implements IEsgElectricPagedResultDto {
    items: EsgElectric[] | undefined;
    totalCount: number;

    constructor(data?: IEsgElectricPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EsgElectric.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): EsgElectricPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EsgElectricPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): EsgElectricPagedResultDto {
        const json = this.toJSON();
        let result = new EsgElectricPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IEsgElectricPagedResultDto {
    items: EsgElectric[] | undefined;
    totalCount: number;
}

export class EsgEmissionDto implements IEsgEmissionDto {
    tenantId: number;
    consumerId: number;
    consumer: EsgConsumer;
    emissionType: string | undefined;
    recordDate: moment.Moment;
    provider: string | undefined;
    quantity: number;
    unit: string | undefined;
    emissionFactor: number;
    totalEmissions: number;
    remark: string | undefined;
    cost: number;
    documentUrl: string | undefined;
    ghgScope: number;
    esgEmissionId: number;

    constructor(data?: IEsgEmissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.consumerId = _data["consumerId"];
            this.consumer = _data["consumer"] ? EsgConsumer.fromJS(_data["consumer"]) : <any>undefined;
            this.emissionType = _data["emissionType"];
            this.recordDate = _data["recordDate"] ? moment(_data["recordDate"].toString()) : <any>undefined;
            this.provider = _data["provider"];
            this.quantity = _data["quantity"];
            this.unit = _data["unit"];
            this.emissionFactor = _data["emissionFactor"];
            this.totalEmissions = _data["totalEmissions"];
            this.remark = _data["remark"];
            this.cost = _data["cost"];
            this.documentUrl = _data["documentUrl"];
            this.ghgScope = _data["ghgScope"];
            this.esgEmissionId = _data["esgEmissionId"];
        }
    }

    static fromJS(data: any): EsgEmissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EsgEmissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["consumerId"] = this.consumerId;
        data["consumer"] = this.consumer ? this.consumer.toJSON() : <any>undefined;
        data["emissionType"] = this.emissionType;
        data["recordDate"] = this.recordDate ? this.recordDate.toISOString() : <any>undefined;
        data["provider"] = this.provider;
        data["quantity"] = this.quantity;
        data["unit"] = this.unit;
        data["emissionFactor"] = this.emissionFactor;
        data["totalEmissions"] = this.totalEmissions;
        data["remark"] = this.remark;
        data["cost"] = this.cost;
        data["documentUrl"] = this.documentUrl;
        data["ghgScope"] = this.ghgScope;
        data["esgEmissionId"] = this.esgEmissionId;
        return data;
    }

    clone(): EsgEmissionDto {
        const json = this.toJSON();
        let result = new EsgEmissionDto();
        result.init(json);
        return result;
    }
}

export interface IEsgEmissionDto {
    tenantId: number;
    consumerId: number;
    consumer: EsgConsumer;
    emissionType: string | undefined;
    recordDate: moment.Moment;
    provider: string | undefined;
    quantity: number;
    unit: string | undefined;
    emissionFactor: number;
    totalEmissions: number;
    remark: string | undefined;
    cost: number;
    documentUrl: string | undefined;
    ghgScope: number;
    esgEmissionId: number;
}

export class EsgEmissionMigrationDto implements IEsgEmissionMigrationDto {
    tenantId: number;
    consumerId: number;
    consumerName: string | undefined;
    parentLocation: string | undefined;
    emissionType: string | undefined;
    recordDate: moment.Moment;
    provider: string | undefined;
    quantity: number;
    unit: string | undefined;
    emissionFactor: number;
    totalEmissions: number;
    remark: string | undefined;
    cost: number;
    documentUrl: string | undefined;
    ghgScope: number;
    esgEmissionId: number;
    isValid: boolean;
    error: string | undefined;

    constructor(data?: IEsgEmissionMigrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.consumerId = _data["consumerId"];
            this.consumerName = _data["consumerName"];
            this.parentLocation = _data["parentLocation"];
            this.emissionType = _data["emissionType"];
            this.recordDate = _data["recordDate"] ? moment(_data["recordDate"].toString()) : <any>undefined;
            this.provider = _data["provider"];
            this.quantity = _data["quantity"];
            this.unit = _data["unit"];
            this.emissionFactor = _data["emissionFactor"];
            this.totalEmissions = _data["totalEmissions"];
            this.remark = _data["remark"];
            this.cost = _data["cost"];
            this.documentUrl = _data["documentUrl"];
            this.ghgScope = _data["ghgScope"];
            this.esgEmissionId = _data["esgEmissionId"];
            this.isValid = _data["isValid"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): EsgEmissionMigrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EsgEmissionMigrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["consumerId"] = this.consumerId;
        data["consumerName"] = this.consumerName;
        data["parentLocation"] = this.parentLocation;
        data["emissionType"] = this.emissionType;
        data["recordDate"] = this.recordDate ? this.recordDate.toISOString() : <any>undefined;
        data["provider"] = this.provider;
        data["quantity"] = this.quantity;
        data["unit"] = this.unit;
        data["emissionFactor"] = this.emissionFactor;
        data["totalEmissions"] = this.totalEmissions;
        data["remark"] = this.remark;
        data["cost"] = this.cost;
        data["documentUrl"] = this.documentUrl;
        data["ghgScope"] = this.ghgScope;
        data["esgEmissionId"] = this.esgEmissionId;
        data["isValid"] = this.isValid;
        data["error"] = this.error;
        return data;
    }

    clone(): EsgEmissionMigrationDto {
        const json = this.toJSON();
        let result = new EsgEmissionMigrationDto();
        result.init(json);
        return result;
    }
}

export interface IEsgEmissionMigrationDto {
    tenantId: number;
    consumerId: number;
    consumerName: string | undefined;
    parentLocation: string | undefined;
    emissionType: string | undefined;
    recordDate: moment.Moment;
    provider: string | undefined;
    quantity: number;
    unit: string | undefined;
    emissionFactor: number;
    totalEmissions: number;
    remark: string | undefined;
    cost: number;
    documentUrl: string | undefined;
    ghgScope: number;
    esgEmissionId: number;
    isValid: boolean;
    error: string | undefined;
}

export class EsgWasteDto implements IEsgWasteDto {
    tenantId: number;
    date: moment.Moment;
    consumerId: number;
    consumer: EsgConsumer;
    wasteTypeId: number;
    wasteType: EsgWasteType;
    quantity: number;
    unit: string | undefined;
    disposalMethod: string | undefined;
    disposalCost: number;
    currency: string | undefined;
    fileUrl: string | undefined;
    remarks: string | undefined;
    esgWasteId: number;

    constructor(data?: IEsgWasteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.consumerId = _data["consumerId"];
            this.consumer = _data["consumer"] ? EsgConsumer.fromJS(_data["consumer"]) : <any>undefined;
            this.wasteTypeId = _data["wasteTypeId"];
            this.wasteType = _data["wasteType"] ? EsgWasteType.fromJS(_data["wasteType"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.unit = _data["unit"];
            this.disposalMethod = _data["disposalMethod"];
            this.disposalCost = _data["disposalCost"];
            this.currency = _data["currency"];
            this.fileUrl = _data["fileUrl"];
            this.remarks = _data["remarks"];
            this.esgWasteId = _data["esgWasteId"];
        }
    }

    static fromJS(data: any): EsgWasteDto {
        data = typeof data === 'object' ? data : {};
        let result = new EsgWasteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["consumerId"] = this.consumerId;
        data["consumer"] = this.consumer ? this.consumer.toJSON() : <any>undefined;
        data["wasteTypeId"] = this.wasteTypeId;
        data["wasteType"] = this.wasteType ? this.wasteType.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["unit"] = this.unit;
        data["disposalMethod"] = this.disposalMethod;
        data["disposalCost"] = this.disposalCost;
        data["currency"] = this.currency;
        data["fileUrl"] = this.fileUrl;
        data["remarks"] = this.remarks;
        data["esgWasteId"] = this.esgWasteId;
        return data;
    }

    clone(): EsgWasteDto {
        const json = this.toJSON();
        let result = new EsgWasteDto();
        result.init(json);
        return result;
    }
}

export interface IEsgWasteDto {
    tenantId: number;
    date: moment.Moment;
    consumerId: number;
    consumer: EsgConsumer;
    wasteTypeId: number;
    wasteType: EsgWasteType;
    quantity: number;
    unit: string | undefined;
    disposalMethod: string | undefined;
    disposalCost: number;
    currency: string | undefined;
    fileUrl: string | undefined;
    remarks: string | undefined;
    esgWasteId: number;
}

export class EsgWasteMigrationDto implements IEsgWasteMigrationDto {
    date: moment.Moment;
    parentLocation: string | undefined;
    consumerName: string | undefined;
    quantity: number;
    unit: string | undefined;
    wasteTypeId: number;
    wasteTypeDbId: number;
    disposalMethod: string | undefined;
    disposalCost: number;
    remarks: string | undefined;
    isValid: boolean;
    error: string | undefined;
    consumerId: number | undefined;

    constructor(data?: IEsgWasteMigrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.parentLocation = _data["parentLocation"];
            this.consumerName = _data["consumerName"];
            this.quantity = _data["quantity"];
            this.unit = _data["unit"];
            this.wasteTypeId = _data["wasteTypeId"];
            this.wasteTypeDbId = _data["wasteTypeDbId"];
            this.disposalMethod = _data["disposalMethod"];
            this.disposalCost = _data["disposalCost"];
            this.remarks = _data["remarks"];
            this.isValid = _data["isValid"];
            this.error = _data["error"];
            this.consumerId = _data["consumerId"];
        }
    }

    static fromJS(data: any): EsgWasteMigrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new EsgWasteMigrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["parentLocation"] = this.parentLocation;
        data["consumerName"] = this.consumerName;
        data["quantity"] = this.quantity;
        data["unit"] = this.unit;
        data["wasteTypeId"] = this.wasteTypeId;
        data["wasteTypeDbId"] = this.wasteTypeDbId;
        data["disposalMethod"] = this.disposalMethod;
        data["disposalCost"] = this.disposalCost;
        data["remarks"] = this.remarks;
        data["isValid"] = this.isValid;
        data["error"] = this.error;
        data["consumerId"] = this.consumerId;
        return data;
    }

    clone(): EsgWasteMigrationDto {
        const json = this.toJSON();
        let result = new EsgWasteMigrationDto();
        result.init(json);
        return result;
    }
}

export interface IEsgWasteMigrationDto {
    date: moment.Moment;
    parentLocation: string | undefined;
    consumerName: string | undefined;
    quantity: number;
    unit: string | undefined;
    wasteTypeId: number;
    wasteTypeDbId: number;
    disposalMethod: string | undefined;
    disposalCost: number;
    remarks: string | undefined;
    isValid: boolean;
    error: string | undefined;
    consumerId: number | undefined;
}

export class EsgWasteType implements IEsgWasteType {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    description: string | undefined;
    regulatoryCode: string | undefined;
    disposalInstructions: string | undefined;
    standardDisposalCost: number;
    environmentalImpact: string | undefined;
    colorCode: string | undefined;
    category: string | undefined;
    isHazardous: boolean;
    isRecyclable: boolean;
    emissionFactor: number;

    constructor(data?: IEsgWasteType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.regulatoryCode = _data["regulatoryCode"];
            this.disposalInstructions = _data["disposalInstructions"];
            this.standardDisposalCost = _data["standardDisposalCost"];
            this.environmentalImpact = _data["environmentalImpact"];
            this.colorCode = _data["colorCode"];
            this.category = _data["category"];
            this.isHazardous = _data["isHazardous"];
            this.isRecyclable = _data["isRecyclable"];
            this.emissionFactor = _data["emissionFactor"];
        }
    }

    static fromJS(data: any): EsgWasteType {
        data = typeof data === 'object' ? data : {};
        let result = new EsgWasteType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["regulatoryCode"] = this.regulatoryCode;
        data["disposalInstructions"] = this.disposalInstructions;
        data["standardDisposalCost"] = this.standardDisposalCost;
        data["environmentalImpact"] = this.environmentalImpact;
        data["colorCode"] = this.colorCode;
        data["category"] = this.category;
        data["isHazardous"] = this.isHazardous;
        data["isRecyclable"] = this.isRecyclable;
        data["emissionFactor"] = this.emissionFactor;
        return data;
    }

    clone(): EsgWasteType {
        const json = this.toJSON();
        let result = new EsgWasteType();
        result.init(json);
        return result;
    }
}

export interface IEsgWasteType {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    description: string | undefined;
    regulatoryCode: string | undefined;
    disposalInstructions: string | undefined;
    standardDisposalCost: number;
    environmentalImpact: string | undefined;
    colorCode: string | undefined;
    category: string | undefined;
    isHazardous: boolean;
    isRecyclable: boolean;
    emissionFactor: number;
}

export class EsgWasteTypeDto implements IEsgWasteTypeDto {
    tenantId: number;
    name: string | undefined;
    description: string | undefined;
    regulatoryCode: string | undefined;
    disposalInstructions: string | undefined;
    standardDisposalCost: number;
    environmentalImpact: string | undefined;
    colorCode: string | undefined;
    category: string | undefined;
    isHazardous: boolean;
    isRecyclable: boolean;
    emissionFactor: number;

    constructor(data?: IEsgWasteTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.regulatoryCode = _data["regulatoryCode"];
            this.disposalInstructions = _data["disposalInstructions"];
            this.standardDisposalCost = _data["standardDisposalCost"];
            this.environmentalImpact = _data["environmentalImpact"];
            this.colorCode = _data["colorCode"];
            this.category = _data["category"];
            this.isHazardous = _data["isHazardous"];
            this.isRecyclable = _data["isRecyclable"];
            this.emissionFactor = _data["emissionFactor"];
        }
    }

    static fromJS(data: any): EsgWasteTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EsgWasteTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["regulatoryCode"] = this.regulatoryCode;
        data["disposalInstructions"] = this.disposalInstructions;
        data["standardDisposalCost"] = this.standardDisposalCost;
        data["environmentalImpact"] = this.environmentalImpact;
        data["colorCode"] = this.colorCode;
        data["category"] = this.category;
        data["isHazardous"] = this.isHazardous;
        data["isRecyclable"] = this.isRecyclable;
        data["emissionFactor"] = this.emissionFactor;
        return data;
    }

    clone(): EsgWasteTypeDto {
        const json = this.toJSON();
        let result = new EsgWasteTypeDto();
        result.init(json);
        return result;
    }
}

export interface IEsgWasteTypeDto {
    tenantId: number;
    name: string | undefined;
    description: string | undefined;
    regulatoryCode: string | undefined;
    disposalInstructions: string | undefined;
    standardDisposalCost: number;
    environmentalImpact: string | undefined;
    colorCode: string | undefined;
    category: string | undefined;
    isHazardous: boolean;
    isRecyclable: boolean;
    emissionFactor: number;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        return data;
    }

    clone(): ExternalAuthenticateModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        return data;
    }

    clone(): ExternalAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data;
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class FinancialStatementFile implements IFinancialStatementFile {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    url: string | undefined;
    description: string | undefined;
    description2: string | undefined;
    name: string | undefined;
    language: string | undefined;
    companyType: string | undefined;
    isPurchased: boolean;
    type: string | undefined;
    isManagementReport: boolean;

    constructor(data?: IFinancialStatementFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.url = _data["url"];
            this.description = _data["description"];
            this.description2 = _data["description2"];
            this.name = _data["name"];
            this.language = _data["language"];
            this.companyType = _data["companyType"];
            this.isPurchased = _data["isPurchased"];
            this.type = _data["type"];
            this.isManagementReport = _data["isManagementReport"];
        }
    }

    static fromJS(data: any): FinancialStatementFile {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialStatementFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["url"] = this.url;
        data["description"] = this.description;
        data["description2"] = this.description2;
        data["name"] = this.name;
        data["language"] = this.language;
        data["companyType"] = this.companyType;
        data["isPurchased"] = this.isPurchased;
        data["type"] = this.type;
        data["isManagementReport"] = this.isManagementReport;
        return data;
    }

    clone(): FinancialStatementFile {
        const json = this.toJSON();
        let result = new FinancialStatementFile();
        result.init(json);
        return result;
    }
}

export interface IFinancialStatementFile {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    url: string | undefined;
    description: string | undefined;
    description2: string | undefined;
    name: string | undefined;
    language: string | undefined;
    companyType: string | undefined;
    isPurchased: boolean;
    type: string | undefined;
    isManagementReport: boolean;
}

export class FinancialStatementFileDto implements IFinancialStatementFileDto {
    tenantId: number;
    url: string | undefined;
    description: string | undefined;
    description2: string | undefined;
    name: string | undefined;
    language: string | undefined;
    companyType: string | undefined;
    isPurchased: boolean;
    type: string | undefined;
    isManagementReport: boolean;

    constructor(data?: IFinancialStatementFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.url = _data["url"];
            this.description = _data["description"];
            this.description2 = _data["description2"];
            this.name = _data["name"];
            this.language = _data["language"];
            this.companyType = _data["companyType"];
            this.isPurchased = _data["isPurchased"];
            this.type = _data["type"];
            this.isManagementReport = _data["isManagementReport"];
        }
    }

    static fromJS(data: any): FinancialStatementFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialStatementFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["url"] = this.url;
        data["description"] = this.description;
        data["description2"] = this.description2;
        data["name"] = this.name;
        data["language"] = this.language;
        data["companyType"] = this.companyType;
        data["isPurchased"] = this.isPurchased;
        data["type"] = this.type;
        data["isManagementReport"] = this.isManagementReport;
        return data;
    }

    clone(): FinancialStatementFileDto {
        const json = this.toJSON();
        let result = new FinancialStatementFileDto();
        result.init(json);
        return result;
    }
}

export interface IFinancialStatementFileDto {
    tenantId: number;
    url: string | undefined;
    description: string | undefined;
    description2: string | undefined;
    name: string | undefined;
    language: string | undefined;
    companyType: string | undefined;
    isPurchased: boolean;
    type: string | undefined;
    isManagementReport: boolean;
}

export class FirebaseProductDto implements IFirebaseProductDto {
    name: string | undefined;
    price: number;
    image: string | undefined;
    category: string | undefined;
    docID: string | undefined;
    productId: string | undefined;

    constructor(data?: IFirebaseProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.price = _data["price"];
            this.image = _data["image"];
            this.category = _data["category"];
            this.docID = _data["docID"];
            this.productId = _data["productId"];
        }
    }

    static fromJS(data: any): FirebaseProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new FirebaseProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["price"] = this.price;
        data["image"] = this.image;
        data["category"] = this.category;
        data["docID"] = this.docID;
        data["productId"] = this.productId;
        return data;
    }

    clone(): FirebaseProductDto {
        const json = this.toJSON();
        let result = new FirebaseProductDto();
        result.init(json);
        return result;
    }
}

export interface IFirebaseProductDto {
    name: string | undefined;
    price: number;
    image: string | undefined;
    category: string | undefined;
    docID: string | undefined;
    productId: string | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class FullCalendarEventDto implements IFullCalendarEventDto {
    id: string | undefined;
    groupId: string | undefined;
    allDay: boolean;
    start: moment.Moment;
    end: moment.Moment | undefined;
    startStr: string | undefined;
    endStr: string | undefined;
    title: string | undefined;
    url: string | undefined;
    classNames: string[] | undefined;
    editable: boolean | undefined;
    startEditable: boolean | undefined;
    durationEditable: boolean | undefined;
    resourceEditable: boolean | undefined;
    display: string | undefined;
    overlap: boolean;
    constraint: string | undefined;
    backgroundColor: string | undefined;
    borderColor: string | undefined;
    textColor: string | undefined;
    extendedProps: string | undefined;
    source: string | undefined;

    constructor(data?: IFullCalendarEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupId = _data["groupId"];
            this.allDay = _data["allDay"];
            this.start = _data["start"] ? moment(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? moment(_data["end"].toString()) : <any>undefined;
            this.startStr = _data["startStr"];
            this.endStr = _data["endStr"];
            this.title = _data["title"];
            this.url = _data["url"];
            if (Array.isArray(_data["classNames"])) {
                this.classNames = [] as any;
                for (let item of _data["classNames"])
                    this.classNames.push(item);
            }
            this.editable = _data["editable"];
            this.startEditable = _data["startEditable"];
            this.durationEditable = _data["durationEditable"];
            this.resourceEditable = _data["resourceEditable"];
            this.display = _data["display"];
            this.overlap = _data["overlap"];
            this.constraint = _data["constraint"];
            this.backgroundColor = _data["backgroundColor"];
            this.borderColor = _data["borderColor"];
            this.textColor = _data["textColor"];
            this.extendedProps = _data["extendedProps"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): FullCalendarEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new FullCalendarEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupId"] = this.groupId;
        data["allDay"] = this.allDay;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["startStr"] = this.startStr;
        data["endStr"] = this.endStr;
        data["title"] = this.title;
        data["url"] = this.url;
        if (Array.isArray(this.classNames)) {
            data["classNames"] = [];
            for (let item of this.classNames)
                data["classNames"].push(item);
        }
        data["editable"] = this.editable;
        data["startEditable"] = this.startEditable;
        data["durationEditable"] = this.durationEditable;
        data["resourceEditable"] = this.resourceEditable;
        data["display"] = this.display;
        data["overlap"] = this.overlap;
        data["constraint"] = this.constraint;
        data["backgroundColor"] = this.backgroundColor;
        data["borderColor"] = this.borderColor;
        data["textColor"] = this.textColor;
        data["extendedProps"] = this.extendedProps;
        data["source"] = this.source;
        return data;
    }

    clone(): FullCalendarEventDto {
        const json = this.toJSON();
        let result = new FullCalendarEventDto();
        result.init(json);
        return result;
    }
}

export interface IFullCalendarEventDto {
    id: string | undefined;
    groupId: string | undefined;
    allDay: boolean;
    start: moment.Moment;
    end: moment.Moment | undefined;
    startStr: string | undefined;
    endStr: string | undefined;
    title: string | undefined;
    url: string | undefined;
    classNames: string[] | undefined;
    editable: boolean | undefined;
    startEditable: boolean | undefined;
    durationEditable: boolean | undefined;
    resourceEditable: boolean | undefined;
    display: string | undefined;
    overlap: boolean;
    constraint: string | undefined;
    backgroundColor: string | undefined;
    borderColor: string | undefined;
    textColor: string | undefined;
    extendedProps: string | undefined;
    source: string | undefined;
}

export class GeneralDataBudget implements IGeneralDataBudget {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    financialYear: number;
    key: string | undefined;
    tenantId: number;
    budget: number;

    constructor(data?: IGeneralDataBudget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.financialYear = _data["financialYear"];
            this.key = _data["key"];
            this.tenantId = _data["tenantId"];
            this.budget = _data["budget"];
        }
    }

    static fromJS(data: any): GeneralDataBudget {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralDataBudget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["financialYear"] = this.financialYear;
        data["key"] = this.key;
        data["tenantId"] = this.tenantId;
        data["budget"] = this.budget;
        return data;
    }

    clone(): GeneralDataBudget {
        const json = this.toJSON();
        let result = new GeneralDataBudget();
        result.init(json);
        return result;
    }
}

export interface IGeneralDataBudget {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    financialYear: number;
    key: string | undefined;
    tenantId: number;
    budget: number;
}

export class GeneralDataBudgetDto implements IGeneralDataBudgetDto {
    financialYear: number;
    key: string | undefined;
    tenantId: number;
    budget: number;

    constructor(data?: IGeneralDataBudgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialYear = _data["financialYear"];
            this.key = _data["key"];
            this.tenantId = _data["tenantId"];
            this.budget = _data["budget"];
        }
    }

    static fromJS(data: any): GeneralDataBudgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralDataBudgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialYear"] = this.financialYear;
        data["key"] = this.key;
        data["tenantId"] = this.tenantId;
        data["budget"] = this.budget;
        return data;
    }

    clone(): GeneralDataBudgetDto {
        const json = this.toJSON();
        let result = new GeneralDataBudgetDto();
        result.init(json);
        return result;
    }
}

export interface IGeneralDataBudgetDto {
    financialYear: number;
    key: string | undefined;
    tenantId: number;
    budget: number;
}

export class GeneralDataDto implements IGeneralDataDto {
    generalDataId: number;
    tenantId: number;
    key: string | undefined;
    description: string | undefined;
    values: GeneralDataValue[] | undefined;
    weight: number;

    constructor(data?: IGeneralDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generalDataId = _data["generalDataId"];
            this.tenantId = _data["tenantId"];
            this.key = _data["key"];
            this.description = _data["description"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values.push(GeneralDataValue.fromJS(item));
            }
            this.weight = _data["weight"];
        }
    }

    static fromJS(data: any): GeneralDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generalDataId"] = this.generalDataId;
        data["tenantId"] = this.tenantId;
        data["key"] = this.key;
        data["description"] = this.description;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        data["weight"] = this.weight;
        return data;
    }

    clone(): GeneralDataDto {
        const json = this.toJSON();
        let result = new GeneralDataDto();
        result.init(json);
        return result;
    }
}

export interface IGeneralDataDto {
    generalDataId: number;
    tenantId: number;
    key: string | undefined;
    description: string | undefined;
    values: GeneralDataValue[] | undefined;
    weight: number;
}

export class GeneralDataDtoPagedResultDto implements IGeneralDataDtoPagedResultDto {
    items: GeneralDataDto[] | undefined;
    totalCount: number;

    constructor(data?: IGeneralDataDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(GeneralDataDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): GeneralDataDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralDataDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): GeneralDataDtoPagedResultDto {
        const json = this.toJSON();
        let result = new GeneralDataDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IGeneralDataDtoPagedResultDto {
    items: GeneralDataDto[] | undefined;
    totalCount: number;
}

export class GeneralDataValue implements IGeneralDataValue {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    key: string | undefined;
    type: string | undefined;
    code: string | undefined;
    isNegative: boolean;
    operatorString: string | undefined;
    parentId: number;

    constructor(data?: IGeneralDataValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.key = _data["key"];
            this.type = _data["type"];
            this.code = _data["code"];
            this.isNegative = _data["isNegative"];
            this.operatorString = _data["operatorString"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): GeneralDataValue {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralDataValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["key"] = this.key;
        data["type"] = this.type;
        data["code"] = this.code;
        data["isNegative"] = this.isNegative;
        data["operatorString"] = this.operatorString;
        data["parentId"] = this.parentId;
        return data;
    }

    clone(): GeneralDataValue {
        const json = this.toJSON();
        let result = new GeneralDataValue();
        result.init(json);
        return result;
    }
}

export interface IGeneralDataValue {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    key: string | undefined;
    type: string | undefined;
    code: string | undefined;
    isNegative: boolean;
    operatorString: string | undefined;
    parentId: number;
}

export class GeneralDataValueDto implements IGeneralDataValueDto {
    tenantId: number;
    key: string | undefined;
    type: string | undefined;
    code: string | undefined;
    isNegative: boolean;
    operatorString: string | undefined;
    parentId: number;

    constructor(data?: IGeneralDataValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.key = _data["key"];
            this.type = _data["type"];
            this.code = _data["code"];
            this.isNegative = _data["isNegative"];
            this.operatorString = _data["operatorString"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): GeneralDataValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralDataValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["key"] = this.key;
        data["type"] = this.type;
        data["code"] = this.code;
        data["isNegative"] = this.isNegative;
        data["operatorString"] = this.operatorString;
        data["parentId"] = this.parentId;
        return data;
    }

    clone(): GeneralDataValueDto {
        const json = this.toJSON();
        let result = new GeneralDataValueDto();
        result.init(json);
        return result;
    }
}

export interface IGeneralDataValueDto {
    tenantId: number;
    key: string | undefined;
    type: string | undefined;
    code: string | undefined;
    isNegative: boolean;
    operatorString: string | undefined;
    parentId: number;
}

export class GeneralLedgerData implements IGeneralLedgerData {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    year: number;
    generalData: string | undefined;
    isAudited: boolean;
    auditedDate: moment.Moment | undefined;
    auditorUserId: number;
    auditorUserName: string | undefined;
    auditorUserEmail: string | undefined;
    reverseAuditedDate: moment.Moment | undefined;
    reverseRemarks: string | undefined;
    reverseDocumentUrl: string | undefined;
    reverseDocumentFileName: string | undefined;
    reverseAuditorUserId: number;
    reverseAuditorUserName: string | undefined;
    reverseAuditorUserEmail: string | undefined;
    userId: number;

    constructor(data?: IGeneralLedgerData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.year = _data["year"];
            this.generalData = _data["generalData"];
            this.isAudited = _data["isAudited"];
            this.auditedDate = _data["auditedDate"] ? moment(_data["auditedDate"].toString()) : <any>undefined;
            this.auditorUserId = _data["auditorUserId"];
            this.auditorUserName = _data["auditorUserName"];
            this.auditorUserEmail = _data["auditorUserEmail"];
            this.reverseAuditedDate = _data["reverseAuditedDate"] ? moment(_data["reverseAuditedDate"].toString()) : <any>undefined;
            this.reverseRemarks = _data["reverseRemarks"];
            this.reverseDocumentUrl = _data["reverseDocumentUrl"];
            this.reverseDocumentFileName = _data["reverseDocumentFileName"];
            this.reverseAuditorUserId = _data["reverseAuditorUserId"];
            this.reverseAuditorUserName = _data["reverseAuditorUserName"];
            this.reverseAuditorUserEmail = _data["reverseAuditorUserEmail"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): GeneralLedgerData {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralLedgerData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["year"] = this.year;
        data["generalData"] = this.generalData;
        data["isAudited"] = this.isAudited;
        data["auditedDate"] = this.auditedDate ? this.auditedDate.toISOString() : <any>undefined;
        data["auditorUserId"] = this.auditorUserId;
        data["auditorUserName"] = this.auditorUserName;
        data["auditorUserEmail"] = this.auditorUserEmail;
        data["reverseAuditedDate"] = this.reverseAuditedDate ? this.reverseAuditedDate.toISOString() : <any>undefined;
        data["reverseRemarks"] = this.reverseRemarks;
        data["reverseDocumentUrl"] = this.reverseDocumentUrl;
        data["reverseDocumentFileName"] = this.reverseDocumentFileName;
        data["reverseAuditorUserId"] = this.reverseAuditorUserId;
        data["reverseAuditorUserName"] = this.reverseAuditorUserName;
        data["reverseAuditorUserEmail"] = this.reverseAuditorUserEmail;
        data["userId"] = this.userId;
        return data;
    }

    clone(): GeneralLedgerData {
        const json = this.toJSON();
        let result = new GeneralLedgerData();
        result.init(json);
        return result;
    }
}

export interface IGeneralLedgerData {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    year: number;
    generalData: string | undefined;
    isAudited: boolean;
    auditedDate: moment.Moment | undefined;
    auditorUserId: number;
    auditorUserName: string | undefined;
    auditorUserEmail: string | undefined;
    reverseAuditedDate: moment.Moment | undefined;
    reverseRemarks: string | undefined;
    reverseDocumentUrl: string | undefined;
    reverseDocumentFileName: string | undefined;
    reverseAuditorUserId: number;
    reverseAuditorUserName: string | undefined;
    reverseAuditorUserEmail: string | undefined;
    userId: number;
}

export class GeneralLedgerDataDto implements IGeneralLedgerDataDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    year: number;
    generalData: string | undefined;
    isAudited: boolean;
    auditedDate: moment.Moment | undefined;
    auditorUserId: number;
    auditorUserName: string | undefined;
    auditorUserEmail: string | undefined;
    reverseAuditedDate: moment.Moment | undefined;
    reverseRemarks: string | undefined;
    reverseDocumentUrl: string | undefined;
    reverseDocumentFileName: string | undefined;
    reverseAuditorUserId: number;
    reverseAuditorUserName: string | undefined;
    reverseAuditorUserEmail: string | undefined;
    userId: number;

    constructor(data?: IGeneralLedgerDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.year = _data["year"];
            this.generalData = _data["generalData"];
            this.isAudited = _data["isAudited"];
            this.auditedDate = _data["auditedDate"] ? moment(_data["auditedDate"].toString()) : <any>undefined;
            this.auditorUserId = _data["auditorUserId"];
            this.auditorUserName = _data["auditorUserName"];
            this.auditorUserEmail = _data["auditorUserEmail"];
            this.reverseAuditedDate = _data["reverseAuditedDate"] ? moment(_data["reverseAuditedDate"].toString()) : <any>undefined;
            this.reverseRemarks = _data["reverseRemarks"];
            this.reverseDocumentUrl = _data["reverseDocumentUrl"];
            this.reverseDocumentFileName = _data["reverseDocumentFileName"];
            this.reverseAuditorUserId = _data["reverseAuditorUserId"];
            this.reverseAuditorUserName = _data["reverseAuditorUserName"];
            this.reverseAuditorUserEmail = _data["reverseAuditorUserEmail"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): GeneralLedgerDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralLedgerDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["year"] = this.year;
        data["generalData"] = this.generalData;
        data["isAudited"] = this.isAudited;
        data["auditedDate"] = this.auditedDate ? this.auditedDate.toISOString() : <any>undefined;
        data["auditorUserId"] = this.auditorUserId;
        data["auditorUserName"] = this.auditorUserName;
        data["auditorUserEmail"] = this.auditorUserEmail;
        data["reverseAuditedDate"] = this.reverseAuditedDate ? this.reverseAuditedDate.toISOString() : <any>undefined;
        data["reverseRemarks"] = this.reverseRemarks;
        data["reverseDocumentUrl"] = this.reverseDocumentUrl;
        data["reverseDocumentFileName"] = this.reverseDocumentFileName;
        data["reverseAuditorUserId"] = this.reverseAuditorUserId;
        data["reverseAuditorUserName"] = this.reverseAuditorUserName;
        data["reverseAuditorUserEmail"] = this.reverseAuditorUserEmail;
        data["userId"] = this.userId;
        return data;
    }

    clone(): GeneralLedgerDataDto {
        const json = this.toJSON();
        let result = new GeneralLedgerDataDto();
        result.init(json);
        return result;
    }
}

export interface IGeneralLedgerDataDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    year: number;
    generalData: string | undefined;
    isAudited: boolean;
    auditedDate: moment.Moment | undefined;
    auditorUserId: number;
    auditorUserName: string | undefined;
    auditorUserEmail: string | undefined;
    reverseAuditedDate: moment.Moment | undefined;
    reverseRemarks: string | undefined;
    reverseDocumentUrl: string | undefined;
    reverseDocumentFileName: string | undefined;
    reverseAuditorUserId: number;
    reverseAuditorUserName: string | undefined;
    reverseAuditorUserEmail: string | undefined;
    userId: number;
}

export class GeneralLedgerDataDtoPagedResultDto implements IGeneralLedgerDataDtoPagedResultDto {
    items: GeneralLedgerDataDto[] | undefined;
    totalCount: number;

    constructor(data?: IGeneralLedgerDataDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(GeneralLedgerDataDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): GeneralLedgerDataDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralLedgerDataDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): GeneralLedgerDataDtoPagedResultDto {
        const json = this.toJSON();
        let result = new GeneralLedgerDataDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IGeneralLedgerDataDtoPagedResultDto {
    items: GeneralLedgerDataDto[] | undefined;
    totalCount: number;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GoodsReceivedNoteDto implements IGoodsReceivedNoteDto {
    goodsReceivedNoteId: number;
    tenantId: number;
    grnReferenceNo: string | undefined;
    factoryTransferNumber: string | undefined;
    supplierDeliveryOrderReferenceNo: string | undefined;
    supplierDeliveryOrderUrl: string | undefined;
    remarks: string | undefined;
    receivedBy: string | undefined;
    dateReceived: moment.Moment;
    taxAmount: number;
    deliveryCost: number;
    installationCost: number;
    purchaseAmount: number;
    totalAmount: number;
    creditNoteOffsetAmount: number;
    creditNotePurchaseAmount: number;
    creditNoteTaxAmount: number;
    creditNoteTotalAmount: number;
    creditNoteAttachmentUrl: string | undefined;
    creditNoteReferenceNo: string | undefined;
    vendorInvoiceItems: VendorInvoiceItem[] | undefined;
    createdDate: moment.Moment;
    vendorInvoiceId: number;
    vendorInvoice: VendorInvoice;
    installation: string | undefined;
    completionApprovedBy: string | undefined;
    completionDate: moment.Moment;
    completionReportUrl: string | undefined;
    hasAsset: boolean;
    hasInventory: boolean;
    hasRejectedItem: boolean;
    hasShortItem: boolean;
    hasSupplementaryGrn: boolean;
    matchSupplementary: boolean;
    supplementaryGrnDoUrl: string | undefined;
    supplementaryGrnDoRefNo: string | undefined;
    supplementaryGrnRemarks: string | undefined;
    supplementaryGrnReceivedBy: string | undefined;
    supplementaryGrnDateReceived: moment.Moment;
    supplementaryGrnPurchaseAmount: number;
    supplementaryGrnTaxAmount: number;
    supplementaryGrnTotalAmount: number;
    isUpdatedInventory: boolean;
    warehouseId: number | undefined;
    warehouse: InventoryWarehouse;
    status: number;

    constructor(data?: IGoodsReceivedNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.goodsReceivedNoteId = _data["goodsReceivedNoteId"];
            this.tenantId = _data["tenantId"];
            this.grnReferenceNo = _data["grnReferenceNo"];
            this.factoryTransferNumber = _data["factoryTransferNumber"];
            this.supplierDeliveryOrderReferenceNo = _data["supplierDeliveryOrderReferenceNo"];
            this.supplierDeliveryOrderUrl = _data["supplierDeliveryOrderUrl"];
            this.remarks = _data["remarks"];
            this.receivedBy = _data["receivedBy"];
            this.dateReceived = _data["dateReceived"] ? moment(_data["dateReceived"].toString()) : <any>undefined;
            this.taxAmount = _data["taxAmount"];
            this.deliveryCost = _data["deliveryCost"];
            this.installationCost = _data["installationCost"];
            this.purchaseAmount = _data["purchaseAmount"];
            this.totalAmount = _data["totalAmount"];
            this.creditNoteOffsetAmount = _data["creditNoteOffsetAmount"];
            this.creditNotePurchaseAmount = _data["creditNotePurchaseAmount"];
            this.creditNoteTaxAmount = _data["creditNoteTaxAmount"];
            this.creditNoteTotalAmount = _data["creditNoteTotalAmount"];
            this.creditNoteAttachmentUrl = _data["creditNoteAttachmentUrl"];
            this.creditNoteReferenceNo = _data["creditNoteReferenceNo"];
            if (Array.isArray(_data["vendorInvoiceItems"])) {
                this.vendorInvoiceItems = [] as any;
                for (let item of _data["vendorInvoiceItems"])
                    this.vendorInvoiceItems.push(VendorInvoiceItem.fromJS(item));
            }
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : <any>undefined;
            this.vendorInvoiceId = _data["vendorInvoiceId"];
            this.vendorInvoice = _data["vendorInvoice"] ? VendorInvoice.fromJS(_data["vendorInvoice"]) : <any>undefined;
            this.installation = _data["installation"];
            this.completionApprovedBy = _data["completionApprovedBy"];
            this.completionDate = _data["completionDate"] ? moment(_data["completionDate"].toString()) : <any>undefined;
            this.completionReportUrl = _data["completionReportUrl"];
            this.hasAsset = _data["hasAsset"];
            this.hasInventory = _data["hasInventory"];
            this.hasRejectedItem = _data["hasRejectedItem"];
            this.hasShortItem = _data["hasShortItem"];
            this.hasSupplementaryGrn = _data["hasSupplementaryGrn"];
            this.matchSupplementary = _data["matchSupplementary"];
            this.supplementaryGrnDoUrl = _data["supplementaryGrnDoUrl"];
            this.supplementaryGrnDoRefNo = _data["supplementaryGrnDoRefNo"];
            this.supplementaryGrnRemarks = _data["supplementaryGrnRemarks"];
            this.supplementaryGrnReceivedBy = _data["supplementaryGrnReceivedBy"];
            this.supplementaryGrnDateReceived = _data["supplementaryGrnDateReceived"] ? moment(_data["supplementaryGrnDateReceived"].toString()) : <any>undefined;
            this.supplementaryGrnPurchaseAmount = _data["supplementaryGrnPurchaseAmount"];
            this.supplementaryGrnTaxAmount = _data["supplementaryGrnTaxAmount"];
            this.supplementaryGrnTotalAmount = _data["supplementaryGrnTotalAmount"];
            this.isUpdatedInventory = _data["isUpdatedInventory"];
            this.warehouseId = _data["warehouseId"];
            this.warehouse = _data["warehouse"] ? InventoryWarehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GoodsReceivedNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new GoodsReceivedNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["goodsReceivedNoteId"] = this.goodsReceivedNoteId;
        data["tenantId"] = this.tenantId;
        data["grnReferenceNo"] = this.grnReferenceNo;
        data["factoryTransferNumber"] = this.factoryTransferNumber;
        data["supplierDeliveryOrderReferenceNo"] = this.supplierDeliveryOrderReferenceNo;
        data["supplierDeliveryOrderUrl"] = this.supplierDeliveryOrderUrl;
        data["remarks"] = this.remarks;
        data["receivedBy"] = this.receivedBy;
        data["dateReceived"] = this.dateReceived ? this.dateReceived.toISOString() : <any>undefined;
        data["taxAmount"] = this.taxAmount;
        data["deliveryCost"] = this.deliveryCost;
        data["installationCost"] = this.installationCost;
        data["purchaseAmount"] = this.purchaseAmount;
        data["totalAmount"] = this.totalAmount;
        data["creditNoteOffsetAmount"] = this.creditNoteOffsetAmount;
        data["creditNotePurchaseAmount"] = this.creditNotePurchaseAmount;
        data["creditNoteTaxAmount"] = this.creditNoteTaxAmount;
        data["creditNoteTotalAmount"] = this.creditNoteTotalAmount;
        data["creditNoteAttachmentUrl"] = this.creditNoteAttachmentUrl;
        data["creditNoteReferenceNo"] = this.creditNoteReferenceNo;
        if (Array.isArray(this.vendorInvoiceItems)) {
            data["vendorInvoiceItems"] = [];
            for (let item of this.vendorInvoiceItems)
                data["vendorInvoiceItems"].push(item.toJSON());
        }
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["vendorInvoiceId"] = this.vendorInvoiceId;
        data["vendorInvoice"] = this.vendorInvoice ? this.vendorInvoice.toJSON() : <any>undefined;
        data["installation"] = this.installation;
        data["completionApprovedBy"] = this.completionApprovedBy;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : <any>undefined;
        data["completionReportUrl"] = this.completionReportUrl;
        data["hasAsset"] = this.hasAsset;
        data["hasInventory"] = this.hasInventory;
        data["hasRejectedItem"] = this.hasRejectedItem;
        data["hasShortItem"] = this.hasShortItem;
        data["hasSupplementaryGrn"] = this.hasSupplementaryGrn;
        data["matchSupplementary"] = this.matchSupplementary;
        data["supplementaryGrnDoUrl"] = this.supplementaryGrnDoUrl;
        data["supplementaryGrnDoRefNo"] = this.supplementaryGrnDoRefNo;
        data["supplementaryGrnRemarks"] = this.supplementaryGrnRemarks;
        data["supplementaryGrnReceivedBy"] = this.supplementaryGrnReceivedBy;
        data["supplementaryGrnDateReceived"] = this.supplementaryGrnDateReceived ? this.supplementaryGrnDateReceived.toISOString() : <any>undefined;
        data["supplementaryGrnPurchaseAmount"] = this.supplementaryGrnPurchaseAmount;
        data["supplementaryGrnTaxAmount"] = this.supplementaryGrnTaxAmount;
        data["supplementaryGrnTotalAmount"] = this.supplementaryGrnTotalAmount;
        data["isUpdatedInventory"] = this.isUpdatedInventory;
        data["warehouseId"] = this.warehouseId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["status"] = this.status;
        return data;
    }

    clone(): GoodsReceivedNoteDto {
        const json = this.toJSON();
        let result = new GoodsReceivedNoteDto();
        result.init(json);
        return result;
    }
}

export interface IGoodsReceivedNoteDto {
    goodsReceivedNoteId: number;
    tenantId: number;
    grnReferenceNo: string | undefined;
    factoryTransferNumber: string | undefined;
    supplierDeliveryOrderReferenceNo: string | undefined;
    supplierDeliveryOrderUrl: string | undefined;
    remarks: string | undefined;
    receivedBy: string | undefined;
    dateReceived: moment.Moment;
    taxAmount: number;
    deliveryCost: number;
    installationCost: number;
    purchaseAmount: number;
    totalAmount: number;
    creditNoteOffsetAmount: number;
    creditNotePurchaseAmount: number;
    creditNoteTaxAmount: number;
    creditNoteTotalAmount: number;
    creditNoteAttachmentUrl: string | undefined;
    creditNoteReferenceNo: string | undefined;
    vendorInvoiceItems: VendorInvoiceItem[] | undefined;
    createdDate: moment.Moment;
    vendorInvoiceId: number;
    vendorInvoice: VendorInvoice;
    installation: string | undefined;
    completionApprovedBy: string | undefined;
    completionDate: moment.Moment;
    completionReportUrl: string | undefined;
    hasAsset: boolean;
    hasInventory: boolean;
    hasRejectedItem: boolean;
    hasShortItem: boolean;
    hasSupplementaryGrn: boolean;
    matchSupplementary: boolean;
    supplementaryGrnDoUrl: string | undefined;
    supplementaryGrnDoRefNo: string | undefined;
    supplementaryGrnRemarks: string | undefined;
    supplementaryGrnReceivedBy: string | undefined;
    supplementaryGrnDateReceived: moment.Moment;
    supplementaryGrnPurchaseAmount: number;
    supplementaryGrnTaxAmount: number;
    supplementaryGrnTotalAmount: number;
    isUpdatedInventory: boolean;
    warehouseId: number | undefined;
    warehouse: InventoryWarehouse;
    status: number;
}

export class GoodsReceivedNoteDtoPagedResultDto implements IGoodsReceivedNoteDtoPagedResultDto {
    items: GoodsReceivedNoteDto[] | undefined;
    totalCount: number;

    constructor(data?: IGoodsReceivedNoteDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(GoodsReceivedNoteDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): GoodsReceivedNoteDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GoodsReceivedNoteDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): GoodsReceivedNoteDtoPagedResultDto {
        const json = this.toJSON();
        let result = new GoodsReceivedNoteDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IGoodsReceivedNoteDtoPagedResultDto {
    items: GoodsReceivedNoteDto[] | undefined;
    totalCount: number;
}

export class GoodsReceivedNotes implements IGoodsReceivedNotes {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    grnReferenceNo: string | undefined;
    factoryTransferNumber: string | undefined;
    supplierDeliveryOrderReferenceNo: string | undefined;
    supplierDeliveryOrderUrl: string | undefined;
    remarks: string | undefined;
    receivedBy: string | undefined;
    dateReceived: moment.Moment;
    taxAmount: number;
    deliveryCost: number;
    installationCost: number;
    purchaseAmount: number;
    totalAmount: number;
    creditNoteOffsetAmount: number;
    creditNotePurchaseAmount: number;
    creditNoteTaxAmount: number;
    creditNoteTotalAmount: number;
    creditNoteAttachmentUrl: string | undefined;
    creditNoteReferenceNo: string | undefined;
    vendorInvoiceId: number;
    vendorInvoice: VendorInvoice;
    installation: string | undefined;
    completionApprovedBy: string | undefined;
    completionDate: moment.Moment;
    completionReportUrl: string | undefined;
    supplementaryGrnDoUrl: string | undefined;
    supplementaryGrnDoRefNo: string | undefined;
    supplementaryGrnRemarks: string | undefined;
    supplementaryGrnReceivedBy: string | undefined;
    supplementaryGrnDateReceived: moment.Moment;
    supplementaryGrnPurchaseAmount: number;
    supplementaryGrnTaxAmount: number;
    supplementaryGrnTotalAmount: number;
    isUpdatedInventory: boolean;
    warehouseId: number | undefined;
    warehouse: InventoryWarehouse;
    status: number;

    constructor(data?: IGoodsReceivedNotes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.grnReferenceNo = _data["grnReferenceNo"];
            this.factoryTransferNumber = _data["factoryTransferNumber"];
            this.supplierDeliveryOrderReferenceNo = _data["supplierDeliveryOrderReferenceNo"];
            this.supplierDeliveryOrderUrl = _data["supplierDeliveryOrderUrl"];
            this.remarks = _data["remarks"];
            this.receivedBy = _data["receivedBy"];
            this.dateReceived = _data["dateReceived"] ? moment(_data["dateReceived"].toString()) : <any>undefined;
            this.taxAmount = _data["taxAmount"];
            this.deliveryCost = _data["deliveryCost"];
            this.installationCost = _data["installationCost"];
            this.purchaseAmount = _data["purchaseAmount"];
            this.totalAmount = _data["totalAmount"];
            this.creditNoteOffsetAmount = _data["creditNoteOffsetAmount"];
            this.creditNotePurchaseAmount = _data["creditNotePurchaseAmount"];
            this.creditNoteTaxAmount = _data["creditNoteTaxAmount"];
            this.creditNoteTotalAmount = _data["creditNoteTotalAmount"];
            this.creditNoteAttachmentUrl = _data["creditNoteAttachmentUrl"];
            this.creditNoteReferenceNo = _data["creditNoteReferenceNo"];
            this.vendorInvoiceId = _data["vendorInvoiceId"];
            this.vendorInvoice = _data["vendorInvoice"] ? VendorInvoice.fromJS(_data["vendorInvoice"]) : <any>undefined;
            this.installation = _data["installation"];
            this.completionApprovedBy = _data["completionApprovedBy"];
            this.completionDate = _data["completionDate"] ? moment(_data["completionDate"].toString()) : <any>undefined;
            this.completionReportUrl = _data["completionReportUrl"];
            this.supplementaryGrnDoUrl = _data["supplementaryGrnDoUrl"];
            this.supplementaryGrnDoRefNo = _data["supplementaryGrnDoRefNo"];
            this.supplementaryGrnRemarks = _data["supplementaryGrnRemarks"];
            this.supplementaryGrnReceivedBy = _data["supplementaryGrnReceivedBy"];
            this.supplementaryGrnDateReceived = _data["supplementaryGrnDateReceived"] ? moment(_data["supplementaryGrnDateReceived"].toString()) : <any>undefined;
            this.supplementaryGrnPurchaseAmount = _data["supplementaryGrnPurchaseAmount"];
            this.supplementaryGrnTaxAmount = _data["supplementaryGrnTaxAmount"];
            this.supplementaryGrnTotalAmount = _data["supplementaryGrnTotalAmount"];
            this.isUpdatedInventory = _data["isUpdatedInventory"];
            this.warehouseId = _data["warehouseId"];
            this.warehouse = _data["warehouse"] ? InventoryWarehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GoodsReceivedNotes {
        data = typeof data === 'object' ? data : {};
        let result = new GoodsReceivedNotes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["grnReferenceNo"] = this.grnReferenceNo;
        data["factoryTransferNumber"] = this.factoryTransferNumber;
        data["supplierDeliveryOrderReferenceNo"] = this.supplierDeliveryOrderReferenceNo;
        data["supplierDeliveryOrderUrl"] = this.supplierDeliveryOrderUrl;
        data["remarks"] = this.remarks;
        data["receivedBy"] = this.receivedBy;
        data["dateReceived"] = this.dateReceived ? this.dateReceived.toISOString() : <any>undefined;
        data["taxAmount"] = this.taxAmount;
        data["deliveryCost"] = this.deliveryCost;
        data["installationCost"] = this.installationCost;
        data["purchaseAmount"] = this.purchaseAmount;
        data["totalAmount"] = this.totalAmount;
        data["creditNoteOffsetAmount"] = this.creditNoteOffsetAmount;
        data["creditNotePurchaseAmount"] = this.creditNotePurchaseAmount;
        data["creditNoteTaxAmount"] = this.creditNoteTaxAmount;
        data["creditNoteTotalAmount"] = this.creditNoteTotalAmount;
        data["creditNoteAttachmentUrl"] = this.creditNoteAttachmentUrl;
        data["creditNoteReferenceNo"] = this.creditNoteReferenceNo;
        data["vendorInvoiceId"] = this.vendorInvoiceId;
        data["vendorInvoice"] = this.vendorInvoice ? this.vendorInvoice.toJSON() : <any>undefined;
        data["installation"] = this.installation;
        data["completionApprovedBy"] = this.completionApprovedBy;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : <any>undefined;
        data["completionReportUrl"] = this.completionReportUrl;
        data["supplementaryGrnDoUrl"] = this.supplementaryGrnDoUrl;
        data["supplementaryGrnDoRefNo"] = this.supplementaryGrnDoRefNo;
        data["supplementaryGrnRemarks"] = this.supplementaryGrnRemarks;
        data["supplementaryGrnReceivedBy"] = this.supplementaryGrnReceivedBy;
        data["supplementaryGrnDateReceived"] = this.supplementaryGrnDateReceived ? this.supplementaryGrnDateReceived.toISOString() : <any>undefined;
        data["supplementaryGrnPurchaseAmount"] = this.supplementaryGrnPurchaseAmount;
        data["supplementaryGrnTaxAmount"] = this.supplementaryGrnTaxAmount;
        data["supplementaryGrnTotalAmount"] = this.supplementaryGrnTotalAmount;
        data["isUpdatedInventory"] = this.isUpdatedInventory;
        data["warehouseId"] = this.warehouseId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["status"] = this.status;
        return data;
    }

    clone(): GoodsReceivedNotes {
        const json = this.toJSON();
        let result = new GoodsReceivedNotes();
        result.init(json);
        return result;
    }
}

export interface IGoodsReceivedNotes {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    grnReferenceNo: string | undefined;
    factoryTransferNumber: string | undefined;
    supplierDeliveryOrderReferenceNo: string | undefined;
    supplierDeliveryOrderUrl: string | undefined;
    remarks: string | undefined;
    receivedBy: string | undefined;
    dateReceived: moment.Moment;
    taxAmount: number;
    deliveryCost: number;
    installationCost: number;
    purchaseAmount: number;
    totalAmount: number;
    creditNoteOffsetAmount: number;
    creditNotePurchaseAmount: number;
    creditNoteTaxAmount: number;
    creditNoteTotalAmount: number;
    creditNoteAttachmentUrl: string | undefined;
    creditNoteReferenceNo: string | undefined;
    vendorInvoiceId: number;
    vendorInvoice: VendorInvoice;
    installation: string | undefined;
    completionApprovedBy: string | undefined;
    completionDate: moment.Moment;
    completionReportUrl: string | undefined;
    supplementaryGrnDoUrl: string | undefined;
    supplementaryGrnDoRefNo: string | undefined;
    supplementaryGrnRemarks: string | undefined;
    supplementaryGrnReceivedBy: string | undefined;
    supplementaryGrnDateReceived: moment.Moment;
    supplementaryGrnPurchaseAmount: number;
    supplementaryGrnTaxAmount: number;
    supplementaryGrnTotalAmount: number;
    isUpdatedInventory: boolean;
    warehouseId: number | undefined;
    warehouse: InventoryWarehouse;
    status: number;
}

export class HolidayModel implements IHolidayModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    year: number;
    month: number;
    readonly monthString: string | undefined;
    day: number;
    name: string;
    readonly date: moment.Moment;
    endYear: number;
    endMonth: number;
    readonly endMonthString: string | undefined;
    endDay: number;
    readonly endDate: moment.Moment;
    visibilityGroup: number;
    payRate: number;

    constructor(data?: IHolidayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.year = _data["year"];
            this.month = _data["month"];
            (<any>this).monthString = _data["monthString"];
            this.day = _data["day"];
            this.name = _data["name"];
            (<any>this).date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.endYear = _data["endYear"];
            this.endMonth = _data["endMonth"];
            (<any>this).endMonthString = _data["endMonthString"];
            this.endDay = _data["endDay"];
            (<any>this).endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.visibilityGroup = _data["visibilityGroup"];
            this.payRate = _data["payRate"];
        }
    }

    static fromJS(data: any): HolidayModel {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["year"] = this.year;
        data["month"] = this.month;
        data["monthString"] = this.monthString;
        data["day"] = this.day;
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["endYear"] = this.endYear;
        data["endMonth"] = this.endMonth;
        data["endMonthString"] = this.endMonthString;
        data["endDay"] = this.endDay;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["visibilityGroup"] = this.visibilityGroup;
        data["payRate"] = this.payRate;
        return data;
    }

    clone(): HolidayModel {
        const json = this.toJSON();
        let result = new HolidayModel();
        result.init(json);
        return result;
    }
}

export interface IHolidayModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    year: number;
    month: number;
    monthString: string | undefined;
    day: number;
    name: string;
    date: moment.Moment;
    endYear: number;
    endMonth: number;
    endMonthString: string | undefined;
    endDay: number;
    endDate: moment.Moment;
    visibilityGroup: number;
    payRate: number;
}

export class HolidayModelDto implements IHolidayModelDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    year: number;
    month: number;
    readonly monthString: string | undefined;
    day: number;
    name: string | undefined;
    readonly date: moment.Moment;
    endYear: number;
    endMonth: number;
    readonly endMonthString: string | undefined;
    endDay: number;
    readonly endDate: moment.Moment;
    visibilityGroup: number;
    payRate: number;

    constructor(data?: IHolidayModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.year = _data["year"];
            this.month = _data["month"];
            (<any>this).monthString = _data["monthString"];
            this.day = _data["day"];
            this.name = _data["name"];
            (<any>this).date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.endYear = _data["endYear"];
            this.endMonth = _data["endMonth"];
            (<any>this).endMonthString = _data["endMonthString"];
            this.endDay = _data["endDay"];
            (<any>this).endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.visibilityGroup = _data["visibilityGroup"];
            this.payRate = _data["payRate"];
        }
    }

    static fromJS(data: any): HolidayModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["year"] = this.year;
        data["month"] = this.month;
        data["monthString"] = this.monthString;
        data["day"] = this.day;
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["endYear"] = this.endYear;
        data["endMonth"] = this.endMonth;
        data["endMonthString"] = this.endMonthString;
        data["endDay"] = this.endDay;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["visibilityGroup"] = this.visibilityGroup;
        data["payRate"] = this.payRate;
        return data;
    }

    clone(): HolidayModelDto {
        const json = this.toJSON();
        let result = new HolidayModelDto();
        result.init(json);
        return result;
    }
}

export interface IHolidayModelDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    year: number;
    month: number;
    monthString: string | undefined;
    day: number;
    name: string | undefined;
    date: moment.Moment;
    endYear: number;
    endMonth: number;
    endMonthString: string | undefined;
    endDay: number;
    endDate: moment.Moment;
    visibilityGroup: number;
    payRate: number;
}

export class HolidayModelDtoPagedResultDto implements IHolidayModelDtoPagedResultDto {
    items: HolidayModelDto[] | undefined;
    totalCount: number;

    constructor(data?: IHolidayModelDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(HolidayModelDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): HolidayModelDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayModelDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): HolidayModelDtoPagedResultDto {
        const json = this.toJSON();
        let result = new HolidayModelDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IHolidayModelDtoPagedResultDto {
    items: HolidayModelDto[] | undefined;
    totalCount: number;
}

export class InnerErrorDto implements IInnerErrorDto {
    propertyName: string | undefined;
    propertyPath: string | undefined;
    errorCode: string | undefined;
    error: string | undefined;
    errorMs: string | undefined;

    constructor(data?: IInnerErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.propertyPath = _data["propertyPath"];
            this.errorCode = _data["errorCode"];
            this.error = _data["error"];
            this.errorMs = _data["errorMs"];
        }
    }

    static fromJS(data: any): InnerErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new InnerErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["propertyPath"] = this.propertyPath;
        data["errorCode"] = this.errorCode;
        data["error"] = this.error;
        data["errorMs"] = this.errorMs;
        return data;
    }

    clone(): InnerErrorDto {
        const json = this.toJSON();
        let result = new InnerErrorDto();
        result.init(json);
        return result;
    }
}

export interface IInnerErrorDto {
    propertyName: string | undefined;
    propertyPath: string | undefined;
    errorCode: string | undefined;
    error: string | undefined;
    errorMs: string | undefined;
}

export class Int64EntityDto implements IInt64EntityDto {
    id: number;

    constructor(data?: IInt64EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Int64EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int64EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): Int64EntityDto {
        const json = this.toJSON();
        let result = new Int64EntityDto();
        result.init(json);
        return result;
    }
}

export interface IInt64EntityDto {
    id: number;
}

export class InventoryCategory implements IInventoryCategory {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    type: number;
    name: string;
    hasSubCategory: boolean;
    parentId: number;

    constructor(data?: IInventoryCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.type = _data["type"];
            this.name = _data["name"];
            this.hasSubCategory = _data["hasSubCategory"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): InventoryCategory {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["type"] = this.type;
        data["name"] = this.name;
        data["hasSubCategory"] = this.hasSubCategory;
        data["parentId"] = this.parentId;
        return data;
    }

    clone(): InventoryCategory {
        const json = this.toJSON();
        let result = new InventoryCategory();
        result.init(json);
        return result;
    }
}

export interface IInventoryCategory {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    type: number;
    name: string;
    hasSubCategory: boolean;
    parentId: number;
}

export class InventoryCategoryDto implements IInventoryCategoryDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    type: number;
    name: string | undefined;
    hasSubCategory: boolean;
    parentId: number;
    productsList: ProductDto[] | undefined;
    productsListLength: number;
    materialsList: MaterialDto[] | undefined;
    materialsListLength: number;
    productLocationList: InventoryProductOnShelf[] | undefined;
    materialLocationList: InventoryMaterialOnShelf[] | undefined;
    totalInvoiceQty: number;
    totalBillQty: number;
    totalCreditNoteQty: number;
    totalWriteOffQty: number;
    totalStockCountQty: number;
    openingStock: number;
    closingStock: number;
    totalValue: number;
    totalOpeningValue: number;
    unitValue: number;
    totalManualEntryQty: number;
    totalTransferBetweenLocationQty: number;
    totalTransferFromFactoryQty: number;
    totalIssueToProductionQty: number;
    totalIssueToProjectQty: number;
    totalWorkInProgressQty: number;

    constructor(data?: IInventoryCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.type = _data["type"];
            this.name = _data["name"];
            this.hasSubCategory = _data["hasSubCategory"];
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["productsList"])) {
                this.productsList = [] as any;
                for (let item of _data["productsList"])
                    this.productsList.push(ProductDto.fromJS(item));
            }
            this.productsListLength = _data["productsListLength"];
            if (Array.isArray(_data["materialsList"])) {
                this.materialsList = [] as any;
                for (let item of _data["materialsList"])
                    this.materialsList.push(MaterialDto.fromJS(item));
            }
            this.materialsListLength = _data["materialsListLength"];
            if (Array.isArray(_data["productLocationList"])) {
                this.productLocationList = [] as any;
                for (let item of _data["productLocationList"])
                    this.productLocationList.push(InventoryProductOnShelf.fromJS(item));
            }
            if (Array.isArray(_data["materialLocationList"])) {
                this.materialLocationList = [] as any;
                for (let item of _data["materialLocationList"])
                    this.materialLocationList.push(InventoryMaterialOnShelf.fromJS(item));
            }
            this.totalInvoiceQty = _data["totalInvoiceQty"];
            this.totalBillQty = _data["totalBillQty"];
            this.totalCreditNoteQty = _data["totalCreditNoteQty"];
            this.totalWriteOffQty = _data["totalWriteOffQty"];
            this.totalStockCountQty = _data["totalStockCountQty"];
            this.openingStock = _data["openingStock"];
            this.closingStock = _data["closingStock"];
            this.totalValue = _data["totalValue"];
            this.totalOpeningValue = _data["totalOpeningValue"];
            this.unitValue = _data["unitValue"];
            this.totalManualEntryQty = _data["totalManualEntryQty"];
            this.totalTransferBetweenLocationQty = _data["totalTransferBetweenLocationQty"];
            this.totalTransferFromFactoryQty = _data["totalTransferFromFactoryQty"];
            this.totalIssueToProductionQty = _data["totalIssueToProductionQty"];
            this.totalIssueToProjectQty = _data["totalIssueToProjectQty"];
            this.totalWorkInProgressQty = _data["totalWorkInProgressQty"];
        }
    }

    static fromJS(data: any): InventoryCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["type"] = this.type;
        data["name"] = this.name;
        data["hasSubCategory"] = this.hasSubCategory;
        data["parentId"] = this.parentId;
        if (Array.isArray(this.productsList)) {
            data["productsList"] = [];
            for (let item of this.productsList)
                data["productsList"].push(item.toJSON());
        }
        data["productsListLength"] = this.productsListLength;
        if (Array.isArray(this.materialsList)) {
            data["materialsList"] = [];
            for (let item of this.materialsList)
                data["materialsList"].push(item.toJSON());
        }
        data["materialsListLength"] = this.materialsListLength;
        if (Array.isArray(this.productLocationList)) {
            data["productLocationList"] = [];
            for (let item of this.productLocationList)
                data["productLocationList"].push(item.toJSON());
        }
        if (Array.isArray(this.materialLocationList)) {
            data["materialLocationList"] = [];
            for (let item of this.materialLocationList)
                data["materialLocationList"].push(item.toJSON());
        }
        data["totalInvoiceQty"] = this.totalInvoiceQty;
        data["totalBillQty"] = this.totalBillQty;
        data["totalCreditNoteQty"] = this.totalCreditNoteQty;
        data["totalWriteOffQty"] = this.totalWriteOffQty;
        data["totalStockCountQty"] = this.totalStockCountQty;
        data["openingStock"] = this.openingStock;
        data["closingStock"] = this.closingStock;
        data["totalValue"] = this.totalValue;
        data["totalOpeningValue"] = this.totalOpeningValue;
        data["unitValue"] = this.unitValue;
        data["totalManualEntryQty"] = this.totalManualEntryQty;
        data["totalTransferBetweenLocationQty"] = this.totalTransferBetweenLocationQty;
        data["totalTransferFromFactoryQty"] = this.totalTransferFromFactoryQty;
        data["totalIssueToProductionQty"] = this.totalIssueToProductionQty;
        data["totalIssueToProjectQty"] = this.totalIssueToProjectQty;
        data["totalWorkInProgressQty"] = this.totalWorkInProgressQty;
        return data;
    }

    clone(): InventoryCategoryDto {
        const json = this.toJSON();
        let result = new InventoryCategoryDto();
        result.init(json);
        return result;
    }
}

export interface IInventoryCategoryDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    type: number;
    name: string | undefined;
    hasSubCategory: boolean;
    parentId: number;
    productsList: ProductDto[] | undefined;
    productsListLength: number;
    materialsList: MaterialDto[] | undefined;
    materialsListLength: number;
    productLocationList: InventoryProductOnShelf[] | undefined;
    materialLocationList: InventoryMaterialOnShelf[] | undefined;
    totalInvoiceQty: number;
    totalBillQty: number;
    totalCreditNoteQty: number;
    totalWriteOffQty: number;
    totalStockCountQty: number;
    openingStock: number;
    closingStock: number;
    totalValue: number;
    totalOpeningValue: number;
    unitValue: number;
    totalManualEntryQty: number;
    totalTransferBetweenLocationQty: number;
    totalTransferFromFactoryQty: number;
    totalIssueToProductionQty: number;
    totalIssueToProjectQty: number;
    totalWorkInProgressQty: number;
}

export class InventoryCategoryDtoPagedResultDto implements IInventoryCategoryDtoPagedResultDto {
    items: InventoryCategoryDto[] | undefined;
    totalCount: number;

    constructor(data?: IInventoryCategoryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(InventoryCategoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InventoryCategoryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryCategoryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InventoryCategoryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InventoryCategoryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInventoryCategoryDtoPagedResultDto {
    items: InventoryCategoryDto[] | undefined;
    totalCount: number;
}

export class InventoryItemDto implements IInventoryItemDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    price: number;
    tenantId: number | undefined;
    tenant: Tenant;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    hideFromMarketplace: boolean;
    companyProfileId: string | undefined;
    companyProfile: CompanyProfile;
    isUserFeatured: boolean;
    showQuantity: boolean;
    minLevel: number;
    isNotifiedMinLevel: boolean;
    tagNumber: string | undefined;
    barCode: string | undefined;
    productMaterialRelations: ProductMaterialRelation[] | undefined;
    averagePriceFromPo: number;
    averageProductionCost: number;
    lastSellingPrice: number;
    lastPriceFromPo: number;
    lastProductionCost: number;
    priceList: ProductPriceHistoryDto[] | undefined;
    inventoryCategoryId: number | undefined;
    producerTenantId: number;
    closingStock: number;
    nextCount: number;
    totalValue: number;
    previousCount: number;
    totalInvoiceQty: number;
    totalBillQty: number;
    totalCreditNoteQty: number;
    totalWriteOffQty: number;
    totalStockCountQty: number;
    openingStock: number;
    totalManualEntryQty: number;
    totalTransferFromFactoryQty: number;
    totalTransferBetweenLocationQty: number;
    totalIssueToProductionQty: number;
    projectId: number;
    itemType: number;
    lastSoldBill: moment.Moment | undefined;

    constructor(data?: IInventoryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.oldPrice = _data["oldPrice"];
            this.discount = _data["discount"];
            this.ratingsCount = _data["ratingsCount"];
            this.ratingsValue = _data["ratingsValue"];
            this.availibilityCount = _data["availibilityCount"];
            this.cartCount = _data["cartCount"];
            this.weight = _data["weight"];
            this.categoryId = _data["categoryId"];
            this.fullDescription = _data["fullDescription"];
            this.serviceTax = _data["serviceTax"];
            this.taxCode = _data["taxCode"];
            this.isSubsidized = _data["isSubsidized"];
            this.isCertified = _data["isCertified"];
            this.isIslamic = _data["isIslamic"];
            this.isLoanAvailable = _data["isLoanAvailable"];
            this.isFeatured = _data["isFeatured"];
            this.isTypeSerice = _data["isTypeSerice"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.hideFromMarketplace = _data["hideFromMarketplace"];
            this.companyProfileId = _data["companyProfileId"];
            this.companyProfile = _data["companyProfile"] ? CompanyProfile.fromJS(_data["companyProfile"]) : <any>undefined;
            this.isUserFeatured = _data["isUserFeatured"];
            this.showQuantity = _data["showQuantity"];
            this.minLevel = _data["minLevel"];
            this.isNotifiedMinLevel = _data["isNotifiedMinLevel"];
            this.tagNumber = _data["tagNumber"];
            this.barCode = _data["barCode"];
            if (Array.isArray(_data["productMaterialRelations"])) {
                this.productMaterialRelations = [] as any;
                for (let item of _data["productMaterialRelations"])
                    this.productMaterialRelations.push(ProductMaterialRelation.fromJS(item));
            }
            this.averagePriceFromPo = _data["averagePriceFromPo"];
            this.averageProductionCost = _data["averageProductionCost"];
            this.lastSellingPrice = _data["lastSellingPrice"];
            this.lastPriceFromPo = _data["lastPriceFromPo"];
            this.lastProductionCost = _data["lastProductionCost"];
            if (Array.isArray(_data["priceList"])) {
                this.priceList = [] as any;
                for (let item of _data["priceList"])
                    this.priceList.push(ProductPriceHistoryDto.fromJS(item));
            }
            this.inventoryCategoryId = _data["inventoryCategoryId"];
            this.producerTenantId = _data["producerTenantId"];
            this.closingStock = _data["closingStock"];
            this.nextCount = _data["nextCount"];
            this.totalValue = _data["totalValue"];
            this.previousCount = _data["previousCount"];
            this.totalInvoiceQty = _data["totalInvoiceQty"];
            this.totalBillQty = _data["totalBillQty"];
            this.totalCreditNoteQty = _data["totalCreditNoteQty"];
            this.totalWriteOffQty = _data["totalWriteOffQty"];
            this.totalStockCountQty = _data["totalStockCountQty"];
            this.openingStock = _data["openingStock"];
            this.totalManualEntryQty = _data["totalManualEntryQty"];
            this.totalTransferFromFactoryQty = _data["totalTransferFromFactoryQty"];
            this.totalTransferBetweenLocationQty = _data["totalTransferBetweenLocationQty"];
            this.totalIssueToProductionQty = _data["totalIssueToProductionQty"];
            this.projectId = _data["projectId"];
            this.itemType = _data["itemType"];
            this.lastSoldBill = _data["lastSoldBill"] ? moment(_data["lastSoldBill"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InventoryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["oldPrice"] = this.oldPrice;
        data["discount"] = this.discount;
        data["ratingsCount"] = this.ratingsCount;
        data["ratingsValue"] = this.ratingsValue;
        data["availibilityCount"] = this.availibilityCount;
        data["cartCount"] = this.cartCount;
        data["weight"] = this.weight;
        data["categoryId"] = this.categoryId;
        data["fullDescription"] = this.fullDescription;
        data["serviceTax"] = this.serviceTax;
        data["taxCode"] = this.taxCode;
        data["isSubsidized"] = this.isSubsidized;
        data["isCertified"] = this.isCertified;
        data["isIslamic"] = this.isIslamic;
        data["isLoanAvailable"] = this.isLoanAvailable;
        data["isFeatured"] = this.isFeatured;
        data["isTypeSerice"] = this.isTypeSerice;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["hideFromMarketplace"] = this.hideFromMarketplace;
        data["companyProfileId"] = this.companyProfileId;
        data["companyProfile"] = this.companyProfile ? this.companyProfile.toJSON() : <any>undefined;
        data["isUserFeatured"] = this.isUserFeatured;
        data["showQuantity"] = this.showQuantity;
        data["minLevel"] = this.minLevel;
        data["isNotifiedMinLevel"] = this.isNotifiedMinLevel;
        data["tagNumber"] = this.tagNumber;
        data["barCode"] = this.barCode;
        if (Array.isArray(this.productMaterialRelations)) {
            data["productMaterialRelations"] = [];
            for (let item of this.productMaterialRelations)
                data["productMaterialRelations"].push(item.toJSON());
        }
        data["averagePriceFromPo"] = this.averagePriceFromPo;
        data["averageProductionCost"] = this.averageProductionCost;
        data["lastSellingPrice"] = this.lastSellingPrice;
        data["lastPriceFromPo"] = this.lastPriceFromPo;
        data["lastProductionCost"] = this.lastProductionCost;
        if (Array.isArray(this.priceList)) {
            data["priceList"] = [];
            for (let item of this.priceList)
                data["priceList"].push(item.toJSON());
        }
        data["inventoryCategoryId"] = this.inventoryCategoryId;
        data["producerTenantId"] = this.producerTenantId;
        data["closingStock"] = this.closingStock;
        data["nextCount"] = this.nextCount;
        data["totalValue"] = this.totalValue;
        data["previousCount"] = this.previousCount;
        data["totalInvoiceQty"] = this.totalInvoiceQty;
        data["totalBillQty"] = this.totalBillQty;
        data["totalCreditNoteQty"] = this.totalCreditNoteQty;
        data["totalWriteOffQty"] = this.totalWriteOffQty;
        data["totalStockCountQty"] = this.totalStockCountQty;
        data["openingStock"] = this.openingStock;
        data["totalManualEntryQty"] = this.totalManualEntryQty;
        data["totalTransferFromFactoryQty"] = this.totalTransferFromFactoryQty;
        data["totalTransferBetweenLocationQty"] = this.totalTransferBetweenLocationQty;
        data["totalIssueToProductionQty"] = this.totalIssueToProductionQty;
        data["projectId"] = this.projectId;
        data["itemType"] = this.itemType;
        data["lastSoldBill"] = this.lastSoldBill ? this.lastSoldBill.toISOString() : <any>undefined;
        return data;
    }

    clone(): InventoryItemDto {
        const json = this.toJSON();
        let result = new InventoryItemDto();
        result.init(json);
        return result;
    }
}

export interface IInventoryItemDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    price: number;
    tenantId: number | undefined;
    tenant: Tenant;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    hideFromMarketplace: boolean;
    companyProfileId: string | undefined;
    companyProfile: CompanyProfile;
    isUserFeatured: boolean;
    showQuantity: boolean;
    minLevel: number;
    isNotifiedMinLevel: boolean;
    tagNumber: string | undefined;
    barCode: string | undefined;
    productMaterialRelations: ProductMaterialRelation[] | undefined;
    averagePriceFromPo: number;
    averageProductionCost: number;
    lastSellingPrice: number;
    lastPriceFromPo: number;
    lastProductionCost: number;
    priceList: ProductPriceHistoryDto[] | undefined;
    inventoryCategoryId: number | undefined;
    producerTenantId: number;
    closingStock: number;
    nextCount: number;
    totalValue: number;
    previousCount: number;
    totalInvoiceQty: number;
    totalBillQty: number;
    totalCreditNoteQty: number;
    totalWriteOffQty: number;
    totalStockCountQty: number;
    openingStock: number;
    totalManualEntryQty: number;
    totalTransferFromFactoryQty: number;
    totalTransferBetweenLocationQty: number;
    totalIssueToProductionQty: number;
    projectId: number;
    itemType: number;
    lastSoldBill: moment.Moment | undefined;
}

export class InventoryLocation implements IInventoryLocation {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    itemGuid: string;
    tenantId: number;
    warehouse: string | undefined;
    shelf: string | undefined;
    quantity: number;

    constructor(data?: IInventoryLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.itemGuid = _data["itemGuid"];
            this.tenantId = _data["tenantId"];
            this.warehouse = _data["warehouse"];
            this.shelf = _data["shelf"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): InventoryLocation {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["itemGuid"] = this.itemGuid;
        data["tenantId"] = this.tenantId;
        data["warehouse"] = this.warehouse;
        data["shelf"] = this.shelf;
        data["quantity"] = this.quantity;
        return data;
    }

    clone(): InventoryLocation {
        const json = this.toJSON();
        let result = new InventoryLocation();
        result.init(json);
        return result;
    }
}

export interface IInventoryLocation {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    itemGuid: string;
    tenantId: number;
    warehouse: string | undefined;
    shelf: string | undefined;
    quantity: number;
}

export class InventoryLocationDto implements IInventoryLocationDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    itemGuid: string;
    tenantId: number;
    warehouse: string | undefined;
    shelf: string | undefined;
    quantity: number;

    constructor(data?: IInventoryLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.itemGuid = _data["itemGuid"];
            this.tenantId = _data["tenantId"];
            this.warehouse = _data["warehouse"];
            this.shelf = _data["shelf"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): InventoryLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["itemGuid"] = this.itemGuid;
        data["tenantId"] = this.tenantId;
        data["warehouse"] = this.warehouse;
        data["shelf"] = this.shelf;
        data["quantity"] = this.quantity;
        return data;
    }

    clone(): InventoryLocationDto {
        const json = this.toJSON();
        let result = new InventoryLocationDto();
        result.init(json);
        return result;
    }
}

export interface IInventoryLocationDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    itemGuid: string;
    tenantId: number;
    warehouse: string | undefined;
    shelf: string | undefined;
    quantity: number;
}

export class InventoryLocationDtoPagedResultDto implements IInventoryLocationDtoPagedResultDto {
    items: InventoryLocationDto[] | undefined;
    totalCount: number;

    constructor(data?: IInventoryLocationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(InventoryLocationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InventoryLocationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryLocationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InventoryLocationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InventoryLocationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInventoryLocationDtoPagedResultDto {
    items: InventoryLocationDto[] | undefined;
    totalCount: number;
}

export class InventoryManualEntry implements IInventoryManualEntry {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    itemType: number;
    itemGuid: string;
    date: moment.Moment;
    quantity: number;
    closingStock: number;
    readonly openingStock: number;
    unitPrice: number;
    tax: number;
    discount: number;
    total: number;
    billItemId: string | undefined;
    manualEntryId: number | undefined;
    invoiceItemId: number | undefined;
    creditNoteId: number | undefined;
    writeOffNoteItemId: number | undefined;
    stockCountItemId: number | undefined;
    transferBetweenLocationItemId: number | undefined;
    transferFromFactoryItemId: number | undefined;
    issueToProductionItemId: number | undefined;
    issueToProjectItemId: number | undefined;

    constructor(data?: IInventoryManualEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.itemType = _data["itemType"];
            this.itemGuid = _data["itemGuid"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.quantity = _data["quantity"];
            this.closingStock = _data["closingStock"];
            (<any>this).openingStock = _data["openingStock"];
            this.unitPrice = _data["unitPrice"];
            this.tax = _data["tax"];
            this.discount = _data["discount"];
            this.total = _data["total"];
            this.billItemId = _data["billItemId"];
            this.manualEntryId = _data["manualEntryId"];
            this.invoiceItemId = _data["invoiceItemId"];
            this.creditNoteId = _data["creditNoteId"];
            this.writeOffNoteItemId = _data["writeOffNoteItemId"];
            this.stockCountItemId = _data["stockCountItemId"];
            this.transferBetweenLocationItemId = _data["transferBetweenLocationItemId"];
            this.transferFromFactoryItemId = _data["transferFromFactoryItemId"];
            this.issueToProductionItemId = _data["issueToProductionItemId"];
            this.issueToProjectItemId = _data["issueToProjectItemId"];
        }
    }

    static fromJS(data: any): InventoryManualEntry {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryManualEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["itemType"] = this.itemType;
        data["itemGuid"] = this.itemGuid;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["quantity"] = this.quantity;
        data["closingStock"] = this.closingStock;
        data["openingStock"] = this.openingStock;
        data["unitPrice"] = this.unitPrice;
        data["tax"] = this.tax;
        data["discount"] = this.discount;
        data["total"] = this.total;
        data["billItemId"] = this.billItemId;
        data["manualEntryId"] = this.manualEntryId;
        data["invoiceItemId"] = this.invoiceItemId;
        data["creditNoteId"] = this.creditNoteId;
        data["writeOffNoteItemId"] = this.writeOffNoteItemId;
        data["stockCountItemId"] = this.stockCountItemId;
        data["transferBetweenLocationItemId"] = this.transferBetweenLocationItemId;
        data["transferFromFactoryItemId"] = this.transferFromFactoryItemId;
        data["issueToProductionItemId"] = this.issueToProductionItemId;
        data["issueToProjectItemId"] = this.issueToProjectItemId;
        return data;
    }

    clone(): InventoryManualEntry {
        const json = this.toJSON();
        let result = new InventoryManualEntry();
        result.init(json);
        return result;
    }
}

export interface IInventoryManualEntry {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    itemType: number;
    itemGuid: string;
    date: moment.Moment;
    quantity: number;
    closingStock: number;
    openingStock: number;
    unitPrice: number;
    tax: number;
    discount: number;
    total: number;
    billItemId: string | undefined;
    manualEntryId: number | undefined;
    invoiceItemId: number | undefined;
    creditNoteId: number | undefined;
    writeOffNoteItemId: number | undefined;
    stockCountItemId: number | undefined;
    transferBetweenLocationItemId: number | undefined;
    transferFromFactoryItemId: number | undefined;
    issueToProductionItemId: number | undefined;
    issueToProjectItemId: number | undefined;
}

export class InventoryManualEntryDto implements IInventoryManualEntryDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    itemType: number;
    itemGuid: string;
    date: moment.Moment;
    quantity: number;
    closingStock: number;
    readonly openingStock: number;
    unitPrice: number;
    tax: number;
    discount: number;
    total: number;
    billItemId: string | undefined;
    manualEntryId: number | undefined;
    invoiceItemId: number | undefined;
    creditNoteId: number | undefined;
    writeOffNoteItemId: number | undefined;
    stockCountItemId: number | undefined;
    transferBetweenLocationItemId: number | undefined;
    transferFromFactoryItemId: number | undefined;
    issueToProductionItemId: number | undefined;
    issueToProjectItemId: number | undefined;

    constructor(data?: IInventoryManualEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.itemType = _data["itemType"];
            this.itemGuid = _data["itemGuid"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.quantity = _data["quantity"];
            this.closingStock = _data["closingStock"];
            (<any>this).openingStock = _data["openingStock"];
            this.unitPrice = _data["unitPrice"];
            this.tax = _data["tax"];
            this.discount = _data["discount"];
            this.total = _data["total"];
            this.billItemId = _data["billItemId"];
            this.manualEntryId = _data["manualEntryId"];
            this.invoiceItemId = _data["invoiceItemId"];
            this.creditNoteId = _data["creditNoteId"];
            this.writeOffNoteItemId = _data["writeOffNoteItemId"];
            this.stockCountItemId = _data["stockCountItemId"];
            this.transferBetweenLocationItemId = _data["transferBetweenLocationItemId"];
            this.transferFromFactoryItemId = _data["transferFromFactoryItemId"];
            this.issueToProductionItemId = _data["issueToProductionItemId"];
            this.issueToProjectItemId = _data["issueToProjectItemId"];
        }
    }

    static fromJS(data: any): InventoryManualEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryManualEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["itemType"] = this.itemType;
        data["itemGuid"] = this.itemGuid;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["quantity"] = this.quantity;
        data["closingStock"] = this.closingStock;
        data["openingStock"] = this.openingStock;
        data["unitPrice"] = this.unitPrice;
        data["tax"] = this.tax;
        data["discount"] = this.discount;
        data["total"] = this.total;
        data["billItemId"] = this.billItemId;
        data["manualEntryId"] = this.manualEntryId;
        data["invoiceItemId"] = this.invoiceItemId;
        data["creditNoteId"] = this.creditNoteId;
        data["writeOffNoteItemId"] = this.writeOffNoteItemId;
        data["stockCountItemId"] = this.stockCountItemId;
        data["transferBetweenLocationItemId"] = this.transferBetweenLocationItemId;
        data["transferFromFactoryItemId"] = this.transferFromFactoryItemId;
        data["issueToProductionItemId"] = this.issueToProductionItemId;
        data["issueToProjectItemId"] = this.issueToProjectItemId;
        return data;
    }

    clone(): InventoryManualEntryDto {
        const json = this.toJSON();
        let result = new InventoryManualEntryDto();
        result.init(json);
        return result;
    }
}

export interface IInventoryManualEntryDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    itemType: number;
    itemGuid: string;
    date: moment.Moment;
    quantity: number;
    closingStock: number;
    openingStock: number;
    unitPrice: number;
    tax: number;
    discount: number;
    total: number;
    billItemId: string | undefined;
    manualEntryId: number | undefined;
    invoiceItemId: number | undefined;
    creditNoteId: number | undefined;
    writeOffNoteItemId: number | undefined;
    stockCountItemId: number | undefined;
    transferBetweenLocationItemId: number | undefined;
    transferFromFactoryItemId: number | undefined;
    issueToProductionItemId: number | undefined;
    issueToProjectItemId: number | undefined;
}

export class InventoryManualEntryDtoPagedResultDto implements IInventoryManualEntryDtoPagedResultDto {
    items: InventoryManualEntryDto[] | undefined;
    totalCount: number;

    constructor(data?: IInventoryManualEntryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(InventoryManualEntryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InventoryManualEntryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryManualEntryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InventoryManualEntryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InventoryManualEntryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInventoryManualEntryDtoPagedResultDto {
    items: InventoryManualEntryDto[] | undefined;
    totalCount: number;
}

export class InventoryMaterialOnShelf implements IInventoryMaterialOnShelf {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    materialGuid: string;
    material: Material;
    inventoryShelfId: number;
    inventoryShelf: InventoryShelf;
    quantity: number;

    constructor(data?: IInventoryMaterialOnShelf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.materialGuid = _data["materialGuid"];
            this.material = _data["material"] ? Material.fromJS(_data["material"]) : <any>undefined;
            this.inventoryShelfId = _data["inventoryShelfId"];
            this.inventoryShelf = _data["inventoryShelf"] ? InventoryShelf.fromJS(_data["inventoryShelf"]) : <any>undefined;
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): InventoryMaterialOnShelf {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryMaterialOnShelf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["materialGuid"] = this.materialGuid;
        data["material"] = this.material ? this.material.toJSON() : <any>undefined;
        data["inventoryShelfId"] = this.inventoryShelfId;
        data["inventoryShelf"] = this.inventoryShelf ? this.inventoryShelf.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        return data;
    }

    clone(): InventoryMaterialOnShelf {
        const json = this.toJSON();
        let result = new InventoryMaterialOnShelf();
        result.init(json);
        return result;
    }
}

export interface IInventoryMaterialOnShelf {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    materialGuid: string;
    material: Material;
    inventoryShelfId: number;
    inventoryShelf: InventoryShelf;
    quantity: number;
}

export class InventoryMaterialOnShelfDto implements IInventoryMaterialOnShelfDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    materialGuid: string;
    material: Material;
    inventoryShelfId: number;
    inventoryShelf: InventoryShelf;
    quantity: number;

    constructor(data?: IInventoryMaterialOnShelfDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.materialGuid = _data["materialGuid"];
            this.material = _data["material"] ? Material.fromJS(_data["material"]) : <any>undefined;
            this.inventoryShelfId = _data["inventoryShelfId"];
            this.inventoryShelf = _data["inventoryShelf"] ? InventoryShelf.fromJS(_data["inventoryShelf"]) : <any>undefined;
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): InventoryMaterialOnShelfDto {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryMaterialOnShelfDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["materialGuid"] = this.materialGuid;
        data["material"] = this.material ? this.material.toJSON() : <any>undefined;
        data["inventoryShelfId"] = this.inventoryShelfId;
        data["inventoryShelf"] = this.inventoryShelf ? this.inventoryShelf.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        return data;
    }

    clone(): InventoryMaterialOnShelfDto {
        const json = this.toJSON();
        let result = new InventoryMaterialOnShelfDto();
        result.init(json);
        return result;
    }
}

export interface IInventoryMaterialOnShelfDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    materialGuid: string;
    material: Material;
    inventoryShelfId: number;
    inventoryShelf: InventoryShelf;
    quantity: number;
}

export class InventoryMaterialOnShelfDtoPagedResultDto implements IInventoryMaterialOnShelfDtoPagedResultDto {
    items: InventoryMaterialOnShelfDto[] | undefined;
    totalCount: number;

    constructor(data?: IInventoryMaterialOnShelfDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(InventoryMaterialOnShelfDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InventoryMaterialOnShelfDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryMaterialOnShelfDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InventoryMaterialOnShelfDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InventoryMaterialOnShelfDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInventoryMaterialOnShelfDtoPagedResultDto {
    items: InventoryMaterialOnShelfDto[] | undefined;
    totalCount: number;
}

export class InventoryProductOnShelf implements IInventoryProductOnShelf {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    productGuid: string;
    product: Product;
    inventoryShelfId: number;
    inventoryShelf: InventoryShelf;
    quantity: number;

    constructor(data?: IInventoryProductOnShelf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.productGuid = _data["productGuid"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.inventoryShelfId = _data["inventoryShelfId"];
            this.inventoryShelf = _data["inventoryShelf"] ? InventoryShelf.fromJS(_data["inventoryShelf"]) : <any>undefined;
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): InventoryProductOnShelf {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryProductOnShelf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["productGuid"] = this.productGuid;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["inventoryShelfId"] = this.inventoryShelfId;
        data["inventoryShelf"] = this.inventoryShelf ? this.inventoryShelf.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        return data;
    }

    clone(): InventoryProductOnShelf {
        const json = this.toJSON();
        let result = new InventoryProductOnShelf();
        result.init(json);
        return result;
    }
}

export interface IInventoryProductOnShelf {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    productGuid: string;
    product: Product;
    inventoryShelfId: number;
    inventoryShelf: InventoryShelf;
    quantity: number;
}

export class InventoryProductOnShelfDto implements IInventoryProductOnShelfDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    productGuid: string;
    product: Product;
    inventoryShelfId: number;
    inventoryShelf: InventoryShelf;
    quantity: number;

    constructor(data?: IInventoryProductOnShelfDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.productGuid = _data["productGuid"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.inventoryShelfId = _data["inventoryShelfId"];
            this.inventoryShelf = _data["inventoryShelf"] ? InventoryShelf.fromJS(_data["inventoryShelf"]) : <any>undefined;
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): InventoryProductOnShelfDto {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryProductOnShelfDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["productGuid"] = this.productGuid;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["inventoryShelfId"] = this.inventoryShelfId;
        data["inventoryShelf"] = this.inventoryShelf ? this.inventoryShelf.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        return data;
    }

    clone(): InventoryProductOnShelfDto {
        const json = this.toJSON();
        let result = new InventoryProductOnShelfDto();
        result.init(json);
        return result;
    }
}

export interface IInventoryProductOnShelfDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    productGuid: string;
    product: Product;
    inventoryShelfId: number;
    inventoryShelf: InventoryShelf;
    quantity: number;
}

export class InventoryProductOnShelfDtoPagedResultDto implements IInventoryProductOnShelfDtoPagedResultDto {
    items: InventoryProductOnShelfDto[] | undefined;
    totalCount: number;

    constructor(data?: IInventoryProductOnShelfDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(InventoryProductOnShelfDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InventoryProductOnShelfDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryProductOnShelfDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InventoryProductOnShelfDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InventoryProductOnShelfDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInventoryProductOnShelfDtoPagedResultDto {
    items: InventoryProductOnShelfDto[] | undefined;
    totalCount: number;
}

export class InventoryShelf implements IInventoryShelf {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    warehouseId: number;
    inventoryWarehouse: InventoryWarehouse;

    constructor(data?: IInventoryShelf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.warehouseId = _data["warehouseId"];
            this.inventoryWarehouse = _data["inventoryWarehouse"] ? InventoryWarehouse.fromJS(_data["inventoryWarehouse"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InventoryShelf {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryShelf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["warehouseId"] = this.warehouseId;
        data["inventoryWarehouse"] = this.inventoryWarehouse ? this.inventoryWarehouse.toJSON() : <any>undefined;
        return data;
    }

    clone(): InventoryShelf {
        const json = this.toJSON();
        let result = new InventoryShelf();
        result.init(json);
        return result;
    }
}

export interface IInventoryShelf {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    warehouseId: number;
    inventoryWarehouse: InventoryWarehouse;
}

export class InventoryShelfDto implements IInventoryShelfDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    warehouseId: number;
    inventoryWarehouse: InventoryWarehouse;
    products: InventoryProductOnShelf[] | undefined;
    materials: InventoryMaterialOnShelf[] | undefined;

    constructor(data?: IInventoryShelfDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.warehouseId = _data["warehouseId"];
            this.inventoryWarehouse = _data["inventoryWarehouse"] ? InventoryWarehouse.fromJS(_data["inventoryWarehouse"]) : <any>undefined;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products.push(InventoryProductOnShelf.fromJS(item));
            }
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials.push(InventoryMaterialOnShelf.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InventoryShelfDto {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryShelfDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["warehouseId"] = this.warehouseId;
        data["inventoryWarehouse"] = this.inventoryWarehouse ? this.inventoryWarehouse.toJSON() : <any>undefined;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item.toJSON());
        }
        return data;
    }

    clone(): InventoryShelfDto {
        const json = this.toJSON();
        let result = new InventoryShelfDto();
        result.init(json);
        return result;
    }
}

export interface IInventoryShelfDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    warehouseId: number;
    inventoryWarehouse: InventoryWarehouse;
    products: InventoryProductOnShelf[] | undefined;
    materials: InventoryMaterialOnShelf[] | undefined;
}

export class InventoryShelfDtoPagedResultDto implements IInventoryShelfDtoPagedResultDto {
    items: InventoryShelfDto[] | undefined;
    totalCount: number;

    constructor(data?: IInventoryShelfDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(InventoryShelfDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InventoryShelfDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryShelfDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InventoryShelfDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InventoryShelfDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInventoryShelfDtoPagedResultDto {
    items: InventoryShelfDto[] | undefined;
    totalCount: number;
}

export class InventoryWarehouse implements IInventoryWarehouse {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    location: string | undefined;

    constructor(data?: IInventoryWarehouse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.location = _data["location"];
        }
    }

    static fromJS(data: any): InventoryWarehouse {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryWarehouse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["location"] = this.location;
        return data;
    }

    clone(): InventoryWarehouse {
        const json = this.toJSON();
        let result = new InventoryWarehouse();
        result.init(json);
        return result;
    }
}

export interface IInventoryWarehouse {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    location: string | undefined;
}

export class InventoryWarehouseDto implements IInventoryWarehouseDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    location: string | undefined;
    inventoryShelves: InventoryShelfDto[] | undefined;
    inventoryShelvesCount: number;

    constructor(data?: IInventoryWarehouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.location = _data["location"];
            if (Array.isArray(_data["inventoryShelves"])) {
                this.inventoryShelves = [] as any;
                for (let item of _data["inventoryShelves"])
                    this.inventoryShelves.push(InventoryShelfDto.fromJS(item));
            }
            this.inventoryShelvesCount = _data["inventoryShelvesCount"];
        }
    }

    static fromJS(data: any): InventoryWarehouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryWarehouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["location"] = this.location;
        if (Array.isArray(this.inventoryShelves)) {
            data["inventoryShelves"] = [];
            for (let item of this.inventoryShelves)
                data["inventoryShelves"].push(item.toJSON());
        }
        data["inventoryShelvesCount"] = this.inventoryShelvesCount;
        return data;
    }

    clone(): InventoryWarehouseDto {
        const json = this.toJSON();
        let result = new InventoryWarehouseDto();
        result.init(json);
        return result;
    }
}

export interface IInventoryWarehouseDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    location: string | undefined;
    inventoryShelves: InventoryShelfDto[] | undefined;
    inventoryShelvesCount: number;
}

export class InventoryWarehouseDtoPagedResultDto implements IInventoryWarehouseDtoPagedResultDto {
    items: InventoryWarehouseDto[] | undefined;
    totalCount: number;

    constructor(data?: IInventoryWarehouseDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(InventoryWarehouseDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InventoryWarehouseDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryWarehouseDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InventoryWarehouseDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InventoryWarehouseDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInventoryWarehouseDtoPagedResultDto {
    items: InventoryWarehouseDto[] | undefined;
    totalCount: number;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
}

export class Journals implements IJournals {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    date: moment.Moment;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    journalType: string | undefined;
    type: string | undefined;
    description: string | undefined;
    attachmentUrl: string | undefined;
    credit: number | undefined;
    debit: number | undefined;
    jvNo: string | undefined;
    status: string | undefined;
    requestedBy: string | undefined;
    approvedBy: string | undefined;
    legacyCode: string | undefined;
    approvedDate: moment.Moment;
    requestedDate: moment.Moment;
    isReversal: boolean;
    reversalDate: moment.Moment | undefined;

    constructor(data?: IJournals) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.categoryCode = _data["categoryCode"];
            this.categoryName = _data["categoryName"];
            this.journalType = _data["journalType"];
            this.type = _data["type"];
            this.description = _data["description"];
            this.attachmentUrl = _data["attachmentUrl"];
            this.credit = _data["credit"];
            this.debit = _data["debit"];
            this.jvNo = _data["jvNo"];
            this.status = _data["status"];
            this.requestedBy = _data["requestedBy"];
            this.approvedBy = _data["approvedBy"];
            this.legacyCode = _data["legacyCode"];
            this.approvedDate = _data["approvedDate"] ? moment(_data["approvedDate"].toString()) : <any>undefined;
            this.requestedDate = _data["requestedDate"] ? moment(_data["requestedDate"].toString()) : <any>undefined;
            this.isReversal = _data["isReversal"];
            this.reversalDate = _data["reversalDate"] ? moment(_data["reversalDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Journals {
        data = typeof data === 'object' ? data : {};
        let result = new Journals();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["journalType"] = this.journalType;
        data["type"] = this.type;
        data["description"] = this.description;
        data["attachmentUrl"] = this.attachmentUrl;
        data["credit"] = this.credit;
        data["debit"] = this.debit;
        data["jvNo"] = this.jvNo;
        data["status"] = this.status;
        data["requestedBy"] = this.requestedBy;
        data["approvedBy"] = this.approvedBy;
        data["legacyCode"] = this.legacyCode;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>undefined;
        data["isReversal"] = this.isReversal;
        data["reversalDate"] = this.reversalDate ? this.reversalDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): Journals {
        const json = this.toJSON();
        let result = new Journals();
        result.init(json);
        return result;
    }
}

export interface IJournals {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    date: moment.Moment;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    journalType: string | undefined;
    type: string | undefined;
    description: string | undefined;
    attachmentUrl: string | undefined;
    credit: number | undefined;
    debit: number | undefined;
    jvNo: string | undefined;
    status: string | undefined;
    requestedBy: string | undefined;
    approvedBy: string | undefined;
    legacyCode: string | undefined;
    approvedDate: moment.Moment;
    requestedDate: moment.Moment;
    isReversal: boolean;
    reversalDate: moment.Moment | undefined;
}

export class JournalsDto implements IJournalsDto {
    tenantId: number;
    date: moment.Moment;
    journalType: string | undefined;
    type: string | undefined;
    description: string | undefined;
    attachmentUrl: string | undefined;
    credit: number | undefined;
    debit: number | undefined;
    jvNo: string | undefined;
    status: string | undefined;
    requestedBy: string | undefined;
    approvedBy: string | undefined;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    creditCode: string | undefined;
    creditName: string | undefined;
    debitCode: string | undefined;
    debitName: string | undefined;
    additionalList: JournalsDto[] | undefined;
    legacyCode: string | undefined;
    journalItems: Journals[] | undefined;
    lastModificationTime: moment.Moment;
    approvedDate: moment.Moment;
    requestedDate: moment.Moment;
    journalId: number;
    isReversal: boolean;
    reversalDate: moment.Moment | undefined;

    constructor(data?: IJournalsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.journalType = _data["journalType"];
            this.type = _data["type"];
            this.description = _data["description"];
            this.attachmentUrl = _data["attachmentUrl"];
            this.credit = _data["credit"];
            this.debit = _data["debit"];
            this.jvNo = _data["jvNo"];
            this.status = _data["status"];
            this.requestedBy = _data["requestedBy"];
            this.approvedBy = _data["approvedBy"];
            this.categoryCode = _data["categoryCode"];
            this.categoryName = _data["categoryName"];
            this.creditCode = _data["creditCode"];
            this.creditName = _data["creditName"];
            this.debitCode = _data["debitCode"];
            this.debitName = _data["debitName"];
            if (Array.isArray(_data["additionalList"])) {
                this.additionalList = [] as any;
                for (let item of _data["additionalList"])
                    this.additionalList.push(JournalsDto.fromJS(item));
            }
            this.legacyCode = _data["legacyCode"];
            if (Array.isArray(_data["journalItems"])) {
                this.journalItems = [] as any;
                for (let item of _data["journalItems"])
                    this.journalItems.push(Journals.fromJS(item));
            }
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.approvedDate = _data["approvedDate"] ? moment(_data["approvedDate"].toString()) : <any>undefined;
            this.requestedDate = _data["requestedDate"] ? moment(_data["requestedDate"].toString()) : <any>undefined;
            this.journalId = _data["journalId"];
            this.isReversal = _data["isReversal"];
            this.reversalDate = _data["reversalDate"] ? moment(_data["reversalDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): JournalsDto {
        data = typeof data === 'object' ? data : {};
        let result = new JournalsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["journalType"] = this.journalType;
        data["type"] = this.type;
        data["description"] = this.description;
        data["attachmentUrl"] = this.attachmentUrl;
        data["credit"] = this.credit;
        data["debit"] = this.debit;
        data["jvNo"] = this.jvNo;
        data["status"] = this.status;
        data["requestedBy"] = this.requestedBy;
        data["approvedBy"] = this.approvedBy;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["creditCode"] = this.creditCode;
        data["creditName"] = this.creditName;
        data["debitCode"] = this.debitCode;
        data["debitName"] = this.debitName;
        if (Array.isArray(this.additionalList)) {
            data["additionalList"] = [];
            for (let item of this.additionalList)
                data["additionalList"].push(item.toJSON());
        }
        data["legacyCode"] = this.legacyCode;
        if (Array.isArray(this.journalItems)) {
            data["journalItems"] = [];
            for (let item of this.journalItems)
                data["journalItems"].push(item.toJSON());
        }
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>undefined;
        data["journalId"] = this.journalId;
        data["isReversal"] = this.isReversal;
        data["reversalDate"] = this.reversalDate ? this.reversalDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): JournalsDto {
        const json = this.toJSON();
        let result = new JournalsDto();
        result.init(json);
        return result;
    }
}

export interface IJournalsDto {
    tenantId: number;
    date: moment.Moment;
    journalType: string | undefined;
    type: string | undefined;
    description: string | undefined;
    attachmentUrl: string | undefined;
    credit: number | undefined;
    debit: number | undefined;
    jvNo: string | undefined;
    status: string | undefined;
    requestedBy: string | undefined;
    approvedBy: string | undefined;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    creditCode: string | undefined;
    creditName: string | undefined;
    debitCode: string | undefined;
    debitName: string | undefined;
    additionalList: JournalsDto[] | undefined;
    legacyCode: string | undefined;
    journalItems: Journals[] | undefined;
    lastModificationTime: moment.Moment;
    approvedDate: moment.Moment;
    requestedDate: moment.Moment;
    journalId: number;
    isReversal: boolean;
    reversalDate: moment.Moment | undefined;
}

export class JournalsPagedResultDto implements IJournalsPagedResultDto {
    items: Journals[] | undefined;
    totalCount: number;

    constructor(data?: IJournalsPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(Journals.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): JournalsPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new JournalsPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): JournalsPagedResultDto {
        const json = this.toJSON();
        let result = new JournalsPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IJournalsPagedResultDto {
    items: Journals[] | undefined;
    totalCount: number;
}

export class LeaveApplicationModel implements ILeaveApplicationModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    userId: number;
    user: User;
    startDate: moment.Moment;
    endDate: moment.Moment;
    leavePolicyId: number;
    leaveTypeId: number;
    leaveType: LeaveTypeModel;
    amount: number;
    status: string;
    reason: string | undefined;
    attachmentUrl: string | undefined;
    attachmentFileName: string | undefined;
    approvedDate: moment.Moment | undefined;
    approverUserId: number | undefined;
    approverUser: User;
    approverName: string | undefined;
    approverEmail: string | undefined;
    approverRemarks: string | undefined;
    leavePolicy: LeavePolicy;

    constructor(data?: ILeaveApplicationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.leavePolicyId = _data["leavePolicyId"];
            this.leaveTypeId = _data["leaveTypeId"];
            this.leaveType = _data["leaveType"] ? LeaveTypeModel.fromJS(_data["leaveType"]) : <any>undefined;
            this.amount = _data["amount"];
            this.status = _data["status"];
            this.reason = _data["reason"];
            this.attachmentUrl = _data["attachmentUrl"];
            this.attachmentFileName = _data["attachmentFileName"];
            this.approvedDate = _data["approvedDate"] ? moment(_data["approvedDate"].toString()) : <any>undefined;
            this.approverUserId = _data["approverUserId"];
            this.approverUser = _data["approverUser"] ? User.fromJS(_data["approverUser"]) : <any>undefined;
            this.approverName = _data["approverName"];
            this.approverEmail = _data["approverEmail"];
            this.approverRemarks = _data["approverRemarks"];
            this.leavePolicy = _data["leavePolicy"] ? LeavePolicy.fromJS(_data["leavePolicy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LeaveApplicationModel {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveApplicationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["leavePolicyId"] = this.leavePolicyId;
        data["leaveTypeId"] = this.leaveTypeId;
        data["leaveType"] = this.leaveType ? this.leaveType.toJSON() : <any>undefined;
        data["amount"] = this.amount;
        data["status"] = this.status;
        data["reason"] = this.reason;
        data["attachmentUrl"] = this.attachmentUrl;
        data["attachmentFileName"] = this.attachmentFileName;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["approverUserId"] = this.approverUserId;
        data["approverUser"] = this.approverUser ? this.approverUser.toJSON() : <any>undefined;
        data["approverName"] = this.approverName;
        data["approverEmail"] = this.approverEmail;
        data["approverRemarks"] = this.approverRemarks;
        data["leavePolicy"] = this.leavePolicy ? this.leavePolicy.toJSON() : <any>undefined;
        return data;
    }

    clone(): LeaveApplicationModel {
        const json = this.toJSON();
        let result = new LeaveApplicationModel();
        result.init(json);
        return result;
    }
}

export interface ILeaveApplicationModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    userId: number;
    user: User;
    startDate: moment.Moment;
    endDate: moment.Moment;
    leavePolicyId: number;
    leaveTypeId: number;
    leaveType: LeaveTypeModel;
    amount: number;
    status: string;
    reason: string | undefined;
    attachmentUrl: string | undefined;
    attachmentFileName: string | undefined;
    approvedDate: moment.Moment | undefined;
    approverUserId: number | undefined;
    approverUser: User;
    approverName: string | undefined;
    approverEmail: string | undefined;
    approverRemarks: string | undefined;
    leavePolicy: LeavePolicy;
}

export class LeaveApplicationModelDto implements ILeaveApplicationModelDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    userId: number;
    user: UserDto;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    leavePolicyId: number;
    leaveTypeId: number;
    leaveType: LeaveTypeModel;
    amount: number;
    status: string | undefined;
    reason: string | undefined;
    attachmentUrl: string | undefined;
    attachmentFileName: string | undefined;
    approvedDate: moment.Moment | undefined;
    approverUserId: number | undefined;
    approverUser: UserDto;
    approverName: string | undefined;
    approverEmail: string | undefined;
    approverRemarks: string | undefined;
    leavePolicy: LeavePolicy;

    constructor(data?: ILeaveApplicationModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.leavePolicyId = _data["leavePolicyId"];
            this.leaveTypeId = _data["leaveTypeId"];
            this.leaveType = _data["leaveType"] ? LeaveTypeModel.fromJS(_data["leaveType"]) : <any>undefined;
            this.amount = _data["amount"];
            this.status = _data["status"];
            this.reason = _data["reason"];
            this.attachmentUrl = _data["attachmentUrl"];
            this.attachmentFileName = _data["attachmentFileName"];
            this.approvedDate = _data["approvedDate"] ? moment(_data["approvedDate"].toString()) : <any>undefined;
            this.approverUserId = _data["approverUserId"];
            this.approverUser = _data["approverUser"] ? UserDto.fromJS(_data["approverUser"]) : <any>undefined;
            this.approverName = _data["approverName"];
            this.approverEmail = _data["approverEmail"];
            this.approverRemarks = _data["approverRemarks"];
            this.leavePolicy = _data["leavePolicy"] ? LeavePolicy.fromJS(_data["leavePolicy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LeaveApplicationModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveApplicationModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["leavePolicyId"] = this.leavePolicyId;
        data["leaveTypeId"] = this.leaveTypeId;
        data["leaveType"] = this.leaveType ? this.leaveType.toJSON() : <any>undefined;
        data["amount"] = this.amount;
        data["status"] = this.status;
        data["reason"] = this.reason;
        data["attachmentUrl"] = this.attachmentUrl;
        data["attachmentFileName"] = this.attachmentFileName;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["approverUserId"] = this.approverUserId;
        data["approverUser"] = this.approverUser ? this.approverUser.toJSON() : <any>undefined;
        data["approverName"] = this.approverName;
        data["approverEmail"] = this.approverEmail;
        data["approverRemarks"] = this.approverRemarks;
        data["leavePolicy"] = this.leavePolicy ? this.leavePolicy.toJSON() : <any>undefined;
        return data;
    }

    clone(): LeaveApplicationModelDto {
        const json = this.toJSON();
        let result = new LeaveApplicationModelDto();
        result.init(json);
        return result;
    }
}

export interface ILeaveApplicationModelDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    userId: number;
    user: UserDto;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    leavePolicyId: number;
    leaveTypeId: number;
    leaveType: LeaveTypeModel;
    amount: number;
    status: string | undefined;
    reason: string | undefined;
    attachmentUrl: string | undefined;
    attachmentFileName: string | undefined;
    approvedDate: moment.Moment | undefined;
    approverUserId: number | undefined;
    approverUser: UserDto;
    approverName: string | undefined;
    approverEmail: string | undefined;
    approverRemarks: string | undefined;
    leavePolicy: LeavePolicy;
}

export class LeaveApplicationModelDtoPagedResultDto implements ILeaveApplicationModelDtoPagedResultDto {
    items: LeaveApplicationModelDto[] | undefined;
    totalCount: number;

    constructor(data?: ILeaveApplicationModelDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LeaveApplicationModelDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): LeaveApplicationModelDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveApplicationModelDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): LeaveApplicationModelDtoPagedResultDto {
        const json = this.toJSON();
        let result = new LeaveApplicationModelDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ILeaveApplicationModelDtoPagedResultDto {
    items: LeaveApplicationModelDto[] | undefined;
    totalCount: number;
}

export class LeaveEmployeeModel implements ILeaveEmployeeModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    userId: number;
    leaveGroupId: number;
    leaveGroup: LeaveGroupModel;
    tenantId: number;

    constructor(data?: ILeaveEmployeeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.leaveGroupId = _data["leaveGroupId"];
            this.leaveGroup = _data["leaveGroup"] ? LeaveGroupModel.fromJS(_data["leaveGroup"]) : <any>undefined;
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): LeaveEmployeeModel {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveEmployeeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["leaveGroupId"] = this.leaveGroupId;
        data["leaveGroup"] = this.leaveGroup ? this.leaveGroup.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): LeaveEmployeeModel {
        const json = this.toJSON();
        let result = new LeaveEmployeeModel();
        result.init(json);
        return result;
    }
}

export interface ILeaveEmployeeModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    userId: number;
    leaveGroupId: number;
    leaveGroup: LeaveGroupModel;
    tenantId: number;
}

export class LeaveEmployeeModelDto implements ILeaveEmployeeModelDto {
    employeeId: number;
    leaveGroupId: number;
    tenantId: number;

    constructor(data?: ILeaveEmployeeModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.leaveGroupId = _data["leaveGroupId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): LeaveEmployeeModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveEmployeeModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["leaveGroupId"] = this.leaveGroupId;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): LeaveEmployeeModelDto {
        const json = this.toJSON();
        let result = new LeaveEmployeeModelDto();
        result.init(json);
        return result;
    }
}

export interface ILeaveEmployeeModelDto {
    employeeId: number;
    leaveGroupId: number;
    tenantId: number;
}

export class LeaveEmployeeModelPagedResultDto implements ILeaveEmployeeModelPagedResultDto {
    items: LeaveEmployeeModel[] | undefined;
    totalCount: number;

    constructor(data?: ILeaveEmployeeModelPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LeaveEmployeeModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): LeaveEmployeeModelPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveEmployeeModelPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): LeaveEmployeeModelPagedResultDto {
        const json = this.toJSON();
        let result = new LeaveEmployeeModelPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ILeaveEmployeeModelPagedResultDto {
    items: LeaveEmployeeModel[] | undefined;
    totalCount: number;
}

export class LeaveGroupModel implements ILeaveGroupModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    leaveGroupName: string;
    sickLeave: number;
    casualLeave: number;
    halfDay: number;
    maternity: number;
    unPaid: number;
    others: number;
    tenantId: number;

    constructor(data?: ILeaveGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.leaveGroupName = _data["leaveGroupName"];
            this.sickLeave = _data["sickLeave"];
            this.casualLeave = _data["casualLeave"];
            this.halfDay = _data["halfDay"];
            this.maternity = _data["maternity"];
            this.unPaid = _data["unPaid"];
            this.others = _data["others"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): LeaveGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["leaveGroupName"] = this.leaveGroupName;
        data["sickLeave"] = this.sickLeave;
        data["casualLeave"] = this.casualLeave;
        data["halfDay"] = this.halfDay;
        data["maternity"] = this.maternity;
        data["unPaid"] = this.unPaid;
        data["others"] = this.others;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): LeaveGroupModel {
        const json = this.toJSON();
        let result = new LeaveGroupModel();
        result.init(json);
        return result;
    }
}

export interface ILeaveGroupModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    leaveGroupName: string;
    sickLeave: number;
    casualLeave: number;
    halfDay: number;
    maternity: number;
    unPaid: number;
    others: number;
    tenantId: number;
}

export class LeaveGroupModelDto implements ILeaveGroupModelDto {
    leaveGroupName: string | undefined;
    sickLeave: number;
    casualLeave: number;
    halfDay: number;
    maternity: number;
    unPaid: number;
    others: number;
    tenantId: number;

    constructor(data?: ILeaveGroupModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leaveGroupName = _data["leaveGroupName"];
            this.sickLeave = _data["sickLeave"];
            this.casualLeave = _data["casualLeave"];
            this.halfDay = _data["halfDay"];
            this.maternity = _data["maternity"];
            this.unPaid = _data["unPaid"];
            this.others = _data["others"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): LeaveGroupModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveGroupModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leaveGroupName"] = this.leaveGroupName;
        data["sickLeave"] = this.sickLeave;
        data["casualLeave"] = this.casualLeave;
        data["halfDay"] = this.halfDay;
        data["maternity"] = this.maternity;
        data["unPaid"] = this.unPaid;
        data["others"] = this.others;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): LeaveGroupModelDto {
        const json = this.toJSON();
        let result = new LeaveGroupModelDto();
        result.init(json);
        return result;
    }
}

export interface ILeaveGroupModelDto {
    leaveGroupName: string | undefined;
    sickLeave: number;
    casualLeave: number;
    halfDay: number;
    maternity: number;
    unPaid: number;
    others: number;
    tenantId: number;
}

export class LeaveGroupModelPagedResultDto implements ILeaveGroupModelPagedResultDto {
    items: LeaveGroupModel[] | undefined;
    totalCount: number;

    constructor(data?: ILeaveGroupModelPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LeaveGroupModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): LeaveGroupModelPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveGroupModelPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): LeaveGroupModelPagedResultDto {
        const json = this.toJSON();
        let result = new LeaveGroupModelPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ILeaveGroupModelPagedResultDto {
    items: LeaveGroupModel[] | undefined;
    totalCount: number;
}

export class LeavePolicy implements ILeavePolicy {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    leaveTypeModelId: number;
    leaveTypeModel: LeaveTypeModel;
    isAccrued: boolean;
    policyName: string;
    isPerHourWorked: boolean;
    accrualAmount: number;
    accrualFrequencyType: AccrualFrequencyType;
    selectedDayOfWeek: number | undefined;
    firstSelectedDayOfMonth: number | undefined;
    secondSelectedDayOfMonth: number | undefined;
    thirdSelectedDayOfMonth: number | undefined;
    fourthSelectedDayOfMonth: number | undefined;
    firstSelectedMonth: number | undefined;
    secondSelectedMonth: number | undefined;
    thirdSelectedMonth: number | undefined;
    fourthSelectedMonth: number | undefined;
    waitingDays: number;
    maxAccrual: number;
    isCanBeCarriedOver: boolean;
    maxCarryOver: number;
    carryOverDayOfMonth: number;
    carryOverMonth: number;
    maxCarryOverExpirationDays: number;
    isResetNegativeBalance: boolean;
    isAccruedByFullAmount: boolean;
    isAccruedAtTheStartOfAccrualPeriod: boolean;
    userLeavePolicies: UserLeavePolicyRelation[] | undefined;

    constructor(data?: ILeavePolicy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.leaveTypeModelId = _data["leaveTypeModelId"];
            this.leaveTypeModel = _data["leaveTypeModel"] ? LeaveTypeModel.fromJS(_data["leaveTypeModel"]) : <any>undefined;
            this.isAccrued = _data["isAccrued"];
            this.policyName = _data["policyName"];
            this.isPerHourWorked = _data["isPerHourWorked"];
            this.accrualAmount = _data["accrualAmount"];
            this.accrualFrequencyType = _data["accrualFrequencyType"];
            this.selectedDayOfWeek = _data["selectedDayOfWeek"];
            this.firstSelectedDayOfMonth = _data["firstSelectedDayOfMonth"];
            this.secondSelectedDayOfMonth = _data["secondSelectedDayOfMonth"];
            this.thirdSelectedDayOfMonth = _data["thirdSelectedDayOfMonth"];
            this.fourthSelectedDayOfMonth = _data["fourthSelectedDayOfMonth"];
            this.firstSelectedMonth = _data["firstSelectedMonth"];
            this.secondSelectedMonth = _data["secondSelectedMonth"];
            this.thirdSelectedMonth = _data["thirdSelectedMonth"];
            this.fourthSelectedMonth = _data["fourthSelectedMonth"];
            this.waitingDays = _data["waitingDays"];
            this.maxAccrual = _data["maxAccrual"];
            this.isCanBeCarriedOver = _data["isCanBeCarriedOver"];
            this.maxCarryOver = _data["maxCarryOver"];
            this.carryOverDayOfMonth = _data["carryOverDayOfMonth"];
            this.carryOverMonth = _data["carryOverMonth"];
            this.maxCarryOverExpirationDays = _data["maxCarryOverExpirationDays"];
            this.isResetNegativeBalance = _data["isResetNegativeBalance"];
            this.isAccruedByFullAmount = _data["isAccruedByFullAmount"];
            this.isAccruedAtTheStartOfAccrualPeriod = _data["isAccruedAtTheStartOfAccrualPeriod"];
            if (Array.isArray(_data["userLeavePolicies"])) {
                this.userLeavePolicies = [] as any;
                for (let item of _data["userLeavePolicies"])
                    this.userLeavePolicies.push(UserLeavePolicyRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LeavePolicy {
        data = typeof data === 'object' ? data : {};
        let result = new LeavePolicy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["leaveTypeModelId"] = this.leaveTypeModelId;
        data["leaveTypeModel"] = this.leaveTypeModel ? this.leaveTypeModel.toJSON() : <any>undefined;
        data["isAccrued"] = this.isAccrued;
        data["policyName"] = this.policyName;
        data["isPerHourWorked"] = this.isPerHourWorked;
        data["accrualAmount"] = this.accrualAmount;
        data["accrualFrequencyType"] = this.accrualFrequencyType;
        data["selectedDayOfWeek"] = this.selectedDayOfWeek;
        data["firstSelectedDayOfMonth"] = this.firstSelectedDayOfMonth;
        data["secondSelectedDayOfMonth"] = this.secondSelectedDayOfMonth;
        data["thirdSelectedDayOfMonth"] = this.thirdSelectedDayOfMonth;
        data["fourthSelectedDayOfMonth"] = this.fourthSelectedDayOfMonth;
        data["firstSelectedMonth"] = this.firstSelectedMonth;
        data["secondSelectedMonth"] = this.secondSelectedMonth;
        data["thirdSelectedMonth"] = this.thirdSelectedMonth;
        data["fourthSelectedMonth"] = this.fourthSelectedMonth;
        data["waitingDays"] = this.waitingDays;
        data["maxAccrual"] = this.maxAccrual;
        data["isCanBeCarriedOver"] = this.isCanBeCarriedOver;
        data["maxCarryOver"] = this.maxCarryOver;
        data["carryOverDayOfMonth"] = this.carryOverDayOfMonth;
        data["carryOverMonth"] = this.carryOverMonth;
        data["maxCarryOverExpirationDays"] = this.maxCarryOverExpirationDays;
        data["isResetNegativeBalance"] = this.isResetNegativeBalance;
        data["isAccruedByFullAmount"] = this.isAccruedByFullAmount;
        data["isAccruedAtTheStartOfAccrualPeriod"] = this.isAccruedAtTheStartOfAccrualPeriod;
        if (Array.isArray(this.userLeavePolicies)) {
            data["userLeavePolicies"] = [];
            for (let item of this.userLeavePolicies)
                data["userLeavePolicies"].push(item.toJSON());
        }
        return data;
    }

    clone(): LeavePolicy {
        const json = this.toJSON();
        let result = new LeavePolicy();
        result.init(json);
        return result;
    }
}

export interface ILeavePolicy {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    leaveTypeModelId: number;
    leaveTypeModel: LeaveTypeModel;
    isAccrued: boolean;
    policyName: string;
    isPerHourWorked: boolean;
    accrualAmount: number;
    accrualFrequencyType: AccrualFrequencyType;
    selectedDayOfWeek: number | undefined;
    firstSelectedDayOfMonth: number | undefined;
    secondSelectedDayOfMonth: number | undefined;
    thirdSelectedDayOfMonth: number | undefined;
    fourthSelectedDayOfMonth: number | undefined;
    firstSelectedMonth: number | undefined;
    secondSelectedMonth: number | undefined;
    thirdSelectedMonth: number | undefined;
    fourthSelectedMonth: number | undefined;
    waitingDays: number;
    maxAccrual: number;
    isCanBeCarriedOver: boolean;
    maxCarryOver: number;
    carryOverDayOfMonth: number;
    carryOverMonth: number;
    maxCarryOverExpirationDays: number;
    isResetNegativeBalance: boolean;
    isAccruedByFullAmount: boolean;
    isAccruedAtTheStartOfAccrualPeriod: boolean;
    userLeavePolicies: UserLeavePolicyRelation[] | undefined;
}

export class LeavePolicyDto implements ILeavePolicyDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    leaveTypeModelId: number;
    leaveTypeModel: LeaveTypeModel;
    isAccrued: boolean;
    policyName: string | undefined;
    isPerHourWorked: boolean;
    accrualAmount: number;
    accrualFrequencyType: AccrualFrequencyType;
    selectedDayOfWeek: number | undefined;
    firstSelectedDayOfMonth: number | undefined;
    secondSelectedDayOfMonth: number | undefined;
    thirdSelectedDayOfMonth: number | undefined;
    fourthSelectedDayOfMonth: number | undefined;
    firstSelectedMonth: number | undefined;
    secondSelectedMonth: number | undefined;
    thirdSelectedMonth: number | undefined;
    fourthSelectedMonth: number | undefined;
    waitingDays: number;
    maxAccrual: number;
    isCanBeCarriedOver: boolean;
    maxCarryOver: number;
    carryOverDayOfMonth: number;
    carryOverMonth: number;
    maxCarryOverExpirationDays: number;
    isResetNegativeBalance: boolean;
    isAccruedByFullAmount: boolean;
    isAccruedAtTheStartOfAccrualPeriod: boolean;
    userLeavePolicies: UserLeavePolicyRelationDto[] | undefined;

    constructor(data?: ILeavePolicyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.leaveTypeModelId = _data["leaveTypeModelId"];
            this.leaveTypeModel = _data["leaveTypeModel"] ? LeaveTypeModel.fromJS(_data["leaveTypeModel"]) : <any>undefined;
            this.isAccrued = _data["isAccrued"];
            this.policyName = _data["policyName"];
            this.isPerHourWorked = _data["isPerHourWorked"];
            this.accrualAmount = _data["accrualAmount"];
            this.accrualFrequencyType = _data["accrualFrequencyType"];
            this.selectedDayOfWeek = _data["selectedDayOfWeek"];
            this.firstSelectedDayOfMonth = _data["firstSelectedDayOfMonth"];
            this.secondSelectedDayOfMonth = _data["secondSelectedDayOfMonth"];
            this.thirdSelectedDayOfMonth = _data["thirdSelectedDayOfMonth"];
            this.fourthSelectedDayOfMonth = _data["fourthSelectedDayOfMonth"];
            this.firstSelectedMonth = _data["firstSelectedMonth"];
            this.secondSelectedMonth = _data["secondSelectedMonth"];
            this.thirdSelectedMonth = _data["thirdSelectedMonth"];
            this.fourthSelectedMonth = _data["fourthSelectedMonth"];
            this.waitingDays = _data["waitingDays"];
            this.maxAccrual = _data["maxAccrual"];
            this.isCanBeCarriedOver = _data["isCanBeCarriedOver"];
            this.maxCarryOver = _data["maxCarryOver"];
            this.carryOverDayOfMonth = _data["carryOverDayOfMonth"];
            this.carryOverMonth = _data["carryOverMonth"];
            this.maxCarryOverExpirationDays = _data["maxCarryOverExpirationDays"];
            this.isResetNegativeBalance = _data["isResetNegativeBalance"];
            this.isAccruedByFullAmount = _data["isAccruedByFullAmount"];
            this.isAccruedAtTheStartOfAccrualPeriod = _data["isAccruedAtTheStartOfAccrualPeriod"];
            if (Array.isArray(_data["userLeavePolicies"])) {
                this.userLeavePolicies = [] as any;
                for (let item of _data["userLeavePolicies"])
                    this.userLeavePolicies.push(UserLeavePolicyRelationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LeavePolicyDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeavePolicyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["leaveTypeModelId"] = this.leaveTypeModelId;
        data["leaveTypeModel"] = this.leaveTypeModel ? this.leaveTypeModel.toJSON() : <any>undefined;
        data["isAccrued"] = this.isAccrued;
        data["policyName"] = this.policyName;
        data["isPerHourWorked"] = this.isPerHourWorked;
        data["accrualAmount"] = this.accrualAmount;
        data["accrualFrequencyType"] = this.accrualFrequencyType;
        data["selectedDayOfWeek"] = this.selectedDayOfWeek;
        data["firstSelectedDayOfMonth"] = this.firstSelectedDayOfMonth;
        data["secondSelectedDayOfMonth"] = this.secondSelectedDayOfMonth;
        data["thirdSelectedDayOfMonth"] = this.thirdSelectedDayOfMonth;
        data["fourthSelectedDayOfMonth"] = this.fourthSelectedDayOfMonth;
        data["firstSelectedMonth"] = this.firstSelectedMonth;
        data["secondSelectedMonth"] = this.secondSelectedMonth;
        data["thirdSelectedMonth"] = this.thirdSelectedMonth;
        data["fourthSelectedMonth"] = this.fourthSelectedMonth;
        data["waitingDays"] = this.waitingDays;
        data["maxAccrual"] = this.maxAccrual;
        data["isCanBeCarriedOver"] = this.isCanBeCarriedOver;
        data["maxCarryOver"] = this.maxCarryOver;
        data["carryOverDayOfMonth"] = this.carryOverDayOfMonth;
        data["carryOverMonth"] = this.carryOverMonth;
        data["maxCarryOverExpirationDays"] = this.maxCarryOverExpirationDays;
        data["isResetNegativeBalance"] = this.isResetNegativeBalance;
        data["isAccruedByFullAmount"] = this.isAccruedByFullAmount;
        data["isAccruedAtTheStartOfAccrualPeriod"] = this.isAccruedAtTheStartOfAccrualPeriod;
        if (Array.isArray(this.userLeavePolicies)) {
            data["userLeavePolicies"] = [];
            for (let item of this.userLeavePolicies)
                data["userLeavePolicies"].push(item.toJSON());
        }
        return data;
    }

    clone(): LeavePolicyDto {
        const json = this.toJSON();
        let result = new LeavePolicyDto();
        result.init(json);
        return result;
    }
}

export interface ILeavePolicyDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    leaveTypeModelId: number;
    leaveTypeModel: LeaveTypeModel;
    isAccrued: boolean;
    policyName: string | undefined;
    isPerHourWorked: boolean;
    accrualAmount: number;
    accrualFrequencyType: AccrualFrequencyType;
    selectedDayOfWeek: number | undefined;
    firstSelectedDayOfMonth: number | undefined;
    secondSelectedDayOfMonth: number | undefined;
    thirdSelectedDayOfMonth: number | undefined;
    fourthSelectedDayOfMonth: number | undefined;
    firstSelectedMonth: number | undefined;
    secondSelectedMonth: number | undefined;
    thirdSelectedMonth: number | undefined;
    fourthSelectedMonth: number | undefined;
    waitingDays: number;
    maxAccrual: number;
    isCanBeCarriedOver: boolean;
    maxCarryOver: number;
    carryOverDayOfMonth: number;
    carryOverMonth: number;
    maxCarryOverExpirationDays: number;
    isResetNegativeBalance: boolean;
    isAccruedByFullAmount: boolean;
    isAccruedAtTheStartOfAccrualPeriod: boolean;
    userLeavePolicies: UserLeavePolicyRelationDto[] | undefined;
}

export class LeavePolicyDtoPagedResultDto implements ILeavePolicyDtoPagedResultDto {
    items: LeavePolicyDto[] | undefined;
    totalCount: number;

    constructor(data?: ILeavePolicyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LeavePolicyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): LeavePolicyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeavePolicyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): LeavePolicyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new LeavePolicyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ILeavePolicyDtoPagedResultDto {
    items: LeavePolicyDto[] | undefined;
    totalCount: number;
}

export class LeaveTypeModel implements ILeaveTypeModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    leaveTypeName: string;
    tenantId: number;
    isUnpaidPolicy: boolean;
    isPubliclyVisibleOnCalendar: boolean;
    isSeenByEveryOne: boolean;
    isTrackedByDays: boolean;
    isDisabled: boolean;
    icon: string | undefined;
    calendarColor: string | undefined;
    userLeavePolicies: UserLeavePolicyRelation[] | undefined;

    constructor(data?: ILeaveTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.leaveTypeName = _data["leaveTypeName"];
            this.tenantId = _data["tenantId"];
            this.isUnpaidPolicy = _data["isUnpaidPolicy"];
            this.isPubliclyVisibleOnCalendar = _data["isPubliclyVisibleOnCalendar"];
            this.isSeenByEveryOne = _data["isSeenByEveryOne"];
            this.isTrackedByDays = _data["isTrackedByDays"];
            this.isDisabled = _data["isDisabled"];
            this.icon = _data["icon"];
            this.calendarColor = _data["calendarColor"];
            if (Array.isArray(_data["userLeavePolicies"])) {
                this.userLeavePolicies = [] as any;
                for (let item of _data["userLeavePolicies"])
                    this.userLeavePolicies.push(UserLeavePolicyRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LeaveTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["leaveTypeName"] = this.leaveTypeName;
        data["tenantId"] = this.tenantId;
        data["isUnpaidPolicy"] = this.isUnpaidPolicy;
        data["isPubliclyVisibleOnCalendar"] = this.isPubliclyVisibleOnCalendar;
        data["isSeenByEveryOne"] = this.isSeenByEveryOne;
        data["isTrackedByDays"] = this.isTrackedByDays;
        data["isDisabled"] = this.isDisabled;
        data["icon"] = this.icon;
        data["calendarColor"] = this.calendarColor;
        if (Array.isArray(this.userLeavePolicies)) {
            data["userLeavePolicies"] = [];
            for (let item of this.userLeavePolicies)
                data["userLeavePolicies"].push(item.toJSON());
        }
        return data;
    }

    clone(): LeaveTypeModel {
        const json = this.toJSON();
        let result = new LeaveTypeModel();
        result.init(json);
        return result;
    }
}

export interface ILeaveTypeModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    leaveTypeName: string;
    tenantId: number;
    isUnpaidPolicy: boolean;
    isPubliclyVisibleOnCalendar: boolean;
    isSeenByEveryOne: boolean;
    isTrackedByDays: boolean;
    isDisabled: boolean;
    icon: string | undefined;
    calendarColor: string | undefined;
    userLeavePolicies: UserLeavePolicyRelation[] | undefined;
}

export class LeaveTypeModelDto implements ILeaveTypeModelDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    leaveTypeName: string | undefined;
    tenantId: number;
    isUnpaidPolicy: boolean;
    isPubliclyVisibleOnCalendar: boolean;
    isSeenByEveryOne: boolean;
    isTrackedByDays: boolean;
    isDisabled: boolean;
    icon: string | undefined;
    calendarColor: string | undefined;
    userLeavePolicies: UserLeavePolicyRelationDto[] | undefined;
    leavePolicies: LeavePolicy[] | undefined;

    constructor(data?: ILeaveTypeModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.leaveTypeName = _data["leaveTypeName"];
            this.tenantId = _data["tenantId"];
            this.isUnpaidPolicy = _data["isUnpaidPolicy"];
            this.isPubliclyVisibleOnCalendar = _data["isPubliclyVisibleOnCalendar"];
            this.isSeenByEveryOne = _data["isSeenByEveryOne"];
            this.isTrackedByDays = _data["isTrackedByDays"];
            this.isDisabled = _data["isDisabled"];
            this.icon = _data["icon"];
            this.calendarColor = _data["calendarColor"];
            if (Array.isArray(_data["userLeavePolicies"])) {
                this.userLeavePolicies = [] as any;
                for (let item of _data["userLeavePolicies"])
                    this.userLeavePolicies.push(UserLeavePolicyRelationDto.fromJS(item));
            }
            if (Array.isArray(_data["leavePolicies"])) {
                this.leavePolicies = [] as any;
                for (let item of _data["leavePolicies"])
                    this.leavePolicies.push(LeavePolicy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LeaveTypeModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveTypeModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["leaveTypeName"] = this.leaveTypeName;
        data["tenantId"] = this.tenantId;
        data["isUnpaidPolicy"] = this.isUnpaidPolicy;
        data["isPubliclyVisibleOnCalendar"] = this.isPubliclyVisibleOnCalendar;
        data["isSeenByEveryOne"] = this.isSeenByEveryOne;
        data["isTrackedByDays"] = this.isTrackedByDays;
        data["isDisabled"] = this.isDisabled;
        data["icon"] = this.icon;
        data["calendarColor"] = this.calendarColor;
        if (Array.isArray(this.userLeavePolicies)) {
            data["userLeavePolicies"] = [];
            for (let item of this.userLeavePolicies)
                data["userLeavePolicies"].push(item.toJSON());
        }
        if (Array.isArray(this.leavePolicies)) {
            data["leavePolicies"] = [];
            for (let item of this.leavePolicies)
                data["leavePolicies"].push(item.toJSON());
        }
        return data;
    }

    clone(): LeaveTypeModelDto {
        const json = this.toJSON();
        let result = new LeaveTypeModelDto();
        result.init(json);
        return result;
    }
}

export interface ILeaveTypeModelDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    leaveTypeName: string | undefined;
    tenantId: number;
    isUnpaidPolicy: boolean;
    isPubliclyVisibleOnCalendar: boolean;
    isSeenByEveryOne: boolean;
    isTrackedByDays: boolean;
    isDisabled: boolean;
    icon: string | undefined;
    calendarColor: string | undefined;
    userLeavePolicies: UserLeavePolicyRelationDto[] | undefined;
    leavePolicies: LeavePolicy[] | undefined;
}

export class LeaveTypeModelPagedResultDto implements ILeaveTypeModelPagedResultDto {
    items: LeaveTypeModel[] | undefined;
    totalCount: number;

    constructor(data?: ILeaveTypeModelPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(LeaveTypeModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): LeaveTypeModelPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LeaveTypeModelPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): LeaveTypeModelPagedResultDto {
        const json = this.toJSON();
        let result = new LeaveTypeModelPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ILeaveTypeModelPagedResultDto {
    items: LeaveTypeModel[] | undefined;
    totalCount: number;
}

export class LedgerDto implements ILedgerDto {
    date: moment.Moment | undefined;
    name: string | undefined;
    amount: number;
    debitAmount: number;
    creditAmount: number;
    type: string | undefined;
    cashbookId: number;
    cashbook: CashbooksDto;
    cashbookList: CashbooksDto[] | undefined;
    vendorInvoiceItemId: number | undefined;
    vendorInvoiceItem: VendorInvoiceItem;
    billItemId: string | undefined;
    billItem: BillItem;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    creditNoteId: number | undefined;
    creditNote: CreditNote;
    billServiceId: number | undefined;
    billService: BillService;
    billId: string | undefined;
    bill: BillDto;
    billList: BillDto[] | undefined;
    purchaseRequisitionId: number | undefined;
    purchaseRequisitionDto: PurchaseRequisitionDto;
    purchaseRequisitionDtoList: PurchaseRequisitionDto[] | undefined;
    documentNo: string | undefined;
    journalId: number | undefined;
    journals: Journals;
    journalsList: Journals[] | undefined;
    ncaiId: string;
    ncaiDto: NonCurrentAssetItemDto;
    ncaiDtoList: NonCurrentAssetItemDto[] | undefined;
    isDepreciation: boolean;
    isDisposal: boolean;
    debitNoteId: number | undefined;
    debitNoteDto: DebitNoteDto;
    debitNoteDtoList: DebitNoteDto[] | undefined;
    writeOffNoteId: number | undefined;
    writeOffNoteDto: WriteOffNoteDto;
    writeOffNoteDtoList: WriteOffNoteDto[] | undefined;
    projectItemId: number | undefined;
    projectItem: ProjectItemDto;
    projectItemList: ProjectItemDto[] | undefined;
    pettyCashId: number | undefined;
    pettyCashDto: PettyCashsDto;
    pettyCashDtoList: PettyCashsDto[] | undefined;
    materialId: string | undefined;
    materialDto: MaterialDto;
    materialDtoList: MaterialDto[] | undefined;
    productId: string | undefined;
    productDto: ProductDto;
    productDtoList: ProductDto[] | undefined;
    employeePayslipModelId: number | undefined;
    employeePayslipModel: EmployeePaySlipModelDto;
    employeePayslipModelList: EmployeePaySlipModelDto[] | undefined;

    constructor(data?: ILedgerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.amount = _data["amount"];
            this.debitAmount = _data["debitAmount"];
            this.creditAmount = _data["creditAmount"];
            this.type = _data["type"];
            this.cashbookId = _data["cashbookId"];
            this.cashbook = _data["cashbook"] ? CashbooksDto.fromJS(_data["cashbook"]) : <any>undefined;
            if (Array.isArray(_data["cashbookList"])) {
                this.cashbookList = [] as any;
                for (let item of _data["cashbookList"])
                    this.cashbookList.push(CashbooksDto.fromJS(item));
            }
            this.vendorInvoiceItemId = _data["vendorInvoiceItemId"];
            this.vendorInvoiceItem = _data["vendorInvoiceItem"] ? VendorInvoiceItem.fromJS(_data["vendorInvoiceItem"]) : <any>undefined;
            this.billItemId = _data["billItemId"];
            this.billItem = _data["billItem"] ? BillItem.fromJS(_data["billItem"]) : <any>undefined;
            this.categoryCode = _data["categoryCode"];
            this.categoryName = _data["categoryName"];
            this.creditNoteId = _data["creditNoteId"];
            this.creditNote = _data["creditNote"] ? CreditNote.fromJS(_data["creditNote"]) : <any>undefined;
            this.billServiceId = _data["billServiceId"];
            this.billService = _data["billService"] ? BillService.fromJS(_data["billService"]) : <any>undefined;
            this.billId = _data["billId"];
            this.bill = _data["bill"] ? BillDto.fromJS(_data["bill"]) : <any>undefined;
            if (Array.isArray(_data["billList"])) {
                this.billList = [] as any;
                for (let item of _data["billList"])
                    this.billList.push(BillDto.fromJS(item));
            }
            this.purchaseRequisitionId = _data["purchaseRequisitionId"];
            this.purchaseRequisitionDto = _data["purchaseRequisitionDto"] ? PurchaseRequisitionDto.fromJS(_data["purchaseRequisitionDto"]) : <any>undefined;
            if (Array.isArray(_data["purchaseRequisitionDtoList"])) {
                this.purchaseRequisitionDtoList = [] as any;
                for (let item of _data["purchaseRequisitionDtoList"])
                    this.purchaseRequisitionDtoList.push(PurchaseRequisitionDto.fromJS(item));
            }
            this.documentNo = _data["documentNo"];
            this.journalId = _data["journalId"];
            this.journals = _data["journals"] ? Journals.fromJS(_data["journals"]) : <any>undefined;
            if (Array.isArray(_data["journalsList"])) {
                this.journalsList = [] as any;
                for (let item of _data["journalsList"])
                    this.journalsList.push(Journals.fromJS(item));
            }
            this.ncaiId = _data["ncaiId"];
            this.ncaiDto = _data["ncaiDto"] ? NonCurrentAssetItemDto.fromJS(_data["ncaiDto"]) : <any>undefined;
            if (Array.isArray(_data["ncaiDtoList"])) {
                this.ncaiDtoList = [] as any;
                for (let item of _data["ncaiDtoList"])
                    this.ncaiDtoList.push(NonCurrentAssetItemDto.fromJS(item));
            }
            this.isDepreciation = _data["isDepreciation"];
            this.isDisposal = _data["isDisposal"];
            this.debitNoteId = _data["debitNoteId"];
            this.debitNoteDto = _data["debitNoteDto"] ? DebitNoteDto.fromJS(_data["debitNoteDto"]) : <any>undefined;
            if (Array.isArray(_data["debitNoteDtoList"])) {
                this.debitNoteDtoList = [] as any;
                for (let item of _data["debitNoteDtoList"])
                    this.debitNoteDtoList.push(DebitNoteDto.fromJS(item));
            }
            this.writeOffNoteId = _data["writeOffNoteId"];
            this.writeOffNoteDto = _data["writeOffNoteDto"] ? WriteOffNoteDto.fromJS(_data["writeOffNoteDto"]) : <any>undefined;
            if (Array.isArray(_data["writeOffNoteDtoList"])) {
                this.writeOffNoteDtoList = [] as any;
                for (let item of _data["writeOffNoteDtoList"])
                    this.writeOffNoteDtoList.push(WriteOffNoteDto.fromJS(item));
            }
            this.projectItemId = _data["projectItemId"];
            this.projectItem = _data["projectItem"] ? ProjectItemDto.fromJS(_data["projectItem"]) : <any>undefined;
            if (Array.isArray(_data["projectItemList"])) {
                this.projectItemList = [] as any;
                for (let item of _data["projectItemList"])
                    this.projectItemList.push(ProjectItemDto.fromJS(item));
            }
            this.pettyCashId = _data["pettyCashId"];
            this.pettyCashDto = _data["pettyCashDto"] ? PettyCashsDto.fromJS(_data["pettyCashDto"]) : <any>undefined;
            if (Array.isArray(_data["pettyCashDtoList"])) {
                this.pettyCashDtoList = [] as any;
                for (let item of _data["pettyCashDtoList"])
                    this.pettyCashDtoList.push(PettyCashsDto.fromJS(item));
            }
            this.materialId = _data["materialId"];
            this.materialDto = _data["materialDto"] ? MaterialDto.fromJS(_data["materialDto"]) : <any>undefined;
            if (Array.isArray(_data["materialDtoList"])) {
                this.materialDtoList = [] as any;
                for (let item of _data["materialDtoList"])
                    this.materialDtoList.push(MaterialDto.fromJS(item));
            }
            this.productId = _data["productId"];
            this.productDto = _data["productDto"] ? ProductDto.fromJS(_data["productDto"]) : <any>undefined;
            if (Array.isArray(_data["productDtoList"])) {
                this.productDtoList = [] as any;
                for (let item of _data["productDtoList"])
                    this.productDtoList.push(ProductDto.fromJS(item));
            }
            this.employeePayslipModelId = _data["employeePayslipModelId"];
            this.employeePayslipModel = _data["employeePayslipModel"] ? EmployeePaySlipModelDto.fromJS(_data["employeePayslipModel"]) : <any>undefined;
            if (Array.isArray(_data["employeePayslipModelList"])) {
                this.employeePayslipModelList = [] as any;
                for (let item of _data["employeePayslipModelList"])
                    this.employeePayslipModelList.push(EmployeePaySlipModelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LedgerDto {
        data = typeof data === 'object' ? data : {};
        let result = new LedgerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["amount"] = this.amount;
        data["debitAmount"] = this.debitAmount;
        data["creditAmount"] = this.creditAmount;
        data["type"] = this.type;
        data["cashbookId"] = this.cashbookId;
        data["cashbook"] = this.cashbook ? this.cashbook.toJSON() : <any>undefined;
        if (Array.isArray(this.cashbookList)) {
            data["cashbookList"] = [];
            for (let item of this.cashbookList)
                data["cashbookList"].push(item.toJSON());
        }
        data["vendorInvoiceItemId"] = this.vendorInvoiceItemId;
        data["vendorInvoiceItem"] = this.vendorInvoiceItem ? this.vendorInvoiceItem.toJSON() : <any>undefined;
        data["billItemId"] = this.billItemId;
        data["billItem"] = this.billItem ? this.billItem.toJSON() : <any>undefined;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["creditNoteId"] = this.creditNoteId;
        data["creditNote"] = this.creditNote ? this.creditNote.toJSON() : <any>undefined;
        data["billServiceId"] = this.billServiceId;
        data["billService"] = this.billService ? this.billService.toJSON() : <any>undefined;
        data["billId"] = this.billId;
        data["bill"] = this.bill ? this.bill.toJSON() : <any>undefined;
        if (Array.isArray(this.billList)) {
            data["billList"] = [];
            for (let item of this.billList)
                data["billList"].push(item.toJSON());
        }
        data["purchaseRequisitionId"] = this.purchaseRequisitionId;
        data["purchaseRequisitionDto"] = this.purchaseRequisitionDto ? this.purchaseRequisitionDto.toJSON() : <any>undefined;
        if (Array.isArray(this.purchaseRequisitionDtoList)) {
            data["purchaseRequisitionDtoList"] = [];
            for (let item of this.purchaseRequisitionDtoList)
                data["purchaseRequisitionDtoList"].push(item.toJSON());
        }
        data["documentNo"] = this.documentNo;
        data["journalId"] = this.journalId;
        data["journals"] = this.journals ? this.journals.toJSON() : <any>undefined;
        if (Array.isArray(this.journalsList)) {
            data["journalsList"] = [];
            for (let item of this.journalsList)
                data["journalsList"].push(item.toJSON());
        }
        data["ncaiId"] = this.ncaiId;
        data["ncaiDto"] = this.ncaiDto ? this.ncaiDto.toJSON() : <any>undefined;
        if (Array.isArray(this.ncaiDtoList)) {
            data["ncaiDtoList"] = [];
            for (let item of this.ncaiDtoList)
                data["ncaiDtoList"].push(item.toJSON());
        }
        data["isDepreciation"] = this.isDepreciation;
        data["isDisposal"] = this.isDisposal;
        data["debitNoteId"] = this.debitNoteId;
        data["debitNoteDto"] = this.debitNoteDto ? this.debitNoteDto.toJSON() : <any>undefined;
        if (Array.isArray(this.debitNoteDtoList)) {
            data["debitNoteDtoList"] = [];
            for (let item of this.debitNoteDtoList)
                data["debitNoteDtoList"].push(item.toJSON());
        }
        data["writeOffNoteId"] = this.writeOffNoteId;
        data["writeOffNoteDto"] = this.writeOffNoteDto ? this.writeOffNoteDto.toJSON() : <any>undefined;
        if (Array.isArray(this.writeOffNoteDtoList)) {
            data["writeOffNoteDtoList"] = [];
            for (let item of this.writeOffNoteDtoList)
                data["writeOffNoteDtoList"].push(item.toJSON());
        }
        data["projectItemId"] = this.projectItemId;
        data["projectItem"] = this.projectItem ? this.projectItem.toJSON() : <any>undefined;
        if (Array.isArray(this.projectItemList)) {
            data["projectItemList"] = [];
            for (let item of this.projectItemList)
                data["projectItemList"].push(item.toJSON());
        }
        data["pettyCashId"] = this.pettyCashId;
        data["pettyCashDto"] = this.pettyCashDto ? this.pettyCashDto.toJSON() : <any>undefined;
        if (Array.isArray(this.pettyCashDtoList)) {
            data["pettyCashDtoList"] = [];
            for (let item of this.pettyCashDtoList)
                data["pettyCashDtoList"].push(item.toJSON());
        }
        data["materialId"] = this.materialId;
        data["materialDto"] = this.materialDto ? this.materialDto.toJSON() : <any>undefined;
        if (Array.isArray(this.materialDtoList)) {
            data["materialDtoList"] = [];
            for (let item of this.materialDtoList)
                data["materialDtoList"].push(item.toJSON());
        }
        data["productId"] = this.productId;
        data["productDto"] = this.productDto ? this.productDto.toJSON() : <any>undefined;
        if (Array.isArray(this.productDtoList)) {
            data["productDtoList"] = [];
            for (let item of this.productDtoList)
                data["productDtoList"].push(item.toJSON());
        }
        data["employeePayslipModelId"] = this.employeePayslipModelId;
        data["employeePayslipModel"] = this.employeePayslipModel ? this.employeePayslipModel.toJSON() : <any>undefined;
        if (Array.isArray(this.employeePayslipModelList)) {
            data["employeePayslipModelList"] = [];
            for (let item of this.employeePayslipModelList)
                data["employeePayslipModelList"].push(item.toJSON());
        }
        return data;
    }

    clone(): LedgerDto {
        const json = this.toJSON();
        let result = new LedgerDto();
        result.init(json);
        return result;
    }
}

export interface ILedgerDto {
    date: moment.Moment | undefined;
    name: string | undefined;
    amount: number;
    debitAmount: number;
    creditAmount: number;
    type: string | undefined;
    cashbookId: number;
    cashbook: CashbooksDto;
    cashbookList: CashbooksDto[] | undefined;
    vendorInvoiceItemId: number | undefined;
    vendorInvoiceItem: VendorInvoiceItem;
    billItemId: string | undefined;
    billItem: BillItem;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    creditNoteId: number | undefined;
    creditNote: CreditNote;
    billServiceId: number | undefined;
    billService: BillService;
    billId: string | undefined;
    bill: BillDto;
    billList: BillDto[] | undefined;
    purchaseRequisitionId: number | undefined;
    purchaseRequisitionDto: PurchaseRequisitionDto;
    purchaseRequisitionDtoList: PurchaseRequisitionDto[] | undefined;
    documentNo: string | undefined;
    journalId: number | undefined;
    journals: Journals;
    journalsList: Journals[] | undefined;
    ncaiId: string;
    ncaiDto: NonCurrentAssetItemDto;
    ncaiDtoList: NonCurrentAssetItemDto[] | undefined;
    isDepreciation: boolean;
    isDisposal: boolean;
    debitNoteId: number | undefined;
    debitNoteDto: DebitNoteDto;
    debitNoteDtoList: DebitNoteDto[] | undefined;
    writeOffNoteId: number | undefined;
    writeOffNoteDto: WriteOffNoteDto;
    writeOffNoteDtoList: WriteOffNoteDto[] | undefined;
    projectItemId: number | undefined;
    projectItem: ProjectItemDto;
    projectItemList: ProjectItemDto[] | undefined;
    pettyCashId: number | undefined;
    pettyCashDto: PettyCashsDto;
    pettyCashDtoList: PettyCashsDto[] | undefined;
    materialId: string | undefined;
    materialDto: MaterialDto;
    materialDtoList: MaterialDto[] | undefined;
    productId: string | undefined;
    productDto: ProductDto;
    productDtoList: ProductDto[] | undefined;
    employeePayslipModelId: number | undefined;
    employeePayslipModel: EmployeePaySlipModelDto;
    employeePayslipModelList: EmployeePaySlipModelDto[] | undefined;
}

export class Material implements IMaterial {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: string;
    name: string;
    description: string | undefined;
    price: number;
    tenantId: number | undefined;
    tenant: Tenant;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    hideFromMarketplace: boolean;
    companyProfileId: string | undefined;
    companyProfile: CompanyProfile;
    isUserFeatured: boolean;
    showQuantity: boolean;
    minLevel: number;
    isNotifiedMinLevel: boolean;
    tagNumber: string | undefined;
    barCode: string | undefined;
    productMaterialRelations: ProductMaterialRelation[] | undefined;
    averagePriceFromPo: number;
    lastPriceFromPo: number;
    movingAverageValue: number;
    readonly unitValue: number;
    inventoryCategoryId: number | undefined;
    dateOfMigration: moment.Moment | undefined;

    constructor(data?: IMaterial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.oldPrice = _data["oldPrice"];
            this.discount = _data["discount"];
            this.ratingsCount = _data["ratingsCount"];
            this.ratingsValue = _data["ratingsValue"];
            this.availibilityCount = _data["availibilityCount"];
            this.cartCount = _data["cartCount"];
            this.weight = _data["weight"];
            this.categoryId = _data["categoryId"];
            this.fullDescription = _data["fullDescription"];
            this.serviceTax = _data["serviceTax"];
            this.taxCode = _data["taxCode"];
            this.isSubsidized = _data["isSubsidized"];
            this.isCertified = _data["isCertified"];
            this.isIslamic = _data["isIslamic"];
            this.isLoanAvailable = _data["isLoanAvailable"];
            this.isFeatured = _data["isFeatured"];
            this.isTypeSerice = _data["isTypeSerice"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.hideFromMarketplace = _data["hideFromMarketplace"];
            this.companyProfileId = _data["companyProfileId"];
            this.companyProfile = _data["companyProfile"] ? CompanyProfile.fromJS(_data["companyProfile"]) : <any>undefined;
            this.isUserFeatured = _data["isUserFeatured"];
            this.showQuantity = _data["showQuantity"];
            this.minLevel = _data["minLevel"];
            this.isNotifiedMinLevel = _data["isNotifiedMinLevel"];
            this.tagNumber = _data["tagNumber"];
            this.barCode = _data["barCode"];
            if (Array.isArray(_data["productMaterialRelations"])) {
                this.productMaterialRelations = [] as any;
                for (let item of _data["productMaterialRelations"])
                    this.productMaterialRelations.push(ProductMaterialRelation.fromJS(item));
            }
            this.averagePriceFromPo = _data["averagePriceFromPo"];
            this.lastPriceFromPo = _data["lastPriceFromPo"];
            this.movingAverageValue = _data["movingAverageValue"];
            (<any>this).unitValue = _data["unitValue"];
            this.inventoryCategoryId = _data["inventoryCategoryId"];
            this.dateOfMigration = _data["dateOfMigration"] ? moment(_data["dateOfMigration"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Material {
        data = typeof data === 'object' ? data : {};
        let result = new Material();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["oldPrice"] = this.oldPrice;
        data["discount"] = this.discount;
        data["ratingsCount"] = this.ratingsCount;
        data["ratingsValue"] = this.ratingsValue;
        data["availibilityCount"] = this.availibilityCount;
        data["cartCount"] = this.cartCount;
        data["weight"] = this.weight;
        data["categoryId"] = this.categoryId;
        data["fullDescription"] = this.fullDescription;
        data["serviceTax"] = this.serviceTax;
        data["taxCode"] = this.taxCode;
        data["isSubsidized"] = this.isSubsidized;
        data["isCertified"] = this.isCertified;
        data["isIslamic"] = this.isIslamic;
        data["isLoanAvailable"] = this.isLoanAvailable;
        data["isFeatured"] = this.isFeatured;
        data["isTypeSerice"] = this.isTypeSerice;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["hideFromMarketplace"] = this.hideFromMarketplace;
        data["companyProfileId"] = this.companyProfileId;
        data["companyProfile"] = this.companyProfile ? this.companyProfile.toJSON() : <any>undefined;
        data["isUserFeatured"] = this.isUserFeatured;
        data["showQuantity"] = this.showQuantity;
        data["minLevel"] = this.minLevel;
        data["isNotifiedMinLevel"] = this.isNotifiedMinLevel;
        data["tagNumber"] = this.tagNumber;
        data["barCode"] = this.barCode;
        if (Array.isArray(this.productMaterialRelations)) {
            data["productMaterialRelations"] = [];
            for (let item of this.productMaterialRelations)
                data["productMaterialRelations"].push(item.toJSON());
        }
        data["averagePriceFromPo"] = this.averagePriceFromPo;
        data["lastPriceFromPo"] = this.lastPriceFromPo;
        data["movingAverageValue"] = this.movingAverageValue;
        data["unitValue"] = this.unitValue;
        data["inventoryCategoryId"] = this.inventoryCategoryId;
        data["dateOfMigration"] = this.dateOfMigration ? this.dateOfMigration.toISOString() : <any>undefined;
        return data;
    }

    clone(): Material {
        const json = this.toJSON();
        let result = new Material();
        result.init(json);
        return result;
    }
}

export interface IMaterial {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: string;
    name: string;
    description: string | undefined;
    price: number;
    tenantId: number | undefined;
    tenant: Tenant;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    hideFromMarketplace: boolean;
    companyProfileId: string | undefined;
    companyProfile: CompanyProfile;
    isUserFeatured: boolean;
    showQuantity: boolean;
    minLevel: number;
    isNotifiedMinLevel: boolean;
    tagNumber: string | undefined;
    barCode: string | undefined;
    productMaterialRelations: ProductMaterialRelation[] | undefined;
    averagePriceFromPo: number;
    lastPriceFromPo: number;
    movingAverageValue: number;
    unitValue: number;
    inventoryCategoryId: number | undefined;
    dateOfMigration: moment.Moment | undefined;
}

export class MaterialDto implements IMaterialDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    price: number;
    tenantId: number;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    hideFromMarketplace: boolean;
    companyProfileId: string | undefined;
    isUserFeatured: boolean;
    mainPicture: string | undefined;
    showQuantity: boolean;
    minLevel: number;
    isNotifiedMinLevel: boolean;
    tagNumber: string | undefined;
    barCode: string | undefined;
    productMaterialRelations: ProductMaterialRelation[] | undefined;
    averagePriceFromPo: number;
    lastPriceFromPo: number;
    dateOfMigration: moment.Moment | undefined;
    manualEntries: InventoryManualEntry[] | undefined;
    inventoryCategoryId: number | undefined;
    previousCount: number;
    nextCount: number;
    totalInvoiceQty: number;
    totalWriteOffQty: number;
    totalStockCountQty: number;
    closingStock: number;
    openingStock: number;
    totalValue: number;
    totalOpeningValue: number;
    readonly unitValue: number;
    movingAverageValue: number;
    totalManualEntryQty: number;
    totalTransferBetweenLocationQty: number;
    totalIssueToProductionQty: number;
    totalIssueToProjectQty: number;
    totalWorkInProgressQty: number;
    projectId: number;
    itemType: number;

    constructor(data?: IMaterialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.tenantId = _data["tenantId"];
            this.oldPrice = _data["oldPrice"];
            this.discount = _data["discount"];
            this.ratingsCount = _data["ratingsCount"];
            this.ratingsValue = _data["ratingsValue"];
            this.availibilityCount = _data["availibilityCount"];
            this.cartCount = _data["cartCount"];
            this.weight = _data["weight"];
            this.categoryId = _data["categoryId"];
            this.fullDescription = _data["fullDescription"];
            this.serviceTax = _data["serviceTax"];
            this.taxCode = _data["taxCode"];
            this.isSubsidized = _data["isSubsidized"];
            this.isCertified = _data["isCertified"];
            this.isIslamic = _data["isIslamic"];
            this.isLoanAvailable = _data["isLoanAvailable"];
            this.isFeatured = _data["isFeatured"];
            this.isTypeSerice = _data["isTypeSerice"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.hideFromMarketplace = _data["hideFromMarketplace"];
            this.companyProfileId = _data["companyProfileId"];
            this.isUserFeatured = _data["isUserFeatured"];
            this.mainPicture = _data["mainPicture"];
            this.showQuantity = _data["showQuantity"];
            this.minLevel = _data["minLevel"];
            this.isNotifiedMinLevel = _data["isNotifiedMinLevel"];
            this.tagNumber = _data["tagNumber"];
            this.barCode = _data["barCode"];
            if (Array.isArray(_data["productMaterialRelations"])) {
                this.productMaterialRelations = [] as any;
                for (let item of _data["productMaterialRelations"])
                    this.productMaterialRelations.push(ProductMaterialRelation.fromJS(item));
            }
            this.averagePriceFromPo = _data["averagePriceFromPo"];
            this.lastPriceFromPo = _data["lastPriceFromPo"];
            this.dateOfMigration = _data["dateOfMigration"] ? moment(_data["dateOfMigration"].toString()) : <any>undefined;
            if (Array.isArray(_data["manualEntries"])) {
                this.manualEntries = [] as any;
                for (let item of _data["manualEntries"])
                    this.manualEntries.push(InventoryManualEntry.fromJS(item));
            }
            this.inventoryCategoryId = _data["inventoryCategoryId"];
            this.previousCount = _data["previousCount"];
            this.nextCount = _data["nextCount"];
            this.totalInvoiceQty = _data["totalInvoiceQty"];
            this.totalWriteOffQty = _data["totalWriteOffQty"];
            this.totalStockCountQty = _data["totalStockCountQty"];
            this.closingStock = _data["closingStock"];
            this.openingStock = _data["openingStock"];
            this.totalValue = _data["totalValue"];
            this.totalOpeningValue = _data["totalOpeningValue"];
            (<any>this).unitValue = _data["unitValue"];
            this.movingAverageValue = _data["movingAverageValue"];
            this.totalManualEntryQty = _data["totalManualEntryQty"];
            this.totalTransferBetweenLocationQty = _data["totalTransferBetweenLocationQty"];
            this.totalIssueToProductionQty = _data["totalIssueToProductionQty"];
            this.totalIssueToProjectQty = _data["totalIssueToProjectQty"];
            this.totalWorkInProgressQty = _data["totalWorkInProgressQty"];
            this.projectId = _data["projectId"];
            this.itemType = _data["itemType"];
        }
    }

    static fromJS(data: any): MaterialDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        data["tenantId"] = this.tenantId;
        data["oldPrice"] = this.oldPrice;
        data["discount"] = this.discount;
        data["ratingsCount"] = this.ratingsCount;
        data["ratingsValue"] = this.ratingsValue;
        data["availibilityCount"] = this.availibilityCount;
        data["cartCount"] = this.cartCount;
        data["weight"] = this.weight;
        data["categoryId"] = this.categoryId;
        data["fullDescription"] = this.fullDescription;
        data["serviceTax"] = this.serviceTax;
        data["taxCode"] = this.taxCode;
        data["isSubsidized"] = this.isSubsidized;
        data["isCertified"] = this.isCertified;
        data["isIslamic"] = this.isIslamic;
        data["isLoanAvailable"] = this.isLoanAvailable;
        data["isFeatured"] = this.isFeatured;
        data["isTypeSerice"] = this.isTypeSerice;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["hideFromMarketplace"] = this.hideFromMarketplace;
        data["companyProfileId"] = this.companyProfileId;
        data["isUserFeatured"] = this.isUserFeatured;
        data["mainPicture"] = this.mainPicture;
        data["showQuantity"] = this.showQuantity;
        data["minLevel"] = this.minLevel;
        data["isNotifiedMinLevel"] = this.isNotifiedMinLevel;
        data["tagNumber"] = this.tagNumber;
        data["barCode"] = this.barCode;
        if (Array.isArray(this.productMaterialRelations)) {
            data["productMaterialRelations"] = [];
            for (let item of this.productMaterialRelations)
                data["productMaterialRelations"].push(item.toJSON());
        }
        data["averagePriceFromPo"] = this.averagePriceFromPo;
        data["lastPriceFromPo"] = this.lastPriceFromPo;
        data["dateOfMigration"] = this.dateOfMigration ? this.dateOfMigration.toISOString() : <any>undefined;
        if (Array.isArray(this.manualEntries)) {
            data["manualEntries"] = [];
            for (let item of this.manualEntries)
                data["manualEntries"].push(item.toJSON());
        }
        data["inventoryCategoryId"] = this.inventoryCategoryId;
        data["previousCount"] = this.previousCount;
        data["nextCount"] = this.nextCount;
        data["totalInvoiceQty"] = this.totalInvoiceQty;
        data["totalWriteOffQty"] = this.totalWriteOffQty;
        data["totalStockCountQty"] = this.totalStockCountQty;
        data["closingStock"] = this.closingStock;
        data["openingStock"] = this.openingStock;
        data["totalValue"] = this.totalValue;
        data["totalOpeningValue"] = this.totalOpeningValue;
        data["unitValue"] = this.unitValue;
        data["movingAverageValue"] = this.movingAverageValue;
        data["totalManualEntryQty"] = this.totalManualEntryQty;
        data["totalTransferBetweenLocationQty"] = this.totalTransferBetweenLocationQty;
        data["totalIssueToProductionQty"] = this.totalIssueToProductionQty;
        data["totalIssueToProjectQty"] = this.totalIssueToProjectQty;
        data["totalWorkInProgressQty"] = this.totalWorkInProgressQty;
        data["projectId"] = this.projectId;
        data["itemType"] = this.itemType;
        return data;
    }

    clone(): MaterialDto {
        const json = this.toJSON();
        let result = new MaterialDto();
        result.init(json);
        return result;
    }
}

export interface IMaterialDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    price: number;
    tenantId: number;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    hideFromMarketplace: boolean;
    companyProfileId: string | undefined;
    isUserFeatured: boolean;
    mainPicture: string | undefined;
    showQuantity: boolean;
    minLevel: number;
    isNotifiedMinLevel: boolean;
    tagNumber: string | undefined;
    barCode: string | undefined;
    productMaterialRelations: ProductMaterialRelation[] | undefined;
    averagePriceFromPo: number;
    lastPriceFromPo: number;
    dateOfMigration: moment.Moment | undefined;
    manualEntries: InventoryManualEntry[] | undefined;
    inventoryCategoryId: number | undefined;
    previousCount: number;
    nextCount: number;
    totalInvoiceQty: number;
    totalWriteOffQty: number;
    totalStockCountQty: number;
    closingStock: number;
    openingStock: number;
    totalValue: number;
    totalOpeningValue: number;
    unitValue: number;
    movingAverageValue: number;
    totalManualEntryQty: number;
    totalTransferBetweenLocationQty: number;
    totalIssueToProductionQty: number;
    totalIssueToProjectQty: number;
    totalWorkInProgressQty: number;
    projectId: number;
    itemType: number;
}

export class MaterialDtoPagedResultDto implements IMaterialDtoPagedResultDto {
    items: MaterialDto[] | undefined;
    totalCount: number;

    constructor(data?: IMaterialDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(MaterialDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MaterialDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MaterialDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MaterialDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMaterialDtoPagedResultDto {
    items: MaterialDto[] | undefined;
    totalCount: number;
}

export class MaterialInventoryDto implements IMaterialInventoryDto {
    openingStock: number;
    closingStock: number;
    manualEntryQty: number;
    invoiceQty: number;
    writeOffQty: number;
    stockCountQty: number;
    transferBetweenLocationQty: number;
    issueToProductionQty: number;
    issueToProjectQty: number;
    workInProgressQty: number;
    manualEntries: InventoryManualEntry[] | undefined;

    constructor(data?: IMaterialInventoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.openingStock = _data["openingStock"];
            this.closingStock = _data["closingStock"];
            this.manualEntryQty = _data["manualEntryQty"];
            this.invoiceQty = _data["invoiceQty"];
            this.writeOffQty = _data["writeOffQty"];
            this.stockCountQty = _data["stockCountQty"];
            this.transferBetweenLocationQty = _data["transferBetweenLocationQty"];
            this.issueToProductionQty = _data["issueToProductionQty"];
            this.issueToProjectQty = _data["issueToProjectQty"];
            this.workInProgressQty = _data["workInProgressQty"];
            if (Array.isArray(_data["manualEntries"])) {
                this.manualEntries = [] as any;
                for (let item of _data["manualEntries"])
                    this.manualEntries.push(InventoryManualEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MaterialInventoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialInventoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["openingStock"] = this.openingStock;
        data["closingStock"] = this.closingStock;
        data["manualEntryQty"] = this.manualEntryQty;
        data["invoiceQty"] = this.invoiceQty;
        data["writeOffQty"] = this.writeOffQty;
        data["stockCountQty"] = this.stockCountQty;
        data["transferBetweenLocationQty"] = this.transferBetweenLocationQty;
        data["issueToProductionQty"] = this.issueToProductionQty;
        data["issueToProjectQty"] = this.issueToProjectQty;
        data["workInProgressQty"] = this.workInProgressQty;
        if (Array.isArray(this.manualEntries)) {
            data["manualEntries"] = [];
            for (let item of this.manualEntries)
                data["manualEntries"].push(item.toJSON());
        }
        return data;
    }

    clone(): MaterialInventoryDto {
        const json = this.toJSON();
        let result = new MaterialInventoryDto();
        result.init(json);
        return result;
    }
}

export interface IMaterialInventoryDto {
    openingStock: number;
    closingStock: number;
    manualEntryQty: number;
    invoiceQty: number;
    writeOffQty: number;
    stockCountQty: number;
    transferBetweenLocationQty: number;
    issueToProductionQty: number;
    issueToProjectQty: number;
    workInProgressQty: number;
    manualEntries: InventoryManualEntry[] | undefined;
}

export class MaterialMigrationDto implements IMaterialMigrationDto {
    name: string | undefined;
    code: string | undefined;
    inventoryCategoryName: string | undefined;
    price: number;
    unitOfMeasurement: string | undefined;
    availibilityCount: number;
    serviceTax: number;
    taxCode: string | undefined;
    description: string | undefined;
    minLevel: number;
    isNotifiedMinLevel: boolean;
    isValid: boolean;
    error: string | undefined;
    dateOfMigration: moment.Moment | undefined;
    inventoryCategoryId: number | undefined;
    inventoryCategory: InventoryCategory;

    constructor(data?: IMaterialMigrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.inventoryCategoryName = _data["inventoryCategoryName"];
            this.price = _data["price"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.availibilityCount = _data["availibilityCount"];
            this.serviceTax = _data["serviceTax"];
            this.taxCode = _data["taxCode"];
            this.description = _data["description"];
            this.minLevel = _data["minLevel"];
            this.isNotifiedMinLevel = _data["isNotifiedMinLevel"];
            this.isValid = _data["isValid"];
            this.error = _data["error"];
            this.dateOfMigration = _data["dateOfMigration"] ? moment(_data["dateOfMigration"].toString()) : <any>undefined;
            this.inventoryCategoryId = _data["inventoryCategoryId"];
            this.inventoryCategory = _data["inventoryCategory"] ? InventoryCategory.fromJS(_data["inventoryCategory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MaterialMigrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialMigrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["inventoryCategoryName"] = this.inventoryCategoryName;
        data["price"] = this.price;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["availibilityCount"] = this.availibilityCount;
        data["serviceTax"] = this.serviceTax;
        data["taxCode"] = this.taxCode;
        data["description"] = this.description;
        data["minLevel"] = this.minLevel;
        data["isNotifiedMinLevel"] = this.isNotifiedMinLevel;
        data["isValid"] = this.isValid;
        data["error"] = this.error;
        data["dateOfMigration"] = this.dateOfMigration ? this.dateOfMigration.toISOString() : <any>undefined;
        data["inventoryCategoryId"] = this.inventoryCategoryId;
        data["inventoryCategory"] = this.inventoryCategory ? this.inventoryCategory.toJSON() : <any>undefined;
        return data;
    }

    clone(): MaterialMigrationDto {
        const json = this.toJSON();
        let result = new MaterialMigrationDto();
        result.init(json);
        return result;
    }
}

export interface IMaterialMigrationDto {
    name: string | undefined;
    code: string | undefined;
    inventoryCategoryName: string | undefined;
    price: number;
    unitOfMeasurement: string | undefined;
    availibilityCount: number;
    serviceTax: number;
    taxCode: string | undefined;
    description: string | undefined;
    minLevel: number;
    isNotifiedMinLevel: boolean;
    isValid: boolean;
    error: string | undefined;
    dateOfMigration: moment.Moment | undefined;
    inventoryCategoryId: number | undefined;
    inventoryCategory: InventoryCategory;
}

export class NonCurrentAsset implements INonCurrentAsset {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: string;
    name: string;
    description: string | undefined;
    price: number;
    tenantId: number | undefined;
    tenant: Tenant;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    hideFromMarketplace: boolean;
    companyProfileId: string | undefined;
    companyProfile: CompanyProfile;
    isUserFeatured: boolean;
    showQuantity: boolean;
    depreciationRate: number;
    accountsCategoryCode: string | undefined;
    accountsCategoryName: string | undefined;
    accountsCategoryCode2: string | undefined;
    accountsCategoryName2: string | undefined;
    nonCurrentAssetClassId: string | undefined;
    nonCurrentAssetClass: NonCurrentAssetClass;

    constructor(data?: INonCurrentAsset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.oldPrice = _data["oldPrice"];
            this.discount = _data["discount"];
            this.ratingsCount = _data["ratingsCount"];
            this.ratingsValue = _data["ratingsValue"];
            this.availibilityCount = _data["availibilityCount"];
            this.cartCount = _data["cartCount"];
            this.weight = _data["weight"];
            this.categoryId = _data["categoryId"];
            this.fullDescription = _data["fullDescription"];
            this.serviceTax = _data["serviceTax"];
            this.taxCode = _data["taxCode"];
            this.isSubsidized = _data["isSubsidized"];
            this.isCertified = _data["isCertified"];
            this.isIslamic = _data["isIslamic"];
            this.isLoanAvailable = _data["isLoanAvailable"];
            this.isFeatured = _data["isFeatured"];
            this.isTypeSerice = _data["isTypeSerice"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.hideFromMarketplace = _data["hideFromMarketplace"];
            this.companyProfileId = _data["companyProfileId"];
            this.companyProfile = _data["companyProfile"] ? CompanyProfile.fromJS(_data["companyProfile"]) : <any>undefined;
            this.isUserFeatured = _data["isUserFeatured"];
            this.showQuantity = _data["showQuantity"];
            this.depreciationRate = _data["depreciationRate"];
            this.accountsCategoryCode = _data["accountsCategoryCode"];
            this.accountsCategoryName = _data["accountsCategoryName"];
            this.accountsCategoryCode2 = _data["accountsCategoryCode2"];
            this.accountsCategoryName2 = _data["accountsCategoryName2"];
            this.nonCurrentAssetClassId = _data["nonCurrentAssetClassId"];
            this.nonCurrentAssetClass = _data["nonCurrentAssetClass"] ? NonCurrentAssetClass.fromJS(_data["nonCurrentAssetClass"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NonCurrentAsset {
        data = typeof data === 'object' ? data : {};
        let result = new NonCurrentAsset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["oldPrice"] = this.oldPrice;
        data["discount"] = this.discount;
        data["ratingsCount"] = this.ratingsCount;
        data["ratingsValue"] = this.ratingsValue;
        data["availibilityCount"] = this.availibilityCount;
        data["cartCount"] = this.cartCount;
        data["weight"] = this.weight;
        data["categoryId"] = this.categoryId;
        data["fullDescription"] = this.fullDescription;
        data["serviceTax"] = this.serviceTax;
        data["taxCode"] = this.taxCode;
        data["isSubsidized"] = this.isSubsidized;
        data["isCertified"] = this.isCertified;
        data["isIslamic"] = this.isIslamic;
        data["isLoanAvailable"] = this.isLoanAvailable;
        data["isFeatured"] = this.isFeatured;
        data["isTypeSerice"] = this.isTypeSerice;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["hideFromMarketplace"] = this.hideFromMarketplace;
        data["companyProfileId"] = this.companyProfileId;
        data["companyProfile"] = this.companyProfile ? this.companyProfile.toJSON() : <any>undefined;
        data["isUserFeatured"] = this.isUserFeatured;
        data["showQuantity"] = this.showQuantity;
        data["depreciationRate"] = this.depreciationRate;
        data["accountsCategoryCode"] = this.accountsCategoryCode;
        data["accountsCategoryName"] = this.accountsCategoryName;
        data["accountsCategoryCode2"] = this.accountsCategoryCode2;
        data["accountsCategoryName2"] = this.accountsCategoryName2;
        data["nonCurrentAssetClassId"] = this.nonCurrentAssetClassId;
        data["nonCurrentAssetClass"] = this.nonCurrentAssetClass ? this.nonCurrentAssetClass.toJSON() : <any>undefined;
        return data;
    }

    clone(): NonCurrentAsset {
        const json = this.toJSON();
        let result = new NonCurrentAsset();
        result.init(json);
        return result;
    }
}

export interface INonCurrentAsset {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: string;
    name: string;
    description: string | undefined;
    price: number;
    tenantId: number | undefined;
    tenant: Tenant;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    hideFromMarketplace: boolean;
    companyProfileId: string | undefined;
    companyProfile: CompanyProfile;
    isUserFeatured: boolean;
    showQuantity: boolean;
    depreciationRate: number;
    accountsCategoryCode: string | undefined;
    accountsCategoryName: string | undefined;
    accountsCategoryCode2: string | undefined;
    accountsCategoryName2: string | undefined;
    nonCurrentAssetClassId: string | undefined;
    nonCurrentAssetClass: NonCurrentAssetClass;
}

export class NonCurrentAssetClass implements INonCurrentAssetClass {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    accountsCategoryCode: string | undefined;
    accountsCategoryName: string | undefined;
    totalItems: number;
    totalCosts: number;
    totalAccumulatedDepreciation: number;
    totalAccumulatedImpairment: number;
    totalNetBookValue: number;

    constructor(data?: INonCurrentAssetClass) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.accountsCategoryCode = _data["accountsCategoryCode"];
            this.accountsCategoryName = _data["accountsCategoryName"];
            this.totalItems = _data["totalItems"];
            this.totalCosts = _data["totalCosts"];
            this.totalAccumulatedDepreciation = _data["totalAccumulatedDepreciation"];
            this.totalAccumulatedImpairment = _data["totalAccumulatedImpairment"];
            this.totalNetBookValue = _data["totalNetBookValue"];
        }
    }

    static fromJS(data: any): NonCurrentAssetClass {
        data = typeof data === 'object' ? data : {};
        let result = new NonCurrentAssetClass();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["accountsCategoryCode"] = this.accountsCategoryCode;
        data["accountsCategoryName"] = this.accountsCategoryName;
        data["totalItems"] = this.totalItems;
        data["totalCosts"] = this.totalCosts;
        data["totalAccumulatedDepreciation"] = this.totalAccumulatedDepreciation;
        data["totalAccumulatedImpairment"] = this.totalAccumulatedImpairment;
        data["totalNetBookValue"] = this.totalNetBookValue;
        return data;
    }

    clone(): NonCurrentAssetClass {
        const json = this.toJSON();
        let result = new NonCurrentAssetClass();
        result.init(json);
        return result;
    }
}

export interface INonCurrentAssetClass {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    accountsCategoryCode: string | undefined;
    accountsCategoryName: string | undefined;
    totalItems: number;
    totalCosts: number;
    totalAccumulatedDepreciation: number;
    totalAccumulatedImpairment: number;
    totalNetBookValue: number;
}

export class NonCurrentAssetClassDto implements INonCurrentAssetClassDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    accountsCategoryCode: string | undefined;
    accountsCategoryName: string | undefined;
    totalItems: number;
    totalCosts: number;
    totalAccumulatedDepreciation: number;
    totalAccumulatedImpairment: number;
    totalNetBookValue: number;
    depreciationToDate: number;
    impairmentToDate: number;
    nonCurrentAssetItemList: NonCurrentAssetItem[] | undefined;
    openingBalance: number;
    addition: number;
    disposal: number;

    constructor(data?: INonCurrentAssetClassDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.accountsCategoryCode = _data["accountsCategoryCode"];
            this.accountsCategoryName = _data["accountsCategoryName"];
            this.totalItems = _data["totalItems"];
            this.totalCosts = _data["totalCosts"];
            this.totalAccumulatedDepreciation = _data["totalAccumulatedDepreciation"];
            this.totalAccumulatedImpairment = _data["totalAccumulatedImpairment"];
            this.totalNetBookValue = _data["totalNetBookValue"];
            this.depreciationToDate = _data["depreciationToDate"];
            this.impairmentToDate = _data["impairmentToDate"];
            if (Array.isArray(_data["nonCurrentAssetItemList"])) {
                this.nonCurrentAssetItemList = [] as any;
                for (let item of _data["nonCurrentAssetItemList"])
                    this.nonCurrentAssetItemList.push(NonCurrentAssetItem.fromJS(item));
            }
            this.openingBalance = _data["openingBalance"];
            this.addition = _data["addition"];
            this.disposal = _data["disposal"];
        }
    }

    static fromJS(data: any): NonCurrentAssetClassDto {
        data = typeof data === 'object' ? data : {};
        let result = new NonCurrentAssetClassDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["accountsCategoryCode"] = this.accountsCategoryCode;
        data["accountsCategoryName"] = this.accountsCategoryName;
        data["totalItems"] = this.totalItems;
        data["totalCosts"] = this.totalCosts;
        data["totalAccumulatedDepreciation"] = this.totalAccumulatedDepreciation;
        data["totalAccumulatedImpairment"] = this.totalAccumulatedImpairment;
        data["totalNetBookValue"] = this.totalNetBookValue;
        data["depreciationToDate"] = this.depreciationToDate;
        data["impairmentToDate"] = this.impairmentToDate;
        if (Array.isArray(this.nonCurrentAssetItemList)) {
            data["nonCurrentAssetItemList"] = [];
            for (let item of this.nonCurrentAssetItemList)
                data["nonCurrentAssetItemList"].push(item.toJSON());
        }
        data["openingBalance"] = this.openingBalance;
        data["addition"] = this.addition;
        data["disposal"] = this.disposal;
        return data;
    }

    clone(): NonCurrentAssetClassDto {
        const json = this.toJSON();
        let result = new NonCurrentAssetClassDto();
        result.init(json);
        return result;
    }
}

export interface INonCurrentAssetClassDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    accountsCategoryCode: string | undefined;
    accountsCategoryName: string | undefined;
    totalItems: number;
    totalCosts: number;
    totalAccumulatedDepreciation: number;
    totalAccumulatedImpairment: number;
    totalNetBookValue: number;
    depreciationToDate: number;
    impairmentToDate: number;
    nonCurrentAssetItemList: NonCurrentAssetItem[] | undefined;
    openingBalance: number;
    addition: number;
    disposal: number;
}

export class NonCurrentAssetClassDtoPagedResultDto implements INonCurrentAssetClassDtoPagedResultDto {
    items: NonCurrentAssetClassDto[] | undefined;
    totalCount: number;

    constructor(data?: INonCurrentAssetClassDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(NonCurrentAssetClassDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): NonCurrentAssetClassDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NonCurrentAssetClassDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): NonCurrentAssetClassDtoPagedResultDto {
        const json = this.toJSON();
        let result = new NonCurrentAssetClassDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface INonCurrentAssetClassDtoPagedResultDto {
    items: NonCurrentAssetClassDto[] | undefined;
    totalCount: number;
}

export class NonCurrentAssetDto implements INonCurrentAssetDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    price: number;
    tenantId: number;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    hideFromMarketplace: boolean;
    companyProfileId: string | undefined;
    isUserFeatured: boolean;
    mainPicture: string | undefined;
    showQuantity: boolean;
    depreciationRate: number;
    nonCurrentAssetItems: NonCurrentAssetItemDto[] | undefined;
    totalItems: number;
    totalCost: number;
    accumulatedDepreciation: number;
    accumulatedImpairment: number;
    netBookValue: number;
    prItemsList: PurchaseRequisitionItems[] | undefined;
    prItemsCount: number;
    accountsCategoryCode: string | undefined;
    accountsCategoryName: string | undefined;
    accountsCategoryCode2: string | undefined;
    accountsCategoryName2: string | undefined;
    nonCurrentAssetClassId: string | undefined;
    totalCosts: number;
    totalAccumulatedDepreciation: number;
    totalAccumulatedImpairment: number;
    totalNetBookValue: number;
    depreciationToDate: number;
    impairmentToDate: number;
    nonCurrentAssetItemList: NonCurrentAssetItem[] | undefined;
    openingBalance: number;
    addition: number;
    disposal: number;

    constructor(data?: INonCurrentAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.tenantId = _data["tenantId"];
            this.oldPrice = _data["oldPrice"];
            this.discount = _data["discount"];
            this.ratingsCount = _data["ratingsCount"];
            this.ratingsValue = _data["ratingsValue"];
            this.availibilityCount = _data["availibilityCount"];
            this.cartCount = _data["cartCount"];
            this.weight = _data["weight"];
            this.categoryId = _data["categoryId"];
            this.fullDescription = _data["fullDescription"];
            this.serviceTax = _data["serviceTax"];
            this.taxCode = _data["taxCode"];
            this.isSubsidized = _data["isSubsidized"];
            this.isCertified = _data["isCertified"];
            this.isIslamic = _data["isIslamic"];
            this.isLoanAvailable = _data["isLoanAvailable"];
            this.isFeatured = _data["isFeatured"];
            this.isTypeSerice = _data["isTypeSerice"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.hideFromMarketplace = _data["hideFromMarketplace"];
            this.companyProfileId = _data["companyProfileId"];
            this.isUserFeatured = _data["isUserFeatured"];
            this.mainPicture = _data["mainPicture"];
            this.showQuantity = _data["showQuantity"];
            this.depreciationRate = _data["depreciationRate"];
            if (Array.isArray(_data["nonCurrentAssetItems"])) {
                this.nonCurrentAssetItems = [] as any;
                for (let item of _data["nonCurrentAssetItems"])
                    this.nonCurrentAssetItems.push(NonCurrentAssetItemDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
            this.totalCost = _data["totalCost"];
            this.accumulatedDepreciation = _data["accumulatedDepreciation"];
            this.accumulatedImpairment = _data["accumulatedImpairment"];
            this.netBookValue = _data["netBookValue"];
            if (Array.isArray(_data["prItemsList"])) {
                this.prItemsList = [] as any;
                for (let item of _data["prItemsList"])
                    this.prItemsList.push(PurchaseRequisitionItems.fromJS(item));
            }
            this.prItemsCount = _data["prItemsCount"];
            this.accountsCategoryCode = _data["accountsCategoryCode"];
            this.accountsCategoryName = _data["accountsCategoryName"];
            this.accountsCategoryCode2 = _data["accountsCategoryCode2"];
            this.accountsCategoryName2 = _data["accountsCategoryName2"];
            this.nonCurrentAssetClassId = _data["nonCurrentAssetClassId"];
            this.totalCosts = _data["totalCosts"];
            this.totalAccumulatedDepreciation = _data["totalAccumulatedDepreciation"];
            this.totalAccumulatedImpairment = _data["totalAccumulatedImpairment"];
            this.totalNetBookValue = _data["totalNetBookValue"];
            this.depreciationToDate = _data["depreciationToDate"];
            this.impairmentToDate = _data["impairmentToDate"];
            if (Array.isArray(_data["nonCurrentAssetItemList"])) {
                this.nonCurrentAssetItemList = [] as any;
                for (let item of _data["nonCurrentAssetItemList"])
                    this.nonCurrentAssetItemList.push(NonCurrentAssetItem.fromJS(item));
            }
            this.openingBalance = _data["openingBalance"];
            this.addition = _data["addition"];
            this.disposal = _data["disposal"];
        }
    }

    static fromJS(data: any): NonCurrentAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new NonCurrentAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        data["tenantId"] = this.tenantId;
        data["oldPrice"] = this.oldPrice;
        data["discount"] = this.discount;
        data["ratingsCount"] = this.ratingsCount;
        data["ratingsValue"] = this.ratingsValue;
        data["availibilityCount"] = this.availibilityCount;
        data["cartCount"] = this.cartCount;
        data["weight"] = this.weight;
        data["categoryId"] = this.categoryId;
        data["fullDescription"] = this.fullDescription;
        data["serviceTax"] = this.serviceTax;
        data["taxCode"] = this.taxCode;
        data["isSubsidized"] = this.isSubsidized;
        data["isCertified"] = this.isCertified;
        data["isIslamic"] = this.isIslamic;
        data["isLoanAvailable"] = this.isLoanAvailable;
        data["isFeatured"] = this.isFeatured;
        data["isTypeSerice"] = this.isTypeSerice;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["hideFromMarketplace"] = this.hideFromMarketplace;
        data["companyProfileId"] = this.companyProfileId;
        data["isUserFeatured"] = this.isUserFeatured;
        data["mainPicture"] = this.mainPicture;
        data["showQuantity"] = this.showQuantity;
        data["depreciationRate"] = this.depreciationRate;
        if (Array.isArray(this.nonCurrentAssetItems)) {
            data["nonCurrentAssetItems"] = [];
            for (let item of this.nonCurrentAssetItems)
                data["nonCurrentAssetItems"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        data["totalCost"] = this.totalCost;
        data["accumulatedDepreciation"] = this.accumulatedDepreciation;
        data["accumulatedImpairment"] = this.accumulatedImpairment;
        data["netBookValue"] = this.netBookValue;
        if (Array.isArray(this.prItemsList)) {
            data["prItemsList"] = [];
            for (let item of this.prItemsList)
                data["prItemsList"].push(item.toJSON());
        }
        data["prItemsCount"] = this.prItemsCount;
        data["accountsCategoryCode"] = this.accountsCategoryCode;
        data["accountsCategoryName"] = this.accountsCategoryName;
        data["accountsCategoryCode2"] = this.accountsCategoryCode2;
        data["accountsCategoryName2"] = this.accountsCategoryName2;
        data["nonCurrentAssetClassId"] = this.nonCurrentAssetClassId;
        data["totalCosts"] = this.totalCosts;
        data["totalAccumulatedDepreciation"] = this.totalAccumulatedDepreciation;
        data["totalAccumulatedImpairment"] = this.totalAccumulatedImpairment;
        data["totalNetBookValue"] = this.totalNetBookValue;
        data["depreciationToDate"] = this.depreciationToDate;
        data["impairmentToDate"] = this.impairmentToDate;
        if (Array.isArray(this.nonCurrentAssetItemList)) {
            data["nonCurrentAssetItemList"] = [];
            for (let item of this.nonCurrentAssetItemList)
                data["nonCurrentAssetItemList"].push(item.toJSON());
        }
        data["openingBalance"] = this.openingBalance;
        data["addition"] = this.addition;
        data["disposal"] = this.disposal;
        return data;
    }

    clone(): NonCurrentAssetDto {
        const json = this.toJSON();
        let result = new NonCurrentAssetDto();
        result.init(json);
        return result;
    }
}

export interface INonCurrentAssetDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    price: number;
    tenantId: number;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    hideFromMarketplace: boolean;
    companyProfileId: string | undefined;
    isUserFeatured: boolean;
    mainPicture: string | undefined;
    showQuantity: boolean;
    depreciationRate: number;
    nonCurrentAssetItems: NonCurrentAssetItemDto[] | undefined;
    totalItems: number;
    totalCost: number;
    accumulatedDepreciation: number;
    accumulatedImpairment: number;
    netBookValue: number;
    prItemsList: PurchaseRequisitionItems[] | undefined;
    prItemsCount: number;
    accountsCategoryCode: string | undefined;
    accountsCategoryName: string | undefined;
    accountsCategoryCode2: string | undefined;
    accountsCategoryName2: string | undefined;
    nonCurrentAssetClassId: string | undefined;
    totalCosts: number;
    totalAccumulatedDepreciation: number;
    totalAccumulatedImpairment: number;
    totalNetBookValue: number;
    depreciationToDate: number;
    impairmentToDate: number;
    nonCurrentAssetItemList: NonCurrentAssetItem[] | undefined;
    openingBalance: number;
    addition: number;
    disposal: number;
}

export class NonCurrentAssetDtoPagedResultDto implements INonCurrentAssetDtoPagedResultDto {
    items: NonCurrentAssetDto[] | undefined;
    totalCount: number;

    constructor(data?: INonCurrentAssetDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(NonCurrentAssetDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): NonCurrentAssetDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NonCurrentAssetDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): NonCurrentAssetDtoPagedResultDto {
        const json = this.toJSON();
        let result = new NonCurrentAssetDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface INonCurrentAssetDtoPagedResultDto {
    items: NonCurrentAssetDto[] | undefined;
    totalCount: number;
}

export class NonCurrentAssetItem implements INonCurrentAssetItem {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    unitPrice: number;
    installationCost: number;
    thirdPartyInstallationCost: number;
    readonly totalInstallationCost: number;
    deliveryCost: number;
    totalOriginalCost: number;
    discount: number;
    tax: number;
    nonCurrentAssetId: string;
    nonCurrentAsset: NonCurrentAsset;
    taxCode: string | undefined;
    creditNote: number;
    serialNumber: string | undefined;
    barCode: string | undefined;
    depreciationRate: number;
    depreciationStartDate: moment.Moment;
    accumulatedImpairment: number;
    isWriteOff: boolean;
    isDisposal: boolean;
    writeOffAndDisposalDate: moment.Moment;
    sellValue: number;
    internalTag: string | undefined;
    residualValue: number;
    location: string | undefined;
    migratedAccumulatedDepreciation: number;
    migratedAccumulatedImpairment: number;
    migratedAccumulatedIncome: number;
    migratedDate: moment.Moment;
    migratedRequesterId: number;
    migratedRequesterName: string | undefined;
    migratedRequesterRemarks: string | undefined;
    migratedApproverId: number;
    migratedApproverName: string | undefined;
    migratedApproverRemarks: string | undefined;
    migratedApprovalStatus: number;
    migratedApprovalDate: moment.Moment;
    supplierInvoiceUrl: string | undefined;
    purchasedDate: moment.Moment;
    depreciationMode: number;
    dateAcquired: moment.Moment | undefined;
    description: string | undefined;
    typeOfInvestment: string | undefined;
    certificate: string | undefined;
    rateOfReturn: number | undefined;
    incomeReceived: number | undefined;
    accruedIncomeReceived: number | undefined;
    readonly totalIncomeReceived: number;
    dateOfIncomeReceived: moment.Moment | undefined;
    companyName: string | undefined;
    companyRegNo: string | undefined;
    companyType: string | undefined;
    numberOfSharePurchased: number | undefined;
    percentageOfHolding: number | undefined;
    shareCertificateNo: string | undefined;
    dividendsReceived: number | undefined;
    dateOfDividentReceived: moment.Moment | undefined;
    maturityDate: moment.Moment | undefined;
    readonly tenure: number | undefined;
    investee: string | undefined;
    vendorInvoiceId: number | undefined;
    writeOffNoteId: number | undefined;
    cashbookId: number | undefined;
    writeOffNote: WriteOffNote;
    vendorInvoice: VendorInvoice;
    postMigration: boolean;

    constructor(data?: INonCurrentAssetItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.unitPrice = _data["unitPrice"];
            this.installationCost = _data["installationCost"];
            this.thirdPartyInstallationCost = _data["thirdPartyInstallationCost"];
            (<any>this).totalInstallationCost = _data["totalInstallationCost"];
            this.deliveryCost = _data["deliveryCost"];
            this.totalOriginalCost = _data["totalOriginalCost"];
            this.discount = _data["discount"];
            this.tax = _data["tax"];
            this.nonCurrentAssetId = _data["nonCurrentAssetId"];
            this.nonCurrentAsset = _data["nonCurrentAsset"] ? NonCurrentAsset.fromJS(_data["nonCurrentAsset"]) : <any>undefined;
            this.taxCode = _data["taxCode"];
            this.creditNote = _data["creditNote"];
            this.serialNumber = _data["serialNumber"];
            this.barCode = _data["barCode"];
            this.depreciationRate = _data["depreciationRate"];
            this.depreciationStartDate = _data["depreciationStartDate"] ? moment(_data["depreciationStartDate"].toString()) : <any>undefined;
            this.accumulatedImpairment = _data["accumulatedImpairment"];
            this.isWriteOff = _data["isWriteOff"];
            this.isDisposal = _data["isDisposal"];
            this.writeOffAndDisposalDate = _data["writeOffAndDisposalDate"] ? moment(_data["writeOffAndDisposalDate"].toString()) : <any>undefined;
            this.sellValue = _data["sellValue"];
            this.internalTag = _data["internalTag"];
            this.residualValue = _data["residualValue"];
            this.location = _data["location"];
            this.migratedAccumulatedDepreciation = _data["migratedAccumulatedDepreciation"];
            this.migratedAccumulatedImpairment = _data["migratedAccumulatedImpairment"];
            this.migratedAccumulatedIncome = _data["migratedAccumulatedIncome"];
            this.migratedDate = _data["migratedDate"] ? moment(_data["migratedDate"].toString()) : <any>undefined;
            this.migratedRequesterId = _data["migratedRequesterId"];
            this.migratedRequesterName = _data["migratedRequesterName"];
            this.migratedRequesterRemarks = _data["migratedRequesterRemarks"];
            this.migratedApproverId = _data["migratedApproverId"];
            this.migratedApproverName = _data["migratedApproverName"];
            this.migratedApproverRemarks = _data["migratedApproverRemarks"];
            this.migratedApprovalStatus = _data["migratedApprovalStatus"];
            this.migratedApprovalDate = _data["migratedApprovalDate"] ? moment(_data["migratedApprovalDate"].toString()) : <any>undefined;
            this.supplierInvoiceUrl = _data["supplierInvoiceUrl"];
            this.purchasedDate = _data["purchasedDate"] ? moment(_data["purchasedDate"].toString()) : <any>undefined;
            this.depreciationMode = _data["depreciationMode"];
            this.dateAcquired = _data["dateAcquired"] ? moment(_data["dateAcquired"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.typeOfInvestment = _data["typeOfInvestment"];
            this.certificate = _data["certificate"];
            this.rateOfReturn = _data["rateOfReturn"];
            this.incomeReceived = _data["incomeReceived"];
            this.accruedIncomeReceived = _data["accruedIncomeReceived"];
            (<any>this).totalIncomeReceived = _data["totalIncomeReceived"];
            this.dateOfIncomeReceived = _data["dateOfIncomeReceived"] ? moment(_data["dateOfIncomeReceived"].toString()) : <any>undefined;
            this.companyName = _data["companyName"];
            this.companyRegNo = _data["companyRegNo"];
            this.companyType = _data["companyType"];
            this.numberOfSharePurchased = _data["numberOfSharePurchased"];
            this.percentageOfHolding = _data["percentageOfHolding"];
            this.shareCertificateNo = _data["shareCertificateNo"];
            this.dividendsReceived = _data["dividendsReceived"];
            this.dateOfDividentReceived = _data["dateOfDividentReceived"] ? moment(_data["dateOfDividentReceived"].toString()) : <any>undefined;
            this.maturityDate = _data["maturityDate"] ? moment(_data["maturityDate"].toString()) : <any>undefined;
            (<any>this).tenure = _data["tenure"];
            this.investee = _data["investee"];
            this.vendorInvoiceId = _data["vendorInvoiceId"];
            this.writeOffNoteId = _data["writeOffNoteId"];
            this.cashbookId = _data["cashbookId"];
            this.writeOffNote = _data["writeOffNote"] ? WriteOffNote.fromJS(_data["writeOffNote"]) : <any>undefined;
            this.vendorInvoice = _data["vendorInvoice"] ? VendorInvoice.fromJS(_data["vendorInvoice"]) : <any>undefined;
            this.postMigration = _data["postMigration"];
        }
    }

    static fromJS(data: any): NonCurrentAssetItem {
        data = typeof data === 'object' ? data : {};
        let result = new NonCurrentAssetItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["unitPrice"] = this.unitPrice;
        data["installationCost"] = this.installationCost;
        data["thirdPartyInstallationCost"] = this.thirdPartyInstallationCost;
        data["totalInstallationCost"] = this.totalInstallationCost;
        data["deliveryCost"] = this.deliveryCost;
        data["totalOriginalCost"] = this.totalOriginalCost;
        data["discount"] = this.discount;
        data["tax"] = this.tax;
        data["nonCurrentAssetId"] = this.nonCurrentAssetId;
        data["nonCurrentAsset"] = this.nonCurrentAsset ? this.nonCurrentAsset.toJSON() : <any>undefined;
        data["taxCode"] = this.taxCode;
        data["creditNote"] = this.creditNote;
        data["serialNumber"] = this.serialNumber;
        data["barCode"] = this.barCode;
        data["depreciationRate"] = this.depreciationRate;
        data["depreciationStartDate"] = this.depreciationStartDate ? this.depreciationStartDate.toISOString() : <any>undefined;
        data["accumulatedImpairment"] = this.accumulatedImpairment;
        data["isWriteOff"] = this.isWriteOff;
        data["isDisposal"] = this.isDisposal;
        data["writeOffAndDisposalDate"] = this.writeOffAndDisposalDate ? this.writeOffAndDisposalDate.toISOString() : <any>undefined;
        data["sellValue"] = this.sellValue;
        data["internalTag"] = this.internalTag;
        data["residualValue"] = this.residualValue;
        data["location"] = this.location;
        data["migratedAccumulatedDepreciation"] = this.migratedAccumulatedDepreciation;
        data["migratedAccumulatedImpairment"] = this.migratedAccumulatedImpairment;
        data["migratedAccumulatedIncome"] = this.migratedAccumulatedIncome;
        data["migratedDate"] = this.migratedDate ? this.migratedDate.toISOString() : <any>undefined;
        data["migratedRequesterId"] = this.migratedRequesterId;
        data["migratedRequesterName"] = this.migratedRequesterName;
        data["migratedRequesterRemarks"] = this.migratedRequesterRemarks;
        data["migratedApproverId"] = this.migratedApproverId;
        data["migratedApproverName"] = this.migratedApproverName;
        data["migratedApproverRemarks"] = this.migratedApproverRemarks;
        data["migratedApprovalStatus"] = this.migratedApprovalStatus;
        data["migratedApprovalDate"] = this.migratedApprovalDate ? this.migratedApprovalDate.toISOString() : <any>undefined;
        data["supplierInvoiceUrl"] = this.supplierInvoiceUrl;
        data["purchasedDate"] = this.purchasedDate ? this.purchasedDate.toISOString() : <any>undefined;
        data["depreciationMode"] = this.depreciationMode;
        data["dateAcquired"] = this.dateAcquired ? this.dateAcquired.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["typeOfInvestment"] = this.typeOfInvestment;
        data["certificate"] = this.certificate;
        data["rateOfReturn"] = this.rateOfReturn;
        data["incomeReceived"] = this.incomeReceived;
        data["accruedIncomeReceived"] = this.accruedIncomeReceived;
        data["totalIncomeReceived"] = this.totalIncomeReceived;
        data["dateOfIncomeReceived"] = this.dateOfIncomeReceived ? this.dateOfIncomeReceived.toISOString() : <any>undefined;
        data["companyName"] = this.companyName;
        data["companyRegNo"] = this.companyRegNo;
        data["companyType"] = this.companyType;
        data["numberOfSharePurchased"] = this.numberOfSharePurchased;
        data["percentageOfHolding"] = this.percentageOfHolding;
        data["shareCertificateNo"] = this.shareCertificateNo;
        data["dividendsReceived"] = this.dividendsReceived;
        data["dateOfDividentReceived"] = this.dateOfDividentReceived ? this.dateOfDividentReceived.toISOString() : <any>undefined;
        data["maturityDate"] = this.maturityDate ? this.maturityDate.toISOString() : <any>undefined;
        data["tenure"] = this.tenure;
        data["investee"] = this.investee;
        data["vendorInvoiceId"] = this.vendorInvoiceId;
        data["writeOffNoteId"] = this.writeOffNoteId;
        data["cashbookId"] = this.cashbookId;
        data["writeOffNote"] = this.writeOffNote ? this.writeOffNote.toJSON() : <any>undefined;
        data["vendorInvoice"] = this.vendorInvoice ? this.vendorInvoice.toJSON() : <any>undefined;
        data["postMigration"] = this.postMigration;
        return data;
    }

    clone(): NonCurrentAssetItem {
        const json = this.toJSON();
        let result = new NonCurrentAssetItem();
        result.init(json);
        return result;
    }
}

export interface INonCurrentAssetItem {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    unitPrice: number;
    installationCost: number;
    thirdPartyInstallationCost: number;
    totalInstallationCost: number;
    deliveryCost: number;
    totalOriginalCost: number;
    discount: number;
    tax: number;
    nonCurrentAssetId: string;
    nonCurrentAsset: NonCurrentAsset;
    taxCode: string | undefined;
    creditNote: number;
    serialNumber: string | undefined;
    barCode: string | undefined;
    depreciationRate: number;
    depreciationStartDate: moment.Moment;
    accumulatedImpairment: number;
    isWriteOff: boolean;
    isDisposal: boolean;
    writeOffAndDisposalDate: moment.Moment;
    sellValue: number;
    internalTag: string | undefined;
    residualValue: number;
    location: string | undefined;
    migratedAccumulatedDepreciation: number;
    migratedAccumulatedImpairment: number;
    migratedAccumulatedIncome: number;
    migratedDate: moment.Moment;
    migratedRequesterId: number;
    migratedRequesterName: string | undefined;
    migratedRequesterRemarks: string | undefined;
    migratedApproverId: number;
    migratedApproverName: string | undefined;
    migratedApproverRemarks: string | undefined;
    migratedApprovalStatus: number;
    migratedApprovalDate: moment.Moment;
    supplierInvoiceUrl: string | undefined;
    purchasedDate: moment.Moment;
    depreciationMode: number;
    dateAcquired: moment.Moment | undefined;
    description: string | undefined;
    typeOfInvestment: string | undefined;
    certificate: string | undefined;
    rateOfReturn: number | undefined;
    incomeReceived: number | undefined;
    accruedIncomeReceived: number | undefined;
    totalIncomeReceived: number;
    dateOfIncomeReceived: moment.Moment | undefined;
    companyName: string | undefined;
    companyRegNo: string | undefined;
    companyType: string | undefined;
    numberOfSharePurchased: number | undefined;
    percentageOfHolding: number | undefined;
    shareCertificateNo: string | undefined;
    dividendsReceived: number | undefined;
    dateOfDividentReceived: moment.Moment | undefined;
    maturityDate: moment.Moment | undefined;
    tenure: number | undefined;
    investee: string | undefined;
    vendorInvoiceId: number | undefined;
    writeOffNoteId: number | undefined;
    cashbookId: number | undefined;
    writeOffNote: WriteOffNote;
    vendorInvoice: VendorInvoice;
    postMigration: boolean;
}

export class NonCurrentAssetItemDto implements INonCurrentAssetItemDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    unitPrice: number;
    installationCost: number;
    thirdPartyInstallationCost: number;
    readonly totalInstallationCost: number;
    deliveryCost: number;
    totalOriginalCost: number;
    discount: number;
    tax: number;
    nonCurrentAssetId: string;
    nonCurrentAsset: NonCurrentAsset;
    nonCurrentAssetDto: NonCurrentAssetDto;
    taxCode: string | undefined;
    subtotal: number;
    totalDiscount: number;
    totalExclTax: number;
    totaltax: number;
    totalInclTax: number;
    creditNote: number;
    serialNumber: string | undefined;
    barCode: string | undefined;
    depreciationRate: number;
    depreciationStartDate: moment.Moment;
    accumulatedImpairment: number;
    accumulatedDepreciation: number;
    previousAccumulatedDepreciation: number;
    isWriteOff: boolean;
    isDisposal: boolean;
    writeOffAndDisposalDate: moment.Moment;
    sellValue: number;
    impairmentList: WriteOffNoteItem[] | undefined;
    remarksList: WriteOffNoteCategory[] | undefined;
    internalTag: string | undefined;
    residualValue: number;
    netBookValue: number;
    profitAndLoss: number;
    location: string | undefined;
    migratedAccumulatedDepreciation: number;
    migratedAccumulatedImpairment: number;
    migratedAccumulatedIncome: number;
    migratedDate: moment.Moment;
    migratedRequesterId: number;
    migratedRequesterName: string | undefined;
    migratedRequesterRemarks: string | undefined;
    migratedApproverId: number;
    migratedApproverName: string | undefined;
    migratedApproverRemarks: string | undefined;
    migratedApprovalStatus: number;
    migratedApprovalDate: moment.Moment;
    supplierInvoiceUrl: string | undefined;
    purchasedDate: moment.Moment;
    depreciationMode: number;
    depreciationToDate: number;
    impairmentToDate: number;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    categoryCode2: string | undefined;
    categoryName2: string | undefined;
    dateAcquired: moment.Moment | undefined;
    description: string | undefined;
    typeOfInvestment: string | undefined;
    certificate: string | undefined;
    rateOfReturn: number | undefined;
    incomeReceived: number | undefined;
    accruedIncomeReceived: number | undefined;
    readonly totalIncomeReceived: number;
    dateOfIncomeReceived: moment.Moment | undefined;
    companyName: string | undefined;
    companyRegNo: string | undefined;
    companyType: string | undefined;
    numberOfSharePurchased: number | undefined;
    percentageOfHolding: number | undefined;
    shareCertificateNo: string | undefined;
    dividendsReceived: number | undefined;
    dateOfDividentReceived: moment.Moment | undefined;
    maturityDate: moment.Moment | undefined;
    readonly tenure: number | undefined;
    investee: string | undefined;
    vendorInvoiceId: number | undefined;
    writeOffNoteId: number | undefined;
    cashbookId: number | undefined;
    writeOffNote: WriteOffNote;
    vendorInvoice: VendorInvoice;
    postMigration: boolean;
    vendorInvoiceItem: VendorInvoiceItem;

    constructor(data?: INonCurrentAssetItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.unitPrice = _data["unitPrice"];
            this.installationCost = _data["installationCost"];
            this.thirdPartyInstallationCost = _data["thirdPartyInstallationCost"];
            (<any>this).totalInstallationCost = _data["totalInstallationCost"];
            this.deliveryCost = _data["deliveryCost"];
            this.totalOriginalCost = _data["totalOriginalCost"];
            this.discount = _data["discount"];
            this.tax = _data["tax"];
            this.nonCurrentAssetId = _data["nonCurrentAssetId"];
            this.nonCurrentAsset = _data["nonCurrentAsset"] ? NonCurrentAsset.fromJS(_data["nonCurrentAsset"]) : <any>undefined;
            this.nonCurrentAssetDto = _data["nonCurrentAssetDto"] ? NonCurrentAssetDto.fromJS(_data["nonCurrentAssetDto"]) : <any>undefined;
            this.taxCode = _data["taxCode"];
            this.subtotal = _data["subtotal"];
            this.totalDiscount = _data["totalDiscount"];
            this.totalExclTax = _data["totalExclTax"];
            this.totaltax = _data["totaltax"];
            this.totalInclTax = _data["totalInclTax"];
            this.creditNote = _data["creditNote"];
            this.serialNumber = _data["serialNumber"];
            this.barCode = _data["barCode"];
            this.depreciationRate = _data["depreciationRate"];
            this.depreciationStartDate = _data["depreciationStartDate"] ? moment(_data["depreciationStartDate"].toString()) : <any>undefined;
            this.accumulatedImpairment = _data["accumulatedImpairment"];
            this.accumulatedDepreciation = _data["accumulatedDepreciation"];
            this.previousAccumulatedDepreciation = _data["previousAccumulatedDepreciation"];
            this.isWriteOff = _data["isWriteOff"];
            this.isDisposal = _data["isDisposal"];
            this.writeOffAndDisposalDate = _data["writeOffAndDisposalDate"] ? moment(_data["writeOffAndDisposalDate"].toString()) : <any>undefined;
            this.sellValue = _data["sellValue"];
            if (Array.isArray(_data["impairmentList"])) {
                this.impairmentList = [] as any;
                for (let item of _data["impairmentList"])
                    this.impairmentList.push(WriteOffNoteItem.fromJS(item));
            }
            if (Array.isArray(_data["remarksList"])) {
                this.remarksList = [] as any;
                for (let item of _data["remarksList"])
                    this.remarksList.push(WriteOffNoteCategory.fromJS(item));
            }
            this.internalTag = _data["internalTag"];
            this.residualValue = _data["residualValue"];
            this.netBookValue = _data["netBookValue"];
            this.profitAndLoss = _data["profitAndLoss"];
            this.location = _data["location"];
            this.migratedAccumulatedDepreciation = _data["migratedAccumulatedDepreciation"];
            this.migratedAccumulatedImpairment = _data["migratedAccumulatedImpairment"];
            this.migratedAccumulatedIncome = _data["migratedAccumulatedIncome"];
            this.migratedDate = _data["migratedDate"] ? moment(_data["migratedDate"].toString()) : <any>undefined;
            this.migratedRequesterId = _data["migratedRequesterId"];
            this.migratedRequesterName = _data["migratedRequesterName"];
            this.migratedRequesterRemarks = _data["migratedRequesterRemarks"];
            this.migratedApproverId = _data["migratedApproverId"];
            this.migratedApproverName = _data["migratedApproverName"];
            this.migratedApproverRemarks = _data["migratedApproverRemarks"];
            this.migratedApprovalStatus = _data["migratedApprovalStatus"];
            this.migratedApprovalDate = _data["migratedApprovalDate"] ? moment(_data["migratedApprovalDate"].toString()) : <any>undefined;
            this.supplierInvoiceUrl = _data["supplierInvoiceUrl"];
            this.purchasedDate = _data["purchasedDate"] ? moment(_data["purchasedDate"].toString()) : <any>undefined;
            this.depreciationMode = _data["depreciationMode"];
            this.depreciationToDate = _data["depreciationToDate"];
            this.impairmentToDate = _data["impairmentToDate"];
            this.categoryCode = _data["categoryCode"];
            this.categoryName = _data["categoryName"];
            this.categoryCode2 = _data["categoryCode2"];
            this.categoryName2 = _data["categoryName2"];
            this.dateAcquired = _data["dateAcquired"] ? moment(_data["dateAcquired"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.typeOfInvestment = _data["typeOfInvestment"];
            this.certificate = _data["certificate"];
            this.rateOfReturn = _data["rateOfReturn"];
            this.incomeReceived = _data["incomeReceived"];
            this.accruedIncomeReceived = _data["accruedIncomeReceived"];
            (<any>this).totalIncomeReceived = _data["totalIncomeReceived"];
            this.dateOfIncomeReceived = _data["dateOfIncomeReceived"] ? moment(_data["dateOfIncomeReceived"].toString()) : <any>undefined;
            this.companyName = _data["companyName"];
            this.companyRegNo = _data["companyRegNo"];
            this.companyType = _data["companyType"];
            this.numberOfSharePurchased = _data["numberOfSharePurchased"];
            this.percentageOfHolding = _data["percentageOfHolding"];
            this.shareCertificateNo = _data["shareCertificateNo"];
            this.dividendsReceived = _data["dividendsReceived"];
            this.dateOfDividentReceived = _data["dateOfDividentReceived"] ? moment(_data["dateOfDividentReceived"].toString()) : <any>undefined;
            this.maturityDate = _data["maturityDate"] ? moment(_data["maturityDate"].toString()) : <any>undefined;
            (<any>this).tenure = _data["tenure"];
            this.investee = _data["investee"];
            this.vendorInvoiceId = _data["vendorInvoiceId"];
            this.writeOffNoteId = _data["writeOffNoteId"];
            this.cashbookId = _data["cashbookId"];
            this.writeOffNote = _data["writeOffNote"] ? WriteOffNote.fromJS(_data["writeOffNote"]) : <any>undefined;
            this.vendorInvoice = _data["vendorInvoice"] ? VendorInvoice.fromJS(_data["vendorInvoice"]) : <any>undefined;
            this.postMigration = _data["postMigration"];
            this.vendorInvoiceItem = _data["vendorInvoiceItem"] ? VendorInvoiceItem.fromJS(_data["vendorInvoiceItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NonCurrentAssetItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new NonCurrentAssetItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["unitPrice"] = this.unitPrice;
        data["installationCost"] = this.installationCost;
        data["thirdPartyInstallationCost"] = this.thirdPartyInstallationCost;
        data["totalInstallationCost"] = this.totalInstallationCost;
        data["deliveryCost"] = this.deliveryCost;
        data["totalOriginalCost"] = this.totalOriginalCost;
        data["discount"] = this.discount;
        data["tax"] = this.tax;
        data["nonCurrentAssetId"] = this.nonCurrentAssetId;
        data["nonCurrentAsset"] = this.nonCurrentAsset ? this.nonCurrentAsset.toJSON() : <any>undefined;
        data["nonCurrentAssetDto"] = this.nonCurrentAssetDto ? this.nonCurrentAssetDto.toJSON() : <any>undefined;
        data["taxCode"] = this.taxCode;
        data["subtotal"] = this.subtotal;
        data["totalDiscount"] = this.totalDiscount;
        data["totalExclTax"] = this.totalExclTax;
        data["totaltax"] = this.totaltax;
        data["totalInclTax"] = this.totalInclTax;
        data["creditNote"] = this.creditNote;
        data["serialNumber"] = this.serialNumber;
        data["barCode"] = this.barCode;
        data["depreciationRate"] = this.depreciationRate;
        data["depreciationStartDate"] = this.depreciationStartDate ? this.depreciationStartDate.toISOString() : <any>undefined;
        data["accumulatedImpairment"] = this.accumulatedImpairment;
        data["accumulatedDepreciation"] = this.accumulatedDepreciation;
        data["previousAccumulatedDepreciation"] = this.previousAccumulatedDepreciation;
        data["isWriteOff"] = this.isWriteOff;
        data["isDisposal"] = this.isDisposal;
        data["writeOffAndDisposalDate"] = this.writeOffAndDisposalDate ? this.writeOffAndDisposalDate.toISOString() : <any>undefined;
        data["sellValue"] = this.sellValue;
        if (Array.isArray(this.impairmentList)) {
            data["impairmentList"] = [];
            for (let item of this.impairmentList)
                data["impairmentList"].push(item.toJSON());
        }
        if (Array.isArray(this.remarksList)) {
            data["remarksList"] = [];
            for (let item of this.remarksList)
                data["remarksList"].push(item.toJSON());
        }
        data["internalTag"] = this.internalTag;
        data["residualValue"] = this.residualValue;
        data["netBookValue"] = this.netBookValue;
        data["profitAndLoss"] = this.profitAndLoss;
        data["location"] = this.location;
        data["migratedAccumulatedDepreciation"] = this.migratedAccumulatedDepreciation;
        data["migratedAccumulatedImpairment"] = this.migratedAccumulatedImpairment;
        data["migratedAccumulatedIncome"] = this.migratedAccumulatedIncome;
        data["migratedDate"] = this.migratedDate ? this.migratedDate.toISOString() : <any>undefined;
        data["migratedRequesterId"] = this.migratedRequesterId;
        data["migratedRequesterName"] = this.migratedRequesterName;
        data["migratedRequesterRemarks"] = this.migratedRequesterRemarks;
        data["migratedApproverId"] = this.migratedApproverId;
        data["migratedApproverName"] = this.migratedApproverName;
        data["migratedApproverRemarks"] = this.migratedApproverRemarks;
        data["migratedApprovalStatus"] = this.migratedApprovalStatus;
        data["migratedApprovalDate"] = this.migratedApprovalDate ? this.migratedApprovalDate.toISOString() : <any>undefined;
        data["supplierInvoiceUrl"] = this.supplierInvoiceUrl;
        data["purchasedDate"] = this.purchasedDate ? this.purchasedDate.toISOString() : <any>undefined;
        data["depreciationMode"] = this.depreciationMode;
        data["depreciationToDate"] = this.depreciationToDate;
        data["impairmentToDate"] = this.impairmentToDate;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["categoryCode2"] = this.categoryCode2;
        data["categoryName2"] = this.categoryName2;
        data["dateAcquired"] = this.dateAcquired ? this.dateAcquired.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["typeOfInvestment"] = this.typeOfInvestment;
        data["certificate"] = this.certificate;
        data["rateOfReturn"] = this.rateOfReturn;
        data["incomeReceived"] = this.incomeReceived;
        data["accruedIncomeReceived"] = this.accruedIncomeReceived;
        data["totalIncomeReceived"] = this.totalIncomeReceived;
        data["dateOfIncomeReceived"] = this.dateOfIncomeReceived ? this.dateOfIncomeReceived.toISOString() : <any>undefined;
        data["companyName"] = this.companyName;
        data["companyRegNo"] = this.companyRegNo;
        data["companyType"] = this.companyType;
        data["numberOfSharePurchased"] = this.numberOfSharePurchased;
        data["percentageOfHolding"] = this.percentageOfHolding;
        data["shareCertificateNo"] = this.shareCertificateNo;
        data["dividendsReceived"] = this.dividendsReceived;
        data["dateOfDividentReceived"] = this.dateOfDividentReceived ? this.dateOfDividentReceived.toISOString() : <any>undefined;
        data["maturityDate"] = this.maturityDate ? this.maturityDate.toISOString() : <any>undefined;
        data["tenure"] = this.tenure;
        data["investee"] = this.investee;
        data["vendorInvoiceId"] = this.vendorInvoiceId;
        data["writeOffNoteId"] = this.writeOffNoteId;
        data["cashbookId"] = this.cashbookId;
        data["writeOffNote"] = this.writeOffNote ? this.writeOffNote.toJSON() : <any>undefined;
        data["vendorInvoice"] = this.vendorInvoice ? this.vendorInvoice.toJSON() : <any>undefined;
        data["postMigration"] = this.postMigration;
        data["vendorInvoiceItem"] = this.vendorInvoiceItem ? this.vendorInvoiceItem.toJSON() : <any>undefined;
        return data;
    }

    clone(): NonCurrentAssetItemDto {
        const json = this.toJSON();
        let result = new NonCurrentAssetItemDto();
        result.init(json);
        return result;
    }
}

export interface INonCurrentAssetItemDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    unitPrice: number;
    installationCost: number;
    thirdPartyInstallationCost: number;
    totalInstallationCost: number;
    deliveryCost: number;
    totalOriginalCost: number;
    discount: number;
    tax: number;
    nonCurrentAssetId: string;
    nonCurrentAsset: NonCurrentAsset;
    nonCurrentAssetDto: NonCurrentAssetDto;
    taxCode: string | undefined;
    subtotal: number;
    totalDiscount: number;
    totalExclTax: number;
    totaltax: number;
    totalInclTax: number;
    creditNote: number;
    serialNumber: string | undefined;
    barCode: string | undefined;
    depreciationRate: number;
    depreciationStartDate: moment.Moment;
    accumulatedImpairment: number;
    accumulatedDepreciation: number;
    previousAccumulatedDepreciation: number;
    isWriteOff: boolean;
    isDisposal: boolean;
    writeOffAndDisposalDate: moment.Moment;
    sellValue: number;
    impairmentList: WriteOffNoteItem[] | undefined;
    remarksList: WriteOffNoteCategory[] | undefined;
    internalTag: string | undefined;
    residualValue: number;
    netBookValue: number;
    profitAndLoss: number;
    location: string | undefined;
    migratedAccumulatedDepreciation: number;
    migratedAccumulatedImpairment: number;
    migratedAccumulatedIncome: number;
    migratedDate: moment.Moment;
    migratedRequesterId: number;
    migratedRequesterName: string | undefined;
    migratedRequesterRemarks: string | undefined;
    migratedApproverId: number;
    migratedApproverName: string | undefined;
    migratedApproverRemarks: string | undefined;
    migratedApprovalStatus: number;
    migratedApprovalDate: moment.Moment;
    supplierInvoiceUrl: string | undefined;
    purchasedDate: moment.Moment;
    depreciationMode: number;
    depreciationToDate: number;
    impairmentToDate: number;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    categoryCode2: string | undefined;
    categoryName2: string | undefined;
    dateAcquired: moment.Moment | undefined;
    description: string | undefined;
    typeOfInvestment: string | undefined;
    certificate: string | undefined;
    rateOfReturn: number | undefined;
    incomeReceived: number | undefined;
    accruedIncomeReceived: number | undefined;
    totalIncomeReceived: number;
    dateOfIncomeReceived: moment.Moment | undefined;
    companyName: string | undefined;
    companyRegNo: string | undefined;
    companyType: string | undefined;
    numberOfSharePurchased: number | undefined;
    percentageOfHolding: number | undefined;
    shareCertificateNo: string | undefined;
    dividendsReceived: number | undefined;
    dateOfDividentReceived: moment.Moment | undefined;
    maturityDate: moment.Moment | undefined;
    tenure: number | undefined;
    investee: string | undefined;
    vendorInvoiceId: number | undefined;
    writeOffNoteId: number | undefined;
    cashbookId: number | undefined;
    writeOffNote: WriteOffNote;
    vendorInvoice: VendorInvoice;
    postMigration: boolean;
    vendorInvoiceItem: VendorInvoiceItem;
}

export class NonCurrentAssetItemDtoListResultDto implements INonCurrentAssetItemDtoListResultDto {
    items: NonCurrentAssetItemDto[] | undefined;

    constructor(data?: INonCurrentAssetItemDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(NonCurrentAssetItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NonCurrentAssetItemDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NonCurrentAssetItemDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): NonCurrentAssetItemDtoListResultDto {
        const json = this.toJSON();
        let result = new NonCurrentAssetItemDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface INonCurrentAssetItemDtoListResultDto {
    items: NonCurrentAssetItemDto[] | undefined;
}

export class NonCurrentAssetItemDtoPagedResultDto implements INonCurrentAssetItemDtoPagedResultDto {
    items: NonCurrentAssetItemDto[] | undefined;
    totalCount: number;

    constructor(data?: INonCurrentAssetItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(NonCurrentAssetItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): NonCurrentAssetItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NonCurrentAssetItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): NonCurrentAssetItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new NonCurrentAssetItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface INonCurrentAssetItemDtoPagedResultDto {
    items: NonCurrentAssetItemDto[] | undefined;
    totalCount: number;
}

export class NonCurrentAssetItemImpairmentDto implements INonCurrentAssetItemImpairmentDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    nonCurrentAssetItemId: string;
    nonCurrentAssetItem: NonCurrentAssetItem;
    impairmentValue: number;

    constructor(data?: INonCurrentAssetItemImpairmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.nonCurrentAssetItemId = _data["nonCurrentAssetItemId"];
            this.nonCurrentAssetItem = _data["nonCurrentAssetItem"] ? NonCurrentAssetItem.fromJS(_data["nonCurrentAssetItem"]) : <any>undefined;
            this.impairmentValue = _data["impairmentValue"];
        }
    }

    static fromJS(data: any): NonCurrentAssetItemImpairmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new NonCurrentAssetItemImpairmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["nonCurrentAssetItemId"] = this.nonCurrentAssetItemId;
        data["nonCurrentAssetItem"] = this.nonCurrentAssetItem ? this.nonCurrentAssetItem.toJSON() : <any>undefined;
        data["impairmentValue"] = this.impairmentValue;
        return data;
    }

    clone(): NonCurrentAssetItemImpairmentDto {
        const json = this.toJSON();
        let result = new NonCurrentAssetItemImpairmentDto();
        result.init(json);
        return result;
    }
}

export interface INonCurrentAssetItemImpairmentDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    nonCurrentAssetItemId: string;
    nonCurrentAssetItem: NonCurrentAssetItem;
    impairmentValue: number;
}

export class NonCurrentAssetItemImpairmentDtoPagedResultDto implements INonCurrentAssetItemImpairmentDtoPagedResultDto {
    items: NonCurrentAssetItemImpairmentDto[] | undefined;
    totalCount: number;

    constructor(data?: INonCurrentAssetItemImpairmentDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(NonCurrentAssetItemImpairmentDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): NonCurrentAssetItemImpairmentDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NonCurrentAssetItemImpairmentDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): NonCurrentAssetItemImpairmentDtoPagedResultDto {
        const json = this.toJSON();
        let result = new NonCurrentAssetItemImpairmentDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface INonCurrentAssetItemImpairmentDtoPagedResultDto {
    items: NonCurrentAssetItemImpairmentDto[] | undefined;
    totalCount: number;
}

export class NonCurrentAssetMaintenance implements INonCurrentAssetMaintenance {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    nonCurrentAssetItemId: string;
    nonCurrentAssetItem: NonCurrentAssetItem;
    dateOfRepair: moment.Moment;
    natureOfRepair: string | undefined;
    scheduledDate: moment.Moment;
    operationHours: number;

    constructor(data?: INonCurrentAssetMaintenance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.nonCurrentAssetItemId = _data["nonCurrentAssetItemId"];
            this.nonCurrentAssetItem = _data["nonCurrentAssetItem"] ? NonCurrentAssetItem.fromJS(_data["nonCurrentAssetItem"]) : <any>undefined;
            this.dateOfRepair = _data["dateOfRepair"] ? moment(_data["dateOfRepair"].toString()) : <any>undefined;
            this.natureOfRepair = _data["natureOfRepair"];
            this.scheduledDate = _data["scheduledDate"] ? moment(_data["scheduledDate"].toString()) : <any>undefined;
            this.operationHours = _data["operationHours"];
        }
    }

    static fromJS(data: any): NonCurrentAssetMaintenance {
        data = typeof data === 'object' ? data : {};
        let result = new NonCurrentAssetMaintenance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["nonCurrentAssetItemId"] = this.nonCurrentAssetItemId;
        data["nonCurrentAssetItem"] = this.nonCurrentAssetItem ? this.nonCurrentAssetItem.toJSON() : <any>undefined;
        data["dateOfRepair"] = this.dateOfRepair ? this.dateOfRepair.toISOString() : <any>undefined;
        data["natureOfRepair"] = this.natureOfRepair;
        data["scheduledDate"] = this.scheduledDate ? this.scheduledDate.toISOString() : <any>undefined;
        data["operationHours"] = this.operationHours;
        return data;
    }

    clone(): NonCurrentAssetMaintenance {
        const json = this.toJSON();
        let result = new NonCurrentAssetMaintenance();
        result.init(json);
        return result;
    }
}

export interface INonCurrentAssetMaintenance {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    nonCurrentAssetItemId: string;
    nonCurrentAssetItem: NonCurrentAssetItem;
    dateOfRepair: moment.Moment;
    natureOfRepair: string | undefined;
    scheduledDate: moment.Moment;
    operationHours: number;
}

export class NonCurrentAssetMaintenanceDto implements INonCurrentAssetMaintenanceDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    nonCurrentAssetItemId: string;
    nonCurrentAssetItem: NonCurrentAssetItem;
    dateOfRepair: moment.Moment;
    natureOfRepair: string | undefined;
    amount: number;
    amountToBePaid: number;
    scheduledDate: moment.Moment;
    operationHours: number;
    vendorInvoiceItems: VendorInvoiceItem[] | undefined;

    constructor(data?: INonCurrentAssetMaintenanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.nonCurrentAssetItemId = _data["nonCurrentAssetItemId"];
            this.nonCurrentAssetItem = _data["nonCurrentAssetItem"] ? NonCurrentAssetItem.fromJS(_data["nonCurrentAssetItem"]) : <any>undefined;
            this.dateOfRepair = _data["dateOfRepair"] ? moment(_data["dateOfRepair"].toString()) : <any>undefined;
            this.natureOfRepair = _data["natureOfRepair"];
            this.amount = _data["amount"];
            this.amountToBePaid = _data["amountToBePaid"];
            this.scheduledDate = _data["scheduledDate"] ? moment(_data["scheduledDate"].toString()) : <any>undefined;
            this.operationHours = _data["operationHours"];
            if (Array.isArray(_data["vendorInvoiceItems"])) {
                this.vendorInvoiceItems = [] as any;
                for (let item of _data["vendorInvoiceItems"])
                    this.vendorInvoiceItems.push(VendorInvoiceItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NonCurrentAssetMaintenanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new NonCurrentAssetMaintenanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["nonCurrentAssetItemId"] = this.nonCurrentAssetItemId;
        data["nonCurrentAssetItem"] = this.nonCurrentAssetItem ? this.nonCurrentAssetItem.toJSON() : <any>undefined;
        data["dateOfRepair"] = this.dateOfRepair ? this.dateOfRepair.toISOString() : <any>undefined;
        data["natureOfRepair"] = this.natureOfRepair;
        data["amount"] = this.amount;
        data["amountToBePaid"] = this.amountToBePaid;
        data["scheduledDate"] = this.scheduledDate ? this.scheduledDate.toISOString() : <any>undefined;
        data["operationHours"] = this.operationHours;
        if (Array.isArray(this.vendorInvoiceItems)) {
            data["vendorInvoiceItems"] = [];
            for (let item of this.vendorInvoiceItems)
                data["vendorInvoiceItems"].push(item.toJSON());
        }
        return data;
    }

    clone(): NonCurrentAssetMaintenanceDto {
        const json = this.toJSON();
        let result = new NonCurrentAssetMaintenanceDto();
        result.init(json);
        return result;
    }
}

export interface INonCurrentAssetMaintenanceDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    nonCurrentAssetItemId: string;
    nonCurrentAssetItem: NonCurrentAssetItem;
    dateOfRepair: moment.Moment;
    natureOfRepair: string | undefined;
    amount: number;
    amountToBePaid: number;
    scheduledDate: moment.Moment;
    operationHours: number;
    vendorInvoiceItems: VendorInvoiceItem[] | undefined;
}

export class NonCurrentAssetMaintenanceDtoPagedResultDto implements INonCurrentAssetMaintenanceDtoPagedResultDto {
    items: NonCurrentAssetMaintenanceDto[] | undefined;
    totalCount: number;

    constructor(data?: INonCurrentAssetMaintenanceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(NonCurrentAssetMaintenanceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): NonCurrentAssetMaintenanceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NonCurrentAssetMaintenanceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): NonCurrentAssetMaintenanceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new NonCurrentAssetMaintenanceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface INonCurrentAssetMaintenanceDtoPagedResultDto {
    items: NonCurrentAssetMaintenanceDto[] | undefined;
    totalCount: number;
}

export class NonCurrentAssetMigrationDto implements INonCurrentAssetMigrationDto {
    depreciationStartDate: moment.Moment;
    purchasedDate: moment.Moment;
    migratedDate: moment.Moment;
    assetName: string | undefined;
    assetCode: string | undefined;
    unitOfMeasurement: string | undefined;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    categoryCode2: string | undefined;
    categoryName2: string | undefined;
    serialNumberOrBarcodeOrTag: string | undefined;
    location: string | undefined;
    depreciationRate: number;
    accumulatedDepreciation: number;
    originalCost: number;
    installationCost: number;
    deliveryCost: number;
    residualValue: number;
    isValid: boolean;
    error: string | undefined;
    nonCurrentAssetId: string | undefined;
    nonCurrentAsset: NonCurrentAsset;
    postMigration: boolean;
    dateAcquired: moment.Moment | undefined;
    description: string | undefined;
    typeOfInvestment: string | undefined;
    certificate: string | undefined;
    rateOfReturn: number | undefined;
    incomeReceived: number | undefined;
    dateOfIncomeReceived: moment.Moment | undefined;
    companyName: string | undefined;
    companyRegNo: string | undefined;
    companyType: string | undefined;
    numberOfSharePurchased: number | undefined;
    percentageOfHolding: number | undefined;
    shareCertificateNo: string | undefined;
    dividendsReceived: number | undefined;
    dateOfDividentReceived: moment.Moment | undefined;
    tenure: number | undefined;
    investee: string | undefined;
    sellValue: number;
    migratedAccumulatedImpairment: number;
    migratedAccumulatedIncome: number;

    constructor(data?: INonCurrentAssetMigrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.depreciationStartDate = _data["depreciationStartDate"] ? moment(_data["depreciationStartDate"].toString()) : <any>undefined;
            this.purchasedDate = _data["purchasedDate"] ? moment(_data["purchasedDate"].toString()) : <any>undefined;
            this.migratedDate = _data["migratedDate"] ? moment(_data["migratedDate"].toString()) : <any>undefined;
            this.assetName = _data["assetName"];
            this.assetCode = _data["assetCode"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.categoryCode = _data["categoryCode"];
            this.categoryName = _data["categoryName"];
            this.categoryCode2 = _data["categoryCode2"];
            this.categoryName2 = _data["categoryName2"];
            this.serialNumberOrBarcodeOrTag = _data["serialNumberOrBarcodeOrTag"];
            this.location = _data["location"];
            this.depreciationRate = _data["depreciationRate"];
            this.accumulatedDepreciation = _data["accumulatedDepreciation"];
            this.originalCost = _data["originalCost"];
            this.installationCost = _data["installationCost"];
            this.deliveryCost = _data["deliveryCost"];
            this.residualValue = _data["residualValue"];
            this.isValid = _data["isValid"];
            this.error = _data["error"];
            this.nonCurrentAssetId = _data["nonCurrentAssetId"];
            this.nonCurrentAsset = _data["nonCurrentAsset"] ? NonCurrentAsset.fromJS(_data["nonCurrentAsset"]) : <any>undefined;
            this.postMigration = _data["postMigration"];
            this.dateAcquired = _data["dateAcquired"] ? moment(_data["dateAcquired"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.typeOfInvestment = _data["typeOfInvestment"];
            this.certificate = _data["certificate"];
            this.rateOfReturn = _data["rateOfReturn"];
            this.incomeReceived = _data["incomeReceived"];
            this.dateOfIncomeReceived = _data["dateOfIncomeReceived"] ? moment(_data["dateOfIncomeReceived"].toString()) : <any>undefined;
            this.companyName = _data["companyName"];
            this.companyRegNo = _data["companyRegNo"];
            this.companyType = _data["companyType"];
            this.numberOfSharePurchased = _data["numberOfSharePurchased"];
            this.percentageOfHolding = _data["percentageOfHolding"];
            this.shareCertificateNo = _data["shareCertificateNo"];
            this.dividendsReceived = _data["dividendsReceived"];
            this.dateOfDividentReceived = _data["dateOfDividentReceived"] ? moment(_data["dateOfDividentReceived"].toString()) : <any>undefined;
            this.tenure = _data["tenure"];
            this.investee = _data["investee"];
            this.sellValue = _data["sellValue"];
            this.migratedAccumulatedImpairment = _data["migratedAccumulatedImpairment"];
            this.migratedAccumulatedIncome = _data["migratedAccumulatedIncome"];
        }
    }

    static fromJS(data: any): NonCurrentAssetMigrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NonCurrentAssetMigrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["depreciationStartDate"] = this.depreciationStartDate ? this.depreciationStartDate.toISOString() : <any>undefined;
        data["purchasedDate"] = this.purchasedDate ? this.purchasedDate.toISOString() : <any>undefined;
        data["migratedDate"] = this.migratedDate ? this.migratedDate.toISOString() : <any>undefined;
        data["assetName"] = this.assetName;
        data["assetCode"] = this.assetCode;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["categoryCode2"] = this.categoryCode2;
        data["categoryName2"] = this.categoryName2;
        data["serialNumberOrBarcodeOrTag"] = this.serialNumberOrBarcodeOrTag;
        data["location"] = this.location;
        data["depreciationRate"] = this.depreciationRate;
        data["accumulatedDepreciation"] = this.accumulatedDepreciation;
        data["originalCost"] = this.originalCost;
        data["installationCost"] = this.installationCost;
        data["deliveryCost"] = this.deliveryCost;
        data["residualValue"] = this.residualValue;
        data["isValid"] = this.isValid;
        data["error"] = this.error;
        data["nonCurrentAssetId"] = this.nonCurrentAssetId;
        data["nonCurrentAsset"] = this.nonCurrentAsset ? this.nonCurrentAsset.toJSON() : <any>undefined;
        data["postMigration"] = this.postMigration;
        data["dateAcquired"] = this.dateAcquired ? this.dateAcquired.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["typeOfInvestment"] = this.typeOfInvestment;
        data["certificate"] = this.certificate;
        data["rateOfReturn"] = this.rateOfReturn;
        data["incomeReceived"] = this.incomeReceived;
        data["dateOfIncomeReceived"] = this.dateOfIncomeReceived ? this.dateOfIncomeReceived.toISOString() : <any>undefined;
        data["companyName"] = this.companyName;
        data["companyRegNo"] = this.companyRegNo;
        data["companyType"] = this.companyType;
        data["numberOfSharePurchased"] = this.numberOfSharePurchased;
        data["percentageOfHolding"] = this.percentageOfHolding;
        data["shareCertificateNo"] = this.shareCertificateNo;
        data["dividendsReceived"] = this.dividendsReceived;
        data["dateOfDividentReceived"] = this.dateOfDividentReceived ? this.dateOfDividentReceived.toISOString() : <any>undefined;
        data["tenure"] = this.tenure;
        data["investee"] = this.investee;
        data["sellValue"] = this.sellValue;
        data["migratedAccumulatedImpairment"] = this.migratedAccumulatedImpairment;
        data["migratedAccumulatedIncome"] = this.migratedAccumulatedIncome;
        return data;
    }

    clone(): NonCurrentAssetMigrationDto {
        const json = this.toJSON();
        let result = new NonCurrentAssetMigrationDto();
        result.init(json);
        return result;
    }
}

export interface INonCurrentAssetMigrationDto {
    depreciationStartDate: moment.Moment;
    purchasedDate: moment.Moment;
    migratedDate: moment.Moment;
    assetName: string | undefined;
    assetCode: string | undefined;
    unitOfMeasurement: string | undefined;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    categoryCode2: string | undefined;
    categoryName2: string | undefined;
    serialNumberOrBarcodeOrTag: string | undefined;
    location: string | undefined;
    depreciationRate: number;
    accumulatedDepreciation: number;
    originalCost: number;
    installationCost: number;
    deliveryCost: number;
    residualValue: number;
    isValid: boolean;
    error: string | undefined;
    nonCurrentAssetId: string | undefined;
    nonCurrentAsset: NonCurrentAsset;
    postMigration: boolean;
    dateAcquired: moment.Moment | undefined;
    description: string | undefined;
    typeOfInvestment: string | undefined;
    certificate: string | undefined;
    rateOfReturn: number | undefined;
    incomeReceived: number | undefined;
    dateOfIncomeReceived: moment.Moment | undefined;
    companyName: string | undefined;
    companyRegNo: string | undefined;
    companyType: string | undefined;
    numberOfSharePurchased: number | undefined;
    percentageOfHolding: number | undefined;
    shareCertificateNo: string | undefined;
    dividendsReceived: number | undefined;
    dateOfDividentReceived: moment.Moment | undefined;
    tenure: number | undefined;
    investee: string | undefined;
    sellValue: number;
    migratedAccumulatedImpairment: number;
    migratedAccumulatedIncome: number;
}

export class NoticeModel implements INoticeModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    subject: string;
    message: string;
    tenantId: number;
    status: string | undefined;
    creatorUser: User;

    constructor(data?: INoticeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.subject = _data["subject"];
            this.message = _data["message"];
            this.tenantId = _data["tenantId"];
            this.status = _data["status"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NoticeModel {
        data = typeof data === 'object' ? data : {};
        let result = new NoticeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["subject"] = this.subject;
        data["message"] = this.message;
        data["tenantId"] = this.tenantId;
        data["status"] = this.status;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        return data;
    }

    clone(): NoticeModel {
        const json = this.toJSON();
        let result = new NoticeModel();
        result.init(json);
        return result;
    }
}

export interface INoticeModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    subject: string;
    message: string;
    tenantId: number;
    status: string | undefined;
    creatorUser: User;
}

export class NoticeModelDto implements INoticeModelDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    subject: string | undefined;
    message: string | undefined;
    tenantId: number;
    status: string | undefined;
    creatorUser: UserDto;

    constructor(data?: INoticeModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.subject = _data["subject"];
            this.message = _data["message"];
            this.tenantId = _data["tenantId"];
            this.status = _data["status"];
            this.creatorUser = _data["creatorUser"] ? UserDto.fromJS(_data["creatorUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NoticeModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoticeModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["subject"] = this.subject;
        data["message"] = this.message;
        data["tenantId"] = this.tenantId;
        data["status"] = this.status;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        return data;
    }

    clone(): NoticeModelDto {
        const json = this.toJSON();
        let result = new NoticeModelDto();
        result.init(json);
        return result;
    }
}

export interface INoticeModelDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    subject: string | undefined;
    message: string | undefined;
    tenantId: number;
    status: string | undefined;
    creatorUser: UserDto;
}

export class NoticeModelDtoPagedResultDto implements INoticeModelDtoPagedResultDto {
    items: NoticeModelDto[] | undefined;
    totalCount: number;

    constructor(data?: INoticeModelDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(NoticeModelDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): NoticeModelDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoticeModelDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): NoticeModelDtoPagedResultDto {
        const json = this.toJSON();
        let result = new NoticeModelDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface INoticeModelDtoPagedResultDto {
    items: NoticeModelDto[] | undefined;
    totalCount: number;
}

export class OrderItems implements IOrderItems {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    orderId: string;
    orderIdReference: string | undefined;
    quantity: number;
    userId: number;
    merchantTenantId: number;
    price: number;
    productId: string;
    product: Product;
    productShelfId: number | undefined;
    productShelf: InventoryProductOnShelf;

    constructor(data?: IOrderItems) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.orderId = _data["orderId"];
            this.orderIdReference = _data["orderIdReference"];
            this.quantity = _data["quantity"];
            this.userId = _data["userId"];
            this.merchantTenantId = _data["merchantTenantId"];
            this.price = _data["price"];
            this.productId = _data["productId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.productShelfId = _data["productShelfId"];
            this.productShelf = _data["productShelf"] ? InventoryProductOnShelf.fromJS(_data["productShelf"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderItems {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItems();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["orderId"] = this.orderId;
        data["orderIdReference"] = this.orderIdReference;
        data["quantity"] = this.quantity;
        data["userId"] = this.userId;
        data["merchantTenantId"] = this.merchantTenantId;
        data["price"] = this.price;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productShelfId"] = this.productShelfId;
        data["productShelf"] = this.productShelf ? this.productShelf.toJSON() : <any>undefined;
        return data;
    }

    clone(): OrderItems {
        const json = this.toJSON();
        let result = new OrderItems();
        result.init(json);
        return result;
    }
}

export interface IOrderItems {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    orderId: string;
    orderIdReference: string | undefined;
    quantity: number;
    userId: number;
    merchantTenantId: number;
    price: number;
    productId: string;
    product: Product;
    productShelfId: number | undefined;
    productShelf: InventoryProductOnShelf;
}

export class OrderItemsDto implements IOrderItemsDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    orderId: string;
    orderIdReference: string | undefined;
    orders: Orders;
    productId: string;
    product: Product;
    productDto: ProductDto;
    quantity: number;
    userId: number;
    merchantTenantId: number;
    price: number;
    productShelfId: number | undefined;
    productShelf: InventoryProductOnShelf;

    constructor(data?: IOrderItemsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.orderId = _data["orderId"];
            this.orderIdReference = _data["orderIdReference"];
            this.orders = _data["orders"] ? Orders.fromJS(_data["orders"]) : <any>undefined;
            this.productId = _data["productId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.productDto = _data["productDto"] ? ProductDto.fromJS(_data["productDto"]) : <any>undefined;
            this.quantity = _data["quantity"];
            this.userId = _data["userId"];
            this.merchantTenantId = _data["merchantTenantId"];
            this.price = _data["price"];
            this.productShelfId = _data["productShelfId"];
            this.productShelf = _data["productShelf"] ? InventoryProductOnShelf.fromJS(_data["productShelf"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderItemsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["orderId"] = this.orderId;
        data["orderIdReference"] = this.orderIdReference;
        data["orders"] = this.orders ? this.orders.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productDto"] = this.productDto ? this.productDto.toJSON() : <any>undefined;
        data["quantity"] = this.quantity;
        data["userId"] = this.userId;
        data["merchantTenantId"] = this.merchantTenantId;
        data["price"] = this.price;
        data["productShelfId"] = this.productShelfId;
        data["productShelf"] = this.productShelf ? this.productShelf.toJSON() : <any>undefined;
        return data;
    }

    clone(): OrderItemsDto {
        const json = this.toJSON();
        let result = new OrderItemsDto();
        result.init(json);
        return result;
    }
}

export interface IOrderItemsDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    orderId: string;
    orderIdReference: string | undefined;
    orders: Orders;
    productId: string;
    product: Product;
    productDto: ProductDto;
    quantity: number;
    userId: number;
    merchantTenantId: number;
    price: number;
    productShelfId: number | undefined;
    productShelf: InventoryProductOnShelf;
}

export class OrderItemsDtoPagedResultDto implements IOrderItemsDtoPagedResultDto {
    items: OrderItemsDto[] | undefined;
    totalCount: number;

    constructor(data?: IOrderItemsDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderItemsDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): OrderItemsDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemsDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): OrderItemsDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrderItemsDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderItemsDtoPagedResultDto {
    items: OrderItemsDto[] | undefined;
    totalCount: number;
}

export class OrderItemsPagedResultDto implements IOrderItemsPagedResultDto {
    items: OrderItems[] | undefined;
    totalCount: number;

    constructor(data?: IOrderItemsPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrderItems.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): OrderItemsPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderItemsPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): OrderItemsPagedResultDto {
        const json = this.toJSON();
        let result = new OrderItemsPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrderItemsPagedResultDto {
    items: OrderItems[] | undefined;
    totalCount: number;
}

export class Orders implements IOrders {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    orderIdReference: string | undefined;
    tenantId: number;
    deliveryId: number;
    deliveryDescription: string | undefined;
    paymnetMethodId: number;
    totalAmount: number;
    ccName: string | undefined;
    ccNumber: number;
    ccExpireMonth: number;
    ccExpireYear: number;
    ccCVV: number;
    orderStatusId: number;
    userId: number;
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    country: string | undefined;
    city: string | undefined;
    state: string | undefined;
    postcode: number;
    address: string | undefined;
    billId: string | undefined;
    courierCharges: number;
    courierName: string | undefined;
    courierId: string | undefined;
    shippedDate: moment.Moment | undefined;
    goodsReceivedDate: moment.Moment | undefined;
    deliveryTurnaroundTime: number;
    deliveryCharge: number;
    addtionalRemark: string | undefined;
    trackingNumber: string | undefined;
    billObject: Bill;
    customerId: string | undefined;
    customerObject: Customer;

    constructor(data?: IOrders) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.orderIdReference = _data["orderIdReference"];
            this.tenantId = _data["tenantId"];
            this.deliveryId = _data["deliveryId"];
            this.deliveryDescription = _data["deliveryDescription"];
            this.paymnetMethodId = _data["paymnetMethodId"];
            this.totalAmount = _data["totalAmount"];
            this.ccName = _data["ccName"];
            this.ccNumber = _data["ccNumber"];
            this.ccExpireMonth = _data["ccExpireMonth"];
            this.ccExpireYear = _data["ccExpireYear"];
            this.ccCVV = _data["ccCVV"];
            this.orderStatusId = _data["orderStatusId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postcode = _data["postcode"];
            this.address = _data["address"];
            this.billId = _data["billId"];
            this.courierCharges = _data["courierCharges"];
            this.courierName = _data["courierName"];
            this.courierId = _data["courierId"];
            this.shippedDate = _data["shippedDate"] ? moment(_data["shippedDate"].toString()) : <any>undefined;
            this.goodsReceivedDate = _data["goodsReceivedDate"] ? moment(_data["goodsReceivedDate"].toString()) : <any>undefined;
            this.deliveryTurnaroundTime = _data["deliveryTurnaroundTime"];
            this.deliveryCharge = _data["deliveryCharge"];
            this.addtionalRemark = _data["addtionalRemark"];
            this.trackingNumber = _data["trackingNumber"];
            this.billObject = _data["billObject"] ? Bill.fromJS(_data["billObject"]) : <any>undefined;
            this.customerId = _data["customerId"];
            this.customerObject = _data["customerObject"] ? Customer.fromJS(_data["customerObject"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Orders {
        data = typeof data === 'object' ? data : {};
        let result = new Orders();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["orderIdReference"] = this.orderIdReference;
        data["tenantId"] = this.tenantId;
        data["deliveryId"] = this.deliveryId;
        data["deliveryDescription"] = this.deliveryDescription;
        data["paymnetMethodId"] = this.paymnetMethodId;
        data["totalAmount"] = this.totalAmount;
        data["ccName"] = this.ccName;
        data["ccNumber"] = this.ccNumber;
        data["ccExpireMonth"] = this.ccExpireMonth;
        data["ccExpireYear"] = this.ccExpireYear;
        data["ccCVV"] = this.ccCVV;
        data["orderStatusId"] = this.orderStatusId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["country"] = this.country;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postcode"] = this.postcode;
        data["address"] = this.address;
        data["billId"] = this.billId;
        data["courierCharges"] = this.courierCharges;
        data["courierName"] = this.courierName;
        data["courierId"] = this.courierId;
        data["shippedDate"] = this.shippedDate ? this.shippedDate.toISOString() : <any>undefined;
        data["goodsReceivedDate"] = this.goodsReceivedDate ? this.goodsReceivedDate.toISOString() : <any>undefined;
        data["deliveryTurnaroundTime"] = this.deliveryTurnaroundTime;
        data["deliveryCharge"] = this.deliveryCharge;
        data["addtionalRemark"] = this.addtionalRemark;
        data["trackingNumber"] = this.trackingNumber;
        data["billObject"] = this.billObject ? this.billObject.toJSON() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customerObject"] = this.customerObject ? this.customerObject.toJSON() : <any>undefined;
        return data;
    }

    clone(): Orders {
        const json = this.toJSON();
        let result = new Orders();
        result.init(json);
        return result;
    }
}

export interface IOrders {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    orderIdReference: string | undefined;
    tenantId: number;
    deliveryId: number;
    deliveryDescription: string | undefined;
    paymnetMethodId: number;
    totalAmount: number;
    ccName: string | undefined;
    ccNumber: number;
    ccExpireMonth: number;
    ccExpireYear: number;
    ccCVV: number;
    orderStatusId: number;
    userId: number;
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    country: string | undefined;
    city: string | undefined;
    state: string | undefined;
    postcode: number;
    address: string | undefined;
    billId: string | undefined;
    courierCharges: number;
    courierName: string | undefined;
    courierId: string | undefined;
    shippedDate: moment.Moment | undefined;
    goodsReceivedDate: moment.Moment | undefined;
    deliveryTurnaroundTime: number;
    deliveryCharge: number;
    addtionalRemark: string | undefined;
    trackingNumber: string | undefined;
    billObject: Bill;
    customerId: string | undefined;
    customerObject: Customer;
}

export class OrdersDto implements IOrdersDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    orderId: string;
    orderIdReference: string | undefined;
    deliveryId: number;
    deliveryDescription: string | undefined;
    paymnetMethodId: number;
    totalAmount: number;
    ccName: string | undefined;
    ccNumber: number;
    ccExpireMonth: number;
    ccExpireYear: number;
    ccCVV: number;
    orderStatusId: number;
    userId: number;
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    country: string | undefined;
    city: string | undefined;
    state: string | undefined;
    postcode: number;
    address: string | undefined;
    orderITems: OrderItems[] | undefined;
    createdDate: moment.Moment;
    customerId: string | undefined;
    courierCharges: number;
    courierName: string | undefined;
    courierId: string | undefined;
    shippedDate: moment.Moment | undefined;
    goodsReceivedDate: moment.Moment | undefined;
    deliveryTurnaroundTime: number;
    deliveryCharge: number;
    addtionalRemark: string | undefined;
    trackingNumber: string | undefined;
    customerObject: Customer;
    billId: string | undefined;
    billObject: Bill;

    constructor(data?: IOrdersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.orderId = _data["orderId"];
            this.orderIdReference = _data["orderIdReference"];
            this.deliveryId = _data["deliveryId"];
            this.deliveryDescription = _data["deliveryDescription"];
            this.paymnetMethodId = _data["paymnetMethodId"];
            this.totalAmount = _data["totalAmount"];
            this.ccName = _data["ccName"];
            this.ccNumber = _data["ccNumber"];
            this.ccExpireMonth = _data["ccExpireMonth"];
            this.ccExpireYear = _data["ccExpireYear"];
            this.ccCVV = _data["ccCVV"];
            this.orderStatusId = _data["orderStatusId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postcode = _data["postcode"];
            this.address = _data["address"];
            if (Array.isArray(_data["orderITems"])) {
                this.orderITems = [] as any;
                for (let item of _data["orderITems"])
                    this.orderITems.push(OrderItems.fromJS(item));
            }
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : <any>undefined;
            this.customerId = _data["customerId"];
            this.courierCharges = _data["courierCharges"];
            this.courierName = _data["courierName"];
            this.courierId = _data["courierId"];
            this.shippedDate = _data["shippedDate"] ? moment(_data["shippedDate"].toString()) : <any>undefined;
            this.goodsReceivedDate = _data["goodsReceivedDate"] ? moment(_data["goodsReceivedDate"].toString()) : <any>undefined;
            this.deliveryTurnaroundTime = _data["deliveryTurnaroundTime"];
            this.deliveryCharge = _data["deliveryCharge"];
            this.addtionalRemark = _data["addtionalRemark"];
            this.trackingNumber = _data["trackingNumber"];
            this.customerObject = _data["customerObject"] ? Customer.fromJS(_data["customerObject"]) : <any>undefined;
            this.billId = _data["billId"];
            this.billObject = _data["billObject"] ? Bill.fromJS(_data["billObject"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrdersDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrdersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["orderId"] = this.orderId;
        data["orderIdReference"] = this.orderIdReference;
        data["deliveryId"] = this.deliveryId;
        data["deliveryDescription"] = this.deliveryDescription;
        data["paymnetMethodId"] = this.paymnetMethodId;
        data["totalAmount"] = this.totalAmount;
        data["ccName"] = this.ccName;
        data["ccNumber"] = this.ccNumber;
        data["ccExpireMonth"] = this.ccExpireMonth;
        data["ccExpireYear"] = this.ccExpireYear;
        data["ccCVV"] = this.ccCVV;
        data["orderStatusId"] = this.orderStatusId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["country"] = this.country;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postcode"] = this.postcode;
        data["address"] = this.address;
        if (Array.isArray(this.orderITems)) {
            data["orderITems"] = [];
            for (let item of this.orderITems)
                data["orderITems"].push(item.toJSON());
        }
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["customerId"] = this.customerId;
        data["courierCharges"] = this.courierCharges;
        data["courierName"] = this.courierName;
        data["courierId"] = this.courierId;
        data["shippedDate"] = this.shippedDate ? this.shippedDate.toISOString() : <any>undefined;
        data["goodsReceivedDate"] = this.goodsReceivedDate ? this.goodsReceivedDate.toISOString() : <any>undefined;
        data["deliveryTurnaroundTime"] = this.deliveryTurnaroundTime;
        data["deliveryCharge"] = this.deliveryCharge;
        data["addtionalRemark"] = this.addtionalRemark;
        data["trackingNumber"] = this.trackingNumber;
        data["customerObject"] = this.customerObject ? this.customerObject.toJSON() : <any>undefined;
        data["billId"] = this.billId;
        data["billObject"] = this.billObject ? this.billObject.toJSON() : <any>undefined;
        return data;
    }

    clone(): OrdersDto {
        const json = this.toJSON();
        let result = new OrdersDto();
        result.init(json);
        return result;
    }
}

export interface IOrdersDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    orderId: string;
    orderIdReference: string | undefined;
    deliveryId: number;
    deliveryDescription: string | undefined;
    paymnetMethodId: number;
    totalAmount: number;
    ccName: string | undefined;
    ccNumber: number;
    ccExpireMonth: number;
    ccExpireYear: number;
    ccCVV: number;
    orderStatusId: number;
    userId: number;
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    country: string | undefined;
    city: string | undefined;
    state: string | undefined;
    postcode: number;
    address: string | undefined;
    orderITems: OrderItems[] | undefined;
    createdDate: moment.Moment;
    customerId: string | undefined;
    courierCharges: number;
    courierName: string | undefined;
    courierId: string | undefined;
    shippedDate: moment.Moment | undefined;
    goodsReceivedDate: moment.Moment | undefined;
    deliveryTurnaroundTime: number;
    deliveryCharge: number;
    addtionalRemark: string | undefined;
    trackingNumber: string | undefined;
    customerObject: Customer;
    billId: string | undefined;
    billObject: Bill;
}

export class OrdersDtoPagedResultDto implements IOrdersDtoPagedResultDto {
    items: OrdersDto[] | undefined;
    totalCount: number;

    constructor(data?: IOrdersDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OrdersDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): OrdersDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrdersDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): OrdersDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrdersDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrdersDtoPagedResultDto {
    items: OrdersDto[] | undefined;
    totalCount: number;
}

export class OrderSummaryDto implements IOrderSummaryDto {
    pendingPaymentCount: number;
    toShipCount: number;
    toReceivedCount: number;
    completedCount: number;

    constructor(data?: IOrderSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pendingPaymentCount = _data["pendingPaymentCount"];
            this.toShipCount = _data["toShipCount"];
            this.toReceivedCount = _data["toReceivedCount"];
            this.completedCount = _data["completedCount"];
        }
    }

    static fromJS(data: any): OrderSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pendingPaymentCount"] = this.pendingPaymentCount;
        data["toShipCount"] = this.toShipCount;
        data["toReceivedCount"] = this.toReceivedCount;
        data["completedCount"] = this.completedCount;
        return data;
    }

    clone(): OrderSummaryDto {
        const json = this.toJSON();
        let result = new OrderSummaryDto();
        result.init(json);
        return result;
    }
}

export interface IOrderSummaryDto {
    pendingPaymentCount: number;
    toShipCount: number;
    toReceivedCount: number;
    completedCount: number;
}

export class PayBadgeDto implements IPayBadgeDto {
    cashbookApprovalCount: number;
    reversalRequestCount: number;

    constructor(data?: IPayBadgeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cashbookApprovalCount = _data["cashbookApprovalCount"];
            this.reversalRequestCount = _data["reversalRequestCount"];
        }
    }

    static fromJS(data: any): PayBadgeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayBadgeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cashbookApprovalCount"] = this.cashbookApprovalCount;
        data["reversalRequestCount"] = this.reversalRequestCount;
        return data;
    }

    clone(): PayBadgeDto {
        const json = this.toJSON();
        let result = new PayBadgeDto();
        result.init(json);
        return result;
    }
}

export interface IPayBadgeDto {
    cashbookApprovalCount: number;
    reversalRequestCount: number;
}

export class PaymentBill implements IPaymentBill {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    paymentBillId: string | undefined;
    collection_Id: string | undefined;
    paid: boolean;
    state: string | undefined;
    amount: number;
    paid_Amount: number;
    email: string | undefined;
    mobile: string | undefined;
    name: string | undefined;
    url: string | undefined;
    reference_1_label: string | undefined;
    reference_1: string | undefined;
    reference_2_label: string | undefined;
    reference_2: string | undefined;
    redirect_url: string | undefined;
    callback_url: string | undefined;
    description: string | undefined;
    billId: string | undefined;
    tenantId: number | undefined;
    customerId: string | undefined;
    updateTenancy: string | undefined;
    subscriptionEndDate: moment.Moment | undefined;
    edition: string | undefined;
    productString: string | undefined;
    orderId: string | undefined;

    constructor(data?: IPaymentBill) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.paymentBillId = _data["paymentBillId"];
            this.collection_Id = _data["collection_Id"];
            this.paid = _data["paid"];
            this.state = _data["state"];
            this.amount = _data["amount"];
            this.paid_Amount = _data["paid_Amount"];
            this.email = _data["email"];
            this.mobile = _data["mobile"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.reference_1_label = _data["reference_1_label"];
            this.reference_1 = _data["reference_1"];
            this.reference_2_label = _data["reference_2_label"];
            this.reference_2 = _data["reference_2"];
            this.redirect_url = _data["redirect_url"];
            this.callback_url = _data["callback_url"];
            this.description = _data["description"];
            this.billId = _data["billId"];
            this.tenantId = _data["tenantId"];
            this.customerId = _data["customerId"];
            this.updateTenancy = _data["updateTenancy"];
            this.subscriptionEndDate = _data["subscriptionEndDate"] ? moment(_data["subscriptionEndDate"].toString()) : <any>undefined;
            this.edition = _data["edition"];
            this.productString = _data["productString"];
            this.orderId = _data["orderId"];
        }
    }

    static fromJS(data: any): PaymentBill {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentBill();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["paymentBillId"] = this.paymentBillId;
        data["collection_Id"] = this.collection_Id;
        data["paid"] = this.paid;
        data["state"] = this.state;
        data["amount"] = this.amount;
        data["paid_Amount"] = this.paid_Amount;
        data["email"] = this.email;
        data["mobile"] = this.mobile;
        data["name"] = this.name;
        data["url"] = this.url;
        data["reference_1_label"] = this.reference_1_label;
        data["reference_1"] = this.reference_1;
        data["reference_2_label"] = this.reference_2_label;
        data["reference_2"] = this.reference_2;
        data["redirect_url"] = this.redirect_url;
        data["callback_url"] = this.callback_url;
        data["description"] = this.description;
        data["billId"] = this.billId;
        data["tenantId"] = this.tenantId;
        data["customerId"] = this.customerId;
        data["updateTenancy"] = this.updateTenancy;
        data["subscriptionEndDate"] = this.subscriptionEndDate ? this.subscriptionEndDate.toISOString() : <any>undefined;
        data["edition"] = this.edition;
        data["productString"] = this.productString;
        data["orderId"] = this.orderId;
        return data;
    }

    clone(): PaymentBill {
        const json = this.toJSON();
        let result = new PaymentBill();
        result.init(json);
        return result;
    }
}

export interface IPaymentBill {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    paymentBillId: string | undefined;
    collection_Id: string | undefined;
    paid: boolean;
    state: string | undefined;
    amount: number;
    paid_Amount: number;
    email: string | undefined;
    mobile: string | undefined;
    name: string | undefined;
    url: string | undefined;
    reference_1_label: string | undefined;
    reference_1: string | undefined;
    reference_2_label: string | undefined;
    reference_2: string | undefined;
    redirect_url: string | undefined;
    callback_url: string | undefined;
    description: string | undefined;
    billId: string | undefined;
    tenantId: number | undefined;
    customerId: string | undefined;
    updateTenancy: string | undefined;
    subscriptionEndDate: moment.Moment | undefined;
    edition: string | undefined;
    productString: string | undefined;
    orderId: string | undefined;
}

export class PaymentBillDto implements IPaymentBillDto {
    id: string | undefined;
    collection_Id: string | undefined;
    paid: boolean;
    state: string | undefined;
    amount: number;
    paid_Amount: number;
    email: string | undefined;
    mobile: string | undefined;
    name: string | undefined;
    url: string | undefined;
    reference_1_label: string | undefined;
    reference_1: string | undefined;
    reference_2_label: string | undefined;
    reference_2: string | undefined;
    redirect_url: string | undefined;
    callback_url: string | undefined;
    description: string | undefined;
    billId: string | undefined;
    bill: Bill;
    tenantId: number | undefined;
    customerId: string | undefined;
    paymentBillId: string | undefined;
    objectId: number;
    customer: Customer;
    updateTenancy: string | undefined;
    subscriptionEndDate: moment.Moment | undefined;
    edition: string | undefined;
    productString: string | undefined;
    orderId: string | undefined;

    constructor(data?: IPaymentBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.collection_Id = _data["collection_Id"];
            this.paid = _data["paid"];
            this.state = _data["state"];
            this.amount = _data["amount"];
            this.paid_Amount = _data["paid_Amount"];
            this.email = _data["email"];
            this.mobile = _data["mobile"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.reference_1_label = _data["reference_1_label"];
            this.reference_1 = _data["reference_1"];
            this.reference_2_label = _data["reference_2_label"];
            this.reference_2 = _data["reference_2"];
            this.redirect_url = _data["redirect_url"];
            this.callback_url = _data["callback_url"];
            this.description = _data["description"];
            this.billId = _data["billId"];
            this.bill = _data["bill"] ? Bill.fromJS(_data["bill"]) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.customerId = _data["customerId"];
            this.paymentBillId = _data["paymentBillId"];
            this.objectId = _data["objectId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.updateTenancy = _data["updateTenancy"];
            this.subscriptionEndDate = _data["subscriptionEndDate"] ? moment(_data["subscriptionEndDate"].toString()) : <any>undefined;
            this.edition = _data["edition"];
            this.productString = _data["productString"];
            this.orderId = _data["orderId"];
        }
    }

    static fromJS(data: any): PaymentBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["collection_Id"] = this.collection_Id;
        data["paid"] = this.paid;
        data["state"] = this.state;
        data["amount"] = this.amount;
        data["paid_Amount"] = this.paid_Amount;
        data["email"] = this.email;
        data["mobile"] = this.mobile;
        data["name"] = this.name;
        data["url"] = this.url;
        data["reference_1_label"] = this.reference_1_label;
        data["reference_1"] = this.reference_1;
        data["reference_2_label"] = this.reference_2_label;
        data["reference_2"] = this.reference_2;
        data["redirect_url"] = this.redirect_url;
        data["callback_url"] = this.callback_url;
        data["description"] = this.description;
        data["billId"] = this.billId;
        data["bill"] = this.bill ? this.bill.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["customerId"] = this.customerId;
        data["paymentBillId"] = this.paymentBillId;
        data["objectId"] = this.objectId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["updateTenancy"] = this.updateTenancy;
        data["subscriptionEndDate"] = this.subscriptionEndDate ? this.subscriptionEndDate.toISOString() : <any>undefined;
        data["edition"] = this.edition;
        data["productString"] = this.productString;
        data["orderId"] = this.orderId;
        return data;
    }

    clone(): PaymentBillDto {
        const json = this.toJSON();
        let result = new PaymentBillDto();
        result.init(json);
        return result;
    }
}

export interface IPaymentBillDto {
    id: string | undefined;
    collection_Id: string | undefined;
    paid: boolean;
    state: string | undefined;
    amount: number;
    paid_Amount: number;
    email: string | undefined;
    mobile: string | undefined;
    name: string | undefined;
    url: string | undefined;
    reference_1_label: string | undefined;
    reference_1: string | undefined;
    reference_2_label: string | undefined;
    reference_2: string | undefined;
    redirect_url: string | undefined;
    callback_url: string | undefined;
    description: string | undefined;
    billId: string | undefined;
    bill: Bill;
    tenantId: number | undefined;
    customerId: string | undefined;
    paymentBillId: string | undefined;
    objectId: number;
    customer: Customer;
    updateTenancy: string | undefined;
    subscriptionEndDate: moment.Moment | undefined;
    edition: string | undefined;
    productString: string | undefined;
    orderId: string | undefined;
}

export class PaymentBillDtoPagedResultDto implements IPaymentBillDtoPagedResultDto {
    items: PaymentBillDto[] | undefined;
    totalCount: number;

    constructor(data?: IPaymentBillDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PaymentBillDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PaymentBillDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentBillDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PaymentBillDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PaymentBillDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPaymentBillDtoPagedResultDto {
    items: PaymentBillDto[] | undefined;
    totalCount: number;
}

export class PaymentResponseDto implements IPaymentResponseDto {
    api_status: string | undefined;
    error_code: string | undefined;
    error_remark: string | undefined;

    constructor(data?: IPaymentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.api_status = _data["api_status"];
            this.error_code = _data["error_code"];
            this.error_remark = _data["error_remark"];
        }
    }

    static fromJS(data: any): PaymentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["api_status"] = this.api_status;
        data["error_code"] = this.error_code;
        data["error_remark"] = this.error_remark;
        return data;
    }

    clone(): PaymentResponseDto {
        const json = this.toJSON();
        let result = new PaymentResponseDto();
        result.init(json);
        return result;
    }
}

export interface IPaymentResponseDto {
    api_status: string | undefined;
    error_code: string | undefined;
    error_remark: string | undefined;
}

export class PayrollReportDto implements IPayrollReportDto {
    usersPayrollNotCreated: UserDto[] | undefined;
    optInEmployeePayslip: EmployeePaySlipModelDto[] | undefined;
    optOutEmployeePayslip: EmployeePaySlipModelDto[] | undefined;

    constructor(data?: IPayrollReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["usersPayrollNotCreated"])) {
                this.usersPayrollNotCreated = [] as any;
                for (let item of _data["usersPayrollNotCreated"])
                    this.usersPayrollNotCreated.push(UserDto.fromJS(item));
            }
            if (Array.isArray(_data["optInEmployeePayslip"])) {
                this.optInEmployeePayslip = [] as any;
                for (let item of _data["optInEmployeePayslip"])
                    this.optInEmployeePayslip.push(EmployeePaySlipModelDto.fromJS(item));
            }
            if (Array.isArray(_data["optOutEmployeePayslip"])) {
                this.optOutEmployeePayslip = [] as any;
                for (let item of _data["optOutEmployeePayslip"])
                    this.optOutEmployeePayslip.push(EmployeePaySlipModelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PayrollReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.usersPayrollNotCreated)) {
            data["usersPayrollNotCreated"] = [];
            for (let item of this.usersPayrollNotCreated)
                data["usersPayrollNotCreated"].push(item.toJSON());
        }
        if (Array.isArray(this.optInEmployeePayslip)) {
            data["optInEmployeePayslip"] = [];
            for (let item of this.optInEmployeePayslip)
                data["optInEmployeePayslip"].push(item.toJSON());
        }
        if (Array.isArray(this.optOutEmployeePayslip)) {
            data["optOutEmployeePayslip"] = [];
            for (let item of this.optOutEmployeePayslip)
                data["optOutEmployeePayslip"].push(item.toJSON());
        }
        return data;
    }

    clone(): PayrollReportDto {
        const json = this.toJSON();
        let result = new PayrollReportDto();
        result.init(json);
        return result;
    }
}

export interface IPayrollReportDto {
    usersPayrollNotCreated: UserDto[] | undefined;
    optInEmployeePayslip: EmployeePaySlipModelDto[] | undefined;
    optOutEmployeePayslip: EmployeePaySlipModelDto[] | undefined;
}

export class PaySlipAllowanceModel implements IPaySlipAllowanceModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    allowanceId: number;
    allowance: AllowanceModel;
    employeePaySlipId: number;
    employeePaySlip: EmployeePaySlipModel;
    value: number;

    constructor(data?: IPaySlipAllowanceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.allowanceId = _data["allowanceId"];
            this.allowance = _data["allowance"] ? AllowanceModel.fromJS(_data["allowance"]) : <any>undefined;
            this.employeePaySlipId = _data["employeePaySlipId"];
            this.employeePaySlip = _data["employeePaySlip"] ? EmployeePaySlipModel.fromJS(_data["employeePaySlip"]) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): PaySlipAllowanceModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaySlipAllowanceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["allowanceId"] = this.allowanceId;
        data["allowance"] = this.allowance ? this.allowance.toJSON() : <any>undefined;
        data["employeePaySlipId"] = this.employeePaySlipId;
        data["employeePaySlip"] = this.employeePaySlip ? this.employeePaySlip.toJSON() : <any>undefined;
        data["value"] = this.value;
        return data;
    }

    clone(): PaySlipAllowanceModel {
        const json = this.toJSON();
        let result = new PaySlipAllowanceModel();
        result.init(json);
        return result;
    }
}

export interface IPaySlipAllowanceModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    allowanceId: number;
    allowance: AllowanceModel;
    employeePaySlipId: number;
    employeePaySlip: EmployeePaySlipModel;
    value: number;
}

export class PaySlipAllowanceModelDto implements IPaySlipAllowanceModelDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    allowanceId: number;
    allowance: AllowanceModel;
    employeePaySlipId: number;
    employeePaySlip: EmployeePaySlipModel;
    value: number;

    constructor(data?: IPaySlipAllowanceModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.allowanceId = _data["allowanceId"];
            this.allowance = _data["allowance"] ? AllowanceModel.fromJS(_data["allowance"]) : <any>undefined;
            this.employeePaySlipId = _data["employeePaySlipId"];
            this.employeePaySlip = _data["employeePaySlip"] ? EmployeePaySlipModel.fromJS(_data["employeePaySlip"]) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): PaySlipAllowanceModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaySlipAllowanceModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["allowanceId"] = this.allowanceId;
        data["allowance"] = this.allowance ? this.allowance.toJSON() : <any>undefined;
        data["employeePaySlipId"] = this.employeePaySlipId;
        data["employeePaySlip"] = this.employeePaySlip ? this.employeePaySlip.toJSON() : <any>undefined;
        data["value"] = this.value;
        return data;
    }

    clone(): PaySlipAllowanceModelDto {
        const json = this.toJSON();
        let result = new PaySlipAllowanceModelDto();
        result.init(json);
        return result;
    }
}

export interface IPaySlipAllowanceModelDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    allowanceId: number;
    allowance: AllowanceModel;
    employeePaySlipId: number;
    employeePaySlip: EmployeePaySlipModel;
    value: number;
}

export class PaySlipAllowanceModelPagedResultDto implements IPaySlipAllowanceModelPagedResultDto {
    items: PaySlipAllowanceModel[] | undefined;
    totalCount: number;

    constructor(data?: IPaySlipAllowanceModelPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PaySlipAllowanceModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PaySlipAllowanceModelPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaySlipAllowanceModelPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PaySlipAllowanceModelPagedResultDto {
        const json = this.toJSON();
        let result = new PaySlipAllowanceModelPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPaySlipAllowanceModelPagedResultDto {
    items: PaySlipAllowanceModel[] | undefined;
    totalCount: number;
}

export class PaySlipModel implements IPaySlipModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    title: string;
    departmentId: number;
    month: string;
    paymentDate: moment.Moment;
    description: string | undefined;
    tenantId: number;

    constructor(data?: IPaySlipModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.departmentId = _data["departmentId"];
            this.month = _data["month"];
            this.paymentDate = _data["paymentDate"] ? moment(_data["paymentDate"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): PaySlipModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaySlipModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["title"] = this.title;
        data["departmentId"] = this.departmentId;
        data["month"] = this.month;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): PaySlipModel {
        const json = this.toJSON();
        let result = new PaySlipModel();
        result.init(json);
        return result;
    }
}

export interface IPaySlipModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    title: string;
    departmentId: number;
    month: string;
    paymentDate: moment.Moment;
    description: string | undefined;
    tenantId: number;
}

export class PaySlipModelDto implements IPaySlipModelDto {
    title: string | undefined;
    departmentId: number;
    department: Department;
    month: string | undefined;
    paymentDate: moment.Moment;
    description: string | undefined;
    tenantId: number;
    paySlipModelId: number;

    constructor(data?: IPaySlipModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.departmentId = _data["departmentId"];
            this.department = _data["department"] ? Department.fromJS(_data["department"]) : <any>undefined;
            this.month = _data["month"];
            this.paymentDate = _data["paymentDate"] ? moment(_data["paymentDate"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.tenantId = _data["tenantId"];
            this.paySlipModelId = _data["paySlipModelId"];
        }
    }

    static fromJS(data: any): PaySlipModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaySlipModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["departmentId"] = this.departmentId;
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        data["month"] = this.month;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["tenantId"] = this.tenantId;
        data["paySlipModelId"] = this.paySlipModelId;
        return data;
    }

    clone(): PaySlipModelDto {
        const json = this.toJSON();
        let result = new PaySlipModelDto();
        result.init(json);
        return result;
    }
}

export interface IPaySlipModelDto {
    title: string | undefined;
    departmentId: number;
    department: Department;
    month: string | undefined;
    paymentDate: moment.Moment;
    description: string | undefined;
    tenantId: number;
    paySlipModelId: number;
}

export class PaySlipModelPagedResultDto implements IPaySlipModelPagedResultDto {
    items: PaySlipModel[] | undefined;
    totalCount: number;

    constructor(data?: IPaySlipModelPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PaySlipModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PaySlipModelPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaySlipModelPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PaySlipModelPagedResultDto {
        const json = this.toJSON();
        let result = new PaySlipModelPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPaySlipModelPagedResultDto {
    items: PaySlipModel[] | undefined;
    totalCount: number;
}

export class PermissionDto implements IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;

    constructor(data?: IPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new PermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;
}

export class PettyCashCategories implements IPettyCashCategories {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    description: string | undefined;

    constructor(data?: IPettyCashCategories) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PettyCashCategories {
        data = typeof data === 'object' ? data : {};
        let result = new PettyCashCategories();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }

    clone(): PettyCashCategories {
        const json = this.toJSON();
        let result = new PettyCashCategories();
        result.init(json);
        return result;
    }
}

export interface IPettyCashCategories {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    description: string | undefined;
}

export class PettyCashCategoriesDto implements IPettyCashCategoriesDto {
    tenantId: number;
    name: string | undefined;
    description: string | undefined;

    constructor(data?: IPettyCashCategoriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PettyCashCategoriesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PettyCashCategoriesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }

    clone(): PettyCashCategoriesDto {
        const json = this.toJSON();
        let result = new PettyCashCategoriesDto();
        result.init(json);
        return result;
    }
}

export interface IPettyCashCategoriesDto {
    tenantId: number;
    name: string | undefined;
    description: string | undefined;
}

export class PettyCashItemsDto implements IPettyCashItemsDto {
    tenantId: number;
    pettycashId: number;
    pettyCash: PettyCashs;
    itemName: string | undefined;
    itemDescription: string | undefined;
    amount: number;
    paymentMethod: string | undefined;
    receiptUrl: string | undefined;
    accountCode: string | undefined;

    constructor(data?: IPettyCashItemsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.pettycashId = _data["pettycashId"];
            this.pettyCash = _data["pettyCash"] ? PettyCashs.fromJS(_data["pettyCash"]) : <any>undefined;
            this.itemName = _data["itemName"];
            this.itemDescription = _data["itemDescription"];
            this.amount = _data["amount"];
            this.paymentMethod = _data["paymentMethod"];
            this.receiptUrl = _data["receiptUrl"];
            this.accountCode = _data["accountCode"];
        }
    }

    static fromJS(data: any): PettyCashItemsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PettyCashItemsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["pettycashId"] = this.pettycashId;
        data["pettyCash"] = this.pettyCash ? this.pettyCash.toJSON() : <any>undefined;
        data["itemName"] = this.itemName;
        data["itemDescription"] = this.itemDescription;
        data["amount"] = this.amount;
        data["paymentMethod"] = this.paymentMethod;
        data["receiptUrl"] = this.receiptUrl;
        data["accountCode"] = this.accountCode;
        return data;
    }

    clone(): PettyCashItemsDto {
        const json = this.toJSON();
        let result = new PettyCashItemsDto();
        result.init(json);
        return result;
    }
}

export interface IPettyCashItemsDto {
    tenantId: number;
    pettycashId: number;
    pettyCash: PettyCashs;
    itemName: string | undefined;
    itemDescription: string | undefined;
    amount: number;
    paymentMethod: string | undefined;
    receiptUrl: string | undefined;
    accountCode: string | undefined;
}

export class PettyCashs implements IPettyCashs {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    status: string | undefined;
    amountRequested: number;
    tenantId: number;
    date: moment.Moment;
    categoryId: number;
    category: PettyCashCategories;
    attachmentUrl: string | undefined;
    description: string | undefined;
    referenceNo: string | undefined;
    requestedBy: string | undefined;
    requestDate: moment.Moment;
    approvedBy: string | undefined;
    approvedDate: moment.Moment;

    constructor(data?: IPettyCashs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.amountRequested = _data["amountRequested"];
            this.tenantId = _data["tenantId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.categoryId = _data["categoryId"];
            this.category = _data["category"] ? PettyCashCategories.fromJS(_data["category"]) : <any>undefined;
            this.attachmentUrl = _data["attachmentUrl"];
            this.description = _data["description"];
            this.referenceNo = _data["referenceNo"];
            this.requestedBy = _data["requestedBy"];
            this.requestDate = _data["requestDate"] ? moment(_data["requestDate"].toString()) : <any>undefined;
            this.approvedBy = _data["approvedBy"];
            this.approvedDate = _data["approvedDate"] ? moment(_data["approvedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PettyCashs {
        data = typeof data === 'object' ? data : {};
        let result = new PettyCashs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["amountRequested"] = this.amountRequested;
        data["tenantId"] = this.tenantId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["categoryId"] = this.categoryId;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["attachmentUrl"] = this.attachmentUrl;
        data["description"] = this.description;
        data["referenceNo"] = this.referenceNo;
        data["requestedBy"] = this.requestedBy;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["approvedBy"] = this.approvedBy;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): PettyCashs {
        const json = this.toJSON();
        let result = new PettyCashs();
        result.init(json);
        return result;
    }
}

export interface IPettyCashs {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    status: string | undefined;
    amountRequested: number;
    tenantId: number;
    date: moment.Moment;
    categoryId: number;
    category: PettyCashCategories;
    attachmentUrl: string | undefined;
    description: string | undefined;
    referenceNo: string | undefined;
    requestedBy: string | undefined;
    requestDate: moment.Moment;
    approvedBy: string | undefined;
    approvedDate: moment.Moment;
}

export class PettyCashsDto implements IPettyCashsDto {
    status: string | undefined;
    amountRequested: number;
    tenantId: number;
    date: moment.Moment;
    categoryId: number;
    category: PettyCashCategories;
    attachmentUrl: string | undefined;
    description: string | undefined;
    referenceNo: string | undefined;
    requestedBy: string | undefined;
    requestDate: moment.Moment;
    approvedBy: string | undefined;
    approvedDate: moment.Moment;
    itemList: PettyCashItemsDto[] | undefined;
    id: number;

    constructor(data?: IPettyCashsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.amountRequested = _data["amountRequested"];
            this.tenantId = _data["tenantId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.categoryId = _data["categoryId"];
            this.category = _data["category"] ? PettyCashCategories.fromJS(_data["category"]) : <any>undefined;
            this.attachmentUrl = _data["attachmentUrl"];
            this.description = _data["description"];
            this.referenceNo = _data["referenceNo"];
            this.requestedBy = _data["requestedBy"];
            this.requestDate = _data["requestDate"] ? moment(_data["requestDate"].toString()) : <any>undefined;
            this.approvedBy = _data["approvedBy"];
            this.approvedDate = _data["approvedDate"] ? moment(_data["approvedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["itemList"])) {
                this.itemList = [] as any;
                for (let item of _data["itemList"])
                    this.itemList.push(PettyCashItemsDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PettyCashsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PettyCashsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["amountRequested"] = this.amountRequested;
        data["tenantId"] = this.tenantId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["categoryId"] = this.categoryId;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["attachmentUrl"] = this.attachmentUrl;
        data["description"] = this.description;
        data["referenceNo"] = this.referenceNo;
        data["requestedBy"] = this.requestedBy;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["approvedBy"] = this.approvedBy;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.itemList)) {
            data["itemList"] = [];
            for (let item of this.itemList)
                data["itemList"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): PettyCashsDto {
        const json = this.toJSON();
        let result = new PettyCashsDto();
        result.init(json);
        return result;
    }
}

export interface IPettyCashsDto {
    status: string | undefined;
    amountRequested: number;
    tenantId: number;
    date: moment.Moment;
    categoryId: number;
    category: PettyCashCategories;
    attachmentUrl: string | undefined;
    description: string | undefined;
    referenceNo: string | undefined;
    requestedBy: string | undefined;
    requestDate: moment.Moment;
    approvedBy: string | undefined;
    approvedDate: moment.Moment;
    itemList: PettyCashItemsDto[] | undefined;
    id: number;
}

export class PettyCashsDtoPagedResultDto implements IPettyCashsDtoPagedResultDto {
    items: PettyCashsDto[] | undefined;
    totalCount: number;

    constructor(data?: IPettyCashsDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PettyCashsDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PettyCashsDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PettyCashsDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PettyCashsDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PettyCashsDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPettyCashsDtoPagedResultDto {
    items: PettyCashsDto[] | undefined;
    totalCount: number;
}

export class PgeonPoint implements IPgeonPoint {
    sender_point: SenderPoint[] | undefined;
    receiver_point: ReceiverPoint[] | undefined;

    constructor(data?: IPgeonPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sender_point"])) {
                this.sender_point = [] as any;
                for (let item of _data["sender_point"])
                    this.sender_point.push(SenderPoint.fromJS(item));
            }
            if (Array.isArray(_data["receiver_point"])) {
                this.receiver_point = [] as any;
                for (let item of _data["receiver_point"])
                    this.receiver_point.push(ReceiverPoint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PgeonPoint {
        data = typeof data === 'object' ? data : {};
        let result = new PgeonPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sender_point)) {
            data["sender_point"] = [];
            for (let item of this.sender_point)
                data["sender_point"].push(item.toJSON());
        }
        if (Array.isArray(this.receiver_point)) {
            data["receiver_point"] = [];
            for (let item of this.receiver_point)
                data["receiver_point"].push(item.toJSON());
        }
        return data;
    }

    clone(): PgeonPoint {
        const json = this.toJSON();
        let result = new PgeonPoint();
        result.init(json);
        return result;
    }
}

export interface IPgeonPoint {
    sender_point: SenderPoint[] | undefined;
    receiver_point: ReceiverPoint[] | undefined;
}

export class PlaceOrderResponseDto implements IPlaceOrderResponseDto {
    result: Result2[] | undefined;
    api_status: string | undefined;
    error_code: string | undefined;
    error_remark: string | undefined;

    constructor(data?: IPlaceOrderResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(Result2.fromJS(item));
            }
            this.api_status = _data["api_status"];
            this.error_code = _data["error_code"];
            this.error_remark = _data["error_remark"];
        }
    }

    static fromJS(data: any): PlaceOrderResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlaceOrderResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["api_status"] = this.api_status;
        data["error_code"] = this.error_code;
        data["error_remark"] = this.error_remark;
        return data;
    }

    clone(): PlaceOrderResponseDto {
        const json = this.toJSON();
        let result = new PlaceOrderResponseDto();
        result.init(json);
        return result;
    }
}

export interface IPlaceOrderResponseDto {
    result: Result2[] | undefined;
    api_status: string | undefined;
    error_code: string | undefined;
    error_remark: string | undefined;
}

export class Product implements IProduct {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: string;
    name: string;
    description: string | undefined;
    price: number;
    tenantId: number | undefined;
    tenant: Tenant;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    hideFromMarketplace: boolean;
    companyProfileId: string | undefined;
    companyProfile: CompanyProfile;
    isUserFeatured: boolean;
    showQuantity: boolean;
    minLevel: number;
    isNotifiedMinLevel: boolean;
    tagNumber: string | undefined;
    barCode: string | undefined;
    productMaterialRelations: ProductMaterialRelation[] | undefined;
    averagePriceFromPo: number;
    averageProductionCost: number;
    lastSellingPrice: number;
    lastPriceFromPo: number;
    lastProductionCost: number;
    movingAverageValue: number;
    isHidden: boolean;
    readonly unitValue: number;
    firebaseDocID: string | undefined;
    firebaseCategory: string | undefined;
    inventoryCategoryId: number | undefined;
    inventoryCategory: InventoryCategory;
    producerTenantId: number;
    projectId: number | undefined;
    project: Project;
    dateOfMigration: moment.Moment | undefined;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            this.oldPrice = _data["oldPrice"];
            this.discount = _data["discount"];
            this.ratingsCount = _data["ratingsCount"];
            this.ratingsValue = _data["ratingsValue"];
            this.availibilityCount = _data["availibilityCount"];
            this.cartCount = _data["cartCount"];
            this.weight = _data["weight"];
            this.categoryId = _data["categoryId"];
            this.fullDescription = _data["fullDescription"];
            this.serviceTax = _data["serviceTax"];
            this.taxCode = _data["taxCode"];
            this.isSubsidized = _data["isSubsidized"];
            this.isCertified = _data["isCertified"];
            this.isIslamic = _data["isIslamic"];
            this.isLoanAvailable = _data["isLoanAvailable"];
            this.isFeatured = _data["isFeatured"];
            this.isTypeSerice = _data["isTypeSerice"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.hideFromMarketplace = _data["hideFromMarketplace"];
            this.companyProfileId = _data["companyProfileId"];
            this.companyProfile = _data["companyProfile"] ? CompanyProfile.fromJS(_data["companyProfile"]) : <any>undefined;
            this.isUserFeatured = _data["isUserFeatured"];
            this.showQuantity = _data["showQuantity"];
            this.minLevel = _data["minLevel"];
            this.isNotifiedMinLevel = _data["isNotifiedMinLevel"];
            this.tagNumber = _data["tagNumber"];
            this.barCode = _data["barCode"];
            if (Array.isArray(_data["productMaterialRelations"])) {
                this.productMaterialRelations = [] as any;
                for (let item of _data["productMaterialRelations"])
                    this.productMaterialRelations.push(ProductMaterialRelation.fromJS(item));
            }
            this.averagePriceFromPo = _data["averagePriceFromPo"];
            this.averageProductionCost = _data["averageProductionCost"];
            this.lastSellingPrice = _data["lastSellingPrice"];
            this.lastPriceFromPo = _data["lastPriceFromPo"];
            this.lastProductionCost = _data["lastProductionCost"];
            this.movingAverageValue = _data["movingAverageValue"];
            this.isHidden = _data["isHidden"];
            (<any>this).unitValue = _data["unitValue"];
            this.firebaseDocID = _data["firebaseDocID"];
            this.firebaseCategory = _data["firebaseCategory"];
            this.inventoryCategoryId = _data["inventoryCategoryId"];
            this.inventoryCategory = _data["inventoryCategory"] ? InventoryCategory.fromJS(_data["inventoryCategory"]) : <any>undefined;
            this.producerTenantId = _data["producerTenantId"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            this.dateOfMigration = _data["dateOfMigration"] ? moment(_data["dateOfMigration"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["oldPrice"] = this.oldPrice;
        data["discount"] = this.discount;
        data["ratingsCount"] = this.ratingsCount;
        data["ratingsValue"] = this.ratingsValue;
        data["availibilityCount"] = this.availibilityCount;
        data["cartCount"] = this.cartCount;
        data["weight"] = this.weight;
        data["categoryId"] = this.categoryId;
        data["fullDescription"] = this.fullDescription;
        data["serviceTax"] = this.serviceTax;
        data["taxCode"] = this.taxCode;
        data["isSubsidized"] = this.isSubsidized;
        data["isCertified"] = this.isCertified;
        data["isIslamic"] = this.isIslamic;
        data["isLoanAvailable"] = this.isLoanAvailable;
        data["isFeatured"] = this.isFeatured;
        data["isTypeSerice"] = this.isTypeSerice;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["hideFromMarketplace"] = this.hideFromMarketplace;
        data["companyProfileId"] = this.companyProfileId;
        data["companyProfile"] = this.companyProfile ? this.companyProfile.toJSON() : <any>undefined;
        data["isUserFeatured"] = this.isUserFeatured;
        data["showQuantity"] = this.showQuantity;
        data["minLevel"] = this.minLevel;
        data["isNotifiedMinLevel"] = this.isNotifiedMinLevel;
        data["tagNumber"] = this.tagNumber;
        data["barCode"] = this.barCode;
        if (Array.isArray(this.productMaterialRelations)) {
            data["productMaterialRelations"] = [];
            for (let item of this.productMaterialRelations)
                data["productMaterialRelations"].push(item.toJSON());
        }
        data["averagePriceFromPo"] = this.averagePriceFromPo;
        data["averageProductionCost"] = this.averageProductionCost;
        data["lastSellingPrice"] = this.lastSellingPrice;
        data["lastPriceFromPo"] = this.lastPriceFromPo;
        data["lastProductionCost"] = this.lastProductionCost;
        data["movingAverageValue"] = this.movingAverageValue;
        data["isHidden"] = this.isHidden;
        data["unitValue"] = this.unitValue;
        data["firebaseDocID"] = this.firebaseDocID;
        data["firebaseCategory"] = this.firebaseCategory;
        data["inventoryCategoryId"] = this.inventoryCategoryId;
        data["inventoryCategory"] = this.inventoryCategory ? this.inventoryCategory.toJSON() : <any>undefined;
        data["producerTenantId"] = this.producerTenantId;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["dateOfMigration"] = this.dateOfMigration ? this.dateOfMigration.toISOString() : <any>undefined;
        return data;
    }

    clone(): Product {
        const json = this.toJSON();
        let result = new Product();
        result.init(json);
        return result;
    }
}

export interface IProduct {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: string;
    name: string;
    description: string | undefined;
    price: number;
    tenantId: number | undefined;
    tenant: Tenant;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    hideFromMarketplace: boolean;
    companyProfileId: string | undefined;
    companyProfile: CompanyProfile;
    isUserFeatured: boolean;
    showQuantity: boolean;
    minLevel: number;
    isNotifiedMinLevel: boolean;
    tagNumber: string | undefined;
    barCode: string | undefined;
    productMaterialRelations: ProductMaterialRelation[] | undefined;
    averagePriceFromPo: number;
    averageProductionCost: number;
    lastSellingPrice: number;
    lastPriceFromPo: number;
    lastProductionCost: number;
    movingAverageValue: number;
    isHidden: boolean;
    unitValue: number;
    firebaseDocID: string | undefined;
    firebaseCategory: string | undefined;
    inventoryCategoryId: number | undefined;
    inventoryCategory: InventoryCategory;
    producerTenantId: number;
    projectId: number | undefined;
    project: Project;
    dateOfMigration: moment.Moment | undefined;
}

export class ProductColors implements IProductColors {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    productId: string;
    product: Product;
    color: string | undefined;

    constructor(data?: IProductColors) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.productId = _data["productId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): ProductColors {
        data = typeof data === 'object' ? data : {};
        let result = new ProductColors();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["color"] = this.color;
        return data;
    }

    clone(): ProductColors {
        const json = this.toJSON();
        let result = new ProductColors();
        result.init(json);
        return result;
    }
}

export interface IProductColors {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    productId: string;
    product: Product;
    color: string | undefined;
}

export class ProductColorsDto implements IProductColorsDto {
    productId: string;
    color: string | undefined;

    constructor(data?: IProductColorsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): ProductColorsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductColorsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["color"] = this.color;
        return data;
    }

    clone(): ProductColorsDto {
        const json = this.toJSON();
        let result = new ProductColorsDto();
        result.init(json);
        return result;
    }
}

export interface IProductColorsDto {
    productId: string;
    color: string | undefined;
}

export class ProductDto implements IProductDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    price: number;
    tenantId: number;
    tenant: Tenant;
    images: ProductImages[] | undefined;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    color: ProductColors[] | undefined;
    size: ProductSizes[] | undefined;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    hideFromMarketplace: boolean;
    companyProfileId: string | undefined;
    companyProfile: CompanyProfile;
    isUserFeatured: boolean;
    mainPicture: string | undefined;
    showQuantity: boolean;
    minLevel: number;
    isNotifiedMinLevel: boolean;
    tagNumber: string | undefined;
    barCode: string | undefined;
    productMaterialRelations: ProductMaterialRelation[] | undefined;
    warehouses: InventoryWarehouse[] | undefined;
    averagePriceFromPo: number;
    averageProductionCost: number;
    lastSellingPrice: number;
    lastPriceFromPo: number;
    lastProductionCost: number;
    priceList: ProductPriceHistoryDto[] | undefined;
    docId: string | undefined;
    isHidden: boolean;
    dateOfMigration: moment.Moment | undefined;
    firebaseDocID: string | undefined;
    firebaseCategory: string | undefined;
    manualEntries: InventoryManualEntry[] | undefined;
    additionalInfo: string | undefined;
    inventoryCategoryId: number | undefined;
    inventoryCategory: InventoryCategory;
    previousCount: number;
    nextCount: number;
    producerTenantId: number;
    totalInvoiceQty: number;
    totalBillQty: number;
    totalCreditNoteQty: number;
    totalWriteOffQty: number;
    totalStockCountQty: number;
    closingStock: number;
    openingStock: number;
    totalValue: number;
    totalOpeningValue: number;
    readonly unitValue: number;
    movingAverageValue: number;
    totalManualEntryQty: number;
    totalTransferFromFactoryQty: number;
    totalTransferBetweenLocationQty: number;
    totalWorkInProgressQty: number;
    projectId: number | undefined;
    project: Project;
    itemType: number;
    lastSoldBill: moment.Moment | undefined;

    constructor(data?: IProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.tenantId = _data["tenantId"];
            this.tenant = _data["tenant"] ? Tenant.fromJS(_data["tenant"]) : <any>undefined;
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images.push(ProductImages.fromJS(item));
            }
            this.oldPrice = _data["oldPrice"];
            this.discount = _data["discount"];
            this.ratingsCount = _data["ratingsCount"];
            this.ratingsValue = _data["ratingsValue"];
            this.availibilityCount = _data["availibilityCount"];
            this.cartCount = _data["cartCount"];
            if (Array.isArray(_data["color"])) {
                this.color = [] as any;
                for (let item of _data["color"])
                    this.color.push(ProductColors.fromJS(item));
            }
            if (Array.isArray(_data["size"])) {
                this.size = [] as any;
                for (let item of _data["size"])
                    this.size.push(ProductSizes.fromJS(item));
            }
            this.weight = _data["weight"];
            this.categoryId = _data["categoryId"];
            this.fullDescription = _data["fullDescription"];
            this.serviceTax = _data["serviceTax"];
            this.taxCode = _data["taxCode"];
            this.isSubsidized = _data["isSubsidized"];
            this.isCertified = _data["isCertified"];
            this.isIslamic = _data["isIslamic"];
            this.isLoanAvailable = _data["isLoanAvailable"];
            this.isFeatured = _data["isFeatured"];
            this.isTypeSerice = _data["isTypeSerice"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.hideFromMarketplace = _data["hideFromMarketplace"];
            this.companyProfileId = _data["companyProfileId"];
            this.companyProfile = _data["companyProfile"] ? CompanyProfile.fromJS(_data["companyProfile"]) : <any>undefined;
            this.isUserFeatured = _data["isUserFeatured"];
            this.mainPicture = _data["mainPicture"];
            this.showQuantity = _data["showQuantity"];
            this.minLevel = _data["minLevel"];
            this.isNotifiedMinLevel = _data["isNotifiedMinLevel"];
            this.tagNumber = _data["tagNumber"];
            this.barCode = _data["barCode"];
            if (Array.isArray(_data["productMaterialRelations"])) {
                this.productMaterialRelations = [] as any;
                for (let item of _data["productMaterialRelations"])
                    this.productMaterialRelations.push(ProductMaterialRelation.fromJS(item));
            }
            if (Array.isArray(_data["warehouses"])) {
                this.warehouses = [] as any;
                for (let item of _data["warehouses"])
                    this.warehouses.push(InventoryWarehouse.fromJS(item));
            }
            this.averagePriceFromPo = _data["averagePriceFromPo"];
            this.averageProductionCost = _data["averageProductionCost"];
            this.lastSellingPrice = _data["lastSellingPrice"];
            this.lastPriceFromPo = _data["lastPriceFromPo"];
            this.lastProductionCost = _data["lastProductionCost"];
            if (Array.isArray(_data["priceList"])) {
                this.priceList = [] as any;
                for (let item of _data["priceList"])
                    this.priceList.push(ProductPriceHistoryDto.fromJS(item));
            }
            this.docId = _data["docId"];
            this.isHidden = _data["isHidden"];
            this.dateOfMigration = _data["dateOfMigration"] ? moment(_data["dateOfMigration"].toString()) : <any>undefined;
            this.firebaseDocID = _data["firebaseDocID"];
            this.firebaseCategory = _data["firebaseCategory"];
            if (Array.isArray(_data["manualEntries"])) {
                this.manualEntries = [] as any;
                for (let item of _data["manualEntries"])
                    this.manualEntries.push(InventoryManualEntry.fromJS(item));
            }
            this.additionalInfo = _data["additionalInfo"];
            this.inventoryCategoryId = _data["inventoryCategoryId"];
            this.inventoryCategory = _data["inventoryCategory"] ? InventoryCategory.fromJS(_data["inventoryCategory"]) : <any>undefined;
            this.previousCount = _data["previousCount"];
            this.nextCount = _data["nextCount"];
            this.producerTenantId = _data["producerTenantId"];
            this.totalInvoiceQty = _data["totalInvoiceQty"];
            this.totalBillQty = _data["totalBillQty"];
            this.totalCreditNoteQty = _data["totalCreditNoteQty"];
            this.totalWriteOffQty = _data["totalWriteOffQty"];
            this.totalStockCountQty = _data["totalStockCountQty"];
            this.closingStock = _data["closingStock"];
            this.openingStock = _data["openingStock"];
            this.totalValue = _data["totalValue"];
            this.totalOpeningValue = _data["totalOpeningValue"];
            (<any>this).unitValue = _data["unitValue"];
            this.movingAverageValue = _data["movingAverageValue"];
            this.totalManualEntryQty = _data["totalManualEntryQty"];
            this.totalTransferFromFactoryQty = _data["totalTransferFromFactoryQty"];
            this.totalTransferBetweenLocationQty = _data["totalTransferBetweenLocationQty"];
            this.totalWorkInProgressQty = _data["totalWorkInProgressQty"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            this.itemType = _data["itemType"];
            this.lastSoldBill = _data["lastSoldBill"] ? moment(_data["lastSoldBill"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        data["tenantId"] = this.tenantId;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["oldPrice"] = this.oldPrice;
        data["discount"] = this.discount;
        data["ratingsCount"] = this.ratingsCount;
        data["ratingsValue"] = this.ratingsValue;
        data["availibilityCount"] = this.availibilityCount;
        data["cartCount"] = this.cartCount;
        if (Array.isArray(this.color)) {
            data["color"] = [];
            for (let item of this.color)
                data["color"].push(item.toJSON());
        }
        if (Array.isArray(this.size)) {
            data["size"] = [];
            for (let item of this.size)
                data["size"].push(item.toJSON());
        }
        data["weight"] = this.weight;
        data["categoryId"] = this.categoryId;
        data["fullDescription"] = this.fullDescription;
        data["serviceTax"] = this.serviceTax;
        data["taxCode"] = this.taxCode;
        data["isSubsidized"] = this.isSubsidized;
        data["isCertified"] = this.isCertified;
        data["isIslamic"] = this.isIslamic;
        data["isLoanAvailable"] = this.isLoanAvailable;
        data["isFeatured"] = this.isFeatured;
        data["isTypeSerice"] = this.isTypeSerice;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["hideFromMarketplace"] = this.hideFromMarketplace;
        data["companyProfileId"] = this.companyProfileId;
        data["companyProfile"] = this.companyProfile ? this.companyProfile.toJSON() : <any>undefined;
        data["isUserFeatured"] = this.isUserFeatured;
        data["mainPicture"] = this.mainPicture;
        data["showQuantity"] = this.showQuantity;
        data["minLevel"] = this.minLevel;
        data["isNotifiedMinLevel"] = this.isNotifiedMinLevel;
        data["tagNumber"] = this.tagNumber;
        data["barCode"] = this.barCode;
        if (Array.isArray(this.productMaterialRelations)) {
            data["productMaterialRelations"] = [];
            for (let item of this.productMaterialRelations)
                data["productMaterialRelations"].push(item.toJSON());
        }
        if (Array.isArray(this.warehouses)) {
            data["warehouses"] = [];
            for (let item of this.warehouses)
                data["warehouses"].push(item.toJSON());
        }
        data["averagePriceFromPo"] = this.averagePriceFromPo;
        data["averageProductionCost"] = this.averageProductionCost;
        data["lastSellingPrice"] = this.lastSellingPrice;
        data["lastPriceFromPo"] = this.lastPriceFromPo;
        data["lastProductionCost"] = this.lastProductionCost;
        if (Array.isArray(this.priceList)) {
            data["priceList"] = [];
            for (let item of this.priceList)
                data["priceList"].push(item.toJSON());
        }
        data["docId"] = this.docId;
        data["isHidden"] = this.isHidden;
        data["dateOfMigration"] = this.dateOfMigration ? this.dateOfMigration.toISOString() : <any>undefined;
        data["firebaseDocID"] = this.firebaseDocID;
        data["firebaseCategory"] = this.firebaseCategory;
        if (Array.isArray(this.manualEntries)) {
            data["manualEntries"] = [];
            for (let item of this.manualEntries)
                data["manualEntries"].push(item.toJSON());
        }
        data["additionalInfo"] = this.additionalInfo;
        data["inventoryCategoryId"] = this.inventoryCategoryId;
        data["inventoryCategory"] = this.inventoryCategory ? this.inventoryCategory.toJSON() : <any>undefined;
        data["previousCount"] = this.previousCount;
        data["nextCount"] = this.nextCount;
        data["producerTenantId"] = this.producerTenantId;
        data["totalInvoiceQty"] = this.totalInvoiceQty;
        data["totalBillQty"] = this.totalBillQty;
        data["totalCreditNoteQty"] = this.totalCreditNoteQty;
        data["totalWriteOffQty"] = this.totalWriteOffQty;
        data["totalStockCountQty"] = this.totalStockCountQty;
        data["closingStock"] = this.closingStock;
        data["openingStock"] = this.openingStock;
        data["totalValue"] = this.totalValue;
        data["totalOpeningValue"] = this.totalOpeningValue;
        data["unitValue"] = this.unitValue;
        data["movingAverageValue"] = this.movingAverageValue;
        data["totalManualEntryQty"] = this.totalManualEntryQty;
        data["totalTransferFromFactoryQty"] = this.totalTransferFromFactoryQty;
        data["totalTransferBetweenLocationQty"] = this.totalTransferBetweenLocationQty;
        data["totalWorkInProgressQty"] = this.totalWorkInProgressQty;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["itemType"] = this.itemType;
        data["lastSoldBill"] = this.lastSoldBill ? this.lastSoldBill.toISOString() : <any>undefined;
        return data;
    }

    clone(): ProductDto {
        const json = this.toJSON();
        let result = new ProductDto();
        result.init(json);
        return result;
    }
}

export interface IProductDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    price: number;
    tenantId: number;
    tenant: Tenant;
    images: ProductImages[] | undefined;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    color: ProductColors[] | undefined;
    size: ProductSizes[] | undefined;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    hideFromMarketplace: boolean;
    companyProfileId: string | undefined;
    companyProfile: CompanyProfile;
    isUserFeatured: boolean;
    mainPicture: string | undefined;
    showQuantity: boolean;
    minLevel: number;
    isNotifiedMinLevel: boolean;
    tagNumber: string | undefined;
    barCode: string | undefined;
    productMaterialRelations: ProductMaterialRelation[] | undefined;
    warehouses: InventoryWarehouse[] | undefined;
    averagePriceFromPo: number;
    averageProductionCost: number;
    lastSellingPrice: number;
    lastPriceFromPo: number;
    lastProductionCost: number;
    priceList: ProductPriceHistoryDto[] | undefined;
    docId: string | undefined;
    isHidden: boolean;
    dateOfMigration: moment.Moment | undefined;
    firebaseDocID: string | undefined;
    firebaseCategory: string | undefined;
    manualEntries: InventoryManualEntry[] | undefined;
    additionalInfo: string | undefined;
    inventoryCategoryId: number | undefined;
    inventoryCategory: InventoryCategory;
    previousCount: number;
    nextCount: number;
    producerTenantId: number;
    totalInvoiceQty: number;
    totalBillQty: number;
    totalCreditNoteQty: number;
    totalWriteOffQty: number;
    totalStockCountQty: number;
    closingStock: number;
    openingStock: number;
    totalValue: number;
    totalOpeningValue: number;
    unitValue: number;
    movingAverageValue: number;
    totalManualEntryQty: number;
    totalTransferFromFactoryQty: number;
    totalTransferBetweenLocationQty: number;
    totalWorkInProgressQty: number;
    projectId: number | undefined;
    project: Project;
    itemType: number;
    lastSoldBill: moment.Moment | undefined;
}

export class ProductDtoPagedResultDto implements IProductDtoPagedResultDto {
    items: ProductDto[] | undefined;
    totalCount: number;

    constructor(data?: IProductDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProductDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ProductDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ProductDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProductDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProductDtoPagedResultDto {
    items: ProductDto[] | undefined;
    totalCount: number;
}

export class ProductImages implements IProductImages {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    productId: string;
    product: Product;
    small: string | undefined;
    medium: string | undefined;
    big: string | undefined;

    constructor(data?: IProductImages) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.productId = _data["productId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.small = _data["small"];
            this.medium = _data["medium"];
            this.big = _data["big"];
        }
    }

    static fromJS(data: any): ProductImages {
        data = typeof data === 'object' ? data : {};
        let result = new ProductImages();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["small"] = this.small;
        data["medium"] = this.medium;
        data["big"] = this.big;
        return data;
    }

    clone(): ProductImages {
        const json = this.toJSON();
        let result = new ProductImages();
        result.init(json);
        return result;
    }
}

export interface IProductImages {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    productId: string;
    product: Product;
    small: string | undefined;
    medium: string | undefined;
    big: string | undefined;
}

export class ProductImagesDto implements IProductImagesDto {
    productId: string;
    small: string | undefined;
    medium: string | undefined;
    big: string | undefined;

    constructor(data?: IProductImagesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.small = _data["small"];
            this.medium = _data["medium"];
            this.big = _data["big"];
        }
    }

    static fromJS(data: any): ProductImagesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductImagesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["small"] = this.small;
        data["medium"] = this.medium;
        data["big"] = this.big;
        return data;
    }

    clone(): ProductImagesDto {
        const json = this.toJSON();
        let result = new ProductImagesDto();
        result.init(json);
        return result;
    }
}

export interface IProductImagesDto {
    productId: string;
    small: string | undefined;
    medium: string | undefined;
    big: string | undefined;
}

export class ProductIventoryDto implements IProductIventoryDto {
    openingStock: number;
    closingStock: number;
    manualEntryQty: number;
    billQty: number;
    invoiceQty: number;
    creditQty: number;
    writeOffQty: number;
    stockCountQty: number;
    transferFromFactoryQty: number;
    transferBetweenLocationQty: number;
    workInProgressQty: number;
    lastSoldBill: moment.Moment | undefined;
    manualEntries: InventoryManualEntry[] | undefined;

    constructor(data?: IProductIventoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.openingStock = _data["openingStock"];
            this.closingStock = _data["closingStock"];
            this.manualEntryQty = _data["manualEntryQty"];
            this.billQty = _data["billQty"];
            this.invoiceQty = _data["invoiceQty"];
            this.creditQty = _data["creditQty"];
            this.writeOffQty = _data["writeOffQty"];
            this.stockCountQty = _data["stockCountQty"];
            this.transferFromFactoryQty = _data["transferFromFactoryQty"];
            this.transferBetweenLocationQty = _data["transferBetweenLocationQty"];
            this.workInProgressQty = _data["workInProgressQty"];
            this.lastSoldBill = _data["lastSoldBill"] ? moment(_data["lastSoldBill"].toString()) : <any>undefined;
            if (Array.isArray(_data["manualEntries"])) {
                this.manualEntries = [] as any;
                for (let item of _data["manualEntries"])
                    this.manualEntries.push(InventoryManualEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductIventoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductIventoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["openingStock"] = this.openingStock;
        data["closingStock"] = this.closingStock;
        data["manualEntryQty"] = this.manualEntryQty;
        data["billQty"] = this.billQty;
        data["invoiceQty"] = this.invoiceQty;
        data["creditQty"] = this.creditQty;
        data["writeOffQty"] = this.writeOffQty;
        data["stockCountQty"] = this.stockCountQty;
        data["transferFromFactoryQty"] = this.transferFromFactoryQty;
        data["transferBetweenLocationQty"] = this.transferBetweenLocationQty;
        data["workInProgressQty"] = this.workInProgressQty;
        data["lastSoldBill"] = this.lastSoldBill ? this.lastSoldBill.toISOString() : <any>undefined;
        if (Array.isArray(this.manualEntries)) {
            data["manualEntries"] = [];
            for (let item of this.manualEntries)
                data["manualEntries"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductIventoryDto {
        const json = this.toJSON();
        let result = new ProductIventoryDto();
        result.init(json);
        return result;
    }
}

export interface IProductIventoryDto {
    openingStock: number;
    closingStock: number;
    manualEntryQty: number;
    billQty: number;
    invoiceQty: number;
    creditQty: number;
    writeOffQty: number;
    stockCountQty: number;
    transferFromFactoryQty: number;
    transferBetweenLocationQty: number;
    workInProgressQty: number;
    lastSoldBill: moment.Moment | undefined;
    manualEntries: InventoryManualEntry[] | undefined;
}

export class ProductMaterialRelation implements IProductMaterialRelation {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    productId: string;
    product: Product;
    materialId: string;
    material: Material;

    constructor(data?: IProductMaterialRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.productId = _data["productId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.materialId = _data["materialId"];
            this.material = _data["material"] ? Material.fromJS(_data["material"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductMaterialRelation {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMaterialRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["materialId"] = this.materialId;
        data["material"] = this.material ? this.material.toJSON() : <any>undefined;
        return data;
    }

    clone(): ProductMaterialRelation {
        const json = this.toJSON();
        let result = new ProductMaterialRelation();
        result.init(json);
        return result;
    }
}

export interface IProductMaterialRelation {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    productId: string;
    product: Product;
    materialId: string;
    material: Material;
}

export class ProductMigrationDto implements IProductMigrationDto {
    name: string | undefined;
    code: string | undefined;
    isTypeSerice: boolean;
    categoryId: string | undefined;
    inventoryCategoryName: string | undefined;
    price: number;
    lastProductionCost: number;
    unitOfMeasurement: string | undefined;
    discount: number;
    availibilityCount: number;
    hideFromMarketplace: boolean;
    serviceTax: number;
    taxCode: string | undefined;
    description: string | undefined;
    fullDescription: string | undefined;
    isFeatured: boolean;
    isValid: boolean;
    error: string | undefined;
    dateOfMigration: moment.Moment | undefined;
    imageUrl: string | undefined;
    firebaseDocID: string | undefined;
    firebaseCategory: string | undefined;
    inventoryCategoryId: number | undefined;
    inventoryCategory: InventoryCategory;
    productId: string | undefined;

    constructor(data?: IProductMigrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.isTypeSerice = _data["isTypeSerice"];
            this.categoryId = _data["categoryId"];
            this.inventoryCategoryName = _data["inventoryCategoryName"];
            this.price = _data["price"];
            this.lastProductionCost = _data["lastProductionCost"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.discount = _data["discount"];
            this.availibilityCount = _data["availibilityCount"];
            this.hideFromMarketplace = _data["hideFromMarketplace"];
            this.serviceTax = _data["serviceTax"];
            this.taxCode = _data["taxCode"];
            this.description = _data["description"];
            this.fullDescription = _data["fullDescription"];
            this.isFeatured = _data["isFeatured"];
            this.isValid = _data["isValid"];
            this.error = _data["error"];
            this.dateOfMigration = _data["dateOfMigration"] ? moment(_data["dateOfMigration"].toString()) : <any>undefined;
            this.imageUrl = _data["imageUrl"];
            this.firebaseDocID = _data["firebaseDocID"];
            this.firebaseCategory = _data["firebaseCategory"];
            this.inventoryCategoryId = _data["inventoryCategoryId"];
            this.inventoryCategory = _data["inventoryCategory"] ? InventoryCategory.fromJS(_data["inventoryCategory"]) : <any>undefined;
            this.productId = _data["productId"];
        }
    }

    static fromJS(data: any): ProductMigrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMigrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["isTypeSerice"] = this.isTypeSerice;
        data["categoryId"] = this.categoryId;
        data["inventoryCategoryName"] = this.inventoryCategoryName;
        data["price"] = this.price;
        data["lastProductionCost"] = this.lastProductionCost;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["discount"] = this.discount;
        data["availibilityCount"] = this.availibilityCount;
        data["hideFromMarketplace"] = this.hideFromMarketplace;
        data["serviceTax"] = this.serviceTax;
        data["taxCode"] = this.taxCode;
        data["description"] = this.description;
        data["fullDescription"] = this.fullDescription;
        data["isFeatured"] = this.isFeatured;
        data["isValid"] = this.isValid;
        data["error"] = this.error;
        data["dateOfMigration"] = this.dateOfMigration ? this.dateOfMigration.toISOString() : <any>undefined;
        data["imageUrl"] = this.imageUrl;
        data["firebaseDocID"] = this.firebaseDocID;
        data["firebaseCategory"] = this.firebaseCategory;
        data["inventoryCategoryId"] = this.inventoryCategoryId;
        data["inventoryCategory"] = this.inventoryCategory ? this.inventoryCategory.toJSON() : <any>undefined;
        data["productId"] = this.productId;
        return data;
    }

    clone(): ProductMigrationDto {
        const json = this.toJSON();
        let result = new ProductMigrationDto();
        result.init(json);
        return result;
    }
}

export interface IProductMigrationDto {
    name: string | undefined;
    code: string | undefined;
    isTypeSerice: boolean;
    categoryId: string | undefined;
    inventoryCategoryName: string | undefined;
    price: number;
    lastProductionCost: number;
    unitOfMeasurement: string | undefined;
    discount: number;
    availibilityCount: number;
    hideFromMarketplace: boolean;
    serviceTax: number;
    taxCode: string | undefined;
    description: string | undefined;
    fullDescription: string | undefined;
    isFeatured: boolean;
    isValid: boolean;
    error: string | undefined;
    dateOfMigration: moment.Moment | undefined;
    imageUrl: string | undefined;
    firebaseDocID: string | undefined;
    firebaseCategory: string | undefined;
    inventoryCategoryId: number | undefined;
    inventoryCategory: InventoryCategory;
    productId: string | undefined;
}

export class ProductPriceHistoryDto implements IProductPriceHistoryDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    productId: string;
    product: Product;
    tenantId: number;
    oldPrice: number;
    oldDiscount: number;
    readonly oldPriceAfterDiscount: number;
    oldCost: number;
    newPrice: number;
    newDiscount: number;
    readonly newPriceAfterDiscount: number;
    newCost: number;
    requesterUserId: number;
    requesterUserDto: UserDto;
    requesterUserName: string | undefined;
    requestDate: moment.Moment;
    remarksByRequester: string | undefined;
    approverUserId: number;
    approverUserDto: UserDto;
    approverUserName: string | undefined;
    approvalStatus: number;
    readonly approvalText: string | undefined;
    approvalDate: moment.Moment;
    remarksByApprover: string | undefined;
    documentUrl: string | undefined;
    documentFileName: string | undefined;
    referenceNumber: string | undefined;

    constructor(data?: IProductPriceHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.productId = _data["productId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.oldPrice = _data["oldPrice"];
            this.oldDiscount = _data["oldDiscount"];
            (<any>this).oldPriceAfterDiscount = _data["oldPriceAfterDiscount"];
            this.oldCost = _data["oldCost"];
            this.newPrice = _data["newPrice"];
            this.newDiscount = _data["newDiscount"];
            (<any>this).newPriceAfterDiscount = _data["newPriceAfterDiscount"];
            this.newCost = _data["newCost"];
            this.requesterUserId = _data["requesterUserId"];
            this.requesterUserDto = _data["requesterUserDto"] ? UserDto.fromJS(_data["requesterUserDto"]) : <any>undefined;
            this.requesterUserName = _data["requesterUserName"];
            this.requestDate = _data["requestDate"] ? moment(_data["requestDate"].toString()) : <any>undefined;
            this.remarksByRequester = _data["remarksByRequester"];
            this.approverUserId = _data["approverUserId"];
            this.approverUserDto = _data["approverUserDto"] ? UserDto.fromJS(_data["approverUserDto"]) : <any>undefined;
            this.approverUserName = _data["approverUserName"];
            this.approvalStatus = _data["approvalStatus"];
            (<any>this).approvalText = _data["approvalText"];
            this.approvalDate = _data["approvalDate"] ? moment(_data["approvalDate"].toString()) : <any>undefined;
            this.remarksByApprover = _data["remarksByApprover"];
            this.documentUrl = _data["documentUrl"];
            this.documentFileName = _data["documentFileName"];
            this.referenceNumber = _data["referenceNumber"];
        }
    }

    static fromJS(data: any): ProductPriceHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPriceHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["oldPrice"] = this.oldPrice;
        data["oldDiscount"] = this.oldDiscount;
        data["oldPriceAfterDiscount"] = this.oldPriceAfterDiscount;
        data["oldCost"] = this.oldCost;
        data["newPrice"] = this.newPrice;
        data["newDiscount"] = this.newDiscount;
        data["newPriceAfterDiscount"] = this.newPriceAfterDiscount;
        data["newCost"] = this.newCost;
        data["requesterUserId"] = this.requesterUserId;
        data["requesterUserDto"] = this.requesterUserDto ? this.requesterUserDto.toJSON() : <any>undefined;
        data["requesterUserName"] = this.requesterUserName;
        data["requestDate"] = this.requestDate ? this.requestDate.toISOString() : <any>undefined;
        data["remarksByRequester"] = this.remarksByRequester;
        data["approverUserId"] = this.approverUserId;
        data["approverUserDto"] = this.approverUserDto ? this.approverUserDto.toJSON() : <any>undefined;
        data["approverUserName"] = this.approverUserName;
        data["approvalStatus"] = this.approvalStatus;
        data["approvalText"] = this.approvalText;
        data["approvalDate"] = this.approvalDate ? this.approvalDate.toISOString() : <any>undefined;
        data["remarksByApprover"] = this.remarksByApprover;
        data["documentUrl"] = this.documentUrl;
        data["documentFileName"] = this.documentFileName;
        data["referenceNumber"] = this.referenceNumber;
        return data;
    }

    clone(): ProductPriceHistoryDto {
        const json = this.toJSON();
        let result = new ProductPriceHistoryDto();
        result.init(json);
        return result;
    }
}

export interface IProductPriceHistoryDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    productId: string;
    product: Product;
    tenantId: number;
    oldPrice: number;
    oldDiscount: number;
    oldPriceAfterDiscount: number;
    oldCost: number;
    newPrice: number;
    newDiscount: number;
    newPriceAfterDiscount: number;
    newCost: number;
    requesterUserId: number;
    requesterUserDto: UserDto;
    requesterUserName: string | undefined;
    requestDate: moment.Moment;
    remarksByRequester: string | undefined;
    approverUserId: number;
    approverUserDto: UserDto;
    approverUserName: string | undefined;
    approvalStatus: number;
    approvalText: string | undefined;
    approvalDate: moment.Moment;
    remarksByApprover: string | undefined;
    documentUrl: string | undefined;
    documentFileName: string | undefined;
    referenceNumber: string | undefined;
}

export class ProductSizes implements IProductSizes {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    productId: string;
    product: Product;
    size: string | undefined;

    constructor(data?: IProductSizes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.productId = _data["productId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): ProductSizes {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSizes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["size"] = this.size;
        return data;
    }

    clone(): ProductSizes {
        const json = this.toJSON();
        let result = new ProductSizes();
        result.init(json);
        return result;
    }
}

export interface IProductSizes {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    productId: string;
    product: Product;
    size: string | undefined;
}

export class ProductSizesDto implements IProductSizesDto {
    productId: string;
    size: string | undefined;

    constructor(data?: IProductSizesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.size = _data["size"];
        }
    }

    static fromJS(data: any): ProductSizesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSizesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["size"] = this.size;
        return data;
    }

    clone(): ProductSizesDto {
        const json = this.toJSON();
        let result = new ProductSizesDto();
        result.init(json);
        return result;
    }
}

export interface IProductSizesDto {
    productId: string;
    size: string | undefined;
}

export class Project implements IProject {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    projectName: string | undefined;
    projectValue: number;
    commencementDate: moment.Moment | undefined;
    completionDate: moment.Moment | undefined;
    customerId: string;
    customer: Customer;
    totalBudgetCosts: number;
    preparedBy: string | undefined;
    approvedBy: string | undefined;
    tenantId: number;
    isApproved: boolean;
    staffList: ProjectStaff[] | undefined;
    contractAgreementFileName: string | undefined;
    contractAgreementUrl: string | undefined;
    projectCompletionPercentage: number;

    constructor(data?: IProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.projectName = _data["projectName"];
            this.projectValue = _data["projectValue"];
            this.commencementDate = _data["commencementDate"] ? moment(_data["commencementDate"].toString()) : <any>undefined;
            this.completionDate = _data["completionDate"] ? moment(_data["completionDate"].toString()) : <any>undefined;
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.totalBudgetCosts = _data["totalBudgetCosts"];
            this.preparedBy = _data["preparedBy"];
            this.approvedBy = _data["approvedBy"];
            this.tenantId = _data["tenantId"];
            this.isApproved = _data["isApproved"];
            if (Array.isArray(_data["staffList"])) {
                this.staffList = [] as any;
                for (let item of _data["staffList"])
                    this.staffList.push(ProjectStaff.fromJS(item));
            }
            this.contractAgreementFileName = _data["contractAgreementFileName"];
            this.contractAgreementUrl = _data["contractAgreementUrl"];
            this.projectCompletionPercentage = _data["projectCompletionPercentage"];
        }
    }

    static fromJS(data: any): Project {
        data = typeof data === 'object' ? data : {};
        let result = new Project();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["projectName"] = this.projectName;
        data["projectValue"] = this.projectValue;
        data["commencementDate"] = this.commencementDate ? this.commencementDate.toISOString() : <any>undefined;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["totalBudgetCosts"] = this.totalBudgetCosts;
        data["preparedBy"] = this.preparedBy;
        data["approvedBy"] = this.approvedBy;
        data["tenantId"] = this.tenantId;
        data["isApproved"] = this.isApproved;
        if (Array.isArray(this.staffList)) {
            data["staffList"] = [];
            for (let item of this.staffList)
                data["staffList"].push(item.toJSON());
        }
        data["contractAgreementFileName"] = this.contractAgreementFileName;
        data["contractAgreementUrl"] = this.contractAgreementUrl;
        data["projectCompletionPercentage"] = this.projectCompletionPercentage;
        return data;
    }

    clone(): Project {
        const json = this.toJSON();
        let result = new Project();
        result.init(json);
        return result;
    }
}

export interface IProject {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    projectName: string | undefined;
    projectValue: number;
    commencementDate: moment.Moment | undefined;
    completionDate: moment.Moment | undefined;
    customerId: string;
    customer: Customer;
    totalBudgetCosts: number;
    preparedBy: string | undefined;
    approvedBy: string | undefined;
    tenantId: number;
    isApproved: boolean;
    staffList: ProjectStaff[] | undefined;
    contractAgreementFileName: string | undefined;
    contractAgreementUrl: string | undefined;
    projectCompletionPercentage: number;
}

export class ProjectBudgetDto implements IProjectBudgetDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    projectId: number;
    project: Project;
    costType: string | undefined;
    itemName: string | undefined;
    budgetAmount: number;

    constructor(data?: IProjectBudgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            this.costType = _data["costType"];
            this.itemName = _data["itemName"];
            this.budgetAmount = _data["budgetAmount"];
        }
    }

    static fromJS(data: any): ProjectBudgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectBudgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["costType"] = this.costType;
        data["itemName"] = this.itemName;
        data["budgetAmount"] = this.budgetAmount;
        return data;
    }

    clone(): ProjectBudgetDto {
        const json = this.toJSON();
        let result = new ProjectBudgetDto();
        result.init(json);
        return result;
    }
}

export interface IProjectBudgetDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    projectId: number;
    project: Project;
    costType: string | undefined;
    itemName: string | undefined;
    budgetAmount: number;
}

export class ProjectBudgetMigrationDto implements IProjectBudgetMigrationDto {
    costType: string | undefined;
    itemName: string | undefined;
    budgetAmount: number;
    isValid: boolean;
    error: string | undefined;

    constructor(data?: IProjectBudgetMigrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costType = _data["costType"];
            this.itemName = _data["itemName"];
            this.budgetAmount = _data["budgetAmount"];
            this.isValid = _data["isValid"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): ProjectBudgetMigrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectBudgetMigrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costType"] = this.costType;
        data["itemName"] = this.itemName;
        data["budgetAmount"] = this.budgetAmount;
        data["isValid"] = this.isValid;
        data["error"] = this.error;
        return data;
    }

    clone(): ProjectBudgetMigrationDto {
        const json = this.toJSON();
        let result = new ProjectBudgetMigrationDto();
        result.init(json);
        return result;
    }
}

export interface IProjectBudgetMigrationDto {
    costType: string | undefined;
    itemName: string | undefined;
    budgetAmount: number;
    isValid: boolean;
    error: string | undefined;
}

export class ProjectDto implements IProjectDto {
    projectId: number;
    projectName: string | undefined;
    projectValue: number;
    commencementDate: moment.Moment | undefined;
    completionDate: moment.Moment | undefined;
    customerId: string;
    customer: Customer;
    totalBudgetCosts: number;
    preparedBy: string | undefined;
    approvedBy: string | undefined;
    tenantId: number;
    isApproved: boolean;
    projectItems: ProjectItemDto[] | undefined;
    projectInvoices: Bill[] | undefined;
    contractAgreementFileName: string | undefined;
    contractAgreementUrl: string | undefined;
    projectCompletionPercentage: number;

    constructor(data?: IProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.projectValue = _data["projectValue"];
            this.commencementDate = _data["commencementDate"] ? moment(_data["commencementDate"].toString()) : <any>undefined;
            this.completionDate = _data["completionDate"] ? moment(_data["completionDate"].toString()) : <any>undefined;
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : <any>undefined;
            this.totalBudgetCosts = _data["totalBudgetCosts"];
            this.preparedBy = _data["preparedBy"];
            this.approvedBy = _data["approvedBy"];
            this.tenantId = _data["tenantId"];
            this.isApproved = _data["isApproved"];
            if (Array.isArray(_data["projectItems"])) {
                this.projectItems = [] as any;
                for (let item of _data["projectItems"])
                    this.projectItems.push(ProjectItemDto.fromJS(item));
            }
            if (Array.isArray(_data["projectInvoices"])) {
                this.projectInvoices = [] as any;
                for (let item of _data["projectInvoices"])
                    this.projectInvoices.push(Bill.fromJS(item));
            }
            this.contractAgreementFileName = _data["contractAgreementFileName"];
            this.contractAgreementUrl = _data["contractAgreementUrl"];
            this.projectCompletionPercentage = _data["projectCompletionPercentage"];
        }
    }

    static fromJS(data: any): ProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectValue"] = this.projectValue;
        data["commencementDate"] = this.commencementDate ? this.commencementDate.toISOString() : <any>undefined;
        data["completionDate"] = this.completionDate ? this.completionDate.toISOString() : <any>undefined;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["totalBudgetCosts"] = this.totalBudgetCosts;
        data["preparedBy"] = this.preparedBy;
        data["approvedBy"] = this.approvedBy;
        data["tenantId"] = this.tenantId;
        data["isApproved"] = this.isApproved;
        if (Array.isArray(this.projectItems)) {
            data["projectItems"] = [];
            for (let item of this.projectItems)
                data["projectItems"].push(item.toJSON());
        }
        if (Array.isArray(this.projectInvoices)) {
            data["projectInvoices"] = [];
            for (let item of this.projectInvoices)
                data["projectInvoices"].push(item.toJSON());
        }
        data["contractAgreementFileName"] = this.contractAgreementFileName;
        data["contractAgreementUrl"] = this.contractAgreementUrl;
        data["projectCompletionPercentage"] = this.projectCompletionPercentage;
        return data;
    }

    clone(): ProjectDto {
        const json = this.toJSON();
        let result = new ProjectDto();
        result.init(json);
        return result;
    }
}

export interface IProjectDto {
    projectId: number;
    projectName: string | undefined;
    projectValue: number;
    commencementDate: moment.Moment | undefined;
    completionDate: moment.Moment | undefined;
    customerId: string;
    customer: Customer;
    totalBudgetCosts: number;
    preparedBy: string | undefined;
    approvedBy: string | undefined;
    tenantId: number;
    isApproved: boolean;
    projectItems: ProjectItemDto[] | undefined;
    projectInvoices: Bill[] | undefined;
    contractAgreementFileName: string | undefined;
    contractAgreementUrl: string | undefined;
    projectCompletionPercentage: number;
}

export class ProjectDtoPagedResultDto implements IProjectDtoPagedResultDto {
    items: ProjectDto[] | undefined;
    totalCount: number;

    constructor(data?: IProjectDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProjectDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ProjectDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ProjectDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProjectDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProjectDtoPagedResultDto {
    items: ProjectDto[] | undefined;
    totalCount: number;
}

export class ProjectItem implements IProjectItem {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    projectId: number;
    vendorId: number;
    customerId: string;
    itemName: string | undefined;
    description: string | undefined;
    date: moment.Moment;
    projectInvoiceId: string | undefined;
    projectInvoice: Bill;
    status: string | undefined;
    quantity: number;
    unitPrice: number;
    discount: number;
    tax: number;
    taxCode: string | undefined;
    type: string | undefined;
    cashbookId: number;
    scannedDocumentUrl: string | undefined;
    invoiceNumber: string | undefined;

    constructor(data?: IProjectItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.vendorId = _data["vendorId"];
            this.customerId = _data["customerId"];
            this.itemName = _data["itemName"];
            this.description = _data["description"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.projectInvoiceId = _data["projectInvoiceId"];
            this.projectInvoice = _data["projectInvoice"] ? Bill.fromJS(_data["projectInvoice"]) : <any>undefined;
            this.status = _data["status"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.discount = _data["discount"];
            this.tax = _data["tax"];
            this.taxCode = _data["taxCode"];
            this.type = _data["type"];
            this.cashbookId = _data["cashbookId"];
            this.scannedDocumentUrl = _data["scannedDocumentUrl"];
            this.invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): ProjectItem {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["vendorId"] = this.vendorId;
        data["customerId"] = this.customerId;
        data["itemName"] = this.itemName;
        data["description"] = this.description;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["projectInvoiceId"] = this.projectInvoiceId;
        data["projectInvoice"] = this.projectInvoice ? this.projectInvoice.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["discount"] = this.discount;
        data["tax"] = this.tax;
        data["taxCode"] = this.taxCode;
        data["type"] = this.type;
        data["cashbookId"] = this.cashbookId;
        data["scannedDocumentUrl"] = this.scannedDocumentUrl;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }

    clone(): ProjectItem {
        const json = this.toJSON();
        let result = new ProjectItem();
        result.init(json);
        return result;
    }
}

export interface IProjectItem {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    projectId: number;
    vendorId: number;
    customerId: string;
    itemName: string | undefined;
    description: string | undefined;
    date: moment.Moment;
    projectInvoiceId: string | undefined;
    projectInvoice: Bill;
    status: string | undefined;
    quantity: number;
    unitPrice: number;
    discount: number;
    tax: number;
    taxCode: string | undefined;
    type: string | undefined;
    cashbookId: number;
    scannedDocumentUrl: string | undefined;
    invoiceNumber: string | undefined;
}

export class ProjectItemDto implements IProjectItemDto {
    tenantId: number;
    projectId: number;
    vendorId: number;
    customerId: string;
    itemName: string | undefined;
    description: string | undefined;
    date: moment.Moment;
    projectInvoiceId: string | undefined;
    projectInvoice: Bill;
    status: string | undefined;
    quantity: number;
    unitPrice: number;
    discount: number;
    tax: number;
    taxCode: string | undefined;
    type: string | undefined;
    vendorInvoiceItemId: number;
    projectIssueNoteId: number;
    projectIssueNoteItemId: number;
    itemId: number;
    hoursList: ProjectStaffHours[] | undefined;
    transferToCost: boolean;
    vendorInvoice: VendorInvoice;
    projectIssueNote: WriteOffNote;
    cashbookId: number;
    cashbookNo: string | undefined;
    scannedDocumentUrl: string | undefined;
    billingAmount: number;
    billingRate: number;
    budgetAmount: number;
    invoiceNumber: string | undefined;

    constructor(data?: IProjectItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.vendorId = _data["vendorId"];
            this.customerId = _data["customerId"];
            this.itemName = _data["itemName"];
            this.description = _data["description"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.projectInvoiceId = _data["projectInvoiceId"];
            this.projectInvoice = _data["projectInvoice"] ? Bill.fromJS(_data["projectInvoice"]) : <any>undefined;
            this.status = _data["status"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.discount = _data["discount"];
            this.tax = _data["tax"];
            this.taxCode = _data["taxCode"];
            this.type = _data["type"];
            this.vendorInvoiceItemId = _data["vendorInvoiceItemId"];
            this.projectIssueNoteId = _data["projectIssueNoteId"];
            this.projectIssueNoteItemId = _data["projectIssueNoteItemId"];
            this.itemId = _data["itemId"];
            if (Array.isArray(_data["hoursList"])) {
                this.hoursList = [] as any;
                for (let item of _data["hoursList"])
                    this.hoursList.push(ProjectStaffHours.fromJS(item));
            }
            this.transferToCost = _data["transferToCost"];
            this.vendorInvoice = _data["vendorInvoice"] ? VendorInvoice.fromJS(_data["vendorInvoice"]) : <any>undefined;
            this.projectIssueNote = _data["projectIssueNote"] ? WriteOffNote.fromJS(_data["projectIssueNote"]) : <any>undefined;
            this.cashbookId = _data["cashbookId"];
            this.cashbookNo = _data["cashbookNo"];
            this.scannedDocumentUrl = _data["scannedDocumentUrl"];
            this.billingAmount = _data["billingAmount"];
            this.billingRate = _data["billingRate"];
            this.budgetAmount = _data["budgetAmount"];
            this.invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): ProjectItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["vendorId"] = this.vendorId;
        data["customerId"] = this.customerId;
        data["itemName"] = this.itemName;
        data["description"] = this.description;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["projectInvoiceId"] = this.projectInvoiceId;
        data["projectInvoice"] = this.projectInvoice ? this.projectInvoice.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["discount"] = this.discount;
        data["tax"] = this.tax;
        data["taxCode"] = this.taxCode;
        data["type"] = this.type;
        data["vendorInvoiceItemId"] = this.vendorInvoiceItemId;
        data["projectIssueNoteId"] = this.projectIssueNoteId;
        data["projectIssueNoteItemId"] = this.projectIssueNoteItemId;
        data["itemId"] = this.itemId;
        if (Array.isArray(this.hoursList)) {
            data["hoursList"] = [];
            for (let item of this.hoursList)
                data["hoursList"].push(item.toJSON());
        }
        data["transferToCost"] = this.transferToCost;
        data["vendorInvoice"] = this.vendorInvoice ? this.vendorInvoice.toJSON() : <any>undefined;
        data["projectIssueNote"] = this.projectIssueNote ? this.projectIssueNote.toJSON() : <any>undefined;
        data["cashbookId"] = this.cashbookId;
        data["cashbookNo"] = this.cashbookNo;
        data["scannedDocumentUrl"] = this.scannedDocumentUrl;
        data["billingAmount"] = this.billingAmount;
        data["billingRate"] = this.billingRate;
        data["budgetAmount"] = this.budgetAmount;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }

    clone(): ProjectItemDto {
        const json = this.toJSON();
        let result = new ProjectItemDto();
        result.init(json);
        return result;
    }
}

export interface IProjectItemDto {
    tenantId: number;
    projectId: number;
    vendorId: number;
    customerId: string;
    itemName: string | undefined;
    description: string | undefined;
    date: moment.Moment;
    projectInvoiceId: string | undefined;
    projectInvoice: Bill;
    status: string | undefined;
    quantity: number;
    unitPrice: number;
    discount: number;
    tax: number;
    taxCode: string | undefined;
    type: string | undefined;
    vendorInvoiceItemId: number;
    projectIssueNoteId: number;
    projectIssueNoteItemId: number;
    itemId: number;
    hoursList: ProjectStaffHours[] | undefined;
    transferToCost: boolean;
    vendorInvoice: VendorInvoice;
    projectIssueNote: WriteOffNote;
    cashbookId: number;
    cashbookNo: string | undefined;
    scannedDocumentUrl: string | undefined;
    billingAmount: number;
    billingRate: number;
    budgetAmount: number;
    invoiceNumber: string | undefined;
}

export class ProjectItemPagedResultDto implements IProjectItemPagedResultDto {
    items: ProjectItem[] | undefined;
    totalCount: number;

    constructor(data?: IProjectItemPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProjectItem.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ProjectItemPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectItemPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ProjectItemPagedResultDto {
        const json = this.toJSON();
        let result = new ProjectItemPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProjectItemPagedResultDto {
    items: ProjectItem[] | undefined;
    totalCount: number;
}

export class ProjectStaff implements IProjectStaff {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    projectId: number;
    project: Project;
    staffName: string | undefined;
    staffCode: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment | undefined;
    type: string | undefined;
    tenantId: number;
    contactNumber: string | undefined;
    email: string | undefined;
    profileLink: string | undefined;
    userId: number | undefined;
    note: string | undefined;

    constructor(data?: IProjectStaff) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            this.staffName = _data["staffName"];
            this.staffCode = _data["staffCode"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.tenantId = _data["tenantId"];
            this.contactNumber = _data["contactNumber"];
            this.email = _data["email"];
            this.profileLink = _data["profileLink"];
            this.userId = _data["userId"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): ProjectStaff {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectStaff();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["staffName"] = this.staffName;
        data["staffCode"] = this.staffCode;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["tenantId"] = this.tenantId;
        data["contactNumber"] = this.contactNumber;
        data["email"] = this.email;
        data["profileLink"] = this.profileLink;
        data["userId"] = this.userId;
        data["note"] = this.note;
        return data;
    }

    clone(): ProjectStaff {
        const json = this.toJSON();
        let result = new ProjectStaff();
        result.init(json);
        return result;
    }
}

export interface IProjectStaff {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    projectId: number;
    project: Project;
    staffName: string | undefined;
    staffCode: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment | undefined;
    type: string | undefined;
    tenantId: number;
    contactNumber: string | undefined;
    email: string | undefined;
    profileLink: string | undefined;
    userId: number | undefined;
    note: string | undefined;
}

export class ProjectStaffDto implements IProjectStaffDto {
    projectId: number;
    project: Project;
    staffName: string | undefined;
    staffCode: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment | undefined;
    type: string | undefined;
    tenantId: number;
    contactNumber: string | undefined;
    email: string | undefined;
    profileLink: string | undefined;
    hoursList: ProjectStaffHours[] | undefined;
    projectStaffId: number;
    userId: number | undefined;
    note: string | undefined;

    constructor(data?: IProjectStaffDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            this.staffName = _data["staffName"];
            this.staffCode = _data["staffCode"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.tenantId = _data["tenantId"];
            this.contactNumber = _data["contactNumber"];
            this.email = _data["email"];
            this.profileLink = _data["profileLink"];
            if (Array.isArray(_data["hoursList"])) {
                this.hoursList = [] as any;
                for (let item of _data["hoursList"])
                    this.hoursList.push(ProjectStaffHours.fromJS(item));
            }
            this.projectStaffId = _data["projectStaffId"];
            this.userId = _data["userId"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): ProjectStaffDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectStaffDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["staffName"] = this.staffName;
        data["staffCode"] = this.staffCode;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["tenantId"] = this.tenantId;
        data["contactNumber"] = this.contactNumber;
        data["email"] = this.email;
        data["profileLink"] = this.profileLink;
        if (Array.isArray(this.hoursList)) {
            data["hoursList"] = [];
            for (let item of this.hoursList)
                data["hoursList"].push(item.toJSON());
        }
        data["projectStaffId"] = this.projectStaffId;
        data["userId"] = this.userId;
        data["note"] = this.note;
        return data;
    }

    clone(): ProjectStaffDto {
        const json = this.toJSON();
        let result = new ProjectStaffDto();
        result.init(json);
        return result;
    }
}

export interface IProjectStaffDto {
    projectId: number;
    project: Project;
    staffName: string | undefined;
    staffCode: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment | undefined;
    type: string | undefined;
    tenantId: number;
    contactNumber: string | undefined;
    email: string | undefined;
    profileLink: string | undefined;
    hoursList: ProjectStaffHours[] | undefined;
    projectStaffId: number;
    userId: number | undefined;
    note: string | undefined;
}

export class ProjectStaffDtoPagedResultDto implements IProjectStaffDtoPagedResultDto {
    items: ProjectStaffDto[] | undefined;
    totalCount: number;

    constructor(data?: IProjectStaffDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProjectStaffDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ProjectStaffDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectStaffDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ProjectStaffDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProjectStaffDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProjectStaffDtoPagedResultDto {
    items: ProjectStaffDto[] | undefined;
    totalCount: number;
}

export class ProjectStaffHours implements IProjectStaffHours {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    projectId: number;
    projectStaffId: number;
    numberOfHours: number;
    costPerHour: number;
    workDescription: string | undefined;
    status: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    projectInvoiceId: string | undefined;
    projectInvoice: Bill;
    cashbookId: number;
    billingRate: number;

    constructor(data?: IProjectStaffHours) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.projectStaffId = _data["projectStaffId"];
            this.numberOfHours = _data["numberOfHours"];
            this.costPerHour = _data["costPerHour"];
            this.workDescription = _data["workDescription"];
            this.status = _data["status"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.projectInvoiceId = _data["projectInvoiceId"];
            this.projectInvoice = _data["projectInvoice"] ? Bill.fromJS(_data["projectInvoice"]) : <any>undefined;
            this.cashbookId = _data["cashbookId"];
            this.billingRate = _data["billingRate"];
        }
    }

    static fromJS(data: any): ProjectStaffHours {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectStaffHours();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["projectStaffId"] = this.projectStaffId;
        data["numberOfHours"] = this.numberOfHours;
        data["costPerHour"] = this.costPerHour;
        data["workDescription"] = this.workDescription;
        data["status"] = this.status;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["projectInvoiceId"] = this.projectInvoiceId;
        data["projectInvoice"] = this.projectInvoice ? this.projectInvoice.toJSON() : <any>undefined;
        data["cashbookId"] = this.cashbookId;
        data["billingRate"] = this.billingRate;
        return data;
    }

    clone(): ProjectStaffHours {
        const json = this.toJSON();
        let result = new ProjectStaffHours();
        result.init(json);
        return result;
    }
}

export interface IProjectStaffHours {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    projectId: number;
    projectStaffId: number;
    numberOfHours: number;
    costPerHour: number;
    workDescription: string | undefined;
    status: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    projectInvoiceId: string | undefined;
    projectInvoice: Bill;
    cashbookId: number;
    billingRate: number;
}

export class ProjectStaffHoursDto implements IProjectStaffHoursDto {
    tenantId: number;
    projectId: number;
    projectStaffId: number;
    numberOfHours: number;
    costPerHour: number;
    workDescription: string | undefined;
    status: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    projectInvoiceId: string | undefined;
    projectInvoice: Bill;
    cashbookId: number;
    billingRate: number;

    constructor(data?: IProjectStaffHoursDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.projectStaffId = _data["projectStaffId"];
            this.numberOfHours = _data["numberOfHours"];
            this.costPerHour = _data["costPerHour"];
            this.workDescription = _data["workDescription"];
            this.status = _data["status"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.projectInvoiceId = _data["projectInvoiceId"];
            this.projectInvoice = _data["projectInvoice"] ? Bill.fromJS(_data["projectInvoice"]) : <any>undefined;
            this.cashbookId = _data["cashbookId"];
            this.billingRate = _data["billingRate"];
        }
    }

    static fromJS(data: any): ProjectStaffHoursDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectStaffHoursDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["projectStaffId"] = this.projectStaffId;
        data["numberOfHours"] = this.numberOfHours;
        data["costPerHour"] = this.costPerHour;
        data["workDescription"] = this.workDescription;
        data["status"] = this.status;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["projectInvoiceId"] = this.projectInvoiceId;
        data["projectInvoice"] = this.projectInvoice ? this.projectInvoice.toJSON() : <any>undefined;
        data["cashbookId"] = this.cashbookId;
        data["billingRate"] = this.billingRate;
        return data;
    }

    clone(): ProjectStaffHoursDto {
        const json = this.toJSON();
        let result = new ProjectStaffHoursDto();
        result.init(json);
        return result;
    }
}

export interface IProjectStaffHoursDto {
    tenantId: number;
    projectId: number;
    projectStaffId: number;
    numberOfHours: number;
    costPerHour: number;
    workDescription: string | undefined;
    status: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    projectInvoiceId: string | undefined;
    projectInvoice: Bill;
    cashbookId: number;
    billingRate: number;
}

export class PurchaseOrderItem implements IPurchaseOrderItem {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    purchaseRequisitionItemId: number;
    originalGuid: string | undefined;
    originalCode: string | undefined;
    name: string | undefined;
    description: string | undefined;
    quantity: number;
    remainingQuantity: number;
    unitPrice: number;
    taxRate: number;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    taxCode: string | undefined;
    chargeTo: string | undefined;
    quality: string | undefined;
    discount: number;
    unitOfMeasurement: string | undefined;
    purchaseOrderId: number | undefined;
    projectId: number;
    assetItemMaintenanceId: string | undefined;
    assetItemMaintenance: NonCurrentAssetMaintenance;
    deliveryCost: number;
    deliveryCode: string | undefined;
    deliveryName: string | undefined;
    installationCost: number;
    installationCode: string | undefined;
    installationName: string | undefined;

    constructor(data?: IPurchaseOrderItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.purchaseRequisitionItemId = _data["purchaseRequisitionItemId"];
            this.originalGuid = _data["originalGuid"];
            this.originalCode = _data["originalCode"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.remainingQuantity = _data["remainingQuantity"];
            this.unitPrice = _data["unitPrice"];
            this.taxRate = _data["taxRate"];
            this.categoryCode = _data["categoryCode"];
            this.categoryName = _data["categoryName"];
            this.taxCode = _data["taxCode"];
            this.chargeTo = _data["chargeTo"];
            this.quality = _data["quality"];
            this.discount = _data["discount"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.purchaseOrderId = _data["purchaseOrderId"];
            this.projectId = _data["projectId"];
            this.assetItemMaintenanceId = _data["assetItemMaintenanceId"];
            this.assetItemMaintenance = _data["assetItemMaintenance"] ? NonCurrentAssetMaintenance.fromJS(_data["assetItemMaintenance"]) : <any>undefined;
            this.deliveryCost = _data["deliveryCost"];
            this.deliveryCode = _data["deliveryCode"];
            this.deliveryName = _data["deliveryName"];
            this.installationCost = _data["installationCost"];
            this.installationCode = _data["installationCode"];
            this.installationName = _data["installationName"];
        }
    }

    static fromJS(data: any): PurchaseOrderItem {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["purchaseRequisitionItemId"] = this.purchaseRequisitionItemId;
        data["originalGuid"] = this.originalGuid;
        data["originalCode"] = this.originalCode;
        data["name"] = this.name;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["remainingQuantity"] = this.remainingQuantity;
        data["unitPrice"] = this.unitPrice;
        data["taxRate"] = this.taxRate;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["taxCode"] = this.taxCode;
        data["chargeTo"] = this.chargeTo;
        data["quality"] = this.quality;
        data["discount"] = this.discount;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["purchaseOrderId"] = this.purchaseOrderId;
        data["projectId"] = this.projectId;
        data["assetItemMaintenanceId"] = this.assetItemMaintenanceId;
        data["assetItemMaintenance"] = this.assetItemMaintenance ? this.assetItemMaintenance.toJSON() : <any>undefined;
        data["deliveryCost"] = this.deliveryCost;
        data["deliveryCode"] = this.deliveryCode;
        data["deliveryName"] = this.deliveryName;
        data["installationCost"] = this.installationCost;
        data["installationCode"] = this.installationCode;
        data["installationName"] = this.installationName;
        return data;
    }

    clone(): PurchaseOrderItem {
        const json = this.toJSON();
        let result = new PurchaseOrderItem();
        result.init(json);
        return result;
    }
}

export interface IPurchaseOrderItem {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    purchaseRequisitionItemId: number;
    originalGuid: string | undefined;
    originalCode: string | undefined;
    name: string | undefined;
    description: string | undefined;
    quantity: number;
    remainingQuantity: number;
    unitPrice: number;
    taxRate: number;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    taxCode: string | undefined;
    chargeTo: string | undefined;
    quality: string | undefined;
    discount: number;
    unitOfMeasurement: string | undefined;
    purchaseOrderId: number | undefined;
    projectId: number;
    assetItemMaintenanceId: string | undefined;
    assetItemMaintenance: NonCurrentAssetMaintenance;
    deliveryCost: number;
    deliveryCode: string | undefined;
    deliveryName: string | undefined;
    installationCost: number;
    installationCode: string | undefined;
    installationName: string | undefined;
}

export class PurchaseOrderItemDto implements IPurchaseOrderItemDto {
    tenantId: number;
    purchaseRequisitionItemId: number;
    purchaseOrderItemId: number;
    originalGuid: string | undefined;
    originalCode: string | undefined;
    name: string | undefined;
    description: string | undefined;
    quantity: number;
    remainingQuantity: number;
    unitPrice: number;
    taxRate: number;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    taxCode: string | undefined;
    chargeTo: string | undefined;
    quality: string | undefined;
    discount: number;
    unitOfMeasurement: string | undefined;
    purchaseOrderId: number | undefined;
    projectId: number;
    assetItemMaintenanceId: string | undefined;
    assetItemMaintenance: NonCurrentAssetMaintenance;
    deliveryCost: number;
    deliveryCode: string | undefined;
    deliveryName: string | undefined;
    installationCost: number;
    installationCode: string | undefined;
    installationName: string | undefined;
    purchaseOrder: PurchaseOrders;

    constructor(data?: IPurchaseOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.purchaseRequisitionItemId = _data["purchaseRequisitionItemId"];
            this.purchaseOrderItemId = _data["purchaseOrderItemId"];
            this.originalGuid = _data["originalGuid"];
            this.originalCode = _data["originalCode"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.remainingQuantity = _data["remainingQuantity"];
            this.unitPrice = _data["unitPrice"];
            this.taxRate = _data["taxRate"];
            this.categoryCode = _data["categoryCode"];
            this.categoryName = _data["categoryName"];
            this.taxCode = _data["taxCode"];
            this.chargeTo = _data["chargeTo"];
            this.quality = _data["quality"];
            this.discount = _data["discount"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.purchaseOrderId = _data["purchaseOrderId"];
            this.projectId = _data["projectId"];
            this.assetItemMaintenanceId = _data["assetItemMaintenanceId"];
            this.assetItemMaintenance = _data["assetItemMaintenance"] ? NonCurrentAssetMaintenance.fromJS(_data["assetItemMaintenance"]) : <any>undefined;
            this.deliveryCost = _data["deliveryCost"];
            this.deliveryCode = _data["deliveryCode"];
            this.deliveryName = _data["deliveryName"];
            this.installationCost = _data["installationCost"];
            this.installationCode = _data["installationCode"];
            this.installationName = _data["installationName"];
            this.purchaseOrder = _data["purchaseOrder"] ? PurchaseOrders.fromJS(_data["purchaseOrder"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PurchaseOrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["purchaseRequisitionItemId"] = this.purchaseRequisitionItemId;
        data["purchaseOrderItemId"] = this.purchaseOrderItemId;
        data["originalGuid"] = this.originalGuid;
        data["originalCode"] = this.originalCode;
        data["name"] = this.name;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["remainingQuantity"] = this.remainingQuantity;
        data["unitPrice"] = this.unitPrice;
        data["taxRate"] = this.taxRate;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["taxCode"] = this.taxCode;
        data["chargeTo"] = this.chargeTo;
        data["quality"] = this.quality;
        data["discount"] = this.discount;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["purchaseOrderId"] = this.purchaseOrderId;
        data["projectId"] = this.projectId;
        data["assetItemMaintenanceId"] = this.assetItemMaintenanceId;
        data["assetItemMaintenance"] = this.assetItemMaintenance ? this.assetItemMaintenance.toJSON() : <any>undefined;
        data["deliveryCost"] = this.deliveryCost;
        data["deliveryCode"] = this.deliveryCode;
        data["deliveryName"] = this.deliveryName;
        data["installationCost"] = this.installationCost;
        data["installationCode"] = this.installationCode;
        data["installationName"] = this.installationName;
        data["purchaseOrder"] = this.purchaseOrder ? this.purchaseOrder.toJSON() : <any>undefined;
        return data;
    }

    clone(): PurchaseOrderItemDto {
        const json = this.toJSON();
        let result = new PurchaseOrderItemDto();
        result.init(json);
        return result;
    }
}

export interface IPurchaseOrderItemDto {
    tenantId: number;
    purchaseRequisitionItemId: number;
    purchaseOrderItemId: number;
    originalGuid: string | undefined;
    originalCode: string | undefined;
    name: string | undefined;
    description: string | undefined;
    quantity: number;
    remainingQuantity: number;
    unitPrice: number;
    taxRate: number;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    taxCode: string | undefined;
    chargeTo: string | undefined;
    quality: string | undefined;
    discount: number;
    unitOfMeasurement: string | undefined;
    purchaseOrderId: number | undefined;
    projectId: number;
    assetItemMaintenanceId: string | undefined;
    assetItemMaintenance: NonCurrentAssetMaintenance;
    deliveryCost: number;
    deliveryCode: string | undefined;
    deliveryName: string | undefined;
    installationCost: number;
    installationCode: string | undefined;
    installationName: string | undefined;
    purchaseOrder: PurchaseOrders;
}

export class PurchaseOrderItemPagedResultDto implements IPurchaseOrderItemPagedResultDto {
    items: PurchaseOrderItem[] | undefined;
    totalCount: number;

    constructor(data?: IPurchaseOrderItemPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PurchaseOrderItem.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PurchaseOrderItemPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrderItemPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PurchaseOrderItemPagedResultDto {
        const json = this.toJSON();
        let result = new PurchaseOrderItemPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPurchaseOrderItemPagedResultDto {
    items: PurchaseOrderItem[] | undefined;
    totalCount: number;
}

export class PurchaseOrders implements IPurchaseOrders {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    status: string | undefined;
    requestor: number;
    approver: number;
    poReferenceNumber: string | undefined;
    vendorId: number;
    vendor: Vendor;
    invoiceReferenceNumber: string | undefined;
    grnNumber: string | undefined;
    totalAmount: number;
    totalTax: number;
    deliveryCost: number;
    installationCost: number;
    vendorTotalAmount: number;
    vendorTotalTax: number;
    vendorDeliveryCost: number;
    chargeTo: string | undefined;
    tenantId: number;
    prReferenceNumber: string | undefined;
    requestorDeliveryAddress: string | undefined;
    requestorInvoiceAddress: string | undefined;
    requestorContactNo: string | undefined;
    requestorEmail: string | undefined;
    requestorName: string | undefined;
    requestorDepartment: string | undefined;
    approverName: string | undefined;
    deliveryDate: moment.Moment;
    remarks: string | undefined;
    attachmentUrl1: string | undefined;
    attachmentUrl2: string | undefined;
    paymentTerm: number;
    issueDate: moment.Moment;
    dueDate: moment.Moment;
    quotationId: number;
    quotationReferenceNumber: string | undefined;
    ccEmails: string | undefined;
    invoiceIssueDate: moment.Moment;
    negotiateMessage: string | undefined;
    addOnFeatures: string | undefined;
    vendorPurchaseAmount: number;
    isBlanketed: boolean;
    startDate: moment.Moment;
    endDate: moment.Moment;
    isPurchaseWithoutPo: boolean;
    isMigrated: boolean;
    purchaseRequisitionId: number;
    purchaseOrderItems: PurchaseOrderItem[] | undefined;
    postMigration: boolean;
    currency: string | undefined;
    exchangeRate: number;

    constructor(data?: IPurchaseOrders) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.requestor = _data["requestor"];
            this.approver = _data["approver"];
            this.poReferenceNumber = _data["poReferenceNumber"];
            this.vendorId = _data["vendorId"];
            this.vendor = _data["vendor"] ? Vendor.fromJS(_data["vendor"]) : <any>undefined;
            this.invoiceReferenceNumber = _data["invoiceReferenceNumber"];
            this.grnNumber = _data["grnNumber"];
            this.totalAmount = _data["totalAmount"];
            this.totalTax = _data["totalTax"];
            this.deliveryCost = _data["deliveryCost"];
            this.installationCost = _data["installationCost"];
            this.vendorTotalAmount = _data["vendorTotalAmount"];
            this.vendorTotalTax = _data["vendorTotalTax"];
            this.vendorDeliveryCost = _data["vendorDeliveryCost"];
            this.chargeTo = _data["chargeTo"];
            this.tenantId = _data["tenantId"];
            this.prReferenceNumber = _data["prReferenceNumber"];
            this.requestorDeliveryAddress = _data["requestorDeliveryAddress"];
            this.requestorInvoiceAddress = _data["requestorInvoiceAddress"];
            this.requestorContactNo = _data["requestorContactNo"];
            this.requestorEmail = _data["requestorEmail"];
            this.requestorName = _data["requestorName"];
            this.requestorDepartment = _data["requestorDepartment"];
            this.approverName = _data["approverName"];
            this.deliveryDate = _data["deliveryDate"] ? moment(_data["deliveryDate"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.attachmentUrl1 = _data["attachmentUrl1"];
            this.attachmentUrl2 = _data["attachmentUrl2"];
            this.paymentTerm = _data["paymentTerm"];
            this.issueDate = _data["issueDate"] ? moment(_data["issueDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.quotationId = _data["quotationId"];
            this.quotationReferenceNumber = _data["quotationReferenceNumber"];
            this.ccEmails = _data["ccEmails"];
            this.invoiceIssueDate = _data["invoiceIssueDate"] ? moment(_data["invoiceIssueDate"].toString()) : <any>undefined;
            this.negotiateMessage = _data["negotiateMessage"];
            this.addOnFeatures = _data["addOnFeatures"];
            this.vendorPurchaseAmount = _data["vendorPurchaseAmount"];
            this.isBlanketed = _data["isBlanketed"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.isPurchaseWithoutPo = _data["isPurchaseWithoutPo"];
            this.isMigrated = _data["isMigrated"];
            this.purchaseRequisitionId = _data["purchaseRequisitionId"];
            if (Array.isArray(_data["purchaseOrderItems"])) {
                this.purchaseOrderItems = [] as any;
                for (let item of _data["purchaseOrderItems"])
                    this.purchaseOrderItems.push(PurchaseOrderItem.fromJS(item));
            }
            this.postMigration = _data["postMigration"];
            this.currency = _data["currency"];
            this.exchangeRate = _data["exchangeRate"];
        }
    }

    static fromJS(data: any): PurchaseOrders {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrders();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["requestor"] = this.requestor;
        data["approver"] = this.approver;
        data["poReferenceNumber"] = this.poReferenceNumber;
        data["vendorId"] = this.vendorId;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        data["invoiceReferenceNumber"] = this.invoiceReferenceNumber;
        data["grnNumber"] = this.grnNumber;
        data["totalAmount"] = this.totalAmount;
        data["totalTax"] = this.totalTax;
        data["deliveryCost"] = this.deliveryCost;
        data["installationCost"] = this.installationCost;
        data["vendorTotalAmount"] = this.vendorTotalAmount;
        data["vendorTotalTax"] = this.vendorTotalTax;
        data["vendorDeliveryCost"] = this.vendorDeliveryCost;
        data["chargeTo"] = this.chargeTo;
        data["tenantId"] = this.tenantId;
        data["prReferenceNumber"] = this.prReferenceNumber;
        data["requestorDeliveryAddress"] = this.requestorDeliveryAddress;
        data["requestorInvoiceAddress"] = this.requestorInvoiceAddress;
        data["requestorContactNo"] = this.requestorContactNo;
        data["requestorEmail"] = this.requestorEmail;
        data["requestorName"] = this.requestorName;
        data["requestorDepartment"] = this.requestorDepartment;
        data["approverName"] = this.approverName;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["attachmentUrl1"] = this.attachmentUrl1;
        data["attachmentUrl2"] = this.attachmentUrl2;
        data["paymentTerm"] = this.paymentTerm;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["quotationId"] = this.quotationId;
        data["quotationReferenceNumber"] = this.quotationReferenceNumber;
        data["ccEmails"] = this.ccEmails;
        data["invoiceIssueDate"] = this.invoiceIssueDate ? this.invoiceIssueDate.toISOString() : <any>undefined;
        data["negotiateMessage"] = this.negotiateMessage;
        data["addOnFeatures"] = this.addOnFeatures;
        data["vendorPurchaseAmount"] = this.vendorPurchaseAmount;
        data["isBlanketed"] = this.isBlanketed;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isPurchaseWithoutPo"] = this.isPurchaseWithoutPo;
        data["isMigrated"] = this.isMigrated;
        data["purchaseRequisitionId"] = this.purchaseRequisitionId;
        if (Array.isArray(this.purchaseOrderItems)) {
            data["purchaseOrderItems"] = [];
            for (let item of this.purchaseOrderItems)
                data["purchaseOrderItems"].push(item.toJSON());
        }
        data["postMigration"] = this.postMigration;
        data["currency"] = this.currency;
        data["exchangeRate"] = this.exchangeRate;
        return data;
    }

    clone(): PurchaseOrders {
        const json = this.toJSON();
        let result = new PurchaseOrders();
        result.init(json);
        return result;
    }
}

export interface IPurchaseOrders {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    status: string | undefined;
    requestor: number;
    approver: number;
    poReferenceNumber: string | undefined;
    vendorId: number;
    vendor: Vendor;
    invoiceReferenceNumber: string | undefined;
    grnNumber: string | undefined;
    totalAmount: number;
    totalTax: number;
    deliveryCost: number;
    installationCost: number;
    vendorTotalAmount: number;
    vendorTotalTax: number;
    vendorDeliveryCost: number;
    chargeTo: string | undefined;
    tenantId: number;
    prReferenceNumber: string | undefined;
    requestorDeliveryAddress: string | undefined;
    requestorInvoiceAddress: string | undefined;
    requestorContactNo: string | undefined;
    requestorEmail: string | undefined;
    requestorName: string | undefined;
    requestorDepartment: string | undefined;
    approverName: string | undefined;
    deliveryDate: moment.Moment;
    remarks: string | undefined;
    attachmentUrl1: string | undefined;
    attachmentUrl2: string | undefined;
    paymentTerm: number;
    issueDate: moment.Moment;
    dueDate: moment.Moment;
    quotationId: number;
    quotationReferenceNumber: string | undefined;
    ccEmails: string | undefined;
    invoiceIssueDate: moment.Moment;
    negotiateMessage: string | undefined;
    addOnFeatures: string | undefined;
    vendorPurchaseAmount: number;
    isBlanketed: boolean;
    startDate: moment.Moment;
    endDate: moment.Moment;
    isPurchaseWithoutPo: boolean;
    isMigrated: boolean;
    purchaseRequisitionId: number;
    purchaseOrderItems: PurchaseOrderItem[] | undefined;
    postMigration: boolean;
    currency: string | undefined;
    exchangeRate: number;
}

export class PurchaseOrdersDto implements IPurchaseOrdersDto {
    quotationId: number;
    purchaseOrderId: number;
    status: string | undefined;
    requestor: number;
    approver: number;
    poReferenceNumber: string | undefined;
    vendorId: number;
    vendor: Vendor;
    invoiceReferenceNumber: string | undefined;
    grnNumber: string | undefined;
    totalAmount: number;
    totalTax: number;
    deliveryCost: number;
    installationCost: number;
    vendorTotalAmount: number;
    vendorTotalTax: number;
    vendorDeliveryCost: number;
    chargeTo: string | undefined;
    tenantId: number;
    prReferenceNumber: string | undefined;
    requestorDeliveryAddress: string | undefined;
    requestorInvoiceAddress: string | undefined;
    requestorContactNo: string | undefined;
    requestorEmail: string | undefined;
    requestorName: string | undefined;
    requestorDepartment: string | undefined;
    approverName: string | undefined;
    deliveryDate: moment.Moment;
    remarks: string | undefined;
    attachmentUrl1: string | undefined;
    attachmentUrl2: string | undefined;
    paymentTerm: number;
    issueDate: moment.Moment;
    dueDate: moment.Moment;
    quotationReferenceNumber: string | undefined;
    ccEmails: string | undefined;
    invoiceIssueDate: moment.Moment;
    negotiateMessage: string | undefined;
    addOnFeatures: string | undefined;
    vendorPurchaseAmount: number;
    isBlanketed: boolean;
    startDate: moment.Moment;
    endDate: moment.Moment;
    isPurchaseWithoutPo: boolean;
    isMigrated: boolean;
    purchaseRequisitionId: number;
    purchaseRequisition: PurchaseRequisition;
    postMigration: boolean;
    currency: string | undefined;
    exchangeRate: number;

    constructor(data?: IPurchaseOrdersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quotationId = _data["quotationId"];
            this.purchaseOrderId = _data["purchaseOrderId"];
            this.status = _data["status"];
            this.requestor = _data["requestor"];
            this.approver = _data["approver"];
            this.poReferenceNumber = _data["poReferenceNumber"];
            this.vendorId = _data["vendorId"];
            this.vendor = _data["vendor"] ? Vendor.fromJS(_data["vendor"]) : <any>undefined;
            this.invoiceReferenceNumber = _data["invoiceReferenceNumber"];
            this.grnNumber = _data["grnNumber"];
            this.totalAmount = _data["totalAmount"];
            this.totalTax = _data["totalTax"];
            this.deliveryCost = _data["deliveryCost"];
            this.installationCost = _data["installationCost"];
            this.vendorTotalAmount = _data["vendorTotalAmount"];
            this.vendorTotalTax = _data["vendorTotalTax"];
            this.vendorDeliveryCost = _data["vendorDeliveryCost"];
            this.chargeTo = _data["chargeTo"];
            this.tenantId = _data["tenantId"];
            this.prReferenceNumber = _data["prReferenceNumber"];
            this.requestorDeliveryAddress = _data["requestorDeliveryAddress"];
            this.requestorInvoiceAddress = _data["requestorInvoiceAddress"];
            this.requestorContactNo = _data["requestorContactNo"];
            this.requestorEmail = _data["requestorEmail"];
            this.requestorName = _data["requestorName"];
            this.requestorDepartment = _data["requestorDepartment"];
            this.approverName = _data["approverName"];
            this.deliveryDate = _data["deliveryDate"] ? moment(_data["deliveryDate"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.attachmentUrl1 = _data["attachmentUrl1"];
            this.attachmentUrl2 = _data["attachmentUrl2"];
            this.paymentTerm = _data["paymentTerm"];
            this.issueDate = _data["issueDate"] ? moment(_data["issueDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.quotationReferenceNumber = _data["quotationReferenceNumber"];
            this.ccEmails = _data["ccEmails"];
            this.invoiceIssueDate = _data["invoiceIssueDate"] ? moment(_data["invoiceIssueDate"].toString()) : <any>undefined;
            this.negotiateMessage = _data["negotiateMessage"];
            this.addOnFeatures = _data["addOnFeatures"];
            this.vendorPurchaseAmount = _data["vendorPurchaseAmount"];
            this.isBlanketed = _data["isBlanketed"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.isPurchaseWithoutPo = _data["isPurchaseWithoutPo"];
            this.isMigrated = _data["isMigrated"];
            this.purchaseRequisitionId = _data["purchaseRequisitionId"];
            this.purchaseRequisition = _data["purchaseRequisition"] ? PurchaseRequisition.fromJS(_data["purchaseRequisition"]) : <any>undefined;
            this.postMigration = _data["postMigration"];
            this.currency = _data["currency"];
            this.exchangeRate = _data["exchangeRate"];
        }
    }

    static fromJS(data: any): PurchaseOrdersDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrdersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quotationId"] = this.quotationId;
        data["purchaseOrderId"] = this.purchaseOrderId;
        data["status"] = this.status;
        data["requestor"] = this.requestor;
        data["approver"] = this.approver;
        data["poReferenceNumber"] = this.poReferenceNumber;
        data["vendorId"] = this.vendorId;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        data["invoiceReferenceNumber"] = this.invoiceReferenceNumber;
        data["grnNumber"] = this.grnNumber;
        data["totalAmount"] = this.totalAmount;
        data["totalTax"] = this.totalTax;
        data["deliveryCost"] = this.deliveryCost;
        data["installationCost"] = this.installationCost;
        data["vendorTotalAmount"] = this.vendorTotalAmount;
        data["vendorTotalTax"] = this.vendorTotalTax;
        data["vendorDeliveryCost"] = this.vendorDeliveryCost;
        data["chargeTo"] = this.chargeTo;
        data["tenantId"] = this.tenantId;
        data["prReferenceNumber"] = this.prReferenceNumber;
        data["requestorDeliveryAddress"] = this.requestorDeliveryAddress;
        data["requestorInvoiceAddress"] = this.requestorInvoiceAddress;
        data["requestorContactNo"] = this.requestorContactNo;
        data["requestorEmail"] = this.requestorEmail;
        data["requestorName"] = this.requestorName;
        data["requestorDepartment"] = this.requestorDepartment;
        data["approverName"] = this.approverName;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["attachmentUrl1"] = this.attachmentUrl1;
        data["attachmentUrl2"] = this.attachmentUrl2;
        data["paymentTerm"] = this.paymentTerm;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["quotationReferenceNumber"] = this.quotationReferenceNumber;
        data["ccEmails"] = this.ccEmails;
        data["invoiceIssueDate"] = this.invoiceIssueDate ? this.invoiceIssueDate.toISOString() : <any>undefined;
        data["negotiateMessage"] = this.negotiateMessage;
        data["addOnFeatures"] = this.addOnFeatures;
        data["vendorPurchaseAmount"] = this.vendorPurchaseAmount;
        data["isBlanketed"] = this.isBlanketed;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isPurchaseWithoutPo"] = this.isPurchaseWithoutPo;
        data["isMigrated"] = this.isMigrated;
        data["purchaseRequisitionId"] = this.purchaseRequisitionId;
        data["purchaseRequisition"] = this.purchaseRequisition ? this.purchaseRequisition.toJSON() : <any>undefined;
        data["postMigration"] = this.postMigration;
        data["currency"] = this.currency;
        data["exchangeRate"] = this.exchangeRate;
        return data;
    }

    clone(): PurchaseOrdersDto {
        const json = this.toJSON();
        let result = new PurchaseOrdersDto();
        result.init(json);
        return result;
    }
}

export interface IPurchaseOrdersDto {
    quotationId: number;
    purchaseOrderId: number;
    status: string | undefined;
    requestor: number;
    approver: number;
    poReferenceNumber: string | undefined;
    vendorId: number;
    vendor: Vendor;
    invoiceReferenceNumber: string | undefined;
    grnNumber: string | undefined;
    totalAmount: number;
    totalTax: number;
    deliveryCost: number;
    installationCost: number;
    vendorTotalAmount: number;
    vendorTotalTax: number;
    vendorDeliveryCost: number;
    chargeTo: string | undefined;
    tenantId: number;
    prReferenceNumber: string | undefined;
    requestorDeliveryAddress: string | undefined;
    requestorInvoiceAddress: string | undefined;
    requestorContactNo: string | undefined;
    requestorEmail: string | undefined;
    requestorName: string | undefined;
    requestorDepartment: string | undefined;
    approverName: string | undefined;
    deliveryDate: moment.Moment;
    remarks: string | undefined;
    attachmentUrl1: string | undefined;
    attachmentUrl2: string | undefined;
    paymentTerm: number;
    issueDate: moment.Moment;
    dueDate: moment.Moment;
    quotationReferenceNumber: string | undefined;
    ccEmails: string | undefined;
    invoiceIssueDate: moment.Moment;
    negotiateMessage: string | undefined;
    addOnFeatures: string | undefined;
    vendorPurchaseAmount: number;
    isBlanketed: boolean;
    startDate: moment.Moment;
    endDate: moment.Moment;
    isPurchaseWithoutPo: boolean;
    isMigrated: boolean;
    purchaseRequisitionId: number;
    purchaseRequisition: PurchaseRequisition;
    postMigration: boolean;
    currency: string | undefined;
    exchangeRate: number;
}

export class PurchaseOrdersDtoPagedResultDto implements IPurchaseOrdersDtoPagedResultDto {
    items: PurchaseOrdersDto[] | undefined;
    totalCount: number;

    constructor(data?: IPurchaseOrdersDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PurchaseOrdersDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PurchaseOrdersDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrdersDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PurchaseOrdersDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PurchaseOrdersDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPurchaseOrdersDtoPagedResultDto {
    items: PurchaseOrdersDto[] | undefined;
    totalCount: number;
}

export class PurchaseOrdersPagedResultDto implements IPurchaseOrdersPagedResultDto {
    items: PurchaseOrders[] | undefined;
    totalCount: number;

    constructor(data?: IPurchaseOrdersPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PurchaseOrders.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PurchaseOrdersPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseOrdersPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PurchaseOrdersPagedResultDto {
        const json = this.toJSON();
        let result = new PurchaseOrdersPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPurchaseOrdersPagedResultDto {
    items: PurchaseOrders[] | undefined;
    totalCount: number;
}

export class PurchaseRequisition implements IPurchaseRequisition {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    employeeUserId: number;
    employeeName: string | undefined;
    deliveryDate: moment.Moment;
    remarks: string | undefined;
    capexJustification: string | undefined;
    opexJustification: string | undefined;
    resaleJustification: string | undefined;
    manufacturingJustification: string | undefined;
    projectJustification: string | undefined;
    attachmentUrl1: string | undefined;
    attachmentUrl2: string | undefined;
    status: number;
    referenceNo: string | undefined;
    deliveryAddress: string | undefined;
    requestorId: number;
    requestedDate: moment.Moment;
    approvedDate: moment.Moment;
    rejectedDate: moment.Moment;
    rejectedReason: string | undefined;
    isDraftApproved: boolean;
    isApproved: boolean;
    isCalledForQuotation: boolean;
    approverUserId: number;
    approverName: string | undefined;
    approverEmail: string | undefined;
    finalApproverUserId: number;
    finalApproverName: string | undefined;
    finalApproverEmail: string | undefined;
    requestorName: string | undefined;
    requestorContactNo: string | undefined;
    requestorEmail: string | undefined;
    requestorDeliveryAddress: string | undefined;
    requestorInvoiceAddress: string | undefined;
    requestorDepartment: string | undefined;
    totalAmount: number;
    totalTax: number;
    ccEmails: string | undefined;
    justificationForSelection: string | undefined;
    isSkipApproval: boolean;
    isSkipEverything: boolean;
    totalCapexAmount: number;
    totalOpexAmount: number;
    totalResaleAmount: number;
    totalManufacturingAmount: number;
    totalProjectAmount: number;
    boardResolutionAttachmentUrl: string | undefined;
    boardResolutionReference: string | undefined;
    boardResolutionDate: moment.Moment;
    isBlanketed: boolean;
    startDate: moment.Moment;
    endDate: moment.Moment;
    isPurchaseWithoutPo: boolean;
    isMigrated: boolean;
    currency: string | undefined;
    exchangeRate: number;
    deliveryCost: number;
    installationCost: number;
    vendorId: number | undefined;
    vendorObject: Vendor;
    purchaseOrdersId: number | undefined;
    purchaseOrders: PurchaseOrders;
    vendorInvoiceId: number | undefined;
    vendorInvoices: VendorInvoice;
    goodsReceivedNoteId: number | undefined;
    goodsReceivedNote: GoodsReceivedNotes;
    quotationId: number | undefined;
    purchaseRequisitionItems: PurchaseRequisitionItems[] | undefined;
    postMigration: boolean;

    constructor(data?: IPurchaseRequisition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.employeeUserId = _data["employeeUserId"];
            this.employeeName = _data["employeeName"];
            this.deliveryDate = _data["deliveryDate"] ? moment(_data["deliveryDate"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.capexJustification = _data["capexJustification"];
            this.opexJustification = _data["opexJustification"];
            this.resaleJustification = _data["resaleJustification"];
            this.manufacturingJustification = _data["manufacturingJustification"];
            this.projectJustification = _data["projectJustification"];
            this.attachmentUrl1 = _data["attachmentUrl1"];
            this.attachmentUrl2 = _data["attachmentUrl2"];
            this.status = _data["status"];
            this.referenceNo = _data["referenceNo"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.requestorId = _data["requestorId"];
            this.requestedDate = _data["requestedDate"] ? moment(_data["requestedDate"].toString()) : <any>undefined;
            this.approvedDate = _data["approvedDate"] ? moment(_data["approvedDate"].toString()) : <any>undefined;
            this.rejectedDate = _data["rejectedDate"] ? moment(_data["rejectedDate"].toString()) : <any>undefined;
            this.rejectedReason = _data["rejectedReason"];
            this.isDraftApproved = _data["isDraftApproved"];
            this.isApproved = _data["isApproved"];
            this.isCalledForQuotation = _data["isCalledForQuotation"];
            this.approverUserId = _data["approverUserId"];
            this.approverName = _data["approverName"];
            this.approverEmail = _data["approverEmail"];
            this.finalApproverUserId = _data["finalApproverUserId"];
            this.finalApproverName = _data["finalApproverName"];
            this.finalApproverEmail = _data["finalApproverEmail"];
            this.requestorName = _data["requestorName"];
            this.requestorContactNo = _data["requestorContactNo"];
            this.requestorEmail = _data["requestorEmail"];
            this.requestorDeliveryAddress = _data["requestorDeliveryAddress"];
            this.requestorInvoiceAddress = _data["requestorInvoiceAddress"];
            this.requestorDepartment = _data["requestorDepartment"];
            this.totalAmount = _data["totalAmount"];
            this.totalTax = _data["totalTax"];
            this.ccEmails = _data["ccEmails"];
            this.justificationForSelection = _data["justificationForSelection"];
            this.isSkipApproval = _data["isSkipApproval"];
            this.isSkipEverything = _data["isSkipEverything"];
            this.totalCapexAmount = _data["totalCapexAmount"];
            this.totalOpexAmount = _data["totalOpexAmount"];
            this.totalResaleAmount = _data["totalResaleAmount"];
            this.totalManufacturingAmount = _data["totalManufacturingAmount"];
            this.totalProjectAmount = _data["totalProjectAmount"];
            this.boardResolutionAttachmentUrl = _data["boardResolutionAttachmentUrl"];
            this.boardResolutionReference = _data["boardResolutionReference"];
            this.boardResolutionDate = _data["boardResolutionDate"] ? moment(_data["boardResolutionDate"].toString()) : <any>undefined;
            this.isBlanketed = _data["isBlanketed"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.isPurchaseWithoutPo = _data["isPurchaseWithoutPo"];
            this.isMigrated = _data["isMigrated"];
            this.currency = _data["currency"];
            this.exchangeRate = _data["exchangeRate"];
            this.deliveryCost = _data["deliveryCost"];
            this.installationCost = _data["installationCost"];
            this.vendorId = _data["vendorId"];
            this.vendorObject = _data["vendorObject"] ? Vendor.fromJS(_data["vendorObject"]) : <any>undefined;
            this.purchaseOrdersId = _data["purchaseOrdersId"];
            this.purchaseOrders = _data["purchaseOrders"] ? PurchaseOrders.fromJS(_data["purchaseOrders"]) : <any>undefined;
            this.vendorInvoiceId = _data["vendorInvoiceId"];
            this.vendorInvoices = _data["vendorInvoices"] ? VendorInvoice.fromJS(_data["vendorInvoices"]) : <any>undefined;
            this.goodsReceivedNoteId = _data["goodsReceivedNoteId"];
            this.goodsReceivedNote = _data["goodsReceivedNote"] ? GoodsReceivedNotes.fromJS(_data["goodsReceivedNote"]) : <any>undefined;
            this.quotationId = _data["quotationId"];
            if (Array.isArray(_data["purchaseRequisitionItems"])) {
                this.purchaseRequisitionItems = [] as any;
                for (let item of _data["purchaseRequisitionItems"])
                    this.purchaseRequisitionItems.push(PurchaseRequisitionItems.fromJS(item));
            }
            this.postMigration = _data["postMigration"];
        }
    }

    static fromJS(data: any): PurchaseRequisition {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseRequisition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["employeeUserId"] = this.employeeUserId;
        data["employeeName"] = this.employeeName;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["capexJustification"] = this.capexJustification;
        data["opexJustification"] = this.opexJustification;
        data["resaleJustification"] = this.resaleJustification;
        data["manufacturingJustification"] = this.manufacturingJustification;
        data["projectJustification"] = this.projectJustification;
        data["attachmentUrl1"] = this.attachmentUrl1;
        data["attachmentUrl2"] = this.attachmentUrl2;
        data["status"] = this.status;
        data["referenceNo"] = this.referenceNo;
        data["deliveryAddress"] = this.deliveryAddress;
        data["requestorId"] = this.requestorId;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>undefined;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["rejectedDate"] = this.rejectedDate ? this.rejectedDate.toISOString() : <any>undefined;
        data["rejectedReason"] = this.rejectedReason;
        data["isDraftApproved"] = this.isDraftApproved;
        data["isApproved"] = this.isApproved;
        data["isCalledForQuotation"] = this.isCalledForQuotation;
        data["approverUserId"] = this.approverUserId;
        data["approverName"] = this.approverName;
        data["approverEmail"] = this.approverEmail;
        data["finalApproverUserId"] = this.finalApproverUserId;
        data["finalApproverName"] = this.finalApproverName;
        data["finalApproverEmail"] = this.finalApproverEmail;
        data["requestorName"] = this.requestorName;
        data["requestorContactNo"] = this.requestorContactNo;
        data["requestorEmail"] = this.requestorEmail;
        data["requestorDeliveryAddress"] = this.requestorDeliveryAddress;
        data["requestorInvoiceAddress"] = this.requestorInvoiceAddress;
        data["requestorDepartment"] = this.requestorDepartment;
        data["totalAmount"] = this.totalAmount;
        data["totalTax"] = this.totalTax;
        data["ccEmails"] = this.ccEmails;
        data["justificationForSelection"] = this.justificationForSelection;
        data["isSkipApproval"] = this.isSkipApproval;
        data["isSkipEverything"] = this.isSkipEverything;
        data["totalCapexAmount"] = this.totalCapexAmount;
        data["totalOpexAmount"] = this.totalOpexAmount;
        data["totalResaleAmount"] = this.totalResaleAmount;
        data["totalManufacturingAmount"] = this.totalManufacturingAmount;
        data["totalProjectAmount"] = this.totalProjectAmount;
        data["boardResolutionAttachmentUrl"] = this.boardResolutionAttachmentUrl;
        data["boardResolutionReference"] = this.boardResolutionReference;
        data["boardResolutionDate"] = this.boardResolutionDate ? this.boardResolutionDate.toISOString() : <any>undefined;
        data["isBlanketed"] = this.isBlanketed;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isPurchaseWithoutPo"] = this.isPurchaseWithoutPo;
        data["isMigrated"] = this.isMigrated;
        data["currency"] = this.currency;
        data["exchangeRate"] = this.exchangeRate;
        data["deliveryCost"] = this.deliveryCost;
        data["installationCost"] = this.installationCost;
        data["vendorId"] = this.vendorId;
        data["vendorObject"] = this.vendorObject ? this.vendorObject.toJSON() : <any>undefined;
        data["purchaseOrdersId"] = this.purchaseOrdersId;
        data["purchaseOrders"] = this.purchaseOrders ? this.purchaseOrders.toJSON() : <any>undefined;
        data["vendorInvoiceId"] = this.vendorInvoiceId;
        data["vendorInvoices"] = this.vendorInvoices ? this.vendorInvoices.toJSON() : <any>undefined;
        data["goodsReceivedNoteId"] = this.goodsReceivedNoteId;
        data["goodsReceivedNote"] = this.goodsReceivedNote ? this.goodsReceivedNote.toJSON() : <any>undefined;
        data["quotationId"] = this.quotationId;
        if (Array.isArray(this.purchaseRequisitionItems)) {
            data["purchaseRequisitionItems"] = [];
            for (let item of this.purchaseRequisitionItems)
                data["purchaseRequisitionItems"].push(item.toJSON());
        }
        data["postMigration"] = this.postMigration;
        return data;
    }

    clone(): PurchaseRequisition {
        const json = this.toJSON();
        let result = new PurchaseRequisition();
        result.init(json);
        return result;
    }
}

export interface IPurchaseRequisition {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    employeeUserId: number;
    employeeName: string | undefined;
    deliveryDate: moment.Moment;
    remarks: string | undefined;
    capexJustification: string | undefined;
    opexJustification: string | undefined;
    resaleJustification: string | undefined;
    manufacturingJustification: string | undefined;
    projectJustification: string | undefined;
    attachmentUrl1: string | undefined;
    attachmentUrl2: string | undefined;
    status: number;
    referenceNo: string | undefined;
    deliveryAddress: string | undefined;
    requestorId: number;
    requestedDate: moment.Moment;
    approvedDate: moment.Moment;
    rejectedDate: moment.Moment;
    rejectedReason: string | undefined;
    isDraftApproved: boolean;
    isApproved: boolean;
    isCalledForQuotation: boolean;
    approverUserId: number;
    approverName: string | undefined;
    approverEmail: string | undefined;
    finalApproverUserId: number;
    finalApproverName: string | undefined;
    finalApproverEmail: string | undefined;
    requestorName: string | undefined;
    requestorContactNo: string | undefined;
    requestorEmail: string | undefined;
    requestorDeliveryAddress: string | undefined;
    requestorInvoiceAddress: string | undefined;
    requestorDepartment: string | undefined;
    totalAmount: number;
    totalTax: number;
    ccEmails: string | undefined;
    justificationForSelection: string | undefined;
    isSkipApproval: boolean;
    isSkipEverything: boolean;
    totalCapexAmount: number;
    totalOpexAmount: number;
    totalResaleAmount: number;
    totalManufacturingAmount: number;
    totalProjectAmount: number;
    boardResolutionAttachmentUrl: string | undefined;
    boardResolutionReference: string | undefined;
    boardResolutionDate: moment.Moment;
    isBlanketed: boolean;
    startDate: moment.Moment;
    endDate: moment.Moment;
    isPurchaseWithoutPo: boolean;
    isMigrated: boolean;
    currency: string | undefined;
    exchangeRate: number;
    deliveryCost: number;
    installationCost: number;
    vendorId: number | undefined;
    vendorObject: Vendor;
    purchaseOrdersId: number | undefined;
    purchaseOrders: PurchaseOrders;
    vendorInvoiceId: number | undefined;
    vendorInvoices: VendorInvoice;
    goodsReceivedNoteId: number | undefined;
    goodsReceivedNote: GoodsReceivedNotes;
    quotationId: number | undefined;
    purchaseRequisitionItems: PurchaseRequisitionItems[] | undefined;
    postMigration: boolean;
}

export class PurchaseRequisitionDto implements IPurchaseRequisitionDto {
    tenantId: number;
    purchaseRequisitionId: number;
    employeeUserId: number;
    employeeName: string | undefined;
    deliveryDate: moment.Moment;
    remarks: string | undefined;
    capexJustification: string | undefined;
    opexJustification: string | undefined;
    resaleJustification: string | undefined;
    manufacturingJustification: string | undefined;
    projectJustification: string | undefined;
    attachmentUrl1: string | undefined;
    attachmentUrl2: string | undefined;
    status: number;
    referenceNo: string | undefined;
    deliveryAddress: string | undefined;
    requestorId: number;
    requestedDate: moment.Moment;
    approvedDate: moment.Moment;
    rejectedDate: moment.Moment;
    rejectedReason: string | undefined;
    isDraftApproved: boolean;
    isApproved: boolean;
    isCalledForQuotation: boolean;
    approverUserId: number;
    approverName: string | undefined;
    approverEmail: string | undefined;
    finalApproverUserId: number;
    finalApproverName: string | undefined;
    finalApproverEmail: string | undefined;
    requestorName: string | undefined;
    requestorContactNo: string | undefined;
    requestorEmail: string | undefined;
    requestorDeliveryAddress: string | undefined;
    requestorInvoiceAddress: string | undefined;
    requestorDepartment: string | undefined;
    totalAmount: number;
    totalTax: number;
    ccEmails: string | undefined;
    justificationForSelection: string | undefined;
    isSkipApproval: boolean;
    isSkipEverything: boolean;
    totalCapexAmount: number;
    totalOpexAmount: number;
    totalResaleAmount: number;
    totalManufacturingAmount: number;
    totalProjectAmount: number;
    boardResolutionAttachmentUrl: string | undefined;
    boardResolutionReference: string | undefined;
    boardResolutionDate: moment.Moment;
    isBlanketed: boolean;
    startDate: moment.Moment;
    endDate: moment.Moment;
    isPurchaseWithoutPo: boolean;
    isMigrated: boolean;
    vendorId: number | undefined;
    cashbookList: Cashbooks[] | undefined;
    currency: string | undefined;
    exchangeRate: number;
    deliveryCost: number;
    installationCost: number;
    vendorObject: Vendor;
    purchaseOrdersId: number | undefined;
    purchaseOrders: PurchaseOrders;
    purchaseOrderItemList: PurchaseOrderItem[] | undefined;
    vendorInvoiceId: number | undefined;
    vendorInvoices: VendorInvoice;
    vendorInvoicesList: VendorInvoice[] | undefined;
    goodsReceivedNoteId: number | undefined;
    goodsReceivedNote: GoodsReceivedNotes;
    goodsReceivedNoteList: GoodsReceivedNotes[] | undefined;
    vendorInvoiceItemList: VendorInvoiceItem[] | undefined;
    quotationId: number | undefined;
    quotation: Quotation;
    purchaseRequisitionItems: PurchaseRequisitionItems[] | undefined;
    purchaseRequisition: PurchaseRequisition;
    departmentDto: DepartmentDto;
    purchaseOrdersDto: PurchaseOrdersDto;
    postMigration: boolean;

    constructor(data?: IPurchaseRequisitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.purchaseRequisitionId = _data["purchaseRequisitionId"];
            this.employeeUserId = _data["employeeUserId"];
            this.employeeName = _data["employeeName"];
            this.deliveryDate = _data["deliveryDate"] ? moment(_data["deliveryDate"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.capexJustification = _data["capexJustification"];
            this.opexJustification = _data["opexJustification"];
            this.resaleJustification = _data["resaleJustification"];
            this.manufacturingJustification = _data["manufacturingJustification"];
            this.projectJustification = _data["projectJustification"];
            this.attachmentUrl1 = _data["attachmentUrl1"];
            this.attachmentUrl2 = _data["attachmentUrl2"];
            this.status = _data["status"];
            this.referenceNo = _data["referenceNo"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.requestorId = _data["requestorId"];
            this.requestedDate = _data["requestedDate"] ? moment(_data["requestedDate"].toString()) : <any>undefined;
            this.approvedDate = _data["approvedDate"] ? moment(_data["approvedDate"].toString()) : <any>undefined;
            this.rejectedDate = _data["rejectedDate"] ? moment(_data["rejectedDate"].toString()) : <any>undefined;
            this.rejectedReason = _data["rejectedReason"];
            this.isDraftApproved = _data["isDraftApproved"];
            this.isApproved = _data["isApproved"];
            this.isCalledForQuotation = _data["isCalledForQuotation"];
            this.approverUserId = _data["approverUserId"];
            this.approverName = _data["approverName"];
            this.approverEmail = _data["approverEmail"];
            this.finalApproverUserId = _data["finalApproverUserId"];
            this.finalApproverName = _data["finalApproverName"];
            this.finalApproverEmail = _data["finalApproverEmail"];
            this.requestorName = _data["requestorName"];
            this.requestorContactNo = _data["requestorContactNo"];
            this.requestorEmail = _data["requestorEmail"];
            this.requestorDeliveryAddress = _data["requestorDeliveryAddress"];
            this.requestorInvoiceAddress = _data["requestorInvoiceAddress"];
            this.requestorDepartment = _data["requestorDepartment"];
            this.totalAmount = _data["totalAmount"];
            this.totalTax = _data["totalTax"];
            this.ccEmails = _data["ccEmails"];
            this.justificationForSelection = _data["justificationForSelection"];
            this.isSkipApproval = _data["isSkipApproval"];
            this.isSkipEverything = _data["isSkipEverything"];
            this.totalCapexAmount = _data["totalCapexAmount"];
            this.totalOpexAmount = _data["totalOpexAmount"];
            this.totalResaleAmount = _data["totalResaleAmount"];
            this.totalManufacturingAmount = _data["totalManufacturingAmount"];
            this.totalProjectAmount = _data["totalProjectAmount"];
            this.boardResolutionAttachmentUrl = _data["boardResolutionAttachmentUrl"];
            this.boardResolutionReference = _data["boardResolutionReference"];
            this.boardResolutionDate = _data["boardResolutionDate"] ? moment(_data["boardResolutionDate"].toString()) : <any>undefined;
            this.isBlanketed = _data["isBlanketed"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.isPurchaseWithoutPo = _data["isPurchaseWithoutPo"];
            this.isMigrated = _data["isMigrated"];
            this.vendorId = _data["vendorId"];
            if (Array.isArray(_data["cashbookList"])) {
                this.cashbookList = [] as any;
                for (let item of _data["cashbookList"])
                    this.cashbookList.push(Cashbooks.fromJS(item));
            }
            this.currency = _data["currency"];
            this.exchangeRate = _data["exchangeRate"];
            this.deliveryCost = _data["deliveryCost"];
            this.installationCost = _data["installationCost"];
            this.vendorObject = _data["vendorObject"] ? Vendor.fromJS(_data["vendorObject"]) : <any>undefined;
            this.purchaseOrdersId = _data["purchaseOrdersId"];
            this.purchaseOrders = _data["purchaseOrders"] ? PurchaseOrders.fromJS(_data["purchaseOrders"]) : <any>undefined;
            if (Array.isArray(_data["purchaseOrderItemList"])) {
                this.purchaseOrderItemList = [] as any;
                for (let item of _data["purchaseOrderItemList"])
                    this.purchaseOrderItemList.push(PurchaseOrderItem.fromJS(item));
            }
            this.vendorInvoiceId = _data["vendorInvoiceId"];
            this.vendorInvoices = _data["vendorInvoices"] ? VendorInvoice.fromJS(_data["vendorInvoices"]) : <any>undefined;
            if (Array.isArray(_data["vendorInvoicesList"])) {
                this.vendorInvoicesList = [] as any;
                for (let item of _data["vendorInvoicesList"])
                    this.vendorInvoicesList.push(VendorInvoice.fromJS(item));
            }
            this.goodsReceivedNoteId = _data["goodsReceivedNoteId"];
            this.goodsReceivedNote = _data["goodsReceivedNote"] ? GoodsReceivedNotes.fromJS(_data["goodsReceivedNote"]) : <any>undefined;
            if (Array.isArray(_data["goodsReceivedNoteList"])) {
                this.goodsReceivedNoteList = [] as any;
                for (let item of _data["goodsReceivedNoteList"])
                    this.goodsReceivedNoteList.push(GoodsReceivedNotes.fromJS(item));
            }
            if (Array.isArray(_data["vendorInvoiceItemList"])) {
                this.vendorInvoiceItemList = [] as any;
                for (let item of _data["vendorInvoiceItemList"])
                    this.vendorInvoiceItemList.push(VendorInvoiceItem.fromJS(item));
            }
            this.quotationId = _data["quotationId"];
            this.quotation = _data["quotation"] ? Quotation.fromJS(_data["quotation"]) : <any>undefined;
            if (Array.isArray(_data["purchaseRequisitionItems"])) {
                this.purchaseRequisitionItems = [] as any;
                for (let item of _data["purchaseRequisitionItems"])
                    this.purchaseRequisitionItems.push(PurchaseRequisitionItems.fromJS(item));
            }
            this.purchaseRequisition = _data["purchaseRequisition"] ? PurchaseRequisition.fromJS(_data["purchaseRequisition"]) : <any>undefined;
            this.departmentDto = _data["departmentDto"] ? DepartmentDto.fromJS(_data["departmentDto"]) : <any>undefined;
            this.purchaseOrdersDto = _data["purchaseOrdersDto"] ? PurchaseOrdersDto.fromJS(_data["purchaseOrdersDto"]) : <any>undefined;
            this.postMigration = _data["postMigration"];
        }
    }

    static fromJS(data: any): PurchaseRequisitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseRequisitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["purchaseRequisitionId"] = this.purchaseRequisitionId;
        data["employeeUserId"] = this.employeeUserId;
        data["employeeName"] = this.employeeName;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["capexJustification"] = this.capexJustification;
        data["opexJustification"] = this.opexJustification;
        data["resaleJustification"] = this.resaleJustification;
        data["manufacturingJustification"] = this.manufacturingJustification;
        data["projectJustification"] = this.projectJustification;
        data["attachmentUrl1"] = this.attachmentUrl1;
        data["attachmentUrl2"] = this.attachmentUrl2;
        data["status"] = this.status;
        data["referenceNo"] = this.referenceNo;
        data["deliveryAddress"] = this.deliveryAddress;
        data["requestorId"] = this.requestorId;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>undefined;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["rejectedDate"] = this.rejectedDate ? this.rejectedDate.toISOString() : <any>undefined;
        data["rejectedReason"] = this.rejectedReason;
        data["isDraftApproved"] = this.isDraftApproved;
        data["isApproved"] = this.isApproved;
        data["isCalledForQuotation"] = this.isCalledForQuotation;
        data["approverUserId"] = this.approverUserId;
        data["approverName"] = this.approverName;
        data["approverEmail"] = this.approverEmail;
        data["finalApproverUserId"] = this.finalApproverUserId;
        data["finalApproverName"] = this.finalApproverName;
        data["finalApproverEmail"] = this.finalApproverEmail;
        data["requestorName"] = this.requestorName;
        data["requestorContactNo"] = this.requestorContactNo;
        data["requestorEmail"] = this.requestorEmail;
        data["requestorDeliveryAddress"] = this.requestorDeliveryAddress;
        data["requestorInvoiceAddress"] = this.requestorInvoiceAddress;
        data["requestorDepartment"] = this.requestorDepartment;
        data["totalAmount"] = this.totalAmount;
        data["totalTax"] = this.totalTax;
        data["ccEmails"] = this.ccEmails;
        data["justificationForSelection"] = this.justificationForSelection;
        data["isSkipApproval"] = this.isSkipApproval;
        data["isSkipEverything"] = this.isSkipEverything;
        data["totalCapexAmount"] = this.totalCapexAmount;
        data["totalOpexAmount"] = this.totalOpexAmount;
        data["totalResaleAmount"] = this.totalResaleAmount;
        data["totalManufacturingAmount"] = this.totalManufacturingAmount;
        data["totalProjectAmount"] = this.totalProjectAmount;
        data["boardResolutionAttachmentUrl"] = this.boardResolutionAttachmentUrl;
        data["boardResolutionReference"] = this.boardResolutionReference;
        data["boardResolutionDate"] = this.boardResolutionDate ? this.boardResolutionDate.toISOString() : <any>undefined;
        data["isBlanketed"] = this.isBlanketed;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isPurchaseWithoutPo"] = this.isPurchaseWithoutPo;
        data["isMigrated"] = this.isMigrated;
        data["vendorId"] = this.vendorId;
        if (Array.isArray(this.cashbookList)) {
            data["cashbookList"] = [];
            for (let item of this.cashbookList)
                data["cashbookList"].push(item.toJSON());
        }
        data["currency"] = this.currency;
        data["exchangeRate"] = this.exchangeRate;
        data["deliveryCost"] = this.deliveryCost;
        data["installationCost"] = this.installationCost;
        data["vendorObject"] = this.vendorObject ? this.vendorObject.toJSON() : <any>undefined;
        data["purchaseOrdersId"] = this.purchaseOrdersId;
        data["purchaseOrders"] = this.purchaseOrders ? this.purchaseOrders.toJSON() : <any>undefined;
        if (Array.isArray(this.purchaseOrderItemList)) {
            data["purchaseOrderItemList"] = [];
            for (let item of this.purchaseOrderItemList)
                data["purchaseOrderItemList"].push(item.toJSON());
        }
        data["vendorInvoiceId"] = this.vendorInvoiceId;
        data["vendorInvoices"] = this.vendorInvoices ? this.vendorInvoices.toJSON() : <any>undefined;
        if (Array.isArray(this.vendorInvoicesList)) {
            data["vendorInvoicesList"] = [];
            for (let item of this.vendorInvoicesList)
                data["vendorInvoicesList"].push(item.toJSON());
        }
        data["goodsReceivedNoteId"] = this.goodsReceivedNoteId;
        data["goodsReceivedNote"] = this.goodsReceivedNote ? this.goodsReceivedNote.toJSON() : <any>undefined;
        if (Array.isArray(this.goodsReceivedNoteList)) {
            data["goodsReceivedNoteList"] = [];
            for (let item of this.goodsReceivedNoteList)
                data["goodsReceivedNoteList"].push(item.toJSON());
        }
        if (Array.isArray(this.vendorInvoiceItemList)) {
            data["vendorInvoiceItemList"] = [];
            for (let item of this.vendorInvoiceItemList)
                data["vendorInvoiceItemList"].push(item.toJSON());
        }
        data["quotationId"] = this.quotationId;
        data["quotation"] = this.quotation ? this.quotation.toJSON() : <any>undefined;
        if (Array.isArray(this.purchaseRequisitionItems)) {
            data["purchaseRequisitionItems"] = [];
            for (let item of this.purchaseRequisitionItems)
                data["purchaseRequisitionItems"].push(item.toJSON());
        }
        data["purchaseRequisition"] = this.purchaseRequisition ? this.purchaseRequisition.toJSON() : <any>undefined;
        data["departmentDto"] = this.departmentDto ? this.departmentDto.toJSON() : <any>undefined;
        data["purchaseOrdersDto"] = this.purchaseOrdersDto ? this.purchaseOrdersDto.toJSON() : <any>undefined;
        data["postMigration"] = this.postMigration;
        return data;
    }

    clone(): PurchaseRequisitionDto {
        const json = this.toJSON();
        let result = new PurchaseRequisitionDto();
        result.init(json);
        return result;
    }
}

export interface IPurchaseRequisitionDto {
    tenantId: number;
    purchaseRequisitionId: number;
    employeeUserId: number;
    employeeName: string | undefined;
    deliveryDate: moment.Moment;
    remarks: string | undefined;
    capexJustification: string | undefined;
    opexJustification: string | undefined;
    resaleJustification: string | undefined;
    manufacturingJustification: string | undefined;
    projectJustification: string | undefined;
    attachmentUrl1: string | undefined;
    attachmentUrl2: string | undefined;
    status: number;
    referenceNo: string | undefined;
    deliveryAddress: string | undefined;
    requestorId: number;
    requestedDate: moment.Moment;
    approvedDate: moment.Moment;
    rejectedDate: moment.Moment;
    rejectedReason: string | undefined;
    isDraftApproved: boolean;
    isApproved: boolean;
    isCalledForQuotation: boolean;
    approverUserId: number;
    approverName: string | undefined;
    approverEmail: string | undefined;
    finalApproverUserId: number;
    finalApproverName: string | undefined;
    finalApproverEmail: string | undefined;
    requestorName: string | undefined;
    requestorContactNo: string | undefined;
    requestorEmail: string | undefined;
    requestorDeliveryAddress: string | undefined;
    requestorInvoiceAddress: string | undefined;
    requestorDepartment: string | undefined;
    totalAmount: number;
    totalTax: number;
    ccEmails: string | undefined;
    justificationForSelection: string | undefined;
    isSkipApproval: boolean;
    isSkipEverything: boolean;
    totalCapexAmount: number;
    totalOpexAmount: number;
    totalResaleAmount: number;
    totalManufacturingAmount: number;
    totalProjectAmount: number;
    boardResolutionAttachmentUrl: string | undefined;
    boardResolutionReference: string | undefined;
    boardResolutionDate: moment.Moment;
    isBlanketed: boolean;
    startDate: moment.Moment;
    endDate: moment.Moment;
    isPurchaseWithoutPo: boolean;
    isMigrated: boolean;
    vendorId: number | undefined;
    cashbookList: Cashbooks[] | undefined;
    currency: string | undefined;
    exchangeRate: number;
    deliveryCost: number;
    installationCost: number;
    vendorObject: Vendor;
    purchaseOrdersId: number | undefined;
    purchaseOrders: PurchaseOrders;
    purchaseOrderItemList: PurchaseOrderItem[] | undefined;
    vendorInvoiceId: number | undefined;
    vendorInvoices: VendorInvoice;
    vendorInvoicesList: VendorInvoice[] | undefined;
    goodsReceivedNoteId: number | undefined;
    goodsReceivedNote: GoodsReceivedNotes;
    goodsReceivedNoteList: GoodsReceivedNotes[] | undefined;
    vendorInvoiceItemList: VendorInvoiceItem[] | undefined;
    quotationId: number | undefined;
    quotation: Quotation;
    purchaseRequisitionItems: PurchaseRequisitionItems[] | undefined;
    purchaseRequisition: PurchaseRequisition;
    departmentDto: DepartmentDto;
    purchaseOrdersDto: PurchaseOrdersDto;
    postMigration: boolean;
}

export class PurchaseRequisitionDtoPagedResultDto implements IPurchaseRequisitionDtoPagedResultDto {
    items: PurchaseRequisitionDto[] | undefined;
    totalCount: number;

    constructor(data?: IPurchaseRequisitionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PurchaseRequisitionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PurchaseRequisitionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseRequisitionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PurchaseRequisitionDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PurchaseRequisitionDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPurchaseRequisitionDtoPagedResultDto {
    items: PurchaseRequisitionDto[] | undefined;
    totalCount: number;
}

export class PurchaseRequisitionItems implements IPurchaseRequisitionItems {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    originalGuid: string | undefined;
    originalCode: string | undefined;
    name: string | undefined;
    description: string | undefined;
    quantity: number;
    vendorQuantity: number;
    unitPrice: number;
    vendorUnitPrice: number;
    negotiatedUnitPrice: number;
    taxRate: number;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    taxCode: string | undefined;
    chargeTo: string | undefined;
    quality: string | undefined;
    discount: number;
    unitOfMeasurement: string | undefined;
    receivedQuantity: number;
    rejectedQuantity: number;
    acceptedQuantity: number;
    purchaseRequisitionId: number;
    purchaseRequisition: PurchaseRequisition;
    tenantId: number;
    projectId: number;
    assetItemMaintenanceId: string | undefined;
    assetItemMaintenance: NonCurrentAssetMaintenance;
    deliveryCost: number;
    deliveryCode: string | undefined;
    deliveryName: string | undefined;
    installationCost: number;
    installationCode: string | undefined;
    installationName: string | undefined;

    constructor(data?: IPurchaseRequisitionItems) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.originalGuid = _data["originalGuid"];
            this.originalCode = _data["originalCode"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.vendorQuantity = _data["vendorQuantity"];
            this.unitPrice = _data["unitPrice"];
            this.vendorUnitPrice = _data["vendorUnitPrice"];
            this.negotiatedUnitPrice = _data["negotiatedUnitPrice"];
            this.taxRate = _data["taxRate"];
            this.categoryCode = _data["categoryCode"];
            this.categoryName = _data["categoryName"];
            this.taxCode = _data["taxCode"];
            this.chargeTo = _data["chargeTo"];
            this.quality = _data["quality"];
            this.discount = _data["discount"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.receivedQuantity = _data["receivedQuantity"];
            this.rejectedQuantity = _data["rejectedQuantity"];
            this.acceptedQuantity = _data["acceptedQuantity"];
            this.purchaseRequisitionId = _data["purchaseRequisitionId"];
            this.purchaseRequisition = _data["purchaseRequisition"] ? PurchaseRequisition.fromJS(_data["purchaseRequisition"]) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.assetItemMaintenanceId = _data["assetItemMaintenanceId"];
            this.assetItemMaintenance = _data["assetItemMaintenance"] ? NonCurrentAssetMaintenance.fromJS(_data["assetItemMaintenance"]) : <any>undefined;
            this.deliveryCost = _data["deliveryCost"];
            this.deliveryCode = _data["deliveryCode"];
            this.deliveryName = _data["deliveryName"];
            this.installationCost = _data["installationCost"];
            this.installationCode = _data["installationCode"];
            this.installationName = _data["installationName"];
        }
    }

    static fromJS(data: any): PurchaseRequisitionItems {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseRequisitionItems();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["originalGuid"] = this.originalGuid;
        data["originalCode"] = this.originalCode;
        data["name"] = this.name;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["vendorQuantity"] = this.vendorQuantity;
        data["unitPrice"] = this.unitPrice;
        data["vendorUnitPrice"] = this.vendorUnitPrice;
        data["negotiatedUnitPrice"] = this.negotiatedUnitPrice;
        data["taxRate"] = this.taxRate;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["taxCode"] = this.taxCode;
        data["chargeTo"] = this.chargeTo;
        data["quality"] = this.quality;
        data["discount"] = this.discount;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["receivedQuantity"] = this.receivedQuantity;
        data["rejectedQuantity"] = this.rejectedQuantity;
        data["acceptedQuantity"] = this.acceptedQuantity;
        data["purchaseRequisitionId"] = this.purchaseRequisitionId;
        data["purchaseRequisition"] = this.purchaseRequisition ? this.purchaseRequisition.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["assetItemMaintenanceId"] = this.assetItemMaintenanceId;
        data["assetItemMaintenance"] = this.assetItemMaintenance ? this.assetItemMaintenance.toJSON() : <any>undefined;
        data["deliveryCost"] = this.deliveryCost;
        data["deliveryCode"] = this.deliveryCode;
        data["deliveryName"] = this.deliveryName;
        data["installationCost"] = this.installationCost;
        data["installationCode"] = this.installationCode;
        data["installationName"] = this.installationName;
        return data;
    }

    clone(): PurchaseRequisitionItems {
        const json = this.toJSON();
        let result = new PurchaseRequisitionItems();
        result.init(json);
        return result;
    }
}

export interface IPurchaseRequisitionItems {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    originalGuid: string | undefined;
    originalCode: string | undefined;
    name: string | undefined;
    description: string | undefined;
    quantity: number;
    vendorQuantity: number;
    unitPrice: number;
    vendorUnitPrice: number;
    negotiatedUnitPrice: number;
    taxRate: number;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    taxCode: string | undefined;
    chargeTo: string | undefined;
    quality: string | undefined;
    discount: number;
    unitOfMeasurement: string | undefined;
    receivedQuantity: number;
    rejectedQuantity: number;
    acceptedQuantity: number;
    purchaseRequisitionId: number;
    purchaseRequisition: PurchaseRequisition;
    tenantId: number;
    projectId: number;
    assetItemMaintenanceId: string | undefined;
    assetItemMaintenance: NonCurrentAssetMaintenance;
    deliveryCost: number;
    deliveryCode: string | undefined;
    deliveryName: string | undefined;
    installationCost: number;
    installationCode: string | undefined;
    installationName: string | undefined;
}

export class PurchaseRequisitionItemsDto implements IPurchaseRequisitionItemsDto {
    originalGuid: string | undefined;
    originalCode: string | undefined;
    purchaseRequisitionId: number;
    purchaseRequisitionItemsId: number;
    name: string | undefined;
    description: string | undefined;
    quantity: number;
    vendorQuantity: number;
    unitPrice: number;
    vendorUnitPrice: number;
    negotiatedUnitPrice: number;
    taxRate: number;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    taxCode: string | undefined;
    chargeTo: string | undefined;
    quality: string | undefined;
    discount: number;
    unitOfMeasurement: string | undefined;
    receivedQuantity: number;
    rejectedQuantity: number;
    acceptedQuantity: number;
    purchaseRequisition: PurchaseRequisition;
    tenantId: number;
    projectId: number;
    assetItemMaintenanceId: string | undefined;
    assetItemMaintenance: NonCurrentAssetMaintenance;
    deliveryCost: number;
    deliveryCode: string | undefined;
    deliveryName: string | undefined;
    installationCost: number;
    installationCode: string | undefined;
    installationName: string | undefined;

    constructor(data?: IPurchaseRequisitionItemsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalGuid = _data["originalGuid"];
            this.originalCode = _data["originalCode"];
            this.purchaseRequisitionId = _data["purchaseRequisitionId"];
            this.purchaseRequisitionItemsId = _data["purchaseRequisitionItemsId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.vendorQuantity = _data["vendorQuantity"];
            this.unitPrice = _data["unitPrice"];
            this.vendorUnitPrice = _data["vendorUnitPrice"];
            this.negotiatedUnitPrice = _data["negotiatedUnitPrice"];
            this.taxRate = _data["taxRate"];
            this.categoryCode = _data["categoryCode"];
            this.categoryName = _data["categoryName"];
            this.taxCode = _data["taxCode"];
            this.chargeTo = _data["chargeTo"];
            this.quality = _data["quality"];
            this.discount = _data["discount"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.receivedQuantity = _data["receivedQuantity"];
            this.rejectedQuantity = _data["rejectedQuantity"];
            this.acceptedQuantity = _data["acceptedQuantity"];
            this.purchaseRequisition = _data["purchaseRequisition"] ? PurchaseRequisition.fromJS(_data["purchaseRequisition"]) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.projectId = _data["projectId"];
            this.assetItemMaintenanceId = _data["assetItemMaintenanceId"];
            this.assetItemMaintenance = _data["assetItemMaintenance"] ? NonCurrentAssetMaintenance.fromJS(_data["assetItemMaintenance"]) : <any>undefined;
            this.deliveryCost = _data["deliveryCost"];
            this.deliveryCode = _data["deliveryCode"];
            this.deliveryName = _data["deliveryName"];
            this.installationCost = _data["installationCost"];
            this.installationCode = _data["installationCode"];
            this.installationName = _data["installationName"];
        }
    }

    static fromJS(data: any): PurchaseRequisitionItemsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseRequisitionItemsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalGuid"] = this.originalGuid;
        data["originalCode"] = this.originalCode;
        data["purchaseRequisitionId"] = this.purchaseRequisitionId;
        data["purchaseRequisitionItemsId"] = this.purchaseRequisitionItemsId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["vendorQuantity"] = this.vendorQuantity;
        data["unitPrice"] = this.unitPrice;
        data["vendorUnitPrice"] = this.vendorUnitPrice;
        data["negotiatedUnitPrice"] = this.negotiatedUnitPrice;
        data["taxRate"] = this.taxRate;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["taxCode"] = this.taxCode;
        data["chargeTo"] = this.chargeTo;
        data["quality"] = this.quality;
        data["discount"] = this.discount;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["receivedQuantity"] = this.receivedQuantity;
        data["rejectedQuantity"] = this.rejectedQuantity;
        data["acceptedQuantity"] = this.acceptedQuantity;
        data["purchaseRequisition"] = this.purchaseRequisition ? this.purchaseRequisition.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["projectId"] = this.projectId;
        data["assetItemMaintenanceId"] = this.assetItemMaintenanceId;
        data["assetItemMaintenance"] = this.assetItemMaintenance ? this.assetItemMaintenance.toJSON() : <any>undefined;
        data["deliveryCost"] = this.deliveryCost;
        data["deliveryCode"] = this.deliveryCode;
        data["deliveryName"] = this.deliveryName;
        data["installationCost"] = this.installationCost;
        data["installationCode"] = this.installationCode;
        data["installationName"] = this.installationName;
        return data;
    }

    clone(): PurchaseRequisitionItemsDto {
        const json = this.toJSON();
        let result = new PurchaseRequisitionItemsDto();
        result.init(json);
        return result;
    }
}

export interface IPurchaseRequisitionItemsDto {
    originalGuid: string | undefined;
    originalCode: string | undefined;
    purchaseRequisitionId: number;
    purchaseRequisitionItemsId: number;
    name: string | undefined;
    description: string | undefined;
    quantity: number;
    vendorQuantity: number;
    unitPrice: number;
    vendorUnitPrice: number;
    negotiatedUnitPrice: number;
    taxRate: number;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    taxCode: string | undefined;
    chargeTo: string | undefined;
    quality: string | undefined;
    discount: number;
    unitOfMeasurement: string | undefined;
    receivedQuantity: number;
    rejectedQuantity: number;
    acceptedQuantity: number;
    purchaseRequisition: PurchaseRequisition;
    tenantId: number;
    projectId: number;
    assetItemMaintenanceId: string | undefined;
    assetItemMaintenance: NonCurrentAssetMaintenance;
    deliveryCost: number;
    deliveryCode: string | undefined;
    deliveryName: string | undefined;
    installationCost: number;
    installationCode: string | undefined;
    installationName: string | undefined;
}

export class PurchaseRequisitionPagedResultDto implements IPurchaseRequisitionPagedResultDto {
    items: PurchaseRequisition[] | undefined;
    totalCount: number;

    constructor(data?: IPurchaseRequisitionPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PurchaseRequisition.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PurchaseRequisitionPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseRequisitionPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PurchaseRequisitionPagedResultDto {
        const json = this.toJSON();
        let result = new PurchaseRequisitionPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPurchaseRequisitionPagedResultDto {
    items: PurchaseRequisition[] | undefined;
    totalCount: number;
}

export class PurchaseRequisitionRecommendedVendors implements IPurchaseRequisitionRecommendedVendors {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    purchaseRequisitionId: number;
    tenantId: number;
    name: string | undefined;
    code: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    postcode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    picName: string | undefined;
    picEmail: string | undefined;
    picContactNo: string | undefined;
    remarks: string | undefined;
    websiteLink: string | undefined;
    isApproved: boolean;
    offeredPrice: number;
    quotationAttachment: string | undefined;
    remarksFromVendor: string | undefined;
    deliveryCost: number;
    comments: string | undefined;
    vendorQuotationApprovedBy: string | undefined;
    currency: string | undefined;
    vendorId: number | undefined;
    vendor: Vendor;

    constructor(data?: IPurchaseRequisitionRecommendedVendors) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.purchaseRequisitionId = _data["purchaseRequisitionId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.postcode = _data["postcode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.picName = _data["picName"];
            this.picEmail = _data["picEmail"];
            this.picContactNo = _data["picContactNo"];
            this.remarks = _data["remarks"];
            this.websiteLink = _data["websiteLink"];
            this.isApproved = _data["isApproved"];
            this.offeredPrice = _data["offeredPrice"];
            this.quotationAttachment = _data["quotationAttachment"];
            this.remarksFromVendor = _data["remarksFromVendor"];
            this.deliveryCost = _data["deliveryCost"];
            this.comments = _data["comments"];
            this.vendorQuotationApprovedBy = _data["vendorQuotationApprovedBy"];
            this.currency = _data["currency"];
            this.vendorId = _data["vendorId"];
            this.vendor = _data["vendor"] ? Vendor.fromJS(_data["vendor"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PurchaseRequisitionRecommendedVendors {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseRequisitionRecommendedVendors();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["purchaseRequisitionId"] = this.purchaseRequisitionId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["postcode"] = this.postcode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["picName"] = this.picName;
        data["picEmail"] = this.picEmail;
        data["picContactNo"] = this.picContactNo;
        data["remarks"] = this.remarks;
        data["websiteLink"] = this.websiteLink;
        data["isApproved"] = this.isApproved;
        data["offeredPrice"] = this.offeredPrice;
        data["quotationAttachment"] = this.quotationAttachment;
        data["remarksFromVendor"] = this.remarksFromVendor;
        data["deliveryCost"] = this.deliveryCost;
        data["comments"] = this.comments;
        data["vendorQuotationApprovedBy"] = this.vendorQuotationApprovedBy;
        data["currency"] = this.currency;
        data["vendorId"] = this.vendorId;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        return data;
    }

    clone(): PurchaseRequisitionRecommendedVendors {
        const json = this.toJSON();
        let result = new PurchaseRequisitionRecommendedVendors();
        result.init(json);
        return result;
    }
}

export interface IPurchaseRequisitionRecommendedVendors {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    purchaseRequisitionId: number;
    tenantId: number;
    name: string | undefined;
    code: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    postcode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    picName: string | undefined;
    picEmail: string | undefined;
    picContactNo: string | undefined;
    remarks: string | undefined;
    websiteLink: string | undefined;
    isApproved: boolean;
    offeredPrice: number;
    quotationAttachment: string | undefined;
    remarksFromVendor: string | undefined;
    deliveryCost: number;
    comments: string | undefined;
    vendorQuotationApprovedBy: string | undefined;
    currency: string | undefined;
    vendorId: number | undefined;
    vendor: Vendor;
}

export class PurchaseRequisitionRecommendedVendorsDto implements IPurchaseRequisitionRecommendedVendorsDto {
    purchaseRequisitionId: number;
    purchaseRequisitionRecommendedVendorsId: number;
    tenantId: number;
    name: string | undefined;
    code: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    postcode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    picName: string | undefined;
    picEmail: string | undefined;
    picContactNo: string | undefined;
    remarks: string | undefined;
    websiteLink: string | undefined;
    isApproved: boolean;
    offeredPrice: number;
    quotationAttachment: string | undefined;
    remarksFromVendor: string | undefined;
    deliveryCost: number;
    comments: string | undefined;
    vendorQuotationApprovedBy: string | undefined;
    currency: string | undefined;
    vendorId: number | undefined;
    vendor: Vendor;

    constructor(data?: IPurchaseRequisitionRecommendedVendorsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchaseRequisitionId = _data["purchaseRequisitionId"];
            this.purchaseRequisitionRecommendedVendorsId = _data["purchaseRequisitionRecommendedVendorsId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.postcode = _data["postcode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.picName = _data["picName"];
            this.picEmail = _data["picEmail"];
            this.picContactNo = _data["picContactNo"];
            this.remarks = _data["remarks"];
            this.websiteLink = _data["websiteLink"];
            this.isApproved = _data["isApproved"];
            this.offeredPrice = _data["offeredPrice"];
            this.quotationAttachment = _data["quotationAttachment"];
            this.remarksFromVendor = _data["remarksFromVendor"];
            this.deliveryCost = _data["deliveryCost"];
            this.comments = _data["comments"];
            this.vendorQuotationApprovedBy = _data["vendorQuotationApprovedBy"];
            this.currency = _data["currency"];
            this.vendorId = _data["vendorId"];
            this.vendor = _data["vendor"] ? Vendor.fromJS(_data["vendor"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PurchaseRequisitionRecommendedVendorsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseRequisitionRecommendedVendorsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaseRequisitionId"] = this.purchaseRequisitionId;
        data["purchaseRequisitionRecommendedVendorsId"] = this.purchaseRequisitionRecommendedVendorsId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["postcode"] = this.postcode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["picName"] = this.picName;
        data["picEmail"] = this.picEmail;
        data["picContactNo"] = this.picContactNo;
        data["remarks"] = this.remarks;
        data["websiteLink"] = this.websiteLink;
        data["isApproved"] = this.isApproved;
        data["offeredPrice"] = this.offeredPrice;
        data["quotationAttachment"] = this.quotationAttachment;
        data["remarksFromVendor"] = this.remarksFromVendor;
        data["deliveryCost"] = this.deliveryCost;
        data["comments"] = this.comments;
        data["vendorQuotationApprovedBy"] = this.vendorQuotationApprovedBy;
        data["currency"] = this.currency;
        data["vendorId"] = this.vendorId;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        return data;
    }

    clone(): PurchaseRequisitionRecommendedVendorsDto {
        const json = this.toJSON();
        let result = new PurchaseRequisitionRecommendedVendorsDto();
        result.init(json);
        return result;
    }
}

export interface IPurchaseRequisitionRecommendedVendorsDto {
    purchaseRequisitionId: number;
    purchaseRequisitionRecommendedVendorsId: number;
    tenantId: number;
    name: string | undefined;
    code: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    postcode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    picName: string | undefined;
    picEmail: string | undefined;
    picContactNo: string | undefined;
    remarks: string | undefined;
    websiteLink: string | undefined;
    isApproved: boolean;
    offeredPrice: number;
    quotationAttachment: string | undefined;
    remarksFromVendor: string | undefined;
    deliveryCost: number;
    comments: string | undefined;
    vendorQuotationApprovedBy: string | undefined;
    currency: string | undefined;
    vendorId: number | undefined;
    vendor: Vendor;
}

export class PurchaseRequisitionVendorItems implements IPurchaseRequisitionVendorItems {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    originalGuid: string | undefined;
    originalCode: string | undefined;
    quotationId: number;
    purchaseRequisitionId: number;
    purchaseRequisitionItemsId: number;
    purchaseRequisitionRecommendedVendorsId: number;
    vendorId: number;
    name: string | undefined;
    description: string | undefined;
    quantity: number;
    vendorQuantity: number;
    requestorUnitPrice: number;
    unitPrice: number;
    negotiatedUnitPrice: number;
    taxRate: number;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    taxCode: string | undefined;
    chargeTo: string | undefined;
    quality: string | undefined;
    discount: number;
    unitOfMeasurement: string | undefined;
    receivedQuantity: number;
    rejectedQuantity: number;
    acceptedQuantity: number;
    projectId: number;
    deliveryCost: number;
    deliveryCode: string | undefined;
    deliveryName: string | undefined;
    installationCost: number;
    installationCode: string | undefined;
    installationName: string | undefined;

    constructor(data?: IPurchaseRequisitionVendorItems) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.originalGuid = _data["originalGuid"];
            this.originalCode = _data["originalCode"];
            this.quotationId = _data["quotationId"];
            this.purchaseRequisitionId = _data["purchaseRequisitionId"];
            this.purchaseRequisitionItemsId = _data["purchaseRequisitionItemsId"];
            this.purchaseRequisitionRecommendedVendorsId = _data["purchaseRequisitionRecommendedVendorsId"];
            this.vendorId = _data["vendorId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.vendorQuantity = _data["vendorQuantity"];
            this.requestorUnitPrice = _data["requestorUnitPrice"];
            this.unitPrice = _data["unitPrice"];
            this.negotiatedUnitPrice = _data["negotiatedUnitPrice"];
            this.taxRate = _data["taxRate"];
            this.categoryCode = _data["categoryCode"];
            this.categoryName = _data["categoryName"];
            this.taxCode = _data["taxCode"];
            this.chargeTo = _data["chargeTo"];
            this.quality = _data["quality"];
            this.discount = _data["discount"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.receivedQuantity = _data["receivedQuantity"];
            this.rejectedQuantity = _data["rejectedQuantity"];
            this.acceptedQuantity = _data["acceptedQuantity"];
            this.projectId = _data["projectId"];
            this.deliveryCost = _data["deliveryCost"];
            this.deliveryCode = _data["deliveryCode"];
            this.deliveryName = _data["deliveryName"];
            this.installationCost = _data["installationCost"];
            this.installationCode = _data["installationCode"];
            this.installationName = _data["installationName"];
        }
    }

    static fromJS(data: any): PurchaseRequisitionVendorItems {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseRequisitionVendorItems();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["originalGuid"] = this.originalGuid;
        data["originalCode"] = this.originalCode;
        data["quotationId"] = this.quotationId;
        data["purchaseRequisitionId"] = this.purchaseRequisitionId;
        data["purchaseRequisitionItemsId"] = this.purchaseRequisitionItemsId;
        data["purchaseRequisitionRecommendedVendorsId"] = this.purchaseRequisitionRecommendedVendorsId;
        data["vendorId"] = this.vendorId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["vendorQuantity"] = this.vendorQuantity;
        data["requestorUnitPrice"] = this.requestorUnitPrice;
        data["unitPrice"] = this.unitPrice;
        data["negotiatedUnitPrice"] = this.negotiatedUnitPrice;
        data["taxRate"] = this.taxRate;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["taxCode"] = this.taxCode;
        data["chargeTo"] = this.chargeTo;
        data["quality"] = this.quality;
        data["discount"] = this.discount;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["receivedQuantity"] = this.receivedQuantity;
        data["rejectedQuantity"] = this.rejectedQuantity;
        data["acceptedQuantity"] = this.acceptedQuantity;
        data["projectId"] = this.projectId;
        data["deliveryCost"] = this.deliveryCost;
        data["deliveryCode"] = this.deliveryCode;
        data["deliveryName"] = this.deliveryName;
        data["installationCost"] = this.installationCost;
        data["installationCode"] = this.installationCode;
        data["installationName"] = this.installationName;
        return data;
    }

    clone(): PurchaseRequisitionVendorItems {
        const json = this.toJSON();
        let result = new PurchaseRequisitionVendorItems();
        result.init(json);
        return result;
    }
}

export interface IPurchaseRequisitionVendorItems {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    originalGuid: string | undefined;
    originalCode: string | undefined;
    quotationId: number;
    purchaseRequisitionId: number;
    purchaseRequisitionItemsId: number;
    purchaseRequisitionRecommendedVendorsId: number;
    vendorId: number;
    name: string | undefined;
    description: string | undefined;
    quantity: number;
    vendorQuantity: number;
    requestorUnitPrice: number;
    unitPrice: number;
    negotiatedUnitPrice: number;
    taxRate: number;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    taxCode: string | undefined;
    chargeTo: string | undefined;
    quality: string | undefined;
    discount: number;
    unitOfMeasurement: string | undefined;
    receivedQuantity: number;
    rejectedQuantity: number;
    acceptedQuantity: number;
    projectId: number;
    deliveryCost: number;
    deliveryCode: string | undefined;
    deliveryName: string | undefined;
    installationCost: number;
    installationCode: string | undefined;
    installationName: string | undefined;
}

export class PurchaseRequisitionVendorItemsDto implements IPurchaseRequisitionVendorItemsDto {
    originalGuid: string | undefined;
    originalCode: string | undefined;
    quotationId: number;
    purchaseRequisitionId: number;
    purchaseRequisitionItemsId: number;
    purchaseRequisitionVendorItemsId: number;
    purchaseRequisitionRecommendedVendorsId: number;
    vendorId: number;
    name: string | undefined;
    description: string | undefined;
    quantity: number;
    vendorQuantity: number;
    requestorUnitPrice: number;
    unitPrice: number;
    negotiatedUnitPrice: number;
    taxRate: number;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    taxCode: string | undefined;
    chargeTo: string | undefined;
    quality: string | undefined;
    discount: number;
    unitOfMeasurement: string | undefined;
    receivedQuantity: number;
    rejectedQuantity: number;
    acceptedQuantity: number;
    projectId: number;
    deliveryCost: number;
    deliveryCode: string | undefined;
    deliveryName: string | undefined;
    installationCost: number;
    installationCode: string | undefined;
    installationName: string | undefined;

    constructor(data?: IPurchaseRequisitionVendorItemsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalGuid = _data["originalGuid"];
            this.originalCode = _data["originalCode"];
            this.quotationId = _data["quotationId"];
            this.purchaseRequisitionId = _data["purchaseRequisitionId"];
            this.purchaseRequisitionItemsId = _data["purchaseRequisitionItemsId"];
            this.purchaseRequisitionVendorItemsId = _data["purchaseRequisitionVendorItemsId"];
            this.purchaseRequisitionRecommendedVendorsId = _data["purchaseRequisitionRecommendedVendorsId"];
            this.vendorId = _data["vendorId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.vendorQuantity = _data["vendorQuantity"];
            this.requestorUnitPrice = _data["requestorUnitPrice"];
            this.unitPrice = _data["unitPrice"];
            this.negotiatedUnitPrice = _data["negotiatedUnitPrice"];
            this.taxRate = _data["taxRate"];
            this.categoryCode = _data["categoryCode"];
            this.categoryName = _data["categoryName"];
            this.taxCode = _data["taxCode"];
            this.chargeTo = _data["chargeTo"];
            this.quality = _data["quality"];
            this.discount = _data["discount"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.receivedQuantity = _data["receivedQuantity"];
            this.rejectedQuantity = _data["rejectedQuantity"];
            this.acceptedQuantity = _data["acceptedQuantity"];
            this.projectId = _data["projectId"];
            this.deliveryCost = _data["deliveryCost"];
            this.deliveryCode = _data["deliveryCode"];
            this.deliveryName = _data["deliveryName"];
            this.installationCost = _data["installationCost"];
            this.installationCode = _data["installationCode"];
            this.installationName = _data["installationName"];
        }
    }

    static fromJS(data: any): PurchaseRequisitionVendorItemsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseRequisitionVendorItemsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalGuid"] = this.originalGuid;
        data["originalCode"] = this.originalCode;
        data["quotationId"] = this.quotationId;
        data["purchaseRequisitionId"] = this.purchaseRequisitionId;
        data["purchaseRequisitionItemsId"] = this.purchaseRequisitionItemsId;
        data["purchaseRequisitionVendorItemsId"] = this.purchaseRequisitionVendorItemsId;
        data["purchaseRequisitionRecommendedVendorsId"] = this.purchaseRequisitionRecommendedVendorsId;
        data["vendorId"] = this.vendorId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["vendorQuantity"] = this.vendorQuantity;
        data["requestorUnitPrice"] = this.requestorUnitPrice;
        data["unitPrice"] = this.unitPrice;
        data["negotiatedUnitPrice"] = this.negotiatedUnitPrice;
        data["taxRate"] = this.taxRate;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["taxCode"] = this.taxCode;
        data["chargeTo"] = this.chargeTo;
        data["quality"] = this.quality;
        data["discount"] = this.discount;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["receivedQuantity"] = this.receivedQuantity;
        data["rejectedQuantity"] = this.rejectedQuantity;
        data["acceptedQuantity"] = this.acceptedQuantity;
        data["projectId"] = this.projectId;
        data["deliveryCost"] = this.deliveryCost;
        data["deliveryCode"] = this.deliveryCode;
        data["deliveryName"] = this.deliveryName;
        data["installationCost"] = this.installationCost;
        data["installationCode"] = this.installationCode;
        data["installationName"] = this.installationName;
        return data;
    }

    clone(): PurchaseRequisitionVendorItemsDto {
        const json = this.toJSON();
        let result = new PurchaseRequisitionVendorItemsDto();
        result.init(json);
        return result;
    }
}

export interface IPurchaseRequisitionVendorItemsDto {
    originalGuid: string | undefined;
    originalCode: string | undefined;
    quotationId: number;
    purchaseRequisitionId: number;
    purchaseRequisitionItemsId: number;
    purchaseRequisitionVendorItemsId: number;
    purchaseRequisitionRecommendedVendorsId: number;
    vendorId: number;
    name: string | undefined;
    description: string | undefined;
    quantity: number;
    vendorQuantity: number;
    requestorUnitPrice: number;
    unitPrice: number;
    negotiatedUnitPrice: number;
    taxRate: number;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    taxCode: string | undefined;
    chargeTo: string | undefined;
    quality: string | undefined;
    discount: number;
    unitOfMeasurement: string | undefined;
    receivedQuantity: number;
    rejectedQuantity: number;
    acceptedQuantity: number;
    projectId: number;
    deliveryCost: number;
    deliveryCode: string | undefined;
    deliveryName: string | undefined;
    installationCost: number;
    installationCode: string | undefined;
    installationName: string | undefined;
}

export class Quotation implements IQuotation {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    purchaseRequisitionId: number;
    purchaseRequisition: PurchaseRequisition;
    employeeUserId: number;
    employeeName: string | undefined;
    deliveryDate: moment.Moment;
    remarks: string | undefined;
    remarksFromVendor: string | undefined;
    agreedRemarks: string | undefined;
    capexJustification: string | undefined;
    opexJustification: string | undefined;
    resaleJustification: string | undefined;
    manufacturingJustification: string | undefined;
    projectJustification: string | undefined;
    attachmentUrl1: string | undefined;
    attachmentUrl2: string | undefined;
    status: number;
    quotationReferenceNo: string | undefined;
    prReferenceNumber: string | undefined;
    deliveryAddress: string | undefined;
    requestorId: number;
    requestedDate: moment.Moment;
    approvedDate: moment.Moment;
    rejectedDate: moment.Moment;
    rejectedReason: string | undefined;
    isDraftApproved: boolean;
    isApproved: boolean;
    isCalledForQuotation: boolean;
    approverUserId: number;
    approverName: string | undefined;
    requestorName: string | undefined;
    requestorContactNo: string | undefined;
    requestorEmail: string | undefined;
    requestorDeliveryAddress: string | undefined;
    requestorInvoiceAddress: string | undefined;
    requestorDepartment: string | undefined;
    totalAmount: number;
    offeredPrice: number;
    totalTax: number;
    ccEmails: string | undefined;
    justificationForSelection: string | undefined;
    deliveryCost: number;
    installationCost: number;
    comments: string | undefined;
    vendorQuotationApprovedBy: string | undefined;
    startDate: moment.Moment;
    dueDate: moment.Moment;
    currency: string | undefined;
    exchangeRate: number;
    vendorId: number | undefined;
    vendorObject: Vendor;

    constructor(data?: IQuotation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.purchaseRequisitionId = _data["purchaseRequisitionId"];
            this.purchaseRequisition = _data["purchaseRequisition"] ? PurchaseRequisition.fromJS(_data["purchaseRequisition"]) : <any>undefined;
            this.employeeUserId = _data["employeeUserId"];
            this.employeeName = _data["employeeName"];
            this.deliveryDate = _data["deliveryDate"] ? moment(_data["deliveryDate"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.remarksFromVendor = _data["remarksFromVendor"];
            this.agreedRemarks = _data["agreedRemarks"];
            this.capexJustification = _data["capexJustification"];
            this.opexJustification = _data["opexJustification"];
            this.resaleJustification = _data["resaleJustification"];
            this.manufacturingJustification = _data["manufacturingJustification"];
            this.projectJustification = _data["projectJustification"];
            this.attachmentUrl1 = _data["attachmentUrl1"];
            this.attachmentUrl2 = _data["attachmentUrl2"];
            this.status = _data["status"];
            this.quotationReferenceNo = _data["quotationReferenceNo"];
            this.prReferenceNumber = _data["prReferenceNumber"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.requestorId = _data["requestorId"];
            this.requestedDate = _data["requestedDate"] ? moment(_data["requestedDate"].toString()) : <any>undefined;
            this.approvedDate = _data["approvedDate"] ? moment(_data["approvedDate"].toString()) : <any>undefined;
            this.rejectedDate = _data["rejectedDate"] ? moment(_data["rejectedDate"].toString()) : <any>undefined;
            this.rejectedReason = _data["rejectedReason"];
            this.isDraftApproved = _data["isDraftApproved"];
            this.isApproved = _data["isApproved"];
            this.isCalledForQuotation = _data["isCalledForQuotation"];
            this.approverUserId = _data["approverUserId"];
            this.approverName = _data["approverName"];
            this.requestorName = _data["requestorName"];
            this.requestorContactNo = _data["requestorContactNo"];
            this.requestorEmail = _data["requestorEmail"];
            this.requestorDeliveryAddress = _data["requestorDeliveryAddress"];
            this.requestorInvoiceAddress = _data["requestorInvoiceAddress"];
            this.requestorDepartment = _data["requestorDepartment"];
            this.totalAmount = _data["totalAmount"];
            this.offeredPrice = _data["offeredPrice"];
            this.totalTax = _data["totalTax"];
            this.ccEmails = _data["ccEmails"];
            this.justificationForSelection = _data["justificationForSelection"];
            this.deliveryCost = _data["deliveryCost"];
            this.installationCost = _data["installationCost"];
            this.comments = _data["comments"];
            this.vendorQuotationApprovedBy = _data["vendorQuotationApprovedBy"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.currency = _data["currency"];
            this.exchangeRate = _data["exchangeRate"];
            this.vendorId = _data["vendorId"];
            this.vendorObject = _data["vendorObject"] ? Vendor.fromJS(_data["vendorObject"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Quotation {
        data = typeof data === 'object' ? data : {};
        let result = new Quotation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["purchaseRequisitionId"] = this.purchaseRequisitionId;
        data["purchaseRequisition"] = this.purchaseRequisition ? this.purchaseRequisition.toJSON() : <any>undefined;
        data["employeeUserId"] = this.employeeUserId;
        data["employeeName"] = this.employeeName;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["remarksFromVendor"] = this.remarksFromVendor;
        data["agreedRemarks"] = this.agreedRemarks;
        data["capexJustification"] = this.capexJustification;
        data["opexJustification"] = this.opexJustification;
        data["resaleJustification"] = this.resaleJustification;
        data["manufacturingJustification"] = this.manufacturingJustification;
        data["projectJustification"] = this.projectJustification;
        data["attachmentUrl1"] = this.attachmentUrl1;
        data["attachmentUrl2"] = this.attachmentUrl2;
        data["status"] = this.status;
        data["quotationReferenceNo"] = this.quotationReferenceNo;
        data["prReferenceNumber"] = this.prReferenceNumber;
        data["deliveryAddress"] = this.deliveryAddress;
        data["requestorId"] = this.requestorId;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>undefined;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["rejectedDate"] = this.rejectedDate ? this.rejectedDate.toISOString() : <any>undefined;
        data["rejectedReason"] = this.rejectedReason;
        data["isDraftApproved"] = this.isDraftApproved;
        data["isApproved"] = this.isApproved;
        data["isCalledForQuotation"] = this.isCalledForQuotation;
        data["approverUserId"] = this.approverUserId;
        data["approverName"] = this.approverName;
        data["requestorName"] = this.requestorName;
        data["requestorContactNo"] = this.requestorContactNo;
        data["requestorEmail"] = this.requestorEmail;
        data["requestorDeliveryAddress"] = this.requestorDeliveryAddress;
        data["requestorInvoiceAddress"] = this.requestorInvoiceAddress;
        data["requestorDepartment"] = this.requestorDepartment;
        data["totalAmount"] = this.totalAmount;
        data["offeredPrice"] = this.offeredPrice;
        data["totalTax"] = this.totalTax;
        data["ccEmails"] = this.ccEmails;
        data["justificationForSelection"] = this.justificationForSelection;
        data["deliveryCost"] = this.deliveryCost;
        data["installationCost"] = this.installationCost;
        data["comments"] = this.comments;
        data["vendorQuotationApprovedBy"] = this.vendorQuotationApprovedBy;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["currency"] = this.currency;
        data["exchangeRate"] = this.exchangeRate;
        data["vendorId"] = this.vendorId;
        data["vendorObject"] = this.vendorObject ? this.vendorObject.toJSON() : <any>undefined;
        return data;
    }

    clone(): Quotation {
        const json = this.toJSON();
        let result = new Quotation();
        result.init(json);
        return result;
    }
}

export interface IQuotation {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    purchaseRequisitionId: number;
    purchaseRequisition: PurchaseRequisition;
    employeeUserId: number;
    employeeName: string | undefined;
    deliveryDate: moment.Moment;
    remarks: string | undefined;
    remarksFromVendor: string | undefined;
    agreedRemarks: string | undefined;
    capexJustification: string | undefined;
    opexJustification: string | undefined;
    resaleJustification: string | undefined;
    manufacturingJustification: string | undefined;
    projectJustification: string | undefined;
    attachmentUrl1: string | undefined;
    attachmentUrl2: string | undefined;
    status: number;
    quotationReferenceNo: string | undefined;
    prReferenceNumber: string | undefined;
    deliveryAddress: string | undefined;
    requestorId: number;
    requestedDate: moment.Moment;
    approvedDate: moment.Moment;
    rejectedDate: moment.Moment;
    rejectedReason: string | undefined;
    isDraftApproved: boolean;
    isApproved: boolean;
    isCalledForQuotation: boolean;
    approverUserId: number;
    approverName: string | undefined;
    requestorName: string | undefined;
    requestorContactNo: string | undefined;
    requestorEmail: string | undefined;
    requestorDeliveryAddress: string | undefined;
    requestorInvoiceAddress: string | undefined;
    requestorDepartment: string | undefined;
    totalAmount: number;
    offeredPrice: number;
    totalTax: number;
    ccEmails: string | undefined;
    justificationForSelection: string | undefined;
    deliveryCost: number;
    installationCost: number;
    comments: string | undefined;
    vendorQuotationApprovedBy: string | undefined;
    startDate: moment.Moment;
    dueDate: moment.Moment;
    currency: string | undefined;
    exchangeRate: number;
    vendorId: number | undefined;
    vendorObject: Vendor;
}

export class QuotationDto implements IQuotationDto {
    tenantId: number;
    purchaseRequisitionId: number;
    purchaseRequisition: PurchaseRequisition;
    quotationId: number;
    employeeUserId: number;
    employeeName: string | undefined;
    deliveryDate: moment.Moment;
    remarks: string | undefined;
    remarksFromVendor: string | undefined;
    agreedRemarks: string | undefined;
    capexJustification: string | undefined;
    opexJustification: string | undefined;
    resaleJustification: string | undefined;
    manufacturingJustification: string | undefined;
    projectJustification: string | undefined;
    attachmentUrl1: string | undefined;
    attachmentUrl2: string | undefined;
    status: number;
    quotationReferenceNo: string | undefined;
    prReferenceNumber: string | undefined;
    deliveryAddress: string | undefined;
    requestorId: number;
    requestedDate: moment.Moment;
    approvedDate: moment.Moment;
    rejectedDate: moment.Moment;
    rejectedReason: string | undefined;
    isDraftApproved: boolean;
    isApproved: boolean;
    isCalledForQuotation: boolean;
    approverUserId: number;
    approverName: string | undefined;
    requestorName: string | undefined;
    requestorContactNo: string | undefined;
    requestorEmail: string | undefined;
    requestorDeliveryAddress: string | undefined;
    requestorInvoiceAddress: string | undefined;
    requestorDepartment: string | undefined;
    totalAmount: number;
    offeredPrice: number;
    totalTax: number;
    ccEmails: string | undefined;
    justificationForSelection: string | undefined;
    deliveryCost: number;
    installationCost: number;
    comments: string | undefined;
    vendorQuotationApprovedBy: string | undefined;
    startDate: moment.Moment;
    dueDate: moment.Moment;
    currency: string | undefined;
    exchangeRate: number;
    vendorId: number | undefined;
    vendorObject: Vendor;

    constructor(data?: IQuotationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.purchaseRequisitionId = _data["purchaseRequisitionId"];
            this.purchaseRequisition = _data["purchaseRequisition"] ? PurchaseRequisition.fromJS(_data["purchaseRequisition"]) : <any>undefined;
            this.quotationId = _data["quotationId"];
            this.employeeUserId = _data["employeeUserId"];
            this.employeeName = _data["employeeName"];
            this.deliveryDate = _data["deliveryDate"] ? moment(_data["deliveryDate"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.remarksFromVendor = _data["remarksFromVendor"];
            this.agreedRemarks = _data["agreedRemarks"];
            this.capexJustification = _data["capexJustification"];
            this.opexJustification = _data["opexJustification"];
            this.resaleJustification = _data["resaleJustification"];
            this.manufacturingJustification = _data["manufacturingJustification"];
            this.projectJustification = _data["projectJustification"];
            this.attachmentUrl1 = _data["attachmentUrl1"];
            this.attachmentUrl2 = _data["attachmentUrl2"];
            this.status = _data["status"];
            this.quotationReferenceNo = _data["quotationReferenceNo"];
            this.prReferenceNumber = _data["prReferenceNumber"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.requestorId = _data["requestorId"];
            this.requestedDate = _data["requestedDate"] ? moment(_data["requestedDate"].toString()) : <any>undefined;
            this.approvedDate = _data["approvedDate"] ? moment(_data["approvedDate"].toString()) : <any>undefined;
            this.rejectedDate = _data["rejectedDate"] ? moment(_data["rejectedDate"].toString()) : <any>undefined;
            this.rejectedReason = _data["rejectedReason"];
            this.isDraftApproved = _data["isDraftApproved"];
            this.isApproved = _data["isApproved"];
            this.isCalledForQuotation = _data["isCalledForQuotation"];
            this.approverUserId = _data["approverUserId"];
            this.approverName = _data["approverName"];
            this.requestorName = _data["requestorName"];
            this.requestorContactNo = _data["requestorContactNo"];
            this.requestorEmail = _data["requestorEmail"];
            this.requestorDeliveryAddress = _data["requestorDeliveryAddress"];
            this.requestorInvoiceAddress = _data["requestorInvoiceAddress"];
            this.requestorDepartment = _data["requestorDepartment"];
            this.totalAmount = _data["totalAmount"];
            this.offeredPrice = _data["offeredPrice"];
            this.totalTax = _data["totalTax"];
            this.ccEmails = _data["ccEmails"];
            this.justificationForSelection = _data["justificationForSelection"];
            this.deliveryCost = _data["deliveryCost"];
            this.installationCost = _data["installationCost"];
            this.comments = _data["comments"];
            this.vendorQuotationApprovedBy = _data["vendorQuotationApprovedBy"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.currency = _data["currency"];
            this.exchangeRate = _data["exchangeRate"];
            this.vendorId = _data["vendorId"];
            this.vendorObject = _data["vendorObject"] ? Vendor.fromJS(_data["vendorObject"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QuotationDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["purchaseRequisitionId"] = this.purchaseRequisitionId;
        data["purchaseRequisition"] = this.purchaseRequisition ? this.purchaseRequisition.toJSON() : <any>undefined;
        data["quotationId"] = this.quotationId;
        data["employeeUserId"] = this.employeeUserId;
        data["employeeName"] = this.employeeName;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["remarksFromVendor"] = this.remarksFromVendor;
        data["agreedRemarks"] = this.agreedRemarks;
        data["capexJustification"] = this.capexJustification;
        data["opexJustification"] = this.opexJustification;
        data["resaleJustification"] = this.resaleJustification;
        data["manufacturingJustification"] = this.manufacturingJustification;
        data["projectJustification"] = this.projectJustification;
        data["attachmentUrl1"] = this.attachmentUrl1;
        data["attachmentUrl2"] = this.attachmentUrl2;
        data["status"] = this.status;
        data["quotationReferenceNo"] = this.quotationReferenceNo;
        data["prReferenceNumber"] = this.prReferenceNumber;
        data["deliveryAddress"] = this.deliveryAddress;
        data["requestorId"] = this.requestorId;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>undefined;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["rejectedDate"] = this.rejectedDate ? this.rejectedDate.toISOString() : <any>undefined;
        data["rejectedReason"] = this.rejectedReason;
        data["isDraftApproved"] = this.isDraftApproved;
        data["isApproved"] = this.isApproved;
        data["isCalledForQuotation"] = this.isCalledForQuotation;
        data["approverUserId"] = this.approverUserId;
        data["approverName"] = this.approverName;
        data["requestorName"] = this.requestorName;
        data["requestorContactNo"] = this.requestorContactNo;
        data["requestorEmail"] = this.requestorEmail;
        data["requestorDeliveryAddress"] = this.requestorDeliveryAddress;
        data["requestorInvoiceAddress"] = this.requestorInvoiceAddress;
        data["requestorDepartment"] = this.requestorDepartment;
        data["totalAmount"] = this.totalAmount;
        data["offeredPrice"] = this.offeredPrice;
        data["totalTax"] = this.totalTax;
        data["ccEmails"] = this.ccEmails;
        data["justificationForSelection"] = this.justificationForSelection;
        data["deliveryCost"] = this.deliveryCost;
        data["installationCost"] = this.installationCost;
        data["comments"] = this.comments;
        data["vendorQuotationApprovedBy"] = this.vendorQuotationApprovedBy;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["currency"] = this.currency;
        data["exchangeRate"] = this.exchangeRate;
        data["vendorId"] = this.vendorId;
        data["vendorObject"] = this.vendorObject ? this.vendorObject.toJSON() : <any>undefined;
        return data;
    }

    clone(): QuotationDto {
        const json = this.toJSON();
        let result = new QuotationDto();
        result.init(json);
        return result;
    }
}

export interface IQuotationDto {
    tenantId: number;
    purchaseRequisitionId: number;
    purchaseRequisition: PurchaseRequisition;
    quotationId: number;
    employeeUserId: number;
    employeeName: string | undefined;
    deliveryDate: moment.Moment;
    remarks: string | undefined;
    remarksFromVendor: string | undefined;
    agreedRemarks: string | undefined;
    capexJustification: string | undefined;
    opexJustification: string | undefined;
    resaleJustification: string | undefined;
    manufacturingJustification: string | undefined;
    projectJustification: string | undefined;
    attachmentUrl1: string | undefined;
    attachmentUrl2: string | undefined;
    status: number;
    quotationReferenceNo: string | undefined;
    prReferenceNumber: string | undefined;
    deliveryAddress: string | undefined;
    requestorId: number;
    requestedDate: moment.Moment;
    approvedDate: moment.Moment;
    rejectedDate: moment.Moment;
    rejectedReason: string | undefined;
    isDraftApproved: boolean;
    isApproved: boolean;
    isCalledForQuotation: boolean;
    approverUserId: number;
    approverName: string | undefined;
    requestorName: string | undefined;
    requestorContactNo: string | undefined;
    requestorEmail: string | undefined;
    requestorDeliveryAddress: string | undefined;
    requestorInvoiceAddress: string | undefined;
    requestorDepartment: string | undefined;
    totalAmount: number;
    offeredPrice: number;
    totalTax: number;
    ccEmails: string | undefined;
    justificationForSelection: string | undefined;
    deliveryCost: number;
    installationCost: number;
    comments: string | undefined;
    vendorQuotationApprovedBy: string | undefined;
    startDate: moment.Moment;
    dueDate: moment.Moment;
    currency: string | undefined;
    exchangeRate: number;
    vendorId: number | undefined;
    vendorObject: Vendor;
}

export class QuotationPagedResultDto implements IQuotationPagedResultDto {
    items: Quotation[] | undefined;
    totalCount: number;

    constructor(data?: IQuotationPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(Quotation.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): QuotationPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): QuotationPagedResultDto {
        const json = this.toJSON();
        let result = new QuotationPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IQuotationPagedResultDto {
    items: Quotation[] | undefined;
    totalCount: number;
}

export class QuotationRecommendedVendors implements IQuotationRecommendedVendors {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    purchaseRequisitionId: number;
    quotationId: number;
    tenantId: number;
    name: string | undefined;
    code: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    postcode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    picName: string | undefined;
    picEmail: string | undefined;
    picContactNo: string | undefined;
    remarks: string | undefined;
    websiteLink: string | undefined;
    offeredPrice: number;
    quotationAttachment: string | undefined;
    remarksFromVendor: string | undefined;
    deliveryCost: number;
    installationCost: number;
    comments: string | undefined;
    vendorQuotationApprovedBy: string | undefined;
    status: number;
    isMeetTechnical: boolean;
    commercialEvaluation: number;
    isApproved: boolean;
    isTncAccepted: boolean;
    isEsgCompliance: boolean;
    evaluationAttachment1: string | undefined;
    vendorPaymentTerm: number;
    isEvaluated: boolean;
    lastEvaluationDate: moment.Moment | undefined;
    technicalRatings: number;
    trustRatings: number;
    tncRatings: number;
    esgRatings: number;
    bankDetails: string | undefined;
    sstRegistrationNo: string | undefined;
    companyRegNo: string | undefined;
    currency: string | undefined;
    vendorId: number | undefined;
    vendor: Vendor;
    quotationSubmissionDate: moment.Moment | undefined;

    constructor(data?: IQuotationRecommendedVendors) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.purchaseRequisitionId = _data["purchaseRequisitionId"];
            this.quotationId = _data["quotationId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.postcode = _data["postcode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.picName = _data["picName"];
            this.picEmail = _data["picEmail"];
            this.picContactNo = _data["picContactNo"];
            this.remarks = _data["remarks"];
            this.websiteLink = _data["websiteLink"];
            this.offeredPrice = _data["offeredPrice"];
            this.quotationAttachment = _data["quotationAttachment"];
            this.remarksFromVendor = _data["remarksFromVendor"];
            this.deliveryCost = _data["deliveryCost"];
            this.installationCost = _data["installationCost"];
            this.comments = _data["comments"];
            this.vendorQuotationApprovedBy = _data["vendorQuotationApprovedBy"];
            this.status = _data["status"];
            this.isMeetTechnical = _data["isMeetTechnical"];
            this.commercialEvaluation = _data["commercialEvaluation"];
            this.isApproved = _data["isApproved"];
            this.isTncAccepted = _data["isTncAccepted"];
            this.isEsgCompliance = _data["isEsgCompliance"];
            this.evaluationAttachment1 = _data["evaluationAttachment1"];
            this.vendorPaymentTerm = _data["vendorPaymentTerm"];
            this.isEvaluated = _data["isEvaluated"];
            this.lastEvaluationDate = _data["lastEvaluationDate"] ? moment(_data["lastEvaluationDate"].toString()) : <any>undefined;
            this.technicalRatings = _data["technicalRatings"];
            this.trustRatings = _data["trustRatings"];
            this.tncRatings = _data["tncRatings"];
            this.esgRatings = _data["esgRatings"];
            this.bankDetails = _data["bankDetails"];
            this.sstRegistrationNo = _data["sstRegistrationNo"];
            this.companyRegNo = _data["companyRegNo"];
            this.currency = _data["currency"];
            this.vendorId = _data["vendorId"];
            this.vendor = _data["vendor"] ? Vendor.fromJS(_data["vendor"]) : <any>undefined;
            this.quotationSubmissionDate = _data["quotationSubmissionDate"] ? moment(_data["quotationSubmissionDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): QuotationRecommendedVendors {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationRecommendedVendors();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["purchaseRequisitionId"] = this.purchaseRequisitionId;
        data["quotationId"] = this.quotationId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["postcode"] = this.postcode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["picName"] = this.picName;
        data["picEmail"] = this.picEmail;
        data["picContactNo"] = this.picContactNo;
        data["remarks"] = this.remarks;
        data["websiteLink"] = this.websiteLink;
        data["offeredPrice"] = this.offeredPrice;
        data["quotationAttachment"] = this.quotationAttachment;
        data["remarksFromVendor"] = this.remarksFromVendor;
        data["deliveryCost"] = this.deliveryCost;
        data["installationCost"] = this.installationCost;
        data["comments"] = this.comments;
        data["vendorQuotationApprovedBy"] = this.vendorQuotationApprovedBy;
        data["status"] = this.status;
        data["isMeetTechnical"] = this.isMeetTechnical;
        data["commercialEvaluation"] = this.commercialEvaluation;
        data["isApproved"] = this.isApproved;
        data["isTncAccepted"] = this.isTncAccepted;
        data["isEsgCompliance"] = this.isEsgCompliance;
        data["evaluationAttachment1"] = this.evaluationAttachment1;
        data["vendorPaymentTerm"] = this.vendorPaymentTerm;
        data["isEvaluated"] = this.isEvaluated;
        data["lastEvaluationDate"] = this.lastEvaluationDate ? this.lastEvaluationDate.toISOString() : <any>undefined;
        data["technicalRatings"] = this.technicalRatings;
        data["trustRatings"] = this.trustRatings;
        data["tncRatings"] = this.tncRatings;
        data["esgRatings"] = this.esgRatings;
        data["bankDetails"] = this.bankDetails;
        data["sstRegistrationNo"] = this.sstRegistrationNo;
        data["companyRegNo"] = this.companyRegNo;
        data["currency"] = this.currency;
        data["vendorId"] = this.vendorId;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        data["quotationSubmissionDate"] = this.quotationSubmissionDate ? this.quotationSubmissionDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): QuotationRecommendedVendors {
        const json = this.toJSON();
        let result = new QuotationRecommendedVendors();
        result.init(json);
        return result;
    }
}

export interface IQuotationRecommendedVendors {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    purchaseRequisitionId: number;
    quotationId: number;
    tenantId: number;
    name: string | undefined;
    code: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    postcode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    picName: string | undefined;
    picEmail: string | undefined;
    picContactNo: string | undefined;
    remarks: string | undefined;
    websiteLink: string | undefined;
    offeredPrice: number;
    quotationAttachment: string | undefined;
    remarksFromVendor: string | undefined;
    deliveryCost: number;
    installationCost: number;
    comments: string | undefined;
    vendorQuotationApprovedBy: string | undefined;
    status: number;
    isMeetTechnical: boolean;
    commercialEvaluation: number;
    isApproved: boolean;
    isTncAccepted: boolean;
    isEsgCompliance: boolean;
    evaluationAttachment1: string | undefined;
    vendorPaymentTerm: number;
    isEvaluated: boolean;
    lastEvaluationDate: moment.Moment | undefined;
    technicalRatings: number;
    trustRatings: number;
    tncRatings: number;
    esgRatings: number;
    bankDetails: string | undefined;
    sstRegistrationNo: string | undefined;
    companyRegNo: string | undefined;
    currency: string | undefined;
    vendorId: number | undefined;
    vendor: Vendor;
    quotationSubmissionDate: moment.Moment | undefined;
}

export class QuotationRecommendedVendorsDto implements IQuotationRecommendedVendorsDto {
    quotationRecommendedVendorId: number;
    purchaseRequisitionId: number;
    quotationId: number;
    tenantId: number;
    name: string | undefined;
    code: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    postcode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    picName: string | undefined;
    picEmail: string | undefined;
    picContactNo: string | undefined;
    remarks: string | undefined;
    websiteLink: string | undefined;
    offeredPrice: number;
    quotationAttachment: string | undefined;
    remarksFromVendor: string | undefined;
    deliveryCost: number;
    installationCost: number;
    comments: string | undefined;
    vendorQuotationApprovedBy: string | undefined;
    status: number;
    isMeetTechnical: boolean;
    commercialEvaluation: number;
    isApproved: boolean;
    isTncAccepted: boolean;
    isEsgCompliance: boolean;
    evaluationAttachment1: string | undefined;
    vendorPaymentTerm: number;
    isEvaluated: boolean;
    lastEvaluationDate: moment.Moment | undefined;
    technicalRatings: number;
    trustRatings: number;
    tncRatings: number;
    esgRatings: number;
    bankDetails: string | undefined;
    sstRegistrationNo: string | undefined;
    companyRegNo: string | undefined;
    currency: string | undefined;
    vendorId: number | undefined;
    vendor: Vendor;
    quotationSubmissionDate: moment.Moment | undefined;

    constructor(data?: IQuotationRecommendedVendorsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quotationRecommendedVendorId = _data["quotationRecommendedVendorId"];
            this.purchaseRequisitionId = _data["purchaseRequisitionId"];
            this.quotationId = _data["quotationId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.postcode = _data["postcode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.picName = _data["picName"];
            this.picEmail = _data["picEmail"];
            this.picContactNo = _data["picContactNo"];
            this.remarks = _data["remarks"];
            this.websiteLink = _data["websiteLink"];
            this.offeredPrice = _data["offeredPrice"];
            this.quotationAttachment = _data["quotationAttachment"];
            this.remarksFromVendor = _data["remarksFromVendor"];
            this.deliveryCost = _data["deliveryCost"];
            this.installationCost = _data["installationCost"];
            this.comments = _data["comments"];
            this.vendorQuotationApprovedBy = _data["vendorQuotationApprovedBy"];
            this.status = _data["status"];
            this.isMeetTechnical = _data["isMeetTechnical"];
            this.commercialEvaluation = _data["commercialEvaluation"];
            this.isApproved = _data["isApproved"];
            this.isTncAccepted = _data["isTncAccepted"];
            this.isEsgCompliance = _data["isEsgCompliance"];
            this.evaluationAttachment1 = _data["evaluationAttachment1"];
            this.vendorPaymentTerm = _data["vendorPaymentTerm"];
            this.isEvaluated = _data["isEvaluated"];
            this.lastEvaluationDate = _data["lastEvaluationDate"] ? moment(_data["lastEvaluationDate"].toString()) : <any>undefined;
            this.technicalRatings = _data["technicalRatings"];
            this.trustRatings = _data["trustRatings"];
            this.tncRatings = _data["tncRatings"];
            this.esgRatings = _data["esgRatings"];
            this.bankDetails = _data["bankDetails"];
            this.sstRegistrationNo = _data["sstRegistrationNo"];
            this.companyRegNo = _data["companyRegNo"];
            this.currency = _data["currency"];
            this.vendorId = _data["vendorId"];
            this.vendor = _data["vendor"] ? Vendor.fromJS(_data["vendor"]) : <any>undefined;
            this.quotationSubmissionDate = _data["quotationSubmissionDate"] ? moment(_data["quotationSubmissionDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): QuotationRecommendedVendorsDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotationRecommendedVendorsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quotationRecommendedVendorId"] = this.quotationRecommendedVendorId;
        data["purchaseRequisitionId"] = this.purchaseRequisitionId;
        data["quotationId"] = this.quotationId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["postcode"] = this.postcode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["picName"] = this.picName;
        data["picEmail"] = this.picEmail;
        data["picContactNo"] = this.picContactNo;
        data["remarks"] = this.remarks;
        data["websiteLink"] = this.websiteLink;
        data["offeredPrice"] = this.offeredPrice;
        data["quotationAttachment"] = this.quotationAttachment;
        data["remarksFromVendor"] = this.remarksFromVendor;
        data["deliveryCost"] = this.deliveryCost;
        data["installationCost"] = this.installationCost;
        data["comments"] = this.comments;
        data["vendorQuotationApprovedBy"] = this.vendorQuotationApprovedBy;
        data["status"] = this.status;
        data["isMeetTechnical"] = this.isMeetTechnical;
        data["commercialEvaluation"] = this.commercialEvaluation;
        data["isApproved"] = this.isApproved;
        data["isTncAccepted"] = this.isTncAccepted;
        data["isEsgCompliance"] = this.isEsgCompliance;
        data["evaluationAttachment1"] = this.evaluationAttachment1;
        data["vendorPaymentTerm"] = this.vendorPaymentTerm;
        data["isEvaluated"] = this.isEvaluated;
        data["lastEvaluationDate"] = this.lastEvaluationDate ? this.lastEvaluationDate.toISOString() : <any>undefined;
        data["technicalRatings"] = this.technicalRatings;
        data["trustRatings"] = this.trustRatings;
        data["tncRatings"] = this.tncRatings;
        data["esgRatings"] = this.esgRatings;
        data["bankDetails"] = this.bankDetails;
        data["sstRegistrationNo"] = this.sstRegistrationNo;
        data["companyRegNo"] = this.companyRegNo;
        data["currency"] = this.currency;
        data["vendorId"] = this.vendorId;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        data["quotationSubmissionDate"] = this.quotationSubmissionDate ? this.quotationSubmissionDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): QuotationRecommendedVendorsDto {
        const json = this.toJSON();
        let result = new QuotationRecommendedVendorsDto();
        result.init(json);
        return result;
    }
}

export interface IQuotationRecommendedVendorsDto {
    quotationRecommendedVendorId: number;
    purchaseRequisitionId: number;
    quotationId: number;
    tenantId: number;
    name: string | undefined;
    code: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    postcode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    picName: string | undefined;
    picEmail: string | undefined;
    picContactNo: string | undefined;
    remarks: string | undefined;
    websiteLink: string | undefined;
    offeredPrice: number;
    quotationAttachment: string | undefined;
    remarksFromVendor: string | undefined;
    deliveryCost: number;
    installationCost: number;
    comments: string | undefined;
    vendorQuotationApprovedBy: string | undefined;
    status: number;
    isMeetTechnical: boolean;
    commercialEvaluation: number;
    isApproved: boolean;
    isTncAccepted: boolean;
    isEsgCompliance: boolean;
    evaluationAttachment1: string | undefined;
    vendorPaymentTerm: number;
    isEvaluated: boolean;
    lastEvaluationDate: moment.Moment | undefined;
    technicalRatings: number;
    trustRatings: number;
    tncRatings: number;
    esgRatings: number;
    bankDetails: string | undefined;
    sstRegistrationNo: string | undefined;
    companyRegNo: string | undefined;
    currency: string | undefined;
    vendorId: number | undefined;
    vendor: Vendor;
    quotationSubmissionDate: moment.Moment | undefined;
}

export class Rate implements IRate {
    rate_id: string | undefined;
    service_detail: string | undefined;
    service_id: string | undefined;
    service_type: string | undefined;
    courier_id: string | undefined;
    courier_logo: string | undefined;
    scheduled_start_date: string | undefined;
    pickup_date: string | undefined;
    delivery: string | undefined;
    price: number;
    addon_price: number;
    shipment_price: number;
    require_min_order: number;
    service_name: string | undefined;
    courier_name: string | undefined;
    dropoff_point: DropoffPoint[] | undefined;
    pickup_point: any[] | undefined;

    constructor(data?: IRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rate_id = _data["rate_id"];
            this.service_detail = _data["service_detail"];
            this.service_id = _data["service_id"];
            this.service_type = _data["service_type"];
            this.courier_id = _data["courier_id"];
            this.courier_logo = _data["courier_logo"];
            this.scheduled_start_date = _data["scheduled_start_date"];
            this.pickup_date = _data["pickup_date"];
            this.delivery = _data["delivery"];
            this.price = _data["price"];
            this.addon_price = _data["addon_price"];
            this.shipment_price = _data["shipment_price"];
            this.require_min_order = _data["require_min_order"];
            this.service_name = _data["service_name"];
            this.courier_name = _data["courier_name"];
            if (Array.isArray(_data["dropoff_point"])) {
                this.dropoff_point = [] as any;
                for (let item of _data["dropoff_point"])
                    this.dropoff_point.push(DropoffPoint.fromJS(item));
            }
            if (Array.isArray(_data["pickup_point"])) {
                this.pickup_point = [] as any;
                for (let item of _data["pickup_point"])
                    this.pickup_point.push(item);
            }
        }
    }

    static fromJS(data: any): Rate {
        data = typeof data === 'object' ? data : {};
        let result = new Rate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate_id"] = this.rate_id;
        data["service_detail"] = this.service_detail;
        data["service_id"] = this.service_id;
        data["service_type"] = this.service_type;
        data["courier_id"] = this.courier_id;
        data["courier_logo"] = this.courier_logo;
        data["scheduled_start_date"] = this.scheduled_start_date;
        data["pickup_date"] = this.pickup_date;
        data["delivery"] = this.delivery;
        data["price"] = this.price;
        data["addon_price"] = this.addon_price;
        data["shipment_price"] = this.shipment_price;
        data["require_min_order"] = this.require_min_order;
        data["service_name"] = this.service_name;
        data["courier_name"] = this.courier_name;
        if (Array.isArray(this.dropoff_point)) {
            data["dropoff_point"] = [];
            for (let item of this.dropoff_point)
                data["dropoff_point"].push(item.toJSON());
        }
        if (Array.isArray(this.pickup_point)) {
            data["pickup_point"] = [];
            for (let item of this.pickup_point)
                data["pickup_point"].push(item);
        }
        return data;
    }

    clone(): Rate {
        const json = this.toJSON();
        let result = new Rate();
        result.init(json);
        return result;
    }
}

export interface IRate {
    rate_id: string | undefined;
    service_detail: string | undefined;
    service_id: string | undefined;
    service_type: string | undefined;
    courier_id: string | undefined;
    courier_logo: string | undefined;
    scheduled_start_date: string | undefined;
    pickup_date: string | undefined;
    delivery: string | undefined;
    price: number;
    addon_price: number;
    shipment_price: number;
    require_min_order: number;
    service_name: string | undefined;
    courier_name: string | undefined;
    dropoff_point: DropoffPoint[] | undefined;
    pickup_point: any[] | undefined;
}

export class ReceiverPoint implements IReceiverPoint {
    point_id: string | undefined;
    company: string | undefined;
    point_name: string | undefined;
    point_contact: string | undefined;
    point_lat: string | undefined;
    point_lon: string | undefined;
    point_addr1: string | undefined;
    point_addr2: string | undefined;
    point_addr3: string | undefined;
    point_addr4: string | undefined;
    point_city: string | undefined;
    point_state: string | undefined;
    point_postcode: string | undefined;
    price: number;

    constructor(data?: IReceiverPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.point_id = _data["point_id"];
            this.company = _data["company"];
            this.point_name = _data["point_name"];
            this.point_contact = _data["point_contact"];
            this.point_lat = _data["point_lat"];
            this.point_lon = _data["point_lon"];
            this.point_addr1 = _data["point_addr1"];
            this.point_addr2 = _data["point_addr2"];
            this.point_addr3 = _data["point_addr3"];
            this.point_addr4 = _data["point_addr4"];
            this.point_city = _data["point_city"];
            this.point_state = _data["point_state"];
            this.point_postcode = _data["point_postcode"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): ReceiverPoint {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiverPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["point_id"] = this.point_id;
        data["company"] = this.company;
        data["point_name"] = this.point_name;
        data["point_contact"] = this.point_contact;
        data["point_lat"] = this.point_lat;
        data["point_lon"] = this.point_lon;
        data["point_addr1"] = this.point_addr1;
        data["point_addr2"] = this.point_addr2;
        data["point_addr3"] = this.point_addr3;
        data["point_addr4"] = this.point_addr4;
        data["point_city"] = this.point_city;
        data["point_state"] = this.point_state;
        data["point_postcode"] = this.point_postcode;
        data["price"] = this.price;
        return data;
    }

    clone(): ReceiverPoint {
        const json = this.toJSON();
        let result = new ReceiverPoint();
        result.init(json);
        return result;
    }
}

export interface IReceiverPoint {
    point_id: string | undefined;
    company: string | undefined;
    point_name: string | undefined;
    point_contact: string | undefined;
    point_lat: string | undefined;
    point_lon: string | undefined;
    point_addr1: string | undefined;
    point_addr2: string | undefined;
    point_addr3: string | undefined;
    point_addr4: string | undefined;
    point_city: string | undefined;
    point_state: string | undefined;
    point_postcode: string | undefined;
    price: number;
}

export class RegisterInput implements IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }

    clone(): RegisterInput {
        const json = this.toJSON();
        let result = new RegisterInput();
        result.init(json);
        return result;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }

    clone(): RegisterOutput {
        const json = this.toJSON();
        let result = new RegisterOutput();
        result.init(json);
        return result;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class RejectedDocumentDto implements IRejectedDocumentDto {
    invoiceCodeNumber: string | undefined;
    error: ErrorDetailsDto;

    constructor(data?: IRejectedDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceCodeNumber = _data["invoiceCodeNumber"];
            this.error = _data["error"] ? ErrorDetailsDto.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RejectedDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectedDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceCodeNumber"] = this.invoiceCodeNumber;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }

    clone(): RejectedDocumentDto {
        const json = this.toJSON();
        let result = new RejectedDocumentDto();
        result.init(json);
        return result;
    }
}

export interface IRejectedDocumentDto {
    invoiceCodeNumber: string | undefined;
    error: ErrorDetailsDto;
}

export class ResetPasswordDto implements IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ResetPasswordDto {
        const json = this.toJSON();
        let result = new ResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export class ResetPasswordInputDto implements IResetPasswordInputDto {
    tenantId: number;
    emailAddress: string | undefined;
    resetCode: string | undefined;
    newPassword: string | undefined;

    constructor(data?: IResetPasswordInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.emailAddress = _data["emailAddress"];
            this.resetCode = _data["resetCode"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["resetCode"] = this.resetCode;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ResetPasswordInputDto {
        const json = this.toJSON();
        let result = new ResetPasswordInputDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordInputDto {
    tenantId: number;
    emailAddress: string | undefined;
    resetCode: string | undefined;
    newPassword: string | undefined;
}

export class ResetPasswordResponseDto implements IResetPasswordResponseDto {
    result: boolean;
    user: User;

    constructor(data?: IResetPasswordResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResetPasswordResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }

    clone(): ResetPasswordResponseDto {
        const json = this.toJSON();
        let result = new ResetPasswordResponseDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordResponseDto {
    result: boolean;
    user: User;
}

export class Result implements IResult {
    reQ_ID: string | undefined;
    status: string | undefined;
    remarks: string | undefined;
    rates: Rate[] | undefined;
    pgeon_point: PgeonPoint;

    constructor(data?: IResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reQ_ID = _data["reQ_ID"];
            this.status = _data["status"];
            this.remarks = _data["remarks"];
            if (Array.isArray(_data["rates"])) {
                this.rates = [] as any;
                for (let item of _data["rates"])
                    this.rates.push(Rate.fromJS(item));
            }
            this.pgeon_point = _data["pgeon_point"] ? PgeonPoint.fromJS(_data["pgeon_point"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Result {
        data = typeof data === 'object' ? data : {};
        let result = new Result();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reQ_ID"] = this.reQ_ID;
        data["status"] = this.status;
        data["remarks"] = this.remarks;
        if (Array.isArray(this.rates)) {
            data["rates"] = [];
            for (let item of this.rates)
                data["rates"].push(item.toJSON());
        }
        data["pgeon_point"] = this.pgeon_point ? this.pgeon_point.toJSON() : <any>undefined;
        return data;
    }

    clone(): Result {
        const json = this.toJSON();
        let result = new Result();
        result.init(json);
        return result;
    }
}

export interface IResult {
    reQ_ID: string | undefined;
    status: string | undefined;
    remarks: string | undefined;
    rates: Rate[] | undefined;
    pgeon_point: PgeonPoint;
}

export class Result2 implements IResult2 {
    reQ_ID: string | undefined;
    parcel_number: string | undefined;
    order_number: string | undefined;
    price: string | undefined;
    addon_price: string | undefined;
    addon: Addon;
    shipment_price: string | undefined;
    insurance_charges: string | undefined;
    max_insurance_coverage: string | undefined;
    cod_charges: string | undefined;
    status: string | undefined;
    remarks: string | undefined;
    courier: string | undefined;
    collect_date: string | undefined;
    orderId: string | undefined;

    constructor(data?: IResult2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reQ_ID = _data["reQ_ID"];
            this.parcel_number = _data["parcel_number"];
            this.order_number = _data["order_number"];
            this.price = _data["price"];
            this.addon_price = _data["addon_price"];
            this.addon = _data["addon"] ? Addon.fromJS(_data["addon"]) : <any>undefined;
            this.shipment_price = _data["shipment_price"];
            this.insurance_charges = _data["insurance_charges"];
            this.max_insurance_coverage = _data["max_insurance_coverage"];
            this.cod_charges = _data["cod_charges"];
            this.status = _data["status"];
            this.remarks = _data["remarks"];
            this.courier = _data["courier"];
            this.collect_date = _data["collect_date"];
            this.orderId = _data["orderId"];
        }
    }

    static fromJS(data: any): Result2 {
        data = typeof data === 'object' ? data : {};
        let result = new Result2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reQ_ID"] = this.reQ_ID;
        data["parcel_number"] = this.parcel_number;
        data["order_number"] = this.order_number;
        data["price"] = this.price;
        data["addon_price"] = this.addon_price;
        data["addon"] = this.addon ? this.addon.toJSON() : <any>undefined;
        data["shipment_price"] = this.shipment_price;
        data["insurance_charges"] = this.insurance_charges;
        data["max_insurance_coverage"] = this.max_insurance_coverage;
        data["cod_charges"] = this.cod_charges;
        data["status"] = this.status;
        data["remarks"] = this.remarks;
        data["courier"] = this.courier;
        data["collect_date"] = this.collect_date;
        data["orderId"] = this.orderId;
        return data;
    }

    clone(): Result2 {
        const json = this.toJSON();
        let result = new Result2();
        result.init(json);
        return result;
    }
}

export interface IResult2 {
    reQ_ID: string | undefined;
    parcel_number: string | undefined;
    order_number: string | undefined;
    price: string | undefined;
    addon_price: string | undefined;
    addon: Addon;
    shipment_price: string | undefined;
    insurance_charges: string | undefined;
    max_insurance_coverage: string | undefined;
    cod_charges: string | undefined;
    status: string | undefined;
    remarks: string | undefined;
    courier: string | undefined;
    collect_date: string | undefined;
    orderId: string | undefined;
}

export class RoleDto implements IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class RoleDtoListResultDto implements IRoleDtoListResultDto {
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoListResultDto {
    items: RoleDto[] | undefined;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;
}

export class RoleEditDto implements IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        return data;
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
}

export class RoleListDto implements IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class RolePermissionSetting implements IRolePermissionSetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    roleId: number;

    constructor(data?: IRolePermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isGranted = _data["isGranted"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): RolePermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new RolePermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["roleId"] = this.roleId;
        return data;
    }

    clone(): RolePermissionSetting {
        const json = this.toJSON();
        let result = new RolePermissionSetting();
        result.init(json);
        return result;
    }
}

export interface IRolePermissionSetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    roleId: number;
}

export enum SalaryType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class SellBadgeDto implements ISellBadgeDto {
    invoicePendingApprovalCount: number;
    ordersReceivedCount: number;
    financingPendingApprovalCount: number;

    constructor(data?: ISellBadgeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoicePendingApprovalCount = _data["invoicePendingApprovalCount"];
            this.ordersReceivedCount = _data["ordersReceivedCount"];
            this.financingPendingApprovalCount = _data["financingPendingApprovalCount"];
        }
    }

    static fromJS(data: any): SellBadgeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SellBadgeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoicePendingApprovalCount"] = this.invoicePendingApprovalCount;
        data["ordersReceivedCount"] = this.ordersReceivedCount;
        data["financingPendingApprovalCount"] = this.financingPendingApprovalCount;
        return data;
    }

    clone(): SellBadgeDto {
        const json = this.toJSON();
        let result = new SellBadgeDto();
        result.init(json);
        return result;
    }
}

export interface ISellBadgeDto {
    invoicePendingApprovalCount: number;
    ordersReceivedCount: number;
    financingPendingApprovalCount: number;
}

export class SenderPoint implements ISenderPoint {
    point_id: string | undefined;
    company: string | undefined;
    point_name: string | undefined;
    point_contact: string | undefined;
    point_lat: string | undefined;
    point_lon: string | undefined;
    point_addr1: string | undefined;
    point_addr2: string | undefined;
    point_addr3: string | undefined;
    point_addr4: string | undefined;
    point_city: string | undefined;
    point_state: string | undefined;
    point_postcode: string | undefined;
    price: number;

    constructor(data?: ISenderPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.point_id = _data["point_id"];
            this.company = _data["company"];
            this.point_name = _data["point_name"];
            this.point_contact = _data["point_contact"];
            this.point_lat = _data["point_lat"];
            this.point_lon = _data["point_lon"];
            this.point_addr1 = _data["point_addr1"];
            this.point_addr2 = _data["point_addr2"];
            this.point_addr3 = _data["point_addr3"];
            this.point_addr4 = _data["point_addr4"];
            this.point_city = _data["point_city"];
            this.point_state = _data["point_state"];
            this.point_postcode = _data["point_postcode"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): SenderPoint {
        data = typeof data === 'object' ? data : {};
        let result = new SenderPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["point_id"] = this.point_id;
        data["company"] = this.company;
        data["point_name"] = this.point_name;
        data["point_contact"] = this.point_contact;
        data["point_lat"] = this.point_lat;
        data["point_lon"] = this.point_lon;
        data["point_addr1"] = this.point_addr1;
        data["point_addr2"] = this.point_addr2;
        data["point_addr3"] = this.point_addr3;
        data["point_addr4"] = this.point_addr4;
        data["point_city"] = this.point_city;
        data["point_state"] = this.point_state;
        data["point_postcode"] = this.point_postcode;
        data["price"] = this.price;
        return data;
    }

    clone(): SenderPoint {
        const json = this.toJSON();
        let result = new SenderPoint();
        result.init(json);
        return result;
    }
}

export interface ISenderPoint {
    point_id: string | undefined;
    company: string | undefined;
    point_name: string | undefined;
    point_contact: string | undefined;
    point_lat: string | undefined;
    point_lon: string | undefined;
    point_addr1: string | undefined;
    point_addr2: string | undefined;
    point_addr3: string | undefined;
    point_addr4: string | undefined;
    point_city: string | undefined;
    point_state: string | undefined;
    point_postcode: string | undefined;
    price: number;
}

export class Setting implements ISetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): Setting {
        const json = this.toJSON();
        let result = new Setting();
        result.init(json);
        return result;
    }
}

export interface ISetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
}

export class SmeAnalyticsDto implements ISmeAnalyticsDto {
    invoicesSentByErp: number;
    productsSoldThroughPaymentGateway: number;
    productsSoldOutsidePaymentGateway: number;

    constructor(data?: ISmeAnalyticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoicesSentByErp = _data["invoicesSentByErp"];
            this.productsSoldThroughPaymentGateway = _data["productsSoldThroughPaymentGateway"];
            this.productsSoldOutsidePaymentGateway = _data["productsSoldOutsidePaymentGateway"];
        }
    }

    static fromJS(data: any): SmeAnalyticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmeAnalyticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoicesSentByErp"] = this.invoicesSentByErp;
        data["productsSoldThroughPaymentGateway"] = this.productsSoldThroughPaymentGateway;
        data["productsSoldOutsidePaymentGateway"] = this.productsSoldOutsidePaymentGateway;
        return data;
    }

    clone(): SmeAnalyticsDto {
        const json = this.toJSON();
        let result = new SmeAnalyticsDto();
        result.init(json);
        return result;
    }
}

export interface ISmeAnalyticsDto {
    invoicesSentByErp: number;
    productsSoldThroughPaymentGateway: number;
    productsSoldOutsidePaymentGateway: number;
}

export class StatementDto implements IStatementDto {
    date: moment.Moment | undefined;
    description: string | undefined;
    debit: number;
    credit: number;
    total: number;
    tax: number;
    billObject: Bill;
    cashbookList: Cashbooks[] | undefined;

    constructor(data?: IStatementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.debit = _data["debit"];
            this.credit = _data["credit"];
            this.total = _data["total"];
            this.tax = _data["tax"];
            this.billObject = _data["billObject"] ? Bill.fromJS(_data["billObject"]) : <any>undefined;
            if (Array.isArray(_data["cashbookList"])) {
                this.cashbookList = [] as any;
                for (let item of _data["cashbookList"])
                    this.cashbookList.push(Cashbooks.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StatementDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["debit"] = this.debit;
        data["credit"] = this.credit;
        data["total"] = this.total;
        data["tax"] = this.tax;
        data["billObject"] = this.billObject ? this.billObject.toJSON() : <any>undefined;
        if (Array.isArray(this.cashbookList)) {
            data["cashbookList"] = [];
            for (let item of this.cashbookList)
                data["cashbookList"].push(item.toJSON());
        }
        return data;
    }

    clone(): StatementDto {
        const json = this.toJSON();
        let result = new StatementDto();
        result.init(json);
        return result;
    }
}

export interface IStatementDto {
    date: moment.Moment | undefined;
    description: string | undefined;
    debit: number;
    credit: number;
    total: number;
    tax: number;
    billObject: Bill;
    cashbookList: Cashbooks[] | undefined;
}

export class SubmitDocumentsResponseDto implements ISubmitDocumentsResponseDto {
    submissionUid: string | undefined;
    acceptedDocuments: AcceptedDocumentDto[] | undefined;
    rejectedDocuments: RejectedDocumentDto[] | undefined;

    constructor(data?: ISubmitDocumentsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionUid = _data["submissionUid"];
            if (Array.isArray(_data["acceptedDocuments"])) {
                this.acceptedDocuments = [] as any;
                for (let item of _data["acceptedDocuments"])
                    this.acceptedDocuments.push(AcceptedDocumentDto.fromJS(item));
            }
            if (Array.isArray(_data["rejectedDocuments"])) {
                this.rejectedDocuments = [] as any;
                for (let item of _data["rejectedDocuments"])
                    this.rejectedDocuments.push(RejectedDocumentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubmitDocumentsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitDocumentsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionUid"] = this.submissionUid;
        if (Array.isArray(this.acceptedDocuments)) {
            data["acceptedDocuments"] = [];
            for (let item of this.acceptedDocuments)
                data["acceptedDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.rejectedDocuments)) {
            data["rejectedDocuments"] = [];
            for (let item of this.rejectedDocuments)
                data["rejectedDocuments"].push(item.toJSON());
        }
        return data;
    }

    clone(): SubmitDocumentsResponseDto {
        const json = this.toJSON();
        let result = new SubmitDocumentsResponseDto();
        result.init(json);
        return result;
    }
}

export interface ISubmitDocumentsResponseDto {
    submissionUid: string | undefined;
    acceptedDocuments: AcceptedDocumentDto[] | undefined;
    rejectedDocuments: RejectedDocumentDto[] | undefined;
}

export class SubscribableEdition implements ISubscribableEdition {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string;
    displayName: string;
    expiringEditionId: number | undefined;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    addHr: boolean;
    accessLevel: number;
    waitingDayAfterExpire: number | undefined;
    readonly isFree: boolean;

    constructor(data?: ISubscribableEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.expiringEditionId = _data["expiringEditionId"];
            this.dailyPrice = _data["dailyPrice"];
            this.weeklyPrice = _data["weeklyPrice"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.trialDayCount = _data["trialDayCount"];
            this.addHr = _data["addHr"];
            this.accessLevel = _data["accessLevel"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            (<any>this).isFree = _data["isFree"];
        }
    }

    static fromJS(data: any): SubscribableEdition {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribableEdition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["addHr"] = this.addHr;
        data["accessLevel"] = this.accessLevel;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["isFree"] = this.isFree;
        return data;
    }

    clone(): SubscribableEdition {
        const json = this.toJSON();
        let result = new SubscribableEdition();
        result.init(json);
        return result;
    }
}

export interface ISubscribableEdition {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    name: string;
    displayName: string;
    expiringEditionId: number | undefined;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    addHr: boolean;
    accessLevel: number;
    waitingDayAfterExpire: number | undefined;
    isFree: boolean;
}

export enum SubscriptionPaymentType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class Tenant implements ITenant {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    isActive: boolean;
    edition: Edition;
    editionId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    deleterUser: User;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    customCssId: string | undefined;
    logoId: string | undefined;
    logoFileType: string | undefined;
    subscriptionPaymentType: SubscriptionPaymentType;
    addHr: boolean;

    constructor(data?: ITenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
            this.edition = _data["edition"] ? Edition.fromJS(_data["edition"]) : <any>undefined;
            this.editionId = _data["editionId"];
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? moment(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.customCssId = _data["customCssId"];
            this.logoId = _data["logoId"];
            this.logoFileType = _data["logoFileType"];
            this.subscriptionPaymentType = _data["subscriptionPaymentType"];
            this.addHr = _data["addHr"];
        }
    }

    static fromJS(data: any): Tenant {
        data = typeof data === 'object' ? data : {};
        let result = new Tenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["editionId"] = this.editionId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["customCssId"] = this.customCssId;
        data["logoId"] = this.logoId;
        data["logoFileType"] = this.logoFileType;
        data["subscriptionPaymentType"] = this.subscriptionPaymentType;
        data["addHr"] = this.addHr;
        return data;
    }

    clone(): Tenant {
        const json = this.toJSON();
        let result = new Tenant();
        result.init(json);
        return result;
    }
}

export interface ITenant {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    isActive: boolean;
    edition: Edition;
    editionId: number | undefined;
    creatorUser: User;
    lastModifierUser: User;
    deleterUser: User;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    customCssId: string | undefined;
    logoId: string | undefined;
    logoFileType: string | undefined;
    subscriptionPaymentType: SubscriptionPaymentType;
    addHr: boolean;
}

export enum TenantAvailabilityState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class TenantDto implements ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;
    companyProfile: CompanyProfile;
    editionId: number | undefined;
    edition: Edition;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    customCssId: string | undefined;
    logoId: string | undefined;
    logoFileType: string | undefined;
    subscriptionPaymentType: SubscriptionPaymentType;
    addHr: boolean;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.companyProfile = _data["companyProfile"] ? CompanyProfile.fromJS(_data["companyProfile"]) : <any>undefined;
            this.editionId = _data["editionId"];
            this.edition = _data["edition"] ? Edition.fromJS(_data["edition"]) : <any>undefined;
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? moment(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.customCssId = _data["customCssId"];
            this.logoId = _data["logoId"];
            this.logoFileType = _data["logoFileType"];
            this.subscriptionPaymentType = _data["subscriptionPaymentType"];
            this.addHr = _data["addHr"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["companyProfile"] = this.companyProfile ? this.companyProfile.toJSON() : <any>undefined;
        data["editionId"] = this.editionId;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["customCssId"] = this.customCssId;
        data["logoId"] = this.logoId;
        data["logoFileType"] = this.logoFileType;
        data["subscriptionPaymentType"] = this.subscriptionPaymentType;
        data["addHr"] = this.addHr;
        return data;
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;
    companyProfile: CompanyProfile;
    editionId: number | undefined;
    edition: Edition;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    customCssId: string | undefined;
    logoId: string | undefined;
    logoFileType: string | undefined;
    subscriptionPaymentType: SubscriptionPaymentType;
    addHr: boolean;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TenantDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
    addHr: boolean;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.addHr = _data["addHr"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["addHr"] = this.addHr;
        return data;
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
    addHr: boolean;
}

export class TestTableDto implements ITestTableDto {
    name: string | undefined;

    constructor(data?: ITestTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TestTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new TestTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }

    clone(): TestTableDto {
        const json = this.toJSON();
        let result = new TestTableDto();
        result.init(json);
        return result;
    }
}

export interface ITestTableDto {
    name: string | undefined;
}

export class TfxBillDto implements ITfxBillDto {
    invoiceNo: string | undefined;
    paymentUrl: string | undefined;
    companyId: string;
    company: CompanyProfile;
    tfxBillId: number;
    totalValue: number;
    billItems: TfxBillItem[] | undefined;
    paymentBillId: string | undefined;

    constructor(data?: ITfxBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceNo = _data["invoiceNo"];
            this.paymentUrl = _data["paymentUrl"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyProfile.fromJS(_data["company"]) : <any>undefined;
            this.tfxBillId = _data["tfxBillId"];
            this.totalValue = _data["totalValue"];
            if (Array.isArray(_data["billItems"])) {
                this.billItems = [] as any;
                for (let item of _data["billItems"])
                    this.billItems.push(TfxBillItem.fromJS(item));
            }
            this.paymentBillId = _data["paymentBillId"];
        }
    }

    static fromJS(data: any): TfxBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new TfxBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceNo"] = this.invoiceNo;
        data["paymentUrl"] = this.paymentUrl;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["tfxBillId"] = this.tfxBillId;
        data["totalValue"] = this.totalValue;
        if (Array.isArray(this.billItems)) {
            data["billItems"] = [];
            for (let item of this.billItems)
                data["billItems"].push(item.toJSON());
        }
        data["paymentBillId"] = this.paymentBillId;
        return data;
    }

    clone(): TfxBillDto {
        const json = this.toJSON();
        let result = new TfxBillDto();
        result.init(json);
        return result;
    }
}

export interface ITfxBillDto {
    invoiceNo: string | undefined;
    paymentUrl: string | undefined;
    companyId: string;
    company: CompanyProfile;
    tfxBillId: number;
    totalValue: number;
    billItems: TfxBillItem[] | undefined;
    paymentBillId: string | undefined;
}

export class TfxBillDtoPagedResultDto implements ITfxBillDtoPagedResultDto {
    items: TfxBillDto[] | undefined;
    totalCount: number;

    constructor(data?: ITfxBillDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TfxBillDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TfxBillDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TfxBillDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TfxBillDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TfxBillDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITfxBillDtoPagedResultDto {
    items: TfxBillDto[] | undefined;
    totalCount: number;
}

export class TfxBillItem implements ITfxBillItem {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tfxBillId: number;
    productName: string | undefined;
    quantity: number;
    unitPrice: number;
    orderId: string | undefined;

    constructor(data?: ITfxBillItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tfxBillId = _data["tfxBillId"];
            this.productName = _data["productName"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.orderId = _data["orderId"];
        }
    }

    static fromJS(data: any): TfxBillItem {
        data = typeof data === 'object' ? data : {};
        let result = new TfxBillItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tfxBillId"] = this.tfxBillId;
        data["productName"] = this.productName;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["orderId"] = this.orderId;
        return data;
    }

    clone(): TfxBillItem {
        const json = this.toJSON();
        let result = new TfxBillItem();
        result.init(json);
        return result;
    }
}

export interface ITfxBillItem {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tfxBillId: number;
    productName: string | undefined;
    quantity: number;
    unitPrice: number;
    orderId: string | undefined;
}

export class TfxBillItemDto implements ITfxBillItemDto {
    tfxBillId: number;
    productName: string | undefined;
    quantity: number;
    unitPrice: number;
    orderId: string | undefined;

    constructor(data?: ITfxBillItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tfxBillId = _data["tfxBillId"];
            this.productName = _data["productName"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.orderId = _data["orderId"];
        }
    }

    static fromJS(data: any): TfxBillItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TfxBillItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tfxBillId"] = this.tfxBillId;
        data["productName"] = this.productName;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["orderId"] = this.orderId;
        return data;
    }

    clone(): TfxBillItemDto {
        const json = this.toJSON();
        let result = new TfxBillItemDto();
        result.init(json);
        return result;
    }
}

export interface ITfxBillItemDto {
    tfxBillId: number;
    productName: string | undefined;
    quantity: number;
    unitPrice: number;
    orderId: string | undefined;
}

export class TfxCurrency implements ITfxCurrency {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    base: string | undefined;
    date: string | undefined;
    usd: number;
    gbp: number;
    eur: number;
    sgd: number;
    idr: number;
    cny: number;
    jpy: number;

    constructor(data?: ITfxCurrency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.base = _data["base"];
            this.date = _data["date"];
            this.usd = _data["usd"];
            this.gbp = _data["gbp"];
            this.eur = _data["eur"];
            this.sgd = _data["sgd"];
            this.idr = _data["idr"];
            this.cny = _data["cny"];
            this.jpy = _data["jpy"];
        }
    }

    static fromJS(data: any): TfxCurrency {
        data = typeof data === 'object' ? data : {};
        let result = new TfxCurrency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["base"] = this.base;
        data["date"] = this.date;
        data["usd"] = this.usd;
        data["gbp"] = this.gbp;
        data["eur"] = this.eur;
        data["sgd"] = this.sgd;
        data["idr"] = this.idr;
        data["cny"] = this.cny;
        data["jpy"] = this.jpy;
        return data;
    }

    clone(): TfxCurrency {
        const json = this.toJSON();
        let result = new TfxCurrency();
        result.init(json);
        return result;
    }
}

export interface ITfxCurrency {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    base: string | undefined;
    date: string | undefined;
    usd: number;
    gbp: number;
    eur: number;
    sgd: number;
    idr: number;
    cny: number;
    jpy: number;
}

export class TfxHolidayDto implements ITfxHolidayDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    countryId: string | undefined;
    countryName: string | undefined;
    year: number;
    month: number;
    day: number;
    readonly date: moment.Moment;
    name: string | undefined;
    description: string | undefined;
    type: string | undefined;
    primaryType: string | undefined;
    canonicalUrl: string | undefined;
    urlId: string | undefined;
    locations: string | undefined;
    states: string | undefined;

    constructor(data?: ITfxHolidayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.countryId = _data["countryId"];
            this.countryName = _data["countryName"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.day = _data["day"];
            (<any>this).date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
            this.type = _data["type"];
            this.primaryType = _data["primaryType"];
            this.canonicalUrl = _data["canonicalUrl"];
            this.urlId = _data["urlId"];
            this.locations = _data["locations"];
            this.states = _data["states"];
        }
    }

    static fromJS(data: any): TfxHolidayDto {
        data = typeof data === 'object' ? data : {};
        let result = new TfxHolidayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        data["year"] = this.year;
        data["month"] = this.month;
        data["day"] = this.day;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["type"] = this.type;
        data["primaryType"] = this.primaryType;
        data["canonicalUrl"] = this.canonicalUrl;
        data["urlId"] = this.urlId;
        data["locations"] = this.locations;
        data["states"] = this.states;
        return data;
    }

    clone(): TfxHolidayDto {
        const json = this.toJSON();
        let result = new TfxHolidayDto();
        result.init(json);
        return result;
    }
}

export interface ITfxHolidayDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    countryId: string | undefined;
    countryName: string | undefined;
    year: number;
    month: number;
    day: number;
    date: moment.Moment;
    name: string | undefined;
    description: string | undefined;
    type: string | undefined;
    primaryType: string | undefined;
    canonicalUrl: string | undefined;
    urlId: string | undefined;
    locations: string | undefined;
    states: string | undefined;
}

export class TilesDto implements ITilesDto {
    totalProduct: number;
    totalCustomer: number;
    totalUnpaidInvoices: number;
    totalPaidInvoices: number;

    constructor(data?: ITilesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProduct = _data["totalProduct"];
            this.totalCustomer = _data["totalCustomer"];
            this.totalUnpaidInvoices = _data["totalUnpaidInvoices"];
            this.totalPaidInvoices = _data["totalPaidInvoices"];
        }
    }

    static fromJS(data: any): TilesDto {
        data = typeof data === 'object' ? data : {};
        let result = new TilesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProduct"] = this.totalProduct;
        data["totalCustomer"] = this.totalCustomer;
        data["totalUnpaidInvoices"] = this.totalUnpaidInvoices;
        data["totalPaidInvoices"] = this.totalPaidInvoices;
        return data;
    }

    clone(): TilesDto {
        const json = this.toJSON();
        let result = new TilesDto();
        result.init(json);
        return result;
    }
}

export interface ITilesDto {
    totalProduct: number;
    totalCustomer: number;
    totalUnpaidInvoices: number;
    totalPaidInvoices: number;
}

export class TransactionDto implements ITransactionDto {
    balance: number;
    name: string | undefined;
    payment: number;
    time: string | undefined;
    total: number;
    type: string | undefined;
    docId: string | undefined;
    attachments: string[] | undefined;
    vendorInvoiceId: number;

    constructor(data?: ITransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.balance = _data["balance"];
            this.name = _data["name"];
            this.payment = _data["payment"];
            this.time = _data["time"];
            this.total = _data["total"];
            this.type = _data["type"];
            this.docId = _data["docId"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments.push(item);
            }
            this.vendorInvoiceId = _data["vendorInvoiceId"];
        }
    }

    static fromJS(data: any): TransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["balance"] = this.balance;
        data["name"] = this.name;
        data["payment"] = this.payment;
        data["time"] = this.time;
        data["total"] = this.total;
        data["type"] = this.type;
        data["docId"] = this.docId;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item);
        }
        data["vendorInvoiceId"] = this.vendorInvoiceId;
        return data;
    }

    clone(): TransactionDto {
        const json = this.toJSON();
        let result = new TransactionDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionDto {
    balance: number;
    name: string | undefined;
    payment: number;
    time: string | undefined;
    total: number;
    type: string | undefined;
    docId: string | undefined;
    attachments: string[] | undefined;
    vendorInvoiceId: number;
}

export class TransactionItemDto implements ITransactionItemDto {
    productId: string | undefined;
    balance: number;
    name: string | undefined;
    payment: number;
    price: number;
    time: string | undefined;
    category: string | undefined;
    transactionName: string | undefined;
    product: Product;

    constructor(data?: ITransactionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.balance = _data["balance"];
            this.name = _data["name"];
            this.payment = _data["payment"];
            this.price = _data["price"];
            this.time = _data["time"];
            this.category = _data["category"];
            this.transactionName = _data["transactionName"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TransactionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["balance"] = this.balance;
        data["name"] = this.name;
        data["payment"] = this.payment;
        data["price"] = this.price;
        data["time"] = this.time;
        data["category"] = this.category;
        data["transactionName"] = this.transactionName;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        return data;
    }

    clone(): TransactionItemDto {
        const json = this.toJSON();
        let result = new TransactionItemDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionItemDto {
    productId: string | undefined;
    balance: number;
    name: string | undefined;
    payment: number;
    price: number;
    time: string | undefined;
    category: string | undefined;
    transactionName: string | undefined;
    product: Product;
}

export class TransactionSummaryDto implements ITransactionSummaryDto {
    collection: number;
    dateString: string | undefined;
    cashin: number;
    name: string | undefined;
    open: number;
    sales: number;
    spending: number;
    transactions: TransactionDto[] | undefined;
    transactionItems: TransactionItemDto[] | undefined;

    constructor(data?: ITransactionSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.collection = _data["collection"];
            this.dateString = _data["dateString"];
            this.cashin = _data["cashin"];
            this.name = _data["name"];
            this.open = _data["open"];
            this.sales = _data["sales"];
            this.spending = _data["spending"];
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["transactions"])
                    this.transactions.push(TransactionDto.fromJS(item));
            }
            if (Array.isArray(_data["transactionItems"])) {
                this.transactionItems = [] as any;
                for (let item of _data["transactionItems"])
                    this.transactionItems.push(TransactionItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransactionSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["collection"] = this.collection;
        data["dateString"] = this.dateString;
        data["cashin"] = this.cashin;
        data["name"] = this.name;
        data["open"] = this.open;
        data["sales"] = this.sales;
        data["spending"] = this.spending;
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        if (Array.isArray(this.transactionItems)) {
            data["transactionItems"] = [];
            for (let item of this.transactionItems)
                data["transactionItems"].push(item.toJSON());
        }
        return data;
    }

    clone(): TransactionSummaryDto {
        const json = this.toJSON();
        let result = new TransactionSummaryDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionSummaryDto {
    collection: number;
    dateString: string | undefined;
    cashin: number;
    name: string | undefined;
    open: number;
    sales: number;
    spending: number;
    transactions: TransactionDto[] | undefined;
    transactionItems: TransactionItemDto[] | undefined;
}

export class UpdateBillDto implements IUpdateBillDto {
    billNo: string;
    billType: string;
    issueDate: moment.Moment;
    dueDate: moment.Moment;
    paymentTerm: number;
    remarks: string | undefined;
    totalDiscount: number;
    totalTax: number;
    totalAmount: number;
    status: string;
    customerId: string | undefined;
    tenantId: number | undefined;
    receivedDate: moment.Moment | undefined;
    paymentUrl: string | undefined;
    paymentDate: moment.Moment | undefined;
    paymentId: string | undefined;
    invoiceMessage: string | undefined;
    ccEmails: string | undefined;
    taxAmount: number;
    totalSubtotal: number;
    goodsReceived: boolean;
    goodsReceivedDate: moment.Moment | undefined;
    poReferenceNumber: string | undefined;
    shippingName: string | undefined;
    shippingAddress1: string | undefined;
    shippingAddress2: string | undefined;
    shippingCity: string | undefined;
    shippingState: string | undefined;
    shippingCountry: string | undefined;
    shippingPoscode: string | undefined;
    deliveryCharge: number;
    totalCreditNote: number;
    addtionalRemark: string | undefined;
    totalCreditnoteTax: number;
    isApproved: boolean;
    approvalRequestUserId: number;
    approvalRequestDate: moment.Moment;
    approvedDate: moment.Moment;
    approvalRequestName: string | undefined;
    paymentMethodId: number;
    paymentBankName: string | undefined;
    paymentBankAccountNo: string | undefined;
    paymentBankAccountHolder: string | undefined;
    reasonDateChange: string | undefined;
    warehouseId: number | undefined;
    warehouse: InventoryWarehouse;
    isUpdatedInventory: boolean;
    projectId: number;
    postMigration: boolean;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    currency: string | undefined;
    exchangeRate: number;
    id: string;

    constructor(data?: IUpdateBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billNo = _data["billNo"];
            this.billType = _data["billType"];
            this.issueDate = _data["issueDate"] ? moment(_data["issueDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.paymentTerm = _data["paymentTerm"];
            this.remarks = _data["remarks"];
            this.totalDiscount = _data["totalDiscount"];
            this.totalTax = _data["totalTax"];
            this.totalAmount = _data["totalAmount"];
            this.status = _data["status"];
            this.customerId = _data["customerId"];
            this.tenantId = _data["tenantId"];
            this.receivedDate = _data["receivedDate"] ? moment(_data["receivedDate"].toString()) : <any>undefined;
            this.paymentUrl = _data["paymentUrl"];
            this.paymentDate = _data["paymentDate"] ? moment(_data["paymentDate"].toString()) : <any>undefined;
            this.paymentId = _data["paymentId"];
            this.invoiceMessage = _data["invoiceMessage"];
            this.ccEmails = _data["ccEmails"];
            this.taxAmount = _data["taxAmount"];
            this.totalSubtotal = _data["totalSubtotal"];
            this.goodsReceived = _data["goodsReceived"];
            this.goodsReceivedDate = _data["goodsReceivedDate"] ? moment(_data["goodsReceivedDate"].toString()) : <any>undefined;
            this.poReferenceNumber = _data["poReferenceNumber"];
            this.shippingName = _data["shippingName"];
            this.shippingAddress1 = _data["shippingAddress1"];
            this.shippingAddress2 = _data["shippingAddress2"];
            this.shippingCity = _data["shippingCity"];
            this.shippingState = _data["shippingState"];
            this.shippingCountry = _data["shippingCountry"];
            this.shippingPoscode = _data["shippingPoscode"];
            this.deliveryCharge = _data["deliveryCharge"];
            this.totalCreditNote = _data["totalCreditNote"];
            this.addtionalRemark = _data["addtionalRemark"];
            this.totalCreditnoteTax = _data["totalCreditnoteTax"];
            this.isApproved = _data["isApproved"];
            this.approvalRequestUserId = _data["approvalRequestUserId"];
            this.approvalRequestDate = _data["approvalRequestDate"] ? moment(_data["approvalRequestDate"].toString()) : <any>undefined;
            this.approvedDate = _data["approvedDate"] ? moment(_data["approvedDate"].toString()) : <any>undefined;
            this.approvalRequestName = _data["approvalRequestName"];
            this.paymentMethodId = _data["paymentMethodId"];
            this.paymentBankName = _data["paymentBankName"];
            this.paymentBankAccountNo = _data["paymentBankAccountNo"];
            this.paymentBankAccountHolder = _data["paymentBankAccountHolder"];
            this.reasonDateChange = _data["reasonDateChange"];
            this.warehouseId = _data["warehouseId"];
            this.warehouse = _data["warehouse"] ? InventoryWarehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.isUpdatedInventory = _data["isUpdatedInventory"];
            this.projectId = _data["projectId"];
            this.postMigration = _data["postMigration"];
            this.categoryCode = _data["categoryCode"];
            this.categoryName = _data["categoryName"];
            this.currency = _data["currency"];
            this.exchangeRate = _data["exchangeRate"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billNo"] = this.billNo;
        data["billType"] = this.billType;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["paymentTerm"] = this.paymentTerm;
        data["remarks"] = this.remarks;
        data["totalDiscount"] = this.totalDiscount;
        data["totalTax"] = this.totalTax;
        data["totalAmount"] = this.totalAmount;
        data["status"] = this.status;
        data["customerId"] = this.customerId;
        data["tenantId"] = this.tenantId;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["paymentUrl"] = this.paymentUrl;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentId"] = this.paymentId;
        data["invoiceMessage"] = this.invoiceMessage;
        data["ccEmails"] = this.ccEmails;
        data["taxAmount"] = this.taxAmount;
        data["totalSubtotal"] = this.totalSubtotal;
        data["goodsReceived"] = this.goodsReceived;
        data["goodsReceivedDate"] = this.goodsReceivedDate ? this.goodsReceivedDate.toISOString() : <any>undefined;
        data["poReferenceNumber"] = this.poReferenceNumber;
        data["shippingName"] = this.shippingName;
        data["shippingAddress1"] = this.shippingAddress1;
        data["shippingAddress2"] = this.shippingAddress2;
        data["shippingCity"] = this.shippingCity;
        data["shippingState"] = this.shippingState;
        data["shippingCountry"] = this.shippingCountry;
        data["shippingPoscode"] = this.shippingPoscode;
        data["deliveryCharge"] = this.deliveryCharge;
        data["totalCreditNote"] = this.totalCreditNote;
        data["addtionalRemark"] = this.addtionalRemark;
        data["totalCreditnoteTax"] = this.totalCreditnoteTax;
        data["isApproved"] = this.isApproved;
        data["approvalRequestUserId"] = this.approvalRequestUserId;
        data["approvalRequestDate"] = this.approvalRequestDate ? this.approvalRequestDate.toISOString() : <any>undefined;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["approvalRequestName"] = this.approvalRequestName;
        data["paymentMethodId"] = this.paymentMethodId;
        data["paymentBankName"] = this.paymentBankName;
        data["paymentBankAccountNo"] = this.paymentBankAccountNo;
        data["paymentBankAccountHolder"] = this.paymentBankAccountHolder;
        data["reasonDateChange"] = this.reasonDateChange;
        data["warehouseId"] = this.warehouseId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["isUpdatedInventory"] = this.isUpdatedInventory;
        data["projectId"] = this.projectId;
        data["postMigration"] = this.postMigration;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["currency"] = this.currency;
        data["exchangeRate"] = this.exchangeRate;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateBillDto {
        const json = this.toJSON();
        let result = new UpdateBillDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateBillDto {
    billNo: string;
    billType: string;
    issueDate: moment.Moment;
    dueDate: moment.Moment;
    paymentTerm: number;
    remarks: string | undefined;
    totalDiscount: number;
    totalTax: number;
    totalAmount: number;
    status: string;
    customerId: string | undefined;
    tenantId: number | undefined;
    receivedDate: moment.Moment | undefined;
    paymentUrl: string | undefined;
    paymentDate: moment.Moment | undefined;
    paymentId: string | undefined;
    invoiceMessage: string | undefined;
    ccEmails: string | undefined;
    taxAmount: number;
    totalSubtotal: number;
    goodsReceived: boolean;
    goodsReceivedDate: moment.Moment | undefined;
    poReferenceNumber: string | undefined;
    shippingName: string | undefined;
    shippingAddress1: string | undefined;
    shippingAddress2: string | undefined;
    shippingCity: string | undefined;
    shippingState: string | undefined;
    shippingCountry: string | undefined;
    shippingPoscode: string | undefined;
    deliveryCharge: number;
    totalCreditNote: number;
    addtionalRemark: string | undefined;
    totalCreditnoteTax: number;
    isApproved: boolean;
    approvalRequestUserId: number;
    approvalRequestDate: moment.Moment;
    approvedDate: moment.Moment;
    approvalRequestName: string | undefined;
    paymentMethodId: number;
    paymentBankName: string | undefined;
    paymentBankAccountNo: string | undefined;
    paymentBankAccountHolder: string | undefined;
    reasonDateChange: string | undefined;
    warehouseId: number | undefined;
    warehouse: InventoryWarehouse;
    isUpdatedInventory: boolean;
    projectId: number;
    postMigration: boolean;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    currency: string | undefined;
    exchangeRate: number;
    id: string;
}

export class UpdateBillItemDto implements IUpdateBillItemDto {
    quantity: number;
    unitPrice: number;
    discount: number;
    tax: number;
    productId: string;
    billId: string;
    taxCode: string | undefined;
    orderId: string;
    creditNote: number;
    productShelfId: number | undefined;
    id: string;

    constructor(data?: IUpdateBillItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.discount = _data["discount"];
            this.tax = _data["tax"];
            this.productId = _data["productId"];
            this.billId = _data["billId"];
            this.taxCode = _data["taxCode"];
            this.orderId = _data["orderId"];
            this.creditNote = _data["creditNote"];
            this.productShelfId = _data["productShelfId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateBillItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBillItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["discount"] = this.discount;
        data["tax"] = this.tax;
        data["productId"] = this.productId;
        data["billId"] = this.billId;
        data["taxCode"] = this.taxCode;
        data["orderId"] = this.orderId;
        data["creditNote"] = this.creditNote;
        data["productShelfId"] = this.productShelfId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateBillItemDto {
        const json = this.toJSON();
        let result = new UpdateBillItemDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateBillItemDto {
    quantity: number;
    unitPrice: number;
    discount: number;
    tax: number;
    productId: string;
    billId: string;
    taxCode: string | undefined;
    orderId: string;
    creditNote: number;
    productShelfId: number | undefined;
    id: string;
}

export class UpdateBillplzDto implements IUpdateBillplzDto {
    companyProfileId: string;
    billplzEmail: string | undefined;
    billplzPhone: string | undefined;
    billplzPassword: string | undefined;
    billplzStatusId: number;
    billplzCollectionId: string | undefined;
    billplzSecretKey: string | undefined;

    constructor(data?: IUpdateBillplzDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyProfileId = _data["companyProfileId"];
            this.billplzEmail = _data["billplzEmail"];
            this.billplzPhone = _data["billplzPhone"];
            this.billplzPassword = _data["billplzPassword"];
            this.billplzStatusId = _data["billplzStatusId"];
            this.billplzCollectionId = _data["billplzCollectionId"];
            this.billplzSecretKey = _data["billplzSecretKey"];
        }
    }

    static fromJS(data: any): UpdateBillplzDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBillplzDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyProfileId"] = this.companyProfileId;
        data["billplzEmail"] = this.billplzEmail;
        data["billplzPhone"] = this.billplzPhone;
        data["billplzPassword"] = this.billplzPassword;
        data["billplzStatusId"] = this.billplzStatusId;
        data["billplzCollectionId"] = this.billplzCollectionId;
        data["billplzSecretKey"] = this.billplzSecretKey;
        return data;
    }

    clone(): UpdateBillplzDto {
        const json = this.toJSON();
        let result = new UpdateBillplzDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateBillplzDto {
    companyProfileId: string;
    billplzEmail: string | undefined;
    billplzPhone: string | undefined;
    billplzPassword: string | undefined;
    billplzStatusId: number;
    billplzCollectionId: string | undefined;
    billplzSecretKey: string | undefined;
}

export class UpdateCartDto implements IUpdateCartDto {
    userId: number;
    tenantId: number;
    productId: string;
    name: string;
    quantity: number;
    unitPrice: number;
    discount: number;
    tax: number;
    taxCode: string | undefined;
    docId: string | undefined;
    additionalInfo: string | undefined;
    id: string;

    constructor(data?: IUpdateCartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.productId = _data["productId"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.discount = _data["discount"];
            this.tax = _data["tax"];
            this.taxCode = _data["taxCode"];
            this.docId = _data["docId"];
            this.additionalInfo = _data["additionalInfo"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCartDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["productId"] = this.productId;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["discount"] = this.discount;
        data["tax"] = this.tax;
        data["taxCode"] = this.taxCode;
        data["docId"] = this.docId;
        data["additionalInfo"] = this.additionalInfo;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateCartDto {
        const json = this.toJSON();
        let result = new UpdateCartDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCartDto {
    userId: number;
    tenantId: number;
    productId: string;
    name: string;
    quantity: number;
    unitPrice: number;
    discount: number;
    tax: number;
    taxCode: string | undefined;
    docId: string | undefined;
    additionalInfo: string | undefined;
    id: string;
}

export class UpdateCompanyProfileDto implements IUpdateCompanyProfileDto {
    tenantId: number;
    companyRegNo: string;
    companyName: string;
    contactNo: string;
    email: string | undefined;
    address1: string | undefined;
    address2: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    pAddress1: string | undefined;
    pAddress2: string | undefined;
    pPostCode: string | undefined;
    pCity: string | undefined;
    pState: string | undefined;
    pCountry: string | undefined;
    accountFullName: string | undefined;
    accountEmailAddress: string | undefined;
    accountPassword: string | undefined;
    businessCompanyRegNo: string | undefined;
    businessAddress: string | undefined;
    bnmCode: string | undefined;
    picName: string | undefined;
    picPosition: string | undefined;
    picEmailAddress: string | undefined;
    picPhoneNumber: string | undefined;
    companyLogo: string | undefined;
    bankName: string | undefined;
    bankAccountHolder: string | undefined;
    bankAccountNo: string | undefined;
    invoiceTemplate: number | undefined;
    brandingColor: string | undefined;
    invoiceMessage: string | undefined;
    remarkMessage: string | undefined;
    revenue: string | undefined;
    numberOfEmployees: number;
    tutorialCompleted: boolean;
    dayDueReminder: number;
    invoiceTnC: string | undefined;
    invoiceApproval: boolean;
    requisitionApproval: boolean;
    customerApproval: boolean;
    productApproval: boolean;
    mainBannerUrl: string | undefined;
    mainBannerTitle: string | undefined;
    mainBannerDescription: string | undefined;
    lastActive: moment.Moment;
    hideFromMarketplace: boolean;
    websiteLink: string | undefined;
    facebookLink: string | undefined;
    youtubeLink: string | undefined;
    whatsappLink: string | undefined;
    secondaryBankName: string | undefined;
    secondaryBankAccountHolder: string | undefined;
    secondaryBankAccountNo: string | undefined;
    secondaryBannerUrl: string | undefined;
    secondaryBannerTitle: string | undefined;
    secondaryBannerDescription: string | undefined;
    isScfOnboarded: boolean;
    scfTenancyName: string | undefined;
    scfTenantId: number;
    scfEmail: string | undefined;
    scfPassword: string | undefined;
    scfApplicationStatus: number;
    scfSupplierId: number;
    purchaseOrderMessage: string | undefined;
    quotationMessage: string | undefined;
    requisitionApproverDepartmentId: number | undefined;
    poDeliveryDueReminder: number;
    producerTenantId: number;
    typeOfCompany: string | undefined;
    overheadAllocation: number;
    financialYearOffset: number;
    financialYearStartDay: number;
    financialYearStartMonth: number;
    coreActivityDescription: string | undefined;
    isHideBankFromInvoice: boolean;
    aiOnboardingStatus: string | undefined;
    facebookURL: string | undefined;
    instagramURL: string | undefined;
    postFacebook: boolean;
    postInstagram: boolean;
    postTwitter: boolean;
    postLinkedin: boolean;
    postOthers: string | undefined;
    forBrandAwareness: boolean;
    forLeadGeneration: boolean;
    forEngagement: boolean;
    forCustomerSupport: boolean;
    forSales: boolean;
    professionalTone: boolean;
    casualTone: boolean;
    informativeTone: boolean;
    funTone: boolean;
    inspirationalTone: boolean;
    targetAudience: string | undefined;
    imageContent: boolean;
    videoContent: boolean;
    blogContent: boolean;
    infographicContent: boolean;
    podcastContent: boolean;
    webinarContent: boolean;
    topicsToCover: string | undefined;
    topicsToAvoid: string | undefined;
    productsToPromote: string | undefined;
    keyMessages: string | undefined;
    guideLines: string | undefined;
    postWeekday: boolean;
    postWeekend: boolean;
    postMorning: boolean;
    postAfternoon: boolean;
    postEvening: boolean;
    significantDates: string | undefined;
    postFrequency: string | undefined;
    numberOfWords: string | undefined;
    marketingRefence: string | undefined;
    exampleLink: string | undefined;
    extraInfo: string | undefined;
    totalSmsSent: number;
    purchasedPos: boolean;
    currency: string | undefined;
    sharesIssued: number;
    taxIdentificationNumber: string | undefined;
    id: string;

    constructor(data?: IUpdateCompanyProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.companyRegNo = _data["companyRegNo"];
            this.companyName = _data["companyName"];
            this.contactNo = _data["contactNo"];
            this.email = _data["email"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.pAddress1 = _data["pAddress1"];
            this.pAddress2 = _data["pAddress2"];
            this.pPostCode = _data["pPostCode"];
            this.pCity = _data["pCity"];
            this.pState = _data["pState"];
            this.pCountry = _data["pCountry"];
            this.accountFullName = _data["accountFullName"];
            this.accountEmailAddress = _data["accountEmailAddress"];
            this.accountPassword = _data["accountPassword"];
            this.businessCompanyRegNo = _data["businessCompanyRegNo"];
            this.businessAddress = _data["businessAddress"];
            this.bnmCode = _data["bnmCode"];
            this.picName = _data["picName"];
            this.picPosition = _data["picPosition"];
            this.picEmailAddress = _data["picEmailAddress"];
            this.picPhoneNumber = _data["picPhoneNumber"];
            this.companyLogo = _data["companyLogo"];
            this.bankName = _data["bankName"];
            this.bankAccountHolder = _data["bankAccountHolder"];
            this.bankAccountNo = _data["bankAccountNo"];
            this.invoiceTemplate = _data["invoiceTemplate"];
            this.brandingColor = _data["brandingColor"];
            this.invoiceMessage = _data["invoiceMessage"];
            this.remarkMessage = _data["remarkMessage"];
            this.revenue = _data["revenue"];
            this.numberOfEmployees = _data["numberOfEmployees"];
            this.tutorialCompleted = _data["tutorialCompleted"];
            this.dayDueReminder = _data["dayDueReminder"];
            this.invoiceTnC = _data["invoiceTnC"];
            this.invoiceApproval = _data["invoiceApproval"];
            this.requisitionApproval = _data["requisitionApproval"];
            this.customerApproval = _data["customerApproval"];
            this.productApproval = _data["productApproval"];
            this.mainBannerUrl = _data["mainBannerUrl"];
            this.mainBannerTitle = _data["mainBannerTitle"];
            this.mainBannerDescription = _data["mainBannerDescription"];
            this.lastActive = _data["lastActive"] ? moment(_data["lastActive"].toString()) : <any>undefined;
            this.hideFromMarketplace = _data["hideFromMarketplace"];
            this.websiteLink = _data["websiteLink"];
            this.facebookLink = _data["facebookLink"];
            this.youtubeLink = _data["youtubeLink"];
            this.whatsappLink = _data["whatsappLink"];
            this.secondaryBankName = _data["secondaryBankName"];
            this.secondaryBankAccountHolder = _data["secondaryBankAccountHolder"];
            this.secondaryBankAccountNo = _data["secondaryBankAccountNo"];
            this.secondaryBannerUrl = _data["secondaryBannerUrl"];
            this.secondaryBannerTitle = _data["secondaryBannerTitle"];
            this.secondaryBannerDescription = _data["secondaryBannerDescription"];
            this.isScfOnboarded = _data["isScfOnboarded"];
            this.scfTenancyName = _data["scfTenancyName"];
            this.scfTenantId = _data["scfTenantId"];
            this.scfEmail = _data["scfEmail"];
            this.scfPassword = _data["scfPassword"];
            this.scfApplicationStatus = _data["scfApplicationStatus"];
            this.scfSupplierId = _data["scfSupplierId"];
            this.purchaseOrderMessage = _data["purchaseOrderMessage"];
            this.quotationMessage = _data["quotationMessage"];
            this.requisitionApproverDepartmentId = _data["requisitionApproverDepartmentId"];
            this.poDeliveryDueReminder = _data["poDeliveryDueReminder"];
            this.producerTenantId = _data["producerTenantId"];
            this.typeOfCompany = _data["typeOfCompany"];
            this.overheadAllocation = _data["overheadAllocation"];
            this.financialYearOffset = _data["financialYearOffset"];
            this.financialYearStartDay = _data["financialYearStartDay"];
            this.financialYearStartMonth = _data["financialYearStartMonth"];
            this.coreActivityDescription = _data["coreActivityDescription"];
            this.isHideBankFromInvoice = _data["isHideBankFromInvoice"];
            this.aiOnboardingStatus = _data["aiOnboardingStatus"];
            this.facebookURL = _data["facebookURL"];
            this.instagramURL = _data["instagramURL"];
            this.postFacebook = _data["postFacebook"];
            this.postInstagram = _data["postInstagram"];
            this.postTwitter = _data["postTwitter"];
            this.postLinkedin = _data["postLinkedin"];
            this.postOthers = _data["postOthers"];
            this.forBrandAwareness = _data["forBrandAwareness"];
            this.forLeadGeneration = _data["forLeadGeneration"];
            this.forEngagement = _data["forEngagement"];
            this.forCustomerSupport = _data["forCustomerSupport"];
            this.forSales = _data["forSales"];
            this.professionalTone = _data["professionalTone"];
            this.casualTone = _data["casualTone"];
            this.informativeTone = _data["informativeTone"];
            this.funTone = _data["funTone"];
            this.inspirationalTone = _data["inspirationalTone"];
            this.targetAudience = _data["targetAudience"];
            this.imageContent = _data["imageContent"];
            this.videoContent = _data["videoContent"];
            this.blogContent = _data["blogContent"];
            this.infographicContent = _data["infographicContent"];
            this.podcastContent = _data["podcastContent"];
            this.webinarContent = _data["webinarContent"];
            this.topicsToCover = _data["topicsToCover"];
            this.topicsToAvoid = _data["topicsToAvoid"];
            this.productsToPromote = _data["productsToPromote"];
            this.keyMessages = _data["keyMessages"];
            this.guideLines = _data["guideLines"];
            this.postWeekday = _data["postWeekday"];
            this.postWeekend = _data["postWeekend"];
            this.postMorning = _data["postMorning"];
            this.postAfternoon = _data["postAfternoon"];
            this.postEvening = _data["postEvening"];
            this.significantDates = _data["significantDates"];
            this.postFrequency = _data["postFrequency"];
            this.numberOfWords = _data["numberOfWords"];
            this.marketingRefence = _data["marketingRefence"];
            this.exampleLink = _data["exampleLink"];
            this.extraInfo = _data["extraInfo"];
            this.totalSmsSent = _data["totalSmsSent"];
            this.purchasedPos = _data["purchasedPos"];
            this.currency = _data["currency"];
            this.sharesIssued = _data["sharesIssued"];
            this.taxIdentificationNumber = _data["taxIdentificationNumber"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCompanyProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["companyRegNo"] = this.companyRegNo;
        data["companyName"] = this.companyName;
        data["contactNo"] = this.contactNo;
        data["email"] = this.email;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["pAddress1"] = this.pAddress1;
        data["pAddress2"] = this.pAddress2;
        data["pPostCode"] = this.pPostCode;
        data["pCity"] = this.pCity;
        data["pState"] = this.pState;
        data["pCountry"] = this.pCountry;
        data["accountFullName"] = this.accountFullName;
        data["accountEmailAddress"] = this.accountEmailAddress;
        data["accountPassword"] = this.accountPassword;
        data["businessCompanyRegNo"] = this.businessCompanyRegNo;
        data["businessAddress"] = this.businessAddress;
        data["bnmCode"] = this.bnmCode;
        data["picName"] = this.picName;
        data["picPosition"] = this.picPosition;
        data["picEmailAddress"] = this.picEmailAddress;
        data["picPhoneNumber"] = this.picPhoneNumber;
        data["companyLogo"] = this.companyLogo;
        data["bankName"] = this.bankName;
        data["bankAccountHolder"] = this.bankAccountHolder;
        data["bankAccountNo"] = this.bankAccountNo;
        data["invoiceTemplate"] = this.invoiceTemplate;
        data["brandingColor"] = this.brandingColor;
        data["invoiceMessage"] = this.invoiceMessage;
        data["remarkMessage"] = this.remarkMessage;
        data["revenue"] = this.revenue;
        data["numberOfEmployees"] = this.numberOfEmployees;
        data["tutorialCompleted"] = this.tutorialCompleted;
        data["dayDueReminder"] = this.dayDueReminder;
        data["invoiceTnC"] = this.invoiceTnC;
        data["invoiceApproval"] = this.invoiceApproval;
        data["requisitionApproval"] = this.requisitionApproval;
        data["customerApproval"] = this.customerApproval;
        data["productApproval"] = this.productApproval;
        data["mainBannerUrl"] = this.mainBannerUrl;
        data["mainBannerTitle"] = this.mainBannerTitle;
        data["mainBannerDescription"] = this.mainBannerDescription;
        data["lastActive"] = this.lastActive ? this.lastActive.toISOString() : <any>undefined;
        data["hideFromMarketplace"] = this.hideFromMarketplace;
        data["websiteLink"] = this.websiteLink;
        data["facebookLink"] = this.facebookLink;
        data["youtubeLink"] = this.youtubeLink;
        data["whatsappLink"] = this.whatsappLink;
        data["secondaryBankName"] = this.secondaryBankName;
        data["secondaryBankAccountHolder"] = this.secondaryBankAccountHolder;
        data["secondaryBankAccountNo"] = this.secondaryBankAccountNo;
        data["secondaryBannerUrl"] = this.secondaryBannerUrl;
        data["secondaryBannerTitle"] = this.secondaryBannerTitle;
        data["secondaryBannerDescription"] = this.secondaryBannerDescription;
        data["isScfOnboarded"] = this.isScfOnboarded;
        data["scfTenancyName"] = this.scfTenancyName;
        data["scfTenantId"] = this.scfTenantId;
        data["scfEmail"] = this.scfEmail;
        data["scfPassword"] = this.scfPassword;
        data["scfApplicationStatus"] = this.scfApplicationStatus;
        data["scfSupplierId"] = this.scfSupplierId;
        data["purchaseOrderMessage"] = this.purchaseOrderMessage;
        data["quotationMessage"] = this.quotationMessage;
        data["requisitionApproverDepartmentId"] = this.requisitionApproverDepartmentId;
        data["poDeliveryDueReminder"] = this.poDeliveryDueReminder;
        data["producerTenantId"] = this.producerTenantId;
        data["typeOfCompany"] = this.typeOfCompany;
        data["overheadAllocation"] = this.overheadAllocation;
        data["financialYearOffset"] = this.financialYearOffset;
        data["financialYearStartDay"] = this.financialYearStartDay;
        data["financialYearStartMonth"] = this.financialYearStartMonth;
        data["coreActivityDescription"] = this.coreActivityDescription;
        data["isHideBankFromInvoice"] = this.isHideBankFromInvoice;
        data["aiOnboardingStatus"] = this.aiOnboardingStatus;
        data["facebookURL"] = this.facebookURL;
        data["instagramURL"] = this.instagramURL;
        data["postFacebook"] = this.postFacebook;
        data["postInstagram"] = this.postInstagram;
        data["postTwitter"] = this.postTwitter;
        data["postLinkedin"] = this.postLinkedin;
        data["postOthers"] = this.postOthers;
        data["forBrandAwareness"] = this.forBrandAwareness;
        data["forLeadGeneration"] = this.forLeadGeneration;
        data["forEngagement"] = this.forEngagement;
        data["forCustomerSupport"] = this.forCustomerSupport;
        data["forSales"] = this.forSales;
        data["professionalTone"] = this.professionalTone;
        data["casualTone"] = this.casualTone;
        data["informativeTone"] = this.informativeTone;
        data["funTone"] = this.funTone;
        data["inspirationalTone"] = this.inspirationalTone;
        data["targetAudience"] = this.targetAudience;
        data["imageContent"] = this.imageContent;
        data["videoContent"] = this.videoContent;
        data["blogContent"] = this.blogContent;
        data["infographicContent"] = this.infographicContent;
        data["podcastContent"] = this.podcastContent;
        data["webinarContent"] = this.webinarContent;
        data["topicsToCover"] = this.topicsToCover;
        data["topicsToAvoid"] = this.topicsToAvoid;
        data["productsToPromote"] = this.productsToPromote;
        data["keyMessages"] = this.keyMessages;
        data["guideLines"] = this.guideLines;
        data["postWeekday"] = this.postWeekday;
        data["postWeekend"] = this.postWeekend;
        data["postMorning"] = this.postMorning;
        data["postAfternoon"] = this.postAfternoon;
        data["postEvening"] = this.postEvening;
        data["significantDates"] = this.significantDates;
        data["postFrequency"] = this.postFrequency;
        data["numberOfWords"] = this.numberOfWords;
        data["marketingRefence"] = this.marketingRefence;
        data["exampleLink"] = this.exampleLink;
        data["extraInfo"] = this.extraInfo;
        data["totalSmsSent"] = this.totalSmsSent;
        data["purchasedPos"] = this.purchasedPos;
        data["currency"] = this.currency;
        data["sharesIssued"] = this.sharesIssued;
        data["taxIdentificationNumber"] = this.taxIdentificationNumber;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateCompanyProfileDto {
        const json = this.toJSON();
        let result = new UpdateCompanyProfileDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCompanyProfileDto {
    tenantId: number;
    companyRegNo: string;
    companyName: string;
    contactNo: string;
    email: string | undefined;
    address1: string | undefined;
    address2: string | undefined;
    postCode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    pAddress1: string | undefined;
    pAddress2: string | undefined;
    pPostCode: string | undefined;
    pCity: string | undefined;
    pState: string | undefined;
    pCountry: string | undefined;
    accountFullName: string | undefined;
    accountEmailAddress: string | undefined;
    accountPassword: string | undefined;
    businessCompanyRegNo: string | undefined;
    businessAddress: string | undefined;
    bnmCode: string | undefined;
    picName: string | undefined;
    picPosition: string | undefined;
    picEmailAddress: string | undefined;
    picPhoneNumber: string | undefined;
    companyLogo: string | undefined;
    bankName: string | undefined;
    bankAccountHolder: string | undefined;
    bankAccountNo: string | undefined;
    invoiceTemplate: number | undefined;
    brandingColor: string | undefined;
    invoiceMessage: string | undefined;
    remarkMessage: string | undefined;
    revenue: string | undefined;
    numberOfEmployees: number;
    tutorialCompleted: boolean;
    dayDueReminder: number;
    invoiceTnC: string | undefined;
    invoiceApproval: boolean;
    requisitionApproval: boolean;
    customerApproval: boolean;
    productApproval: boolean;
    mainBannerUrl: string | undefined;
    mainBannerTitle: string | undefined;
    mainBannerDescription: string | undefined;
    lastActive: moment.Moment;
    hideFromMarketplace: boolean;
    websiteLink: string | undefined;
    facebookLink: string | undefined;
    youtubeLink: string | undefined;
    whatsappLink: string | undefined;
    secondaryBankName: string | undefined;
    secondaryBankAccountHolder: string | undefined;
    secondaryBankAccountNo: string | undefined;
    secondaryBannerUrl: string | undefined;
    secondaryBannerTitle: string | undefined;
    secondaryBannerDescription: string | undefined;
    isScfOnboarded: boolean;
    scfTenancyName: string | undefined;
    scfTenantId: number;
    scfEmail: string | undefined;
    scfPassword: string | undefined;
    scfApplicationStatus: number;
    scfSupplierId: number;
    purchaseOrderMessage: string | undefined;
    quotationMessage: string | undefined;
    requisitionApproverDepartmentId: number | undefined;
    poDeliveryDueReminder: number;
    producerTenantId: number;
    typeOfCompany: string | undefined;
    overheadAllocation: number;
    financialYearOffset: number;
    financialYearStartDay: number;
    financialYearStartMonth: number;
    coreActivityDescription: string | undefined;
    isHideBankFromInvoice: boolean;
    aiOnboardingStatus: string | undefined;
    facebookURL: string | undefined;
    instagramURL: string | undefined;
    postFacebook: boolean;
    postInstagram: boolean;
    postTwitter: boolean;
    postLinkedin: boolean;
    postOthers: string | undefined;
    forBrandAwareness: boolean;
    forLeadGeneration: boolean;
    forEngagement: boolean;
    forCustomerSupport: boolean;
    forSales: boolean;
    professionalTone: boolean;
    casualTone: boolean;
    informativeTone: boolean;
    funTone: boolean;
    inspirationalTone: boolean;
    targetAudience: string | undefined;
    imageContent: boolean;
    videoContent: boolean;
    blogContent: boolean;
    infographicContent: boolean;
    podcastContent: boolean;
    webinarContent: boolean;
    topicsToCover: string | undefined;
    topicsToAvoid: string | undefined;
    productsToPromote: string | undefined;
    keyMessages: string | undefined;
    guideLines: string | undefined;
    postWeekday: boolean;
    postWeekend: boolean;
    postMorning: boolean;
    postAfternoon: boolean;
    postEvening: boolean;
    significantDates: string | undefined;
    postFrequency: string | undefined;
    numberOfWords: string | undefined;
    marketingRefence: string | undefined;
    exampleLink: string | undefined;
    extraInfo: string | undefined;
    totalSmsSent: number;
    purchasedPos: boolean;
    currency: string | undefined;
    sharesIssued: number;
    taxIdentificationNumber: string | undefined;
    id: string;
}

export class UpdateCustomerDto implements IUpdateCustomerDto {
    name: string;
    companyRegNo: string | undefined;
    contactNo: string;
    email: string | undefined;
    billingAddress1: string;
    billingAddress2: string | undefined;
    postCode: string;
    city: string;
    state: string;
    country: string;
    tenantId: number | undefined;
    customertypeId: number;
    firstName: string | undefined;
    lastName: string | undefined;
    middleTitle: string | undefined;
    userId: number;
    creditRating: string | undefined;
    paymentTerm: number;
    creditDocumentUrl: string | undefined;
    code: string | undefined;
    sstRegistrationNo: string | undefined;
    taxIdentificationNumber: string | undefined;
    currency: string | undefined;
    id: string;

    constructor(data?: IUpdateCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.companyRegNo = _data["companyRegNo"];
            this.contactNo = _data["contactNo"];
            this.email = _data["email"];
            this.billingAddress1 = _data["billingAddress1"];
            this.billingAddress2 = _data["billingAddress2"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.tenantId = _data["tenantId"];
            this.customertypeId = _data["customertypeId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleTitle = _data["middleTitle"];
            this.userId = _data["userId"];
            this.creditRating = _data["creditRating"];
            this.paymentTerm = _data["paymentTerm"];
            this.creditDocumentUrl = _data["creditDocumentUrl"];
            this.code = _data["code"];
            this.sstRegistrationNo = _data["sstRegistrationNo"];
            this.taxIdentificationNumber = _data["taxIdentificationNumber"];
            this.currency = _data["currency"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["companyRegNo"] = this.companyRegNo;
        data["contactNo"] = this.contactNo;
        data["email"] = this.email;
        data["billingAddress1"] = this.billingAddress1;
        data["billingAddress2"] = this.billingAddress2;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["tenantId"] = this.tenantId;
        data["customertypeId"] = this.customertypeId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleTitle"] = this.middleTitle;
        data["userId"] = this.userId;
        data["creditRating"] = this.creditRating;
        data["paymentTerm"] = this.paymentTerm;
        data["creditDocumentUrl"] = this.creditDocumentUrl;
        data["code"] = this.code;
        data["sstRegistrationNo"] = this.sstRegistrationNo;
        data["taxIdentificationNumber"] = this.taxIdentificationNumber;
        data["currency"] = this.currency;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateCustomerDto {
        const json = this.toJSON();
        let result = new UpdateCustomerDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCustomerDto {
    name: string;
    companyRegNo: string | undefined;
    contactNo: string;
    email: string | undefined;
    billingAddress1: string;
    billingAddress2: string | undefined;
    postCode: string;
    city: string;
    state: string;
    country: string;
    tenantId: number | undefined;
    customertypeId: number;
    firstName: string | undefined;
    lastName: string | undefined;
    middleTitle: string | undefined;
    userId: number;
    creditRating: string | undefined;
    paymentTerm: number;
    creditDocumentUrl: string | undefined;
    code: string | undefined;
    sstRegistrationNo: string | undefined;
    taxIdentificationNumber: string | undefined;
    currency: string | undefined;
    id: string;
}

export class UpdateFSDto implements IUpdateFSDto {
    tenantId: number;
    fs1Url: string | undefined;
    fs2Url: string | undefined;
    fs3Url: string | undefined;
    fs4Url: string | undefined;

    constructor(data?: IUpdateFSDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.fs1Url = _data["fs1Url"];
            this.fs2Url = _data["fs2Url"];
            this.fs3Url = _data["fs3Url"];
            this.fs4Url = _data["fs4Url"];
        }
    }

    static fromJS(data: any): UpdateFSDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFSDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["fs1Url"] = this.fs1Url;
        data["fs2Url"] = this.fs2Url;
        data["fs3Url"] = this.fs3Url;
        data["fs4Url"] = this.fs4Url;
        return data;
    }

    clone(): UpdateFSDto {
        const json = this.toJSON();
        let result = new UpdateFSDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateFSDto {
    tenantId: number;
    fs1Url: string | undefined;
    fs2Url: string | undefined;
    fs3Url: string | undefined;
    fs4Url: string | undefined;
}

export class UpdateMaterialDto implements IUpdateMaterialDto {
    code: string;
    name: string;
    description: string | undefined;
    price: number;
    tenantId: number | undefined;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    hideFromMarketplace: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    companyProfileId: string | undefined;
    isUserFeatured: boolean;
    showQuantity: boolean;
    minLevel: number;
    isNotifiedMinLevel: boolean;
    tagNumber: string | undefined;
    barCode: string | undefined;
    inventoryCategoryId: number | undefined;
    averagePriceFromPo: number;
    lastPriceFromPo: number;
    movingAverageValue: number;
    projectId: number;
    dateOfMigration: moment.Moment | undefined;
    id: string;

    constructor(data?: IUpdateMaterialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.tenantId = _data["tenantId"];
            this.oldPrice = _data["oldPrice"];
            this.discount = _data["discount"];
            this.ratingsCount = _data["ratingsCount"];
            this.ratingsValue = _data["ratingsValue"];
            this.availibilityCount = _data["availibilityCount"];
            this.cartCount = _data["cartCount"];
            this.weight = _data["weight"];
            this.categoryId = _data["categoryId"];
            this.fullDescription = _data["fullDescription"];
            this.serviceTax = _data["serviceTax"];
            this.taxCode = _data["taxCode"];
            this.isSubsidized = _data["isSubsidized"];
            this.isCertified = _data["isCertified"];
            this.isIslamic = _data["isIslamic"];
            this.isLoanAvailable = _data["isLoanAvailable"];
            this.hideFromMarketplace = _data["hideFromMarketplace"];
            this.isFeatured = _data["isFeatured"];
            this.isTypeSerice = _data["isTypeSerice"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.companyProfileId = _data["companyProfileId"];
            this.isUserFeatured = _data["isUserFeatured"];
            this.showQuantity = _data["showQuantity"];
            this.minLevel = _data["minLevel"];
            this.isNotifiedMinLevel = _data["isNotifiedMinLevel"];
            this.tagNumber = _data["tagNumber"];
            this.barCode = _data["barCode"];
            this.inventoryCategoryId = _data["inventoryCategoryId"];
            this.averagePriceFromPo = _data["averagePriceFromPo"];
            this.lastPriceFromPo = _data["lastPriceFromPo"];
            this.movingAverageValue = _data["movingAverageValue"];
            this.projectId = _data["projectId"];
            this.dateOfMigration = _data["dateOfMigration"] ? moment(_data["dateOfMigration"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateMaterialDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMaterialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        data["tenantId"] = this.tenantId;
        data["oldPrice"] = this.oldPrice;
        data["discount"] = this.discount;
        data["ratingsCount"] = this.ratingsCount;
        data["ratingsValue"] = this.ratingsValue;
        data["availibilityCount"] = this.availibilityCount;
        data["cartCount"] = this.cartCount;
        data["weight"] = this.weight;
        data["categoryId"] = this.categoryId;
        data["fullDescription"] = this.fullDescription;
        data["serviceTax"] = this.serviceTax;
        data["taxCode"] = this.taxCode;
        data["isSubsidized"] = this.isSubsidized;
        data["isCertified"] = this.isCertified;
        data["isIslamic"] = this.isIslamic;
        data["isLoanAvailable"] = this.isLoanAvailable;
        data["hideFromMarketplace"] = this.hideFromMarketplace;
        data["isFeatured"] = this.isFeatured;
        data["isTypeSerice"] = this.isTypeSerice;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["companyProfileId"] = this.companyProfileId;
        data["isUserFeatured"] = this.isUserFeatured;
        data["showQuantity"] = this.showQuantity;
        data["minLevel"] = this.minLevel;
        data["isNotifiedMinLevel"] = this.isNotifiedMinLevel;
        data["tagNumber"] = this.tagNumber;
        data["barCode"] = this.barCode;
        data["inventoryCategoryId"] = this.inventoryCategoryId;
        data["averagePriceFromPo"] = this.averagePriceFromPo;
        data["lastPriceFromPo"] = this.lastPriceFromPo;
        data["movingAverageValue"] = this.movingAverageValue;
        data["projectId"] = this.projectId;
        data["dateOfMigration"] = this.dateOfMigration ? this.dateOfMigration.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateMaterialDto {
        const json = this.toJSON();
        let result = new UpdateMaterialDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateMaterialDto {
    code: string;
    name: string;
    description: string | undefined;
    price: number;
    tenantId: number | undefined;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    hideFromMarketplace: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    companyProfileId: string | undefined;
    isUserFeatured: boolean;
    showQuantity: boolean;
    minLevel: number;
    isNotifiedMinLevel: boolean;
    tagNumber: string | undefined;
    barCode: string | undefined;
    inventoryCategoryId: number | undefined;
    averagePriceFromPo: number;
    lastPriceFromPo: number;
    movingAverageValue: number;
    projectId: number;
    dateOfMigration: moment.Moment | undefined;
    id: string;
}

export class UpdateNonCurrentAssetClassDto implements IUpdateNonCurrentAssetClassDto {
    tenantId: number;
    name: string;
    accountsCategoryCode: string | undefined;
    accountsCategoryName: string | undefined;
    totalItems: number;
    totalCosts: number;
    totalAccumulatedDepreciation: number;
    totalAccumulatedImpairment: number;
    totalNetBookValue: number;
    id: string;

    constructor(data?: IUpdateNonCurrentAssetClassDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.accountsCategoryCode = _data["accountsCategoryCode"];
            this.accountsCategoryName = _data["accountsCategoryName"];
            this.totalItems = _data["totalItems"];
            this.totalCosts = _data["totalCosts"];
            this.totalAccumulatedDepreciation = _data["totalAccumulatedDepreciation"];
            this.totalAccumulatedImpairment = _data["totalAccumulatedImpairment"];
            this.totalNetBookValue = _data["totalNetBookValue"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateNonCurrentAssetClassDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNonCurrentAssetClassDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["accountsCategoryCode"] = this.accountsCategoryCode;
        data["accountsCategoryName"] = this.accountsCategoryName;
        data["totalItems"] = this.totalItems;
        data["totalCosts"] = this.totalCosts;
        data["totalAccumulatedDepreciation"] = this.totalAccumulatedDepreciation;
        data["totalAccumulatedImpairment"] = this.totalAccumulatedImpairment;
        data["totalNetBookValue"] = this.totalNetBookValue;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateNonCurrentAssetClassDto {
        const json = this.toJSON();
        let result = new UpdateNonCurrentAssetClassDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateNonCurrentAssetClassDto {
    tenantId: number;
    name: string;
    accountsCategoryCode: string | undefined;
    accountsCategoryName: string | undefined;
    totalItems: number;
    totalCosts: number;
    totalAccumulatedDepreciation: number;
    totalAccumulatedImpairment: number;
    totalNetBookValue: number;
    id: string;
}

export class UpdateNonCurrentAssetDto implements IUpdateNonCurrentAssetDto {
    code: string;
    name: string;
    description: string | undefined;
    price: number;
    tenantId: number | undefined;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    hideFromMarketplace: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    companyProfileId: string | undefined;
    isUserFeatured: boolean;
    showQuantity: boolean;
    depreciationRate: number;
    accountsCategoryCode: string | undefined;
    accountsCategoryName: string | undefined;
    nonCurrentAssetClassId: string | undefined;
    id: string;

    constructor(data?: IUpdateNonCurrentAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.tenantId = _data["tenantId"];
            this.oldPrice = _data["oldPrice"];
            this.discount = _data["discount"];
            this.ratingsCount = _data["ratingsCount"];
            this.ratingsValue = _data["ratingsValue"];
            this.availibilityCount = _data["availibilityCount"];
            this.cartCount = _data["cartCount"];
            this.weight = _data["weight"];
            this.categoryId = _data["categoryId"];
            this.fullDescription = _data["fullDescription"];
            this.serviceTax = _data["serviceTax"];
            this.taxCode = _data["taxCode"];
            this.isSubsidized = _data["isSubsidized"];
            this.isCertified = _data["isCertified"];
            this.isIslamic = _data["isIslamic"];
            this.isLoanAvailable = _data["isLoanAvailable"];
            this.hideFromMarketplace = _data["hideFromMarketplace"];
            this.isFeatured = _data["isFeatured"];
            this.isTypeSerice = _data["isTypeSerice"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.companyProfileId = _data["companyProfileId"];
            this.isUserFeatured = _data["isUserFeatured"];
            this.showQuantity = _data["showQuantity"];
            this.depreciationRate = _data["depreciationRate"];
            this.accountsCategoryCode = _data["accountsCategoryCode"];
            this.accountsCategoryName = _data["accountsCategoryName"];
            this.nonCurrentAssetClassId = _data["nonCurrentAssetClassId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateNonCurrentAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNonCurrentAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        data["tenantId"] = this.tenantId;
        data["oldPrice"] = this.oldPrice;
        data["discount"] = this.discount;
        data["ratingsCount"] = this.ratingsCount;
        data["ratingsValue"] = this.ratingsValue;
        data["availibilityCount"] = this.availibilityCount;
        data["cartCount"] = this.cartCount;
        data["weight"] = this.weight;
        data["categoryId"] = this.categoryId;
        data["fullDescription"] = this.fullDescription;
        data["serviceTax"] = this.serviceTax;
        data["taxCode"] = this.taxCode;
        data["isSubsidized"] = this.isSubsidized;
        data["isCertified"] = this.isCertified;
        data["isIslamic"] = this.isIslamic;
        data["isLoanAvailable"] = this.isLoanAvailable;
        data["hideFromMarketplace"] = this.hideFromMarketplace;
        data["isFeatured"] = this.isFeatured;
        data["isTypeSerice"] = this.isTypeSerice;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["companyProfileId"] = this.companyProfileId;
        data["isUserFeatured"] = this.isUserFeatured;
        data["showQuantity"] = this.showQuantity;
        data["depreciationRate"] = this.depreciationRate;
        data["accountsCategoryCode"] = this.accountsCategoryCode;
        data["accountsCategoryName"] = this.accountsCategoryName;
        data["nonCurrentAssetClassId"] = this.nonCurrentAssetClassId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateNonCurrentAssetDto {
        const json = this.toJSON();
        let result = new UpdateNonCurrentAssetDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateNonCurrentAssetDto {
    code: string;
    name: string;
    description: string | undefined;
    price: number;
    tenantId: number | undefined;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    hideFromMarketplace: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    companyProfileId: string | undefined;
    isUserFeatured: boolean;
    showQuantity: boolean;
    depreciationRate: number;
    accountsCategoryCode: string | undefined;
    accountsCategoryName: string | undefined;
    nonCurrentAssetClassId: string | undefined;
    id: string;
}

export class UpdateNonCurrentAssetItemDto implements IUpdateNonCurrentAssetItemDto {
    unitPrice: number;
    installationCost: number;
    thirdPartyInstallationCost: number;
    readonly totalInstallationCost: number;
    deliveryCost: number;
    totalOriginalCost: number;
    discount: number;
    tax: number;
    nonCurrentAssetId: string;
    taxCode: string | undefined;
    creditNote: number;
    serialNumber: string | undefined;
    barCode: string | undefined;
    depreciationRate: number;
    depreciationStartDate: moment.Moment;
    accumulatedImpairment: number;
    isWriteOff: boolean;
    isDisposal: boolean;
    writeOffAndDisposalDate: moment.Moment;
    sellValue: number;
    internalTag: string | undefined;
    residualValue: number;
    location: string | undefined;
    migratedAccumulatedDepreciation: number;
    migratedAccumulatedImpairment: number;
    migratedAccumulatedIncome: number;
    migratedDate: moment.Moment;
    migratedRequesterId: number;
    migratedRequesterName: string | undefined;
    migratedRequesterRemarks: string | undefined;
    migratedApproverId: number;
    migratedApproverName: string | undefined;
    migratedApproverRemarks: string | undefined;
    migratedApprovalStatus: number;
    migratedApprovalDate: moment.Moment;
    supplierInvoiceUrl: string | undefined;
    purchasedDate: moment.Moment;
    depreciationMode: number;
    vendorInvoiceId: number | undefined;
    writeOffNoteId: number | undefined;
    cashbookId: number | undefined;
    postMigration: boolean;
    dateAcquired: moment.Moment | undefined;
    description: string | undefined;
    typeOfInvestment: string | undefined;
    certificate: string | undefined;
    rateOfReturn: number | undefined;
    incomeReceived: number | undefined;
    accruedIncomeReceived: number | undefined;
    readonly totalIncomeReceived: number;
    dateOfIncomeReceived: moment.Moment | undefined;
    companyName: string | undefined;
    companyRegNo: string | undefined;
    companyType: string | undefined;
    numberOfSharePurchased: number | undefined;
    percentageOfHolding: number | undefined;
    shareCertificateNo: string | undefined;
    dividendsReceived: number | undefined;
    dateOfDividentReceived: moment.Moment | undefined;
    maturityDate: moment.Moment | undefined;
    readonly tenure: number | undefined;
    investee: string | undefined;
    id: string;

    constructor(data?: IUpdateNonCurrentAssetItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitPrice = _data["unitPrice"];
            this.installationCost = _data["installationCost"];
            this.thirdPartyInstallationCost = _data["thirdPartyInstallationCost"];
            (<any>this).totalInstallationCost = _data["totalInstallationCost"];
            this.deliveryCost = _data["deliveryCost"];
            this.totalOriginalCost = _data["totalOriginalCost"];
            this.discount = _data["discount"];
            this.tax = _data["tax"];
            this.nonCurrentAssetId = _data["nonCurrentAssetId"];
            this.taxCode = _data["taxCode"];
            this.creditNote = _data["creditNote"];
            this.serialNumber = _data["serialNumber"];
            this.barCode = _data["barCode"];
            this.depreciationRate = _data["depreciationRate"];
            this.depreciationStartDate = _data["depreciationStartDate"] ? moment(_data["depreciationStartDate"].toString()) : <any>undefined;
            this.accumulatedImpairment = _data["accumulatedImpairment"];
            this.isWriteOff = _data["isWriteOff"];
            this.isDisposal = _data["isDisposal"];
            this.writeOffAndDisposalDate = _data["writeOffAndDisposalDate"] ? moment(_data["writeOffAndDisposalDate"].toString()) : <any>undefined;
            this.sellValue = _data["sellValue"];
            this.internalTag = _data["internalTag"];
            this.residualValue = _data["residualValue"];
            this.location = _data["location"];
            this.migratedAccumulatedDepreciation = _data["migratedAccumulatedDepreciation"];
            this.migratedAccumulatedImpairment = _data["migratedAccumulatedImpairment"];
            this.migratedAccumulatedIncome = _data["migratedAccumulatedIncome"];
            this.migratedDate = _data["migratedDate"] ? moment(_data["migratedDate"].toString()) : <any>undefined;
            this.migratedRequesterId = _data["migratedRequesterId"];
            this.migratedRequesterName = _data["migratedRequesterName"];
            this.migratedRequesterRemarks = _data["migratedRequesterRemarks"];
            this.migratedApproverId = _data["migratedApproverId"];
            this.migratedApproverName = _data["migratedApproverName"];
            this.migratedApproverRemarks = _data["migratedApproverRemarks"];
            this.migratedApprovalStatus = _data["migratedApprovalStatus"];
            this.migratedApprovalDate = _data["migratedApprovalDate"] ? moment(_data["migratedApprovalDate"].toString()) : <any>undefined;
            this.supplierInvoiceUrl = _data["supplierInvoiceUrl"];
            this.purchasedDate = _data["purchasedDate"] ? moment(_data["purchasedDate"].toString()) : <any>undefined;
            this.depreciationMode = _data["depreciationMode"];
            this.vendorInvoiceId = _data["vendorInvoiceId"];
            this.writeOffNoteId = _data["writeOffNoteId"];
            this.cashbookId = _data["cashbookId"];
            this.postMigration = _data["postMigration"];
            this.dateAcquired = _data["dateAcquired"] ? moment(_data["dateAcquired"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.typeOfInvestment = _data["typeOfInvestment"];
            this.certificate = _data["certificate"];
            this.rateOfReturn = _data["rateOfReturn"];
            this.incomeReceived = _data["incomeReceived"];
            this.accruedIncomeReceived = _data["accruedIncomeReceived"];
            (<any>this).totalIncomeReceived = _data["totalIncomeReceived"];
            this.dateOfIncomeReceived = _data["dateOfIncomeReceived"] ? moment(_data["dateOfIncomeReceived"].toString()) : <any>undefined;
            this.companyName = _data["companyName"];
            this.companyRegNo = _data["companyRegNo"];
            this.companyType = _data["companyType"];
            this.numberOfSharePurchased = _data["numberOfSharePurchased"];
            this.percentageOfHolding = _data["percentageOfHolding"];
            this.shareCertificateNo = _data["shareCertificateNo"];
            this.dividendsReceived = _data["dividendsReceived"];
            this.dateOfDividentReceived = _data["dateOfDividentReceived"] ? moment(_data["dateOfDividentReceived"].toString()) : <any>undefined;
            this.maturityDate = _data["maturityDate"] ? moment(_data["maturityDate"].toString()) : <any>undefined;
            (<any>this).tenure = _data["tenure"];
            this.investee = _data["investee"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateNonCurrentAssetItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNonCurrentAssetItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitPrice"] = this.unitPrice;
        data["installationCost"] = this.installationCost;
        data["thirdPartyInstallationCost"] = this.thirdPartyInstallationCost;
        data["totalInstallationCost"] = this.totalInstallationCost;
        data["deliveryCost"] = this.deliveryCost;
        data["totalOriginalCost"] = this.totalOriginalCost;
        data["discount"] = this.discount;
        data["tax"] = this.tax;
        data["nonCurrentAssetId"] = this.nonCurrentAssetId;
        data["taxCode"] = this.taxCode;
        data["creditNote"] = this.creditNote;
        data["serialNumber"] = this.serialNumber;
        data["barCode"] = this.barCode;
        data["depreciationRate"] = this.depreciationRate;
        data["depreciationStartDate"] = this.depreciationStartDate ? this.depreciationStartDate.toISOString() : <any>undefined;
        data["accumulatedImpairment"] = this.accumulatedImpairment;
        data["isWriteOff"] = this.isWriteOff;
        data["isDisposal"] = this.isDisposal;
        data["writeOffAndDisposalDate"] = this.writeOffAndDisposalDate ? this.writeOffAndDisposalDate.toISOString() : <any>undefined;
        data["sellValue"] = this.sellValue;
        data["internalTag"] = this.internalTag;
        data["residualValue"] = this.residualValue;
        data["location"] = this.location;
        data["migratedAccumulatedDepreciation"] = this.migratedAccumulatedDepreciation;
        data["migratedAccumulatedImpairment"] = this.migratedAccumulatedImpairment;
        data["migratedAccumulatedIncome"] = this.migratedAccumulatedIncome;
        data["migratedDate"] = this.migratedDate ? this.migratedDate.toISOString() : <any>undefined;
        data["migratedRequesterId"] = this.migratedRequesterId;
        data["migratedRequesterName"] = this.migratedRequesterName;
        data["migratedRequesterRemarks"] = this.migratedRequesterRemarks;
        data["migratedApproverId"] = this.migratedApproverId;
        data["migratedApproverName"] = this.migratedApproverName;
        data["migratedApproverRemarks"] = this.migratedApproverRemarks;
        data["migratedApprovalStatus"] = this.migratedApprovalStatus;
        data["migratedApprovalDate"] = this.migratedApprovalDate ? this.migratedApprovalDate.toISOString() : <any>undefined;
        data["supplierInvoiceUrl"] = this.supplierInvoiceUrl;
        data["purchasedDate"] = this.purchasedDate ? this.purchasedDate.toISOString() : <any>undefined;
        data["depreciationMode"] = this.depreciationMode;
        data["vendorInvoiceId"] = this.vendorInvoiceId;
        data["writeOffNoteId"] = this.writeOffNoteId;
        data["cashbookId"] = this.cashbookId;
        data["postMigration"] = this.postMigration;
        data["dateAcquired"] = this.dateAcquired ? this.dateAcquired.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["typeOfInvestment"] = this.typeOfInvestment;
        data["certificate"] = this.certificate;
        data["rateOfReturn"] = this.rateOfReturn;
        data["incomeReceived"] = this.incomeReceived;
        data["accruedIncomeReceived"] = this.accruedIncomeReceived;
        data["totalIncomeReceived"] = this.totalIncomeReceived;
        data["dateOfIncomeReceived"] = this.dateOfIncomeReceived ? this.dateOfIncomeReceived.toISOString() : <any>undefined;
        data["companyName"] = this.companyName;
        data["companyRegNo"] = this.companyRegNo;
        data["companyType"] = this.companyType;
        data["numberOfSharePurchased"] = this.numberOfSharePurchased;
        data["percentageOfHolding"] = this.percentageOfHolding;
        data["shareCertificateNo"] = this.shareCertificateNo;
        data["dividendsReceived"] = this.dividendsReceived;
        data["dateOfDividentReceived"] = this.dateOfDividentReceived ? this.dateOfDividentReceived.toISOString() : <any>undefined;
        data["maturityDate"] = this.maturityDate ? this.maturityDate.toISOString() : <any>undefined;
        data["tenure"] = this.tenure;
        data["investee"] = this.investee;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateNonCurrentAssetItemDto {
        const json = this.toJSON();
        let result = new UpdateNonCurrentAssetItemDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateNonCurrentAssetItemDto {
    unitPrice: number;
    installationCost: number;
    thirdPartyInstallationCost: number;
    totalInstallationCost: number;
    deliveryCost: number;
    totalOriginalCost: number;
    discount: number;
    tax: number;
    nonCurrentAssetId: string;
    taxCode: string | undefined;
    creditNote: number;
    serialNumber: string | undefined;
    barCode: string | undefined;
    depreciationRate: number;
    depreciationStartDate: moment.Moment;
    accumulatedImpairment: number;
    isWriteOff: boolean;
    isDisposal: boolean;
    writeOffAndDisposalDate: moment.Moment;
    sellValue: number;
    internalTag: string | undefined;
    residualValue: number;
    location: string | undefined;
    migratedAccumulatedDepreciation: number;
    migratedAccumulatedImpairment: number;
    migratedAccumulatedIncome: number;
    migratedDate: moment.Moment;
    migratedRequesterId: number;
    migratedRequesterName: string | undefined;
    migratedRequesterRemarks: string | undefined;
    migratedApproverId: number;
    migratedApproverName: string | undefined;
    migratedApproverRemarks: string | undefined;
    migratedApprovalStatus: number;
    migratedApprovalDate: moment.Moment;
    supplierInvoiceUrl: string | undefined;
    purchasedDate: moment.Moment;
    depreciationMode: number;
    vendorInvoiceId: number | undefined;
    writeOffNoteId: number | undefined;
    cashbookId: number | undefined;
    postMigration: boolean;
    dateAcquired: moment.Moment | undefined;
    description: string | undefined;
    typeOfInvestment: string | undefined;
    certificate: string | undefined;
    rateOfReturn: number | undefined;
    incomeReceived: number | undefined;
    accruedIncomeReceived: number | undefined;
    totalIncomeReceived: number;
    dateOfIncomeReceived: moment.Moment | undefined;
    companyName: string | undefined;
    companyRegNo: string | undefined;
    companyType: string | undefined;
    numberOfSharePurchased: number | undefined;
    percentageOfHolding: number | undefined;
    shareCertificateNo: string | undefined;
    dividendsReceived: number | undefined;
    dateOfDividentReceived: moment.Moment | undefined;
    maturityDate: moment.Moment | undefined;
    tenure: number | undefined;
    investee: string | undefined;
    id: string;
}

export class UpdateNonCurrentAssetItemImpairmentDto implements IUpdateNonCurrentAssetItemImpairmentDto {
    nonCurrentAssetItemId: string;
    impairmentValue: number;
    id: string;

    constructor(data?: IUpdateNonCurrentAssetItemImpairmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nonCurrentAssetItemId = _data["nonCurrentAssetItemId"];
            this.impairmentValue = _data["impairmentValue"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateNonCurrentAssetItemImpairmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNonCurrentAssetItemImpairmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nonCurrentAssetItemId"] = this.nonCurrentAssetItemId;
        data["impairmentValue"] = this.impairmentValue;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateNonCurrentAssetItemImpairmentDto {
        const json = this.toJSON();
        let result = new UpdateNonCurrentAssetItemImpairmentDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateNonCurrentAssetItemImpairmentDto {
    nonCurrentAssetItemId: string;
    impairmentValue: number;
    id: string;
}

export class UpdateNonCurrentAssetMaintenanceDto implements IUpdateNonCurrentAssetMaintenanceDto {
    tenantId: number;
    nonCurrentAssetItemId: string;
    dateOfRepair: moment.Moment;
    natureOfRepair: string | undefined;
    amount: number;
    scheduledDate: moment.Moment;
    operationHours: number;
    id: string;

    constructor(data?: IUpdateNonCurrentAssetMaintenanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.nonCurrentAssetItemId = _data["nonCurrentAssetItemId"];
            this.dateOfRepair = _data["dateOfRepair"] ? moment(_data["dateOfRepair"].toString()) : <any>undefined;
            this.natureOfRepair = _data["natureOfRepair"];
            this.amount = _data["amount"];
            this.scheduledDate = _data["scheduledDate"] ? moment(_data["scheduledDate"].toString()) : <any>undefined;
            this.operationHours = _data["operationHours"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateNonCurrentAssetMaintenanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNonCurrentAssetMaintenanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["nonCurrentAssetItemId"] = this.nonCurrentAssetItemId;
        data["dateOfRepair"] = this.dateOfRepair ? this.dateOfRepair.toISOString() : <any>undefined;
        data["natureOfRepair"] = this.natureOfRepair;
        data["amount"] = this.amount;
        data["scheduledDate"] = this.scheduledDate ? this.scheduledDate.toISOString() : <any>undefined;
        data["operationHours"] = this.operationHours;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateNonCurrentAssetMaintenanceDto {
        const json = this.toJSON();
        let result = new UpdateNonCurrentAssetMaintenanceDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateNonCurrentAssetMaintenanceDto {
    tenantId: number;
    nonCurrentAssetItemId: string;
    dateOfRepair: moment.Moment;
    natureOfRepair: string | undefined;
    amount: number;
    scheduledDate: moment.Moment;
    operationHours: number;
    id: string;
}

export class UpdateProductDto implements IUpdateProductDto {
    code: string;
    name: string;
    description: string | undefined;
    price: number;
    tenantId: number | undefined;
    images: ProductImages[] | undefined;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    color: ProductColors[] | undefined;
    size: ProductSizes[] | undefined;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    hideFromMarketplace: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    companyProfileId: string | undefined;
    isUserFeatured: boolean;
    showQuantity: boolean;
    minLevel: number;
    isNotifiedMinLevel: boolean;
    tagNumber: string | undefined;
    barCode: string | undefined;
    inventoryCategoryId: number | undefined;
    producerTenantId: number;
    averagePriceFromPo: number;
    averageProductionCost: number;
    lastSellingPrice: number;
    lastPriceFromPo: number;
    lastProductionCost: number;
    movingAverageValue: number;
    isHidden: boolean;
    projectId: number | undefined;
    dateOfMigration: moment.Moment | undefined;
    firebaseDocID: string | undefined;
    firebaseCategory: string | undefined;
    id: string;

    constructor(data?: IUpdateProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images.push(ProductImages.fromJS(item));
            }
            this.oldPrice = _data["oldPrice"];
            this.discount = _data["discount"];
            this.ratingsCount = _data["ratingsCount"];
            this.ratingsValue = _data["ratingsValue"];
            this.availibilityCount = _data["availibilityCount"];
            this.cartCount = _data["cartCount"];
            if (Array.isArray(_data["color"])) {
                this.color = [] as any;
                for (let item of _data["color"])
                    this.color.push(ProductColors.fromJS(item));
            }
            if (Array.isArray(_data["size"])) {
                this.size = [] as any;
                for (let item of _data["size"])
                    this.size.push(ProductSizes.fromJS(item));
            }
            this.weight = _data["weight"];
            this.categoryId = _data["categoryId"];
            this.fullDescription = _data["fullDescription"];
            this.serviceTax = _data["serviceTax"];
            this.taxCode = _data["taxCode"];
            this.isSubsidized = _data["isSubsidized"];
            this.isCertified = _data["isCertified"];
            this.isIslamic = _data["isIslamic"];
            this.isLoanAvailable = _data["isLoanAvailable"];
            this.hideFromMarketplace = _data["hideFromMarketplace"];
            this.isFeatured = _data["isFeatured"];
            this.isTypeSerice = _data["isTypeSerice"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.companyProfileId = _data["companyProfileId"];
            this.isUserFeatured = _data["isUserFeatured"];
            this.showQuantity = _data["showQuantity"];
            this.minLevel = _data["minLevel"];
            this.isNotifiedMinLevel = _data["isNotifiedMinLevel"];
            this.tagNumber = _data["tagNumber"];
            this.barCode = _data["barCode"];
            this.inventoryCategoryId = _data["inventoryCategoryId"];
            this.producerTenantId = _data["producerTenantId"];
            this.averagePriceFromPo = _data["averagePriceFromPo"];
            this.averageProductionCost = _data["averageProductionCost"];
            this.lastSellingPrice = _data["lastSellingPrice"];
            this.lastPriceFromPo = _data["lastPriceFromPo"];
            this.lastProductionCost = _data["lastProductionCost"];
            this.movingAverageValue = _data["movingAverageValue"];
            this.isHidden = _data["isHidden"];
            this.projectId = _data["projectId"];
            this.dateOfMigration = _data["dateOfMigration"] ? moment(_data["dateOfMigration"].toString()) : <any>undefined;
            this.firebaseDocID = _data["firebaseDocID"];
            this.firebaseCategory = _data["firebaseCategory"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["description"] = this.description;
        data["price"] = this.price;
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["oldPrice"] = this.oldPrice;
        data["discount"] = this.discount;
        data["ratingsCount"] = this.ratingsCount;
        data["ratingsValue"] = this.ratingsValue;
        data["availibilityCount"] = this.availibilityCount;
        data["cartCount"] = this.cartCount;
        if (Array.isArray(this.color)) {
            data["color"] = [];
            for (let item of this.color)
                data["color"].push(item.toJSON());
        }
        if (Array.isArray(this.size)) {
            data["size"] = [];
            for (let item of this.size)
                data["size"].push(item.toJSON());
        }
        data["weight"] = this.weight;
        data["categoryId"] = this.categoryId;
        data["fullDescription"] = this.fullDescription;
        data["serviceTax"] = this.serviceTax;
        data["taxCode"] = this.taxCode;
        data["isSubsidized"] = this.isSubsidized;
        data["isCertified"] = this.isCertified;
        data["isIslamic"] = this.isIslamic;
        data["isLoanAvailable"] = this.isLoanAvailable;
        data["hideFromMarketplace"] = this.hideFromMarketplace;
        data["isFeatured"] = this.isFeatured;
        data["isTypeSerice"] = this.isTypeSerice;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["companyProfileId"] = this.companyProfileId;
        data["isUserFeatured"] = this.isUserFeatured;
        data["showQuantity"] = this.showQuantity;
        data["minLevel"] = this.minLevel;
        data["isNotifiedMinLevel"] = this.isNotifiedMinLevel;
        data["tagNumber"] = this.tagNumber;
        data["barCode"] = this.barCode;
        data["inventoryCategoryId"] = this.inventoryCategoryId;
        data["producerTenantId"] = this.producerTenantId;
        data["averagePriceFromPo"] = this.averagePriceFromPo;
        data["averageProductionCost"] = this.averageProductionCost;
        data["lastSellingPrice"] = this.lastSellingPrice;
        data["lastPriceFromPo"] = this.lastPriceFromPo;
        data["lastProductionCost"] = this.lastProductionCost;
        data["movingAverageValue"] = this.movingAverageValue;
        data["isHidden"] = this.isHidden;
        data["projectId"] = this.projectId;
        data["dateOfMigration"] = this.dateOfMigration ? this.dateOfMigration.toISOString() : <any>undefined;
        data["firebaseDocID"] = this.firebaseDocID;
        data["firebaseCategory"] = this.firebaseCategory;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateProductDto {
        const json = this.toJSON();
        let result = new UpdateProductDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateProductDto {
    code: string;
    name: string;
    description: string | undefined;
    price: number;
    tenantId: number | undefined;
    images: ProductImages[] | undefined;
    oldPrice: number;
    discount: number;
    ratingsCount: number;
    ratingsValue: number;
    availibilityCount: number;
    cartCount: number;
    color: ProductColors[] | undefined;
    size: ProductSizes[] | undefined;
    weight: number;
    categoryId: string | undefined;
    fullDescription: string | undefined;
    serviceTax: number;
    taxCode: string | undefined;
    isSubsidized: boolean;
    isCertified: boolean;
    isIslamic: boolean;
    isLoanAvailable: boolean;
    hideFromMarketplace: boolean;
    isFeatured: boolean;
    isTypeSerice: boolean;
    unitOfMeasurement: string | undefined;
    companyProfileId: string | undefined;
    isUserFeatured: boolean;
    showQuantity: boolean;
    minLevel: number;
    isNotifiedMinLevel: boolean;
    tagNumber: string | undefined;
    barCode: string | undefined;
    inventoryCategoryId: number | undefined;
    producerTenantId: number;
    averagePriceFromPo: number;
    averageProductionCost: number;
    lastSellingPrice: number;
    lastPriceFromPo: number;
    lastProductionCost: number;
    movingAverageValue: number;
    isHidden: boolean;
    projectId: number | undefined;
    dateOfMigration: moment.Moment | undefined;
    firebaseDocID: string | undefined;
    firebaseCategory: string | undefined;
    id: string;
}

export class UpdateQuotationVendorDto implements IUpdateQuotationVendorDto {
    justificationForSelection: string | undefined;
    offeredPrice: number;
    remarksFromVendor: string | undefined;
    vendorId: number;
    vendorObject: Vendor;
    deliveryCost: number;
    installationCost: number;

    constructor(data?: IUpdateQuotationVendorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.justificationForSelection = _data["justificationForSelection"];
            this.offeredPrice = _data["offeredPrice"];
            this.remarksFromVendor = _data["remarksFromVendor"];
            this.vendorId = _data["vendorId"];
            this.vendorObject = _data["vendorObject"] ? Vendor.fromJS(_data["vendorObject"]) : <any>undefined;
            this.deliveryCost = _data["deliveryCost"];
            this.installationCost = _data["installationCost"];
        }
    }

    static fromJS(data: any): UpdateQuotationVendorDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuotationVendorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["justificationForSelection"] = this.justificationForSelection;
        data["offeredPrice"] = this.offeredPrice;
        data["remarksFromVendor"] = this.remarksFromVendor;
        data["vendorId"] = this.vendorId;
        data["vendorObject"] = this.vendorObject ? this.vendorObject.toJSON() : <any>undefined;
        data["deliveryCost"] = this.deliveryCost;
        data["installationCost"] = this.installationCost;
        return data;
    }

    clone(): UpdateQuotationVendorDto {
        const json = this.toJSON();
        let result = new UpdateQuotationVendorDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateQuotationVendorDto {
    justificationForSelection: string | undefined;
    offeredPrice: number;
    remarksFromVendor: string | undefined;
    vendorId: number;
    vendorObject: Vendor;
    deliveryCost: number;
    installationCost: number;
}

export class UpdateScfDto implements IUpdateScfDto {
    isScfOnboarded: boolean;
    scfTenancyName: string | undefined;
    scfTenantId: number;
    scfEmail: string | undefined;
    scfPassword: string | undefined;
    scfApplicationStatus: number;
    scfSupplierId: number;

    constructor(data?: IUpdateScfDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isScfOnboarded = _data["isScfOnboarded"];
            this.scfTenancyName = _data["scfTenancyName"];
            this.scfTenantId = _data["scfTenantId"];
            this.scfEmail = _data["scfEmail"];
            this.scfPassword = _data["scfPassword"];
            this.scfApplicationStatus = _data["scfApplicationStatus"];
            this.scfSupplierId = _data["scfSupplierId"];
        }
    }

    static fromJS(data: any): UpdateScfDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScfDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isScfOnboarded"] = this.isScfOnboarded;
        data["scfTenancyName"] = this.scfTenancyName;
        data["scfTenantId"] = this.scfTenantId;
        data["scfEmail"] = this.scfEmail;
        data["scfPassword"] = this.scfPassword;
        data["scfApplicationStatus"] = this.scfApplicationStatus;
        data["scfSupplierId"] = this.scfSupplierId;
        return data;
    }

    clone(): UpdateScfDto {
        const json = this.toJSON();
        let result = new UpdateScfDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateScfDto {
    isScfOnboarded: boolean;
    scfTenancyName: string | undefined;
    scfTenantId: number;
    scfEmail: string | undefined;
    scfPassword: string | undefined;
    scfApplicationStatus: number;
    scfSupplierId: number;
}

export class UpdateVendorInvoiceDto implements IUpdateVendorInvoiceDto {
    id: number;
    status: number;
    paymentBankName: string | undefined;
    paymentBankAccountNo: string | undefined;
    paymentBankAccountHolder: string | undefined;

    constructor(data?: IUpdateVendorInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.paymentBankName = _data["paymentBankName"];
            this.paymentBankAccountNo = _data["paymentBankAccountNo"];
            this.paymentBankAccountHolder = _data["paymentBankAccountHolder"];
        }
    }

    static fromJS(data: any): UpdateVendorInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVendorInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["paymentBankName"] = this.paymentBankName;
        data["paymentBankAccountNo"] = this.paymentBankAccountNo;
        data["paymentBankAccountHolder"] = this.paymentBankAccountHolder;
        return data;
    }

    clone(): UpdateVendorInvoiceDto {
        const json = this.toJSON();
        let result = new UpdateVendorInvoiceDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateVendorInvoiceDto {
    id: number;
    status: number;
    paymentBankName: string | undefined;
    paymentBankAccountNo: string | undefined;
    paymentBankAccountHolder: string | undefined;
}

export class UpdateWishlistDto implements IUpdateWishlistDto {
    userId: number;
    tenantId: number;
    productId: string;
    name: string;
    quantity: number;
    unitPrice: number;
    discount: number;
    tax: number;
    taxCode: string | undefined;
    docId: string | undefined;
    id: string;

    constructor(data?: IUpdateWishlistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.productId = _data["productId"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.discount = _data["discount"];
            this.tax = _data["tax"];
            this.taxCode = _data["taxCode"];
            this.docId = _data["docId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateWishlistDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWishlistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["productId"] = this.productId;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["discount"] = this.discount;
        data["tax"] = this.tax;
        data["taxCode"] = this.taxCode;
        data["docId"] = this.docId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateWishlistDto {
        const json = this.toJSON();
        let result = new UpdateWishlistDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateWishlistDto {
    userId: number;
    tenantId: number;
    productId: string;
    name: string;
    quantity: number;
    unitPrice: number;
    discount: number;
    tax: number;
    taxCode: string | undefined;
    docId: string | undefined;
    id: string;
}

export class User implements IUser {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    readonly fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    lastVisitedMerchantStore: string | undefined;
    mobile: string | undefined;
    imagePath: string | undefined;
    dateOfBirth: moment.Moment;
    gender: string | undefined;
    presentAddress1: string | undefined;
    presentAddress2: string | undefined;
    presentAddress3: string | undefined;
    presentAddress4: string | undefined;
    permanentAddress1: string | undefined;
    permanentAddress2: string | undefined;
    permanentAddress3: string | undefined;
    permanentAddress4: string | undefined;
    basicSalary: number;
    status: number;
    joiningDate: moment.Moment;
    resignDate: moment.Moment;
    departmentId: number;
    designationId: number;
    bankName: string | undefined;
    accountName: string | undefined;
    accountNumber: string | undefined;
    swiftCode: string | undefined;
    branch: string | undefined;
    cv: string | undefined;
    nationalId: string | undefined;
    other: string | undefined;
    icUrl: string | undefined;
    otherUrl: string | undefined;
    accessToken: string | undefined;
    userLeavePolicies: UserLeavePolicyRelation[] | undefined;
    staffId: string | undefined;
    isResident: boolean;
    identificationType: string | undefined;
    identificationNo: string | undefined;
    religion: string | undefined;
    ethnicity: string | undefined;
    maritalStatus: string | undefined;
    disability: boolean;
    country: string | undefined;
    postcode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    highestEducation: string | undefined;
    educationSpecialisation: string | undefined;
    isSpecialWorker: boolean;
    salaryType: SalaryType;
    salaryPaymentMethod: boolean;
    epfNumber: string | undefined;
    incomeTaxNumber: string | undefined;
    socsoAccountNumber: string | undefined;
    socsoContributionSchedule: number;
    eisAccountNumber: string | undefined;
    zakatAccountNumber: string | undefined;
    zakatState: string | undefined;
    zakatAmount: number;
    asnbAccountNumber: string | undefined;
    asnbAmount: number;
    ptptnAccountNumber: string | undefined;
    ptptnAmount: number;
    tabungHajiAccountNumber: string | undefined;
    tabungHajiAmount: number;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.authenticationSource = _data["authenticationSource"];
            this.userName = _data["userName"];
            this.tenantId = _data["tenantId"];
            this.emailAddress = _data["emailAddress"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            (<any>this).fullName = _data["fullName"];
            this.password = _data["password"];
            this.emailConfirmationCode = _data["emailConfirmationCode"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? moment(_data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.accessFailedCount = _data["accessFailedCount"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.securityStamp = _data["securityStamp"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            if (Array.isArray(_data["logins"])) {
                this.logins = [] as any;
                for (let item of _data["logins"])
                    this.logins.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims.push(UserClaim.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(UserPermissionSetting.fromJS(item));
            }
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings.push(Setting.fromJS(item));
            }
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.isActive = _data["isActive"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.normalizedEmailAddress = _data["normalizedEmailAddress"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens.push(UserToken.fromJS(item));
            }
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
            this.lastVisitedMerchantStore = _data["lastVisitedMerchantStore"];
            this.mobile = _data["mobile"];
            this.imagePath = _data["imagePath"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.presentAddress1 = _data["presentAddress1"];
            this.presentAddress2 = _data["presentAddress2"];
            this.presentAddress3 = _data["presentAddress3"];
            this.presentAddress4 = _data["presentAddress4"];
            this.permanentAddress1 = _data["permanentAddress1"];
            this.permanentAddress2 = _data["permanentAddress2"];
            this.permanentAddress3 = _data["permanentAddress3"];
            this.permanentAddress4 = _data["permanentAddress4"];
            this.basicSalary = _data["basicSalary"];
            this.status = _data["status"];
            this.joiningDate = _data["joiningDate"] ? moment(_data["joiningDate"].toString()) : <any>undefined;
            this.resignDate = _data["resignDate"] ? moment(_data["resignDate"].toString()) : <any>undefined;
            this.departmentId = _data["departmentId"];
            this.designationId = _data["designationId"];
            this.bankName = _data["bankName"];
            this.accountName = _data["accountName"];
            this.accountNumber = _data["accountNumber"];
            this.swiftCode = _data["swiftCode"];
            this.branch = _data["branch"];
            this.cv = _data["cv"];
            this.nationalId = _data["nationalId"];
            this.other = _data["other"];
            this.icUrl = _data["icUrl"];
            this.otherUrl = _data["otherUrl"];
            this.accessToken = _data["accessToken"];
            if (Array.isArray(_data["userLeavePolicies"])) {
                this.userLeavePolicies = [] as any;
                for (let item of _data["userLeavePolicies"])
                    this.userLeavePolicies.push(UserLeavePolicyRelation.fromJS(item));
            }
            this.staffId = _data["staffId"];
            this.isResident = _data["isResident"];
            this.identificationType = _data["identificationType"];
            this.identificationNo = _data["identificationNo"];
            this.religion = _data["religion"];
            this.ethnicity = _data["ethnicity"];
            this.maritalStatus = _data["maritalStatus"];
            this.disability = _data["disability"];
            this.country = _data["country"];
            this.postcode = _data["postcode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.highestEducation = _data["highestEducation"];
            this.educationSpecialisation = _data["educationSpecialisation"];
            this.isSpecialWorker = _data["isSpecialWorker"];
            this.salaryType = _data["salaryType"];
            this.salaryPaymentMethod = _data["salaryPaymentMethod"];
            this.epfNumber = _data["epfNumber"];
            this.incomeTaxNumber = _data["incomeTaxNumber"];
            this.socsoAccountNumber = _data["socsoAccountNumber"];
            this.socsoContributionSchedule = _data["socsoContributionSchedule"];
            this.eisAccountNumber = _data["eisAccountNumber"];
            this.zakatAccountNumber = _data["zakatAccountNumber"];
            this.zakatState = _data["zakatState"];
            this.zakatAmount = _data["zakatAmount"];
            this.asnbAccountNumber = _data["asnbAccountNumber"];
            this.asnbAmount = _data["asnbAmount"];
            this.ptptnAccountNumber = _data["ptptnAccountNumber"];
            this.ptptnAmount = _data["ptptnAmount"];
            this.tabungHajiAccountNumber = _data["tabungHajiAccountNumber"];
            this.tabungHajiAmount = _data["tabungHajiAmount"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["authenticationSource"] = this.authenticationSource;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : <any>undefined;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (Array.isArray(this.logins)) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["normalizedUserName"] = this.normalizedUserName;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data["lastVisitedMerchantStore"] = this.lastVisitedMerchantStore;
        data["mobile"] = this.mobile;
        data["imagePath"] = this.imagePath;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["presentAddress1"] = this.presentAddress1;
        data["presentAddress2"] = this.presentAddress2;
        data["presentAddress3"] = this.presentAddress3;
        data["presentAddress4"] = this.presentAddress4;
        data["permanentAddress1"] = this.permanentAddress1;
        data["permanentAddress2"] = this.permanentAddress2;
        data["permanentAddress3"] = this.permanentAddress3;
        data["permanentAddress4"] = this.permanentAddress4;
        data["basicSalary"] = this.basicSalary;
        data["status"] = this.status;
        data["joiningDate"] = this.joiningDate ? this.joiningDate.toISOString() : <any>undefined;
        data["resignDate"] = this.resignDate ? this.resignDate.toISOString() : <any>undefined;
        data["departmentId"] = this.departmentId;
        data["designationId"] = this.designationId;
        data["bankName"] = this.bankName;
        data["accountName"] = this.accountName;
        data["accountNumber"] = this.accountNumber;
        data["swiftCode"] = this.swiftCode;
        data["branch"] = this.branch;
        data["cv"] = this.cv;
        data["nationalId"] = this.nationalId;
        data["other"] = this.other;
        data["icUrl"] = this.icUrl;
        data["otherUrl"] = this.otherUrl;
        data["accessToken"] = this.accessToken;
        if (Array.isArray(this.userLeavePolicies)) {
            data["userLeavePolicies"] = [];
            for (let item of this.userLeavePolicies)
                data["userLeavePolicies"].push(item.toJSON());
        }
        data["staffId"] = this.staffId;
        data["isResident"] = this.isResident;
        data["identificationType"] = this.identificationType;
        data["identificationNo"] = this.identificationNo;
        data["religion"] = this.religion;
        data["ethnicity"] = this.ethnicity;
        data["maritalStatus"] = this.maritalStatus;
        data["disability"] = this.disability;
        data["country"] = this.country;
        data["postcode"] = this.postcode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["highestEducation"] = this.highestEducation;
        data["educationSpecialisation"] = this.educationSpecialisation;
        data["isSpecialWorker"] = this.isSpecialWorker;
        data["salaryType"] = this.salaryType;
        data["salaryPaymentMethod"] = this.salaryPaymentMethod;
        data["epfNumber"] = this.epfNumber;
        data["incomeTaxNumber"] = this.incomeTaxNumber;
        data["socsoAccountNumber"] = this.socsoAccountNumber;
        data["socsoContributionSchedule"] = this.socsoContributionSchedule;
        data["eisAccountNumber"] = this.eisAccountNumber;
        data["zakatAccountNumber"] = this.zakatAccountNumber;
        data["zakatState"] = this.zakatState;
        data["zakatAmount"] = this.zakatAmount;
        data["asnbAccountNumber"] = this.asnbAccountNumber;
        data["asnbAmount"] = this.asnbAmount;
        data["ptptnAccountNumber"] = this.ptptnAccountNumber;
        data["ptptnAmount"] = this.ptptnAmount;
        data["tabungHajiAccountNumber"] = this.tabungHajiAccountNumber;
        data["tabungHajiAmount"] = this.tabungHajiAmount;
        return data;
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    lastVisitedMerchantStore: string | undefined;
    mobile: string | undefined;
    imagePath: string | undefined;
    dateOfBirth: moment.Moment;
    gender: string | undefined;
    presentAddress1: string | undefined;
    presentAddress2: string | undefined;
    presentAddress3: string | undefined;
    presentAddress4: string | undefined;
    permanentAddress1: string | undefined;
    permanentAddress2: string | undefined;
    permanentAddress3: string | undefined;
    permanentAddress4: string | undefined;
    basicSalary: number;
    status: number;
    joiningDate: moment.Moment;
    resignDate: moment.Moment;
    departmentId: number;
    designationId: number;
    bankName: string | undefined;
    accountName: string | undefined;
    accountNumber: string | undefined;
    swiftCode: string | undefined;
    branch: string | undefined;
    cv: string | undefined;
    nationalId: string | undefined;
    other: string | undefined;
    icUrl: string | undefined;
    otherUrl: string | undefined;
    accessToken: string | undefined;
    userLeavePolicies: UserLeavePolicyRelation[] | undefined;
    staffId: string | undefined;
    isResident: boolean;
    identificationType: string | undefined;
    identificationNo: string | undefined;
    religion: string | undefined;
    ethnicity: string | undefined;
    maritalStatus: string | undefined;
    disability: boolean;
    country: string | undefined;
    postcode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    highestEducation: string | undefined;
    educationSpecialisation: string | undefined;
    isSpecialWorker: boolean;
    salaryType: SalaryType;
    salaryPaymentMethod: boolean;
    epfNumber: string | undefined;
    incomeTaxNumber: string | undefined;
    socsoAccountNumber: string | undefined;
    socsoContributionSchedule: number;
    eisAccountNumber: string | undefined;
    zakatAccountNumber: string | undefined;
    zakatState: string | undefined;
    zakatAmount: number;
    asnbAccountNumber: string | undefined;
    asnbAmount: number;
    ptptnAccountNumber: string | undefined;
    ptptnAmount: number;
    tabungHajiAccountNumber: string | undefined;
    tabungHajiAmount: number;
}

export class UserAddress implements IUserAddress {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    userId: number;
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    country: string | undefined;
    city: string | undefined;
    state: string | undefined;
    postcode: number;
    address: string | undefined;

    constructor(data?: IUserAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postcode = _data["postcode"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): UserAddress {
        data = typeof data === 'object' ? data : {};
        let result = new UserAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["country"] = this.country;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postcode"] = this.postcode;
        data["address"] = this.address;
        return data;
    }

    clone(): UserAddress {
        const json = this.toJSON();
        let result = new UserAddress();
        result.init(json);
        return result;
    }
}

export interface IUserAddress {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    userId: number;
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    country: string | undefined;
    city: string | undefined;
    state: string | undefined;
    postcode: number;
    address: string | undefined;
}

export class UserAddressDto implements IUserAddressDto {
    userId: number;
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    country: string | undefined;
    city: string | undefined;
    state: string | undefined;
    postcode: number;
    address: string | undefined;

    constructor(data?: IUserAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postcode = _data["postcode"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): UserAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["country"] = this.country;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postcode"] = this.postcode;
        data["address"] = this.address;
        return data;
    }

    clone(): UserAddressDto {
        const json = this.toJSON();
        let result = new UserAddressDto();
        result.init(json);
        return result;
    }
}

export interface IUserAddressDto {
    userId: number;
    name: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    country: string | undefined;
    city: string | undefined;
    state: string | undefined;
    postcode: number;
    address: string | undefined;
}

export class UserClaim implements IUserClaim {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        return data;
    }

    clone(): UserClaim {
        const json = this.toJSON();
        let result = new UserClaim();
        result.init(json);
        return result;
    }
}

export interface IUserClaim {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
}

export class UserCurrentAccountDto implements IUserCurrentAccountDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    userId: number;
    user: UserDto;
    userName: string | undefined;
    userEmail: string | undefined;
    status: string | undefined;
    type: string | undefined;
    date: moment.Moment | undefined;
    attachmentUrl: string | undefined;
    attachmentFileName: string | undefined;
    description: string | undefined;
    referenceNo: string | undefined;
    amount: number;
    approverUserId: number;
    approverUser: UserDto;
    approverUserName: string | undefined;
    approverUserEmail: string | undefined;
    approvedDate: moment.Moment | undefined;

    constructor(data?: IUserCurrentAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.userName = _data["userName"];
            this.userEmail = _data["userEmail"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.attachmentUrl = _data["attachmentUrl"];
            this.attachmentFileName = _data["attachmentFileName"];
            this.description = _data["description"];
            this.referenceNo = _data["referenceNo"];
            this.amount = _data["amount"];
            this.approverUserId = _data["approverUserId"];
            this.approverUser = _data["approverUser"] ? UserDto.fromJS(_data["approverUser"]) : <any>undefined;
            this.approverUserName = _data["approverUserName"];
            this.approverUserEmail = _data["approverUserEmail"];
            this.approvedDate = _data["approvedDate"] ? moment(_data["approvedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserCurrentAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCurrentAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userName"] = this.userName;
        data["userEmail"] = this.userEmail;
        data["status"] = this.status;
        data["type"] = this.type;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["attachmentUrl"] = this.attachmentUrl;
        data["attachmentFileName"] = this.attachmentFileName;
        data["description"] = this.description;
        data["referenceNo"] = this.referenceNo;
        data["amount"] = this.amount;
        data["approverUserId"] = this.approverUserId;
        data["approverUser"] = this.approverUser ? this.approverUser.toJSON() : <any>undefined;
        data["approverUserName"] = this.approverUserName;
        data["approverUserEmail"] = this.approverUserEmail;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): UserCurrentAccountDto {
        const json = this.toJSON();
        let result = new UserCurrentAccountDto();
        result.init(json);
        return result;
    }
}

export interface IUserCurrentAccountDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    userId: number;
    user: UserDto;
    userName: string | undefined;
    userEmail: string | undefined;
    status: string | undefined;
    type: string | undefined;
    date: moment.Moment | undefined;
    attachmentUrl: string | undefined;
    attachmentFileName: string | undefined;
    description: string | undefined;
    referenceNo: string | undefined;
    amount: number;
    approverUserId: number;
    approverUser: UserDto;
    approverUserName: string | undefined;
    approverUserEmail: string | undefined;
    approvedDate: moment.Moment | undefined;
}

export class UserCurrentAccountDtoPagedResultDto implements IUserCurrentAccountDtoPagedResultDto {
    items: UserCurrentAccountDto[] | undefined;
    totalCount: number;

    constructor(data?: IUserCurrentAccountDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserCurrentAccountDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserCurrentAccountDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCurrentAccountDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserCurrentAccountDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserCurrentAccountDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserCurrentAccountDtoPagedResultDto {
    items: UserCurrentAccountDto[] | undefined;
    totalCount: number;
}

export class UserDependantModelDto implements IUserDependantModelDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    userId: number;
    user: UserDto;
    relationship: string | undefined;
    name: string | undefined;
    dateOfBirth: moment.Moment | undefined;
    nationality: string | undefined;
    identificationNumber: string | undefined;
    phoneNumber: string | undefined;

    constructor(data?: IUserDependantModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.relationship = _data["relationship"];
            this.name = _data["name"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : <any>undefined;
            this.nationality = _data["nationality"];
            this.identificationNumber = _data["identificationNumber"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): UserDependantModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDependantModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["relationship"] = this.relationship;
        data["name"] = this.name;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["nationality"] = this.nationality;
        data["identificationNumber"] = this.identificationNumber;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }

    clone(): UserDependantModelDto {
        const json = this.toJSON();
        let result = new UserDependantModelDto();
        result.init(json);
        return result;
    }
}

export interface IUserDependantModelDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    userId: number;
    user: UserDto;
    relationship: string | undefined;
    name: string | undefined;
    dateOfBirth: moment.Moment | undefined;
    nationality: string | undefined;
    identificationNumber: string | undefined;
    phoneNumber: string | undefined;
}

export class UserDto implements IUserDto {
    id: number;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
    mainRoleId: number;
    mainRoleName: string | undefined;
    mainRolePermissionList: RolePermissionSetting[] | undefined;
    lastVisitedMerchantStore: string | undefined;
    isEmailConfirmed: boolean;
    mobile: string | undefined;
    imagePath: string | undefined;
    dateOfBirth: moment.Moment;
    gender: string | undefined;
    presentAddress1: string | undefined;
    presentAddress2: string | undefined;
    presentAddress3: string | undefined;
    presentAddress4: string | undefined;
    permanentAddress1: string | undefined;
    permanentAddress2: string | undefined;
    permanentAddress3: string | undefined;
    permanentAddress4: string | undefined;
    basicSalary: number;
    status: number;
    joiningDate: moment.Moment;
    resignDate: moment.Moment;
    departmentId: number;
    department: Department;
    designationId: number;
    designation: DesignationModel;
    bankName: string | undefined;
    accountName: string | undefined;
    accountNumber: string | undefined;
    swiftCode: string | undefined;
    branch: string | undefined;
    cv: string | undefined;
    nationalId: string | undefined;
    other: string | undefined;
    tenantId: number;
    icUrl: string | undefined;
    otherUrl: string | undefined;
    regularList: AttendenceModel[] | undefined;
    absentList: AttendenceModel[] | undefined;
    overtimeList: AttendenceModel[] | undefined;
    holidayList: AttendenceModel[] | undefined;
    paidTimeOffList: AttendenceModel[] | undefined;
    regularHours: number;
    absentHours: number;
    overtimeHours: number;
    holidayHours: number;
    paidTimeOffHours: number;
    totalHours: number;
    userLeavePolicies: UserLeavePolicyRelationDto[] | undefined;
    staffId: string | undefined;
    isResident: boolean;
    identificationType: string | undefined;
    identificationNo: string | undefined;
    religion: string | undefined;
    ethnicity: string | undefined;
    maritalStatus: string | undefined;
    disability: boolean;
    country: string | undefined;
    postcode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    highestEducation: string | undefined;
    educationSpecialisation: string | undefined;
    isSpecialWorker: boolean;
    salaryType: SalaryType;
    salaryPaymentMethod: boolean;
    epfNumber: string | undefined;
    incomeTaxNumber: string | undefined;
    socsoAccountNumber: string | undefined;
    socsoContributionSchedule: number;
    eisAccountNumber: string | undefined;
    zakatAccountNumber: string | undefined;
    zakatState: string | undefined;
    zakatAmount: number;
    asnbAccountNumber: string | undefined;
    asnbAmount: number;
    ptptnAccountNumber: string | undefined;
    ptptnAmount: number;
    tabungHajiAccountNumber: string | undefined;
    tabungHajiAmount: number;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.mainRoleId = _data["mainRoleId"];
            this.mainRoleName = _data["mainRoleName"];
            if (Array.isArray(_data["mainRolePermissionList"])) {
                this.mainRolePermissionList = [] as any;
                for (let item of _data["mainRolePermissionList"])
                    this.mainRolePermissionList.push(RolePermissionSetting.fromJS(item));
            }
            this.lastVisitedMerchantStore = _data["lastVisitedMerchantStore"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.mobile = _data["mobile"];
            this.imagePath = _data["imagePath"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.presentAddress1 = _data["presentAddress1"];
            this.presentAddress2 = _data["presentAddress2"];
            this.presentAddress3 = _data["presentAddress3"];
            this.presentAddress4 = _data["presentAddress4"];
            this.permanentAddress1 = _data["permanentAddress1"];
            this.permanentAddress2 = _data["permanentAddress2"];
            this.permanentAddress3 = _data["permanentAddress3"];
            this.permanentAddress4 = _data["permanentAddress4"];
            this.basicSalary = _data["basicSalary"];
            this.status = _data["status"];
            this.joiningDate = _data["joiningDate"] ? moment(_data["joiningDate"].toString()) : <any>undefined;
            this.resignDate = _data["resignDate"] ? moment(_data["resignDate"].toString()) : <any>undefined;
            this.departmentId = _data["departmentId"];
            this.department = _data["department"] ? Department.fromJS(_data["department"]) : <any>undefined;
            this.designationId = _data["designationId"];
            this.designation = _data["designation"] ? DesignationModel.fromJS(_data["designation"]) : <any>undefined;
            this.bankName = _data["bankName"];
            this.accountName = _data["accountName"];
            this.accountNumber = _data["accountNumber"];
            this.swiftCode = _data["swiftCode"];
            this.branch = _data["branch"];
            this.cv = _data["cv"];
            this.nationalId = _data["nationalId"];
            this.other = _data["other"];
            this.tenantId = _data["tenantId"];
            this.icUrl = _data["icUrl"];
            this.otherUrl = _data["otherUrl"];
            if (Array.isArray(_data["regularList"])) {
                this.regularList = [] as any;
                for (let item of _data["regularList"])
                    this.regularList.push(AttendenceModel.fromJS(item));
            }
            if (Array.isArray(_data["absentList"])) {
                this.absentList = [] as any;
                for (let item of _data["absentList"])
                    this.absentList.push(AttendenceModel.fromJS(item));
            }
            if (Array.isArray(_data["overtimeList"])) {
                this.overtimeList = [] as any;
                for (let item of _data["overtimeList"])
                    this.overtimeList.push(AttendenceModel.fromJS(item));
            }
            if (Array.isArray(_data["holidayList"])) {
                this.holidayList = [] as any;
                for (let item of _data["holidayList"])
                    this.holidayList.push(AttendenceModel.fromJS(item));
            }
            if (Array.isArray(_data["paidTimeOffList"])) {
                this.paidTimeOffList = [] as any;
                for (let item of _data["paidTimeOffList"])
                    this.paidTimeOffList.push(AttendenceModel.fromJS(item));
            }
            this.regularHours = _data["regularHours"];
            this.absentHours = _data["absentHours"];
            this.overtimeHours = _data["overtimeHours"];
            this.holidayHours = _data["holidayHours"];
            this.paidTimeOffHours = _data["paidTimeOffHours"];
            this.totalHours = _data["totalHours"];
            if (Array.isArray(_data["userLeavePolicies"])) {
                this.userLeavePolicies = [] as any;
                for (let item of _data["userLeavePolicies"])
                    this.userLeavePolicies.push(UserLeavePolicyRelationDto.fromJS(item));
            }
            this.staffId = _data["staffId"];
            this.isResident = _data["isResident"];
            this.identificationType = _data["identificationType"];
            this.identificationNo = _data["identificationNo"];
            this.religion = _data["religion"];
            this.ethnicity = _data["ethnicity"];
            this.maritalStatus = _data["maritalStatus"];
            this.disability = _data["disability"];
            this.country = _data["country"];
            this.postcode = _data["postcode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.highestEducation = _data["highestEducation"];
            this.educationSpecialisation = _data["educationSpecialisation"];
            this.isSpecialWorker = _data["isSpecialWorker"];
            this.salaryType = _data["salaryType"];
            this.salaryPaymentMethod = _data["salaryPaymentMethod"];
            this.epfNumber = _data["epfNumber"];
            this.incomeTaxNumber = _data["incomeTaxNumber"];
            this.socsoAccountNumber = _data["socsoAccountNumber"];
            this.socsoContributionSchedule = _data["socsoContributionSchedule"];
            this.eisAccountNumber = _data["eisAccountNumber"];
            this.zakatAccountNumber = _data["zakatAccountNumber"];
            this.zakatState = _data["zakatState"];
            this.zakatAmount = _data["zakatAmount"];
            this.asnbAccountNumber = _data["asnbAccountNumber"];
            this.asnbAmount = _data["asnbAmount"];
            this.ptptnAccountNumber = _data["ptptnAccountNumber"];
            this.ptptnAmount = _data["ptptnAmount"];
            this.tabungHajiAccountNumber = _data["tabungHajiAccountNumber"];
            this.tabungHajiAmount = _data["tabungHajiAmount"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["mainRoleId"] = this.mainRoleId;
        data["mainRoleName"] = this.mainRoleName;
        if (Array.isArray(this.mainRolePermissionList)) {
            data["mainRolePermissionList"] = [];
            for (let item of this.mainRolePermissionList)
                data["mainRolePermissionList"].push(item.toJSON());
        }
        data["lastVisitedMerchantStore"] = this.lastVisitedMerchantStore;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["mobile"] = this.mobile;
        data["imagePath"] = this.imagePath;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["presentAddress1"] = this.presentAddress1;
        data["presentAddress2"] = this.presentAddress2;
        data["presentAddress3"] = this.presentAddress3;
        data["presentAddress4"] = this.presentAddress4;
        data["permanentAddress1"] = this.permanentAddress1;
        data["permanentAddress2"] = this.permanentAddress2;
        data["permanentAddress3"] = this.permanentAddress3;
        data["permanentAddress4"] = this.permanentAddress4;
        data["basicSalary"] = this.basicSalary;
        data["status"] = this.status;
        data["joiningDate"] = this.joiningDate ? this.joiningDate.toISOString() : <any>undefined;
        data["resignDate"] = this.resignDate ? this.resignDate.toISOString() : <any>undefined;
        data["departmentId"] = this.departmentId;
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        data["designationId"] = this.designationId;
        data["designation"] = this.designation ? this.designation.toJSON() : <any>undefined;
        data["bankName"] = this.bankName;
        data["accountName"] = this.accountName;
        data["accountNumber"] = this.accountNumber;
        data["swiftCode"] = this.swiftCode;
        data["branch"] = this.branch;
        data["cv"] = this.cv;
        data["nationalId"] = this.nationalId;
        data["other"] = this.other;
        data["tenantId"] = this.tenantId;
        data["icUrl"] = this.icUrl;
        data["otherUrl"] = this.otherUrl;
        if (Array.isArray(this.regularList)) {
            data["regularList"] = [];
            for (let item of this.regularList)
                data["regularList"].push(item.toJSON());
        }
        if (Array.isArray(this.absentList)) {
            data["absentList"] = [];
            for (let item of this.absentList)
                data["absentList"].push(item.toJSON());
        }
        if (Array.isArray(this.overtimeList)) {
            data["overtimeList"] = [];
            for (let item of this.overtimeList)
                data["overtimeList"].push(item.toJSON());
        }
        if (Array.isArray(this.holidayList)) {
            data["holidayList"] = [];
            for (let item of this.holidayList)
                data["holidayList"].push(item.toJSON());
        }
        if (Array.isArray(this.paidTimeOffList)) {
            data["paidTimeOffList"] = [];
            for (let item of this.paidTimeOffList)
                data["paidTimeOffList"].push(item.toJSON());
        }
        data["regularHours"] = this.regularHours;
        data["absentHours"] = this.absentHours;
        data["overtimeHours"] = this.overtimeHours;
        data["holidayHours"] = this.holidayHours;
        data["paidTimeOffHours"] = this.paidTimeOffHours;
        data["totalHours"] = this.totalHours;
        if (Array.isArray(this.userLeavePolicies)) {
            data["userLeavePolicies"] = [];
            for (let item of this.userLeavePolicies)
                data["userLeavePolicies"].push(item.toJSON());
        }
        data["staffId"] = this.staffId;
        data["isResident"] = this.isResident;
        data["identificationType"] = this.identificationType;
        data["identificationNo"] = this.identificationNo;
        data["religion"] = this.religion;
        data["ethnicity"] = this.ethnicity;
        data["maritalStatus"] = this.maritalStatus;
        data["disability"] = this.disability;
        data["country"] = this.country;
        data["postcode"] = this.postcode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["highestEducation"] = this.highestEducation;
        data["educationSpecialisation"] = this.educationSpecialisation;
        data["isSpecialWorker"] = this.isSpecialWorker;
        data["salaryType"] = this.salaryType;
        data["salaryPaymentMethod"] = this.salaryPaymentMethod;
        data["epfNumber"] = this.epfNumber;
        data["incomeTaxNumber"] = this.incomeTaxNumber;
        data["socsoAccountNumber"] = this.socsoAccountNumber;
        data["socsoContributionSchedule"] = this.socsoContributionSchedule;
        data["eisAccountNumber"] = this.eisAccountNumber;
        data["zakatAccountNumber"] = this.zakatAccountNumber;
        data["zakatState"] = this.zakatState;
        data["zakatAmount"] = this.zakatAmount;
        data["asnbAccountNumber"] = this.asnbAccountNumber;
        data["asnbAmount"] = this.asnbAmount;
        data["ptptnAccountNumber"] = this.ptptnAccountNumber;
        data["ptptnAmount"] = this.ptptnAmount;
        data["tabungHajiAccountNumber"] = this.tabungHajiAccountNumber;
        data["tabungHajiAmount"] = this.tabungHajiAmount;
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    id: number;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
    mainRoleId: number;
    mainRoleName: string | undefined;
    mainRolePermissionList: RolePermissionSetting[] | undefined;
    lastVisitedMerchantStore: string | undefined;
    isEmailConfirmed: boolean;
    mobile: string | undefined;
    imagePath: string | undefined;
    dateOfBirth: moment.Moment;
    gender: string | undefined;
    presentAddress1: string | undefined;
    presentAddress2: string | undefined;
    presentAddress3: string | undefined;
    presentAddress4: string | undefined;
    permanentAddress1: string | undefined;
    permanentAddress2: string | undefined;
    permanentAddress3: string | undefined;
    permanentAddress4: string | undefined;
    basicSalary: number;
    status: number;
    joiningDate: moment.Moment;
    resignDate: moment.Moment;
    departmentId: number;
    department: Department;
    designationId: number;
    designation: DesignationModel;
    bankName: string | undefined;
    accountName: string | undefined;
    accountNumber: string | undefined;
    swiftCode: string | undefined;
    branch: string | undefined;
    cv: string | undefined;
    nationalId: string | undefined;
    other: string | undefined;
    tenantId: number;
    icUrl: string | undefined;
    otherUrl: string | undefined;
    regularList: AttendenceModel[] | undefined;
    absentList: AttendenceModel[] | undefined;
    overtimeList: AttendenceModel[] | undefined;
    holidayList: AttendenceModel[] | undefined;
    paidTimeOffList: AttendenceModel[] | undefined;
    regularHours: number;
    absentHours: number;
    overtimeHours: number;
    holidayHours: number;
    paidTimeOffHours: number;
    totalHours: number;
    userLeavePolicies: UserLeavePolicyRelationDto[] | undefined;
    staffId: string | undefined;
    isResident: boolean;
    identificationType: string | undefined;
    identificationNo: string | undefined;
    religion: string | undefined;
    ethnicity: string | undefined;
    maritalStatus: string | undefined;
    disability: boolean;
    country: string | undefined;
    postcode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    highestEducation: string | undefined;
    educationSpecialisation: string | undefined;
    isSpecialWorker: boolean;
    salaryType: SalaryType;
    salaryPaymentMethod: boolean;
    epfNumber: string | undefined;
    incomeTaxNumber: string | undefined;
    socsoAccountNumber: string | undefined;
    socsoContributionSchedule: number;
    eisAccountNumber: string | undefined;
    zakatAccountNumber: string | undefined;
    zakatState: string | undefined;
    zakatAmount: number;
    asnbAccountNumber: string | undefined;
    asnbAmount: number;
    ptptnAccountNumber: string | undefined;
    ptptnAmount: number;
    tabungHajiAccountNumber: string | undefined;
    tabungHajiAmount: number;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;
}

export class UserLeavePolicyRelation implements IUserLeavePolicyRelation {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    userId: number;
    user: User;
    leavePolicyId: number;
    leavePolicy: LeavePolicy;
    leaveTypeModelId: number;
    leaveTypeModel: LeaveTypeModel;
    accrualStartDate: moment.Moment | undefined;
    lastAccrualDate: moment.Moment | undefined;
    totalLeaveAccrued: number;
    totalLeaveUsed: number;
    readonly accruedLeaveBalance: number;

    constructor(data?: IUserLeavePolicyRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.leavePolicyId = _data["leavePolicyId"];
            this.leavePolicy = _data["leavePolicy"] ? LeavePolicy.fromJS(_data["leavePolicy"]) : <any>undefined;
            this.leaveTypeModelId = _data["leaveTypeModelId"];
            this.leaveTypeModel = _data["leaveTypeModel"] ? LeaveTypeModel.fromJS(_data["leaveTypeModel"]) : <any>undefined;
            this.accrualStartDate = _data["accrualStartDate"] ? moment(_data["accrualStartDate"].toString()) : <any>undefined;
            this.lastAccrualDate = _data["lastAccrualDate"] ? moment(_data["lastAccrualDate"].toString()) : <any>undefined;
            this.totalLeaveAccrued = _data["totalLeaveAccrued"];
            this.totalLeaveUsed = _data["totalLeaveUsed"];
            (<any>this).accruedLeaveBalance = _data["accruedLeaveBalance"];
        }
    }

    static fromJS(data: any): UserLeavePolicyRelation {
        data = typeof data === 'object' ? data : {};
        let result = new UserLeavePolicyRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["leavePolicyId"] = this.leavePolicyId;
        data["leavePolicy"] = this.leavePolicy ? this.leavePolicy.toJSON() : <any>undefined;
        data["leaveTypeModelId"] = this.leaveTypeModelId;
        data["leaveTypeModel"] = this.leaveTypeModel ? this.leaveTypeModel.toJSON() : <any>undefined;
        data["accrualStartDate"] = this.accrualStartDate ? this.accrualStartDate.toISOString() : <any>undefined;
        data["lastAccrualDate"] = this.lastAccrualDate ? this.lastAccrualDate.toISOString() : <any>undefined;
        data["totalLeaveAccrued"] = this.totalLeaveAccrued;
        data["totalLeaveUsed"] = this.totalLeaveUsed;
        data["accruedLeaveBalance"] = this.accruedLeaveBalance;
        return data;
    }

    clone(): UserLeavePolicyRelation {
        const json = this.toJSON();
        let result = new UserLeavePolicyRelation();
        result.init(json);
        return result;
    }
}

export interface IUserLeavePolicyRelation {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    userId: number;
    user: User;
    leavePolicyId: number;
    leavePolicy: LeavePolicy;
    leaveTypeModelId: number;
    leaveTypeModel: LeaveTypeModel;
    accrualStartDate: moment.Moment | undefined;
    lastAccrualDate: moment.Moment | undefined;
    totalLeaveAccrued: number;
    totalLeaveUsed: number;
    accruedLeaveBalance: number;
}

export class UserLeavePolicyRelationDto implements IUserLeavePolicyRelationDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    userId: number;
    user: UserDto;
    leavePolicyId: number;
    leavePolicy: LeavePolicy;
    leaveTypeModelId: number;
    leaveTypeModel: LeaveTypeModel;
    accrualStartDate: moment.Moment | undefined;
    lastAccrualDate: moment.Moment | undefined;
    totalLeaveAccrued: number;
    totalLeaveUsed: number;
    readonly accruedLeaveBalance: number;
    readonly displayNumber: number;
    readonly displayText: string | undefined;

    constructor(data?: IUserLeavePolicyRelationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.leavePolicyId = _data["leavePolicyId"];
            this.leavePolicy = _data["leavePolicy"] ? LeavePolicy.fromJS(_data["leavePolicy"]) : <any>undefined;
            this.leaveTypeModelId = _data["leaveTypeModelId"];
            this.leaveTypeModel = _data["leaveTypeModel"] ? LeaveTypeModel.fromJS(_data["leaveTypeModel"]) : <any>undefined;
            this.accrualStartDate = _data["accrualStartDate"] ? moment(_data["accrualStartDate"].toString()) : <any>undefined;
            this.lastAccrualDate = _data["lastAccrualDate"] ? moment(_data["lastAccrualDate"].toString()) : <any>undefined;
            this.totalLeaveAccrued = _data["totalLeaveAccrued"];
            this.totalLeaveUsed = _data["totalLeaveUsed"];
            (<any>this).accruedLeaveBalance = _data["accruedLeaveBalance"];
            (<any>this).displayNumber = _data["displayNumber"];
            (<any>this).displayText = _data["displayText"];
        }
    }

    static fromJS(data: any): UserLeavePolicyRelationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLeavePolicyRelationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["leavePolicyId"] = this.leavePolicyId;
        data["leavePolicy"] = this.leavePolicy ? this.leavePolicy.toJSON() : <any>undefined;
        data["leaveTypeModelId"] = this.leaveTypeModelId;
        data["leaveTypeModel"] = this.leaveTypeModel ? this.leaveTypeModel.toJSON() : <any>undefined;
        data["accrualStartDate"] = this.accrualStartDate ? this.accrualStartDate.toISOString() : <any>undefined;
        data["lastAccrualDate"] = this.lastAccrualDate ? this.lastAccrualDate.toISOString() : <any>undefined;
        data["totalLeaveAccrued"] = this.totalLeaveAccrued;
        data["totalLeaveUsed"] = this.totalLeaveUsed;
        data["accruedLeaveBalance"] = this.accruedLeaveBalance;
        data["displayNumber"] = this.displayNumber;
        data["displayText"] = this.displayText;
        return data;
    }

    clone(): UserLeavePolicyRelationDto {
        const json = this.toJSON();
        let result = new UserLeavePolicyRelationDto();
        result.init(json);
        return result;
    }
}

export interface IUserLeavePolicyRelationDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    userId: number;
    user: UserDto;
    leavePolicyId: number;
    leavePolicy: LeavePolicy;
    leaveTypeModelId: number;
    leaveTypeModel: LeaveTypeModel;
    accrualStartDate: moment.Moment | undefined;
    lastAccrualDate: moment.Moment | undefined;
    totalLeaveAccrued: number;
    totalLeaveUsed: number;
    accruedLeaveBalance: number;
    displayNumber: number;
    displayText: string | undefined;
}

export class UserLeavePolicyRelationDtoPagedResultDto implements IUserLeavePolicyRelationDtoPagedResultDto {
    items: UserLeavePolicyRelationDto[] | undefined;
    totalCount: number;

    constructor(data?: IUserLeavePolicyRelationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserLeavePolicyRelationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserLeavePolicyRelationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLeavePolicyRelationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserLeavePolicyRelationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserLeavePolicyRelationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserLeavePolicyRelationDtoPagedResultDto {
    items: UserLeavePolicyRelationDto[] | undefined;
    totalCount: number;
}

export class UserLogin implements IUserLogin {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        return data;
    }

    clone(): UserLogin {
        const json = this.toJSON();
        let result = new UserLogin();
        result.init(json);
        return result;
    }
}

export interface IUserLogin {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    imagePath: string | undefined;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.imagePath = _data["imagePath"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["imagePath"] = this.imagePath;
        return data;
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    imagePath: string | undefined;
}

export class UserModel implements IUserModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    email: string;
    password: string;
    role: string;
    userId: number | undefined;
    tenantId: number;

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.password = _data["password"];
            this.role = _data["role"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["password"] = this.password;
        data["role"] = this.role;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): UserModel {
        const json = this.toJSON();
        let result = new UserModel();
        result.init(json);
        return result;
    }
}

export interface IUserModel {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    email: string;
    password: string;
    role: string;
    userId: number | undefined;
    tenantId: number;
}

export class UserModelDto implements IUserModelDto {
    email: string | undefined;
    password: string | undefined;
    role: string | undefined;
    userId: number | undefined;
    tenantId: number;

    constructor(data?: IUserModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            this.role = _data["role"];
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): UserModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["role"] = this.role;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): UserModelDto {
        const json = this.toJSON();
        let result = new UserModelDto();
        result.init(json);
        return result;
    }
}

export interface IUserModelDto {
    email: string | undefined;
    password: string | undefined;
    role: string | undefined;
    userId: number | undefined;
    tenantId: number;
}

export class UserModelPagedResultDto implements IUserModelPagedResultDto {
    items: UserModel[] | undefined;
    totalCount: number;

    constructor(data?: IUserModelPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserModel.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserModelPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserModelPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserModelPagedResultDto {
        const json = this.toJSON();
        let result = new UserModelPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserModelPagedResultDto {
    items: UserModel[] | undefined;
    totalCount: number;
}

export class UserPermissionSetting implements IUserPermissionSetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    userId: number;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isGranted = _data["isGranted"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UserPermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["userId"] = this.userId;
        return data;
    }

    clone(): UserPermissionSetting {
        const json = this.toJSON();
        let result = new UserPermissionSetting();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionSetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    userId: number;
}

export class UserRole implements IUserRole {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    roleId: number;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        return data;
    }

    clone(): UserRole {
        const json = this.toJSON();
        let result = new UserRole();
        result.init(json);
        return result;
    }
}

export interface IUserRole {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    roleId: number;
}

export class UserToken implements IUserToken {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): UserToken {
        const json = this.toJSON();
        let result = new UserToken();
        result.init(json);
        return result;
    }
}

export interface IUserToken {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
}

export class ValidationErrorDto implements IValidationErrorDto {
    propertyName: string | undefined;
    propertyPath: string | undefined;
    errorCode: string | undefined;
    error: string | undefined;
    errorMs: string | undefined;
    innerError: InnerErrorDto[] | undefined;

    constructor(data?: IValidationErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.propertyPath = _data["propertyPath"];
            this.errorCode = _data["errorCode"];
            this.error = _data["error"];
            this.errorMs = _data["errorMs"];
            if (Array.isArray(_data["innerError"])) {
                this.innerError = [] as any;
                for (let item of _data["innerError"])
                    this.innerError.push(InnerErrorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["propertyPath"] = this.propertyPath;
        data["errorCode"] = this.errorCode;
        data["error"] = this.error;
        data["errorMs"] = this.errorMs;
        if (Array.isArray(this.innerError)) {
            data["innerError"] = [];
            for (let item of this.innerError)
                data["innerError"].push(item.toJSON());
        }
        return data;
    }

    clone(): ValidationErrorDto {
        const json = this.toJSON();
        let result = new ValidationErrorDto();
        result.init(json);
        return result;
    }
}

export interface IValidationErrorDto {
    propertyName: string | undefined;
    propertyPath: string | undefined;
    errorCode: string | undefined;
    error: string | undefined;
    errorMs: string | undefined;
    innerError: InnerErrorDto[] | undefined;
}

export class ValidationResultsDto implements IValidationResultsDto {
    status: string | undefined;
    validationSteps: ValidationStepDto[] | undefined;

    constructor(data?: IValidationResultsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["validationSteps"])) {
                this.validationSteps = [] as any;
                for (let item of _data["validationSteps"])
                    this.validationSteps.push(ValidationStepDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidationResultsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationResultsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.validationSteps)) {
            data["validationSteps"] = [];
            for (let item of this.validationSteps)
                data["validationSteps"].push(item.toJSON());
        }
        return data;
    }

    clone(): ValidationResultsDto {
        const json = this.toJSON();
        let result = new ValidationResultsDto();
        result.init(json);
        return result;
    }
}

export interface IValidationResultsDto {
    status: string | undefined;
    validationSteps: ValidationStepDto[] | undefined;
}

export class ValidationStepDto implements IValidationStepDto {
    status: string | undefined;
    name: string | undefined;
    error: ValidationErrorDto;

    constructor(data?: IValidationStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.name = _data["name"];
            this.error = _data["error"] ? ValidationErrorDto.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ValidationStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["name"] = this.name;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }

    clone(): ValidationStepDto {
        const json = this.toJSON();
        let result = new ValidationStepDto();
        result.init(json);
        return result;
    }
}

export interface IValidationStepDto {
    status: string | undefined;
    name: string | undefined;
    error: ValidationErrorDto;
}

export class Vendor implements IVendor {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    code: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    postcode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    picName: string | undefined;
    picEmail: string | undefined;
    picContactNo: string | undefined;
    remarks: string | undefined;
    websiteLink: string | undefined;
    producerTenantId: number;
    lastEvaluationDate: moment.Moment | undefined;
    evaluationAttachment1: string | undefined;
    commercialEvaluation: number;
    technicalRatings: number;
    trustRatings: number;
    tncRatings: number;
    esgRatings: number;
    bankDetails: string | undefined;
    sstRegistrationNo: string | undefined;
    companyRegNo: string | undefined;
    currency: string | undefined;

    constructor(data?: IVendor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.postcode = _data["postcode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.picName = _data["picName"];
            this.picEmail = _data["picEmail"];
            this.picContactNo = _data["picContactNo"];
            this.remarks = _data["remarks"];
            this.websiteLink = _data["websiteLink"];
            this.producerTenantId = _data["producerTenantId"];
            this.lastEvaluationDate = _data["lastEvaluationDate"] ? moment(_data["lastEvaluationDate"].toString()) : <any>undefined;
            this.evaluationAttachment1 = _data["evaluationAttachment1"];
            this.commercialEvaluation = _data["commercialEvaluation"];
            this.technicalRatings = _data["technicalRatings"];
            this.trustRatings = _data["trustRatings"];
            this.tncRatings = _data["tncRatings"];
            this.esgRatings = _data["esgRatings"];
            this.bankDetails = _data["bankDetails"];
            this.sstRegistrationNo = _data["sstRegistrationNo"];
            this.companyRegNo = _data["companyRegNo"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): Vendor {
        data = typeof data === 'object' ? data : {};
        let result = new Vendor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["postcode"] = this.postcode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["picName"] = this.picName;
        data["picEmail"] = this.picEmail;
        data["picContactNo"] = this.picContactNo;
        data["remarks"] = this.remarks;
        data["websiteLink"] = this.websiteLink;
        data["producerTenantId"] = this.producerTenantId;
        data["lastEvaluationDate"] = this.lastEvaluationDate ? this.lastEvaluationDate.toISOString() : <any>undefined;
        data["evaluationAttachment1"] = this.evaluationAttachment1;
        data["commercialEvaluation"] = this.commercialEvaluation;
        data["technicalRatings"] = this.technicalRatings;
        data["trustRatings"] = this.trustRatings;
        data["tncRatings"] = this.tncRatings;
        data["esgRatings"] = this.esgRatings;
        data["bankDetails"] = this.bankDetails;
        data["sstRegistrationNo"] = this.sstRegistrationNo;
        data["companyRegNo"] = this.companyRegNo;
        data["currency"] = this.currency;
        return data;
    }

    clone(): Vendor {
        const json = this.toJSON();
        let result = new Vendor();
        result.init(json);
        return result;
    }
}

export interface IVendor {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    code: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    postcode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    picName: string | undefined;
    picEmail: string | undefined;
    picContactNo: string | undefined;
    remarks: string | undefined;
    websiteLink: string | undefined;
    producerTenantId: number;
    lastEvaluationDate: moment.Moment | undefined;
    evaluationAttachment1: string | undefined;
    commercialEvaluation: number;
    technicalRatings: number;
    trustRatings: number;
    tncRatings: number;
    esgRatings: number;
    bankDetails: string | undefined;
    sstRegistrationNo: string | undefined;
    companyRegNo: string | undefined;
    currency: string | undefined;
}

export class VendorDto implements IVendorDto {
    tenantId: number;
    name: string | undefined;
    code: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    postcode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    picName: string | undefined;
    picEmail: string | undefined;
    picContactNo: string | undefined;
    vendorId: number;
    remarks: string | undefined;
    websiteLink: string | undefined;
    purchaseRequisitionList: PurchaseRequisitionDto[] | undefined;
    previousPrList: PurchaseRequisitionDto[] | undefined;
    producerTenantId: number;
    cashbookList: Cashbooks[] | undefined;
    lastEvaluationDate: moment.Moment | undefined;
    evaluationAttachment1: string | undefined;
    commercialEvaluation: number;
    technicalRatings: number;
    trustRatings: number;
    tncRatings: number;
    esgRatings: number;
    bankDetails: string | undefined;
    sstRegistrationNo: string | undefined;
    companyRegNo: string | undefined;
    currency: string | undefined;

    constructor(data?: IVendorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.postcode = _data["postcode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.picName = _data["picName"];
            this.picEmail = _data["picEmail"];
            this.picContactNo = _data["picContactNo"];
            this.vendorId = _data["vendorId"];
            this.remarks = _data["remarks"];
            this.websiteLink = _data["websiteLink"];
            if (Array.isArray(_data["purchaseRequisitionList"])) {
                this.purchaseRequisitionList = [] as any;
                for (let item of _data["purchaseRequisitionList"])
                    this.purchaseRequisitionList.push(PurchaseRequisitionDto.fromJS(item));
            }
            if (Array.isArray(_data["previousPrList"])) {
                this.previousPrList = [] as any;
                for (let item of _data["previousPrList"])
                    this.previousPrList.push(PurchaseRequisitionDto.fromJS(item));
            }
            this.producerTenantId = _data["producerTenantId"];
            if (Array.isArray(_data["cashbookList"])) {
                this.cashbookList = [] as any;
                for (let item of _data["cashbookList"])
                    this.cashbookList.push(Cashbooks.fromJS(item));
            }
            this.lastEvaluationDate = _data["lastEvaluationDate"] ? moment(_data["lastEvaluationDate"].toString()) : <any>undefined;
            this.evaluationAttachment1 = _data["evaluationAttachment1"];
            this.commercialEvaluation = _data["commercialEvaluation"];
            this.technicalRatings = _data["technicalRatings"];
            this.trustRatings = _data["trustRatings"];
            this.tncRatings = _data["tncRatings"];
            this.esgRatings = _data["esgRatings"];
            this.bankDetails = _data["bankDetails"];
            this.sstRegistrationNo = _data["sstRegistrationNo"];
            this.companyRegNo = _data["companyRegNo"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): VendorDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["postcode"] = this.postcode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["picName"] = this.picName;
        data["picEmail"] = this.picEmail;
        data["picContactNo"] = this.picContactNo;
        data["vendorId"] = this.vendorId;
        data["remarks"] = this.remarks;
        data["websiteLink"] = this.websiteLink;
        if (Array.isArray(this.purchaseRequisitionList)) {
            data["purchaseRequisitionList"] = [];
            for (let item of this.purchaseRequisitionList)
                data["purchaseRequisitionList"].push(item.toJSON());
        }
        if (Array.isArray(this.previousPrList)) {
            data["previousPrList"] = [];
            for (let item of this.previousPrList)
                data["previousPrList"].push(item.toJSON());
        }
        data["producerTenantId"] = this.producerTenantId;
        if (Array.isArray(this.cashbookList)) {
            data["cashbookList"] = [];
            for (let item of this.cashbookList)
                data["cashbookList"].push(item.toJSON());
        }
        data["lastEvaluationDate"] = this.lastEvaluationDate ? this.lastEvaluationDate.toISOString() : <any>undefined;
        data["evaluationAttachment1"] = this.evaluationAttachment1;
        data["commercialEvaluation"] = this.commercialEvaluation;
        data["technicalRatings"] = this.technicalRatings;
        data["trustRatings"] = this.trustRatings;
        data["tncRatings"] = this.tncRatings;
        data["esgRatings"] = this.esgRatings;
        data["bankDetails"] = this.bankDetails;
        data["sstRegistrationNo"] = this.sstRegistrationNo;
        data["companyRegNo"] = this.companyRegNo;
        data["currency"] = this.currency;
        return data;
    }

    clone(): VendorDto {
        const json = this.toJSON();
        let result = new VendorDto();
        result.init(json);
        return result;
    }
}

export interface IVendorDto {
    tenantId: number;
    name: string | undefined;
    code: string | undefined;
    address: string | undefined;
    address2: string | undefined;
    postcode: string | undefined;
    city: string | undefined;
    state: string | undefined;
    country: string | undefined;
    picName: string | undefined;
    picEmail: string | undefined;
    picContactNo: string | undefined;
    vendorId: number;
    remarks: string | undefined;
    websiteLink: string | undefined;
    purchaseRequisitionList: PurchaseRequisitionDto[] | undefined;
    previousPrList: PurchaseRequisitionDto[] | undefined;
    producerTenantId: number;
    cashbookList: Cashbooks[] | undefined;
    lastEvaluationDate: moment.Moment | undefined;
    evaluationAttachment1: string | undefined;
    commercialEvaluation: number;
    technicalRatings: number;
    trustRatings: number;
    tncRatings: number;
    esgRatings: number;
    bankDetails: string | undefined;
    sstRegistrationNo: string | undefined;
    companyRegNo: string | undefined;
    currency: string | undefined;
}

export class VendorDtoPagedResultDto implements IVendorDtoPagedResultDto {
    items: VendorDto[] | undefined;
    totalCount: number;

    constructor(data?: IVendorDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(VendorDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): VendorDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): VendorDtoPagedResultDto {
        const json = this.toJSON();
        let result = new VendorDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IVendorDtoPagedResultDto {
    items: VendorDto[] | undefined;
    totalCount: number;
}

export class VendorInvoice implements IVendorInvoice {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    attachmentUrl: string | undefined;
    referenceNumbber: string | undefined;
    issueDate: moment.Moment;
    dueDate: moment.Moment;
    purchaseAmount: number;
    deliveryCost: number;
    installationCost: number;
    taxAmount: number;
    totalAmount: number;
    status: number;
    remarks: string | undefined;
    deliveryDate: moment.Moment;
    isPurchaseWithoutPo: boolean;
    isMigrated: boolean;
    purchaseRequisitionId: number;
    purchaseOrderId: number | undefined;
    paymentBankName: string | undefined;
    paymentBankAccountNo: string | undefined;
    paymentBankAccountHolder: string | undefined;
    deliveryCode: string | undefined;
    deliveryName: string | undefined;
    installationCode: string | undefined;
    installationName: string | undefined;
    currency: string | undefined;
    exchangeRate: number;
    purchaseOrder: PurchaseOrders;
    paymentDate: moment.Moment | undefined;
    postMigration: boolean;
    posDocId: string | undefined;

    constructor(data?: IVendorInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.attachmentUrl = _data["attachmentUrl"];
            this.referenceNumbber = _data["referenceNumbber"];
            this.issueDate = _data["issueDate"] ? moment(_data["issueDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.purchaseAmount = _data["purchaseAmount"];
            this.deliveryCost = _data["deliveryCost"];
            this.installationCost = _data["installationCost"];
            this.taxAmount = _data["taxAmount"];
            this.totalAmount = _data["totalAmount"];
            this.status = _data["status"];
            this.remarks = _data["remarks"];
            this.deliveryDate = _data["deliveryDate"] ? moment(_data["deliveryDate"].toString()) : <any>undefined;
            this.isPurchaseWithoutPo = _data["isPurchaseWithoutPo"];
            this.isMigrated = _data["isMigrated"];
            this.purchaseRequisitionId = _data["purchaseRequisitionId"];
            this.purchaseOrderId = _data["purchaseOrderId"];
            this.paymentBankName = _data["paymentBankName"];
            this.paymentBankAccountNo = _data["paymentBankAccountNo"];
            this.paymentBankAccountHolder = _data["paymentBankAccountHolder"];
            this.deliveryCode = _data["deliveryCode"];
            this.deliveryName = _data["deliveryName"];
            this.installationCode = _data["installationCode"];
            this.installationName = _data["installationName"];
            this.currency = _data["currency"];
            this.exchangeRate = _data["exchangeRate"];
            this.purchaseOrder = _data["purchaseOrder"] ? PurchaseOrders.fromJS(_data["purchaseOrder"]) : <any>undefined;
            this.paymentDate = _data["paymentDate"] ? moment(_data["paymentDate"].toString()) : <any>undefined;
            this.postMigration = _data["postMigration"];
            this.posDocId = _data["posDocId"];
        }
    }

    static fromJS(data: any): VendorInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new VendorInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["attachmentUrl"] = this.attachmentUrl;
        data["referenceNumbber"] = this.referenceNumbber;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["purchaseAmount"] = this.purchaseAmount;
        data["deliveryCost"] = this.deliveryCost;
        data["installationCost"] = this.installationCost;
        data["taxAmount"] = this.taxAmount;
        data["totalAmount"] = this.totalAmount;
        data["status"] = this.status;
        data["remarks"] = this.remarks;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["isPurchaseWithoutPo"] = this.isPurchaseWithoutPo;
        data["isMigrated"] = this.isMigrated;
        data["purchaseRequisitionId"] = this.purchaseRequisitionId;
        data["purchaseOrderId"] = this.purchaseOrderId;
        data["paymentBankName"] = this.paymentBankName;
        data["paymentBankAccountNo"] = this.paymentBankAccountNo;
        data["paymentBankAccountHolder"] = this.paymentBankAccountHolder;
        data["deliveryCode"] = this.deliveryCode;
        data["deliveryName"] = this.deliveryName;
        data["installationCode"] = this.installationCode;
        data["installationName"] = this.installationName;
        data["currency"] = this.currency;
        data["exchangeRate"] = this.exchangeRate;
        data["purchaseOrder"] = this.purchaseOrder ? this.purchaseOrder.toJSON() : <any>undefined;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["postMigration"] = this.postMigration;
        data["posDocId"] = this.posDocId;
        return data;
    }

    clone(): VendorInvoice {
        const json = this.toJSON();
        let result = new VendorInvoice();
        result.init(json);
        return result;
    }
}

export interface IVendorInvoice {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    attachmentUrl: string | undefined;
    referenceNumbber: string | undefined;
    issueDate: moment.Moment;
    dueDate: moment.Moment;
    purchaseAmount: number;
    deliveryCost: number;
    installationCost: number;
    taxAmount: number;
    totalAmount: number;
    status: number;
    remarks: string | undefined;
    deliveryDate: moment.Moment;
    isPurchaseWithoutPo: boolean;
    isMigrated: boolean;
    purchaseRequisitionId: number;
    purchaseOrderId: number | undefined;
    paymentBankName: string | undefined;
    paymentBankAccountNo: string | undefined;
    paymentBankAccountHolder: string | undefined;
    deliveryCode: string | undefined;
    deliveryName: string | undefined;
    installationCode: string | undefined;
    installationName: string | undefined;
    currency: string | undefined;
    exchangeRate: number;
    purchaseOrder: PurchaseOrders;
    paymentDate: moment.Moment | undefined;
    postMigration: boolean;
    posDocId: string | undefined;
}

export class VendorInvoiceDto implements IVendorInvoiceDto {
    vendorInvoiceId: number;
    tenantId: number;
    attachmentUrl: string | undefined;
    referenceNumbber: string | undefined;
    issueDate: moment.Moment;
    dueDate: moment.Moment;
    purchaseAmount: number;
    deliveryCost: number;
    installationCost: number;
    taxAmount: number;
    totalAmount: number;
    status: number;
    deliveryDate: moment.Moment;
    remarks: string | undefined;
    isPurchaseWithoutPo: boolean;
    isMigrated: boolean;
    goodsReceivedNotes: GoodsReceivedNotes;
    purchaseRequisitionId: number;
    paymentBankName: string | undefined;
    paymentBankAccountNo: string | undefined;
    paymentBankAccountHolder: string | undefined;
    deliveryCode: string | undefined;
    deliveryName: string | undefined;
    installationCode: string | undefined;
    installationName: string | undefined;
    currency: string | undefined;
    exchangeRate: number;
    vendorId: number;
    purchaseRequisition: PurchaseRequisition;
    purchaseOrderId: number | undefined;
    purchaseOrder: PurchaseOrders;
    paymentDate: moment.Moment | undefined;
    vendorInvoiceItemDto: VendorInvoiceItemDto[] | undefined;
    postMigration: boolean;
    posDocId: string | undefined;

    constructor(data?: IVendorInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendorInvoiceId = _data["vendorInvoiceId"];
            this.tenantId = _data["tenantId"];
            this.attachmentUrl = _data["attachmentUrl"];
            this.referenceNumbber = _data["referenceNumbber"];
            this.issueDate = _data["issueDate"] ? moment(_data["issueDate"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.purchaseAmount = _data["purchaseAmount"];
            this.deliveryCost = _data["deliveryCost"];
            this.installationCost = _data["installationCost"];
            this.taxAmount = _data["taxAmount"];
            this.totalAmount = _data["totalAmount"];
            this.status = _data["status"];
            this.deliveryDate = _data["deliveryDate"] ? moment(_data["deliveryDate"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.isPurchaseWithoutPo = _data["isPurchaseWithoutPo"];
            this.isMigrated = _data["isMigrated"];
            this.goodsReceivedNotes = _data["goodsReceivedNotes"] ? GoodsReceivedNotes.fromJS(_data["goodsReceivedNotes"]) : <any>undefined;
            this.purchaseRequisitionId = _data["purchaseRequisitionId"];
            this.paymentBankName = _data["paymentBankName"];
            this.paymentBankAccountNo = _data["paymentBankAccountNo"];
            this.paymentBankAccountHolder = _data["paymentBankAccountHolder"];
            this.deliveryCode = _data["deliveryCode"];
            this.deliveryName = _data["deliveryName"];
            this.installationCode = _data["installationCode"];
            this.installationName = _data["installationName"];
            this.currency = _data["currency"];
            this.exchangeRate = _data["exchangeRate"];
            this.vendorId = _data["vendorId"];
            this.purchaseRequisition = _data["purchaseRequisition"] ? PurchaseRequisition.fromJS(_data["purchaseRequisition"]) : <any>undefined;
            this.purchaseOrderId = _data["purchaseOrderId"];
            this.purchaseOrder = _data["purchaseOrder"] ? PurchaseOrders.fromJS(_data["purchaseOrder"]) : <any>undefined;
            this.paymentDate = _data["paymentDate"] ? moment(_data["paymentDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["vendorInvoiceItemDto"])) {
                this.vendorInvoiceItemDto = [] as any;
                for (let item of _data["vendorInvoiceItemDto"])
                    this.vendorInvoiceItemDto.push(VendorInvoiceItemDto.fromJS(item));
            }
            this.postMigration = _data["postMigration"];
            this.posDocId = _data["posDocId"];
        }
    }

    static fromJS(data: any): VendorInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendorInvoiceId"] = this.vendorInvoiceId;
        data["tenantId"] = this.tenantId;
        data["attachmentUrl"] = this.attachmentUrl;
        data["referenceNumbber"] = this.referenceNumbber;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["purchaseAmount"] = this.purchaseAmount;
        data["deliveryCost"] = this.deliveryCost;
        data["installationCost"] = this.installationCost;
        data["taxAmount"] = this.taxAmount;
        data["totalAmount"] = this.totalAmount;
        data["status"] = this.status;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["isPurchaseWithoutPo"] = this.isPurchaseWithoutPo;
        data["isMigrated"] = this.isMigrated;
        data["goodsReceivedNotes"] = this.goodsReceivedNotes ? this.goodsReceivedNotes.toJSON() : <any>undefined;
        data["purchaseRequisitionId"] = this.purchaseRequisitionId;
        data["paymentBankName"] = this.paymentBankName;
        data["paymentBankAccountNo"] = this.paymentBankAccountNo;
        data["paymentBankAccountHolder"] = this.paymentBankAccountHolder;
        data["deliveryCode"] = this.deliveryCode;
        data["deliveryName"] = this.deliveryName;
        data["installationCode"] = this.installationCode;
        data["installationName"] = this.installationName;
        data["currency"] = this.currency;
        data["exchangeRate"] = this.exchangeRate;
        data["vendorId"] = this.vendorId;
        data["purchaseRequisition"] = this.purchaseRequisition ? this.purchaseRequisition.toJSON() : <any>undefined;
        data["purchaseOrderId"] = this.purchaseOrderId;
        data["purchaseOrder"] = this.purchaseOrder ? this.purchaseOrder.toJSON() : <any>undefined;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        if (Array.isArray(this.vendorInvoiceItemDto)) {
            data["vendorInvoiceItemDto"] = [];
            for (let item of this.vendorInvoiceItemDto)
                data["vendorInvoiceItemDto"].push(item.toJSON());
        }
        data["postMigration"] = this.postMigration;
        data["posDocId"] = this.posDocId;
        return data;
    }

    clone(): VendorInvoiceDto {
        const json = this.toJSON();
        let result = new VendorInvoiceDto();
        result.init(json);
        return result;
    }
}

export interface IVendorInvoiceDto {
    vendorInvoiceId: number;
    tenantId: number;
    attachmentUrl: string | undefined;
    referenceNumbber: string | undefined;
    issueDate: moment.Moment;
    dueDate: moment.Moment;
    purchaseAmount: number;
    deliveryCost: number;
    installationCost: number;
    taxAmount: number;
    totalAmount: number;
    status: number;
    deliveryDate: moment.Moment;
    remarks: string | undefined;
    isPurchaseWithoutPo: boolean;
    isMigrated: boolean;
    goodsReceivedNotes: GoodsReceivedNotes;
    purchaseRequisitionId: number;
    paymentBankName: string | undefined;
    paymentBankAccountNo: string | undefined;
    paymentBankAccountHolder: string | undefined;
    deliveryCode: string | undefined;
    deliveryName: string | undefined;
    installationCode: string | undefined;
    installationName: string | undefined;
    currency: string | undefined;
    exchangeRate: number;
    vendorId: number;
    purchaseRequisition: PurchaseRequisition;
    purchaseOrderId: number | undefined;
    purchaseOrder: PurchaseOrders;
    paymentDate: moment.Moment | undefined;
    vendorInvoiceItemDto: VendorInvoiceItemDto[] | undefined;
    postMigration: boolean;
    posDocId: string | undefined;
}

export class VendorInvoiceDtoPagedResultDto implements IVendorInvoiceDtoPagedResultDto {
    items: VendorInvoiceDto[] | undefined;
    totalCount: number;

    constructor(data?: IVendorInvoiceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(VendorInvoiceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): VendorInvoiceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorInvoiceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): VendorInvoiceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new VendorInvoiceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IVendorInvoiceDtoPagedResultDto {
    items: VendorInvoiceDto[] | undefined;
    totalCount: number;
}

export class VendorInvoiceItem implements IVendorInvoiceItem {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    purchaseOrderItemId: number;
    purchaseOrderItem: PurchaseOrderItem;
    originalGuid: string | undefined;
    originalCode: string | undefined;
    name: string | undefined;
    description: string | undefined;
    quantity: number;
    receivedQuantity: number;
    rejectedQuantity: number;
    acceptedQuantity: number;
    unitPrice: number;
    taxRate: number;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    taxCode: string | undefined;
    chargeTo: string | undefined;
    quality: string | undefined;
    discount: number;
    unitOfMeasurement: string | undefined;
    creditNoteQuantity: number;
    supplementaryGrnQuantity: number;
    shelfName: string | undefined;
    vendorInvoiceId: number | undefined;
    projectId: number;
    averagePriceFromPo: number;
    projectInvoiceId: string | undefined;
    projectInvoice: Bill;
    assetItemMaintenanceId: string | undefined;
    assetItemMaintenance: NonCurrentAssetMaintenance;
    deliveryCost: number;
    deliveryCode: string | undefined;
    deliveryName: string | undefined;
    installationCost: number;
    installationCode: string | undefined;
    installationName: string | undefined;
    vendorInvoice: VendorInvoice;
    isTaxNotRecoverable: boolean;
    goodsReceivedNoteId: number | undefined;
    goodsReceivedNote: GoodsReceivedNotes;

    constructor(data?: IVendorInvoiceItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.purchaseOrderItemId = _data["purchaseOrderItemId"];
            this.purchaseOrderItem = _data["purchaseOrderItem"] ? PurchaseOrderItem.fromJS(_data["purchaseOrderItem"]) : <any>undefined;
            this.originalGuid = _data["originalGuid"];
            this.originalCode = _data["originalCode"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.receivedQuantity = _data["receivedQuantity"];
            this.rejectedQuantity = _data["rejectedQuantity"];
            this.acceptedQuantity = _data["acceptedQuantity"];
            this.unitPrice = _data["unitPrice"];
            this.taxRate = _data["taxRate"];
            this.categoryCode = _data["categoryCode"];
            this.categoryName = _data["categoryName"];
            this.taxCode = _data["taxCode"];
            this.chargeTo = _data["chargeTo"];
            this.quality = _data["quality"];
            this.discount = _data["discount"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.creditNoteQuantity = _data["creditNoteQuantity"];
            this.supplementaryGrnQuantity = _data["supplementaryGrnQuantity"];
            this.shelfName = _data["shelfName"];
            this.vendorInvoiceId = _data["vendorInvoiceId"];
            this.projectId = _data["projectId"];
            this.averagePriceFromPo = _data["averagePriceFromPo"];
            this.projectInvoiceId = _data["projectInvoiceId"];
            this.projectInvoice = _data["projectInvoice"] ? Bill.fromJS(_data["projectInvoice"]) : <any>undefined;
            this.assetItemMaintenanceId = _data["assetItemMaintenanceId"];
            this.assetItemMaintenance = _data["assetItemMaintenance"] ? NonCurrentAssetMaintenance.fromJS(_data["assetItemMaintenance"]) : <any>undefined;
            this.deliveryCost = _data["deliveryCost"];
            this.deliveryCode = _data["deliveryCode"];
            this.deliveryName = _data["deliveryName"];
            this.installationCost = _data["installationCost"];
            this.installationCode = _data["installationCode"];
            this.installationName = _data["installationName"];
            this.vendorInvoice = _data["vendorInvoice"] ? VendorInvoice.fromJS(_data["vendorInvoice"]) : <any>undefined;
            this.isTaxNotRecoverable = _data["isTaxNotRecoverable"];
            this.goodsReceivedNoteId = _data["goodsReceivedNoteId"];
            this.goodsReceivedNote = _data["goodsReceivedNote"] ? GoodsReceivedNotes.fromJS(_data["goodsReceivedNote"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VendorInvoiceItem {
        data = typeof data === 'object' ? data : {};
        let result = new VendorInvoiceItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["purchaseOrderItemId"] = this.purchaseOrderItemId;
        data["purchaseOrderItem"] = this.purchaseOrderItem ? this.purchaseOrderItem.toJSON() : <any>undefined;
        data["originalGuid"] = this.originalGuid;
        data["originalCode"] = this.originalCode;
        data["name"] = this.name;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["receivedQuantity"] = this.receivedQuantity;
        data["rejectedQuantity"] = this.rejectedQuantity;
        data["acceptedQuantity"] = this.acceptedQuantity;
        data["unitPrice"] = this.unitPrice;
        data["taxRate"] = this.taxRate;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["taxCode"] = this.taxCode;
        data["chargeTo"] = this.chargeTo;
        data["quality"] = this.quality;
        data["discount"] = this.discount;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["creditNoteQuantity"] = this.creditNoteQuantity;
        data["supplementaryGrnQuantity"] = this.supplementaryGrnQuantity;
        data["shelfName"] = this.shelfName;
        data["vendorInvoiceId"] = this.vendorInvoiceId;
        data["projectId"] = this.projectId;
        data["averagePriceFromPo"] = this.averagePriceFromPo;
        data["projectInvoiceId"] = this.projectInvoiceId;
        data["projectInvoice"] = this.projectInvoice ? this.projectInvoice.toJSON() : <any>undefined;
        data["assetItemMaintenanceId"] = this.assetItemMaintenanceId;
        data["assetItemMaintenance"] = this.assetItemMaintenance ? this.assetItemMaintenance.toJSON() : <any>undefined;
        data["deliveryCost"] = this.deliveryCost;
        data["deliveryCode"] = this.deliveryCode;
        data["deliveryName"] = this.deliveryName;
        data["installationCost"] = this.installationCost;
        data["installationCode"] = this.installationCode;
        data["installationName"] = this.installationName;
        data["vendorInvoice"] = this.vendorInvoice ? this.vendorInvoice.toJSON() : <any>undefined;
        data["isTaxNotRecoverable"] = this.isTaxNotRecoverable;
        data["goodsReceivedNoteId"] = this.goodsReceivedNoteId;
        data["goodsReceivedNote"] = this.goodsReceivedNote ? this.goodsReceivedNote.toJSON() : <any>undefined;
        return data;
    }

    clone(): VendorInvoiceItem {
        const json = this.toJSON();
        let result = new VendorInvoiceItem();
        result.init(json);
        return result;
    }
}

export interface IVendorInvoiceItem {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    purchaseOrderItemId: number;
    purchaseOrderItem: PurchaseOrderItem;
    originalGuid: string | undefined;
    originalCode: string | undefined;
    name: string | undefined;
    description: string | undefined;
    quantity: number;
    receivedQuantity: number;
    rejectedQuantity: number;
    acceptedQuantity: number;
    unitPrice: number;
    taxRate: number;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    taxCode: string | undefined;
    chargeTo: string | undefined;
    quality: string | undefined;
    discount: number;
    unitOfMeasurement: string | undefined;
    creditNoteQuantity: number;
    supplementaryGrnQuantity: number;
    shelfName: string | undefined;
    vendorInvoiceId: number | undefined;
    projectId: number;
    averagePriceFromPo: number;
    projectInvoiceId: string | undefined;
    projectInvoice: Bill;
    assetItemMaintenanceId: string | undefined;
    assetItemMaintenance: NonCurrentAssetMaintenance;
    deliveryCost: number;
    deliveryCode: string | undefined;
    deliveryName: string | undefined;
    installationCost: number;
    installationCode: string | undefined;
    installationName: string | undefined;
    vendorInvoice: VendorInvoice;
    isTaxNotRecoverable: boolean;
    goodsReceivedNoteId: number | undefined;
    goodsReceivedNote: GoodsReceivedNotes;
}

export class VendorInvoiceItemDto implements IVendorInvoiceItemDto {
    tenantId: number;
    vendorInvoiceItemId: number;
    purchaseOrderItemId: number;
    purchaseOrderItem: PurchaseOrderItem;
    originalGuid: string | undefined;
    originalCode: string | undefined;
    name: string | undefined;
    description: string | undefined;
    quantity: number;
    receivedQuantity: number;
    rejectedQuantity: number;
    acceptedQuantity: number;
    unitPrice: number;
    taxRate: number;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    taxCode: string | undefined;
    chargeTo: string | undefined;
    quality: string | undefined;
    discount: number;
    unitOfMeasurement: string | undefined;
    creditNoteQuantity: number;
    supplementaryGrnQuantity: number;
    shelfName: string | undefined;
    vendorInvoiceId: number | undefined;
    projectId: number;
    averagePriceFromPo: number;
    projectInvoiceId: string | undefined;
    projectInvoice: Bill;
    assetItemMaintenanceId: string | undefined;
    assetItemMaintenance: NonCurrentAssetMaintenance;
    deliveryCost: number;
    deliveryCode: string | undefined;
    deliveryName: string | undefined;
    installationCost: number;
    installationCode: string | undefined;
    installationName: string | undefined;
    vendorInvoice: VendorInvoice;
    isTaxNotRecoverable: boolean;
    goodsReceivedNoteId: number | undefined;
    goodsReceivedNote: GoodsReceivedNotes;

    constructor(data?: IVendorInvoiceItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.vendorInvoiceItemId = _data["vendorInvoiceItemId"];
            this.purchaseOrderItemId = _data["purchaseOrderItemId"];
            this.purchaseOrderItem = _data["purchaseOrderItem"] ? PurchaseOrderItem.fromJS(_data["purchaseOrderItem"]) : <any>undefined;
            this.originalGuid = _data["originalGuid"];
            this.originalCode = _data["originalCode"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.receivedQuantity = _data["receivedQuantity"];
            this.rejectedQuantity = _data["rejectedQuantity"];
            this.acceptedQuantity = _data["acceptedQuantity"];
            this.unitPrice = _data["unitPrice"];
            this.taxRate = _data["taxRate"];
            this.categoryCode = _data["categoryCode"];
            this.categoryName = _data["categoryName"];
            this.taxCode = _data["taxCode"];
            this.chargeTo = _data["chargeTo"];
            this.quality = _data["quality"];
            this.discount = _data["discount"];
            this.unitOfMeasurement = _data["unitOfMeasurement"];
            this.creditNoteQuantity = _data["creditNoteQuantity"];
            this.supplementaryGrnQuantity = _data["supplementaryGrnQuantity"];
            this.shelfName = _data["shelfName"];
            this.vendorInvoiceId = _data["vendorInvoiceId"];
            this.projectId = _data["projectId"];
            this.averagePriceFromPo = _data["averagePriceFromPo"];
            this.projectInvoiceId = _data["projectInvoiceId"];
            this.projectInvoice = _data["projectInvoice"] ? Bill.fromJS(_data["projectInvoice"]) : <any>undefined;
            this.assetItemMaintenanceId = _data["assetItemMaintenanceId"];
            this.assetItemMaintenance = _data["assetItemMaintenance"] ? NonCurrentAssetMaintenance.fromJS(_data["assetItemMaintenance"]) : <any>undefined;
            this.deliveryCost = _data["deliveryCost"];
            this.deliveryCode = _data["deliveryCode"];
            this.deliveryName = _data["deliveryName"];
            this.installationCost = _data["installationCost"];
            this.installationCode = _data["installationCode"];
            this.installationName = _data["installationName"];
            this.vendorInvoice = _data["vendorInvoice"] ? VendorInvoice.fromJS(_data["vendorInvoice"]) : <any>undefined;
            this.isTaxNotRecoverable = _data["isTaxNotRecoverable"];
            this.goodsReceivedNoteId = _data["goodsReceivedNoteId"];
            this.goodsReceivedNote = _data["goodsReceivedNote"] ? GoodsReceivedNotes.fromJS(_data["goodsReceivedNote"]) : <any>undefined;
        }
    }

    static fromJS(data: any): VendorInvoiceItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorInvoiceItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["vendorInvoiceItemId"] = this.vendorInvoiceItemId;
        data["purchaseOrderItemId"] = this.purchaseOrderItemId;
        data["purchaseOrderItem"] = this.purchaseOrderItem ? this.purchaseOrderItem.toJSON() : <any>undefined;
        data["originalGuid"] = this.originalGuid;
        data["originalCode"] = this.originalCode;
        data["name"] = this.name;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["receivedQuantity"] = this.receivedQuantity;
        data["rejectedQuantity"] = this.rejectedQuantity;
        data["acceptedQuantity"] = this.acceptedQuantity;
        data["unitPrice"] = this.unitPrice;
        data["taxRate"] = this.taxRate;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["taxCode"] = this.taxCode;
        data["chargeTo"] = this.chargeTo;
        data["quality"] = this.quality;
        data["discount"] = this.discount;
        data["unitOfMeasurement"] = this.unitOfMeasurement;
        data["creditNoteQuantity"] = this.creditNoteQuantity;
        data["supplementaryGrnQuantity"] = this.supplementaryGrnQuantity;
        data["shelfName"] = this.shelfName;
        data["vendorInvoiceId"] = this.vendorInvoiceId;
        data["projectId"] = this.projectId;
        data["averagePriceFromPo"] = this.averagePriceFromPo;
        data["projectInvoiceId"] = this.projectInvoiceId;
        data["projectInvoice"] = this.projectInvoice ? this.projectInvoice.toJSON() : <any>undefined;
        data["assetItemMaintenanceId"] = this.assetItemMaintenanceId;
        data["assetItemMaintenance"] = this.assetItemMaintenance ? this.assetItemMaintenance.toJSON() : <any>undefined;
        data["deliveryCost"] = this.deliveryCost;
        data["deliveryCode"] = this.deliveryCode;
        data["deliveryName"] = this.deliveryName;
        data["installationCost"] = this.installationCost;
        data["installationCode"] = this.installationCode;
        data["installationName"] = this.installationName;
        data["vendorInvoice"] = this.vendorInvoice ? this.vendorInvoice.toJSON() : <any>undefined;
        data["isTaxNotRecoverable"] = this.isTaxNotRecoverable;
        data["goodsReceivedNoteId"] = this.goodsReceivedNoteId;
        data["goodsReceivedNote"] = this.goodsReceivedNote ? this.goodsReceivedNote.toJSON() : <any>undefined;
        return data;
    }

    clone(): VendorInvoiceItemDto {
        const json = this.toJSON();
        let result = new VendorInvoiceItemDto();
        result.init(json);
        return result;
    }
}

export interface IVendorInvoiceItemDto {
    tenantId: number;
    vendorInvoiceItemId: number;
    purchaseOrderItemId: number;
    purchaseOrderItem: PurchaseOrderItem;
    originalGuid: string | undefined;
    originalCode: string | undefined;
    name: string | undefined;
    description: string | undefined;
    quantity: number;
    receivedQuantity: number;
    rejectedQuantity: number;
    acceptedQuantity: number;
    unitPrice: number;
    taxRate: number;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    taxCode: string | undefined;
    chargeTo: string | undefined;
    quality: string | undefined;
    discount: number;
    unitOfMeasurement: string | undefined;
    creditNoteQuantity: number;
    supplementaryGrnQuantity: number;
    shelfName: string | undefined;
    vendorInvoiceId: number | undefined;
    projectId: number;
    averagePriceFromPo: number;
    projectInvoiceId: string | undefined;
    projectInvoice: Bill;
    assetItemMaintenanceId: string | undefined;
    assetItemMaintenance: NonCurrentAssetMaintenance;
    deliveryCost: number;
    deliveryCode: string | undefined;
    deliveryName: string | undefined;
    installationCost: number;
    installationCode: string | undefined;
    installationName: string | undefined;
    vendorInvoice: VendorInvoice;
    isTaxNotRecoverable: boolean;
    goodsReceivedNoteId: number | undefined;
    goodsReceivedNote: GoodsReceivedNotes;
}

export class VendorInvoiceItemPagedResultDto implements IVendorInvoiceItemPagedResultDto {
    items: VendorInvoiceItem[] | undefined;
    totalCount: number;

    constructor(data?: IVendorInvoiceItemPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(VendorInvoiceItem.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): VendorInvoiceItemPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorInvoiceItemPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): VendorInvoiceItemPagedResultDto {
        const json = this.toJSON();
        let result = new VendorInvoiceItemPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IVendorInvoiceItemPagedResultDto {
    items: VendorInvoiceItem[] | undefined;
    totalCount: number;
}

export class VendorInvoiceMigrationDto implements IVendorInvoiceMigrationDto {
    invoiceDate: moment.Moment;
    paymentDueDate: moment.Moment;
    deliveryDate: moment.Moment;
    invoiceNo: string | undefined;
    description: string | undefined;
    invoiceAmount: number;
    taxAmount: number;
    deliveryCharge: number;
    chargeTo: string | undefined;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    isPaid: boolean;
    vendorName: string | undefined;
    vendorCode: string | undefined;
    vendorPicName: string | undefined;
    vendorPicEmail: string | undefined;
    vendorPicContactNo: string | undefined;
    vendorAddress: string | undefined;
    vendorAddress2: string | undefined;
    vendorPostcode: string | undefined;
    vendorCity: string | undefined;
    vendorState: string | undefined;
    vendorCountry: string | undefined;
    vendorWebsite: string | undefined;
    isValid: boolean;
    error: string | undefined;
    vendorId: number | undefined;
    vendor: Vendor;
    postMigration: boolean;

    constructor(data?: IVendorInvoiceMigrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceDate = _data["invoiceDate"] ? moment(_data["invoiceDate"].toString()) : <any>undefined;
            this.paymentDueDate = _data["paymentDueDate"] ? moment(_data["paymentDueDate"].toString()) : <any>undefined;
            this.deliveryDate = _data["deliveryDate"] ? moment(_data["deliveryDate"].toString()) : <any>undefined;
            this.invoiceNo = _data["invoiceNo"];
            this.description = _data["description"];
            this.invoiceAmount = _data["invoiceAmount"];
            this.taxAmount = _data["taxAmount"];
            this.deliveryCharge = _data["deliveryCharge"];
            this.chargeTo = _data["chargeTo"];
            this.categoryCode = _data["categoryCode"];
            this.categoryName = _data["categoryName"];
            this.isPaid = _data["isPaid"];
            this.vendorName = _data["vendorName"];
            this.vendorCode = _data["vendorCode"];
            this.vendorPicName = _data["vendorPicName"];
            this.vendorPicEmail = _data["vendorPicEmail"];
            this.vendorPicContactNo = _data["vendorPicContactNo"];
            this.vendorAddress = _data["vendorAddress"];
            this.vendorAddress2 = _data["vendorAddress2"];
            this.vendorPostcode = _data["vendorPostcode"];
            this.vendorCity = _data["vendorCity"];
            this.vendorState = _data["vendorState"];
            this.vendorCountry = _data["vendorCountry"];
            this.vendorWebsite = _data["vendorWebsite"];
            this.isValid = _data["isValid"];
            this.error = _data["error"];
            this.vendorId = _data["vendorId"];
            this.vendor = _data["vendor"] ? Vendor.fromJS(_data["vendor"]) : <any>undefined;
            this.postMigration = _data["postMigration"];
        }
    }

    static fromJS(data: any): VendorInvoiceMigrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorInvoiceMigrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data["paymentDueDate"] = this.paymentDueDate ? this.paymentDueDate.toISOString() : <any>undefined;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : <any>undefined;
        data["invoiceNo"] = this.invoiceNo;
        data["description"] = this.description;
        data["invoiceAmount"] = this.invoiceAmount;
        data["taxAmount"] = this.taxAmount;
        data["deliveryCharge"] = this.deliveryCharge;
        data["chargeTo"] = this.chargeTo;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["isPaid"] = this.isPaid;
        data["vendorName"] = this.vendorName;
        data["vendorCode"] = this.vendorCode;
        data["vendorPicName"] = this.vendorPicName;
        data["vendorPicEmail"] = this.vendorPicEmail;
        data["vendorPicContactNo"] = this.vendorPicContactNo;
        data["vendorAddress"] = this.vendorAddress;
        data["vendorAddress2"] = this.vendorAddress2;
        data["vendorPostcode"] = this.vendorPostcode;
        data["vendorCity"] = this.vendorCity;
        data["vendorState"] = this.vendorState;
        data["vendorCountry"] = this.vendorCountry;
        data["vendorWebsite"] = this.vendorWebsite;
        data["isValid"] = this.isValid;
        data["error"] = this.error;
        data["vendorId"] = this.vendorId;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        data["postMigration"] = this.postMigration;
        return data;
    }

    clone(): VendorInvoiceMigrationDto {
        const json = this.toJSON();
        let result = new VendorInvoiceMigrationDto();
        result.init(json);
        return result;
    }
}

export interface IVendorInvoiceMigrationDto {
    invoiceDate: moment.Moment;
    paymentDueDate: moment.Moment;
    deliveryDate: moment.Moment;
    invoiceNo: string | undefined;
    description: string | undefined;
    invoiceAmount: number;
    taxAmount: number;
    deliveryCharge: number;
    chargeTo: string | undefined;
    categoryCode: string | undefined;
    categoryName: string | undefined;
    isPaid: boolean;
    vendorName: string | undefined;
    vendorCode: string | undefined;
    vendorPicName: string | undefined;
    vendorPicEmail: string | undefined;
    vendorPicContactNo: string | undefined;
    vendorAddress: string | undefined;
    vendorAddress2: string | undefined;
    vendorPostcode: string | undefined;
    vendorCity: string | undefined;
    vendorState: string | undefined;
    vendorCountry: string | undefined;
    vendorWebsite: string | undefined;
    isValid: boolean;
    error: string | undefined;
    vendorId: number | undefined;
    vendor: Vendor;
    postMigration: boolean;
}

export class VendorPagedResultDto implements IVendorPagedResultDto {
    items: Vendor[] | undefined;
    totalCount: number;

    constructor(data?: IVendorPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(Vendor.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): VendorPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): VendorPagedResultDto {
        const json = this.toJSON();
        let result = new VendorPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IVendorPagedResultDto {
    items: Vendor[] | undefined;
    totalCount: number;
}

export class WishlistDto implements IWishlistDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    userId: number;
    tenantId: number;
    productId: string;
    product: Product;
    productDto: ProductDto;
    name: string | undefined;
    quantity: number;
    unitPrice: number;
    discount: number;
    tax: number;
    taxCode: string | undefined;
    readonly purchaseAmount: number;
    readonly taxAmount: number;
    readonly totalAmount: number;
    readonly discountedPurchaseAmount: number;
    readonly discountedTaxAmount: number;
    readonly discountedTotalAmount: number;
    docId: string | undefined;

    constructor(data?: IWishlistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.productId = _data["productId"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.productDto = _data["productDto"] ? ProductDto.fromJS(_data["productDto"]) : <any>undefined;
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.discount = _data["discount"];
            this.tax = _data["tax"];
            this.taxCode = _data["taxCode"];
            (<any>this).purchaseAmount = _data["purchaseAmount"];
            (<any>this).taxAmount = _data["taxAmount"];
            (<any>this).totalAmount = _data["totalAmount"];
            (<any>this).discountedPurchaseAmount = _data["discountedPurchaseAmount"];
            (<any>this).discountedTaxAmount = _data["discountedTaxAmount"];
            (<any>this).discountedTotalAmount = _data["discountedTotalAmount"];
            this.docId = _data["docId"];
        }
    }

    static fromJS(data: any): WishlistDto {
        data = typeof data === 'object' ? data : {};
        let result = new WishlistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["productId"] = this.productId;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productDto"] = this.productDto ? this.productDto.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["discount"] = this.discount;
        data["tax"] = this.tax;
        data["taxCode"] = this.taxCode;
        data["purchaseAmount"] = this.purchaseAmount;
        data["taxAmount"] = this.taxAmount;
        data["totalAmount"] = this.totalAmount;
        data["discountedPurchaseAmount"] = this.discountedPurchaseAmount;
        data["discountedTaxAmount"] = this.discountedTaxAmount;
        data["discountedTotalAmount"] = this.discountedTotalAmount;
        data["docId"] = this.docId;
        return data;
    }

    clone(): WishlistDto {
        const json = this.toJSON();
        let result = new WishlistDto();
        result.init(json);
        return result;
    }
}

export interface IWishlistDto {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    userId: number;
    tenantId: number;
    productId: string;
    product: Product;
    productDto: ProductDto;
    name: string | undefined;
    quantity: number;
    unitPrice: number;
    discount: number;
    tax: number;
    taxCode: string | undefined;
    purchaseAmount: number;
    taxAmount: number;
    totalAmount: number;
    discountedPurchaseAmount: number;
    discountedTaxAmount: number;
    discountedTotalAmount: number;
    docId: string | undefined;
}

export class WishlistDtoPagedResultDto implements IWishlistDtoPagedResultDto {
    items: WishlistDto[] | undefined;
    totalCount: number;

    constructor(data?: IWishlistDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WishlistDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): WishlistDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WishlistDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): WishlistDtoPagedResultDto {
        const json = this.toJSON();
        let result = new WishlistDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IWishlistDtoPagedResultDto {
    items: WishlistDto[] | undefined;
    totalCount: number;
}

export class WriteOffNote implements IWriteOffNote {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    type: number;
    tenantId: number;
    requestedDate: moment.Moment;
    referenceNumber: string | undefined;
    writeOffDocumentUrl: string | undefined;
    writeOffDocumentReference: string | undefined;
    requesterUserId: number;
    approverUserId: number;
    status: number;
    approvalDate: moment.Moment;
    termsOfSale: string | undefined;
    justification: string | undefined;
    sellName: string | undefined;
    sellAddress: string | undefined;
    sellTerm: number;
    produceQuantity: number;
    estimatedProduceQuantity: number;
    produceCost: number;
    overheadAllocation: number;
    totalItemAndLabourValue: number;
    produceCostPerUnit: number;
    writeOffNoteCategoryRelations: WriteOffNoteCategoryRelation[] | undefined;
    warehouseId: number | undefined;
    warehouse: InventoryWarehouse;
    productToProduceId: string | undefined;
    productToProduce: Product;
    receiverUserId: number;
    remarksByFactoryManager: string | undefined;
    remarksByWarehouseManager: string | undefined;
    factoryStatus: number;
    writeOffNoteItems: WriteOffNoteItem[] | undefined;
    writeOffNoteLabourItems: WriteOffNoteLabour[] | undefined;
    isTransferredFromFactory: boolean;
    projectId: number | undefined;
    project: Project;

    constructor(data?: IWriteOffNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.tenantId = _data["tenantId"];
            this.requestedDate = _data["requestedDate"] ? moment(_data["requestedDate"].toString()) : <any>undefined;
            this.referenceNumber = _data["referenceNumber"];
            this.writeOffDocumentUrl = _data["writeOffDocumentUrl"];
            this.writeOffDocumentReference = _data["writeOffDocumentReference"];
            this.requesterUserId = _data["requesterUserId"];
            this.approverUserId = _data["approverUserId"];
            this.status = _data["status"];
            this.approvalDate = _data["approvalDate"] ? moment(_data["approvalDate"].toString()) : <any>undefined;
            this.termsOfSale = _data["termsOfSale"];
            this.justification = _data["justification"];
            this.sellName = _data["sellName"];
            this.sellAddress = _data["sellAddress"];
            this.sellTerm = _data["sellTerm"];
            this.produceQuantity = _data["produceQuantity"];
            this.estimatedProduceQuantity = _data["estimatedProduceQuantity"];
            this.produceCost = _data["produceCost"];
            this.overheadAllocation = _data["overheadAllocation"];
            this.totalItemAndLabourValue = _data["totalItemAndLabourValue"];
            this.produceCostPerUnit = _data["produceCostPerUnit"];
            if (Array.isArray(_data["writeOffNoteCategoryRelations"])) {
                this.writeOffNoteCategoryRelations = [] as any;
                for (let item of _data["writeOffNoteCategoryRelations"])
                    this.writeOffNoteCategoryRelations.push(WriteOffNoteCategoryRelation.fromJS(item));
            }
            this.warehouseId = _data["warehouseId"];
            this.warehouse = _data["warehouse"] ? InventoryWarehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.productToProduceId = _data["productToProduceId"];
            this.productToProduce = _data["productToProduce"] ? Product.fromJS(_data["productToProduce"]) : <any>undefined;
            this.receiverUserId = _data["receiverUserId"];
            this.remarksByFactoryManager = _data["remarksByFactoryManager"];
            this.remarksByWarehouseManager = _data["remarksByWarehouseManager"];
            this.factoryStatus = _data["factoryStatus"];
            if (Array.isArray(_data["writeOffNoteItems"])) {
                this.writeOffNoteItems = [] as any;
                for (let item of _data["writeOffNoteItems"])
                    this.writeOffNoteItems.push(WriteOffNoteItem.fromJS(item));
            }
            if (Array.isArray(_data["writeOffNoteLabourItems"])) {
                this.writeOffNoteLabourItems = [] as any;
                for (let item of _data["writeOffNoteLabourItems"])
                    this.writeOffNoteLabourItems.push(WriteOffNoteLabour.fromJS(item));
            }
            this.isTransferredFromFactory = _data["isTransferredFromFactory"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WriteOffNote {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["tenantId"] = this.tenantId;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>undefined;
        data["referenceNumber"] = this.referenceNumber;
        data["writeOffDocumentUrl"] = this.writeOffDocumentUrl;
        data["writeOffDocumentReference"] = this.writeOffDocumentReference;
        data["requesterUserId"] = this.requesterUserId;
        data["approverUserId"] = this.approverUserId;
        data["status"] = this.status;
        data["approvalDate"] = this.approvalDate ? this.approvalDate.toISOString() : <any>undefined;
        data["termsOfSale"] = this.termsOfSale;
        data["justification"] = this.justification;
        data["sellName"] = this.sellName;
        data["sellAddress"] = this.sellAddress;
        data["sellTerm"] = this.sellTerm;
        data["produceQuantity"] = this.produceQuantity;
        data["estimatedProduceQuantity"] = this.estimatedProduceQuantity;
        data["produceCost"] = this.produceCost;
        data["overheadAllocation"] = this.overheadAllocation;
        data["totalItemAndLabourValue"] = this.totalItemAndLabourValue;
        data["produceCostPerUnit"] = this.produceCostPerUnit;
        if (Array.isArray(this.writeOffNoteCategoryRelations)) {
            data["writeOffNoteCategoryRelations"] = [];
            for (let item of this.writeOffNoteCategoryRelations)
                data["writeOffNoteCategoryRelations"].push(item.toJSON());
        }
        data["warehouseId"] = this.warehouseId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["productToProduceId"] = this.productToProduceId;
        data["productToProduce"] = this.productToProduce ? this.productToProduce.toJSON() : <any>undefined;
        data["receiverUserId"] = this.receiverUserId;
        data["remarksByFactoryManager"] = this.remarksByFactoryManager;
        data["remarksByWarehouseManager"] = this.remarksByWarehouseManager;
        data["factoryStatus"] = this.factoryStatus;
        if (Array.isArray(this.writeOffNoteItems)) {
            data["writeOffNoteItems"] = [];
            for (let item of this.writeOffNoteItems)
                data["writeOffNoteItems"].push(item.toJSON());
        }
        if (Array.isArray(this.writeOffNoteLabourItems)) {
            data["writeOffNoteLabourItems"] = [];
            for (let item of this.writeOffNoteLabourItems)
                data["writeOffNoteLabourItems"].push(item.toJSON());
        }
        data["isTransferredFromFactory"] = this.isTransferredFromFactory;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data;
    }

    clone(): WriteOffNote {
        const json = this.toJSON();
        let result = new WriteOffNote();
        result.init(json);
        return result;
    }
}

export interface IWriteOffNote {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    type: number;
    tenantId: number;
    requestedDate: moment.Moment;
    referenceNumber: string | undefined;
    writeOffDocumentUrl: string | undefined;
    writeOffDocumentReference: string | undefined;
    requesterUserId: number;
    approverUserId: number;
    status: number;
    approvalDate: moment.Moment;
    termsOfSale: string | undefined;
    justification: string | undefined;
    sellName: string | undefined;
    sellAddress: string | undefined;
    sellTerm: number;
    produceQuantity: number;
    estimatedProduceQuantity: number;
    produceCost: number;
    overheadAllocation: number;
    totalItemAndLabourValue: number;
    produceCostPerUnit: number;
    writeOffNoteCategoryRelations: WriteOffNoteCategoryRelation[] | undefined;
    warehouseId: number | undefined;
    warehouse: InventoryWarehouse;
    productToProduceId: string | undefined;
    productToProduce: Product;
    receiverUserId: number;
    remarksByFactoryManager: string | undefined;
    remarksByWarehouseManager: string | undefined;
    factoryStatus: number;
    writeOffNoteItems: WriteOffNoteItem[] | undefined;
    writeOffNoteLabourItems: WriteOffNoteLabour[] | undefined;
    isTransferredFromFactory: boolean;
    projectId: number | undefined;
    project: Project;
}

export class WriteOffNoteCategory implements IWriteOffNoteCategory {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    type: number;
    tenantId: number;
    name: string | undefined;
    writeOffNoteCategoryRelations: WriteOffNoteCategoryRelation[] | undefined;

    constructor(data?: IWriteOffNoteCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            if (Array.isArray(_data["writeOffNoteCategoryRelations"])) {
                this.writeOffNoteCategoryRelations = [] as any;
                for (let item of _data["writeOffNoteCategoryRelations"])
                    this.writeOffNoteCategoryRelations.push(WriteOffNoteCategoryRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WriteOffNoteCategory {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffNoteCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        if (Array.isArray(this.writeOffNoteCategoryRelations)) {
            data["writeOffNoteCategoryRelations"] = [];
            for (let item of this.writeOffNoteCategoryRelations)
                data["writeOffNoteCategoryRelations"].push(item.toJSON());
        }
        return data;
    }

    clone(): WriteOffNoteCategory {
        const json = this.toJSON();
        let result = new WriteOffNoteCategory();
        result.init(json);
        return result;
    }
}

export interface IWriteOffNoteCategory {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    type: number;
    tenantId: number;
    name: string | undefined;
    writeOffNoteCategoryRelations: WriteOffNoteCategoryRelation[] | undefined;
}

export class WriteOffNoteCategoryDto implements IWriteOffNoteCategoryDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    type: number;
    tenantId: number;
    name: string | undefined;
    writeOffNoteCategoryRelations: WriteOffNoteCategoryRelation[] | undefined;

    constructor(data?: IWriteOffNoteCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            if (Array.isArray(_data["writeOffNoteCategoryRelations"])) {
                this.writeOffNoteCategoryRelations = [] as any;
                for (let item of _data["writeOffNoteCategoryRelations"])
                    this.writeOffNoteCategoryRelations.push(WriteOffNoteCategoryRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WriteOffNoteCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffNoteCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        if (Array.isArray(this.writeOffNoteCategoryRelations)) {
            data["writeOffNoteCategoryRelations"] = [];
            for (let item of this.writeOffNoteCategoryRelations)
                data["writeOffNoteCategoryRelations"].push(item.toJSON());
        }
        return data;
    }

    clone(): WriteOffNoteCategoryDto {
        const json = this.toJSON();
        let result = new WriteOffNoteCategoryDto();
        result.init(json);
        return result;
    }
}

export interface IWriteOffNoteCategoryDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    type: number;
    tenantId: number;
    name: string | undefined;
    writeOffNoteCategoryRelations: WriteOffNoteCategoryRelation[] | undefined;
}

export class WriteOffNoteCategoryDtoPagedResultDto implements IWriteOffNoteCategoryDtoPagedResultDto {
    items: WriteOffNoteCategoryDto[] | undefined;
    totalCount: number;

    constructor(data?: IWriteOffNoteCategoryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WriteOffNoteCategoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): WriteOffNoteCategoryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffNoteCategoryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): WriteOffNoteCategoryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new WriteOffNoteCategoryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IWriteOffNoteCategoryDtoPagedResultDto {
    items: WriteOffNoteCategoryDto[] | undefined;
    totalCount: number;
}

export class WriteOffNoteCategoryRelation implements IWriteOffNoteCategoryRelation {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    writeOffNoteId: number;
    writeOffNote: WriteOffNote;
    writeOffNoteCategoryId: number;
    writeOffNoteCategory: WriteOffNoteCategory;

    constructor(data?: IWriteOffNoteCategoryRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.writeOffNoteId = _data["writeOffNoteId"];
            this.writeOffNote = _data["writeOffNote"] ? WriteOffNote.fromJS(_data["writeOffNote"]) : <any>undefined;
            this.writeOffNoteCategoryId = _data["writeOffNoteCategoryId"];
            this.writeOffNoteCategory = _data["writeOffNoteCategory"] ? WriteOffNoteCategory.fromJS(_data["writeOffNoteCategory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WriteOffNoteCategoryRelation {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffNoteCategoryRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["writeOffNoteId"] = this.writeOffNoteId;
        data["writeOffNote"] = this.writeOffNote ? this.writeOffNote.toJSON() : <any>undefined;
        data["writeOffNoteCategoryId"] = this.writeOffNoteCategoryId;
        data["writeOffNoteCategory"] = this.writeOffNoteCategory ? this.writeOffNoteCategory.toJSON() : <any>undefined;
        return data;
    }

    clone(): WriteOffNoteCategoryRelation {
        const json = this.toJSON();
        let result = new WriteOffNoteCategoryRelation();
        result.init(json);
        return result;
    }
}

export interface IWriteOffNoteCategoryRelation {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    writeOffNoteId: number;
    writeOffNote: WriteOffNote;
    writeOffNoteCategoryId: number;
    writeOffNoteCategory: WriteOffNoteCategory;
}

export class WriteOffNoteCategoryRelationDto implements IWriteOffNoteCategoryRelationDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    writeOffNoteId: number;
    writeOffNote: WriteOffNote;
    writeOffNoteCategoryId: number;
    writeOffNoteCategory: WriteOffNoteCategory;

    constructor(data?: IWriteOffNoteCategoryRelationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.writeOffNoteId = _data["writeOffNoteId"];
            this.writeOffNote = _data["writeOffNote"] ? WriteOffNote.fromJS(_data["writeOffNote"]) : <any>undefined;
            this.writeOffNoteCategoryId = _data["writeOffNoteCategoryId"];
            this.writeOffNoteCategory = _data["writeOffNoteCategory"] ? WriteOffNoteCategory.fromJS(_data["writeOffNoteCategory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WriteOffNoteCategoryRelationDto {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffNoteCategoryRelationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["writeOffNoteId"] = this.writeOffNoteId;
        data["writeOffNote"] = this.writeOffNote ? this.writeOffNote.toJSON() : <any>undefined;
        data["writeOffNoteCategoryId"] = this.writeOffNoteCategoryId;
        data["writeOffNoteCategory"] = this.writeOffNoteCategory ? this.writeOffNoteCategory.toJSON() : <any>undefined;
        return data;
    }

    clone(): WriteOffNoteCategoryRelationDto {
        const json = this.toJSON();
        let result = new WriteOffNoteCategoryRelationDto();
        result.init(json);
        return result;
    }
}

export interface IWriteOffNoteCategoryRelationDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    writeOffNoteId: number;
    writeOffNote: WriteOffNote;
    writeOffNoteCategoryId: number;
    writeOffNoteCategory: WriteOffNoteCategory;
}

export class WriteOffNoteCategoryRelationDtoPagedResultDto implements IWriteOffNoteCategoryRelationDtoPagedResultDto {
    items: WriteOffNoteCategoryRelationDto[] | undefined;
    totalCount: number;

    constructor(data?: IWriteOffNoteCategoryRelationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WriteOffNoteCategoryRelationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): WriteOffNoteCategoryRelationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffNoteCategoryRelationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): WriteOffNoteCategoryRelationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new WriteOffNoteCategoryRelationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IWriteOffNoteCategoryRelationDtoPagedResultDto {
    items: WriteOffNoteCategoryRelationDto[] | undefined;
    totalCount: number;
}

export class WriteOffNoteDto implements IWriteOffNoteDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    type: number;
    tenantId: number;
    requestedDate: moment.Moment;
    referenceNumber: string | undefined;
    writeOffDocumentUrl: string | undefined;
    writeOffDocumentReference: string | undefined;
    requesterUserId: number;
    requesterUserDto: UserDto;
    approverUserId: number;
    approverUserDto: UserDto;
    status: number;
    approvalDate: moment.Moment;
    termsOfSale: string | undefined;
    justification: string | undefined;
    sellName: string | undefined;
    sellAddress: string | undefined;
    sellTerm: number;
    produceQuantity: number;
    estimatedProduceQuantity: number;
    produceCost: number;
    overheadAllocation: number;
    totalItemAndLabourValue: number;
    produceCostPerUnit: number;
    writeOffNoteCategoryRelations: WriteOffNoteCategoryRelation[] | undefined;
    warehouseId: number | undefined;
    warehouse: InventoryWarehouse;
    productToProduceId: string | undefined;
    productToProduce: Product;
    receiverUserId: number;
    receiverUserDto: UserDto;
    remarksByFactoryManager: string | undefined;
    remarksByWarehouseManager: string | undefined;
    factoryStatus: number;
    items: WriteOffNoteItemDto[] | undefined;
    isTransferredFromFactory: boolean;
    labours: WriteOffNoteLabourDto[] | undefined;
    categoryRelation: WriteOffNoteCategoryRelationDto[] | undefined;
    warehouseDto: InventoryWarehouseDto;
    projectId: number | undefined;
    project: Project;
    projectDto: ProjectDto;
    disposedAssetItemDto: NonCurrentAssetItemDto;

    constructor(data?: IWriteOffNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.tenantId = _data["tenantId"];
            this.requestedDate = _data["requestedDate"] ? moment(_data["requestedDate"].toString()) : <any>undefined;
            this.referenceNumber = _data["referenceNumber"];
            this.writeOffDocumentUrl = _data["writeOffDocumentUrl"];
            this.writeOffDocumentReference = _data["writeOffDocumentReference"];
            this.requesterUserId = _data["requesterUserId"];
            this.requesterUserDto = _data["requesterUserDto"] ? UserDto.fromJS(_data["requesterUserDto"]) : <any>undefined;
            this.approverUserId = _data["approverUserId"];
            this.approverUserDto = _data["approverUserDto"] ? UserDto.fromJS(_data["approverUserDto"]) : <any>undefined;
            this.status = _data["status"];
            this.approvalDate = _data["approvalDate"] ? moment(_data["approvalDate"].toString()) : <any>undefined;
            this.termsOfSale = _data["termsOfSale"];
            this.justification = _data["justification"];
            this.sellName = _data["sellName"];
            this.sellAddress = _data["sellAddress"];
            this.sellTerm = _data["sellTerm"];
            this.produceQuantity = _data["produceQuantity"];
            this.estimatedProduceQuantity = _data["estimatedProduceQuantity"];
            this.produceCost = _data["produceCost"];
            this.overheadAllocation = _data["overheadAllocation"];
            this.totalItemAndLabourValue = _data["totalItemAndLabourValue"];
            this.produceCostPerUnit = _data["produceCostPerUnit"];
            if (Array.isArray(_data["writeOffNoteCategoryRelations"])) {
                this.writeOffNoteCategoryRelations = [] as any;
                for (let item of _data["writeOffNoteCategoryRelations"])
                    this.writeOffNoteCategoryRelations.push(WriteOffNoteCategoryRelation.fromJS(item));
            }
            this.warehouseId = _data["warehouseId"];
            this.warehouse = _data["warehouse"] ? InventoryWarehouse.fromJS(_data["warehouse"]) : <any>undefined;
            this.productToProduceId = _data["productToProduceId"];
            this.productToProduce = _data["productToProduce"] ? Product.fromJS(_data["productToProduce"]) : <any>undefined;
            this.receiverUserId = _data["receiverUserId"];
            this.receiverUserDto = _data["receiverUserDto"] ? UserDto.fromJS(_data["receiverUserDto"]) : <any>undefined;
            this.remarksByFactoryManager = _data["remarksByFactoryManager"];
            this.remarksByWarehouseManager = _data["remarksByWarehouseManager"];
            this.factoryStatus = _data["factoryStatus"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WriteOffNoteItemDto.fromJS(item));
            }
            this.isTransferredFromFactory = _data["isTransferredFromFactory"];
            if (Array.isArray(_data["labours"])) {
                this.labours = [] as any;
                for (let item of _data["labours"])
                    this.labours.push(WriteOffNoteLabourDto.fromJS(item));
            }
            if (Array.isArray(_data["categoryRelation"])) {
                this.categoryRelation = [] as any;
                for (let item of _data["categoryRelation"])
                    this.categoryRelation.push(WriteOffNoteCategoryRelationDto.fromJS(item));
            }
            this.warehouseDto = _data["warehouseDto"] ? InventoryWarehouseDto.fromJS(_data["warehouseDto"]) : <any>undefined;
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : <any>undefined;
            this.projectDto = _data["projectDto"] ? ProjectDto.fromJS(_data["projectDto"]) : <any>undefined;
            this.disposedAssetItemDto = _data["disposedAssetItemDto"] ? NonCurrentAssetItemDto.fromJS(_data["disposedAssetItemDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WriteOffNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["tenantId"] = this.tenantId;
        data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : <any>undefined;
        data["referenceNumber"] = this.referenceNumber;
        data["writeOffDocumentUrl"] = this.writeOffDocumentUrl;
        data["writeOffDocumentReference"] = this.writeOffDocumentReference;
        data["requesterUserId"] = this.requesterUserId;
        data["requesterUserDto"] = this.requesterUserDto ? this.requesterUserDto.toJSON() : <any>undefined;
        data["approverUserId"] = this.approverUserId;
        data["approverUserDto"] = this.approverUserDto ? this.approverUserDto.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["approvalDate"] = this.approvalDate ? this.approvalDate.toISOString() : <any>undefined;
        data["termsOfSale"] = this.termsOfSale;
        data["justification"] = this.justification;
        data["sellName"] = this.sellName;
        data["sellAddress"] = this.sellAddress;
        data["sellTerm"] = this.sellTerm;
        data["produceQuantity"] = this.produceQuantity;
        data["estimatedProduceQuantity"] = this.estimatedProduceQuantity;
        data["produceCost"] = this.produceCost;
        data["overheadAllocation"] = this.overheadAllocation;
        data["totalItemAndLabourValue"] = this.totalItemAndLabourValue;
        data["produceCostPerUnit"] = this.produceCostPerUnit;
        if (Array.isArray(this.writeOffNoteCategoryRelations)) {
            data["writeOffNoteCategoryRelations"] = [];
            for (let item of this.writeOffNoteCategoryRelations)
                data["writeOffNoteCategoryRelations"].push(item.toJSON());
        }
        data["warehouseId"] = this.warehouseId;
        data["warehouse"] = this.warehouse ? this.warehouse.toJSON() : <any>undefined;
        data["productToProduceId"] = this.productToProduceId;
        data["productToProduce"] = this.productToProduce ? this.productToProduce.toJSON() : <any>undefined;
        data["receiverUserId"] = this.receiverUserId;
        data["receiverUserDto"] = this.receiverUserDto ? this.receiverUserDto.toJSON() : <any>undefined;
        data["remarksByFactoryManager"] = this.remarksByFactoryManager;
        data["remarksByWarehouseManager"] = this.remarksByWarehouseManager;
        data["factoryStatus"] = this.factoryStatus;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["isTransferredFromFactory"] = this.isTransferredFromFactory;
        if (Array.isArray(this.labours)) {
            data["labours"] = [];
            for (let item of this.labours)
                data["labours"].push(item.toJSON());
        }
        if (Array.isArray(this.categoryRelation)) {
            data["categoryRelation"] = [];
            for (let item of this.categoryRelation)
                data["categoryRelation"].push(item.toJSON());
        }
        data["warehouseDto"] = this.warehouseDto ? this.warehouseDto.toJSON() : <any>undefined;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["projectDto"] = this.projectDto ? this.projectDto.toJSON() : <any>undefined;
        data["disposedAssetItemDto"] = this.disposedAssetItemDto ? this.disposedAssetItemDto.toJSON() : <any>undefined;
        return data;
    }

    clone(): WriteOffNoteDto {
        const json = this.toJSON();
        let result = new WriteOffNoteDto();
        result.init(json);
        return result;
    }
}

export interface IWriteOffNoteDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    type: number;
    tenantId: number;
    requestedDate: moment.Moment;
    referenceNumber: string | undefined;
    writeOffDocumentUrl: string | undefined;
    writeOffDocumentReference: string | undefined;
    requesterUserId: number;
    requesterUserDto: UserDto;
    approverUserId: number;
    approverUserDto: UserDto;
    status: number;
    approvalDate: moment.Moment;
    termsOfSale: string | undefined;
    justification: string | undefined;
    sellName: string | undefined;
    sellAddress: string | undefined;
    sellTerm: number;
    produceQuantity: number;
    estimatedProduceQuantity: number;
    produceCost: number;
    overheadAllocation: number;
    totalItemAndLabourValue: number;
    produceCostPerUnit: number;
    writeOffNoteCategoryRelations: WriteOffNoteCategoryRelation[] | undefined;
    warehouseId: number | undefined;
    warehouse: InventoryWarehouse;
    productToProduceId: string | undefined;
    productToProduce: Product;
    receiverUserId: number;
    receiverUserDto: UserDto;
    remarksByFactoryManager: string | undefined;
    remarksByWarehouseManager: string | undefined;
    factoryStatus: number;
    items: WriteOffNoteItemDto[] | undefined;
    isTransferredFromFactory: boolean;
    labours: WriteOffNoteLabourDto[] | undefined;
    categoryRelation: WriteOffNoteCategoryRelationDto[] | undefined;
    warehouseDto: InventoryWarehouseDto;
    projectId: number | undefined;
    project: Project;
    projectDto: ProjectDto;
    disposedAssetItemDto: NonCurrentAssetItemDto;
}

export class WriteOffNoteDtoPagedResultDto implements IWriteOffNoteDtoPagedResultDto {
    items: WriteOffNoteDto[] | undefined;
    totalCount: number;

    constructor(data?: IWriteOffNoteDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WriteOffNoteDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): WriteOffNoteDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffNoteDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): WriteOffNoteDtoPagedResultDto {
        const json = this.toJSON();
        let result = new WriteOffNoteDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IWriteOffNoteDtoPagedResultDto {
    items: WriteOffNoteDto[] | undefined;
    totalCount: number;
}

export class WriteOffNoteItem implements IWriteOffNoteItem {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    itemType: number;
    itemGuid: string;
    writeOffQuantity: number;
    writeOffUnitPrice: number;
    impairmentValue: number;
    transferQuantity: number;
    transferUnitPrice: number;
    productionQuantity: number;
    productionUnitPrice: number;
    projectQuantity: number;
    projectUnitPrice: number;
    fromShelfId: number | undefined;
    fromShelf: InventoryShelf;
    toShelfId: number | undefined;
    toShelf: InventoryShelf;
    writeOffNoteId: number | undefined;
    writeOffNote: WriteOffNote;
    receivedQuantity: number;
    acceptedQuantity: number;
    rejectedQuantity: number;
    projectInvoiceId: string | undefined;
    projectInvoice: Bill;

    constructor(data?: IWriteOffNoteItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.itemType = _data["itemType"];
            this.itemGuid = _data["itemGuid"];
            this.writeOffQuantity = _data["writeOffQuantity"];
            this.writeOffUnitPrice = _data["writeOffUnitPrice"];
            this.impairmentValue = _data["impairmentValue"];
            this.transferQuantity = _data["transferQuantity"];
            this.transferUnitPrice = _data["transferUnitPrice"];
            this.productionQuantity = _data["productionQuantity"];
            this.productionUnitPrice = _data["productionUnitPrice"];
            this.projectQuantity = _data["projectQuantity"];
            this.projectUnitPrice = _data["projectUnitPrice"];
            this.fromShelfId = _data["fromShelfId"];
            this.fromShelf = _data["fromShelf"] ? InventoryShelf.fromJS(_data["fromShelf"]) : <any>undefined;
            this.toShelfId = _data["toShelfId"];
            this.toShelf = _data["toShelf"] ? InventoryShelf.fromJS(_data["toShelf"]) : <any>undefined;
            this.writeOffNoteId = _data["writeOffNoteId"];
            this.writeOffNote = _data["writeOffNote"] ? WriteOffNote.fromJS(_data["writeOffNote"]) : <any>undefined;
            this.receivedQuantity = _data["receivedQuantity"];
            this.acceptedQuantity = _data["acceptedQuantity"];
            this.rejectedQuantity = _data["rejectedQuantity"];
            this.projectInvoiceId = _data["projectInvoiceId"];
            this.projectInvoice = _data["projectInvoice"] ? Bill.fromJS(_data["projectInvoice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WriteOffNoteItem {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffNoteItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["itemType"] = this.itemType;
        data["itemGuid"] = this.itemGuid;
        data["writeOffQuantity"] = this.writeOffQuantity;
        data["writeOffUnitPrice"] = this.writeOffUnitPrice;
        data["impairmentValue"] = this.impairmentValue;
        data["transferQuantity"] = this.transferQuantity;
        data["transferUnitPrice"] = this.transferUnitPrice;
        data["productionQuantity"] = this.productionQuantity;
        data["productionUnitPrice"] = this.productionUnitPrice;
        data["projectQuantity"] = this.projectQuantity;
        data["projectUnitPrice"] = this.projectUnitPrice;
        data["fromShelfId"] = this.fromShelfId;
        data["fromShelf"] = this.fromShelf ? this.fromShelf.toJSON() : <any>undefined;
        data["toShelfId"] = this.toShelfId;
        data["toShelf"] = this.toShelf ? this.toShelf.toJSON() : <any>undefined;
        data["writeOffNoteId"] = this.writeOffNoteId;
        data["writeOffNote"] = this.writeOffNote ? this.writeOffNote.toJSON() : <any>undefined;
        data["receivedQuantity"] = this.receivedQuantity;
        data["acceptedQuantity"] = this.acceptedQuantity;
        data["rejectedQuantity"] = this.rejectedQuantity;
        data["projectInvoiceId"] = this.projectInvoiceId;
        data["projectInvoice"] = this.projectInvoice ? this.projectInvoice.toJSON() : <any>undefined;
        return data;
    }

    clone(): WriteOffNoteItem {
        const json = this.toJSON();
        let result = new WriteOffNoteItem();
        result.init(json);
        return result;
    }
}

export interface IWriteOffNoteItem {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    itemType: number;
    itemGuid: string;
    writeOffQuantity: number;
    writeOffUnitPrice: number;
    impairmentValue: number;
    transferQuantity: number;
    transferUnitPrice: number;
    productionQuantity: number;
    productionUnitPrice: number;
    projectQuantity: number;
    projectUnitPrice: number;
    fromShelfId: number | undefined;
    fromShelf: InventoryShelf;
    toShelfId: number | undefined;
    toShelf: InventoryShelf;
    writeOffNoteId: number | undefined;
    writeOffNote: WriteOffNote;
    receivedQuantity: number;
    acceptedQuantity: number;
    rejectedQuantity: number;
    projectInvoiceId: string | undefined;
    projectInvoice: Bill;
}

export class WriteOffNoteItemDto implements IWriteOffNoteItemDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    itemType: number;
    itemGuid: string;
    writeOffQuantity: number;
    writeOffUnitPrice: number;
    impairmentValue: number;
    transferQuantity: number;
    transferUnitPrice: number;
    productionQuantity: number;
    productionUnitPrice: number;
    projectQuantity: number;
    projectUnitPrice: number;
    fromShelfId: number | undefined;
    fromShelf: InventoryShelf;
    toShelfId: number | undefined;
    toShelf: InventoryShelf;
    writeOffNoteId: number | undefined;
    writeOffNote: WriteOffNote;
    product: Product;
    productDto: ProductDto;
    material: Material;
    materialDto: MaterialDto;
    nonCurrentAssetItem: NonCurrentAssetItem;
    nonCurrentAssetItemDto: NonCurrentAssetItemDto;
    receivedQuantity: number;
    acceptedQuantity: number;
    rejectedQuantity: number;
    projectInvoiceId: string | undefined;
    projectInvoice: Bill;

    constructor(data?: IWriteOffNoteItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.itemType = _data["itemType"];
            this.itemGuid = _data["itemGuid"];
            this.writeOffQuantity = _data["writeOffQuantity"];
            this.writeOffUnitPrice = _data["writeOffUnitPrice"];
            this.impairmentValue = _data["impairmentValue"];
            this.transferQuantity = _data["transferQuantity"];
            this.transferUnitPrice = _data["transferUnitPrice"];
            this.productionQuantity = _data["productionQuantity"];
            this.productionUnitPrice = _data["productionUnitPrice"];
            this.projectQuantity = _data["projectQuantity"];
            this.projectUnitPrice = _data["projectUnitPrice"];
            this.fromShelfId = _data["fromShelfId"];
            this.fromShelf = _data["fromShelf"] ? InventoryShelf.fromJS(_data["fromShelf"]) : <any>undefined;
            this.toShelfId = _data["toShelfId"];
            this.toShelf = _data["toShelf"] ? InventoryShelf.fromJS(_data["toShelf"]) : <any>undefined;
            this.writeOffNoteId = _data["writeOffNoteId"];
            this.writeOffNote = _data["writeOffNote"] ? WriteOffNote.fromJS(_data["writeOffNote"]) : <any>undefined;
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
            this.productDto = _data["productDto"] ? ProductDto.fromJS(_data["productDto"]) : <any>undefined;
            this.material = _data["material"] ? Material.fromJS(_data["material"]) : <any>undefined;
            this.materialDto = _data["materialDto"] ? MaterialDto.fromJS(_data["materialDto"]) : <any>undefined;
            this.nonCurrentAssetItem = _data["nonCurrentAssetItem"] ? NonCurrentAssetItem.fromJS(_data["nonCurrentAssetItem"]) : <any>undefined;
            this.nonCurrentAssetItemDto = _data["nonCurrentAssetItemDto"] ? NonCurrentAssetItemDto.fromJS(_data["nonCurrentAssetItemDto"]) : <any>undefined;
            this.receivedQuantity = _data["receivedQuantity"];
            this.acceptedQuantity = _data["acceptedQuantity"];
            this.rejectedQuantity = _data["rejectedQuantity"];
            this.projectInvoiceId = _data["projectInvoiceId"];
            this.projectInvoice = _data["projectInvoice"] ? Bill.fromJS(_data["projectInvoice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WriteOffNoteItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffNoteItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["itemType"] = this.itemType;
        data["itemGuid"] = this.itemGuid;
        data["writeOffQuantity"] = this.writeOffQuantity;
        data["writeOffUnitPrice"] = this.writeOffUnitPrice;
        data["impairmentValue"] = this.impairmentValue;
        data["transferQuantity"] = this.transferQuantity;
        data["transferUnitPrice"] = this.transferUnitPrice;
        data["productionQuantity"] = this.productionQuantity;
        data["productionUnitPrice"] = this.productionUnitPrice;
        data["projectQuantity"] = this.projectQuantity;
        data["projectUnitPrice"] = this.projectUnitPrice;
        data["fromShelfId"] = this.fromShelfId;
        data["fromShelf"] = this.fromShelf ? this.fromShelf.toJSON() : <any>undefined;
        data["toShelfId"] = this.toShelfId;
        data["toShelf"] = this.toShelf ? this.toShelf.toJSON() : <any>undefined;
        data["writeOffNoteId"] = this.writeOffNoteId;
        data["writeOffNote"] = this.writeOffNote ? this.writeOffNote.toJSON() : <any>undefined;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        data["productDto"] = this.productDto ? this.productDto.toJSON() : <any>undefined;
        data["material"] = this.material ? this.material.toJSON() : <any>undefined;
        data["materialDto"] = this.materialDto ? this.materialDto.toJSON() : <any>undefined;
        data["nonCurrentAssetItem"] = this.nonCurrentAssetItem ? this.nonCurrentAssetItem.toJSON() : <any>undefined;
        data["nonCurrentAssetItemDto"] = this.nonCurrentAssetItemDto ? this.nonCurrentAssetItemDto.toJSON() : <any>undefined;
        data["receivedQuantity"] = this.receivedQuantity;
        data["acceptedQuantity"] = this.acceptedQuantity;
        data["rejectedQuantity"] = this.rejectedQuantity;
        data["projectInvoiceId"] = this.projectInvoiceId;
        data["projectInvoice"] = this.projectInvoice ? this.projectInvoice.toJSON() : <any>undefined;
        return data;
    }

    clone(): WriteOffNoteItemDto {
        const json = this.toJSON();
        let result = new WriteOffNoteItemDto();
        result.init(json);
        return result;
    }
}

export interface IWriteOffNoteItemDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    itemType: number;
    itemGuid: string;
    writeOffQuantity: number;
    writeOffUnitPrice: number;
    impairmentValue: number;
    transferQuantity: number;
    transferUnitPrice: number;
    productionQuantity: number;
    productionUnitPrice: number;
    projectQuantity: number;
    projectUnitPrice: number;
    fromShelfId: number | undefined;
    fromShelf: InventoryShelf;
    toShelfId: number | undefined;
    toShelf: InventoryShelf;
    writeOffNoteId: number | undefined;
    writeOffNote: WriteOffNote;
    product: Product;
    productDto: ProductDto;
    material: Material;
    materialDto: MaterialDto;
    nonCurrentAssetItem: NonCurrentAssetItem;
    nonCurrentAssetItemDto: NonCurrentAssetItemDto;
    receivedQuantity: number;
    acceptedQuantity: number;
    rejectedQuantity: number;
    projectInvoiceId: string | undefined;
    projectInvoice: Bill;
}

export class WriteOffNoteItemDtoPagedResultDto implements IWriteOffNoteItemDtoPagedResultDto {
    items: WriteOffNoteItemDto[] | undefined;
    totalCount: number;

    constructor(data?: IWriteOffNoteItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WriteOffNoteItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): WriteOffNoteItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffNoteItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): WriteOffNoteItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new WriteOffNoteItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IWriteOffNoteItemDtoPagedResultDto {
    items: WriteOffNoteItemDto[] | undefined;
    totalCount: number;
}

export class WriteOffNoteLabour implements IWriteOffNoteLabour {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    hours: number;
    costPerHour: number;
    value: number;
    writeOffNoteId: number | undefined;
    writeOffNote: WriteOffNote;

    constructor(data?: IWriteOffNoteLabour) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.hours = _data["hours"];
            this.costPerHour = _data["costPerHour"];
            this.value = _data["value"];
            this.writeOffNoteId = _data["writeOffNoteId"];
            this.writeOffNote = _data["writeOffNote"] ? WriteOffNote.fromJS(_data["writeOffNote"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WriteOffNoteLabour {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffNoteLabour();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["hours"] = this.hours;
        data["costPerHour"] = this.costPerHour;
        data["value"] = this.value;
        data["writeOffNoteId"] = this.writeOffNoteId;
        data["writeOffNote"] = this.writeOffNote ? this.writeOffNote.toJSON() : <any>undefined;
        return data;
    }

    clone(): WriteOffNoteLabour {
        const json = this.toJSON();
        let result = new WriteOffNoteLabour();
        result.init(json);
        return result;
    }
}

export interface IWriteOffNoteLabour {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    hours: number;
    costPerHour: number;
    value: number;
    writeOffNoteId: number | undefined;
    writeOffNote: WriteOffNote;
}

export class WriteOffNoteLabourDto implements IWriteOffNoteLabourDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    hours: number;
    costPerHour: number;
    value: number;
    writeOffNoteId: number | undefined;
    writeOffNote: WriteOffNote;

    constructor(data?: IWriteOffNoteLabourDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.hours = _data["hours"];
            this.costPerHour = _data["costPerHour"];
            this.value = _data["value"];
            this.writeOffNoteId = _data["writeOffNoteId"];
            this.writeOffNote = _data["writeOffNote"] ? WriteOffNote.fromJS(_data["writeOffNote"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WriteOffNoteLabourDto {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffNoteLabourDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["hours"] = this.hours;
        data["costPerHour"] = this.costPerHour;
        data["value"] = this.value;
        data["writeOffNoteId"] = this.writeOffNoteId;
        data["writeOffNote"] = this.writeOffNote ? this.writeOffNote.toJSON() : <any>undefined;
        return data;
    }

    clone(): WriteOffNoteLabourDto {
        const json = this.toJSON();
        let result = new WriteOffNoteLabourDto();
        result.init(json);
        return result;
    }
}

export interface IWriteOffNoteLabourDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number;
    name: string | undefined;
    hours: number;
    costPerHour: number;
    value: number;
    writeOffNoteId: number | undefined;
    writeOffNote: WriteOffNote;
}

export class WriteOffNoteLabourDtoPagedResultDto implements IWriteOffNoteLabourDtoPagedResultDto {
    items: WriteOffNoteLabourDto[] | undefined;
    totalCount: number;

    constructor(data?: IWriteOffNoteLabourDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WriteOffNoteLabourDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): WriteOffNoteLabourDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WriteOffNoteLabourDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): WriteOffNoteLabourDtoPagedResultDto {
        const json = this.toJSON();
        let result = new WriteOffNoteLabourDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IWriteOffNoteLabourDtoPagedResultDto {
    items: WriteOffNoteLabourDto[] | undefined;
    totalCount: number;
}

export class YayasanHijau implements IYayasanHijau {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    status: string | undefined;
    receiptNumber: string | undefined;
    approvedDate: moment.Moment;
    approvedStartDate: moment.Moment;
    approvedEndDate: moment.Moment;
    approvedBy: string | undefined;
    supportingApprovalDocUrl: string | undefined;
    isIndividual: boolean;
    tenantId: number;
    description: string | undefined;
    totalPayment: number;
    paymentMethod: string | undefined;
    transactionRefNo: string | undefined;
    paymentDate: moment.Moment;
    scannedDocumentUrl: string | undefined;
    otherSupportingDocumentUrl: string | undefined;
    programName: string | undefined;
    lhdnReferenceNo: string | undefined;
    generatedReceiptUrl: string | undefined;
    verifiedBy: string | undefined;
    customerName: string | undefined;
    customerReferenceNo: string | undefined;
    customerAddress1: string | undefined;
    customerAddress2: string | undefined;
    customerPoscode: string | undefined;
    customerCity: string | undefined;
    customerCountry: string | undefined;
    customerEmail: string | undefined;

    constructor(data?: IYayasanHijau) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.receiptNumber = _data["receiptNumber"];
            this.approvedDate = _data["approvedDate"] ? moment(_data["approvedDate"].toString()) : <any>undefined;
            this.approvedStartDate = _data["approvedStartDate"] ? moment(_data["approvedStartDate"].toString()) : <any>undefined;
            this.approvedEndDate = _data["approvedEndDate"] ? moment(_data["approvedEndDate"].toString()) : <any>undefined;
            this.approvedBy = _data["approvedBy"];
            this.supportingApprovalDocUrl = _data["supportingApprovalDocUrl"];
            this.isIndividual = _data["isIndividual"];
            this.tenantId = _data["tenantId"];
            this.description = _data["description"];
            this.totalPayment = _data["totalPayment"];
            this.paymentMethod = _data["paymentMethod"];
            this.transactionRefNo = _data["transactionRefNo"];
            this.paymentDate = _data["paymentDate"] ? moment(_data["paymentDate"].toString()) : <any>undefined;
            this.scannedDocumentUrl = _data["scannedDocumentUrl"];
            this.otherSupportingDocumentUrl = _data["otherSupportingDocumentUrl"];
            this.programName = _data["programName"];
            this.lhdnReferenceNo = _data["lhdnReferenceNo"];
            this.generatedReceiptUrl = _data["generatedReceiptUrl"];
            this.verifiedBy = _data["verifiedBy"];
            this.customerName = _data["customerName"];
            this.customerReferenceNo = _data["customerReferenceNo"];
            this.customerAddress1 = _data["customerAddress1"];
            this.customerAddress2 = _data["customerAddress2"];
            this.customerPoscode = _data["customerPoscode"];
            this.customerCity = _data["customerCity"];
            this.customerCountry = _data["customerCountry"];
            this.customerEmail = _data["customerEmail"];
        }
    }

    static fromJS(data: any): YayasanHijau {
        data = typeof data === 'object' ? data : {};
        let result = new YayasanHijau();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["receiptNumber"] = this.receiptNumber;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["approvedStartDate"] = this.approvedStartDate ? this.approvedStartDate.toISOString() : <any>undefined;
        data["approvedEndDate"] = this.approvedEndDate ? this.approvedEndDate.toISOString() : <any>undefined;
        data["approvedBy"] = this.approvedBy;
        data["supportingApprovalDocUrl"] = this.supportingApprovalDocUrl;
        data["isIndividual"] = this.isIndividual;
        data["tenantId"] = this.tenantId;
        data["description"] = this.description;
        data["totalPayment"] = this.totalPayment;
        data["paymentMethod"] = this.paymentMethod;
        data["transactionRefNo"] = this.transactionRefNo;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["scannedDocumentUrl"] = this.scannedDocumentUrl;
        data["otherSupportingDocumentUrl"] = this.otherSupportingDocumentUrl;
        data["programName"] = this.programName;
        data["lhdnReferenceNo"] = this.lhdnReferenceNo;
        data["generatedReceiptUrl"] = this.generatedReceiptUrl;
        data["verifiedBy"] = this.verifiedBy;
        data["customerName"] = this.customerName;
        data["customerReferenceNo"] = this.customerReferenceNo;
        data["customerAddress1"] = this.customerAddress1;
        data["customerAddress2"] = this.customerAddress2;
        data["customerPoscode"] = this.customerPoscode;
        data["customerCity"] = this.customerCity;
        data["customerCountry"] = this.customerCountry;
        data["customerEmail"] = this.customerEmail;
        return data;
    }

    clone(): YayasanHijau {
        const json = this.toJSON();
        let result = new YayasanHijau();
        result.init(json);
        return result;
    }
}

export interface IYayasanHijau {
    id: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    status: string | undefined;
    receiptNumber: string | undefined;
    approvedDate: moment.Moment;
    approvedStartDate: moment.Moment;
    approvedEndDate: moment.Moment;
    approvedBy: string | undefined;
    supportingApprovalDocUrl: string | undefined;
    isIndividual: boolean;
    tenantId: number;
    description: string | undefined;
    totalPayment: number;
    paymentMethod: string | undefined;
    transactionRefNo: string | undefined;
    paymentDate: moment.Moment;
    scannedDocumentUrl: string | undefined;
    otherSupportingDocumentUrl: string | undefined;
    programName: string | undefined;
    lhdnReferenceNo: string | undefined;
    generatedReceiptUrl: string | undefined;
    verifiedBy: string | undefined;
    customerName: string | undefined;
    customerReferenceNo: string | undefined;
    customerAddress1: string | undefined;
    customerAddress2: string | undefined;
    customerPoscode: string | undefined;
    customerCity: string | undefined;
    customerCountry: string | undefined;
    customerEmail: string | undefined;
}

export class YayasanHijauDto implements IYayasanHijauDto {
    status: string | undefined;
    receiptNumber: string | undefined;
    approvedDate: moment.Moment;
    approvedStartDate: moment.Moment;
    approvedEndDate: moment.Moment;
    approvedBy: string | undefined;
    supportingApprovalDocUrl: string | undefined;
    isIndividual: boolean;
    tenantId: number;
    description: string | undefined;
    totalPayment: number;
    paymentMethod: string | undefined;
    transactionRefNo: string | undefined;
    paymentDate: moment.Moment;
    scannedDocumentUrl: string | undefined;
    otherSupportingDocumentUrl: string | undefined;
    yayasanHijauId: string;
    programName: string | undefined;
    lhdnReferenceNo: string | undefined;
    generatedReceiptUrl: string | undefined;
    verifiedBy: string | undefined;
    customerName: string | undefined;
    customerReferenceNo: string | undefined;
    customerAddress1: string | undefined;
    customerAddress2: string | undefined;
    customerPoscode: string | undefined;
    customerCity: string | undefined;
    customerCountry: string | undefined;
    customerEmail: string | undefined;

    constructor(data?: IYayasanHijauDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.receiptNumber = _data["receiptNumber"];
            this.approvedDate = _data["approvedDate"] ? moment(_data["approvedDate"].toString()) : <any>undefined;
            this.approvedStartDate = _data["approvedStartDate"] ? moment(_data["approvedStartDate"].toString()) : <any>undefined;
            this.approvedEndDate = _data["approvedEndDate"] ? moment(_data["approvedEndDate"].toString()) : <any>undefined;
            this.approvedBy = _data["approvedBy"];
            this.supportingApprovalDocUrl = _data["supportingApprovalDocUrl"];
            this.isIndividual = _data["isIndividual"];
            this.tenantId = _data["tenantId"];
            this.description = _data["description"];
            this.totalPayment = _data["totalPayment"];
            this.paymentMethod = _data["paymentMethod"];
            this.transactionRefNo = _data["transactionRefNo"];
            this.paymentDate = _data["paymentDate"] ? moment(_data["paymentDate"].toString()) : <any>undefined;
            this.scannedDocumentUrl = _data["scannedDocumentUrl"];
            this.otherSupportingDocumentUrl = _data["otherSupportingDocumentUrl"];
            this.yayasanHijauId = _data["yayasanHijauId"];
            this.programName = _data["programName"];
            this.lhdnReferenceNo = _data["lhdnReferenceNo"];
            this.generatedReceiptUrl = _data["generatedReceiptUrl"];
            this.verifiedBy = _data["verifiedBy"];
            this.customerName = _data["customerName"];
            this.customerReferenceNo = _data["customerReferenceNo"];
            this.customerAddress1 = _data["customerAddress1"];
            this.customerAddress2 = _data["customerAddress2"];
            this.customerPoscode = _data["customerPoscode"];
            this.customerCity = _data["customerCity"];
            this.customerCountry = _data["customerCountry"];
            this.customerEmail = _data["customerEmail"];
        }
    }

    static fromJS(data: any): YayasanHijauDto {
        data = typeof data === 'object' ? data : {};
        let result = new YayasanHijauDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["receiptNumber"] = this.receiptNumber;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["approvedStartDate"] = this.approvedStartDate ? this.approvedStartDate.toISOString() : <any>undefined;
        data["approvedEndDate"] = this.approvedEndDate ? this.approvedEndDate.toISOString() : <any>undefined;
        data["approvedBy"] = this.approvedBy;
        data["supportingApprovalDocUrl"] = this.supportingApprovalDocUrl;
        data["isIndividual"] = this.isIndividual;
        data["tenantId"] = this.tenantId;
        data["description"] = this.description;
        data["totalPayment"] = this.totalPayment;
        data["paymentMethod"] = this.paymentMethod;
        data["transactionRefNo"] = this.transactionRefNo;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["scannedDocumentUrl"] = this.scannedDocumentUrl;
        data["otherSupportingDocumentUrl"] = this.otherSupportingDocumentUrl;
        data["yayasanHijauId"] = this.yayasanHijauId;
        data["programName"] = this.programName;
        data["lhdnReferenceNo"] = this.lhdnReferenceNo;
        data["generatedReceiptUrl"] = this.generatedReceiptUrl;
        data["verifiedBy"] = this.verifiedBy;
        data["customerName"] = this.customerName;
        data["customerReferenceNo"] = this.customerReferenceNo;
        data["customerAddress1"] = this.customerAddress1;
        data["customerAddress2"] = this.customerAddress2;
        data["customerPoscode"] = this.customerPoscode;
        data["customerCity"] = this.customerCity;
        data["customerCountry"] = this.customerCountry;
        data["customerEmail"] = this.customerEmail;
        return data;
    }

    clone(): YayasanHijauDto {
        const json = this.toJSON();
        let result = new YayasanHijauDto();
        result.init(json);
        return result;
    }
}

export interface IYayasanHijauDto {
    status: string | undefined;
    receiptNumber: string | undefined;
    approvedDate: moment.Moment;
    approvedStartDate: moment.Moment;
    approvedEndDate: moment.Moment;
    approvedBy: string | undefined;
    supportingApprovalDocUrl: string | undefined;
    isIndividual: boolean;
    tenantId: number;
    description: string | undefined;
    totalPayment: number;
    paymentMethod: string | undefined;
    transactionRefNo: string | undefined;
    paymentDate: moment.Moment;
    scannedDocumentUrl: string | undefined;
    otherSupportingDocumentUrl: string | undefined;
    yayasanHijauId: string;
    programName: string | undefined;
    lhdnReferenceNo: string | undefined;
    generatedReceiptUrl: string | undefined;
    verifiedBy: string | undefined;
    customerName: string | undefined;
    customerReferenceNo: string | undefined;
    customerAddress1: string | undefined;
    customerAddress2: string | undefined;
    customerPoscode: string | undefined;
    customerCity: string | undefined;
    customerCountry: string | undefined;
    customerEmail: string | undefined;
}

export class YayasanHijauPagedResultDto implements IYayasanHijauPagedResultDto {
    items: YayasanHijau[] | undefined;
    totalCount: number;

    constructor(data?: IYayasanHijauPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(YayasanHijau.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): YayasanHijauPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new YayasanHijauPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): YayasanHijauPagedResultDto {
        const json = this.toJSON();
        let result = new YayasanHijauPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IYayasanHijauPagedResultDto {
    items: YayasanHijau[] | undefined;
    totalCount: number;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                var jsonObject = JSON.parse((event.target).result.toString());
                var jsonString = JSON.stringify(jsonObject.result);
                observer.next(<any>jsonString);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
